
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaac8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaac8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4qeEp", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $3384f47436f9c07c$export$ffb0004e005737fa; }, function (v) { return $3384f47436f9c07c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $3384f47436f9c07c$export$34b9dba7ce09269b; }, function (v) { return $3384f47436f9c07c$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $3384f47436f9c07c$export$25062201e9e25d76; }, function (v) { return $3384f47436f9c07c$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3384f47436f9c07c$export$ffb0004e005737fa;
var $3384f47436f9c07c$export$34b9dba7ce09269b;
var $3384f47436f9c07c$export$25062201e9e25d76;
'use strict';

var $6aRB8 = parcelRequire("6aRB8");
var $3384f47436f9c07c$var$k = Symbol.for("react.element"), $3384f47436f9c07c$var$l = Symbol.for("react.fragment"), $3384f47436f9c07c$var$m = Object.prototype.hasOwnProperty, $3384f47436f9c07c$var$n = $6aRB8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $3384f47436f9c07c$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $3384f47436f9c07c$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$3384f47436f9c07c$var$m.call(a, b) && !$3384f47436f9c07c$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $3384f47436f9c07c$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $3384f47436f9c07c$var$n.current
    };
}
$3384f47436f9c07c$export$ffb0004e005737fa = $3384f47436f9c07c$var$l;
$3384f47436f9c07c$export$34b9dba7ce09269b = $3384f47436f9c07c$var$q;
$3384f47436f9c07c$export$25062201e9e25d76 = $3384f47436f9c07c$var$q;

});
parcelRegister("6aRB8", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bxjdH"));

});
parcelRegister("bxjdH", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $8661af75706be5f2$export$dca3b0875bd9a954; }, function (v) { return $8661af75706be5f2$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $8661af75706be5f2$export$16fa2f45be04daa8; }, function (v) { return $8661af75706be5f2$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8661af75706be5f2$export$ffb0004e005737fa; }, function (v) { return $8661af75706be5f2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $8661af75706be5f2$export$e2c29f18771995cb; }, function (v) { return $8661af75706be5f2$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $8661af75706be5f2$export$221d75b3f55bb0bd; }, function (v) { return $8661af75706be5f2$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8661af75706be5f2$export$5f8d39834fd61797; }, function (v) { return $8661af75706be5f2$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8661af75706be5f2$export$74bf444e3cd11ea5; }, function (v) { return $8661af75706be5f2$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $8661af75706be5f2$export$ae55be85d98224ed; }, function (v) { return $8661af75706be5f2$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $8661af75706be5f2$export$3ba232387fd5d6dd; }, function (v) { return $8661af75706be5f2$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $8661af75706be5f2$export$e530037191fcd5d7; }, function (v) { return $8661af75706be5f2$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $8661af75706be5f2$export$fd42f52fd3ae1109; }, function (v) { return $8661af75706be5f2$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $8661af75706be5f2$export$c8a8987d4410bf2d; }, function (v) { return $8661af75706be5f2$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $8661af75706be5f2$export$d38cd72104c1f0e9; }, function (v) { return $8661af75706be5f2$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $8661af75706be5f2$export$7d1e3a5e95ceca43; }, function (v) { return $8661af75706be5f2$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $8661af75706be5f2$export$257a8862b851cb5b; }, function (v) { return $8661af75706be5f2$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $8661af75706be5f2$export$a8257692ac88316c; }, function (v) { return $8661af75706be5f2$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $8661af75706be5f2$export$488013bae63b21da; }, function (v) { return $8661af75706be5f2$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $8661af75706be5f2$export$7c73462e0d25e514; }, function (v) { return $8661af75706be5f2$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $8661af75706be5f2$export$7568632d0d33d16d; }, function (v) { return $8661af75706be5f2$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $8661af75706be5f2$export$88948ce120ea2619; }, function (v) { return $8661af75706be5f2$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $8661af75706be5f2$export$35808ee640e87ca7; }, function (v) { return $8661af75706be5f2$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $8661af75706be5f2$export$fae74005e78b1a27; }, function (v) { return $8661af75706be5f2$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $8661af75706be5f2$export$dc8fbce3eb94dc1e; }, function (v) { return $8661af75706be5f2$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $8661af75706be5f2$export$6a7bc4e911dc01cf; }, function (v) { return $8661af75706be5f2$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $8661af75706be5f2$export$6d9c69b0de29b591; }, function (v) { return $8661af75706be5f2$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $8661af75706be5f2$export$f680877a34711e37; }, function (v) { return $8661af75706be5f2$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $8661af75706be5f2$export$d5a552a76deda3c2; }, function (v) { return $8661af75706be5f2$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $8661af75706be5f2$export$aaabe4eda9ed9969; }, function (v) { return $8661af75706be5f2$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $8661af75706be5f2$export$e5c5a5f917a5871c; }, function (v) { return $8661af75706be5f2$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $8661af75706be5f2$export$1538c33de8887b59; }, function (v) { return $8661af75706be5f2$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $8661af75706be5f2$export$13e3392192263954; }, function (v) { return $8661af75706be5f2$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $8661af75706be5f2$export$b8f5890fc79d6aca; }, function (v) { return $8661af75706be5f2$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $8661af75706be5f2$export$60241385465d0a34; }, function (v) { return $8661af75706be5f2$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $8661af75706be5f2$export$306c0aa65ff9ec16; }, function (v) { return $8661af75706be5f2$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $8661af75706be5f2$export$7b286972b8d8ccbf; }, function (v) { return $8661af75706be5f2$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $8661af75706be5f2$export$83d89fbfd8236492; }, function (v) { return $8661af75706be5f2$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8661af75706be5f2$export$dca3b0875bd9a954;
var $8661af75706be5f2$export$16fa2f45be04daa8;
var $8661af75706be5f2$export$ffb0004e005737fa;
var $8661af75706be5f2$export$e2c29f18771995cb;
var $8661af75706be5f2$export$221d75b3f55bb0bd;
var $8661af75706be5f2$export$5f8d39834fd61797;
var $8661af75706be5f2$export$74bf444e3cd11ea5;
var $8661af75706be5f2$export$ae55be85d98224ed;
var $8661af75706be5f2$export$3ba232387fd5d6dd;
var $8661af75706be5f2$export$e530037191fcd5d7;
var $8661af75706be5f2$export$fd42f52fd3ae1109;
var $8661af75706be5f2$export$c8a8987d4410bf2d;
var $8661af75706be5f2$export$d38cd72104c1f0e9;
var $8661af75706be5f2$export$7d1e3a5e95ceca43;
var $8661af75706be5f2$export$257a8862b851cb5b;
var $8661af75706be5f2$export$a8257692ac88316c;
var $8661af75706be5f2$export$488013bae63b21da;
var $8661af75706be5f2$export$7c73462e0d25e514;
var $8661af75706be5f2$export$7568632d0d33d16d;
var $8661af75706be5f2$export$88948ce120ea2619;
var $8661af75706be5f2$export$35808ee640e87ca7;
var $8661af75706be5f2$export$fae74005e78b1a27;
var $8661af75706be5f2$export$dc8fbce3eb94dc1e;
var $8661af75706be5f2$export$6a7bc4e911dc01cf;
var $8661af75706be5f2$export$6d9c69b0de29b591;
var $8661af75706be5f2$export$f680877a34711e37;
var $8661af75706be5f2$export$d5a552a76deda3c2;
var $8661af75706be5f2$export$aaabe4eda9ed9969;
var $8661af75706be5f2$export$e5c5a5f917a5871c;
var $8661af75706be5f2$export$1538c33de8887b59;
var $8661af75706be5f2$export$13e3392192263954;
var $8661af75706be5f2$export$b8f5890fc79d6aca;
var $8661af75706be5f2$export$60241385465d0a34;
var $8661af75706be5f2$export$306c0aa65ff9ec16;
var $8661af75706be5f2$export$7b286972b8d8ccbf;
var $8661af75706be5f2$export$83d89fbfd8236492;
'use strict';
var $8661af75706be5f2$var$l = Symbol.for("react.element"), $8661af75706be5f2$var$n = Symbol.for("react.portal"), $8661af75706be5f2$var$p = Symbol.for("react.fragment"), $8661af75706be5f2$var$q = Symbol.for("react.strict_mode"), $8661af75706be5f2$var$r = Symbol.for("react.profiler"), $8661af75706be5f2$var$t = Symbol.for("react.provider"), $8661af75706be5f2$var$u = Symbol.for("react.context"), $8661af75706be5f2$var$v = Symbol.for("react.forward_ref"), $8661af75706be5f2$var$w = Symbol.for("react.suspense"), $8661af75706be5f2$var$x = Symbol.for("react.memo"), $8661af75706be5f2$var$y = Symbol.for("react.lazy"), $8661af75706be5f2$var$z = Symbol.iterator;
function $8661af75706be5f2$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8661af75706be5f2$var$z && a[$8661af75706be5f2$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $8661af75706be5f2$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8661af75706be5f2$var$C = Object.assign, $8661af75706be5f2$var$D = {};
function $8661af75706be5f2$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $8661af75706be5f2$var$D;
    this.updater = e || $8661af75706be5f2$var$B;
}
$8661af75706be5f2$var$E.prototype.isReactComponent = {};
$8661af75706be5f2$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$8661af75706be5f2$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $8661af75706be5f2$var$F() {}
$8661af75706be5f2$var$F.prototype = $8661af75706be5f2$var$E.prototype;
function $8661af75706be5f2$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $8661af75706be5f2$var$D;
    this.updater = e || $8661af75706be5f2$var$B;
}
var $8661af75706be5f2$var$H = $8661af75706be5f2$var$G.prototype = new $8661af75706be5f2$var$F;
$8661af75706be5f2$var$H.constructor = $8661af75706be5f2$var$G;
$8661af75706be5f2$var$C($8661af75706be5f2$var$H, $8661af75706be5f2$var$E.prototype);
$8661af75706be5f2$var$H.isPureReactComponent = !0;
var $8661af75706be5f2$var$I = Array.isArray, $8661af75706be5f2$var$J = Object.prototype.hasOwnProperty, $8661af75706be5f2$var$K = {
    current: null
}, $8661af75706be5f2$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8661af75706be5f2$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$8661af75706be5f2$var$J.call(b, d) && !$8661af75706be5f2$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $8661af75706be5f2$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $8661af75706be5f2$var$K.current
    };
}
function $8661af75706be5f2$var$N(a, b) {
    return {
        $$typeof: $8661af75706be5f2$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $8661af75706be5f2$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8661af75706be5f2$var$l;
}
function $8661af75706be5f2$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $8661af75706be5f2$var$P = /\/+/g;
function $8661af75706be5f2$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $8661af75706be5f2$var$escape("" + a.key) : b.toString(36);
}
function $8661af75706be5f2$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $8661af75706be5f2$var$l:
                case $8661af75706be5f2$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $8661af75706be5f2$var$Q(h, 0) : d, $8661af75706be5f2$var$I(c) ? (e = "", null != a && (e = a.replace($8661af75706be5f2$var$P, "$&/") + "/"), $8661af75706be5f2$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($8661af75706be5f2$var$O(c) && (c = $8661af75706be5f2$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($8661af75706be5f2$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($8661af75706be5f2$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $8661af75706be5f2$var$Q(k, g);
        h += $8661af75706be5f2$var$R(k, b, e, f, c);
    }
    else if (f = $8661af75706be5f2$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $8661af75706be5f2$var$Q(k, g++), h += $8661af75706be5f2$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $8661af75706be5f2$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $8661af75706be5f2$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $8661af75706be5f2$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $8661af75706be5f2$var$U = {
    current: null
}, $8661af75706be5f2$var$V = {
    transition: null
}, $8661af75706be5f2$var$W = {
    ReactCurrentDispatcher: $8661af75706be5f2$var$U,
    ReactCurrentBatchConfig: $8661af75706be5f2$var$V,
    ReactCurrentOwner: $8661af75706be5f2$var$K
};
function $8661af75706be5f2$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$8661af75706be5f2$export$dca3b0875bd9a954 = {
    map: $8661af75706be5f2$var$S,
    forEach: function(a, b, e) {
        $8661af75706be5f2$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $8661af75706be5f2$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $8661af75706be5f2$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$8661af75706be5f2$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$8661af75706be5f2$export$16fa2f45be04daa8 = $8661af75706be5f2$var$E;
$8661af75706be5f2$export$ffb0004e005737fa = $8661af75706be5f2$var$p;
$8661af75706be5f2$export$e2c29f18771995cb = $8661af75706be5f2$var$r;
$8661af75706be5f2$export$221d75b3f55bb0bd = $8661af75706be5f2$var$G;
$8661af75706be5f2$export$5f8d39834fd61797 = $8661af75706be5f2$var$q;
$8661af75706be5f2$export$74bf444e3cd11ea5 = $8661af75706be5f2$var$w;
$8661af75706be5f2$export$ae55be85d98224ed = $8661af75706be5f2$var$W;
$8661af75706be5f2$export$3ba232387fd5d6dd = $8661af75706be5f2$var$X;
$8661af75706be5f2$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $8661af75706be5f2$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $8661af75706be5f2$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$8661af75706be5f2$var$J.call(b, f) && !$8661af75706be5f2$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $8661af75706be5f2$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$8661af75706be5f2$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $8661af75706be5f2$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $8661af75706be5f2$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$8661af75706be5f2$export$c8a8987d4410bf2d = $8661af75706be5f2$var$M;
$8661af75706be5f2$export$d38cd72104c1f0e9 = function(a) {
    var b = $8661af75706be5f2$var$M.bind(null, a);
    b.type = a;
    return b;
};
$8661af75706be5f2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8661af75706be5f2$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $8661af75706be5f2$var$v,
        render: a
    };
};
$8661af75706be5f2$export$a8257692ac88316c = $8661af75706be5f2$var$O;
$8661af75706be5f2$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $8661af75706be5f2$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $8661af75706be5f2$var$T
    };
};
$8661af75706be5f2$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $8661af75706be5f2$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$8661af75706be5f2$export$7568632d0d33d16d = function(a) {
    var b = $8661af75706be5f2$var$V.transition;
    $8661af75706be5f2$var$V.transition = {};
    try {
        a();
    } finally{
        $8661af75706be5f2$var$V.transition = b;
    }
};
$8661af75706be5f2$export$88948ce120ea2619 = $8661af75706be5f2$var$X;
$8661af75706be5f2$export$35808ee640e87ca7 = function(a, b) {
    return $8661af75706be5f2$var$U.current.useCallback(a, b);
};
$8661af75706be5f2$export$fae74005e78b1a27 = function(a) {
    return $8661af75706be5f2$var$U.current.useContext(a);
};
$8661af75706be5f2$export$dc8fbce3eb94dc1e = function() {};
$8661af75706be5f2$export$6a7bc4e911dc01cf = function(a) {
    return $8661af75706be5f2$var$U.current.useDeferredValue(a);
};
$8661af75706be5f2$export$6d9c69b0de29b591 = function(a, b) {
    return $8661af75706be5f2$var$U.current.useEffect(a, b);
};
$8661af75706be5f2$export$f680877a34711e37 = function() {
    return $8661af75706be5f2$var$U.current.useId();
};
$8661af75706be5f2$export$d5a552a76deda3c2 = function(a, b, e) {
    return $8661af75706be5f2$var$U.current.useImperativeHandle(a, b, e);
};
$8661af75706be5f2$export$aaabe4eda9ed9969 = function(a, b) {
    return $8661af75706be5f2$var$U.current.useInsertionEffect(a, b);
};
$8661af75706be5f2$export$e5c5a5f917a5871c = function(a, b) {
    return $8661af75706be5f2$var$U.current.useLayoutEffect(a, b);
};
$8661af75706be5f2$export$1538c33de8887b59 = function(a, b) {
    return $8661af75706be5f2$var$U.current.useMemo(a, b);
};
$8661af75706be5f2$export$13e3392192263954 = function(a, b, e) {
    return $8661af75706be5f2$var$U.current.useReducer(a, b, e);
};
$8661af75706be5f2$export$b8f5890fc79d6aca = function(a) {
    return $8661af75706be5f2$var$U.current.useRef(a);
};
$8661af75706be5f2$export$60241385465d0a34 = function(a) {
    return $8661af75706be5f2$var$U.current.useState(a);
};
$8661af75706be5f2$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $8661af75706be5f2$var$U.current.useSyncExternalStore(a, b, e);
};
$8661af75706be5f2$export$7b286972b8d8ccbf = function() {
    return $8661af75706be5f2$var$U.current.useTransition();
};
$8661af75706be5f2$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("cALPN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $e7dIb = parcelRequire("e7dIb");
function $92adf3c13b108af8$var$emptyFunction() {}
function $92adf3c13b108af8$var$emptyFunctionWithReset() {}
$92adf3c13b108af8$var$emptyFunctionWithReset.resetWarningCache = $92adf3c13b108af8$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $e7dIb) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $92adf3c13b108af8$var$emptyFunctionWithReset,
        resetWarningCache: $92adf3c13b108af8$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("e7dIb", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $a46c5af503544301$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $a46c5af503544301$var$ReactPropTypesSecret;

});


parcelRegister("fSlyq", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $b8ec9e6414e19d2a$export$2b8d127b894957b9; }, function (v) { return $b8ec9e6414e19d2a$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $b8ec9e6414e19d2a$export$cea3a54a6425200c; }, function (v) { return $b8ec9e6414e19d2a$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $b8ec9e6414e19d2a$export$a7c73072b1a182ae; }, function (v) { return $b8ec9e6414e19d2a$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b8ec9e6414e19d2a$export$9f27bc3417b4524d; }, function (v) { return $b8ec9e6414e19d2a$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b8ec9e6414e19d2a$export$db77ccec0bb4ccac; }, function (v) { return $b8ec9e6414e19d2a$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b8ec9e6414e19d2a$export$8392c0c9d3dcbd35; }, function (v) { return $b8ec9e6414e19d2a$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b8ec9e6414e19d2a$export$ffb0004e005737fa; }, function (v) { return $b8ec9e6414e19d2a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b8ec9e6414e19d2a$export$b624eff549462981; }, function (v) { return $b8ec9e6414e19d2a$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b8ec9e6414e19d2a$export$7897aa7841a5380c; }, function (v) { return $b8ec9e6414e19d2a$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b8ec9e6414e19d2a$export$602eac185826482c; }, function (v) { return $b8ec9e6414e19d2a$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b8ec9e6414e19d2a$export$e2c29f18771995cb; }, function (v) { return $b8ec9e6414e19d2a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b8ec9e6414e19d2a$export$5f8d39834fd61797; }, function (v) { return $b8ec9e6414e19d2a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b8ec9e6414e19d2a$export$74bf444e3cd11ea5; }, function (v) { return $b8ec9e6414e19d2a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $b8ec9e6414e19d2a$export$92387174baf9b227; }, function (v) { return $b8ec9e6414e19d2a$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $b8ec9e6414e19d2a$export$ec112efeb987d9c6; }, function (v) { return $b8ec9e6414e19d2a$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b8ec9e6414e19d2a$export$b706b080d889d2c9; }, function (v) { return $b8ec9e6414e19d2a$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b8ec9e6414e19d2a$export$5be5a87408f70ddc; }, function (v) { return $b8ec9e6414e19d2a$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b8ec9e6414e19d2a$export$45a5e7f76e0caa8d; }, function (v) { return $b8ec9e6414e19d2a$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b8ec9e6414e19d2a$export$455c2e768291efa6; }, function (v) { return $b8ec9e6414e19d2a$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b8ec9e6414e19d2a$export$9522e17588c12572; }, function (v) { return $b8ec9e6414e19d2a$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b8ec9e6414e19d2a$export$2110ac352bb060b9; }, function (v) { return $b8ec9e6414e19d2a$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b8ec9e6414e19d2a$export$56885ab8b9c456ab; }, function (v) { return $b8ec9e6414e19d2a$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b8ec9e6414e19d2a$export$d927fcb6adf8f9de; }, function (v) { return $b8ec9e6414e19d2a$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b8ec9e6414e19d2a$export$b82d16f27459e05a; }, function (v) { return $b8ec9e6414e19d2a$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b8ec9e6414e19d2a$export$522c17b4f5e123e8; }, function (v) { return $b8ec9e6414e19d2a$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b8ec9e6414e19d2a$export$1aabd8a0274ecfd6; }, function (v) { return $b8ec9e6414e19d2a$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b8ec9e6414e19d2a$export$9b621391a187a31a; }, function (v) { return $b8ec9e6414e19d2a$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b8ec9e6414e19d2a$export$f5bbd400c2f4426f; }, function (v) { return $b8ec9e6414e19d2a$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b8ec9e6414e19d2a$export$2b8d127b894957b9;
var $b8ec9e6414e19d2a$export$cea3a54a6425200c;
var $b8ec9e6414e19d2a$export$a7c73072b1a182ae;
var $b8ec9e6414e19d2a$export$9f27bc3417b4524d;
var $b8ec9e6414e19d2a$export$db77ccec0bb4ccac;
var $b8ec9e6414e19d2a$export$8392c0c9d3dcbd35;
var $b8ec9e6414e19d2a$export$ffb0004e005737fa;
var $b8ec9e6414e19d2a$export$b624eff549462981;
var $b8ec9e6414e19d2a$export$7897aa7841a5380c;
var $b8ec9e6414e19d2a$export$602eac185826482c;
var $b8ec9e6414e19d2a$export$e2c29f18771995cb;
var $b8ec9e6414e19d2a$export$5f8d39834fd61797;
var $b8ec9e6414e19d2a$export$74bf444e3cd11ea5;
var $b8ec9e6414e19d2a$export$92387174baf9b227;
var $b8ec9e6414e19d2a$export$ec112efeb987d9c6;
var $b8ec9e6414e19d2a$export$b706b080d889d2c9;
var $b8ec9e6414e19d2a$export$5be5a87408f70ddc;
var $b8ec9e6414e19d2a$export$45a5e7f76e0caa8d;
var $b8ec9e6414e19d2a$export$455c2e768291efa6;
var $b8ec9e6414e19d2a$export$9522e17588c12572;
var $b8ec9e6414e19d2a$export$2110ac352bb060b9;
var $b8ec9e6414e19d2a$export$56885ab8b9c456ab;
var $b8ec9e6414e19d2a$export$d927fcb6adf8f9de;
var $b8ec9e6414e19d2a$export$b82d16f27459e05a;
var $b8ec9e6414e19d2a$export$522c17b4f5e123e8;
var $b8ec9e6414e19d2a$export$1aabd8a0274ecfd6;
var $b8ec9e6414e19d2a$export$9b621391a187a31a;
var $b8ec9e6414e19d2a$export$f5bbd400c2f4426f;
'use strict';
var $b8ec9e6414e19d2a$var$b = "function" === typeof Symbol && Symbol.for, $b8ec9e6414e19d2a$var$c = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.element") : 60103, $b8ec9e6414e19d2a$var$d = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.portal") : 60106, $b8ec9e6414e19d2a$var$e = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.fragment") : 60107, $b8ec9e6414e19d2a$var$f = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.strict_mode") : 60108, $b8ec9e6414e19d2a$var$g = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.profiler") : 60114, $b8ec9e6414e19d2a$var$h = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.provider") : 60109, $b8ec9e6414e19d2a$var$k = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.context") : 60110, $b8ec9e6414e19d2a$var$l = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.async_mode") : 60111, $b8ec9e6414e19d2a$var$m = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.concurrent_mode") : 60111, $b8ec9e6414e19d2a$var$n = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.forward_ref") : 60112, $b8ec9e6414e19d2a$var$p = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.suspense") : 60113, $b8ec9e6414e19d2a$var$q = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.suspense_list") : 60120, $b8ec9e6414e19d2a$var$r = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.memo") : 60115, $b8ec9e6414e19d2a$var$t = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.lazy") : 60116, $b8ec9e6414e19d2a$var$v = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.block") : 60121, $b8ec9e6414e19d2a$var$w = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.fundamental") : 60117, $b8ec9e6414e19d2a$var$x = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.responder") : 60118, $b8ec9e6414e19d2a$var$y = $b8ec9e6414e19d2a$var$b ? Symbol.for("react.scope") : 60119;
function $b8ec9e6414e19d2a$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $b8ec9e6414e19d2a$var$c:
                switch(a = a.type, a){
                    case $b8ec9e6414e19d2a$var$l:
                    case $b8ec9e6414e19d2a$var$m:
                    case $b8ec9e6414e19d2a$var$e:
                    case $b8ec9e6414e19d2a$var$g:
                    case $b8ec9e6414e19d2a$var$f:
                    case $b8ec9e6414e19d2a$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b8ec9e6414e19d2a$var$k:
                            case $b8ec9e6414e19d2a$var$n:
                            case $b8ec9e6414e19d2a$var$t:
                            case $b8ec9e6414e19d2a$var$r:
                            case $b8ec9e6414e19d2a$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $b8ec9e6414e19d2a$var$d:
                return u;
        }
    }
}
function $b8ec9e6414e19d2a$var$A(a) {
    return $b8ec9e6414e19d2a$var$z(a) === $b8ec9e6414e19d2a$var$m;
}
$b8ec9e6414e19d2a$export$2b8d127b894957b9 = $b8ec9e6414e19d2a$var$l;
$b8ec9e6414e19d2a$export$cea3a54a6425200c = $b8ec9e6414e19d2a$var$m;
$b8ec9e6414e19d2a$export$a7c73072b1a182ae = $b8ec9e6414e19d2a$var$k;
$b8ec9e6414e19d2a$export$9f27bc3417b4524d = $b8ec9e6414e19d2a$var$h;
$b8ec9e6414e19d2a$export$db77ccec0bb4ccac = $b8ec9e6414e19d2a$var$c;
$b8ec9e6414e19d2a$export$8392c0c9d3dcbd35 = $b8ec9e6414e19d2a$var$n;
$b8ec9e6414e19d2a$export$ffb0004e005737fa = $b8ec9e6414e19d2a$var$e;
$b8ec9e6414e19d2a$export$b624eff549462981 = $b8ec9e6414e19d2a$var$t;
$b8ec9e6414e19d2a$export$7897aa7841a5380c = $b8ec9e6414e19d2a$var$r;
$b8ec9e6414e19d2a$export$602eac185826482c = $b8ec9e6414e19d2a$var$d;
$b8ec9e6414e19d2a$export$e2c29f18771995cb = $b8ec9e6414e19d2a$var$g;
$b8ec9e6414e19d2a$export$5f8d39834fd61797 = $b8ec9e6414e19d2a$var$f;
$b8ec9e6414e19d2a$export$74bf444e3cd11ea5 = $b8ec9e6414e19d2a$var$p;
$b8ec9e6414e19d2a$export$92387174baf9b227 = function(a) {
    return $b8ec9e6414e19d2a$var$A(a) || $b8ec9e6414e19d2a$var$z(a) === $b8ec9e6414e19d2a$var$l;
};
$b8ec9e6414e19d2a$export$ec112efeb987d9c6 = $b8ec9e6414e19d2a$var$A;
$b8ec9e6414e19d2a$export$b706b080d889d2c9 = function(a) {
    return $b8ec9e6414e19d2a$var$z(a) === $b8ec9e6414e19d2a$var$k;
};
$b8ec9e6414e19d2a$export$5be5a87408f70ddc = function(a) {
    return $b8ec9e6414e19d2a$var$z(a) === $b8ec9e6414e19d2a$var$h;
};
$b8ec9e6414e19d2a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b8ec9e6414e19d2a$var$c;
};
$b8ec9e6414e19d2a$export$455c2e768291efa6 = function(a) {
    return $b8ec9e6414e19d2a$var$z(a) === $b8ec9e6414e19d2a$var$n;
};
$b8ec9e6414e19d2a$export$9522e17588c12572 = function(a) {
    return $b8ec9e6414e19d2a$var$z(a) === $b8ec9e6414e19d2a$var$e;
};
$b8ec9e6414e19d2a$export$2110ac352bb060b9 = function(a) {
    return $b8ec9e6414e19d2a$var$z(a) === $b8ec9e6414e19d2a$var$t;
};
$b8ec9e6414e19d2a$export$56885ab8b9c456ab = function(a) {
    return $b8ec9e6414e19d2a$var$z(a) === $b8ec9e6414e19d2a$var$r;
};
$b8ec9e6414e19d2a$export$d927fcb6adf8f9de = function(a) {
    return $b8ec9e6414e19d2a$var$z(a) === $b8ec9e6414e19d2a$var$d;
};
$b8ec9e6414e19d2a$export$b82d16f27459e05a = function(a) {
    return $b8ec9e6414e19d2a$var$z(a) === $b8ec9e6414e19d2a$var$g;
};
$b8ec9e6414e19d2a$export$522c17b4f5e123e8 = function(a) {
    return $b8ec9e6414e19d2a$var$z(a) === $b8ec9e6414e19d2a$var$f;
};
$b8ec9e6414e19d2a$export$1aabd8a0274ecfd6 = function(a) {
    return $b8ec9e6414e19d2a$var$z(a) === $b8ec9e6414e19d2a$var$p;
};
$b8ec9e6414e19d2a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b8ec9e6414e19d2a$var$e || a === $b8ec9e6414e19d2a$var$m || a === $b8ec9e6414e19d2a$var$g || a === $b8ec9e6414e19d2a$var$f || a === $b8ec9e6414e19d2a$var$p || a === $b8ec9e6414e19d2a$var$q || "object" === typeof a && null !== a && (a.$$typeof === $b8ec9e6414e19d2a$var$t || a.$$typeof === $b8ec9e6414e19d2a$var$r || a.$$typeof === $b8ec9e6414e19d2a$var$h || a.$$typeof === $b8ec9e6414e19d2a$var$k || a.$$typeof === $b8ec9e6414e19d2a$var$n || a.$$typeof === $b8ec9e6414e19d2a$var$w || a.$$typeof === $b8ec9e6414e19d2a$var$x || a.$$typeof === $b8ec9e6414e19d2a$var$y || a.$$typeof === $b8ec9e6414e19d2a$var$v);
};
$b8ec9e6414e19d2a$export$f5bbd400c2f4426f = $b8ec9e6414e19d2a$var$z;

});

parcelRegister("87PU2", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $5ea73cfb65e4f747$export$ae55be85d98224ed; }, function (v) { return $5ea73cfb65e4f747$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $5ea73cfb65e4f747$export$d39a5bbd09211389; }, function (v) { return $5ea73cfb65e4f747$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $5ea73cfb65e4f747$export$882461b6382ed46c; }, function (v) { return $5ea73cfb65e4f747$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $5ea73cfb65e4f747$export$466bfc07425424d5; }, function (v) { return $5ea73cfb65e4f747$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $5ea73cfb65e4f747$export$cd75ccfd720a3cd4; }, function (v) { return $5ea73cfb65e4f747$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $5ea73cfb65e4f747$export$fa8d919ba61d84db; }, function (v) { return $5ea73cfb65e4f747$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $5ea73cfb65e4f747$export$757ceba2d55c277e; }, function (v) { return $5ea73cfb65e4f747$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $5ea73cfb65e4f747$export$b3890eb0ae9dca99; }, function (v) { return $5ea73cfb65e4f747$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $5ea73cfb65e4f747$export$502457920280e6be; }, function (v) { return $5ea73cfb65e4f747$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $5ea73cfb65e4f747$export$c78a37762a8d58e1; }, function (v) { return $5ea73cfb65e4f747$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $5ea73cfb65e4f747$export$dc54d992c10e8a18; }, function (v) { return $5ea73cfb65e4f747$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $5ea73cfb65e4f747$export$83d89fbfd8236492; }, function (v) { return $5ea73cfb65e4f747$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $5ea73cfb65e4f747$export$ae55be85d98224ed;
var $5ea73cfb65e4f747$export$d39a5bbd09211389;
var $5ea73cfb65e4f747$export$882461b6382ed46c;
var $5ea73cfb65e4f747$export$466bfc07425424d5;
var $5ea73cfb65e4f747$export$cd75ccfd720a3cd4;
var $5ea73cfb65e4f747$export$fa8d919ba61d84db;
var $5ea73cfb65e4f747$export$757ceba2d55c277e;
var $5ea73cfb65e4f747$export$b3890eb0ae9dca99;
var $5ea73cfb65e4f747$export$502457920280e6be;
var $5ea73cfb65e4f747$export$c78a37762a8d58e1;
var $5ea73cfb65e4f747$export$dc54d992c10e8a18;
var $5ea73cfb65e4f747$export$83d89fbfd8236492;
'use strict';

var $6aRB8 = parcelRequire("6aRB8");

var $4xFQO = parcelRequire("4xFQO");
function $5ea73cfb65e4f747$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $5ea73cfb65e4f747$var$da = new Set, $5ea73cfb65e4f747$var$ea = {};
function $5ea73cfb65e4f747$var$fa(a, b) {
    $5ea73cfb65e4f747$var$ha(a, b);
    $5ea73cfb65e4f747$var$ha(a + "Capture", b);
}
function $5ea73cfb65e4f747$var$ha(a, b) {
    $5ea73cfb65e4f747$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$5ea73cfb65e4f747$var$da.add(b[a]);
}
var $5ea73cfb65e4f747$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $5ea73cfb65e4f747$var$ja = Object.prototype.hasOwnProperty, $5ea73cfb65e4f747$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $5ea73cfb65e4f747$var$la = {}, $5ea73cfb65e4f747$var$ma = {};
function $5ea73cfb65e4f747$var$oa(a) {
    if ($5ea73cfb65e4f747$var$ja.call($5ea73cfb65e4f747$var$ma, a)) return !0;
    if ($5ea73cfb65e4f747$var$ja.call($5ea73cfb65e4f747$var$la, a)) return !1;
    if ($5ea73cfb65e4f747$var$ka.test(a)) return $5ea73cfb65e4f747$var$ma[a] = !0;
    $5ea73cfb65e4f747$var$la[a] = !0;
    return !1;
}
function $5ea73cfb65e4f747$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $5ea73cfb65e4f747$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $5ea73cfb65e4f747$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $5ea73cfb65e4f747$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $5ea73cfb65e4f747$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $5ea73cfb65e4f747$var$z[a] = new $5ea73cfb65e4f747$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $5ea73cfb65e4f747$var$z[b] = new $5ea73cfb65e4f747$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $5ea73cfb65e4f747$var$z[a] = new $5ea73cfb65e4f747$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $5ea73cfb65e4f747$var$z[a] = new $5ea73cfb65e4f747$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $5ea73cfb65e4f747$var$z[a] = new $5ea73cfb65e4f747$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $5ea73cfb65e4f747$var$z[a] = new $5ea73cfb65e4f747$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $5ea73cfb65e4f747$var$z[a] = new $5ea73cfb65e4f747$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $5ea73cfb65e4f747$var$z[a] = new $5ea73cfb65e4f747$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $5ea73cfb65e4f747$var$z[a] = new $5ea73cfb65e4f747$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $5ea73cfb65e4f747$var$ra = /[\-:]([a-z])/g;
function $5ea73cfb65e4f747$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($5ea73cfb65e4f747$var$ra, $5ea73cfb65e4f747$var$sa);
    $5ea73cfb65e4f747$var$z[b] = new $5ea73cfb65e4f747$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($5ea73cfb65e4f747$var$ra, $5ea73cfb65e4f747$var$sa);
    $5ea73cfb65e4f747$var$z[b] = new $5ea73cfb65e4f747$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($5ea73cfb65e4f747$var$ra, $5ea73cfb65e4f747$var$sa);
    $5ea73cfb65e4f747$var$z[b] = new $5ea73cfb65e4f747$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $5ea73cfb65e4f747$var$z[a] = new $5ea73cfb65e4f747$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$5ea73cfb65e4f747$var$z.xlinkHref = new $5ea73cfb65e4f747$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $5ea73cfb65e4f747$var$z[a] = new $5ea73cfb65e4f747$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $5ea73cfb65e4f747$var$ta(a, b, c, d) {
    var e = $5ea73cfb65e4f747$var$z.hasOwnProperty(b) ? $5ea73cfb65e4f747$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $5ea73cfb65e4f747$var$qa(b, c, e, d) && (c = null), d || null === e ? $5ea73cfb65e4f747$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $5ea73cfb65e4f747$var$ua = $6aRB8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $5ea73cfb65e4f747$var$va = Symbol.for("react.element"), $5ea73cfb65e4f747$var$wa = Symbol.for("react.portal"), $5ea73cfb65e4f747$var$ya = Symbol.for("react.fragment"), $5ea73cfb65e4f747$var$za = Symbol.for("react.strict_mode"), $5ea73cfb65e4f747$var$Aa = Symbol.for("react.profiler"), $5ea73cfb65e4f747$var$Ba = Symbol.for("react.provider"), $5ea73cfb65e4f747$var$Ca = Symbol.for("react.context"), $5ea73cfb65e4f747$var$Da = Symbol.for("react.forward_ref"), $5ea73cfb65e4f747$var$Ea = Symbol.for("react.suspense"), $5ea73cfb65e4f747$var$Fa = Symbol.for("react.suspense_list"), $5ea73cfb65e4f747$var$Ga = Symbol.for("react.memo"), $5ea73cfb65e4f747$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $5ea73cfb65e4f747$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $5ea73cfb65e4f747$var$Ja = Symbol.iterator;
function $5ea73cfb65e4f747$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5ea73cfb65e4f747$var$Ja && a[$5ea73cfb65e4f747$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $5ea73cfb65e4f747$var$A = Object.assign, $5ea73cfb65e4f747$var$La;
function $5ea73cfb65e4f747$var$Ma(a) {
    if (void 0 === $5ea73cfb65e4f747$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $5ea73cfb65e4f747$var$La = b && b[1] || "";
    }
    return "\n" + $5ea73cfb65e4f747$var$La + a;
}
var $5ea73cfb65e4f747$var$Na = !1;
function $5ea73cfb65e4f747$var$Oa(a, b) {
    if (!a || $5ea73cfb65e4f747$var$Na) return "";
    $5ea73cfb65e4f747$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $5ea73cfb65e4f747$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $5ea73cfb65e4f747$var$Ma(a) : "";
}
function $5ea73cfb65e4f747$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $5ea73cfb65e4f747$var$Ma(a.type);
        case 16:
            return $5ea73cfb65e4f747$var$Ma("Lazy");
        case 13:
            return $5ea73cfb65e4f747$var$Ma("Suspense");
        case 19:
            return $5ea73cfb65e4f747$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $5ea73cfb65e4f747$var$Oa(a.type, !1), a;
        case 11:
            return a = $5ea73cfb65e4f747$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $5ea73cfb65e4f747$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $5ea73cfb65e4f747$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $5ea73cfb65e4f747$var$ya:
            return "Fragment";
        case $5ea73cfb65e4f747$var$wa:
            return "Portal";
        case $5ea73cfb65e4f747$var$Aa:
            return "Profiler";
        case $5ea73cfb65e4f747$var$za:
            return "StrictMode";
        case $5ea73cfb65e4f747$var$Ea:
            return "Suspense";
        case $5ea73cfb65e4f747$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $5ea73cfb65e4f747$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $5ea73cfb65e4f747$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $5ea73cfb65e4f747$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $5ea73cfb65e4f747$var$Ga:
            return b = a.displayName || null, null !== b ? b : $5ea73cfb65e4f747$var$Qa(a.type) || "Memo";
        case $5ea73cfb65e4f747$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $5ea73cfb65e4f747$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $5ea73cfb65e4f747$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $5ea73cfb65e4f747$var$Qa(b);
        case 8:
            return b === $5ea73cfb65e4f747$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $5ea73cfb65e4f747$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $5ea73cfb65e4f747$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $5ea73cfb65e4f747$var$Ua(a) {
    var b = $5ea73cfb65e4f747$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $5ea73cfb65e4f747$var$Va(a) {
    a._valueTracker || (a._valueTracker = $5ea73cfb65e4f747$var$Ua(a));
}
function $5ea73cfb65e4f747$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $5ea73cfb65e4f747$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $5ea73cfb65e4f747$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $5ea73cfb65e4f747$var$Ya(a, b) {
    var c = b.checked;
    return $5ea73cfb65e4f747$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $5ea73cfb65e4f747$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $5ea73cfb65e4f747$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $5ea73cfb65e4f747$var$ab(a, b) {
    b = b.checked;
    null != b && $5ea73cfb65e4f747$var$ta(a, "checked", b, !1);
}
function $5ea73cfb65e4f747$var$bb(a, b) {
    $5ea73cfb65e4f747$var$ab(a, b);
    var c = $5ea73cfb65e4f747$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $5ea73cfb65e4f747$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $5ea73cfb65e4f747$var$cb(a, b.type, $5ea73cfb65e4f747$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $5ea73cfb65e4f747$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $5ea73cfb65e4f747$var$cb(a, b, c) {
    if ("number" !== b || $5ea73cfb65e4f747$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $5ea73cfb65e4f747$var$eb = Array.isArray;
function $5ea73cfb65e4f747$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $5ea73cfb65e4f747$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $5ea73cfb65e4f747$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($5ea73cfb65e4f747$var$p(91));
    return $5ea73cfb65e4f747$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $5ea73cfb65e4f747$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($5ea73cfb65e4f747$var$p(92));
            if ($5ea73cfb65e4f747$var$eb(c)) {
                if (1 < c.length) throw Error($5ea73cfb65e4f747$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $5ea73cfb65e4f747$var$Sa(c)
    };
}
function $5ea73cfb65e4f747$var$ib(a, b) {
    var c = $5ea73cfb65e4f747$var$Sa(b.value), d = $5ea73cfb65e4f747$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $5ea73cfb65e4f747$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $5ea73cfb65e4f747$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $5ea73cfb65e4f747$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $5ea73cfb65e4f747$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $5ea73cfb65e4f747$var$mb, $5ea73cfb65e4f747$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $5ea73cfb65e4f747$var$mb = $5ea73cfb65e4f747$var$mb || document.createElement("div");
        $5ea73cfb65e4f747$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $5ea73cfb65e4f747$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $5ea73cfb65e4f747$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $5ea73cfb65e4f747$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $5ea73cfb65e4f747$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($5ea73cfb65e4f747$var$pb).forEach(function(a) {
    $5ea73cfb65e4f747$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $5ea73cfb65e4f747$var$pb[b] = $5ea73cfb65e4f747$var$pb[a];
    });
});
function $5ea73cfb65e4f747$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $5ea73cfb65e4f747$var$pb.hasOwnProperty(a) && $5ea73cfb65e4f747$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $5ea73cfb65e4f747$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $5ea73cfb65e4f747$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $5ea73cfb65e4f747$var$tb = $5ea73cfb65e4f747$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $5ea73cfb65e4f747$var$ub(a, b) {
    if (b) {
        if ($5ea73cfb65e4f747$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($5ea73cfb65e4f747$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($5ea73cfb65e4f747$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($5ea73cfb65e4f747$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($5ea73cfb65e4f747$var$p(62));
    }
}
function $5ea73cfb65e4f747$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $5ea73cfb65e4f747$var$wb = null;
function $5ea73cfb65e4f747$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $5ea73cfb65e4f747$var$yb = null, $5ea73cfb65e4f747$var$zb = null, $5ea73cfb65e4f747$var$Ab = null;
function $5ea73cfb65e4f747$var$Bb(a) {
    if (a = $5ea73cfb65e4f747$var$Cb(a)) {
        if ("function" !== typeof $5ea73cfb65e4f747$var$yb) throw Error($5ea73cfb65e4f747$var$p(280));
        var b = a.stateNode;
        b && (b = $5ea73cfb65e4f747$var$Db(b), $5ea73cfb65e4f747$var$yb(a.stateNode, a.type, b));
    }
}
function $5ea73cfb65e4f747$var$Eb(a) {
    $5ea73cfb65e4f747$var$zb ? $5ea73cfb65e4f747$var$Ab ? $5ea73cfb65e4f747$var$Ab.push(a) : $5ea73cfb65e4f747$var$Ab = [
        a
    ] : $5ea73cfb65e4f747$var$zb = a;
}
function $5ea73cfb65e4f747$var$Fb() {
    if ($5ea73cfb65e4f747$var$zb) {
        var a = $5ea73cfb65e4f747$var$zb, b = $5ea73cfb65e4f747$var$Ab;
        $5ea73cfb65e4f747$var$Ab = $5ea73cfb65e4f747$var$zb = null;
        $5ea73cfb65e4f747$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$5ea73cfb65e4f747$var$Bb(b[a]);
    }
}
function $5ea73cfb65e4f747$var$Gb(a, b) {
    return a(b);
}
function $5ea73cfb65e4f747$var$Hb() {}
var $5ea73cfb65e4f747$var$Ib = !1;
function $5ea73cfb65e4f747$var$Jb(a, b, c) {
    if ($5ea73cfb65e4f747$var$Ib) return a(b, c);
    $5ea73cfb65e4f747$var$Ib = !0;
    try {
        return $5ea73cfb65e4f747$var$Gb(a, b, c);
    } finally{
        if ($5ea73cfb65e4f747$var$Ib = !1, null !== $5ea73cfb65e4f747$var$zb || null !== $5ea73cfb65e4f747$var$Ab) $5ea73cfb65e4f747$var$Hb(), $5ea73cfb65e4f747$var$Fb();
    }
}
function $5ea73cfb65e4f747$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $5ea73cfb65e4f747$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($5ea73cfb65e4f747$var$p(231, b, typeof c));
    return c;
}
var $5ea73cfb65e4f747$var$Lb = !1;
if ($5ea73cfb65e4f747$var$ia) try {
    var $5ea73cfb65e4f747$var$Mb = {};
    Object.defineProperty($5ea73cfb65e4f747$var$Mb, "passive", {
        get: function() {
            $5ea73cfb65e4f747$var$Lb = !0;
        }
    });
    window.addEventListener("test", $5ea73cfb65e4f747$var$Mb, $5ea73cfb65e4f747$var$Mb);
    window.removeEventListener("test", $5ea73cfb65e4f747$var$Mb, $5ea73cfb65e4f747$var$Mb);
} catch (a) {
    $5ea73cfb65e4f747$var$Lb = !1;
}
function $5ea73cfb65e4f747$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $5ea73cfb65e4f747$var$Ob = !1, $5ea73cfb65e4f747$var$Pb = null, $5ea73cfb65e4f747$var$Qb = !1, $5ea73cfb65e4f747$var$Rb = null, $5ea73cfb65e4f747$var$Sb = {
    onError: function(a) {
        $5ea73cfb65e4f747$var$Ob = !0;
        $5ea73cfb65e4f747$var$Pb = a;
    }
};
function $5ea73cfb65e4f747$var$Tb(a, b, c, d, e, f, g, h, k) {
    $5ea73cfb65e4f747$var$Ob = !1;
    $5ea73cfb65e4f747$var$Pb = null;
    $5ea73cfb65e4f747$var$Nb.apply($5ea73cfb65e4f747$var$Sb, arguments);
}
function $5ea73cfb65e4f747$var$Ub(a, b, c, d, e, f, g, h, k) {
    $5ea73cfb65e4f747$var$Tb.apply(this, arguments);
    if ($5ea73cfb65e4f747$var$Ob) {
        if ($5ea73cfb65e4f747$var$Ob) {
            var l = $5ea73cfb65e4f747$var$Pb;
            $5ea73cfb65e4f747$var$Ob = !1;
            $5ea73cfb65e4f747$var$Pb = null;
        } else throw Error($5ea73cfb65e4f747$var$p(198));
        $5ea73cfb65e4f747$var$Qb || ($5ea73cfb65e4f747$var$Qb = !0, $5ea73cfb65e4f747$var$Rb = l);
    }
}
function $5ea73cfb65e4f747$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $5ea73cfb65e4f747$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $5ea73cfb65e4f747$var$Xb(a) {
    if ($5ea73cfb65e4f747$var$Vb(a) !== a) throw Error($5ea73cfb65e4f747$var$p(188));
}
function $5ea73cfb65e4f747$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $5ea73cfb65e4f747$var$Vb(a);
        if (null === b) throw Error($5ea73cfb65e4f747$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $5ea73cfb65e4f747$var$Xb(e), a;
                if (f === d) return $5ea73cfb65e4f747$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($5ea73cfb65e4f747$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($5ea73cfb65e4f747$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($5ea73cfb65e4f747$var$p(190));
    }
    if (3 !== c.tag) throw Error($5ea73cfb65e4f747$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $5ea73cfb65e4f747$var$Zb(a) {
    a = $5ea73cfb65e4f747$var$Yb(a);
    return null !== a ? $5ea73cfb65e4f747$var$$b(a) : null;
}
function $5ea73cfb65e4f747$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $5ea73cfb65e4f747$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $5ea73cfb65e4f747$var$ac = $4xFQO.unstable_scheduleCallback, $5ea73cfb65e4f747$var$bc = $4xFQO.unstable_cancelCallback, $5ea73cfb65e4f747$var$cc = $4xFQO.unstable_shouldYield, $5ea73cfb65e4f747$var$dc = $4xFQO.unstable_requestPaint, $5ea73cfb65e4f747$var$B = $4xFQO.unstable_now, $5ea73cfb65e4f747$var$ec = $4xFQO.unstable_getCurrentPriorityLevel, $5ea73cfb65e4f747$var$fc = $4xFQO.unstable_ImmediatePriority, $5ea73cfb65e4f747$var$gc = $4xFQO.unstable_UserBlockingPriority, $5ea73cfb65e4f747$var$hc = $4xFQO.unstable_NormalPriority, $5ea73cfb65e4f747$var$ic = $4xFQO.unstable_LowPriority, $5ea73cfb65e4f747$var$jc = $4xFQO.unstable_IdlePriority, $5ea73cfb65e4f747$var$kc = null, $5ea73cfb65e4f747$var$lc = null;
function $5ea73cfb65e4f747$var$mc(a) {
    if ($5ea73cfb65e4f747$var$lc && "function" === typeof $5ea73cfb65e4f747$var$lc.onCommitFiberRoot) try {
        $5ea73cfb65e4f747$var$lc.onCommitFiberRoot($5ea73cfb65e4f747$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $5ea73cfb65e4f747$var$oc = Math.clz32 ? Math.clz32 : $5ea73cfb65e4f747$var$nc, $5ea73cfb65e4f747$var$pc = Math.log, $5ea73cfb65e4f747$var$qc = Math.LN2;
function $5ea73cfb65e4f747$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($5ea73cfb65e4f747$var$pc(a) / $5ea73cfb65e4f747$var$qc | 0) | 0;
}
var $5ea73cfb65e4f747$var$rc = 64, $5ea73cfb65e4f747$var$sc = 4194304;
function $5ea73cfb65e4f747$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $5ea73cfb65e4f747$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $5ea73cfb65e4f747$var$tc(h) : (f &= g, 0 !== f && (d = $5ea73cfb65e4f747$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $5ea73cfb65e4f747$var$tc(g) : 0 !== f && (d = $5ea73cfb65e4f747$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $5ea73cfb65e4f747$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $5ea73cfb65e4f747$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $5ea73cfb65e4f747$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $5ea73cfb65e4f747$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $5ea73cfb65e4f747$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $5ea73cfb65e4f747$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $5ea73cfb65e4f747$var$yc() {
    var a = $5ea73cfb65e4f747$var$rc;
    $5ea73cfb65e4f747$var$rc <<= 1;
    0 === ($5ea73cfb65e4f747$var$rc & 4194240) && ($5ea73cfb65e4f747$var$rc = 64);
    return a;
}
function $5ea73cfb65e4f747$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $5ea73cfb65e4f747$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $5ea73cfb65e4f747$var$oc(b);
    a[b] = c;
}
function $5ea73cfb65e4f747$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $5ea73cfb65e4f747$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $5ea73cfb65e4f747$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $5ea73cfb65e4f747$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $5ea73cfb65e4f747$var$C = 0;
function $5ea73cfb65e4f747$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $5ea73cfb65e4f747$var$Ec, $5ea73cfb65e4f747$var$Fc, $5ea73cfb65e4f747$var$Gc, $5ea73cfb65e4f747$var$Hc, $5ea73cfb65e4f747$var$Ic, $5ea73cfb65e4f747$var$Jc = !1, $5ea73cfb65e4f747$var$Kc = [], $5ea73cfb65e4f747$var$Lc = null, $5ea73cfb65e4f747$var$Mc = null, $5ea73cfb65e4f747$var$Nc = null, $5ea73cfb65e4f747$var$Oc = new Map, $5ea73cfb65e4f747$var$Pc = new Map, $5ea73cfb65e4f747$var$Qc = [], $5ea73cfb65e4f747$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $5ea73cfb65e4f747$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $5ea73cfb65e4f747$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $5ea73cfb65e4f747$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $5ea73cfb65e4f747$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $5ea73cfb65e4f747$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $5ea73cfb65e4f747$var$Pc.delete(b.pointerId);
    }
}
function $5ea73cfb65e4f747$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $5ea73cfb65e4f747$var$Cb(b), null !== b && $5ea73cfb65e4f747$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $5ea73cfb65e4f747$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $5ea73cfb65e4f747$var$Lc = $5ea73cfb65e4f747$var$Tc($5ea73cfb65e4f747$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $5ea73cfb65e4f747$var$Mc = $5ea73cfb65e4f747$var$Tc($5ea73cfb65e4f747$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $5ea73cfb65e4f747$var$Nc = $5ea73cfb65e4f747$var$Tc($5ea73cfb65e4f747$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $5ea73cfb65e4f747$var$Oc.set(f, $5ea73cfb65e4f747$var$Tc($5ea73cfb65e4f747$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $5ea73cfb65e4f747$var$Pc.set(f, $5ea73cfb65e4f747$var$Tc($5ea73cfb65e4f747$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $5ea73cfb65e4f747$var$Vc(a) {
    var b = $5ea73cfb65e4f747$var$Wc(a.target);
    if (null !== b) {
        var c = $5ea73cfb65e4f747$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $5ea73cfb65e4f747$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $5ea73cfb65e4f747$var$Ic(a.priority, function() {
                        $5ea73cfb65e4f747$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $5ea73cfb65e4f747$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $5ea73cfb65e4f747$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $5ea73cfb65e4f747$var$wb = d;
            c.target.dispatchEvent(d);
            $5ea73cfb65e4f747$var$wb = null;
        } else return b = $5ea73cfb65e4f747$var$Cb(c), null !== b && $5ea73cfb65e4f747$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $5ea73cfb65e4f747$var$Zc(a, b, c) {
    $5ea73cfb65e4f747$var$Xc(a) && c.delete(b);
}
function $5ea73cfb65e4f747$var$$c() {
    $5ea73cfb65e4f747$var$Jc = !1;
    null !== $5ea73cfb65e4f747$var$Lc && $5ea73cfb65e4f747$var$Xc($5ea73cfb65e4f747$var$Lc) && ($5ea73cfb65e4f747$var$Lc = null);
    null !== $5ea73cfb65e4f747$var$Mc && $5ea73cfb65e4f747$var$Xc($5ea73cfb65e4f747$var$Mc) && ($5ea73cfb65e4f747$var$Mc = null);
    null !== $5ea73cfb65e4f747$var$Nc && $5ea73cfb65e4f747$var$Xc($5ea73cfb65e4f747$var$Nc) && ($5ea73cfb65e4f747$var$Nc = null);
    $5ea73cfb65e4f747$var$Oc.forEach($5ea73cfb65e4f747$var$Zc);
    $5ea73cfb65e4f747$var$Pc.forEach($5ea73cfb65e4f747$var$Zc);
}
function $5ea73cfb65e4f747$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $5ea73cfb65e4f747$var$Jc || ($5ea73cfb65e4f747$var$Jc = !0, $4xFQO.unstable_scheduleCallback($4xFQO.unstable_NormalPriority, $5ea73cfb65e4f747$var$$c)));
}
function $5ea73cfb65e4f747$var$bd(a) {
    function b(b) {
        return $5ea73cfb65e4f747$var$ad(b, a);
    }
    if (0 < $5ea73cfb65e4f747$var$Kc.length) {
        $5ea73cfb65e4f747$var$ad($5ea73cfb65e4f747$var$Kc[0], a);
        for(var c = 1; c < $5ea73cfb65e4f747$var$Kc.length; c++){
            var d = $5ea73cfb65e4f747$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $5ea73cfb65e4f747$var$Lc && $5ea73cfb65e4f747$var$ad($5ea73cfb65e4f747$var$Lc, a);
    null !== $5ea73cfb65e4f747$var$Mc && $5ea73cfb65e4f747$var$ad($5ea73cfb65e4f747$var$Mc, a);
    null !== $5ea73cfb65e4f747$var$Nc && $5ea73cfb65e4f747$var$ad($5ea73cfb65e4f747$var$Nc, a);
    $5ea73cfb65e4f747$var$Oc.forEach(b);
    $5ea73cfb65e4f747$var$Pc.forEach(b);
    for(c = 0; c < $5ea73cfb65e4f747$var$Qc.length; c++)d = $5ea73cfb65e4f747$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $5ea73cfb65e4f747$var$Qc.length && (c = $5ea73cfb65e4f747$var$Qc[0], null === c.blockedOn);)$5ea73cfb65e4f747$var$Vc(c), null === c.blockedOn && $5ea73cfb65e4f747$var$Qc.shift();
}
var $5ea73cfb65e4f747$var$cd = $5ea73cfb65e4f747$var$ua.ReactCurrentBatchConfig, $5ea73cfb65e4f747$var$dd = !0;
function $5ea73cfb65e4f747$var$ed(a, b, c, d) {
    var e = $5ea73cfb65e4f747$var$C, f = $5ea73cfb65e4f747$var$cd.transition;
    $5ea73cfb65e4f747$var$cd.transition = null;
    try {
        $5ea73cfb65e4f747$var$C = 1, $5ea73cfb65e4f747$var$fd(a, b, c, d);
    } finally{
        $5ea73cfb65e4f747$var$C = e, $5ea73cfb65e4f747$var$cd.transition = f;
    }
}
function $5ea73cfb65e4f747$var$gd(a, b, c, d) {
    var e = $5ea73cfb65e4f747$var$C, f = $5ea73cfb65e4f747$var$cd.transition;
    $5ea73cfb65e4f747$var$cd.transition = null;
    try {
        $5ea73cfb65e4f747$var$C = 4, $5ea73cfb65e4f747$var$fd(a, b, c, d);
    } finally{
        $5ea73cfb65e4f747$var$C = e, $5ea73cfb65e4f747$var$cd.transition = f;
    }
}
function $5ea73cfb65e4f747$var$fd(a, b, c, d) {
    if ($5ea73cfb65e4f747$var$dd) {
        var e = $5ea73cfb65e4f747$var$Yc(a, b, c, d);
        if (null === e) $5ea73cfb65e4f747$var$hd(a, b, d, $5ea73cfb65e4f747$var$id, c), $5ea73cfb65e4f747$var$Sc(a, d);
        else if ($5ea73cfb65e4f747$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($5ea73cfb65e4f747$var$Sc(a, d), b & 4 && -1 < $5ea73cfb65e4f747$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $5ea73cfb65e4f747$var$Cb(e);
                null !== f && $5ea73cfb65e4f747$var$Ec(f);
                f = $5ea73cfb65e4f747$var$Yc(a, b, c, d);
                null === f && $5ea73cfb65e4f747$var$hd(a, b, d, $5ea73cfb65e4f747$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $5ea73cfb65e4f747$var$hd(a, b, d, null, c);
    }
}
var $5ea73cfb65e4f747$var$id = null;
function $5ea73cfb65e4f747$var$Yc(a, b, c, d) {
    $5ea73cfb65e4f747$var$id = null;
    a = $5ea73cfb65e4f747$var$xb(d);
    a = $5ea73cfb65e4f747$var$Wc(a);
    if (null !== a) {
        if (b = $5ea73cfb65e4f747$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $5ea73cfb65e4f747$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $5ea73cfb65e4f747$var$id = a;
    return null;
}
function $5ea73cfb65e4f747$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($5ea73cfb65e4f747$var$ec()){
                case $5ea73cfb65e4f747$var$fc:
                    return 1;
                case $5ea73cfb65e4f747$var$gc:
                    return 4;
                case $5ea73cfb65e4f747$var$hc:
                case $5ea73cfb65e4f747$var$ic:
                    return 16;
                case $5ea73cfb65e4f747$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $5ea73cfb65e4f747$var$kd = null, $5ea73cfb65e4f747$var$ld = null, $5ea73cfb65e4f747$var$md = null;
function $5ea73cfb65e4f747$var$nd() {
    if ($5ea73cfb65e4f747$var$md) return $5ea73cfb65e4f747$var$md;
    var a, b = $5ea73cfb65e4f747$var$ld, c = b.length, d, e = "value" in $5ea73cfb65e4f747$var$kd ? $5ea73cfb65e4f747$var$kd.value : $5ea73cfb65e4f747$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $5ea73cfb65e4f747$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $5ea73cfb65e4f747$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $5ea73cfb65e4f747$var$pd() {
    return !0;
}
function $5ea73cfb65e4f747$var$qd() {
    return !1;
}
function $5ea73cfb65e4f747$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $5ea73cfb65e4f747$var$pd : $5ea73cfb65e4f747$var$qd;
        this.isPropagationStopped = $5ea73cfb65e4f747$var$qd;
        return this;
    }
    $5ea73cfb65e4f747$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $5ea73cfb65e4f747$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $5ea73cfb65e4f747$var$pd);
        },
        persist: function() {},
        isPersistent: $5ea73cfb65e4f747$var$pd
    });
    return b;
}
var $5ea73cfb65e4f747$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $5ea73cfb65e4f747$var$td = $5ea73cfb65e4f747$var$rd($5ea73cfb65e4f747$var$sd), $5ea73cfb65e4f747$var$ud = $5ea73cfb65e4f747$var$A({}, $5ea73cfb65e4f747$var$sd, {
    view: 0,
    detail: 0
}), $5ea73cfb65e4f747$var$vd = $5ea73cfb65e4f747$var$rd($5ea73cfb65e4f747$var$ud), $5ea73cfb65e4f747$var$wd, $5ea73cfb65e4f747$var$xd, $5ea73cfb65e4f747$var$yd, $5ea73cfb65e4f747$var$Ad = $5ea73cfb65e4f747$var$A({}, $5ea73cfb65e4f747$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $5ea73cfb65e4f747$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $5ea73cfb65e4f747$var$yd && ($5ea73cfb65e4f747$var$yd && "mousemove" === a.type ? ($5ea73cfb65e4f747$var$wd = a.screenX - $5ea73cfb65e4f747$var$yd.screenX, $5ea73cfb65e4f747$var$xd = a.screenY - $5ea73cfb65e4f747$var$yd.screenY) : $5ea73cfb65e4f747$var$xd = $5ea73cfb65e4f747$var$wd = 0, $5ea73cfb65e4f747$var$yd = a);
        return $5ea73cfb65e4f747$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $5ea73cfb65e4f747$var$xd;
    }
}), $5ea73cfb65e4f747$var$Bd = $5ea73cfb65e4f747$var$rd($5ea73cfb65e4f747$var$Ad), $5ea73cfb65e4f747$var$Cd = $5ea73cfb65e4f747$var$A({}, $5ea73cfb65e4f747$var$Ad, {
    dataTransfer: 0
}), $5ea73cfb65e4f747$var$Dd = $5ea73cfb65e4f747$var$rd($5ea73cfb65e4f747$var$Cd), $5ea73cfb65e4f747$var$Ed = $5ea73cfb65e4f747$var$A({}, $5ea73cfb65e4f747$var$ud, {
    relatedTarget: 0
}), $5ea73cfb65e4f747$var$Fd = $5ea73cfb65e4f747$var$rd($5ea73cfb65e4f747$var$Ed), $5ea73cfb65e4f747$var$Gd = $5ea73cfb65e4f747$var$A({}, $5ea73cfb65e4f747$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5ea73cfb65e4f747$var$Hd = $5ea73cfb65e4f747$var$rd($5ea73cfb65e4f747$var$Gd), $5ea73cfb65e4f747$var$Id = $5ea73cfb65e4f747$var$A({}, $5ea73cfb65e4f747$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $5ea73cfb65e4f747$var$Jd = $5ea73cfb65e4f747$var$rd($5ea73cfb65e4f747$var$Id), $5ea73cfb65e4f747$var$Kd = $5ea73cfb65e4f747$var$A({}, $5ea73cfb65e4f747$var$sd, {
    data: 0
}), $5ea73cfb65e4f747$var$Ld = $5ea73cfb65e4f747$var$rd($5ea73cfb65e4f747$var$Kd), $5ea73cfb65e4f747$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $5ea73cfb65e4f747$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $5ea73cfb65e4f747$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $5ea73cfb65e4f747$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $5ea73cfb65e4f747$var$Od[a]) ? !!b[a] : !1;
}
function $5ea73cfb65e4f747$var$zd() {
    return $5ea73cfb65e4f747$var$Pd;
}
var $5ea73cfb65e4f747$var$Qd = $5ea73cfb65e4f747$var$A({}, $5ea73cfb65e4f747$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $5ea73cfb65e4f747$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $5ea73cfb65e4f747$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $5ea73cfb65e4f747$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $5ea73cfb65e4f747$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $5ea73cfb65e4f747$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $5ea73cfb65e4f747$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $5ea73cfb65e4f747$var$Rd = $5ea73cfb65e4f747$var$rd($5ea73cfb65e4f747$var$Qd), $5ea73cfb65e4f747$var$Sd = $5ea73cfb65e4f747$var$A({}, $5ea73cfb65e4f747$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $5ea73cfb65e4f747$var$Td = $5ea73cfb65e4f747$var$rd($5ea73cfb65e4f747$var$Sd), $5ea73cfb65e4f747$var$Ud = $5ea73cfb65e4f747$var$A({}, $5ea73cfb65e4f747$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $5ea73cfb65e4f747$var$zd
}), $5ea73cfb65e4f747$var$Vd = $5ea73cfb65e4f747$var$rd($5ea73cfb65e4f747$var$Ud), $5ea73cfb65e4f747$var$Wd = $5ea73cfb65e4f747$var$A({}, $5ea73cfb65e4f747$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5ea73cfb65e4f747$var$Xd = $5ea73cfb65e4f747$var$rd($5ea73cfb65e4f747$var$Wd), $5ea73cfb65e4f747$var$Yd = $5ea73cfb65e4f747$var$A({}, $5ea73cfb65e4f747$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $5ea73cfb65e4f747$var$Zd = $5ea73cfb65e4f747$var$rd($5ea73cfb65e4f747$var$Yd), $5ea73cfb65e4f747$var$$d = [
    9,
    13,
    27,
    32
], $5ea73cfb65e4f747$var$ae = $5ea73cfb65e4f747$var$ia && "CompositionEvent" in window, $5ea73cfb65e4f747$var$be = null;
$5ea73cfb65e4f747$var$ia && "documentMode" in document && ($5ea73cfb65e4f747$var$be = document.documentMode);
var $5ea73cfb65e4f747$var$ce = $5ea73cfb65e4f747$var$ia && "TextEvent" in window && !$5ea73cfb65e4f747$var$be, $5ea73cfb65e4f747$var$de = $5ea73cfb65e4f747$var$ia && (!$5ea73cfb65e4f747$var$ae || $5ea73cfb65e4f747$var$be && 8 < $5ea73cfb65e4f747$var$be && 11 >= $5ea73cfb65e4f747$var$be), $5ea73cfb65e4f747$var$ee = String.fromCharCode(32), $5ea73cfb65e4f747$var$fe = !1;
function $5ea73cfb65e4f747$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $5ea73cfb65e4f747$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $5ea73cfb65e4f747$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $5ea73cfb65e4f747$var$ie = !1;
function $5ea73cfb65e4f747$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $5ea73cfb65e4f747$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $5ea73cfb65e4f747$var$fe = !0;
            return $5ea73cfb65e4f747$var$ee;
        case "textInput":
            return a = b.data, a === $5ea73cfb65e4f747$var$ee && $5ea73cfb65e4f747$var$fe ? null : a;
        default:
            return null;
    }
}
function $5ea73cfb65e4f747$var$ke(a, b) {
    if ($5ea73cfb65e4f747$var$ie) return "compositionend" === a || !$5ea73cfb65e4f747$var$ae && $5ea73cfb65e4f747$var$ge(a, b) ? (a = $5ea73cfb65e4f747$var$nd(), $5ea73cfb65e4f747$var$md = $5ea73cfb65e4f747$var$ld = $5ea73cfb65e4f747$var$kd = null, $5ea73cfb65e4f747$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $5ea73cfb65e4f747$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $5ea73cfb65e4f747$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $5ea73cfb65e4f747$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$5ea73cfb65e4f747$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $5ea73cfb65e4f747$var$ne(a, b, c, d) {
    $5ea73cfb65e4f747$var$Eb(d);
    b = $5ea73cfb65e4f747$var$oe(b, "onChange");
    0 < b.length && (c = new $5ea73cfb65e4f747$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $5ea73cfb65e4f747$var$pe = null, $5ea73cfb65e4f747$var$qe = null;
function $5ea73cfb65e4f747$var$re(a) {
    $5ea73cfb65e4f747$var$se(a, 0);
}
function $5ea73cfb65e4f747$var$te(a) {
    var b = $5ea73cfb65e4f747$var$ue(a);
    if ($5ea73cfb65e4f747$var$Wa(b)) return a;
}
function $5ea73cfb65e4f747$var$ve(a, b) {
    if ("change" === a) return b;
}
var $5ea73cfb65e4f747$var$we = !1;
if ($5ea73cfb65e4f747$var$ia) {
    var $5ea73cfb65e4f747$var$xe;
    if ($5ea73cfb65e4f747$var$ia) {
        var $5ea73cfb65e4f747$var$ye = "oninput" in document;
        if (!$5ea73cfb65e4f747$var$ye) {
            var $5ea73cfb65e4f747$var$ze = document.createElement("div");
            $5ea73cfb65e4f747$var$ze.setAttribute("oninput", "return;");
            $5ea73cfb65e4f747$var$ye = "function" === typeof $5ea73cfb65e4f747$var$ze.oninput;
        }
        $5ea73cfb65e4f747$var$xe = $5ea73cfb65e4f747$var$ye;
    } else $5ea73cfb65e4f747$var$xe = !1;
    $5ea73cfb65e4f747$var$we = $5ea73cfb65e4f747$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $5ea73cfb65e4f747$var$Ae() {
    $5ea73cfb65e4f747$var$pe && ($5ea73cfb65e4f747$var$pe.detachEvent("onpropertychange", $5ea73cfb65e4f747$var$Be), $5ea73cfb65e4f747$var$qe = $5ea73cfb65e4f747$var$pe = null);
}
function $5ea73cfb65e4f747$var$Be(a) {
    if ("value" === a.propertyName && $5ea73cfb65e4f747$var$te($5ea73cfb65e4f747$var$qe)) {
        var b = [];
        $5ea73cfb65e4f747$var$ne(b, $5ea73cfb65e4f747$var$qe, a, $5ea73cfb65e4f747$var$xb(a));
        $5ea73cfb65e4f747$var$Jb($5ea73cfb65e4f747$var$re, b);
    }
}
function $5ea73cfb65e4f747$var$Ce(a, b, c) {
    "focusin" === a ? ($5ea73cfb65e4f747$var$Ae(), $5ea73cfb65e4f747$var$pe = b, $5ea73cfb65e4f747$var$qe = c, $5ea73cfb65e4f747$var$pe.attachEvent("onpropertychange", $5ea73cfb65e4f747$var$Be)) : "focusout" === a && $5ea73cfb65e4f747$var$Ae();
}
function $5ea73cfb65e4f747$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $5ea73cfb65e4f747$var$te($5ea73cfb65e4f747$var$qe);
}
function $5ea73cfb65e4f747$var$Ee(a, b) {
    if ("click" === a) return $5ea73cfb65e4f747$var$te(b);
}
function $5ea73cfb65e4f747$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $5ea73cfb65e4f747$var$te(b);
}
function $5ea73cfb65e4f747$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5ea73cfb65e4f747$var$He = "function" === typeof Object.is ? Object.is : $5ea73cfb65e4f747$var$Ge;
function $5ea73cfb65e4f747$var$Ie(a, b) {
    if ($5ea73cfb65e4f747$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$5ea73cfb65e4f747$var$ja.call(b, e) || !$5ea73cfb65e4f747$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $5ea73cfb65e4f747$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $5ea73cfb65e4f747$var$Ke(a, b) {
    var c = $5ea73cfb65e4f747$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $5ea73cfb65e4f747$var$Je(c);
    }
}
function $5ea73cfb65e4f747$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $5ea73cfb65e4f747$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $5ea73cfb65e4f747$var$Me() {
    for(var a = window, b = $5ea73cfb65e4f747$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $5ea73cfb65e4f747$var$Xa(a.document);
    }
    return b;
}
function $5ea73cfb65e4f747$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $5ea73cfb65e4f747$var$Oe(a) {
    var b = $5ea73cfb65e4f747$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $5ea73cfb65e4f747$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $5ea73cfb65e4f747$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $5ea73cfb65e4f747$var$Ke(c, f);
                var g = $5ea73cfb65e4f747$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $5ea73cfb65e4f747$var$Pe = $5ea73cfb65e4f747$var$ia && "documentMode" in document && 11 >= document.documentMode, $5ea73cfb65e4f747$var$Qe = null, $5ea73cfb65e4f747$var$Re = null, $5ea73cfb65e4f747$var$Se = null, $5ea73cfb65e4f747$var$Te = !1;
function $5ea73cfb65e4f747$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $5ea73cfb65e4f747$var$Te || null == $5ea73cfb65e4f747$var$Qe || $5ea73cfb65e4f747$var$Qe !== $5ea73cfb65e4f747$var$Xa(d) || (d = $5ea73cfb65e4f747$var$Qe, "selectionStart" in d && $5ea73cfb65e4f747$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $5ea73cfb65e4f747$var$Se && $5ea73cfb65e4f747$var$Ie($5ea73cfb65e4f747$var$Se, d) || ($5ea73cfb65e4f747$var$Se = d, d = $5ea73cfb65e4f747$var$oe($5ea73cfb65e4f747$var$Re, "onSelect"), 0 < d.length && (b = new $5ea73cfb65e4f747$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $5ea73cfb65e4f747$var$Qe)));
}
function $5ea73cfb65e4f747$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $5ea73cfb65e4f747$var$We = {
    animationend: $5ea73cfb65e4f747$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $5ea73cfb65e4f747$var$Ve("Animation", "AnimationIteration"),
    animationstart: $5ea73cfb65e4f747$var$Ve("Animation", "AnimationStart"),
    transitionend: $5ea73cfb65e4f747$var$Ve("Transition", "TransitionEnd")
}, $5ea73cfb65e4f747$var$Xe = {}, $5ea73cfb65e4f747$var$Ye = {};
$5ea73cfb65e4f747$var$ia && ($5ea73cfb65e4f747$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $5ea73cfb65e4f747$var$We.animationend.animation, delete $5ea73cfb65e4f747$var$We.animationiteration.animation, delete $5ea73cfb65e4f747$var$We.animationstart.animation), "TransitionEvent" in window || delete $5ea73cfb65e4f747$var$We.transitionend.transition);
function $5ea73cfb65e4f747$var$Ze(a) {
    if ($5ea73cfb65e4f747$var$Xe[a]) return $5ea73cfb65e4f747$var$Xe[a];
    if (!$5ea73cfb65e4f747$var$We[a]) return a;
    var b = $5ea73cfb65e4f747$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $5ea73cfb65e4f747$var$Ye) return $5ea73cfb65e4f747$var$Xe[a] = b[c];
    return a;
}
var $5ea73cfb65e4f747$var$$e = $5ea73cfb65e4f747$var$Ze("animationend"), $5ea73cfb65e4f747$var$af = $5ea73cfb65e4f747$var$Ze("animationiteration"), $5ea73cfb65e4f747$var$bf = $5ea73cfb65e4f747$var$Ze("animationstart"), $5ea73cfb65e4f747$var$cf = $5ea73cfb65e4f747$var$Ze("transitionend"), $5ea73cfb65e4f747$var$df = new Map, $5ea73cfb65e4f747$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $5ea73cfb65e4f747$var$ff(a, b) {
    $5ea73cfb65e4f747$var$df.set(a, b);
    $5ea73cfb65e4f747$var$fa(b, [
        a
    ]);
}
for(var $5ea73cfb65e4f747$var$gf = 0; $5ea73cfb65e4f747$var$gf < $5ea73cfb65e4f747$var$ef.length; $5ea73cfb65e4f747$var$gf++){
    var $5ea73cfb65e4f747$var$hf = $5ea73cfb65e4f747$var$ef[$5ea73cfb65e4f747$var$gf], $5ea73cfb65e4f747$var$jf = $5ea73cfb65e4f747$var$hf.toLowerCase(), $5ea73cfb65e4f747$var$kf = $5ea73cfb65e4f747$var$hf[0].toUpperCase() + $5ea73cfb65e4f747$var$hf.slice(1);
    $5ea73cfb65e4f747$var$ff($5ea73cfb65e4f747$var$jf, "on" + $5ea73cfb65e4f747$var$kf);
}
$5ea73cfb65e4f747$var$ff($5ea73cfb65e4f747$var$$e, "onAnimationEnd");
$5ea73cfb65e4f747$var$ff($5ea73cfb65e4f747$var$af, "onAnimationIteration");
$5ea73cfb65e4f747$var$ff($5ea73cfb65e4f747$var$bf, "onAnimationStart");
$5ea73cfb65e4f747$var$ff("dblclick", "onDoubleClick");
$5ea73cfb65e4f747$var$ff("focusin", "onFocus");
$5ea73cfb65e4f747$var$ff("focusout", "onBlur");
$5ea73cfb65e4f747$var$ff($5ea73cfb65e4f747$var$cf, "onTransitionEnd");
$5ea73cfb65e4f747$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$5ea73cfb65e4f747$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$5ea73cfb65e4f747$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$5ea73cfb65e4f747$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$5ea73cfb65e4f747$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$5ea73cfb65e4f747$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$5ea73cfb65e4f747$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$5ea73cfb65e4f747$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$5ea73cfb65e4f747$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$5ea73cfb65e4f747$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $5ea73cfb65e4f747$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $5ea73cfb65e4f747$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($5ea73cfb65e4f747$var$lf));
function $5ea73cfb65e4f747$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $5ea73cfb65e4f747$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $5ea73cfb65e4f747$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $5ea73cfb65e4f747$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $5ea73cfb65e4f747$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($5ea73cfb65e4f747$var$Qb) throw a = $5ea73cfb65e4f747$var$Rb, $5ea73cfb65e4f747$var$Qb = !1, $5ea73cfb65e4f747$var$Rb = null, a;
}
function $5ea73cfb65e4f747$var$D(a, b) {
    var c = b[$5ea73cfb65e4f747$var$of];
    void 0 === c && (c = b[$5ea73cfb65e4f747$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($5ea73cfb65e4f747$var$pf(b, a, 2, !1), c.add(d));
}
function $5ea73cfb65e4f747$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $5ea73cfb65e4f747$var$pf(c, a, d, b);
}
var $5ea73cfb65e4f747$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $5ea73cfb65e4f747$var$sf(a) {
    if (!a[$5ea73cfb65e4f747$var$rf]) {
        a[$5ea73cfb65e4f747$var$rf] = !0;
        $5ea73cfb65e4f747$var$da.forEach(function(b) {
            "selectionchange" !== b && ($5ea73cfb65e4f747$var$mf.has(b) || $5ea73cfb65e4f747$var$qf(b, !1, a), $5ea73cfb65e4f747$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$5ea73cfb65e4f747$var$rf] || (b[$5ea73cfb65e4f747$var$rf] = !0, $5ea73cfb65e4f747$var$qf("selectionchange", !1, b));
    }
}
function $5ea73cfb65e4f747$var$pf(a, b, c, d) {
    switch($5ea73cfb65e4f747$var$jd(b)){
        case 1:
            var e = $5ea73cfb65e4f747$var$ed;
            break;
        case 4:
            e = $5ea73cfb65e4f747$var$gd;
            break;
        default:
            e = $5ea73cfb65e4f747$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$5ea73cfb65e4f747$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $5ea73cfb65e4f747$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $5ea73cfb65e4f747$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $5ea73cfb65e4f747$var$Jb(function() {
        var d = f, e = $5ea73cfb65e4f747$var$xb(c), g = [];
        a: {
            var h = $5ea73cfb65e4f747$var$df.get(a);
            if (void 0 !== h) {
                var k = $5ea73cfb65e4f747$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $5ea73cfb65e4f747$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $5ea73cfb65e4f747$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $5ea73cfb65e4f747$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $5ea73cfb65e4f747$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $5ea73cfb65e4f747$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $5ea73cfb65e4f747$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $5ea73cfb65e4f747$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $5ea73cfb65e4f747$var$Vd;
                        break;
                    case $5ea73cfb65e4f747$var$$e:
                    case $5ea73cfb65e4f747$var$af:
                    case $5ea73cfb65e4f747$var$bf:
                        k = $5ea73cfb65e4f747$var$Hd;
                        break;
                    case $5ea73cfb65e4f747$var$cf:
                        k = $5ea73cfb65e4f747$var$Xd;
                        break;
                    case "scroll":
                        k = $5ea73cfb65e4f747$var$vd;
                        break;
                    case "wheel":
                        k = $5ea73cfb65e4f747$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $5ea73cfb65e4f747$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $5ea73cfb65e4f747$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $5ea73cfb65e4f747$var$Kb(w, x), null != F && t.push($5ea73cfb65e4f747$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $5ea73cfb65e4f747$var$wb && (n = c.relatedTarget || c.fromElement) && ($5ea73cfb65e4f747$var$Wc(n) || n[$5ea73cfb65e4f747$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $5ea73cfb65e4f747$var$Wc(n) : null, null !== n && (J = $5ea73cfb65e4f747$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $5ea73cfb65e4f747$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $5ea73cfb65e4f747$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $5ea73cfb65e4f747$var$ue(k);
                        u = null == n ? h : $5ea73cfb65e4f747$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $5ea73cfb65e4f747$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $5ea73cfb65e4f747$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $5ea73cfb65e4f747$var$vf(F))u++;
                            for(; 0 < w - u;)t = $5ea73cfb65e4f747$var$vf(t), w--;
                            for(; 0 < u - w;)x = $5ea73cfb65e4f747$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $5ea73cfb65e4f747$var$vf(t);
                                x = $5ea73cfb65e4f747$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $5ea73cfb65e4f747$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $5ea73cfb65e4f747$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $5ea73cfb65e4f747$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $5ea73cfb65e4f747$var$ve;
                else if ($5ea73cfb65e4f747$var$me(h)) {
                    if ($5ea73cfb65e4f747$var$we) na = $5ea73cfb65e4f747$var$Fe;
                    else {
                        na = $5ea73cfb65e4f747$var$De;
                        var xa = $5ea73cfb65e4f747$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $5ea73cfb65e4f747$var$Ee);
                if (na && (na = na(a, d))) {
                    $5ea73cfb65e4f747$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $5ea73cfb65e4f747$var$cb(h, "number", h.value);
            }
            xa = d ? $5ea73cfb65e4f747$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($5ea73cfb65e4f747$var$me(xa) || "true" === xa.contentEditable) $5ea73cfb65e4f747$var$Qe = xa, $5ea73cfb65e4f747$var$Re = d, $5ea73cfb65e4f747$var$Se = null;
                    break;
                case "focusout":
                    $5ea73cfb65e4f747$var$Se = $5ea73cfb65e4f747$var$Re = $5ea73cfb65e4f747$var$Qe = null;
                    break;
                case "mousedown":
                    $5ea73cfb65e4f747$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $5ea73cfb65e4f747$var$Te = !1;
                    $5ea73cfb65e4f747$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($5ea73cfb65e4f747$var$Pe) break;
                case "keydown":
                case "keyup":
                    $5ea73cfb65e4f747$var$Ue(g, c, e);
            }
            var $a;
            if ($5ea73cfb65e4f747$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $5ea73cfb65e4f747$var$ie ? $5ea73cfb65e4f747$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($5ea73cfb65e4f747$var$de && "ko" !== c.locale && ($5ea73cfb65e4f747$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $5ea73cfb65e4f747$var$ie && ($a = $5ea73cfb65e4f747$var$nd()) : ($5ea73cfb65e4f747$var$kd = e, $5ea73cfb65e4f747$var$ld = "value" in $5ea73cfb65e4f747$var$kd ? $5ea73cfb65e4f747$var$kd.value : $5ea73cfb65e4f747$var$kd.textContent, $5ea73cfb65e4f747$var$ie = !0)), xa = $5ea73cfb65e4f747$var$oe(d, ba), 0 < xa.length && (ba = new $5ea73cfb65e4f747$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $5ea73cfb65e4f747$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $5ea73cfb65e4f747$var$ce ? $5ea73cfb65e4f747$var$je(a, c) : $5ea73cfb65e4f747$var$ke(a, c)) d = $5ea73cfb65e4f747$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $5ea73cfb65e4f747$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $5ea73cfb65e4f747$var$se(g, b);
    });
}
function $5ea73cfb65e4f747$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $5ea73cfb65e4f747$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $5ea73cfb65e4f747$var$Kb(a, c), null != f && d.unshift($5ea73cfb65e4f747$var$tf(a, f, e)), f = $5ea73cfb65e4f747$var$Kb(a, b), null != f && d.push($5ea73cfb65e4f747$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $5ea73cfb65e4f747$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $5ea73cfb65e4f747$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $5ea73cfb65e4f747$var$Kb(c, f), null != k && g.unshift($5ea73cfb65e4f747$var$tf(c, k, h))) : e || (k = $5ea73cfb65e4f747$var$Kb(c, f), null != k && g.push($5ea73cfb65e4f747$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $5ea73cfb65e4f747$var$xf = /\r\n?/g, $5ea73cfb65e4f747$var$yf = /\u0000|\uFFFD/g;
function $5ea73cfb65e4f747$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($5ea73cfb65e4f747$var$xf, "\n").replace($5ea73cfb65e4f747$var$yf, "");
}
function $5ea73cfb65e4f747$var$Af(a, b, c) {
    b = $5ea73cfb65e4f747$var$zf(b);
    if ($5ea73cfb65e4f747$var$zf(a) !== b && c) throw Error($5ea73cfb65e4f747$var$p(425));
}
function $5ea73cfb65e4f747$var$Bf() {}
var $5ea73cfb65e4f747$var$Cf = null, $5ea73cfb65e4f747$var$Df = null;
function $5ea73cfb65e4f747$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $5ea73cfb65e4f747$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $5ea73cfb65e4f747$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $5ea73cfb65e4f747$var$Hf = "function" === typeof Promise ? Promise : void 0, $5ea73cfb65e4f747$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $5ea73cfb65e4f747$var$Hf ? function(a) {
    return $5ea73cfb65e4f747$var$Hf.resolve(null).then(a).catch($5ea73cfb65e4f747$var$If);
} : $5ea73cfb65e4f747$var$Ff;
function $5ea73cfb65e4f747$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $5ea73cfb65e4f747$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $5ea73cfb65e4f747$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $5ea73cfb65e4f747$var$bd(b);
}
function $5ea73cfb65e4f747$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $5ea73cfb65e4f747$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $5ea73cfb65e4f747$var$Nf = Math.random().toString(36).slice(2), $5ea73cfb65e4f747$var$Of = "__reactFiber$" + $5ea73cfb65e4f747$var$Nf, $5ea73cfb65e4f747$var$Pf = "__reactProps$" + $5ea73cfb65e4f747$var$Nf, $5ea73cfb65e4f747$var$uf = "__reactContainer$" + $5ea73cfb65e4f747$var$Nf, $5ea73cfb65e4f747$var$of = "__reactEvents$" + $5ea73cfb65e4f747$var$Nf, $5ea73cfb65e4f747$var$Qf = "__reactListeners$" + $5ea73cfb65e4f747$var$Nf, $5ea73cfb65e4f747$var$Rf = "__reactHandles$" + $5ea73cfb65e4f747$var$Nf;
function $5ea73cfb65e4f747$var$Wc(a) {
    var b = a[$5ea73cfb65e4f747$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$5ea73cfb65e4f747$var$uf] || c[$5ea73cfb65e4f747$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $5ea73cfb65e4f747$var$Mf(a); null !== a;){
                if (c = a[$5ea73cfb65e4f747$var$Of]) return c;
                a = $5ea73cfb65e4f747$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $5ea73cfb65e4f747$var$Cb(a) {
    a = a[$5ea73cfb65e4f747$var$Of] || a[$5ea73cfb65e4f747$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $5ea73cfb65e4f747$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($5ea73cfb65e4f747$var$p(33));
}
function $5ea73cfb65e4f747$var$Db(a) {
    return a[$5ea73cfb65e4f747$var$Pf] || null;
}
var $5ea73cfb65e4f747$var$Sf = [], $5ea73cfb65e4f747$var$Tf = -1;
function $5ea73cfb65e4f747$var$Uf(a) {
    return {
        current: a
    };
}
function $5ea73cfb65e4f747$var$E(a) {
    0 > $5ea73cfb65e4f747$var$Tf || (a.current = $5ea73cfb65e4f747$var$Sf[$5ea73cfb65e4f747$var$Tf], $5ea73cfb65e4f747$var$Sf[$5ea73cfb65e4f747$var$Tf] = null, $5ea73cfb65e4f747$var$Tf--);
}
function $5ea73cfb65e4f747$var$G(a, b) {
    $5ea73cfb65e4f747$var$Tf++;
    $5ea73cfb65e4f747$var$Sf[$5ea73cfb65e4f747$var$Tf] = a.current;
    a.current = b;
}
var $5ea73cfb65e4f747$var$Vf = {}, $5ea73cfb65e4f747$var$H = $5ea73cfb65e4f747$var$Uf($5ea73cfb65e4f747$var$Vf), $5ea73cfb65e4f747$var$Wf = $5ea73cfb65e4f747$var$Uf(!1), $5ea73cfb65e4f747$var$Xf = $5ea73cfb65e4f747$var$Vf;
function $5ea73cfb65e4f747$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $5ea73cfb65e4f747$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $5ea73cfb65e4f747$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $5ea73cfb65e4f747$var$$f() {
    $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$Wf);
    $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$H);
}
function $5ea73cfb65e4f747$var$ag(a, b, c) {
    if ($5ea73cfb65e4f747$var$H.current !== $5ea73cfb65e4f747$var$Vf) throw Error($5ea73cfb65e4f747$var$p(168));
    $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$H, b);
    $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$Wf, c);
}
function $5ea73cfb65e4f747$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($5ea73cfb65e4f747$var$p(108, $5ea73cfb65e4f747$var$Ra(a) || "Unknown", e));
    return $5ea73cfb65e4f747$var$A({}, c, d);
}
function $5ea73cfb65e4f747$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $5ea73cfb65e4f747$var$Vf;
    $5ea73cfb65e4f747$var$Xf = $5ea73cfb65e4f747$var$H.current;
    $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$H, a);
    $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$Wf, $5ea73cfb65e4f747$var$Wf.current);
    return !0;
}
function $5ea73cfb65e4f747$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($5ea73cfb65e4f747$var$p(169));
    c ? (a = $5ea73cfb65e4f747$var$bg(a, b, $5ea73cfb65e4f747$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$Wf), $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$H), $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$H, a)) : $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$Wf);
    $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$Wf, c);
}
var $5ea73cfb65e4f747$var$eg = null, $5ea73cfb65e4f747$var$fg = !1, $5ea73cfb65e4f747$var$gg = !1;
function $5ea73cfb65e4f747$var$hg(a) {
    null === $5ea73cfb65e4f747$var$eg ? $5ea73cfb65e4f747$var$eg = [
        a
    ] : $5ea73cfb65e4f747$var$eg.push(a);
}
function $5ea73cfb65e4f747$var$ig(a) {
    $5ea73cfb65e4f747$var$fg = !0;
    $5ea73cfb65e4f747$var$hg(a);
}
function $5ea73cfb65e4f747$var$jg() {
    if (!$5ea73cfb65e4f747$var$gg && null !== $5ea73cfb65e4f747$var$eg) {
        $5ea73cfb65e4f747$var$gg = !0;
        var a = 0, b = $5ea73cfb65e4f747$var$C;
        try {
            var c = $5ea73cfb65e4f747$var$eg;
            for($5ea73cfb65e4f747$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $5ea73cfb65e4f747$var$eg = null;
            $5ea73cfb65e4f747$var$fg = !1;
        } catch (e) {
            throw null !== $5ea73cfb65e4f747$var$eg && ($5ea73cfb65e4f747$var$eg = $5ea73cfb65e4f747$var$eg.slice(a + 1)), $5ea73cfb65e4f747$var$ac($5ea73cfb65e4f747$var$fc, $5ea73cfb65e4f747$var$jg), e;
        } finally{
            $5ea73cfb65e4f747$var$C = b, $5ea73cfb65e4f747$var$gg = !1;
        }
    }
    return null;
}
var $5ea73cfb65e4f747$var$kg = [], $5ea73cfb65e4f747$var$lg = 0, $5ea73cfb65e4f747$var$mg = null, $5ea73cfb65e4f747$var$ng = 0, $5ea73cfb65e4f747$var$og = [], $5ea73cfb65e4f747$var$pg = 0, $5ea73cfb65e4f747$var$qg = null, $5ea73cfb65e4f747$var$rg = 1, $5ea73cfb65e4f747$var$sg = "";
function $5ea73cfb65e4f747$var$tg(a, b) {
    $5ea73cfb65e4f747$var$kg[$5ea73cfb65e4f747$var$lg++] = $5ea73cfb65e4f747$var$ng;
    $5ea73cfb65e4f747$var$kg[$5ea73cfb65e4f747$var$lg++] = $5ea73cfb65e4f747$var$mg;
    $5ea73cfb65e4f747$var$mg = a;
    $5ea73cfb65e4f747$var$ng = b;
}
function $5ea73cfb65e4f747$var$ug(a, b, c) {
    $5ea73cfb65e4f747$var$og[$5ea73cfb65e4f747$var$pg++] = $5ea73cfb65e4f747$var$rg;
    $5ea73cfb65e4f747$var$og[$5ea73cfb65e4f747$var$pg++] = $5ea73cfb65e4f747$var$sg;
    $5ea73cfb65e4f747$var$og[$5ea73cfb65e4f747$var$pg++] = $5ea73cfb65e4f747$var$qg;
    $5ea73cfb65e4f747$var$qg = a;
    var d = $5ea73cfb65e4f747$var$rg;
    a = $5ea73cfb65e4f747$var$sg;
    var e = 32 - $5ea73cfb65e4f747$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $5ea73cfb65e4f747$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $5ea73cfb65e4f747$var$rg = 1 << 32 - $5ea73cfb65e4f747$var$oc(b) + e | c << e | d;
        $5ea73cfb65e4f747$var$sg = f + a;
    } else $5ea73cfb65e4f747$var$rg = 1 << f | c << e | d, $5ea73cfb65e4f747$var$sg = a;
}
function $5ea73cfb65e4f747$var$vg(a) {
    null !== a.return && ($5ea73cfb65e4f747$var$tg(a, 1), $5ea73cfb65e4f747$var$ug(a, 1, 0));
}
function $5ea73cfb65e4f747$var$wg(a) {
    for(; a === $5ea73cfb65e4f747$var$mg;)$5ea73cfb65e4f747$var$mg = $5ea73cfb65e4f747$var$kg[--$5ea73cfb65e4f747$var$lg], $5ea73cfb65e4f747$var$kg[$5ea73cfb65e4f747$var$lg] = null, $5ea73cfb65e4f747$var$ng = $5ea73cfb65e4f747$var$kg[--$5ea73cfb65e4f747$var$lg], $5ea73cfb65e4f747$var$kg[$5ea73cfb65e4f747$var$lg] = null;
    for(; a === $5ea73cfb65e4f747$var$qg;)$5ea73cfb65e4f747$var$qg = $5ea73cfb65e4f747$var$og[--$5ea73cfb65e4f747$var$pg], $5ea73cfb65e4f747$var$og[$5ea73cfb65e4f747$var$pg] = null, $5ea73cfb65e4f747$var$sg = $5ea73cfb65e4f747$var$og[--$5ea73cfb65e4f747$var$pg], $5ea73cfb65e4f747$var$og[$5ea73cfb65e4f747$var$pg] = null, $5ea73cfb65e4f747$var$rg = $5ea73cfb65e4f747$var$og[--$5ea73cfb65e4f747$var$pg], $5ea73cfb65e4f747$var$og[$5ea73cfb65e4f747$var$pg] = null;
}
var $5ea73cfb65e4f747$var$xg = null, $5ea73cfb65e4f747$var$yg = null, $5ea73cfb65e4f747$var$I = !1, $5ea73cfb65e4f747$var$zg = null;
function $5ea73cfb65e4f747$var$Ag(a, b) {
    var c = $5ea73cfb65e4f747$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $5ea73cfb65e4f747$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $5ea73cfb65e4f747$var$xg = a, $5ea73cfb65e4f747$var$yg = $5ea73cfb65e4f747$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $5ea73cfb65e4f747$var$xg = a, $5ea73cfb65e4f747$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $5ea73cfb65e4f747$var$qg ? {
                id: $5ea73cfb65e4f747$var$rg,
                overflow: $5ea73cfb65e4f747$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $5ea73cfb65e4f747$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $5ea73cfb65e4f747$var$xg = a, $5ea73cfb65e4f747$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $5ea73cfb65e4f747$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $5ea73cfb65e4f747$var$Eg(a) {
    if ($5ea73cfb65e4f747$var$I) {
        var b = $5ea73cfb65e4f747$var$yg;
        if (b) {
            var c = b;
            if (!$5ea73cfb65e4f747$var$Cg(a, b)) {
                if ($5ea73cfb65e4f747$var$Dg(a)) throw Error($5ea73cfb65e4f747$var$p(418));
                b = $5ea73cfb65e4f747$var$Lf(c.nextSibling);
                var d = $5ea73cfb65e4f747$var$xg;
                b && $5ea73cfb65e4f747$var$Cg(a, b) ? $5ea73cfb65e4f747$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $5ea73cfb65e4f747$var$I = !1, $5ea73cfb65e4f747$var$xg = a);
            }
        } else {
            if ($5ea73cfb65e4f747$var$Dg(a)) throw Error($5ea73cfb65e4f747$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $5ea73cfb65e4f747$var$I = !1;
            $5ea73cfb65e4f747$var$xg = a;
        }
    }
}
function $5ea73cfb65e4f747$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $5ea73cfb65e4f747$var$xg = a;
}
function $5ea73cfb65e4f747$var$Gg(a) {
    if (a !== $5ea73cfb65e4f747$var$xg) return !1;
    if (!$5ea73cfb65e4f747$var$I) return $5ea73cfb65e4f747$var$Fg(a), $5ea73cfb65e4f747$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$5ea73cfb65e4f747$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $5ea73cfb65e4f747$var$yg)) {
        if ($5ea73cfb65e4f747$var$Dg(a)) throw $5ea73cfb65e4f747$var$Hg(), Error($5ea73cfb65e4f747$var$p(418));
        for(; b;)$5ea73cfb65e4f747$var$Ag(a, b), b = $5ea73cfb65e4f747$var$Lf(b.nextSibling);
    }
    $5ea73cfb65e4f747$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($5ea73cfb65e4f747$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $5ea73cfb65e4f747$var$yg = $5ea73cfb65e4f747$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $5ea73cfb65e4f747$var$yg = null;
        }
    } else $5ea73cfb65e4f747$var$yg = $5ea73cfb65e4f747$var$xg ? $5ea73cfb65e4f747$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $5ea73cfb65e4f747$var$Hg() {
    for(var a = $5ea73cfb65e4f747$var$yg; a;)a = $5ea73cfb65e4f747$var$Lf(a.nextSibling);
}
function $5ea73cfb65e4f747$var$Ig() {
    $5ea73cfb65e4f747$var$yg = $5ea73cfb65e4f747$var$xg = null;
    $5ea73cfb65e4f747$var$I = !1;
}
function $5ea73cfb65e4f747$var$Jg(a) {
    null === $5ea73cfb65e4f747$var$zg ? $5ea73cfb65e4f747$var$zg = [
        a
    ] : $5ea73cfb65e4f747$var$zg.push(a);
}
var $5ea73cfb65e4f747$var$Kg = $5ea73cfb65e4f747$var$ua.ReactCurrentBatchConfig;
function $5ea73cfb65e4f747$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($5ea73cfb65e4f747$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($5ea73cfb65e4f747$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($5ea73cfb65e4f747$var$p(284));
        if (!c._owner) throw Error($5ea73cfb65e4f747$var$p(290, a));
    }
    return a;
}
function $5ea73cfb65e4f747$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($5ea73cfb65e4f747$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $5ea73cfb65e4f747$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $5ea73cfb65e4f747$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $5ea73cfb65e4f747$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $5ea73cfb65e4f747$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $5ea73cfb65e4f747$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $5ea73cfb65e4f747$var$Ha && $5ea73cfb65e4f747$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $5ea73cfb65e4f747$var$Lg(a, b, c), d.return = a, d;
        d = $5ea73cfb65e4f747$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $5ea73cfb65e4f747$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $5ea73cfb65e4f747$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $5ea73cfb65e4f747$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $5ea73cfb65e4f747$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $5ea73cfb65e4f747$var$va:
                    return c = $5ea73cfb65e4f747$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $5ea73cfb65e4f747$var$Lg(a, null, b), c.return = a, c;
                case $5ea73cfb65e4f747$var$wa:
                    return b = $5ea73cfb65e4f747$var$Sg(b, a.mode, c), b.return = a, b;
                case $5ea73cfb65e4f747$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($5ea73cfb65e4f747$var$eb(b) || $5ea73cfb65e4f747$var$Ka(b)) return b = $5ea73cfb65e4f747$var$Tg(b, a.mode, c, null), b.return = a, b;
            $5ea73cfb65e4f747$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $5ea73cfb65e4f747$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $5ea73cfb65e4f747$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $5ea73cfb65e4f747$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($5ea73cfb65e4f747$var$eb(c) || $5ea73cfb65e4f747$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $5ea73cfb65e4f747$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $5ea73cfb65e4f747$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $5ea73cfb65e4f747$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $5ea73cfb65e4f747$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($5ea73cfb65e4f747$var$eb(d) || $5ea73cfb65e4f747$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $5ea73cfb65e4f747$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $5ea73cfb65e4f747$var$I && $5ea73cfb65e4f747$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $5ea73cfb65e4f747$var$I && $5ea73cfb65e4f747$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $5ea73cfb65e4f747$var$I && $5ea73cfb65e4f747$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $5ea73cfb65e4f747$var$Ka(h);
        if ("function" !== typeof l) throw Error($5ea73cfb65e4f747$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($5ea73cfb65e4f747$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $5ea73cfb65e4f747$var$I && $5ea73cfb65e4f747$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $5ea73cfb65e4f747$var$I && $5ea73cfb65e4f747$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $5ea73cfb65e4f747$var$I && $5ea73cfb65e4f747$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $5ea73cfb65e4f747$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $5ea73cfb65e4f747$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $5ea73cfb65e4f747$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $5ea73cfb65e4f747$var$Ha && $5ea73cfb65e4f747$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $5ea73cfb65e4f747$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $5ea73cfb65e4f747$var$ya ? (d = $5ea73cfb65e4f747$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $5ea73cfb65e4f747$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $5ea73cfb65e4f747$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $5ea73cfb65e4f747$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $5ea73cfb65e4f747$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $5ea73cfb65e4f747$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($5ea73cfb65e4f747$var$eb(f)) return n(a, d, f, h);
            if ($5ea73cfb65e4f747$var$Ka(f)) return t(a, d, f, h);
            $5ea73cfb65e4f747$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $5ea73cfb65e4f747$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $5ea73cfb65e4f747$var$Ug = $5ea73cfb65e4f747$var$Og(!0), $5ea73cfb65e4f747$var$Vg = $5ea73cfb65e4f747$var$Og(!1), $5ea73cfb65e4f747$var$Wg = $5ea73cfb65e4f747$var$Uf(null), $5ea73cfb65e4f747$var$Xg = null, $5ea73cfb65e4f747$var$Yg = null, $5ea73cfb65e4f747$var$Zg = null;
function $5ea73cfb65e4f747$var$$g() {
    $5ea73cfb65e4f747$var$Zg = $5ea73cfb65e4f747$var$Yg = $5ea73cfb65e4f747$var$Xg = null;
}
function $5ea73cfb65e4f747$var$ah(a) {
    var b = $5ea73cfb65e4f747$var$Wg.current;
    $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$Wg);
    a._currentValue = b;
}
function $5ea73cfb65e4f747$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $5ea73cfb65e4f747$var$ch(a, b) {
    $5ea73cfb65e4f747$var$Xg = a;
    $5ea73cfb65e4f747$var$Zg = $5ea73cfb65e4f747$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($5ea73cfb65e4f747$var$dh = !0), a.firstContext = null);
}
function $5ea73cfb65e4f747$var$eh(a) {
    var b = a._currentValue;
    if ($5ea73cfb65e4f747$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $5ea73cfb65e4f747$var$Yg) {
            if (null === $5ea73cfb65e4f747$var$Xg) throw Error($5ea73cfb65e4f747$var$p(308));
            $5ea73cfb65e4f747$var$Yg = a;
            $5ea73cfb65e4f747$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $5ea73cfb65e4f747$var$Yg = $5ea73cfb65e4f747$var$Yg.next = a;
    }
    return b;
}
var $5ea73cfb65e4f747$var$fh = null;
function $5ea73cfb65e4f747$var$gh(a) {
    null === $5ea73cfb65e4f747$var$fh ? $5ea73cfb65e4f747$var$fh = [
        a
    ] : $5ea73cfb65e4f747$var$fh.push(a);
}
function $5ea73cfb65e4f747$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $5ea73cfb65e4f747$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $5ea73cfb65e4f747$var$ih(a, d);
}
function $5ea73cfb65e4f747$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $5ea73cfb65e4f747$var$jh = !1;
function $5ea73cfb65e4f747$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $5ea73cfb65e4f747$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $5ea73cfb65e4f747$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $5ea73cfb65e4f747$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($5ea73cfb65e4f747$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $5ea73cfb65e4f747$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $5ea73cfb65e4f747$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $5ea73cfb65e4f747$var$ih(a, c);
}
function $5ea73cfb65e4f747$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $5ea73cfb65e4f747$var$Cc(a, c);
    }
}
function $5ea73cfb65e4f747$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $5ea73cfb65e4f747$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $5ea73cfb65e4f747$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $5ea73cfb65e4f747$var$A({}, q, r);
                            break a;
                        case 2:
                            $5ea73cfb65e4f747$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $5ea73cfb65e4f747$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $5ea73cfb65e4f747$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($5ea73cfb65e4f747$var$p(191, e));
            e.call(d);
        }
    }
}
var $5ea73cfb65e4f747$var$th = {}, $5ea73cfb65e4f747$var$uh = $5ea73cfb65e4f747$var$Uf($5ea73cfb65e4f747$var$th), $5ea73cfb65e4f747$var$vh = $5ea73cfb65e4f747$var$Uf($5ea73cfb65e4f747$var$th), $5ea73cfb65e4f747$var$wh = $5ea73cfb65e4f747$var$Uf($5ea73cfb65e4f747$var$th);
function $5ea73cfb65e4f747$var$xh(a) {
    if (a === $5ea73cfb65e4f747$var$th) throw Error($5ea73cfb65e4f747$var$p(174));
    return a;
}
function $5ea73cfb65e4f747$var$yh(a, b) {
    $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$wh, b);
    $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$vh, a);
    $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$uh, $5ea73cfb65e4f747$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $5ea73cfb65e4f747$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $5ea73cfb65e4f747$var$lb(b, a);
    }
    $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$uh);
    $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$uh, b);
}
function $5ea73cfb65e4f747$var$zh() {
    $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$uh);
    $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$vh);
    $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$wh);
}
function $5ea73cfb65e4f747$var$Ah(a) {
    $5ea73cfb65e4f747$var$xh($5ea73cfb65e4f747$var$wh.current);
    var b = $5ea73cfb65e4f747$var$xh($5ea73cfb65e4f747$var$uh.current);
    var c = $5ea73cfb65e4f747$var$lb(b, a.type);
    b !== c && ($5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$vh, a), $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$uh, c));
}
function $5ea73cfb65e4f747$var$Bh(a) {
    $5ea73cfb65e4f747$var$vh.current === a && ($5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$uh), $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$vh));
}
var $5ea73cfb65e4f747$var$L = $5ea73cfb65e4f747$var$Uf(0);
function $5ea73cfb65e4f747$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $5ea73cfb65e4f747$var$Dh = [];
function $5ea73cfb65e4f747$var$Eh() {
    for(var a = 0; a < $5ea73cfb65e4f747$var$Dh.length; a++)$5ea73cfb65e4f747$var$Dh[a]._workInProgressVersionPrimary = null;
    $5ea73cfb65e4f747$var$Dh.length = 0;
}
var $5ea73cfb65e4f747$var$Fh = $5ea73cfb65e4f747$var$ua.ReactCurrentDispatcher, $5ea73cfb65e4f747$var$Gh = $5ea73cfb65e4f747$var$ua.ReactCurrentBatchConfig, $5ea73cfb65e4f747$var$Hh = 0, $5ea73cfb65e4f747$var$M = null, $5ea73cfb65e4f747$var$N = null, $5ea73cfb65e4f747$var$O = null, $5ea73cfb65e4f747$var$Ih = !1, $5ea73cfb65e4f747$var$Jh = !1, $5ea73cfb65e4f747$var$Kh = 0, $5ea73cfb65e4f747$var$Lh = 0;
function $5ea73cfb65e4f747$var$P() {
    throw Error($5ea73cfb65e4f747$var$p(321));
}
function $5ea73cfb65e4f747$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$5ea73cfb65e4f747$var$He(a[c], b[c])) return !1;
    return !0;
}
function $5ea73cfb65e4f747$var$Nh(a, b, c, d, e, f) {
    $5ea73cfb65e4f747$var$Hh = f;
    $5ea73cfb65e4f747$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $5ea73cfb65e4f747$var$Fh.current = null === a || null === a.memoizedState ? $5ea73cfb65e4f747$var$Oh : $5ea73cfb65e4f747$var$Ph;
    a = c(d, e);
    if ($5ea73cfb65e4f747$var$Jh) {
        f = 0;
        do {
            $5ea73cfb65e4f747$var$Jh = !1;
            $5ea73cfb65e4f747$var$Kh = 0;
            if (25 <= f) throw Error($5ea73cfb65e4f747$var$p(301));
            f += 1;
            $5ea73cfb65e4f747$var$O = $5ea73cfb65e4f747$var$N = null;
            b.updateQueue = null;
            $5ea73cfb65e4f747$var$Fh.current = $5ea73cfb65e4f747$var$Qh;
            a = c(d, e);
        }while ($5ea73cfb65e4f747$var$Jh);
    }
    $5ea73cfb65e4f747$var$Fh.current = $5ea73cfb65e4f747$var$Rh;
    b = null !== $5ea73cfb65e4f747$var$N && null !== $5ea73cfb65e4f747$var$N.next;
    $5ea73cfb65e4f747$var$Hh = 0;
    $5ea73cfb65e4f747$var$O = $5ea73cfb65e4f747$var$N = $5ea73cfb65e4f747$var$M = null;
    $5ea73cfb65e4f747$var$Ih = !1;
    if (b) throw Error($5ea73cfb65e4f747$var$p(300));
    return a;
}
function $5ea73cfb65e4f747$var$Sh() {
    var a = 0 !== $5ea73cfb65e4f747$var$Kh;
    $5ea73cfb65e4f747$var$Kh = 0;
    return a;
}
function $5ea73cfb65e4f747$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $5ea73cfb65e4f747$var$O ? $5ea73cfb65e4f747$var$M.memoizedState = $5ea73cfb65e4f747$var$O = a : $5ea73cfb65e4f747$var$O = $5ea73cfb65e4f747$var$O.next = a;
    return $5ea73cfb65e4f747$var$O;
}
function $5ea73cfb65e4f747$var$Uh() {
    if (null === $5ea73cfb65e4f747$var$N) {
        var a = $5ea73cfb65e4f747$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $5ea73cfb65e4f747$var$N.next;
    var b = null === $5ea73cfb65e4f747$var$O ? $5ea73cfb65e4f747$var$M.memoizedState : $5ea73cfb65e4f747$var$O.next;
    if (null !== b) $5ea73cfb65e4f747$var$O = b, $5ea73cfb65e4f747$var$N = a;
    else {
        if (null === a) throw Error($5ea73cfb65e4f747$var$p(310));
        $5ea73cfb65e4f747$var$N = a;
        a = {
            memoizedState: $5ea73cfb65e4f747$var$N.memoizedState,
            baseState: $5ea73cfb65e4f747$var$N.baseState,
            baseQueue: $5ea73cfb65e4f747$var$N.baseQueue,
            queue: $5ea73cfb65e4f747$var$N.queue,
            next: null
        };
        null === $5ea73cfb65e4f747$var$O ? $5ea73cfb65e4f747$var$M.memoizedState = $5ea73cfb65e4f747$var$O = a : $5ea73cfb65e4f747$var$O = $5ea73cfb65e4f747$var$O.next = a;
    }
    return $5ea73cfb65e4f747$var$O;
}
function $5ea73cfb65e4f747$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $5ea73cfb65e4f747$var$Wh(a) {
    var b = $5ea73cfb65e4f747$var$Uh(), c = b.queue;
    if (null === c) throw Error($5ea73cfb65e4f747$var$p(311));
    c.lastRenderedReducer = a;
    var d = $5ea73cfb65e4f747$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($5ea73cfb65e4f747$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $5ea73cfb65e4f747$var$M.lanes |= m;
                $5ea73cfb65e4f747$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $5ea73cfb65e4f747$var$He(d, b.memoizedState) || ($5ea73cfb65e4f747$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $5ea73cfb65e4f747$var$M.lanes |= f, $5ea73cfb65e4f747$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $5ea73cfb65e4f747$var$Xh(a) {
    var b = $5ea73cfb65e4f747$var$Uh(), c = b.queue;
    if (null === c) throw Error($5ea73cfb65e4f747$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $5ea73cfb65e4f747$var$He(f, b.memoizedState) || ($5ea73cfb65e4f747$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $5ea73cfb65e4f747$var$Yh() {}
function $5ea73cfb65e4f747$var$Zh(a, b) {
    var c = $5ea73cfb65e4f747$var$M, d = $5ea73cfb65e4f747$var$Uh(), e = b(), f = !$5ea73cfb65e4f747$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $5ea73cfb65e4f747$var$dh = !0);
    d = d.queue;
    $5ea73cfb65e4f747$var$$h($5ea73cfb65e4f747$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $5ea73cfb65e4f747$var$O && $5ea73cfb65e4f747$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $5ea73cfb65e4f747$var$bi(9, $5ea73cfb65e4f747$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $5ea73cfb65e4f747$var$Q) throw Error($5ea73cfb65e4f747$var$p(349));
        0 !== ($5ea73cfb65e4f747$var$Hh & 30) || $5ea73cfb65e4f747$var$di(c, b, e);
    }
    return e;
}
function $5ea73cfb65e4f747$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $5ea73cfb65e4f747$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $5ea73cfb65e4f747$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $5ea73cfb65e4f747$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $5ea73cfb65e4f747$var$ei(b) && $5ea73cfb65e4f747$var$fi(a);
}
function $5ea73cfb65e4f747$var$ai(a, b, c) {
    return c(function() {
        $5ea73cfb65e4f747$var$ei(b) && $5ea73cfb65e4f747$var$fi(a);
    });
}
function $5ea73cfb65e4f747$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$5ea73cfb65e4f747$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $5ea73cfb65e4f747$var$fi(a) {
    var b = $5ea73cfb65e4f747$var$ih(a, 1);
    null !== b && $5ea73cfb65e4f747$var$gi(b, a, 1, -1);
}
function $5ea73cfb65e4f747$var$hi(a) {
    var b = $5ea73cfb65e4f747$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $5ea73cfb65e4f747$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $5ea73cfb65e4f747$var$ii.bind(null, $5ea73cfb65e4f747$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $5ea73cfb65e4f747$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $5ea73cfb65e4f747$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $5ea73cfb65e4f747$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $5ea73cfb65e4f747$var$ji() {
    return $5ea73cfb65e4f747$var$Uh().memoizedState;
}
function $5ea73cfb65e4f747$var$ki(a, b, c, d) {
    var e = $5ea73cfb65e4f747$var$Th();
    $5ea73cfb65e4f747$var$M.flags |= a;
    e.memoizedState = $5ea73cfb65e4f747$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $5ea73cfb65e4f747$var$li(a, b, c, d) {
    var e = $5ea73cfb65e4f747$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $5ea73cfb65e4f747$var$N) {
        var g = $5ea73cfb65e4f747$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $5ea73cfb65e4f747$var$Mh(d, g.deps)) {
            e.memoizedState = $5ea73cfb65e4f747$var$bi(b, c, f, d);
            return;
        }
    }
    $5ea73cfb65e4f747$var$M.flags |= a;
    e.memoizedState = $5ea73cfb65e4f747$var$bi(1 | b, c, f, d);
}
function $5ea73cfb65e4f747$var$mi(a, b) {
    return $5ea73cfb65e4f747$var$ki(8390656, 8, a, b);
}
function $5ea73cfb65e4f747$var$$h(a, b) {
    return $5ea73cfb65e4f747$var$li(2048, 8, a, b);
}
function $5ea73cfb65e4f747$var$ni(a, b) {
    return $5ea73cfb65e4f747$var$li(4, 2, a, b);
}
function $5ea73cfb65e4f747$var$oi(a, b) {
    return $5ea73cfb65e4f747$var$li(4, 4, a, b);
}
function $5ea73cfb65e4f747$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $5ea73cfb65e4f747$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $5ea73cfb65e4f747$var$li(4, 4, $5ea73cfb65e4f747$var$pi.bind(null, b, a), c);
}
function $5ea73cfb65e4f747$var$ri() {}
function $5ea73cfb65e4f747$var$si(a, b) {
    var c = $5ea73cfb65e4f747$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5ea73cfb65e4f747$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5ea73cfb65e4f747$var$ti(a, b) {
    var c = $5ea73cfb65e4f747$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5ea73cfb65e4f747$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5ea73cfb65e4f747$var$ui(a, b, c) {
    if (0 === ($5ea73cfb65e4f747$var$Hh & 21)) return a.baseState && (a.baseState = !1, $5ea73cfb65e4f747$var$dh = !0), a.memoizedState = c;
    $5ea73cfb65e4f747$var$He(c, b) || (c = $5ea73cfb65e4f747$var$yc(), $5ea73cfb65e4f747$var$M.lanes |= c, $5ea73cfb65e4f747$var$rh |= c, a.baseState = !0);
    return b;
}
function $5ea73cfb65e4f747$var$vi(a, b) {
    var c = $5ea73cfb65e4f747$var$C;
    $5ea73cfb65e4f747$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $5ea73cfb65e4f747$var$Gh.transition;
    $5ea73cfb65e4f747$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $5ea73cfb65e4f747$var$C = c, $5ea73cfb65e4f747$var$Gh.transition = d;
    }
}
function $5ea73cfb65e4f747$var$wi() {
    return $5ea73cfb65e4f747$var$Uh().memoizedState;
}
function $5ea73cfb65e4f747$var$xi(a, b, c) {
    var d = $5ea73cfb65e4f747$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5ea73cfb65e4f747$var$zi(a)) $5ea73cfb65e4f747$var$Ai(b, c);
    else if (c = $5ea73cfb65e4f747$var$hh(a, b, c, d), null !== c) {
        var e = $5ea73cfb65e4f747$var$R();
        $5ea73cfb65e4f747$var$gi(c, a, d, e);
        $5ea73cfb65e4f747$var$Bi(c, b, d);
    }
}
function $5ea73cfb65e4f747$var$ii(a, b, c) {
    var d = $5ea73cfb65e4f747$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5ea73cfb65e4f747$var$zi(a)) $5ea73cfb65e4f747$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($5ea73cfb65e4f747$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $5ea73cfb65e4f747$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $5ea73cfb65e4f747$var$hh(a, b, e, d);
        null !== c && (e = $5ea73cfb65e4f747$var$R(), $5ea73cfb65e4f747$var$gi(c, a, d, e), $5ea73cfb65e4f747$var$Bi(c, b, d));
    }
}
function $5ea73cfb65e4f747$var$zi(a) {
    var b = a.alternate;
    return a === $5ea73cfb65e4f747$var$M || null !== b && b === $5ea73cfb65e4f747$var$M;
}
function $5ea73cfb65e4f747$var$Ai(a, b) {
    $5ea73cfb65e4f747$var$Jh = $5ea73cfb65e4f747$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $5ea73cfb65e4f747$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $5ea73cfb65e4f747$var$Cc(a, c);
    }
}
var $5ea73cfb65e4f747$var$Rh = {
    readContext: $5ea73cfb65e4f747$var$eh,
    useCallback: $5ea73cfb65e4f747$var$P,
    useContext: $5ea73cfb65e4f747$var$P,
    useEffect: $5ea73cfb65e4f747$var$P,
    useImperativeHandle: $5ea73cfb65e4f747$var$P,
    useInsertionEffect: $5ea73cfb65e4f747$var$P,
    useLayoutEffect: $5ea73cfb65e4f747$var$P,
    useMemo: $5ea73cfb65e4f747$var$P,
    useReducer: $5ea73cfb65e4f747$var$P,
    useRef: $5ea73cfb65e4f747$var$P,
    useState: $5ea73cfb65e4f747$var$P,
    useDebugValue: $5ea73cfb65e4f747$var$P,
    useDeferredValue: $5ea73cfb65e4f747$var$P,
    useTransition: $5ea73cfb65e4f747$var$P,
    useMutableSource: $5ea73cfb65e4f747$var$P,
    useSyncExternalStore: $5ea73cfb65e4f747$var$P,
    useId: $5ea73cfb65e4f747$var$P,
    unstable_isNewReconciler: !1
}, $5ea73cfb65e4f747$var$Oh = {
    readContext: $5ea73cfb65e4f747$var$eh,
    useCallback: function(a, b) {
        $5ea73cfb65e4f747$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $5ea73cfb65e4f747$var$eh,
    useEffect: $5ea73cfb65e4f747$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $5ea73cfb65e4f747$var$ki(4194308, 4, $5ea73cfb65e4f747$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $5ea73cfb65e4f747$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $5ea73cfb65e4f747$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $5ea73cfb65e4f747$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $5ea73cfb65e4f747$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $5ea73cfb65e4f747$var$xi.bind(null, $5ea73cfb65e4f747$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $5ea73cfb65e4f747$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $5ea73cfb65e4f747$var$hi,
    useDebugValue: $5ea73cfb65e4f747$var$ri,
    useDeferredValue: function(a) {
        return $5ea73cfb65e4f747$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $5ea73cfb65e4f747$var$hi(!1), b = a[0];
        a = $5ea73cfb65e4f747$var$vi.bind(null, a[1]);
        $5ea73cfb65e4f747$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $5ea73cfb65e4f747$var$M, e = $5ea73cfb65e4f747$var$Th();
        if ($5ea73cfb65e4f747$var$I) {
            if (void 0 === c) throw Error($5ea73cfb65e4f747$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $5ea73cfb65e4f747$var$Q) throw Error($5ea73cfb65e4f747$var$p(349));
            0 !== ($5ea73cfb65e4f747$var$Hh & 30) || $5ea73cfb65e4f747$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $5ea73cfb65e4f747$var$mi($5ea73cfb65e4f747$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $5ea73cfb65e4f747$var$bi(9, $5ea73cfb65e4f747$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $5ea73cfb65e4f747$var$Th(), b = $5ea73cfb65e4f747$var$Q.identifierPrefix;
        if ($5ea73cfb65e4f747$var$I) {
            var c = $5ea73cfb65e4f747$var$sg;
            var d = $5ea73cfb65e4f747$var$rg;
            c = (d & ~(1 << 32 - $5ea73cfb65e4f747$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $5ea73cfb65e4f747$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $5ea73cfb65e4f747$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $5ea73cfb65e4f747$var$Ph = {
    readContext: $5ea73cfb65e4f747$var$eh,
    useCallback: $5ea73cfb65e4f747$var$si,
    useContext: $5ea73cfb65e4f747$var$eh,
    useEffect: $5ea73cfb65e4f747$var$$h,
    useImperativeHandle: $5ea73cfb65e4f747$var$qi,
    useInsertionEffect: $5ea73cfb65e4f747$var$ni,
    useLayoutEffect: $5ea73cfb65e4f747$var$oi,
    useMemo: $5ea73cfb65e4f747$var$ti,
    useReducer: $5ea73cfb65e4f747$var$Wh,
    useRef: $5ea73cfb65e4f747$var$ji,
    useState: function() {
        return $5ea73cfb65e4f747$var$Wh($5ea73cfb65e4f747$var$Vh);
    },
    useDebugValue: $5ea73cfb65e4f747$var$ri,
    useDeferredValue: function(a) {
        var b = $5ea73cfb65e4f747$var$Uh();
        return $5ea73cfb65e4f747$var$ui(b, $5ea73cfb65e4f747$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $5ea73cfb65e4f747$var$Wh($5ea73cfb65e4f747$var$Vh)[0], b = $5ea73cfb65e4f747$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $5ea73cfb65e4f747$var$Yh,
    useSyncExternalStore: $5ea73cfb65e4f747$var$Zh,
    useId: $5ea73cfb65e4f747$var$wi,
    unstable_isNewReconciler: !1
}, $5ea73cfb65e4f747$var$Qh = {
    readContext: $5ea73cfb65e4f747$var$eh,
    useCallback: $5ea73cfb65e4f747$var$si,
    useContext: $5ea73cfb65e4f747$var$eh,
    useEffect: $5ea73cfb65e4f747$var$$h,
    useImperativeHandle: $5ea73cfb65e4f747$var$qi,
    useInsertionEffect: $5ea73cfb65e4f747$var$ni,
    useLayoutEffect: $5ea73cfb65e4f747$var$oi,
    useMemo: $5ea73cfb65e4f747$var$ti,
    useReducer: $5ea73cfb65e4f747$var$Xh,
    useRef: $5ea73cfb65e4f747$var$ji,
    useState: function() {
        return $5ea73cfb65e4f747$var$Xh($5ea73cfb65e4f747$var$Vh);
    },
    useDebugValue: $5ea73cfb65e4f747$var$ri,
    useDeferredValue: function(a) {
        var b = $5ea73cfb65e4f747$var$Uh();
        return null === $5ea73cfb65e4f747$var$N ? b.memoizedState = a : $5ea73cfb65e4f747$var$ui(b, $5ea73cfb65e4f747$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $5ea73cfb65e4f747$var$Xh($5ea73cfb65e4f747$var$Vh)[0], b = $5ea73cfb65e4f747$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $5ea73cfb65e4f747$var$Yh,
    useSyncExternalStore: $5ea73cfb65e4f747$var$Zh,
    useId: $5ea73cfb65e4f747$var$wi,
    unstable_isNewReconciler: !1
};
function $5ea73cfb65e4f747$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $5ea73cfb65e4f747$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $5ea73cfb65e4f747$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $5ea73cfb65e4f747$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $5ea73cfb65e4f747$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $5ea73cfb65e4f747$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $5ea73cfb65e4f747$var$R(), e = $5ea73cfb65e4f747$var$yi(a), f = $5ea73cfb65e4f747$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $5ea73cfb65e4f747$var$nh(a, f, e);
        null !== b && ($5ea73cfb65e4f747$var$gi(b, a, e, d), $5ea73cfb65e4f747$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $5ea73cfb65e4f747$var$R(), e = $5ea73cfb65e4f747$var$yi(a), f = $5ea73cfb65e4f747$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $5ea73cfb65e4f747$var$nh(a, f, e);
        null !== b && ($5ea73cfb65e4f747$var$gi(b, a, e, d), $5ea73cfb65e4f747$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $5ea73cfb65e4f747$var$R(), d = $5ea73cfb65e4f747$var$yi(a), e = $5ea73cfb65e4f747$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $5ea73cfb65e4f747$var$nh(a, e, d);
        null !== b && ($5ea73cfb65e4f747$var$gi(b, a, d, c), $5ea73cfb65e4f747$var$oh(b, a, d));
    }
};
function $5ea73cfb65e4f747$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$5ea73cfb65e4f747$var$Ie(c, d) || !$5ea73cfb65e4f747$var$Ie(e, f) : !0;
}
function $5ea73cfb65e4f747$var$Gi(a, b, c) {
    var d = !1, e = $5ea73cfb65e4f747$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $5ea73cfb65e4f747$var$eh(f) : (e = $5ea73cfb65e4f747$var$Zf(b) ? $5ea73cfb65e4f747$var$Xf : $5ea73cfb65e4f747$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $5ea73cfb65e4f747$var$Yf(a, e) : $5ea73cfb65e4f747$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $5ea73cfb65e4f747$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $5ea73cfb65e4f747$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $5ea73cfb65e4f747$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $5ea73cfb65e4f747$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $5ea73cfb65e4f747$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $5ea73cfb65e4f747$var$eh(f) : (f = $5ea73cfb65e4f747$var$Zf(b) ? $5ea73cfb65e4f747$var$Xf : $5ea73cfb65e4f747$var$H.current, e.context = $5ea73cfb65e4f747$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($5ea73cfb65e4f747$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $5ea73cfb65e4f747$var$Ei.enqueueReplaceState(e, e.state, null), $5ea73cfb65e4f747$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $5ea73cfb65e4f747$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $5ea73cfb65e4f747$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $5ea73cfb65e4f747$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $5ea73cfb65e4f747$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $5ea73cfb65e4f747$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $5ea73cfb65e4f747$var$Ni(a, b, c) {
    c = $5ea73cfb65e4f747$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $5ea73cfb65e4f747$var$Oi || ($5ea73cfb65e4f747$var$Oi = !0, $5ea73cfb65e4f747$var$Pi = d);
        $5ea73cfb65e4f747$var$Li(a, b);
    };
    return c;
}
function $5ea73cfb65e4f747$var$Qi(a, b, c) {
    c = $5ea73cfb65e4f747$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $5ea73cfb65e4f747$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $5ea73cfb65e4f747$var$Li(a, b);
        "function" !== typeof d && (null === $5ea73cfb65e4f747$var$Ri ? $5ea73cfb65e4f747$var$Ri = new Set([
            this
        ]) : $5ea73cfb65e4f747$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $5ea73cfb65e4f747$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $5ea73cfb65e4f747$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $5ea73cfb65e4f747$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $5ea73cfb65e4f747$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $5ea73cfb65e4f747$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $5ea73cfb65e4f747$var$mh(-1, 1), b.tag = 2, $5ea73cfb65e4f747$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $5ea73cfb65e4f747$var$Wi = $5ea73cfb65e4f747$var$ua.ReactCurrentOwner, $5ea73cfb65e4f747$var$dh = !1;
function $5ea73cfb65e4f747$var$Xi(a, b, c, d) {
    b.child = null === a ? $5ea73cfb65e4f747$var$Vg(b, null, c, d) : $5ea73cfb65e4f747$var$Ug(b, a.child, c, d);
}
function $5ea73cfb65e4f747$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $5ea73cfb65e4f747$var$ch(b, e);
    d = $5ea73cfb65e4f747$var$Nh(a, b, c, d, f, e);
    c = $5ea73cfb65e4f747$var$Sh();
    if (null !== a && !$5ea73cfb65e4f747$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $5ea73cfb65e4f747$var$Zi(a, b, e);
    $5ea73cfb65e4f747$var$I && c && $5ea73cfb65e4f747$var$vg(b);
    b.flags |= 1;
    $5ea73cfb65e4f747$var$Xi(a, b, d, e);
    return b.child;
}
function $5ea73cfb65e4f747$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$5ea73cfb65e4f747$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $5ea73cfb65e4f747$var$bj(a, b, f, d, e);
        a = $5ea73cfb65e4f747$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $5ea73cfb65e4f747$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $5ea73cfb65e4f747$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $5ea73cfb65e4f747$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $5ea73cfb65e4f747$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($5ea73cfb65e4f747$var$Ie(f, d) && a.ref === b.ref) {
            if ($5ea73cfb65e4f747$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($5ea73cfb65e4f747$var$dh = !0);
            else return b.lanes = a.lanes, $5ea73cfb65e4f747$var$Zi(a, b, e);
        }
    }
    return $5ea73cfb65e4f747$var$cj(a, b, c, d, e);
}
function $5ea73cfb65e4f747$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$ej, $5ea73cfb65e4f747$var$fj), $5ea73cfb65e4f747$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$ej, $5ea73cfb65e4f747$var$fj), $5ea73cfb65e4f747$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$ej, $5ea73cfb65e4f747$var$fj);
            $5ea73cfb65e4f747$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$ej, $5ea73cfb65e4f747$var$fj), $5ea73cfb65e4f747$var$fj |= d;
    $5ea73cfb65e4f747$var$Xi(a, b, e, c);
    return b.child;
}
function $5ea73cfb65e4f747$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $5ea73cfb65e4f747$var$cj(a, b, c, d, e) {
    var f = $5ea73cfb65e4f747$var$Zf(c) ? $5ea73cfb65e4f747$var$Xf : $5ea73cfb65e4f747$var$H.current;
    f = $5ea73cfb65e4f747$var$Yf(b, f);
    $5ea73cfb65e4f747$var$ch(b, e);
    c = $5ea73cfb65e4f747$var$Nh(a, b, c, d, f, e);
    d = $5ea73cfb65e4f747$var$Sh();
    if (null !== a && !$5ea73cfb65e4f747$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $5ea73cfb65e4f747$var$Zi(a, b, e);
    $5ea73cfb65e4f747$var$I && d && $5ea73cfb65e4f747$var$vg(b);
    b.flags |= 1;
    $5ea73cfb65e4f747$var$Xi(a, b, c, e);
    return b.child;
}
function $5ea73cfb65e4f747$var$hj(a, b, c, d, e) {
    if ($5ea73cfb65e4f747$var$Zf(c)) {
        var f = !0;
        $5ea73cfb65e4f747$var$cg(b);
    } else f = !1;
    $5ea73cfb65e4f747$var$ch(b, e);
    if (null === b.stateNode) $5ea73cfb65e4f747$var$ij(a, b), $5ea73cfb65e4f747$var$Gi(b, c, d), $5ea73cfb65e4f747$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $5ea73cfb65e4f747$var$eh(l) : (l = $5ea73cfb65e4f747$var$Zf(c) ? $5ea73cfb65e4f747$var$Xf : $5ea73cfb65e4f747$var$H.current, l = $5ea73cfb65e4f747$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $5ea73cfb65e4f747$var$Hi(b, g, d, l);
        $5ea73cfb65e4f747$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $5ea73cfb65e4f747$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $5ea73cfb65e4f747$var$Wf.current || $5ea73cfb65e4f747$var$jh ? ("function" === typeof m && ($5ea73cfb65e4f747$var$Di(b, c, m, d), k = b.memoizedState), (h = $5ea73cfb65e4f747$var$jh || $5ea73cfb65e4f747$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $5ea73cfb65e4f747$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $5ea73cfb65e4f747$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $5ea73cfb65e4f747$var$eh(k) : (k = $5ea73cfb65e4f747$var$Zf(c) ? $5ea73cfb65e4f747$var$Xf : $5ea73cfb65e4f747$var$H.current, k = $5ea73cfb65e4f747$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $5ea73cfb65e4f747$var$Hi(b, g, d, k);
        $5ea73cfb65e4f747$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $5ea73cfb65e4f747$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $5ea73cfb65e4f747$var$Wf.current || $5ea73cfb65e4f747$var$jh ? ("function" === typeof y && ($5ea73cfb65e4f747$var$Di(b, c, y, d), n = b.memoizedState), (l = $5ea73cfb65e4f747$var$jh || $5ea73cfb65e4f747$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $5ea73cfb65e4f747$var$jj(a, b, c, d, f, e);
}
function $5ea73cfb65e4f747$var$jj(a, b, c, d, e, f) {
    $5ea73cfb65e4f747$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $5ea73cfb65e4f747$var$dg(b, c, !1), $5ea73cfb65e4f747$var$Zi(a, b, f);
    d = b.stateNode;
    $5ea73cfb65e4f747$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $5ea73cfb65e4f747$var$Ug(b, a.child, null, f), b.child = $5ea73cfb65e4f747$var$Ug(b, null, h, f)) : $5ea73cfb65e4f747$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $5ea73cfb65e4f747$var$dg(b, c, !0);
    return b.child;
}
function $5ea73cfb65e4f747$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $5ea73cfb65e4f747$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $5ea73cfb65e4f747$var$ag(a, b.context, !1);
    $5ea73cfb65e4f747$var$yh(a, b.containerInfo);
}
function $5ea73cfb65e4f747$var$lj(a, b, c, d, e) {
    $5ea73cfb65e4f747$var$Ig();
    $5ea73cfb65e4f747$var$Jg(e);
    b.flags |= 256;
    $5ea73cfb65e4f747$var$Xi(a, b, c, d);
    return b.child;
}
var $5ea73cfb65e4f747$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $5ea73cfb65e4f747$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $5ea73cfb65e4f747$var$oj(a, b, c) {
    var d = b.pendingProps, e = $5ea73cfb65e4f747$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$L, e & 1);
    if (null === a) {
        $5ea73cfb65e4f747$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $5ea73cfb65e4f747$var$pj(g, d, 0, null), a = $5ea73cfb65e4f747$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $5ea73cfb65e4f747$var$nj(c), b.memoizedState = $5ea73cfb65e4f747$var$mj, a) : $5ea73cfb65e4f747$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $5ea73cfb65e4f747$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $5ea73cfb65e4f747$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $5ea73cfb65e4f747$var$Pg(h, f) : (f = $5ea73cfb65e4f747$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $5ea73cfb65e4f747$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $5ea73cfb65e4f747$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $5ea73cfb65e4f747$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $5ea73cfb65e4f747$var$qj(a, b) {
    b = $5ea73cfb65e4f747$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $5ea73cfb65e4f747$var$sj(a, b, c, d) {
    null !== d && $5ea73cfb65e4f747$var$Jg(d);
    $5ea73cfb65e4f747$var$Ug(b, a.child, null, c);
    a = $5ea73cfb65e4f747$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $5ea73cfb65e4f747$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $5ea73cfb65e4f747$var$Ki(Error($5ea73cfb65e4f747$var$p(422))), $5ea73cfb65e4f747$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $5ea73cfb65e4f747$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $5ea73cfb65e4f747$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $5ea73cfb65e4f747$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $5ea73cfb65e4f747$var$nj(g);
        b.memoizedState = $5ea73cfb65e4f747$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $5ea73cfb65e4f747$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($5ea73cfb65e4f747$var$p(419));
        d = $5ea73cfb65e4f747$var$Ki(f, d, void 0);
        return $5ea73cfb65e4f747$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($5ea73cfb65e4f747$var$dh || h) {
        d = $5ea73cfb65e4f747$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $5ea73cfb65e4f747$var$ih(a, e), $5ea73cfb65e4f747$var$gi(d, a, e, -1));
        }
        $5ea73cfb65e4f747$var$tj();
        d = $5ea73cfb65e4f747$var$Ki(Error($5ea73cfb65e4f747$var$p(421)));
        return $5ea73cfb65e4f747$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $5ea73cfb65e4f747$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $5ea73cfb65e4f747$var$yg = $5ea73cfb65e4f747$var$Lf(e.nextSibling);
    $5ea73cfb65e4f747$var$xg = b;
    $5ea73cfb65e4f747$var$I = !0;
    $5ea73cfb65e4f747$var$zg = null;
    null !== a && ($5ea73cfb65e4f747$var$og[$5ea73cfb65e4f747$var$pg++] = $5ea73cfb65e4f747$var$rg, $5ea73cfb65e4f747$var$og[$5ea73cfb65e4f747$var$pg++] = $5ea73cfb65e4f747$var$sg, $5ea73cfb65e4f747$var$og[$5ea73cfb65e4f747$var$pg++] = $5ea73cfb65e4f747$var$qg, $5ea73cfb65e4f747$var$rg = a.id, $5ea73cfb65e4f747$var$sg = a.overflow, $5ea73cfb65e4f747$var$qg = b);
    b = $5ea73cfb65e4f747$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $5ea73cfb65e4f747$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $5ea73cfb65e4f747$var$bh(a.return, b, c);
}
function $5ea73cfb65e4f747$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $5ea73cfb65e4f747$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $5ea73cfb65e4f747$var$Xi(a, b, d.children, c);
    d = $5ea73cfb65e4f747$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $5ea73cfb65e4f747$var$vj(a, c, b);
            else if (19 === a.tag) $5ea73cfb65e4f747$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $5ea73cfb65e4f747$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $5ea73cfb65e4f747$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $5ea73cfb65e4f747$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $5ea73cfb65e4f747$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $5ea73cfb65e4f747$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $5ea73cfb65e4f747$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $5ea73cfb65e4f747$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $5ea73cfb65e4f747$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($5ea73cfb65e4f747$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $5ea73cfb65e4f747$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $5ea73cfb65e4f747$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $5ea73cfb65e4f747$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $5ea73cfb65e4f747$var$kj(b);
            $5ea73cfb65e4f747$var$Ig();
            break;
        case 5:
            $5ea73cfb65e4f747$var$Ah(b);
            break;
        case 1:
            $5ea73cfb65e4f747$var$Zf(b.type) && $5ea73cfb65e4f747$var$cg(b);
            break;
        case 4:
            $5ea73cfb65e4f747$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$L, $5ea73cfb65e4f747$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $5ea73cfb65e4f747$var$oj(a, b, c);
                $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$L, $5ea73cfb65e4f747$var$L.current & 1);
                a = $5ea73cfb65e4f747$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$L, $5ea73cfb65e4f747$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $5ea73cfb65e4f747$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$L, $5ea73cfb65e4f747$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $5ea73cfb65e4f747$var$dj(a, b, c);
    }
    return $5ea73cfb65e4f747$var$Zi(a, b, c);
}
var $5ea73cfb65e4f747$var$zj, $5ea73cfb65e4f747$var$Aj, $5ea73cfb65e4f747$var$Bj, $5ea73cfb65e4f747$var$Cj;
$5ea73cfb65e4f747$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$5ea73cfb65e4f747$var$Aj = function() {};
$5ea73cfb65e4f747$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $5ea73cfb65e4f747$var$xh($5ea73cfb65e4f747$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $5ea73cfb65e4f747$var$Ya(a, e);
                d = $5ea73cfb65e4f747$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $5ea73cfb65e4f747$var$A({}, e, {
                    value: void 0
                });
                d = $5ea73cfb65e4f747$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $5ea73cfb65e4f747$var$gb(a, e);
                d = $5ea73cfb65e4f747$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $5ea73cfb65e4f747$var$Bf);
        }
        $5ea73cfb65e4f747$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($5ea73cfb65e4f747$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($5ea73cfb65e4f747$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $5ea73cfb65e4f747$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$5ea73cfb65e4f747$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $5ea73cfb65e4f747$var$Dj(a, b) {
    if (!$5ea73cfb65e4f747$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $5ea73cfb65e4f747$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $5ea73cfb65e4f747$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $5ea73cfb65e4f747$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $5ea73cfb65e4f747$var$S(b), null;
        case 1:
            return $5ea73cfb65e4f747$var$Zf(b.type) && $5ea73cfb65e4f747$var$$f(), $5ea73cfb65e4f747$var$S(b), null;
        case 3:
            d = b.stateNode;
            $5ea73cfb65e4f747$var$zh();
            $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$Wf);
            $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$H);
            $5ea73cfb65e4f747$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $5ea73cfb65e4f747$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $5ea73cfb65e4f747$var$zg && ($5ea73cfb65e4f747$var$Fj($5ea73cfb65e4f747$var$zg), $5ea73cfb65e4f747$var$zg = null));
            $5ea73cfb65e4f747$var$Aj(a, b);
            $5ea73cfb65e4f747$var$S(b);
            return null;
        case 5:
            $5ea73cfb65e4f747$var$Bh(b);
            var e = $5ea73cfb65e4f747$var$xh($5ea73cfb65e4f747$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $5ea73cfb65e4f747$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($5ea73cfb65e4f747$var$p(166));
                    $5ea73cfb65e4f747$var$S(b);
                    return null;
                }
                a = $5ea73cfb65e4f747$var$xh($5ea73cfb65e4f747$var$uh.current);
                if ($5ea73cfb65e4f747$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$5ea73cfb65e4f747$var$Of] = b;
                    d[$5ea73cfb65e4f747$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $5ea73cfb65e4f747$var$D("cancel", d);
                            $5ea73cfb65e4f747$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $5ea73cfb65e4f747$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $5ea73cfb65e4f747$var$lf.length; e++)$5ea73cfb65e4f747$var$D($5ea73cfb65e4f747$var$lf[e], d);
                            break;
                        case "source":
                            $5ea73cfb65e4f747$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $5ea73cfb65e4f747$var$D("error", d);
                            $5ea73cfb65e4f747$var$D("load", d);
                            break;
                        case "details":
                            $5ea73cfb65e4f747$var$D("toggle", d);
                            break;
                        case "input":
                            $5ea73cfb65e4f747$var$Za(d, f);
                            $5ea73cfb65e4f747$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $5ea73cfb65e4f747$var$D("invalid", d);
                            break;
                        case "textarea":
                            $5ea73cfb65e4f747$var$hb(d, f), $5ea73cfb65e4f747$var$D("invalid", d);
                    }
                    $5ea73cfb65e4f747$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $5ea73cfb65e4f747$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $5ea73cfb65e4f747$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $5ea73cfb65e4f747$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $5ea73cfb65e4f747$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $5ea73cfb65e4f747$var$Va(d);
                            $5ea73cfb65e4f747$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $5ea73cfb65e4f747$var$Va(d);
                            $5ea73cfb65e4f747$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $5ea73cfb65e4f747$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $5ea73cfb65e4f747$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$5ea73cfb65e4f747$var$Of] = b;
                    a[$5ea73cfb65e4f747$var$Pf] = d;
                    $5ea73cfb65e4f747$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $5ea73cfb65e4f747$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $5ea73cfb65e4f747$var$D("cancel", a);
                                $5ea73cfb65e4f747$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $5ea73cfb65e4f747$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $5ea73cfb65e4f747$var$lf.length; e++)$5ea73cfb65e4f747$var$D($5ea73cfb65e4f747$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $5ea73cfb65e4f747$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $5ea73cfb65e4f747$var$D("error", a);
                                $5ea73cfb65e4f747$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $5ea73cfb65e4f747$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $5ea73cfb65e4f747$var$Za(a, d);
                                e = $5ea73cfb65e4f747$var$Ya(a, d);
                                $5ea73cfb65e4f747$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $5ea73cfb65e4f747$var$A({}, d, {
                                    value: void 0
                                });
                                $5ea73cfb65e4f747$var$D("invalid", a);
                                break;
                            case "textarea":
                                $5ea73cfb65e4f747$var$hb(a, d);
                                e = $5ea73cfb65e4f747$var$gb(a, d);
                                $5ea73cfb65e4f747$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $5ea73cfb65e4f747$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $5ea73cfb65e4f747$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $5ea73cfb65e4f747$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $5ea73cfb65e4f747$var$ob(a, k) : "number" === typeof k && $5ea73cfb65e4f747$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($5ea73cfb65e4f747$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $5ea73cfb65e4f747$var$D("scroll", a) : null != k && $5ea73cfb65e4f747$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $5ea73cfb65e4f747$var$Va(a);
                                $5ea73cfb65e4f747$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $5ea73cfb65e4f747$var$Va(a);
                                $5ea73cfb65e4f747$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $5ea73cfb65e4f747$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $5ea73cfb65e4f747$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $5ea73cfb65e4f747$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $5ea73cfb65e4f747$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $5ea73cfb65e4f747$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $5ea73cfb65e4f747$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($5ea73cfb65e4f747$var$p(166));
                c = $5ea73cfb65e4f747$var$xh($5ea73cfb65e4f747$var$wh.current);
                $5ea73cfb65e4f747$var$xh($5ea73cfb65e4f747$var$uh.current);
                if ($5ea73cfb65e4f747$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$5ea73cfb65e4f747$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $5ea73cfb65e4f747$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $5ea73cfb65e4f747$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $5ea73cfb65e4f747$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$5ea73cfb65e4f747$var$Of] = b, b.stateNode = d;
            }
            $5ea73cfb65e4f747$var$S(b);
            return null;
        case 13:
            $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($5ea73cfb65e4f747$var$I && null !== $5ea73cfb65e4f747$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $5ea73cfb65e4f747$var$Hg(), $5ea73cfb65e4f747$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $5ea73cfb65e4f747$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($5ea73cfb65e4f747$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($5ea73cfb65e4f747$var$p(317));
                        f[$5ea73cfb65e4f747$var$Of] = b;
                    } else $5ea73cfb65e4f747$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $5ea73cfb65e4f747$var$S(b);
                    f = !1;
                } else null !== $5ea73cfb65e4f747$var$zg && ($5ea73cfb65e4f747$var$Fj($5ea73cfb65e4f747$var$zg), $5ea73cfb65e4f747$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($5ea73cfb65e4f747$var$L.current & 1) ? 0 === $5ea73cfb65e4f747$var$T && ($5ea73cfb65e4f747$var$T = 3) : $5ea73cfb65e4f747$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $5ea73cfb65e4f747$var$S(b);
            return null;
        case 4:
            return $5ea73cfb65e4f747$var$zh(), $5ea73cfb65e4f747$var$Aj(a, b), null === a && $5ea73cfb65e4f747$var$sf(b.stateNode.containerInfo), $5ea73cfb65e4f747$var$S(b), null;
        case 10:
            return $5ea73cfb65e4f747$var$ah(b.type._context), $5ea73cfb65e4f747$var$S(b), null;
        case 17:
            return $5ea73cfb65e4f747$var$Zf(b.type) && $5ea73cfb65e4f747$var$$f(), $5ea73cfb65e4f747$var$S(b), null;
        case 19:
            $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$L);
            f = b.memoizedState;
            if (null === f) return $5ea73cfb65e4f747$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $5ea73cfb65e4f747$var$Dj(f, !1);
                else {
                    if (0 !== $5ea73cfb65e4f747$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $5ea73cfb65e4f747$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $5ea73cfb65e4f747$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$L, $5ea73cfb65e4f747$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $5ea73cfb65e4f747$var$B() > $5ea73cfb65e4f747$var$Gj && (b.flags |= 128, d = !0, $5ea73cfb65e4f747$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $5ea73cfb65e4f747$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $5ea73cfb65e4f747$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$5ea73cfb65e4f747$var$I) return $5ea73cfb65e4f747$var$S(b), null;
                    } else 2 * $5ea73cfb65e4f747$var$B() - f.renderingStartTime > $5ea73cfb65e4f747$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $5ea73cfb65e4f747$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $5ea73cfb65e4f747$var$B(), b.sibling = null, c = $5ea73cfb65e4f747$var$L.current, $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$L, d ? c & 1 | 2 : c & 1), b;
            $5ea73cfb65e4f747$var$S(b);
            return null;
        case 22:
        case 23:
            return $5ea73cfb65e4f747$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($5ea73cfb65e4f747$var$fj & 1073741824) && ($5ea73cfb65e4f747$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $5ea73cfb65e4f747$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($5ea73cfb65e4f747$var$p(156, b.tag));
}
function $5ea73cfb65e4f747$var$Ij(a, b) {
    $5ea73cfb65e4f747$var$wg(b);
    switch(b.tag){
        case 1:
            return $5ea73cfb65e4f747$var$Zf(b.type) && $5ea73cfb65e4f747$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $5ea73cfb65e4f747$var$zh(), $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$Wf), $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$H), $5ea73cfb65e4f747$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $5ea73cfb65e4f747$var$Bh(b), null;
        case 13:
            $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($5ea73cfb65e4f747$var$p(340));
                $5ea73cfb65e4f747$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$L), null;
        case 4:
            return $5ea73cfb65e4f747$var$zh(), null;
        case 10:
            return $5ea73cfb65e4f747$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $5ea73cfb65e4f747$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $5ea73cfb65e4f747$var$Jj = !1, $5ea73cfb65e4f747$var$U = !1, $5ea73cfb65e4f747$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $5ea73cfb65e4f747$var$V = null;
function $5ea73cfb65e4f747$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $5ea73cfb65e4f747$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $5ea73cfb65e4f747$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $5ea73cfb65e4f747$var$W(a, b, d);
    }
}
var $5ea73cfb65e4f747$var$Nj = !1;
function $5ea73cfb65e4f747$var$Oj(a, b) {
    $5ea73cfb65e4f747$var$Cf = $5ea73cfb65e4f747$var$dd;
    a = $5ea73cfb65e4f747$var$Me();
    if ($5ea73cfb65e4f747$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $5ea73cfb65e4f747$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $5ea73cfb65e4f747$var$dd = !1;
    for($5ea73cfb65e4f747$var$V = b; null !== $5ea73cfb65e4f747$var$V;)if (b = $5ea73cfb65e4f747$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $5ea73cfb65e4f747$var$V = a;
    else for(; null !== $5ea73cfb65e4f747$var$V;){
        b = $5ea73cfb65e4f747$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $5ea73cfb65e4f747$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($5ea73cfb65e4f747$var$p(163));
            }
        } catch (F) {
            $5ea73cfb65e4f747$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $5ea73cfb65e4f747$var$V = a;
            break;
        }
        $5ea73cfb65e4f747$var$V = b.return;
    }
    n = $5ea73cfb65e4f747$var$Nj;
    $5ea73cfb65e4f747$var$Nj = !1;
    return n;
}
function $5ea73cfb65e4f747$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $5ea73cfb65e4f747$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $5ea73cfb65e4f747$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $5ea73cfb65e4f747$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $5ea73cfb65e4f747$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $5ea73cfb65e4f747$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$5ea73cfb65e4f747$var$Of], delete b[$5ea73cfb65e4f747$var$Pf], delete b[$5ea73cfb65e4f747$var$of], delete b[$5ea73cfb65e4f747$var$Qf], delete b[$5ea73cfb65e4f747$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $5ea73cfb65e4f747$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $5ea73cfb65e4f747$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $5ea73cfb65e4f747$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $5ea73cfb65e4f747$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $5ea73cfb65e4f747$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($5ea73cfb65e4f747$var$Vj(a, b, c), a = a.sibling; null !== a;)$5ea73cfb65e4f747$var$Vj(a, b, c), a = a.sibling;
}
function $5ea73cfb65e4f747$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($5ea73cfb65e4f747$var$Wj(a, b, c), a = a.sibling; null !== a;)$5ea73cfb65e4f747$var$Wj(a, b, c), a = a.sibling;
}
var $5ea73cfb65e4f747$var$X = null, $5ea73cfb65e4f747$var$Xj = !1;
function $5ea73cfb65e4f747$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$5ea73cfb65e4f747$var$Zj(a, b, c), c = c.sibling;
}
function $5ea73cfb65e4f747$var$Zj(a, b, c) {
    if ($5ea73cfb65e4f747$var$lc && "function" === typeof $5ea73cfb65e4f747$var$lc.onCommitFiberUnmount) try {
        $5ea73cfb65e4f747$var$lc.onCommitFiberUnmount($5ea73cfb65e4f747$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $5ea73cfb65e4f747$var$U || $5ea73cfb65e4f747$var$Lj(c, b);
        case 6:
            var d = $5ea73cfb65e4f747$var$X, e = $5ea73cfb65e4f747$var$Xj;
            $5ea73cfb65e4f747$var$X = null;
            $5ea73cfb65e4f747$var$Yj(a, b, c);
            $5ea73cfb65e4f747$var$X = d;
            $5ea73cfb65e4f747$var$Xj = e;
            null !== $5ea73cfb65e4f747$var$X && ($5ea73cfb65e4f747$var$Xj ? (a = $5ea73cfb65e4f747$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $5ea73cfb65e4f747$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $5ea73cfb65e4f747$var$X && ($5ea73cfb65e4f747$var$Xj ? (a = $5ea73cfb65e4f747$var$X, c = c.stateNode, 8 === a.nodeType ? $5ea73cfb65e4f747$var$Kf(a.parentNode, c) : 1 === a.nodeType && $5ea73cfb65e4f747$var$Kf(a, c), $5ea73cfb65e4f747$var$bd(a)) : $5ea73cfb65e4f747$var$Kf($5ea73cfb65e4f747$var$X, c.stateNode));
            break;
        case 4:
            d = $5ea73cfb65e4f747$var$X;
            e = $5ea73cfb65e4f747$var$Xj;
            $5ea73cfb65e4f747$var$X = c.stateNode.containerInfo;
            $5ea73cfb65e4f747$var$Xj = !0;
            $5ea73cfb65e4f747$var$Yj(a, b, c);
            $5ea73cfb65e4f747$var$X = d;
            $5ea73cfb65e4f747$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$5ea73cfb65e4f747$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $5ea73cfb65e4f747$var$Mj(c, b, g) : 0 !== (f & 4) && $5ea73cfb65e4f747$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $5ea73cfb65e4f747$var$Yj(a, b, c);
            break;
        case 1:
            if (!$5ea73cfb65e4f747$var$U && ($5ea73cfb65e4f747$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $5ea73cfb65e4f747$var$W(c, b, h);
            }
            $5ea73cfb65e4f747$var$Yj(a, b, c);
            break;
        case 21:
            $5ea73cfb65e4f747$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($5ea73cfb65e4f747$var$U = (d = $5ea73cfb65e4f747$var$U) || null !== c.memoizedState, $5ea73cfb65e4f747$var$Yj(a, b, c), $5ea73cfb65e4f747$var$U = d) : $5ea73cfb65e4f747$var$Yj(a, b, c);
            break;
        default:
            $5ea73cfb65e4f747$var$Yj(a, b, c);
    }
}
function $5ea73cfb65e4f747$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $5ea73cfb65e4f747$var$Kj);
        b.forEach(function(b) {
            var d = $5ea73cfb65e4f747$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $5ea73cfb65e4f747$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $5ea73cfb65e4f747$var$X = h.stateNode;
                        $5ea73cfb65e4f747$var$Xj = !1;
                        break a;
                    case 3:
                        $5ea73cfb65e4f747$var$X = h.stateNode.containerInfo;
                        $5ea73cfb65e4f747$var$Xj = !0;
                        break a;
                    case 4:
                        $5ea73cfb65e4f747$var$X = h.stateNode.containerInfo;
                        $5ea73cfb65e4f747$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $5ea73cfb65e4f747$var$X) throw Error($5ea73cfb65e4f747$var$p(160));
            $5ea73cfb65e4f747$var$Zj(f, g, e);
            $5ea73cfb65e4f747$var$X = null;
            $5ea73cfb65e4f747$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $5ea73cfb65e4f747$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$5ea73cfb65e4f747$var$dk(b, a), b = b.sibling;
}
function $5ea73cfb65e4f747$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $5ea73cfb65e4f747$var$ck(b, a);
            $5ea73cfb65e4f747$var$ek(a);
            if (d & 4) {
                try {
                    $5ea73cfb65e4f747$var$Pj(3, a, a.return), $5ea73cfb65e4f747$var$Qj(3, a);
                } catch (t) {
                    $5ea73cfb65e4f747$var$W(a, a.return, t);
                }
                try {
                    $5ea73cfb65e4f747$var$Pj(5, a, a.return);
                } catch (t) {
                    $5ea73cfb65e4f747$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $5ea73cfb65e4f747$var$ck(b, a);
            $5ea73cfb65e4f747$var$ek(a);
            d & 512 && null !== c && $5ea73cfb65e4f747$var$Lj(c, c.return);
            break;
        case 5:
            $5ea73cfb65e4f747$var$ck(b, a);
            $5ea73cfb65e4f747$var$ek(a);
            d & 512 && null !== c && $5ea73cfb65e4f747$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $5ea73cfb65e4f747$var$ob(e, "");
                } catch (t) {
                    $5ea73cfb65e4f747$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $5ea73cfb65e4f747$var$ab(e, f);
                    $5ea73cfb65e4f747$var$vb(h, g);
                    var l = $5ea73cfb65e4f747$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $5ea73cfb65e4f747$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $5ea73cfb65e4f747$var$nb(e, q) : "children" === m ? $5ea73cfb65e4f747$var$ob(e, q) : $5ea73cfb65e4f747$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $5ea73cfb65e4f747$var$bb(e, f);
                            break;
                        case "textarea":
                            $5ea73cfb65e4f747$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $5ea73cfb65e4f747$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $5ea73cfb65e4f747$var$fb(e, !!f.multiple, f.defaultValue, !0) : $5ea73cfb65e4f747$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$5ea73cfb65e4f747$var$Pf] = f;
                } catch (t) {
                    $5ea73cfb65e4f747$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $5ea73cfb65e4f747$var$ck(b, a);
            $5ea73cfb65e4f747$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($5ea73cfb65e4f747$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $5ea73cfb65e4f747$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $5ea73cfb65e4f747$var$ck(b, a);
            $5ea73cfb65e4f747$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $5ea73cfb65e4f747$var$bd(b.containerInfo);
            } catch (t) {
                $5ea73cfb65e4f747$var$W(a, a.return, t);
            }
            break;
        case 4:
            $5ea73cfb65e4f747$var$ck(b, a);
            $5ea73cfb65e4f747$var$ek(a);
            break;
        case 13:
            $5ea73cfb65e4f747$var$ck(b, a);
            $5ea73cfb65e4f747$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($5ea73cfb65e4f747$var$fk = $5ea73cfb65e4f747$var$B()));
            d & 4 && $5ea73cfb65e4f747$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($5ea73cfb65e4f747$var$U = (l = $5ea73cfb65e4f747$var$U) || m, $5ea73cfb65e4f747$var$ck(b, a), $5ea73cfb65e4f747$var$U = l) : $5ea73cfb65e4f747$var$ck(b, a);
            $5ea73cfb65e4f747$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($5ea73cfb65e4f747$var$V = a, m = a.child; null !== m;){
                    for(q = $5ea73cfb65e4f747$var$V = m; null !== $5ea73cfb65e4f747$var$V;){
                        r = $5ea73cfb65e4f747$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $5ea73cfb65e4f747$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $5ea73cfb65e4f747$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $5ea73cfb65e4f747$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $5ea73cfb65e4f747$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $5ea73cfb65e4f747$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $5ea73cfb65e4f747$var$V = y) : $5ea73cfb65e4f747$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $5ea73cfb65e4f747$var$rb("display", g));
                            } catch (t) {
                                $5ea73cfb65e4f747$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $5ea73cfb65e4f747$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $5ea73cfb65e4f747$var$ck(b, a);
            $5ea73cfb65e4f747$var$ek(a);
            d & 4 && $5ea73cfb65e4f747$var$ak(a);
            break;
        case 21:
            break;
        default:
            $5ea73cfb65e4f747$var$ck(b, a), $5ea73cfb65e4f747$var$ek(a);
    }
}
function $5ea73cfb65e4f747$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($5ea73cfb65e4f747$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($5ea73cfb65e4f747$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($5ea73cfb65e4f747$var$ob(e, ""), d.flags &= -33);
                    var f = $5ea73cfb65e4f747$var$Uj(a);
                    $5ea73cfb65e4f747$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $5ea73cfb65e4f747$var$Uj(a);
                    $5ea73cfb65e4f747$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($5ea73cfb65e4f747$var$p(161));
            }
        } catch (k) {
            $5ea73cfb65e4f747$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $5ea73cfb65e4f747$var$hk(a, b, c) {
    $5ea73cfb65e4f747$var$V = a;
    $5ea73cfb65e4f747$var$ik(a, b, c);
}
function $5ea73cfb65e4f747$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $5ea73cfb65e4f747$var$V;){
        var e = $5ea73cfb65e4f747$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $5ea73cfb65e4f747$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $5ea73cfb65e4f747$var$U;
                h = $5ea73cfb65e4f747$var$Jj;
                var l = $5ea73cfb65e4f747$var$U;
                $5ea73cfb65e4f747$var$Jj = g;
                if (($5ea73cfb65e4f747$var$U = k) && !l) for($5ea73cfb65e4f747$var$V = e; null !== $5ea73cfb65e4f747$var$V;)g = $5ea73cfb65e4f747$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $5ea73cfb65e4f747$var$jk(e) : null !== k ? (k.return = g, $5ea73cfb65e4f747$var$V = k) : $5ea73cfb65e4f747$var$jk(e);
                for(; null !== f;)$5ea73cfb65e4f747$var$V = f, $5ea73cfb65e4f747$var$ik(f, b, c), f = f.sibling;
                $5ea73cfb65e4f747$var$V = e;
                $5ea73cfb65e4f747$var$Jj = h;
                $5ea73cfb65e4f747$var$U = l;
            }
            $5ea73cfb65e4f747$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $5ea73cfb65e4f747$var$V = f) : $5ea73cfb65e4f747$var$kk(a, b, c);
    }
}
function $5ea73cfb65e4f747$var$kk(a) {
    for(; null !== $5ea73cfb65e4f747$var$V;){
        var b = $5ea73cfb65e4f747$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $5ea73cfb65e4f747$var$U || $5ea73cfb65e4f747$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$5ea73cfb65e4f747$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $5ea73cfb65e4f747$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $5ea73cfb65e4f747$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $5ea73cfb65e4f747$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $5ea73cfb65e4f747$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($5ea73cfb65e4f747$var$p(163));
                }
                $5ea73cfb65e4f747$var$U || b.flags & 512 && $5ea73cfb65e4f747$var$Rj(b);
            } catch (r) {
                $5ea73cfb65e4f747$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $5ea73cfb65e4f747$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $5ea73cfb65e4f747$var$V = c;
            break;
        }
        $5ea73cfb65e4f747$var$V = b.return;
    }
}
function $5ea73cfb65e4f747$var$gk(a) {
    for(; null !== $5ea73cfb65e4f747$var$V;){
        var b = $5ea73cfb65e4f747$var$V;
        if (b === a) {
            $5ea73cfb65e4f747$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $5ea73cfb65e4f747$var$V = c;
            break;
        }
        $5ea73cfb65e4f747$var$V = b.return;
    }
}
function $5ea73cfb65e4f747$var$jk(a) {
    for(; null !== $5ea73cfb65e4f747$var$V;){
        var b = $5ea73cfb65e4f747$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $5ea73cfb65e4f747$var$Qj(4, b);
                    } catch (k) {
                        $5ea73cfb65e4f747$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $5ea73cfb65e4f747$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $5ea73cfb65e4f747$var$Rj(b);
                    } catch (k) {
                        $5ea73cfb65e4f747$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $5ea73cfb65e4f747$var$Rj(b);
                    } catch (k) {
                        $5ea73cfb65e4f747$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $5ea73cfb65e4f747$var$W(b, b.return, k);
        }
        if (b === a) {
            $5ea73cfb65e4f747$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $5ea73cfb65e4f747$var$V = h;
            break;
        }
        $5ea73cfb65e4f747$var$V = b.return;
    }
}
var $5ea73cfb65e4f747$var$lk = Math.ceil, $5ea73cfb65e4f747$var$mk = $5ea73cfb65e4f747$var$ua.ReactCurrentDispatcher, $5ea73cfb65e4f747$var$nk = $5ea73cfb65e4f747$var$ua.ReactCurrentOwner, $5ea73cfb65e4f747$var$ok = $5ea73cfb65e4f747$var$ua.ReactCurrentBatchConfig, $5ea73cfb65e4f747$var$K = 0, $5ea73cfb65e4f747$var$Q = null, $5ea73cfb65e4f747$var$Y = null, $5ea73cfb65e4f747$var$Z = 0, $5ea73cfb65e4f747$var$fj = 0, $5ea73cfb65e4f747$var$ej = $5ea73cfb65e4f747$var$Uf(0), $5ea73cfb65e4f747$var$T = 0, $5ea73cfb65e4f747$var$pk = null, $5ea73cfb65e4f747$var$rh = 0, $5ea73cfb65e4f747$var$qk = 0, $5ea73cfb65e4f747$var$rk = 0, $5ea73cfb65e4f747$var$sk = null, $5ea73cfb65e4f747$var$tk = null, $5ea73cfb65e4f747$var$fk = 0, $5ea73cfb65e4f747$var$Gj = Infinity, $5ea73cfb65e4f747$var$uk = null, $5ea73cfb65e4f747$var$Oi = !1, $5ea73cfb65e4f747$var$Pi = null, $5ea73cfb65e4f747$var$Ri = null, $5ea73cfb65e4f747$var$vk = !1, $5ea73cfb65e4f747$var$wk = null, $5ea73cfb65e4f747$var$xk = 0, $5ea73cfb65e4f747$var$yk = 0, $5ea73cfb65e4f747$var$zk = null, $5ea73cfb65e4f747$var$Ak = -1, $5ea73cfb65e4f747$var$Bk = 0;
function $5ea73cfb65e4f747$var$R() {
    return 0 !== ($5ea73cfb65e4f747$var$K & 6) ? $5ea73cfb65e4f747$var$B() : -1 !== $5ea73cfb65e4f747$var$Ak ? $5ea73cfb65e4f747$var$Ak : $5ea73cfb65e4f747$var$Ak = $5ea73cfb65e4f747$var$B();
}
function $5ea73cfb65e4f747$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($5ea73cfb65e4f747$var$K & 2) && 0 !== $5ea73cfb65e4f747$var$Z) return $5ea73cfb65e4f747$var$Z & -$5ea73cfb65e4f747$var$Z;
    if (null !== $5ea73cfb65e4f747$var$Kg.transition) return 0 === $5ea73cfb65e4f747$var$Bk && ($5ea73cfb65e4f747$var$Bk = $5ea73cfb65e4f747$var$yc()), $5ea73cfb65e4f747$var$Bk;
    a = $5ea73cfb65e4f747$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $5ea73cfb65e4f747$var$jd(a.type);
    return a;
}
function $5ea73cfb65e4f747$var$gi(a, b, c, d) {
    if (50 < $5ea73cfb65e4f747$var$yk) throw $5ea73cfb65e4f747$var$yk = 0, $5ea73cfb65e4f747$var$zk = null, Error($5ea73cfb65e4f747$var$p(185));
    $5ea73cfb65e4f747$var$Ac(a, c, d);
    if (0 === ($5ea73cfb65e4f747$var$K & 2) || a !== $5ea73cfb65e4f747$var$Q) a === $5ea73cfb65e4f747$var$Q && (0 === ($5ea73cfb65e4f747$var$K & 2) && ($5ea73cfb65e4f747$var$qk |= c), 4 === $5ea73cfb65e4f747$var$T && $5ea73cfb65e4f747$var$Ck(a, $5ea73cfb65e4f747$var$Z)), $5ea73cfb65e4f747$var$Dk(a, d), 1 === c && 0 === $5ea73cfb65e4f747$var$K && 0 === (b.mode & 1) && ($5ea73cfb65e4f747$var$Gj = $5ea73cfb65e4f747$var$B() + 500, $5ea73cfb65e4f747$var$fg && $5ea73cfb65e4f747$var$jg());
}
function $5ea73cfb65e4f747$var$Dk(a, b) {
    var c = a.callbackNode;
    $5ea73cfb65e4f747$var$wc(a, b);
    var d = $5ea73cfb65e4f747$var$uc(a, a === $5ea73cfb65e4f747$var$Q ? $5ea73cfb65e4f747$var$Z : 0);
    if (0 === d) null !== c && $5ea73cfb65e4f747$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $5ea73cfb65e4f747$var$bc(c);
        if (1 === b) 0 === a.tag ? $5ea73cfb65e4f747$var$ig($5ea73cfb65e4f747$var$Ek.bind(null, a)) : $5ea73cfb65e4f747$var$hg($5ea73cfb65e4f747$var$Ek.bind(null, a)), $5ea73cfb65e4f747$var$Jf(function() {
            0 === ($5ea73cfb65e4f747$var$K & 6) && $5ea73cfb65e4f747$var$jg();
        }), c = null;
        else {
            switch($5ea73cfb65e4f747$var$Dc(d)){
                case 1:
                    c = $5ea73cfb65e4f747$var$fc;
                    break;
                case 4:
                    c = $5ea73cfb65e4f747$var$gc;
                    break;
                case 16:
                    c = $5ea73cfb65e4f747$var$hc;
                    break;
                case 536870912:
                    c = $5ea73cfb65e4f747$var$jc;
                    break;
                default:
                    c = $5ea73cfb65e4f747$var$hc;
            }
            c = $5ea73cfb65e4f747$var$Fk(c, $5ea73cfb65e4f747$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $5ea73cfb65e4f747$var$Gk(a, b) {
    $5ea73cfb65e4f747$var$Ak = -1;
    $5ea73cfb65e4f747$var$Bk = 0;
    if (0 !== ($5ea73cfb65e4f747$var$K & 6)) throw Error($5ea73cfb65e4f747$var$p(327));
    var c = a.callbackNode;
    if ($5ea73cfb65e4f747$var$Hk() && a.callbackNode !== c) return null;
    var d = $5ea73cfb65e4f747$var$uc(a, a === $5ea73cfb65e4f747$var$Q ? $5ea73cfb65e4f747$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $5ea73cfb65e4f747$var$Ik(a, d);
    else {
        b = d;
        var e = $5ea73cfb65e4f747$var$K;
        $5ea73cfb65e4f747$var$K |= 2;
        var f = $5ea73cfb65e4f747$var$Jk();
        if ($5ea73cfb65e4f747$var$Q !== a || $5ea73cfb65e4f747$var$Z !== b) $5ea73cfb65e4f747$var$uk = null, $5ea73cfb65e4f747$var$Gj = $5ea73cfb65e4f747$var$B() + 500, $5ea73cfb65e4f747$var$Kk(a, b);
        for(;;)try {
            $5ea73cfb65e4f747$var$Lk();
            break;
        } catch (h) {
            $5ea73cfb65e4f747$var$Mk(a, h);
        }
        $5ea73cfb65e4f747$var$$g();
        $5ea73cfb65e4f747$var$mk.current = f;
        $5ea73cfb65e4f747$var$K = e;
        null !== $5ea73cfb65e4f747$var$Y ? b = 0 : ($5ea73cfb65e4f747$var$Q = null, $5ea73cfb65e4f747$var$Z = 0, b = $5ea73cfb65e4f747$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $5ea73cfb65e4f747$var$xc(a), 0 !== e && (d = e, b = $5ea73cfb65e4f747$var$Nk(a, e)));
        if (1 === b) throw c = $5ea73cfb65e4f747$var$pk, $5ea73cfb65e4f747$var$Kk(a, 0), $5ea73cfb65e4f747$var$Ck(a, d), $5ea73cfb65e4f747$var$Dk(a, $5ea73cfb65e4f747$var$B()), c;
        if (6 === b) $5ea73cfb65e4f747$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$5ea73cfb65e4f747$var$Ok(e) && (b = $5ea73cfb65e4f747$var$Ik(a, d), 2 === b && (f = $5ea73cfb65e4f747$var$xc(a), 0 !== f && (d = f, b = $5ea73cfb65e4f747$var$Nk(a, f))), 1 === b)) throw c = $5ea73cfb65e4f747$var$pk, $5ea73cfb65e4f747$var$Kk(a, 0), $5ea73cfb65e4f747$var$Ck(a, d), $5ea73cfb65e4f747$var$Dk(a, $5ea73cfb65e4f747$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($5ea73cfb65e4f747$var$p(345));
                case 2:
                    $5ea73cfb65e4f747$var$Pk(a, $5ea73cfb65e4f747$var$tk, $5ea73cfb65e4f747$var$uk);
                    break;
                case 3:
                    $5ea73cfb65e4f747$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $5ea73cfb65e4f747$var$fk + 500 - $5ea73cfb65e4f747$var$B(), 10 < b)) {
                        if (0 !== $5ea73cfb65e4f747$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $5ea73cfb65e4f747$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $5ea73cfb65e4f747$var$Ff($5ea73cfb65e4f747$var$Pk.bind(null, a, $5ea73cfb65e4f747$var$tk, $5ea73cfb65e4f747$var$uk), b);
                        break;
                    }
                    $5ea73cfb65e4f747$var$Pk(a, $5ea73cfb65e4f747$var$tk, $5ea73cfb65e4f747$var$uk);
                    break;
                case 4:
                    $5ea73cfb65e4f747$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $5ea73cfb65e4f747$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $5ea73cfb65e4f747$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $5ea73cfb65e4f747$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $5ea73cfb65e4f747$var$Ff($5ea73cfb65e4f747$var$Pk.bind(null, a, $5ea73cfb65e4f747$var$tk, $5ea73cfb65e4f747$var$uk), d);
                        break;
                    }
                    $5ea73cfb65e4f747$var$Pk(a, $5ea73cfb65e4f747$var$tk, $5ea73cfb65e4f747$var$uk);
                    break;
                case 5:
                    $5ea73cfb65e4f747$var$Pk(a, $5ea73cfb65e4f747$var$tk, $5ea73cfb65e4f747$var$uk);
                    break;
                default:
                    throw Error($5ea73cfb65e4f747$var$p(329));
            }
        }
    }
    $5ea73cfb65e4f747$var$Dk(a, $5ea73cfb65e4f747$var$B());
    return a.callbackNode === c ? $5ea73cfb65e4f747$var$Gk.bind(null, a) : null;
}
function $5ea73cfb65e4f747$var$Nk(a, b) {
    var c = $5ea73cfb65e4f747$var$sk;
    a.current.memoizedState.isDehydrated && ($5ea73cfb65e4f747$var$Kk(a, b).flags |= 256);
    a = $5ea73cfb65e4f747$var$Ik(a, b);
    2 !== a && (b = $5ea73cfb65e4f747$var$tk, $5ea73cfb65e4f747$var$tk = c, null !== b && $5ea73cfb65e4f747$var$Fj(b));
    return a;
}
function $5ea73cfb65e4f747$var$Fj(a) {
    null === $5ea73cfb65e4f747$var$tk ? $5ea73cfb65e4f747$var$tk = a : $5ea73cfb65e4f747$var$tk.push.apply($5ea73cfb65e4f747$var$tk, a);
}
function $5ea73cfb65e4f747$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$5ea73cfb65e4f747$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $5ea73cfb65e4f747$var$Ck(a, b) {
    b &= ~$5ea73cfb65e4f747$var$rk;
    b &= ~$5ea73cfb65e4f747$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $5ea73cfb65e4f747$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $5ea73cfb65e4f747$var$Ek(a) {
    if (0 !== ($5ea73cfb65e4f747$var$K & 6)) throw Error($5ea73cfb65e4f747$var$p(327));
    $5ea73cfb65e4f747$var$Hk();
    var b = $5ea73cfb65e4f747$var$uc(a, 0);
    if (0 === (b & 1)) return $5ea73cfb65e4f747$var$Dk(a, $5ea73cfb65e4f747$var$B()), null;
    var c = $5ea73cfb65e4f747$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $5ea73cfb65e4f747$var$xc(a);
        0 !== d && (b = d, c = $5ea73cfb65e4f747$var$Nk(a, d));
    }
    if (1 === c) throw c = $5ea73cfb65e4f747$var$pk, $5ea73cfb65e4f747$var$Kk(a, 0), $5ea73cfb65e4f747$var$Ck(a, b), $5ea73cfb65e4f747$var$Dk(a, $5ea73cfb65e4f747$var$B()), c;
    if (6 === c) throw Error($5ea73cfb65e4f747$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $5ea73cfb65e4f747$var$Pk(a, $5ea73cfb65e4f747$var$tk, $5ea73cfb65e4f747$var$uk);
    $5ea73cfb65e4f747$var$Dk(a, $5ea73cfb65e4f747$var$B());
    return null;
}
function $5ea73cfb65e4f747$var$Qk(a, b) {
    var c = $5ea73cfb65e4f747$var$K;
    $5ea73cfb65e4f747$var$K |= 1;
    try {
        return a(b);
    } finally{
        $5ea73cfb65e4f747$var$K = c, 0 === $5ea73cfb65e4f747$var$K && ($5ea73cfb65e4f747$var$Gj = $5ea73cfb65e4f747$var$B() + 500, $5ea73cfb65e4f747$var$fg && $5ea73cfb65e4f747$var$jg());
    }
}
function $5ea73cfb65e4f747$var$Rk(a) {
    null !== $5ea73cfb65e4f747$var$wk && 0 === $5ea73cfb65e4f747$var$wk.tag && 0 === ($5ea73cfb65e4f747$var$K & 6) && $5ea73cfb65e4f747$var$Hk();
    var b = $5ea73cfb65e4f747$var$K;
    $5ea73cfb65e4f747$var$K |= 1;
    var c = $5ea73cfb65e4f747$var$ok.transition, d = $5ea73cfb65e4f747$var$C;
    try {
        if ($5ea73cfb65e4f747$var$ok.transition = null, $5ea73cfb65e4f747$var$C = 1, a) return a();
    } finally{
        $5ea73cfb65e4f747$var$C = d, $5ea73cfb65e4f747$var$ok.transition = c, $5ea73cfb65e4f747$var$K = b, 0 === ($5ea73cfb65e4f747$var$K & 6) && $5ea73cfb65e4f747$var$jg();
    }
}
function $5ea73cfb65e4f747$var$Hj() {
    $5ea73cfb65e4f747$var$fj = $5ea73cfb65e4f747$var$ej.current;
    $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$ej);
}
function $5ea73cfb65e4f747$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $5ea73cfb65e4f747$var$Gf(c));
    if (null !== $5ea73cfb65e4f747$var$Y) for(c = $5ea73cfb65e4f747$var$Y.return; null !== c;){
        var d = c;
        $5ea73cfb65e4f747$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $5ea73cfb65e4f747$var$$f();
                break;
            case 3:
                $5ea73cfb65e4f747$var$zh();
                $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$Wf);
                $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$H);
                $5ea73cfb65e4f747$var$Eh();
                break;
            case 5:
                $5ea73cfb65e4f747$var$Bh(d);
                break;
            case 4:
                $5ea73cfb65e4f747$var$zh();
                break;
            case 13:
                $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$L);
                break;
            case 19:
                $5ea73cfb65e4f747$var$E($5ea73cfb65e4f747$var$L);
                break;
            case 10:
                $5ea73cfb65e4f747$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $5ea73cfb65e4f747$var$Hj();
        }
        c = c.return;
    }
    $5ea73cfb65e4f747$var$Q = a;
    $5ea73cfb65e4f747$var$Y = a = $5ea73cfb65e4f747$var$Pg(a.current, null);
    $5ea73cfb65e4f747$var$Z = $5ea73cfb65e4f747$var$fj = b;
    $5ea73cfb65e4f747$var$T = 0;
    $5ea73cfb65e4f747$var$pk = null;
    $5ea73cfb65e4f747$var$rk = $5ea73cfb65e4f747$var$qk = $5ea73cfb65e4f747$var$rh = 0;
    $5ea73cfb65e4f747$var$tk = $5ea73cfb65e4f747$var$sk = null;
    if (null !== $5ea73cfb65e4f747$var$fh) {
        for(b = 0; b < $5ea73cfb65e4f747$var$fh.length; b++)if (c = $5ea73cfb65e4f747$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $5ea73cfb65e4f747$var$fh = null;
    }
    return a;
}
function $5ea73cfb65e4f747$var$Mk(a, b) {
    do {
        var c = $5ea73cfb65e4f747$var$Y;
        try {
            $5ea73cfb65e4f747$var$$g();
            $5ea73cfb65e4f747$var$Fh.current = $5ea73cfb65e4f747$var$Rh;
            if ($5ea73cfb65e4f747$var$Ih) {
                for(var d = $5ea73cfb65e4f747$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $5ea73cfb65e4f747$var$Ih = !1;
            }
            $5ea73cfb65e4f747$var$Hh = 0;
            $5ea73cfb65e4f747$var$O = $5ea73cfb65e4f747$var$N = $5ea73cfb65e4f747$var$M = null;
            $5ea73cfb65e4f747$var$Jh = !1;
            $5ea73cfb65e4f747$var$Kh = 0;
            $5ea73cfb65e4f747$var$nk.current = null;
            if (null === c || null === c.return) {
                $5ea73cfb65e4f747$var$T = 1;
                $5ea73cfb65e4f747$var$pk = b;
                $5ea73cfb65e4f747$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $5ea73cfb65e4f747$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $5ea73cfb65e4f747$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $5ea73cfb65e4f747$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $5ea73cfb65e4f747$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $5ea73cfb65e4f747$var$Si(f, l, b);
                            $5ea73cfb65e4f747$var$tj();
                            break a;
                        }
                        k = Error($5ea73cfb65e4f747$var$p(426));
                    }
                } else if ($5ea73cfb65e4f747$var$I && h.mode & 1) {
                    var J = $5ea73cfb65e4f747$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $5ea73cfb65e4f747$var$Vi(J, g, h, f, b);
                        $5ea73cfb65e4f747$var$Jg($5ea73cfb65e4f747$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $5ea73cfb65e4f747$var$Ji(k, h);
                4 !== $5ea73cfb65e4f747$var$T && ($5ea73cfb65e4f747$var$T = 2);
                null === $5ea73cfb65e4f747$var$sk ? $5ea73cfb65e4f747$var$sk = [
                    f
                ] : $5ea73cfb65e4f747$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $5ea73cfb65e4f747$var$Ni(f, k, b);
                            $5ea73cfb65e4f747$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $5ea73cfb65e4f747$var$Ri || !$5ea73cfb65e4f747$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $5ea73cfb65e4f747$var$Qi(f, h, b);
                                $5ea73cfb65e4f747$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $5ea73cfb65e4f747$var$Sk(c);
        } catch (na) {
            b = na;
            $5ea73cfb65e4f747$var$Y === c && null !== c && ($5ea73cfb65e4f747$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $5ea73cfb65e4f747$var$Jk() {
    var a = $5ea73cfb65e4f747$var$mk.current;
    $5ea73cfb65e4f747$var$mk.current = $5ea73cfb65e4f747$var$Rh;
    return null === a ? $5ea73cfb65e4f747$var$Rh : a;
}
function $5ea73cfb65e4f747$var$tj() {
    if (0 === $5ea73cfb65e4f747$var$T || 3 === $5ea73cfb65e4f747$var$T || 2 === $5ea73cfb65e4f747$var$T) $5ea73cfb65e4f747$var$T = 4;
    null === $5ea73cfb65e4f747$var$Q || 0 === ($5ea73cfb65e4f747$var$rh & 268435455) && 0 === ($5ea73cfb65e4f747$var$qk & 268435455) || $5ea73cfb65e4f747$var$Ck($5ea73cfb65e4f747$var$Q, $5ea73cfb65e4f747$var$Z);
}
function $5ea73cfb65e4f747$var$Ik(a, b) {
    var c = $5ea73cfb65e4f747$var$K;
    $5ea73cfb65e4f747$var$K |= 2;
    var d = $5ea73cfb65e4f747$var$Jk();
    if ($5ea73cfb65e4f747$var$Q !== a || $5ea73cfb65e4f747$var$Z !== b) $5ea73cfb65e4f747$var$uk = null, $5ea73cfb65e4f747$var$Kk(a, b);
    for(;;)try {
        $5ea73cfb65e4f747$var$Tk();
        break;
    } catch (e) {
        $5ea73cfb65e4f747$var$Mk(a, e);
    }
    $5ea73cfb65e4f747$var$$g();
    $5ea73cfb65e4f747$var$K = c;
    $5ea73cfb65e4f747$var$mk.current = d;
    if (null !== $5ea73cfb65e4f747$var$Y) throw Error($5ea73cfb65e4f747$var$p(261));
    $5ea73cfb65e4f747$var$Q = null;
    $5ea73cfb65e4f747$var$Z = 0;
    return $5ea73cfb65e4f747$var$T;
}
function $5ea73cfb65e4f747$var$Tk() {
    for(; null !== $5ea73cfb65e4f747$var$Y;)$5ea73cfb65e4f747$var$Uk($5ea73cfb65e4f747$var$Y);
}
function $5ea73cfb65e4f747$var$Lk() {
    for(; null !== $5ea73cfb65e4f747$var$Y && !$5ea73cfb65e4f747$var$cc();)$5ea73cfb65e4f747$var$Uk($5ea73cfb65e4f747$var$Y);
}
function $5ea73cfb65e4f747$var$Uk(a) {
    var b = $5ea73cfb65e4f747$var$Vk(a.alternate, a, $5ea73cfb65e4f747$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $5ea73cfb65e4f747$var$Sk(a) : $5ea73cfb65e4f747$var$Y = b;
    $5ea73cfb65e4f747$var$nk.current = null;
}
function $5ea73cfb65e4f747$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $5ea73cfb65e4f747$var$Ej(c, b, $5ea73cfb65e4f747$var$fj), null !== c) {
                $5ea73cfb65e4f747$var$Y = c;
                return;
            }
        } else {
            c = $5ea73cfb65e4f747$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $5ea73cfb65e4f747$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $5ea73cfb65e4f747$var$T = 6;
                $5ea73cfb65e4f747$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $5ea73cfb65e4f747$var$Y = b;
            return;
        }
        $5ea73cfb65e4f747$var$Y = b = a;
    }while (null !== b);
    0 === $5ea73cfb65e4f747$var$T && ($5ea73cfb65e4f747$var$T = 5);
}
function $5ea73cfb65e4f747$var$Pk(a, b, c) {
    var d = $5ea73cfb65e4f747$var$C, e = $5ea73cfb65e4f747$var$ok.transition;
    try {
        $5ea73cfb65e4f747$var$ok.transition = null, $5ea73cfb65e4f747$var$C = 1, $5ea73cfb65e4f747$var$Wk(a, b, c, d);
    } finally{
        $5ea73cfb65e4f747$var$ok.transition = e, $5ea73cfb65e4f747$var$C = d;
    }
    return null;
}
function $5ea73cfb65e4f747$var$Wk(a, b, c, d) {
    do $5ea73cfb65e4f747$var$Hk();
    while (null !== $5ea73cfb65e4f747$var$wk);
    if (0 !== ($5ea73cfb65e4f747$var$K & 6)) throw Error($5ea73cfb65e4f747$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($5ea73cfb65e4f747$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $5ea73cfb65e4f747$var$Bc(a, f);
    a === $5ea73cfb65e4f747$var$Q && ($5ea73cfb65e4f747$var$Y = $5ea73cfb65e4f747$var$Q = null, $5ea73cfb65e4f747$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $5ea73cfb65e4f747$var$vk || ($5ea73cfb65e4f747$var$vk = !0, $5ea73cfb65e4f747$var$Fk($5ea73cfb65e4f747$var$hc, function() {
        $5ea73cfb65e4f747$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $5ea73cfb65e4f747$var$ok.transition;
        $5ea73cfb65e4f747$var$ok.transition = null;
        var g = $5ea73cfb65e4f747$var$C;
        $5ea73cfb65e4f747$var$C = 1;
        var h = $5ea73cfb65e4f747$var$K;
        $5ea73cfb65e4f747$var$K |= 4;
        $5ea73cfb65e4f747$var$nk.current = null;
        $5ea73cfb65e4f747$var$Oj(a, c);
        $5ea73cfb65e4f747$var$dk(c, a);
        $5ea73cfb65e4f747$var$Oe($5ea73cfb65e4f747$var$Df);
        $5ea73cfb65e4f747$var$dd = !!$5ea73cfb65e4f747$var$Cf;
        $5ea73cfb65e4f747$var$Df = $5ea73cfb65e4f747$var$Cf = null;
        a.current = c;
        $5ea73cfb65e4f747$var$hk(c, a, e);
        $5ea73cfb65e4f747$var$dc();
        $5ea73cfb65e4f747$var$K = h;
        $5ea73cfb65e4f747$var$C = g;
        $5ea73cfb65e4f747$var$ok.transition = f;
    } else a.current = c;
    $5ea73cfb65e4f747$var$vk && ($5ea73cfb65e4f747$var$vk = !1, $5ea73cfb65e4f747$var$wk = a, $5ea73cfb65e4f747$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($5ea73cfb65e4f747$var$Ri = null);
    $5ea73cfb65e4f747$var$mc(c.stateNode, d);
    $5ea73cfb65e4f747$var$Dk(a, $5ea73cfb65e4f747$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($5ea73cfb65e4f747$var$Oi) throw $5ea73cfb65e4f747$var$Oi = !1, a = $5ea73cfb65e4f747$var$Pi, $5ea73cfb65e4f747$var$Pi = null, a;
    0 !== ($5ea73cfb65e4f747$var$xk & 1) && 0 !== a.tag && $5ea73cfb65e4f747$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $5ea73cfb65e4f747$var$zk ? $5ea73cfb65e4f747$var$yk++ : ($5ea73cfb65e4f747$var$yk = 0, $5ea73cfb65e4f747$var$zk = a) : $5ea73cfb65e4f747$var$yk = 0;
    $5ea73cfb65e4f747$var$jg();
    return null;
}
function $5ea73cfb65e4f747$var$Hk() {
    if (null !== $5ea73cfb65e4f747$var$wk) {
        var a = $5ea73cfb65e4f747$var$Dc($5ea73cfb65e4f747$var$xk), b = $5ea73cfb65e4f747$var$ok.transition, c = $5ea73cfb65e4f747$var$C;
        try {
            $5ea73cfb65e4f747$var$ok.transition = null;
            $5ea73cfb65e4f747$var$C = 16 > a ? 16 : a;
            if (null === $5ea73cfb65e4f747$var$wk) var d = !1;
            else {
                a = $5ea73cfb65e4f747$var$wk;
                $5ea73cfb65e4f747$var$wk = null;
                $5ea73cfb65e4f747$var$xk = 0;
                if (0 !== ($5ea73cfb65e4f747$var$K & 6)) throw Error($5ea73cfb65e4f747$var$p(331));
                var e = $5ea73cfb65e4f747$var$K;
                $5ea73cfb65e4f747$var$K |= 4;
                for($5ea73cfb65e4f747$var$V = a.current; null !== $5ea73cfb65e4f747$var$V;){
                    var f = $5ea73cfb65e4f747$var$V, g = f.child;
                    if (0 !== ($5ea73cfb65e4f747$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($5ea73cfb65e4f747$var$V = l; null !== $5ea73cfb65e4f747$var$V;){
                                    var m = $5ea73cfb65e4f747$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $5ea73cfb65e4f747$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $5ea73cfb65e4f747$var$V = q;
                                    else for(; null !== $5ea73cfb65e4f747$var$V;){
                                        m = $5ea73cfb65e4f747$var$V;
                                        var r = m.sibling, y = m.return;
                                        $5ea73cfb65e4f747$var$Sj(m);
                                        if (m === l) {
                                            $5ea73cfb65e4f747$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $5ea73cfb65e4f747$var$V = r;
                                            break;
                                        }
                                        $5ea73cfb65e4f747$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $5ea73cfb65e4f747$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $5ea73cfb65e4f747$var$V = g;
                    else b: for(; null !== $5ea73cfb65e4f747$var$V;){
                        f = $5ea73cfb65e4f747$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $5ea73cfb65e4f747$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $5ea73cfb65e4f747$var$V = x;
                            break b;
                        }
                        $5ea73cfb65e4f747$var$V = f.return;
                    }
                }
                var w = a.current;
                for($5ea73cfb65e4f747$var$V = w; null !== $5ea73cfb65e4f747$var$V;){
                    g = $5ea73cfb65e4f747$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $5ea73cfb65e4f747$var$V = u;
                    else b: for(g = w; null !== $5ea73cfb65e4f747$var$V;){
                        h = $5ea73cfb65e4f747$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $5ea73cfb65e4f747$var$Qj(9, h);
                            }
                        } catch (na) {
                            $5ea73cfb65e4f747$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $5ea73cfb65e4f747$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $5ea73cfb65e4f747$var$V = F;
                            break b;
                        }
                        $5ea73cfb65e4f747$var$V = h.return;
                    }
                }
                $5ea73cfb65e4f747$var$K = e;
                $5ea73cfb65e4f747$var$jg();
                if ($5ea73cfb65e4f747$var$lc && "function" === typeof $5ea73cfb65e4f747$var$lc.onPostCommitFiberRoot) try {
                    $5ea73cfb65e4f747$var$lc.onPostCommitFiberRoot($5ea73cfb65e4f747$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $5ea73cfb65e4f747$var$C = c, $5ea73cfb65e4f747$var$ok.transition = b;
        }
    }
    return !1;
}
function $5ea73cfb65e4f747$var$Xk(a, b, c) {
    b = $5ea73cfb65e4f747$var$Ji(c, b);
    b = $5ea73cfb65e4f747$var$Ni(a, b, 1);
    a = $5ea73cfb65e4f747$var$nh(a, b, 1);
    b = $5ea73cfb65e4f747$var$R();
    null !== a && ($5ea73cfb65e4f747$var$Ac(a, 1, b), $5ea73cfb65e4f747$var$Dk(a, b));
}
function $5ea73cfb65e4f747$var$W(a, b, c) {
    if (3 === a.tag) $5ea73cfb65e4f747$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $5ea73cfb65e4f747$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $5ea73cfb65e4f747$var$Ri || !$5ea73cfb65e4f747$var$Ri.has(d))) {
                a = $5ea73cfb65e4f747$var$Ji(c, a);
                a = $5ea73cfb65e4f747$var$Qi(b, a, 1);
                b = $5ea73cfb65e4f747$var$nh(b, a, 1);
                a = $5ea73cfb65e4f747$var$R();
                null !== b && ($5ea73cfb65e4f747$var$Ac(b, 1, a), $5ea73cfb65e4f747$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $5ea73cfb65e4f747$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $5ea73cfb65e4f747$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $5ea73cfb65e4f747$var$Q === a && ($5ea73cfb65e4f747$var$Z & c) === c && (4 === $5ea73cfb65e4f747$var$T || 3 === $5ea73cfb65e4f747$var$T && ($5ea73cfb65e4f747$var$Z & 130023424) === $5ea73cfb65e4f747$var$Z && 500 > $5ea73cfb65e4f747$var$B() - $5ea73cfb65e4f747$var$fk ? $5ea73cfb65e4f747$var$Kk(a, 0) : $5ea73cfb65e4f747$var$rk |= c);
    $5ea73cfb65e4f747$var$Dk(a, b);
}
function $5ea73cfb65e4f747$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $5ea73cfb65e4f747$var$sc, $5ea73cfb65e4f747$var$sc <<= 1, 0 === ($5ea73cfb65e4f747$var$sc & 130023424) && ($5ea73cfb65e4f747$var$sc = 4194304)));
    var c = $5ea73cfb65e4f747$var$R();
    a = $5ea73cfb65e4f747$var$ih(a, b);
    null !== a && ($5ea73cfb65e4f747$var$Ac(a, b, c), $5ea73cfb65e4f747$var$Dk(a, c));
}
function $5ea73cfb65e4f747$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $5ea73cfb65e4f747$var$Yk(a, c);
}
function $5ea73cfb65e4f747$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($5ea73cfb65e4f747$var$p(314));
    }
    null !== d && d.delete(b);
    $5ea73cfb65e4f747$var$Yk(a, c);
}
var $5ea73cfb65e4f747$var$Vk;
$5ea73cfb65e4f747$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $5ea73cfb65e4f747$var$Wf.current) $5ea73cfb65e4f747$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $5ea73cfb65e4f747$var$dh = !1, $5ea73cfb65e4f747$var$yj(a, b, c);
            $5ea73cfb65e4f747$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $5ea73cfb65e4f747$var$dh = !1, $5ea73cfb65e4f747$var$I && 0 !== (b.flags & 1048576) && $5ea73cfb65e4f747$var$ug(b, $5ea73cfb65e4f747$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $5ea73cfb65e4f747$var$ij(a, b);
            a = b.pendingProps;
            var e = $5ea73cfb65e4f747$var$Yf(b, $5ea73cfb65e4f747$var$H.current);
            $5ea73cfb65e4f747$var$ch(b, c);
            e = $5ea73cfb65e4f747$var$Nh(null, b, d, a, e, c);
            var f = $5ea73cfb65e4f747$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $5ea73cfb65e4f747$var$Zf(d) ? (f = !0, $5ea73cfb65e4f747$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $5ea73cfb65e4f747$var$kh(b), e.updater = $5ea73cfb65e4f747$var$Ei, b.stateNode = e, e._reactInternals = b, $5ea73cfb65e4f747$var$Ii(b, d, a, c), b = $5ea73cfb65e4f747$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $5ea73cfb65e4f747$var$I && f && $5ea73cfb65e4f747$var$vg(b), $5ea73cfb65e4f747$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $5ea73cfb65e4f747$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $5ea73cfb65e4f747$var$Zk(d);
                a = $5ea73cfb65e4f747$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $5ea73cfb65e4f747$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $5ea73cfb65e4f747$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $5ea73cfb65e4f747$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $5ea73cfb65e4f747$var$$i(null, b, d, $5ea73cfb65e4f747$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($5ea73cfb65e4f747$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5ea73cfb65e4f747$var$Ci(d, e), $5ea73cfb65e4f747$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5ea73cfb65e4f747$var$Ci(d, e), $5ea73cfb65e4f747$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $5ea73cfb65e4f747$var$kj(b);
                if (null === a) throw Error($5ea73cfb65e4f747$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $5ea73cfb65e4f747$var$lh(a, b);
                $5ea73cfb65e4f747$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $5ea73cfb65e4f747$var$Ji(Error($5ea73cfb65e4f747$var$p(423)), b);
                        b = $5ea73cfb65e4f747$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $5ea73cfb65e4f747$var$Ji(Error($5ea73cfb65e4f747$var$p(424)), b);
                        b = $5ea73cfb65e4f747$var$lj(a, b, d, c, e);
                        break a;
                    } else for($5ea73cfb65e4f747$var$yg = $5ea73cfb65e4f747$var$Lf(b.stateNode.containerInfo.firstChild), $5ea73cfb65e4f747$var$xg = b, $5ea73cfb65e4f747$var$I = !0, $5ea73cfb65e4f747$var$zg = null, c = $5ea73cfb65e4f747$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $5ea73cfb65e4f747$var$Ig();
                    if (d === e) {
                        b = $5ea73cfb65e4f747$var$Zi(a, b, c);
                        break a;
                    }
                    $5ea73cfb65e4f747$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $5ea73cfb65e4f747$var$Ah(b), null === a && $5ea73cfb65e4f747$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $5ea73cfb65e4f747$var$Ef(d, e) ? g = null : null !== f && $5ea73cfb65e4f747$var$Ef(d, f) && (b.flags |= 32), $5ea73cfb65e4f747$var$gj(a, b), $5ea73cfb65e4f747$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $5ea73cfb65e4f747$var$Eg(b), null;
        case 13:
            return $5ea73cfb65e4f747$var$oj(a, b, c);
        case 4:
            return $5ea73cfb65e4f747$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $5ea73cfb65e4f747$var$Ug(b, null, d, c) : $5ea73cfb65e4f747$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5ea73cfb65e4f747$var$Ci(d, e), $5ea73cfb65e4f747$var$Yi(a, b, d, e, c);
        case 7:
            return $5ea73cfb65e4f747$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $5ea73cfb65e4f747$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $5ea73cfb65e4f747$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $5ea73cfb65e4f747$var$G($5ea73cfb65e4f747$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($5ea73cfb65e4f747$var$He(f.value, g)) {
                        if (f.children === e.children && !$5ea73cfb65e4f747$var$Wf.current) {
                            b = $5ea73cfb65e4f747$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $5ea73cfb65e4f747$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $5ea73cfb65e4f747$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($5ea73cfb65e4f747$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $5ea73cfb65e4f747$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $5ea73cfb65e4f747$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $5ea73cfb65e4f747$var$ch(b, c), e = $5ea73cfb65e4f747$var$eh(e), d = d(e), b.flags |= 1, $5ea73cfb65e4f747$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $5ea73cfb65e4f747$var$Ci(d, b.pendingProps), e = $5ea73cfb65e4f747$var$Ci(d.type, e), $5ea73cfb65e4f747$var$$i(a, b, d, e, c);
        case 15:
            return $5ea73cfb65e4f747$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5ea73cfb65e4f747$var$Ci(d, e), $5ea73cfb65e4f747$var$ij(a, b), b.tag = 1, $5ea73cfb65e4f747$var$Zf(d) ? (a = !0, $5ea73cfb65e4f747$var$cg(b)) : a = !1, $5ea73cfb65e4f747$var$ch(b, c), $5ea73cfb65e4f747$var$Gi(b, d, e), $5ea73cfb65e4f747$var$Ii(b, d, e, c), $5ea73cfb65e4f747$var$jj(null, b, d, !0, a, c);
        case 19:
            return $5ea73cfb65e4f747$var$xj(a, b, c);
        case 22:
            return $5ea73cfb65e4f747$var$dj(a, b, c);
    }
    throw Error($5ea73cfb65e4f747$var$p(156, b.tag));
};
function $5ea73cfb65e4f747$var$Fk(a, b) {
    return $5ea73cfb65e4f747$var$ac(a, b);
}
function $5ea73cfb65e4f747$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $5ea73cfb65e4f747$var$Bg(a, b, c, d) {
    return new $5ea73cfb65e4f747$var$$k(a, b, c, d);
}
function $5ea73cfb65e4f747$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $5ea73cfb65e4f747$var$Zk(a) {
    if ("function" === typeof a) return $5ea73cfb65e4f747$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $5ea73cfb65e4f747$var$Da) return 11;
        if (a === $5ea73cfb65e4f747$var$Ga) return 14;
    }
    return 2;
}
function $5ea73cfb65e4f747$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $5ea73cfb65e4f747$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $5ea73cfb65e4f747$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $5ea73cfb65e4f747$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $5ea73cfb65e4f747$var$ya:
            return $5ea73cfb65e4f747$var$Tg(c.children, e, f, b);
        case $5ea73cfb65e4f747$var$za:
            g = 8;
            e |= 8;
            break;
        case $5ea73cfb65e4f747$var$Aa:
            return a = $5ea73cfb65e4f747$var$Bg(12, c, b, e | 2), a.elementType = $5ea73cfb65e4f747$var$Aa, a.lanes = f, a;
        case $5ea73cfb65e4f747$var$Ea:
            return a = $5ea73cfb65e4f747$var$Bg(13, c, b, e), a.elementType = $5ea73cfb65e4f747$var$Ea, a.lanes = f, a;
        case $5ea73cfb65e4f747$var$Fa:
            return a = $5ea73cfb65e4f747$var$Bg(19, c, b, e), a.elementType = $5ea73cfb65e4f747$var$Fa, a.lanes = f, a;
        case $5ea73cfb65e4f747$var$Ia:
            return $5ea73cfb65e4f747$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $5ea73cfb65e4f747$var$Ba:
                    g = 10;
                    break a;
                case $5ea73cfb65e4f747$var$Ca:
                    g = 9;
                    break a;
                case $5ea73cfb65e4f747$var$Da:
                    g = 11;
                    break a;
                case $5ea73cfb65e4f747$var$Ga:
                    g = 14;
                    break a;
                case $5ea73cfb65e4f747$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($5ea73cfb65e4f747$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $5ea73cfb65e4f747$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $5ea73cfb65e4f747$var$Tg(a, b, c, d) {
    a = $5ea73cfb65e4f747$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $5ea73cfb65e4f747$var$pj(a, b, c, d) {
    a = $5ea73cfb65e4f747$var$Bg(22, a, d, b);
    a.elementType = $5ea73cfb65e4f747$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $5ea73cfb65e4f747$var$Qg(a, b, c) {
    a = $5ea73cfb65e4f747$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $5ea73cfb65e4f747$var$Sg(a, b, c) {
    b = $5ea73cfb65e4f747$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $5ea73cfb65e4f747$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $5ea73cfb65e4f747$var$zc(0);
    this.expirationTimes = $5ea73cfb65e4f747$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $5ea73cfb65e4f747$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $5ea73cfb65e4f747$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $5ea73cfb65e4f747$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $5ea73cfb65e4f747$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $5ea73cfb65e4f747$var$kh(f);
    return a;
}
function $5ea73cfb65e4f747$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $5ea73cfb65e4f747$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $5ea73cfb65e4f747$var$dl(a) {
    if (!a) return $5ea73cfb65e4f747$var$Vf;
    a = a._reactInternals;
    a: {
        if ($5ea73cfb65e4f747$var$Vb(a) !== a || 1 !== a.tag) throw Error($5ea73cfb65e4f747$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($5ea73cfb65e4f747$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($5ea73cfb65e4f747$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($5ea73cfb65e4f747$var$Zf(c)) return $5ea73cfb65e4f747$var$bg(a, c, b);
    }
    return b;
}
function $5ea73cfb65e4f747$var$el(a, b, c, d, e, f, g, h, k) {
    a = $5ea73cfb65e4f747$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $5ea73cfb65e4f747$var$dl(null);
    c = a.current;
    d = $5ea73cfb65e4f747$var$R();
    e = $5ea73cfb65e4f747$var$yi(c);
    f = $5ea73cfb65e4f747$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $5ea73cfb65e4f747$var$nh(c, f, e);
    a.current.lanes = e;
    $5ea73cfb65e4f747$var$Ac(a, e, d);
    $5ea73cfb65e4f747$var$Dk(a, d);
    return a;
}
function $5ea73cfb65e4f747$var$fl(a, b, c, d) {
    var e = b.current, f = $5ea73cfb65e4f747$var$R(), g = $5ea73cfb65e4f747$var$yi(e);
    c = $5ea73cfb65e4f747$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $5ea73cfb65e4f747$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $5ea73cfb65e4f747$var$nh(e, b, g);
    null !== a && ($5ea73cfb65e4f747$var$gi(a, e, g, f), $5ea73cfb65e4f747$var$oh(a, e, g));
    return g;
}
function $5ea73cfb65e4f747$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $5ea73cfb65e4f747$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $5ea73cfb65e4f747$var$il(a, b) {
    $5ea73cfb65e4f747$var$hl(a, b);
    (a = a.alternate) && $5ea73cfb65e4f747$var$hl(a, b);
}
function $5ea73cfb65e4f747$var$jl() {
    return null;
}
var $5ea73cfb65e4f747$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $5ea73cfb65e4f747$var$ll(a) {
    this._internalRoot = a;
}
$5ea73cfb65e4f747$var$ml.prototype.render = $5ea73cfb65e4f747$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($5ea73cfb65e4f747$var$p(409));
    $5ea73cfb65e4f747$var$fl(a, b, null, null);
};
$5ea73cfb65e4f747$var$ml.prototype.unmount = $5ea73cfb65e4f747$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $5ea73cfb65e4f747$var$Rk(function() {
            $5ea73cfb65e4f747$var$fl(null, a, null, null);
        });
        b[$5ea73cfb65e4f747$var$uf] = null;
    }
};
function $5ea73cfb65e4f747$var$ml(a) {
    this._internalRoot = a;
}
$5ea73cfb65e4f747$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $5ea73cfb65e4f747$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $5ea73cfb65e4f747$var$Qc.length && 0 !== b && b < $5ea73cfb65e4f747$var$Qc[c].priority; c++);
        $5ea73cfb65e4f747$var$Qc.splice(c, 0, a);
        0 === c && $5ea73cfb65e4f747$var$Vc(a);
    }
};
function $5ea73cfb65e4f747$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $5ea73cfb65e4f747$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $5ea73cfb65e4f747$var$pl() {}
function $5ea73cfb65e4f747$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $5ea73cfb65e4f747$var$gl(g);
                f.call(a);
            };
        }
        var g = $5ea73cfb65e4f747$var$el(b, d, a, 0, null, !1, !1, "", $5ea73cfb65e4f747$var$pl);
        a._reactRootContainer = g;
        a[$5ea73cfb65e4f747$var$uf] = g.current;
        $5ea73cfb65e4f747$var$sf(8 === a.nodeType ? a.parentNode : a);
        $5ea73cfb65e4f747$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $5ea73cfb65e4f747$var$gl(k);
            h.call(a);
        };
    }
    var k = $5ea73cfb65e4f747$var$bl(a, 0, !1, null, null, !1, !1, "", $5ea73cfb65e4f747$var$pl);
    a._reactRootContainer = k;
    a[$5ea73cfb65e4f747$var$uf] = k.current;
    $5ea73cfb65e4f747$var$sf(8 === a.nodeType ? a.parentNode : a);
    $5ea73cfb65e4f747$var$Rk(function() {
        $5ea73cfb65e4f747$var$fl(b, k, c, d);
    });
    return k;
}
function $5ea73cfb65e4f747$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $5ea73cfb65e4f747$var$gl(g);
                h.call(a);
            };
        }
        $5ea73cfb65e4f747$var$fl(b, g, a, e);
    } else g = $5ea73cfb65e4f747$var$ql(c, b, a, e, d);
    return $5ea73cfb65e4f747$var$gl(g);
}
$5ea73cfb65e4f747$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $5ea73cfb65e4f747$var$tc(b.pendingLanes);
                0 !== c && ($5ea73cfb65e4f747$var$Cc(b, c | 1), $5ea73cfb65e4f747$var$Dk(b, $5ea73cfb65e4f747$var$B()), 0 === ($5ea73cfb65e4f747$var$K & 6) && ($5ea73cfb65e4f747$var$Gj = $5ea73cfb65e4f747$var$B() + 500, $5ea73cfb65e4f747$var$jg()));
            }
            break;
        case 13:
            $5ea73cfb65e4f747$var$Rk(function() {
                var b = $5ea73cfb65e4f747$var$ih(a, 1);
                if (null !== b) {
                    var c = $5ea73cfb65e4f747$var$R();
                    $5ea73cfb65e4f747$var$gi(b, a, 1, c);
                }
            }), $5ea73cfb65e4f747$var$il(a, 1);
    }
};
$5ea73cfb65e4f747$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $5ea73cfb65e4f747$var$ih(a, 134217728);
        if (null !== b) {
            var c = $5ea73cfb65e4f747$var$R();
            $5ea73cfb65e4f747$var$gi(b, a, 134217728, c);
        }
        $5ea73cfb65e4f747$var$il(a, 134217728);
    }
};
$5ea73cfb65e4f747$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $5ea73cfb65e4f747$var$yi(a), c = $5ea73cfb65e4f747$var$ih(a, b);
        if (null !== c) {
            var d = $5ea73cfb65e4f747$var$R();
            $5ea73cfb65e4f747$var$gi(c, a, b, d);
        }
        $5ea73cfb65e4f747$var$il(a, b);
    }
};
$5ea73cfb65e4f747$var$Hc = function() {
    return $5ea73cfb65e4f747$var$C;
};
$5ea73cfb65e4f747$var$Ic = function(a, b) {
    var c = $5ea73cfb65e4f747$var$C;
    try {
        return $5ea73cfb65e4f747$var$C = a, b();
    } finally{
        $5ea73cfb65e4f747$var$C = c;
    }
};
$5ea73cfb65e4f747$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $5ea73cfb65e4f747$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $5ea73cfb65e4f747$var$Db(d);
                        if (!e) throw Error($5ea73cfb65e4f747$var$p(90));
                        $5ea73cfb65e4f747$var$Wa(d);
                        $5ea73cfb65e4f747$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $5ea73cfb65e4f747$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $5ea73cfb65e4f747$var$fb(a, !!c.multiple, b, !1);
    }
};
$5ea73cfb65e4f747$var$Gb = $5ea73cfb65e4f747$var$Qk;
$5ea73cfb65e4f747$var$Hb = $5ea73cfb65e4f747$var$Rk;
var $5ea73cfb65e4f747$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $5ea73cfb65e4f747$var$Cb,
        $5ea73cfb65e4f747$var$ue,
        $5ea73cfb65e4f747$var$Db,
        $5ea73cfb65e4f747$var$Eb,
        $5ea73cfb65e4f747$var$Fb,
        $5ea73cfb65e4f747$var$Qk
    ]
}, $5ea73cfb65e4f747$var$tl = {
    findFiberByHostInstance: $5ea73cfb65e4f747$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $5ea73cfb65e4f747$var$ul = {
    bundleType: $5ea73cfb65e4f747$var$tl.bundleType,
    version: $5ea73cfb65e4f747$var$tl.version,
    rendererPackageName: $5ea73cfb65e4f747$var$tl.rendererPackageName,
    rendererConfig: $5ea73cfb65e4f747$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $5ea73cfb65e4f747$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $5ea73cfb65e4f747$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $5ea73cfb65e4f747$var$tl.findFiberByHostInstance || $5ea73cfb65e4f747$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $5ea73cfb65e4f747$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$5ea73cfb65e4f747$var$vl.isDisabled && $5ea73cfb65e4f747$var$vl.supportsFiber) try {
        $5ea73cfb65e4f747$var$kc = $5ea73cfb65e4f747$var$vl.inject($5ea73cfb65e4f747$var$ul), $5ea73cfb65e4f747$var$lc = $5ea73cfb65e4f747$var$vl;
    } catch (a) {}
}
$5ea73cfb65e4f747$export$ae55be85d98224ed = $5ea73cfb65e4f747$var$sl;
$5ea73cfb65e4f747$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$5ea73cfb65e4f747$var$nl(b)) throw Error($5ea73cfb65e4f747$var$p(200));
    return $5ea73cfb65e4f747$var$cl(a, b, null, c);
};
$5ea73cfb65e4f747$export$882461b6382ed46c = function(a, b) {
    if (!$5ea73cfb65e4f747$var$nl(a)) throw Error($5ea73cfb65e4f747$var$p(299));
    var c = !1, d = "", e = $5ea73cfb65e4f747$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $5ea73cfb65e4f747$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$5ea73cfb65e4f747$var$uf] = b.current;
    $5ea73cfb65e4f747$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $5ea73cfb65e4f747$var$ll(b);
};
$5ea73cfb65e4f747$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($5ea73cfb65e4f747$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($5ea73cfb65e4f747$var$p(268, a));
    }
    a = $5ea73cfb65e4f747$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$5ea73cfb65e4f747$export$cd75ccfd720a3cd4 = function(a) {
    return $5ea73cfb65e4f747$var$Rk(a);
};
$5ea73cfb65e4f747$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$5ea73cfb65e4f747$var$ol(b)) throw Error($5ea73cfb65e4f747$var$p(200));
    return $5ea73cfb65e4f747$var$rl(null, a, b, !0, c);
};
$5ea73cfb65e4f747$export$757ceba2d55c277e = function(a, b, c) {
    if (!$5ea73cfb65e4f747$var$nl(a)) throw Error($5ea73cfb65e4f747$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $5ea73cfb65e4f747$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $5ea73cfb65e4f747$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$5ea73cfb65e4f747$var$uf] = b.current;
    $5ea73cfb65e4f747$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $5ea73cfb65e4f747$var$ml(b);
};
$5ea73cfb65e4f747$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$5ea73cfb65e4f747$var$ol(b)) throw Error($5ea73cfb65e4f747$var$p(200));
    return $5ea73cfb65e4f747$var$rl(null, a, b, !1, c);
};
$5ea73cfb65e4f747$export$502457920280e6be = function(a) {
    if (!$5ea73cfb65e4f747$var$ol(a)) throw Error($5ea73cfb65e4f747$var$p(40));
    return a._reactRootContainer ? ($5ea73cfb65e4f747$var$Rk(function() {
        $5ea73cfb65e4f747$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$5ea73cfb65e4f747$var$uf] = null;
        });
    }), !0) : !1;
};
$5ea73cfb65e4f747$export$c78a37762a8d58e1 = $5ea73cfb65e4f747$var$Qk;
$5ea73cfb65e4f747$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$5ea73cfb65e4f747$var$ol(c)) throw Error($5ea73cfb65e4f747$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($5ea73cfb65e4f747$var$p(38));
    return $5ea73cfb65e4f747$var$rl(a, b, c, !1, d);
};
$5ea73cfb65e4f747$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("4xFQO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3bPHt"));

});
parcelRegister("3bPHt", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $252a80c15cddff21$export$c4744153514ff05d; }, function (v) { return $252a80c15cddff21$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $252a80c15cddff21$export$3e506c1ccc9cc1a7; }, function (v) { return $252a80c15cddff21$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $252a80c15cddff21$export$e26fe2ed2fa76875; }, function (v) { return $252a80c15cddff21$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $252a80c15cddff21$export$502329bbf4b505b1; }, function (v) { return $252a80c15cddff21$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $252a80c15cddff21$export$6e3807111c4874c4; }, function (v) { return $252a80c15cddff21$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $252a80c15cddff21$export$c27134553091fb3a; }, function (v) { return $252a80c15cddff21$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $252a80c15cddff21$export$33ee1acdc04fd2a2; }, function (v) { return $252a80c15cddff21$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $252a80c15cddff21$export$b00a404bbd5edef2; }, function (v) { return $252a80c15cddff21$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $252a80c15cddff21$export$8352ce38b91d0c62; }, function (v) { return $252a80c15cddff21$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $252a80c15cddff21$export$d66a1c1c77bd778b; }, function (v) { return $252a80c15cddff21$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $252a80c15cddff21$export$d3dfb8e4810cb555; }, function (v) { return $252a80c15cddff21$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $252a80c15cddff21$export$839f9183b0465a69; }, function (v) { return $252a80c15cddff21$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $252a80c15cddff21$export$72fdf0e06517287b; }, function (v) { return $252a80c15cddff21$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $252a80c15cddff21$export$4b844e58a3e414b4; }, function (v) { return $252a80c15cddff21$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $252a80c15cddff21$export$816d2913ae6b83b1; }, function (v) { return $252a80c15cddff21$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $252a80c15cddff21$export$61bcfe829111a1d0; }, function (v) { return $252a80c15cddff21$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $252a80c15cddff21$export$7ee8c9beb337bc3f; }, function (v) { return $252a80c15cddff21$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $252a80c15cddff21$export$b5836b71941fa3ed; }, function (v) { return $252a80c15cddff21$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $252a80c15cddff21$export$cf845f2c119da08a; }, function (v) { return $252a80c15cddff21$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $252a80c15cddff21$export$c4744153514ff05d;
var $252a80c15cddff21$export$3e506c1ccc9cc1a7;
var $252a80c15cddff21$export$e26fe2ed2fa76875;
var $252a80c15cddff21$export$502329bbf4b505b1;
var $252a80c15cddff21$export$6e3807111c4874c4;
var $252a80c15cddff21$export$c27134553091fb3a;
var $252a80c15cddff21$export$33ee1acdc04fd2a2;
var $252a80c15cddff21$export$b00a404bbd5edef2;
var $252a80c15cddff21$export$8352ce38b91d0c62;
var $252a80c15cddff21$export$d66a1c1c77bd778b;
var $252a80c15cddff21$export$d3dfb8e4810cb555;
var $252a80c15cddff21$export$839f9183b0465a69;
var $252a80c15cddff21$export$72fdf0e06517287b;
var $252a80c15cddff21$export$4b844e58a3e414b4;
var $252a80c15cddff21$export$816d2913ae6b83b1;
var $252a80c15cddff21$export$61bcfe829111a1d0;
var $252a80c15cddff21$export$7ee8c9beb337bc3f;
var $252a80c15cddff21$export$b5836b71941fa3ed;
var $252a80c15cddff21$export$cf845f2c119da08a;
'use strict';
function $252a80c15cddff21$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $252a80c15cddff21$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $252a80c15cddff21$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $252a80c15cddff21$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $252a80c15cddff21$var$g(C, c)) n < e && 0 > $252a80c15cddff21$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $252a80c15cddff21$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $252a80c15cddff21$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $252a80c15cddff21$var$l = performance;
    $252a80c15cddff21$export$c4744153514ff05d = function() {
        return $252a80c15cddff21$var$l.now();
    };
} else {
    var $252a80c15cddff21$var$p = Date, $252a80c15cddff21$var$q = $252a80c15cddff21$var$p.now();
    $252a80c15cddff21$export$c4744153514ff05d = function() {
        return $252a80c15cddff21$var$p.now() - $252a80c15cddff21$var$q;
    };
}
var $252a80c15cddff21$var$r = [], $252a80c15cddff21$var$t = [], $252a80c15cddff21$var$u = 1, $252a80c15cddff21$var$v = null, $252a80c15cddff21$var$y = 3, $252a80c15cddff21$var$z = !1, $252a80c15cddff21$var$A = !1, $252a80c15cddff21$var$B = !1, $252a80c15cddff21$var$D = "function" === typeof setTimeout ? setTimeout : null, $252a80c15cddff21$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $252a80c15cddff21$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $252a80c15cddff21$var$G(a) {
    for(var b = $252a80c15cddff21$var$h($252a80c15cddff21$var$t); null !== b;){
        if (null === b.callback) $252a80c15cddff21$var$k($252a80c15cddff21$var$t);
        else if (b.startTime <= a) $252a80c15cddff21$var$k($252a80c15cddff21$var$t), b.sortIndex = b.expirationTime, $252a80c15cddff21$var$f($252a80c15cddff21$var$r, b);
        else break;
        b = $252a80c15cddff21$var$h($252a80c15cddff21$var$t);
    }
}
function $252a80c15cddff21$var$H(a) {
    $252a80c15cddff21$var$B = !1;
    $252a80c15cddff21$var$G(a);
    if (!$252a80c15cddff21$var$A) {
        if (null !== $252a80c15cddff21$var$h($252a80c15cddff21$var$r)) $252a80c15cddff21$var$A = !0, $252a80c15cddff21$var$I($252a80c15cddff21$var$J);
        else {
            var b = $252a80c15cddff21$var$h($252a80c15cddff21$var$t);
            null !== b && $252a80c15cddff21$var$K($252a80c15cddff21$var$H, b.startTime - a);
        }
    }
}
function $252a80c15cddff21$var$J(a, b) {
    $252a80c15cddff21$var$A = !1;
    $252a80c15cddff21$var$B && ($252a80c15cddff21$var$B = !1, $252a80c15cddff21$var$E($252a80c15cddff21$var$L), $252a80c15cddff21$var$L = -1);
    $252a80c15cddff21$var$z = !0;
    var c = $252a80c15cddff21$var$y;
    try {
        $252a80c15cddff21$var$G(b);
        for($252a80c15cddff21$var$v = $252a80c15cddff21$var$h($252a80c15cddff21$var$r); null !== $252a80c15cddff21$var$v && (!($252a80c15cddff21$var$v.expirationTime > b) || a && !$252a80c15cddff21$var$M());){
            var d = $252a80c15cddff21$var$v.callback;
            if ("function" === typeof d) {
                $252a80c15cddff21$var$v.callback = null;
                $252a80c15cddff21$var$y = $252a80c15cddff21$var$v.priorityLevel;
                var e = d($252a80c15cddff21$var$v.expirationTime <= b);
                b = $252a80c15cddff21$export$c4744153514ff05d();
                "function" === typeof e ? $252a80c15cddff21$var$v.callback = e : $252a80c15cddff21$var$v === $252a80c15cddff21$var$h($252a80c15cddff21$var$r) && $252a80c15cddff21$var$k($252a80c15cddff21$var$r);
                $252a80c15cddff21$var$G(b);
            } else $252a80c15cddff21$var$k($252a80c15cddff21$var$r);
            $252a80c15cddff21$var$v = $252a80c15cddff21$var$h($252a80c15cddff21$var$r);
        }
        if (null !== $252a80c15cddff21$var$v) var w = !0;
        else {
            var m = $252a80c15cddff21$var$h($252a80c15cddff21$var$t);
            null !== m && $252a80c15cddff21$var$K($252a80c15cddff21$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $252a80c15cddff21$var$v = null, $252a80c15cddff21$var$y = c, $252a80c15cddff21$var$z = !1;
    }
}
var $252a80c15cddff21$var$N = !1, $252a80c15cddff21$var$O = null, $252a80c15cddff21$var$L = -1, $252a80c15cddff21$var$P = 5, $252a80c15cddff21$var$Q = -1;
function $252a80c15cddff21$var$M() {
    return $252a80c15cddff21$export$c4744153514ff05d() - $252a80c15cddff21$var$Q < $252a80c15cddff21$var$P ? !1 : !0;
}
function $252a80c15cddff21$var$R() {
    if (null !== $252a80c15cddff21$var$O) {
        var a = $252a80c15cddff21$export$c4744153514ff05d();
        $252a80c15cddff21$var$Q = a;
        var b = !0;
        try {
            b = $252a80c15cddff21$var$O(!0, a);
        } finally{
            b ? $252a80c15cddff21$var$S() : ($252a80c15cddff21$var$N = !1, $252a80c15cddff21$var$O = null);
        }
    } else $252a80c15cddff21$var$N = !1;
}
var $252a80c15cddff21$var$S;
if ("function" === typeof $252a80c15cddff21$var$F) $252a80c15cddff21$var$S = function() {
    $252a80c15cddff21$var$F($252a80c15cddff21$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $252a80c15cddff21$var$T = new MessageChannel, $252a80c15cddff21$var$U = $252a80c15cddff21$var$T.port2;
    $252a80c15cddff21$var$T.port1.onmessage = $252a80c15cddff21$var$R;
    $252a80c15cddff21$var$S = function() {
        $252a80c15cddff21$var$U.postMessage(null);
    };
} else $252a80c15cddff21$var$S = function() {
    $252a80c15cddff21$var$D($252a80c15cddff21$var$R, 0);
};
function $252a80c15cddff21$var$I(a) {
    $252a80c15cddff21$var$O = a;
    $252a80c15cddff21$var$N || ($252a80c15cddff21$var$N = !0, $252a80c15cddff21$var$S());
}
function $252a80c15cddff21$var$K(a, b) {
    $252a80c15cddff21$var$L = $252a80c15cddff21$var$D(function() {
        a($252a80c15cddff21$export$c4744153514ff05d());
    }, b);
}
$252a80c15cddff21$export$3e506c1ccc9cc1a7 = 5;
$252a80c15cddff21$export$e26fe2ed2fa76875 = 1;
$252a80c15cddff21$export$502329bbf4b505b1 = 4;
$252a80c15cddff21$export$6e3807111c4874c4 = 3;
$252a80c15cddff21$export$c27134553091fb3a = null;
$252a80c15cddff21$export$33ee1acdc04fd2a2 = 2;
$252a80c15cddff21$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$252a80c15cddff21$export$8352ce38b91d0c62 = function() {
    $252a80c15cddff21$var$A || $252a80c15cddff21$var$z || ($252a80c15cddff21$var$A = !0, $252a80c15cddff21$var$I($252a80c15cddff21$var$J));
};
$252a80c15cddff21$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $252a80c15cddff21$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$252a80c15cddff21$export$d3dfb8e4810cb555 = function() {
    return $252a80c15cddff21$var$y;
};
$252a80c15cddff21$export$839f9183b0465a69 = function() {
    return $252a80c15cddff21$var$h($252a80c15cddff21$var$r);
};
$252a80c15cddff21$export$72fdf0e06517287b = function(a) {
    switch($252a80c15cddff21$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $252a80c15cddff21$var$y;
    }
    var c = $252a80c15cddff21$var$y;
    $252a80c15cddff21$var$y = b;
    try {
        return a();
    } finally{
        $252a80c15cddff21$var$y = c;
    }
};
$252a80c15cddff21$export$4b844e58a3e414b4 = function() {};
$252a80c15cddff21$export$816d2913ae6b83b1 = function() {};
$252a80c15cddff21$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $252a80c15cddff21$var$y;
    $252a80c15cddff21$var$y = a;
    try {
        return b();
    } finally{
        $252a80c15cddff21$var$y = c;
    }
};
$252a80c15cddff21$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $252a80c15cddff21$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $252a80c15cddff21$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $252a80c15cddff21$var$f($252a80c15cddff21$var$t, a), null === $252a80c15cddff21$var$h($252a80c15cddff21$var$r) && a === $252a80c15cddff21$var$h($252a80c15cddff21$var$t) && ($252a80c15cddff21$var$B ? ($252a80c15cddff21$var$E($252a80c15cddff21$var$L), $252a80c15cddff21$var$L = -1) : $252a80c15cddff21$var$B = !0, $252a80c15cddff21$var$K($252a80c15cddff21$var$H, c - d))) : (a.sortIndex = e, $252a80c15cddff21$var$f($252a80c15cddff21$var$r, a), $252a80c15cddff21$var$A || $252a80c15cddff21$var$z || ($252a80c15cddff21$var$A = !0, $252a80c15cddff21$var$I($252a80c15cddff21$var$J)));
    return a;
};
$252a80c15cddff21$export$b5836b71941fa3ed = $252a80c15cddff21$var$M;
$252a80c15cddff21$export$cf845f2c119da08a = function(a) {
    var b = $252a80c15cddff21$var$y;
    return function() {
        var c = $252a80c15cddff21$var$y;
        $252a80c15cddff21$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $252a80c15cddff21$var$y = c;
        }
    };
};

});



parcelRegister("ly5Rw", function(module, exports) {

var $bbx7s = parcelRequire("bbx7s");

var $eie1Q = parcelRequire("eie1Q");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $bbx7s.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $eie1Q;
module.exports = isBuffer;

});
parcelRegister("bbx7s", function(module, exports) {

var $43XtX = parcelRequire("43XtX");
/** Detect free variable `self`. */ var $824a69934299db0d$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $824a69934299db0d$var$root = $43XtX || $824a69934299db0d$var$freeSelf || Function('return this')();
module.exports = $824a69934299db0d$var$root;

});
parcelRegister("43XtX", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $2f55952b3315082c$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $2f55952b3315082c$var$freeGlobal;

});


parcelRegister("eie1Q", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $a67da0ef657bbe74$var$stubFalse() {
    return false;
}
module.exports = $a67da0ef657bbe74$var$stubFalse;

});


parcelRegister("lOIux", function(module, exports) {

var $43XtX = parcelRequire("43XtX");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $43XtX.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("lLzME", function(module, exports) {

var $bbx7s = parcelRequire("bbx7s");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $bbx7s.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("kaWlt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $eb01fffcd27d5a8f$export$bf730a2d8bf68b42; }, function (v) { return $eb01fffcd27d5a8f$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eb01fffcd27d5a8f$export$bf730a2d8bf68b42;
"use strict";

var $6aRB8 = parcelRequire("6aRB8");

var $gbiuv = parcelRequire("gbiuv");
function $eb01fffcd27d5a8f$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $eb01fffcd27d5a8f$var$objectIs = "function" === typeof Object.is ? Object.is : $eb01fffcd27d5a8f$var$is, $eb01fffcd27d5a8f$var$useSyncExternalStore = $gbiuv.useSyncExternalStore, $eb01fffcd27d5a8f$var$useRef = $6aRB8.useRef, $eb01fffcd27d5a8f$var$useEffect = $6aRB8.useEffect, $eb01fffcd27d5a8f$var$useMemo = $6aRB8.useMemo, $eb01fffcd27d5a8f$var$useDebugValue = $6aRB8.useDebugValue;
$eb01fffcd27d5a8f$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $eb01fffcd27d5a8f$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $eb01fffcd27d5a8f$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($eb01fffcd27d5a8f$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $eb01fffcd27d5a8f$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $eb01fffcd27d5a8f$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $eb01fffcd27d5a8f$var$useDebugValue(value);
    return value;
};

});
parcelRegister("gbiuv", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kfSRm"));

});
parcelRegister("kfSRm", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $ebefc3584c52c4a5$export$306c0aa65ff9ec16; }, function (v) { return $ebefc3584c52c4a5$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ebefc3584c52c4a5$export$306c0aa65ff9ec16;
"use strict";

var $6aRB8 = parcelRequire("6aRB8");
function $ebefc3584c52c4a5$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $ebefc3584c52c4a5$var$objectIs = "function" === typeof Object.is ? Object.is : $ebefc3584c52c4a5$var$is, $ebefc3584c52c4a5$var$useState = $6aRB8.useState, $ebefc3584c52c4a5$var$useEffect = $6aRB8.useEffect, $ebefc3584c52c4a5$var$useLayoutEffect = $6aRB8.useLayoutEffect, $ebefc3584c52c4a5$var$useDebugValue = $6aRB8.useDebugValue;
function $ebefc3584c52c4a5$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $ebefc3584c52c4a5$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $ebefc3584c52c4a5$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $ebefc3584c52c4a5$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $ebefc3584c52c4a5$var$useEffect(function() {
        $ebefc3584c52c4a5$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $ebefc3584c52c4a5$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $ebefc3584c52c4a5$var$useDebugValue(value);
    return value;
}
function $ebefc3584c52c4a5$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$ebefc3584c52c4a5$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $ebefc3584c52c4a5$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $ebefc3584c52c4a5$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $ebefc3584c52c4a5$var$useSyncExternalStore$1 : $ebefc3584c52c4a5$var$useSyncExternalStore$2;
$ebefc3584c52c4a5$export$306c0aa65ff9ec16 = void 0 !== $6aRB8.useSyncExternalStore ? $6aRB8.useSyncExternalStore : $ebefc3584c52c4a5$var$shim;

});



parcelRegister("1wW4r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11d5d3342ab31c43$export$2e2bcd8739ae039; });

var $2kosG = parcelRequire("2kosG");

var $clUeB = parcelRequire("clUeB");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2kosG.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $clUeB.default);
var $11d5d3342ab31c43$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("2kosG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b206c9314f26066$export$2e2bcd8739ae039; });

var $a1BoP = parcelRequire("a1BoP");
/** Detect free variable `self`. */ var $1b206c9314f26066$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b206c9314f26066$var$root = (0, $a1BoP.default) || $1b206c9314f26066$var$freeSelf || Function('return this')();
var $1b206c9314f26066$export$2e2bcd8739ae039 = $1b206c9314f26066$var$root;

});
parcelRegister("a1BoP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74c7022085fd9e6e$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $74c7022085fd9e6e$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $74c7022085fd9e6e$export$2e2bcd8739ae039 = $74c7022085fd9e6e$var$freeGlobal;

});


parcelRegister("clUeB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fe31137b518617a$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $8fe31137b518617a$var$stubFalse() {
    return false;
}
var $8fe31137b518617a$export$2e2bcd8739ae039 = $8fe31137b518617a$var$stubFalse;

});


parcelRegister("hkpCq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9d82d4827fc6f0c$export$2e2bcd8739ae039; });

var $a1BoP = parcelRequire("a1BoP");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $a1BoP.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $c9d82d4827fc6f0c$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRegister("e877a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

var $jrKKx = parcelRequire("jrKKx");


var $6aRB8 = parcelRequire("6aRB8");
function $a49754d646294c24$var$_typeof(e) {
    return ($a49754d646294c24$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
}
function $a49754d646294c24$var$_classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $a49754d646294c24$var$_defineProperties(e, t) {
    for(var n = 0; n < t.length; n++){
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
}
function $a49754d646294c24$var$_createClass(e, t, n) {
    return t && $a49754d646294c24$var$_defineProperties(e.prototype, t), n && $a49754d646294c24$var$_defineProperties(e, n), e;
}
function $a49754d646294c24$var$_defineProperty(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $a49754d646294c24$var$_inherits(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
        constructor: {
            value: e,
            writable: !0,
            configurable: !0
        }
    }), t && $a49754d646294c24$var$_setPrototypeOf(e, t);
}
function $a49754d646294c24$var$_getPrototypeOf(e) {
    return ($a49754d646294c24$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
}
function $a49754d646294c24$var$_setPrototypeOf(e, t) {
    return ($a49754d646294c24$var$_setPrototypeOf = Object.setPrototypeOf || function(e, t) {
        return e.__proto__ = t, e;
    })(e, t);
}
function $a49754d646294c24$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $a49754d646294c24$var$_possibleConstructorReturn(e, t) {
    return !t || "object" != typeof t && "function" != typeof t ? $a49754d646294c24$var$_assertThisInitialized(e) : t;
}
var $a49754d646294c24$var$EventSet = function() {
    function e(t) {
        $a49754d646294c24$var$_classCallCheck(this, e), $a49754d646294c24$var$_defineProperty(this, "handlers", void 0), this.handlers = t.slice(0);
    }
    return $a49754d646294c24$var$_createClass(e, [
        {
            key: "addHandlers",
            value: function(t) {
                for(var n = this.handlers.slice(0), r = t.length, o = 0; o < r; o += 1)n.push(t[o]);
                return new e(n);
            }
        },
        {
            key: "dispatchEvent",
            value: function(e, t) {
                var n = this.handlers.length - 1;
                if (t) {
                    for(var r = n; r >= 0; r -= 1)this.handlers[r].called || (this.handlers[r].called = !0, this.handlers[r](e));
                    for(var o = n; o >= 0; o -= 1)this.handlers[o].called = !1;
                } else (0, this.handlers[n])(e);
            }
        },
        {
            key: "hasHandlers",
            value: function() {
                return this.handlers.length > 0;
            }
        },
        {
            key: "removeHandlers",
            value: function(t) {
                for(var n = [], r = this.handlers.length, o = 0; o < r; o += 1){
                    var a = this.handlers[o];
                    -1 === t.indexOf(a) && n.push(a);
                }
                return new e(n);
            }
        }
    ]), e;
}();
function $a49754d646294c24$var$cloneMap(e) {
    var t = new Map;
    return e.forEach(function(e, n) {
        t.set(n, e);
    }), t;
}
function $a49754d646294c24$var$normalizeHandlers(e) {
    return Array.isArray(e) ? e : [
        e
    ];
}
var $a49754d646294c24$var$isRefObject = function(e) {
    return null !== e && "object" === $a49754d646294c24$var$_typeof(e) && e.hasOwnProperty("current");
};
function $a49754d646294c24$var$normalizeTarget(e) {
    return "document" === e ? document : "window" === e ? window : $a49754d646294c24$var$isRefObject(e) ? e.current || document : e || document;
}
var $a49754d646294c24$var$EventPool = function() {
    function e(t, n) {
        $a49754d646294c24$var$_classCallCheck(this, e), $a49754d646294c24$var$_defineProperty(this, "handlerSets", void 0), $a49754d646294c24$var$_defineProperty(this, "poolName", void 0), this.handlerSets = n, this.poolName = t;
    }
    return $a49754d646294c24$var$_createClass(e, [
        {
            key: "addHandlers",
            value: function(t, n) {
                var r = $a49754d646294c24$var$cloneMap(this.handlerSets);
                if (r.has(t)) {
                    var o = r.get(t);
                    r.set(t, o.addHandlers(n));
                } else r.set(t, new $a49754d646294c24$var$EventSet(n));
                return new e(this.poolName, r);
            }
        },
        {
            key: "dispatchEvent",
            value: function(e, t) {
                var n = this.handlerSets.get(e), r = "default" === this.poolName;
                n && n.dispatchEvent(t, r);
            }
        },
        {
            key: "hasHandlers",
            value: function(e) {
                if (!e) return this.handlerSets.size > 0;
                var t = this.handlerSets.get(e);
                return !!t && t.hasHandlers();
            }
        },
        {
            key: "removeHandlers",
            value: function(t, n) {
                var r = $a49754d646294c24$var$cloneMap(this.handlerSets);
                if (!r.has(t)) return new e(this.poolName, r);
                var o = r.get(t).removeHandlers(n);
                return o.hasHandlers() ? r.set(t, o) : r.delete(t), new e(this.poolName, r);
            }
        }
    ]), e;
}();
$a49754d646294c24$var$_defineProperty($a49754d646294c24$var$EventPool, "createByType", function(e, t, n) {
    var r = new Map;
    return r.set(t, new $a49754d646294c24$var$EventSet(n)), new $a49754d646294c24$var$EventPool(e, r);
});
var $a49754d646294c24$var$EventTarget = function() {
    function e(t) {
        var n = this;
        $a49754d646294c24$var$_classCallCheck(this, e), $a49754d646294c24$var$_defineProperty(this, "handlers", new Map), $a49754d646294c24$var$_defineProperty(this, "pools", new Map), $a49754d646294c24$var$_defineProperty(this, "target", void 0), $a49754d646294c24$var$_defineProperty(this, "createEmitter", function(e) {
            return function(t) {
                n.pools.forEach(function(n) {
                    n.dispatchEvent(e, t);
                });
            };
        }), this.target = t;
    }
    return $a49754d646294c24$var$_createClass(e, [
        {
            key: "addHandlers",
            value: function(e, t, n) {
                if (this.pools.has(e)) {
                    var r = this.pools.get(e);
                    this.pools.set(e, r.addHandlers(t, n));
                } else this.pools.set(e, $a49754d646294c24$var$EventPool.createByType(e, t, n));
                this.handlers.has(t) || this.addTargetHandler(t);
            }
        },
        {
            key: "hasHandlers",
            value: function() {
                return this.handlers.size > 0;
            }
        },
        {
            key: "removeHandlers",
            value: function(e, t, n) {
                if (this.pools.has(e)) {
                    var r = this.pools.get(e).removeHandlers(t, n);
                    r.hasHandlers() ? this.pools.set(e, r) : this.pools.delete(e);
                    var o = !1;
                    this.pools.forEach(function(e) {
                        return o = o || e.hasHandlers(t);
                    }), o || this.removeTargetHandler(t);
                }
            }
        },
        {
            key: "addTargetHandler",
            value: function(e) {
                var t = this.createEmitter(e);
                this.handlers.set(e, t), this.target.addEventListener(e, t, !0);
            }
        },
        {
            key: "removeTargetHandler",
            value: function(e) {
                this.handlers.has(e) && (this.target.removeEventListener(e, this.handlers.get(e), !0), this.handlers.delete(e));
            }
        }
    ]), e;
}(), $a49754d646294c24$var$EventStack = function() {
    function e() {
        var t = this;
        $a49754d646294c24$var$_classCallCheck(this, e), $a49754d646294c24$var$_defineProperty(this, "targets", new Map), $a49754d646294c24$var$_defineProperty(this, "getTarget", function(e) {
            var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = $a49754d646294c24$var$normalizeTarget(e);
            if (t.targets.has(r)) return t.targets.get(r);
            if (!n) return null;
            var o = new $a49754d646294c24$var$EventTarget(r);
            return t.targets.set(r, o), o;
        }), $a49754d646294c24$var$_defineProperty(this, "removeTarget", function(e) {
            t.targets.delete($a49754d646294c24$var$normalizeTarget(e));
        });
    }
    return $a49754d646294c24$var$_createClass(e, [
        {
            key: "sub",
            value: function(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if ($jrKKx.canUseDOM) {
                    var r = n.target, o = void 0 === r ? document : r, a = n.pool, s = void 0 === a ? "default" : a;
                    this.getTarget(o).addHandlers(s, e, $a49754d646294c24$var$normalizeHandlers(t));
                }
            }
        },
        {
            key: "unsub",
            value: function(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if ($jrKKx.canUseDOM) {
                    var r = n.target, o = void 0 === r ? document : r, a = n.pool, s = void 0 === a ? "default" : a, i = this.getTarget(o, !1);
                    i && (i.removeHandlers(s, e, $a49754d646294c24$var$normalizeHandlers(t)), i.hasHandlers() || this.removeTarget(o));
                }
            }
        }
    ]), e;
}(), $a49754d646294c24$var$instance = new $a49754d646294c24$var$EventStack, $a49754d646294c24$var$EventStack$1 = function(e) {
    function t() {
        return $a49754d646294c24$var$_classCallCheck(this, t), $a49754d646294c24$var$_possibleConstructorReturn(this, $a49754d646294c24$var$_getPrototypeOf(t).apply(this, arguments));
    }
    return $a49754d646294c24$var$_inherits(t, $6aRB8.PureComponent), $a49754d646294c24$var$_createClass(t, [
        {
            key: "componentDidMount",
            value: function() {
                this.subscribe(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function(e) {
                this.unsubscribe(e), this.subscribe(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                this.unsubscribe(this.props);
            }
        },
        {
            key: "subscribe",
            value: function(e) {
                var t = e.name, n = e.on, r = e.pool, o = e.target;
                $a49754d646294c24$var$instance.sub(t, n, {
                    pool: r,
                    target: o
                });
            }
        },
        {
            key: "unsubscribe",
            value: function(e) {
                var t = e.name, n = e.on, r = e.pool, o = e.target;
                $a49754d646294c24$var$instance.unsub(t, n, {
                    pool: r,
                    target: o
                });
            }
        },
        {
            key: "render",
            value: function() {
                return null;
            }
        }
    ]), t;
}();
$a49754d646294c24$var$_defineProperty($a49754d646294c24$var$EventStack$1, "defaultProps", {
    pool: "default",
    target: "document"
}), $a49754d646294c24$var$EventStack$1.propTypes = {}, module.exports.instance = $a49754d646294c24$var$instance, module.exports.default = $a49754d646294c24$var$EventStack$1;

});
parcelRegister("jrKKx", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});


parcelRegister("g7o4x", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("4bMTH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $30ce1e83929c455b$var$ReactIs, $30ce1e83929c455b$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("cALPN"))();

});

/* eslint react/jsx-filename-extension: 0 */ var $cd58308bfc2f0eb2$exports = {};
'use strict';

$cd58308bfc2f0eb2$exports = (parcelRequire("4qeEp"));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
const $8e91a29fca34c6c0$export$13470c6f1642bbce = 'Logging';
const $8e91a29fca34c6c0$export$16032fc466434892 = 'x-amz-user-agent';
// Error exception code constants
const $8e91a29fca34c6c0$export$86d53207c3c20049 = 'NoHubcallbackProvidedException';


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $b256d095927368bd$export$a0472aa3a356446c;
(function(LogType) {
    LogType["DEBUG"] = "DEBUG";
    LogType["ERROR"] = "ERROR";
    LogType["INFO"] = "INFO";
    LogType["WARN"] = "WARN";
    LogType["VERBOSE"] = "VERBOSE";
    LogType["NONE"] = "NONE";
})($b256d095927368bd$export$a0472aa3a356446c || ($b256d095927368bd$export$a0472aa3a356446c = {}));


/* eslint-disable no-console */ // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $294c375a4ec5088f$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
    NONE: 6
};
/**
 * Write logs
 * @class Logger
 */ class $294c375a4ec5088f$export$ba6a9c7ac8291f7f {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ constructor(name, level = (0, $b256d095927368bd$export$a0472aa3a356446c).WARN){
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    _padding(n) {
        return n < 10 ? '0' + n : '' + n;
    }
    _ts() {
        const dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(':') + '.' + dt.getMilliseconds();
    }
    configure(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    }
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LogType|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ _log(type, ...msg) {
        let loggerLevelName = this.level;
        if ($294c375a4ec5088f$export$ba6a9c7ac8291f7f.LOG_LEVEL) loggerLevelName = $294c375a4ec5088f$export$ba6a9c7ac8291f7f.LOG_LEVEL;
        if (typeof window !== 'undefined' && window.LOG_LEVEL) loggerLevelName = window.LOG_LEVEL;
        const loggerLevel = $294c375a4ec5088f$var$LOG_LEVELS[loggerLevelName];
        const typeLevel = $294c375a4ec5088f$var$LOG_LEVELS[type];
        if (!(typeLevel >= loggerLevel)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        let log = console.log.bind(console);
        if (type === (0, $b256d095927368bd$export$a0472aa3a356446c).ERROR && console.error) log = console.error.bind(console);
        if (type === (0, $b256d095927368bd$export$a0472aa3a356446c).WARN && console.warn) log = console.warn.bind(console);
        if ($294c375a4ec5088f$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS) {
            if (type === (0, $b256d095927368bd$export$a0472aa3a356446c).INFO && console.info) log = console.info.bind(console);
            if (type === (0, $b256d095927368bd$export$a0472aa3a356446c).DEBUG && console.debug) log = console.debug.bind(console);
        }
        const prefix = `[${type}] ${this._ts()} ${this.name}`;
        let message = '';
        if (msg.length === 1 && typeof msg[0] === 'string') {
            message = `${prefix} - ${msg[0]}`;
            log(message);
        } else if (msg.length === 1) {
            message = `${prefix} ${msg[0]}`;
            log(prefix, msg[0]);
        } else if (typeof msg[0] === 'string') {
            let obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = `${prefix} - ${msg[0]} ${obj}`;
            log(`${prefix} - ${msg[0]}`, obj);
        } else {
            message = `${prefix} ${msg}`;
            log(prefix, msg);
        }
        for (const plugin of this._pluggables){
            const logEvent = {
                message: message,
                timestamp: Date.now()
            };
            plugin.pushLogs([
                logEvent
            ]);
        }
    }
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ log(...msg) {
        this._log((0, $b256d095927368bd$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ info(...msg) {
        this._log((0, $b256d095927368bd$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ warn(...msg) {
        this._log((0, $b256d095927368bd$export$a0472aa3a356446c).WARN, ...msg);
    }
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ error(...msg) {
        this._log((0, $b256d095927368bd$export$a0472aa3a356446c).ERROR, ...msg);
    }
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ debug(...msg) {
        this._log((0, $b256d095927368bd$export$a0472aa3a356446c).DEBUG, ...msg);
    }
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ verbose(...msg) {
        this._log((0, $b256d095927368bd$export$a0472aa3a356446c).VERBOSE, ...msg);
    }
    addPluggable(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $8e91a29fca34c6c0$export$13470c6f1642bbce)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    }
    listPluggables() {
        return this._pluggables;
    }
}
$294c375a4ec5088f$export$ba6a9c7ac8291f7f.LOG_LEVEL = null;
$294c375a4ec5088f$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS = false;



class $c848663d1100c12f$export$37321a6dace1881c extends Error {
    /**
     *  Constructs an AmplifyError.
     *
     * @param message text that describes the main problem.
     * @param underlyingError the underlying cause of the error.
     * @param recoverySuggestion suggestion to recover from the error.
     *
     */ constructor({ message: message, name: name, recoverySuggestion: recoverySuggestion, underlyingError: underlyingError, metadata: metadata }){
        super(message);
        this.name = name;
        this.underlyingError = underlyingError;
        this.recoverySuggestion = recoverySuggestion;
        if (metadata) {
            // If metadata exists, explicitly only record the following properties.
            const { extendedRequestId: extendedRequestId, httpStatusCode: httpStatusCode, requestId: requestId } = metadata;
            this.metadata = {
                extendedRequestId: extendedRequestId,
                httpStatusCode: httpStatusCode,
                requestId: requestId
            };
        }
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $c848663d1100c12f$export$37321a6dace1881c;
        Object.setPrototypeOf(this, $c848663d1100c12f$export$37321a6dace1881c.prototype);
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7c7b61d0858d9585$export$aadf71dd9875dd20 = typeof Symbol !== 'undefined' ? Symbol('amplify_default') : '@@amplify_default';
const $7c7b61d0858d9585$var$logger = new (0, $294c375a4ec5088f$export$ba6a9c7ac8291f7f)('Hub');
class $7c7b61d0858d9585$export$6b38ef2be9abbbb9 {
    constructor(name){
        this.listeners = new Map();
        this.protectedChannels = [
            'core',
            'auth',
            'api',
            'analytics',
            'interactions',
            'pubsub',
            'storage',
            'ui',
            'xr'
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ _remove(channel, listener) {
        const holder = this.listeners.get(channel);
        if (!holder) {
            $7c7b61d0858d9585$var$logger.warn(`No listeners for ${channel}`);
            return;
        }
        this.listeners.set(channel, [
            ...holder.filter(({ callback: callback })=>callback !== listener)
        ]);
    }
    dispatch(channel, payload, source, ampSymbol) {
        if (typeof channel === 'string' && this.protectedChannels.indexOf(channel) > -1) {
            const hasAccess = ampSymbol === $7c7b61d0858d9585$export$aadf71dd9875dd20;
            if (!hasAccess) $7c7b61d0858d9585$var$logger.warn(`WARNING: ${channel} is protected and dispatching on it can have unintended consequences`);
        }
        const capsule = {
            channel: channel,
            payload: {
                ...payload
            },
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $7c7b61d0858d9585$var$logger.error(e);
        }
    }
    listen(channel, callback, listenerName = 'noname') {
        let cb;
        if (typeof callback !== 'function') throw new (0, $c848663d1100c12f$export$37321a6dace1881c)({
            name: (0, $8e91a29fca34c6c0$export$86d53207c3c20049),
            message: 'No callback supplied to Hub'
        });
        else // Needs to be casted as a more generic type
        cb = callback;
        let holder = this.listeners.get(channel);
        if (!holder) {
            holder = [];
            this.listeners.set(channel, holder);
        }
        holder.push({
            name: listenerName,
            callback: cb
        });
        return ()=>{
            this._remove(channel, cb);
        };
    }
    _toListeners(capsule) {
        const { channel: channel, payload: payload } = capsule;
        const holder = this.listeners.get(channel);
        if (holder) holder.forEach((listener)=>{
            $7c7b61d0858d9585$var$logger.debug(`Dispatching to ${channel} with `, payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $7c7b61d0858d9585$var$logger.error(e);
            }
        });
    }
}
/* We export a __default__ instance of HubClass to use it as a
pseudo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events. */ const $7c7b61d0858d9585$export$8c41bb232f1008b1 = new $7c7b61d0858d9585$export$6b38ef2be9abbbb9('__default__');
/**
 * @internal
 *
 * Internal hub used for core Amplify functionality. Not intended for use outside of Amplify.
 *
 */ const $7c7b61d0858d9585$export$45dde0743a4c8d6e = new $7c7b61d0858d9585$export$6b38ef2be9abbbb9('internal-hub');






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e4ca7b58aa7f1eb6$export$7e32b29e1cb162e1 = (object)=>{
    const propNames = Reflect.ownKeys(object);
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === 'object' || typeof value === 'function') $e4ca7b58aa7f1eb6$export$7e32b29e1cb162e1(value);
    }
    return Object.freeze(object);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $34cc7e2a3c52f094$export$35210b3191d26437 = Symbol('oauth-listener');







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $b615537506e3f1e4$var$logger = new (0, $294c375a4ec5088f$export$ba6a9c7ac8291f7f)('parseAWSExports');
const $b615537506e3f1e4$var$authTypeMapping = {
    API_KEY: 'apiKey',
    AWS_IAM: 'iam',
    AMAZON_COGNITO_USER_POOLS: 'userPool',
    OPENID_CONNECT: 'oidc',
    NONE: 'none',
    AWS_LAMBDA: 'lambda',
    // `LAMBDA` is an incorrect value that was added during the v6 rewrite.
    // Keeping it as a valid value until v7 to prevent breaking customers who might
    // be relying on it as a workaround.
    // ref: https://github.com/aws-amplify/amplify-js/pull/12922
    // TODO: @v7 remove next line
    LAMBDA: 'lambda'
};
/**
 * Converts the object imported from `aws-exports.js` or `amplifyconfiguration.json` files generated by
 * the Amplify CLI into an object that conforms to the {@link ResourcesConfig}.
 *
 * @param config A configuration object imported  from `aws-exports.js` or `amplifyconfiguration.json`.
 *
 * @returns An object that conforms to the {@link ResourcesConfig} .
 */ const $b615537506e3f1e4$export$1ef2e9c2da492d = (config = {})=>{
    if (!Object.prototype.hasOwnProperty.call(config, 'aws_project_region')) throw new (0, $c848663d1100c12f$export$37321a6dace1881c)({
        name: 'InvalidParameterException',
        message: 'Invalid config parameter.',
        recoverySuggestion: 'Ensure passing the config object imported from  `amplifyconfiguration.json`.'
    });
    const { aws_appsync_apiKey: aws_appsync_apiKey, aws_appsync_authenticationType: aws_appsync_authenticationType, aws_appsync_graphqlEndpoint: aws_appsync_graphqlEndpoint, aws_appsync_region: aws_appsync_region, aws_bots_config: aws_bots_config, aws_cognito_identity_pool_id: aws_cognito_identity_pool_id, aws_cognito_sign_up_verification_method: aws_cognito_sign_up_verification_method, aws_cognito_mfa_configuration: aws_cognito_mfa_configuration, aws_cognito_mfa_types: aws_cognito_mfa_types, aws_cognito_password_protection_settings: aws_cognito_password_protection_settings, aws_cognito_verification_mechanisms: aws_cognito_verification_mechanisms, aws_cognito_signup_attributes: aws_cognito_signup_attributes, aws_cognito_social_providers: aws_cognito_social_providers, aws_cognito_username_attributes: aws_cognito_username_attributes, aws_mandatory_sign_in: aws_mandatory_sign_in, aws_mobile_analytics_app_id: aws_mobile_analytics_app_id, aws_mobile_analytics_app_region: aws_mobile_analytics_app_region, aws_user_files_s3_bucket: aws_user_files_s3_bucket, aws_user_files_s3_bucket_region: aws_user_files_s3_bucket_region, aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing, aws_user_pools_id: aws_user_pools_id, aws_user_pools_web_client_id: aws_user_pools_web_client_id, geo: geo, oauth: oauth, predictions: predictions, aws_cloud_logic_custom: aws_cloud_logic_custom, Notifications: Notifications, modelIntrospection: modelIntrospection } = config;
    const amplifyConfig = {};
    // Analytics
    if (aws_mobile_analytics_app_id) amplifyConfig.Analytics = {
        Pinpoint: {
            appId: aws_mobile_analytics_app_id,
            region: aws_mobile_analytics_app_region
        }
    };
    // Notifications
    const { InAppMessaging: InAppMessaging, Push: Push } = Notifications ?? {};
    if (InAppMessaging?.AWSPinpoint || Push?.AWSPinpoint) {
        if (InAppMessaging?.AWSPinpoint) {
            const { appId: appId, region: region } = InAppMessaging.AWSPinpoint;
            amplifyConfig.Notifications = {
                InAppMessaging: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
        if (Push?.AWSPinpoint) {
            const { appId: appId, region: region } = Push.AWSPinpoint;
            amplifyConfig.Notifications = {
                ...amplifyConfig.Notifications,
                PushNotification: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
    }
    // Interactions
    if (Array.isArray(aws_bots_config)) amplifyConfig.Interactions = {
        LexV1: Object.fromEntries(aws_bots_config.map((bot)=>[
                bot.name,
                bot
            ]))
    };
    // API
    if (aws_appsync_graphqlEndpoint) {
        const defaultAuthMode = $b615537506e3f1e4$var$authTypeMapping[aws_appsync_authenticationType];
        if (!defaultAuthMode) $b615537506e3f1e4$var$logger.debug(`Invalid authentication type ${aws_appsync_authenticationType}. Falling back to IAM.`);
        amplifyConfig.API = {
            GraphQL: {
                endpoint: aws_appsync_graphqlEndpoint,
                apiKey: aws_appsync_apiKey,
                region: aws_appsync_region,
                defaultAuthMode: defaultAuthMode ?? 'iam'
            }
        };
        if (modelIntrospection) amplifyConfig.API.GraphQL.modelIntrospection = modelIntrospection;
    }
    // Auth
    const mfaConfig = aws_cognito_mfa_configuration ? {
        status: aws_cognito_mfa_configuration && aws_cognito_mfa_configuration.toLowerCase(),
        totpEnabled: aws_cognito_mfa_types?.includes('TOTP') ?? false,
        smsEnabled: aws_cognito_mfa_types?.includes('SMS') ?? false
    } : undefined;
    const passwordFormatConfig = aws_cognito_password_protection_settings ? {
        minLength: aws_cognito_password_protection_settings.passwordPolicyMinLength,
        requireLowercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes('REQUIRES_LOWERCASE') ?? false,
        requireUppercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes('REQUIRES_UPPERCASE') ?? false,
        requireNumbers: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes('REQUIRES_NUMBERS') ?? false,
        requireSpecialCharacters: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes('REQUIRES_SYMBOLS') ?? false
    } : undefined;
    const mergedUserAttributes = Array.from(new Set([
        ...aws_cognito_verification_mechanisms ?? [],
        ...aws_cognito_signup_attributes ?? []
    ]));
    const userAttributes = mergedUserAttributes.reduce((attributes, key)=>({
            ...attributes,
            // All user attributes generated by the CLI are required
            [key.toLowerCase()]: {
                required: true
            }
        }), {});
    const loginWithEmailEnabled = aws_cognito_username_attributes?.includes('EMAIL') ?? false;
    const loginWithPhoneEnabled = aws_cognito_username_attributes?.includes('PHONE_NUMBER') ?? false;
    if (aws_cognito_identity_pool_id || aws_user_pools_id) amplifyConfig.Auth = {
        Cognito: {
            identityPoolId: aws_cognito_identity_pool_id,
            allowGuestAccess: aws_mandatory_sign_in !== 'enable',
            signUpVerificationMethod: aws_cognito_sign_up_verification_method,
            userAttributes: userAttributes,
            userPoolClientId: aws_user_pools_web_client_id,
            userPoolId: aws_user_pools_id,
            mfa: mfaConfig,
            passwordFormat: passwordFormatConfig,
            loginWith: {
                username: !(loginWithEmailEnabled || loginWithPhoneEnabled),
                email: loginWithEmailEnabled,
                phone: loginWithPhoneEnabled
            }
        }
    };
    const hasOAuthConfig = oauth ? Object.keys(oauth).length > 0 : false;
    const hasSocialProviderConfig = aws_cognito_social_providers ? aws_cognito_social_providers.length > 0 : false;
    if (amplifyConfig.Auth && hasOAuthConfig) amplifyConfig.Auth.Cognito.loginWith = {
        ...amplifyConfig.Auth.Cognito.loginWith,
        oauth: {
            ...$b615537506e3f1e4$var$getOAuthConfig(oauth),
            ...hasSocialProviderConfig && {
                providers: $b615537506e3f1e4$var$parseSocialProviders(aws_cognito_social_providers)
            }
        }
    };
    // Storage
    if (aws_user_files_s3_bucket) amplifyConfig.Storage = {
        S3: {
            bucket: aws_user_files_s3_bucket,
            region: aws_user_files_s3_bucket_region,
            dangerouslyConnectToHttpEndpointForTesting: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
        }
    };
    // Geo
    if (geo) {
        const { amazon_location_service: amazon_location_service } = geo;
        amplifyConfig.Geo = {
            LocationService: {
                maps: amazon_location_service.maps,
                geofenceCollections: amazon_location_service.geofenceCollections,
                searchIndices: amazon_location_service.search_indices,
                region: amazon_location_service.region
            }
        };
    }
    // REST API
    if (aws_cloud_logic_custom) amplifyConfig.API = {
        ...amplifyConfig.API,
        REST: aws_cloud_logic_custom.reduce((acc, api)=>{
            const { name: name, endpoint: endpoint, region: region, service: service } = api;
            return {
                ...acc,
                [name]: {
                    endpoint: endpoint,
                    ...service ? {
                        service: service
                    } : undefined,
                    ...region ? {
                        region: region
                    } : undefined
                }
            };
        }, {})
    };
    // Predictions
    if (predictions) {
        // map VoiceId from speechGenerator defaults to voiceId
        const { VoiceId: voiceId } = predictions?.convert?.speechGenerator?.defaults ?? {};
        amplifyConfig.Predictions = voiceId ? {
            ...predictions,
            convert: {
                ...predictions.convert,
                speechGenerator: {
                    ...predictions.convert.speechGenerator,
                    defaults: {
                        voiceId: voiceId
                    }
                }
            }
        } : predictions;
    }
    return amplifyConfig;
};
const $b615537506e3f1e4$var$getRedirectUrl = (redirectStr)=>redirectStr?.split(',') ?? [];
const $b615537506e3f1e4$var$getOAuthConfig = ({ domain: domain, scope: scope, redirectSignIn: redirectSignIn, redirectSignOut: redirectSignOut, responseType: responseType })=>({
        domain: domain,
        scopes: scope,
        redirectSignIn: $b615537506e3f1e4$var$getRedirectUrl(redirectSignIn),
        redirectSignOut: $b615537506e3f1e4$var$getRedirectUrl(redirectSignOut),
        responseType: responseType
    });
const $b615537506e3f1e4$var$parseSocialProviders = (aws_cognito_social_providers)=>{
    return aws_cognito_social_providers.map((provider)=>{
        const updatedProvider = provider.toLowerCase();
        return updatedProvider.charAt(0).toUpperCase() + updatedProvider.slice(1);
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $d089d28a3f331f70$export$99bf765e6322c00(config) {
    // version format initially will be '1' but is expected to be something like x.y where x is major and y minor version
    const { version: version } = config;
    if (!version) return false;
    return version.startsWith('1');
}
function $d089d28a3f331f70$var$parseStorage(amplifyOutputsStorageProperties) {
    if (!amplifyOutputsStorageProperties) return undefined;
    const { bucket_name: bucket_name, aws_region: aws_region, buckets: buckets } = amplifyOutputsStorageProperties;
    return {
        S3: {
            bucket: bucket_name,
            region: aws_region,
            buckets: buckets && $d089d28a3f331f70$var$createBucketInfoMap(buckets)
        }
    };
}
function $d089d28a3f331f70$var$parseAuth(amplifyOutputsAuthProperties) {
    if (!amplifyOutputsAuthProperties) return undefined;
    const { user_pool_id: user_pool_id, user_pool_client_id: user_pool_client_id, identity_pool_id: identity_pool_id, password_policy: password_policy, mfa_configuration: mfa_configuration, mfa_methods: mfa_methods, unauthenticated_identities_enabled: unauthenticated_identities_enabled, oauth: oauth, username_attributes: username_attributes, standard_required_attributes: standard_required_attributes, groups: groups, passwordless: passwordless } = amplifyOutputsAuthProperties;
    const authConfig = {
        Cognito: {
            userPoolId: user_pool_id,
            userPoolClientId: user_pool_client_id,
            groups: groups
        }
    };
    if (identity_pool_id) authConfig.Cognito = {
        ...authConfig.Cognito,
        identityPoolId: identity_pool_id
    };
    if (password_policy) authConfig.Cognito.passwordFormat = {
        requireLowercase: password_policy.require_lowercase,
        requireNumbers: password_policy.require_numbers,
        requireUppercase: password_policy.require_uppercase,
        requireSpecialCharacters: password_policy.require_symbols,
        minLength: password_policy.min_length ?? 6
    };
    if (mfa_configuration) authConfig.Cognito.mfa = {
        status: $d089d28a3f331f70$var$getMfaStatus(mfa_configuration),
        smsEnabled: mfa_methods?.includes('SMS'),
        totpEnabled: mfa_methods?.includes('TOTP')
    };
    if (unauthenticated_identities_enabled) authConfig.Cognito.allowGuestAccess = unauthenticated_identities_enabled;
    if (oauth) authConfig.Cognito.loginWith = {
        oauth: {
            domain: oauth.domain,
            redirectSignIn: oauth.redirect_sign_in_uri,
            redirectSignOut: oauth.redirect_sign_out_uri,
            responseType: oauth.response_type === 'token' ? 'token' : 'code',
            scopes: oauth.scopes,
            providers: $d089d28a3f331f70$var$getOAuthProviders(oauth.identity_providers)
        }
    };
    if (username_attributes) authConfig.Cognito.loginWith = {
        ...authConfig.Cognito.loginWith,
        email: username_attributes.includes('email'),
        phone: username_attributes.includes('phone_number'),
        // Signing in with a username is not currently supported in Gen2, this should always evaluate to false
        username: username_attributes.includes('username')
    };
    if (standard_required_attributes) authConfig.Cognito.userAttributes = standard_required_attributes.reduce((acc, curr)=>({
            ...acc,
            [curr]: {
                required: true
            }
        }), {});
    if (passwordless) authConfig.Cognito.passwordless = {
        emailOtpEnabled: passwordless.email_otp_enabled,
        smsOtpEnabled: passwordless.sms_otp_enabled,
        webAuthn: passwordless.web_authn ? {
            relyingPartyId: passwordless.web_authn.relying_party_id,
            userVerification: passwordless.web_authn.user_verification
        } : undefined,
        preferredChallenge: passwordless.preferred_challenge
    };
    return authConfig;
}
function $d089d28a3f331f70$export$fbb0a2a08db9629a(amplifyOutputsAnalyticsProperties) {
    if (!amplifyOutputsAnalyticsProperties?.amazon_pinpoint) return undefined;
    const { amazon_pinpoint: amazon_pinpoint } = amplifyOutputsAnalyticsProperties;
    return {
        Pinpoint: {
            appId: amazon_pinpoint.app_id,
            region: amazon_pinpoint.aws_region
        }
    };
}
function $d089d28a3f331f70$var$parseGeo(amplifyOutputsAnalyticsProperties) {
    if (!amplifyOutputsAnalyticsProperties) return undefined;
    const { aws_region: aws_region, geofence_collections: geofence_collections, maps: maps, search_indices: search_indices } = amplifyOutputsAnalyticsProperties;
    return {
        LocationService: {
            region: aws_region,
            searchIndices: search_indices,
            geofenceCollections: geofence_collections,
            maps: maps
        }
    };
}
function $d089d28a3f331f70$var$parseData(amplifyOutputsDataProperties) {
    if (!amplifyOutputsDataProperties) return undefined;
    const { aws_region: aws_region, default_authorization_type: default_authorization_type, url: url, api_key: api_key, model_introspection: model_introspection } = amplifyOutputsDataProperties;
    const GraphQL = {
        endpoint: url,
        defaultAuthMode: $d089d28a3f331f70$var$getGraphQLAuthMode(default_authorization_type),
        region: aws_region,
        apiKey: api_key,
        modelIntrospection: model_introspection
    };
    return {
        GraphQL: GraphQL
    };
}
function $d089d28a3f331f70$var$parseCustom(amplifyOutputsCustomProperties) {
    if (!amplifyOutputsCustomProperties?.events) return undefined;
    const { url: url, aws_region: aws_region, api_key: api_key, default_authorization_type: default_authorization_type } = amplifyOutputsCustomProperties.events;
    const Events = {
        endpoint: url,
        defaultAuthMode: $d089d28a3f331f70$var$getGraphQLAuthMode(default_authorization_type),
        region: aws_region,
        apiKey: api_key
    };
    return {
        Events: Events
    };
}
function $d089d28a3f331f70$var$parseNotifications(amplifyOutputsNotificationsProperties) {
    if (!amplifyOutputsNotificationsProperties) return undefined;
    const { aws_region: aws_region, channels: channels, amazon_pinpoint_app_id: amazon_pinpoint_app_id } = amplifyOutputsNotificationsProperties;
    const hasInAppMessaging = channels.includes('IN_APP_MESSAGING');
    const hasPushNotification = channels.includes('APNS') || channels.includes('FCM');
    if (!(hasInAppMessaging || hasPushNotification)) return undefined;
    // At this point, we know the Amplify outputs contains at least one supported channel
    const notificationsConfig = {};
    if (hasInAppMessaging) notificationsConfig.InAppMessaging = {
        Pinpoint: {
            appId: amazon_pinpoint_app_id,
            region: aws_region
        }
    };
    if (hasPushNotification) notificationsConfig.PushNotification = {
        Pinpoint: {
            appId: amazon_pinpoint_app_id,
            region: aws_region
        }
    };
    return notificationsConfig;
}
function $d089d28a3f331f70$export$11d0da171d17ab63(amplifyOutputs) {
    const resourcesConfig = {};
    if (amplifyOutputs.storage) resourcesConfig.Storage = $d089d28a3f331f70$var$parseStorage(amplifyOutputs.storage);
    if (amplifyOutputs.auth) resourcesConfig.Auth = $d089d28a3f331f70$var$parseAuth(amplifyOutputs.auth);
    if (amplifyOutputs.analytics) resourcesConfig.Analytics = $d089d28a3f331f70$export$fbb0a2a08db9629a(amplifyOutputs.analytics);
    if (amplifyOutputs.geo) resourcesConfig.Geo = $d089d28a3f331f70$var$parseGeo(amplifyOutputs.geo);
    if (amplifyOutputs.data) resourcesConfig.API = $d089d28a3f331f70$var$parseData(amplifyOutputs.data);
    if (amplifyOutputs.custom) {
        const customConfig = $d089d28a3f331f70$var$parseCustom(amplifyOutputs.custom);
        if (customConfig && 'Events' in customConfig) resourcesConfig.API = {
            ...resourcesConfig.API,
            ...customConfig
        };
    }
    if (amplifyOutputs.notifications) resourcesConfig.Notifications = $d089d28a3f331f70$var$parseNotifications(amplifyOutputs.notifications);
    return resourcesConfig;
}
const $d089d28a3f331f70$var$authModeNames = {
    AMAZON_COGNITO_USER_POOLS: 'userPool',
    API_KEY: 'apiKey',
    AWS_IAM: 'iam',
    AWS_LAMBDA: 'lambda',
    OPENID_CONNECT: 'oidc'
};
function $d089d28a3f331f70$var$getGraphQLAuthMode(authType) {
    return $d089d28a3f331f70$var$authModeNames[authType];
}
const $d089d28a3f331f70$var$providerNames = {
    GOOGLE: 'Google',
    LOGIN_WITH_AMAZON: 'Amazon',
    FACEBOOK: 'Facebook',
    SIGN_IN_WITH_APPLE: 'Apple'
};
function $d089d28a3f331f70$var$getOAuthProviders(providers = []) {
    return providers.reduce((oAuthProviders, provider)=>{
        if ($d089d28a3f331f70$var$providerNames[provider] !== undefined) oAuthProviders.push($d089d28a3f331f70$var$providerNames[provider]);
        return oAuthProviders;
    }, []);
}
function $d089d28a3f331f70$var$getMfaStatus(mfaConfiguration) {
    if (mfaConfiguration === 'OPTIONAL') return 'optional';
    if (mfaConfiguration === 'REQUIRED') return 'on';
    return 'off';
}
function $d089d28a3f331f70$var$createBucketInfoMap(buckets) {
    const mappedBuckets = {};
    buckets.forEach(({ name: name, bucket_name: bucketName, aws_region: region, paths: paths })=>{
        if (name in mappedBuckets) throw new Error(`Duplicate friendly name found: ${name}. Name must be unique.`);
        const sanitizedPaths = paths ? Object.entries(paths).reduce((acc, [key, value])=>{
            if (value !== undefined) acc[key] = value;
            return acc;
        }, {}) : undefined;
        mappedBuckets[name] = {
            bucketName: bucketName,
            region: region,
            paths: sanitizedPaths
        };
    });
    return mappedBuckets;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Parses the variety of configuration shapes that Amplify can accept into a ResourcesConfig.
 *
 * @param amplifyConfig An Amplify configuration object conforming to one of the supported schemas.
 * @return A ResourcesConfig for the provided configuration object.
 */ const $3eb0fd433137e38a$export$f101a69cd6dc6202 = (amplifyConfig)=>{
    if (Object.keys(amplifyConfig).some((key)=>key.startsWith('aws_'))) return (0, $b615537506e3f1e4$export$1ef2e9c2da492d)(amplifyConfig);
    else if ((0, $d089d28a3f331f70$export$99bf765e6322c00)(amplifyConfig)) return (0, $d089d28a3f331f70$export$11d0da171d17ab63)(amplifyConfig);
    else return amplifyConfig;
};



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $af88ec659a926699$var$extendStatics = function(d, b) {
    $af88ec659a926699$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $af88ec659a926699$var$extendStatics(d, b);
};
function $af88ec659a926699$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $af88ec659a926699$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $af88ec659a926699$export$18ce0697a983be9b = function() {
    $af88ec659a926699$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $af88ec659a926699$export$18ce0697a983be9b.apply(this, arguments);
};
function $af88ec659a926699$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $af88ec659a926699$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $af88ec659a926699$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $af88ec659a926699$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $af88ec659a926699$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $af88ec659a926699$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $af88ec659a926699$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $af88ec659a926699$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $af88ec659a926699$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $af88ec659a926699$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $af88ec659a926699$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $af88ec659a926699$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $af88ec659a926699$export$45d3717a4c69092e(o, m, p);
}
function $af88ec659a926699$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $af88ec659a926699$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $af88ec659a926699$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($af88ec659a926699$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $af88ec659a926699$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $af88ec659a926699$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $af88ec659a926699$export$10c90e4f7922046c(v) {
    return this instanceof $af88ec659a926699$export$10c90e4f7922046c ? (this.v = v, this) : new $af88ec659a926699$export$10c90e4f7922046c(v);
}
function $af88ec659a926699$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $af88ec659a926699$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $af88ec659a926699$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $af88ec659a926699$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $af88ec659a926699$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $af88ec659a926699$export$19a8beecd37a4c45 === "function" ? $af88ec659a926699$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $af88ec659a926699$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $af88ec659a926699$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $af88ec659a926699$var$ownKeys = function(o) {
    $af88ec659a926699$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $af88ec659a926699$var$ownKeys(o);
};
function $af88ec659a926699$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $af88ec659a926699$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $af88ec659a926699$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $af88ec659a926699$var$__setModuleDefault(result, mod);
    return result;
}
function $af88ec659a926699$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $af88ec659a926699$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $af88ec659a926699$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $af88ec659a926699$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $af88ec659a926699$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $af88ec659a926699$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $af88ec659a926699$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $af88ec659a926699$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $af88ec659a926699$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $af88ec659a926699$export$2e2bcd8739ae039 = {
    __extends: $af88ec659a926699$export$a8ba968b8961cb8a,
    __assign: $af88ec659a926699$export$18ce0697a983be9b,
    __rest: $af88ec659a926699$export$3c9a16f847548506,
    __decorate: $af88ec659a926699$export$29e00dfd3077644b,
    __param: $af88ec659a926699$export$d5ad3fd78186038f,
    __esDecorate: $af88ec659a926699$export$3a84e1ae4e97e9b0,
    __runInitializers: $af88ec659a926699$export$d831c04e792af3d,
    __propKey: $af88ec659a926699$export$6a2a36740a146cb8,
    __setFunctionName: $af88ec659a926699$export$d1a06452d3489bc7,
    __metadata: $af88ec659a926699$export$f1db080c865becb9,
    __awaiter: $af88ec659a926699$export$1050f835b63b671e,
    __generator: $af88ec659a926699$export$67ebef60e6f28a6,
    __createBinding: $af88ec659a926699$export$45d3717a4c69092e,
    __exportStar: $af88ec659a926699$export$f33643c0debef087,
    __values: $af88ec659a926699$export$19a8beecd37a4c45,
    __read: $af88ec659a926699$export$8d051b38c9118094,
    __spread: $af88ec659a926699$export$afc72e2116322959,
    __spreadArrays: $af88ec659a926699$export$6388937ca91ccae8,
    __spreadArray: $af88ec659a926699$export$1216008129fb82ed,
    __await: $af88ec659a926699$export$10c90e4f7922046c,
    __asyncGenerator: $af88ec659a926699$export$e427f37a30a4de9b,
    __asyncDelegator: $af88ec659a926699$export$bbd80228419bb833,
    __asyncValues: $af88ec659a926699$export$e3b29a3d6162315f,
    __makeTemplateObject: $af88ec659a926699$export$4fb47efe1390b86f,
    __importStar: $af88ec659a926699$export$c21735bcef00d192,
    __importDefault: $af88ec659a926699$export$da59b14a69baef04,
    __classPrivateFieldGet: $af88ec659a926699$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $af88ec659a926699$export$d40a35129aaff81f,
    __classPrivateFieldIn: $af88ec659a926699$export$81fdc39f203e4e04,
    __addDisposableResource: $af88ec659a926699$export$88ac25d8e944e405,
    __disposeResources: $af88ec659a926699$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $af88ec659a926699$export$889dfb5d17574b0b
};


/**
 * @internal
 */ var $1732e0f54806e10a$export$b2e3d6d444266a5c = 64;
var $1732e0f54806e10a$export$d7bd469488748c5f = 32;
var $1732e0f54806e10a$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $1732e0f54806e10a$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $1732e0f54806e10a$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;



/**
 * @internal
 */ var $fba4ff864ec76233$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $1732e0f54806e10a$export$d788bc089976c004));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $1732e0f54806e10a$export$856b3d11dc447b50)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $1732e0f54806e10a$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $1732e0f54806e10a$export$b2e3d6d444266a5c) >= (0, $1732e0f54806e10a$export$b2e3d6d444266a5c) - 8) {
                for(var i = this.bufferLength; i < (0, $1732e0f54806e10a$export$b2e3d6d444266a5c); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $1732e0f54806e10a$export$b2e3d6d444266a5c) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $1732e0f54806e10a$export$b2e3d6d444266a5c) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $1732e0f54806e10a$export$b2e3d6d444266a5c) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $1732e0f54806e10a$export$d7bd469488748c5f));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $1732e0f54806e10a$export$b2e3d6d444266a5c); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $1732e0f54806e10a$export$7167c830cefcb6b5)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $5c06fb009da1a4bd$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $94e355b821094213$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $5c06fb009da1a4bd$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $deefa1551719faa9$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};




/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0cc3b8228b7b07a9$export$a143d493d941bafc;
var $0cc3b8228b7b07a9$export$e4cf37d7f6fb9e0a;
var $0cc3b8228b7b07a9$export$f99ded8fe4b79145;
var $0cc3b8228b7b07a9$export$599f31c3813fae4d;
'use strict';
var $fc4225561c45ae11$export$a48f0734ac7c2329;
var $fc4225561c45ae11$export$d622b2ad8d90c771;
var $fc4225561c45ae11$export$6100ba28696e12de;
'use strict';
$fc4225561c45ae11$export$a48f0734ac7c2329 = $fc4225561c45ae11$var$byteLength;
$fc4225561c45ae11$export$d622b2ad8d90c771 = $fc4225561c45ae11$var$toByteArray;
$fc4225561c45ae11$export$6100ba28696e12de = $fc4225561c45ae11$var$fromByteArray;
var $fc4225561c45ae11$var$lookup = [];
var $fc4225561c45ae11$var$revLookup = [];
var $fc4225561c45ae11$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $fc4225561c45ae11$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $fc4225561c45ae11$var$i = 0, $fc4225561c45ae11$var$len = $fc4225561c45ae11$var$code.length; $fc4225561c45ae11$var$i < $fc4225561c45ae11$var$len; ++$fc4225561c45ae11$var$i){
    $fc4225561c45ae11$var$lookup[$fc4225561c45ae11$var$i] = $fc4225561c45ae11$var$code[$fc4225561c45ae11$var$i];
    $fc4225561c45ae11$var$revLookup[$fc4225561c45ae11$var$code.charCodeAt($fc4225561c45ae11$var$i)] = $fc4225561c45ae11$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$fc4225561c45ae11$var$revLookup['-'.charCodeAt(0)] = 62;
$fc4225561c45ae11$var$revLookup['_'.charCodeAt(0)] = 63;
function $fc4225561c45ae11$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $fc4225561c45ae11$var$byteLength(b64) {
    var lens = $fc4225561c45ae11$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $fc4225561c45ae11$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $fc4225561c45ae11$var$toByteArray(b64) {
    var tmp;
    var lens = $fc4225561c45ae11$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $fc4225561c45ae11$var$Arr($fc4225561c45ae11$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $fc4225561c45ae11$var$revLookup[b64.charCodeAt(i)] << 18 | $fc4225561c45ae11$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $fc4225561c45ae11$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $fc4225561c45ae11$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $fc4225561c45ae11$var$revLookup[b64.charCodeAt(i)] << 2 | $fc4225561c45ae11$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $fc4225561c45ae11$var$revLookup[b64.charCodeAt(i)] << 10 | $fc4225561c45ae11$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $fc4225561c45ae11$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $fc4225561c45ae11$var$tripletToBase64(num) {
    return $fc4225561c45ae11$var$lookup[num >> 18 & 0x3F] + $fc4225561c45ae11$var$lookup[num >> 12 & 0x3F] + $fc4225561c45ae11$var$lookup[num >> 6 & 0x3F] + $fc4225561c45ae11$var$lookup[num & 0x3F];
}
function $fc4225561c45ae11$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($fc4225561c45ae11$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $fc4225561c45ae11$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($fc4225561c45ae11$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($fc4225561c45ae11$var$lookup[tmp >> 2] + $fc4225561c45ae11$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($fc4225561c45ae11$var$lookup[tmp >> 10] + $fc4225561c45ae11$var$lookup[tmp >> 4 & 0x3F] + $fc4225561c45ae11$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $60b932779b311275$export$aafa59e2e03f2942;
var $60b932779b311275$export$68d8715fc104d294;
$60b932779b311275$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$60b932779b311275$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $0cc3b8228b7b07a9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0cc3b8228b7b07a9$export$a143d493d941bafc = $0cc3b8228b7b07a9$var$Buffer;
$0cc3b8228b7b07a9$export$e4cf37d7f6fb9e0a = $0cc3b8228b7b07a9$var$SlowBuffer;
$0cc3b8228b7b07a9$export$f99ded8fe4b79145 = 50;
const $0cc3b8228b7b07a9$var$K_MAX_LENGTH = 0x7fffffff;
$0cc3b8228b7b07a9$export$599f31c3813fae4d = $0cc3b8228b7b07a9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0cc3b8228b7b07a9$var$Buffer.TYPED_ARRAY_SUPPORT = $0cc3b8228b7b07a9$var$typedArraySupport();
if (!$0cc3b8228b7b07a9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0cc3b8228b7b07a9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0cc3b8228b7b07a9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0cc3b8228b7b07a9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0cc3b8228b7b07a9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0cc3b8228b7b07a9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0cc3b8228b7b07a9$var$createBuffer(length) {
    if (length > $0cc3b8228b7b07a9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0cc3b8228b7b07a9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0cc3b8228b7b07a9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0cc3b8228b7b07a9$var$allocUnsafe(arg);
    }
    return $0cc3b8228b7b07a9$var$from(arg, encodingOrOffset, length);
}
$0cc3b8228b7b07a9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0cc3b8228b7b07a9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0cc3b8228b7b07a9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0cc3b8228b7b07a9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0cc3b8228b7b07a9$var$isInstance(value, ArrayBuffer) || value && $0cc3b8228b7b07a9$var$isInstance(value.buffer, ArrayBuffer)) return $0cc3b8228b7b07a9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0cc3b8228b7b07a9$var$isInstance(value, SharedArrayBuffer) || value && $0cc3b8228b7b07a9$var$isInstance(value.buffer, SharedArrayBuffer))) return $0cc3b8228b7b07a9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0cc3b8228b7b07a9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0cc3b8228b7b07a9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0cc3b8228b7b07a9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0cc3b8228b7b07a9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0cc3b8228b7b07a9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0cc3b8228b7b07a9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0cc3b8228b7b07a9$var$Buffer, Uint8Array);
function $0cc3b8228b7b07a9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0cc3b8228b7b07a9$var$alloc(size, fill, encoding) {
    $0cc3b8228b7b07a9$var$assertSize(size);
    if (size <= 0) return $0cc3b8228b7b07a9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0cc3b8228b7b07a9$var$createBuffer(size).fill(fill, encoding) : $0cc3b8228b7b07a9$var$createBuffer(size).fill(fill);
    return $0cc3b8228b7b07a9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0cc3b8228b7b07a9$var$Buffer.alloc = function(size, fill, encoding) {
    return $0cc3b8228b7b07a9$var$alloc(size, fill, encoding);
};
function $0cc3b8228b7b07a9$var$allocUnsafe(size) {
    $0cc3b8228b7b07a9$var$assertSize(size);
    return $0cc3b8228b7b07a9$var$createBuffer(size < 0 ? 0 : $0cc3b8228b7b07a9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0cc3b8228b7b07a9$var$Buffer.allocUnsafe = function(size) {
    return $0cc3b8228b7b07a9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0cc3b8228b7b07a9$var$Buffer.allocUnsafeSlow = function(size) {
    return $0cc3b8228b7b07a9$var$allocUnsafe(size);
};
function $0cc3b8228b7b07a9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0cc3b8228b7b07a9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0cc3b8228b7b07a9$var$byteLength(string, encoding) | 0;
    let buf = $0cc3b8228b7b07a9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0cc3b8228b7b07a9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0cc3b8228b7b07a9$var$checked(array.length) | 0;
    const buf = $0cc3b8228b7b07a9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0cc3b8228b7b07a9$var$fromArrayView(arrayView) {
    if ($0cc3b8228b7b07a9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0cc3b8228b7b07a9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0cc3b8228b7b07a9$var$fromArrayLike(arrayView);
}
function $0cc3b8228b7b07a9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0cc3b8228b7b07a9$var$Buffer.prototype);
    return buf;
}
function $0cc3b8228b7b07a9$var$fromObject(obj) {
    if ($0cc3b8228b7b07a9$var$Buffer.isBuffer(obj)) {
        const len = $0cc3b8228b7b07a9$var$checked(obj.length) | 0;
        const buf = $0cc3b8228b7b07a9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0cc3b8228b7b07a9$var$numberIsNaN(obj.length)) return $0cc3b8228b7b07a9$var$createBuffer(0);
        return $0cc3b8228b7b07a9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0cc3b8228b7b07a9$var$fromArrayLike(obj.data);
}
function $0cc3b8228b7b07a9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0cc3b8228b7b07a9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0cc3b8228b7b07a9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0cc3b8228b7b07a9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0cc3b8228b7b07a9$var$Buffer.alloc(+length);
}
$0cc3b8228b7b07a9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0cc3b8228b7b07a9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0cc3b8228b7b07a9$var$Buffer.compare = function compare(a, b) {
    if ($0cc3b8228b7b07a9$var$isInstance(a, Uint8Array)) a = $0cc3b8228b7b07a9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0cc3b8228b7b07a9$var$isInstance(b, Uint8Array)) b = $0cc3b8228b7b07a9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0cc3b8228b7b07a9$var$Buffer.isBuffer(a) || !$0cc3b8228b7b07a9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0cc3b8228b7b07a9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0cc3b8228b7b07a9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0cc3b8228b7b07a9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0cc3b8228b7b07a9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0cc3b8228b7b07a9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0cc3b8228b7b07a9$var$Buffer.isBuffer(buf)) buf = $0cc3b8228b7b07a9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0cc3b8228b7b07a9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0cc3b8228b7b07a9$var$byteLength(string, encoding) {
    if ($0cc3b8228b7b07a9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0cc3b8228b7b07a9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0cc3b8228b7b07a9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0cc3b8228b7b07a9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0cc3b8228b7b07a9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0cc3b8228b7b07a9$var$Buffer.byteLength = $0cc3b8228b7b07a9$var$byteLength;
function $0cc3b8228b7b07a9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0cc3b8228b7b07a9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0cc3b8228b7b07a9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0cc3b8228b7b07a9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0cc3b8228b7b07a9$var$latin1Slice(this, start, end);
        case 'base64':
            return $0cc3b8228b7b07a9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0cc3b8228b7b07a9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0cc3b8228b7b07a9$var$Buffer.prototype._isBuffer = true;
function $0cc3b8228b7b07a9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0cc3b8228b7b07a9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0cc3b8228b7b07a9$var$swap(this, i, i + 1);
    return this;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0cc3b8228b7b07a9$var$swap(this, i, i + 3);
        $0cc3b8228b7b07a9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0cc3b8228b7b07a9$var$swap(this, i, i + 7);
        $0cc3b8228b7b07a9$var$swap(this, i + 1, i + 6);
        $0cc3b8228b7b07a9$var$swap(this, i + 2, i + 5);
        $0cc3b8228b7b07a9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0cc3b8228b7b07a9$var$utf8Slice(this, 0, length);
    return $0cc3b8228b7b07a9$var$slowToString.apply(this, arguments);
};
$0cc3b8228b7b07a9$var$Buffer.prototype.toLocaleString = $0cc3b8228b7b07a9$var$Buffer.prototype.toString;
$0cc3b8228b7b07a9$var$Buffer.prototype.equals = function equals(b) {
    if (!$0cc3b8228b7b07a9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0cc3b8228b7b07a9$var$Buffer.compare(this, b) === 0;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0cc3b8228b7b07a9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0cc3b8228b7b07a9$var$customInspectSymbol) $0cc3b8228b7b07a9$var$Buffer.prototype[$0cc3b8228b7b07a9$var$customInspectSymbol] = $0cc3b8228b7b07a9$var$Buffer.prototype.inspect;
$0cc3b8228b7b07a9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0cc3b8228b7b07a9$var$isInstance(target, Uint8Array)) target = $0cc3b8228b7b07a9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0cc3b8228b7b07a9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0cc3b8228b7b07a9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0cc3b8228b7b07a9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0cc3b8228b7b07a9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0cc3b8228b7b07a9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0cc3b8228b7b07a9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0cc3b8228b7b07a9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0cc3b8228b7b07a9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0cc3b8228b7b07a9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0cc3b8228b7b07a9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0cc3b8228b7b07a9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0cc3b8228b7b07a9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0cc3b8228b7b07a9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0cc3b8228b7b07a9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0cc3b8228b7b07a9$var$utf8Write(buf, string, offset, length) {
    return $0cc3b8228b7b07a9$var$blitBuffer($0cc3b8228b7b07a9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0cc3b8228b7b07a9$var$asciiWrite(buf, string, offset, length) {
    return $0cc3b8228b7b07a9$var$blitBuffer($0cc3b8228b7b07a9$var$asciiToBytes(string), buf, offset, length);
}
function $0cc3b8228b7b07a9$var$base64Write(buf, string, offset, length) {
    return $0cc3b8228b7b07a9$var$blitBuffer($0cc3b8228b7b07a9$var$base64ToBytes(string), buf, offset, length);
}
function $0cc3b8228b7b07a9$var$ucs2Write(buf, string, offset, length) {
    return $0cc3b8228b7b07a9$var$blitBuffer($0cc3b8228b7b07a9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0cc3b8228b7b07a9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0cc3b8228b7b07a9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0cc3b8228b7b07a9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0cc3b8228b7b07a9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0cc3b8228b7b07a9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0cc3b8228b7b07a9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0cc3b8228b7b07a9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0cc3b8228b7b07a9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $fc4225561c45ae11$export$6100ba28696e12de(buf);
    else return $fc4225561c45ae11$export$6100ba28696e12de(buf.slice(start, end));
}
function $0cc3b8228b7b07a9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0cc3b8228b7b07a9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0cc3b8228b7b07a9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0cc3b8228b7b07a9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0cc3b8228b7b07a9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0cc3b8228b7b07a9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0cc3b8228b7b07a9$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0cc3b8228b7b07a9$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0cc3b8228b7b07a9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0cc3b8228b7b07a9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0cc3b8228b7b07a9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0cc3b8228b7b07a9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0cc3b8228b7b07a9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0cc3b8228b7b07a9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0cc3b8228b7b07a9$var$Buffer.prototype.readUintLE = $0cc3b8228b7b07a9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readUintBE = $0cc3b8228b7b07a9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readUint8 = $0cc3b8228b7b07a9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readUint16LE = $0cc3b8228b7b07a9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readUint16BE = $0cc3b8228b7b07a9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readUint32LE = $0cc3b8228b7b07a9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readUint32BE = $0cc3b8228b7b07a9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readBigUInt64LE = $0cc3b8228b7b07a9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0cc3b8228b7b07a9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0cc3b8228b7b07a9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0cc3b8228b7b07a9$var$Buffer.prototype.readBigUInt64BE = $0cc3b8228b7b07a9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0cc3b8228b7b07a9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0cc3b8228b7b07a9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0cc3b8228b7b07a9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readBigInt64LE = $0cc3b8228b7b07a9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0cc3b8228b7b07a9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0cc3b8228b7b07a9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0cc3b8228b7b07a9$var$Buffer.prototype.readBigInt64BE = $0cc3b8228b7b07a9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0cc3b8228b7b07a9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0cc3b8228b7b07a9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0cc3b8228b7b07a9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 4, this.length);
    return $60b932779b311275$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 4, this.length);
    return $60b932779b311275$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 8, this.length);
    return $60b932779b311275$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$0cc3b8228b7b07a9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkOffset(offset, 8, this.length);
    return $60b932779b311275$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $0cc3b8228b7b07a9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0cc3b8228b7b07a9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0cc3b8228b7b07a9$var$Buffer.prototype.writeUintLE = $0cc3b8228b7b07a9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0cc3b8228b7b07a9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeUintBE = $0cc3b8228b7b07a9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0cc3b8228b7b07a9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeUint8 = $0cc3b8228b7b07a9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeUint16LE = $0cc3b8228b7b07a9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeUint16BE = $0cc3b8228b7b07a9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeUint32LE = $0cc3b8228b7b07a9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeUint32BE = $0cc3b8228b7b07a9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0cc3b8228b7b07a9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0cc3b8228b7b07a9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0cc3b8228b7b07a9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0cc3b8228b7b07a9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0cc3b8228b7b07a9$var$Buffer.prototype.writeBigUInt64LE = $0cc3b8228b7b07a9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0cc3b8228b7b07a9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0cc3b8228b7b07a9$var$Buffer.prototype.writeBigUInt64BE = $0cc3b8228b7b07a9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0cc3b8228b7b07a9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0cc3b8228b7b07a9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0cc3b8228b7b07a9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0cc3b8228b7b07a9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeBigInt64LE = $0cc3b8228b7b07a9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0cc3b8228b7b07a9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0cc3b8228b7b07a9$var$Buffer.prototype.writeBigInt64BE = $0cc3b8228b7b07a9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0cc3b8228b7b07a9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0cc3b8228b7b07a9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0cc3b8228b7b07a9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $60b932779b311275$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0cc3b8228b7b07a9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0cc3b8228b7b07a9$var$writeFloat(this, value, offset, true, noAssert);
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0cc3b8228b7b07a9$var$writeFloat(this, value, offset, false, noAssert);
};
function $0cc3b8228b7b07a9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0cc3b8228b7b07a9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $60b932779b311275$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0cc3b8228b7b07a9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0cc3b8228b7b07a9$var$writeDouble(this, value, offset, true, noAssert);
};
$0cc3b8228b7b07a9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0cc3b8228b7b07a9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0cc3b8228b7b07a9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0cc3b8228b7b07a9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0cc3b8228b7b07a9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0cc3b8228b7b07a9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0cc3b8228b7b07a9$var$Buffer.isBuffer(val) ? val : $0cc3b8228b7b07a9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0cc3b8228b7b07a9$var$errors = {};
function $0cc3b8228b7b07a9$var$E(sym, getMessage, Base) {
    $0cc3b8228b7b07a9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0cc3b8228b7b07a9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0cc3b8228b7b07a9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0cc3b8228b7b07a9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0cc3b8228b7b07a9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0cc3b8228b7b07a9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0cc3b8228b7b07a9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0cc3b8228b7b07a9$var$checkBounds(buf, offset, byteLength) {
    $0cc3b8228b7b07a9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0cc3b8228b7b07a9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0cc3b8228b7b07a9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0cc3b8228b7b07a9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0cc3b8228b7b07a9$var$checkBounds(buf, offset, byteLength);
}
function $0cc3b8228b7b07a9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0cc3b8228b7b07a9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0cc3b8228b7b07a9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0cc3b8228b7b07a9$var$validateNumber(value, type);
        throw new $0cc3b8228b7b07a9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0cc3b8228b7b07a9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0cc3b8228b7b07a9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0cc3b8228b7b07a9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0cc3b8228b7b07a9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0cc3b8228b7b07a9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0cc3b8228b7b07a9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0cc3b8228b7b07a9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0cc3b8228b7b07a9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0cc3b8228b7b07a9$var$base64ToBytes(str) {
    return $fc4225561c45ae11$export$d622b2ad8d90c771($0cc3b8228b7b07a9$var$base64clean(str));
}
function $0cc3b8228b7b07a9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0cc3b8228b7b07a9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0cc3b8228b7b07a9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0cc3b8228b7b07a9$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0cc3b8228b7b07a9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0cc3b8228b7b07a9$var$BufferBigIntNotDefined : fn;
}
function $0cc3b8228b7b07a9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $14bb00412ad468bf$require$Buffer = $0cc3b8228b7b07a9$export$a143d493d941bafc;
// Quick polyfill
var $14bb00412ad468bf$var$fromUtf8 = typeof $14bb00412ad468bf$require$Buffer !== "undefined" && $14bb00412ad468bf$require$Buffer.from ? function(input) {
    return $14bb00412ad468bf$require$Buffer.from(input, "utf8");
} : (0, $5c06fb009da1a4bd$export$c7c5cef950a4d2fc);
function $14bb00412ad468bf$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $14bb00412ad468bf$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $ad1e0ea10aee54ce$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $0c61eb0c60ec5413$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $0943115c77bb4ec5$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}




var $bf8fb85b69ce25b0$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $fba4ff864ec76233$export$aab6bc1ad3c77a42)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $ad1e0ea10aee54ce$export$ea55f474a468804e)(toHash) || this.error) return;
        try {
            this.hash.update((0, $14bb00412ad468bf$export$4f21f20c2f1a9063)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $af88ec659a926699$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $af88ec659a926699$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $fba4ff864ec76233$export$aab6bc1ad3c77a42)();
        if (this.secret) {
            this.outer = new (0, $fba4ff864ec76233$export$aab6bc1ad3c77a42)();
            var inner = $bf8fb85b69ce25b0$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $1732e0f54806e10a$export$b2e3d6d444266a5c));
            outer.set(inner);
            for(var i = 0; i < (0, $1732e0f54806e10a$export$b2e3d6d444266a5c); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $bf8fb85b69ce25b0$var$bufferFromSecret(secret) {
    var input = (0, $14bb00412ad468bf$export$4f21f20c2f1a9063)(secret);
    if (input.byteLength > (0, $1732e0f54806e10a$export$b2e3d6d444266a5c)) {
        var bufferHash = new (0, $fba4ff864ec76233$export$aab6bc1ad3c77a42)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $1732e0f54806e10a$export$b2e3d6d444266a5c));
    buffer.set(input);
    return buffer;
}




const $952ef6ce455b139a$var$SHORT_TO_HEX = {};
const $952ef6ce455b139a$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $952ef6ce455b139a$var$SHORT_TO_HEX[i] = encodedByte;
    $952ef6ce455b139a$var$HEX_TO_SHORT[encodedByte] = i;
}
function $952ef6ce455b139a$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $952ef6ce455b139a$var$HEX_TO_SHORT) out[i / 2] = $952ef6ce455b139a$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $952ef6ce455b139a$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $952ef6ce455b139a$var$SHORT_TO_HEX[bytes[i]];
    return out;
}








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $60e3fc0dec42160e$var$logger = new (0, $294c375a4ec5088f$export$ba6a9c7ac8291f7f)('Auth');
class $60e3fc0dec42160e$export$eeff9d1a8b8c057b {
    /**
     * Configure Auth category
     *
     * @internal
     *
     * @param authResourcesConfig - Resources configurations required by Auth providers.
     * @param authOptions - Client options used by library
     *
     * @returns void
     */ configure(authResourcesConfig, authOptions) {
        this.authConfig = authResourcesConfig;
        this.authOptions = authOptions;
        if (authResourcesConfig && authResourcesConfig.Cognito?.userPoolEndpoint) $60e3fc0dec42160e$var$logger.warn($60e3fc0dec42160e$var$getCustomEndpointWarningMessage('Amazon Cognito User Pool'));
        if (authResourcesConfig && authResourcesConfig.Cognito?.identityPoolEndpoint) $60e3fc0dec42160e$var$logger.warn($60e3fc0dec42160e$var$getCustomEndpointWarningMessage('Amazon Cognito Identity Pool'));
    }
    /**
     * Fetch the auth tokens, and the temporary AWS credentials and identity if they are configured. By default it
     * will automatically refresh expired auth tokens if a valid refresh token is present. You can force a refresh
     * of non-expired tokens with `{ forceRefresh: true }` input.
     *
     * @param options - Options configuring the fetch behavior.
     *
     * @returns Promise of current auth session {@link AuthSession}.
     */ async fetchAuthSession(options = {}) {
        let credentialsAndIdentityId;
        let userSub;
        // Get tokens will throw if session cannot be refreshed (network or service error) or return null if not available
        const tokens = await this.getTokens(options);
        if (tokens) {
            userSub = tokens.accessToken?.payload?.sub;
            // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
            credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
                authConfig: this.authConfig,
                tokens: tokens,
                authenticated: true,
                forceRefresh: options.forceRefresh
            });
        } else // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
        credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
            authConfig: this.authConfig,
            authenticated: false,
            forceRefresh: options.forceRefresh
        });
        return {
            tokens: tokens,
            credentials: credentialsAndIdentityId?.credentials,
            identityId: credentialsAndIdentityId?.identityId,
            userSub: userSub
        };
    }
    async clearCredentials() {
        await this.authOptions?.credentialsProvider?.clearCredentialsAndIdentityId();
    }
    async getTokens(options) {
        return await this.authOptions?.tokenProvider?.getTokens(options) ?? undefined;
    }
}
const $60e3fc0dec42160e$var$getCustomEndpointWarningMessage = (target)=>`You are using a custom Amazon ${target} endpoint, ensure the endpoint is correct.`;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $4e3539eda5094cb7$export$b412d755cfa0136 {
    constructor(){
        this.oAuthListener = undefined;
        this.isConfigured = false;
        this.resourcesConfig = {};
        this.libraryOptions = {};
        this.Auth = new (0, $60e3fc0dec42160e$export$eeff9d1a8b8c057b)();
    }
    /**
     * Configures Amplify for use with your back-end resources.
     *
     * @remarks
     * This API does not perform any merging of either `resourcesConfig` or `libraryOptions`. The most recently
     * provided values will be used after configuration.
     *
     * @remarks
     * `configure` can be used to specify additional library options where available for supported categories.
     *
     * @param resourceConfig - Back-end resource configuration. Typically provided via the `aws-exports.js` file.
     * @param libraryOptions - Additional options for customizing the behavior of the library.
     */ configure(resourcesConfig, libraryOptions) {
        const resolvedResourceConfig = (0, $3eb0fd433137e38a$export$f101a69cd6dc6202)(resourcesConfig);
        this.resourcesConfig = resolvedResourceConfig;
        if (libraryOptions) this.libraryOptions = libraryOptions;
        // Make resource config immutable
        this.resourcesConfig = (0, $e4ca7b58aa7f1eb6$export$7e32b29e1cb162e1)(this.resourcesConfig);
        this.Auth.configure(this.resourcesConfig.Auth, this.libraryOptions.Auth);
        // Warn if Pinpoint is configured
        if (this.resourcesConfig.Analytics?.Pinpoint || this.resourcesConfig.Notifications?.InAppMessaging?.Pinpoint || this.resourcesConfig.Notifications?.PushNotification?.Pinpoint) // eslint-disable-next-line no-console
        console.warn("AWS will end support for Amazon Pinpoint on October 30, 2026. The guidance is to use AWS End User Messaging for push notifications and SMS, Amazon Simple Email Service for sending emails, Amazon Connect for campaigns, journeys, endpoints, and engagement analytics. Pinpoint recommends Amazon Kinesis for event collection and mobile analytics.");
        (0, $7c7b61d0858d9585$export$8c41bb232f1008b1).dispatch('core', {
            event: 'configure',
            data: this.resourcesConfig
        }, 'Configure', (0, $7c7b61d0858d9585$export$aadf71dd9875dd20));
        this.notifyOAuthListener();
        this.isConfigured = true;
    }
    /**
     * Provides access to the current back-end resource configuration for the Library.
     *
     * @returns Returns the immutable back-end resource configuration.
     */ getConfig() {
        if (!this.isConfigured) // eslint-disable-next-line no-console
        console.warn(`Amplify has not been configured. Please call Amplify.configure() before using this service.`);
        return this.resourcesConfig;
    }
    /** @internal */ [(0, $34cc7e2a3c52f094$export$35210b3191d26437)](listener) {
        if (this.resourcesConfig.Auth?.Cognito.loginWith?.oauth) // when Amplify has been configured with a valid OAuth config while adding the listener, run it directly
        listener(this.resourcesConfig.Auth?.Cognito);
        else // otherwise register the listener and run it later when Amplify gets configured with a valid oauth config
        this.oAuthListener = listener;
    }
    notifyOAuthListener() {
        if (!this.resourcesConfig.Auth?.Cognito.loginWith?.oauth || !this.oAuthListener) return;
        this.oAuthListener(this.resourcesConfig.Auth?.Cognito);
        // the listener should only be notified once with a valid oauth config
        this.oAuthListener = undefined;
    }
}
/**
 * The `Amplify` utility is used to configure the library.
 *
 * @remarks
 * `Amplify` orchestrates cross-category communication within the library.
 */ const $4e3539eda5094cb7$export$a3858a9a153cffc7 = new $4e3539eda5094cb7$export$b412d755cfa0136();

var $4a16e2e4eaa07c41$exports = {};
/*! js-cookie v3.0.8 | MIT */ (function(global, factory) {
    $4a16e2e4eaa07c41$exports = factory();
})($4a16e2e4eaa07c41$exports, function() {
    'use strict';
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === '__proto__') continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    return api;
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $cb3744adff06104d$export$dae7d845015939d5 {
    constructor(data = {}){
        const { path: path, domain: domain, expires: expires, sameSite: sameSite, secure: secure } = data;
        this.domain = domain;
        this.path = path || '/';
        this.expires = Object.prototype.hasOwnProperty.call(data, 'expires') ? expires : 365;
        this.secure = Object.prototype.hasOwnProperty.call(data, 'secure') ? secure : true;
        if (Object.prototype.hasOwnProperty.call(data, 'sameSite')) {
            if (!sameSite || ![
                'strict',
                'lax',
                'none'
            ].includes(sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (sameSite === 'none' && !this.secure) throw new Error('sameSite = None requires the Secure attribute in latest browser versions.');
            this.sameSite = sameSite;
        }
    }
    async setItem(key, value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4a16e2e4eaa07c41$exports))).set(key, value, this.getData());
    }
    async getItem(key) {
        const item = (0, (/*@__PURE__*/$parcel$interopDefault($4a16e2e4eaa07c41$exports))).get(key);
        return item ?? null;
    }
    async removeItem(key) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4a16e2e4eaa07c41$exports))).remove(key, this.getData());
    }
    async clear() {
        const cookie = (0, (/*@__PURE__*/$parcel$interopDefault($4a16e2e4eaa07c41$exports))).get();
        const promises = Object.keys(cookie).map((key)=>this.removeItem(key));
        await Promise.all(promises);
    }
    getData() {
        return {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure,
            ...this.sameSite && {
                sameSite: this.sameSite
            }
        };
    }
}

var $0f90bdfda3f0916b$export$4e712df6b850c8d0;
(function(AmplifyErrorCode) {
    AmplifyErrorCode["NoEndpointId"] = "NoEndpointId";
    AmplifyErrorCode["PlatformNotSupported"] = "PlatformNotSupported";
    AmplifyErrorCode["Unknown"] = "Unknown";
    AmplifyErrorCode["NetworkError"] = "NetworkError";
})($0f90bdfda3f0916b$export$4e712df6b850c8d0 || ($0f90bdfda3f0916b$export$4e712df6b850c8d0 = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $c4bb5e7b5b31dea6$export$f5362e8a6666a455 extends (0, $c848663d1100c12f$export$37321a6dace1881c) {
    constructor(){
        super({
            name: (0, $0f90bdfda3f0916b$export$4e712df6b850c8d0).PlatformNotSupported,
            message: 'Function not supported on current platform'
        });
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $c845a1ac9978db98$export$8536778e426ddf92 {
    constructor(storage){
        this.storage = storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ async setItem(key, value) {
        if (!this.storage) throw new (0, $c4bb5e7b5b31dea6$export$f5362e8a6666a455)();
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ async getItem(key) {
        if (!this.storage) throw new (0, $c4bb5e7b5b31dea6$export$f5362e8a6666a455)();
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ async removeItem(key) {
        if (!this.storage) throw new (0, $c4bb5e7b5b31dea6$export$f5362e8a6666a455)();
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ async clear() {
        if (!this.storage) throw new (0, $c4bb5e7b5b31dea6$export$f5362e8a6666a455)();
        this.storage.clear();
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $c77d9fd51f89364f$export$e4315e25b840a0ea {
    constructor(){
        this.storage = new Map();
    }
    get length() {
        return this.storage.size;
    }
    key(index) {
        if (index > this.length - 1) return null;
        return Array.from(this.storage.keys())[index];
    }
    setItem(key, value) {
        this.storage.set(key, value);
    }
    getItem(key) {
        return this.storage.get(key) ?? null;
    }
    removeItem(key) {
        this.storage.delete(key);
    }
    clear() {
        this.storage.clear();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 * @returns Either a reference to window.localStorage or an in-memory storage as fallback
 */ const $6d38169755c8f48b$var$logger = new (0, $294c375a4ec5088f$export$ba6a9c7ac8291f7f)('CoreStorageUtils');
const $6d38169755c8f48b$export$5d9abaf8ff62cd65 = ()=>{
    try {
        // Attempt to use localStorage directly
        if (typeof window !== 'undefined' && window.localStorage) return window.localStorage;
    } catch (e) {
        // Handle any errors related to localStorage access
        $6d38169755c8f48b$var$logger.info('localStorage not found. InMemoryStorage is used as a fallback.');
    }
    // Return in-memory storage as a fallback if localStorage is not accessible
    return new (0, $c77d9fd51f89364f$export$e4315e25b840a0ea)();
};
/**
 * @internal
 * @returns Either a reference to window.sessionStorage or an in-memory storage as fallback
 */ const $6d38169755c8f48b$export$518dcc1598f87b = ()=>{
    try {
        // Attempt to use sessionStorage directly
        if (typeof window !== 'undefined' && window.sessionStorage) {
            // Verify we can actually use it by testing access
            window.sessionStorage.getItem('test');
            return window.sessionStorage;
        }
        throw new Error('sessionStorage is not defined');
    } catch (e) {
        // Handle any errors related to sessionStorage access
        $6d38169755c8f48b$var$logger.info('sessionStorage not found. InMemoryStorage is used as a fallback.');
        return new (0, $c77d9fd51f89364f$export$e4315e25b840a0ea)();
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $fc8e6e4236320919$export$bec45e7703e93690 extends (0, $c845a1ac9978db98$export$8536778e426ddf92) {
    constructor(){
        super((0, $6d38169755c8f48b$export$5d9abaf8ff62cd65)());
    }
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $dd3628bcd93bb04f$export$2c4b17e1c2e0931 extends (0, $c845a1ac9978db98$export$8536778e426ddf92) {
    constructor(){
        super((0, $6d38169755c8f48b$export$518dcc1598f87b)());
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $8530a1df9daa187d$export$f7640313c5d17c27 {
    constructor(storage){
        this._storage = storage;
    }
    get storage() {
        if (!this._storage) throw new (0, $c4bb5e7b5b31dea6$export$f5362e8a6666a455)();
        return this._storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ setItem(key, value) {
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ getItem(key) {
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ removeItem(key) {
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ clear() {
        this.storage.clear();
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $bedcee9c1a8f54e4$export$eb7b875b75a2c8df extends (0, $8530a1df9daa187d$export$f7640313c5d17c27) {
    constructor(){
        super((0, $6d38169755c8f48b$export$518dcc1598f87b)());
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $48e450c8813210c3$export$586b30dcaeecb901 = new (0, $fc8e6e4236320919$export$bec45e7703e93690)();
const $48e450c8813210c3$export$f119d83aa936d634 = new (0, $dd3628bcd93bb04f$export$2c4b17e1c2e0931)();
const $48e450c8813210c3$export$9015f19b74348a18 = new (0, $bedcee9c1a8f54e4$export$eb7b875b75a2c8df)();
const $48e450c8813210c3$export$41feb988b3a84f03 = new (0, $c845a1ac9978db98$export$8536778e426ddf92)(new (0, $c77d9fd51f89364f$export$e4315e25b840a0ea)());












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c2cf6542a631fa20$export$638889172ebce0c4;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})($c2cf6542a631fa20$export$638889172ebce0c4 || ($c2cf6542a631fa20$export$638889172ebce0c4 = {}));
var $c2cf6542a631fa20$export$3a8840c5b2ecf003;
(function(Category) {
    Category["AI"] = "ai";
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})($c2cf6542a631fa20$export$3a8840c5b2ecf003 || ($c2cf6542a631fa20$export$3a8840c5b2ecf003 = {}));
var $c2cf6542a631fa20$export$89656a7f296a8665;
(function(AiAction) {
    AiAction["CreateConversation"] = "1";
    AiAction["GetConversation"] = "2";
    AiAction["ListConversations"] = "3";
    AiAction["DeleteConversation"] = "4";
    AiAction["SendMessage"] = "5";
    AiAction["ListMessages"] = "6";
    AiAction["OnMessage"] = "7";
    AiAction["Generation"] = "8";
    AiAction["UpdateConversation"] = "9";
})($c2cf6542a631fa20$export$89656a7f296a8665 || ($c2cf6542a631fa20$export$89656a7f296a8665 = {}));
var $c2cf6542a631fa20$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["IdentifyUser"] = "2";
})($c2cf6542a631fa20$export$30c16f5c43437fd7 || ($c2cf6542a631fa20$export$30c16f5c43437fd7 = {}));
var $c2cf6542a631fa20$export$126e20fdc0f0d34b;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})($c2cf6542a631fa20$export$126e20fdc0f0d34b || ($c2cf6542a631fa20$export$126e20fdc0f0d34b = {}));
var $c2cf6542a631fa20$export$900b1436d7e65f4;
(function(AuthAction) {
    AuthAction["SignUp"] = "1";
    AuthAction["ConfirmSignUp"] = "2";
    AuthAction["ResendSignUpCode"] = "3";
    AuthAction["SignIn"] = "4";
    AuthAction["FetchMFAPreference"] = "6";
    AuthAction["UpdateMFAPreference"] = "7";
    AuthAction["SetUpTOTP"] = "10";
    AuthAction["VerifyTOTPSetup"] = "11";
    AuthAction["ConfirmSignIn"] = "12";
    AuthAction["DeleteUserAttributes"] = "15";
    AuthAction["DeleteUser"] = "16";
    AuthAction["UpdateUserAttributes"] = "17";
    AuthAction["FetchUserAttributes"] = "18";
    AuthAction["ConfirmUserAttribute"] = "22";
    AuthAction["SignOut"] = "26";
    AuthAction["UpdatePassword"] = "27";
    AuthAction["ResetPassword"] = "28";
    AuthAction["ConfirmResetPassword"] = "29";
    AuthAction["FederatedSignIn"] = "30";
    AuthAction["RememberDevice"] = "32";
    AuthAction["ForgetDevice"] = "33";
    AuthAction["FetchDevices"] = "34";
    AuthAction["SendUserAttributeVerificationCode"] = "35";
    AuthAction["SignInWithRedirect"] = "36";
    AuthAction["StartWebAuthnRegistration"] = "37";
    AuthAction["CompleteWebAuthnRegistration"] = "38";
    AuthAction["ListWebAuthnCredentials"] = "39";
    AuthAction["DeleteWebAuthnCredential"] = "40";
})($c2cf6542a631fa20$export$900b1436d7e65f4 || ($c2cf6542a631fa20$export$900b1436d7e65f4 = {}));
var $c2cf6542a631fa20$export$2f5a715aba4cde93;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})($c2cf6542a631fa20$export$2f5a715aba4cde93 || ($c2cf6542a631fa20$export$2f5a715aba4cde93 = {}));
var $c2cf6542a631fa20$export$afafab3eb8fc6fef;
(function(GeoAction) {
    GeoAction["SearchByText"] = "0";
    GeoAction["SearchByCoordinates"] = "1";
    GeoAction["SearchForSuggestions"] = "2";
    GeoAction["SearchByPlaceId"] = "3";
    GeoAction["SaveGeofences"] = "4";
    GeoAction["GetGeofence"] = "5";
    GeoAction["ListGeofences"] = "6";
    GeoAction["DeleteGeofences"] = "7";
})($c2cf6542a631fa20$export$afafab3eb8fc6fef || ($c2cf6542a631fa20$export$afafab3eb8fc6fef = {}));
var $c2cf6542a631fa20$export$c01a8c16ffda791e;
(function(InAppMessagingAction) {
    InAppMessagingAction["SyncMessages"] = "1";
    InAppMessagingAction["IdentifyUser"] = "2";
    InAppMessagingAction["NotifyMessageInteraction"] = "3";
})($c2cf6542a631fa20$export$c01a8c16ffda791e || ($c2cf6542a631fa20$export$c01a8c16ffda791e = {}));
var $c2cf6542a631fa20$export$68e0695a774ab7fa;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})($c2cf6542a631fa20$export$68e0695a774ab7fa || ($c2cf6542a631fa20$export$68e0695a774ab7fa = {}));
var $c2cf6542a631fa20$export$aa89b4c447a07cee;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})($c2cf6542a631fa20$export$aa89b4c447a07cee || ($c2cf6542a631fa20$export$aa89b4c447a07cee = {}));
var $c2cf6542a631fa20$export$ade48b30f1e78672;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})($c2cf6542a631fa20$export$ade48b30f1e78672 || ($c2cf6542a631fa20$export$ade48b30f1e78672 = {}));
var $c2cf6542a631fa20$export$2c5ee06ab9fa5040;
(function(PushNotificationAction) {
    PushNotificationAction["InitializePushNotifications"] = "1";
    PushNotificationAction["IdentifyUser"] = "2";
})($c2cf6542a631fa20$export$2c5ee06ab9fa5040 || ($c2cf6542a631fa20$export$2c5ee06ab9fa5040 = {}));
var $c2cf6542a631fa20$export$d4f3c54b808b00ce;
(function(StorageAction) {
    StorageAction["UploadData"] = "1";
    StorageAction["DownloadData"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
    StorageAction["GetUrl"] = "7";
    StorageAction["GetDataAccess"] = "8";
    StorageAction["ListCallerAccessGrants"] = "9";
})($c2cf6542a631fa20$export$d4f3c54b808b00ce || ($c2cf6542a631fa20$export$d4f3c54b808b00ce = {}));


// generated by genversion
const $d69e86718301ccbb$export$83d89fbfd8236492 = '6.18.0';




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $68e02f0eef35d384$export$a15eed0e463030a9 = ()=>{
    return typeof $parcel$global !== 'undefined';
};
const $68e02f0eef35d384$export$a5e7eb32e5221222 = ()=>{
    return typeof globalThis !== 'undefined';
};
const $68e02f0eef35d384$export$daba2802a1a41c1f = ()=>{
    return typeof window !== 'undefined';
};
const $68e02f0eef35d384$export$b949ebcb877faa59 = ()=>{
    return typeof document !== 'undefined';
};
const $68e02f0eef35d384$export$ba10401363d0f7f6 = ()=>{
    return false;
};
const $68e02f0eef35d384$export$252f88727cff70c7 = (object, prefix)=>{
    return !!Object.keys(object).find((key)=>key.startsWith(prefix));
};


var $0d6979920132cafe$exports = {};
// shim for using process in browser
var $0d6979920132cafe$var$process = $0d6979920132cafe$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $0d6979920132cafe$var$cachedSetTimeout;
var $0d6979920132cafe$var$cachedClearTimeout;
function $0d6979920132cafe$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $0d6979920132cafe$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $0d6979920132cafe$var$cachedSetTimeout = setTimeout;
        else $0d6979920132cafe$var$cachedSetTimeout = $0d6979920132cafe$var$defaultSetTimout;
    } catch (e) {
        $0d6979920132cafe$var$cachedSetTimeout = $0d6979920132cafe$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $0d6979920132cafe$var$cachedClearTimeout = clearTimeout;
        else $0d6979920132cafe$var$cachedClearTimeout = $0d6979920132cafe$var$defaultClearTimeout;
    } catch (e) {
        $0d6979920132cafe$var$cachedClearTimeout = $0d6979920132cafe$var$defaultClearTimeout;
    }
})();
function $0d6979920132cafe$var$runTimeout(fun) {
    if ($0d6979920132cafe$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($0d6979920132cafe$var$cachedSetTimeout === $0d6979920132cafe$var$defaultSetTimout || !$0d6979920132cafe$var$cachedSetTimeout) && setTimeout) {
        $0d6979920132cafe$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0d6979920132cafe$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $0d6979920132cafe$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $0d6979920132cafe$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $0d6979920132cafe$var$runClearTimeout(marker) {
    if ($0d6979920132cafe$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($0d6979920132cafe$var$cachedClearTimeout === $0d6979920132cafe$var$defaultClearTimeout || !$0d6979920132cafe$var$cachedClearTimeout) && clearTimeout) {
        $0d6979920132cafe$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0d6979920132cafe$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $0d6979920132cafe$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $0d6979920132cafe$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $0d6979920132cafe$var$queue = [];
var $0d6979920132cafe$var$draining = false;
var $0d6979920132cafe$var$currentQueue;
var $0d6979920132cafe$var$queueIndex = -1;
function $0d6979920132cafe$var$cleanUpNextTick() {
    if (!$0d6979920132cafe$var$draining || !$0d6979920132cafe$var$currentQueue) return;
    $0d6979920132cafe$var$draining = false;
    if ($0d6979920132cafe$var$currentQueue.length) $0d6979920132cafe$var$queue = $0d6979920132cafe$var$currentQueue.concat($0d6979920132cafe$var$queue);
    else $0d6979920132cafe$var$queueIndex = -1;
    if ($0d6979920132cafe$var$queue.length) $0d6979920132cafe$var$drainQueue();
}
function $0d6979920132cafe$var$drainQueue() {
    if ($0d6979920132cafe$var$draining) return;
    var timeout = $0d6979920132cafe$var$runTimeout($0d6979920132cafe$var$cleanUpNextTick);
    $0d6979920132cafe$var$draining = true;
    var len = $0d6979920132cafe$var$queue.length;
    while(len){
        $0d6979920132cafe$var$currentQueue = $0d6979920132cafe$var$queue;
        $0d6979920132cafe$var$queue = [];
        while(++$0d6979920132cafe$var$queueIndex < len)if ($0d6979920132cafe$var$currentQueue) $0d6979920132cafe$var$currentQueue[$0d6979920132cafe$var$queueIndex].run();
        $0d6979920132cafe$var$queueIndex = -1;
        len = $0d6979920132cafe$var$queue.length;
    }
    $0d6979920132cafe$var$currentQueue = null;
    $0d6979920132cafe$var$draining = false;
    $0d6979920132cafe$var$runClearTimeout(timeout);
}
$0d6979920132cafe$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $0d6979920132cafe$var$queue.push(new $0d6979920132cafe$var$Item(fun, args));
    if ($0d6979920132cafe$var$queue.length === 1 && !$0d6979920132cafe$var$draining) $0d6979920132cafe$var$runTimeout($0d6979920132cafe$var$drainQueue);
};
// v8 likes predictible objects
function $0d6979920132cafe$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$0d6979920132cafe$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$0d6979920132cafe$var$process.title = 'browser';
$0d6979920132cafe$var$process.browser = true;
$0d6979920132cafe$var$process.env = {};
$0d6979920132cafe$var$process.argv = [];
$0d6979920132cafe$var$process.version = ''; // empty string to avoid regexp issues
$0d6979920132cafe$var$process.versions = {};
function $0d6979920132cafe$var$noop() {}
$0d6979920132cafe$var$process.on = $0d6979920132cafe$var$noop;
$0d6979920132cafe$var$process.addListener = $0d6979920132cafe$var$noop;
$0d6979920132cafe$var$process.once = $0d6979920132cafe$var$noop;
$0d6979920132cafe$var$process.off = $0d6979920132cafe$var$noop;
$0d6979920132cafe$var$process.removeListener = $0d6979920132cafe$var$noop;
$0d6979920132cafe$var$process.removeAllListeners = $0d6979920132cafe$var$noop;
$0d6979920132cafe$var$process.emit = $0d6979920132cafe$var$noop;
$0d6979920132cafe$var$process.prependListener = $0d6979920132cafe$var$noop;
$0d6979920132cafe$var$process.prependOnceListener = $0d6979920132cafe$var$noop;
$0d6979920132cafe$var$process.listeners = function(name) {
    return [];
};
$0d6979920132cafe$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$0d6979920132cafe$var$process.cwd = function() {
    return '/';
};
$0d6979920132cafe$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$0d6979920132cafe$var$process.umask = function() {
    return 0;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react 18.2 - built using Vite
function $5dc108f354f2b257$export$ba3f37c54f0f7805() {
    const elementKeyPrefixedWithReact = (key)=>{
        return key.startsWith('_react') || key.startsWith('__react');
    };
    const elementIsReactEnabled = (element)=>{
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    const allElementsWithId = ()=>Array.from(document.querySelectorAll('[id]'));
    return (0, $68e02f0eef35d384$export$b949ebcb877faa59)() && allElementsWithId().some(elementIsReactEnabled);
}
function $5dc108f354f2b257$export$86269c582305790() {
    return (0, $68e02f0eef35d384$export$ba10401363d0f7f6)() && typeof $0d6979920132cafe$exports.env !== 'undefined' && !!Object.keys($0d6979920132cafe$exports.env).find((key)=>key.includes('react'));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with vue 3.3.2
function $cdd7b22407943934$export$d91d90d62b78936d() {
    return (0, $68e02f0eef35d384$export$daba2802a1a41c1f)() && (0, $68e02f0eef35d384$export$252f88727cff70c7)(window, '__VUE');
}
function $cdd7b22407943934$export$257a4c0f8294a101() {
    return (0, $68e02f0eef35d384$export$a15eed0e463030a9)() && (0, $68e02f0eef35d384$export$252f88727cff70c7)($parcel$global, '__VUE');
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with svelte 3.59
function $3a29445db4e260bb$export$6dafc32a94edaed3() {
    return (0, $68e02f0eef35d384$export$daba2802a1a41c1f)() && (0, $68e02f0eef35d384$export$252f88727cff70c7)(window, '__SVELTE');
}
function $3a29445db4e260bb$export$819dcb7fe144d8b0() {
    return (0, $68e02f0eef35d384$export$ba10401363d0f7f6)() && typeof $0d6979920132cafe$exports.env !== 'undefined' && !!Object.keys($0d6979920132cafe$exports.env).find((key)=>key.includes('svelte'));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with next 13.4 / react 18.2
function $89bf50c69a9dbf92$export$f8462bcf03110eff() {
    return (0, $68e02f0eef35d384$export$daba2802a1a41c1f)() && window.next && typeof window.next === 'object';
}
function $89bf50c69a9dbf92$export$61c08ed144a5d4ca() {
    return (0, $68e02f0eef35d384$export$a15eed0e463030a9)() && ((0, $68e02f0eef35d384$export$252f88727cff70c7)($parcel$global, '__next') || (0, $68e02f0eef35d384$export$252f88727cff70c7)($parcel$global, '__NEXT'));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with nuxt 2.15 / vue 2.7
function $e7f426dbb8cd4ab7$export$bed54a4e6d9d25fb() {
    return (0, $68e02f0eef35d384$export$daba2802a1a41c1f)() && (window.__NUXT__ !== undefined || window.$nuxt !== undefined);
}
function $e7f426dbb8cd4ab7$export$fb3ce982948d27e8() {
    return (0, $68e02f0eef35d384$export$a15eed0e463030a9)() && typeof $parcel$global.__NUXT_PATHS__ !== 'undefined';
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with @angular/core 16.0.0
function $313373e27b537b73$export$b5a20bd39eb02ba0() {
    const angularVersionSetInDocument = Boolean((0, $68e02f0eef35d384$export$b949ebcb877faa59)() && document.querySelector('[ng-version]'));
    const angularContentSetInWindow = Boolean((0, $68e02f0eef35d384$export$daba2802a1a41c1f)() && typeof window.ng !== 'undefined');
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function $313373e27b537b73$export$8ab518c8987c870f() {
    return (0, $68e02f0eef35d384$export$ba10401363d0f7f6)() && typeof $0d6979920132cafe$exports.env === 'object' && undefined?.startsWith('ng ') || false;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
function $62018308a5cdc444$export$1c8414c1859e3748() {
    return typeof navigator !== 'undefined' && typeof navigator.product !== 'undefined' && navigator.product === 'ReactNative';
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with expo 48 / react-native 0.71.3
function $8428d8a8a4767bb3$export$85fd46d5e29a4f7e() {
    return (0, $68e02f0eef35d384$export$a15eed0e463030a9)() && typeof $parcel$global.expo !== 'undefined';
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $7d5412b7989450a6$export$41b1270b988065fb() {
    return (0, $68e02f0eef35d384$export$daba2802a1a41c1f)();
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// These are in the order of detection where when both are detectable, the early Framework will be reported
const $8ae57a0d52fa0c75$var$detectionMap = [
    // First, detect mobile
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).Expo,
        detectionMethod: (0, $8428d8a8a4767bb3$export$85fd46d5e29a4f7e)
    },
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).ReactNative,
        detectionMethod: (0, $62018308a5cdc444$export$1c8414c1859e3748)
    },
    // Next, detect web frameworks
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).NextJs,
        detectionMethod: (0, $89bf50c69a9dbf92$export$f8462bcf03110eff)
    },
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).Nuxt,
        detectionMethod: (0, $e7f426dbb8cd4ab7$export$bed54a4e6d9d25fb)
    },
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).Angular,
        detectionMethod: (0, $313373e27b537b73$export$b5a20bd39eb02ba0)
    },
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).React,
        detectionMethod: (0, $5dc108f354f2b257$export$ba3f37c54f0f7805)
    },
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).VueJs,
        detectionMethod: (0, $cdd7b22407943934$export$d91d90d62b78936d)
    },
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).Svelte,
        detectionMethod: (0, $3a29445db4e260bb$export$6dafc32a94edaed3)
    },
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).WebUnknown,
        detectionMethod: (0, $7d5412b7989450a6$export$41b1270b988065fb)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).NextJsSSR,
        detectionMethod: (0, $89bf50c69a9dbf92$export$61c08ed144a5d4ca)
    },
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).NuxtSSR,
        detectionMethod: (0, $e7f426dbb8cd4ab7$export$fb3ce982948d27e8)
    },
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).ReactSSR,
        detectionMethod: (0, $5dc108f354f2b257$export$86269c582305790)
    },
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).VueJsSSR,
        detectionMethod: (0, $cdd7b22407943934$export$257a4c0f8294a101)
    },
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).AngularSSR,
        detectionMethod: (0, $313373e27b537b73$export$8ab518c8987c870f)
    },
    {
        platform: (0, $c2cf6542a631fa20$export$638889172ebce0c4).SvelteSSR,
        detectionMethod: (0, $3a29445db4e260bb$export$819dcb7fe144d8b0)
    }
];
function $8ae57a0d52fa0c75$export$17b446b869dad473() {
    return $8ae57a0d52fa0c75$var$detectionMap.find((detectionEntry)=>detectionEntry.detectionMethod())?.platform || (0, $c2cf6542a631fa20$export$638889172ebce0c4).ServerSideUnknown;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// We want to cache detection since the framework won't change
let $79709d4b52dec43b$var$frameworkCache;
const $79709d4b52dec43b$export$d56891f33aa26edc = [];
// Setup the detection reset tracking / timeout delays
let $79709d4b52dec43b$var$resetTriggered = false;
const $79709d4b52dec43b$var$SSR_RESET_TIMEOUT = 10; // ms
const $79709d4b52dec43b$var$WEB_RESET_TIMEOUT = 10; // ms
const $79709d4b52dec43b$var$PRIME_FRAMEWORK_DELAY = 1000; // ms
const $79709d4b52dec43b$export$9ce73e459ec93b6a = ()=>{
    if (!$79709d4b52dec43b$var$frameworkCache) {
        $79709d4b52dec43b$var$frameworkCache = (0, $8ae57a0d52fa0c75$export$17b446b869dad473)();
        if ($79709d4b52dec43b$var$resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while($79709d4b52dec43b$export$d56891f33aa26edc.length)$79709d4b52dec43b$export$d56891f33aa26edc.pop()?.();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        $79709d4b52dec43b$export$d56891f33aa26edc.forEach((fcn)=>{
            fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        $79709d4b52dec43b$var$resetTimeout((0, $c2cf6542a631fa20$export$638889172ebce0c4).ServerSideUnknown, $79709d4b52dec43b$var$SSR_RESET_TIMEOUT);
        $79709d4b52dec43b$var$resetTimeout((0, $c2cf6542a631fa20$export$638889172ebce0c4).WebUnknown, $79709d4b52dec43b$var$WEB_RESET_TIMEOUT);
    }
    return $79709d4b52dec43b$var$frameworkCache;
};
/**
 * @internal Setup observer callback that will be called everytime the framework changes
 */ const $79709d4b52dec43b$export$5d5c467ce0b213f = (fcn)=>{
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if ($79709d4b52dec43b$var$resetTriggered) return;
    $79709d4b52dec43b$export$d56891f33aa26edc.push(fcn);
};
function $79709d4b52dec43b$export$d2adf65b87e47523() {
    $79709d4b52dec43b$var$frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function $79709d4b52dec43b$var$resetTimeout(framework, delay) {
    if ($79709d4b52dec43b$var$frameworkCache === framework && !$79709d4b52dec43b$var$resetTriggered) setTimeout(()=>{
        $79709d4b52dec43b$export$d2adf65b87e47523();
        $79709d4b52dec43b$var$resetTriggered = true;
        setTimeout($79709d4b52dec43b$export$9ce73e459ec93b6a, $79709d4b52dec43b$var$PRIME_FRAMEWORK_DELAY);
    }, delay);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Maintains custom user-agent state set by external consumers.
const $241333051c8fcffd$var$customUserAgentState = {};
/**
 * Sets custom user agent state which will be appended to applicable requests. Returns a function that can be used to
 * clean up any custom state set with this API.
 *
 * @note
 * This API operates globally. Calling this API multiple times will result in the most recently set values for a
 * particular API being used.
 *
 * @note
 * This utility IS NOT compatible with SSR.
 *
 * @param input - SetCustomUserAgentInput that defines custom state to apply to the specified APIs.
 */ const $241333051c8fcffd$export$20cd2fa9001e90da = (input)=>{
    // Save custom user-agent state & increment reference counter
    // TODO Remove `any` when we upgrade to TypeScript 5.2, see: https://github.com/microsoft/TypeScript/issues/44373
    $241333051c8fcffd$var$customUserAgentState[input.category] = input.apis.reduce((acc, api)=>({
            ...acc,
            [api]: {
                refCount: acc[api]?.refCount ? acc[api].refCount + 1 : 1,
                additionalDetails: input.additionalDetails
            }
        }), $241333051c8fcffd$var$customUserAgentState[input.category] ?? {});
    // Callback that cleans up state for APIs recorded by this call
    let cleanUpCallbackCalled = false;
    const cleanUpCallback = ()=>{
        // Only allow the cleanup callback to be called once
        if (cleanUpCallbackCalled) return;
        cleanUpCallbackCalled = true;
        input.apis.forEach((api)=>{
            const apiRefCount = $241333051c8fcffd$var$customUserAgentState[input.category][api].refCount;
            if (apiRefCount > 1) $241333051c8fcffd$var$customUserAgentState[input.category][api].refCount = apiRefCount - 1;
            else {
                delete $241333051c8fcffd$var$customUserAgentState[input.category][api];
                // Clean up category if no more APIs set
                if (!Object.keys($241333051c8fcffd$var$customUserAgentState[input.category]).length) delete $241333051c8fcffd$var$customUserAgentState[input.category];
            }
        });
    };
    return cleanUpCallback;
};
const $241333051c8fcffd$export$e399dbcfd99a2928 = (category, api)=>$241333051c8fcffd$var$customUserAgentState[category]?.[api]?.additionalDetails;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f1e6ffab4508d917$var$BASE_USER_AGENT = `aws-amplify`;
/** Sanitize Amplify version string be removing special character + and character post the special character  */ const $f1e6ffab4508d917$export$b8f78c57ec316f83 = (amplifyVersion)=>amplifyVersion.replace(/\+.*/, '');
class $f1e6ffab4508d917$var$PlatformBuilder {
    constructor(){
        this.userAgent = `${$f1e6ffab4508d917$var$BASE_USER_AGENT}/${$f1e6ffab4508d917$export$b8f78c57ec316f83((0, $d69e86718301ccbb$export$83d89fbfd8236492))}`;
    }
    get framework() {
        return (0, $79709d4b52dec43b$export$9ce73e459ec93b6a)();
    }
    get isReactNative() {
        return this.framework === (0, $c2cf6542a631fa20$export$638889172ebce0c4).ReactNative || this.framework === (0, $c2cf6542a631fa20$export$638889172ebce0c4).Expo;
    }
    observeFrameworkChanges(fcn) {
        (0, $79709d4b52dec43b$export$5d5c467ce0b213f)(fcn);
    }
}
const $f1e6ffab4508d917$export$2dffd0b5373a4389 = new $f1e6ffab4508d917$var$PlatformBuilder();
const $f1e6ffab4508d917$export$7d201307d8979e21 = ({ category: category, action: action } = {})=>{
    const userAgent = [
        [
            $f1e6ffab4508d917$var$BASE_USER_AGENT,
            $f1e6ffab4508d917$export$b8f78c57ec316f83((0, $d69e86718301ccbb$export$83d89fbfd8236492))
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        'framework',
        (0, $79709d4b52dec43b$export$9ce73e459ec93b6a)()
    ]);
    if (category && action) {
        const customState = (0, $241333051c8fcffd$export$e399dbcfd99a2928)(category, action);
        if (customState) customState.forEach((state)=>{
            userAgent.push(state);
        });
    }
    return userAgent;
};
const $f1e6ffab4508d917$export$ede38edb26c0bfdf = (customUserAgentDetails)=>{
    const userAgent = $f1e6ffab4508d917$export$7d201307d8979e21(customUserAgentDetails);
    const userAgentString = userAgent.map(([agentKey, agentValue])=>agentKey && agentValue ? `${agentKey}/${agentValue}` : agentKey).join(' ');
    return userAgentString;
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c2082beb1843d999$export$978f9418fe0cb26c = (response)=>{
    const { headers: headers, statusCode: statusCode } = response;
    return {
        ...$c2082beb1843d999$var$isMetadataBearer(response) ? response.$metadata : {},
        httpStatusCode: statusCode,
        requestId: headers['x-amzn-requestid'] ?? headers['x-amzn-request-id'] ?? headers['x-amz-request-id'],
        extendedRequestId: headers['x-amz-id-2'],
        cfId: headers['x-amz-cf-id']
    };
};
const $c2082beb1843d999$var$isMetadataBearer = (response)=>typeof response?.$metadata === 'object';



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Utility functions for serializing and deserializing of JSON protocol in general(including: REST-JSON, JSON-RPC, etc.)
 */ /**
 * Error parser for AWS JSON protocol.
 */ const $5267ac398181f2f6$export$be467dfcc0538e25 = async (response)=>{
    if (!response || response.statusCode < 300) return;
    const body = await $5267ac398181f2f6$export$759bcb35b0d1bf81(response);
    const sanitizeErrorCode = (rawValue)=>{
        const [cleanValue] = rawValue.toString().split(/[,:]+/);
        if (cleanValue.includes('#')) return cleanValue.split('#')[1];
        return cleanValue;
    };
    const code = sanitizeErrorCode(response.headers['x-amzn-errortype'] ?? body.code ?? body.__type ?? 'UnknownError');
    const message = body.message ?? body.Message ?? 'Unknown error';
    const error = new Error(message);
    return Object.assign(error, {
        name: code,
        $metadata: (0, $c2082beb1843d999$export$978f9418fe0cb26c)(response)
    });
};
/**
 * Parse JSON response body to JavaScript object.
 */ const $5267ac398181f2f6$export$759bcb35b0d1bf81 = async (response)=>{
    if (!response.body) throw new Error('Missing response payload');
    const output = await response.body.json();
    return Object.assign(output, {
        $metadata: (0, $c2082beb1843d999$export$978f9418fe0cb26c)(response)
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a service API handler that accepts input as defined shape and responds conforming to defined output shape.
 * A service API handler is composed with:
 * * A transfer handler
 * * A serializer function
 * * A deserializer function
 * * A default config object
 *
 * The returned service API handler, when called, will trigger the following workflow:
 * 1. When calling the service API handler function, the default config object is merged into the input config
 * object to assign the default values of some omitted configs, resulting to a resolved config object.
 * 2. The `endpointResolver` function from the default config object will be invoked with the resolved config object and
 * API input object resulting to an endpoint instance.
 * 3. The serializer function is invoked with API input object and the endpoint instance resulting to an HTTP request
 * instance.
 * 4. The HTTP request instance and the resolved config object is passed to the transfer handler function.
 * 5. The transfer handler function resolves to an HTTP response instance(can be either successful or failed status code).
 * 6. The deserializer function is invoked with the HTTP response instance resulting to the API output object, and
 * return to the caller.
 *
 *
 * @param transferHandler Async function for dispatching HTTP requests and returning HTTP response.
 * @param serializer  Async function for converting object in defined input shape into HTTP request targeting a given
 * 	endpoint.
 * @param deserializer Async function for converting HTTP response into output object in defined output shape, or error
 * 	shape.
 * @param defaultConfig  object containing default options to be consumed by transfer handler, serializer and
 *  deserializer.
 * @returns a async service API handler function that accepts a config object and input object in defined shape, returns
 * 	an output object in defined shape. It may also throw error instance in defined shape in deserializer. The config
 *  object type is composed with options type of transferHandler, endpointResolver function as well as endpointResolver
 *  function's input options type, region string. The config object property will be marked as optional if it's also
 * 	defined in defaultConfig.
 *
 * @internal
 */ const $d542fb085dbe76dd$export$880429a8ae983d4d = (transferHandler, serializer, deserializer, defaultConfig)=>{
    return async (config, input)=>{
        const resolvedConfig = {
            ...defaultConfig,
            ...config
        };
        // We need to allow different endpoints based on both given config(other than region) and input.
        // However for most of non-S3 services, region is the only input for endpoint resolver.
        const endpoint = await resolvedConfig.endpointResolver(resolvedConfig, input);
        // Unlike AWS SDK clients, a serializer should NOT populate the `host` or `content-length` headers.
        // Both of these headers are prohibited per Spec(https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name).
        // They will be populated automatically by browser, or node-fetch polyfill.
        const request = await serializer(input, endpoint);
        const response = await transferHandler(request, {
            ...resolvedConfig
        });
        return deserializer(response);
    };
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $5a8fb71cadaa5fa2$export$76041b1400befb8b = 300000;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ function $79e48ac4124308d2$export$caea50bde345f648(maxDelayMs = (0, $5a8fb71cadaa5fa2$export$76041b1400befb8b)) {
    const BASE_TIME_MS = 100;
    const JITTER_FACTOR = 100;
    return (attempt)=>{
        const delay = 2 ** attempt * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $99d8f576b000d280$export$75829a87374c6534 = 3;
const $99d8f576b000d280$export$ec2fb17ba97fe7ed = 'amz-sdk-invocation-id';
const $99d8f576b000d280$export$d5da05c23e67fcde = 'amz-sdk-request';
const $99d8f576b000d280$export$174c32b9a171db76 = 300000;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
const $cec796d2dc7b6bb0$export$caea50bde345f648 = (attempt)=>{
    const delayFunction = (0, $79e48ac4124308d2$export$caea50bde345f648)((0, $99d8f576b000d280$export$174c32b9a171db76));
    const delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? (0, $99d8f576b000d280$export$174c32b9a171db76) : delay;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
const $c2046179980246c0$var$CLOCK_SKEW_ERROR_CODES = [
    'AuthFailure',
    'InvalidSignatureException',
    'RequestExpired',
    'RequestInTheFuture',
    'RequestTimeTooSkewed',
    'SignatureDoesNotMatch',
    'BadRequestException'
];
/**
 * Given an error code, returns true if it is related to a clock skew error.
 *
 * @param errorCode String representation of some error.
 * @returns True if given error is present in `CLOCK_SKEW_ERROR_CODES`, false otherwise.
 *
 * @internal
 */ const $c2046179980246c0$export$7b87435661177a94 = (errorCode)=>!!errorCode && $c2046179980246c0$var$CLOCK_SKEW_ERROR_CODES.includes(errorCode);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get retry decider function
 * @param errorParser Function to load JavaScript error from HTTP response
 */ const $2834a3e909bad72b$export$b919d98317a7685f = (errorParser)=>async (response, error)=>{
        const parsedError = error ?? await errorParser(response) ?? undefined;
        const errorCode = parsedError?.code || parsedError?.name;
        const statusCode = response?.statusCode;
        const isRetryable = $2834a3e909bad72b$var$isConnectionError(error) || $2834a3e909bad72b$var$isThrottlingError(statusCode, errorCode) || (0, $c2046179980246c0$export$7b87435661177a94)(errorCode) || $2834a3e909bad72b$var$isServerSideError(statusCode, errorCode);
        return {
            retryable: isRetryable
        };
    };
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
const $2834a3e909bad72b$var$THROTTLING_ERROR_CODES = [
    'BandwidthLimitExceeded',
    'EC2ThrottledException',
    'LimitExceededException',
    'PriorRequestNotComplete',
    'ProvisionedThroughputExceededException',
    'RequestLimitExceeded',
    'RequestThrottled',
    'RequestThrottledException',
    'SlowDown',
    'ThrottledException',
    'Throttling',
    'ThrottlingException',
    'TooManyRequestsException'
];
const $2834a3e909bad72b$var$TIMEOUT_ERROR_CODES = [
    'TimeoutError',
    'RequestTimeout',
    'RequestTimeoutException'
];
const $2834a3e909bad72b$var$isThrottlingError = (statusCode, errorCode)=>statusCode === 429 || !!errorCode && $2834a3e909bad72b$var$THROTTLING_ERROR_CODES.includes(errorCode);
const $2834a3e909bad72b$var$isConnectionError = (error)=>[
        (0, $0f90bdfda3f0916b$export$4e712df6b850c8d0).NetworkError,
        // TODO(vNext): unify the error code `ERR_NETWORK` used by the Storage XHR handler
        'ERR_NETWORK'
    ].includes(error?.name);
const $2834a3e909bad72b$var$isServerSideError = (statusCode, errorCode)=>!!statusCode && [
        500,
        502,
        503,
        504
    ].includes(statusCode) || !!errorCode && $2834a3e909bad72b$var$TIMEOUT_ERROR_CODES.includes(errorCode);
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $81f7009c97cf3adf$export$b8d936b6160bc3fa = 'cognito-identity';
const $81f7009c97cf3adf$export$22a3716e7860147a = {
    service: $81f7009c97cf3adf$export$b8d936b6160bc3fa,
    retryDecider: (0, $2834a3e909bad72b$export$b919d98317a7685f)((0, $5267ac398181f2f6$export$be467dfcc0538e25)),
    computeDelay: (0, $cec796d2dc7b6bb0$export$caea50bde345f648),
    cache: 'no-store'
};





/**
 * Middleware that executes the retry logic.
 */ const $c3e8eb6d4c0395de$export$72f002d3da1a429f = ({ maxAttempts: maxAttempts = (0, $99d8f576b000d280$export$75829a87374c6534), retryDecider: retryDecider, computeDelay: computeDelay, abortSignal: abortSignal })=>{
    if (maxAttempts < 1) throw new Error('maxAttempts must be greater than 0');
    return (next, context)=>async function retryMiddleware(request) {
            let error;
            let attemptsCount = context.attemptsCount ?? 0;
            let response;
            // When retry is not needed or max attempts is reached, either error or response will be set. This function handles either cases.
            const handleTerminalErrorOrResponse = ()=>{
                if (response) {
                    $c3e8eb6d4c0395de$var$addOrIncrementMetadataAttempts(response, attemptsCount);
                    return response;
                } else {
                    $c3e8eb6d4c0395de$var$addOrIncrementMetadataAttempts(error, attemptsCount);
                    throw error;
                }
            };
            while(!abortSignal?.aborted && attemptsCount < maxAttempts){
                try {
                    response = await next(request);
                    error = undefined;
                } catch (e) {
                    error = e;
                    response = undefined;
                }
                // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                attemptsCount = (context.attemptsCount ?? 0) > attemptsCount ? context.attemptsCount ?? 0 : attemptsCount + 1;
                context.attemptsCount = attemptsCount;
                const { isCredentialsExpiredError: isCredentialsExpiredError, retryable: retryable } = await retryDecider(response, error, context);
                if (retryable) {
                    // Setting isCredentialsInvalid flag to notify signing middleware to forceRefresh credentials provider.
                    context.isCredentialsExpired = !!isCredentialsExpiredError;
                    if (!abortSignal?.aborted && attemptsCount < maxAttempts) {
                        // prevent sleep for last attempt or cancelled request;
                        const delay = computeDelay(attemptsCount);
                        await $c3e8eb6d4c0395de$var$cancellableSleep(delay, abortSignal);
                    }
                    continue;
                } else return handleTerminalErrorOrResponse();
            }
            if (abortSignal?.aborted) throw new Error('Request aborted.');
            else return handleTerminalErrorOrResponse();
        };
};
const $c3e8eb6d4c0395de$var$cancellableSleep = (timeoutMs, abortSignal)=>{
    if (abortSignal?.aborted) return Promise.resolve();
    let timeoutId;
    let sleepPromiseResolveFn;
    const sleepPromise = new Promise((resolve)=>{
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal?.addEventListener('abort', function cancelSleep(_) {
        clearTimeout(timeoutId);
        abortSignal?.removeEventListener('abort', cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
const $c3e8eb6d4c0395de$var$addOrIncrementMetadataAttempts = (nextHandlerOutput, attempts)=>{
    if (Object.prototype.toString.call(nextHandlerOutput) !== '[object Object]') return;
    nextHandlerOutput.$metadata = {
        ...nextHandlerOutput.$metadata ?? {},
        attempts: attempts
    };
};











const $97ae8b3805167e21$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $97ae8b3805167e21$export$2e2bcd8739ae039 = {
    randomUUID: $97ae8b3805167e21$var$randomUUID
};


let $85ea56ff2db29b62$var$getRandomValues;
const $85ea56ff2db29b62$var$rnds8 = new Uint8Array(16);
function $85ea56ff2db29b62$export$2e2bcd8739ae039() {
    if (!$85ea56ff2db29b62$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $85ea56ff2db29b62$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $85ea56ff2db29b62$var$getRandomValues($85ea56ff2db29b62$var$rnds8);
}


var $0666c7b8d6a0c645$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $4e055d4cda77273a$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $0666c7b8d6a0c645$export$2e2bcd8739ae039).test(uuid);
}
var $4e055d4cda77273a$export$2e2bcd8739ae039 = $4e055d4cda77273a$var$validate;


const $b5e1fb15acbc67a3$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$b5e1fb15acbc67a3$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $b5e1fb15acbc67a3$export$8fb373d660548968(arr, offset = 0) {
    return ($b5e1fb15acbc67a3$var$byteToHex[arr[offset + 0]] + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 1]] + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 2]] + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 3]] + '-' + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 4]] + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 5]] + '-' + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 6]] + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 7]] + '-' + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 8]] + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 9]] + '-' + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 10]] + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 11]] + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 12]] + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 13]] + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 14]] + $b5e1fb15acbc67a3$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $b5e1fb15acbc67a3$var$stringify(arr, offset = 0) {
    const uuid = $b5e1fb15acbc67a3$export$8fb373d660548968(arr, offset);
    if (!(0, $4e055d4cda77273a$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $b5e1fb15acbc67a3$export$2e2bcd8739ae039 = $b5e1fb15acbc67a3$var$stringify;


function $830142bc66166179$var$v4(options, buf, offset) {
    if ((0, $97ae8b3805167e21$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $97ae8b3805167e21$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $85ea56ff2db29b62$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $b5e1fb15acbc67a3$export$8fb373d660548968)(rnds);
}
var $830142bc66166179$export$2e2bcd8739ae039 = $830142bc66166179$var$v4;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $11fb55e6cb0dea54$export$80bbb53510529a00 = (0, $830142bc66166179$export$2e2bcd8739ae039);












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects a UUID string to `amz-sdk-invocation-id` header.
 * if the header is not set already. This header is helpful to provide
 * observability to group the requests caused by automatic retry.
 *
 * This middleware is standalone because of extra UUID dependency, we will
 * NOT use this middleware for API categories.
 *
 * Ref: https://sdk.amazonaws.com/kotlin/api/smithy-kotlin/api/1.0.9/http-client/aws.smithy.kotlin.runtime.http.operation/-http-operation-context/-sdk-invocation-id.html
 */ const $8736a6c3ad4f7cc9$export$b0cced6a8201397f = ()=>(next)=>{
        return async function amzSdkInvocationIdHeaderMiddleware(request) {
            if (!request.headers[0, $99d8f576b000d280$export$ec2fb17ba97fe7ed]) request.headers[0, $99d8f576b000d280$export$ec2fb17ba97fe7ed] = (0, $11fb55e6cb0dea54$export$80bbb53510529a00)();
            return next(request);
        };
    };



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects `amz-sdk-request` header to indicate the retry state at the time an HTTP request is made.
 * This middleware should co-exist with retryMiddleware as it relies on the retryAttempts value in middleware context
 * set by the retry middleware.
 *
 * Example header: `amz-sdk-request: attempt=1; max=3`.
 *
 * This middleware is standalone because of extra headers may conflict with custom endpoint settings(e.g. CORS), we will
 * NOT use this middleware for API categories.
 */ const $edf3c84be4a8c2a5$export$6550d5b3b0ddb1d5 = ({ maxAttempts: maxAttempts = (0, $99d8f576b000d280$export$75829a87374c6534) })=>(next, context)=>{
        return async function amzSdkRequestHeaderMiddleware(request) {
            const attemptsCount = context.attemptsCount ?? 0;
            request.headers[0, $99d8f576b000d280$export$d5da05c23e67fcde] = `attempt=${attemptsCount + 1}; max=${maxAttempts}`;
            return next(request);
        };
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects user agent string to specified header(default to 'x-amz-user-agent'),
 * if the header is not set already.
 *
 * TODO: incorporate new user agent design
 */ const $7136c535d162728a$export$ff28171a05413bc5 = ({ userAgentHeader: userAgentHeader = 'x-amz-user-agent', userAgentValue: userAgentValue = '' })=>(next)=>{
        return async function userAgentMiddleware(request) {
            if (userAgentValue.trim().length === 0) {
                const result = await next(request);
                return result;
            } else {
                const headerName = userAgentHeader.toLowerCase();
                request.headers[headerName] = request.headers[headerName] ? `${request.headers[headerName]} ${userAgentValue}` : userAgentValue;
                const response = await next(request);
                return response;
            }
        };
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ const $5e4ae0c57a3d0fa3$export$f074d76e52925468 = (coreHandler, middleware)=>(request, options)=>{
        const context = {};
        let composedHandler = (composeHandlerRequest)=>coreHandler(composeHandlerRequest, options);
        for(let i = middleware.length - 1; i >= 0; i--){
            const m = middleware[i];
            const resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ const $e4fd390debf7c66b$export$580ad1ce15092b15 = (payloadAccessor)=>{
    let cached;
    return ()=>{
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $adb62b7891f8b528$var$shouldSendBody = (method)=>![
        'HEAD',
        'GET'
    ].includes(method.toUpperCase());
// TODO[AllanZhengYP]: we need to provide isCanceledError utility
const $adb62b7891f8b528$export$d2573baf35521e4c = async ({ url: url, method: method, headers: headers, body: body }, { abortSignal: abortSignal, cache: cache, withCrossDomainCredentials: withCrossDomainCredentials })=>{
    let resp;
    try {
        resp = await fetch(url, {
            method: method,
            headers: headers,
            body: $adb62b7891f8b528$var$shouldSendBody(method) ? body : undefined,
            signal: abortSignal,
            cache: cache,
            credentials: withCrossDomainCredentials ? 'include' : 'same-origin'
        });
    } catch (e) {
        if (e instanceof TypeError) throw new (0, $c848663d1100c12f$export$37321a6dace1881c)({
            name: (0, $0f90bdfda3f0916b$export$4e712df6b850c8d0).NetworkError,
            message: 'A network error has occurred.',
            underlyingError: e
        });
        throw e;
    }
    const responseHeaders = {};
    resp.headers?.forEach((value, key)=>{
        responseHeaders[key.toLowerCase()] = value;
    });
    const httpResponse = {
        statusCode: resp.status,
        headers: responseHeaders,
        body: null
    };
    // resp.body is a ReadableStream according to Fetch API spec, but React Native
    // does not implement it.
    const bodyWithMixin = Object.assign(resp.body ?? {}, {
        text: (0, $e4fd390debf7c66b$export$580ad1ce15092b15)(()=>resp.text()),
        blob: (0, $e4fd390debf7c66b$export$580ad1ce15092b15)(()=>resp.blob()),
        json: (0, $e4fd390debf7c66b$export$580ad1ce15092b15)(()=>resp.json())
    });
    return {
        ...httpResponse,
        body: bodyWithMixin
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $5daf8bf9553757d0$export$ed7e1ccf00f39c4a = (0, $5e4ae0c57a3d0fa3$export$f074d76e52925468)((0, $adb62b7891f8b528$export$d2573baf35521e4c), [
    (0, $7136c535d162728a$export$ff28171a05413bc5),
    (0, $8736a6c3ad4f7cc9$export$b0cced6a8201397f),
    (0, $c3e8eb6d4c0395de$export$72f002d3da1a429f),
    (0, $edf3c84be4a8c2a5$export$6550d5b3b0ddb1d5)
]);
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $7b94092130d02c99$export$86e9249ea12798b8 = ()=>(next)=>async function disableCacheMiddleware(request) {
            request.headers['cache-control'] = 'no-store';
            return next(request);
        };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $681ce518a1ff6652$export$8029646671d2c482 = (0, $5e4ae0c57a3d0fa3$export$f074d76e52925468)((0, $5daf8bf9553757d0$export$ed7e1ccf00f39c4a), [
    (0, $7b94092130d02c99$export$86e9249ea12798b8)
]);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $60f3935c9cee1fbe$export$c234d706564f344 = (operation)=>(input, endpoint)=>{
        const headers = $60f3935c9cee1fbe$var$getSharedHeaders(operation);
        const body = JSON.stringify(input);
        return $60f3935c9cee1fbe$export$a692bdb7eb624f96(endpoint, headers, body);
    };
const $60f3935c9cee1fbe$var$getSharedHeaders = (operation)=>({
        'content-type': 'application/x-amz-json-1.1',
        'x-amz-target': `AWSCognitoIdentityService.${operation}`
    });
const $60f3935c9cee1fbe$export$a692bdb7eb624f96 = ({ url: url }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: 'POST'
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c397c0b8c37c8ae9$export$5994eaf220022b69 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $681ce518a1ff6652$export$8029646671d2c482), (0, $60f3935c9cee1fbe$export$c234d706564f344)('GetCredentialsForIdentity'), $c397c0b8c37c8ae9$var$getCredentialsForIdentityDeserializer, {
        ...(0, $81f7009c97cf3adf$export$22a3716e7860147a),
        ...config,
        userAgentValue: (0, $f1e6ffab4508d917$export$ede38edb26c0bfdf)()
    });
const $c397c0b8c37c8ae9$var$getCredentialsForIdentityDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $5267ac398181f2f6$export$be467dfcc0538e25)(response);
        throw error;
    }
    const body = await (0, $5267ac398181f2f6$export$759bcb35b0d1bf81)(response);
    return {
        IdentityId: body.IdentityId,
        Credentials: $c397c0b8c37c8ae9$var$deserializeCredentials(body.Credentials),
        $metadata: (0, $c2082beb1843d999$export$978f9418fe0cb26c)(response)
    };
};
const $c397c0b8c37c8ae9$var$deserializeCredentials = ({ Expiration: Expiration, ...rest } = {})=>({
        ...rest,
        Expiration: Expiration && new Date(Expiration * 1000)
    });





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2f3406124c4dec3f$export$e003cc239f955cb6 = ()=>{
    if (typeof window === 'object' && typeof window.crypto === 'object') return window.crypto;
    // Next.js global polyfill
    if (typeof crypto === 'object') return crypto;
    throw new (0, $c848663d1100c12f$export$37321a6dace1881c)({
        name: 'MissingPolyfill',
        message: 'Cannot resolve the `crypto` function from the environment.'
    });
};
const $2f3406124c4dec3f$export$94f295707b435c6d = ()=>{
    // browser
    if (typeof window !== 'undefined' && typeof window.btoa === 'function') return window.btoa;
    // Next.js global polyfill
    if (typeof btoa === 'function') return btoa;
    throw new (0, $c848663d1100c12f$export$37321a6dace1881c)({
        name: 'Base64EncoderError',
        message: 'Cannot resolve the `btoa` function from the environment.'
    });
};
const $2f3406124c4dec3f$export$ea737e7700106b27 = ()=>{
    // browser
    if (typeof window !== 'undefined' && typeof window.atob === 'function') return window.atob;
    // Next.js global polyfill
    if (typeof atob === 'function') return atob;
    throw new (0, $c848663d1100c12f$export$37321a6dace1881c)({
        name: 'Base64EncoderError',
        message: 'Cannot resolve the `atob` function from the environment.'
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $05be7a5c43db640d$export$1e303d38dab7b376 = {
    convert (input, options) {
        let inputStr = input;
        // urlSafe character replacement options conform to the base64 url spec
        // https://datatracker.ietf.org/doc/html/rfc4648#page-7
        if (options?.urlSafe) inputStr = inputStr.replace(/-/g, '+').replace(/_/g, '/');
        return (0, $2f3406124c4dec3f$export$ea737e7700106b27)()(inputStr);
    }
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $97bdb48788a05322$export$5cb8fc27ccbe9d40 = (errorMap, AssertionError = (0, $c848663d1100c12f$export$37321a6dace1881c))=>(assertion, name, additionalContext)=>{
        const { message: message, recoverySuggestion: recoverySuggestion } = errorMap[name];
        if (!assertion) throw new AssertionError({
            name: name,
            message: additionalContext ? `${message} ${additionalContext}` : message,
            recoverySuggestion: recoverySuggestion
        });
    };




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $801d59d662573802$export$7b5c8b570ea8407;
(function(AuthConfigurationErrorCode) {
    AuthConfigurationErrorCode["AuthTokenConfigException"] = "AuthTokenConfigException";
    AuthConfigurationErrorCode["AuthUserPoolAndIdentityPoolException"] = "AuthUserPoolAndIdentityPoolException";
    AuthConfigurationErrorCode["AuthUserPoolException"] = "AuthUserPoolException";
    AuthConfigurationErrorCode["InvalidIdentityPoolIdException"] = "InvalidIdentityPoolIdException";
    AuthConfigurationErrorCode["OAuthNotConfigureException"] = "OAuthNotConfigureException";
})($801d59d662573802$export$7b5c8b570ea8407 || ($801d59d662573802$export$7b5c8b570ea8407 = {}));
const $801d59d662573802$var$authConfigurationErrorMap = {
    [$801d59d662573802$export$7b5c8b570ea8407.AuthTokenConfigException]: {
        message: 'Auth Token Provider not configured.',
        recoverySuggestion: 'Make sure to call Amplify.configure in your app.'
    },
    [$801d59d662573802$export$7b5c8b570ea8407.AuthUserPoolAndIdentityPoolException]: {
        message: 'Auth UserPool or IdentityPool not configured.',
        recoverySuggestion: 'Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId.'
    },
    [$801d59d662573802$export$7b5c8b570ea8407.AuthUserPoolException]: {
        message: 'Auth UserPool not configured.',
        recoverySuggestion: 'Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId.'
    },
    [$801d59d662573802$export$7b5c8b570ea8407.InvalidIdentityPoolIdException]: {
        message: 'Invalid identity pool id provided.',
        recoverySuggestion: 'Make sure a valid identityPoolId is given in the config.'
    },
    [$801d59d662573802$export$7b5c8b570ea8407.OAuthNotConfigureException]: {
        message: 'oauth param not configured.',
        recoverySuggestion: 'Make sure to call Amplify.configure with oauth parameter in your app.'
    }
};
const $801d59d662573802$export$a7a9523472993e97 = (0, $97bdb48788a05322$export$5cb8fc27ccbe9d40)($801d59d662573802$var$authConfigurationErrorMap);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $5c85900a0ff57646$export$80c92581e59ed502(cognitoConfig) {
    let assertionValid = true; // assume valid until otherwise proveed
    if (!cognitoConfig) assertionValid = false;
    else assertionValid = !!cognitoConfig.userPoolId && !!cognitoConfig.userPoolClientId;
    (0, $801d59d662573802$export$a7a9523472993e97)(assertionValid, (0, $801d59d662573802$export$7b5c8b570ea8407).AuthUserPoolException);
}
function $5c85900a0ff57646$export$c13e6dbaf90a8e5f(cognitoConfig) {
    const validOAuthConfig = !!cognitoConfig?.loginWith?.oauth?.domain && !!cognitoConfig?.loginWith?.oauth?.redirectSignOut && !!cognitoConfig?.loginWith?.oauth?.redirectSignIn && !!cognitoConfig?.loginWith?.oauth?.responseType;
    (0, $801d59d662573802$export$a7a9523472993e97)(validOAuthConfig, (0, $801d59d662573802$export$7b5c8b570ea8407).OAuthNotConfigureException);
}
function $5c85900a0ff57646$export$8a2f5318ea3215e3(cognitoConfig) {
    const validConfig = !!cognitoConfig?.identityPoolId;
    (0, $801d59d662573802$export$a7a9523472993e97)(validConfig, (0, $801d59d662573802$export$7b5c8b570ea8407).InvalidIdentityPoolIdException);
}
/**
 * Decodes payload of JWT token
 *
 * @param {String} token A string representing a token to be decoded
 * @throws {@link Error} - Throws error when token is invalid or payload malformed.
 */ function $5c85900a0ff57646$export$9a62e6c0a30e00bc(token) {
    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) throw new Error('Invalid token');
    try {
        const base64WithUrlSafe = tokenParts[1];
        const base64 = base64WithUrlSafe.replace(/-/g, '+').replace(/_/g, '/');
        const jsonStr = decodeURIComponent((0, $05be7a5c43db640d$export$1e303d38dab7b376).convert(base64).split('').map((char)=>`%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`).join(''));
        const payload = JSON.parse(jsonStr);
        return {
            toString: ()=>token,
            payload: payload
        };
    } catch (err) {
        throw new Error('Invalid token payload');
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $6b5d16e8c6288a5f$export$145273558d58e0ac extends (0, $c848663d1100c12f$export$37321a6dace1881c) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $6b5d16e8c6288a5f$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $6b5d16e8c6288a5f$export$145273558d58e0ac.prototype);
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $d7152ac0bbeb6a00$export$5b3890f50cd4853f(error) {
    if (!error || error.name === 'Error' || error instanceof TypeError) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: (0, $0f90bdfda3f0916b$export$4e712df6b850c8d0).Unknown,
        message: 'An unknown error has occurred.',
        underlyingError: error
    });
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $26bed30b682a3f10$export$5f7eb9761ac2d0d9(userPoolId) {
    const region = userPoolId?.split('_')[0];
    if (!userPoolId || userPoolId.indexOf('_') < 0 || !region || typeof region !== 'string') throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: 'InvalidUserPoolId',
        message: 'Invalid user pool id provided.'
    });
    return region;
}
function $26bed30b682a3f10$export$8fb32fba519c460(identityPoolId) {
    if (!identityPoolId || !identityPoolId.includes(':')) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: 'InvalidIdentityPoolIdException',
        message: 'Invalid identity pool id provided.',
        recoverySuggestion: 'Make sure a valid identityPoolId is given in the config.'
    });
    return identityPoolId.split(':')[0];
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $6c49017af88bac4c$export$d29d1996d6b6f5e3 = 'UserUnAuthenticatedException';
const $6c49017af88bac4c$export$bdd0e7e9babcd5c8 = 'UserAlreadyAuthenticatedException';
const $6c49017af88bac4c$export$740e7000ac27ebf3 = 'DeviceMetadataNotFoundException';
const $6c49017af88bac4c$export$fe46a12932d2550a = 'AutoSignInException';
const $6c49017af88bac4c$export$36f9d08d6bc647dd = 'InvalidRedirectException';
const $6c49017af88bac4c$export$a2095d473f418f40 = 'InvalidAppSchemeException';
const $6c49017af88bac4c$export$818bb4aeac915442 = 'InvalidPreferredRedirectUrlException';
const $6c49017af88bac4c$export$60b68b138a52e5ae = new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
    name: $6c49017af88bac4c$export$36f9d08d6bc647dd,
    message: 'signInRedirect or signOutRedirect had an invalid format or was not found.',
    recoverySuggestion: 'Please make sure the signIn/Out redirect in your oauth config is valid.'
});
const $6c49017af88bac4c$export$c1829c2a0b9b2e21 = new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
    name: $6c49017af88bac4c$export$a2095d473f418f40,
    message: 'A valid non-http app scheme was not found in the config.',
    recoverySuggestion: 'Please make sure a valid custom app scheme is present in the config.'
});
const $6c49017af88bac4c$export$41a56a70fc1a4962 = new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
    name: $6c49017af88bac4c$export$818bb4aeac915442,
    message: 'The given preferredRedirectUrl does not match any items in the redirectSignOutUrls array from the config.',
    recoverySuggestion: 'Please make sure a matching preferredRedirectUrl is provided.'
});
const $6c49017af88bac4c$export$27ddc47447101bcf = 'InvalidOriginException';
const $6c49017af88bac4c$export$c01b4acd6291e035 = new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
    name: $6c49017af88bac4c$export$27ddc47447101bcf,
    message: 'redirect is coming from a different origin. The oauth flow needs to be initiated from the same origin',
    recoverySuggestion: 'Please call signInWithRedirect from the same origin.'
});
const $6c49017af88bac4c$export$625255707e22459c = 'OAuthSignOutException';
const $6c49017af88bac4c$export$a0a904daf48e2c33 = 'TokenRefreshException';
const $6c49017af88bac4c$export$606cffc85964c24b = 'UnexpectedSignInInterruptionException';


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $6cdbc20a8ad3ee2e$export$d76f9f8544dc304d(authConfig) {
    if (authConfig && authConfig.Cognito.userPoolId && authConfig.Cognito.userPoolClientId) return true;
    return false;
}
function $6cdbc20a8ad3ee2e$export$77712ea5882cac9f(tokens) {
    if (!tokens || !tokens.accessToken) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: (0, $6c49017af88bac4c$export$d29d1996d6b6f5e3),
        message: 'User needs to be authenticated to call this API.',
        recoverySuggestion: 'Sign in before calling this API again.'
    });
}
function $6cdbc20a8ad3ee2e$export$f4d99632f0717a4b(tokens) {
    if (!tokens || !tokens.idToken) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: (0, $6c49017af88bac4c$export$d29d1996d6b6f5e3),
        message: 'User needs to be authenticated to call this API.',
        recoverySuggestion: 'Sign in before calling this API again.'
    });
}
const $6cdbc20a8ad3ee2e$export$31fce2aaeafa4b60 = new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
    name: (0, $6c49017af88bac4c$export$a0a904daf48e2c33),
    message: `Token refresh is not supported when authenticated with the 'implicit grant' (token) oauth flow. 
	Please change your oauth configuration to use 'code grant' flow.`,
    recoverySuggestion: `Please logout and change your Amplify configuration to use "code grant" flow. 
	E.g { responseType: 'code' }`
});
const $6cdbc20a8ad3ee2e$export$35cfa8cbd2d5bcdd = new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
    name: (0, $6c49017af88bac4c$export$d29d1996d6b6f5e3),
    message: 'User needs to be authenticated to call this API.',
    recoverySuggestion: 'Sign in before calling this API again.'
});
function $6cdbc20a8ad3ee2e$export$be38b2d22222d505(tokens) {
    if ($6cdbc20a8ad3ee2e$var$isAuthenticatedWithImplicitOauthFlow(tokens)) throw $6cdbc20a8ad3ee2e$export$31fce2aaeafa4b60;
    if (!$6cdbc20a8ad3ee2e$var$isAuthenticatedWithRefreshToken(tokens)) throw $6cdbc20a8ad3ee2e$export$35cfa8cbd2d5bcdd;
}
function $6cdbc20a8ad3ee2e$export$b6f03be79626ab0f(deviceMetadata) {
    if (!deviceMetadata || !deviceMetadata.deviceKey || !deviceMetadata.deviceGroupKey || !deviceMetadata.randomPassword) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: (0, $6c49017af88bac4c$export$740e7000ac27ebf3),
        message: 'Either deviceKey, deviceGroupKey or secretPassword were not found during the sign-in process.',
        recoverySuggestion: 'Make sure to not clear storage after calling the signIn API.'
    });
}
const $6cdbc20a8ad3ee2e$export$3820b4ff343394ea = {
    inflightOAuth: 'inflightOAuth',
    oauthSignIn: 'oauthSignIn',
    oauthPKCE: 'oauthPKCE',
    oauthState: 'oauthState'
};
function $6cdbc20a8ad3ee2e$var$isAuthenticated(tokens) {
    return tokens?.accessToken || tokens?.idToken;
}
function $6cdbc20a8ad3ee2e$var$isAuthenticatedWithRefreshToken(tokens) {
    return $6cdbc20a8ad3ee2e$var$isAuthenticated(tokens) && tokens?.refreshToken;
}
function $6cdbc20a8ad3ee2e$var$isAuthenticatedWithImplicitOauthFlow(tokens) {
    return $6cdbc20a8ad3ee2e$var$isAuthenticated(tokens) && !tokens?.refreshToken;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ const $d65963faea22982f$export$72f3cee421ee8a74 = {
    id: 'aws',
    outputs: {
        dnsSuffix: 'amazonaws.com'
    },
    regionRegex: '^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$',
    regions: [
        'aws-global'
    ]
};
/**
 * This data is adapted from the partition file from AWS SDK shared utilities but remove some contents for bundle size
 * concern. Information removed are `dualStackDnsSuffix`, `supportDualStack`, `supportFIPS`, restricted partitions, and
 * list of regions for each partition other than global regions.
 *
 * * Ref: https://docs.aws.amazon.com/general/latest/gr/rande.html#regional-endpoints
 * * Ref: https://github.com/aws/aws-sdk-js-v3/blob/0201baef03c2379f1f6f7150b9d401d4b230d488/packages/util-endpoints/src/lib/aws/partitions.json#L1
 *
 * @internal
 */ const $d65963faea22982f$export$d7c12af0c0f12206 = {
    partitions: [
        $d65963faea22982f$export$72f3cee421ee8a74,
        {
            id: 'aws-cn',
            outputs: {
                dnsSuffix: 'amazonaws.com.cn'
            },
            regionRegex: '^cn\\-\\w+\\-\\d+$',
            regions: [
                'aws-cn-global'
            ]
        }
    ]
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get the AWS Services endpoint URL's DNS suffix for a given region. A typical AWS regional service endpoint URL will
 * follow this pattern: {endpointPrefix}.{region}.{dnsSuffix}. For example, the endpoint URL for Cognito Identity in
 * us-east-1 will be cognito-identity.us-east-1.amazonaws.com. Here the DnsSuffix is `amazonaws.com`.
 *
 * @param region
 * @returns The DNS suffix
 *
 * @internal
 */ const $8183f8310104c0d4$export$1c28e37cdcc37f6d = (region)=>{
    const { partitions: partitions } = (0, $d65963faea22982f$export$d7c12af0c0f12206);
    for (const { regions: regions, outputs: outputs, regionRegex: regionRegex } of partitions){
        const regex = new RegExp(regionRegex);
        if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
    }
    return (0, $d65963faea22982f$export$72f3cee421ee8a74).outputs.dnsSuffix;
};








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e4212cfe0940953e$export$beb82d9d9136c16e = URL;
const $e4212cfe0940953e$export$4ea7bbdac595b5fb = URLSearchParams;












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e1a8a6641de3bf19$export$562f22ddc5fcdb97 = ({ region: region })=>({
        url: new (0, $e4212cfe0940953e$export$beb82d9d9136c16e)(`https://${(0, $81f7009c97cf3adf$export$b8d936b6160bc3fa)}.${region}.${(0, $8183f8310104c0d4$export$1c28e37cdcc37f6d)(region)}`)
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $99980684d4d15aab$export$e67952c510717cd6 = ({ endpointOverride: endpointOverride })=>(input)=>{
        if (endpointOverride) return {
            url: new (0, $e4212cfe0940953e$export$beb82d9d9136c16e)(endpointOverride)
        };
        return (0, $e1a8a6641de3bf19$export$562f22ddc5fcdb97)(input);
    };























// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $075bd78ed1e884bc$export$4dec1d0c118e41c8 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $681ce518a1ff6652$export$8029646671d2c482), (0, $60f3935c9cee1fbe$export$c234d706564f344)('GetId'), $075bd78ed1e884bc$var$getIdDeserializer, {
        ...(0, $81f7009c97cf3adf$export$22a3716e7860147a),
        ...config,
        userAgentValue: (0, $f1e6ffab4508d917$export$ede38edb26c0bfdf)()
    });
const $075bd78ed1e884bc$var$getIdDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $5267ac398181f2f6$export$be467dfcc0538e25)(response);
        throw error;
    }
    const body = await (0, $5267ac398181f2f6$export$759bcb35b0d1bf81)(response);
    return {
        IdentityId: body.IdentityId,
        $metadata: (0, $c2082beb1843d999$export$978f9418fe0cb26c)(response)
    };
};










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $86bb803c35b00e84$export$edfb13e85a2c0dc4(idToken) {
    const issuer = (0, $5c85900a0ff57646$export$9a62e6c0a30e00bc)(idToken).payload.iss;
    const res = {};
    if (!issuer) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: 'InvalidIdTokenException',
        message: 'Invalid Idtoken.'
    });
    const domainName = issuer.replace(/(^\w+:|^)\/\//, '');
    res[domainName] = idToken;
    return res;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Provides a Cognito identityId
 *
 * @param tokens - The AuthTokens received after SignIn
 * @returns string
 * @throws configuration exceptions: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service exceptions: {@link GetIdException }
 */ async function $8106e59b01f9ebb6$export$7c3e576630d5e301({ tokens: tokens, authConfig: authConfig, identityIdStore: identityIdStore }) {
    identityIdStore.setAuthConfig({
        Cognito: authConfig
    });
    // will return null only if there is no identityId cached or if there is an error retrieving it
    const identityId = await identityIdStore.loadIdentityId();
    if (identityId) return identityId.id;
    const logins = tokens?.idToken ? (0, $86bb803c35b00e84$export$edfb13e85a2c0dc4)(tokens.idToken.toString()) : {};
    const generatedIdentityId = await $8106e59b01f9ebb6$var$generateIdentityId(logins, authConfig);
    // Store generated identityId
    identityIdStore.storeIdentityId({
        id: generatedIdentityId,
        type: tokens ? 'primary' : 'guest'
    });
    return generatedIdentityId;
}
async function $8106e59b01f9ebb6$var$generateIdentityId(logins, authConfig) {
    const identityPoolId = authConfig?.identityPoolId;
    const region = (0, $26bed30b682a3f10$export$8fb32fba519c460)(identityPoolId);
    const getId = (0, $075bd78ed1e884bc$export$4dec1d0c118e41c8)({
        endpointResolver: (0, $99980684d4d15aab$export$e67952c510717cd6)({
            endpointOverride: authConfig.identityPoolEndpoint
        })
    });
    // IdentityId is absent so get it using IdentityPoolId with Cognito's GetId API
    let idResult;
    // for a first-time user, this will return a brand new identity
    // for a returning user, this will retrieve the previous identity assocaited with the logins
    try {
        idResult = (await getId({
            region: region
        }, {
            IdentityPoolId: identityPoolId,
            Logins: logins
        })).IdentityId;
    } catch (e) {
        (0, $d7152ac0bbeb6a00$export$5b3890f50cd4853f)(e);
        throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)(e);
    }
    if (!idResult) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: 'GetIdResponseException',
        message: 'Received undefined response from getId operation',
        recoverySuggestion: 'Make sure to pass a valid identityPoolId in the configuration.'
    });
    return idResult;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $b01c7b656f4fccc9$var$logger = new (0, $294c375a4ec5088f$export$ba6a9c7ac8291f7f)('CognitoCredentialsProvider');
const $b01c7b656f4fccc9$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
class $b01c7b656f4fccc9$export$be6550e37264dc26 {
    constructor(identityIdStore){
        this._nextCredentialsRefresh = 0;
        this._identityIdStore = identityIdStore;
    }
    async clearCredentialsAndIdentityId() {
        $b01c7b656f4fccc9$var$logger.debug('Clearing out credentials and identityId');
        this._credentialsAndIdentityId = undefined;
        await this._identityIdStore.clearIdentityId();
    }
    async clearCredentials() {
        $b01c7b656f4fccc9$var$logger.debug('Clearing out in-memory credentials');
        this._credentialsAndIdentityId = undefined;
    }
    async getCredentialsAndIdentityId(getCredentialsOptions) {
        const isAuthenticated = getCredentialsOptions.authenticated;
        const { tokens: tokens } = getCredentialsOptions;
        const { authConfig: authConfig } = getCredentialsOptions;
        try {
            (0, $5c85900a0ff57646$export$8a2f5318ea3215e3)(authConfig?.Cognito);
        } catch  {
            // No identity pool configured, skipping
            return;
        }
        if (!isAuthenticated && !authConfig.Cognito.allowGuestAccess) // TODO(V6): return partial result like Native platforms
        return;
        const { forceRefresh: forceRefresh } = getCredentialsOptions;
        const tokenHasChanged = this.hasTokenChanged(tokens);
        const identityId = await (0, $8106e59b01f9ebb6$export$7c3e576630d5e301)({
            tokens: tokens,
            authConfig: authConfig.Cognito,
            identityIdStore: this._identityIdStore
        });
        // Clear cached credentials when forceRefresh is true OR the cache token has changed
        if (forceRefresh || tokenHasChanged) this.clearCredentials();
        if (!isAuthenticated) return this.getGuestCredentials(identityId, authConfig.Cognito);
        else {
            (0, $6cdbc20a8ad3ee2e$export$f4d99632f0717a4b)(tokens);
            return this.credsForOIDCTokens(authConfig.Cognito, tokens, identityId);
        }
    }
    async getGuestCredentials(identityId, authConfig) {
        // Return existing in-memory cached credentials only if it exists, is not past it's lifetime and is unauthenticated credentials
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === false) {
            $b01c7b656f4fccc9$var$logger.info('returning stored credentials as they neither past TTL nor expired.');
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any authenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const region = (0, $26bed30b682a3f10$export$8fb32fba519c460)(authConfig.identityPoolId);
        const getCredentialsForIdentity = (0, $c397c0b8c37c8ae9$export$5994eaf220022b69)({
            endpointResolver: (0, $99980684d4d15aab$export$e67952c510717cd6)({
                endpointOverride: authConfig.identityPoolEndpoint
            })
        });
        // use identityId to obtain guest credentials
        // save credentials in-memory
        // No logins params should be passed for guest creds:
        // https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetCredentialsForIdentity.html
        let clientResult;
        try {
            clientResult = await getCredentialsForIdentity({
                region: region
            }, {
                IdentityId: identityId
            });
        } catch (e) {
            (0, $d7152ac0bbeb6a00$export$5b3890f50cd4853f)(e);
            throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)(e);
        }
        if (clientResult?.Credentials?.AccessKeyId && clientResult?.Credentials?.SecretKey) {
            this._nextCredentialsRefresh = new Date().getTime() + $b01c7b656f4fccc9$var$CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            if (clientResult.IdentityId) {
                res.identityId = clientResult.IdentityId;
                this._identityIdStore.storeIdentityId({
                    id: clientResult.IdentityId,
                    type: 'guest'
                });
            }
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: false
            };
            return res;
        } else throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
            name: 'CredentialsNotFoundException',
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    async credsForOIDCTokens(authConfig, authTokens, identityId) {
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === true) {
            $b01c7b656f4fccc9$var$logger.debug('returning stored credentials as they neither past TTL nor expired.');
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any unauthenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const logins = authTokens.idToken ? (0, $86bb803c35b00e84$export$edfb13e85a2c0dc4)(authTokens.idToken.toString()) : {};
        const region = (0, $26bed30b682a3f10$export$8fb32fba519c460)(authConfig.identityPoolId);
        const getCredentialsForIdentity = (0, $c397c0b8c37c8ae9$export$5994eaf220022b69)({
            endpointResolver: (0, $99980684d4d15aab$export$e67952c510717cd6)({
                endpointOverride: authConfig.identityPoolEndpoint
            })
        });
        let clientResult;
        try {
            clientResult = await getCredentialsForIdentity({
                region: region
            }, {
                IdentityId: identityId,
                Logins: logins
            });
        } catch (e) {
            (0, $d7152ac0bbeb6a00$export$5b3890f50cd4853f)(e);
            throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)(e);
        }
        if (clientResult?.Credentials?.AccessKeyId && clientResult?.Credentials?.SecretKey) {
            this._nextCredentialsRefresh = new Date().getTime() + $b01c7b656f4fccc9$var$CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            if (clientResult.IdentityId) {
                res.identityId = clientResult.IdentityId;
                // note: the following call removes guest identityId from the persistent store (localStorage)
                this._identityIdStore.storeIdentityId({
                    id: clientResult.IdentityId,
                    type: 'primary'
                });
            }
            // Store the credentials in-memory along with the expiration
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: true,
                associatedIdToken: authTokens.idToken?.toString()
            };
            return res;
        } else throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
            name: 'CredentialsException',
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    isPastTTL() {
        return this._nextCredentialsRefresh === undefined ? true : this._nextCredentialsRefresh <= Date.now();
    }
    hasTokenChanged(tokens) {
        return !!tokens && !!this._credentialsAndIdentityId?.associatedIdToken && tokens.idToken?.toString() !== this._credentialsAndIdentityId.associatedIdToken;
    }
}






const $f25bae83eb86ed3d$export$b8429d1428aad8ba = {
    accessToken: 'accessToken',
    idToken: 'idToken',
    oidcProvider: 'oidcProvider',
    clockDrift: 'clockDrift',
    refreshToken: 'refreshToken',
    deviceKey: 'deviceKey',
    randomPasswordKey: 'randomPasswordKey',
    deviceGroupKey: 'deviceGroupKey',
    signInDetails: 'signInDetails',
    oauthMetadata: 'oauthMetadata'
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $66bfb07d169e6aab$export$cc5909720f29144;
(function(TokenProviderErrorCode) {
    TokenProviderErrorCode["InvalidAuthTokens"] = "InvalidAuthTokens";
})($66bfb07d169e6aab$export$cc5909720f29144 || ($66bfb07d169e6aab$export$cc5909720f29144 = {}));
const $66bfb07d169e6aab$var$tokenValidationErrorMap = {
    [$66bfb07d169e6aab$export$cc5909720f29144.InvalidAuthTokens]: {
        message: 'Invalid tokens.',
        recoverySuggestion: 'Make sure the tokens are valid.'
    }
};
const $66bfb07d169e6aab$export$a7a9523472993e97 = (0, $97bdb48788a05322$export$5cb8fc27ccbe9d40)($66bfb07d169e6aab$var$tokenValidationErrorMap);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e2ce8e281b170ab5$export$2c8f6d7ed1534551 = 'CognitoIdentityServiceProvider';


class $b7e461ac2c273bae$export$a36be852d43d512 {
    getKeyValueStorage() {
        if (!this.keyValueStorage) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
            name: 'KeyValueStorageNotFoundException',
            message: 'KeyValueStorage was not found in TokenStore'
        });
        return this.keyValueStorage;
    }
    setKeyValueStorage(keyValueStorage) {
        this.keyValueStorage = keyValueStorage;
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    async loadTokens() {
        // TODO(v6): migration logic should be here
        // Reading V5 tokens old format
        try {
            const authKeys = await this.getAuthKeys();
            const accessTokenString = await this.getKeyValueStorage().getItem(authKeys.accessToken);
            if (!accessTokenString) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
                name: 'NoSessionFoundException',
                message: 'Auth session was not found. Make sure to call signIn.'
            });
            const accessToken = (0, $5c85900a0ff57646$export$9a62e6c0a30e00bc)(accessTokenString);
            const itString = await this.getKeyValueStorage().getItem(authKeys.idToken);
            const idToken = itString ? (0, $5c85900a0ff57646$export$9a62e6c0a30e00bc)(itString) : undefined;
            const refreshToken = await this.getKeyValueStorage().getItem(authKeys.refreshToken) ?? undefined;
            const clockDriftString = await this.getKeyValueStorage().getItem(authKeys.clockDrift) ?? '0';
            const clockDrift = Number.parseInt(clockDriftString);
            const signInDetails = await this.getKeyValueStorage().getItem(authKeys.signInDetails);
            const tokens = {
                accessToken: accessToken,
                idToken: idToken,
                refreshToken: refreshToken,
                deviceMetadata: await this.getDeviceMetadata() ?? undefined,
                clockDrift: clockDrift,
                username: await this.getLastAuthUser()
            };
            if (signInDetails) tokens.signInDetails = JSON.parse(signInDetails);
            return tokens;
        } catch (err) {
            return null;
        }
    }
    async storeTokens(tokens) {
        (0, $66bfb07d169e6aab$export$a7a9523472993e97)(tokens !== undefined, (0, $66bfb07d169e6aab$export$cc5909720f29144).InvalidAuthTokens);
        const lastAuthUser = tokens.username;
        await this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), lastAuthUser);
        const authKeys = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(authKeys.accessToken, tokens.accessToken.toString());
        if (tokens.idToken) await this.getKeyValueStorage().setItem(authKeys.idToken, tokens.idToken.toString());
        else await this.getKeyValueStorage().removeItem(authKeys.idToken);
        if (tokens.refreshToken) await this.getKeyValueStorage().setItem(authKeys.refreshToken, tokens.refreshToken);
        else await this.getKeyValueStorage().removeItem(authKeys.refreshToken);
        if (tokens.deviceMetadata) {
            if (tokens.deviceMetadata.deviceKey) await this.getKeyValueStorage().setItem(authKeys.deviceKey, tokens.deviceMetadata.deviceKey);
            if (tokens.deviceMetadata.deviceGroupKey) await this.getKeyValueStorage().setItem(authKeys.deviceGroupKey, tokens.deviceMetadata.deviceGroupKey);
            await this.getKeyValueStorage().setItem(authKeys.randomPasswordKey, tokens.deviceMetadata.randomPassword);
        }
        if (tokens.signInDetails) await this.getKeyValueStorage().setItem(authKeys.signInDetails, JSON.stringify(tokens.signInDetails));
        else await this.getKeyValueStorage().removeItem(authKeys.signInDetails);
        await this.getKeyValueStorage().setItem(authKeys.clockDrift, `${tokens.clockDrift}`);
    }
    async clearTokens() {
        const authKeys = await this.getAuthKeys();
        // Not calling clear because it can remove data that is not managed by AuthTokenStore
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.accessToken),
            this.getKeyValueStorage().removeItem(authKeys.idToken),
            this.getKeyValueStorage().removeItem(authKeys.clockDrift),
            this.getKeyValueStorage().removeItem(authKeys.refreshToken),
            this.getKeyValueStorage().removeItem(authKeys.signInDetails),
            this.getKeyValueStorage().removeItem(this.getLastAuthUserKey()),
            this.getKeyValueStorage().removeItem(authKeys.oauthMetadata)
        ]);
    }
    async getDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        const deviceKey = await this.getKeyValueStorage().getItem(authKeys.deviceKey);
        const deviceGroupKey = await this.getKeyValueStorage().getItem(authKeys.deviceGroupKey);
        const randomPassword = await this.getKeyValueStorage().getItem(authKeys.randomPasswordKey);
        return randomPassword && deviceGroupKey && deviceKey ? {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        } : null;
    }
    async clearDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.deviceKey),
            this.getKeyValueStorage().removeItem(authKeys.deviceGroupKey),
            this.getKeyValueStorage().removeItem(authKeys.randomPasswordKey)
        ]);
    }
    async getAuthKeys(username) {
        (0, $5c85900a0ff57646$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const lastAuthUser = username ?? await this.getLastAuthUser();
        return $b7e461ac2c273bae$export$4647c72f6828a74d((0, $e2ce8e281b170ab5$export$2c8f6d7ed1534551), `${this.authConfig.Cognito.userPoolClientId}.${lastAuthUser}`);
    }
    getLastAuthUserKey() {
        (0, $5c85900a0ff57646$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const identifier = this.authConfig.Cognito.userPoolClientId;
        return `${0, $e2ce8e281b170ab5$export$2c8f6d7ed1534551}.${identifier}.LastAuthUser`;
    }
    async getLastAuthUser() {
        const lastAuthUser = await this.getKeyValueStorage().getItem(this.getLastAuthUserKey()) ?? 'username';
        return lastAuthUser;
    }
    async setOAuthMetadata(metadata) {
        const { oauthMetadata: oauthMetadataKey } = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(oauthMetadataKey, JSON.stringify(metadata));
    }
    async getOAuthMetadata() {
        const { oauthMetadata: oauthMetadataKey } = await this.getAuthKeys();
        const oauthMetadata = await this.getKeyValueStorage().getItem(oauthMetadataKey);
        return oauthMetadata && JSON.parse(oauthMetadata);
    }
}
const $b7e461ac2c273bae$export$4647c72f6828a74d = (provider, identifier)=>{
    return $b7e461ac2c273bae$export$dfb8da757ca62eed((0, $f25bae83eb86ed3d$export$b8429d1428aad8ba))(`${provider}`, identifier);
};
function $b7e461ac2c273bae$export$dfb8da757ca62eed(authKeys) {
    const keys = Object.values({
        ...authKeys
    });
    return (prefix, identifier)=>keys.reduce((acc, authKey)=>({
                ...acc,
                [authKey]: `${prefix}.${identifier}.${authKey}`
            }), {});
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d8ccbc31127429ce$export$dad1700b96c3a835 = {
    identityId: 'identityId'
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $91156778eb96652a$var$logger = new (0, $294c375a4ec5088f$export$ba6a9c7ac8291f7f)('DefaultIdentityIdStore');
class $91156778eb96652a$export$3e97b78667a539a0 {
    setAuthConfig(authConfigParam) {
        (0, $5c85900a0ff57646$export$8a2f5318ea3215e3)(authConfigParam.Cognito);
        this.authConfig = authConfigParam;
        this._authKeys = $91156778eb96652a$var$createKeysForAuthStorage('Cognito', authConfigParam.Cognito.identityPoolId);
    }
    constructor(keyValueStorage){
        this._authKeys = {};
        this._hasGuestIdentityId = false;
        this.keyValueStorage = keyValueStorage;
    }
    async loadIdentityId() {
        (0, $5c85900a0ff57646$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        try {
            if (this._primaryIdentityId) return {
                id: this._primaryIdentityId,
                type: 'primary'
            };
            else {
                const storedIdentityId = await this.keyValueStorage.getItem(this._authKeys.identityId);
                if (storedIdentityId) {
                    this._hasGuestIdentityId = true;
                    return {
                        id: storedIdentityId,
                        type: 'guest'
                    };
                }
                return null;
            }
        } catch (err) {
            $91156778eb96652a$var$logger.log('Error getting stored IdentityId.', err);
            return null;
        }
    }
    async storeIdentityId(identity) {
        (0, $5c85900a0ff57646$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        if (identity.type === 'guest') {
            this.keyValueStorage.setItem(this._authKeys.identityId, identity.id);
            // Clear in-memory storage of primary identityId
            this._primaryIdentityId = undefined;
            this._hasGuestIdentityId = true;
        } else {
            this._primaryIdentityId = identity.id;
            // Clear locally stored guest id
            if (this._hasGuestIdentityId) {
                this.keyValueStorage.removeItem(this._authKeys.identityId);
                this._hasGuestIdentityId = false;
            }
        }
    }
    async clearIdentityId() {
        this._primaryIdentityId = undefined;
        await this.keyValueStorage.removeItem(this._authKeys.identityId);
    }
}
const $91156778eb96652a$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $b7e461ac2c273bae$export$dfb8da757ca62eed)((0, $d8ccbc31127429ce$export$dad1700b96c3a835))(`com.amplify.${provider}`, identifier);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cognito specific implmentation of the CredentialsProvider interface
 * that manages setting and getting of AWS Credentials.
 *
 * @throws configuration expections: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service expections: {@link GetCredentialsForIdentityException}, {@link GetIdException}
 *
 */ const $1e31ee8ae916e49f$export$be43b753aec531e2 = new (0, $b01c7b656f4fccc9$export$be6550e37264dc26)(new (0, $91156778eb96652a$export$3e97b78667a539a0)((0, $48e450c8813210c3$export$586b30dcaeecb901)));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * returns in-flight promise if there is one
 *
 * @param asyncFunction - asyncFunction to be deduped.
 * @returns - the return type of the callback
 */ const $d95fd0689da9610f$export$cd8d22e3dc00ae5a = (asyncFunction)=>{
    let inflightPromise;
    return async (...args)=>{
        if (inflightPromise) return inflightPromise;
        inflightPromise = new Promise((resolve, reject)=>{
            asyncFunction(...args).then((result)=>{
                resolve(result);
            }).catch((error)=>{
                reject(error);
            }).finally(()=>{
                inflightPromise = undefined;
            });
        });
        return inflightPromise;
    };
};








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $ab9c5c2c075749e2$export$a0efffb4b0c72e04 = 'cognito-idp';


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3eb819cd2039ddbd$export$54dd9d9496cb66b9 = ({ region: region })=>({
        url: new (0, $e4212cfe0940953e$export$beb82d9d9136c16e)(`https://${(0, $ab9c5c2c075749e2$export$a0efffb4b0c72e04)}.${region}.${(0, $8183f8310104c0d4$export$1c28e37cdcc37f6d)(region)}`)
    });


const $7668796e368c8896$export$9fc8f7dceefe00a6 = ({ endpointOverride: endpointOverride })=>(input)=>{
        if (endpointOverride) return {
            url: new (0, $e4212cfe0940953e$export$beb82d9d9136c16e)(endpointOverride)
        };
        return (0, $3eb819cd2039ddbd$export$54dd9d9496cb66b9)(input);
    };








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $6e0e8649366ba8a6$export$1113413e6e842bef = (operation)=>(input, endpoint)=>{
        const headers = $6e0e8649366ba8a6$var$getSharedHeaders(operation);
        const body = JSON.stringify(input);
        return $6e0e8649366ba8a6$var$buildHttpRpcRequest(endpoint, headers, body);
    };
const $6e0e8649366ba8a6$var$getSharedHeaders = (operation)=>({
        'content-type': 'application/x-amz-json-1.1',
        'x-amz-target': `AWSCognitoIdentityProviderService.${operation}`
    });
const $6e0e8649366ba8a6$var$buildHttpRpcRequest = ({ url: url }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: 'POST'
    });





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8d8d97398d8cb87c$export$8159795418a3e796 = ()=>async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $5267ac398181f2f6$export$be467dfcc0538e25)(response);
            (0, $d7152ac0bbeb6a00$export$5b3890f50cd4853f)(error);
            throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
                name: error.name,
                message: error.message,
                metadata: error.$metadata
            });
        }
        return (0, $5267ac398181f2f6$export$759bcb35b0d1bf81)(response);
    };







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $95cac467723af41c$var$disableCacheMiddlewareFactory = ()=>(next, _)=>async function disableCacheMiddleware(request) {
            request.headers = {
                ...request.headers,
                'cache-control': 'no-store',
                ...await (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).libraryOptions?.Auth?.headers?.()
            };
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $95cac467723af41c$export$10f11e95d7a96f7b = (0, $5e4ae0c57a3d0fa3$export$f074d76e52925468)((0, $5daf8bf9553757d0$export$ed7e1ccf00f39c4a), [
    $95cac467723af41c$var$disableCacheMiddlewareFactory
]);





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ee4971f4008297c5$export$22a3716e7860147a = {
    service: (0, $ab9c5c2c075749e2$export$a0efffb4b0c72e04),
    retryDecider: (0, $2834a3e909bad72b$export$b919d98317a7685f)((0, $5267ac398181f2f6$export$be467dfcc0538e25)),
    computeDelay: (0, $cec796d2dc7b6bb0$export$caea50bde345f648),
    get userAgentValue () {
        return (0, $f1e6ffab4508d917$export$ede38edb26c0bfdf)();
    },
    cache: 'no-store'
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9d67df12fc98d9aa$export$fd10af15e909e7b5 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('GetTokensFromRefreshToken'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $cabef263d10fbba4$var$refreshAuthTokensFunction = async ({ tokens: tokens, authConfig: authConfig, username: username, clientMetadata: clientMetadata })=>{
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig?.Cognito);
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = authConfig.Cognito;
    const region = (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId);
    (0, $6cdbc20a8ad3ee2e$export$be38b2d22222d505)(tokens);
    const getTokensFromRefreshToken = (0, $9d67df12fc98d9aa$export$fd10af15e909e7b5)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { AuthenticationResult: AuthenticationResult } = await getTokensFromRefreshToken({
        region: region
    }, {
        ClientId: userPoolClientId,
        RefreshToken: tokens.refreshToken,
        DeviceKey: tokens.deviceMetadata?.deviceKey,
        ClientMetadata: clientMetadata
    });
    const accessToken = (0, $5c85900a0ff57646$export$9a62e6c0a30e00bc)(AuthenticationResult?.AccessToken ?? '');
    const idToken = AuthenticationResult?.IdToken ? (0, $5c85900a0ff57646$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken) : undefined;
    const { iat: iat } = accessToken.payload;
    // This should never happen. If it does, it's a bug from the service.
    if (!iat) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: 'iatNotFoundException',
        message: 'iat not found in access token'
    });
    const clockDrift = iat * 1000 - new Date().getTime();
    return {
        accessToken: accessToken,
        idToken: idToken,
        clockDrift: clockDrift,
        refreshToken: AuthenticationResult?.RefreshToken ?? tokens.refreshToken,
        username: username
    };
};
const $cabef263d10fbba4$export$ab413c2cb4a135d9 = (0, $d95fd0689da9610f$export$cd8d22e3dc00ae5a)($cabef263d10fbba4$var$refreshAuthTokensFunction);
const $cabef263d10fbba4$export$d5c14381105da273 = $cabef263d10fbba4$var$refreshAuthTokensFunction;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f030787848639548$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined' && typeof window.document !== 'undefined';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $bc7268ce8d49d9e9$export$b007d77a962aa175({ expiresAt: expiresAt, clockDrift: clockDrift, tolerance: tolerance = 5000 }) {
    const currentTime = Date.now();
    return currentTime + clockDrift + tolerance > expiresAt;
}








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $42fbbaa41d94a4ff$var$V5_HOSTED_UI_KEY = 'amplify-signin-with-hostedUI';
const $42fbbaa41d94a4ff$var$name = 'CognitoIdentityServiceProvider';
class $42fbbaa41d94a4ff$export$9b2cef5d94f9b6e8 {
    constructor(keyValueStorage){
        this.keyValueStorage = keyValueStorage;
    }
    async clearOAuthInflightData() {
        (0, $5c85900a0ff57646$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $42fbbaa41d94a4ff$var$createKeysForAuthStorage($42fbbaa41d94a4ff$var$name, this.cognitoConfig.userPoolClientId);
        await Promise.all([
            this.keyValueStorage.removeItem(authKeys.inflightOAuth),
            this.keyValueStorage.removeItem(authKeys.oauthPKCE),
            this.keyValueStorage.removeItem(authKeys.oauthState)
        ]);
    }
    async clearOAuthData() {
        (0, $5c85900a0ff57646$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $42fbbaa41d94a4ff$var$createKeysForAuthStorage($42fbbaa41d94a4ff$var$name, this.cognitoConfig.userPoolClientId);
        await this.clearOAuthInflightData();
        await this.keyValueStorage.removeItem($42fbbaa41d94a4ff$var$V5_HOSTED_UI_KEY); // remove in case a customer migrated an App from v5 to v6
        return this.keyValueStorage.removeItem(authKeys.oauthSignIn);
    }
    loadOAuthState() {
        (0, $5c85900a0ff57646$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $42fbbaa41d94a4ff$var$createKeysForAuthStorage($42fbbaa41d94a4ff$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthState);
    }
    storeOAuthState(state) {
        (0, $5c85900a0ff57646$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $42fbbaa41d94a4ff$var$createKeysForAuthStorage($42fbbaa41d94a4ff$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthState, state);
    }
    loadPKCE() {
        (0, $5c85900a0ff57646$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $42fbbaa41d94a4ff$var$createKeysForAuthStorage($42fbbaa41d94a4ff$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthPKCE);
    }
    storePKCE(pkce) {
        (0, $5c85900a0ff57646$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $42fbbaa41d94a4ff$var$createKeysForAuthStorage($42fbbaa41d94a4ff$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthPKCE, pkce);
    }
    setAuthConfig(authConfigParam) {
        this.cognitoConfig = authConfigParam;
    }
    async loadOAuthInFlight() {
        (0, $5c85900a0ff57646$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $42fbbaa41d94a4ff$var$createKeysForAuthStorage($42fbbaa41d94a4ff$var$name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.getItem(authKeys.inflightOAuth) === 'true';
    }
    async storeOAuthInFlight(inflight) {
        (0, $5c85900a0ff57646$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $42fbbaa41d94a4ff$var$createKeysForAuthStorage($42fbbaa41d94a4ff$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.inflightOAuth, `${inflight}`);
    }
    async loadOAuthSignIn() {
        (0, $5c85900a0ff57646$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $42fbbaa41d94a4ff$var$createKeysForAuthStorage($42fbbaa41d94a4ff$var$name, this.cognitoConfig.userPoolClientId);
        const isLegacyHostedUISignIn = await this.keyValueStorage.getItem($42fbbaa41d94a4ff$var$V5_HOSTED_UI_KEY);
        const [isOAuthSignIn, preferPrivateSession] = (await this.keyValueStorage.getItem(authKeys.oauthSignIn))?.split(',') ?? [];
        return {
            isOAuthSignIn: isOAuthSignIn === 'true' || isLegacyHostedUISignIn === 'true',
            preferPrivateSession: preferPrivateSession === 'true'
        };
    }
    async storeOAuthSignIn(oauthSignIn, preferPrivateSession = false) {
        (0, $5c85900a0ff57646$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $42fbbaa41d94a4ff$var$createKeysForAuthStorage($42fbbaa41d94a4ff$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.oauthSignIn, `${oauthSignIn},${preferPrivateSession}`);
    }
}
const $42fbbaa41d94a4ff$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $b7e461ac2c273bae$export$dfb8da757ca62eed)((0, $6cdbc20a8ad3ee2e$export$3820b4ff343394ea))(provider, identifier);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8a5433823b726473$export$2ed0ec267eb6cb1c = new (0, $42fbbaa41d94a4ff$export$9b2cef5d94f9b6e8)((0, $48e450c8813210c3$export$586b30dcaeecb901));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1b618344cbb99d11$var$inflightPromises = [];
const $1b618344cbb99d11$export$c55b09e0e9be0d04 = (resolver)=>{
    $1b618344cbb99d11$var$inflightPromises.push(resolver);
};
const $1b618344cbb99d11$export$bcb0b7a105a5df59 = ()=>{
    while($1b618344cbb99d11$var$inflightPromises.length)$1b618344cbb99d11$var$inflightPromises.pop()?.();
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $4634bcd03ff60236$export$ba2f3fbc8979d2e6 {
    constructor(){
        this.waitForInflightOAuth = (0, $f030787848639548$export$4e09c449d6c407f7)() ? async ()=>{
            if (!await (0, $8a5433823b726473$export$2ed0ec267eb6cb1c).loadOAuthInFlight()) return;
            if (this.inflightPromise) return this.inflightPromise;
            // when there is valid oauth config and there is an inflight oauth flow, try
            // to block async calls that require fetching tokens before the oauth flow completes
            // e.g. getCurrentUser, fetchAuthSession etc.
            this.inflightPromise = new Promise((resolve, _reject)=>{
                (0, $1b618344cbb99d11$export$c55b09e0e9be0d04)(resolve);
            });
            return this.inflightPromise;
        } : async ()=>{
        // no-op for non-browser environments
        };
    }
    setAuthConfig(authConfig) {
        (0, $8a5433823b726473$export$2ed0ec267eb6cb1c).setAuthConfig(authConfig.Cognito);
        this.authConfig = authConfig;
    }
    setTokenRefresher(tokenRefresher) {
        this.tokenRefresher = tokenRefresher;
    }
    setAuthTokenStore(tokenStore) {
        this.tokenStore = tokenStore;
    }
    getTokenStore() {
        if (!this.tokenStore) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
            name: 'EmptyTokenStoreException',
            message: 'TokenStore not set'
        });
        return this.tokenStore;
    }
    getTokenRefresher() {
        if (!this.tokenRefresher) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
            name: 'EmptyTokenRefresherException',
            message: 'TokenRefresher not set'
        });
        return this.tokenRefresher;
    }
    setClientMetadataProvider(clientMetadataProvider) {
        this.clientMetadataProvider = clientMetadataProvider;
    }
    async getTokens(options) {
        let tokens;
        try {
            (0, $5c85900a0ff57646$export$80c92581e59ed502)(this.authConfig?.Cognito);
        } catch (_err) {
            // Token provider not configured
            return null;
        }
        await this.waitForInflightOAuth();
        this.inflightPromise = undefined;
        tokens = await this.getTokenStore().loadTokens();
        const username = await this.getTokenStore().getLastAuthUser();
        if (tokens === null) return null;
        const idTokenExpired = !!tokens?.idToken && (0, $bc7268ce8d49d9e9$export$b007d77a962aa175)({
            expiresAt: (tokens.idToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        const accessTokenExpired = (0, $bc7268ce8d49d9e9$export$b007d77a962aa175)({
            expiresAt: (tokens.accessToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        if (options?.forceRefresh || idTokenExpired || accessTokenExpired) {
            tokens = await this.refreshTokens({
                tokens: tokens,
                username: username,
                clientMetadata: options?.clientMetadata ?? await this.clientMetadataProvider?.()
            });
            if (tokens === null) return null;
        }
        return {
            accessToken: tokens?.accessToken,
            idToken: tokens?.idToken,
            signInDetails: tokens?.signInDetails
        };
    }
    async refreshTokens({ tokens: tokens, username: username, clientMetadata: clientMetadata }) {
        try {
            const { signInDetails: signInDetails } = tokens;
            const newTokens = await this.getTokenRefresher()({
                tokens: tokens,
                authConfig: this.authConfig,
                username: username,
                clientMetadata: clientMetadata
            });
            newTokens.signInDetails = signInDetails;
            await this.setTokens({
                tokens: newTokens
            });
            (0, $7c7b61d0858d9585$export$8c41bb232f1008b1).dispatch('auth', {
                event: 'tokenRefresh'
            }, 'Auth', (0, $7c7b61d0858d9585$export$aadf71dd9875dd20));
            return newTokens;
        } catch (err) {
            return this.handleErrors(err);
        }
    }
    handleErrors(err) {
        (0, $d7152ac0bbeb6a00$export$5b3890f50cd4853f)(err);
        // Only clear tokens for definitive authentication failures
        // Do NOT clear tokens for transient errors like service issues, rate limits, etc.
        const shouldClearTokens = this.isAuthenticationError(err);
        if (shouldClearTokens) this.clearTokens();
        (0, $7c7b61d0858d9585$export$8c41bb232f1008b1).dispatch('auth', {
            event: 'tokenRefresh_failure',
            data: {
                error: err
            }
        }, 'Auth', (0, $7c7b61d0858d9585$export$aadf71dd9875dd20));
        if (err.name.startsWith('NotAuthorizedException')) return null;
        throw err;
    }
    isAuthenticationError(err) {
        // Only clear tokens for errors that definitively indicate the tokens are invalid
        // and re-authentication is required. All other errors (service errors, rate limits, etc.)
        // should preserve the tokens to allow for retry.
        // See: https://github.com/aws-amplify/amplify-js/issues/14534
        const authErrorNames = [
            'NotAuthorizedException',
            'TokenRevokedException',
            'UserNotFoundException',
            'PasswordResetRequiredException',
            'UserNotConfirmedException',
            'RefreshTokenReuseException'
        ];
        return authErrorNames.some((errorName)=>err?.name?.startsWith?.(errorName));
    }
    async setTokens({ tokens: tokens }) {
        return this.getTokenStore().storeTokens(tokens);
    }
    async clearTokens() {
        return this.getTokenStore().clearTokens();
    }
    getDeviceMetadata(username) {
        return this.getTokenStore().getDeviceMetadata(username);
    }
    clearDeviceMetadata(username) {
        return this.getTokenStore().clearDeviceMetadata(username);
    }
    setOAuthMetadata(metadata) {
        return this.getTokenStore().setOAuthMetadata(metadata);
    }
    getOAuthMetadata() {
        return this.getTokenStore().getOAuthMetadata();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $059a3a2fbc7b71a6$export$85b743bbda58cb6c {
    constructor(){
        this.authTokenStore = new (0, $b7e461ac2c273bae$export$a36be852d43d512)();
        this.authTokenStore.setKeyValueStorage((0, $48e450c8813210c3$export$586b30dcaeecb901));
        this.tokenOrchestrator = new (0, $4634bcd03ff60236$export$ba2f3fbc8979d2e6)();
        this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore);
        this.tokenOrchestrator.setTokenRefresher((0, $cabef263d10fbba4$export$ab413c2cb4a135d9));
    }
    getTokens(options = {}) {
        return this.tokenOrchestrator.getTokens(options);
    }
    setKeyValueStorage(keyValueStorage) {
        this.authTokenStore.setKeyValueStorage(keyValueStorage);
    }
    setClientMetadataProvider(clientMetadataProvider) {
        this.tokenOrchestrator.setClientMetadataProvider(clientMetadataProvider);
    }
    setAuthConfig(authConfig) {
        this.authTokenStore.setAuthConfig(authConfig);
        this.tokenOrchestrator.setAuthConfig(authConfig);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The default provider for the JWT access token and ID token issued from the configured Cognito user pool. It manages
 * the refresh and storage of the tokens. It stores the tokens in `window.localStorage` if available, and falls back to
 * in-memory storage if not.
 */ const $3c6129946b01fbcd$export$18e158b80aac31a7 = new (0, $059a3a2fbc7b71a6$export$85b743bbda58cb6c)();
const { tokenOrchestrator: $3c6129946b01fbcd$export$66561e66d62991d0 } = $3c6129946b01fbcd$export$18e158b80aac31a7;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c429b4341d882bd4$export$11ac3725994bec7b = {
    /**
     * Configures Amplify with the {@link resourceConfig} and {@link libraryOptions}.
     *
     * @param resourceConfig The {@link ResourcesConfig} object that is typically imported from the
     * `amplifyconfiguration.json` file. It can also be an object literal created inline when calling `Amplify.configure`.
     * @param libraryOptions The {@link LibraryOptions} additional options for the library.
     *
     * @example
     * import config from './amplifyconfiguration.json';
     *
     * Amplify.configure(config);
     */ configure (resourceConfig, libraryOptions) {
        const resolvedResourceConfig = (0, $3eb0fd433137e38a$export$f101a69cd6dc6202)(resourceConfig);
        const cookieBasedKeyValueStorage = new (0, $cb3744adff06104d$export$dae7d845015939d5)({
            sameSite: 'lax'
        });
        const resolvedKeyValueStorage = libraryOptions?.ssr ? cookieBasedKeyValueStorage : (0, $48e450c8813210c3$export$586b30dcaeecb901);
        const resolvedCredentialsProvider = libraryOptions?.ssr ? new (0, $b01c7b656f4fccc9$export$be6550e37264dc26)(new (0, $91156778eb96652a$export$3e97b78667a539a0)(cookieBasedKeyValueStorage)) : (0, $1e31ee8ae916e49f$export$be43b753aec531e2);
        if (!resolvedResourceConfig.Auth || libraryOptions?.Auth) {
            (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
            return;
        }
        (0, $3c6129946b01fbcd$export$18e158b80aac31a7).setAuthConfig(resolvedResourceConfig.Auth);
        (0, $3c6129946b01fbcd$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
        resolvedKeyValueStorage);
        (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).configure(resolvedResourceConfig, {
            ...libraryOptions,
            Auth: {
                tokenProvider: (0, $3c6129946b01fbcd$export$18e158b80aac31a7),
                credentialsProvider: resolvedCredentialsProvider
            }
        });
    },
    /**
     * Returns the {@link ResourcesConfig} object passed in as the `resourceConfig` parameter when calling
     * `Amplify.configure`.
     *
     * @returns An {@link ResourcesConfig} object.
     */ getConfig () {
        return (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig();
    }
};


parcelRequire("6aRB8");
function $e48023f969bf5885$export$2e2bcd8739ae039(t, e) {
    return $e48023f969bf5885$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $e48023f969bf5885$export$2e2bcd8739ae039(t, e);
}


function $19bf3c71fafed899$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $e48023f969bf5885$export$2e2bcd8739ae039)(t, o);
}



var $6aRB8 = parcelRequire("6aRB8");

var $4bMTH = parcelRequire("4bMTH");
function $19c4b1072adac5ce$export$2e2bcd8739ae039() {
    return $19c4b1072adac5ce$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $19c4b1072adac5ce$export$2e2bcd8739ae039.apply(null, arguments);
}


function $b8288e270e86deea$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $b8288e270e86deea$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $b8288e270e86deea$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $b8288e270e86deea$var$isAbsolute(to);
    var isFromAbs = from && $b8288e270e86deea$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $b8288e270e86deea$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $b8288e270e86deea$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $b8288e270e86deea$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $b8288e270e86deea$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$b8288e270e86deea$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $b8288e270e86deea$export$2e2bcd8739ae039 = $b8288e270e86deea$var$resolvePathname;


function $e3218eaa09e6d15c$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $e3218eaa09e6d15c$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $e3218eaa09e6d15c$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $e3218eaa09e6d15c$var$valueOf(a);
        var bValue = $e3218eaa09e6d15c$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $e3218eaa09e6d15c$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $e3218eaa09e6d15c$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $e3218eaa09e6d15c$export$2e2bcd8739ae039 = $e3218eaa09e6d15c$var$valueEqual;



var $18c04954bc1fbe52$var$isProduction = true;
var $18c04954bc1fbe52$var$prefix = 'Invariant failed';
function $18c04954bc1fbe52$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($18c04954bc1fbe52$var$isProduction) throw new Error($18c04954bc1fbe52$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($18c04954bc1fbe52$var$prefix, ": ").concat(provided) : $18c04954bc1fbe52$var$prefix;
    throw new Error(value);
}


function $d9551d69f5f40879$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $d9551d69f5f40879$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $d9551d69f5f40879$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $d9551d69f5f40879$var$stripBasename(path, prefix) {
    return $d9551d69f5f40879$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $d9551d69f5f40879$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $d9551d69f5f40879$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $d9551d69f5f40879$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $d9551d69f5f40879$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $d9551d69f5f40879$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $19c4b1072adac5ce$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $b8288e270e86deea$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $d9551d69f5f40879$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $e3218eaa09e6d15c$export$2e2bcd8739ae039)(a.state, b.state);
}
function $d9551d69f5f40879$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $d9551d69f5f40879$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $d9551d69f5f40879$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $d9551d69f5f40879$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $d9551d69f5f40879$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $d9551d69f5f40879$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $d9551d69f5f40879$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $d9551d69f5f40879$var$PopStateEvent = 'popstate';
var $d9551d69f5f40879$var$HashChangeEvent = 'hashchange';
function $d9551d69f5f40879$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $d9551d69f5f40879$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$d9551d69f5f40879$var$canUseDOM && (0, $18c04954bc1fbe52$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $d9551d69f5f40879$var$supportsHistory();
    var needsHashChangeListener = !$d9551d69f5f40879$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $d9551d69f5f40879$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $d9551d69f5f40879$var$stripTrailingSlash($d9551d69f5f40879$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $d9551d69f5f40879$var$stripBasename(path, basename);
        return $d9551d69f5f40879$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $d9551d69f5f40879$var$createTransitionManager();
    function setState(nextState) {
        (0, $19c4b1072adac5ce$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($d9551d69f5f40879$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($d9551d69f5f40879$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($d9551d69f5f40879$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $d9551d69f5f40879$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $d9551d69f5f40879$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $d9551d69f5f40879$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($d9551d69f5f40879$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($d9551d69f5f40879$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($d9551d69f5f40879$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($d9551d69f5f40879$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $d9551d69f5f40879$var$HashChangeEvent$1 = 'hashchange';
var $d9551d69f5f40879$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $d9551d69f5f40879$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $d9551d69f5f40879$var$stripLeadingSlash,
        decodePath: $d9551d69f5f40879$var$addLeadingSlash
    },
    slash: {
        encodePath: $d9551d69f5f40879$var$addLeadingSlash,
        decodePath: $d9551d69f5f40879$var$addLeadingSlash
    }
};
function $d9551d69f5f40879$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $d9551d69f5f40879$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $d9551d69f5f40879$var$pushHashPath(path) {
    window.location.hash = path;
}
function $d9551d69f5f40879$var$replaceHashPath(path) {
    window.location.replace($d9551d69f5f40879$var$stripHash(window.location.href) + '#' + path);
}
function $d9551d69f5f40879$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$d9551d69f5f40879$var$canUseDOM && (0, $18c04954bc1fbe52$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $d9551d69f5f40879$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $d9551d69f5f40879$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $d9551d69f5f40879$var$stripTrailingSlash($d9551d69f5f40879$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $d9551d69f5f40879$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($d9551d69f5f40879$var$getHashPath());
        if (basename) path = $d9551d69f5f40879$var$stripBasename(path, basename);
        return $d9551d69f5f40879$export$90c043f1c57770b8(path);
    }
    var transitionManager = $d9551d69f5f40879$var$createTransitionManager();
    function setState(nextState) {
        (0, $19c4b1072adac5ce$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $d9551d69f5f40879$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $d9551d69f5f40879$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $d9551d69f5f40879$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($d9551d69f5f40879$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($d9551d69f5f40879$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $d9551d69f5f40879$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $d9551d69f5f40879$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $d9551d69f5f40879$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $d9551d69f5f40879$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $d9551d69f5f40879$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $d9551d69f5f40879$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $d9551d69f5f40879$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $d9551d69f5f40879$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $d9551d69f5f40879$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($d9551d69f5f40879$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $d9551d69f5f40879$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $d9551d69f5f40879$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $d9551d69f5f40879$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $d9551d69f5f40879$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($d9551d69f5f40879$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($d9551d69f5f40879$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($d9551d69f5f40879$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $d9551d69f5f40879$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $d9551d69f5f40879$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $d9551d69f5f40879$var$createTransitionManager();
    function setState(nextState) {
        (0, $19c4b1072adac5ce$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $d9551d69f5f40879$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $d9551d69f5f40879$export$90c043f1c57770b8(entry, undefined, createKey()) : $d9551d69f5f40879$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $d9551d69f5f40879$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $d9551d69f5f40879$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $d9551d69f5f40879$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $d9551d69f5f40879$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $2504662093335c90$exports = {};
var $8427b89c46be19af$exports = {};
$8427b89c46be19af$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $2504662093335c90$exports = $2504662093335c90$var$pathToRegexp;
$2504662093335c90$exports.parse = $2504662093335c90$var$parse;
$2504662093335c90$exports.compile = $2504662093335c90$var$compile;
$2504662093335c90$exports.tokensToFunction = $2504662093335c90$var$tokensToFunction;
$2504662093335c90$exports.tokensToRegExp = $2504662093335c90$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $2504662093335c90$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $2504662093335c90$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $2504662093335c90$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $2504662093335c90$var$escapeGroup(pattern) : asterisk ? '.*' : $2504662093335c90$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $2504662093335c90$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $2504662093335c90$var$escapeString(delimiter) + ']+?';
    return $2504662093335c90$var$escapeString(prevText) + '|(?:(?!' + $2504662093335c90$var$escapeString(prevText) + ')[^' + $2504662093335c90$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $2504662093335c90$var$compile(str, options) {
    return $2504662093335c90$var$tokensToFunction($2504662093335c90$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $2504662093335c90$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $2504662093335c90$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $2504662093335c90$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $2504662093335c90$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $2504662093335c90$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($8427b89c46be19af$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $2504662093335c90$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $2504662093335c90$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $2504662093335c90$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $2504662093335c90$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $2504662093335c90$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $2504662093335c90$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $2504662093335c90$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $2504662093335c90$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($2504662093335c90$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $2504662093335c90$var$flags(options));
    return $2504662093335c90$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $2504662093335c90$var$stringToRegexp(path, keys, options) {
    return $2504662093335c90$var$tokensToRegExp($2504662093335c90$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $2504662093335c90$var$tokensToRegExp(tokens, keys, options) {
    if (!$8427b89c46be19af$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $2504662093335c90$var$escapeString(token);
        else {
            var prefix = $2504662093335c90$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $2504662093335c90$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $2504662093335c90$var$attachKeys(new RegExp('^' + route, $2504662093335c90$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $2504662093335c90$var$pathToRegexp(path, keys, options) {
    if (!$8427b89c46be19af$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $2504662093335c90$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($8427b89c46be19af$exports(path)) return $2504662093335c90$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $2504662093335c90$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $fef01f59125f2c7c$exports = {};
'use strict';

$fef01f59125f2c7c$exports = (parcelRequire("fSlyq"));


function $ad714b0cbc0e2484$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


var $7c74ab122fcb49e6$exports = {};
'use strict';

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $7c74ab122fcb49e6$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $7c74ab122fcb49e6$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $7c74ab122fcb49e6$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $7c74ab122fcb49e6$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $7c74ab122fcb49e6$var$TYPE_STATICS = {};
$7c74ab122fcb49e6$var$TYPE_STATICS[$fef01f59125f2c7c$exports.ForwardRef] = $7c74ab122fcb49e6$var$FORWARD_REF_STATICS;
$7c74ab122fcb49e6$var$TYPE_STATICS[$fef01f59125f2c7c$exports.Memo] = $7c74ab122fcb49e6$var$MEMO_STATICS;
function $7c74ab122fcb49e6$var$getStatics(component) {
    // React v16.11 and below
    if ($fef01f59125f2c7c$exports.isMemo(component)) return $7c74ab122fcb49e6$var$MEMO_STATICS;
     // React v16.12 and above
    return $7c74ab122fcb49e6$var$TYPE_STATICS[component['$$typeof']] || $7c74ab122fcb49e6$var$REACT_STATICS;
}
var $7c74ab122fcb49e6$var$defineProperty = Object.defineProperty;
var $7c74ab122fcb49e6$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $7c74ab122fcb49e6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $7c74ab122fcb49e6$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $7c74ab122fcb49e6$var$getPrototypeOf = Object.getPrototypeOf;
var $7c74ab122fcb49e6$var$objectPrototype = Object.prototype;
function $7c74ab122fcb49e6$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($7c74ab122fcb49e6$var$objectPrototype) {
            var inheritedComponent = $7c74ab122fcb49e6$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $7c74ab122fcb49e6$var$objectPrototype) $7c74ab122fcb49e6$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $7c74ab122fcb49e6$var$getOwnPropertyNames(sourceComponent);
        if ($7c74ab122fcb49e6$var$getOwnPropertySymbols) keys = keys.concat($7c74ab122fcb49e6$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $7c74ab122fcb49e6$var$getStatics(targetComponent);
        var sourceStatics = $7c74ab122fcb49e6$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$7c74ab122fcb49e6$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $7c74ab122fcb49e6$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $7c74ab122fcb49e6$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$7c74ab122fcb49e6$exports = $7c74ab122fcb49e6$var$hoistNonReactStatics;


var $853fc940b1a40d2f$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $853fc940b1a40d2f$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $853fc940b1a40d2f$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $853fc940b1a40d2f$var$commonjsGlobal[key] = ($853fc940b1a40d2f$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $853fc940b1a40d2f$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $853fc940b1a40d2f$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $853fc940b1a40d2f$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $853fc940b1a40d2f$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $853fc940b1a40d2f$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $19bf3c71fafed899$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $853fc940b1a40d2f$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($853fc940b1a40d2f$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $853fc940b1a40d2f$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $19bf3c71fafed899$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $853fc940b1a40d2f$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $853fc940b1a40d2f$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $853fc940b1a40d2f$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $853fc940b1a40d2f$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createContext || $853fc940b1a40d2f$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $853fc940b1a40d2f$var$createNamedContext = function createNamedContext(name) {
    var context = $853fc940b1a40d2f$var$createContext();
    context.displayName = name;
    return context;
};
var $853fc940b1a40d2f$export$c213558b66925821 = /*#__PURE__*/ $853fc940b1a40d2f$var$createNamedContext("Router-History");
var $853fc940b1a40d2f$export$63baa8ccbe60bb07 = /*#__PURE__*/ $853fc940b1a40d2f$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $853fc940b1a40d2f$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $19bf3c71fafed899$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($853fc940b1a40d2f$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($853fc940b1a40d2f$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $853fc940b1a40d2f$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $19bf3c71fafed899$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $d9551d69f5f40879$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($853fc940b1a40d2f$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Component);
var $853fc940b1a40d2f$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $19bf3c71fafed899$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $853fc940b1a40d2f$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($853fc940b1a40d2f$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $18c04954bc1fbe52$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($853fc940b1a40d2f$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $853fc940b1a40d2f$var$messageType;
var $853fc940b1a40d2f$var$cache = {};
var $853fc940b1a40d2f$var$cacheLimit = 10000;
var $853fc940b1a40d2f$var$cacheCount = 0;
function $853fc940b1a40d2f$var$compilePath(path) {
    if ($853fc940b1a40d2f$var$cache[path]) return $853fc940b1a40d2f$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($2504662093335c90$exports))).compile(path);
    if ($853fc940b1a40d2f$var$cacheCount < $853fc940b1a40d2f$var$cacheLimit) {
        $853fc940b1a40d2f$var$cache[path] = generator;
        $853fc940b1a40d2f$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $853fc940b1a40d2f$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $853fc940b1a40d2f$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $853fc940b1a40d2f$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($853fc940b1a40d2f$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $18c04954bc1fbe52$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $d9551d69f5f40879$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $853fc940b1a40d2f$export$82476f982757e71e(to, computedMatch.params) : (0, $19c4b1072adac5ce$export$2e2bcd8739ae039)({}, to, {
            pathname: $853fc940b1a40d2f$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($853fc940b1a40d2f$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $d9551d69f5f40879$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $d9551d69f5f40879$export$c3e8bb440bd55b18)(prevLocation, (0, $19c4b1072adac5ce$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $853fc940b1a40d2f$var$cache$1 = {};
var $853fc940b1a40d2f$var$cacheLimit$1 = 10000;
var $853fc940b1a40d2f$var$cacheCount$1 = 0;
function $853fc940b1a40d2f$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $853fc940b1a40d2f$var$cache$1[cacheKey] || ($853fc940b1a40d2f$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($2504662093335c90$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($853fc940b1a40d2f$var$cacheCount$1 < $853fc940b1a40d2f$var$cacheLimit$1) {
        pathCache[path] = result;
        $853fc940b1a40d2f$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $853fc940b1a40d2f$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $853fc940b1a40d2f$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $853fc940b1a40d2f$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Children.count(children) === 0;
}
function $853fc940b1a40d2f$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $853fc940b1a40d2f$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $19bf3c71fafed899$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($853fc940b1a40d2f$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $18c04954bc1fbe52$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $853fc940b1a40d2f$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $19c4b1072adac5ce$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $853fc940b1a40d2f$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($853fc940b1a40d2f$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Component);
function $853fc940b1a40d2f$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $853fc940b1a40d2f$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $19c4b1072adac5ce$export$2e2bcd8739ae039)({}, location, {
        pathname: $853fc940b1a40d2f$var$addLeadingSlash(basename) + location.pathname
    });
}
function $853fc940b1a40d2f$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $853fc940b1a40d2f$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $19c4b1072adac5ce$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $853fc940b1a40d2f$var$createURL(location) {
    return typeof location === "string" ? location : (0, $d9551d69f5f40879$export$fe53371bee54353d)(location);
}
function $853fc940b1a40d2f$var$staticHandler(methodName) {
    return function() {
        (0, $18c04954bc1fbe52$export$2e2bcd8739ae039)(false);
    };
}
function $853fc940b1a40d2f$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $853fc940b1a40d2f$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $19bf3c71fafed899$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $853fc940b1a40d2f$var$noop;
        };
        _this.handleBlock = function() {
            return $853fc940b1a40d2f$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $853fc940b1a40d2f$var$addBasename(basename, (0, $d9551d69f5f40879$export$90c043f1c57770b8)(location));
        context.url = $853fc940b1a40d2f$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $ad714b0cbc0e2484$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $853fc940b1a40d2f$var$addLeadingSlash(basename + $853fc940b1a40d2f$var$createURL(path));
            },
            action: "POP",
            location: $853fc940b1a40d2f$var$stripBasename(basename, (0, $d9551d69f5f40879$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $853fc940b1a40d2f$var$staticHandler("go"),
            goBack: $853fc940b1a40d2f$var$staticHandler("goBack"),
            goForward: $853fc940b1a40d2f$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($853fc940b1a40d2f$export$55185c17a0fcbe46, (0, $19c4b1072adac5ce$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $853fc940b1a40d2f$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $19bf3c71fafed899$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($853fc940b1a40d2f$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $18c04954bc1fbe52$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $853fc940b1a40d2f$export$81336c211d5ff295(location.pathname, (0, $19c4b1072adac5ce$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $853fc940b1a40d2f$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $ad714b0cbc0e2484$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($853fc940b1a40d2f$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $18c04954bc1fbe52$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Component, (0, $19c4b1072adac5ce$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7c74ab122fcb49e6$exports)))(C, Component);
}
var $853fc940b1a40d2f$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useContext;
function $853fc940b1a40d2f$export$3420e1dc2c4a518c() {
    return $853fc940b1a40d2f$var$useContext($853fc940b1a40d2f$export$c213558b66925821);
}
function $853fc940b1a40d2f$export$45d76561a5302f2b() {
    return $853fc940b1a40d2f$var$useContext($853fc940b1a40d2f$export$63baa8ccbe60bb07).location;
}
function $853fc940b1a40d2f$export$99eaa27ddbbb95ef() {
    var match = $853fc940b1a40d2f$var$useContext($853fc940b1a40d2f$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $853fc940b1a40d2f$export$632be4bb944c1bc7(path) {
    var location = $853fc940b1a40d2f$export$45d76561a5302f2b();
    var match = $853fc940b1a40d2f$var$useContext($853fc940b1a40d2f$export$63baa8ccbe60bb07).match;
    return path ? $853fc940b1a40d2f$export$81336c211d5ff295(location.pathname, path) : match;
}
var $853fc940b1a40d2f$var$global$1, $853fc940b1a40d2f$var$key, $853fc940b1a40d2f$var$buildNames, $853fc940b1a40d2f$var$initialBuildName, $853fc940b1a40d2f$var$secondaryBuildName;


function $a50f6ab707feebda$export$2e2bcd8739ae039(t, e) {
    return $a50f6ab707feebda$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a50f6ab707feebda$export$2e2bcd8739ae039(t, e);
}


function $1e69fa31b9c24ab0$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $a50f6ab707feebda$export$2e2bcd8739ae039)(t, o);
}



var $6aRB8 = parcelRequire("6aRB8");



function $1e0a7747b096edac$export$2e2bcd8739ae039() {
    return $1e0a7747b096edac$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1e0a7747b096edac$export$2e2bcd8739ae039.apply(null, arguments);
}


function $fd431c8bd20aef0b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $86f9b5396d19fca8$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $d9551d69f5f40879$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $853fc940b1a40d2f$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $86f9b5396d19fca8$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $d9551d69f5f40879$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $853fc940b1a40d2f$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Component);
var $86f9b5396d19fca8$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $86f9b5396d19fca8$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $d9551d69f5f40879$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $86f9b5396d19fca8$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $86f9b5396d19fca8$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).forwardRef;
if (typeof $86f9b5396d19fca8$var$forwardRef === "undefined") $86f9b5396d19fca8$var$forwardRef = $86f9b5396d19fca8$var$forwardRefShim;
function $86f9b5396d19fca8$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $86f9b5396d19fca8$var$LinkAnchor = $86f9b5396d19fca8$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $fd431c8bd20aef0b$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$86f9b5396d19fca8$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($86f9b5396d19fca8$var$forwardRefShim !== $86f9b5396d19fca8$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $86f9b5396d19fca8$export$a6c7ac8248d6e38a = $86f9b5396d19fca8$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $86f9b5396d19fca8$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $fd431c8bd20aef0b$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $853fc940b1a40d2f$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $18c04954bc1fbe52$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $86f9b5396d19fca8$var$normalizeToLocation($86f9b5396d19fca8$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $86f9b5396d19fca8$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $d9551d69f5f40879$export$fe53371bee54353d)(context.location) === (0, $d9551d69f5f40879$export$fe53371bee54353d)($86f9b5396d19fca8$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($86f9b5396d19fca8$var$forwardRefShim !== $86f9b5396d19fca8$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(component, props);
    });
});
var $86f9b5396d19fca8$var$toType, $86f9b5396d19fca8$var$refType;
var $86f9b5396d19fca8$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $86f9b5396d19fca8$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).forwardRef;
if (typeof $86f9b5396d19fca8$var$forwardRef$1 === "undefined") $86f9b5396d19fca8$var$forwardRef$1 = $86f9b5396d19fca8$var$forwardRefShim$1;
function $86f9b5396d19fca8$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $86f9b5396d19fca8$export$b0d92dbee9b5b60d = $86f9b5396d19fca8$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $fd431c8bd20aef0b$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $853fc940b1a40d2f$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $18c04954bc1fbe52$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $86f9b5396d19fca8$var$normalizeToLocation($86f9b5396d19fca8$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $853fc940b1a40d2f$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $86f9b5396d19fca8$var$joinClassnames(className, activeClassName);
            style = (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($86f9b5396d19fca8$var$forwardRefShim$1 !== $86f9b5396d19fca8$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($86f9b5396d19fca8$export$a6c7ac8248d6e38a, props);
    });
});
var $86f9b5396d19fca8$var$ariaCurrentType;


var $de5328cf3ad8c318$export$882461b6382ed46c;
var $de5328cf3ad8c318$export$757ceba2d55c277e;
'use strict';
var $f0d8bf13803656d4$exports = {};
'use strict';
function $f0d8bf13803656d4$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f0d8bf13803656d4$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f0d8bf13803656d4$var$checkDCE();

$f0d8bf13803656d4$exports = (parcelRequire("87PU2"));


var $de5328cf3ad8c318$var$i;
$de5328cf3ad8c318$export$882461b6382ed46c = $f0d8bf13803656d4$exports.createRoot;
$de5328cf3ad8c318$export$757ceba2d55c277e = $f0d8bf13803656d4$exports.hydrateRoot;


/* eslint react/jsx-filename-extension: 0 */ 
parcelRequire("6aRB8");


var $6aRB8 = parcelRequire("6aRB8");

var $6aRB8 = parcelRequire("6aRB8");
/**
 * @deprecated - will be removed in a future major version
 *
 * Some libraries may not follow Node ES module spec and could be loaded as CommonJS modules,
 * To ensure the interoperability between ESM and CJS, modules from those libraries have to be loaded via namespace import
 * And sanitized by the function below because unlike ESM namespace, CJS namespace set `module.exports` object on the `default` key
 * https://nodejs.org/api/esm.html#interoperability-with-commonjs
 */ const $fd30e9352c42562e$export$fa356a32a7b5bee2 = (namespaceModule)=>{
    const sanitizedNamespaceModule = {
        default: undefined,
        ...namespaceModule
    };
    return sanitizedNamespaceModule.default ?? sanitizedNamespaceModule;
};
/**
 * Checks if `value` is an Object (non-primitive, non-array, non-function)
 * Will return false for Arrays and functions
 *
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is an object, `false` otherwise
 */ function $fd30e9352c42562e$export$a6cdc56e425d0d0a(value) {
    return value != null && !Array.isArray(value) && typeof value === 'object';
}
/**
 * Checks if `value` is a string primitive or object
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is a string, `false` otherwise
 */ function $fd30e9352c42562e$export$844ec244b1367d54(value) {
    return typeof value === 'string' || typeof value === 'object' && Object.prototype.toString.call(value) === '[object String]';
}
/**
 * Checks if `value` is a Map
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is a Map, `false` otherwise
 */ function $fd30e9352c42562e$export$5c90113a285f2241(value) {
    return $fd30e9352c42562e$export$a6cdc56e425d0d0a(value) && Object.prototype.toString.call(value) === '[object Map]';
}
/**
 * Checks if `value` is a Set
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is a Set, `false` otherwise
 */ function $fd30e9352c42562e$export$6750766a7c7ec627(value) {
    return $fd30e9352c42562e$export$a6cdc56e425d0d0a(value) && Object.prototype.toString.call(value) === '[object Set]';
}
/**
 * Checks if `value` is undefined
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is undefined, `false` otherwise
 */ function $fd30e9352c42562e$export$fce6876652108ab(value) {
    return value === undefined;
}
/**
 * Checks if `value` is nullish
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is nullish, `false` otherwise
 */ function $fd30e9352c42562e$export$984f70f9382f5d27(value) {
    return value == null;
}
/**
 * Checks if `value` is empty
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is empty, `false` otherwise
 */ function $fd30e9352c42562e$export$dd1bc94b04021eeb(value) {
    if (value === null || value === undefined) return true;
    if ($fd30e9352c42562e$export$a6cdc56e425d0d0a(value) && ($fd30e9352c42562e$export$5c90113a285f2241(value) || $fd30e9352c42562e$export$6750766a7c7ec627(value))) return !value.size;
    if ($fd30e9352c42562e$export$a6cdc56e425d0d0a(value) && ($fd30e9352c42562e$export$844ec244b1367d54(value) || Array.isArray(value))) return !value.length;
    for(const key in value){
        if ($fd30e9352c42562e$export$a4f4bb6b1453fff5(value, key)) return false;
    }
    return true;
}
/**
 * Checks if `value` is an empty array
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is a empty, `false` otherwise
 */ function $fd30e9352c42562e$var$isEmptyArray(value) {
    return Array.isArray(value) && $fd30e9352c42562e$export$dd1bc94b04021eeb(value);
}
/**
 * Checks if all members of the `values` param are empty arrays
 *
 * @param {unknown} value The values to check
 * @returns {boolean} Returns `true` if all members of `values` are empty, `false` otherwise
 */ function $fd30e9352c42562e$export$2c02be4a78959098(...values) {
    return values.every($fd30e9352c42562e$var$isEmptyArray);
}
/**
 * Checks if `value` is an empty object
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is empty, `false` otherwise
 */ function $fd30e9352c42562e$export$83b788b1a3698c03(value) {
    return $fd30e9352c42562e$export$a6cdc56e425d0d0a(value) && $fd30e9352c42562e$export$dd1bc94b04021eeb(value);
}
/**
 * Checks if all members of the `values` param are empty objects
 *
 * @param {unknown} values The values to check
 * @returns {boolean} Returns `true` if all members of the `values` param are empty, `false` otherwise
 */ function $fd30e9352c42562e$export$d6708a3543c32fe4(...values) {
    return values.every($fd30e9352c42562e$export$83b788b1a3698c03);
}
/**
 * Capitalizes `value` and its return type
 *
 * @param {string} value string to capitalize
 * @returns {string} capitalized string
 */ function $fd30e9352c42562e$export$9a00dee1beb8f576(value) {
    return $fd30e9352c42562e$export$844ec244b1367d54(value) ? value.charAt(0).toUpperCase() + value.slice(1) : '';
}
/**
 * Checks if `key` is a direct property of `value`
 *
 * @param {unknown} value `object` potentially containing property
 * @param {string} key property key
 * @returns whether `key` param is a property of the `obj` param
 */ function $fd30e9352c42562e$export$a4f4bb6b1453fff5(value, key) {
    return value != null && Object.prototype.hasOwnProperty.call(value, key);
}
/**
 * Checks if `value` is a function
 *
 * @param {unknown} value param to check
 * @returns {boolean} whether `value` is a function
 */ function $fd30e9352c42562e$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
/**
 * This helper function creates modifier class names that are used for our flat BEM styling
 * it takes in a base and modifier and returns the modified class if a modifier was passed in and null otherwise
 * @param base The base class of the output
 * @param modifier The modifier to add onto the base
 * @returns the modified class name or empty string
 */ const $fd30e9352c42562e$export$1d6fb99b5e148be8 = (base, modifier)=>{
    return modifier ? `${base}--${modifier}` : '';
};
/**
 * This helper function creates modified class names that are used for our flat BEM styling
 * it takes in a base, modifier, and flag and returns the modified class name if the flag is true and null if the flag is false
 * @param base
 * @param modifier
 * @param flag
 * @returns the modified class name or empty string
 */ const $fd30e9352c42562e$export$3c152e7b97c7496c = (base, modifier, flag)=>{
    return flag ? `${base}--${modifier}` : '';
};
/**
 * Similar to `Array.join`, with an optional callback/template param
 * for formatting returned string values
 *
 * @param {string[]} values string array
 * @param {(value: string) => string} template callback format param
 * @returns formatted string array
 */ function $fd30e9352c42562e$export$41f379f522580228(values, template) {
    return values.reduce((acc, curr, index)=>`${acc}${$fd30e9352c42562e$export$844ec244b1367d54(curr) ? template(curr, index, values) : ''}`, '');
}
/**
 * A function that does nothing
 *
 * @param {any[]} _ accepts any parameters
 * @returns nothing
 */ function $fd30e9352c42562e$export$8793edee2d425525(..._) {
    return;
}
/**
 * @param {string} groupName name of group
 * @param events string values related to group
 */ function $fd30e9352c42562e$export$c35e244fdf72907e(groupName, ...events) {
    const hasEvents = !!events?.length;
    if (hasEvents) {
        // eslint-disable-next-line no-console
        console.groupCollapsed(groupName);
        events?.forEach((event)=>{
            // eslint-disable-next-line no-console
            console.log(event);
        });
        // eslint-disable-next-line no-console
        console.groupEnd();
    } else // eslint-disable-next-line no-console
    console.log(groupName);
}
/**
 * Splits an object into 2 objects based on a predicate
 *
 * @param {object} obj an object to split into two
 * @param {function} predicate function to determin where an element should go
 * @returns
 */ function $fd30e9352c42562e$export$d7e675a9b5995fea(obj, predicate) {
    const left = {};
    const right = {};
    Object.entries(obj).forEach(([key, value])=>{
        if (predicate(key)) left[key] = value;
        else right[key] = value;
    });
    return [
        left,
        right
    ];
}
const $fd30e9352c42562e$export$629a2bd3f5a49ecc = (obj)=>{
    if (obj === null || obj === undefined || typeof obj !== 'object') return obj;
    if (obj instanceof Array) return obj.reduce((arr, item, i)=>{
        arr[i] = $fd30e9352c42562e$export$629a2bd3f5a49ecc(item);
        return arr;
    }, []);
    if (obj instanceof Object) return Object.keys(obj || {}).reduce((cpObj, key)=>{
        cpObj[key] = $fd30e9352c42562e$export$629a2bd3f5a49ecc(obj[key]);
        return cpObj;
    }, {});
};



var $6aRB8 = parcelRequire("6aRB8");

var $6aRB8 = parcelRequire("6aRB8");

var $6aRB8 = parcelRequire("6aRB8");
var $d1ed4a9ded341161$export$2e2bcd8739ae039 = (0, $6aRB8.useLayoutEffect);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $1d68e7cbb4c6c146$export$18ce0697a983be9b = function() {
    $1d68e7cbb4c6c146$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1d68e7cbb4c6c146$export$18ce0697a983be9b.apply(this, arguments);
};
function $1d68e7cbb4c6c146$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1d68e7cbb4c6c146$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1d68e7cbb4c6c146$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1d68e7cbb4c6c146$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}


var $48a17dffa424dcd9$export$1385d81a6c6bbcd4;
(function(ActionTypes) {
    ActionTypes["Start"] = "xstate.start";
    ActionTypes["Stop"] = "xstate.stop";
    ActionTypes["Raise"] = "xstate.raise";
    ActionTypes["Send"] = "xstate.send";
    ActionTypes["Cancel"] = "xstate.cancel";
    ActionTypes["NullEvent"] = "";
    ActionTypes["Assign"] = "xstate.assign";
    ActionTypes["After"] = "xstate.after";
    ActionTypes["DoneState"] = "done.state";
    ActionTypes["DoneInvoke"] = "done.invoke";
    ActionTypes["Log"] = "xstate.log";
    ActionTypes["Init"] = "xstate.init";
    ActionTypes["Invoke"] = "xstate.invoke";
    ActionTypes["ErrorExecution"] = "error.execution";
    ActionTypes["ErrorCommunication"] = "error.communication";
    ActionTypes["ErrorPlatform"] = "error.platform";
    ActionTypes["ErrorCustom"] = "xstate.error";
    ActionTypes["Update"] = "xstate.update";
    ActionTypes["Pure"] = "xstate.pure";
    ActionTypes["Choose"] = "xstate.choose";
})($48a17dffa424dcd9$export$1385d81a6c6bbcd4 || ($48a17dffa424dcd9$export$1385d81a6c6bbcd4 = {}));
var $48a17dffa424dcd9$export$79f5baa747fbdd45;
(function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
})($48a17dffa424dcd9$export$79f5baa747fbdd45 || ($48a17dffa424dcd9$export$79f5baa747fbdd45 = {}));



var $5d5891f130d5ede2$export$b060f3cec92ef5c9 = '.';
var $5d5891f130d5ede2$export$505a390a702f4a23 = {};
var $5d5891f130d5ede2$export$656461011b562379 = 'xstate.guard';
var $5d5891f130d5ede2$export$31935b4577455331 = '';




var $b9f819ed84df55d9$exports = {};

$parcel$export($b9f819ed84df55d9$exports, "start", function () { return $b9f819ed84df55d9$export$b3571188c770cc5a; });
$parcel$export($b9f819ed84df55d9$exports, "stop", function () { return $b9f819ed84df55d9$export$fa6813432f753b0d; });
$parcel$export($b9f819ed84df55d9$exports, "raise", function () { return $b9f819ed84df55d9$export$66313c302b2ea154; });
$parcel$export($b9f819ed84df55d9$exports, "send", function () { return $b9f819ed84df55d9$export$89db4734f6c919c4; });
$parcel$export($b9f819ed84df55d9$exports, "cancel", function () { return $b9f819ed84df55d9$export$70b61ad426ddbe54; });
$parcel$export($b9f819ed84df55d9$exports, "nullEvent", function () { return $b9f819ed84df55d9$export$9477ceca5dcd796a; });
$parcel$export($b9f819ed84df55d9$exports, "assign", function () { return $b9f819ed84df55d9$export$e6e34fd1f2686227; });
$parcel$export($b9f819ed84df55d9$exports, "after", function () { return $b9f819ed84df55d9$export$742acabee3dd6465; });
$parcel$export($b9f819ed84df55d9$exports, "doneState", function () { return $b9f819ed84df55d9$export$de2557b5933c9ac6; });
$parcel$export($b9f819ed84df55d9$exports, "log", function () { return $b9f819ed84df55d9$export$bef1f36f5486a6a3; });
$parcel$export($b9f819ed84df55d9$exports, "init", function () { return $b9f819ed84df55d9$export$2cd8252107eb640b; });
$parcel$export($b9f819ed84df55d9$exports, "invoke", function () { return $b9f819ed84df55d9$export$468cda29b159ee5d; });
$parcel$export($b9f819ed84df55d9$exports, "errorExecution", function () { return $b9f819ed84df55d9$export$aca059ee6fbf94e8; });
$parcel$export($b9f819ed84df55d9$exports, "errorPlatform", function () { return $b9f819ed84df55d9$export$503a23d0e5cd1226; });
$parcel$export($b9f819ed84df55d9$exports, "error", function () { return $b9f819ed84df55d9$export$a3bc9b8ed74fc; });
$parcel$export($b9f819ed84df55d9$exports, "update", function () { return $b9f819ed84df55d9$export$722fbec263ad908a; });
$parcel$export($b9f819ed84df55d9$exports, "choose", function () { return $b9f819ed84df55d9$export$7877a478dd30fd3d; });
$parcel$export($b9f819ed84df55d9$exports, "pure", function () { return $b9f819ed84df55d9$export$48ec4a2b1cfc6557; });

var $b9f819ed84df55d9$export$b3571188c770cc5a = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Start;
var $b9f819ed84df55d9$export$fa6813432f753b0d = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Stop;
var $b9f819ed84df55d9$export$66313c302b2ea154 = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Raise;
var $b9f819ed84df55d9$export$89db4734f6c919c4 = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Send;
var $b9f819ed84df55d9$export$70b61ad426ddbe54 = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Cancel;
var $b9f819ed84df55d9$export$9477ceca5dcd796a = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).NullEvent;
var $b9f819ed84df55d9$export$e6e34fd1f2686227 = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Assign;
var $b9f819ed84df55d9$export$742acabee3dd6465 = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).After;
var $b9f819ed84df55d9$export$de2557b5933c9ac6 = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).DoneState;
var $b9f819ed84df55d9$export$bef1f36f5486a6a3 = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Log;
var $b9f819ed84df55d9$export$2cd8252107eb640b = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Init;
var $b9f819ed84df55d9$export$468cda29b159ee5d = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Invoke;
var $b9f819ed84df55d9$export$aca059ee6fbf94e8 = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).ErrorExecution;
var $b9f819ed84df55d9$export$503a23d0e5cd1226 = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).ErrorPlatform;
var $b9f819ed84df55d9$export$a3bc9b8ed74fc = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).ErrorCustom;
var $b9f819ed84df55d9$export$722fbec263ad908a = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Update;
var $b9f819ed84df55d9$export$7877a478dd30fd3d = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Choose;
var $b9f819ed84df55d9$export$48ec4a2b1cfc6557 = (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Pure;



var $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571 = true;


var $620580f2e39be27d$var$_a;
function $620580f2e39be27d$export$ed97f33186d4b816(value) {
    return Object.keys(value);
}
function $620580f2e39be27d$export$2870710bf0eac88e(parentStateId, childStateId, delimiter) {
    if (delimiter === void 0) delimiter = (0, $5d5891f130d5ede2$export$b060f3cec92ef5c9);
    var parentStateValue = $620580f2e39be27d$export$fb3aecd1d93744e3(parentStateId, delimiter);
    var childStateValue = $620580f2e39be27d$export$fb3aecd1d93744e3(childStateId, delimiter);
    if ($620580f2e39be27d$export$844ec244b1367d54(childStateValue)) {
        if ($620580f2e39be27d$export$844ec244b1367d54(parentStateValue)) return childStateValue === parentStateValue;
         // Parent more specific than child
        return false;
    }
    if ($620580f2e39be27d$export$844ec244b1367d54(parentStateValue)) return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every(function(key) {
        if (!(key in childStateValue)) return false;
        return $620580f2e39be27d$export$2870710bf0eac88e(parentStateValue[key], childStateValue[key]);
    });
}
function $620580f2e39be27d$export$7193fc8c8cd445e9(event) {
    try {
        return $620580f2e39be27d$export$844ec244b1367d54(event) || typeof event === 'number' ? "".concat(event) : event.type;
    } catch (e) {
        throw new Error('Events must be strings or objects with a string event.type property.');
    }
}
function $620580f2e39be27d$export$e303144c5506946a(action) {
    try {
        return $620580f2e39be27d$export$844ec244b1367d54(action) || typeof action === 'number' ? "".concat(action) : $620580f2e39be27d$export$f6e2535fb5126e54(action) ? action.name : action.type;
    } catch (e) {
        throw new Error('Actions must be strings or objects with a string action.type property.');
    }
}
function $620580f2e39be27d$export$304cde62ecda7af8(stateId, delimiter) {
    try {
        if ($620580f2e39be27d$export$43bee75e5e14138e(stateId)) return stateId;
        return stateId.toString().split(delimiter);
    } catch (e) {
        throw new Error("'".concat(stateId, "' is not a valid state path."));
    }
}
function $620580f2e39be27d$export$e080e3931a079c9b(state) {
    return typeof state === 'object' && 'value' in state && 'context' in state && 'event' in state && '_event' in state;
}
function $620580f2e39be27d$export$fb3aecd1d93744e3(stateValue, delimiter) {
    if ($620580f2e39be27d$export$e080e3931a079c9b(stateValue)) return stateValue.value;
    if ($620580f2e39be27d$export$43bee75e5e14138e(stateValue)) return $620580f2e39be27d$export$f2ee84fc53c45e74(stateValue);
    if (typeof stateValue !== 'string') return stateValue;
    var statePath = $620580f2e39be27d$export$304cde62ecda7af8(stateValue, delimiter);
    return $620580f2e39be27d$export$f2ee84fc53c45e74(statePath);
}
function $620580f2e39be27d$export$f2ee84fc53c45e74(statePath) {
    if (statePath.length === 1) return statePath[0];
    var value = {};
    var marker = value;
    for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        marker[statePath[i]] = {};
        marker = marker[statePath[i]];
    }
    return value;
}
function $620580f2e39be27d$export$825e789796ab7275(collection, iteratee) {
    var result = {};
    var collectionKeys = Object.keys(collection);
    for(var i = 0; i < collectionKeys.length; i++){
        var key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $620580f2e39be27d$export$2d4204fe9b34204e(collection, iteratee, predicate) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var item = collection[key];
            if (!predicate(item)) continue;
            result[key] = iteratee(item, key, collection);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */ var $620580f2e39be27d$export$bb654e07daaf8c3a = function(props) {
    return function(object) {
        var e_2, _a;
        var result = object;
        try {
            for(var props_1 = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                result = result[prop];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */ function $620580f2e39be27d$export$314d0a1a7c835392(props, accessorProp) {
    return function(object) {
        var e_3, _a;
        var result = object;
        try {
            for(var props_2 = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                var prop = props_2_1.value;
                result = result[accessorProp][prop];
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
}
function $620580f2e39be27d$export$a2618e9e89698dd6(stateValue) {
    if (!stateValue) return [
        []
    ];
    if ($620580f2e39be27d$export$844ec244b1367d54(stateValue)) return [
        [
            stateValue
        ]
    ];
    var result = $620580f2e39be27d$export$bffa455ba8c619a6(Object.keys(stateValue).map(function(key) {
        var subStateValue = stateValue[key];
        if (typeof subStateValue !== 'string' && (!subStateValue || !Object.keys(subStateValue).length)) return [
            [
                key
            ]
        ];
        return $620580f2e39be27d$export$a2618e9e89698dd6(stateValue[key]).map(function(subPath) {
            return [
                key
            ].concat(subPath);
        });
    }));
    return result;
}
function $620580f2e39be27d$export$c9d3abe59e55cae0(paths) {
    var e_4, _a;
    var result = {};
    if (paths && paths.length === 1 && paths[0].length === 1) return paths[0][0];
    try {
        for(var paths_1 = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var currentPath = paths_1_1.value;
            var marker = result; // tslint:disable-next-line:prefer-for-of
            for(var i = 0; i < currentPath.length; i++){
                var subPath = currentPath[i];
                if (i === currentPath.length - 2) {
                    marker[subPath] = currentPath[i + 1];
                    break;
                }
                marker[subPath] = marker[subPath] || {};
                marker = marker[subPath];
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return result;
}
function $620580f2e39be27d$export$bffa455ba8c619a6(array) {
    var _a;
    return (_a = []).concat.apply(_a, (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(array), false));
}
function $620580f2e39be27d$export$2c0b6b2f4faf21e1(value) {
    if ($620580f2e39be27d$export$43bee75e5e14138e(value)) return value;
    return [
        value
    ];
}
function $620580f2e39be27d$export$45b10814cc054894(value) {
    if (value === undefined) return [];
    return $620580f2e39be27d$export$2c0b6b2f4faf21e1(value);
}
function $620580f2e39be27d$export$e756e60189cc2351(mapper, context, _event) {
    var e_5, _a;
    if ($620580f2e39be27d$export$f6e2535fb5126e54(mapper)) return mapper(context, _event.data);
    var result = {};
    try {
        for(var _b = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var subMapper = mapper[key];
            if ($620580f2e39be27d$export$f6e2535fb5126e54(subMapper)) result[key] = subMapper(context, _event.data);
            else result[key] = subMapper;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return result;
}
function $620580f2e39be27d$export$479b1b8942fd0b8d(eventType) {
    return /^(done|error)\./.test(eventType);
}
function $620580f2e39be27d$export$ae936b9d47e5870e(value) {
    if (value instanceof Promise) return true;
     // Check if shape matches the Promise/A+ specification for a "thenable".
    if (value !== null && ($620580f2e39be27d$export$f6e2535fb5126e54(value) || typeof value === 'object') && $620580f2e39be27d$export$f6e2535fb5126e54(value.then)) return true;
    return false;
}
function $620580f2e39be27d$export$42749ebe1e7fdef7(value) {
    return value !== null && typeof value === 'object' && 'transition' in value && typeof value.transition === 'function';
}
function $620580f2e39be27d$export$b29f828819edca8d(items, predicate) {
    var e_6, _a;
    var _b = (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $620580f2e39be27d$export$3737909a0074eb1(hist, stateValue) {
    return $620580f2e39be27d$export$825e789796ab7275(hist.states, function(subHist, key) {
        if (!subHist) return undefined;
        var subStateValue = ($620580f2e39be27d$export$844ec244b1367d54(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
        if (!subStateValue) return undefined;
        return {
            current: subStateValue,
            states: $620580f2e39be27d$export$3737909a0074eb1(subHist, subStateValue)
        };
    });
}
function $620580f2e39be27d$export$240d7cdd99ccb95a(hist, stateValue) {
    return {
        current: stateValue,
        states: $620580f2e39be27d$export$3737909a0074eb1(hist, stateValue)
    };
}
function $620580f2e39be27d$export$d84706064a6e6c1c(context, _event, assignActions, state) {
    if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) $620580f2e39be27d$export$c106dd0671a0fc2d(!!context, 'Attempting to update undefined context');
    var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
        var e_7, _a;
        var assignment = assignAction.assignment;
        var meta = {
            state: state,
            action: assignAction,
            _event: _event
        };
        var partialUpdate = {};
        if ($620580f2e39be27d$export$f6e2535fb5126e54(assignment)) partialUpdate = assignment(acc, _event.data, meta);
        else try {
            for(var _b = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var propAssignment = assignment[key];
                partialUpdate[key] = $620580f2e39be27d$export$f6e2535fb5126e54(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return Object.assign({}, acc, partialUpdate);
    }, context) : context;
    return updatedContext;
} // tslint:disable-next-line:no-empty
var $620580f2e39be27d$export$c106dd0671a0fc2d = function() {};
if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) $620580f2e39be27d$export$c106dd0671a0fc2d = function(condition, message) {
    var error = condition instanceof Error ? condition : undefined;
    if (!error && condition) return;
    if (console !== undefined) {
        var args = [
            "Warning: ".concat(message)
        ];
        if (error) args.push(error);
         // tslint:disable-next-line:no-console
        console.warn.apply(console, args);
    }
};
function $620580f2e39be27d$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
} // tslint:disable-next-line:ban-types
function $620580f2e39be27d$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $620580f2e39be27d$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $620580f2e39be27d$export$b0f5a08e0ca47933(condition, guardMap) {
    if (!condition) return undefined;
    if ($620580f2e39be27d$export$844ec244b1367d54(condition)) return {
        type: (0, $5d5891f130d5ede2$export$656461011b562379),
        name: condition,
        predicate: guardMap ? guardMap[condition] : undefined
    };
    if ($620580f2e39be27d$export$f6e2535fb5126e54(condition)) return {
        type: (0, $5d5891f130d5ede2$export$656461011b562379),
        name: condition.name,
        predicate: condition
    };
    return condition;
}
function $620580f2e39be27d$export$5cd057a6046189f9(value) {
    try {
        return 'subscribe' in value && $620580f2e39be27d$export$f6e2535fb5126e54(value.subscribe);
    } catch (e) {
        return false;
    }
}
var $620580f2e39be27d$export$c45ebe72e3b2885 = /*#__PURE__*/ function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages
var $620580f2e39be27d$export$a6273dafbee7f61e = ($620580f2e39be27d$var$_a = {}, $620580f2e39be27d$var$_a[$620580f2e39be27d$export$c45ebe72e3b2885] = function() {
    return this;
}, $620580f2e39be27d$var$_a[Symbol.observable] = function() {
    return this;
}, $620580f2e39be27d$var$_a);
function $620580f2e39be27d$export$2163e7903738b5df(value) {
    return !!value && '__xstatenode' in value;
}
function $620580f2e39be27d$export$e769f6913f14f1b7(value) {
    return !!value && typeof value.send === 'function';
}
var $620580f2e39be27d$export$8b15d37bc3f197d4 = /*#__PURE__*/ function() {
    var currentId = 0;
    return function() {
        currentId++;
        return currentId.toString(16);
    };
}();
function $620580f2e39be27d$export$5a4ea50826a01d14(event, payload // id?: TEvent['type']
) {
    if ($620580f2e39be27d$export$844ec244b1367d54(event) || typeof event === 'number') return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({
        type: event
    }, payload);
    return event;
}
function $620580f2e39be27d$export$eaf22249b410f633(event, scxmlEvent) {
    if (!$620580f2e39be27d$export$844ec244b1367d54(event) && '$$type' in event && event.$$type === 'scxml') return event;
    var eventObject = $620580f2e39be27d$export$5a4ea50826a01d14(event);
    return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({
        name: eventObject.type,
        data: eventObject,
        $$type: 'scxml',
        type: 'external'
    }, scxmlEvent);
}
function $620580f2e39be27d$export$3822a36ea084a4d5(event, configLike) {
    var transitions = $620580f2e39be27d$export$2c0b6b2f4faf21e1(configLike).map(function(transitionLike) {
        if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string' || $620580f2e39be27d$export$2163e7903738b5df(transitionLike)) return {
            target: transitionLike,
            event: event
        };
        return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, transitionLike), {
            event: event
        });
    });
    return transitions;
}
function $620580f2e39be27d$export$2a4fe5c3c80e3288(target) {
    if (target === undefined || target === (0, $5d5891f130d5ede2$export$31935b4577455331)) return undefined;
    return $620580f2e39be27d$export$45b10814cc054894(target);
}
function $620580f2e39be27d$export$b240b9b7a78b5f3e(originalError, currentError, id) {
    if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) {
        var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : '';
        if (originalError === currentError) // tslint:disable-next-line:no-console
        console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
        else {
            var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ''; // tslint:disable-next-line:no-console
            console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
        }
    }
}
function $620580f2e39be27d$export$91646ab912d254e8(machine, guard, context, _event, state) {
    var guards = machine.options.guards;
    var guardMeta = {
        state: state,
        cond: guard,
        _event: _event
    }; // TODO: do not hardcode!
    if (guard.type === (0, $5d5891f130d5ede2$export$656461011b562379)) return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
    var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
    if (!condFn) throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
    return condFn(context, _event.data, guardMeta);
}
function $620580f2e39be27d$export$436e852aa2feda95(src) {
    if (typeof src === 'string') return {
        type: src
    };
    return src;
}
function $620580f2e39be27d$export$75b67481063f2f98(nextHandler, errorHandler, completionHandler) {
    var noop = function() {};
    var isObserver = typeof nextHandler === 'object';
    var self = isObserver ? nextHandler : null;
    return {
        next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
        error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
        complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
    };
}
function $620580f2e39be27d$export$107b54c5097f9157(stateNodeId, index) {
    return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}
function $620580f2e39be27d$export$37dc2eda56cb25a5(action) {
    return (action.type === (0, $b9f819ed84df55d9$export$66313c302b2ea154) || action.type === (0, $b9f819ed84df55d9$export$89db4734f6c919c4) && action.to === (0, $48a17dffa424dcd9$export$79f5baa747fbdd45).Internal) && typeof action.delay !== 'number';
}




var $cfb92dfa6e7dbf48$export$335db82b86111fd1 = function(stateNode) {
    return stateNode.type === 'atomic' || stateNode.type === 'final';
};
function $cfb92dfa6e7dbf48$export$ad3d2e38d4deaf6d(stateNode) {
    return Object.keys(stateNode.states).map(function(key) {
        return stateNode.states[key];
    });
}
function $cfb92dfa6e7dbf48$export$f8cf48ee793b41be(stateNode) {
    return $cfb92dfa6e7dbf48$export$ad3d2e38d4deaf6d(stateNode).filter(function(sn) {
        return sn.type !== 'history';
    });
}
function $cfb92dfa6e7dbf48$export$3de19bba299e3801(stateNode) {
    var stateNodes = [
        stateNode
    ];
    if ($cfb92dfa6e7dbf48$export$335db82b86111fd1(stateNode)) return stateNodes;
    return stateNodes.concat((0, $620580f2e39be27d$export$bffa455ba8c619a6)($cfb92dfa6e7dbf48$export$f8cf48ee793b41be(stateNode).map($cfb92dfa6e7dbf48$export$3de19bba299e3801)));
}
function $cfb92dfa6e7dbf48$export$3de01744a82b21a4(prevStateNodes, stateNodes) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var prevConfiguration = new Set(prevStateNodes);
    var prevAdjList = $cfb92dfa6e7dbf48$export$b837d8c2d0189d63(prevConfiguration);
    var configuration = new Set(stateNodes);
    try {
        // add all ancestors
        for(var configuration_1 = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()){
            var s = configuration_1_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    var adjList = $cfb92dfa6e7dbf48$export$b837d8c2d0189d63(configuration);
    try {
        // add descendants
        for(var configuration_2 = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()){
            var s = configuration_2_1.value; // if previously active, add existing child nodes
            if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) {
                if (prevAdjList.get(s)) prevAdjList.get(s).forEach(function(sn) {
                    return configuration.add(sn);
                });
                else s.initialStateNodes.forEach(function(sn) {
                    return configuration.add(sn);
                });
            } else {
                if (s.type === 'parallel') try {
                    for(var _e = (e_3 = void 0, (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)($cfb92dfa6e7dbf48$export$f8cf48ee793b41be(s))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var child = _f.value;
                        if (!configuration.has(child)) {
                            configuration.add(child);
                            if (prevAdjList.get(child)) prevAdjList.get(child).forEach(function(sn) {
                                return configuration.add(sn);
                            });
                            else child.initialStateNodes.forEach(function(sn) {
                                return configuration.add(sn);
                            });
                        }
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    try {
        // add all ancestors
        for(var configuration_3 = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()){
            var s = configuration_3_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return configuration;
}
function $cfb92dfa6e7dbf48$var$getValueFromAdj(baseNode, adjList) {
    var childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === 'compound') {
        var childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($cfb92dfa6e7dbf48$export$335db82b86111fd1(childStateNode)) return childStateNode.key;
        } else return {};
    }
    var stateValue = {};
    childStateNodes.forEach(function(csn) {
        stateValue[csn.key] = $cfb92dfa6e7dbf48$var$getValueFromAdj(csn, adjList);
    });
    return stateValue;
}
function $cfb92dfa6e7dbf48$export$b837d8c2d0189d63(configuration) {
    var e_5, _a;
    var adjList = new Map();
    try {
        for(var configuration_4 = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()){
            var s = configuration_4_1.value;
            if (!adjList.has(s)) adjList.set(s, []);
            if (s.parent) {
                if (!adjList.has(s.parent)) adjList.set(s.parent, []);
                adjList.get(s.parent).push(s);
            }
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return adjList;
}
function $cfb92dfa6e7dbf48$export$bf7199a9ebcb84a9(rootNode, configuration) {
    var config = $cfb92dfa6e7dbf48$export$3de01744a82b21a4([
        rootNode
    ], configuration);
    return $cfb92dfa6e7dbf48$var$getValueFromAdj(rootNode, $cfb92dfa6e7dbf48$export$b837d8c2d0189d63(config));
}
function $cfb92dfa6e7dbf48$export$a4f4bb6b1453fff5(iterable, item) {
    if (Array.isArray(iterable)) return iterable.some(function(member) {
        return member === item;
    });
    if (iterable instanceof Set) return iterable.has(item);
    return false; // TODO: fix
}
function $cfb92dfa6e7dbf48$export$c661ab6895e3ed73(configuration) {
    return (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(new Set((0, $620580f2e39be27d$export$bffa455ba8c619a6)((0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(configuration.map(function(sn) {
        return sn.ownEvents;
    })), false)))), false);
}
function $cfb92dfa6e7dbf48$export$cf3d5dae927fcf63(configuration, stateNode) {
    if (stateNode.type === 'compound') return $cfb92dfa6e7dbf48$export$f8cf48ee793b41be(stateNode).some(function(s) {
        return s.type === 'final' && $cfb92dfa6e7dbf48$export$a4f4bb6b1453fff5(configuration, s);
    });
    if (stateNode.type === 'parallel') return $cfb92dfa6e7dbf48$export$f8cf48ee793b41be(stateNode).every(function(sn) {
        return $cfb92dfa6e7dbf48$export$cf3d5dae927fcf63(configuration, sn);
    });
    return false;
}
function $cfb92dfa6e7dbf48$export$c47913ca32a5c6f7(configuration) {
    if (configuration === void 0) configuration = [];
    return configuration.reduce(function(acc, stateNode) {
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
}
function $cfb92dfa6e7dbf48$export$5301196121335ca0(configuration) {
    return new Set((0, $620580f2e39be27d$export$bffa455ba8c619a6)(configuration.map(function(sn) {
        return sn.tags;
    })));
}


var $673da5a8478f7656$exports = {};

$parcel$export($673da5a8478f7656$exports, "initEvent", function () { return $673da5a8478f7656$export$163c566c60ed2ec9; });
$parcel$export($673da5a8478f7656$exports, "getActionFunction", function () { return $673da5a8478f7656$export$c7e5ca927bd4567; });
$parcel$export($673da5a8478f7656$exports, "toActionObject", function () { return $673da5a8478f7656$export$b38b66cc2da3ede7; });
$parcel$export($673da5a8478f7656$exports, "toActionObjects", function () { return $673da5a8478f7656$export$aa68691f32e6c459; });
$parcel$export($673da5a8478f7656$exports, "toActivityDefinition", function () { return $673da5a8478f7656$export$e81fdd8937d44864; });
$parcel$export($673da5a8478f7656$exports, "raise", function () { return $673da5a8478f7656$export$66313c302b2ea154; });
$parcel$export($673da5a8478f7656$exports, "resolveRaise", function () { return $673da5a8478f7656$export$ed3daf8e935ede01; });
$parcel$export($673da5a8478f7656$exports, "send", function () { return $673da5a8478f7656$export$89db4734f6c919c4; });
$parcel$export($673da5a8478f7656$exports, "resolveSend", function () { return $673da5a8478f7656$export$f43e8cbb721d72d5; });
$parcel$export($673da5a8478f7656$exports, "sendParent", function () { return $673da5a8478f7656$export$408d8d51fa351f53; });
$parcel$export($673da5a8478f7656$exports, "sendTo", function () { return $673da5a8478f7656$export$daa976aaff721e41; });
$parcel$export($673da5a8478f7656$exports, "sendUpdate", function () { return $673da5a8478f7656$export$7f8b724299523eb6; });
$parcel$export($673da5a8478f7656$exports, "respond", function () { return $673da5a8478f7656$export$72b816ae90496f19; });
$parcel$export($673da5a8478f7656$exports, "log", function () { return $673da5a8478f7656$export$bef1f36f5486a6a3; });
$parcel$export($673da5a8478f7656$exports, "resolveLog", function () { return $673da5a8478f7656$export$12cba28d36be4946; });
$parcel$export($673da5a8478f7656$exports, "cancel", function () { return $673da5a8478f7656$export$70b61ad426ddbe54; });
$parcel$export($673da5a8478f7656$exports, "start", function () { return $673da5a8478f7656$export$b3571188c770cc5a; });
$parcel$export($673da5a8478f7656$exports, "stop", function () { return $673da5a8478f7656$export$fa6813432f753b0d; });
$parcel$export($673da5a8478f7656$exports, "resolveStop", function () { return $673da5a8478f7656$export$21aa461f4eb8e82; });
$parcel$export($673da5a8478f7656$exports, "assign", function () { return $673da5a8478f7656$export$e6e34fd1f2686227; });
$parcel$export($673da5a8478f7656$exports, "isActionObject", function () { return $673da5a8478f7656$export$6e816592f80fc079; });
$parcel$export($673da5a8478f7656$exports, "after", function () { return $673da5a8478f7656$export$742acabee3dd6465; });
$parcel$export($673da5a8478f7656$exports, "done", function () { return $673da5a8478f7656$export$3df11c9c20e7b288; });
$parcel$export($673da5a8478f7656$exports, "doneInvoke", function () { return $673da5a8478f7656$export$c105e588793f70b4; });
$parcel$export($673da5a8478f7656$exports, "error", function () { return $673da5a8478f7656$export$a3bc9b8ed74fc; });
$parcel$export($673da5a8478f7656$exports, "pure", function () { return $673da5a8478f7656$export$48ec4a2b1cfc6557; });
$parcel$export($673da5a8478f7656$exports, "forwardTo", function () { return $673da5a8478f7656$export$eb147b7589db8e8a; });
$parcel$export($673da5a8478f7656$exports, "escalate", function () { return $673da5a8478f7656$export$f514678a4137c4d6; });
$parcel$export($673da5a8478f7656$exports, "choose", function () { return $673da5a8478f7656$export$7877a478dd30fd3d; });
$parcel$export($673da5a8478f7656$exports, "resolveActions", function () { return $673da5a8478f7656$export$b8b9e7ba5b8c7b3e; });
$parcel$export($673da5a8478f7656$exports, "actionTypes", function () { return $b9f819ed84df55d9$exports; });





var $673da5a8478f7656$export$163c566c60ed2ec9 = /*#__PURE__*/ (0, $620580f2e39be27d$export$eaf22249b410f633)({
    type: (0, $b9f819ed84df55d9$export$2cd8252107eb640b)
});
function $673da5a8478f7656$export$c7e5ca927bd4567(actionType, actionFunctionMap) {
    return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function $673da5a8478f7656$export$b38b66cc2da3ede7(action, actionFunctionMap) {
    var actionObject;
    if ((0, $620580f2e39be27d$export$844ec244b1367d54)(action) || typeof action === 'number') {
        var exec = $673da5a8478f7656$export$c7e5ca927bd4567(action, actionFunctionMap);
        if ((0, $620580f2e39be27d$export$f6e2535fb5126e54)(exec)) actionObject = {
            type: action,
            exec: exec
        };
        else if (exec) actionObject = exec;
        else actionObject = {
            type: action,
            exec: undefined
        };
    } else if ((0, $620580f2e39be27d$export$f6e2535fb5126e54)(action)) actionObject = {
        // Convert action to string if unnamed
        type: action.name || action.toString(),
        exec: action
    };
    else {
        var exec = $673da5a8478f7656$export$c7e5ca927bd4567(action.type, actionFunctionMap);
        if ((0, $620580f2e39be27d$export$f6e2535fb5126e54)(exec)) actionObject = (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, action), {
            exec: exec
        });
        else if (exec) {
            var actionType = exec.type || action.type;
            actionObject = (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, exec), action), {
                type: actionType
            });
        } else actionObject = action;
    }
    return actionObject;
}
var $673da5a8478f7656$export$aa68691f32e6c459 = function(action, actionFunctionMap) {
    if (!action) return [];
    var actions = (0, $620580f2e39be27d$export$43bee75e5e14138e)(action) ? action : [
        action
    ];
    return actions.map(function(subAction) {
        return $673da5a8478f7656$export$b38b66cc2da3ede7(subAction, actionFunctionMap);
    });
};
function $673da5a8478f7656$export$e81fdd8937d44864(action) {
    var actionObject = $673da5a8478f7656$export$b38b66cc2da3ede7(action);
    return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({
        id: (0, $620580f2e39be27d$export$844ec244b1367d54)(action) ? action : actionObject.id
    }, actionObject), {
        type: actionObject.type
    });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $673da5a8478f7656$export$66313c302b2ea154(event, options) {
    return {
        type: (0, $b9f819ed84df55d9$export$66313c302b2ea154),
        event: typeof event === 'function' ? event : (0, $620580f2e39be27d$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        id: options === null || options === void 0 ? void 0 : options.id
    };
}
function $673da5a8478f7656$export$ed3daf8e935ede01(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    };
    var resolvedEvent = (0, $620580f2e39be27d$export$eaf22249b410f633)((0, $620580f2e39be27d$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $620580f2e39be27d$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $620580f2e39be27d$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $620580f2e39be27d$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, action), {
        type: (0, $b9f819ed84df55d9$export$66313c302b2ea154),
        _event: resolvedEvent,
        delay: resolvedDelay
    });
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @deprecated Use the `sendTo(...)` action creator instead.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */ function $673da5a8478f7656$export$89db4734f6c919c4(event, options) {
    return {
        to: options ? options.to : undefined,
        type: (0, $b9f819ed84df55d9$export$89db4734f6c919c4),
        event: (0, $620580f2e39be27d$export$f6e2535fb5126e54)(event) ? event : (0, $620580f2e39be27d$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        // TODO: don't auto-generate IDs here like that
        // there is too big chance of the ID collision
        id: options && options.id !== undefined ? options.id : (0, $620580f2e39be27d$export$f6e2535fb5126e54)(event) ? event.name : (0, $620580f2e39be27d$export$7193fc8c8cd445e9)(event)
    };
}
function $673da5a8478f7656$export$f43e8cbb721d72d5(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    }; // TODO: helper function for resolving Expr
    var resolvedEvent = (0, $620580f2e39be27d$export$eaf22249b410f633)((0, $620580f2e39be27d$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $620580f2e39be27d$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $620580f2e39be27d$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $620580f2e39be27d$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    var resolvedTarget = (0, $620580f2e39be27d$export$f6e2535fb5126e54)(action.to) ? action.to(ctx, _event.data, meta) : action.to;
    return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, action), {
        to: resolvedTarget,
        _event: resolvedEvent,
        event: resolvedEvent.data,
        delay: resolvedDelay
    });
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $673da5a8478f7656$export$408d8d51fa351f53(event, options) {
    return $673da5a8478f7656$export$89db4734f6c919c4(event, (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, options), {
        to: (0, $48a17dffa424dcd9$export$79f5baa747fbdd45).Parent
    }));
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event to send
 * @param options Send action options
 * @returns An XState send action object
 */ function $673da5a8478f7656$export$daa976aaff721e41(actor, event, options) {
    return $673da5a8478f7656$export$89db4734f6c919c4(event, (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, options), {
        to: actor
    }));
}
/**
 * Sends an update event to this machine's parent.
 */ function $673da5a8478f7656$export$7f8b724299523eb6() {
    return $673da5a8478f7656$export$408d8d51fa351f53((0, $b9f819ed84df55d9$export$722fbec263ad908a));
}
/**
 * Sends an event back to the sender of the original event.
 *
 * @param event The event to send back to the sender
 * @param options Options to pass into the send event
 */ function $673da5a8478f7656$export$72b816ae90496f19(event, options) {
    return $673da5a8478f7656$export$89db4734f6c919c4(event, (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, options), {
        to: function(_, __, _a) {
            var _event = _a._event;
            return _event.origin; // TODO: handle when _event.origin is undefined
        }
    }));
}
var $673da5a8478f7656$var$defaultLogExpr = function(context, event) {
    return {
        context: context,
        event: event
    };
};
/**
 *
 * @param expr The expression function to evaluate which will be logged.
 *  Takes in 2 arguments:
 *  - `ctx` - the current state context
 *  - `event` - the event that caused this action to be executed.
 * @param label The label to give to the logged expression.
 */ function $673da5a8478f7656$export$bef1f36f5486a6a3(expr, label) {
    if (expr === void 0) expr = $673da5a8478f7656$var$defaultLogExpr;
    return {
        type: (0, $b9f819ed84df55d9$export$bef1f36f5486a6a3),
        label: label,
        expr: expr
    };
}
var $673da5a8478f7656$export$12cba28d36be4946 = function(action, ctx, _event) {
    return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, action), {
        value: (0, $620580f2e39be27d$export$844ec244b1367d54)(action.expr) ? action.expr : action.expr(ctx, _event.data, {
            _event: _event
        })
    });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */ var $673da5a8478f7656$export$70b61ad426ddbe54 = function(sendId) {
    return {
        type: (0, $b9f819ed84df55d9$export$70b61ad426ddbe54),
        sendId: sendId
    };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */ function $673da5a8478f7656$export$b3571188c770cc5a(activity) {
    var activityDef = $673da5a8478f7656$export$e81fdd8937d44864(activity);
    return {
        type: (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Start,
        activity: activityDef,
        exec: undefined
    };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */ function $673da5a8478f7656$export$fa6813432f753b0d(actorRef) {
    var activity = (0, $620580f2e39be27d$export$f6e2535fb5126e54)(actorRef) ? actorRef : $673da5a8478f7656$export$e81fdd8937d44864(actorRef);
    return {
        type: (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Stop,
        activity: activity,
        exec: undefined
    };
}
function $673da5a8478f7656$export$21aa461f4eb8e82(action, context, _event) {
    var actorRefOrString = (0, $620580f2e39be27d$export$f6e2535fb5126e54)(action.activity) ? action.activity(context, _event.data) : action.activity;
    var resolvedActorRef = typeof actorRefOrString === 'string' ? {
        id: actorRefOrString
    } : actorRefOrString;
    var actionObject = {
        type: (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Stop,
        activity: resolvedActorRef
    };
    return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */ var $673da5a8478f7656$export$e6e34fd1f2686227 = function(assignment) {
    return {
        type: (0, $b9f819ed84df55d9$export$e6e34fd1f2686227),
        assignment: assignment
    };
};
function $673da5a8478f7656$export$6e816592f80fc079(action) {
    return typeof action === 'object' && 'type' in action;
}
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $673da5a8478f7656$export$742acabee3dd6465(delayRef, id) {
    var idSuffix = id ? "#".concat(id) : '';
    return "".concat((0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */ function $673da5a8478f7656$export$3df11c9c20e7b288(id, data) {
    var type = "".concat((0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).DoneState, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */ function $673da5a8478f7656$export$c105e588793f70b4(id, data) {
    var type = "".concat((0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).DoneInvoke, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $673da5a8478f7656$export$a3bc9b8ed74fc(id, data) {
    var type = "".concat((0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).ErrorPlatform, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $673da5a8478f7656$export$48ec4a2b1cfc6557(getActions) {
    return {
        type: (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Pure,
        get: getActions
    };
}
/**
 * Forwards (sends) an event to a specified service.
 *
 * @param target The target service to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $673da5a8478f7656$export$eb147b7589db8e8a(target, options) {
    if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571) && (!target || typeof target === 'function')) {
        var originalTarget_1 = target;
        target = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var resolvedTarget = typeof originalTarget_1 === 'function' ? originalTarget_1.apply(void 0, (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(args), false)) : originalTarget_1;
            if (!resolvedTarget) throw new Error("Attempted to forward event to undefined actor. This risks an infinite loop in the sender.");
            return resolvedTarget;
        };
    }
    return $673da5a8478f7656$export$89db4734f6c919c4(function(_, event) {
        return event;
    }, (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, options), {
        to: target
    }));
}
/**
 * Escalates an error by sending it as an event to this machine's parent.
 *
 * @param errorData The error data to send, or the expression function that
 * takes in the `context`, `event`, and `meta`, and returns the error data to send.
 * @param options Options to pass into the send action creator.
 */ function $673da5a8478f7656$export$f514678a4137c4d6(errorData, options) {
    return $673da5a8478f7656$export$408d8d51fa351f53(function(context, event, meta) {
        return {
            type: (0, $b9f819ed84df55d9$export$a3bc9b8ed74fc),
            data: (0, $620580f2e39be27d$export$f6e2535fb5126e54)(errorData) ? errorData(context, event, meta) : errorData
        };
    }, (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, options), {
        to: (0, $48a17dffa424dcd9$export$79f5baa747fbdd45).Parent
    }));
}
function $673da5a8478f7656$export$7877a478dd30fd3d(conds) {
    return {
        type: (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Choose,
        conds: conds
    };
}
var $673da5a8478f7656$var$pluckAssigns = function(actionBlocks) {
    var e_1, _a;
    var assignActions = [];
    try {
        for(var actionBlocks_1 = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
            var block = actionBlocks_1_1.value;
            var i = 0;
            while(i < block.actions.length){
                if (block.actions[i].type === (0, $b9f819ed84df55d9$export$e6e34fd1f2686227)) {
                    assignActions.push(block.actions[i]);
                    block.actions.splice(i, 1);
                    continue;
                }
                i++;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return assignActions;
};
function $673da5a8478f7656$export$b8b9e7ba5b8c7b3e(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
    if (preserveActionOrder === void 0) preserveActionOrder = false;
    var assignActions = preserveActionOrder ? [] : $673da5a8478f7656$var$pluckAssigns(actionBlocks);
    var updatedContext = assignActions.length ? (0, $620580f2e39be27d$export$d84706064a6e6c1c)(currentContext, _event, assignActions, currentState) : currentContext;
    var preservedContexts = preserveActionOrder ? [
        currentContext
    ] : undefined;
    var deferredToBlockEnd = [];
    function handleAction(blockType, actionObject) {
        var _a;
        switch(actionObject.type){
            case 0, $b9f819ed84df55d9$export$66313c302b2ea154:
                var raisedAction = $673da5a8478f7656$export$ed3daf8e935ede01(actionObject, updatedContext, _event, machine.options.delays);
                if (predictableExec && typeof raisedAction.delay === 'number') predictableExec(raisedAction, updatedContext, _event);
                return raisedAction;
            case 0, $b9f819ed84df55d9$export$89db4734f6c919c4:
                var sendAction = $673da5a8478f7656$export$f43e8cbb721d72d5(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init
                if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) {
                    var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here
                    (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(!(0, $620580f2e39be27d$export$844ec244b1367d54)(configuredDelay) || typeof sendAction.delay === 'number', "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
                }
                if (predictableExec && sendAction.to !== (0, $48a17dffa424dcd9$export$79f5baa747fbdd45).Internal) {
                    if (blockType === 'entry') deferredToBlockEnd.push(sendAction);
                    else predictableExec(sendAction, updatedContext, _event);
                }
                return sendAction;
            case 0, $b9f819ed84df55d9$export$bef1f36f5486a6a3:
                var resolved = $673da5a8478f7656$export$12cba28d36be4946(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, updatedContext, _event);
                return resolved;
            case 0, $b9f819ed84df55d9$export$7877a478dd30fd3d:
                var chooseAction = actionObject;
                var matchedActions = (_a = chooseAction.conds.find(function(condition) {
                    var guard = (0, $620580f2e39be27d$export$b0f5a08e0ca47933)(condition.cond, machine.options.guards);
                    return !guard || (0, $620580f2e39be27d$export$91646ab912d254e8)(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
                })) === null || _a === void 0 ? void 0 : _a.actions;
                if (!matchedActions) return [];
                var _b = (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)($673da5a8478f7656$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $673da5a8478f7656$export$aa68691f32e6c459((0, $620580f2e39be27d$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
                updatedContext = resolvedContextFromChoose;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromChoose;
            case 0, $b9f819ed84df55d9$export$48ec4a2b1cfc6557:
                var matchedActions = actionObject.get(updatedContext, _event.data);
                if (!matchedActions) return [];
                var _c = (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)($673da5a8478f7656$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $673da5a8478f7656$export$aa68691f32e6c459((0, $620580f2e39be27d$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
                updatedContext = resolvedContext;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromPure;
            case 0, $b9f819ed84df55d9$export$fa6813432f753b0d:
                var resolved = $673da5a8478f7656$export$21aa461f4eb8e82(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, currentContext, _event);
                return resolved;
            case 0, $b9f819ed84df55d9$export$e6e34fd1f2686227:
                updatedContext = (0, $620580f2e39be27d$export$d84706064a6e6c1c)(updatedContext, _event, [
                    actionObject
                ], !predictableExec ? currentState : undefined);
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                break;
            default:
                var resolvedActionObject = $673da5a8478f7656$export$b38b66cc2da3ede7(actionObject, machine.options.actions);
                var exec_1 = resolvedActionObject.exec;
                if (predictableExec) predictableExec(resolvedActionObject, updatedContext, _event);
                else if (exec_1 && preservedContexts) {
                    var contextIndex_1 = preservedContexts.length - 1;
                    var wrapped = (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, resolvedActionObject), {
                        exec: function(_ctx) {
                            var args = [];
                            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                            exec_1.apply(void 0, (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([
                                preservedContexts[contextIndex_1]
                            ], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(args), false));
                        }
                    });
                    resolvedActionObject = wrapped;
                }
                return resolvedActionObject;
        }
    }
    function processBlock(block) {
        var e_2, _a;
        var resolvedActions = [];
        try {
            for(var _b = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(block.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                var resolved = handleAction(block.type, action);
                if (resolved) resolvedActions = resolvedActions.concat(resolved);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        deferredToBlockEnd.forEach(function(action) {
            predictableExec(action, updatedContext, _event);
        });
        deferredToBlockEnd.length = 0;
        return resolvedActions;
    }
    var resolvedActions = (0, $620580f2e39be27d$export$bffa455ba8c619a6)(actionBlocks.map(processBlock));
    return [
        resolvedActions,
        updatedContext
    ];
}



function $480eade3b32f6a45$export$3a6d15eeb5fb214c(a, b) {
    if (a === b) return true;
    if (a === undefined || b === undefined) return false;
    if ((0, $620580f2e39be27d$export$844ec244b1367d54)(a) || (0, $620580f2e39be27d$export$844ec244b1367d54)(b)) return a === b;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    return aKeys.length === bKeys.length && aKeys.every(function(key) {
        return $480eade3b32f6a45$export$3a6d15eeb5fb214c(a[key], b[key]);
    });
}
function $480eade3b32f6a45$export$4c86eb6450eda77a(state) {
    if (typeof state !== 'object' || state === null) return false;
    return 'value' in state && '_event' in state;
}
/**
 * @deprecated Use `isStateConfig(object)` or `state instanceof State` instead.
 */ var $480eade3b32f6a45$export$e5d60a6bbabd36f = $480eade3b32f6a45$export$4c86eb6450eda77a;
function $480eade3b32f6a45$export$e42513ad58964418(action, state) {
    var exec = action.exec;
    var boundAction = (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, action), {
        exec: exec !== undefined ? function() {
            return exec(state.context, state.event, {
                action: action,
                state: state,
                _event: state._event
            });
        } : undefined
    });
    return boundAction;
}
var $480eade3b32f6a45$export$7254cc27399e90bd = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */ function State(config) {
        var _this = this;
        var _a;
        this.actions = [];
        this.activities = (0, $5d5891f130d5ede2$export$505a390a702f4a23);
        this.meta = {};
        this.events = [];
        this.value = config.value;
        this.context = config.context;
        this._event = config._event;
        this._sessionid = config._sessionid;
        this.event = this._event.data;
        this.historyValue = config.historyValue;
        this.history = config.history;
        this.actions = config.actions || [];
        this.activities = config.activities || (0, $5d5891f130d5ede2$export$505a390a702f4a23);
        this.meta = (0, $cfb92dfa6e7dbf48$export$c47913ca32a5c6f7)(config.configuration);
        this.events = config.events || [];
        this.matches = this.matches.bind(this);
        this.toStrings = this.toStrings.bind(this);
        this.configuration = config.configuration;
        this.transitions = config.transitions;
        this.children = config.children;
        this.done = !!config.done;
        this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
        this.machine = config.machine;
        Object.defineProperty(this, 'nextEvents', {
            get: function() {
                return (0, $cfb92dfa6e7dbf48$export$c661ab6895e3ed73)(_this.configuration);
            }
        });
    }
    /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */ State.from = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (stateValue.context !== context) return new State({
                value: stateValue.value,
                context: context,
                _event: stateValue._event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                actions: [],
                activities: stateValue.activities,
                meta: {},
                events: [],
                configuration: [],
                transitions: [],
                children: {}
            });
            return stateValue;
        }
        var _event = (0, $673da5a8478f7656$export$163c566c60ed2ec9);
        return new State({
            value: stateValue,
            context: context,
            _event: _event,
            _sessionid: null,
            historyValue: undefined,
            history: undefined,
            actions: [],
            activities: undefined,
            meta: undefined,
            events: [],
            configuration: [],
            transitions: [],
            children: {}
        });
    };
    /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */ State.create = function(config) {
        return new State(config);
    };
    /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */ State.inert = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (!stateValue.actions.length) return stateValue;
            var _event = (0, $673da5a8478f7656$export$163c566c60ed2ec9);
            return new State({
                value: stateValue.value,
                context: context,
                _event: _event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                activities: stateValue.activities,
                configuration: stateValue.configuration,
                transitions: [],
                children: {}
            });
        }
        return State.from(stateValue, context);
    };
    /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */ State.prototype.toStrings = function(stateValue, delimiter) {
        var _this = this;
        if (stateValue === void 0) stateValue = this.value;
        if (delimiter === void 0) delimiter = '.';
        if ((0, $620580f2e39be27d$export$844ec244b1367d54)(stateValue)) return [
            stateValue
        ];
        var valueKeys = Object.keys(stateValue);
        return valueKeys.concat.apply(valueKeys, (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(valueKeys.map(function(key) {
            return _this.toStrings(stateValue[key], delimiter).map(function(s) {
                return key + delimiter + s;
            });
        })), false));
    };
    State.prototype.toJSON = function() {
        var _a = this;
        _a.configuration;
        _a.transitions;
        var tags = _a.tags;
        _a.machine;
        var jsonValues = (0, $1d68e7cbb4c6c146$export$3c9a16f847548506)(_a, [
            "configuration",
            "transitions",
            "tags",
            "machine"
        ]);
        return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, jsonValues), {
            tags: Array.from(tags)
        });
    };
    State.prototype.matches = function(parentStateValue) {
        return (0, $620580f2e39be27d$export$2870710bf0eac88e)(parentStateValue, this.value);
    };
    /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */ State.prototype.hasTag = function(tag) {
        return this.tags.has(tag);
    };
    /**
   * Determines whether sending the `event` will cause a non-forbidden transition
   * to be selected, even if the transitions have no actions nor
   * change the state value.
   *
   * @param event The event to test
   * @returns Whether the event will cause a transition
   */ State.prototype.can = function(event) {
        var _a;
        if (0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571) (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
        var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
        return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
        transitionData.transitions.some(function(t) {
            return t.target !== undefined || t.actions.length;
        });
    };
    return State;
}();







var $7a6b4bfbe5460c94$var$defaultOptions = {
    deferEvents: false
};
var $7a6b4bfbe5460c94$export$d3e54bb8584cda7c = /*#__PURE__*/ /** @class */ function() {
    function Scheduler(options) {
        this.processingEvent = false;
        this.queue = [];
        this.initialized = false;
        this.options = (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, $7a6b4bfbe5460c94$var$defaultOptions), options);
    }
    Scheduler.prototype.initialize = function(callback) {
        this.initialized = true;
        if (callback) {
            if (!this.options.deferEvents) {
                this.schedule(callback);
                return;
            }
            this.process(callback);
        }
        this.flushEvents();
    };
    Scheduler.prototype.schedule = function(task) {
        if (!this.initialized || this.processingEvent) {
            this.queue.push(task);
            return;
        }
        if (this.queue.length !== 0) throw new Error('Event queue should be empty when it is not processing events');
        this.process(task);
        this.flushEvents();
    };
    Scheduler.prototype.clear = function() {
        this.queue = [];
    };
    Scheduler.prototype.flushEvents = function() {
        var nextCallback = this.queue.shift();
        while(nextCallback){
            this.process(nextCallback);
            nextCallback = this.queue.shift();
        }
    };
    Scheduler.prototype.process = function(callback) {
        this.processingEvent = true;
        try {
            callback();
        } catch (e) {
            // there is no use to keep the future events
            // as the situation is not anymore the same
            this.clear();
            throw e;
        } finally{
            this.processingEvent = false;
        }
    };
    return Scheduler;
}();




/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */ var $bc878c7a3cc754f3$var$serviceStack = [];
var $bc878c7a3cc754f3$export$abe1e183e22e10ad = function(service, fn) {
    $bc878c7a3cc754f3$var$serviceStack.push(service);
    var result = fn(service);
    $bc878c7a3cc754f3$var$serviceStack.pop();
    return result;
};
var $bc878c7a3cc754f3$export$e11e6a155c5c4d9d = function(fn) {
    return fn($bc878c7a3cc754f3$var$serviceStack[$bc878c7a3cc754f3$var$serviceStack.length - 1]);
};


function $61142dedda67d7fc$export$8998449b468dcdad(id) {
    var _a;
    return _a = {
        id: id,
        send: function() {
            return void 0;
        },
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        getSnapshot: function() {
            return undefined;
        },
        toJSON: function() {
            return {
                id: id
            };
        }
    }, _a[0, $620580f2e39be27d$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a;
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */ function $61142dedda67d7fc$export$78b4a98dcb5ac328(invokeDefinition, machine, context, _event) {
    var _a;
    var invokeSrc = (0, $620580f2e39be27d$export$436e852aa2feda95)(invokeDefinition.src);
    var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
    var resolvedData = invokeDefinition.data ? (0, $620580f2e39be27d$export$e756e60189cc2351)(invokeDefinition.data, context, _event) : undefined;
    var tempActor = serviceCreator ? $61142dedda67d7fc$export$59bcb51d8e40ed48(serviceCreator, invokeDefinition.id, resolvedData) : $61142dedda67d7fc$export$8998449b468dcdad(invokeDefinition.id); // @ts-ignore
    tempActor.meta = invokeDefinition;
    return tempActor;
}
function $61142dedda67d7fc$export$59bcb51d8e40ed48(entity, id, data) {
    var tempActor = $61142dedda67d7fc$export$8998449b468dcdad(id); // @ts-ignore
    tempActor.deferred = true;
    if ((0, $620580f2e39be27d$export$2163e7903738b5df)(entity)) {
        // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
        var initialState_1 = tempActor.state = (0, $bc878c7a3cc754f3$export$abe1e183e22e10ad)(undefined, function() {
            return (data ? entity.withContext(data) : entity).initialState;
        });
        tempActor.getSnapshot = function() {
            return initialState_1;
        };
    }
    return tempActor;
}
function $61142dedda67d7fc$export$e769f6913f14f1b7(item) {
    try {
        return typeof item.send === 'function';
    } catch (e) {
        return false;
    }
}
function $61142dedda67d7fc$export$b0f989039dc164f9(item) {
    return $61142dedda67d7fc$export$e769f6913f14f1b7(item) && 'id' in item;
} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now
function $61142dedda67d7fc$export$ccadea5f6b9e9b4e(actorRefLike) {
    var _a;
    return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((_a = {
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        id: 'anonymous',
        getSnapshot: function() {
            return undefined;
        }
    }, _a[0, $620580f2e39be27d$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a), actorRefLike);
}


var $3e40894effda66d6$var$children = /*#__PURE__*/ new Map();
var $3e40894effda66d6$var$sessionIdIndex = 0;
var $3e40894effda66d6$export$4bb7493d241fd8a5 = {
    bookId: function() {
        return "x:".concat($3e40894effda66d6$var$sessionIdIndex++);
    },
    register: function(id, actor) {
        $3e40894effda66d6$var$children.set(id, actor);
        return id;
    },
    get: function(id) {
        return $3e40894effda66d6$var$children.get(id);
    },
    free: function(id) {
        $3e40894effda66d6$var$children.delete(id);
    }
};



function $4837de0392fa930f$export$a4e55266d2135a7f() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) console.warn('XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues');
}
function $4837de0392fa930f$var$getDevTools() {
    var global1 = $4837de0392fa930f$export$a4e55266d2135a7f();
    if (global1 && '__xstate__' in global1) return global1.__xstate__;
    return undefined;
}
function $4837de0392fa930f$export$4d7a7d14704ebc13(service) {
    if (!$4837de0392fa930f$export$a4e55266d2135a7f()) return;
    var devTools = $4837de0392fa930f$var$getDevTools();
    if (devTools) devTools.register(service);
}






/**
 * Returns an actor behavior from a reducer and its initial state.
 *
 * @param transition The pure reducer that returns the next state given the current state and event.
 * @param initialState The initial state of the reducer.
 * @returns An actor behavior
 */ function $65bf4aaa446dfad7$export$fe581ffd4962847b(transition, initialState) {
    return {
        transition: transition,
        initialState: initialState
    };
}
function $65bf4aaa446dfad7$export$60f45028237c39d1(promiseFn) {
    var initialState = {
        error: undefined,
        data: undefined,
        status: 'pending'
    };
    return {
        transition: function(state, event, _a) {
            var parent = _a.parent, id = _a.id, observers = _a.observers;
            switch(event.type){
                case 'fulfill':
                    parent === null || parent === void 0 || parent.send((0, $673da5a8478f7656$export$c105e588793f70b4)(id, event.data));
                    return {
                        error: undefined,
                        data: event.data,
                        status: 'fulfilled'
                    };
                case 'reject':
                    parent === null || parent === void 0 || parent.send((0, $673da5a8478f7656$export$a3bc9b8ed74fc)(id, event.error));
                    observers.forEach(function(observer) {
                        observer.error(event.error);
                    });
                    return {
                        error: event.error,
                        data: undefined,
                        status: 'rejected'
                    };
                default:
                    return state;
            }
        },
        initialState: initialState,
        start: function(_a) {
            var self = _a.self;
            promiseFn().then(function(data) {
                self.send({
                    type: 'fulfill',
                    data: data
                });
            }, function(reason) {
                self.send({
                    type: 'reject',
                    error: reason
                });
            });
            return initialState;
        }
    };
}
function $65bf4aaa446dfad7$export$cc3859917b3feaf8(behavior, options) {
    if (options === void 0) options = {};
    var state = behavior.initialState;
    var observers = new Set();
    var mailbox = [];
    var flushing = false;
    var flush = function() {
        if (flushing) return;
        flushing = true;
        while(mailbox.length > 0){
            var event_1 = mailbox.shift();
            state = behavior.transition(state, event_1, actorCtx);
            observers.forEach(function(observer) {
                return observer.next(state);
            });
        }
        flushing = false;
    };
    var actor = (0, $61142dedda67d7fc$export$ccadea5f6b9e9b4e)({
        id: options.id,
        send: function(event) {
            mailbox.push(event);
            flush();
        },
        getSnapshot: function() {
            return state;
        },
        subscribe: function(next, handleError, complete) {
            var observer = (0, $620580f2e39be27d$export$75b67481063f2f98)(next, handleError, complete);
            observers.add(observer);
            observer.next(state);
            return {
                unsubscribe: function() {
                    observers.delete(observer);
                }
            };
        }
    });
    var actorCtx = {
        parent: options.parent,
        self: actor,
        id: options.id || 'anonymous',
        observers: observers
    };
    state = behavior.start ? behavior.start(actorCtx) : state;
    return actor;
}


var $d85a79a5044f63e6$var$DEFAULT_SPAWN_OPTIONS = {
    sync: false,
    autoForward: false
};
var $d85a79a5044f63e6$export$7a567c9c5088a551;
(function(InterpreterStatus) {
    InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
    InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
    InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})($d85a79a5044f63e6$export$7a567c9c5088a551 || ($d85a79a5044f63e6$export$7a567c9c5088a551 = {}));
var $d85a79a5044f63e6$export$e5b52c46a548ff03 = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */ function Interpreter(machine, options) {
        if (options === void 0) options = Interpreter.defaultOptions;
        var _this = this;
        this.machine = machine;
        this.delayedEventsMap = {};
        this.listeners = new Set();
        this.contextListeners = new Set();
        this.stopListeners = new Set();
        this.doneListeners = new Set();
        this.eventListeners = new Set();
        this.sendListeners = new Set();
        /**
     * Whether the service is started.
     */ this.initialized = false;
        this.status = $d85a79a5044f63e6$export$7a567c9c5088a551.NotStarted;
        this.children = new Map();
        this.forwardTo = new Set();
        this._outgoingQueue = [];
        /**
     * Alias for Interpreter.prototype.start
     */ this.init = this.start;
        /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */ this.send = function(event1, payload) {
            if ((0, $620580f2e39be27d$export$43bee75e5e14138e)(event1)) {
                _this.batch(event1);
                return _this.state;
            }
            var _event = (0, $620580f2e39be27d$export$eaf22249b410f633)((0, $620580f2e39be27d$export$5a4ea50826a01d14)(event1, payload));
            if (_this.status === $d85a79a5044f63e6$export$7a567c9c5088a551.Stopped) {
                // do nothing
                if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(false, "Event \"".concat(_event.name, "\" was sent to stopped service \"").concat(_this.machine.id, "\". This service has already reached its final state, and will not transition.\nEvent: ").concat(JSON.stringify(_event.data)));
                return _this.state;
            }
            if (_this.status !== $d85a79a5044f63e6$export$7a567c9c5088a551.Running && !_this.options.deferEvents) throw new Error("Event \"".concat(_event.name, "\" was sent to uninitialized service \"").concat(_this.machine.id // tslint:disable-next-line:max-line-length
            , "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ").concat(JSON.stringify(_event.data)));
            _this.scheduler.schedule(function() {
                // Forward copy of event to child actors
                _this.forward(_event);
                var nextState = _this._nextState(_event);
                _this.update(nextState, _event);
            });
            return _this._state; // TODO: deprecate (should return void)
        // tslint:disable-next-line:semicolon
        };
        this.sendTo = function(event1, to, immediate) {
            var isParent = _this.parent && (to === (0, $48a17dffa424dcd9$export$79f5baa747fbdd45).Parent || _this.parent.id === to);
            var target = isParent ? _this.parent : (0, $620580f2e39be27d$export$844ec244b1367d54)(to) ? to === (0, $48a17dffa424dcd9$export$79f5baa747fbdd45).Internal ? _this : _this.children.get(to) || (0, $3e40894effda66d6$export$4bb7493d241fd8a5).get(to) : (0, $620580f2e39be27d$export$e769f6913f14f1b7)(to) ? to : undefined;
            if (!target) {
                if (!isParent) throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
                 // tslint:disable-next-line:no-console
                if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event1.type));
                return;
            }
            if ('machine' in target) // perhaps those events should be rejected in the parent
            // but atm it doesn't have easy access to all of the information that is required to do it reliably
            {
                if (_this.status !== $d85a79a5044f63e6$export$7a567c9c5088a551.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
                _this.state.done) {
                    // Send SCXML events to machines
                    var scxmlEvent = (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, event1), {
                        name: event1.name === (0, $b9f819ed84df55d9$export$a3bc9b8ed74fc) ? "".concat((0, $673da5a8478f7656$export$a3bc9b8ed74fc)(_this.id)) : event1.name,
                        origin: _this.sessionId
                    });
                    if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                        target,
                        scxmlEvent
                    ]);
                    else target.send(scxmlEvent);
                }
            } else // Send normal events to other targets
            if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                target,
                event1.data
            ]);
            else target.send(event1.data);
        };
        this._exec = function(action, context, _event, actionFunctionMap) {
            if (actionFunctionMap === void 0) actionFunctionMap = _this.machine.options.actions;
            var actionOrExec = action.exec || (0, $673da5a8478f7656$export$c7e5ca927bd4567)(action.type, actionFunctionMap);
            var exec = (0, $620580f2e39be27d$export$f6e2535fb5126e54)(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;
            if (exec) try {
                return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
                    action: action,
                    state: _this.state,
                    _event: _event
                } : {
                    action: action,
                    _event: _event
                });
            } catch (err) {
                if (_this.parent) _this.parent.send({
                    type: 'xstate.error',
                    data: err
                });
                throw err;
            }
            switch(action.type){
                case 0, $b9f819ed84df55d9$export$66313c302b2ea154:
                    // if raise action reached the interpreter then it's a delayed one
                    var sendAction_1 = action;
                    _this.defer(sendAction_1);
                    break;
                case 0, $b9f819ed84df55d9$export$89db4734f6c919c4:
                    var sendAction = action;
                    if (typeof sendAction.delay === 'number') {
                        _this.defer(sendAction);
                        return;
                    } else if (sendAction.to) _this.sendTo(sendAction._event, sendAction.to, _event === (0, $673da5a8478f7656$export$163c566c60ed2ec9));
                    else _this.send(sendAction._event);
                    break;
                case 0, $b9f819ed84df55d9$export$70b61ad426ddbe54:
                    _this.cancel(action.sendId);
                    break;
                case 0, $b9f819ed84df55d9$export$b3571188c770cc5a:
                    if (_this.status !== $d85a79a5044f63e6$export$7a567c9c5088a551.Running) return;
                    var activity = action.activity; // If the activity will be stopped right after it's started
                    // (such as in transient states)
                    // don't bother starting the activity.
                    if (!_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) break;
                     // Invoked services
                    if (activity.type === (0, $48a17dffa424dcd9$export$1385d81a6c6bbcd4).Invoke) {
                        var invokeSource = (0, $620580f2e39be27d$export$436e852aa2feda95)(activity.src);
                        var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : undefined;
                        var id = activity.id, data = activity.data;
                        if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(!('forward' in activity), "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead.");
                        var autoForward = 'autoForward' in activity ? activity.autoForward : !!activity.forward;
                        if (!serviceCreator) {
                            // tslint:disable-next-line:no-console
                            if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
                            return;
                        }
                        var resolvedData = data ? (0, $620580f2e39be27d$export$e756e60189cc2351)(data, context, _event) : undefined;
                        if (typeof serviceCreator === 'string') // TODO: warn
                        return;
                        var source = (0, $620580f2e39be27d$export$f6e2535fb5126e54)(serviceCreator) ? serviceCreator(context, _event.data, {
                            data: resolvedData,
                            src: invokeSource,
                            meta: activity.meta
                        }) : serviceCreator;
                        if (!source) // TODO: warn?
                        return;
                        var options = void 0;
                        if ((0, $620580f2e39be27d$export$2163e7903738b5df)(source)) {
                            source = resolvedData ? source.withContext(resolvedData) : source;
                            options = {
                                autoForward: autoForward
                            };
                        }
                        _this.spawn(source, id, options);
                    } else _this.spawnActivity(activity);
                    break;
                case 0, $b9f819ed84df55d9$export$fa6813432f753b0d:
                    _this.stopChild(action.activity.id);
                    break;
                case 0, $b9f819ed84df55d9$export$bef1f36f5486a6a3:
                    var _a = action, label = _a.label, value = _a.value;
                    if (label) _this.logger(label, value);
                    else _this.logger(value);
                    break;
                default:
                    if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(false, "No implementation found for action type '".concat(action.type, "'"));
                    break;
            }
        };
        var resolvedOptions = (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, Interpreter.defaultOptions), options);
        var clock = resolvedOptions.clock, logger = resolvedOptions.logger, parent = resolvedOptions.parent, id = resolvedOptions.id;
        var resolvedId = id !== undefined ? id : machine.id;
        this.id = resolvedId;
        this.logger = logger;
        this.clock = clock;
        this.parent = parent;
        this.options = resolvedOptions;
        this.scheduler = new (0, $7a6b4bfbe5460c94$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
        this.sessionId = (0, $3e40894effda66d6$export$4bb7493d241fd8a5).bookId();
    }
    Object.defineProperty(Interpreter.prototype, "initialState", {
        get: function() {
            var _this = this;
            if (this._initialState) return this._initialState;
            return (0, $bc878c7a3cc754f3$export$abe1e183e22e10ad)(this, function() {
                _this._initialState = _this.machine.initialState;
                return _this._initialState;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interpreter.prototype, "state", {
        /**
     * @deprecated Use `.getSnapshot()` instead.
     */ get: function() {
            if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(this.status !== $d85a79a5044f63e6$export$7a567c9c5088a551.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */ Interpreter.prototype.execute = function(state, actionsConfig) {
        var e_1, _a;
        try {
            for(var _b = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(state.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                this.exec(action, state, actionsConfig);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Interpreter.prototype.update = function(state, _event) {
        var e_2, _a, e_3, _b, e_4, _c, e_5, _d;
        var _this = this; // Attach session ID to state
        state._sessionid = this.sessionId; // Update state
        this._state = state; // Execute actions
        if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
        // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
        _event === (0, $673da5a8478f7656$export$163c566c60ed2ec9)) && this.options.execute) this.execute(this.state);
        else {
            var item = void 0;
            while(item = this._outgoingQueue.shift())item[0].send(item[1]);
        } // Update children
        this.children.forEach(function(child) {
            _this.state.children[child.id] = child;
        }); // Dev tools
        if (this.devTools) this.devTools.send(_event.data, state);
         // Execute listeners
        if (state.event) try {
            for(var _e = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()){
                var listener = _f.value;
                listener(state.event);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        try {
            for(var _g = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()){
                var listener = _h.value;
                listener(state, state.event);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        try {
            for(var _j = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()){
                var contextListener = _k.value;
                contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        if (this.state.done) {
            // get final child state node
            var finalChildStateNode = state.configuration.find(function(sn) {
                return sn.type === 'final' && sn.parent === _this.machine;
            });
            var doneData = finalChildStateNode && finalChildStateNode.doneData ? (0, $620580f2e39be27d$export$e756e60189cc2351)(finalChildStateNode.doneData, state.context, _event) : undefined;
            this._doneEvent = (0, $673da5a8478f7656$export$c105e588793f70b4)(this.id, doneData);
            try {
                for(var _l = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()){
                    var listener = _m.value;
                    listener(this._doneEvent);
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            this._stop();
            this._stopChildren();
            (0, $3e40894effda66d6$export$4bb7493d241fd8a5).free(this.sessionId);
        }
    };
    /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */ Interpreter.prototype.onTransition = function(listener) {
        this.listeners.add(listener); // Send current state to listener
        if (this.status === $d85a79a5044f63e6$export$7a567c9c5088a551.Running) listener(this.state, this.state.event);
        return this;
    };
    Interpreter.prototype.subscribe = function(nextListenerOrObserver, _, completeListener) {
        var _this = this;
        var observer = (0, $620580f2e39be27d$export$75b67481063f2f98)(nextListenerOrObserver, _, completeListener);
        this.listeners.add(observer.next); // Send current state to listener
        if (this.status !== $d85a79a5044f63e6$export$7a567c9c5088a551.NotStarted) observer.next(this.state);
        var completeOnce = function() {
            _this.doneListeners.delete(completeOnce);
            _this.stopListeners.delete(completeOnce);
            observer.complete();
        };
        if (this.status === $d85a79a5044f63e6$export$7a567c9c5088a551.Stopped) observer.complete();
        else {
            this.onDone(completeOnce);
            this.onStop(completeOnce);
        }
        return {
            unsubscribe: function() {
                _this.listeners.delete(observer.next);
                _this.doneListeners.delete(completeOnce);
                _this.stopListeners.delete(completeOnce);
            }
        };
    };
    /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */ Interpreter.prototype.onEvent = function(listener) {
        this.eventListeners.add(listener);
        return this;
    };
    /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */ Interpreter.prototype.onSend = function(listener) {
        this.sendListeners.add(listener);
        return this;
    };
    /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */ Interpreter.prototype.onChange = function(listener) {
        this.contextListeners.add(listener);
        return this;
    };
    /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */ Interpreter.prototype.onStop = function(listener) {
        this.stopListeners.add(listener);
        return this;
    };
    /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */ Interpreter.prototype.onDone = function(listener) {
        if (this.status === $d85a79a5044f63e6$export$7a567c9c5088a551.Stopped && this._doneEvent) listener(this._doneEvent);
        else this.doneListeners.add(listener);
        return this;
    };
    /**
   * Removes a listener.
   * @param listener The listener to remove
   */ Interpreter.prototype.off = function(listener) {
        this.listeners.delete(listener);
        this.eventListeners.delete(listener);
        this.sendListeners.delete(listener);
        this.stopListeners.delete(listener);
        this.doneListeners.delete(listener);
        this.contextListeners.delete(listener);
        return this;
    };
    /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */ Interpreter.prototype.start = function(initialState) {
        var _this = this;
        if (this.status === $d85a79a5044f63e6$export$7a567c9c5088a551.Running) // Do not restart the service if it is already started
        return this;
         // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
        // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
        // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
        // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)
        this.machine._init();
        (0, $3e40894effda66d6$export$4bb7493d241fd8a5).register(this.sessionId, this);
        this.initialized = true;
        this.status = $d85a79a5044f63e6$export$7a567c9c5088a551.Running;
        var resolvedState = initialState === undefined ? this.initialState : (0, $bc878c7a3cc754f3$export$abe1e183e22e10ad)(this, function() {
            return (0, $480eade3b32f6a45$export$4c86eb6450eda77a)(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState((0, $480eade3b32f6a45$export$7254cc27399e90bd).from(initialState, _this.machine.context));
        });
        if (this.options.devTools) this.attachDev();
        this.scheduler.initialize(function() {
            _this.update(resolvedState, (0, $673da5a8478f7656$export$163c566c60ed2ec9));
        });
        return this;
    };
    Interpreter.prototype._stopChildren = function() {
        // TODO: think about converting those to actions
        this.children.forEach(function(child) {
            if ((0, $620580f2e39be27d$export$f6e2535fb5126e54)(child.stop)) child.stop();
        });
        this.children.clear();
    };
    Interpreter.prototype._stop = function() {
        var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
        try {
            for(var _f = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()){
                var listener = _g.value;
                this.listeners.delete(listener);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        try {
            for(var _h = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()){
                var listener = _j.value; // call listener, then remove
                listener();
                this.stopListeners.delete(listener);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        try {
            for(var _k = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()){
                var listener = _l.value;
                this.contextListeners.delete(listener);
            }
        } catch (e_8_1) {
            e_8 = {
                error: e_8_1
            };
        } finally{
            try {
                if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
            } finally{
                if (e_8) throw e_8.error;
            }
        }
        try {
            for(var _m = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()){
                var listener = _o.value;
                this.doneListeners.delete(listener);
            }
        } catch (e_9_1) {
            e_9 = {
                error: e_9_1
            };
        } finally{
            try {
                if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
            } finally{
                if (e_9) throw e_9.error;
            }
        }
        if (!this.initialized) // Interpreter already stopped; do nothing
        return this;
        this.initialized = false;
        this.status = $d85a79a5044f63e6$export$7a567c9c5088a551.Stopped;
        this._initialState = undefined;
        try {
            // we are going to stop within the current sync frame
            // so we can safely just cancel this here as nothing async should be fired anyway
            for(var _p = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()){
                var key = _q.value;
                this.clock.clearTimeout(this.delayedEventsMap[key]);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
            } finally{
                if (e_10) throw e_10.error;
            }
        } // clear everything that might be enqueued
        this.scheduler.clear();
        this.scheduler = new (0, $7a6b4bfbe5460c94$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
    };
    /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */ Interpreter.prototype.stop = function() {
        // TODO: add warning for stopping non-root interpreters
        var _this = this; // grab the current scheduler as it will be replaced in _stop
        var scheduler = this.scheduler;
        this._stop(); // let what is currently processed to be finished
        scheduler.schedule(function() {
            var _a;
            if ((_a = _this._state) === null || _a === void 0 ? void 0 : _a.done) return;
             // it feels weird to handle this here but we need to handle this even slightly "out of band"
            var _event = (0, $620580f2e39be27d$export$eaf22249b410f633)({
                type: 'xstate.stop'
            });
            var nextState = (0, $bc878c7a3cc754f3$export$abe1e183e22e10ad)(_this, function() {
                var exitActions = (0, $620580f2e39be27d$export$bffa455ba8c619a6)((0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(_this.state.configuration), false).sort(function(a, b) {
                    return b.order - a.order;
                }).map(function(stateNode) {
                    return (0, $673da5a8478f7656$export$aa68691f32e6c459)(stateNode.onExit, _this.machine.options.actions);
                }));
                var _a = (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)((0, $673da5a8478f7656$export$b8b9e7ba5b8c7b3e)(_this.machine, _this.state, _this.state.context, _event, [
                    {
                        type: 'exit',
                        actions: exitActions
                    }
                ], _this.machine.config.predictableActionArguments ? _this._exec : undefined, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2), resolvedActions = _a[0], updatedContext = _a[1];
                var newState = new (0, $480eade3b32f6a45$export$7254cc27399e90bd)({
                    value: _this.state.value,
                    context: updatedContext,
                    _event: _event,
                    _sessionid: _this.sessionId,
                    historyValue: undefined,
                    history: _this.state,
                    actions: resolvedActions.filter(function(action) {
                        return !(0, $620580f2e39be27d$export$37dc2eda56cb25a5)(action);
                    }),
                    activities: {},
                    events: [],
                    configuration: [],
                    transitions: [],
                    children: {},
                    done: _this.state.done,
                    tags: _this.state.tags,
                    machine: _this.machine
                });
                newState.changed = true;
                return newState;
            });
            _this.update(nextState, _event);
            _this._stopChildren();
            (0, $3e40894effda66d6$export$4bb7493d241fd8a5).free(_this.sessionId);
        });
        return this;
    };
    Interpreter.prototype.batch = function(events) {
        var _this = this;
        if (this.status === $d85a79a5044f63e6$export$7a567c9c5088a551.NotStarted && this.options.deferEvents) // tslint:disable-next-line:no-console
        {
            if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(false, "".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\" and are deferred. Make sure .start() is called for this service.\nEvent: ").concat(JSON.stringify(event)));
        } else if (this.status !== $d85a79a5044f63e6$export$7a567c9c5088a551.Running) throw new Error("".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options."));
        if (!events.length) return;
        var exec = !!this.machine.config.predictableActionArguments && this._exec;
        this.scheduler.schedule(function() {
            var e_11, _a;
            var nextState = _this.state;
            var batchChanged = false;
            var batchedActions = [];
            var _loop_1 = function(event_1) {
                var _event = (0, $620580f2e39be27d$export$eaf22249b410f633)(event_1);
                _this.forward(_event);
                nextState = (0, $bc878c7a3cc754f3$export$abe1e183e22e10ad)(_this, function() {
                    return _this.machine.transition(nextState, _event, undefined, exec || undefined);
                });
                batchedActions.push.apply(batchedActions, (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function(a) {
                    return (0, $480eade3b32f6a45$export$e42513ad58964418)(a, nextState);
                })), false));
                batchChanged = batchChanged || !!nextState.changed;
            };
            try {
                for(var events_1 = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()){
                    var event_1 = events_1_1.value;
                    _loop_1(event_1);
                }
            } catch (e_11_1) {
                e_11 = {
                    error: e_11_1
                };
            } finally{
                try {
                    if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                } finally{
                    if (e_11) throw e_11.error;
                }
            }
            nextState.changed = batchChanged;
            nextState.actions = batchedActions;
            _this.update(nextState, (0, $620580f2e39be27d$export$eaf22249b410f633)(events[events.length - 1]));
        });
    };
    /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */ Interpreter.prototype.sender = function(event1) {
        return this.send.bind(this, event1);
    };
    Interpreter.prototype._nextState = function(event1, exec) {
        var _this = this;
        if (exec === void 0) exec = !!this.machine.config.predictableActionArguments && this._exec;
        var _event = (0, $620580f2e39be27d$export$eaf22249b410f633)(event1);
        if (_event.name.indexOf((0, $b9f819ed84df55d9$export$503a23d0e5cd1226)) === 0 && !this.state.nextEvents.some(function(nextEvent) {
            return nextEvent.indexOf((0, $b9f819ed84df55d9$export$503a23d0e5cd1226)) === 0;
        })) throw _event.data.data;
        var nextState = (0, $bc878c7a3cc754f3$export$abe1e183e22e10ad)(this, function() {
            return _this.machine.transition(_this.state, _event, undefined, exec || undefined);
        });
        return nextState;
    };
    /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */ Interpreter.prototype.nextState = function(event1) {
        return this._nextState(event1, false);
    };
    Interpreter.prototype.forward = function(event1) {
        var e_12, _a;
        try {
            for(var _b = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()){
                var id = _c.value;
                var child = this.children.get(id);
                if (!child) throw new Error("Unable to forward event '".concat(event1, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
                child.send(event1);
            }
        } catch (e_12_1) {
            e_12 = {
                error: e_12_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_12) throw e_12.error;
            }
        }
    };
    Interpreter.prototype.defer = function(sendAction) {
        var _this = this;
        var timerId = this.clock.setTimeout(function() {
            if ('to' in sendAction && sendAction.to) _this.sendTo(sendAction._event, sendAction.to, true);
            else _this.send(sendAction._event);
        }, sendAction.delay);
        if (sendAction.id) this.delayedEventsMap[sendAction.id] = timerId;
    };
    Interpreter.prototype.cancel = function(sendId) {
        this.clock.clearTimeout(this.delayedEventsMap[sendId]);
        delete this.delayedEventsMap[sendId];
    };
    Interpreter.prototype.exec = function(action, state, actionFunctionMap) {
        if (actionFunctionMap === void 0) actionFunctionMap = this.machine.options.actions;
        this._exec(action, state.context, state._event, actionFunctionMap);
    };
    Interpreter.prototype.removeChild = function(childId) {
        var _a;
        this.children.delete(childId);
        this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
        // such as when a child is added then removed while initializing the state
        (_a = this.state) === null || _a === void 0 || delete _a.children[childId];
    };
    Interpreter.prototype.stopChild = function(childId) {
        var child = this.children.get(childId);
        if (!child) return;
        this.removeChild(childId);
        if ((0, $620580f2e39be27d$export$f6e2535fb5126e54)(child.stop)) child.stop();
    };
    Interpreter.prototype.spawn = function(entity, name, options) {
        if (this.status !== $d85a79a5044f63e6$export$7a567c9c5088a551.Running) return (0, $61142dedda67d7fc$export$59bcb51d8e40ed48)(entity, name);
        if ((0, $620580f2e39be27d$export$ae936b9d47e5870e)(entity)) return this.spawnPromise(Promise.resolve(entity), name);
        else if ((0, $620580f2e39be27d$export$f6e2535fb5126e54)(entity)) return this.spawnCallback(entity, name);
        else if ((0, $61142dedda67d7fc$export$b0f989039dc164f9)(entity)) return this.spawnActor(entity, name);
        else if ((0, $620580f2e39be27d$export$5cd057a6046189f9)(entity)) return this.spawnObservable(entity, name);
        else if ((0, $620580f2e39be27d$export$2163e7903738b5df)(entity)) return this.spawnMachine(entity, (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, options), {
            id: name
        }));
        else if ((0, $620580f2e39be27d$export$42749ebe1e7fdef7)(entity)) return this.spawnBehavior(entity, name);
        else throw new Error("Unable to spawn entity \"".concat(name, "\" of type \"").concat(typeof entity, "\"."));
    };
    Interpreter.prototype.spawnMachine = function(machine, options) {
        var _this = this;
        if (options === void 0) options = {};
        var childService = new Interpreter(machine, (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, this.options), {
            parent: this,
            id: options.id || machine.id
        }));
        var resolvedOptions = (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, $d85a79a5044f63e6$var$DEFAULT_SPAWN_OPTIONS), options);
        if (resolvedOptions.sync) childService.onTransition(function(state) {
            _this.send((0, $b9f819ed84df55d9$export$722fbec263ad908a), {
                state: state,
                id: childService.id
            });
        });
        var actor = childService;
        this.children.set(childService.id, actor);
        if (resolvedOptions.autoForward) this.forwardTo.add(childService.id);
        childService.onDone(function(doneEvent) {
            _this.removeChild(childService.id);
            _this.send((0, $620580f2e39be27d$export$eaf22249b410f633)(doneEvent, {
                origin: childService.id
            }));
        }).start();
        return actor;
    };
    Interpreter.prototype.spawnBehavior = function(behavior, id) {
        var actorRef = (0, $65bf4aaa446dfad7$export$cc3859917b3feaf8)(behavior, {
            id: id,
            parent: this
        });
        this.children.set(id, actorRef);
        return actorRef;
    };
    Interpreter.prototype.spawnPromise = function(promise, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var resolvedData;
        promise.then(function(response) {
            if (!canceled) {
                resolvedData = response;
                _this.removeChild(id);
                _this.send((0, $620580f2e39be27d$export$eaf22249b410f633)((0, $673da5a8478f7656$export$c105e588793f70b4)(id, response), {
                    origin: id
                }));
            }
        }, function(errorData) {
            if (!canceled) {
                _this.removeChild(id);
                var errorEvent = (0, $673da5a8478f7656$export$a3bc9b8ed74fc)(id, errorData);
                try {
                    // Send "error.platform.id" to this (parent).
                    _this.send((0, $620580f2e39be27d$export$eaf22249b410f633)(errorEvent, {
                        origin: id
                    }));
                } catch (error) {
                    (0, $620580f2e39be27d$export$b240b9b7a78b5f3e)(errorData, error, id);
                    if (_this.devTools) _this.devTools.send(errorEvent, _this.state);
                    if (_this.machine.strict) // it would be better to always stop the state machine if unhandled
                    // exception/promise rejection happens but because we don't want to
                    // break existing code so enforce it on strict mode only especially so
                    // because documentation says that onError is optional
                    _this.stop();
                }
            }
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                var observer = (0, $620580f2e39be27d$export$75b67481063f2f98)(next, handleError, complete);
                var unsubscribed = false;
                promise.then(function(response) {
                    if (unsubscribed) return;
                    observer.next(response);
                    if (unsubscribed) return;
                    observer.complete();
                }, function(err) {
                    if (unsubscribed) return;
                    observer.error(err);
                });
                return {
                    unsubscribe: function() {
                        return unsubscribed = true;
                    }
                };
            },
            stop: function() {
                canceled = true;
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return resolvedData;
            }
        }, _a[0, $620580f2e39be27d$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnCallback = function(callback, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var receivers = new Set();
        var listeners = new Set();
        var emitted;
        var receive = function(e) {
            emitted = e;
            listeners.forEach(function(listener) {
                return listener(e);
            });
            if (canceled) return;
            _this.send((0, $620580f2e39be27d$export$eaf22249b410f633)(e, {
                origin: id
            }));
        };
        var callbackStop;
        try {
            callbackStop = callback(receive, function(newListener) {
                receivers.add(newListener);
            });
        } catch (err) {
            this.send((0, $673da5a8478f7656$export$a3bc9b8ed74fc)(id, err));
        }
        if ((0, $620580f2e39be27d$export$ae936b9d47e5870e)(callbackStop)) // it turned out to be an async function, can't reliably check this before calling `callback`
        // because transpiled async functions are not recognizable
        return this.spawnPromise(callbackStop, id);
        var actor = (_a = {
            id: id,
            send: function(event1) {
                return receivers.forEach(function(receiver) {
                    return receiver(event1);
                });
            },
            subscribe: function(next) {
                var observer = (0, $620580f2e39be27d$export$75b67481063f2f98)(next);
                listeners.add(observer.next);
                return {
                    unsubscribe: function() {
                        listeners.delete(observer.next);
                    }
                };
            },
            stop: function() {
                canceled = true;
                if ((0, $620580f2e39be27d$export$f6e2535fb5126e54)(callbackStop)) callbackStop();
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return emitted;
            }
        }, _a[0, $620580f2e39be27d$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnObservable = function(source, id) {
        var _a;
        var _this = this;
        var emitted;
        var subscription = source.subscribe(function(value) {
            emitted = value;
            _this.send((0, $620580f2e39be27d$export$eaf22249b410f633)(value, {
                origin: id
            }));
        }, function(err) {
            _this.removeChild(id);
            _this.send((0, $620580f2e39be27d$export$eaf22249b410f633)((0, $673da5a8478f7656$export$a3bc9b8ed74fc)(id, err), {
                origin: id
            }));
        }, function() {
            _this.removeChild(id);
            _this.send((0, $620580f2e39be27d$export$eaf22249b410f633)((0, $673da5a8478f7656$export$c105e588793f70b4)(id), {
                origin: id
            }));
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                return source.subscribe(next, handleError, complete);
            },
            stop: function() {
                return subscription.unsubscribe();
            },
            getSnapshot: function() {
                return emitted;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $620580f2e39be27d$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnActor = function(actor, name) {
        this.children.set(name, actor);
        return actor;
    };
    Interpreter.prototype.spawnActivity = function(activity) {
        var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;
        if (!implementation) {
            if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(false, "No implementation found for activity '".concat(activity.type, "'"));
             // tslint:disable-next-line:no-console
            return;
        } // Start implementation
        var dispose = implementation(this.state.context, activity);
        this.spawnEffect(activity.id, dispose);
    };
    Interpreter.prototype.spawnEffect = function(id, dispose) {
        var _a;
        this.children.set(id, (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function() {
                return {
                    unsubscribe: function() {
                        return void 0;
                    }
                };
            },
            stop: dispose || undefined,
            getSnapshot: function() {
                return undefined;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $620580f2e39be27d$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a));
    };
    Interpreter.prototype.attachDev = function() {
        var global = (0, $4837de0392fa930f$export$a4e55266d2135a7f)();
        if (this.options.devTools && global) {
            if (global.__REDUX_DEVTOOLS_EXTENSION__) {
                var devToolsOptions = typeof this.options.devTools === 'object' ? this.options.devTools : undefined;
                this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({
                    name: this.id,
                    autoPause: true,
                    stateSanitizer: function(state) {
                        return {
                            value: state.value,
                            context: state.context,
                            actions: state.actions
                        };
                    }
                }, devToolsOptions), {
                    features: (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({
                        jump: false,
                        skip: false
                    }, devToolsOptions ? devToolsOptions.features : undefined)
                }), this.machine);
                this.devTools.init(this.state);
            } // add XState-specific dev tooling hook
            (0, $4837de0392fa930f$export$4d7a7d14704ebc13)(this);
        }
    };
    Interpreter.prototype.toJSON = function() {
        return {
            id: this.id
        };
    };
    Interpreter.prototype[0, $620580f2e39be27d$export$c45ebe72e3b2885] = function() {
        return this;
    };
    Interpreter.prototype.getSnapshot = function() {
        if (this.status === $d85a79a5044f63e6$export$7a567c9c5088a551.NotStarted) return this.initialState;
        return this._state;
    };
    /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */ Interpreter.defaultOptions = {
        execute: true,
        deferEvents: true,
        clock: {
            setTimeout: function(fn, ms) {
                return setTimeout(fn, ms);
            },
            clearTimeout: function(id) {
                return clearTimeout(id);
            }
        },
        logger: /*#__PURE__*/ console.log.bind(console),
        devTools: false
    };
    Interpreter.interpret = $d85a79a5044f63e6$export$67beed298888a38b;
    return Interpreter;
}();
var $d85a79a5044f63e6$var$resolveSpawnOptions = function(nameOrOptions) {
    if ((0, $620580f2e39be27d$export$844ec244b1367d54)(nameOrOptions)) return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, $d85a79a5044f63e6$var$DEFAULT_SPAWN_OPTIONS), {
        name: nameOrOptions
    });
    return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, $d85a79a5044f63e6$var$DEFAULT_SPAWN_OPTIONS), {
        name: (0, $620580f2e39be27d$export$8b15d37bc3f197d4)()
    }), nameOrOptions);
};
function $d85a79a5044f63e6$export$1713f5ac2bf0caf5(entity, nameOrOptions) {
    var resolvedOptions = $d85a79a5044f63e6$var$resolveSpawnOptions(nameOrOptions);
    return (0, $bc878c7a3cc754f3$export$e11e6a155c5c4d9d)(function(service) {
        if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) {
            var isLazyEntity = (0, $620580f2e39be27d$export$2163e7903738b5df)(entity) || (0, $620580f2e39be27d$export$f6e2535fb5126e54)(entity);
            (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(!!service || isLazyEntity, "Attempted to spawn an Actor (ID: \"".concat((0, $620580f2e39be27d$export$2163e7903738b5df)(entity) ? entity.id : 'undefined', "\") outside of a service. This will have no effect."));
        }
        if (service) return service.spawn(entity, resolvedOptions.name, resolvedOptions);
        else return (0, $61142dedda67d7fc$export$59bcb51d8e40ed48)(entity, resolvedOptions.name);
    });
}
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */ function $d85a79a5044f63e6$export$67beed298888a38b(machine, options) {
    var interpreter = new $d85a79a5044f63e6$export$e5b52c46a548ff03(machine, options);
    return interpreter;
}



var $6aRB8 = parcelRequire("6aRB8");
function $38bf2de1fea6698f$export$2e2bcd8739ae039(fn) {
    var ref = $6aRB8.useRef();
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
}


var $ee9601896ba21c96$var$__assign = undefined && undefined.__assign || function() {
    $ee9601896ba21c96$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ee9601896ba21c96$var$__assign.apply(this, arguments);
};
var $ee9601896ba21c96$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ee9601896ba21c96$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $ee9601896ba21c96$export$d09836c9e303db57(getMachine, options) {
    var machine = (0, $38bf2de1fea6698f$export$2e2bcd8739ae039)(function() {
        return typeof getMachine === 'function' ? getMachine() : getMachine;
    });
    var _a, initialMachine;
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = $ee9601896ba21c96$var$__rest(options, [
        "context",
        "guards",
        "actions",
        "activities",
        "services",
        "delays",
        "state"
    ]);
    var service = (0, $38bf2de1fea6698f$export$2e2bcd8739ae039)(function() {
        var machineConfig = {
            context: context,
            guards: guards,
            actions: actions,
            activities: activities,
            services: services,
            delays: delays
        };
        var machineWithConfig = machine.withConfig(machineConfig, function() {
            return $ee9601896ba21c96$var$__assign($ee9601896ba21c96$var$__assign({}, machine.context), context);
        });
        return (0, $d85a79a5044f63e6$export$67beed298888a38b)(machineWithConfig, interpreterOptions);
    });
    // Make sure options are kept updated when they change.
    // This mutation assignment is safe because the service instance is only used
    // in one place -- this hook's caller.
    (0, $d1ed4a9ded341161$export$2e2bcd8739ae039)(function() {
        Object.assign(service.machine.options.actions, actions);
        Object.assign(service.machine.options.guards, guards);
        Object.assign(service.machine.options.activities, activities);
        Object.assign(service.machine.options.services, services);
        Object.assign(service.machine.options.delays, delays);
    }, [
        actions,
        guards,
        activities,
        services,
        delays
    ]);
    return service;
}
function $ee9601896ba21c96$export$d9e9b060fbbae528(getMachine) {
    var _a = [];
    for(var _i = 1; _i < arguments.length; _i++)_a[_i - 1] = arguments[_i];
    var _b = $ee9601896ba21c96$var$__read(_a, 2), _c = _b[0], options = _c === void 0 ? {} : _c, observerOrListener = _b[1];
    var service = $ee9601896ba21c96$export$d09836c9e303db57(getMachine, options);
    (0, $6aRB8.useEffect)(function() {
        if (!observerOrListener) return;
        var sub = service.subscribe((0, $620580f2e39be27d$export$75b67481063f2f98)(observerOrListener));
        return function() {
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $6aRB8.useEffect)(function() {
        var rehydratedState = options.state;
        service.start(rehydratedState ? (0, $480eade3b32f6a45$export$7254cc27399e90bd).create(rehydratedState) : undefined);
        return function() {
            service.stop();
            service.status = (0, $d85a79a5044f63e6$export$7a567c9c5088a551).NotStarted;
        };
    }, []);
    return service;
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $acef69210e286daa$export$e5432d4c8eb97ea7 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const tokens = await amplify.Auth.getTokens({
        forceRefresh: false
    });
    (0, $6cdbc20a8ad3ee2e$export$77712ea5882cac9f)(tokens);
    const { 'cognito:username': username, sub: sub } = tokens.idToken?.payload ?? {};
    const authUser = {
        username: username,
        userId: sub
    };
    const signInDetails = $acef69210e286daa$var$getSignInDetailsFromTokens(tokens);
    if (signInDetails) authUser.signInDetails = signInDetails;
    return authUser;
};
function $acef69210e286daa$var$getSignInDetailsFromTokens(tokens) {
    return tokens?.signInDetails;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Gets the current user from the idToken.
 *
 * @param input -  The GetCurrentUserInput object.
 * @returns GetCurrentUserOutput
 * @throws - {@link InitiateAuthException} - Thrown when the service fails to refresh the tokens.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $52783992aa7f744e$export$e5432d4c8eb97ea7 = async ()=>{
    return (0, $acef69210e286daa$export$e5432d4c8eb97ea7)((0, $4e3539eda5094cb7$export$a3858a9a153cffc7));
};



















function $95515909817cd92d$export$436e852aa2feda95(src) {
    if (typeof src === 'string') {
        var simpleSrc = {
            type: src
        };
        simpleSrc.toString = function() {
            return src;
        }; // v4 compat - TODO: remove in v5
        return simpleSrc;
    }
    return src;
}
function $95515909817cd92d$export$4c73f685ba879446(invokeConfig) {
    return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({
        type: (0, $b9f819ed84df55d9$export$468cda29b159ee5d)
    }, invokeConfig), {
        toJSON: function() {
            invokeConfig.onDone;
            invokeConfig.onError;
            var invokeDef = (0, $1d68e7cbb4c6c146$export$3c9a16f847548506)(invokeConfig, [
                "onDone",
                "onError"
            ]);
            return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, invokeDef), {
                type: (0, $b9f819ed84df55d9$export$468cda29b159ee5d),
                src: $95515909817cd92d$export$436e852aa2feda95(invokeConfig.src)
            });
        }
    });
}


var $fb310f2624fa893f$var$NULL_EVENT = '';
var $fb310f2624fa893f$var$STATE_IDENTIFIER = '#';
var $fb310f2624fa893f$var$WILDCARD = '*';
var $fb310f2624fa893f$var$EMPTY_OBJECT = {};
var $fb310f2624fa893f$var$isStateId = function(str) {
    return str[0] === $fb310f2624fa893f$var$STATE_IDENTIFIER;
};
var $fb310f2624fa893f$var$createDefaultOptions = function() {
    return {
        actions: {},
        guards: {},
        services: {},
        activities: {},
        delays: {}
    };
};
var $fb310f2624fa893f$var$validateArrayifiedTransitions = function(stateNode, event, transitions) {
    var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function(transition) {
        return !('cond' in transition) && !('in' in transition) && ((0, $620580f2e39be27d$export$844ec244b1367d54)(transition.target) || (0, $620580f2e39be27d$export$2163e7903738b5df)(transition.target));
    });
    var eventText = event === $fb310f2624fa893f$var$NULL_EVENT ? 'the transient event' : "event '".concat(event, "'");
    (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};
var $fb310f2624fa893f$export$342f24f5edd47b1 = /*#__PURE__*/ /** @class */ function() {
    function StateNode(/**
   * The raw config used to create the machine.
   */ config, options, /**
   * The initial extended state
   */ _context, _stateInfo) {
        if (_context === void 0) _context = 'context' in config ? config.context : undefined;
        var _this = this;
        var _a;
        this.config = config;
        this._context = _context;
        /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */ this.order = -1;
        this.__xstatenode = true;
        this.__cache = {
            events: undefined,
            relativeValue: new Map(),
            initialStateValue: undefined,
            initialState: undefined,
            on: undefined,
            transitions: undefined,
            candidates: {},
            delayedTransitions: undefined
        };
        this.idMap = {};
        this.tags = [];
        this.options = Object.assign($fb310f2624fa893f$var$createDefaultOptions(), options);
        this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
        this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || '(machine)';
        this.machine = this.parent ? this.parent.machine : this;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : (0, $5d5891f130d5ede2$export$b060f3cec92ef5c9));
        this.id = this.config.id || (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([
            this.machine.key
        ], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(this.path), false).join(this.delimiter);
        this.version = this.parent ? this.parent.version : this.config.version;
        this.type = this.config.type || (this.config.parallel ? 'parallel' : this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
        this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
        this.description = this.config.description;
        if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(!('parallel' in this.config), "The \"parallel\" property is deprecated and will be removed in version 4.1. ".concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
        this.initial = this.config.initial;
        this.states = this.config.states ? (0, $620580f2e39be27d$export$825e789796ab7275)(this.config.states, function(stateConfig, key) {
            var _a;
            var stateNode = new StateNode(stateConfig, {}, undefined, {
                parent: _this,
                key: key
            });
            Object.assign(_this.idMap, (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
            return stateNode;
        }) : $fb310f2624fa893f$var$EMPTY_OBJECT; // Document order
        var order = 0;
        function dfs(stateNode) {
            var e_1, _a;
            stateNode.order = order++;
            try {
                for(var _b = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)((0, $cfb92dfa6e7dbf48$export$ad3d2e38d4deaf6d)(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var child = _c.value;
                    dfs(child);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        dfs(this); // History config
        this.history = this.config.history === true ? 'shallow' : this.config.history || false;
        this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a) {
            var event = _a.event;
            return event === $fb310f2624fa893f$var$NULL_EVENT;
        }) : $fb310f2624fa893f$var$NULL_EVENT in this.config.on);
        this.strict = !!this.config.strict; // TODO: deprecate (entry)
        this.onEntry = (0, $620580f2e39be27d$export$45b10814cc054894)(this.config.entry || this.config.onEntry).map(function(action) {
            return (0, $673da5a8478f7656$export$b38b66cc2da3ede7)(action);
        }); // TODO: deprecate (exit)
        this.onExit = (0, $620580f2e39be27d$export$45b10814cc054894)(this.config.exit || this.config.onExit).map(function(action) {
            return (0, $673da5a8478f7656$export$b38b66cc2da3ede7)(action);
        });
        this.meta = this.config.meta;
        this.doneData = this.type === 'final' ? this.config.data : undefined;
        this.invoke = (0, $620580f2e39be27d$export$45b10814cc054894)(this.config.invoke).map(function(invokeConfig, i) {
            var _a, _b;
            if ((0, $620580f2e39be27d$export$2163e7903738b5df)(invokeConfig)) {
                var invokeId = (0, $620580f2e39be27d$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
                return (0, $95515909817cd92d$export$4c73f685ba879446)({
                    src: invokeId,
                    id: invokeId
                });
            } else if ((0, $620580f2e39be27d$export$844ec244b1367d54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $620580f2e39be27d$export$107b54c5097f9157)(_this.id, i);
                return (0, $95515909817cd92d$export$4c73f685ba879446)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, invokeConfig), {
                    id: invokeId,
                    src: invokeConfig.src
                }));
            } else if ((0, $620580f2e39be27d$export$2163e7903738b5df)(invokeConfig.src) || (0, $620580f2e39be27d$export$f6e2535fb5126e54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $620580f2e39be27d$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
                return (0, $95515909817cd92d$export$4c73f685ba879446)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({
                    id: invokeId
                }, invokeConfig), {
                    src: invokeId
                }));
            } else {
                var invokeSource = invokeConfig.src;
                return (0, $95515909817cd92d$export$4c73f685ba879446)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({
                    id: (0, $620580f2e39be27d$export$107b54c5097f9157)(_this.id, i)
                }, invokeConfig), {
                    src: invokeSource
                }));
            }
        });
        this.activities = (0, $620580f2e39be27d$export$45b10814cc054894)(this.config.activities).concat(this.invoke).map(function(activity) {
            return (0, $673da5a8478f7656$export$e81fdd8937d44864)(activity);
        });
        this.transition = this.transition.bind(this);
        this.tags = (0, $620580f2e39be27d$export$45b10814cc054894)(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
    }
    StateNode.prototype._init = function() {
        if (this.__cache.transitions) return;
        (0, $cfb92dfa6e7dbf48$export$3de19bba299e3801)(this).forEach(function(stateNode) {
            return stateNode.on;
        });
    };
    /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */ StateNode.prototype.withConfig = function(options, context) {
        var _a = this.options, actions = _a.actions, activities = _a.activities, guards = _a.guards, services = _a.services, delays = _a.delays;
        return new StateNode(this.config, {
            actions: (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, actions), options.actions),
            activities: (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, activities), options.activities),
            guards: (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, guards), options.guards),
            services: (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, services), options.services),
            delays: (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, delays), options.delays)
        }, context !== null && context !== void 0 ? context : this.context);
    };
    /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */ StateNode.prototype.withContext = function(context) {
        return new StateNode(this.config, this.options, context);
    };
    Object.defineProperty(StateNode.prototype, "context", {
        get: function() {
            return (0, $620580f2e39be27d$export$f6e2535fb5126e54)(this._context) ? this._context() : this._context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "definition", {
        /**
     * The well-structured state node definition.
     */ get: function() {
            return {
                id: this.id,
                key: this.key,
                version: this.version,
                context: this.context,
                type: this.type,
                initial: this.initial,
                history: this.history,
                states: (0, $620580f2e39be27d$export$825e789796ab7275)(this.states, function(state) {
                    return state.definition;
                }),
                on: this.on,
                transitions: this.transitions,
                entry: this.onEntry,
                exit: this.onExit,
                activities: this.activities || [],
                meta: this.meta,
                order: this.order || -1,
                data: this.doneData,
                invoke: this.invoke,
                description: this.description,
                tags: this.tags
            };
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.toJSON = function() {
        return this.definition;
    };
    Object.defineProperty(StateNode.prototype, "on", {
        /**
     * The mapping of events to transitions.
     */ get: function() {
            if (this.__cache.on) return this.__cache.on;
            var transitions = this.transitions;
            return this.__cache.on = transitions.reduce(function(map, transition) {
                map[transition.eventType] = map[transition.eventType] || [];
                map[transition.eventType].push(transition);
                return map;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "after", {
        get: function() {
            return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "transitions", {
        /**
     * All the transitions that can be taken from this state node.
     */ get: function() {
            return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getCandidates = function(eventName) {
        if (this.__cache.candidates[eventName]) return this.__cache.candidates[eventName];
        var transient = eventName === $fb310f2624fa893f$var$NULL_EVENT;
        var candidates = this.transitions.filter(function(transition) {
            var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions
            return transient ? sameEventType : sameEventType || transition.eventType === $fb310f2624fa893f$var$WILDCARD;
        });
        this.__cache.candidates[eventName] = candidates;
        return candidates;
    };
    /**
   * All delayed transitions from the config.
   */ StateNode.prototype.getDelayedTransitions = function() {
        var _this = this;
        var afterConfig = this.config.after;
        if (!afterConfig) return [];
        var mutateEntryExit = function(delay, i) {
            var delayRef = (0, $620580f2e39be27d$export$f6e2535fb5126e54)(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
            var eventType = (0, $673da5a8478f7656$export$742acabee3dd6465)(delayRef, _this.id);
            _this.onEntry.push((0, $673da5a8478f7656$export$89db4734f6c919c4)(eventType, {
                delay: delay
            }));
            _this.onExit.push((0, $673da5a8478f7656$export$70b61ad426ddbe54)(eventType));
            return eventType;
        };
        var delayedTransitions = (0, $620580f2e39be27d$export$43bee75e5e14138e)(afterConfig) ? afterConfig.map(function(transition, i) {
            var eventType = mutateEntryExit(transition.delay, i);
            return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, transition), {
                event: eventType
            });
        }) : (0, $620580f2e39be27d$export$bffa455ba8c619a6)(Object.keys(afterConfig).map(function(delay, i) {
            var configTransition = afterConfig[delay];
            var resolvedTransition = (0, $620580f2e39be27d$export$844ec244b1367d54)(configTransition) ? {
                target: configTransition
            } : configTransition;
            var resolvedDelay = !isNaN(+delay) ? +delay : delay;
            var eventType = mutateEntryExit(resolvedDelay, i);
            return (0, $620580f2e39be27d$export$45b10814cc054894)(resolvedTransition).map(function(transition) {
                return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, transition), {
                    event: eventType,
                    delay: resolvedDelay
                });
            });
        }));
        return delayedTransitions.map(function(delayedTransition) {
            var delay = delayedTransition.delay;
            return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, _this.formatTransition(delayedTransition)), {
                delay: delay
            });
        });
    };
    /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */ StateNode.prototype.getStateNodes = function(state) {
        var _a;
        var _this = this;
        if (!state) return [];
        var stateValue = state instanceof (0, $480eade3b32f6a45$export$7254cc27399e90bd) ? state.value : (0, $620580f2e39be27d$export$fb3aecd1d93744e3)(state, this.delimiter);
        if ((0, $620580f2e39be27d$export$844ec244b1367d54)(stateValue)) {
            var initialStateValue = this.getStateNode(stateValue).initial;
            return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [
                this,
                this.states[stateValue]
            ];
        }
        var subStateKeys = Object.keys(stateValue);
        var subStateNodes = [
            this
        ];
        subStateNodes.push.apply(subStateNodes, (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)((0, $620580f2e39be27d$export$bffa455ba8c619a6)(subStateKeys.map(function(subStateKey) {
            return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
        }))), false));
        return subStateNodes;
    };
    /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */ StateNode.prototype.handles = function(event) {
        var eventType = (0, $620580f2e39be27d$export$7193fc8c8cd445e9)(event);
        return this.events.includes(eventType);
    };
    /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */ StateNode.prototype.resolveState = function(state) {
        var stateFromConfig = state instanceof (0, $480eade3b32f6a45$export$7254cc27399e90bd) ? state : (0, $480eade3b32f6a45$export$7254cc27399e90bd).create(state);
        var configuration = Array.from((0, $cfb92dfa6e7dbf48$export$3de01744a82b21a4)([], this.getStateNodes(stateFromConfig.value)));
        return new (0, $480eade3b32f6a45$export$7254cc27399e90bd)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, stateFromConfig), {
            value: this.resolve(stateFromConfig.value),
            configuration: configuration,
            done: (0, $cfb92dfa6e7dbf48$export$cf3d5dae927fcf63)(configuration, this),
            tags: (0, $cfb92dfa6e7dbf48$export$5301196121335ca0)(configuration),
            machine: this.machine
        }));
    };
    StateNode.prototype.transitionLeafNode = function(stateValue, state, _event) {
        var stateNode = this.getStateNode(stateValue);
        var next = stateNode.next(state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionCompoundNode = function(stateValue, state, _event) {
        var subStateKeys = Object.keys(stateValue);
        var stateNode = this.getStateNode(subStateKeys[0]);
        var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionParallelNode = function(stateValue, state, _event) {
        var e_2, _a;
        var transitionMap = {};
        try {
            for(var _b = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()){
                var subStateKey = _c.value;
                var subStateValue = stateValue[subStateKey];
                if (!subStateValue) continue;
                var subStateNode = this.getStateNode(subStateKey);
                var next = subStateNode._transition(subStateValue, state, _event);
                if (next) transitionMap[subStateKey] = next;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var stateTransitions = Object.keys(transitionMap).map(function(key) {
            return transitionMap[key];
        });
        var enabledTransitions = (0, $620580f2e39be27d$export$bffa455ba8c619a6)(stateTransitions.map(function(st) {
            return st.transitions;
        }));
        var willTransition = stateTransitions.some(function(st) {
            return st.transitions.length > 0;
        });
        if (!willTransition) return this.next(state, _event);
        var configuration = (0, $620580f2e39be27d$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
            return transitionMap[key].configuration;
        }));
        return {
            transitions: enabledTransitions,
            exitSet: (0, $620580f2e39be27d$export$bffa455ba8c619a6)(stateTransitions.map(function(t) {
                return t.exitSet;
            })),
            configuration: configuration,
            source: state,
            actions: (0, $620580f2e39be27d$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
                return transitionMap[key].actions;
            }))
        };
    };
    StateNode.prototype._transition = function(stateValue, state, _event) {
        // leaf node
        if ((0, $620580f2e39be27d$export$844ec244b1367d54)(stateValue)) return this.transitionLeafNode(stateValue, state, _event);
         // hierarchical node
        if (Object.keys(stateValue).length === 1) return this.transitionCompoundNode(stateValue, state, _event);
         // orthogonal node
        return this.transitionParallelNode(stateValue, state, _event);
    };
    StateNode.prototype.getTransitionData = function(state, event) {
        return this._transition(state.value, state, (0, $620580f2e39be27d$export$eaf22249b410f633)(event));
    };
    StateNode.prototype.next = function(state, _event) {
        var e_3, _a;
        var _this = this;
        var eventName = _event.name;
        var actions = [];
        var nextStateNodes = [];
        var selectedTransition;
        try {
            for(var _b = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()){
                var candidate = _c.value;
                var cond = candidate.cond, stateIn = candidate.in;
                var resolvedContext = state.context;
                var isInState = stateIn ? (0, $620580f2e39be27d$export$844ec244b1367d54)(stateIn) && $fb310f2624fa893f$var$isStateId(stateIn) ? state.matches((0, $620580f2e39be27d$export$fb3aecd1d93744e3)(this.getStateNodeById(stateIn).path, this.delimiter)) : (0, $620580f2e39be27d$export$2870710bf0eac88e)((0, $620580f2e39be27d$export$fb3aecd1d93744e3)(stateIn, this.delimiter), (0, $620580f2e39be27d$export$bb654e07daaf8c3a)(this.path.slice(0, -2))(state.value)) : true;
                var guardPassed = false;
                try {
                    guardPassed = !cond || (0, $620580f2e39be27d$export$91646ab912d254e8)(this.machine, cond, resolvedContext, _event, state);
                } catch (err) {
                    throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
                }
                if (guardPassed && isInState) {
                    if (candidate.target !== undefined) nextStateNodes = candidate.target;
                    actions.push.apply(actions, (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(candidate.actions), false));
                    selectedTransition = candidate;
                    break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (!selectedTransition) return undefined;
        if (!nextStateNodes.length) return {
            transitions: [
                selectedTransition
            ],
            exitSet: [],
            configuration: state.value ? [
                this
            ] : [],
            source: state,
            actions: actions
        };
        var allNextStateNodes = (0, $620580f2e39be27d$export$bffa455ba8c619a6)(nextStateNodes.map(function(stateNode) {
            return _this.getRelativeStateNodes(stateNode, state.historyValue);
        }));
        var isInternal = !!selectedTransition.internal;
        return {
            transitions: [
                selectedTransition
            ],
            exitSet: isInternal ? [] : (0, $620580f2e39be27d$export$bffa455ba8c619a6)(nextStateNodes.map(function(targetNode) {
                return _this.getPotentiallyReenteringNodes(targetNode);
            })),
            configuration: allNextStateNodes,
            source: state,
            actions: actions
        };
    }; // even though the name of this function mentions reentry nodes
    // we are pushing its result into `exitSet`
    // that's because what we exit might be reentered (it's an invariant of reentrancy)
    StateNode.prototype.getPotentiallyReenteringNodes = function(targetNode) {
        if (this.order < targetNode.order) return [
            this
        ];
        var nodes = [];
        var marker = this;
        var possibleAncestor = targetNode;
        while(marker && marker !== possibleAncestor){
            nodes.push(marker);
            marker = marker.parent;
        }
        if (marker !== possibleAncestor) // we never got to `possibleAncestor`, therefore the initial `marker` "escapes" it
        // it's in a different part of the tree so no states will be reentered for such an external transition
        return [];
        nodes.push(possibleAncestor);
        return nodes;
    };
    StateNode.prototype.getActions = function(resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
        var e_4, _a, e_5, _b;
        var _this = this;
        var prevConfig = prevState ? (0, $cfb92dfa6e7dbf48$export$3de01744a82b21a4)([], this.getStateNodes(prevState.value)) : [];
        var entrySet = new Set();
        try {
            for(var _c = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(Array.from(resolvedConfig).sort(function(a, b) {
                return a.order - b.order;
            })), _d = _c.next(); !_d.done; _d = _c.next()){
                var sn = _d.value;
                if (!(0, $cfb92dfa6e7dbf48$export$a4f4bb6b1453fff5)(prevConfig, sn) || (0, $cfb92dfa6e7dbf48$export$a4f4bb6b1453fff5)(transition.exitSet, sn) || sn.parent && entrySet.has(sn.parent)) entrySet.add(sn);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        try {
            for(var prevConfig_1 = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()){
                var sn = prevConfig_1_1.value;
                if (!(0, $cfb92dfa6e7dbf48$export$a4f4bb6b1453fff5)(resolvedConfig, sn) || (0, $cfb92dfa6e7dbf48$export$a4f4bb6b1453fff5)(transition.exitSet, sn.parent)) transition.exitSet.push(sn);
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        transition.exitSet.sort(function(a, b) {
            return b.order - a.order;
        });
        var entryStates = Array.from(entrySet).sort(function(a, b) {
            return a.order - b.order;
        });
        var exitStates = new Set(transition.exitSet);
        var doneEvents = (0, $620580f2e39be27d$export$bffa455ba8c619a6)(entryStates.map(function(sn) {
            var events = [];
            if (sn.type !== 'final') return events;
            var parent = sn.parent;
            if (!parent.parent) return events;
            events.push((0, $673da5a8478f7656$export$3df11c9c20e7b288)(sn.id, sn.doneData), (0, $673da5a8478f7656$export$3df11c9c20e7b288)(parent.id, sn.doneData ? (0, $620580f2e39be27d$export$e756e60189cc2351)(sn.doneData, currentContext, _event) : undefined));
            var grandparent = parent.parent;
            if (grandparent.type === 'parallel') {
                if ((0, $cfb92dfa6e7dbf48$export$f8cf48ee793b41be)(grandparent).every(function(parentNode) {
                    return (0, $cfb92dfa6e7dbf48$export$cf3d5dae927fcf63)(transition.configuration, parentNode);
                })) events.push((0, $673da5a8478f7656$export$3df11c9c20e7b288)(grandparent.id));
            }
            return events;
        }));
        var entryActions = entryStates.map(function(stateNode) {
            var entryActions = stateNode.onEntry;
            var invokeActions = stateNode.activities.map(function(activity) {
                return (0, $673da5a8478f7656$export$b3571188c770cc5a)(activity);
            });
            return {
                type: 'entry',
                actions: (0, $673da5a8478f7656$export$aa68691f32e6c459)(predictableExec ? (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)((0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(entryActions), false), (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(invokeActions), false) : (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)((0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(invokeActions), false), (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(entryActions), false), _this.machine.options.actions)
            };
        }).concat({
            type: 'state_done',
            actions: doneEvents.map(function(event) {
                return (0, $673da5a8478f7656$export$66313c302b2ea154)(event);
            })
        });
        var exitActions = Array.from(exitStates).map(function(stateNode) {
            return {
                type: 'exit',
                actions: (0, $673da5a8478f7656$export$aa68691f32e6c459)((0, $1d68e7cbb4c6c146$export$1216008129fb82ed)((0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(stateNode.onExit), false), (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(stateNode.activities.map(function(activity) {
                    return (0, $673da5a8478f7656$export$fa6813432f753b0d)(activity);
                })), false), _this.machine.options.actions)
            };
        });
        var actions = exitActions.concat({
            type: 'transition',
            actions: (0, $673da5a8478f7656$export$aa68691f32e6c459)(transition.actions, this.machine.options.actions)
        }).concat(entryActions);
        if (isDone) {
            var stopActions = (0, $673da5a8478f7656$export$aa68691f32e6c459)((0, $620580f2e39be27d$export$bffa455ba8c619a6)((0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(resolvedConfig), false).sort(function(a, b) {
                return b.order - a.order;
            }).map(function(stateNode) {
                return stateNode.onExit;
            })), this.machine.options.actions).filter(function(action) {
                return !(0, $620580f2e39be27d$export$37dc2eda56cb25a5)(action);
            });
            return actions.concat({
                type: 'stop',
                actions: stopActions
            });
        }
        return actions;
    };
    /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */ StateNode.prototype.transition = function(state, event, context, exec) {
        if (state === void 0) state = this.initialState;
        var _event = (0, $620580f2e39be27d$export$eaf22249b410f633)(event);
        var currentState;
        if (state instanceof (0, $480eade3b32f6a45$export$7254cc27399e90bd)) currentState = context === undefined ? state : this.resolveState((0, $480eade3b32f6a45$export$7254cc27399e90bd).from(state, context));
        else {
            var resolvedStateValue = (0, $620580f2e39be27d$export$844ec244b1367d54)(state) ? this.resolve((0, $620580f2e39be27d$export$f2ee84fc53c45e74)(this.getResolvedPath(state))) : this.resolve(state);
            var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
            currentState = this.resolveState((0, $480eade3b32f6a45$export$7254cc27399e90bd).from(resolvedStateValue, resolvedContext));
        }
        if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571) && _event.name === $fb310f2624fa893f$var$WILDCARD) throw new Error("An event cannot have the wildcard type ('".concat($fb310f2624fa893f$var$WILDCARD, "')"));
        if (this.strict) {
            if (!this.events.includes(_event.name) && !(0, $620580f2e39be27d$export$479b1b8942fd0b8d)(_event.name)) throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
        }
        var stateTransition = this._transition(currentState.value, currentState, _event) || {
            transitions: [],
            configuration: [],
            exitSet: [],
            source: currentState,
            actions: []
        };
        var prevConfig = (0, $cfb92dfa6e7dbf48$export$3de01744a82b21a4)([], this.getStateNodes(currentState.value));
        var resolvedConfig = stateTransition.configuration.length ? (0, $cfb92dfa6e7dbf48$export$3de01744a82b21a4)(prevConfig, stateTransition.configuration) : prevConfig;
        stateTransition.configuration = (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(resolvedConfig), false);
        return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
    };
    StateNode.prototype.resolveRaisedTransition = function(state, _event, originalEvent, predictableExec) {
        var _a;
        var currentActions = state.actions;
        state = this.transition(state, _event, undefined, predictableExec); // Save original event to state
        // TODO: this should be the raised event! Delete in V5 (breaking)
        state._event = originalEvent;
        state.event = originalEvent.data;
        (_a = state.actions).unshift.apply(_a, (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(currentActions), false));
        return state;
    };
    StateNode.prototype.resolveTransition = function(stateTransition, currentState, context, predictableExec, _event) {
        var e_6, _a, e_7, _b;
        var _this = this;
        if (_event === void 0) _event = (0, $673da5a8478f7656$export$163c566c60ed2ec9);
        var configuration = stateTransition.configuration; // Transition will "apply" if:
        // - this is the initial state (there is no current state)
        // - OR there are transitions
        var willTransition = !currentState || stateTransition.transitions.length > 0;
        var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
        var isDone = (0, $cfb92dfa6e7dbf48$export$cf3d5dae927fcf63)(resolvedConfiguration, this);
        var resolvedStateValue = willTransition ? (0, $cfb92dfa6e7dbf48$export$bf7199a9ebcb84a9)(this.machine, configuration) : undefined;
        var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
        var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
        var activities = currentState ? (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, currentState.activities) : {};
        try {
            for(var actionBlocks_1 = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
                var block = actionBlocks_1_1.value;
                try {
                    for(var _c = (e_7 = void 0, (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(block.actions)), _d = _c.next(); !_d.done; _d = _c.next()){
                        var action = _d.value;
                        if (action.type === (0, $b9f819ed84df55d9$export$b3571188c770cc5a)) activities[action.activity.id || action.activity.type] = action;
                        else if (action.type === (0, $b9f819ed84df55d9$export$fa6813432f753b0d)) activities[action.activity.id || action.activity.type] = false;
                    }
                } catch (e_7_1) {
                    e_7 = {
                        error: e_7_1
                    };
                } finally{
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally{
                        if (e_7) throw e_7.error;
                    }
                }
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        var _e = (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)((0, $673da5a8478f7656$export$b8b9e7ba5b8c7b3e)(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), resolvedActions = _e[0], updatedContext = _e[1];
        var _f = (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)((0, $620580f2e39be27d$export$b29f828819edca8d)(resolvedActions, (0, $620580f2e39be27d$export$37dc2eda56cb25a5)), 2), raisedEvents = _f[0], nonRaisedActions = _f[1];
        var invokeActions = resolvedActions.filter(function(action) {
            var _a;
            return action.type === (0, $b9f819ed84df55d9$export$b3571188c770cc5a) && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === (0, $b9f819ed84df55d9$export$468cda29b159ee5d);
        });
        var children = invokeActions.reduce(function(acc, action) {
            acc[action.activity.id] = (0, $61142dedda67d7fc$export$78b4a98dcb5ac328)(action.activity, _this.machine, updatedContext, _event);
            return acc;
        }, currentState ? (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, currentState.children) : {});
        var nextState = new (0, $480eade3b32f6a45$export$7254cc27399e90bd)({
            value: resolvedStateValue || currentState.value,
            context: updatedContext,
            _event: _event,
            // Persist _sessionid between states
            _sessionid: currentState ? currentState._sessionid : null,
            historyValue: resolvedStateValue ? historyValue ? (0, $620580f2e39be27d$export$240d7cdd99ccb95a)(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
            history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
            actions: resolvedStateValue ? nonRaisedActions : [],
            activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
            events: [],
            configuration: resolvedConfiguration,
            transitions: stateTransition.transitions,
            children: children,
            done: isDone,
            tags: (0, $cfb92dfa6e7dbf48$export$5301196121335ca0)(resolvedConfiguration),
            machine: this
        });
        var didUpdateContext = context !== updatedContext;
        nextState.changed = _event.name === (0, $b9f819ed84df55d9$export$722fbec263ad908a) || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks
        var history = nextState.history;
        if (history) delete history.history;
         // There are transient transitions if the machine is not in a final state
        // and if some of the state nodes have transient ("always") transitions.
        var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function(stateNode) {
            return stateNode._transient;
        })); // If there are no enabled transitions, check if there are transient transitions.
        // If there are transient transitions, continue checking for more transitions
        // because an transient transition should be triggered even if there are no
        // enabled transitions.
        //
        // If we're already working on an transient transition then stop to prevent an infinite loop.
        //
        // Otherwise, if there are no enabled nor transient transitions, we are done.
        if (!willTransition && (!hasAlwaysTransitions || _event.name === $fb310f2624fa893f$var$NULL_EVENT)) return nextState;
        var maybeNextState = nextState;
        if (!isDone) {
            if (hasAlwaysTransitions) maybeNextState = this.resolveRaisedTransition(maybeNextState, {
                type: (0, $b9f819ed84df55d9$export$9477ceca5dcd796a)
            }, _event, predictableExec);
            while(raisedEvents.length){
                var raisedEvent = raisedEvents.shift();
                maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
            }
        } // Detect if state changed
        var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !(0, $480eade3b32f6a45$export$3a6d15eeb5fb214c)(maybeNextState.value, history.value) : undefined);
        maybeNextState.changed = changed; // Preserve original history after raised events
        maybeNextState.history = history;
        return maybeNextState;
    };
    /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */ StateNode.prototype.getStateNode = function(stateKey) {
        if ($fb310f2624fa893f$var$isStateId(stateKey)) return this.machine.getStateNodeById(stateKey);
        if (!this.states) throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
        var result = this.states[stateKey];
        if (!result) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return result;
    };
    /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */ StateNode.prototype.getStateNodeById = function(stateId) {
        var resolvedStateId = $fb310f2624fa893f$var$isStateId(stateId) ? stateId.slice($fb310f2624fa893f$var$STATE_IDENTIFIER.length) : stateId;
        if (resolvedStateId === this.id) return this;
        var stateNode = this.machine.idMap[resolvedStateId];
        if (!stateNode) throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
        return stateNode;
    };
    /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */ StateNode.prototype.getStateNodeByPath = function(statePath) {
        if (typeof statePath === 'string' && $fb310f2624fa893f$var$isStateId(statePath)) try {
            return this.getStateNodeById(statePath.slice(1));
        } catch (e) {
        // throw e;
        }
        var arrayStatePath = (0, $620580f2e39be27d$export$304cde62ecda7af8)(statePath, this.delimiter).slice();
        var currentStateNode = this;
        while(arrayStatePath.length){
            var key = arrayStatePath.shift();
            if (!key.length) break;
            currentStateNode = currentStateNode.getStateNode(key);
        }
        return currentStateNode;
    };
    /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */ StateNode.prototype.resolve = function(stateValue) {
        var _a;
        var _this = this;
        if (!stateValue) return this.initialStateValue || $fb310f2624fa893f$var$EMPTY_OBJECT; // TODO: type-specific properties
        switch(this.type){
            case 'parallel':
                return (0, $620580f2e39be27d$export$825e789796ab7275)(this.initialStateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : $fb310f2624fa893f$var$EMPTY_OBJECT;
                });
            case 'compound':
                if ((0, $620580f2e39be27d$export$844ec244b1367d54)(stateValue)) {
                    var subStateNode = this.getStateNode(stateValue);
                    if (subStateNode.type === 'parallel' || subStateNode.type === 'compound') return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
                    return stateValue;
                }
                if (!Object.keys(stateValue).length) return this.initialStateValue || {};
                return (0, $620580f2e39be27d$export$825e789796ab7275)(stateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : $fb310f2624fa893f$var$EMPTY_OBJECT;
                });
            default:
                return stateValue || $fb310f2624fa893f$var$EMPTY_OBJECT;
        }
    };
    StateNode.prototype.getResolvedPath = function(stateIdentifier) {
        if ($fb310f2624fa893f$var$isStateId(stateIdentifier)) {
            var stateNode = this.machine.idMap[stateIdentifier.slice($fb310f2624fa893f$var$STATE_IDENTIFIER.length)];
            if (!stateNode) throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
            return stateNode.path;
        }
        return (0, $620580f2e39be27d$export$304cde62ecda7af8)(stateIdentifier, this.delimiter);
    };
    Object.defineProperty(StateNode.prototype, "initialStateValue", {
        get: function() {
            var _a;
            if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
            var initialStateValue;
            if (this.type === 'parallel') initialStateValue = (0, $620580f2e39be27d$export$2d4204fe9b34204e)(this.states, function(state) {
                return state.initialStateValue || $fb310f2624fa893f$var$EMPTY_OBJECT;
            }, function(stateNode) {
                return !(stateNode.type === 'history');
            });
            else if (this.initial !== undefined) {
                if (!this.states[this.initial]) throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
                initialStateValue = (0, $cfb92dfa6e7dbf48$export$335db82b86111fd1)(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
            } else // The finite state value of a machine without child states is just an empty object
            initialStateValue = {};
            this.__cache.initialStateValue = initialStateValue;
            return this.__cache.initialStateValue;
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getInitialState = function(stateValue, context) {
        this._init(); // TODO: this should be in the constructor (see note in constructor)
        var configuration = this.getStateNodes(stateValue);
        return this.resolveTransition({
            configuration: configuration,
            exitSet: [],
            transitions: [],
            source: undefined,
            actions: []
        }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
    };
    Object.defineProperty(StateNode.prototype, "initialState", {
        /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */ get: function() {
            var initialStateValue = this.initialStateValue;
            if (!initialStateValue) throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
            return this.getInitialState(initialStateValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "target", {
        /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */ get: function() {
            var target;
            if (this.type === 'history') {
                var historyConfig = this.config;
                if ((0, $620580f2e39be27d$export$844ec244b1367d54)(historyConfig.target)) target = $fb310f2624fa893f$var$isStateId(historyConfig.target) ? (0, $620580f2e39be27d$export$f2ee84fc53c45e74)(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
                else target = historyConfig.target;
            }
            return target;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */ StateNode.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
        if (resolve === void 0) resolve = true;
        return resolve ? relativeStateId.type === 'history' ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [
            relativeStateId
        ];
    };
    Object.defineProperty(StateNode.prototype, "initialStateNodes", {
        get: function() {
            var _this = this;
            if ((0, $cfb92dfa6e7dbf48$export$335db82b86111fd1)(this)) return [
                this
            ];
             // Case when state node is compound but no initial state is defined
            if (this.type === 'compound' && !this.initial) {
                if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(false, "Compound state node '".concat(this.id, "' has no initial state."));
                return [
                    this
                ];
            }
            var initialStateNodePaths = (0, $620580f2e39be27d$export$a2618e9e89698dd6)(this.initialStateValue);
            return (0, $620580f2e39be27d$export$bffa455ba8c619a6)(initialStateNodePaths.map(function(initialPath) {
                return _this.getFromRelativePath(initialPath);
            }));
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */ StateNode.prototype.getFromRelativePath = function(relativePath) {
        if (!relativePath.length) return [
            this
        ];
        var _a = (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(relativePath), stateKey = _a[0], childStatePath = _a.slice(1);
        if (!this.states) throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
        var childStateNode = this.getStateNode(stateKey);
        if (childStateNode.type === 'history') return childStateNode.resolveHistory();
        if (!this.states[stateKey]) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return this.states[stateKey].getFromRelativePath(childStatePath);
    };
    StateNode.prototype.historyValue = function(relativeStateValue) {
        if (!Object.keys(this.states).length) return undefined;
        return {
            current: relativeStateValue || this.initialStateValue,
            states: (0, $620580f2e39be27d$export$2d4204fe9b34204e)(this.states, function(stateNode, key) {
                if (!relativeStateValue) return stateNode.historyValue();
                var subStateValue = (0, $620580f2e39be27d$export$844ec244b1367d54)(relativeStateValue) ? undefined : relativeStateValue[key];
                return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
            }, function(stateNode) {
                return !stateNode.history;
            })
        };
    };
    /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */ StateNode.prototype.resolveHistory = function(historyValue) {
        var _this = this;
        if (this.type !== 'history') return [
            this
        ];
        var parent = this.parent;
        if (!historyValue) {
            var historyTarget = this.target;
            return historyTarget ? (0, $620580f2e39be27d$export$bffa455ba8c619a6)((0, $620580f2e39be27d$export$a2618e9e89698dd6)(historyTarget).map(function(relativeChildPath) {
                return parent.getFromRelativePath(relativeChildPath);
            })) : parent.initialStateNodes;
        }
        var subHistoryValue = (0, $620580f2e39be27d$export$314d0a1a7c835392)(parent.path, 'states')(historyValue).current;
        if ((0, $620580f2e39be27d$export$844ec244b1367d54)(subHistoryValue)) return [
            parent.getStateNode(subHistoryValue)
        ];
        return (0, $620580f2e39be27d$export$bffa455ba8c619a6)((0, $620580f2e39be27d$export$a2618e9e89698dd6)(subHistoryValue).map(function(subStatePath) {
            return _this.history === 'deep' ? parent.getFromRelativePath(subStatePath) : [
                parent.states[subStatePath[0]]
            ];
        }));
    };
    Object.defineProperty(StateNode.prototype, "stateIds", {
        /**
     * All the state node IDs of this state node and its descendant state nodes.
     */ get: function() {
            var _this = this;
            var childStateIds = (0, $620580f2e39be27d$export$bffa455ba8c619a6)(Object.keys(this.states).map(function(stateKey) {
                return _this.states[stateKey].stateIds;
            }));
            return [
                this.id
            ].concat(childStateIds);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "events", {
        /**
     * All the event types accepted by this state node and its descendants.
     */ get: function() {
            var e_8, _a, e_9, _b;
            if (this.__cache.events) return this.__cache.events;
            var states = this.states;
            var events = new Set(this.ownEvents);
            if (states) try {
                for(var _c = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var stateId = _d.value;
                    var state = states[stateId];
                    if (state.states) try {
                        for(var _e = (e_9 = void 0, (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(state.events)), _f = _e.next(); !_f.done; _f = _e.next()){
                            var event_1 = _f.value;
                            events.add("".concat(event_1));
                        }
                    } catch (e_9_1) {
                        e_9 = {
                            error: e_9_1
                        };
                    } finally{
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                    }
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
            return this.__cache.events = Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "ownEvents", {
        /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */ get: function() {
            var events = new Set(this.transitions.filter(function(transition) {
                return !(!transition.target && !transition.actions.length && transition.internal);
            }).map(function(transition) {
                return transition.eventType;
            }));
            return Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.resolveTarget = function(_target) {
        var _this = this;
        if (_target === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
        return undefined;
        return _target.map(function(target) {
            if (!(0, $620580f2e39be27d$export$844ec244b1367d54)(target)) return target;
            var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
            // do not include machine key on target
            if (isInternalTarget && !_this.parent) return _this.getStateNodeByPath(target.slice(1));
            var resolvedTarget = isInternalTarget ? _this.key + target : target;
            if (_this.parent) try {
                var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
                return targetStateNode;
            } catch (err) {
                throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
            }
            else return _this.getStateNodeByPath(resolvedTarget);
        });
    };
    StateNode.prototype.formatTransition = function(transitionConfig) {
        var _this = this;
        var normalizedTarget = (0, $620580f2e39be27d$export$2a4fe5c3c80e3288)(transitionConfig.target);
        var internal = 'internal' in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
            return (0, $620580f2e39be27d$export$844ec244b1367d54)(_target) && _target[0] === _this.delimiter;
        }) : true;
        var guards = this.machine.options.guards;
        var target = this.resolveTarget(normalizedTarget);
        var transition = (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, transitionConfig), {
            actions: (0, $673da5a8478f7656$export$aa68691f32e6c459)((0, $620580f2e39be27d$export$45b10814cc054894)(transitionConfig.actions)),
            cond: (0, $620580f2e39be27d$export$b0f5a08e0ca47933)(transitionConfig.cond, guards),
            target: target,
            source: this,
            internal: internal,
            eventType: transitionConfig.event,
            toJSON: function() {
                return (0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)((0, $1d68e7cbb4c6c146$export$18ce0697a983be9b)({}, transition), {
                    target: transition.target ? transition.target.map(function(t) {
                        return "#".concat(t.id);
                    }) : undefined,
                    source: "#".concat(_this.id)
                });
            }
        });
        return transition;
    };
    StateNode.prototype.formatTransitions = function() {
        var e_10, _a;
        var _this = this;
        var onConfig;
        if (!this.config.on) onConfig = [];
        else if (Array.isArray(this.config.on)) onConfig = this.config.on;
        else {
            var _b = this.config.on, _c = $fb310f2624fa893f$var$WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = (0, $1d68e7cbb4c6c146$export$3c9a16f847548506)(_b, [
                typeof _c === "symbol" ? _c : _c + ""
            ]);
            onConfig = (0, $620580f2e39be27d$export$bffa455ba8c619a6)(Object.keys(strictTransitionConfigs_1).map(function(key) {
                if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571) && key === $fb310f2624fa893f$var$NULL_EVENT) (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + "Please check the `on` configuration for \"#".concat(_this.id, "\"."));
                var transitionConfigArray = (0, $620580f2e39be27d$export$3822a36ea084a4d5)(key, strictTransitionConfigs_1[key]);
                if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) $fb310f2624fa893f$var$validateArrayifiedTransitions(_this, key, transitionConfigArray);
                return transitionConfigArray;
            }).concat((0, $620580f2e39be27d$export$3822a36ea084a4d5)($fb310f2624fa893f$var$WILDCARD, wildcardConfigs)));
        }
        var eventlessConfig = this.config.always ? (0, $620580f2e39be27d$export$3822a36ea084a4d5)('', this.config.always) : [];
        var doneConfig = this.config.onDone ? (0, $620580f2e39be27d$export$3822a36ea084a4d5)(String((0, $673da5a8478f7656$export$3df11c9c20e7b288)(this.id)), this.config.onDone) : [];
        if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571)) (0, $620580f2e39be27d$export$c106dd0671a0fc2d)(!(this.config.onDone && !this.parent), "Root nodes cannot have an \".onDone\" transition. Please check the config of \"".concat(this.id, "\"."));
        var invokeConfig = (0, $620580f2e39be27d$export$bffa455ba8c619a6)(this.invoke.map(function(invokeDef) {
            var settleTransitions = [];
            if (invokeDef.onDone) settleTransitions.push.apply(settleTransitions, (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)((0, $620580f2e39be27d$export$3822a36ea084a4d5)(String((0, $673da5a8478f7656$export$c105e588793f70b4)(invokeDef.id)), invokeDef.onDone)), false));
            if (invokeDef.onError) settleTransitions.push.apply(settleTransitions, (0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)((0, $620580f2e39be27d$export$3822a36ea084a4d5)(String((0, $673da5a8478f7656$export$a3bc9b8ed74fc)(invokeDef.id)), invokeDef.onError)), false));
            return settleTransitions;
        }));
        var delayedTransitions = this.after;
        var formattedTransitions = (0, $620580f2e39be27d$export$bffa455ba8c619a6)((0, $1d68e7cbb4c6c146$export$1216008129fb82ed)((0, $1d68e7cbb4c6c146$export$1216008129fb82ed)((0, $1d68e7cbb4c6c146$export$1216008129fb82ed)((0, $1d68e7cbb4c6c146$export$1216008129fb82ed)([], (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(doneConfig), false), (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(invokeConfig), false), (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(onConfig), false), (0, $1d68e7cbb4c6c146$export$8d051b38c9118094)(eventlessConfig), false).map(function(transitionConfig) {
            return (0, $620580f2e39be27d$export$45b10814cc054894)(transitionConfig).map(function(transition) {
                return _this.formatTransition(transition);
            });
        }));
        try {
            for(var delayedTransitions_1 = (0, $1d68e7cbb4c6c146$export$19a8beecd37a4c45)(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()){
                var delayedTransition = delayedTransitions_1_1.value;
                formattedTransitions.push(delayedTransition);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
            } finally{
                if (e_10) throw e_10.error;
            }
        }
        return formattedTransitions;
    };
    return StateNode;
}();



var $15bb13904b1fd3cf$var$warned = false;
function $15bb13904b1fd3cf$export$f391db14ff2d9279(config, options, initialContext) {
    if (initialContext === void 0) initialContext = config.context;
    return new (0, $fb310f2624fa893f$export$342f24f5edd47b1)(config, options, initialContext);
}
function $15bb13904b1fd3cf$export$aaa7fa18f8e9b2e8(config, options) {
    if (!(0, $4c86ee07ad6be3d6$export$9b5f2e1c20ef6571) && !('predictableActionArguments' in config) && !$15bb13904b1fd3cf$var$warned) {
        $15bb13904b1fd3cf$var$warned = true;
        console.warn('It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html');
    }
    return new (0, $fb310f2624fa893f$export$342f24f5edd47b1)(config, options);
}










var $ce3108fccc482c97$export$e6e34fd1f2686227 = (0, $673da5a8478f7656$export$e6e34fd1f2686227), $ce3108fccc482c97$export$70b61ad426ddbe54 = (0, $673da5a8478f7656$export$70b61ad426ddbe54), $ce3108fccc482c97$export$89db4734f6c919c4 = (0, $673da5a8478f7656$export$89db4734f6c919c4), $ce3108fccc482c97$export$daa976aaff721e41 = (0, $673da5a8478f7656$export$daa976aaff721e41), $ce3108fccc482c97$export$408d8d51fa351f53 = (0, $673da5a8478f7656$export$408d8d51fa351f53), $ce3108fccc482c97$export$7f8b724299523eb6 = (0, $673da5a8478f7656$export$7f8b724299523eb6), $ce3108fccc482c97$export$eb147b7589db8e8a = (0, $673da5a8478f7656$export$eb147b7589db8e8a), $ce3108fccc482c97$export$c105e588793f70b4 = (0, $673da5a8478f7656$export$c105e588793f70b4), $ce3108fccc482c97$export$66313c302b2ea154 = (0, $673da5a8478f7656$export$66313c302b2ea154), $ce3108fccc482c97$export$bef1f36f5486a6a3 = (0, $673da5a8478f7656$export$bef1f36f5486a6a3), $ce3108fccc482c97$export$48ec4a2b1cfc6557 = (0, $673da5a8478f7656$export$48ec4a2b1cfc6557), $ce3108fccc482c97$export$7877a478dd30fd3d = (0, $673da5a8478f7656$export$7877a478dd30fd3d), $ce3108fccc482c97$export$fa6813432f753b0d = (0, $673da5a8478f7656$export$fa6813432f753b0d);











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $cfb3c73ccfc8d5e6$var$logger = new (0, $294c375a4ec5088f$export$ba6a9c7ac8291f7f)('I18n');
/**
 * Language translation utility.
 */ let $cfb3c73ccfc8d5e6$export$dbe3113d60765c1a = class I18n {
    constructor(){
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
    }
    /**
     * Sets the default language from the configuration when required.
     */ setDefaultLanguage() {
        // Default to window language if not set in instance
        if (!this._lang && typeof window !== 'undefined' && window && window.navigator) this._lang = window.navigator.language;
        $cfb3c73ccfc8d5e6$var$logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ setLanguage(lang) {
        this._lang = lang;
    }
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ get(key, defVal) {
        this.setDefaultLanguage();
        if (!this._lang) return typeof defVal !== 'undefined' ? defVal : key;
        const lang = this._lang;
        let val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf('-') > 0) val = this.getByLanguage(key, lang.split('-')[0]);
        if (val) return val;
        return typeof defVal !== 'undefined' ? defVal : key;
    }
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ getByLanguage(key, language, defVal = null) {
        if (!language) return defVal;
        const langDict = this._dict[language];
        if (!langDict) return defVal;
        return langDict[key];
    }
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ putVocabulariesForLanguage(language, vocabularies) {
        let langDict = this._dict[language];
        if (!langDict) langDict = this._dict[language] = {};
        this._dict[language] = {
            ...langDict,
            ...vocabularies
        };
    }
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ putVocabularies(vocabularies) {
        Object.keys(vocabularies).forEach((key)=>{
            this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    }
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $6f79bff049b3a2a4$export$6cc46f5977c4544e;
(function(I18nErrorCode) {
    I18nErrorCode["NotConfigured"] = "NotConfigured";
})($6f79bff049b3a2a4$export$6cc46f5977c4544e || ($6f79bff049b3a2a4$export$6cc46f5977c4544e = {}));
const $6f79bff049b3a2a4$var$i18nErrorMap = {
    [$6f79bff049b3a2a4$export$6cc46f5977c4544e.NotConfigured]: {
        message: 'i18n is not configured.'
    }
};
const $6f79bff049b3a2a4$export$a7a9523472993e97 = (0, $97bdb48788a05322$export$5cb8fc27ccbe9d40)($6f79bff049b3a2a4$var$i18nErrorMap);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $abd8c3b7750935f7$var$logger = new (0, $294c375a4ec5088f$export$ba6a9c7ac8291f7f)('I18n');
let $abd8c3b7750935f7$var$_config = {
    language: null
};
let $abd8c3b7750935f7$var$_i18n = null;
/**
 * Export I18n APIs
 */ class $abd8c3b7750935f7$export$dbe3113d60765c1a {
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ static configure(config) {
        $abd8c3b7750935f7$var$logger.debug('configure I18n');
        if (!config) return $abd8c3b7750935f7$var$_config;
        $abd8c3b7750935f7$var$_config = Object.assign({}, $abd8c3b7750935f7$var$_config, config.I18n || config);
        $abd8c3b7750935f7$export$dbe3113d60765c1a.createInstance();
        return $abd8c3b7750935f7$var$_config;
    }
    static getModuleName() {
        return 'I18n';
    }
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ static createInstance() {
        $abd8c3b7750935f7$var$logger.debug('create I18n instance');
        if ($abd8c3b7750935f7$var$_i18n) return;
        $abd8c3b7750935f7$var$_i18n = new (0, $cfb3c73ccfc8d5e6$export$dbe3113d60765c1a)();
    }
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ static setLanguage(lang) {
        $abd8c3b7750935f7$export$dbe3113d60765c1a.checkConfig();
        (0, $6f79bff049b3a2a4$export$a7a9523472993e97)(!!$abd8c3b7750935f7$var$_i18n, (0, $6f79bff049b3a2a4$export$6cc46f5977c4544e).NotConfigured);
        $abd8c3b7750935f7$var$_i18n.setLanguage(lang);
    }
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ static get(key, defVal) {
        if (!$abd8c3b7750935f7$export$dbe3113d60765c1a.checkConfig()) return typeof defVal === 'undefined' ? key : defVal;
        (0, $6f79bff049b3a2a4$export$a7a9523472993e97)(!!$abd8c3b7750935f7$var$_i18n, (0, $6f79bff049b3a2a4$export$6cc46f5977c4544e).NotConfigured);
        return $abd8c3b7750935f7$var$_i18n.get(key, defVal);
    }
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ static putVocabulariesForLanguage(language, vocabularies) {
        $abd8c3b7750935f7$export$dbe3113d60765c1a.checkConfig();
        (0, $6f79bff049b3a2a4$export$a7a9523472993e97)(!!$abd8c3b7750935f7$var$_i18n, (0, $6f79bff049b3a2a4$export$6cc46f5977c4544e).NotConfigured);
        $abd8c3b7750935f7$var$_i18n.putVocabulariesForLanguage(language, vocabularies);
    }
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ static putVocabularies(vocabularies) {
        $abd8c3b7750935f7$export$dbe3113d60765c1a.checkConfig();
        (0, $6f79bff049b3a2a4$export$a7a9523472993e97)(!!$abd8c3b7750935f7$var$_i18n, (0, $6f79bff049b3a2a4$export$6cc46f5977c4544e).NotConfigured);
        $abd8c3b7750935f7$var$_i18n.putVocabularies(vocabularies);
    }
    static checkConfig() {
        if (!$abd8c3b7750935f7$var$_i18n) $abd8c3b7750935f7$export$dbe3113d60765c1a.createInstance();
        return true;
    }
}
// Create an instance of I18n in the static class
$abd8c3b7750935f7$export$dbe3113d60765c1a.createInstance();


const $51fdb4dbc4454e0c$export$cca4a41bdb910c51 = {
    'Account recovery requires verified contact information': "Zur\xfccksetzen des Accounts ben\xf6tigt einen verifizierten Account",
    'Add your Profile': "Ihr Profil hinzuf\xfcgen",
    'Add your Website': "Ihre Website hinzuf\xfcgen",
    'Authenticator App (TOTP)': 'Authentifikator-App (TOTP)',
    'Back to Sign In': "Zur\xfcck zur Anmeldung",
    'Change Password': "Passwort \xe4ndern",
    Changing: "\xc4ndern von",
    Code: 'Code',
    'Confirm Email Code': "E-Mail-Code best\xe4tigen",
    'Confirm Password': "Passwort best\xe4tigen",
    'Please confirm your Password': "Bitte best\xe4tigen Sie Ihr Passwort",
    'Confirm Sign Up': "Registrierung best\xe4tigen",
    'Confirm SMS Code': "SMS-Code best\xe4tigen",
    'Confirm TOTP Code': "TOTP-Code best\xe4tigen",
    Confirm: "Best\xe4tigen",
    'Confirmation Code': "Best\xe4tigungs-Code",
    Confirming: "Wird best\xe4tigt",
    'Create a new account': 'Einen neuen Account erstellen',
    'Create Account': 'Account erstellen',
    'Creating Account': 'Account wird erstellt',
    'Dismiss alert': 'Warnung verwerfen',
    Email: 'E-Mail',
    'Email Message': 'E-Mail-Nachricht',
    'Enter your Birthdate': 'Geben Sie Ihr Geburtsdatum ein',
    'Enter your code': 'Geben Sie Ihren Code ein',
    'Enter your Confirmation Code': "Geben Sie Ihren Best\xe4tigungs-Code ein",
    'Enter your Email': 'Geben Sie Ihre E-Mail ein',
    'Enter your Family Name': 'Geben Sie Ihren Nachnamen ein',
    'Enter your Given Name': 'Geben Sie Ihren Vornamen ein',
    'Enter your Middle Name': 'Geben Sie Ihren zweiten Vornamen ein',
    'Enter your Name': 'Geben Sie Ihren Namen ein',
    'Enter your Nickname': 'Geben Sie Ihren Spitznamen ein',
    'Enter your Password': 'Geben Sie Ihr Passwort ein',
    'Enter your password': 'Geben Sie Ihr Passwort ein',
    'Enter your email': 'Geben Sie Ihre E-Mail ein',
    'Enter your phone number': 'Geben Sie Ihre Telefonnummer ein',
    'Enter your Preferred Username': 'Geben Sie Ihren bevorzugten Benutzernamen ein',
    'Enter your username': 'Geben Sie Ihren Benutzernamen ein',
    'Forgot password?': 'Passwort vergessen?',
    'Forgot your password?': 'Passwort vergessen? ',
    'Hide password': 'Passwort verbergen',
    'It may take a minute to arrive': 'Es kann eine Minute dauern, bis er ankommt',
    Loading: 'Wird geladen',
    'Multi-Factor Authentication': 'Multifaktor-Authentifizierung',
    'Multi-Factor Authentication Setup': 'Einrichtung der Multifaktor-Authentifizierung',
    'New password': 'Neues Passwort',
    or: 'oder',
    Password: 'Passwort',
    'Phone Number': 'Telefonnummer',
    'Resend Code': 'Code erneut senden',
    'Reset your Password': "Zur\xfccksetzen des Passworts",
    'Reset your password': "Zur\xfccksetzen des passworts",
    'Select MFA Type': "MFA-Typ ausw\xe4hlen",
    'Send code': 'Code senden',
    'Send Code': 'Code senden',
    Sending: 'Wird gesendet',
    'Setup Email': 'E-Mail einrichten',
    'Setup TOTP': 'TOTP einrichten',
    'Show password': 'Passwort anzeigen',
    'Sign in to your account': 'Melden Sie sich mit Ihrem Account an',
    'Sign In with Amazon': 'Mit Amazon anmelden',
    'Sign In with Apple': 'Mit Apple anmelden',
    'Sign In with Facebook': 'Mit Facebook anmelden',
    'Sign In with Google': 'Mit Google anmelden',
    'Sign in': 'Anmelden',
    'Sign In': 'Anmelden',
    'Signing in': 'Wird angemeldet',
    Skip: "\xdcberspringen",
    Submit: 'Abschicken',
    Submitting: 'Wird gesendet',
    'Text Message (SMS)': 'Textnachricht (SMS)',
    Username: 'Benutzername',
    'Verify Contact': 'Kontakt verifizieren',
    Verify: 'Verifizieren',
    'We Emailed You': 'E-Mail wurde versendet',
    'We Sent A Code': 'Wir haben einen Code gesendet',
    'We Texted You': 'Wir haben Ihnen eine SMS gesendet',
    'Your code is on the way. To log in, enter the code we emailed to': "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir per E-Mail verschickt haben",
    'Your code is on the way. To log in, enter the code we sent you': 'Ihr Code ist unterwegs. Um sich anzumelden, geben Sie den Code ein, den wir Ihnen gesendet haben',
    'Your code is on the way. To log in, enter the code we texted to': "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir per SMS verschickt haben",
    // Additional translations provided by customers
    'An account with the given email already exists.': 'Ein Account mit dieser E-Mail existiert bereits.',
    'Confirm a Code': "Code best\xe4tigen",
    'Confirm Sign In': "Anmeldung best\xe4tigen",
    'Create account': 'Hier registrieren',
    'Sign Up with Facebook': 'Mit Facebook registrieren',
    'Sign Up with Google': 'Mit Google registrieren',
    'Forgot Password': 'Passwort vergessen',
    'Have an account? ': 'Schon registriert? ',
    'Incorrect username or password': 'Falscher Benutzername oder falsches Passwort',
    'Incorrect username or password.': 'Falscher Benutzername oder falsches Passwort',
    'Invalid password format': "Ung\xfcltiges Passwort-Format",
    'Invalid phone number format': `Ung\xfcltiges Telefonummern-Format. Benutze eine Nummer im Format: +12345678900`,
    'It may take a minute to arrive.': "Es k\xf6nnte eine Minute dauern, bis der Code eintrifft.",
    'Lost your code? ': 'Code verloren? ',
    'New Password': 'Neues Passwort',
    'No account? ': 'Kein Account? ',
    'Password attempts exceeded': 'Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht',
    'Reset password': "Passwort zur\xfccksetzen",
    'Reset Password': "Passwort Zur\xfccksetzen",
    'Sign Out': 'Abmelden',
    'Sign Up': 'Registrieren',
    'User already exists': 'Dieser Benutzer existiert bereits',
    'User does not exist': 'Dieser Benutzer existiert nicht',
    'Username cannot be empty': 'Benutzername darf nicht leer sein'
};


const $299256ea3d92e8a0$export$eb91f595f110d703 = {
    'Account recovery requires verified contact information': 'Account recovery requires verified contact information',
    'Add your Profile': 'Add your Profile',
    'Add your Website': 'Add your Website',
    'Authenticator App (TOTP)': 'Authenticator App (TOTP)',
    'Back to Sign In': 'Back to Sign In',
    'Change Password': 'Change Password',
    Changing: 'Changing',
    Code: 'Code',
    'Confirm Email Code': 'Confirm Email Code',
    'Confirm Password': 'Confirm Password',
    'Confirm Sign Up': 'Confirm Sign Up',
    'Confirm SMS Code': 'Confirm SMS Code',
    'Confirm MFA Code': 'Confirm MFA Code',
    'Confirm TOTP Code': 'Confirm TOTP Code',
    Confirm: 'Confirm',
    'Confirmation Code': 'Confirmation Code',
    Confirming: 'Confirming',
    'Create a new account': 'Create a new account',
    'Create Account': 'Create Account',
    'Creating Account': 'Creating Account',
    'Dismiss alert': 'Dismiss alert',
    Email: 'Email',
    'Email Message': 'Email Message',
    'Enter your Birthdate': 'Enter your Birthdate',
    'Enter your code': 'Enter your code',
    'Enter your Confirmation Code': 'Enter your Confirmation Code',
    'Enter your Email': 'Enter your Email',
    'Enter your Family Name': 'Enter your Family Name',
    'Enter your Given Name': 'Enter your Given Name',
    'Enter your Middle Name': 'Enter your Middle Name',
    'Enter your Name': 'Enter your Name',
    'Enter your Nickname': 'Enter your Nickname',
    'Enter your Password': 'Enter your Password',
    'Enter your phone number': 'Enter your phone number',
    'Enter your Preferred Username': 'Enter your Preferred Username',
    'Enter your username': 'Enter your username',
    'Forgot password?': 'Forgot password?',
    'Forgot your password?': 'Forgot your password?',
    'Hide password': 'Hide password',
    'It may take a minute to arrive': 'It may take a minute to arrive',
    Loading: 'Loading',
    'Multi-Factor Authentication': 'Multi-Factor Authentication',
    'Multi-Factor Authentication Setup': 'Multi-Factor Authentication Setup',
    'New password': 'New password',
    or: 'or',
    Password: 'Password',
    'Phone Number': 'Phone Number',
    'Please confirm your Password': 'Please confirm your Password',
    'Resend Code': 'Resend Code',
    'Reset your password': 'Reset your password',
    'Reset your Password': 'Reset your Password',
    'Select MFA Type': 'Select MFA Type',
    'Send code': 'Send code',
    'Send Code': 'Send Code',
    Sending: 'Sending',
    'Setup Email': 'Setup Email',
    'Setup TOTP': 'Setup TOTP',
    'Show password': 'Show password',
    'Sign in to your account': 'Sign in to your account',
    'Sign In with Amazon': 'Sign In with Amazon',
    'Sign In with Apple': 'Sign In with Apple',
    'Sign In with Facebook': 'Sign In with Facebook',
    'Sign In with Google': 'Sign In with Google',
    'Sign in': 'Sign in',
    'Sign In': 'Sign In',
    'Signing in': 'Signing in',
    Skip: 'Skip',
    Submit: 'Submit',
    Submitting: 'Submitting',
    'Text Message (SMS)': 'Text Message (SMS)',
    Username: 'Username',
    'Verify Contact': 'Verify Contact',
    Verify: 'Verify',
    'We Emailed You': 'We Emailed You',
    'We Sent A Code': 'We Sent A Code',
    'We Texted You': 'We Texted You',
    'Your code is on the way. To log in, enter the code we emailed to': 'Your code is on the way. To log in, enter the code we emailed to',
    'Your code is on the way. To log in, enter the code we sent you': 'Your code is on the way. To log in, enter the code we sent you',
    'Your code is on the way. To log in, enter the code we texted to': 'Your code is on the way. To log in, enter the code we texted to'
};


const $c437ecf620530757$export$1d204a99f5862ba9 = {
    'Account recovery requires verified contact information': "La recuperaci\xf3n de la cuenta requiere informaci\xf3n de contacto verificada",
    'Authenticator App (TOTP)': "Aplicaci\xf3n de autenticaci\xf3n (TOTP)",
    'Back to Sign In': "Volver a inicio de sesi\xf3n",
    'Cannot reset password for the user as there is no registered/verified email or phone_number': "No se puede restablecer la contrase\xf1a para el usuario debido a que no hay Email registrado / verificado o n\xfamero de tel\xe9fono",
    'Change Password': "Cambiar contrase\xf1a",
    Changing: 'Cambiando',
    Code: "C\xf3digo",
    'Code *': "C\xf3digo *",
    'Confirm Email Code': "Confirmar el c\xf3digo de correo electr\xf3nico",
    'Confirm Password': "Confirmar contrase\xf1a",
    'Confirm Sign Up': 'Confirmar registro',
    'Confirm SMS Code': "Confirmar el c\xf3digo de SMS",
    'Confirm TOTP Code': "Confirmar c\xf3digo TOTP",
    Confirm: 'Confirmar',
    'Confirmation Code': "C\xf3digo de confirmaci\xf3n",
    Confirming: 'Confirmando',
    'Create a new account': 'Crear una cuenta nueva',
    'Create Account': 'Crear cuenta',
    'Creating Account': 'Creando cuenta',
    'Dismiss alert': 'Descartar alerta',
    Email: 'Email',
    'Email Message': "Mensaje de correo electr\xf3nico",
    'Enter your code': "Ingrese el c\xf3digo",
    'Enter your Email': 'Escriba su Email',
    'Enter your email': 'Escriba su email',
    'Enter your Password': "Escriba su Contrase\xf1a",
    'Enter your phone number': "Ingrese el n\xfamero de tel\xe9fono",
    'Enter your username': 'Ingrese el nombre de usuario',
    'Forgot your password?': "\xbfOlvid\xf3 su contrase\xf1a?",
    'Hide password': "Ocultar contrase\xf1a",
    'It may take a minute to arrive': 'Es posible que tarde un minuto en llegar',
    Loading: 'Cargando',
    'Multi-Factor Authentication': "Autenticaci\xf3n multifactor",
    'Multi-Factor Authentication Setup': "Configuraci\xf3n de autenticaci\xf3n multifactor",
    'New password': "Nueva contrase\xf1a",
    or: 'o',
    Password: "Contrase\xf1a",
    'Phone Number': "N\xfamero de tel\xe9fono",
    'Resend Code': "Reenviar c\xf3digo",
    'Reset your password': "Restablecer su contrase\xf1a",
    'Reset your Password': "Restablecer su Contrase\xf1a",
    'Select MFA Type': 'Seleccionar el tipo de MFA',
    'Send code': "Enviar c\xf3digo",
    'Send Code': "Enviar c\xf3digo",
    Sending: 'Enviando',
    'Setup Email': "Configurar correo electr\xf3nico",
    'Setup TOTP': 'Configurar TOTP',
    'Show password': "Mostrar contrase\xf1a",
    'Sign in to your account': "Iniciar sesi\xf3n en tu cuenta",
    'Sign In with Amazon': "Iniciar Sesi\xf3n con Amazon",
    'Sign In with Apple': "Iniciar Sesi\xf3n con Apple",
    'Sign In with Facebook': "Iniciar Sesi\xf3n con Facebook",
    'Sign In with Google': "Iniciar Sesi\xf3n con Google",
    'Sign in': "Iniciar sesi\xf3n",
    'Sign In': "Iniciar Sesi\xf3n",
    'Signing in': "Iniciando sesi\xf3n",
    Skip: 'Omitir',
    Submit: 'Enviar',
    Submitting: 'Enviando',
    'Text Message (SMS)': 'Mensaje de texto (SMS)',
    Username: 'Nombre de usuario',
    'Verify Contact': 'Verificar contacto',
    Verify: 'Verificar',
    'We Emailed You': "Le hemos enviado un correo electr\xf3nico",
    'We Sent A Code': "Hemos enviado un c\xf3digo",
    'We Texted You': 'Le hemos enviado un mensaje de texto',
    'Your code is on the way. To log in, enter the code we emailed to': "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que hemos enviado por correo electr\xf3nico a",
    'Your code is on the way. To log in, enter the code we sent you': "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que le hemos enviado",
    'Your code is on the way. To log in, enter the code we texted to': "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que hemos enviado por mensaje de texto a",
    // Additional translations provided by customers
    'An account with the given email already exists.': 'Ya existe una cuenta con el correo ingresado.',
    'Confirm a Code': "Confirmar un c\xf3digo",
    'Confirm Sign In': "Confirmar inicio de sesi\xf3n",
    'Forgot Password': "Olvid\xe9 mi contrase\xf1a",
    'Incorrect username or password.': "Nombre de usuario o contrase\xf1a incorrecta",
    'Enter your Family Name': 'Escriba su apellido',
    'Enter your Given Name': 'Escriba su nombre',
    'Given Name': 'Nombre',
    'Family Name': 'Apellido',
    'Reset Password': "Restablecer contrase\xf1a",
    'Please confirm your Password': "Confirme su contrase\xf1a",
    'Invalid password format': "Formato de contrase\xf1a inv\xe1lido",
    'Invalid phone number format': "Formato de n\xfamero de tel\xe9fono inv\xe1lido",
    'Loading...': 'Cargando...',
    'New Password': "Nueva contrase\xf1a",
    'Resend a Code': "Reenviar un c\xf3digo",
    'Sign Out': "Cerrar sesi\xf3n",
    'Sign Up with Amazon': 'Crear cuenta con Amazon',
    'Sign Up with Apple': 'Crear cuenta con Apple',
    'Sign Up with Facebook': 'Crear cuenta con Facebook',
    'Sign Up with Google': 'Crear cuenta con Google',
    'Sign Up': 'Crear cuenta',
    'User already exists': 'El usuario ya existe',
    'User does not exist.': 'El usuario no existe',
    'Username/client id combination not found.': 'El usuario no existe',
    'Username cannot be empty': "El nombre de usuario no puede estar vac\xedo",
    'Your passwords must match': "Las contrase\xf1as deben coincidir",
    'Password must have at least 8 characters': "La contrase\xf1a debe tener al menos 8 caracteres",
    'Password must have upper case letters': "La contrase\xf1a debe tener al menos un car\xe1cter en may\xfascula",
    'Password must have numbers': "La contrase\xf1a debe tener al menos un car\xe1cter num\xe9rico",
    'Password must have special characters': "La contrase\xf1a debe tener al menos un s\xedmbolo",
    'Password must have lower case letters': "La contrase\xf1a debe tener al menos un car\xe1cter en min\xfasculas",
    'Invalid verification code provided, please try again.': "C\xf3digo de verificaci\xf3n no v\xe1lido, int\xe9ntelo de nuevo.",
    'Attempt limit exceeded, please try after some time.': "N\xfamero m\xe1ximo de intentos excedido, por favor int\xe9ntelo de nuevo m\xe1s tarde.",
    'A network error has occurred.': 'Se ha producido un error de red.'
};


const $0b0631cbb485c66b$export$8cfa91bfcf8d11c8 = {
    'Account recovery requires verified contact information': "La r\xe9cup\xe9ration du compte n\xe9cessite des informations de contact v\xe9rifi\xe9es",
    'Authenticator App (TOTP)': "Application d\u2019authentification (TOTP)",
    'Back to Sign In': "Retour \xe0 la connexion",
    'Cannot reset password for the user as there is no registered/verified email or phone_number': "Impossible de r\xe9initialiser le mot de passe pour l'utilisateur car il n'a pas d'adresse e-mail ou de num\xe9ro de t\xe9l\xe9phone enregistr\xe9 / v\xe9rifi\xe9",
    'Change Password': 'Modifier le mot de passe',
    Changing: 'Modification en cours',
    Code: 'Code',
    'Confirm Email Code': 'Confirmer le code e-mail',
    'Confirm Password': 'Confirmez le mot de passe',
    'Confirm Sign Up': "Confirmer l'inscription",
    'Confirm SMS Code': 'Confirmer le code SMS',
    'Confirm TOTP Code': 'Confirmer le code TOTP',
    Confirm: 'Confirmer',
    'Confirmation Code': 'Code de confirmation',
    Confirming: 'Confirmation',
    'Create a new account': "Cr\xe9er un nouveau compte",
    'Create Account': "Cr\xe9er un compte",
    'Creating Account': `Cr\xe9ation d'un compte`,
    'Dismiss alert': `Supprimer l'alerte`,
    Email: 'Email',
    'Email Message': "Message de l\u2019e-mail",
    'Enter your code': 'Saisissez cotre code de confirmation',
    'Enter your Email': 'Saisissez votre adresse e-mail',
    'Enter your email': 'Saisissez votre adresse e-mail',
    'Enter your phone number': "Saisissez votre num\xe9ro de t\xe9l\xe9phone",
    'Enter your username': "Saisissez votre nom d'utilisateur",
    'Forgot your password?': "Mot de passe oubli\xe9 ? ",
    'Hide password': 'Masquer le mot de passe',
    'It may take a minute to arrive': 'Cela peut prendre une minute',
    Loading: 'Chargement en cours',
    'Multi-Factor Authentication': 'Authentification multifactorielle',
    'Multi-Factor Authentication Setup': "Configuration de l\u2019authentification multifactorielle",
    'New password': 'Nouveau mot de passe',
    or: 'ou',
    Password: 'Mot de passe',
    'Phone Number': "Num\xe9ro de t\xe9l\xe9phone",
    'Resend Code': 'Renvoyer le code',
    'Reset your Password': "R\xe9initialiser votre mot de passe",
    'Reset your password': "R\xe9initialisez votre mot de passe",
    'Select MFA Type': "S\xe9lectionner le type de MFA",
    'Send code': 'Envoyer le code',
    'Send Code': "M'envoyer un code",
    Sending: 'Envoi en cours',
    'Setup Email': 'E-mail de configuration',
    'Setup TOTP': 'Configuration de TOTP',
    'Show password': 'Afficher le mot de passe',
    'Sign in to your account': "Connexion \xe0 votre compte",
    'Sign In with Amazon': 'Se connecter avec Amazon',
    'Sign In with Apple': 'Se connecter avec Apple',
    'Sign In with Facebook': 'Se connecter avec Facebook',
    'Sign In with Google': 'Se connecter avec Google',
    'Sign in': 'Se connecter',
    'Sign In': 'Se connecter',
    'Signing in': 'Connexion en cours',
    Skip: 'Passer',
    Submit: 'Soumettre',
    Submitting: 'Envoi en cours',
    'Text Message (SMS)': 'Message texte (SMS)',
    Username: "Nom d'utilisateur",
    'Verify Contact': "V\xe9rifier le contact",
    Verify: "V\xe9rifier",
    'We Sent A Code': "Nous avons envoy\xe9 un code",
    'We Texted You': "Nous vous avons envoy\xe9 un SMS",
    'Your code is on the way. To log in, enter the code we sent you': `Votre code est en cours d'envoi. Pour vous connecter, saisissez le code que nous vous avons envoy\xe9`,
    // Additional translations provided by customers
    'Add your Profile': 'Ajoutez votre profil',
    'Add your Website': 'Ajoutez votre site web',
    'An account with the given email already exists.': "Un utilisateur avec cette adresse email existe d\xe9j\xe0.",
    Birthdate: 'Date de naissance',
    Change: 'Modifier',
    'Confirm a Code': 'Confirmer un code',
    'Confirm Sign In': 'Confirmer la connexion',
    'Create account': "Cr\xe9er un compte",
    'Enter your Birthdate': 'Saisissez votre date de naissance',
    'Enter your Confirmation Code': 'Saisissez votre code de confirmation',
    'Enter your Family Name': 'Saisissez votre nom de famille',
    'Enter your Given Name': "Saisissez votre pr\xe9nom",
    'Enter your Middle Name': "Saisissez votre deuxi\xe8me pr\xe9nom",
    'Enter your Name': 'Saisissez votre nom',
    'Enter your Nickname': 'Saisissez votre surnom',
    'Enter your Password': 'Saisissez votre mot de passe',
    'Enter your Phone Number': "Saisissez votre num\xe9ro de t\xe9l\xe9phone",
    'Enter your Preferred Username': "Saisissez votre nom d'utilisateur",
    'Enter your password': 'Saisissez votre mot de passe',
    'Given Name': "Pr\xe9nom",
    'Family Name': 'Nom de famille',
    'Forgot Password': "Mot de passe oubli\xe9",
    'Forgot Password?': "Mot de passe oubli\xe9 ?",
    'Incorrect username or password': 'Identifiant ou mot de passe incorrect',
    'Incorrect username or password.': 'Identifiant ou mot de passe incorrect.',
    'Have an account? ': "D\xe9j\xe0 un compte ? ",
    Hello: 'Bonjour',
    'Invalid password format': 'Format de mot de passe invalide',
    'Invalid phone number format': `Format de num\xe9ro de t\xe9l\xe9phone invalide. Veuillez utiliser un format +12345678900`,
    'Loading...': 'Chargement...',
    'Lost your code? ': 'Vous avez perdu votre code ? ',
    'Network error': "Erreur r\xe9seau",
    'New Password': 'Nouveau mot de passe',
    Name: 'Nom',
    'No account? ': 'Pas de compte ? ',
    'Please confirm your Password': 'Confirmez votre mot de passe',
    'Preferred Username': "Nom d'utilisateur pr\xe9f\xe9r\xe9",
    Profile: 'Profil',
    'Resend a Code': 'Renvoyer un code',
    'Reset password': "R\xe9initialiser le mot de passe",
    'Reset Password': "R\xe9initialiser le mot de passe",
    Send: 'Envoyer',
    'Sign In with AWS': 'Se connecter avec AWS',
    'Sign Out': "D\xe9connexion",
    'Sign Up': "S'inscrire",
    SMS: 'SMS',
    'User already exists': "L'utilisateur existe d\xe9j\xe0",
    'User does not exist.': "L'utilisateur n'existe pas",
    'Username cannot be empty': "Le nom d'utilisateur doit \xeatre renseign\xe9",
    'Username/client id combination not found.': "L'utilisateur n'existe pas",
    'We Emailed You': "Nous vous avons envoy\xe9 un code",
    'Your code is on the way. To log in, enter the code we emailed to': "Votre code est en route. Pour vous connecter entrez le code re\xe7u sur cette adresse email",
    'Your code is on the way. To log in, enter the code we texted to': "Votre code est en route. Pour vous connecter entrez le code re\xe7u sur ce num\xe9ro de t\xe9l\xe9phone",
    'Your passwords must match': "Vos mots de passe doivent \xeatre identiques",
    'It may take a minute to arrive.': 'Cela peut prendre quelques minutes.',
    Website: 'Site web',
    'Password must have at least 8 characters': "Le mot de passe doit comporter au moins 8 caract\xe8res",
    'Password must have upper case letters': "Le mot de passe doit comporter des caract\xe8res majuscules",
    'Password must have numbers': "Le mot de passe doit comporter des caract\xe8res num\xe9riques",
    'Password must have special characters': 'Le mot de passe doit comporter des symboles',
    'Password must have lower case letters': "Le mot de passe doit comporter des caract\xe8res minuscules",
    'Invalid verification code provided, please try again.': "Code de v\xe9rification invalide, veuillez r\xe9essayer.",
    'Attempt limit exceeded, please try after some time.': "Nombre maximum de tentatives d\xe9pass\xe9, veuillez r\xe9essayer plus tard.",
    'A network error has occurred.': "Une erreur de r\xe9seau s'est produite."
};


const $9b53da716c551e27$export$fb0bc00b40b6d1a8 = {
    'A network error has occurred.': "H\xe1l\xf3zati hiba t\xf6rt\xe9nt.",
    'Account recovery requires verified contact information': "A fi\xf3k helyre\xe1ll\xedt\xe1s\xe1hoz hiteles\xedtett kapcsolattart\xe1si adatok sz\xfcks\xe9gesek",
    'Add your Profile': "Profil hozz\xe1ad\xe1sa",
    'Add your Website': "Weboldal hozz\xe1ad\xe1sa",
    'An account with the given email already exists.': "Ezzel az e-mail c\xedmmel m\xe1r l\xe9tezik fi\xf3k.",
    'Attempt limit exceeded, please try after some time.': "Pr\xf3b\xe1lkoz\xe1si limit t\xfall\xe9pve, k\xe9rj\xfck pr\xf3b\xe1lja \xfajra k\xe9s\u0151bb.",
    'Authenticator App (TOTP)': "Hiteles\xedt\u0151 alkalmaz\xe1s (TOTP)",
    'Back to Sign In': "Vissza a bejelentkez\xe9shez",
    Birthdate: "Sz\xfclet\xe9si d\xe1tum",
    'Change Password': "Jelsz\xf3 m\xf3dos\xedt\xe1sa",
    Changing: "M\xf3dos\xedt\xe1s",
    Code: "K\xf3d",
    Confirm: "Meger\u0151s\xedt\xe9s",
    'Confirm a Code': "K\xf3d meger\u0151s\xedt\xe9se",
    'Confirm Email Code': "E-mail k\xf3d meger\u0151s\xedt\xe9se",
    'Confirm MFA Code': "MFA k\xf3d meger\u0151s\xedt\xe9se",
    'Confirm Password': "Jelsz\xf3 meger\u0151s\xedt\xe9se",
    'Confirm Sign In': "Bejelentkez\xe9s meger\u0151s\xedt\xe9se",
    'Confirm Sign Up': "Regisztr\xe1ci\xf3 meger\u0151s\xedt\xe9se",
    'Confirm SMS Code': "SMS k\xf3d meger\u0151s\xedt\xe9se",
    'Confirm TOTP Code': "TOTP k\xf3d meger\u0151s\xedt\xe9se",
    'Confirmation Code': "Meger\u0151s\xedt\u0151 k\xf3d",
    Confirming: "Meger\u0151s\xedt\xe9s",
    'Create a new account': "\xdaj fi\xf3k l\xe9trehoz\xe1sa",
    'Create Account': "Fi\xf3k l\xe9trehoz\xe1sa",
    'Create account': "Fi\xf3k l\xe9trehoz\xe1sa",
    'Creating Account': "Fi\xf3k l\xe9trehoz\xe1sa",
    'Dismiss alert': "Figyelmeztet\xe9s ignor\xe1l\xe1sa",
    Email: 'E-mail',
    'Email Message': "E-mail \xfczenet",
    'Enter your Birthdate': "Adja meg a sz\xfclet\xe9si d\xe1tum\xe1t",
    'Enter your code': "Adja meg a k\xf3dot",
    'Enter your Confirmation Code': "Adja meg a meger\u0151s\xedt\u0151 k\xf3dot",
    'Enter your email': "Adja meg az e-mail c\xedm\xe9t",
    'Enter your Email': "Adja meg az e-mail c\xedm\xe9t",
    'Enter your Family Name': "Adja meg a vezet\xe9knev\xe9t",
    'Enter your Given Name': "Adja meg a keresztnev\xe9t",
    'Enter your Middle Name': "Adja meg m\xe1sodik keresztnev\xe9t (ha van)",
    'Enter your Name': "Adja meg a nev\xe9t",
    'Enter your Nickname': "Adja meg a becenev\xe9t",
    'Enter your password': "Adja meg a jelszav\xe1t",
    'Enter your Password': "Adja meg a jelszav\xe1t",
    'Enter your phone number': "Adja meg a telefonsz\xe1m\xe1t",
    'Enter your Phone Number': "Adja meg a telefonsz\xe1m\xe1t",
    'Enter your Preferred Username': "Adja meg a prefer\xe1lt felhaszn\xe1l\xf3nev\xe9t",
    'Enter your username': "Adja meg a felhaszn\xe1l\xf3nev\xe9t",
    'Enter your Username': "Adja meg a felhaszn\xe1l\xf3nev\xe9t",
    'Family Name': "Vezet\xe9kn\xe9v",
    'Forgot Password': "Elfelejtett jelsz\xf3",
    'Forgot password?': "Elfelejtette a jelszav\xe1t?",
    'Forgot your password?': "Elfelejtette a jelszav\xe1t?",
    'Given Name': "Keresztn\xe9v",
    'Have an account? ': "Van m\xe1r fi\xf3kja? ",
    Hello: "\xdcdv\xf6z\xf6lj\xfck",
    'Hide password': "Jelsz\xf3 elrejt\xe9se",
    'Incorrect username or password': "Helytelen felhaszn\xe1l\xf3n\xe9v vagy jelsz\xf3",
    'Incorrect username or password.': "Helytelen felhaszn\xe1l\xf3n\xe9v vagy jelsz\xf3.",
    'Invalid password format': "\xc9rv\xe9nytelen jelsz\xf3 form\xe1tum",
    'Invalid phone number format': "\xc9rv\xe9nytelen telefonsz\xe1m form\xe1tum",
    'It may take a minute to arrive': "Egy percet ig\xe9nybe vehet, am\xedg meg\xe9rkezik",
    'It may take a minute to arrive.': "Egy percet ig\xe9nybe vehet, am\xedg meg\xe9rkezik.",
    Loading: "Bet\xf6lt\xe9s",
    'Loading...': "Bet\xf6lt\xe9s...",
    'Lost your code? ': "Elvesztette a k\xf3dot? ",
    'Middle Name': "M\xe1sodik keresztn\xe9v",
    'Multi-Factor Authentication': "T\xf6bbfaktoros hiteles\xedt\xe9s",
    'Multi-Factor Authentication Setup': "T\xf6bbfaktoros hiteles\xedt\xe9s fel\xe1ll\xedt\xe1sa",
    Name: "N\xe9v",
    'Network error': "H\xe1l\xf3zati hiba",
    'New Password': "\xdaj jelsz\xf3",
    'New password': "\xdaj jelsz\xf3",
    Nickname: "Becen\xe9v",
    'No account? ': "Nincs m\xe9g fi\xf3kja? ",
    or: 'vagy',
    Password: "Jelsz\xf3",
    'Password attempts exceeded': "Jelsz\xf3 pr\xf3b\xe1lkoz\xe1si limit t\xfall\xe9pve",
    'Password did not conform with policy': "A jelsz\xf3nak tartalmaznia kell kisbet\u0171ket",
    'Password must have lower case letters': "A jelsz\xf3nak tartalmaznia kell kisbet\u0171ket",
    'Password must have numbers': "A jelsz\xf3nak tartalmaznia kell sz\xe1mokat",
    'Password must have special characters': "A jelsz\xf3nak tartalmaznia kell szimb\xf3lumokat",
    'Password must have upper case letters': "A jelsz\xf3nak tartalmaznia kell nagybet\u0171ket",
    'Password not long enough': "Jelsz\xf3 nem el\xe9g hossz\xfa",
    'Password must have at least 8 characters': "A jelsz\xf3nak legal\xe1bb 8 karakterb\u0151l kell \xe1llnia",
    'Phone Number': "Telefonsz\xe1m",
    'Please confirm your Password': "K\xe9rj\xfck, er\u0151s\xedtse meg a jelszav\xe1t",
    'Preferred Username': "Prefer\xe1lt felhaszn\xe1l\xf3n\xe9v",
    Profile: 'Profil',
    'Resend a Code': "K\xf3d \xfajrak\xfcld\xe9se",
    'Resend Code': "K\xf3d \xfajrak\xfcld\xe9se",
    'Reset Password': "\xdaj jelsz\xf3 fel\xe1ll\xedt\xe1sa",
    'Reset password': "\xdaj jelsz\xf3 fel\xe1ll\xedt\xe1sa",
    'Reset your password': "\xdaj jelsz\xf3 fel\xe1ll\xedt\xe1sa",
    'Reset your Password': "\xdaj jelsz\xf3 fel\xe1ll\xedt\xe1sa",
    'Select MFA Type': "MFA t\xedpus kiv\xe1laszt\xe1sa",
    Send: "K\xfcld\xe9s",
    'Send code': "K\xf3d k\xfcld\xe9se",
    'Send Code': "K\xf3d k\xfcld\xe9se",
    Sending: "K\xfcld\xe9s",
    'Setup Email': "E-mail c\xedm be\xe1ll\xedt\xe1sa",
    'Setup TOTP': "TOTP be\xe1ll\xedt\xe1sa",
    'Show password': "Jelsz\xf3 megjelen\xedt\xe9se",
    'Sign In': "Bejelentkez\xe9s",
    'Sign in': "Bejelentkez\xe9s",
    'Sign in to your account': "Jelentkezzen be a fi\xf3kj\xe1ba",
    'Sign In with Amazon': "Bejelentkez\xe9s Amazon-nal",
    'Sign In with Apple': "Bejelentkez\xe9s Apple-lel",
    'Sign In with AWS': "Bejelentkez\xe9s AWS-sel",
    'Sign In with Facebook': "Bejelentkez\xe9s Facebook-kal",
    'Sign In with Google': "Bejelentkez\xe9s Google-lal",
    'Sign out': "Kijelentkez\xe9s",
    'Sign Out': "Kijelentkez\xe9s",
    'Sign up': "Regisztr\xe1ci\xf3",
    'Sign Up': "Regisztr\xe1ci\xf3",
    'Sign Up with Amazon': "Regisztr\xe1ci\xf3 Amazon-nal",
    'Sign Up with Apple': "Regisztr\xe1ci\xf3 Apple-lel",
    'Sign Up with Facebook': "Regisztr\xe1ci\xf3 Facebook-kal",
    'Sign Up with Google': "Regisztr\xe1ci\xf3 Google-lal",
    'Signing in': "Bejelentkez\xe9s",
    Skip: "Kihagy\xe1s",
    SMS: 'SMS',
    Submit: "K\xfcld\xe9s",
    Submitting: "K\xfcld\xe9s",
    'Text Message (SMS)': "SMS \xfczenet",
    'User already exists': "A felhaszn\xe1l\xf3 m\xe1r l\xe9tezik",
    'User does not exist': "Felhaszn\xe1l\xf3 nem tal\xe1lhat\xf3",
    'User is disabled.': "A felhaszn\xe1l\xf3 le van tiltva.",
    Username: "Felhaszn\xe1l\xf3n\xe9v",
    'Username cannot be empty': "A felhaszn\xe1l\xf3n\xe9v mez\u0151 nem lehet \xfcres",
    'Username/client id combination not found.': "Felhaszn\xe1l\xf3n\xe9v/kliens azonos\xedt\xf3 kombin\xe1ci\xf3 nem tal\xe1lhat\xf3.",
    Verify: "Ellen\u0151rz\xe9s",
    'Verify Contact': "Kapcsolat ellen\u0151rz\xe9se",
    'We Emailed You': "K\xfcldt\xfcnk \xd6nnek egy e-mailt",
    'We Sent A Code': "K\xfcldt\xfcnk \xd6nnek egy k\xf3dot",
    'We Texted You': "K\xfcldt\xfcnk \xd6nnek egy SMS-t",
    Website: 'Weboldal',
    'Your code is on the way. To log in, enter the code we emailed to': "A bejelentkez\xe9shez sz\xfcks\xe9ges k\xf3d k\xfcld\xe9se folyamatban van, amelyet a k\xf6vetkez\u0151 e-mail c\xedmre k\xfcldt\xfcnk:",
    'Your code is on the way. To log in, enter the code we sent you': "A bejelentkez\xe9shez sz\xfcks\xe9ges k\xf3d k\xfcld\xe9se folyamatban van",
    'Your code is on the way. To log in, enter the code we texted to': "A bejelentkez\xe9shez sz\xfcks\xe9ges k\xf3d k\xfcld\xe9se folyamatban van, amelyet SMS-ben k\xfcldt\xfcnk a k\xf6vetkez\u0151 sz\xe1mra:",
    'Your passwords must match': "A jelszavaknak meg kell egyezni\xfck"
};


const $1fdbceef7d2638e6$export$5c8da73de176fccc = {
    'Account recovery requires verified contact information': "Il ripristino dell'account richiede informazioni di contatto verificate",
    'Authenticator App (TOTP)': 'App di autenticazione (TOTP)',
    'Back to Sign In': 'Torna alla schermata di accesso',
    'Change Password': 'Cambia la password',
    Changing: 'Modifica in corso',
    Code: 'Codice',
    'Confirm Email Code': 'Conferma codice e-mail',
    'Confirm Password': 'Conferma la password',
    'Confirm Sign Up': 'Conferma registrazione',
    'Confirm SMS Code': 'Conferma codice SMS',
    'Confirm TOTP Code': 'Conferma codice TOTP',
    Confirm: 'Conferma',
    'Confirmation Code': 'Codice di verifica',
    Confirming: 'Conferma in corso',
    'Create a new account': 'Crea un nuovo account',
    'Create Account': 'Crea Account',
    'Creating Account': 'Creazione account in corso',
    'Dismiss alert': `Ignora l'avviso`,
    Email: 'Email',
    'Email Message': 'Messaggio e-mail',
    'Enter your code': 'Inserisci il tuo codice',
    'Enter your Email': 'Inserisci la tua e-mail',
    'Enter your phone number': 'Inserisci il tuo numero di telefono"',
    'Enter your username': 'Inserisci il tuo nome utente',
    'Forgot your password?': 'Password dimenticata?',
    'Hide password': 'Nascondi password',
    'It may take a minute to arrive': "L'arrivo potrebbe richiedere qualche minuto",
    Loading: 'Caricamento in corso',
    'Multi-Factor Authentication': "Autenticazione a pi\xf9 fattori",
    'Multi-Factor Authentication Setup': "Configurazione dell'autenticazione a pi\xf9 fattori",
    'New password': 'Nuova password',
    or: 'oppure',
    Password: 'Password',
    'Phone Number': 'Numero di telefono',
    'Resend Code': 'Invia nuovamente il codice',
    'Reset your Password': 'Reimposta la tua Password',
    'Reset your password': 'Reimposta la tua password',
    'Select MFA Type': 'Seleziona il tipo di MFA',
    'Send code': 'Invia codice',
    'Send Code': 'Invia codice',
    Sending: 'Invio in corso',
    'Setup Email': "Configura l'e-mail",
    'Setup TOTP': 'Configura TOTP',
    'Show password': 'Mostra password',
    'Sign in to your account': 'Accedi al tuo account',
    'Sign In with Amazon': 'Accedi con Amazon',
    'Sign In with Apple': 'Accedi con Apple',
    'Sign In with Facebook': 'Accedi con Facebook',
    'Sign In with Google': 'Accedi con Google',
    'Sign in': 'Accedi',
    'Sign In': 'Accedi',
    'Signing in': 'Accesso in corso',
    Skip: 'Salta',
    Submit: 'Invia',
    Submitting: 'Invio in corso',
    'Text Message (SMS)': 'Messaggio di testo (SMS)',
    Username: 'Nome utente',
    'Verify Contact': 'Verifica contatto',
    Verify: 'Verifica',
    'We Emailed You': "Ti abbiamo inviato un'e-mail",
    'We Sent A Code': 'Ti abbiamo inviato un codice',
    'We Texted You': 'Ti abbiamo inviato un SMS',
    'Your code is on the way. To log in, enter the code we emailed to': "Il codice \xe8 in arrivo. Per effettuare l'accesso, immetti il codice che ti abbiamo inviato via e-mail",
    'Your code is on the way. To log in, enter the code we sent you': "Il codice \xe8 in arrivo. Per accedere, immetti il codice che ti abbiamo inviato",
    'Your code is on the way. To log in, enter the code we texted to': "Il codice \xe8 in arrivo. Per accedere, immetti il codice che abbiamo inviato tramite SMS",
    // Additional translations provided by customers
    'An account with the given email already exists.': "Questa email \xe8 gi\xe0 utilizzata da un altro account.",
    'Confirm a Code': 'Conferma un codice',
    'Confirm Sign In': "Conferma l'accesso",
    'Create account': 'Crea account',
    'Enter your password': 'Inserisci la tua password',
    'Forgot Password?': 'Password dimenticata?',
    'Have an account? ': "Gi\xe0 registrato?",
    'Incorrect username or password': 'Nome utente o password errati',
    'Incorrect username or password.': 'Nome utente o password errati',
    'Invalid password format': 'Formato della password non valido',
    'Invalid phone number format': 'Formato del numero di telefono non valido',
    'Lost your code?': 'Codice smarrito?',
    'New Password': 'Nuova password',
    'No account? ': 'Non hai un account?',
    'Password attempts exceeded': "Il numero massimo di tentativi di accesso falliti \xe8 stato raggiunto",
    'Reset password': 'Reimposta password',
    'Sign Out': 'Esci',
    'Sign Up': 'Registrati',
    'User already exists': "Utente gi\xe0 esistente",
    'User does not exist': 'Utente inesistente',
    'Username cannot be empty': "Il nome utente non pu\xf2 essere vuoto"
};


const $556689013d66e172$export$c416809cd76fbf21 = {
    'Account recovery requires verified contact information': "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u5FA9\u65E7\u306B\u306F\u78BA\u8A8D\u6E08\u307F\u306E\u9023\u7D61\u5148\u304C\u5FC5\u8981\u3067\u3059",
    'Authenticator App (TOTP)': "\u8A8D\u8A3C\u30A2\u30D7\u30EA (TOTP)",
    'Back to Sign In': "\u30B5\u30A4\u30F3\u30A4\u30F3\u306B\u623B\u308B",
    'Change Password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u3048\u308B ",
    Changing: "\u5909\u66F4\u4E2D",
    Code: "\u30B3\u30FC\u30C9",
    'Confirm Email Code': "E \u30E1\u30FC\u30EB\u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    'Confirm Password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D",
    'Confirm Sign Up': "\u767B\u9332\u3059\u308B",
    'Confirm SMS Code': "SMS \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    'Confirm TOTP Code': "TOTP \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    Confirm: "\u78BA\u5B9A",
    'Confirmation Code': "\u78BA\u8A8D\u30B3\u30FC\u30C9",
    Confirming: "\u78BA\u8A8D\u4E2D",
    'Create a new account': "\u65B0\u3057\u3044\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
    'Create Account': "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
    'Creating Account': "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u4F5C\u6210\u4E2D",
    'Dismiss alert': "\u30A2\u30E9\u30FC\u30C8\u3092\u9589\u3058\u308B",
    Email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
    'Email Message': "E \u30E1\u30FC\u30EB\u30E1\u30C3\u30BB\u30FC\u30B8",
    'Enter your code': "\u30B3\u30FC\u30C9\u3092\u5165\u529B",
    'Enter your Email': "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B",
    'Enter your phone number': "\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B",
    'Enter your username': "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u5165\u529B ",
    'Enter your Username': "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u5165\u529B ",
    'Forgot your password?': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u307E\u3057\u305F\u304B\uFF1F ",
    'Hide password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u975E\u8868\u793A",
    'It may take a minute to arrive': "\u5230\u7740\u3059\u308B\u307E\u3067\u306B 1 \u5206\u304B\u304B\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059",
    Loading: "\u30ED\u30FC\u30C9\u4E2D",
    'Multi-Factor Authentication': "\u591A\u8981\u7D20\u8A8D\u8A3C",
    'Multi-Factor Authentication Setup': "\u591A\u8981\u7D20\u8A8D\u8A3C\u306E\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7",
    'New password': "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
    or: "\u53C8\u306F",
    Password: "\u30D1\u30B9\u30EF\u30FC\u30C9 ",
    'Phone Number': "\u96FB\u8A71\u756A\u53F7",
    'Resend Code': "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
    'Reset your Password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
    'Reset your password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B",
    'Select MFA Type': "MFA \u30BF\u30A4\u30D7\u3092\u9078\u629E",
    'Send code': "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
    'Send Code': "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
    Sending: "\u9001\u4FE1\u4E2D",
    'Setup Email': "E \u30E1\u30FC\u30EB\u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7",
    'Setup TOTP': "TOTP \u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7",
    'Show password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8868\u793A",
    'Sign in to your account': "\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30B5\u30A4\u30F3\u30A4\u30F3 ",
    'Sign In with Amazon': "Amazon\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    'Sign In with Apple': "Apple \u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    'Sign In with Facebook': "Facebook\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    'Sign In with Google': "Google\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    'Sign In': "\u30B5\u30A4\u30F3\u30A4\u30F3 ",
    'Sign in': "\u30B5\u30A4\u30F3\u30A4\u30F3",
    'Signing in': "\u30B5\u30A4\u30F3\u30A4\u30F3\u4E2D",
    Skip: "\u30B9\u30AD\u30C3\u30D7",
    Submit: "\u9001\u4FE1",
    Submitting: "\u9001\u4FE1\u4E2D",
    'Text Message (SMS)': "\u30C6\u30AD\u30B9\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8 (SMS)",
    Username: "\u30E6\u30FC\u30B6\u30FC\u540D ",
    'Verify Contact': "\u9023\u7D61\u5148\u3092\u78BA\u8A8D",
    Verify: "\u78BA\u8A8D",
    'We Sent A Code': "\u30B3\u30FC\u30C9\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F",
    'We Texted You': "\u30C6\u30AD\u30B9\u30C8\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F",
    'Your code is on the way. To log in, enter the code we sent you': "\u30B3\u30FC\u30C9\u304C\u9014\u4E2D\u3067\u3059\u3002\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u9001\u4FE1\u3057\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    // Additional translations provided by customers
    'An account with the given email already exists.': "\u5165\u529B\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059",
    'Confirm a Code': "\u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    'Confirm Sign In': "\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B",
    'Create account': "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B ",
    'Enter your password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B ",
    'Enter your Password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B",
    'Please confirm your Password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B",
    'Forgot Password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u305F ",
    'Have an account? ': "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6301\u3063\u3066\u3044\u307E\u3059\u304B\uFF1F",
    'Incorrect username or password': "\u30E6\u30FC\u30B6\u30FC\u540D\u304B\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u7570\u306A\u308A\u307E\u3059 ",
    'Incorrect username or password.': "\u30E6\u30FC\u30B6\u30FC\u540D\u304B\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u7570\u306A\u308A\u307E\u3059 ",
    'Invalid password format': "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5F62\u5F0F\u304C\u7121\u52B9\u3067\u3059 ",
    'Invalid phone number format': "\u4E0D\u6B63\u306A\u96FB\u8A71\u756A\u53F7\u306E\u5F62\u5F0F\u3067\u3059\u3002\n+12345678900 \u306E\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    'It may take a minute to arrive.': "\u30B3\u30FC\u30C9\u3092\u53D7\u4FE1\u3059\u308B\u307E\u3067\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002",
    'Lost your code? ': "\u30B3\u30FC\u30C9\u3092\u5931\u304F\u3057\u307E\u3057\u305F\u304B\uFF1F",
    'New Password': "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
    'No account? ': "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u3044\u3068\u304D ",
    'Password attempts exceeded': "\u30B5\u30A4\u30F3\u30A4\u30F3\u306E\u8A66\u884C\u56DE\u6570\u304C\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F",
    'Reset password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8 ",
    'Reset Password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
    'Sign Out': "\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8 ",
    'Sign Up': "\u767B\u9332 ",
    'User already exists': "\u65E2\u306B\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u3066\u3044\u307E\u3059 ",
    'User does not exist': "\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u307E\u305B\u3093 ",
    'Username cannot be empty': "\u30E6\u30FC\u30B6\u30FC\u540D\u306F\u5165\u529B\u5FC5\u9808\u3067\u3059",
    'We Emailed You': "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F",
    'Your code is on the way. To log in, enter the code we emailed to': "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30E1\u30FC\u30EB\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:",
    'Your code is on the way. To log in, enter the code we texted to': "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30C6\u30AD\u30B9\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:"
};


const $84cd8249babd4f6a$export$fb1930c2b96707b2 = {
    'Account recovery requires verified contact information': "\uACC4\uC815 \uBCF5\uAD6C\uB97C \uC704\uD574 \uC5F0\uB77D\uCC98 \uD655\uC778\uC774 \uD544\uC694\uD569\uB2C8\uB2E4",
    'Authenticator App (TOTP)': "\uC778\uC99D \uC571(TOTP)",
    'Back to Sign In': "\uB85C\uADF8\uC778\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30",
    'Change Password': "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD\uD558\uAE30",
    Changing: "\uBCC0\uACBD\uC911",
    Code: "\uCF54\uB4DC",
    'Confirm Email Code': "\uC774\uBA54\uC77C \uCF54\uB4DC \uD655\uC778",
    'Confirm Password': "\uBE44\uBC00\uBC88\uD638 \uC7AC\uD655\uC778",
    'Confirm Sign Up': "\uD68C\uC6D0\uAC00\uC785 \uD655\uC778",
    'Confirm SMS Code': "\uD734\uB300\uD3F0 \uBCF8\uC778 \uD655\uC778",
    'Confirm TOTP Code': "TOTP \uC778\uC99D\uBC88\uD638 \uD655\uC778",
    Confirm: "\uD655\uC778",
    'Confirmation Code': "\uC778\uC99D\uBC88\uD638",
    Confirming: "\uD655\uC778\uC911",
    'Create a new account': "\uD68C\uC6D0\uAC00\uC785",
    'Create Account': "\uD68C\uC6D0\uAC00\uC785",
    'Creating Account': "\uD68C\uC6D0\uAC00\uC785\uC911",
    'Dismiss alert': "\uC54C\uB9BC \uBB34\uC2DC",
    Email: "\uC774\uBA54\uC77C",
    'Email Message': "\uC774\uBA54\uC77C \uBA54\uC2DC\uC9C0",
    'Enter your Birthdate': "\uC0DD\uB144\uC6D4\uC77C \uC785\uB825",
    'Enter your code': "\uC778\uC99D\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
    'Enter your Confirmation Code': "\uD655\uC778 \uCF54\uB4DC \uC785\uB825",
    'Enter your Email': "\uC774\uBA54\uC77C \uC785\uB825",
    'Enter your Family Name': "\uC131 \uC785\uB825",
    'Enter your Given Name': "\uC0AC\uC6A9\uC7A5 \uC774\uB984 \uC785\uB825",
    'Enter your Name': "\uC774\uB984 \uC785\uB825",
    'Enter your Nickname': "\uB2C9\uB124\uC784 \uC785\uB825",
    'Enter your Password': "\uBE44\uBC00\uBC88\uD638 \uC785\uB825",
    'Enter your phone number': "\uC804\uD654\uBC88\uD638 \uC785\uB825",
    'Enter your Preferred Username': "\uC120\uD638\uD558\uB294 \uC544\uC774\uB514 \uC785\uB825",
    'Enter your username': "\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
    'Forgot password?': "\uBE44\uBC00\uBC88\uD638\uB97C \uC78A\uC73C\uC168\uB098\uC694?",
    'Hide password': "\uBE44\uBC00\uBC88\uD638 \uC228\uAE30\uAE30",
    'It may take a minute to arrive': "\uB3C4\uCC29\uD558\uB294 \uB370 1\uBD84 \uC815\uB3C4 \uAC78\uB9B4 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    Loading: "\uB85C\uB529\uC911",
    'Multi-Factor Authentication': "\uB2E4\uC911 \uC778\uC99D",
    'Multi-Factor Authentication Setup': "\uB2E4\uC911 \uC778\uC99D \uC124\uC815",
    'New password': "\uC0C8 \uBE44\uBC00\uBC88\uD638",
    or: "\uB610\uB294",
    Password: "\uBE44\uBC00\uBC88\uD638",
    'Phone Number': "\uC804\uD654\uBC88\uD638",
    'Please confirm your Password': "\uBE44\uBC00\uBC88\uD638\uB97C \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
    'Resend Code': "\uC778\uC99D\uBC88\uD638 \uC7AC\uC804\uC1A1",
    'Reset your password': "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    'Reset your Password': "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    'Select MFA Type': "MFA \uC720\uD615 \uC120\uD0DD",
    'Send code': "\uC778\uC99D\uCF54\uB4DC \uBCF4\uB0B4\uAE30",
    'Send Code': "\uCF54\uB4DC \uC804\uC1A1",
    Sending: "\uC804\uC1A1\uC911",
    'Setup Email': "\uC774\uBA54\uC77C \uC124\uC815",
    'Setup TOTP': "TOTP \uC124\uC815\uD558\uAE30",
    'Show password': "\uBE44\uBC00\uBC88\uD638 \uBCF4\uC774\uAE30",
    'Sign in to your account': "\uB85C\uADF8\uC778",
    'Sign In with Amazon': "Amazon \uB85C\uADF8\uC778",
    'Sign In with Apple': "Apple \uB85C\uADF8\uC778",
    'Sign In with Facebook': "Facebook \uB85C\uADF8\uC778",
    'Sign In with Google': "Google \uB85C\uADF8\uC778",
    'Sign in': "\uB85C\uADF8\uC778",
    'Sign In': "\uB85C\uADF8\uC778",
    'Signing in': "\uB85C\uADF8\uC778\uC911",
    Skip: "\uB2E4\uC74C\uC5D0 \uD558\uAE30",
    Submit: "\uD655\uC778",
    Submitting: "\uD655\uC778\uC911",
    'Text Message (SMS)': "\uBB38\uC790 \uBA54\uC2DC\uC9C0(SMS)",
    Username: "\uC544\uC774\uB514",
    'Verify Contact': "\uC5F0\uB77D\uCC98 \uD655\uC778",
    Verify: "\uC778\uC99D",
    'We Emailed You': "\uC774\uBA54\uC77C\uC744 \uBCF4\uB0C4",
    'We Sent A Code': "\uCF54\uB4DC\uB97C \uBCF4\uB0C4",
    'We Texted You': "\uBB38\uC790 \uBA54\uC2DC\uC9C0\uB97C \uBCF4\uB0C4",
    'Your code is on the way. To log in, enter the code we emailed to': "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uC774\uBA54\uC77C\uB85C \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
    'Your code is on the way. To log in, enter the code we sent you': "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
    'Your code is on the way. To log in, enter the code we texted to': "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uBB38\uC790 \uBA54\uC2DC\uC9C0\uB85C \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
    // Additional translations provided by customers
    Birthdate: "\uC0DD\uB144\uC6D4\uC77C",
    'Family Name': "\uC131",
    'Forgot your password?': "\uBE44\uBC00\uBC88\uD638\uB97C \uC78A\uC73C\uC168\uB098\uC694?",
    'Given Name': "\uC774\uB984",
    Name: "\uC131\uD568",
    Nickname: "\uB2C9\uB124\uC784",
    'Preferred Username': "\uB2C9\uB124\uC784",
    Profile: "\uD504\uB85C\uD544",
    'Reset Password': "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    Website: "\uC6F9\uC0AC\uC774\uD2B8"
};


const $1b4d4745c302acff$export$c27bce1749452052 = {
    'Account recovery requires verified contact information': 'Gjenoppretting av konto krever verifisert kontaktinformajson',
    'Add your Profile': 'Legg til profilen din',
    'Add your Website': 'Legg til nettsiden din',
    'Authenticator App (TOTP)': 'Autentiseringsapp (TOTP)',
    'Back to Sign In': 'Tilbake til innlogging',
    'Change Password': 'Bytt passord',
    Changing: 'Endre',
    Code: 'Kode',
    'Confirm Email Code': 'Bekreft e-postkode',
    'Confirm Password': 'Bekreft passordet',
    'Confirm Sign Up': 'Bekreft registrering',
    'Confirm SMS Code': 'Bekreft SMS-kode',
    'Confirm TOTP Code': 'Bekreft TOTP-kode',
    Confirm: 'Bekreft',
    'Confirmation Code': 'Bekreftelseskode',
    Confirming: 'Bekrefter',
    'Create a new account': 'Opprett en ny konto',
    'Create Account': 'Opprett konto',
    'Creating Account': 'Oppretter konto',
    'Dismiss alert': 'Avvis varsel',
    Email: 'E-post',
    'Email Message': 'E-postmelding',
    'Enter your Birthdate': "Skriv inn f\xf8dselsdatoen din",
    'Enter your code': 'Skriv inn koden din',
    'Enter your Confirmation Code': 'Skriv inn bekreftelseskoden din',
    'Enter your Email': 'Skriv inn e-postadressen din',
    'Enter your Family Name': 'Skriv inn etternavnet ditt',
    'Enter your Given Name': 'Skriv inn fornavnet ditt',
    'Enter your Middle Name': 'Skriv inn mellomnavnet ditt',
    'Enter your Name': 'Skriv inn navnet ditt',
    'Enter your Nickname': 'Skriv inn kallenavnet ditt',
    'Enter your Password': 'Skriv inn passordet ditt',
    'Enter your phone number': 'Skriv inn telefonnummeret ditt',
    'Enter your Preferred Username': 'Skriv inn det foretrukne brukernavnet ditt',
    'Enter your username': 'Skriv inn brukernavnet ditt',
    'Forgot password?': 'Glemt passord?',
    'Forgot your password?': 'Glemt passordet ditt?',
    'Hide password': 'Skjul passordet',
    'It may take a minute to arrive': "Det kan ta et minutt for \xe5 komme frem",
    Loading: 'Laster inn',
    'Multi-Factor Authentication': 'Flerfaktorautentisering',
    'Multi-Factor Authentication Setup': 'Oppsett av flerfaktorautentisering',
    'New password': 'Nytt passord',
    or: 'eller',
    Password: 'Passord',
    'Phone Number': 'Telefonnummer',
    'Please confirm your Password': 'Vennligst bekreft passordet ditt',
    'Resend Code': "Send koden p\xe5 nytt",
    'Reset your password': 'Nullstill passordet ditt',
    'Reset your Password': 'Nullstill passordet ditt',
    'Select MFA Type': 'Velg MFA-type',
    'Send code': 'Send kode',
    'Send Code': 'Send kode',
    Sending: 'Sender',
    'Setup Email': 'Konfigurer e-post',
    'Setup TOTP': 'Konfigurer TOTP',
    'Show password': 'Vis passordet',
    'Sign in to your account': "Logg inn p\xe5 kontoen din",
    'Sign In with Amazon': 'Logg inn med Amazon',
    'Sign In with Apple': 'Logg inn med Apple',
    'Sign In with Facebook': 'Logg inn med Facebook',
    'Sign In with Google': 'Logg inn med Google',
    'Sign in': 'Logg inn',
    'Sign In': 'Logg inn',
    'Signing in': 'Logger inn',
    Skip: 'Hopp over',
    Submit: 'Send inn',
    Submitting: 'Sender inn',
    'Text Message (SMS)': 'Tekstmelding (SMS)',
    Username: 'Brukernavn',
    'Verify Contact': 'Bekreft kontakt',
    Verify: 'Bekreft',
    'We Emailed You': 'Vi sendte deg en e-post',
    'We Sent A Code': 'Vi sendte en kode',
    'We Texted You': 'Vi sendte deg en tekstmelding',
    'Your code is on the way. To log in, enter the code we emailed to': "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte e-post til",
    'Your code is on the way. To log in, enter the code we sent you': "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte deg",
    'Your code is on the way. To log in, enter the code we texted to': "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte tekstmelding til",
    // Additional translations provided by customers
    'An account with the given email already exists.': 'Det finnes allerede en konto med denne e-postadressen',
    'Confirm a Code': 'Bekreft koden',
    'Confirm Sign In': 'Bekreft innlogging',
    'Create account': 'Opprett konto',
    'Enter your password': 'Skriv inn passordet ditt',
    'Forgot Password': 'Glemt passordet',
    'Have an account? ': 'Har en konto allerede? ',
    'Incorrect username or password': 'Feil brukernavn eller passord',
    'Incorrect username or password.': 'Feil brukernavn eller passord',
    'Invalid password format': 'Ugyldig passordformat',
    'Invalid phone number format': 'Ugyldig telefonnummerformat',
    'Lost your code? ': 'Mistet koden? ',
    'New Password': 'Nytt passord',
    'No account? ': 'Ingen konto? ',
    'Password attempts exceeded': "For mange mislykkede passordfors\xf8k",
    'Reset password': 'Nullstill passord',
    'Sign Out': 'Logg ut',
    'Sign Up': 'Registrering',
    'User already exists': 'Brukeren finnes allerede',
    'User does not exist': 'Brukeren finnes ikke',
    'Username cannot be empty': "Brukernavnet kan ikke v\xe6re tomt"
};


const $21313c82790e2217$export$8569df33fbaae243 = {
    'Account recovery requires verified contact information': 'Accountherstel vereist geverifieerde contactgegevens',
    'Authenticator App (TOTP)': 'Authenticator-app (TOTP)',
    'Back to Sign In': 'Terug naar inloggen',
    'Change Password': 'Wachtwoord wijzigen',
    Changing: 'Wordt aangepast',
    Code: 'Code',
    'Confirm Email Code': 'E-mailcode bevestigen',
    'Confirm Password': 'Bevestig Wachtwoord',
    'Confirm Sign Up': 'Bevestig inschrijving',
    'Confirm SMS Code': 'Bevestig SMS Code',
    'Confirm TOTP Code': 'Bevestig TOTP Code',
    Confirm: 'Bevestig',
    'Confirmation Code': 'Bevestigingscode',
    Confirming: 'Bevestigen',
    'Create a new account': 'Nieuw account aanmaken',
    'Create Account': 'Account aanmaken',
    'Creating Account': 'Account wordt aangemaakt',
    'Dismiss alert': 'Waarschuwing sluiten',
    Email: 'E-mail',
    'Email Message': 'E-mailbericht',
    'Enter your code': 'Vul je code in',
    'Enter your Email': 'Vul je e-mail in',
    'Enter your Password': 'Vul je wachtwoord in',
    'Enter your phone number': 'Vul je telefoonnummer in',
    'Enter your username': 'Vul je gebruikersnaam in',
    'Enter your Username': 'Vul je gebruikersnaam in',
    'Forgot your password?': 'Wachtwoord vergeten? ',
    'Hide password': 'Verberg wachtwoord',
    'It may take a minute to arrive': 'Het kan even duren voordat deze aankomt',
    Loading: 'Laden',
    'Multi-Factor Authentication': 'Multi-Factor Authentication',
    'Multi-Factor Authentication Setup': 'Multi-Factor Authentication instellen',
    'New password': 'Nieuw wachtwoord',
    'New Password': 'Nieuw Wachtwoord',
    or: 'of',
    Password: 'Wachtwoord',
    'Phone Number': 'Telefoonnummer',
    'Please confirm your Password': 'Bevestig je wachtwoord',
    'Resend Code': 'Verstuur code nogmaals',
    'Reset Password': 'Wachtwoord resetten',
    'Reset your password': 'Reset je wachtwoord',
    'Reset your Password': 'Wachtwoord resetten',
    'Select MFA Type': 'MFA-type kiezen',
    'Send code': 'Verstuur code',
    'Send Code': 'Verstuur Code',
    Sending: 'Versturen',
    'Setup Email': 'E-mailadres instellen',
    'Setup TOTP': 'TOTP Instellingen',
    'Show password': 'Toon wachtwoord',
    'Sign in to your account': 'Inloggen op je account',
    'Sign In with Amazon': 'Inloggen met Amazon',
    'Sign In with Apple': 'Inloggen met Apple',
    'Sign In with Facebook': 'Inloggen met Facebook',
    'Sign In with Google': 'Inloggen met Google',
    'Sign in': 'Inloggen',
    'Sign In': 'Inloggen',
    'Signing in': 'Inloggen',
    Skip: 'Overslaan',
    Submit: 'Versturen',
    Submitting: 'Wordt verstuurd',
    'Text Message (SMS)': 'Tekstbericht (sms)',
    Username: 'Gebruikersnaam',
    'Verify Contact': 'Verifieer Contact',
    Verify: 'Verifieer',
    'We Emailed You': 'We hebben u een e-mail gestuurd',
    'We Sent A Code': 'We hebben een code gestuurd',
    'We Texted You': 'We hebben u een sms gestuurd',
    'Your code is on the way. To log in, enter the code we emailed to': 'Uw code is onderweg. Om in te loggen, voer de code in die we gemaild hebben naar',
    'Your code is on the way. To log in, enter the code we sent you': 'Uw code is onderweg. Om in te loggen, voer de code in die we u hebben gestuurd',
    'Your code is on the way. To log in, enter the code we texted to': 'Uw code is onderweg. Om in te loggen, voer de code in die we hebben gestuurd naar',
    'Your passwords must match': 'Je wachtwoorden moeten overeenkomen'
};


const $1da5ad2afd54787b$export$6fb0e8139f7ef98d = {
    'Account recovery requires verified contact information': 'Odzyskanie konta wymaga zweryfikowanych danych kontaktowych',
    'Authenticator App (TOTP)': 'Aplikacja uwierzytelniania (TOTP)',
    'Back to Sign In': "Powr\xf3t do logowania",
    'Change Password': "Zmie\u0144 has\u0142o",
    Changing: 'Zmienianie',
    Code: 'Kod',
    'Confirm Email Code': "Potwierd\u017A kod e-mail",
    'Confirm Password': "Potwierd\u017A Has\u0142o",
    'Confirm Sign Up': "Potwierd\u017A rejestracj\u0119",
    'Confirm SMS Code': "Potwierd\u017A kod SMS",
    'Confirm TOTP Code': "Potwierd\u017A has\u0142o jednorazowe",
    Confirm: "Potwierd\u017A",
    'Confirmation Code': 'Kod potwierdzenia',
    Confirming: 'Potwierdzanie',
    'Create a new account': "Utw\xf3rz nowe konto",
    'Create Account': "Utw\xf3rz konto",
    'Creating Account': 'Tworzenie konta',
    'Dismiss alert': "Odrzu\u0107 alert",
    Email: 'E-mail',
    'Email Message': "Wiadomo\u015B\u0107 e-mail",
    'Enter your code': "Wprowad\u017A sw\xf3j kod",
    'Enter your Email': "Wpisz sw\xf3j adres e-mail",
    'Enter your phone number': "Wpisz sw\xf3j numer telefonu",
    'Enter your username': "Wprowad\u017A swoj\u0105 nazw\u0119 u\u017Cytkownika",
    'Forgot your password?': "Zapomnia\u0142e\u015B has\u0142a? ",
    'Hide password': "Ukryj has\u0142o",
    'It may take a minute to arrive': "Mo\u017Ce to chwil\u0119 potrwa\u0107",
    Loading: "\u0141adowanie",
    'Multi-Factor Authentication': "Uwierzytelnianie wielosk\u0142adnikowe",
    'Multi-Factor Authentication Setup': "Konfigurowanie uwierzytelniania wielosk\u0142adnikowego",
    'New password': "Nowe has\u0142o",
    or: 'albo',
    Password: "Has\u0142o",
    'Phone Number': 'Numer telefonu',
    'Resend Code': "Wy\u015Blij kod ponownie",
    'Reset your password': "Zresetuj swoje has\u0142o",
    'Reset your Password': "Zresetuj swoje has\u0142o",
    'Select MFA Type': 'Wybierz typ MFA',
    'Send code': "Wy\u015Blij kod",
    'Send Code': "Zresetuj has\u0142o",
    Sending: "Wysy\u0142anie",
    'Setup Email': 'Konfiguracja poczty e-mail',
    'Setup TOTP': 'Konfiguruj TOTP',
    'Show password': "Poka\u017C has\u0142o",
    'Sign in to your account': "Zaloguj si\u0119 na swoje konto",
    'Sign In with Amazon': 'Zaloguj z Amazon',
    'Sign In with Apple': 'Zaloguj z Apple',
    'Sign In with Facebook': 'Zaloguj z Facebook',
    'Sign In with Google': 'Zaloguj z Google',
    'Sign In': 'Logowanie',
    'Sign in': 'Zaloguj',
    'Signing in': 'Logowanie',
    Skip: "Pomi\u0144",
    Submit: "Wy\u015Blij",
    Submitting: "Wysy\u0142anie",
    'Text Message (SMS)': "Wiadomo\u015B\u0107 tekstowa (SMS)",
    Username: "Nazwa u\u017Cytkownika",
    'Verify Contact': 'Weryfikacja danych kontaktowych',
    Verify: 'Zweryfikuj',
    // Additional translations provided by customers
    Birthdate: 'Data urodzenia',
    'Family Name': 'Nazwisko',
    'Given Name': "Pierwsze imi\u0119",
    'Middle Name': "Drugie imi\u0119",
    Name: "Imi\u0119 i nazwisko",
    Nickname: 'Pseudonim',
    'Preferred Username': "Preferowana nazwa u\u017Cytkownika",
    Profile: 'Profil',
    Website: 'Strona internetowa',
    'We Emailed You': "Wys\u0142ali\u015Bmy Ci wiadomo\u015B\u0107 e-mail",
    'We Sent A Code': "Wys\u0142ali\u015Bmy kod",
    'We Texted You': "Wys\u0142ali\u015Bmy Ci wiadomo\u015B\u0107 SMS",
    'Your code is on the way. To log in, enter the code we emailed to': "Tw\xf3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A kod wys\u0142any na adres e-mail",
    'Your code is on the way. To log in, enter the code we sent you': "Tw\xf3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A wys\u0142any do Ciebie kod",
    'Your code is on the way. To log in, enter the code we texted to': "Tw\xf3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A kod wys\u0142any do Ciebie w wiadomo\u015Bci SMS pod numer"
};


const $acd4011263720517$export$c7dddbf179b434d1 = {
    'Account recovery requires verified contact information': "A recupera\xe7\xe3o da conta requer informa\xe7\xf5es de contato verificadas",
    'Authenticator App (TOTP)': 'Aplicativo autenticador (TOTP)',
    'Add your Profile': 'Adicione seu Perfil',
    'Add your Website': 'Adicione seu Website',
    'Back to Sign In': 'Voltar para Entrar',
    'Change Password': 'Mudar senha',
    Changing: 'Mudando',
    Code: "C\xf3digo",
    'Confirm Email Code': "Confirmar c\xf3digo de e-mail",
    'Confirm Password': 'Confirme a Senha',
    'Confirm Sign Up': "Confirmar inscri\xe7\xe3o",
    'Confirm SMS Code': "Confirme o c\xf3digo SMS",
    'Confirm MFA Code': "Confirme o c\xf3digo MFA",
    'Confirm TOTP Code': "Confirme o c\xf3digo TOTP",
    Confirm: 'confirme',
    'Confirmation Code': "C\xf3digo de confirma\xe7\xe3o",
    Confirming: 'Confirmando',
    'Create a new account': 'Criar uma nova conta',
    'Create Account': 'Criar Conta',
    'Creating Account': 'Criando conta',
    'Dismiss alert': 'Descartar alerta',
    Email: 'O email',
    'Email Message': 'Mensagem de e-mail',
    'Enter your Birthdate': 'Digite sua Data de Nascimento',
    'Enter your code': "Insira seu c\xf3digo",
    'Enter your Confirmation Code': "Digite seu c\xf3digo de confirma\xe7\xe3o",
    'Enter your Email': 'Digite seu e-mail',
    'Enter your Family Name': 'Digite seu Sobrenome',
    'Enter your Given Name': 'Digite seu Primeiro Nome',
    'Enter your Middle Name': 'Digite seu Nome do Meio',
    'Enter your Name': 'Digite seu Nome',
    'Enter your Nickname': 'Digite seu Apelido',
    'Enter your Password': 'Digite sua senha',
    'Enter your phone number': "Digite seu n\xfamero de telefone",
    'Enter your Preferred Username': "Digite seu nome de usu\xe1rio preferido",
    'Enter your username': "Digite seu nome de usu\xe1rio",
    'Forgot password?': 'Esqueceu a senha?',
    'Forgot your password?': 'Esqueceu sua senha?',
    'Hide password': 'Esconder a senha',
    'It may take a minute to arrive': 'Pode levar um minuto para chegar',
    Loading: 'Carregando',
    'Multi-Factor Authentication': "Autentica\xe7\xe3o multifator",
    'Multi-Factor Authentication Setup': "Configura\xe7\xe3o da autentica\xe7\xe3o multifator",
    'New password': 'Nova Senha',
    or: 'ou',
    Password: 'Senha',
    'Phone Number': "N\xfamero de telefone",
    'Please confirm your Password': 'Por favor confirme sua Senha',
    'Resend Code': "Reenviar c\xf3digo",
    'Reset your password': 'Redefina sua senha',
    'Reset your Password': 'Redefina sua senha',
    'Select MFA Type': 'Selecionar tipo de MFA',
    'Send code': "Enviar c\xf3digo",
    'Send Code': "Enviar c\xf3digo",
    Sending: 'Enviando',
    'Setup Email': 'Configurar e-mail',
    'Setup TOTP': 'Configurar TOTP',
    'Show password': 'Mostrar senha',
    'Sign in to your account': "Fa\xe7a login em sua conta",
    'Sign In with Amazon': 'Entrar com a Amazon',
    'Sign In with Apple': 'Entrar com a Apple',
    'Sign In with Facebook': 'Entrar com o Facebook',
    'Sign In with Google': "Fa\xe7a login no Google",
    'Sign in': 'Entrar',
    'Sign In': 'Entrar',
    'Signing in': 'Entrando',
    Skip: 'Pular',
    Submit: 'Enviar',
    Submitting: 'Enviando',
    'Text Message (SMS)': 'Mensagem de texto (SMS)',
    Username: "Nome do usu\xe1rio",
    'Verify Contact': 'Verificar contato',
    Verify: 'Verificar',
    'We Emailed You': "Enviamos um e-mail para voc\xea",
    'We Sent A Code': "Enviamos um c\xf3digo",
    'We Texted You': "Enviamos um SMS para voc\xea",
    'Your code is on the way. To log in, enter the code we emailed to': "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo para o qual enviamos um e-mail",
    'Your code is on the way. To log in, enter the code we sent you': "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo que enviamos para voc\xea",
    'Your code is on the way. To log in, enter the code we texted to': "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo para o qual enviamos uma mensagem de texto",
    // Additional translations provided by customers
    'An account with the given email already exists.': "J\xe1 existe uma conta com o email utilizado.",
    'Confirm a Code': "Confirmar um C\xf3digo",
    'Confirm Sign In': "Confirmar In\xedcio de Sess\xe3o",
    'Forgot Password': 'Esqueci Minha Senha',
    'Incorrect username or password.': "Nome de usu\xe1rio ou senha incorreta",
    'Invalid password format': "Formato de senha inv\xe1lido",
    'Invalid phone number format': "Formato de n\xfamero de telefone inv\xe1lido",
    'Loading...': 'Carregando...',
    'New Password': 'Nova Senha',
    'Resend a Code': "Reenviar um C\xf3digo",
    'Sign Out': 'Sair',
    'Sign Up with Amazon': 'Criar Conta com a Amazon',
    'Sign Up with Apple': 'Criar Conta com a Apple',
    'Sign Up with Facebook': 'Criar Conta com o Facebook',
    'Sign Up with Google': 'Criar Conta com o Google',
    'Sign Up': 'Criar Conta',
    'User already exists': "Usu\xe1rio j\xe1 existe",
    'User does not exist': "Usu\xe1rio n\xe3o existe",
    'Username cannot be empty': "Nome de usu\xe1rio n\xe3o pode estar vazio",
    'Your passwords must match': 'Suas senhas devem ser iguais'
};


const $55a9286deff81867$export$2a86dc37ee9734c = {
    'Account recovery requires verified contact information': "\u8D26\u6237\u6062\u590D\u9700\u8981\u9A8C\u8BC1\u8FC7\u7684\u8054\u7CFB\u65B9\u5F0F",
    'Authenticator App (TOTP)': "Authenticator \u5E94\u7528\u7A0B\u5E8F\uFF08TOTP\uFF09",
    'Back to Sign In': "\u56DE\u5230\u767B\u5F55",
    'Change Password': "\u66F4\u6539\u5BC6\u7801",
    Changing: "\u6B63\u5728\u4FEE\u6539",
    Code: "\u786E\u8BA4\u7801",
    'Confirm Email Code': "\u786E\u8BA4\u7535\u5B50\u90AE\u4EF6\u4EE3\u7801",
    'Confirm Password': "\u786E\u8BA4\u5BC6\u7801",
    'Confirm Sign Up': "\u786E\u8BA4\u6CE8\u518C",
    'Confirm SMS Code': "\u786E\u8BA4\u77ED\u4FE1\u9A8C\u8BC1\u7801",
    'Confirm TOTP Code': "\u786E\u8BA4 TOTP \u4EE3\u7801",
    Confirm: "\u786E\u8BA4",
    'Confirmation Code': "\u786E\u8BA4\u7801",
    Confirming: "\u6B63\u5728\u786E\u8BA4",
    'Create a new account': "\u521B\u5EFA\u65B0\u8D26\u6237",
    'Create Account': "\u521B\u5EFA\u8D26\u6237",
    'Creating Account': "\u6B63\u5728\u521B\u5EFA\u8D26\u6237",
    'Dismiss alert': "\u5173\u95ED\u8B66\u62A5",
    Email: "\u90AE\u7BB1",
    'Email Message': "\u7535\u5B50\u90AE\u4EF6\u6D88\u606F",
    'Enter your code': "\u8F93\u5165\u9A8C\u8BC1\u7801",
    'Enter your Email': "\u8F93\u5165\u7535\u5B50\u90AE\u4EF6",
    'Enter your Password': "\u8F93\u5165\u5BC6\u7801",
    'Enter your phone number': "\u8F93\u5165\u7535\u8BDD\u53F7\u7801",
    'Enter your username': "\u8F93\u5165\u7528\u6237\u540D",
    'Forgot your password?': "\u5FD8\u8BB0\u5BC6\u7801\u4E86\uFF1F",
    'Hide password': "\u9690\u85CF\u5BC6\u7801",
    'It may take a minute to arrive': "\u53EF\u80FD\u9700\u8981\u4E00\u5206\u949F\u624D\u80FD\u5230\u8FBE",
    Loading: "\u6B63\u5728\u52A0\u8F7D",
    'Multi-Factor Authentication': "\u591A\u91CD\u8EAB\u4EFD\u9A8C\u8BC1",
    'Multi-Factor Authentication Setup': "\u591A\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u8BBE\u7F6E",
    'New password': "\u65B0\u5BC6\u7801",
    or: "\u6216\u8005",
    Password: "\u5BC6\u7801",
    'Phone Number': "\u7535\u8BDD",
    'Please confirm your Password': "\u8BF7\u518D\u6B21\u8F93\u5165\u5BC6\u7801",
    'Resend Code': "\u91CD\u53D1\u9A8C\u8BC1\u7801",
    'Reset your password': "\u91CD\u7F6E\u5BC6\u7801",
    'Reset your Password': "\u91CD\u7F6E\u5BC6\u7801",
    'Select MFA Type': "\u9009\u62E9 MFA \u7C7B\u578B",
    'Send Code': "\u53D1\u9001\u786E\u8BA4\u7801",
    'Send code': "\u53D1\u9001\u9A8C\u8BC1\u7801",
    Sending: "\u6B63\u5728\u53D1\u9001",
    'Setup Email': "\u8BBE\u7F6E\u7535\u5B50\u90AE\u4EF6",
    'Setup TOTP': "\u8BBE\u7F6E TOTP",
    'Show password': "\u663E\u793A\u5BC6\u7801",
    'Sign in to your account': "\u767B\u5F55\u8D26\u6237",
    'Sign In with Amazon': "\u901A\u8FC7 Amazon \u767B\u5F55",
    'Sign In with Apple': "\u901A\u8FC7 Apple \u767B\u5F55",
    'Sign In with Facebook': "\u901A\u8FC7 Facebook \u767B\u5F55",
    'Sign In with Google': "\u901A\u8FC7 Google \u767B\u5F55",
    'Sign in': "\u767B\u5F55",
    'Sign In': "\u767B\u5F55",
    'Signing in': "\u6B63\u5728\u767B\u5F55",
    Skip: "\u8DF3\u8FC7",
    Submit: "\u63D0\u4EA4",
    Submitting: "\u6B63\u5728\u63D0\u4EA4",
    'Text Message (SMS)': "\u77ED\u4FE1\uFF08SMS\uFF09",
    Username: "\u7528\u6237\u540D",
    'Verify Contact': "\u9A8C\u8BC1\u8054\u7CFB\u65B9\u5F0F",
    Verify: "\u9A8C\u8BC1",
    'We Emailed You': "\u6211\u4EEC\u7ED9\u60A8\u53D1\u9001\u4E86\u7535\u5B50\u90AE\u4EF6",
    'We Sent A Code': "\u6211\u4EEC\u53D1\u9001\u4E86\u4EE3\u7801",
    'We Texted You': "\u6211\u4EEC\u7ED9\u60A8\u53D1\u9001\u4E86\u77ED\u4FE1",
    'Your code is on the way. To log in, enter the code we emailed to': "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u53D1\u9001\u7ED9\u4EE5\u4E0B\u4EBA\u5458\u7684\u4EE3\u7801\uFF1A",
    'Your code is on the way. To log in, enter the code we sent you': "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u53D1\u9001\u7ED9\u60A8\u7684\u4EE3\u7801",
    'Your code is on the way. To log in, enter the code we texted to': "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u901A\u8FC7\u77ED\u4FE1\u53D1\u9001\u7ED9\u4EE5\u4E0B\u4EBA\u5458\u7684\u4EE3\u7801\uFF1A",
    // Additional translations provided by customers
    'Confirm a Code': "\u786E\u8BA4\u7801",
    'Confirm Sign In': "\u786E\u8BA4\u767B\u5F55",
    'Forgot Password': "\u5FD8\u8BB0\u5BC6\u7801",
    'Incorrect username or password': "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF",
    'Incorrect username or password.': "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF",
    'Invalid password format': "\u5BC6\u7801\u683C\u5F0F\u9519\u8BEF",
    'Invalid phone number format': "\u7535\u8BDD\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u4F7F\u7528\u683C\u5F0F +12345678900",
    'New Password': "\u65B0\u5BC6\u7801",
    'Resend a Code': "\u91CD\u53D1\u786E\u8BA4\u7801",
    'Sign Out': "\u9000\u51FA",
    'Sign Up': "\u6CE8\u518C",
    'User already exists': "\u7528\u6237\u5DF2\u7ECF\u5B58\u5728",
    'User does not exist': "\u7528\u6237\u4E0D\u5B58\u5728"
};


const $0222c81754d7450e$export$9f1a61f9baaa2d2e = {
    'Account recovery requires verified contact information': "F\xf6r att \xe5terst\xe4lla kontot beh\xf6ver du ett verifierat konto",
    'Authenticator App (TOTP)': 'Autentiseringsapp (TOTP)',
    'Back to Sign In': 'Tillbaka till inloggningen',
    'Change Password': "Byt l\xf6senord",
    Changing: "\xc4ndra",
    Code: 'Kod',
    'Confirm Email Code': "Bekr\xe4fta e-postkod",
    'Confirm Password': "Bekr\xe4fta l\xf6senord",
    'Confirm Sign Up': "Bekr\xe4fta registrering",
    'Confirm SMS Code': "Bekr\xe4fta SMS-kod",
    'Confirm TOTP Code': "Bekr\xe4fta TOTP-kod",
    Confirm: "Bekr\xe4fta",
    'Confirmation Code': 'Verifikationskod',
    Confirming: "Bekr\xe4ftar",
    'Create a new account': 'Skapa ett nytt konto',
    'Create Account': 'Skapa konto',
    'Creating Account': 'Skapar konto',
    'Dismiss alert': 'Avvisa varning',
    Email: 'E-post',
    'Email Message': 'E-postmeddelande',
    'Enter your code': 'Skriv din kod',
    'Enter your Email': 'Ange din e-post',
    'Enter your phone number': 'Ange ditt telefonnummer',
    'Enter your username': "Ange ditt anv\xe4ndarnamn",
    'Forgot your password?': "Gl\xf6mt ditt l\xf6senord? ",
    'Hide password': "D\xf6lj l\xf6senord",
    'It may take a minute to arrive': 'Det kan ta en minut att komma fram',
    Loading: 'Laddar',
    'Multi-Factor Authentication': 'Multifaktorautentisering',
    'Multi-Factor Authentication Setup': 'Konfigurering av multifaktorautentisering',
    'New password': "Nytt l\xf6senord",
    or: 'eller',
    Password: "L\xf6senord",
    'Phone Number': 'Telefonnummer',
    'Resend Code': 'Skicka koden igen',
    'Reset your password': "\xc5terst\xe4ll ditt l\xf6senord",
    'Reset your Password': "\xc5terst\xe4ll ditt l\xf6senord",
    'Select MFA Type': "V\xe4lj MFA-typ",
    'Send code': 'Skicka kod',
    'Send Code': 'Skicka kod',
    Sending: 'Skickar',
    'Setup Email': 'Konfigurera e-post',
    'Setup TOTP': 'Konfigurera TOTP',
    'Show password': "Visa l\xf6senord",
    'Sign in to your account': 'Logga in till ditt konto',
    'Sign In with Amazon': 'Logga in med Amazon',
    'Sign In with Apple': 'Logga in med Apple',
    'Sign In with Facebook': 'Logga in med Facebook',
    'Sign In with Google': 'Logga in med Google',
    'Sign in': 'Logga in',
    'Sign In': 'Logga in',
    'Signing in': 'Loggar in',
    Skip: "Hoppa \xf6ver",
    Submit: 'Skicka',
    Submitting: 'Skickar in',
    'Text Message (SMS)': 'Textmeddelande (SMS)',
    Username: "Anv\xe4ndarnamn",
    'Verify Contact': 'Verifiera kontakt',
    Verify: 'Verifiera',
    'We Sent A Code': 'Vi skickade en kod',
    'We Texted You': 'Vi sms:ade dig',
    'Your code is on the way. To log in, enter the code we emailed to': "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi mejlade till",
    'Your code is on the way. To log in, enter the code we sent you': "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi skickade till dig",
    'Your code is on the way. To log in, enter the code we texted to': "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi sms:ade till",
    // Additional translations provided by customers
    'An account with the given email already exists.': 'Det finns redan ett konto med denna e-postadress',
    'Confirm a Code': "Bekr\xe4fta koden",
    'Confirm Sign In': "Bekr\xe4fta inloggning",
    'Create account': 'Skapa konto',
    'Enter your Password': "Ange ditt l\xf6senord",
    'Forgot Password?': "Gl\xf6mt l\xf6senord?",
    'Have an account? ': 'Redan registrerad? ',
    'Incorrect username or password': "Felaktigt anv\xe4ndarnamn eller l\xf6senord",
    'Incorrect username or password.': "Felaktigt anv\xe4ndarnamn eller l\xf6senord",
    'Invalid password format': "Ogiltigt l\xf6senordsformat",
    'Invalid phone number format': `Ogiltigt format f\xf6r telefonnummer`,
    'Lost your code? ': "F\xf6rlorat koden? ",
    'New Password': "Nytt l\xf6senord",
    'No account? ': 'Inget konto? ',
    'Password attempts exceeded': "Maximalt antal felaktiga inloggningsf\xf6rs\xf6k har uppn\xe5tts",
    'Reset Password': "\xc5terst\xe4ll l\xf6senord",
    'Sign Out': 'Logga ut',
    'Sign Up': 'Registrering',
    'User already exists': "Anv\xe4ndaren finns redan",
    'User does not exist': "Anv\xe4ndaren finns inte",
    'Username cannot be empty': "Anv\xe4ndarnamnet kan inte vara tomt",
    'We Emailed You': 'Vi har skickat e-post till dig',
    'Please confirm your Password': "Bekr\xe4fta ditt l\xf6senord"
};


const $6415e0125532ffe7$export$710642024bfcbd8f = {
    'Account recovery requires verified contact information': 'Pemulihan akun memerlukan informasi kontak terverifikasi',
    'Authenticator App (TOTP)': 'Aplikasi Pengauntentikasi (TOTP)',
    'Back to Sign In': 'Kembali ke Masuk',
    'Change Password': 'Ubah kata sandi',
    Changing: 'Mengubah',
    Code: 'Kode',
    'Confirm Email Code': 'Konfirmasi Kode Email',
    'Confirm Password': 'Konfirmasi kata sandi',
    'Confirm Sign Up': 'Konfirmasi Pendaftaran',
    'Confirm SMS Code': 'Konfirmasi Kode SMS',
    'Confirm TOTP Code': 'Konfirmasi Kode TOTP',
    Confirm: 'Konfirmasi',
    'Confirmation Code': 'Kode Konfirmasi',
    Confirming: 'Mengkonfirmasi',
    'Create a new account': 'Buat akun baru',
    'Create Account': 'Buat Akun',
    'Creating Account': 'Membuat Akun',
    'Dismiss alert': 'Hentikan pemberitahuan',
    Email: 'Email',
    'Email Message': 'Pesan Email',
    'Enter your code': 'Masukkan kode anda',
    'Enter your Email': 'Masukkan email anda',
    'Enter your phone number': 'Masukkan nomor telepon anda',
    'Enter your username': 'Masukkan nama akun anda',
    'Forgot your password?': 'Lupa kata sandi? ',
    'Hide password': 'Sembunyikan kata sandi',
    'It may take a minute to arrive': 'Mungkin perlu waktu satu menit untuk tiba',
    Loading: 'Memuat',
    'Multi-Factor Authentication': 'Autentikasi Multifaktor',
    'Multi-Factor Authentication Setup': 'Pengaturan Autentikasi Multifaktor',
    'New password': 'Kata sandi baru',
    or: 'atau',
    Password: 'Kata sandi',
    'Phone Number': 'Nomor telepon',
    'Resend Code': 'Kirim ulang kodenya',
    'Reset your Password': 'Reset Kata Sandi',
    'Reset your password': 'Ubah kata sandi anda',
    'Select MFA Type': 'Pilih tipe MFA',
    'Send code': 'Kirim kode',
    'Send Code': 'Kirim Kode',
    Sending: 'Mengirim',
    'Setup Email': 'Atur Email',
    'Setup TOTP': 'Siapkan TOTP',
    'Show password': 'Tampilkan kata sandi',
    'Sign in to your account': 'Masuk akun anda',
    'Sign In with Amazon': 'Masuk dengan Amazon',
    'Sign In with Apple': 'Masuk dengan Apple',
    'Sign In with Facebook': 'Masuk dengan Facebook',
    'Sign In with Google': 'Masuk dengan Google',
    'Sign in': 'Masuk',
    'Sign In': 'Masuk',
    'Signing in': 'Memasuki',
    Skip: 'Lewati',
    Submit: 'Ajukan',
    Submitting: 'Mengajukan',
    'Text Message (SMS)': 'Pesan Teks (SMS)',
    Username: 'Nama akun',
    'Verify Contact': 'Verifikasi Kontak',
    Verify: 'Verifikasi',
    'We Sent A Code': 'Kami Mengirim Kode',
    'We Texted You': 'Kami mengirim SMS kepada Anda',
    'Your code is on the way. To log in, enter the code we sent you': 'Kode Anda segera hadir. Untuk masuk, masukkan kode yang kami kirimkan kepada Anda',
    // Additional translations provided by customers
    'An account with the given email already exists.': 'Akun dengan email tersebut sudah terdaftar.',
    'Attempt limit exceeded, please try after some time.': 'Batas percobaan terlampaui, mohon coba lagi setelah beberapa waktu.',
    'Cannot reset password for the user as there is no registered/verified email or phone_number': 'Tidak dapat mengatur ulang kata sandi karena tidak ada email terdaftar / terverifikasi atau nomor telepon',
    Change: 'Ubah',
    'Confirm a Code': 'Konfirmasi kode',
    'Create account': 'Buat akun',
    'Enter your password': 'Masukkan kata sandi anda',
    'Forgot Password': 'Lupa kata sandi',
    'Have an account? ': 'Sudah punya akun? ',
    Hello: 'Halo',
    'Incorrect username or password.': 'Nama akun atau kata sandi salah.',
    'Invalid phone number format': 'Nomor telepon tidak sesuai dengan format.',
    'Invalid verification code provided, please try again.': 'Kode verifikasi tidak sesuai, mohon coba lagi.',
    'It may take a minute to arrive.': 'Mungkin perlu beberapa waktu untuk tiba.',
    'Lost your code? ': 'Kode anda hilang?',
    Name: 'Nama',
    'Network error': 'Galat jaringan',
    'No account? ': 'Tidak ada akun?',
    'Password did not conform with policy: Password not long enough': 'Kata sandi tidak sesuai dengan aturan: Kata sandi kurang panjang',
    'Resend a Code': 'Renvoyer un code',
    'Reset password': 'Ubah kata sandi anda',
    Send: 'Kirim',
    'Sign In with AWS': 'Masuk dengan AWS',
    'Sign Up with Amazon': 'Daftar dengan Amazon',
    'Sign Up with AWS': 'Daftar dengan AWS',
    'Sign Up with Facebook': 'Daftar dengan Facebook',
    'Sign Up with Google': 'Daftar dengan Google',
    SMS: 'SMS',
    'User already exists': 'Akun sudah terdaftar',
    'User does not exist.': 'Akun tidak terdaftar.',
    'User is disabled.': 'Akun dinonaktifkan.',
    'Username cannot be empty': 'Nama akun tidak boleh kosong',
    'Username/client id combination not found.': 'Nama akun atau id tidak ditemukan.',
    'We Emailed You': 'Kami mengirimkanmu email',
    'Your code is on the way. To log in, enter the code we emailed to': 'Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami emailkan ke',
    'Your code is on the way. To log in, enter the code we texted to': 'Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami tuliskan ke',
    'Your passwords must match': 'Kata sandi harus sama'
};


const $605227c5949db491$export$6961fa2059aeacf0 = {
    'Account recovery requires verified contact information': "Hesap kurtarma, do\u011Frulanm\u0131\u015F ileti\u015Fim bilgilerini gerektirir",
    'Authenticator App (TOTP)': "Kimlik Do\u011Frulay\u0131c\u0131 Uygulamas\u0131 (TOTP)",
    'Add your Profile': 'Profilinizi ekleyin',
    'Add your Website': 'Web sitenizi ekleyin',
    'Back to Sign In': "Oturum A\xe7maya Geri D\xf6n",
    'Change Password': "\u015Eifreyi De\u011Fi\u015Ftir",
    Changing: "De\u011Fi\u015Ftiriliyor",
    Code: 'Kod',
    'Confirm Email Code': 'E-posta Kodunu Onayla',
    'Confirm Password': "\u015Eifreyi Do\u011Frula",
    'Confirm Sign Up': "Kay\u0131t \u0130\u015Flemini Do\u011Frula",
    'Confirm SMS Code': "SMS Kodunu Do\u011Frula",
    'Confirm MFA Code': "\xc7oklu Fakt\xf6rl\xfc Do\u011Frulama Kodunu Do\u011Frula",
    'Confirm TOTP Code': "Tek Kullan\u0131ml\u0131k \u015Eifreyi Do\u011Frula",
    Confirm: "Do\u011Frula",
    'Confirmation Code': "Do\u011Frulama Kodu",
    Confirming: "Do\u011Frulan\u0131yor",
    'Create a new account': "Yeni bir hesap olu\u015Ftur",
    'Create Account': "Hesap Olu\u015Ftur",
    'Creating Account': "Hesap Olu\u015Fturuluyor",
    'Dismiss alert': "Uyar\u0131y\u0131 reddet",
    Email: 'E-posta',
    'Email Message': "E-posta Mesaj\u0131",
    'Enter your Birthdate': "Do\u011Fum g\xfcn\xfcn\xfcz\xfc girin",
    'Enter your code': 'Kodu girin',
    'Enter your Confirmation Code': "Do\u011Frulama Kodunuzu Girin",
    'Enter your Email': 'E-posta adresinizi girin',
    'Enter your email': 'E-posta adresinizi girin',
    'Enter your Family Name': "Ad Soyad\u0131n\u0131z\u0131 girin",
    'Enter your Given Name': "Ad\u0131n\u0131z\u0131 girin",
    'Enter your Middle Name': "Soyad\u0131n\u0131z\u0131 girin",
    'Enter your Name': "Ad\u0131n\u0131z\u0131 girin",
    'Enter your Nickname': "Takma ad\u0131n\u0131z\u0131 girin",
    'Enter your Password': "\u015Eifrenizi girin",
    'Enter your phone number': "Telefon numaran\u0131z\u0131 girin",
    'Enter your Preferred Username': "Tercih etti\u011Finiz kullan\u0131c\u0131 ad\u0131n\u0131z\u0131 girin",
    'Enter your username': "Kullan\u0131c\u0131 ad\u0131n\u0131z\u0131 girin",
    'Forgot Password?': "\u015Eifrenizi Mi Unuttunuz?",
    'Forgot password?': "\u015Eifrenizi mi unuttunuz?",
    'Forgot your password?': "\u015Eifrenizi mi unuttunuz?",
    'Hide password': "\u015Eifreyi gizle",
    'It may take a minute to arrive': "Kodun gelmesi bir dakika s\xfcrebilir",
    Loading: "Y\xfckleniyor",
    'Multi-Factor Authentication': "\xc7ok Fakt\xf6rl\xfc Kimlik Do\u011Frulama",
    'Multi-Factor Authentication Setup': "\xc7ok Fakt\xf6rl\xfc Kimlik Do\u011Frulama Kurulumu",
    'New password': "Yeni \u015Fifre",
    or: 'veya',
    Password: "\u015Eifre",
    'Phone Number': "Telefon Numaras\u0131",
    'Please confirm your Password': "L\xfctfen \u015Fifrenizi do\u011Frulay\u0131n",
    'Resend Code': "Kodu Yeniden G\xf6nder",
    'Reset your password': "\u015Eifrenizi s\u0131f\u0131rlay\u0131n",
    'Reset your Password': "\u015Eifrenizi S\u0131f\u0131rlay\u0131n",
    'Reset Password': "\u015Eifreyi S\u0131f\u0131rla",
    'Select MFA Type': "MFA t\xfcr\xfcn\xfc se\xe7in",
    'Send code': "Kod g\xf6nder",
    'Send Code': "Kod G\xf6nder",
    Sending: "G\xf6nderiliyor",
    'Setup Email': "E-postay\u0131 ayarla",
    'Setup TOTP': "Tek kullan\u0131ml\u0131k \u015Fifre kurulumu yap",
    'Show password': "\u015Eifreyi g\xf6ster",
    'Sign in to your account': "Hesab\u0131n\u0131zda oturum a\xe7\u0131n",
    'Sign In with Amazon': "Amazon ile Oturum A\xe7",
    'Sign In with Apple': "Apple ile Oturum A\xe7",
    'Sign In with Facebook': "Facebook ile Oturum A\xe7",
    'Sign In with Google': "Google ile Oturum A\xe7",
    'Sign in': "Oturum a\xe7",
    'Sign In': "Oturum A\xe7",
    'Sign Up with Facebook': "Facebook ile Kay\u0131t Ol",
    'Sign Up with Google': "Google ile Kay\u0131t Ol",
    'Signing in': "Oturum a\xe7\u0131l\u0131yor",
    Skip: 'Atla',
    Submit: "G\xf6nder",
    Submitting: "G\xf6nderiliyor",
    'Text Message (SMS)': "K\u0131sa Mesaj (SMS)",
    Username: "Kullan\u0131c\u0131 ad\u0131",
    'Verify Contact': "Ki\u015Fiyi Do\u011Frula",
    Verify: "Do\u011Frula",
    'We Emailed You': "Size E-posta G\xf6nderdik",
    'We Sent A Code': "Bir Kod G\xf6nderdik",
    'We Texted You': "Size Mesaj G\xf6nderdik",
    'Your code is on the way. To log in, enter the code we emailed to': "Kodunuz yolda. Oturum a\xe7mak i\xe7in, g\xf6nderdi\u011Fimiz e-postadaki kodu girin",
    'Your code is on the way. To log in, enter the code we sent you': "Kodunuz yolda. Oturum a\xe7mak i\xe7in, size g\xf6nderdi\u011Fimiz kodu girin",
    'Your code is on the way. To log in, enter the code we texted to': "Kodunuz yolda. Oturum a\xe7mak i\xe7in, g\xf6nderdi\u011Fimiz mesajdaki kodu girin",
    // Additional translations provided by customers
    'An account with the given email already exists.': 'Bu e-postaya ait zaten bir hesap var.',
    'Confirm Sign In': "Oturum A\xe7may\u0131 Do\u011Frula",
    'Have an account? ': "Hesab\u0131n\u0131z var m\u0131? ",
    'Incorrect username or password': "Yanl\u0131\u015F kullan\u0131c\u0131 ad\u0131 ya da \u015Fifre",
    'Incorrect username or password.': "Yanl\u0131\u015F kullan\u0131c\u0131 ad\u0131 ya da \u015Fifre",
    'Invalid password format': "Ge\xe7ersiz parola format\u0131",
    'Invalid phone number format': "Ge\xe7ersiz telefon numaras\u0131 format\u0131",
    'Lost your code? ': 'Kodu mu kaybettiniz? ',
    'No account? ': "Hesab\u0131n\u0131z yok mu? ",
    'Password attempts exceeded': "Maksimum oturum a\xe7ma giri\u015Fimi a\u015F\u0131ld\u0131",
    'Sign Out': "\xc7\u0131k\u0131\u015F yap",
    'Sign Up': "Kay\u0131t Ol",
    'User already exists': "Bu kullan\u0131c\u0131 zaten var",
    'User does not exist': "B\xf6yle bir kullan\u0131c\u0131 mevcut de\u011Fil",
    'Username cannot be empty': "Kullan\u0131c\u0131 ad\u0131 bo\u015F olamaz"
};


const $4456213842a8e1e1$export$6240aeddf7c74bb8 = {
    'Account recovery requires verified contact information': "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438",
    'Authenticator App (TOTP)': "\u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 (TOTP)",
    'Back to Sign In': "\u041D\u0430\u0437\u0430\u0434, \u0447\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438",
    'Change Password': "\u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    Changing: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435",
    Code: "\u041A\u043E\u0434",
    'Confirm Email Code': "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'Confirm Password': "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F",
    'Confirm Sign Up': "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F",
    'Confirm SMS Code': "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 CMC-\u041A\u043E\u0434",
    'Confirm TOTP Code': "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 TOTP-\u041A\u043E\u0434",
    Confirm: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0442\u044C",
    'Confirmation Code': "\u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F",
    Confirming: "\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
    'Create a new account': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    'Create Account': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    'Creating Account': "\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C",
    'Dismiss alert': "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435",
    Email: "\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    'Email Message': "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435",
    'Enter your code': "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u041A\u043E\u0434",
    'Enter your Email': "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    'Enter your phone number': "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    'Enter your username': "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
    'Forgot your password?': "\u0417\u0430\u0431\u044B\u043B\u0438 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C?",
    'Hide password': "\u0421\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    'It may take a minute to arrive': "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043D\u044F\u0442\u044C \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0432\u0440\u0435\u043C\u044F",
    Loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430",
    'Multi-Factor Authentication': "\u041C\u043D\u043E\u0433\u043E\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0430\u044F \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
    'Multi-Factor Authentication Setup': "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043C\u043D\u043E\u0433\u043E\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u043E\u0439 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438",
    'New password': "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    or: "\u0438\u043B\u0438",
    Password: "\u041F\u0430\u0440\u043E\u043B\u044C",
    'Phone Number': "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    'Resend Code': "\u041E\u0442\u043F\u0440\u0430\u0432\u044C \u0435\u0449\u0435 \u0440\u0430\u0437 \u041A\u043E\u0434",
    'Reset your password': "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C",
    'Reset your Password': "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u041F\u0430\u0440\u043E\u043B\u044C",
    'Select MFA Type': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u041C\u0424\u0410",
    'Send code': "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434",
    'Send Code': "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434",
    Sending: "\u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430",
    'Setup Email': "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0447\u0442\u0443",
    'Setup TOTP': "\u041D\u0430\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0442\u044C TOTP",
    'Show password': "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    'Sign in to your account': "\u0437\u043D\u0430\u043A \u0432 \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    'Sign In with Amazon': "\u0437\u043D\u0430\u043A \u0432 \u0441 Amazon",
    'Sign In with Apple': "\u0437\u043D\u0430\u043A \u0432 \u0441 Apple",
    'Sign In with Facebook': "\u0437\u043D\u0430\u043A \u0432 \u0441 Facebook",
    'Sign In with Google': "\u0437\u043D\u0430\u043A \u0432 \u0441 Google",
    'Sign in': "\u0437\u043D\u0430\u043A \u0432",
    'Sign In': "\u0437\u043D\u0430\u043A \u0432",
    'Signing in': "\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0432",
    Skip: "\u041F\u0440\u043E\u043F\u0443\u0441\u043A\u0430\u0442\u044C",
    Submit: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u043D\u0430 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u0435",
    Submitting: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0432",
    'Text Message (SMS)': "\u0422\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 (SMS)",
    Username: "\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
    'Verify Contact': "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u043A\u043E\u043D\u0442\u0430\u043A\u0442",
    Verify: "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C",
    'We Emailed You': "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0435 \u043F\u0438\u0441\u044C\u043C\u043E",
    'We Sent A Code': "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u0434",
    'We Texted You': "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'Your code is on the way. To log in, enter the code we emailed to': "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435",
    'Your code is on the way. To log in, enter the code we sent you': "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043F\u043E\u0441\u043B\u0430\u043B\u0438 \u0432\u0430\u043C",
    'Your code is on the way. To log in, enter the code we texted to': "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u043C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u043C"
};


const $96326d4f2ace3b8b$export$b2ba232c100e7a36 = {
    'Account recovery requires verified contact information': "\u05E9\u05D7\u05D6\u05D5\u05E8 \u05DC\u05E7\u05D5\u05D7 \u05D3\u05D5\u05E8\u05E9 \u05E2\u05D5\u05D3 \u05DE\u05D9\u05D3\u05E2",
    'Authenticator App (TOTP)': "\u05D0\u05E4\u05DC\u05D9\u05E7\u05E6\u05D9\u05D9\u05EA \u05D0\u05D9\u05DE\u05D5\u05EA (TOTP)",
    'Back to Sign In': "\u05D7\u05D6\u05D5\u05E8 \u05DC\u05D4\u05E8\u05E9\u05DE\u05D4",
    'Change Password': "\u05E2\u05D3\u05DB\u05D5\u05DF \u05E1\u05D9\u05E1\u05DE\u05D0",
    Changing: "\u05DE\u05E2\u05D3\u05DB\u05DF",
    Code: "\u05E7\u05D5\u05D3",
    'Confirm Email Code': "\u05D0\u05DE\u05EA \u05E7\u05D5\u05D3 \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
    'Confirm Password': "\u05D0\u05E9\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D0",
    'Confirm Sign Up': "\u05D0\u05E9\u05E8 \u05D4\u05E8\u05E9\u05DE\u05D4",
    'Confirm SMS Code': "\u05D0\u05E9\u05E8 sms \u05E7\u05D5\u05D3",
    'Confirm TOTP Code': "\u05D0\u05E9\u05E8 totp \u05E7\u05D5\u05D3",
    Confirm: "\u05D0\u05D9\u05E9\u05D5\u05E8",
    'Confirmation Code': "\u05D0\u05D9\u05E9\u05D5\u05E8 \u05E7\u05D5\u05D3",
    Confirming: "\u05DE\u05D0\u05E9\u05E8",
    'Create a new account': "\u05E6\u05D5\u05E8 \u05DE\u05E9\u05EA\u05DE\u05E9 \u05D7\u05D3\u05E9",
    'Create Account': "\u05E6\u05D5\u05E8 \u05DE\u05E9\u05EA\u05DE\u05E9",
    'Creating Account': "\u05D9\u05E6\u05D9\u05E8\u05EA \u05DE\u05E9\u05EA\u05DE\u05E9",
    'Dismiss alert': "\u05D4\u05E1\u05E8 \u05D4\u05EA\u05E8\u05D0\u05D4",
    Email: "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
    'Email Message': "\u05D4\u05D5\u05D3\u05E2\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
    'Enter your code': "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3",
    'Enter your Email': "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05DE\u05D9\u05D9\u05DC \u05E9\u05DC\u05DA",
    'Enter your phone number': "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA",
    'Enter your username': "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E9\u05DD \u05D4\u05DE\u05EA\u05DE\u05E9 \u05E9\u05DC\u05DA",
    'Forgot your password?': "\u05E9\u05DB\u05D7\u05EA \u05E1\u05D9\u05E1\u05DE\u05D0 ?",
    'Hide password': "\u05D4\u05E1\u05EA\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D0",
    Loading: "\u05D8\u05D5\u05E2\u05DF",
    'Multi-Factor Authentication': "\u05D0\u05D9\u05DE\u05D5\u05EA \u05E8\u05D1-\u05D2\u05D5\u05E8\u05DE\u05D9",
    'Multi-Factor Authentication Setup': "\u05D4\u05D2\u05D3\u05E8\u05EA \u05D0\u05D9\u05DE\u05D5\u05EA \u05E8\u05D1-\u05D2\u05D5\u05E8\u05DE\u05D9",
    'New password': "\u05E1\u05D9\u05E1\u05DE\u05D0 \u05D7\u05D3\u05E9\u05D4",
    or: "\u05D0\u05D5\u05B9",
    Password: "\u05E1\u05D9\u05E1\u05DE\u05D0",
    'Phone Number': "\u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF",
    'Resend Code': "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 \u05E9\u05D5\u05D1",
    'Reset your password': "\u05D0\u05E4\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D0",
    'Reset your Password': "\u05D0\u05E4\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D0",
    'Select MFA Type': "\u05D1\u05D7\u05E8 \u05E1\u05D5\u05D2 \u05D0\u05D9\u05DE\u05D5\u05EA \u05E8\u05D1-\u05D2\u05D5\u05E8\u05DE\u05D9",
    'Send code': "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3",
    'Send Code': "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3",
    Sending: "\u05E9\u05D5\u05DC\u05D7",
    'Setup Email': "\u05D4\u05D2\u05D3\u05E8 \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
    'Setup TOTP': 'Setup TOTP',
    'Show password': "\u05D4\u05E6\u05D2 \u05E1\u05D9\u05E1\u05DE\u05D0",
    'Sign in to your account': "\u05D4\u05EA\u05D7\u05D1\u05E8 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA",
    'Sign In with Amazon': 'Sign In with Amazon',
    'Sign In with Apple': 'Sign In with Apple',
    'Sign In with Facebook': 'Sign In with Facebook',
    'Sign In with Google': 'Sign In with Google',
    'Sign in': "\u05D4\u05EA\u05D7\u05D1\u05E8",
    'Sign In': "\u05D4\u05EA\u05D7\u05D1\u05E8",
    'Signing in': "\u05DE\u05EA\u05D7\u05D1\u05E8",
    Skip: "\u05D3\u05DC\u05D2",
    Submit: "\u05E9\u05DC\u05D7",
    Submitting: "\u05E9\u05D5\u05DC\u05D7",
    'Text Message (SMS)': "\u05D4\u05D5\u05D3\u05E2\u05EA \u05D8\u05E7\u05E1\u05D8 (SMS)",
    Username: "\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9",
    'Verify Contact': "\u05D0\u05DE\u05EA \u05D0\u05D9\u05E9 \u05E7\u05E9\u05E8",
    Verify: "\u05D0\u05DE\u05EA"
};


const $291f6a97f3551963$export$373d6304c6310960 = {
    'Account recovery requires verified contact information': "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0454 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0457 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457",
    'Authenticator App (TOTP)': "\u0414\u043E\u0434\u0430\u0442\u043E\u043A \u0430\u0432\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457 (TOTP)",
    'Back to Sign In': "\u041D\u0430\u0437\u0430\u0434 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0432\u0445\u043E\u0434\u0443",
    'Change Password': "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    Changing: "\u0417\u043C\u0456\u043D\u044E\u0454\u043C\u043E",
    Code: "\u041A\u043E\u0434",
    'Confirm Email Code': "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u043A\u043E\u0434 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'Confirm Password': "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    'Confirm Sign Up': "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044E",
    'Confirm SMS Code': "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C SMS \u043A\u043E\u0434",
    'Confirm TOTP Code': "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C TOTP \u043A\u043E\u0434",
    Confirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
    'Confirmation Code': "\u041A\u043E\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
    Confirming: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0443\u0454\u043C\u043E",
    'Create a new account': "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
    'Create Account': "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
    'Creating Account': "\u0420\u0435\u0454\u0441\u0442\u0440\u0443\u0454\u043C\u043E",
    'Dismiss alert': "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
    Email: 'Email',
    'Email Message': "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'Enter your code': "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434",
    'Enter your Email': "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448 email",
    'Enter your phone number': "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    'Enter your username': "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448\u0435 \u0456\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
    'Forgot password?': "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?",
    'Forgot your password?': "\u0417\u0430\u0431\u0443\u043B\u0438 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C?",
    'Hide password': "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    'It may take a minute to arrive': "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043C\u043E\u0436\u0435 \u0442\u0440\u0438\u0432\u0430\u0442\u0438 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
    Loading: "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0454\u043C\u043E",
    'Multi-Factor Authentication': "\u0411\u0430\u0433\u0430\u0442\u043E\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0430 \u0430\u0432\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044F",
    'Multi-Factor Authentication Setup': "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0431\u0430\u0433\u0430\u0442\u043E\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u043E\u0457 \u0430\u0432\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457",
    'New password': "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    or: "\u0430\u0431\u043E",
    Password: "\u041F\u0430\u0440\u043E\u043B\u044C",
    'Phone Number': "\u041D\u043E\u043C\u0435\u0440 \u0422\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    'Resend Code': "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
    'Reset your password': "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    'Reset your Password': "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    'Select MFA Type': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F MFA",
    'Send code': "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434",
    'Send Code': "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434",
    Sending: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u044F\u0454\u043C\u043E",
    'Setup Email': "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u0442\u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u043F\u043E\u0448\u0442\u0443",
    'Setup TOTP': "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u0442\u0438 TOTP",
    'Show password': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    'Sign in to your account': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0443 \u0432\u0430\u0448 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441",
    'Sign In with Amazon': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Amazon",
    'Sign In with Apple': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Apple",
    'Sign In with Facebook': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Facebook",
    'Sign In with Google': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Google",
    'Sign in': "\u0423\u0432\u0456\u0439\u0442\u0438",
    'Sign In': "\u0423\u0432\u0456\u0439\u0442\u0438",
    'Signing in': "\u0412\u0445\u043E\u0434\u0438\u043C\u043E",
    Skip: "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u0438",
    Submit: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
    Submitting: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u044F\u0454\u043C\u043E",
    'Text Message (SMS)': "\u0422\u0435\u043A\u0441\u0442\u043E\u0432\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F (SMS)",
    Username: "\u0406\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
    'Verify Contact': "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u041A\u043E\u043D\u0442\u0430\u043A\u0442",
    Verify: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
    'We Emailed You': "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C Email",
    'We Sent A Code': "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u0434",
    'We Texted You': "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
    'Your code is on the way. To log in, enter the code we emailed to': "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u043D\u0430 Email",
    'Your code is on the way. To log in, enter the code we sent you': "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0430\u043C \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438",
    'Your code is on the way. To log in, enter the code we texted to': "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0438\u043C \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F\u043C",
    // Additional translations
    'An account with the given email already exists.': "\u041E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u0437 \u0446\u0438\u043C Email \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454.",
    'Confirm a Code': "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u043A\u043E\u0434",
    'Confirm Sign In': "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0432\u0445\u0456\u0434",
    'Forgot Password': "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    'Incorrect username or password.': "\u041D\u0435\u0432\u0456\u0440\u043D\u0435 \u0456\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0430\u0431\u043E \u043F\u0430\u0440\u043E\u043B\u044C",
    'Invalid password format': "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043F\u0430\u0440\u043E\u043B\u044E",
    'Invalid phone number format': "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043D\u043E\u043C\u0435\u0440\u0443 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    'Loading...': "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0454\u043C\u043E...",
    'New Password': "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    'Resend a Code': "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
    'Reset Password': "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    'Sign Out': "\u0412\u0438\u0439\u0442\u0438",
    'Sign Up with Amazon': "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Amazon",
    'Sign Up with Apple': "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Apple",
    'Sign Up with Facebook': "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Facebook",
    'Sign Up with Google': "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Google",
    'Sign Up': "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
    'User already exists': "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454",
    'User does not exist': "\u0422\u0430\u043A\u0438\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u043D\u0435 \u0456\u0441\u043D\u0443\u0454",
    'Username cannot be empty': "\u0406\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0443\u0441\u0442\u0438\u043C",
    'Your passwords must match': "\u041F\u0430\u0440\u043E\u043B\u0456 \u043C\u0430\u044E\u0442\u044C \u0437\u0431\u0456\u0433\u0430\u0442\u0438\u0441\u044F"
};


const $ee8c8747bf6da86a$export$5d05d9fed4fd76b1 = {
    'Account recovery requires verified contact information': "\u0E01\u0E32\u0E23\u0E01\u0E39\u0E49\u0E04\u0E37\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E41\u0E25\u0E49\u0E27",
    'Add your Profile': "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Add your Website': "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Authenticator App (TOTP)': "\u0E41\u0E2D\u0E1B\u0E1E\u0E25\u0E34\u0E40\u0E04\u0E0A\u0E31\u0E19\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19 (TOTP)",
    'Back to Sign In': "\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    'Change Password': "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
    Changing: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19",
    Code: "\u0E23\u0E2B\u0E31\u0E2A",
    'Confirm Email Code': "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'Confirm Password': "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
    'Please confirm your Password': "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Confirm Sign Up': "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19",
    'Confirm SMS Code': "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E23\u0E2B\u0E31\u0E2A SMS",
    'Confirm MFA Code': "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E23\u0E2B\u0E31\u0E2A MFA",
    'Confirm TOTP Code': "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E23\u0E2B\u0E31\u0E2A TOTP",
    Confirm: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
    'Confirmation Code': "\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
    Confirming: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
    'Create a new account': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E43\u0E2B\u0E21\u0E48",
    'Create Account': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
    'Creating Account': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
    'Dismiss alert': "\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E41\u0E08\u0E49\u0E07\u0E40\u0E15\u0E37\u0E2D\u0E19",
    Email: "\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'Email Message': "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'Enter your Birthdate': "\u0E01\u0E23\u0E2D\u0E01\u0E27\u0E31\u0E19\u0E40\u0E01\u0E34\u0E14\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Enter your code': "\u0E01\u0E23\u0E2D\u0E01\u0E23\u0E2B\u0E31\u0E2A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Enter your Confirmation Code': "\u0E01\u0E23\u0E2D\u0E01\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Enter your Email': "\u0E01\u0E23\u0E2D\u0E01\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Enter your Family Name': "\u0E01\u0E23\u0E2D\u0E01\u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Enter your Given Name': "\u0E01\u0E23\u0E2D\u0E01\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Enter your Middle Name': "\u0E01\u0E23\u0E2D\u0E01\u0E0A\u0E37\u0E48\u0E2D\u0E01\u0E25\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Enter your Name': "\u0E01\u0E23\u0E2D\u0E01\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Enter your Nickname': "\u0E01\u0E23\u0E2D\u0E01\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E25\u0E48\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Enter your Password': "\u0E01\u0E23\u0E2D\u0E01\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Enter your email': "\u0E01\u0E23\u0E2D\u0E01\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Enter your phone number': "\u0E01\u0E23\u0E2D\u0E01\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Enter your Preferred Username': "\u0E01\u0E23\u0E2D\u0E01\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23",
    'Enter your username': "\u0E01\u0E23\u0E2D\u0E01\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Forgot password?': "\u0E25\u0E37\u0E21\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19?",
    'Forgot your password?': "\u0E25\u0E37\u0E21\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?",
    'Hide password': "\u0E0B\u0E48\u0E2D\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
    'It may take a minute to arrive': "\u0E2D\u0E32\u0E08\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E25\u0E32\u0E2A\u0E31\u0E01\u0E04\u0E23\u0E39\u0E48",
    Loading: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14",
    'Multi-Factor Authentication': "\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E2B\u0E25\u0E32\u0E22\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19",
    'Multi-Factor Authentication Setup': "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E41\u0E1A\u0E1A\u0E2B\u0E25\u0E32\u0E22\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19",
    'New password': "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
    or: "\u0E2B\u0E23\u0E37\u0E2D",
    Password: "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
    'Phone Number': "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
    'Resend Code': "\u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'Reset your Password': "\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Reset your password': "\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Select MFA Type': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17 MFA",
    'Send code': "\u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A",
    'Send Code': "\u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A",
    Sending: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E2A\u0E48\u0E07",
    'Setup Email': "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'Setup TOTP': "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32 TOTP",
    'Show password': "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
    'Sign in to your account': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'Sign In with Amazon': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22 Amazon",
    'Sign In with Apple': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22 Apple",
    'Sign In with Facebook': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22 Facebook",
    'Sign In with Google': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22 Google",
    'Sign in': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    'Sign In': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    'Signing in': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    Skip: "\u0E02\u0E49\u0E32\u0E21",
    Submit: "\u0E2A\u0E48\u0E07",
    Submitting: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E2A\u0E48\u0E07",
    'Text Message (SMS)': "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23 (SMS)",
    Username: "\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49",
    'Verify Contact': "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D",
    Verify: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
    'We Emailed You': "\u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E2A\u0E48\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E16\u0E36\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
    'We Sent A Code': "\u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E2A\u0E48\u0E07\u0E23\u0E2B\u0E31\u0E2A\u0E41\u0E25\u0E49\u0E27",
    'We Texted You': "\u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E2A\u0E48\u0E07 SMS \u0E16\u0E36\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
    'Your code is on the way. To log in, enter the code we emailed to': "\u0E23\u0E2B\u0E31\u0E2A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E21\u0E32 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A \u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E23\u0E2B\u0E31\u0E2A\u0E17\u0E35\u0E48\u0E40\u0E23\u0E32\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'Your code is on the way. To log in, enter the code we sent you': "\u0E23\u0E2B\u0E31\u0E2A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E21\u0E32 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A \u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E23\u0E2B\u0E31\u0E2A\u0E17\u0E35\u0E48\u0E40\u0E23\u0E32\u0E2A\u0E48\u0E07\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13",
    'Your code is on the way. To log in, enter the code we texted to': "\u0E23\u0E2B\u0E31\u0E2A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E21\u0E32 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A \u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E23\u0E2B\u0E31\u0E2A\u0E17\u0E35\u0E48\u0E40\u0E23\u0E32\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 SMS",
    // Additional translations
    'An account with the given email already exists.': "\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E19\u0E35\u0E49\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27",
    'Confirm a Code': "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E23\u0E2B\u0E31\u0E2A",
    'Confirm Sign In': "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    'Create account': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
    'Sign Up with Facebook': "\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E14\u0E49\u0E27\u0E22 Facebook",
    'Sign Up with Google': "\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E14\u0E49\u0E27\u0E22 Google",
    'Sign Up with Apple': "\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E14\u0E49\u0E27\u0E22 Apple",
    'Sign Up with Line': "\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E14\u0E49\u0E27\u0E22 Line",
    'Forgot Password': "\u0E25\u0E37\u0E21\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
    'Have an account? ': "\u0E21\u0E35\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27? ",
    'Incorrect username or password': "\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
    'Incorrect username or password.': "\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
    'Invalid password format': "\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
    'It may take a minute to arrive.': "\u0E2D\u0E32\u0E08\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E25\u0E32\u0E2A\u0E31\u0E01\u0E04\u0E23\u0E39\u0E48\u0E43\u0E19\u0E01\u0E32\u0E23\u0E21\u0E32\u0E16\u0E36\u0E07",
    'Lost your code? ': "\u0E2B\u0E32\u0E23\u0E2B\u0E31\u0E2A\u0E44\u0E21\u0E48\u0E40\u0E08\u0E2D? ",
    'New Password': "\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
    'No account? ': "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E1A\u0E31\u0E0D\u0E0A\u0E35? ",
    'Password attempts exceeded': "\u0E40\u0E01\u0E34\u0E19\u0E08\u0E33\u0E19\u0E27\u0E19\u0E04\u0E23\u0E31\u0E49\u0E07\u0E17\u0E35\u0E48\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
    'Reset password': "\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
    'Reset Password': "\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19",
    'Sign Out': "\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A",
    'Sign Up': "\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19",
    'User already exists': "\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E19\u0E35\u0E49\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27",
    'User does not exist': "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E19\u0E35\u0E49",
    'Username cannot be empty': "\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E2A\u0E48\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19"
};


const $7ad2bc49ad52e4f4$export$320d289eca4cc695 = {
    ADD_PROFILE: 'Add your Profile',
    ADD_WEBSITE: 'Add your Website',
    BACK_SIGN_IN: 'Back to Sign In',
    BIRTHDATE: 'Birthdate',
    CHANGE_PASSWORD: 'Change Password',
    CHANGING_PASSWORD: 'Changing',
    CODE: 'Code',
    CODE_ARRIVAL: 'It may take a minute to arrive',
    CODE_EMAILED: 'Your code is on the way. To log in, enter the code we emailed to',
    CODE_SENT: 'Your code is on the way. To log in, enter the code we sent you',
    CODE_TEXTED: 'Your code is on the way. To log in, enter the code we texted to',
    CONFIRM_PASSWORD: 'Confirm Password',
    CONFIRM_PASSWORD_PLACEHOLDER: 'Please confirm your Password',
    CONFIRM_RESET_PASSWORD_HEADING: 'Reset your Password',
    CONFIRM_SIGNUP_HEADING: 'Confirm Sign Up',
    CONFIRM_SMS: 'Confirm SMS Code',
    CONFIRM_EMAIL: 'Confirm Email Code',
    // If challenge name is not returned
    CONFIRM_MFA_DEFAULT: 'Confirm MFA Code',
    CONFIRM_TOTP: 'Confirm TOTP Code',
    CONFIRM: 'Confirm',
    CONFIRMATION_CODE: 'Confirmation Code',
    CONFIRMING: 'Confirming',
    CONTINUE: 'Continue',
    CONTINUE_WITHOUT_PASSKEY: 'Continue without a Passkey',
    CREATE_ACCOUNT: 'Create Account',
    CREATE_ACCOUNT_WITH_EMAIL_OTP: 'Create account with Email OTP',
    CREATE_ACCOUNT_WITH_PASSWORD: 'Create account with Password',
    CREATE_ACCOUNT_WITH_SMS_OTP: 'Create account with SMS OTP',
    CREATE_PASSKEY: 'Create a Passkey',
    CREATING_ACCOUNT: 'Creating Account',
    EMAIL_ADDRESS: 'Email',
    EMAIL_OTP: 'Email Message',
    ENTER_BIRTHDATE: 'Enter your Birthdate',
    ENTER_CODE: 'Enter your code',
    ENTER_CONFIRMATION_CODE: 'Enter your Confirmation Code',
    ENTER_EMAIL: 'Enter your Email',
    ENTER_FAMILY_NAME: 'Enter your Family Name',
    ENTER_GIVEN_NAME: 'Enter your Given Name',
    ENTER_MIDDLE_NAME: 'Enter your Middle Name',
    ENTER_NAME: 'Enter your Name',
    ENTER_NICK_NAME: 'Enter your Nickname',
    ENTER_PASSWORD: 'Enter your Password',
    ENTER_PHONE_NUMBER: 'Enter your Phone Number',
    ENTER_PREFERRED_USERNAME: 'Enter your Preferred Username',
    ENTER_USERNAME: 'Enter your username',
    ENTER_USERNAME_FIRST: 'Please enter your username first',
    EXISTING_PASSKEYS: 'Existing Passkeys',
    FAMILY_NAME: 'Family Name',
    GIVEN_NAME: 'Given Name',
    FORGOT_PASSWORD: 'Forgot Password?',
    FORGOT_YOUR_PASSWORD: 'Forgot your password?',
    HIDE_PASSWORD: 'Hide password',
    LOADING: 'Loading',
    LOGIN_NAME: 'Username',
    MIDDLE_NAME: 'Middle Name',
    MFA_SETUP_SELECTION: 'Multi-Factor Authentication Setup',
    MFA_SELECTION: 'Multi-Factor Authentication',
    NAME: 'Name',
    NICKNAME: 'Nickname',
    NEW_PASSWORD: 'New password',
    OR: 'or',
    OTHER_SIGN_IN_OPTIONS: 'Other sign-in options',
    PASSKEY_AUTHENTICATION_CANCELED: 'Passkey authentication was canceled. Please try again or use a different sign-in method.',
    PASSKEY_CREATED_SUCCESS: 'Passkey created successfully!',
    PASSKEY_LABEL: 'Passkey',
    PASSKEY_PROMPT_DESCRIPTION: 'Passkeys are WebAuthn credentials that validate your identity using biometric data like touch or facial recognition or device authentication like passwords or PINs, serving as a secure password replacement.',
    PASSKEY_PROMPT_HEADING: 'Sign in faster with Passkey',
    PASSKEY_REGISTERED: 'Your passkey has been successfully registered.',
    PASSKEY_REGISTRATION_FAILED: 'Failed to create passkey. Please try again.',
    PASSWORD: 'Password',
    PASSWORDLESS_NOT_ENABLED: 'Passwordless authentication is not enabled for this account. Please contact your administrator or use password sign-in.',
    PHONE_NUMBER: 'Phone Number',
    PREFERRED_USERNAME: 'Preferred Username',
    PROFILE: 'Profile',
    REGISTERING: 'Registering',
    RESEND_CODE: 'Resend Code',
    RESET_PASSWORD_HEADING: 'Reset your password',
    RESET_PASSWORD: 'Reset Password',
    SEND_CODE: 'Send code',
    CODE_DELIVERY_FAILED: 'Unable to send verification code. Please try again.',
    VERIFICATION_CODE_EXPIRED: 'Your verification code has expired. Please request a new code.',
    VERIFICATION_CODE_INVALID: 'The verification code you entered is incorrect. Please try again.',
    SENDING: 'Sending',
    SELECT_MFA_TYPE: 'Select MFA Type',
    SETUP_ANOTHER_PASSKEY: 'Setup another Passkey',
    SETUP_EMAIL: 'Setup Email',
    SETUP_TOTP: 'Setup TOTP',
    SHOW_PASSWORD: 'Show password',
    SIGN_IN_BUTTON: 'Sign in',
    SIGN_IN_TAB: 'Sign In',
    SIGN_IN_WITH_AMAZON: 'Sign In with Amazon',
    SIGN_IN_WITH_APPLE: 'Sign In with Apple',
    SIGN_IN_WITH_EMAIL: 'Sign In with Email',
    SIGN_IN_WITH_FACEBOOK: 'Sign In with Facebook',
    SIGN_IN_WITH_GOOGLE: 'Sign In with Google',
    SIGN_IN_WITH_PASSKEY: 'Sign In with Passkey',
    SIGN_IN_WITH_PASSWORD: 'Sign In with Password',
    SIGN_IN_WITH_SMS: 'Sign In with SMS',
    SIGN_IN: 'Sign in to your account',
    SIGN_UP_BUTTON: 'Create a new account',
    SIGNING_IN_BUTTON: 'Signing in',
    SKIP: 'Skip',
    SMS_MFA: 'Text Message (SMS)',
    SUBMIT: 'Submit',
    SUBMITTING: 'Submitting',
    SOFTWARE_TOKEN_MFA: 'Authenticator App (TOTP)',
    UPPERCASE_COPY: 'COPY',
    USERNAME: 'Username',
    VERIFY_CONTACT: 'Verify Contact',
    VERIFY_HEADING: 'Account recovery requires verified contact information',
    VERIFY: 'Verify',
    WE_EMAILED: 'We Emailed You',
    WE_SENT_CODE: 'We Sent A Code',
    WE_TEXTED: 'We Texted You',
    WEBSITE: 'Website'
};


//merge all the new module translations in respective locale constants
const $a364e3b26e52691b$export$cca4a41bdb910c51 = {
    ...(0, $51fdb4dbc4454e0c$export$cca4a41bdb910c51)
};
const $a364e3b26e52691b$export$eb91f595f110d703 = {
    ...(0, $299256ea3d92e8a0$export$eb91f595f110d703)
};
const $a364e3b26e52691b$export$1d204a99f5862ba9 = {
    ...(0, $c437ecf620530757$export$1d204a99f5862ba9)
};
const $a364e3b26e52691b$export$8cfa91bfcf8d11c8 = {
    ...(0, $0b0631cbb485c66b$export$8cfa91bfcf8d11c8)
};
const $a364e3b26e52691b$export$fb0bc00b40b6d1a8 = {
    ...(0, $9b53da716c551e27$export$fb0bc00b40b6d1a8)
};
const $a364e3b26e52691b$export$5c8da73de176fccc = {
    ...(0, $1fdbceef7d2638e6$export$5c8da73de176fccc)
};
const $a364e3b26e52691b$export$c416809cd76fbf21 = {
    ...(0, $556689013d66e172$export$c416809cd76fbf21)
};
const $a364e3b26e52691b$export$fb1930c2b96707b2 = {
    ...(0, $84cd8249babd4f6a$export$fb1930c2b96707b2)
};
const $a364e3b26e52691b$export$c27bce1749452052 = {
    ...(0, $1b4d4745c302acff$export$c27bce1749452052)
};
const $a364e3b26e52691b$export$8569df33fbaae243 = {
    ...(0, $21313c82790e2217$export$8569df33fbaae243)
};
const $a364e3b26e52691b$export$6fb0e8139f7ef98d = {
    ...(0, $1da5ad2afd54787b$export$6fb0e8139f7ef98d)
};
const $a364e3b26e52691b$export$c7dddbf179b434d1 = {
    ...(0, $acd4011263720517$export$c7dddbf179b434d1)
};
const $a364e3b26e52691b$export$2a86dc37ee9734c = {
    ...(0, $55a9286deff81867$export$2a86dc37ee9734c)
};
const $a364e3b26e52691b$export$9f1a61f9baaa2d2e = {
    ...(0, $0222c81754d7450e$export$9f1a61f9baaa2d2e)
};
const $a364e3b26e52691b$export$710642024bfcbd8f = {
    ...(0, $6415e0125532ffe7$export$710642024bfcbd8f)
};
const $a364e3b26e52691b$export$6961fa2059aeacf0 = {
    ...(0, $605227c5949db491$export$6961fa2059aeacf0)
};
const $a364e3b26e52691b$export$6240aeddf7c74bb8 = {
    ...(0, $4456213842a8e1e1$export$6240aeddf7c74bb8)
};
const $a364e3b26e52691b$export$b2ba232c100e7a36 = {
    ...(0, $96326d4f2ace3b8b$export$b2ba232c100e7a36)
};
const $a364e3b26e52691b$export$373d6304c6310960 = {
    ...(0, $291f6a97f3551963$export$373d6304c6310960)
};
const $a364e3b26e52691b$export$5d05d9fed4fd76b1 = {
    ...(0, $ee8c8747bf6da86a$export$5d05d9fed4fd76b1)
};
const $a364e3b26e52691b$export$320d289eca4cc695 = {
    ...(0, $7ad2bc49ad52e4f4$export$320d289eca4cc695)
};


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /**
 * Contains translatable strings that authenticator provides by default. Customers
 * can use this to add custom vocabularies:
 *
 * ```
 * I18n.putVocabulariesForLanguage("en", {
 *  [DefaultTexts.SIGN_IN]: "Custom Sign In Text",
 *  [DefaultTexts.SIGN_IN_BUTTON]: "Custom Click Here to Sign In"
 * });
 * ```
 */ const $94bd8652748873ad$export$6ba37fd455cdd594 = {
    ...(0, $a364e3b26e52691b$export$320d289eca4cc695)
};
/**
 * This helper type checks that given phrase is one of the texts @aws-amplify/ui
 * provides by default. This enables vscode autocompletion to help catch typos
 * during development.
 *
 * You can also use translate<string> to handle custom strings or dynamic content.
 */ function $94bd8652748873ad$export$d73ee8ef04f5226a(phrase) {
    return (0, $abd8c3b7750935f7$export$dbe3113d60765c1a).get(phrase);
}
/**
 * Whether I18n has a translation entry for given phrase
 */ function $94bd8652748873ad$export$8a4bbd9646545970(phrase) {
    return (0, $abd8c3b7750935f7$export$dbe3113d60765c1a).get(phrase) !== phrase;
}
const $94bd8652748873ad$export$150b732325d14d04 = {
    de: (0, $a364e3b26e52691b$export$cca4a41bdb910c51),
    en: (0, $a364e3b26e52691b$export$eb91f595f110d703),
    es: (0, $a364e3b26e52691b$export$1d204a99f5862ba9),
    fr: (0, $a364e3b26e52691b$export$8cfa91bfcf8d11c8),
    hu: (0, $a364e3b26e52691b$export$fb0bc00b40b6d1a8),
    id: (0, $a364e3b26e52691b$export$710642024bfcbd8f),
    it: (0, $a364e3b26e52691b$export$5c8da73de176fccc),
    ja: (0, $a364e3b26e52691b$export$c416809cd76fbf21),
    // TODO: remove kr in next major release
    kr: (0, $a364e3b26e52691b$export$fb1930c2b96707b2),
    ko: (0, $a364e3b26e52691b$export$fb1930c2b96707b2),
    nb: (0, $a364e3b26e52691b$export$c27bce1749452052),
    nl: (0, $a364e3b26e52691b$export$8569df33fbaae243),
    pl: (0, $a364e3b26e52691b$export$6fb0e8139f7ef98d),
    pt: (0, $a364e3b26e52691b$export$c7dddbf179b434d1),
    zh: (0, $a364e3b26e52691b$export$2a86dc37ee9734c),
    sv: (0, $a364e3b26e52691b$export$9f1a61f9baaa2d2e),
    tr: (0, $a364e3b26e52691b$export$6961fa2059aeacf0),
    ru: (0, $a364e3b26e52691b$export$6240aeddf7c74bb8),
    he: (0, $a364e3b26e52691b$export$b2ba232c100e7a36),
    ua: (0, $a364e3b26e52691b$export$373d6304c6310960),
    th: (0, $a364e3b26e52691b$export$5d05d9fed4fd76b1)
};




const $3f5eb17a62479ee4$export$a51e8cda1526c737 = [
    '+1',
    '+7',
    '+20',
    '+27',
    '+30',
    '+31',
    '+32',
    '+33',
    '+34',
    '+36',
    '+39',
    '+40',
    '+41',
    '+43',
    '+44',
    '+45',
    '+46',
    '+47',
    '+48',
    '+49',
    '+51',
    '+52',
    '+53',
    '+54',
    '+55',
    '+56',
    '+57',
    '+58',
    '+60',
    '+61',
    '+62',
    '+63',
    '+64',
    '+65',
    '+66',
    '+81',
    '+82',
    '+84',
    '+86',
    '+90',
    '+91',
    '+92',
    '+93',
    '+94',
    '+95',
    '+98',
    '+212',
    '+213',
    '+216',
    '+218',
    '+220',
    '+221',
    '+222',
    '+223',
    '+224',
    '+225',
    '+226',
    '+227',
    '+228',
    '+229',
    '+230',
    '+231',
    '+232',
    '+233',
    '+234',
    '+235',
    '+236',
    '+237',
    '+238',
    '+239',
    '+240',
    '+241',
    '+242',
    '+243',
    '+244',
    '+245',
    '+246',
    '+248',
    '+249',
    '+250',
    '+251',
    '+252',
    '+253',
    '+254',
    '+255',
    '+256',
    '+257',
    '+258',
    '+260',
    '+261',
    '+262',
    '+263',
    '+264',
    '+265',
    '+266',
    '+267',
    '+268',
    '+269',
    '+290',
    '+291',
    '+297',
    '+298',
    '+299',
    '+345',
    '+350',
    '+351',
    '+352',
    '+353',
    '+354',
    '+355',
    '+356',
    '+357',
    '+358',
    '+359',
    '+370',
    '+371',
    '+372',
    '+373',
    '+374',
    '+375',
    '+376',
    '+377',
    '+378',
    '+379',
    '+380',
    '+381',
    '+382',
    '+385',
    '+386',
    '+387',
    '+389',
    '+420',
    '+421',
    '+423',
    '+500',
    '+501',
    '+502',
    '+503',
    '+504',
    '+505',
    '+506',
    '+507',
    '+508',
    '+509',
    '+537',
    '+590',
    '+591',
    '+593',
    '+594',
    '+595',
    '+596',
    '+597',
    '+598',
    '+599',
    '+670',
    '+672',
    '+673',
    '+674',
    '+675',
    '+676',
    '+677',
    '+678',
    '+679',
    '+680',
    '+681',
    '+682',
    '+683',
    '+685',
    '+686',
    '+687',
    '+688',
    '+689',
    '+690',
    '+691',
    '+692',
    '+850',
    '+852',
    '+853',
    '+855',
    '+856',
    '+872',
    '+880',
    '+886',
    '+960',
    '+961',
    '+962',
    '+963',
    '+964',
    '+965',
    '+966',
    '+967',
    '+968',
    '+970',
    '+971',
    '+972',
    '+973',
    '+974',
    '+975',
    '+976',
    '+977',
    '+992',
    '+993',
    '+994',
    '+995',
    '+996',
    '+998'
];



/**
 * This file contains helpers related to forms and input attributes.
 */ const $4417241f2cb511f3$export$1222d357a3c2c47f = {
    birthdate: {
        label: 'Birthdate',
        placeholder: 'Enter your Birthdate',
        type: 'date',
        autocomplete: 'bday',
        isRequired: true
    },
    confirmation_code: {
        label: 'Confirmation Code',
        placeholder: 'Enter your Confirmation Code',
        type: 'text',
        autocomplete: 'one-time-code',
        isRequired: true
    },
    confirm_password: {
        label: 'Confirm Password',
        placeholder: 'Please confirm your Password',
        type: 'password',
        autocomplete: 'new-password',
        isRequired: true
    },
    email: {
        label: 'Email',
        placeholder: 'Enter your Email',
        type: 'email',
        autocomplete: 'username',
        isRequired: true
    },
    family_name: {
        label: 'Family Name',
        placeholder: 'Enter your Family Name',
        type: 'text',
        autocomplete: 'family-name',
        isRequired: true
    },
    given_name: {
        label: 'Given Name',
        placeholder: 'Enter your Given Name',
        type: 'text',
        autocomplete: 'given-name',
        isRequired: true
    },
    middle_name: {
        label: 'Middle Name',
        placeholder: 'Enter your Middle Name',
        type: 'text',
        autocomplete: 'additional-name',
        isRequired: true
    },
    name: {
        label: 'Name',
        placeholder: 'Enter your Name',
        type: 'text',
        autocomplete: 'name',
        isRequired: true
    },
    nickname: {
        label: 'Nickname',
        placeholder: 'Enter your Nickname',
        type: 'text',
        autocomplete: 'tel',
        isRequired: true
    },
    password: {
        label: 'Password',
        placeholder: 'Enter your Password',
        type: 'password',
        autocomplete: 'new-password',
        isRequired: true
    },
    phone_number: {
        label: 'Phone Number',
        placeholder: 'Enter your Phone Number',
        type: 'tel',
        autocomplete: 'tel',
        dialCode: '+1',
        dialCodeList: (0, $3f5eb17a62479ee4$export$a51e8cda1526c737),
        isRequired: true
    },
    preferred_username: {
        label: 'Preferred Username',
        placeholder: 'Enter your Preferred Username',
        type: 'text',
        isRequired: true
    },
    profile: {
        label: 'Profile',
        placeholder: 'Add your Profile',
        type: 'url',
        autocomplete: 'url',
        isRequired: true
    },
    website: {
        label: 'Website',
        placeholder: 'Add your Website',
        type: 'url',
        autocomplete: 'url',
        isRequired: true
    },
    username: {
        label: 'Username',
        placeholder: 'Enter your Username',
        type: 'text',
        autocomplete: 'username',
        isRequired: true
    }
};
/**
 * List of special characters that Cognito allows.
 *
 * Adapted from https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
 */ // prettier-ignore
const $4417241f2cb511f3$export$4223938282102ea7 = [
    '^',
    '$',
    '*',
    '.',
    '[',
    ']',
    '{',
    '}',
    '(',
    ')',
    '?',
    '"',
    '!',
    '@',
    '#',
    '%',
    '&',
    '/',
    '\\',
    ',',
    '>',
    '<',
    "'",
    ':',
    ';',
    '|',
    '_',
    '~',
    '`',
    '=',
    '+',
    '-',
    ' '
];
/**
 * Email validation regex
 *
 * source: HTML5 spec https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
 */ const $4417241f2cb511f3$export$976c37132e9c6a10 = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
/**
+ * map navigable route keys to auth event names
+ */ const $4417241f2cb511f3$export$7ccc20c5f9bc8a70 = {
    forgotPassword: 'FORGOT_PASSWORD',
    signIn: 'SIGN_IN',
    signUp: 'SIGN_UP'
};


// replaces all characters in a string with '*', except for the first and last char
const $ff807ec90f5c0ad3$export$655775443891f2b8 = (value)=>{
    const split = value.trim().split('');
    for(let i = 0; i < split.length; i++)if (i > 0 && i < split.length - 1) split[i] = '*';
    return split.join('');
};
// censors all but the last four characters of a phone number
const $ff807ec90f5c0ad3$export$72b2b64445441bf7 = (val)=>{
    if (val.length < 4) return val;
    const split = val.split('');
    for(let i = 0; i < split.length - 4; i++)split[i] = '*';
    return split.join('');
};
// censors all but the first and last of the name of an email and keeps domain
const $ff807ec90f5c0ad3$export$b3d1b28aebc8950b = (val)=>{
    const splitEmail = val.split('@');
    const censoredName = $ff807ec90f5c0ad3$export$655775443891f2b8(splitEmail[0]);
    return `${censoredName}@${splitEmail[1]}`;
};
// based on the ContactMethod type, returns a censored contact value
const $ff807ec90f5c0ad3$export$8d414ac4d74b51 = (type, value)=>{
    return type === 'Phone Number' ? $ff807ec90f5c0ad3$export$72b2b64445441bf7(value) : $ff807ec90f5c0ad3$export$b3d1b28aebc8950b(value);
};
const $ff807ec90f5c0ad3$export$1ec93875315f071d = (password)=>(0, $4417241f2cb511f3$export$4223938282102ea7).some((char)=>password.includes(char));
const $ff807ec90f5c0ad3$export$f1f323074be5cac0 = (issuer, username, secret)=>encodeURI(`otpauth://totp/${issuer}:${username}?secret=${secret}&issuer=${issuer}`);
function $ff807ec90f5c0ad3$export$205c000fb676adf6(values, ...ignored) {
    return Object.entries(values).reduce((acc, [name, value])=>({
            ...acc,
            [name]: ignored.includes(name) ? value : value?.trim()
        }), {});
}
const $ff807ec90f5c0ad3$export$371e338370561054 = (value)=>{
    if (!value) return false;
    return (0, $4417241f2cb511f3$export$976c37132e9c6a10).test(value);
};




var $8d9927c3d5f6b56d$exports = {};
var $a8f8c164fb73cd56$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $a8f8c164fb73cd56$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$a8f8c164fb73cd56$exports = $a8f8c164fb73cd56$var$arrayMap;


var $7db5125c5d420d10$exports = {};
var $685411b8b7c00cec$exports = {};
var $0d840540ce194675$exports = {};
var $4e5fedf6c4491d36$exports = {};
var $865f396e872439b1$exports = {};
var $7c49da4cc76d2d59$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $7c49da4cc76d2d59$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$7c49da4cc76d2d59$exports = $7c49da4cc76d2d59$var$listCacheClear;


var $1b5eb5fb62702fec$exports = {};
var $b6ea260f7e86691e$exports = {};
var $be0db1f702864def$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $be0db1f702864def$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$be0db1f702864def$exports = $be0db1f702864def$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $b6ea260f7e86691e$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($be0db1f702864def$exports(array[length][0], key)) return length;
    }
    return -1;
}
$b6ea260f7e86691e$exports = $b6ea260f7e86691e$var$assocIndexOf;


/** Used for built-in method references. */ var $1b5eb5fb62702fec$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $1b5eb5fb62702fec$var$splice = $1b5eb5fb62702fec$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1b5eb5fb62702fec$var$listCacheDelete(key) {
    var data = this.__data__, index = $b6ea260f7e86691e$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $1b5eb5fb62702fec$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$1b5eb5fb62702fec$exports = $1b5eb5fb62702fec$var$listCacheDelete;


var $7aab67cde60387d4$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7aab67cde60387d4$var$listCacheGet(key) {
    var data = this.__data__, index = $b6ea260f7e86691e$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$7aab67cde60387d4$exports = $7aab67cde60387d4$var$listCacheGet;


var $dc161265032f3d78$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $dc161265032f3d78$var$listCacheHas(key) {
    return $b6ea260f7e86691e$exports(this.__data__, key) > -1;
}
$dc161265032f3d78$exports = $dc161265032f3d78$var$listCacheHas;


var $e01bfd33a01e09ea$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $e01bfd33a01e09ea$var$listCacheSet(key, value) {
    var data = this.__data__, index = $b6ea260f7e86691e$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$e01bfd33a01e09ea$exports = $e01bfd33a01e09ea$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $865f396e872439b1$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$865f396e872439b1$var$ListCache.prototype.clear = $7c49da4cc76d2d59$exports;
$865f396e872439b1$var$ListCache.prototype['delete'] = $1b5eb5fb62702fec$exports;
$865f396e872439b1$var$ListCache.prototype.get = $7aab67cde60387d4$exports;
$865f396e872439b1$var$ListCache.prototype.has = $dc161265032f3d78$exports;
$865f396e872439b1$var$ListCache.prototype.set = $e01bfd33a01e09ea$exports;
$865f396e872439b1$exports = $865f396e872439b1$var$ListCache;


var $ca25650930daa53c$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $ca25650930daa53c$var$stackClear() {
    this.__data__ = new $865f396e872439b1$exports;
    this.size = 0;
}
$ca25650930daa53c$exports = $ca25650930daa53c$var$stackClear;


var $23aebdb2d0e0848f$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $23aebdb2d0e0848f$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$23aebdb2d0e0848f$exports = $23aebdb2d0e0848f$var$stackDelete;


var $c88ebd19ede71860$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c88ebd19ede71860$var$stackGet(key) {
    return this.__data__.get(key);
}
$c88ebd19ede71860$exports = $c88ebd19ede71860$var$stackGet;


var $79648a1f9fee51ff$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $79648a1f9fee51ff$var$stackHas(key) {
    return this.__data__.has(key);
}
$79648a1f9fee51ff$exports = $79648a1f9fee51ff$var$stackHas;


var $273c09739331aef6$exports = {};

var $064ef263a5624d57$exports = {};
var $03025e061708b074$exports = {};
var $151f857797502aa4$exports = {};
var $aa6921325bcd0d84$exports = {};
var $16c0370ed93333b0$exports = {};
var $ca0edca50bb4ac31$exports = {};

var $bbx7s = parcelRequire("bbx7s");
/** Built-in value references. */ var $ca0edca50bb4ac31$var$Symbol = $bbx7s.Symbol;
$ca0edca50bb4ac31$exports = $ca0edca50bb4ac31$var$Symbol;


var $e77981b6481b3b82$exports = {};

/** Used for built-in method references. */ var $e77981b6481b3b82$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e77981b6481b3b82$var$hasOwnProperty = $e77981b6481b3b82$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e77981b6481b3b82$var$nativeObjectToString = $e77981b6481b3b82$var$objectProto.toString;
/** Built-in value references. */ var $e77981b6481b3b82$var$symToStringTag = $ca0edca50bb4ac31$exports ? $ca0edca50bb4ac31$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e77981b6481b3b82$var$getRawTag(value) {
    var isOwn = $e77981b6481b3b82$var$hasOwnProperty.call(value, $e77981b6481b3b82$var$symToStringTag), tag = value[$e77981b6481b3b82$var$symToStringTag];
    try {
        value[$e77981b6481b3b82$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $e77981b6481b3b82$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e77981b6481b3b82$var$symToStringTag] = tag;
        else delete value[$e77981b6481b3b82$var$symToStringTag];
    }
    return result;
}
$e77981b6481b3b82$exports = $e77981b6481b3b82$var$getRawTag;


var $f2624dd731c1c4ff$exports = {};
/** Used for built-in method references. */ var $f2624dd731c1c4ff$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f2624dd731c1c4ff$var$nativeObjectToString = $f2624dd731c1c4ff$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $f2624dd731c1c4ff$var$objectToString(value) {
    return $f2624dd731c1c4ff$var$nativeObjectToString.call(value);
}
$f2624dd731c1c4ff$exports = $f2624dd731c1c4ff$var$objectToString;


/** `Object#toString` result references. */ var $16c0370ed93333b0$var$nullTag = '[object Null]', $16c0370ed93333b0$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $16c0370ed93333b0$var$symToStringTag = $ca0edca50bb4ac31$exports ? $ca0edca50bb4ac31$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $16c0370ed93333b0$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $16c0370ed93333b0$var$undefinedTag : $16c0370ed93333b0$var$nullTag;
    return $16c0370ed93333b0$var$symToStringTag && $16c0370ed93333b0$var$symToStringTag in Object(value) ? $e77981b6481b3b82$exports(value) : $f2624dd731c1c4ff$exports(value);
}
$16c0370ed93333b0$exports = $16c0370ed93333b0$var$baseGetTag;


var $4545c0441e7f9648$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $4545c0441e7f9648$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$4545c0441e7f9648$exports = $4545c0441e7f9648$var$isObject;


/** `Object#toString` result references. */ var $aa6921325bcd0d84$var$asyncTag = '[object AsyncFunction]', $aa6921325bcd0d84$var$funcTag = '[object Function]', $aa6921325bcd0d84$var$genTag = '[object GeneratorFunction]', $aa6921325bcd0d84$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $aa6921325bcd0d84$var$isFunction(value) {
    if (!$4545c0441e7f9648$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $16c0370ed93333b0$exports(value);
    return tag == $aa6921325bcd0d84$var$funcTag || tag == $aa6921325bcd0d84$var$genTag || tag == $aa6921325bcd0d84$var$asyncTag || tag == $aa6921325bcd0d84$var$proxyTag;
}
$aa6921325bcd0d84$exports = $aa6921325bcd0d84$var$isFunction;


var $fbb6052f6b4c8bb3$exports = {};
var $080a0b444cc2cecb$exports = {};

var $bbx7s = parcelRequire("bbx7s");
/** Used to detect overreaching core-js shims. */ var $080a0b444cc2cecb$var$coreJsData = $bbx7s["__core-js_shared__"];
$080a0b444cc2cecb$exports = $080a0b444cc2cecb$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $fbb6052f6b4c8bb3$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($080a0b444cc2cecb$exports && $080a0b444cc2cecb$exports.keys && $080a0b444cc2cecb$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $fbb6052f6b4c8bb3$var$isMasked(func) {
    return !!$fbb6052f6b4c8bb3$var$maskSrcKey && $fbb6052f6b4c8bb3$var$maskSrcKey in func;
}
$fbb6052f6b4c8bb3$exports = $fbb6052f6b4c8bb3$var$isMasked;



var $47af3389be02c86f$exports = {};
/** Used for built-in method references. */ var $47af3389be02c86f$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $47af3389be02c86f$var$funcToString = $47af3389be02c86f$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $47af3389be02c86f$var$toSource(func) {
    if (func != null) {
        try {
            return $47af3389be02c86f$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$47af3389be02c86f$exports = $47af3389be02c86f$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $151f857797502aa4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $151f857797502aa4$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $151f857797502aa4$var$funcProto = Function.prototype, $151f857797502aa4$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $151f857797502aa4$var$funcToString = $151f857797502aa4$var$funcProto.toString;
/** Used to check objects for own properties. */ var $151f857797502aa4$var$hasOwnProperty = $151f857797502aa4$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $151f857797502aa4$var$reIsNative = RegExp('^' + $151f857797502aa4$var$funcToString.call($151f857797502aa4$var$hasOwnProperty).replace($151f857797502aa4$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $151f857797502aa4$var$baseIsNative(value) {
    if (!$4545c0441e7f9648$exports(value) || $fbb6052f6b4c8bb3$exports(value)) return false;
    var pattern = $aa6921325bcd0d84$exports(value) ? $151f857797502aa4$var$reIsNative : $151f857797502aa4$var$reIsHostCtor;
    return pattern.test($47af3389be02c86f$exports(value));
}
$151f857797502aa4$exports = $151f857797502aa4$var$baseIsNative;


var $af63bb13358b6f78$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $af63bb13358b6f78$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$af63bb13358b6f78$exports = $af63bb13358b6f78$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $03025e061708b074$var$getNative(object, key) {
    var value = $af63bb13358b6f78$exports(object, key);
    return $151f857797502aa4$exports(value) ? value : undefined;
}
$03025e061708b074$exports = $03025e061708b074$var$getNative;



var $bbx7s = parcelRequire("bbx7s");
/* Built-in method references that are verified to be native. */ var $064ef263a5624d57$var$Map = $03025e061708b074$exports($bbx7s, 'Map');
$064ef263a5624d57$exports = $064ef263a5624d57$var$Map;


var $e0d6db9befb2396e$exports = {};
var $650bed2300ef72e3$exports = {};
var $5639702a4ffa675e$exports = {};
var $570f10e2cafe3b30$exports = {};
var $9db51cafd3dbad3d$exports = {};

/* Built-in method references that are verified to be native. */ var $9db51cafd3dbad3d$var$nativeCreate = $03025e061708b074$exports(Object, 'create');
$9db51cafd3dbad3d$exports = $9db51cafd3dbad3d$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $570f10e2cafe3b30$var$hashClear() {
    this.__data__ = $9db51cafd3dbad3d$exports ? $9db51cafd3dbad3d$exports(null) : {};
    this.size = 0;
}
$570f10e2cafe3b30$exports = $570f10e2cafe3b30$var$hashClear;


var $275bfae7be4b5e47$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $275bfae7be4b5e47$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$275bfae7be4b5e47$exports = $275bfae7be4b5e47$var$hashDelete;


var $2b0019c545df3d58$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $2b0019c545df3d58$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $2b0019c545df3d58$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2b0019c545df3d58$var$hasOwnProperty = $2b0019c545df3d58$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2b0019c545df3d58$var$hashGet(key) {
    var data = this.__data__;
    if ($9db51cafd3dbad3d$exports) {
        var result = data[key];
        return result === $2b0019c545df3d58$var$HASH_UNDEFINED ? undefined : result;
    }
    return $2b0019c545df3d58$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$2b0019c545df3d58$exports = $2b0019c545df3d58$var$hashGet;


var $159e491e06018134$exports = {};

/** Used for built-in method references. */ var $159e491e06018134$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $159e491e06018134$var$hasOwnProperty = $159e491e06018134$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $159e491e06018134$var$hashHas(key) {
    var data = this.__data__;
    return $9db51cafd3dbad3d$exports ? data[key] !== undefined : $159e491e06018134$var$hasOwnProperty.call(data, key);
}
$159e491e06018134$exports = $159e491e06018134$var$hashHas;


var $4aba512d92074bac$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $4aba512d92074bac$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $4aba512d92074bac$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $9db51cafd3dbad3d$exports && value === undefined ? $4aba512d92074bac$var$HASH_UNDEFINED : value;
    return this;
}
$4aba512d92074bac$exports = $4aba512d92074bac$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5639702a4ffa675e$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$5639702a4ffa675e$var$Hash.prototype.clear = $570f10e2cafe3b30$exports;
$5639702a4ffa675e$var$Hash.prototype['delete'] = $275bfae7be4b5e47$exports;
$5639702a4ffa675e$var$Hash.prototype.get = $2b0019c545df3d58$exports;
$5639702a4ffa675e$var$Hash.prototype.has = $159e491e06018134$exports;
$5639702a4ffa675e$var$Hash.prototype.set = $4aba512d92074bac$exports;
$5639702a4ffa675e$exports = $5639702a4ffa675e$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $650bed2300ef72e3$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $5639702a4ffa675e$exports,
        'map': new ($064ef263a5624d57$exports || $865f396e872439b1$exports),
        'string': new $5639702a4ffa675e$exports
    };
}
$650bed2300ef72e3$exports = $650bed2300ef72e3$var$mapCacheClear;


var $d531c7c968cb8a6c$exports = {};
var $6cb5c7e7a63c5ea2$exports = {};
var $f0048316a45cf76a$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $f0048316a45cf76a$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$f0048316a45cf76a$exports = $f0048316a45cf76a$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6cb5c7e7a63c5ea2$var$getMapData(map, key) {
    var data = map.__data__;
    return $f0048316a45cf76a$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$6cb5c7e7a63c5ea2$exports = $6cb5c7e7a63c5ea2$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d531c7c968cb8a6c$var$mapCacheDelete(key) {
    var result = $6cb5c7e7a63c5ea2$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$d531c7c968cb8a6c$exports = $d531c7c968cb8a6c$var$mapCacheDelete;


var $3f34c22263f17aae$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3f34c22263f17aae$var$mapCacheGet(key) {
    return $6cb5c7e7a63c5ea2$exports(this, key).get(key);
}
$3f34c22263f17aae$exports = $3f34c22263f17aae$var$mapCacheGet;


var $316fbb924fa4f5b0$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $316fbb924fa4f5b0$var$mapCacheHas(key) {
    return $6cb5c7e7a63c5ea2$exports(this, key).has(key);
}
$316fbb924fa4f5b0$exports = $316fbb924fa4f5b0$var$mapCacheHas;


var $d67d1c63fc38702b$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $d67d1c63fc38702b$var$mapCacheSet(key, value) {
    var data = $6cb5c7e7a63c5ea2$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$d67d1c63fc38702b$exports = $d67d1c63fc38702b$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e0d6db9befb2396e$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$e0d6db9befb2396e$var$MapCache.prototype.clear = $650bed2300ef72e3$exports;
$e0d6db9befb2396e$var$MapCache.prototype['delete'] = $d531c7c968cb8a6c$exports;
$e0d6db9befb2396e$var$MapCache.prototype.get = $3f34c22263f17aae$exports;
$e0d6db9befb2396e$var$MapCache.prototype.has = $316fbb924fa4f5b0$exports;
$e0d6db9befb2396e$var$MapCache.prototype.set = $d67d1c63fc38702b$exports;
$e0d6db9befb2396e$exports = $e0d6db9befb2396e$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $273c09739331aef6$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $273c09739331aef6$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $865f396e872439b1$exports) {
        var pairs = data.__data__;
        if (!$064ef263a5624d57$exports || pairs.length < $273c09739331aef6$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $e0d6db9befb2396e$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$273c09739331aef6$exports = $273c09739331aef6$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4e5fedf6c4491d36$var$Stack(entries) {
    var data = this.__data__ = new $865f396e872439b1$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$4e5fedf6c4491d36$var$Stack.prototype.clear = $ca25650930daa53c$exports;
$4e5fedf6c4491d36$var$Stack.prototype['delete'] = $23aebdb2d0e0848f$exports;
$4e5fedf6c4491d36$var$Stack.prototype.get = $c88ebd19ede71860$exports;
$4e5fedf6c4491d36$var$Stack.prototype.has = $79648a1f9fee51ff$exports;
$4e5fedf6c4491d36$var$Stack.prototype.set = $273c09739331aef6$exports;
$4e5fedf6c4491d36$exports = $4e5fedf6c4491d36$var$Stack;


var $3834597d94d69d5d$exports = {};
var $4a14377fce1c378f$exports = {};

var $3085d7bcf6a92010$exports = {};
var $a95ee99968ef1f56$exports = {};

var $a7e0209e860d4103$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $a7e0209e860d4103$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $a7e0209e860d4103$var$setCacheAdd(value) {
    this.__data__.set(value, $a7e0209e860d4103$var$HASH_UNDEFINED);
    return this;
}
$a7e0209e860d4103$exports = $a7e0209e860d4103$var$setCacheAdd;


var $92d4463d3d657db3$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $92d4463d3d657db3$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$92d4463d3d657db3$exports = $92d4463d3d657db3$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a95ee99968ef1f56$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $e0d6db9befb2396e$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a95ee99968ef1f56$var$SetCache.prototype.add = $a95ee99968ef1f56$var$SetCache.prototype.push = $a7e0209e860d4103$exports;
$a95ee99968ef1f56$var$SetCache.prototype.has = $92d4463d3d657db3$exports;
$a95ee99968ef1f56$exports = $a95ee99968ef1f56$var$SetCache;


var $87b5c36e1a0e983f$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $87b5c36e1a0e983f$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$87b5c36e1a0e983f$exports = $87b5c36e1a0e983f$var$arraySome;


var $f0d9a0b5c9b42632$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f0d9a0b5c9b42632$var$cacheHas(cache, key) {
    return cache.has(key);
}
$f0d9a0b5c9b42632$exports = $f0d9a0b5c9b42632$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $3085d7bcf6a92010$var$COMPARE_PARTIAL_FLAG = 1, $3085d7bcf6a92010$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $3085d7bcf6a92010$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3085d7bcf6a92010$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $3085d7bcf6a92010$var$COMPARE_UNORDERED_FLAG ? new $a95ee99968ef1f56$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$87b5c36e1a0e983f$exports(other, function(othValue, othIndex) {
                if (!$f0d9a0b5c9b42632$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$3085d7bcf6a92010$exports = $3085d7bcf6a92010$var$equalArrays;


var $675567072ba418b2$exports = {};

var $caedb05c0337e8b9$exports = {};

var $bbx7s = parcelRequire("bbx7s");
/** Built-in value references. */ var $caedb05c0337e8b9$var$Uint8Array = $bbx7s.Uint8Array;
$caedb05c0337e8b9$exports = $caedb05c0337e8b9$var$Uint8Array;




var $172eaec2001ccb96$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $172eaec2001ccb96$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$172eaec2001ccb96$exports = $172eaec2001ccb96$var$mapToArray;


var $9cb965eecb1f9c3e$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $9cb965eecb1f9c3e$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$9cb965eecb1f9c3e$exports = $9cb965eecb1f9c3e$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $675567072ba418b2$var$COMPARE_PARTIAL_FLAG = 1, $675567072ba418b2$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $675567072ba418b2$var$boolTag = '[object Boolean]', $675567072ba418b2$var$dateTag = '[object Date]', $675567072ba418b2$var$errorTag = '[object Error]', $675567072ba418b2$var$mapTag = '[object Map]', $675567072ba418b2$var$numberTag = '[object Number]', $675567072ba418b2$var$regexpTag = '[object RegExp]', $675567072ba418b2$var$setTag = '[object Set]', $675567072ba418b2$var$stringTag = '[object String]', $675567072ba418b2$var$symbolTag = '[object Symbol]';
var $675567072ba418b2$var$arrayBufferTag = '[object ArrayBuffer]', $675567072ba418b2$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $675567072ba418b2$var$symbolProto = $ca0edca50bb4ac31$exports ? $ca0edca50bb4ac31$exports.prototype : undefined, $675567072ba418b2$var$symbolValueOf = $675567072ba418b2$var$symbolProto ? $675567072ba418b2$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $675567072ba418b2$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $675567072ba418b2$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $675567072ba418b2$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $caedb05c0337e8b9$exports(object), new $caedb05c0337e8b9$exports(other))) return false;
            return true;
        case $675567072ba418b2$var$boolTag:
        case $675567072ba418b2$var$dateTag:
        case $675567072ba418b2$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $be0db1f702864def$exports(+object, +other);
        case $675567072ba418b2$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $675567072ba418b2$var$regexpTag:
        case $675567072ba418b2$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $675567072ba418b2$var$mapTag:
            var convert = $172eaec2001ccb96$exports;
        case $675567072ba418b2$var$setTag:
            var isPartial = bitmask & $675567072ba418b2$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $9cb965eecb1f9c3e$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $675567072ba418b2$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $3085d7bcf6a92010$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $675567072ba418b2$var$symbolTag:
            if ($675567072ba418b2$var$symbolValueOf) return $675567072ba418b2$var$symbolValueOf.call(object) == $675567072ba418b2$var$symbolValueOf.call(other);
    }
    return false;
}
$675567072ba418b2$exports = $675567072ba418b2$var$equalByTag;


var $61c7c6ed01997c46$exports = {};
var $f8c002594ed2bb28$exports = {};
var $5506a4b848cf7d04$exports = {};
var $ba4748716944d382$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $ba4748716944d382$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$ba4748716944d382$exports = $ba4748716944d382$var$arrayPush;


var $14d42d0e7e8c143a$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $14d42d0e7e8c143a$var$isArray = Array.isArray;
$14d42d0e7e8c143a$exports = $14d42d0e7e8c143a$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5506a4b848cf7d04$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $14d42d0e7e8c143a$exports(object) ? result : $ba4748716944d382$exports(result, symbolsFunc(object));
}
$5506a4b848cf7d04$exports = $5506a4b848cf7d04$var$baseGetAllKeys;


var $425472135309e014$exports = {};
var $e16a739892bfd96e$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $e16a739892bfd96e$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$e16a739892bfd96e$exports = $e16a739892bfd96e$var$arrayFilter;


var $4ad543b9c836f9e4$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $4ad543b9c836f9e4$var$stubArray() {
    return [];
}
$4ad543b9c836f9e4$exports = $4ad543b9c836f9e4$var$stubArray;


/** Used for built-in method references. */ var $425472135309e014$var$objectProto = Object.prototype;
/** Built-in value references. */ var $425472135309e014$var$propertyIsEnumerable = $425472135309e014$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $425472135309e014$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $425472135309e014$var$getSymbols = !$425472135309e014$var$nativeGetSymbols ? $4ad543b9c836f9e4$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $e16a739892bfd96e$exports($425472135309e014$var$nativeGetSymbols(object), function(symbol) {
        return $425472135309e014$var$propertyIsEnumerable.call(object, symbol);
    });
};
$425472135309e014$exports = $425472135309e014$var$getSymbols;


var $d5ea71b391b5cad5$exports = {};
var $7beb7cbb7aefe4c4$exports = {};
var $df89e08fabaa21ca$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $df89e08fabaa21ca$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$df89e08fabaa21ca$exports = $df89e08fabaa21ca$var$baseTimes;


var $5317d38e3a6432d8$exports = {};
var $2125339e7f709ea2$exports = {};

var $9c720bfb7629a9dc$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $9c720bfb7629a9dc$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$9c720bfb7629a9dc$exports = $9c720bfb7629a9dc$var$isObjectLike;


/** `Object#toString` result references. */ var $2125339e7f709ea2$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $2125339e7f709ea2$var$baseIsArguments(value) {
    return $9c720bfb7629a9dc$exports(value) && $16c0370ed93333b0$exports(value) == $2125339e7f709ea2$var$argsTag;
}
$2125339e7f709ea2$exports = $2125339e7f709ea2$var$baseIsArguments;



/** Used for built-in method references. */ var $5317d38e3a6432d8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5317d38e3a6432d8$var$hasOwnProperty = $5317d38e3a6432d8$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $5317d38e3a6432d8$var$propertyIsEnumerable = $5317d38e3a6432d8$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $5317d38e3a6432d8$var$isArguments = $2125339e7f709ea2$exports(function() {
    return arguments;
}()) ? $2125339e7f709ea2$exports : function(value) {
    return $9c720bfb7629a9dc$exports(value) && $5317d38e3a6432d8$var$hasOwnProperty.call(value, 'callee') && !$5317d38e3a6432d8$var$propertyIsEnumerable.call(value, 'callee');
};
$5317d38e3a6432d8$exports = $5317d38e3a6432d8$var$isArguments;




var $ly5Rw = parcelRequire("ly5Rw");
var $ec32e1589b18edff$exports = {};
/** Used as references for various `Number` constants. */ var $ec32e1589b18edff$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ec32e1589b18edff$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ec32e1589b18edff$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ec32e1589b18edff$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $ec32e1589b18edff$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$ec32e1589b18edff$exports = $ec32e1589b18edff$var$isIndex;


var $e4f028acbf1dc4a9$exports = {};
var $094e6264cd3174e0$exports = {};

var $7d06a89f661a4fec$exports = {};
/** Used as references for various `Number` constants. */ var $7d06a89f661a4fec$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $7d06a89f661a4fec$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $7d06a89f661a4fec$var$MAX_SAFE_INTEGER;
}
$7d06a89f661a4fec$exports = $7d06a89f661a4fec$var$isLength;



/** `Object#toString` result references. */ var $094e6264cd3174e0$var$argsTag = '[object Arguments]', $094e6264cd3174e0$var$arrayTag = '[object Array]', $094e6264cd3174e0$var$boolTag = '[object Boolean]', $094e6264cd3174e0$var$dateTag = '[object Date]', $094e6264cd3174e0$var$errorTag = '[object Error]', $094e6264cd3174e0$var$funcTag = '[object Function]', $094e6264cd3174e0$var$mapTag = '[object Map]', $094e6264cd3174e0$var$numberTag = '[object Number]', $094e6264cd3174e0$var$objectTag = '[object Object]', $094e6264cd3174e0$var$regexpTag = '[object RegExp]', $094e6264cd3174e0$var$setTag = '[object Set]', $094e6264cd3174e0$var$stringTag = '[object String]', $094e6264cd3174e0$var$weakMapTag = '[object WeakMap]';
var $094e6264cd3174e0$var$arrayBufferTag = '[object ArrayBuffer]', $094e6264cd3174e0$var$dataViewTag = '[object DataView]', $094e6264cd3174e0$var$float32Tag = '[object Float32Array]', $094e6264cd3174e0$var$float64Tag = '[object Float64Array]', $094e6264cd3174e0$var$int8Tag = '[object Int8Array]', $094e6264cd3174e0$var$int16Tag = '[object Int16Array]', $094e6264cd3174e0$var$int32Tag = '[object Int32Array]', $094e6264cd3174e0$var$uint8Tag = '[object Uint8Array]', $094e6264cd3174e0$var$uint8ClampedTag = '[object Uint8ClampedArray]', $094e6264cd3174e0$var$uint16Tag = '[object Uint16Array]', $094e6264cd3174e0$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $094e6264cd3174e0$var$typedArrayTags = {};
$094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$float32Tag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$float64Tag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$int8Tag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$int16Tag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$int32Tag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$uint8Tag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$uint8ClampedTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$uint16Tag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$uint32Tag] = true;
$094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$argsTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$arrayTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$arrayBufferTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$boolTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$dataViewTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$dateTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$errorTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$funcTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$mapTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$numberTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$objectTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$regexpTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$setTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$stringTag] = $094e6264cd3174e0$var$typedArrayTags[$094e6264cd3174e0$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $094e6264cd3174e0$var$baseIsTypedArray(value) {
    return $9c720bfb7629a9dc$exports(value) && $7d06a89f661a4fec$exports(value.length) && !!$094e6264cd3174e0$var$typedArrayTags[$16c0370ed93333b0$exports(value)];
}
$094e6264cd3174e0$exports = $094e6264cd3174e0$var$baseIsTypedArray;


var $32321c4f559ed533$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $32321c4f559ed533$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$32321c4f559ed533$exports = $32321c4f559ed533$var$baseUnary;



var $lOIux = parcelRequire("lOIux");
/* Node.js helper references. */ var $e4f028acbf1dc4a9$var$nodeIsTypedArray = $lOIux && $lOIux.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $e4f028acbf1dc4a9$var$isTypedArray = $e4f028acbf1dc4a9$var$nodeIsTypedArray ? $32321c4f559ed533$exports($e4f028acbf1dc4a9$var$nodeIsTypedArray) : $094e6264cd3174e0$exports;
$e4f028acbf1dc4a9$exports = $e4f028acbf1dc4a9$var$isTypedArray;


/** Used for built-in method references. */ var $7beb7cbb7aefe4c4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7beb7cbb7aefe4c4$var$hasOwnProperty = $7beb7cbb7aefe4c4$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $7beb7cbb7aefe4c4$var$arrayLikeKeys(value, inherited) {
    var isArr = $14d42d0e7e8c143a$exports(value), isArg = !isArr && $5317d38e3a6432d8$exports(value), isBuff = !isArr && !isArg && $ly5Rw(value), isType = !isArr && !isArg && !isBuff && $e4f028acbf1dc4a9$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $df89e08fabaa21ca$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $7beb7cbb7aefe4c4$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $ec32e1589b18edff$exports(key, length)))) result.push(key);
    return result;
}
$7beb7cbb7aefe4c4$exports = $7beb7cbb7aefe4c4$var$arrayLikeKeys;


var $5b7909acebb9447a$exports = {};
var $7d68cb0467e7a6ce$exports = {};
/** Used for built-in method references. */ var $7d68cb0467e7a6ce$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $7d68cb0467e7a6ce$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $7d68cb0467e7a6ce$var$objectProto;
    return value === proto;
}
$7d68cb0467e7a6ce$exports = $7d68cb0467e7a6ce$var$isPrototype;


var $86633c24f846cff0$exports = {};
var $fea2eb01ab971324$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $fea2eb01ab971324$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$fea2eb01ab971324$exports = $fea2eb01ab971324$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $86633c24f846cff0$var$nativeKeys = $fea2eb01ab971324$exports(Object.keys, Object);
$86633c24f846cff0$exports = $86633c24f846cff0$var$nativeKeys;


/** Used for built-in method references. */ var $5b7909acebb9447a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5b7909acebb9447a$var$hasOwnProperty = $5b7909acebb9447a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $5b7909acebb9447a$var$baseKeys(object) {
    if (!$7d68cb0467e7a6ce$exports(object)) return $86633c24f846cff0$exports(object);
    var result = [];
    for(var key in Object(object))if ($5b7909acebb9447a$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$5b7909acebb9447a$exports = $5b7909acebb9447a$var$baseKeys;


var $fc6e7597768712de$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $fc6e7597768712de$var$isArrayLike(value) {
    return value != null && $7d06a89f661a4fec$exports(value.length) && !$aa6921325bcd0d84$exports(value);
}
$fc6e7597768712de$exports = $fc6e7597768712de$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $d5ea71b391b5cad5$var$keys(object) {
    return $fc6e7597768712de$exports(object) ? $7beb7cbb7aefe4c4$exports(object) : $5b7909acebb9447a$exports(object);
}
$d5ea71b391b5cad5$exports = $d5ea71b391b5cad5$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $f8c002594ed2bb28$var$getAllKeys(object) {
    return $5506a4b848cf7d04$exports(object, $d5ea71b391b5cad5$exports, $425472135309e014$exports);
}
$f8c002594ed2bb28$exports = $f8c002594ed2bb28$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $61c7c6ed01997c46$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $61c7c6ed01997c46$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $61c7c6ed01997c46$var$hasOwnProperty = $61c7c6ed01997c46$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $61c7c6ed01997c46$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $61c7c6ed01997c46$var$COMPARE_PARTIAL_FLAG, objProps = $f8c002594ed2bb28$exports(object), objLength = objProps.length, othProps = $f8c002594ed2bb28$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $61c7c6ed01997c46$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$61c7c6ed01997c46$exports = $61c7c6ed01997c46$var$equalObjects;


var $a7d9099ed958a2fb$exports = {};
var $7c5e7ae66a641f8f$exports = {};


var $bbx7s = parcelRequire("bbx7s");
/* Built-in method references that are verified to be native. */ var $7c5e7ae66a641f8f$var$DataView = $03025e061708b074$exports($bbx7s, 'DataView');
$7c5e7ae66a641f8f$exports = $7c5e7ae66a641f8f$var$DataView;



var $a0f37d3fcf9b0b44$exports = {};


var $bbx7s = parcelRequire("bbx7s");
/* Built-in method references that are verified to be native. */ var $a0f37d3fcf9b0b44$var$Promise = $03025e061708b074$exports($bbx7s, 'Promise');
$a0f37d3fcf9b0b44$exports = $a0f37d3fcf9b0b44$var$Promise;


var $f22ab9012fdab743$exports = {};


var $bbx7s = parcelRequire("bbx7s");
/* Built-in method references that are verified to be native. */ var $f22ab9012fdab743$var$Set = $03025e061708b074$exports($bbx7s, 'Set');
$f22ab9012fdab743$exports = $f22ab9012fdab743$var$Set;


var $e9935d93ce6d6240$exports = {};


var $bbx7s = parcelRequire("bbx7s");
/* Built-in method references that are verified to be native. */ var $e9935d93ce6d6240$var$WeakMap = $03025e061708b074$exports($bbx7s, 'WeakMap');
$e9935d93ce6d6240$exports = $e9935d93ce6d6240$var$WeakMap;




/** `Object#toString` result references. */ var $a7d9099ed958a2fb$var$mapTag = '[object Map]', $a7d9099ed958a2fb$var$objectTag = '[object Object]', $a7d9099ed958a2fb$var$promiseTag = '[object Promise]', $a7d9099ed958a2fb$var$setTag = '[object Set]', $a7d9099ed958a2fb$var$weakMapTag = '[object WeakMap]';
var $a7d9099ed958a2fb$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $a7d9099ed958a2fb$var$dataViewCtorString = $47af3389be02c86f$exports($7c5e7ae66a641f8f$exports), $a7d9099ed958a2fb$var$mapCtorString = $47af3389be02c86f$exports($064ef263a5624d57$exports), $a7d9099ed958a2fb$var$promiseCtorString = $47af3389be02c86f$exports($a0f37d3fcf9b0b44$exports), $a7d9099ed958a2fb$var$setCtorString = $47af3389be02c86f$exports($f22ab9012fdab743$exports), $a7d9099ed958a2fb$var$weakMapCtorString = $47af3389be02c86f$exports($e9935d93ce6d6240$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $a7d9099ed958a2fb$var$getTag = $16c0370ed93333b0$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($7c5e7ae66a641f8f$exports && $a7d9099ed958a2fb$var$getTag(new $7c5e7ae66a641f8f$exports(new ArrayBuffer(1))) != $a7d9099ed958a2fb$var$dataViewTag || $064ef263a5624d57$exports && $a7d9099ed958a2fb$var$getTag(new $064ef263a5624d57$exports) != $a7d9099ed958a2fb$var$mapTag || $a0f37d3fcf9b0b44$exports && $a7d9099ed958a2fb$var$getTag($a0f37d3fcf9b0b44$exports.resolve()) != $a7d9099ed958a2fb$var$promiseTag || $f22ab9012fdab743$exports && $a7d9099ed958a2fb$var$getTag(new $f22ab9012fdab743$exports) != $a7d9099ed958a2fb$var$setTag || $e9935d93ce6d6240$exports && $a7d9099ed958a2fb$var$getTag(new $e9935d93ce6d6240$exports) != $a7d9099ed958a2fb$var$weakMapTag) $a7d9099ed958a2fb$var$getTag = function(value) {
    var result = $16c0370ed93333b0$exports(value), Ctor = result == $a7d9099ed958a2fb$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $47af3389be02c86f$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $a7d9099ed958a2fb$var$dataViewCtorString:
            return $a7d9099ed958a2fb$var$dataViewTag;
        case $a7d9099ed958a2fb$var$mapCtorString:
            return $a7d9099ed958a2fb$var$mapTag;
        case $a7d9099ed958a2fb$var$promiseCtorString:
            return $a7d9099ed958a2fb$var$promiseTag;
        case $a7d9099ed958a2fb$var$setCtorString:
            return $a7d9099ed958a2fb$var$setTag;
        case $a7d9099ed958a2fb$var$weakMapCtorString:
            return $a7d9099ed958a2fb$var$weakMapTag;
    }
    return result;
};
$a7d9099ed958a2fb$exports = $a7d9099ed958a2fb$var$getTag;




var $ly5Rw = parcelRequire("ly5Rw");

/** Used to compose bitmasks for value comparisons. */ var $4a14377fce1c378f$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $4a14377fce1c378f$var$argsTag = '[object Arguments]', $4a14377fce1c378f$var$arrayTag = '[object Array]', $4a14377fce1c378f$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $4a14377fce1c378f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4a14377fce1c378f$var$hasOwnProperty = $4a14377fce1c378f$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $4a14377fce1c378f$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $14d42d0e7e8c143a$exports(object), othIsArr = $14d42d0e7e8c143a$exports(other), objTag = objIsArr ? $4a14377fce1c378f$var$arrayTag : $a7d9099ed958a2fb$exports(object), othTag = othIsArr ? $4a14377fce1c378f$var$arrayTag : $a7d9099ed958a2fb$exports(other);
    objTag = objTag == $4a14377fce1c378f$var$argsTag ? $4a14377fce1c378f$var$objectTag : objTag;
    othTag = othTag == $4a14377fce1c378f$var$argsTag ? $4a14377fce1c378f$var$objectTag : othTag;
    var objIsObj = objTag == $4a14377fce1c378f$var$objectTag, othIsObj = othTag == $4a14377fce1c378f$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $ly5Rw(object)) {
        if (!$ly5Rw(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $4e5fedf6c4491d36$exports);
        return objIsArr || $e4f028acbf1dc4a9$exports(object) ? $3085d7bcf6a92010$exports(object, other, bitmask, customizer, equalFunc, stack) : $675567072ba418b2$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $4a14377fce1c378f$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $4a14377fce1c378f$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $4a14377fce1c378f$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $4e5fedf6c4491d36$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $4e5fedf6c4491d36$exports);
    return $61c7c6ed01997c46$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$4a14377fce1c378f$exports = $4a14377fce1c378f$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $3834597d94d69d5d$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$9c720bfb7629a9dc$exports(value) && !$9c720bfb7629a9dc$exports(other)) return value !== value && other !== other;
    return $4a14377fce1c378f$exports(value, other, bitmask, customizer, $3834597d94d69d5d$var$baseIsEqual, stack);
}
$3834597d94d69d5d$exports = $3834597d94d69d5d$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $0d840540ce194675$var$COMPARE_PARTIAL_FLAG = 1, $0d840540ce194675$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $0d840540ce194675$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $4e5fedf6c4491d36$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $3834597d94d69d5d$exports(srcValue, objValue, $0d840540ce194675$var$COMPARE_PARTIAL_FLAG | $0d840540ce194675$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$0d840540ce194675$exports = $0d840540ce194675$var$baseIsMatch;


var $6e8fae8b3fe0092a$exports = {};
var $15646981c6ca22fe$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $15646981c6ca22fe$var$isStrictComparable(value) {
    return value === value && !$4545c0441e7f9648$exports(value);
}
$15646981c6ca22fe$exports = $15646981c6ca22fe$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6e8fae8b3fe0092a$var$getMatchData(object) {
    var result = $d5ea71b391b5cad5$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $15646981c6ca22fe$exports(value)
        ];
    }
    return result;
}
$6e8fae8b3fe0092a$exports = $6e8fae8b3fe0092a$var$getMatchData;


var $4c4b2bc0d2f94b45$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $4c4b2bc0d2f94b45$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$4c4b2bc0d2f94b45$exports = $4c4b2bc0d2f94b45$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $685411b8b7c00cec$var$baseMatches(source) {
    var matchData = $6e8fae8b3fe0092a$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $4c4b2bc0d2f94b45$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $0d840540ce194675$exports(object, source, matchData);
    };
}
$685411b8b7c00cec$exports = $685411b8b7c00cec$var$baseMatches;


var $9d660de226f0558e$exports = {};

var $8e60c6ae315e65d2$exports = {};
var $93ec634d946f116f$exports = {};
var $917a918f9bd42fbb$exports = {};

var $7d83936ac47bb60a$exports = {};

var $96f99890176fc0d1$exports = {};


/** `Object#toString` result references. */ var $96f99890176fc0d1$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $96f99890176fc0d1$var$isSymbol(value) {
    return typeof value == 'symbol' || $9c720bfb7629a9dc$exports(value) && $16c0370ed93333b0$exports(value) == $96f99890176fc0d1$var$symbolTag;
}
$96f99890176fc0d1$exports = $96f99890176fc0d1$var$isSymbol;


/** Used to match property names within property paths. */ var $7d83936ac47bb60a$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $7d83936ac47bb60a$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $7d83936ac47bb60a$var$isKey(value, object) {
    if ($14d42d0e7e8c143a$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $96f99890176fc0d1$exports(value)) return true;
    return $7d83936ac47bb60a$var$reIsPlainProp.test(value) || !$7d83936ac47bb60a$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$7d83936ac47bb60a$exports = $7d83936ac47bb60a$var$isKey;


var $8e22a7cf83e6657c$exports = {};
var $f6e74ebcef6adbf4$exports = {};
var $b60e4474727166e5$exports = {};

/** Error message constants. */ var $b60e4474727166e5$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $b60e4474727166e5$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($b60e4474727166e5$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($b60e4474727166e5$var$memoize.Cache || $e0d6db9befb2396e$exports);
    return memoized;
}
// Expose `MapCache`.
$b60e4474727166e5$var$memoize.Cache = $e0d6db9befb2396e$exports;
$b60e4474727166e5$exports = $b60e4474727166e5$var$memoize;


/** Used as the maximum memoize cache size. */ var $f6e74ebcef6adbf4$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $f6e74ebcef6adbf4$var$memoizeCapped(func) {
    var result = $b60e4474727166e5$exports(func, function(key) {
        if (cache.size === $f6e74ebcef6adbf4$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$f6e74ebcef6adbf4$exports = $f6e74ebcef6adbf4$var$memoizeCapped;


/** Used to match property names within property paths. */ var $8e22a7cf83e6657c$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $8e22a7cf83e6657c$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $8e22a7cf83e6657c$var$stringToPath = $f6e74ebcef6adbf4$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($8e22a7cf83e6657c$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($8e22a7cf83e6657c$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$8e22a7cf83e6657c$exports = $8e22a7cf83e6657c$var$stringToPath;


var $03a7e8a900f37d77$exports = {};
var $088e7573d2c7e7dd$exports = {};




/** Used as references for various `Number` constants. */ var $088e7573d2c7e7dd$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $088e7573d2c7e7dd$var$symbolProto = $ca0edca50bb4ac31$exports ? $ca0edca50bb4ac31$exports.prototype : undefined, $088e7573d2c7e7dd$var$symbolToString = $088e7573d2c7e7dd$var$symbolProto ? $088e7573d2c7e7dd$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $088e7573d2c7e7dd$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($14d42d0e7e8c143a$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $a8f8c164fb73cd56$exports(value, $088e7573d2c7e7dd$var$baseToString) + '';
    if ($96f99890176fc0d1$exports(value)) return $088e7573d2c7e7dd$var$symbolToString ? $088e7573d2c7e7dd$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$088e7573d2c7e7dd$var$INFINITY ? '-0' : result;
}
$088e7573d2c7e7dd$exports = $088e7573d2c7e7dd$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $03a7e8a900f37d77$var$toString(value) {
    return value == null ? '' : $088e7573d2c7e7dd$exports(value);
}
$03a7e8a900f37d77$exports = $03a7e8a900f37d77$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $917a918f9bd42fbb$var$castPath(value, object) {
    if ($14d42d0e7e8c143a$exports(value)) return value;
    return $7d83936ac47bb60a$exports(value, object) ? [
        value
    ] : $8e22a7cf83e6657c$exports($03a7e8a900f37d77$exports(value));
}
$917a918f9bd42fbb$exports = $917a918f9bd42fbb$var$castPath;


var $61124232b85abd54$exports = {};

/** Used as references for various `Number` constants. */ var $61124232b85abd54$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $61124232b85abd54$var$toKey(value) {
    if (typeof value == 'string' || $96f99890176fc0d1$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$61124232b85abd54$var$INFINITY ? '-0' : result;
}
$61124232b85abd54$exports = $61124232b85abd54$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $93ec634d946f116f$var$baseGet(object, path) {
    path = $917a918f9bd42fbb$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$61124232b85abd54$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$93ec634d946f116f$exports = $93ec634d946f116f$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $8e60c6ae315e65d2$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $93ec634d946f116f$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$8e60c6ae315e65d2$exports = $8e60c6ae315e65d2$var$get;


var $d824632192dad7ef$exports = {};
var $1add544c1bf61a97$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $1add544c1bf61a97$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$1add544c1bf61a97$exports = $1add544c1bf61a97$var$baseHasIn;


var $50a3f80039af6a88$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $50a3f80039af6a88$var$hasPath(object, path, hasFunc) {
    path = $917a918f9bd42fbb$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $61124232b85abd54$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $7d06a89f661a4fec$exports(length) && $ec32e1589b18edff$exports(key, length) && ($14d42d0e7e8c143a$exports(object) || $5317d38e3a6432d8$exports(object));
}
$50a3f80039af6a88$exports = $50a3f80039af6a88$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $d824632192dad7ef$var$hasIn(object, path) {
    return object != null && $50a3f80039af6a88$exports(object, path, $1add544c1bf61a97$exports);
}
$d824632192dad7ef$exports = $d824632192dad7ef$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $9d660de226f0558e$var$COMPARE_PARTIAL_FLAG = 1, $9d660de226f0558e$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $9d660de226f0558e$var$baseMatchesProperty(path, srcValue) {
    if ($7d83936ac47bb60a$exports(path) && $15646981c6ca22fe$exports(srcValue)) return $4c4b2bc0d2f94b45$exports($61124232b85abd54$exports(path), srcValue);
    return function(object) {
        var objValue = $8e60c6ae315e65d2$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $d824632192dad7ef$exports(object, path) : $3834597d94d69d5d$exports(srcValue, objValue, $9d660de226f0558e$var$COMPARE_PARTIAL_FLAG | $9d660de226f0558e$var$COMPARE_UNORDERED_FLAG);
    };
}
$9d660de226f0558e$exports = $9d660de226f0558e$var$baseMatchesProperty;


var $5de784dc2546f41c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $5de784dc2546f41c$var$identity(value) {
    return value;
}
$5de784dc2546f41c$exports = $5de784dc2546f41c$var$identity;



var $8c4d3a995118c0e6$exports = {};
var $276548862f935b84$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $276548862f935b84$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$276548862f935b84$exports = $276548862f935b84$var$baseProperty;


var $26cb7012d4079659$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $26cb7012d4079659$var$basePropertyDeep(path) {
    return function(object) {
        return $93ec634d946f116f$exports(object, path);
    };
}
$26cb7012d4079659$exports = $26cb7012d4079659$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $8c4d3a995118c0e6$var$property(path) {
    return $7d83936ac47bb60a$exports(path) ? $276548862f935b84$exports($61124232b85abd54$exports(path)) : $26cb7012d4079659$exports(path);
}
$8c4d3a995118c0e6$exports = $8c4d3a995118c0e6$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $7db5125c5d420d10$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $5de784dc2546f41c$exports;
    if (typeof value == 'object') return $14d42d0e7e8c143a$exports(value) ? $9d660de226f0558e$exports(value[0], value[1]) : $685411b8b7c00cec$exports(value);
    return $8c4d3a995118c0e6$exports(value);
}
$7db5125c5d420d10$exports = $7db5125c5d420d10$var$baseIteratee;


var $b512c8f4f1a9028c$exports = {};

var $4ab46c0b6e0b316d$exports = {};
var $56b9215c6b21dd6b$exports = {};
var $a2acdb4d55eade7d$exports = {};
var $6524000617d31912$exports = {};

var $6524000617d31912$var$defineProperty = function() {
    try {
        var func = $03025e061708b074$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$6524000617d31912$exports = $6524000617d31912$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a2acdb4d55eade7d$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $6524000617d31912$exports) $6524000617d31912$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$a2acdb4d55eade7d$exports = $a2acdb4d55eade7d$var$baseAssignValue;



/** Used for built-in method references. */ var $56b9215c6b21dd6b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $56b9215c6b21dd6b$var$hasOwnProperty = $56b9215c6b21dd6b$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $56b9215c6b21dd6b$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($56b9215c6b21dd6b$var$hasOwnProperty.call(object, key) && $be0db1f702864def$exports(objValue, value)) || value === undefined && !(key in object)) $a2acdb4d55eade7d$exports(object, key, value);
}
$56b9215c6b21dd6b$exports = $56b9215c6b21dd6b$var$assignValue;






/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $4ab46c0b6e0b316d$var$baseSet(object, path, value, customizer) {
    if (!$4545c0441e7f9648$exports(object)) return object;
    path = $917a918f9bd42fbb$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $61124232b85abd54$exports(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $4545c0441e7f9648$exports(objValue) ? objValue : $ec32e1589b18edff$exports(path[index + 1]) ? [] : {};
        }
        $56b9215c6b21dd6b$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$4ab46c0b6e0b316d$exports = $4ab46c0b6e0b316d$var$baseSet;



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $b512c8f4f1a9028c$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $93ec634d946f116f$exports(object, path);
        if (predicate(value, path)) $4ab46c0b6e0b316d$exports(result, $917a918f9bd42fbb$exports(path, object), value);
    }
    return result;
}
$b512c8f4f1a9028c$exports = $b512c8f4f1a9028c$var$basePickBy;


var $e9765ea735d53ac3$exports = {};

var $1cf42a2a314a5e7a$exports = {};

var $dfa68a96ace7fe9b$exports = {};

/** Built-in value references. */ var $dfa68a96ace7fe9b$var$getPrototype = $fea2eb01ab971324$exports(Object.getPrototypeOf, Object);
$dfa68a96ace7fe9b$exports = $dfa68a96ace7fe9b$var$getPrototype;




/* Built-in method references for those with the same name as other `lodash` methods. */ var $1cf42a2a314a5e7a$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $1cf42a2a314a5e7a$var$getSymbolsIn = !$1cf42a2a314a5e7a$var$nativeGetSymbols ? $4ad543b9c836f9e4$exports : function(object) {
    var result = [];
    while(object){
        $ba4748716944d382$exports(result, $425472135309e014$exports(object));
        object = $dfa68a96ace7fe9b$exports(object);
    }
    return result;
};
$1cf42a2a314a5e7a$exports = $1cf42a2a314a5e7a$var$getSymbolsIn;


var $cbb55d54fab94e40$exports = {};

var $7cd35bfa16d81fca$exports = {};


var $8b8621662db4c2fa$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8b8621662db4c2fa$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$8b8621662db4c2fa$exports = $8b8621662db4c2fa$var$nativeKeysIn;


/** Used for built-in method references. */ var $7cd35bfa16d81fca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7cd35bfa16d81fca$var$hasOwnProperty = $7cd35bfa16d81fca$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7cd35bfa16d81fca$var$baseKeysIn(object) {
    if (!$4545c0441e7f9648$exports(object)) return $8b8621662db4c2fa$exports(object);
    var isProto = $7d68cb0467e7a6ce$exports(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$7cd35bfa16d81fca$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$7cd35bfa16d81fca$exports = $7cd35bfa16d81fca$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $cbb55d54fab94e40$var$keysIn(object) {
    return $fc6e7597768712de$exports(object) ? $7beb7cbb7aefe4c4$exports(object, true) : $7cd35bfa16d81fca$exports(object);
}
$cbb55d54fab94e40$exports = $cbb55d54fab94e40$var$keysIn;


/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e9765ea735d53ac3$var$getAllKeysIn(object) {
    return $5506a4b848cf7d04$exports(object, $cbb55d54fab94e40$exports, $1cf42a2a314a5e7a$exports);
}
$e9765ea735d53ac3$exports = $e9765ea735d53ac3$var$getAllKeysIn;


/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $8d9927c3d5f6b56d$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $a8f8c164fb73cd56$exports($e9765ea735d53ac3$exports(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $7db5125c5d420d10$exports(predicate);
    return $b512c8f4f1a9028c$exports(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
$8d9927c3d5f6b56d$exports = $8d9927c3d5f6b56d$var$pickBy;





// default `autoSignIn` flag is `true`
const $c8aa466d6fbfe6bd$var$DEFAULT_AUTO_SIGN_IN = true;
const $c8aa466d6fbfe6bd$var$EMPTY_STRING = '';
const $c8aa466d6fbfe6bd$export$bdf2363efaa77dc8 = (dialCode, phoneNumber)=>`${dialCode}${phoneNumber}`.replace(/[^A-Z0-9+]/gi, '');
const $c8aa466d6fbfe6bd$var$selectUserAttributes = (_, key)=>{
    // Allowlist of Cognito User Pool Attributes (from OpenID Connect specification)
    // See: https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-attributes.html
    switch(key){
        case 'address':
        case 'birthdate':
        case 'email':
        case 'family_name':
        case 'gender':
        case 'given_name':
        case 'locale':
        case 'middle_name':
        case 'name':
        case 'nickname':
        case 'phone_number':
        case 'picture':
        case 'preferred_username':
        case 'profile':
        case 'updated_at':
        case 'website':
        case 'zoneinfo':
            return true;
        // Otherwise, it's a custom attribute
        default:
            return key.startsWith('custom:');
    }
};
const $c8aa466d6fbfe6bd$export$e741ea695767fdb4 = (formValues)=>{
    const { phone_number: phone_number, ...userAttributes } = (0, (/*@__PURE__*/$parcel$interopDefault($8d9927c3d5f6b56d$exports)))(formValues, $c8aa466d6fbfe6bd$var$selectUserAttributes);
    // only include `phone_number` attribute in `userAttributes` if it has a value
    if ((0, $fd30e9352c42562e$export$844ec244b1367d54)(phone_number) && phone_number !== $c8aa466d6fbfe6bd$var$EMPTY_STRING) {
        const { country_code: country_code } = formValues;
        return {
            ...userAttributes,
            phone_number: $c8aa466d6fbfe6bd$export$bdf2363efaa77dc8(country_code, phone_number)
        };
    }
    return userAttributes;
};
const $c8aa466d6fbfe6bd$export$6bc605b0b68c7601 = (username, formValues, loginMechanism, authMethod)=>{
    const { password: password, ...values } = formValues;
    const attributes = $c8aa466d6fbfe6bd$export$e741ea695767fdb4(values);
    const isPasswordless = authMethod && authMethod !== 'PASSWORD';
    // For SMS OTP, set the email channel to empty string if present to force account creation with phone number
    let userAttributes = attributes;
    if (authMethod === 'SMS_OTP' && attributes.email) userAttributes = {
        ...attributes,
        email: ''
    };
    const options = {
        autoSignIn: isPasswordless ? {
            enabled: true,
            authFlowType: 'USER_AUTH',
            preferredChallenge: authMethod
        } : $c8aa466d6fbfe6bd$var$DEFAULT_AUTO_SIGN_IN,
        userAttributes: {
            // use `username` value for `phone_number`
            ...loginMechanism === 'phone_number' ? {
                ...userAttributes,
                phone_number: username
            } : userAttributes
        }
    };
    return {
        username: username,
        password: isPasswordless ? undefined : password,
        options: options
    };
};
const $c8aa466d6fbfe6bd$export$4ff49060fec3afdc = ({ formValues: formValues, loginMechanisms: loginMechanisms })=>{
    // Check if a specific auth method was selected via form data
    const authMethod = formValues.__authMethod;
    // For SMS_OTP, always use phone_number as username
    if (authMethod === 'SMS_OTP') {
        const { country_code: country_code, phone_number: phone_number } = formValues;
        return $c8aa466d6fbfe6bd$export$bdf2363efaa77dc8(country_code, phone_number);
    }
    // For EMAIL_OTP, always use email as username
    if (authMethod === 'EMAIL_OTP') return formValues.email;
    // When 'username' is in loginMechanisms, always use the username field for the Username parameter.
    // This handles both username-only mode and alias mode (username + email/phone as sign-in options).
    // See: https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-attributes.html#user-pool-settings-aliases
    if (loginMechanisms.includes('username')) return formValues.username;
    const loginMechanism = loginMechanisms[0];
    if (loginMechanism === 'phone_number') {
        const { country_code: country_code, phone_number: phone_number } = formValues;
        return $c8aa466d6fbfe6bd$export$bdf2363efaa77dc8(country_code, phone_number);
    }
    // Otherwise, use the primary login mechanism (email as username)
    return formValues[loginMechanism];
};
/**
 * Get available authentication methods based on backend capabilities and hidden methods
 */ const $c8aa466d6fbfe6bd$export$3c35915b968f3769 = (passwordlessCapabilities, hiddenAuthMethods)=>{
    const allMethods = [];
    // If hiddenAuthMethods is explicitly provided (even as empty array),
    // assume all methods are available and let hiddenAuthMethods filter them
    const assumeAllAvailable = hiddenAuthMethods !== undefined;
    // PASSWORD is always available by default
    allMethods.push('PASSWORD');
    // Add passwordless methods if backend supports them OR if hiddenAuthMethods is explicitly set
    if (assumeAllAvailable || passwordlessCapabilities?.emailOtpEnabled) allMethods.push('EMAIL_OTP');
    if (assumeAllAvailable || passwordlessCapabilities?.smsOtpEnabled) allMethods.push('SMS_OTP');
    if (assumeAllAvailable || passwordlessCapabilities?.webAuthnEnabled) allMethods.push('WEB_AUTHN');
    // Filter out hidden methods
    const hidden = hiddenAuthMethods ?? [];
    const availableMethods = allMethods.filter((method)=>!hidden.includes(method));
    // Validate that at least one method remains
    if (availableMethods.length === 0) throw new Error('InvalidPasswordlessSettings: All authentication methods are hidden');
    return availableMethods;
};


const { assign: $64ef23d998d8f5c7$var$assign } = (0, $673da5a8478f7656$exports);
const $64ef23d998d8f5c7$var$clearActorDoneData = $64ef23d998d8f5c7$var$assign({
    actorDoneData: undefined
});
const $64ef23d998d8f5c7$var$clearChallengeName = $64ef23d998d8f5c7$var$assign({
    challengeName: undefined
});
const $64ef23d998d8f5c7$var$clearMissingAttributes = $64ef23d998d8f5c7$var$assign({
    missingAttributes: undefined
});
const $64ef23d998d8f5c7$var$clearError = $64ef23d998d8f5c7$var$assign({
    remoteError: undefined
});
const $64ef23d998d8f5c7$var$clearFormValues = $64ef23d998d8f5c7$var$assign({
    formValues: (context)=>({
            // Preserve username for passwordless flows to avoid "username is required" errors
            username: context.formValues?.username
        })
});
const $64ef23d998d8f5c7$var$clearTouched = $64ef23d998d8f5c7$var$assign({
    touched: {}
});
const $64ef23d998d8f5c7$var$clearUser = $64ef23d998d8f5c7$var$assign({
    user: undefined
});
const $64ef23d998d8f5c7$var$clearValidationError = $64ef23d998d8f5c7$var$assign({
    validationError: {}
});
/**
 * "set" actions
 */ const $64ef23d998d8f5c7$var$setTotpSecretCode = $64ef23d998d8f5c7$var$assign({
    totpSecretCode: (_, { data: data })=>{
        const { sharedSecret: sharedSecret } = data.nextStep?.totpSetupDetails ?? {};
        return sharedSecret;
    }
});
const $64ef23d998d8f5c7$var$setAllowedMfaTypes = $64ef23d998d8f5c7$var$assign({
    allowedMfaTypes: (_, { data: data })=>{
        return data.nextStep?.allowedMFATypes;
    }
});
const $64ef23d998d8f5c7$var$setSignInStep = $64ef23d998d8f5c7$var$assign({
    step: 'SIGN_IN'
});
const $64ef23d998d8f5c7$var$setShouldVerifyUserAttributeStep = $64ef23d998d8f5c7$var$assign({
    step: 'SHOULD_CONFIRM_USER_ATTRIBUTE'
});
const $64ef23d998d8f5c7$var$setConfirmAttributeCompleteStep = $64ef23d998d8f5c7$var$assign({
    step: 'CONFIRM_ATTRIBUTE_COMPLETE'
});
// map v6 `signInStep` to v5 `challengeName`
const $64ef23d998d8f5c7$var$setChallengeName = $64ef23d998d8f5c7$var$assign({
    challengeName: (_, { data: data })=>{
        const { signInStep: signInStep } = data.nextStep;
        switch(signInStep){
            case 'CONFIRM_SIGN_IN_WITH_SMS_CODE':
                return 'SMS_MFA';
            case 'CONFIRM_SIGN_IN_WITH_TOTP_CODE':
                return 'SOFTWARE_TOKEN_MFA';
            case 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE':
                return 'EMAIL_OTP';
            case 'CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION':
            case 'CONTINUE_SIGN_IN_WITH_EMAIL_SETUP':
            case 'CONTINUE_SIGN_IN_WITH_TOTP_SETUP':
                return 'MFA_SETUP';
            case 'CONTINUE_SIGN_IN_WITH_MFA_SELECTION':
                return 'SELECT_MFA_TYPE';
            default:
                return undefined;
        }
    }
});
const $64ef23d998d8f5c7$var$setUsernameForgotPassword = $64ef23d998d8f5c7$var$assign({
    username: ({ formValues: formValues, loginMechanisms: loginMechanisms })=>{
        const loginMechanism = loginMechanisms[0];
        const { username: username, country_code: country_code } = formValues;
        if (loginMechanism === 'phone_number') // forgot password `formValues` uses `username` for base phone number value
        // prefix `country_code` for full `username`
        return (0, $c8aa466d6fbfe6bd$export$bdf2363efaa77dc8)(country_code, username);
        // default username field for loginMechanism === 'email' is "username" for SignIn
        return username;
    }
});
const $64ef23d998d8f5c7$var$setUsernameSignUp = $64ef23d998d8f5c7$var$assign({
    username: (0, $c8aa466d6fbfe6bd$export$4ff49060fec3afdc)
});
const $64ef23d998d8f5c7$var$setUsernameSignIn = $64ef23d998d8f5c7$var$assign({
    username: ({ formValues: formValues, loginMechanisms: loginMechanisms })=>{
        const loginMechanism = loginMechanisms[0];
        const { username: username, country_code: country_code } = formValues;
        if (loginMechanism === 'phone_number') // sign in `formValues` uses `username` for base phone number value
        // prefix `country_code` for full `username`
        return (0, $c8aa466d6fbfe6bd$export$bdf2363efaa77dc8)(country_code, username);
        // return `email` and `username`
        return username;
    }
});
const $64ef23d998d8f5c7$var$setNextSignInStep = $64ef23d998d8f5c7$var$assign({
    step: (_, { data: data })=>data.nextStep.signInStep === 'DONE' ? 'SIGN_IN_COMPLETE' : data.nextStep.signInStep
});
const $64ef23d998d8f5c7$var$setNextSignUpStep = $64ef23d998d8f5c7$var$assign({
    step: (_, { data: data })=>data.nextStep.signUpStep === 'DONE' ? 'SIGN_UP_COMPLETE' : data.nextStep.signUpStep
});
const $64ef23d998d8f5c7$var$setNextResetPasswordStep = $64ef23d998d8f5c7$var$assign({
    step: (_, { data: data })=>data.nextStep.resetPasswordStep === 'DONE' ? 'RESET_PASSWORD_COMPLETE' : data.nextStep.resetPasswordStep
});
const $64ef23d998d8f5c7$var$setMissingAttributes = $64ef23d998d8f5c7$var$assign({
    missingAttributes: (_, { data: data })=>data.nextStep?.missingAttributes
});
const $64ef23d998d8f5c7$var$setFieldErrors = $64ef23d998d8f5c7$var$assign({
    validationError: (_, { data: data })=>data
});
const $64ef23d998d8f5c7$var$setRemoteError = $64ef23d998d8f5c7$var$assign({
    remoteError: (_, { data: data })=>{
        if (data.name === 'NoUserPoolError') return `Configuration error (see console) \u{2013} please contact the administrator`;
        const message = data?.message || '';
        // Handle USER_AUTH flow not enabled error
        if (message.includes('USER_AUTH flow not enabled')) return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).PASSWORDLESS_NOT_ENABLED);
        // Handle cannot send code error
        if (message.includes('Cannot send code to either')) return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CODE_DELIVERY_FAILED);
        // Handle invalid/wrong verification code
        if (message.includes('Invalid code or auth state')) return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).VERIFICATION_CODE_INVALID);
        // Handle expired verification code
        if (message.includes('session is expired')) return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).VERIFICATION_CODE_EXPIRED);
        // Handle passkey authentication canceled
        if (message.includes('ceremony has been canceled')) return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).PASSKEY_AUTHENTICATION_CANCELED);
        return message || data;
    }
});
const $64ef23d998d8f5c7$var$setUser = $64ef23d998d8f5c7$var$assign({
    user: (_, { data: data })=>data
});
const $64ef23d998d8f5c7$var$resolveCodeDeliveryDetails = (details)=>({
        Destination: details.destination,
        DeliveryMedium: details.deliveryMedium,
        AttributeName: details.attributName
    });
const $64ef23d998d8f5c7$var$setCodeDeliveryDetails = $64ef23d998d8f5c7$var$assign({
    codeDeliveryDetails: (_, { data: data })=>{
        if (data?.nextStep?.codeDeliveryDetails) return $64ef23d998d8f5c7$var$resolveCodeDeliveryDetails(data.nextStep.codeDeliveryDetails);
        return $64ef23d998d8f5c7$var$resolveCodeDeliveryDetails(data);
    }
});
const $64ef23d998d8f5c7$var$handleInput = $64ef23d998d8f5c7$var$assign({
    formValues: (context, { data: data })=>{
        const { name: name, value: value } = data;
        return {
            ...context['formValues'],
            [name]: value
        };
    }
});
const $64ef23d998d8f5c7$var$handleSubmit = $64ef23d998d8f5c7$var$assign({
    formValues: (context, { data: data })=>// do not trim password
        (0, $ff807ec90f5c0ad3$export$205c000fb676adf6)({
            ...context['formValues'],
            ...data
        }, 'password')
});
const $64ef23d998d8f5c7$var$handleBlur = $64ef23d998d8f5c7$var$assign({
    touched: (context, { data: data })=>({
            ...context['touched'],
            [data.name]: true
        })
});
const $64ef23d998d8f5c7$var$setUnverifiedUserAttributes = $64ef23d998d8f5c7$var$assign({
    unverifiedUserAttributes: (context, { data: data })=>{
        // Use fetchedUserAttributes from context if data is not provided
        const attributes = data || context.fetchedUserAttributes;
        if (!attributes) return {};
        const { email: email, phone_number: phone_number } = attributes;
        const unverifiedUserAttributes = {
            ...email && {
                email: email
            },
            ...phone_number && {
                phone_number: phone_number
            }
        };
        return unverifiedUserAttributes;
    }
});
const $64ef23d998d8f5c7$var$clearSelectedUserAttribute = $64ef23d998d8f5c7$var$assign({
    selectedUserAttribute: undefined
});
const $64ef23d998d8f5c7$var$setSelectedUserAttribute = $64ef23d998d8f5c7$var$assign({
    selectedUserAttribute: (context)=>context.formValues?.unverifiedAttr
});
// Maps to unexposed `ConfirmSignUpSignUpStep`
const $64ef23d998d8f5c7$var$setConfirmSignUpSignUpStep = $64ef23d998d8f5c7$var$assign({
    step: 'CONFIRM_SIGN_UP'
});
// Passwordless actions
const $64ef23d998d8f5c7$var$setSelectedAuthMethod = $64ef23d998d8f5c7$var$assign({
    selectedAuthMethod: (_, { data: data })=>data.method
});
const $64ef23d998d8f5c7$var$setSelectedAuthMethodFromForm = $64ef23d998d8f5c7$var$assign({
    selectedAuthMethod: (_, { data: data })=>{
        // Extract method from form data if present, default to PASSWORD for form submissions
        return data?.__authMethod || 'PASSWORD';
    }
});
const $64ef23d998d8f5c7$var$setSelectAuthMethodStep = $64ef23d998d8f5c7$var$assign({
    step: 'SELECT_AUTH_METHOD'
});
const $64ef23d998d8f5c7$var$setFetchedUserAttributes = $64ef23d998d8f5c7$var$assign({
    fetchedUserAttributes: (_, event)=>event.data
});
const $64ef23d998d8f5c7$var$setHasExistingPasskeys = $64ef23d998d8f5c7$var$assign({
    hasExistingPasskeys: (_, event)=>event.data
});
const $64ef23d998d8f5c7$var$clearHasExistingPasskeys = $64ef23d998d8f5c7$var$assign({
    hasExistingPasskeys: false
});
const $64ef23d998d8f5c7$export$2e2bcd8739ae039 = {
    clearActorDoneData: $64ef23d998d8f5c7$var$clearActorDoneData,
    clearChallengeName: $64ef23d998d8f5c7$var$clearChallengeName,
    clearError: $64ef23d998d8f5c7$var$clearError,
    clearFormValues: $64ef23d998d8f5c7$var$clearFormValues,
    clearHasExistingPasskeys: $64ef23d998d8f5c7$var$clearHasExistingPasskeys,
    clearMissingAttributes: $64ef23d998d8f5c7$var$clearMissingAttributes,
    clearSelectedUserAttribute: $64ef23d998d8f5c7$var$clearSelectedUserAttribute,
    clearTouched: $64ef23d998d8f5c7$var$clearTouched,
    clearUser: $64ef23d998d8f5c7$var$clearUser,
    clearValidationError: $64ef23d998d8f5c7$var$clearValidationError,
    handleBlur: $64ef23d998d8f5c7$var$handleBlur,
    handleInput: $64ef23d998d8f5c7$var$handleInput,
    handleSubmit: $64ef23d998d8f5c7$var$handleSubmit,
    setAllowedMfaTypes: $64ef23d998d8f5c7$var$setAllowedMfaTypes,
    setChallengeName: $64ef23d998d8f5c7$var$setChallengeName,
    setCodeDeliveryDetails: $64ef23d998d8f5c7$var$setCodeDeliveryDetails,
    setFetchedUserAttributes: $64ef23d998d8f5c7$var$setFetchedUserAttributes,
    setFieldErrors: $64ef23d998d8f5c7$var$setFieldErrors,
    setHasExistingPasskeys: $64ef23d998d8f5c7$var$setHasExistingPasskeys,
    setMissingAttributes: $64ef23d998d8f5c7$var$setMissingAttributes,
    setNextResetPasswordStep: $64ef23d998d8f5c7$var$setNextResetPasswordStep,
    setNextSignInStep: $64ef23d998d8f5c7$var$setNextSignInStep,
    setNextSignUpStep: $64ef23d998d8f5c7$var$setNextSignUpStep,
    setRemoteError: $64ef23d998d8f5c7$var$setRemoteError,
    setConfirmAttributeCompleteStep: $64ef23d998d8f5c7$var$setConfirmAttributeCompleteStep,
    setConfirmSignUpSignUpStep: $64ef23d998d8f5c7$var$setConfirmSignUpSignUpStep,
    setSelectAuthMethodStep: $64ef23d998d8f5c7$var$setSelectAuthMethodStep,
    setSelectedAuthMethod: $64ef23d998d8f5c7$var$setSelectedAuthMethod,
    setSelectedAuthMethodFromForm: $64ef23d998d8f5c7$var$setSelectedAuthMethodFromForm,
    setShouldVerifyUserAttributeStep: $64ef23d998d8f5c7$var$setShouldVerifyUserAttributeStep,
    setSelectedUserAttribute: $64ef23d998d8f5c7$var$setSelectedUserAttribute,
    setSignInStep: $64ef23d998d8f5c7$var$setSignInStep,
    setTotpSecretCode: $64ef23d998d8f5c7$var$setTotpSecretCode,
    setUser: $64ef23d998d8f5c7$var$setUser,
    setUnverifiedUserAttributes: $64ef23d998d8f5c7$var$setUnverifiedUserAttributes,
    setUsernameForgotPassword: $64ef23d998d8f5c7$var$setUsernameForgotPassword,
    setUsernameSignIn: $64ef23d998d8f5c7$var$setUsernameSignIn,
    setUsernameSignUp: $64ef23d998d8f5c7$var$setUsernameSignUp
};


const $c736c047e930e5f4$var$SIGN_IN_STEP_MFA_CONFIRMATION = [
    'CONFIRM_SIGN_IN_WITH_SMS_CODE',
    'CONFIRM_SIGN_IN_WITH_TOTP_CODE',
    'CONFIRM_SIGN_IN_WITH_EMAIL_CODE'
];
// response next step guards
const $c736c047e930e5f4$var$shouldConfirmSignInWithNewPassword = (_, { data: data })=>data?.nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED';
const $c736c047e930e5f4$var$shouldResetPasswordFromSignIn = (_, { data: data })=>data?.nextStep?.signInStep === 'RESET_PASSWORD';
const $c736c047e930e5f4$var$shouldConfirmSignUpFromSignIn = (_, { data: data })=>data?.nextStep.signInStep === 'CONFIRM_SIGN_UP';
const $c736c047e930e5f4$var$shouldAutoSignIn = (_, { data: data })=>data?.nextStep.signUpStep === 'COMPLETE_AUTO_SIGN_IN';
const $c736c047e930e5f4$var$shouldManualSignIn = (context, { data: data })=>data?.nextStep.signUpStep === 'DONE' && context.step === 'CONFIRM_SIGN_UP';
const $c736c047e930e5f4$var$hasCompletedSignIn = (_, { data: data })=>data?.nextStep.signInStep === 'DONE';
const $c736c047e930e5f4$var$hasCompletedSignUp = (_, { data: data })=>data?.nextStep.signUpStep === 'DONE';
const $c736c047e930e5f4$var$hasCompletedResetPassword = (_, { data: data })=>data?.nextStep.resetPasswordStep === 'DONE';
// actor done guards read `step` from actor exit event
const $c736c047e930e5f4$var$hasCompletedAttributeConfirmation = (_, { data: data })=>data?.step === 'CONFIRM_ATTRIBUTE_COMPLETE';
const $c736c047e930e5f4$var$isConfirmUserAttributeStep = (_, { data: data })=>data?.step === 'CONFIRM_ATTRIBUTE_WITH_CODE';
const $c736c047e930e5f4$var$isShouldConfirmUserAttributeStep = (_, { data: data })=>data?.step === 'SHOULD_CONFIRM_USER_ATTRIBUTE';
const $c736c047e930e5f4$var$isResetPasswordStep = (_, { data: data })=>data?.step === 'RESET_PASSWORD';
const $c736c047e930e5f4$var$isConfirmSignUpStep = (_, { data: data })=>data?.step === 'CONFIRM_SIGN_UP';
// actor entry guards read `step` from actor context
const $c736c047e930e5f4$var$shouldConfirmSignIn = ({ step: step })=>$c736c047e930e5f4$var$SIGN_IN_STEP_MFA_CONFIRMATION.includes(step);
const $c736c047e930e5f4$var$shouldSetupTotp = ({ step: step })=>step === 'CONTINUE_SIGN_IN_WITH_TOTP_SETUP';
const $c736c047e930e5f4$var$shouldSetupEmail = ({ step: step })=>step === 'CONTINUE_SIGN_IN_WITH_EMAIL_SETUP';
const $c736c047e930e5f4$var$shouldSelectMfaType = ({ step: step })=>[
        'CONTINUE_SIGN_IN_WITH_MFA_SELECTION',
        'CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION'
    ].includes(step);
const $c736c047e930e5f4$var$shouldResetPassword = ({ step: step })=>step === 'RESET_PASSWORD';
const $c736c047e930e5f4$var$shouldConfirmResetPassword = ({ step: step })=>step === 'CONFIRM_RESET_PASSWORD_WITH_CODE';
const $c736c047e930e5f4$var$shouldConfirmSignUp = ({ step: step })=>step === 'CONFIRM_SIGN_UP';
// miscellaneous guards
const $c736c047e930e5f4$var$shouldVerifyAttribute = (context, event)=>{
    // Try to get data from event first (for backward compatibility), then from context
    const data = event.data || context.fetchedUserAttributes;
    if (!data) return false;
    const { email: email, phone_number: phone_number, phone_number_verified: phone_number_verified, email_verified: email_verified } = data;
    // if neither email nor phone_number exist
    // there is nothing to verify
    if (!email && !phone_number) return false;
    // email/phone_verified is returned as a string
    const emailNotVerified = email_verified === undefined || email_verified === 'false';
    const phoneNotVerified = phone_number_verified === undefined || phone_number_verified === 'false';
    // only request verification if both email and phone are not verified
    return emailNotVerified && phoneNotVerified;
};
/**
 * This guard covers an edge case that exists in the current state of the UI.
 * As of now, our ConfirmSignUp screen only supports showing an input for a
 * confirmation code. However, a Cognito UserPool can instead verify users
 * through a link that gets emailed to them. If a user verifies through the
 * link and then they click on the "Resend Code" button, they will get an error
 * saying that the user has already been confirmed. If we encounter that error,
 * we want to just funnel them through the rest of the flow. In the future, we will
 * want to update our UI to support both confirmation codes and links.
 *
 * https://github.com/aws-amplify/amplify-ui/issues/219
 */ const $c736c047e930e5f4$var$isUserAlreadyConfirmed = (_, { data: data })=>data.message === 'User is already confirmed.';
// passwordless guards
const $c736c047e930e5f4$var$shouldSelectAuthMethod = ({ availableAuthMethods: availableAuthMethods, preferredChallenge: preferredChallenge, selectedAuthMethod: selectedAuthMethod })=>{
    // Show selection if:
    // 1. Multiple methods available
    // 2. AND either no preferredChallenge OR selectedAuthMethod is explicitly cleared (null)
    const hasMultipleMethods = availableAuthMethods && availableAuthMethods.length > 1;
    const shouldShowSelection = !preferredChallenge || selectedAuthMethod === null;
    return hasMultipleMethods && shouldShowSelection;
};
const $c736c047e930e5f4$var$shouldPromptPasskeyRegistration = ({ passwordless: passwordless, hasExistingPasskeys: hasExistingPasskeys })=>{
    const { passkeyRegistrationPrompts: passkeyRegistrationPrompts } = passwordless || {};
    if (!passkeyRegistrationPrompts) return false;
    // Don't prompt if user already has passkeys
    if (hasExistingPasskeys) return false;
    if (typeof passkeyRegistrationPrompts === 'boolean') return passkeyRegistrationPrompts;
    return passkeyRegistrationPrompts.afterSignin === 'ALWAYS';
};
const $c736c047e930e5f4$var$shouldPromptPasskeyRegistrationAfterSignup = ({ passwordless: passwordless, hasExistingPasskeys: hasExistingPasskeys })=>{
    const { passkeyRegistrationPrompts: passkeyRegistrationPrompts } = passwordless || {};
    if (!passkeyRegistrationPrompts) return false;
    // Don't prompt if user already has passkeys
    if (hasExistingPasskeys) return false;
    if (typeof passkeyRegistrationPrompts === 'boolean') return passkeyRegistrationPrompts;
    return passkeyRegistrationPrompts.afterSignup === 'ALWAYS';
};
const $c736c047e930e5f4$var$hasPasskeyRegistrationPrompts = ({ passwordless: passwordless })=>passwordless?.passkeyRegistrationPrompts != null;
const $c736c047e930e5f4$var$shouldReturnToSelectMethod = ({ selectedAuthMethod: selectedAuthMethod, step: step })=>selectedAuthMethod != null && step === 'SELECT_AUTH_METHOD';
const $c736c047e930e5f4$export$2e2bcd8739ae039 = {
    hasCompletedAttributeConfirmation: $c736c047e930e5f4$var$hasCompletedAttributeConfirmation,
    hasCompletedResetPassword: $c736c047e930e5f4$var$hasCompletedResetPassword,
    hasCompletedSignIn: $c736c047e930e5f4$var$hasCompletedSignIn,
    hasCompletedSignUp: $c736c047e930e5f4$var$hasCompletedSignUp,
    hasPasskeyRegistrationPrompts: $c736c047e930e5f4$var$hasPasskeyRegistrationPrompts,
    isConfirmSignUpStep: $c736c047e930e5f4$var$isConfirmSignUpStep,
    isConfirmUserAttributeStep: $c736c047e930e5f4$var$isConfirmUserAttributeStep,
    isResetPasswordStep: $c736c047e930e5f4$var$isResetPasswordStep,
    isShouldConfirmUserAttributeStep: $c736c047e930e5f4$var$isShouldConfirmUserAttributeStep,
    isUserAlreadyConfirmed: $c736c047e930e5f4$var$isUserAlreadyConfirmed,
    shouldAutoSignIn: $c736c047e930e5f4$var$shouldAutoSignIn,
    shouldManualSignIn: $c736c047e930e5f4$var$shouldManualSignIn,
    shouldConfirmResetPassword: $c736c047e930e5f4$var$shouldConfirmResetPassword,
    shouldConfirmSignIn: $c736c047e930e5f4$var$shouldConfirmSignIn,
    shouldConfirmSignInWithNewPassword: $c736c047e930e5f4$var$shouldConfirmSignInWithNewPassword,
    shouldConfirmSignUp: $c736c047e930e5f4$var$shouldConfirmSignUp,
    shouldConfirmSignUpFromSignIn: $c736c047e930e5f4$var$shouldConfirmSignUpFromSignIn,
    shouldResetPassword: $c736c047e930e5f4$var$shouldResetPassword,
    shouldResetPasswordFromSignIn: $c736c047e930e5f4$var$shouldResetPasswordFromSignIn,
    shouldReturnToSelectMethod: $c736c047e930e5f4$var$shouldReturnToSelectMethod,
    shouldSelectAuthMethod: $c736c047e930e5f4$var$shouldSelectAuthMethod,
    shouldSetupTotp: $c736c047e930e5f4$var$shouldSetupTotp,
    shouldSetupEmail: $c736c047e930e5f4$var$shouldSetupEmail,
    shouldSelectMfaType: $c736c047e930e5f4$var$shouldSelectMfaType,
    shouldVerifyAttribute: $c736c047e930e5f4$var$shouldVerifyAttribute,
    shouldPromptPasskeyRegistration: $c736c047e930e5f4$var$shouldPromptPasskeyRegistration,
    shouldPromptPasskeyRegistrationAfterSignup: $c736c047e930e5f4$var$shouldPromptPasskeyRegistrationAfterSignup
};



var $813f399205d54a2a$exports = {};
var $f9de7087bf61e3ed$exports = {};

var $45b1dce45ce55dfc$exports = {};


/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $45b1dce45ce55dfc$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$be0db1f702864def$exports(object[key], value) || value === undefined && !(key in object)) $a2acdb4d55eade7d$exports(object, key, value);
}
$45b1dce45ce55dfc$exports = $45b1dce45ce55dfc$var$assignMergeValue;


var $9cd3dc2af3229c5d$exports = {};
var $b5152dce732798bd$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b5152dce732798bd$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$b5152dce732798bd$exports = $b5152dce732798bd$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9cd3dc2af3229c5d$var$baseFor = $b5152dce732798bd$exports();
$9cd3dc2af3229c5d$exports = $9cd3dc2af3229c5d$var$baseFor;


var $8dcd9e5b2ac4157a$exports = {};


var $lLzME = parcelRequire("lLzME");
var $4c58f3a352a2b20b$exports = {};
var $2221a76d8ea86e73$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $2221a76d8ea86e73$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $caedb05c0337e8b9$exports(result).set(new $caedb05c0337e8b9$exports(arrayBuffer));
    return result;
}
$2221a76d8ea86e73$exports = $2221a76d8ea86e73$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $4c58f3a352a2b20b$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $2221a76d8ea86e73$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$4c58f3a352a2b20b$exports = $4c58f3a352a2b20b$var$cloneTypedArray;


var $44d62cf21c284f7f$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $44d62cf21c284f7f$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$44d62cf21c284f7f$exports = $44d62cf21c284f7f$var$copyArray;


var $5e96516c739899b2$exports = {};
var $7a66b18b56976f39$exports = {};

/** Built-in value references. */ var $7a66b18b56976f39$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $7a66b18b56976f39$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$4545c0441e7f9648$exports(proto)) return {};
        if ($7a66b18b56976f39$var$objectCreate) return $7a66b18b56976f39$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$7a66b18b56976f39$exports = $7a66b18b56976f39$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $5e96516c739899b2$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$7d68cb0467e7a6ce$exports(object) ? $7a66b18b56976f39$exports($dfa68a96ace7fe9b$exports(object)) : {};
}
$5e96516c739899b2$exports = $5e96516c739899b2$var$initCloneObject;




var $58508f14b5ed7bd5$exports = {};


/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $58508f14b5ed7bd5$var$isArrayLikeObject(value) {
    return $9c720bfb7629a9dc$exports(value) && $fc6e7597768712de$exports(value);
}
$58508f14b5ed7bd5$exports = $58508f14b5ed7bd5$var$isArrayLikeObject;



var $ly5Rw = parcelRequire("ly5Rw");


var $20428397d5ecf404$exports = {};



/** `Object#toString` result references. */ var $20428397d5ecf404$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $20428397d5ecf404$var$funcProto = Function.prototype, $20428397d5ecf404$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $20428397d5ecf404$var$funcToString = $20428397d5ecf404$var$funcProto.toString;
/** Used to check objects for own properties. */ var $20428397d5ecf404$var$hasOwnProperty = $20428397d5ecf404$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $20428397d5ecf404$var$objectCtorString = $20428397d5ecf404$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $20428397d5ecf404$var$isPlainObject(value) {
    if (!$9c720bfb7629a9dc$exports(value) || $16c0370ed93333b0$exports(value) != $20428397d5ecf404$var$objectTag) return false;
    var proto = $dfa68a96ace7fe9b$exports(value);
    if (proto === null) return true;
    var Ctor = $20428397d5ecf404$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $20428397d5ecf404$var$funcToString.call(Ctor) == $20428397d5ecf404$var$objectCtorString;
}
$20428397d5ecf404$exports = $20428397d5ecf404$var$isPlainObject;



var $ff5ed96981e16c50$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $ff5ed96981e16c50$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
$ff5ed96981e16c50$exports = $ff5ed96981e16c50$var$safeGet;


var $f61c965639c6267b$exports = {};
var $2ed62341fc7c4c21$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2ed62341fc7c4c21$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $a2acdb4d55eade7d$exports(object, key, newValue);
        else $56b9215c6b21dd6b$exports(object, key, newValue);
    }
    return object;
}
$2ed62341fc7c4c21$exports = $2ed62341fc7c4c21$var$copyObject;



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $f61c965639c6267b$var$toPlainObject(value) {
    return $2ed62341fc7c4c21$exports(value, $cbb55d54fab94e40$exports(value));
}
$f61c965639c6267b$exports = $f61c965639c6267b$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $8dcd9e5b2ac4157a$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $ff5ed96981e16c50$exports(object, key), srcValue = $ff5ed96981e16c50$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $45b1dce45ce55dfc$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $14d42d0e7e8c143a$exports(srcValue), isBuff = !isArr && $ly5Rw(srcValue), isTyped = !isArr && !isBuff && $e4f028acbf1dc4a9$exports(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($14d42d0e7e8c143a$exports(objValue)) newValue = objValue;
            else if ($58508f14b5ed7bd5$exports(objValue)) newValue = $44d62cf21c284f7f$exports(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $lLzME(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $4c58f3a352a2b20b$exports(srcValue, true);
            } else newValue = [];
        } else if ($20428397d5ecf404$exports(srcValue) || $5317d38e3a6432d8$exports(srcValue)) {
            newValue = objValue;
            if ($5317d38e3a6432d8$exports(objValue)) newValue = $f61c965639c6267b$exports(objValue);
            else if (!$4545c0441e7f9648$exports(objValue) || $aa6921325bcd0d84$exports(objValue)) newValue = $5e96516c739899b2$exports(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $45b1dce45ce55dfc$exports(object, key, newValue);
}
$8dcd9e5b2ac4157a$exports = $8dcd9e5b2ac4157a$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $f9de7087bf61e3ed$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $9cd3dc2af3229c5d$exports(source, function(srcValue, key) {
        stack || (stack = new $4e5fedf6c4491d36$exports);
        if ($4545c0441e7f9648$exports(srcValue)) $8dcd9e5b2ac4157a$exports(object, source, key, srcIndex, $f9de7087bf61e3ed$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($ff5ed96981e16c50$exports(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $45b1dce45ce55dfc$exports(object, key, newValue);
        }
    }, $cbb55d54fab94e40$exports);
}
$f9de7087bf61e3ed$exports = $f9de7087bf61e3ed$var$baseMerge;


var $ddb320e9bf192fe0$exports = {};
var $bc2ac79585514411$exports = {};

var $ee4229dc6e39ff9d$exports = {};
var $4533d490b2fc0563$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $4533d490b2fc0563$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$4533d490b2fc0563$exports = $4533d490b2fc0563$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $ee4229dc6e39ff9d$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $ee4229dc6e39ff9d$var$overRest(func, start, transform) {
    start = $ee4229dc6e39ff9d$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $ee4229dc6e39ff9d$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $4533d490b2fc0563$exports(func, this, otherArgs);
    };
}
$ee4229dc6e39ff9d$exports = $ee4229dc6e39ff9d$var$overRest;


var $fe03c6adbb658046$exports = {};
var $c5d977ec4c407452$exports = {};
var $a4f7997840f28217$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $a4f7997840f28217$var$constant(value) {
    return function() {
        return value;
    };
}
$a4f7997840f28217$exports = $a4f7997840f28217$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $c5d977ec4c407452$var$baseSetToString = !$6524000617d31912$exports ? $5de784dc2546f41c$exports : function(func, string) {
    return $6524000617d31912$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $a4f7997840f28217$exports(string),
        'writable': true
    });
};
$c5d977ec4c407452$exports = $c5d977ec4c407452$var$baseSetToString;


var $94d498d217ddd215$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $94d498d217ddd215$var$HOT_COUNT = 800, $94d498d217ddd215$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $94d498d217ddd215$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $94d498d217ddd215$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $94d498d217ddd215$var$nativeNow(), remaining = $94d498d217ddd215$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $94d498d217ddd215$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$94d498d217ddd215$exports = $94d498d217ddd215$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $fe03c6adbb658046$var$setToString = $94d498d217ddd215$exports($c5d977ec4c407452$exports);
$fe03c6adbb658046$exports = $fe03c6adbb658046$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $bc2ac79585514411$var$baseRest(func, start) {
    return $fe03c6adbb658046$exports($ee4229dc6e39ff9d$exports(func, start, $5de784dc2546f41c$exports), func + '');
}
$bc2ac79585514411$exports = $bc2ac79585514411$var$baseRest;


var $702bb4f388ea3269$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $702bb4f388ea3269$var$isIterateeCall(value, index, object) {
    if (!$4545c0441e7f9648$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $fc6e7597768712de$exports(object) && $ec32e1589b18edff$exports(index, object.length) : type == 'string' && index in object) return $be0db1f702864def$exports(object[index], value);
    return false;
}
$702bb4f388ea3269$exports = $702bb4f388ea3269$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $ddb320e9bf192fe0$var$createAssigner(assigner) {
    return $bc2ac79585514411$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $702bb4f388ea3269$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$ddb320e9bf192fe0$exports = $ddb320e9bf192fe0$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $813f399205d54a2a$var$merge = $ddb320e9bf192fe0$exports(function(object, source, srcIndex) {
    $f9de7087bf61e3ed$exports(object, source, srcIndex);
});
$813f399205d54a2a$exports = $813f399205d54a2a$var$merge;





// Runs all validators given. Resolves if there are no error. Rejects otherwise.
const $823a1d9578ae4f09$export$59e2b39f02edfada = async (formData, touchData, passwordSettings, validators)=>{
    const errors = await Promise.all(validators.map((validator)=>validator(formData, touchData, passwordSettings)));
    const mergedError = (0, (/*@__PURE__*/$parcel$interopDefault($813f399205d54a2a$exports)))({}, ...errors);
    if ((0, $fd30e9352c42562e$export$dd1bc94b04021eeb)(mergedError)) // no errors were found
    return Promise.resolve();
    else return Promise.reject(mergedError);
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $a5f802e0bb2944ff$export$12d5c695b2213c4a;
(function(AuthValidationErrorCode) {
    AuthValidationErrorCode["EmptySignInUsername"] = "EmptySignInUsername";
    AuthValidationErrorCode["EmptySignInPassword"] = "EmptySignInPassword";
    AuthValidationErrorCode["CustomAuthSignInPassword"] = "CustomAuthSignInPassword";
    AuthValidationErrorCode["EmptySignUpUsername"] = "EmptySignUpUsername";
    AuthValidationErrorCode["EmptySignUpPassword"] = "EmptySignUpPassword";
    AuthValidationErrorCode["EmptyConfirmSignUpUsername"] = "EmptyConfirmSignUpUsername";
    AuthValidationErrorCode["EmptyConfirmSignUpCode"] = "EmptyConfirmSignUpCode";
    AuthValidationErrorCode["EmptyResendSignUpCodeUsername"] = "EmptyresendSignUpCodeUsername";
    AuthValidationErrorCode["EmptyChallengeResponse"] = "EmptyChallengeResponse";
    AuthValidationErrorCode["EmptyConfirmResetPasswordUsername"] = "EmptyConfirmResetPasswordUsername";
    AuthValidationErrorCode["EmptyConfirmResetPasswordNewPassword"] = "EmptyConfirmResetPasswordNewPassword";
    AuthValidationErrorCode["EmptyConfirmResetPasswordConfirmationCode"] = "EmptyConfirmResetPasswordConfirmationCode";
    AuthValidationErrorCode["EmptyResetPasswordUsername"] = "EmptyResetPasswordUsername";
    AuthValidationErrorCode["EmptyVerifyTOTPSetupCode"] = "EmptyVerifyTOTPSetupCode";
    AuthValidationErrorCode["EmptyConfirmUserAttributeCode"] = "EmptyConfirmUserAttributeCode";
    AuthValidationErrorCode["IncorrectMFAMethod"] = "IncorrectMFAMethod";
    AuthValidationErrorCode["EmptyUpdatePassword"] = "EmptyUpdatePassword";
    AuthValidationErrorCode["InvalidPreferredChallenge"] = "InvalidPreferredChallenge";
})($a5f802e0bb2944ff$export$12d5c695b2213c4a || ($a5f802e0bb2944ff$export$12d5c695b2213c4a = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8d93f22263ae8b19$export$195137955146d376 = {
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyChallengeResponse]: {
        message: 'challengeResponse is required to confirmSignIn'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyConfirmResetPasswordUsername]: {
        message: 'username is required to confirmResetPassword'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyConfirmSignUpCode]: {
        message: 'code is required to confirmSignUp'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername]: {
        message: 'username is required to confirmSignUp'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyConfirmResetPasswordConfirmationCode]: {
        message: 'confirmationCode is required to confirmResetPassword'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyConfirmResetPasswordNewPassword]: {
        message: 'newPassword is required to confirmResetPassword'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyResendSignUpCodeUsername]: {
        message: 'username is required to confirmSignUp'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyResetPasswordUsername]: {
        message: 'username is required to resetPassword'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignInPassword]: {
        message: 'password is required to signIn'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignInUsername]: {
        message: 'username is required to signIn'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignUpPassword]: {
        message: 'password is required to signUp'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignUpUsername]: {
        message: 'username is required to signUp'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).CustomAuthSignInPassword]: {
        message: 'A password is not needed when signing in with CUSTOM_WITHOUT_SRP',
        recoverySuggestion: 'Do not include a password in your signIn call.'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).IncorrectMFAMethod]: {
        message: 'Incorrect MFA method was chosen. It should be either SMS, TOTP, or EMAIL',
        recoverySuggestion: 'Try to pass SMS, TOTP, or EMAIL as the challengeResponse'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyVerifyTOTPSetupCode]: {
        message: 'code is required to verifyTotpSetup'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyUpdatePassword]: {
        message: 'oldPassword and newPassword are required to changePassword'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyConfirmUserAttributeCode]: {
        message: 'confirmation code is required to confirmUserAttribute'
    },
    [(0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).InvalidPreferredChallenge]: {
        message: 'The preferred challenge is not enabled in your backend configuration',
        recoverySuggestion: 'Ensure the authentication method is enabled in your Amplify backend configuration'
    }
};
// TODO: delete this code when the Auth class is removed.
var $8d93f22263ae8b19$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
    AuthErrorStrings["OAUTH_ERROR"] = "Couldn't finish OAuth flow, check your User Pool HostedUI settings";
})($8d93f22263ae8b19$export$c3070468b9d65120 || ($8d93f22263ae8b19$export$c3070468b9d65120 = {}));
var $8d93f22263ae8b19$export$473ab0b56598aacd;
(function(AuthErrorCodes) {
    AuthErrorCodes["SignInException"] = "SignInException";
    AuthErrorCodes["OAuthSignInError"] = "OAuthSignInException";
})($8d93f22263ae8b19$export$473ab0b56598aacd || ($8d93f22263ae8b19$export$473ab0b56598aacd = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $b8b9ab4ec1557efa$export$45936001d12f9b53(assertion, name) {
    const { message: message, recoverySuggestion: recoverySuggestion } = (0, $8d93f22263ae8b19$export$195137955146d376)[name];
    if (!assertion) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: name,
        message: message,
        recoverySuggestion: recoverySuggestion
    });
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $75eb6b3cd47d0a94$export$d6cd780379f37dae = (action, customUserAgentDetails)=>(0, $f1e6ffab4508d917$export$ede38edb26c0bfdf)({
        category: (0, $c2cf6542a631fa20$export$3a8840c5b2ecf003).Auth,
        action: action,
        ...customUserAgentDetails
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $69dcd6b2db6e872f$export$b6e6cdd1f90faa62({ username: username, userPoolId: userPoolId, userPoolClientId: userPoolClientId }) {
    if (typeof window === 'undefined') return undefined;
    const amazonCognitoAdvancedSecurityData = window.AmazonCognitoAdvancedSecurityData;
    if (typeof amazonCognitoAdvancedSecurityData === 'undefined') return undefined;
    const advancedSecurityData = amazonCognitoAdvancedSecurityData.getData(username, userPoolId, userPoolClientId);
    if (advancedSecurityData) {
        const userContextData = {
            EncodedData: advancedSecurityData
        };
        return userContextData;
    }
    return {};
}















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9745189c12661330$export$966c1bde6d375783 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('ConfirmForgotPassword'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms the new password and verification code to reset the password.
 *
 * @param input -  The ConfirmResetPasswordInput object.
 * @throws -{@link ConfirmForgotPasswordException }
 * Thrown due to an invalid confirmation code or password.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code, password or username.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $beebe0ff828f8cfe$export$890261705c8ce36b(input) {
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint } = authConfig;
    const { username: username, newPassword: newPassword } = input;
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!username, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyConfirmResetPasswordUsername);
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!newPassword, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyConfirmResetPasswordNewPassword);
    const code = input.confirmationCode;
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!code, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyConfirmResetPasswordConfirmationCode);
    const metadata = input.options?.clientMetadata;
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const confirmForgotPassword = (0, $9745189c12661330$export$966c1bde6d375783)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    await confirmForgotPassword({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(authConfig.userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmResetPassword)
    }, {
        Username: username,
        ConfirmationCode: code,
        Password: newPassword,
        ClientMetadata: metadata,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Minutes until stored session invalidates is defaulted to 3 minutes
// to maintain parity with Amazon Cognito user pools API behavior
const $fd57acfd3d6695db$var$MS_TO_EXPIRY = 180000;
const $fd57acfd3d6695db$var$TGT_STATE = 'CognitoSignInState';
const $fd57acfd3d6695db$var$SIGN_IN_STATE_KEYS = {
    username: `${$fd57acfd3d6695db$var$TGT_STATE}.username`,
    challengeName: `${$fd57acfd3d6695db$var$TGT_STATE}.challengeName`,
    signInSession: `${$fd57acfd3d6695db$var$TGT_STATE}.signInSession`,
    expiry: `${$fd57acfd3d6695db$var$TGT_STATE}.expiry`
};
const $fd57acfd3d6695db$var$signInReducer = (state, action)=>{
    switch(action.type){
        case 'SET_SIGN_IN_SESSION':
            $fd57acfd3d6695db$export$f0d4bc0f1640c562({
                signInSession: action.value
            });
            return {
                ...state,
                signInSession: action.value
            };
        case 'SET_SIGN_IN_STATE':
            $fd57acfd3d6695db$export$f0d4bc0f1640c562(action.value);
            return {
                ...action.value
            };
        case 'SET_CHALLENGE_NAME':
            $fd57acfd3d6695db$export$f0d4bc0f1640c562({
                challengeName: action.value
            });
            return {
                ...state,
                challengeName: action.value
            };
        case 'SET_USERNAME':
            $fd57acfd3d6695db$export$f0d4bc0f1640c562({
                username: action.value
            });
            return {
                ...state,
                username: action.value
            };
        case 'SET_INITIAL_STATE':
            return $fd57acfd3d6695db$var$getInitialState();
        case 'RESET_STATE':
            $fd57acfd3d6695db$var$clearPersistedSignInState();
            return $fd57acfd3d6695db$var$getDefaultState();
        // this state is never reachable
        default:
            return state;
    }
};
const $fd57acfd3d6695db$var$isExpired = (expiryDate)=>{
    const expiryTimestamp = Number(expiryDate);
    const currentTimestamp = Date.now();
    return expiryTimestamp <= currentTimestamp;
};
const $fd57acfd3d6695db$export$ddfd5a0262ce9df3 = ()=>{
    $fd57acfd3d6695db$export$390d5da4c63a4a41.dispatch({
        type: 'RESET_STATE'
    });
};
const $fd57acfd3d6695db$var$clearPersistedSignInState = ()=>{
    for (const stateKey of Object.values($fd57acfd3d6695db$var$SIGN_IN_STATE_KEYS))(0, $48e450c8813210c3$export$9015f19b74348a18).removeItem(stateKey);
};
const $fd57acfd3d6695db$var$getDefaultState = ()=>({
        username: undefined,
        challengeName: undefined,
        signInSession: undefined
    });
// Hydrate signInStore from syncSessionStorage if the session has not expired
const $fd57acfd3d6695db$var$getInitialState = ()=>{
    const expiry = (0, $48e450c8813210c3$export$9015f19b74348a18).getItem($fd57acfd3d6695db$var$SIGN_IN_STATE_KEYS.expiry);
    if (!expiry || $fd57acfd3d6695db$var$isExpired(expiry)) {
        $fd57acfd3d6695db$var$clearPersistedSignInState();
        return $fd57acfd3d6695db$var$getDefaultState();
    }
    const username = (0, $48e450c8813210c3$export$9015f19b74348a18).getItem($fd57acfd3d6695db$var$SIGN_IN_STATE_KEYS.username) ?? undefined;
    const challengeName = (0, $48e450c8813210c3$export$9015f19b74348a18).getItem($fd57acfd3d6695db$var$SIGN_IN_STATE_KEYS.challengeName) ?? undefined;
    const signInSession = (0, $48e450c8813210c3$export$9015f19b74348a18).getItem($fd57acfd3d6695db$var$SIGN_IN_STATE_KEYS.signInSession) ?? undefined;
    return {
        username: username,
        challengeName: challengeName,
        signInSession: signInSession
    };
};
const $fd57acfd3d6695db$var$createStore = (reducer)=>{
    let currentState = reducer($fd57acfd3d6695db$var$getDefaultState(), {
        type: 'SET_INITIAL_STATE'
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const $fd57acfd3d6695db$export$390d5da4c63a4a41 = $fd57acfd3d6695db$var$createStore($fd57acfd3d6695db$var$signInReducer);
function $fd57acfd3d6695db$export$bae72361b690e075(state) {
    $fd57acfd3d6695db$export$390d5da4c63a4a41.dispatch({
        type: 'SET_SIGN_IN_STATE',
        value: state
    });
}
// Save local state into Session Storage
const $fd57acfd3d6695db$export$f0d4bc0f1640c562 = ({ challengeName: challengeName, signInSession: signInSession, username: username })=>{
    username && (0, $48e450c8813210c3$export$9015f19b74348a18).setItem($fd57acfd3d6695db$var$SIGN_IN_STATE_KEYS.username, username);
    challengeName && (0, $48e450c8813210c3$export$9015f19b74348a18).setItem($fd57acfd3d6695db$var$SIGN_IN_STATE_KEYS.challengeName, challengeName);
    if (signInSession) {
        (0, $48e450c8813210c3$export$9015f19b74348a18).setItem($fd57acfd3d6695db$var$SIGN_IN_STATE_KEYS.signInSession, signInSession);
        // Updates expiry when session is passed
        (0, $48e450c8813210c3$export$9015f19b74348a18).setItem($fd57acfd3d6695db$var$SIGN_IN_STATE_KEYS.expiry, String(Date.now() + $fd57acfd3d6695db$var$MS_TO_EXPIRY));
    }
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $9dae3ebf1d7aa1cb$export$3cc5c71ef5f25e57;
(function(AssociateSoftwareTokenException) {
    AssociateSoftwareTokenException["ConcurrentModificationException"] = "ConcurrentModificationException";
    AssociateSoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    AssociateSoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    AssociateSoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    AssociateSoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    AssociateSoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    AssociateSoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
})($9dae3ebf1d7aa1cb$export$3cc5c71ef5f25e57 || ($9dae3ebf1d7aa1cb$export$3cc5c71ef5f25e57 = {}));
var $9dae3ebf1d7aa1cb$export$4327725e8bb80c51;
(function(ChangePasswordException) {
    ChangePasswordException["ForbiddenException"] = "ForbiddenException";
    ChangePasswordException["InternalErrorException"] = "InternalErrorException";
    ChangePasswordException["InvalidParameterException"] = "InvalidParameterException";
    ChangePasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ChangePasswordException["LimitExceededException"] = "LimitExceededException";
    ChangePasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ChangePasswordException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ChangePasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ChangePasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ChangePasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ChangePasswordException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$4327725e8bb80c51 || ($9dae3ebf1d7aa1cb$export$4327725e8bb80c51 = {}));
var $9dae3ebf1d7aa1cb$export$87a956d0b1b725a1;
(function(ConfirmDeviceException) {
    ConfirmDeviceException["ForbiddenException"] = "ForbiddenException";
    ConfirmDeviceException["InternalErrorException"] = "InternalErrorException";
    ConfirmDeviceException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmDeviceException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ConfirmDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ConfirmDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmDeviceException["UsernameExistsException"] = "UsernameExistsException";
    ConfirmDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$87a956d0b1b725a1 || ($9dae3ebf1d7aa1cb$export$87a956d0b1b725a1 = {}));
var $9dae3ebf1d7aa1cb$export$b86a388af82085af;
(function(ConfirmForgotPasswordException) {
    ConfirmForgotPasswordException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmForgotPasswordException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ConfirmForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ConfirmForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmForgotPasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ConfirmForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmForgotPasswordException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmForgotPasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$b86a388af82085af || ($9dae3ebf1d7aa1cb$export$b86a388af82085af = {}));
var $9dae3ebf1d7aa1cb$export$2ec29642a27fd055;
(function(ConfirmSignUpException) {
    ConfirmSignUpException["AliasExistsException"] = "AliasExistsException";
    ConfirmSignUpException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmSignUpException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmSignUpException["ForbiddenException"] = "ForbiddenException";
    ConfirmSignUpException["InternalErrorException"] = "InternalErrorException";
    ConfirmSignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmSignUpException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmSignUpException["LimitExceededException"] = "LimitExceededException";
    ConfirmSignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmSignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmSignUpException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmSignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmSignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmSignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmSignUpException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$2ec29642a27fd055 || ($9dae3ebf1d7aa1cb$export$2ec29642a27fd055 = {}));
var $9dae3ebf1d7aa1cb$export$c6d546f0ab5ecb26;
(function(DeleteUserAttributesException) {
    DeleteUserAttributesException["ForbiddenException"] = "ForbiddenException";
    DeleteUserAttributesException["InternalErrorException"] = "InternalErrorException";
    DeleteUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$c6d546f0ab5ecb26 || ($9dae3ebf1d7aa1cb$export$c6d546f0ab5ecb26 = {}));
var $9dae3ebf1d7aa1cb$export$315864c77a135492;
(function(DeleteUserException) {
    DeleteUserException["ForbiddenException"] = "ForbiddenException";
    DeleteUserException["InternalErrorException"] = "InternalErrorException";
    DeleteUserException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$315864c77a135492 || ($9dae3ebf1d7aa1cb$export$315864c77a135492 = {}));
var $9dae3ebf1d7aa1cb$export$622cff54bc9a0bb0;
(function(ForgetDeviceException) {
    ForgetDeviceException["ForbiddenException"] = "ForbiddenException";
    ForgetDeviceException["InternalErrorException"] = "InternalErrorException";
    ForgetDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ForgetDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ForgetDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgetDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ForgetDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgetDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgetDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ForgetDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$622cff54bc9a0bb0 || ($9dae3ebf1d7aa1cb$export$622cff54bc9a0bb0 = {}));
var $9dae3ebf1d7aa1cb$export$cedaef1e1242f8be;
(function(ForgotPasswordException) {
    ForgotPasswordException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ForgotPasswordException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ForgotPasswordException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ForgotPasswordException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$cedaef1e1242f8be || ($9dae3ebf1d7aa1cb$export$cedaef1e1242f8be = {}));
var $9dae3ebf1d7aa1cb$export$8d5b6b7a140e0c94;
(function(GetUserException) {
    GetUserException["ForbiddenException"] = "ForbiddenException";
    GetUserException["InternalErrorException"] = "InternalErrorException";
    GetUserException["InvalidParameterException"] = "InvalidParameterException";
    GetUserException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$8d5b6b7a140e0c94 || ($9dae3ebf1d7aa1cb$export$8d5b6b7a140e0c94 = {}));
var $9dae3ebf1d7aa1cb$export$506f117795ed2bb2;
(function(GetIdException) {
    GetIdException["ExternalServiceException"] = "ExternalServiceException";
    GetIdException["InternalErrorException"] = "InternalErrorException";
    GetIdException["InvalidParameterException"] = "InvalidParameterException";
    GetIdException["LimitExceededException"] = "LimitExceededException";
    GetIdException["NotAuthorizedException"] = "NotAuthorizedException";
    GetIdException["ResourceConflictException"] = "ResourceConflictException";
    GetIdException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetIdException["TooManyRequestsException"] = "TooManyRequestsException";
})($9dae3ebf1d7aa1cb$export$506f117795ed2bb2 || ($9dae3ebf1d7aa1cb$export$506f117795ed2bb2 = {}));
var $9dae3ebf1d7aa1cb$export$9bff15c85d75f437;
(function(GetCredentialsForIdentityException) {
    GetCredentialsForIdentityException["ExternalServiceException"] = "ExternalServiceException";
    GetCredentialsForIdentityException["InternalErrorException"] = "InternalErrorException";
    GetCredentialsForIdentityException["InvalidIdentityPoolConfigurationException"] = "InvalidIdentityPoolConfigurationException";
    GetCredentialsForIdentityException["InvalidParameterException"] = "InvalidParameterException";
    GetCredentialsForIdentityException["NotAuthorizedException"] = "NotAuthorizedException";
    GetCredentialsForIdentityException["ResourceConflictException"] = "ResourceConflictException";
    GetCredentialsForIdentityException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetCredentialsForIdentityException["TooManyRequestsException"] = "TooManyRequestsException";
})($9dae3ebf1d7aa1cb$export$9bff15c85d75f437 || ($9dae3ebf1d7aa1cb$export$9bff15c85d75f437 = {}));
var $9dae3ebf1d7aa1cb$export$2a6bba23fbf84d1b;
(function(GetUserAttributeVerificationException) {
    GetUserAttributeVerificationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    GetUserAttributeVerificationException["ForbiddenException"] = "ForbiddenException";
    GetUserAttributeVerificationException["InternalErrorException"] = "InternalErrorException";
    GetUserAttributeVerificationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    GetUserAttributeVerificationException["InvalidParameterException"] = "InvalidParameterException";
    GetUserAttributeVerificationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    GetUserAttributeVerificationException["LimitExceededException"] = "LimitExceededException";
    GetUserAttributeVerificationException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserAttributeVerificationException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserAttributeVerificationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserAttributeVerificationException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserAttributeVerificationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    GetUserAttributeVerificationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    GetUserAttributeVerificationException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserAttributeVerificationException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$2a6bba23fbf84d1b || ($9dae3ebf1d7aa1cb$export$2a6bba23fbf84d1b = {}));
var $9dae3ebf1d7aa1cb$export$3f7e490ba4e0b71e;
(function(GlobalSignOutException) {
    GlobalSignOutException["ForbiddenException"] = "ForbiddenException";
    GlobalSignOutException["InternalErrorException"] = "InternalErrorException";
    GlobalSignOutException["InvalidParameterException"] = "InvalidParameterException";
    GlobalSignOutException["NotAuthorizedException"] = "NotAuthorizedException";
    GlobalSignOutException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GlobalSignOutException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GlobalSignOutException["TooManyRequestsException"] = "TooManyRequestsException";
    GlobalSignOutException["UserNotConfirmedException"] = "UserNotConfirmedException";
})($9dae3ebf1d7aa1cb$export$3f7e490ba4e0b71e || ($9dae3ebf1d7aa1cb$export$3f7e490ba4e0b71e = {}));
var $9dae3ebf1d7aa1cb$export$43ac0110dfdad33b;
(function(InitiateAuthException) {
    InitiateAuthException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    InitiateAuthException["ForbiddenException"] = "ForbiddenException";
    InitiateAuthException["InternalErrorException"] = "InternalErrorException";
    InitiateAuthException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    InitiateAuthException["InvalidParameterException"] = "InvalidParameterException";
    InitiateAuthException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    InitiateAuthException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    InitiateAuthException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    InitiateAuthException["NotAuthorizedException"] = "NotAuthorizedException";
    InitiateAuthException["ResourceNotFoundException"] = "ResourceNotFoundException";
    InitiateAuthException["TooManyRequestsException"] = "TooManyRequestsException";
    InitiateAuthException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    InitiateAuthException["UserLambdaValidationException"] = "UserLambdaValidationException";
    InitiateAuthException["UserNotConfirmedException"] = "UserNotConfirmedException";
    InitiateAuthException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$43ac0110dfdad33b || ($9dae3ebf1d7aa1cb$export$43ac0110dfdad33b = {}));
var $9dae3ebf1d7aa1cb$export$8807b62ddb0e4d9d;
(function(ResendConfirmationException) {
    ResendConfirmationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ResendConfirmationException["ForbiddenException"] = "ForbiddenException";
    ResendConfirmationException["InternalErrorException"] = "InternalErrorException";
    ResendConfirmationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ResendConfirmationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ResendConfirmationException["InvalidParameterException"] = "InvalidParameterException";
    ResendConfirmationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ResendConfirmationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ResendConfirmationException["LimitExceededException"] = "LimitExceededException";
    ResendConfirmationException["NotAuthorizedException"] = "NotAuthorizedException";
    ResendConfirmationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ResendConfirmationException["TooManyRequestsException"] = "TooManyRequestsException";
    ResendConfirmationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ResendConfirmationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ResendConfirmationException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$8807b62ddb0e4d9d || ($9dae3ebf1d7aa1cb$export$8807b62ddb0e4d9d = {}));
var $9dae3ebf1d7aa1cb$export$da9908386393628f;
(function(RespondToAuthChallengeException) {
    RespondToAuthChallengeException["AliasExistsException"] = "AliasExistsException";
    RespondToAuthChallengeException["CodeMismatchException"] = "CodeMismatchException";
    RespondToAuthChallengeException["ExpiredCodeException"] = "ExpiredCodeException";
    RespondToAuthChallengeException["ForbiddenException"] = "ForbiddenException";
    RespondToAuthChallengeException["InternalErrorException"] = "InternalErrorException";
    RespondToAuthChallengeException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    RespondToAuthChallengeException["InvalidParameterException"] = "InvalidParameterException";
    RespondToAuthChallengeException["InvalidPasswordException"] = "InvalidPasswordException";
    RespondToAuthChallengeException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    RespondToAuthChallengeException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    RespondToAuthChallengeException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    RespondToAuthChallengeException["MFAMethodNotFoundException"] = "MFAMethodNotFoundException";
    RespondToAuthChallengeException["NotAuthorizedException"] = "NotAuthorizedException";
    RespondToAuthChallengeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    RespondToAuthChallengeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    RespondToAuthChallengeException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    RespondToAuthChallengeException["TooManyRequestsException"] = "TooManyRequestsException";
    RespondToAuthChallengeException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    RespondToAuthChallengeException["UserLambdaValidationException"] = "UserLambdaValidationException";
    RespondToAuthChallengeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    RespondToAuthChallengeException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$da9908386393628f || ($9dae3ebf1d7aa1cb$export$da9908386393628f = {}));
var $9dae3ebf1d7aa1cb$export$23ea34859d89459d;
(function(SetUserMFAPreferenceException) {
    SetUserMFAPreferenceException["ForbiddenException"] = "ForbiddenException";
    SetUserMFAPreferenceException["InternalErrorException"] = "InternalErrorException";
    SetUserMFAPreferenceException["InvalidParameterException"] = "InvalidParameterException";
    SetUserMFAPreferenceException["NotAuthorizedException"] = "NotAuthorizedException";
    SetUserMFAPreferenceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    SetUserMFAPreferenceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SetUserMFAPreferenceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    SetUserMFAPreferenceException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$23ea34859d89459d || ($9dae3ebf1d7aa1cb$export$23ea34859d89459d = {}));
var $9dae3ebf1d7aa1cb$export$d0816902ed99fce6;
(function(SignUpException) {
    SignUpException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    SignUpException["InternalErrorException"] = "InternalErrorException";
    SignUpException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    SignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    SignUpException["InvalidParameterException"] = "InvalidParameterException";
    SignUpException["InvalidPasswordException"] = "InvalidPasswordException";
    SignUpException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    SignUpException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    SignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    SignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    SignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    SignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    SignUpException["UsernameExistsException"] = "UsernameExistsException";
})($9dae3ebf1d7aa1cb$export$d0816902ed99fce6 || ($9dae3ebf1d7aa1cb$export$d0816902ed99fce6 = {}));
var $9dae3ebf1d7aa1cb$export$44cb15f260897376;
(function(UpdateUserAttributesException) {
    UpdateUserAttributesException["AliasExistsException"] = "AliasExistsException";
    UpdateUserAttributesException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    UpdateUserAttributesException["CodeMismatchException"] = "CodeMismatchException";
    UpdateUserAttributesException["ExpiredCodeException"] = "ExpiredCodeException";
    UpdateUserAttributesException["ForbiddenException"] = "ForbiddenException";
    UpdateUserAttributesException["InternalErrorException"] = "InternalErrorException";
    UpdateUserAttributesException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    UpdateUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    UpdateUserAttributesException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    UpdateUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateUserAttributesException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    UpdateUserAttributesException["UserLambdaValidationException"] = "UserLambdaValidationException";
    UpdateUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$44cb15f260897376 || ($9dae3ebf1d7aa1cb$export$44cb15f260897376 = {}));
var $9dae3ebf1d7aa1cb$export$a974f64d24be573a;
(function(VerifySoftwareTokenException) {
    VerifySoftwareTokenException["CodeMismatchException"] = "CodeMismatchException";
    VerifySoftwareTokenException["EnableSoftwareTokenMFAException"] = "EnableSoftwareTokenMFAException";
    VerifySoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    VerifySoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    VerifySoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    VerifySoftwareTokenException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    VerifySoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifySoftwareTokenException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifySoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifySoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    VerifySoftwareTokenException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifySoftwareTokenException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifySoftwareTokenException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$a974f64d24be573a || ($9dae3ebf1d7aa1cb$export$a974f64d24be573a = {}));
var $9dae3ebf1d7aa1cb$export$527caabb62d14fe3;
(function(VerifyUserAttributeException) {
    VerifyUserAttributeException["AliasExistsException"] = "AliasExistsException";
    VerifyUserAttributeException["CodeMismatchException"] = "CodeMismatchException";
    VerifyUserAttributeException["ExpiredCodeException"] = "ExpiredCodeException";
    VerifyUserAttributeException["ForbiddenException"] = "ForbiddenException";
    VerifyUserAttributeException["InternalErrorException"] = "InternalErrorException";
    VerifyUserAttributeException["InvalidParameterException"] = "InvalidParameterException";
    VerifyUserAttributeException["LimitExceededException"] = "LimitExceededException";
    VerifyUserAttributeException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifyUserAttributeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifyUserAttributeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifyUserAttributeException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifyUserAttributeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifyUserAttributeException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$527caabb62d14fe3 || ($9dae3ebf1d7aa1cb$export$527caabb62d14fe3 = {}));
var $9dae3ebf1d7aa1cb$export$de57be1863bdb9d6;
(function(UpdateDeviceStatusException) {
    UpdateDeviceStatusException["ForbiddenException"] = "ForbiddenException";
    UpdateDeviceStatusException["InternalErrorException"] = "InternalErrorException";
    UpdateDeviceStatusException["InvalidParameterException"] = "InvalidParameterException";
    UpdateDeviceStatusException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    UpdateDeviceStatusException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateDeviceStatusException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateDeviceStatusException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateDeviceStatusException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateDeviceStatusException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateDeviceStatusException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$de57be1863bdb9d6 || ($9dae3ebf1d7aa1cb$export$de57be1863bdb9d6 = {}));
var $9dae3ebf1d7aa1cb$export$eb8cb06bdb07bf0c;
(function(ListDevicesException) {
    ListDevicesException["ForbiddenException"] = "ForbiddenException";
    ListDevicesException["InternalErrorException"] = "InternalErrorException";
    ListDevicesException["InvalidParameterException"] = "InvalidParameterException";
    ListDevicesException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ListDevicesException["NotAuthorizedException"] = "NotAuthorizedException";
    ListDevicesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ListDevicesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ListDevicesException["TooManyRequestsException"] = "TooManyRequestsException";
    ListDevicesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ListDevicesException["UserNotFoundException"] = "UserNotFoundException";
})($9dae3ebf1d7aa1cb$export$eb8cb06bdb07bf0c || ($9dae3ebf1d7aa1cb$export$eb8cb06bdb07bf0c = {}));
const $9dae3ebf1d7aa1cb$export$ecd3eb1722b48d26 = 'SetUpTOTPException';















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d16d4d8349af273b$export$91f349d78bea7765 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('InitiateAuth'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8f35e4984ef6e471$export$11329f5ae466ab5d = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('RespondToAuthChallenge'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c0fbf9d4293877db$export$cf5dd9429415aa98 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('VerifySoftwareToken'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $888d91bf57e232eb$export$6bff32634453de2a = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('AssociateSoftwareToken'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });



















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $91b271eeb38cc677$export$729df6fdd19b8b0d(AuthenticationResult) {
    if (AuthenticationResult.AccessToken) {
        const accessToken = (0, $5c85900a0ff57646$export$9a62e6c0a30e00bc)(AuthenticationResult.AccessToken);
        const accessTokenIssuedAtInMillis = (accessToken.payload.iat || 0) * 1000;
        const currentTime = new Date().getTime();
        const clockDrift = accessTokenIssuedAtInMillis > 0 ? accessTokenIssuedAtInMillis - currentTime : 0;
        let idToken;
        let refreshToken;
        let deviceMetadata;
        if (AuthenticationResult.RefreshToken) refreshToken = AuthenticationResult.RefreshToken;
        if (AuthenticationResult.IdToken) idToken = (0, $5c85900a0ff57646$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken);
        if (AuthenticationResult?.NewDeviceMetadata) deviceMetadata = AuthenticationResult.NewDeviceMetadata;
        const tokens = {
            accessToken: accessToken,
            idToken: idToken,
            refreshToken: refreshToken,
            clockDrift: clockDrift,
            deviceMetadata: deviceMetadata,
            username: AuthenticationResult.username
        };
        if (AuthenticationResult?.signInDetails) tokens.signInDetails = AuthenticationResult.signInDetails;
        await (0, $3c6129946b01fbcd$export$66561e66d62991d0).setTokens({
            tokens: tokens
        });
    } else // This would be a service error
    throw new (0, $c848663d1100c12f$export$37321a6dace1881c)({
        message: 'Invalid tokens',
        name: 'InvalidTokens',
        recoverySuggestion: 'Check Cognito UserPool settings'
    });
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e29e37b04a825a54$export$3f27bc10068ef877 = 'Unable to get user session following successful sign-in.';
const $e29e37b04a825a54$export$4d78d2ee899572ab = async ()=>{
    try {
        (0, $7c7b61d0858d9585$export$8c41bb232f1008b1).dispatch('auth', {
            event: 'signedIn',
            data: await (0, $52783992aa7f744e$export$e5432d4c8eb97ea7)()
        }, 'Auth', (0, $7c7b61d0858d9585$export$aadf71dd9875dd20));
    } catch (error) {
        if (error.name === (0, $6c49017af88bac4c$export$d29d1996d6b6f5e3)) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
            name: (0, $6c49017af88bac4c$export$606cffc85964c24b),
            message: $e29e37b04a825a54$export$3f27bc10068ef877,
            recoverySuggestion: 'This most likely is due to auth tokens not being persisted. If you are using cookie store, please ensure cookies can be correctly set from your server.'
        });
        throw error;
    }
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d90f26e79c87b4f7$export$f71adf3ff8fcbbf8 = 'Passkeys may not be supported on this device. Ensure your application is running in a secure context (HTTPS) and Web Authentication API is supported.';


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $6d90af1ed0fee71a$export$bf0fd5fd31fb5a90 extends (0, $c848663d1100c12f$export$37321a6dace1881c) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $6d90af1ed0fee71a$export$bf0fd5fd31fb5a90;
        Object.setPrototypeOf(this, $6d90af1ed0fee71a$export$bf0fd5fd31fb5a90.prototype);
    }
}
var $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e;
(function(PasskeyErrorCode) {
    // not supported
    PasskeyErrorCode["PasskeyNotSupported"] = "PasskeyNotSupported";
    // duplicate passkey
    PasskeyErrorCode["PasskeyAlreadyExists"] = "PasskeyAlreadyExists";
    // misconfigurations
    PasskeyErrorCode["InvalidPasskeyRegistrationOptions"] = "InvalidPasskeyRegistrationOptions";
    PasskeyErrorCode["InvalidPasskeyAuthenticationOptions"] = "InvalidPasskeyAuthenticationOptions";
    PasskeyErrorCode["RelyingPartyMismatch"] = "RelyingPartyMismatch";
    // failed credential creation / retrieval
    PasskeyErrorCode["PasskeyRegistrationFailed"] = "PasskeyRegistrationFailed";
    PasskeyErrorCode["PasskeyRetrievalFailed"] = "PasskeyRetrievalFailed";
    // cancel / aborts
    PasskeyErrorCode["PasskeyRegistrationCanceled"] = "PasskeyRegistrationCanceled";
    PasskeyErrorCode["PasskeyAuthenticationCanceled"] = "PasskeyAuthenticationCanceled";
    PasskeyErrorCode["PasskeyOperationAborted"] = "PasskeyOperationAborted";
})($6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e || ($6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e = {}));
const $6d90af1ed0fee71a$var$ABORT_OR_CANCEL_RECOVERY_SUGGESTION = 'User may have canceled the ceremony or another interruption has occurred. Check underlying error for details.';
const $6d90af1ed0fee71a$var$MISCONFIGURATION_RECOVERY_SUGGESTION = 'Ensure your user pool is configured to support the WEB_AUTHN as an authentication factor.';
const $6d90af1ed0fee71a$export$e6bc9bceb73ec912 = {
    [$6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e.PasskeyNotSupported]: {
        message: 'Passkeys may not be supported on this device.',
        recoverySuggestion: (0, $d90f26e79c87b4f7$export$f71adf3ff8fcbbf8)
    },
    [$6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e.InvalidPasskeyRegistrationOptions]: {
        message: 'Invalid passkey registration options.',
        recoverySuggestion: $6d90af1ed0fee71a$var$MISCONFIGURATION_RECOVERY_SUGGESTION
    },
    [$6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e.InvalidPasskeyAuthenticationOptions]: {
        message: 'Invalid passkey authentication options.',
        recoverySuggestion: $6d90af1ed0fee71a$var$MISCONFIGURATION_RECOVERY_SUGGESTION
    },
    [$6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e.PasskeyRegistrationFailed]: {
        message: 'Device failed to create passkey.',
        recoverySuggestion: (0, $d90f26e79c87b4f7$export$f71adf3ff8fcbbf8)
    },
    [$6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e.PasskeyRetrievalFailed]: {
        message: 'Device failed to retrieve passkey.',
        recoverySuggestion: 'Passkeys may not be available on this device. Try an alternative authentication factor like PASSWORD, EMAIL_OTP, or SMS_OTP.'
    },
    [$6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e.PasskeyAlreadyExists]: {
        message: 'Passkey already exists in authenticator.',
        recoverySuggestion: 'Proceed with existing passkey or try again after deleting the credential.'
    },
    [$6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e.PasskeyRegistrationCanceled]: {
        message: 'Passkey registration ceremony has been canceled.',
        recoverySuggestion: $6d90af1ed0fee71a$var$ABORT_OR_CANCEL_RECOVERY_SUGGESTION
    },
    [$6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e.PasskeyAuthenticationCanceled]: {
        message: 'Passkey authentication ceremony has been canceled.',
        recoverySuggestion: $6d90af1ed0fee71a$var$ABORT_OR_CANCEL_RECOVERY_SUGGESTION
    },
    [$6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e.PasskeyOperationAborted]: {
        message: 'Passkey operation has been aborted.',
        recoverySuggestion: $6d90af1ed0fee71a$var$ABORT_OR_CANCEL_RECOVERY_SUGGESTION
    },
    [$6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e.RelyingPartyMismatch]: {
        message: 'Relying party does not match current domain.',
        recoverySuggestion: 'Ensure relying party identifier matches current domain.'
    }
};
const $6d90af1ed0fee71a$export$3145abf24cf8a54e = (0, $97bdb48788a05322$export$5cb8fc27ccbe9d40)($6d90af1ed0fee71a$export$e6bc9bceb73ec912, $6d90af1ed0fee71a$export$bf0fd5fd31fb5a90);




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles Overlapping Passkey Errors Between Registration & Authentication
 * https://w3c.github.io/webauthn/#sctn-create-request-exceptions
 * https://w3c.github.io/webauthn/#sctn-get-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const $38408e1587f58920$export$4792b205fc9bc457 = (err)=>{
    if (err instanceof Error) {
        // Passkey Operation Aborted
        if (err.name === 'AbortError') {
            const { message: message, recoverySuggestion: recoverySuggestion } = (0, $6d90af1ed0fee71a$export$e6bc9bceb73ec912)[(0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).PasskeyOperationAborted];
            return new (0, $6d90af1ed0fee71a$export$bf0fd5fd31fb5a90)({
                name: (0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).PasskeyOperationAborted,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
        // Relying Party / Domain Mismatch
        if (err.name === 'SecurityError') {
            const { message: message, recoverySuggestion: recoverySuggestion } = (0, $6d90af1ed0fee71a$export$e6bc9bceb73ec912)[(0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).RelyingPartyMismatch];
            return new (0, $6d90af1ed0fee71a$export$bf0fd5fd31fb5a90)({
                name: (0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).RelyingPartyMismatch,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return new (0, $6d90af1ed0fee71a$export$bf0fd5fd31fb5a90)({
        name: (0, $0f90bdfda3f0916b$export$4e712df6b850c8d0).Unknown,
        message: 'An unknown error has occurred.',
        underlyingError: err
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handle Passkey Authentication Errors
 * https://w3c.github.io/webauthn/#sctn-get-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const $67796abc2f76a865$export$6abde9ceb8dfddc0 = (err)=>{
    if (err instanceof (0, $6d90af1ed0fee71a$export$bf0fd5fd31fb5a90)) return err;
    if (err instanceof Error) {
        if (err.name === 'NotAllowedError') {
            const { message: message, recoverySuggestion: recoverySuggestion } = (0, $6d90af1ed0fee71a$export$e6bc9bceb73ec912)[(0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).PasskeyAuthenticationCanceled];
            return new (0, $6d90af1ed0fee71a$export$bf0fd5fd31fb5a90)({
                name: (0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).PasskeyAuthenticationCanceled,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return (0, $38408e1587f58920$export$4792b205fc9bc457)(err);
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Determines if passkey is supported in current context
 * Will return false if executed in non-secure context
 * @returns boolean
 */ const $931296c4087014b2$export$3b0e0bb0e9c22c1a = ()=>{
    return (0, $f030787848639548$export$4e09c449d6c407f7)() && window.isSecureContext && 'credentials' in navigator && typeof window.PublicKeyCredential === 'function';
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $18f403bd13532a03$export$7c746b75f47c9c7d(input) {
    return Array.from(input, (byte)=>String.fromCodePoint(byte)).join('');
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $820769526bac512e$export$695b149896bd3e2a = {
    /**
     * Convert input to base64-encoded string
     * @param input - string to convert to base64
     * @param options - encoding options that can optionally produce a base64url string
     * @returns base64-encoded string
     */ convert (input, options = {
        urlSafe: false,
        skipPadding: false
    }) {
        const inputStr = typeof input === 'string' ? input : (0, $18f403bd13532a03$export$7c746b75f47c9c7d)(input);
        let encodedStr = (0, $2f3406124c4dec3f$export$94f295707b435c6d)()(inputStr);
        // urlSafe char replacement and skipPadding options conform to the base64url spec
        // https://datatracker.ietf.org/doc/html/rfc4648#section-5
        if (options.urlSafe) encodedStr = encodedStr.replace(/\+/g, '-').replace(/\//g, '_');
        if (options.skipPadding) encodedStr = encodedStr.replace(/=/g, '');
        return encodedStr;
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// https://datatracker.ietf.org/doc/html/rfc4648#page-7
/**
 * Converts an ArrayBuffer to a base64url encoded string
 * @param buffer - the ArrayBuffer instance of a Uint8Array
 * @returns string - a base64url encoded string
 */ const $f22480e0d6168038$export$442d4feb149fcd32 = (buffer)=>{
    return (0, $820769526bac512e$export$695b149896bd3e2a).convert(new Uint8Array(buffer), {
        urlSafe: true,
        skipPadding: true
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a base64url encoded string to an ArrayBuffer
 * @param base64url - a base64url encoded string
 * @returns ArrayBuffer
 */ const $8c2f33f0d52084d2$export$9cebd483a59f0168 = (base64url)=>{
    return Uint8Array.from((0, $05be7a5c43db640d$export$1e303d38dab7b376).convert(base64url, {
        urlSafe: true
    }), (x)=>x.charCodeAt(0)).buffer;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Deserializes Public Key Credential Creation Options JSON
 * @param input PasskeyCreateOptionsJson
 * @returns PublicKeyCredentialCreationOptions
 */ const $53d455558e1abd24$export$a8f43933ee13e976 = (input)=>{
    const userIdBuffer = (0, $8c2f33f0d52084d2$export$9cebd483a59f0168)(input.user.id);
    const challengeBuffer = (0, $8c2f33f0d52084d2$export$9cebd483a59f0168)(input.challenge);
    const excludeCredentialsWithBuffer = (input.excludeCredentials || []).map((excludeCred)=>({
            ...excludeCred,
            id: (0, $8c2f33f0d52084d2$export$9cebd483a59f0168)(excludeCred.id)
        }));
    return {
        ...input,
        excludeCredentials: excludeCredentialsWithBuffer,
        challenge: challengeBuffer,
        user: {
            ...input.user,
            id: userIdBuffer
        }
    };
};
/**
 * Serializes a Public Key Credential With Attestation to JSON
 * @param input PasskeyCreateResult
 * @returns PasskeyCreateResultJson
 */ const $53d455558e1abd24$export$f686d838e2fa9da3 = (input)=>{
    const response = {
        clientDataJSON: (0, $f22480e0d6168038$export$442d4feb149fcd32)(input.response.clientDataJSON),
        attestationObject: (0, $f22480e0d6168038$export$442d4feb149fcd32)(input.response.attestationObject),
        transports: input.response.getTransports(),
        publicKeyAlgorithm: input.response.getPublicKeyAlgorithm(),
        authenticatorData: (0, $f22480e0d6168038$export$442d4feb149fcd32)(input.response.getAuthenticatorData())
    };
    const publicKey = input.response.getPublicKey();
    if (publicKey) response.publicKey = (0, $f22480e0d6168038$export$442d4feb149fcd32)(publicKey);
    const resultJson = {
        type: input.type,
        id: input.id,
        rawId: (0, $f22480e0d6168038$export$442d4feb149fcd32)(input.rawId),
        clientExtensionResults: input.getClientExtensionResults(),
        response: response
    };
    if (input.authenticatorAttachment) resultJson.authenticatorAttachment = input.authenticatorAttachment;
    return resultJson;
};
/**
 * Deserializes Public Key Credential Get Options JSON
 * @param input PasskeyGetOptionsJson
 * @returns PublicKeyCredentialRequestOptions
 */ const $53d455558e1abd24$export$d3f47ce866c52e8e = (input)=>{
    const challengeBuffer = (0, $8c2f33f0d52084d2$export$9cebd483a59f0168)(input.challenge);
    const allowedCredentialsWithBuffer = (input.allowCredentials || []).map((allowedCred)=>({
            ...allowedCred,
            id: (0, $8c2f33f0d52084d2$export$9cebd483a59f0168)(allowedCred.id)
        }));
    return {
        ...input,
        challenge: challengeBuffer,
        allowCredentials: allowedCredentialsWithBuffer
    };
};
/**
 * Serializes a Public Key Credential With Attestation to JSON
 * @param input PasskeyGetResult
 * @returns PasskeyGetResultJson
 */ const $53d455558e1abd24$export$1f22b133ac0d2a5 = (input)=>{
    const response = {
        clientDataJSON: (0, $f22480e0d6168038$export$442d4feb149fcd32)(input.response.clientDataJSON),
        authenticatorData: (0, $f22480e0d6168038$export$442d4feb149fcd32)(input.response.authenticatorData),
        signature: (0, $f22480e0d6168038$export$442d4feb149fcd32)(input.response.signature)
    };
    if (input.response.userHandle) response.userHandle = (0, $f22480e0d6168038$export$442d4feb149fcd32)(input.response.userHandle);
    const resultJson = {
        id: input.id,
        rawId: (0, $f22480e0d6168038$export$442d4feb149fcd32)(input.rawId),
        type: input.type,
        clientExtensionResults: input.getClientExtensionResults(),
        response: response
    };
    if (input.authenticatorAttachment) resultJson.authenticatorAttachment = input.authenticatorAttachment;
    return resultJson;
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $409463b9ba1ec40e$export$c7806094d9c936a2(credential) {
    (0, $6d90af1ed0fee71a$export$3145abf24cf8a54e)(credential && credential instanceof PublicKeyCredential && credential.response instanceof AuthenticatorAttestationResponse, (0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).PasskeyRegistrationFailed);
}
function $409463b9ba1ec40e$export$4f19e511a89efed7(credential) {
    (0, $6d90af1ed0fee71a$export$3145abf24cf8a54e)(credential && credential instanceof PublicKeyCredential && credential.response instanceof AuthenticatorAssertionResponse, (0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).PasskeyRetrievalFailed);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $fba96e0dec8734ec$export$d7f92bd7f1e366c1 = async (input)=>{
    try {
        const isPasskeySupported = (0, $931296c4087014b2$export$3b0e0bb0e9c22c1a)();
        (0, $6d90af1ed0fee71a$export$3145abf24cf8a54e)(isPasskeySupported, (0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).PasskeyNotSupported);
        const passkeyGetOptions = (0, $53d455558e1abd24$export$d3f47ce866c52e8e)(input);
        const credential = await navigator.credentials.get({
            publicKey: passkeyGetOptions
        });
        (0, $409463b9ba1ec40e$export$4f19e511a89efed7)(credential);
        return (0, $53d455558e1abd24$export$1f22b133ac0d2a5)(credential);
    } catch (err) {
        throw (0, $67796abc2f76a865$export$6abde9ceb8dfddc0)(err);
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Retrieves the device name using the User-Agent Client Hints API if available,
 * falling back to the traditional userAgent string if not.
 *
 * @returns {Promise<string>} A promise that resolves with a string representing the device name.
 *
 * Example Output:
 * navigator.userAgentData:
 *   'macOS 14.2.1 arm macOS Not A(Brand/99.0.0.0;Google Chrome/121.0.6167.160;Chromium/121.0.6167.160'
 * navigator.userAgent:
 *   'Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:109.0) Gecko/20100101 Firefox/115.0'
 */ const $9351d6ed6be2ae5c$export$98f0aedb14d75123 = async ()=>{
    const { userAgentData: userAgentData } = navigator;
    if (!userAgentData) return navigator.userAgent;
    const { platform: platform = '', platformVersion: platformVersion = '', model: model = '', architecture: architecture = '', fullVersionList: fullVersionList = [] } = await userAgentData.getHighEntropyValues([
        'platform',
        'platformVersion',
        'architecture',
        'model',
        'fullVersionList'
    ]);
    const versionList = fullVersionList.map((v)=>`${v.brand}/${v.version}`).join(';');
    const deviceName = [
        platform,
        platformVersion,
        architecture,
        model,
        platform,
        versionList
    ].filter((value)=>value).join(' ');
    return deviceName || navigator.userAgent;
};
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e7bfbc78b3dd11ef$export$d88a63af6351a7c3 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('ConfirmDevice'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0b638bbfb6d0e3bb$export$f5d75491a17f02c = {
    convert (input) {
        return new TextEncoder().encode(input);
    }
};


/* eslint-disable */ // @ts-nocheck -> BigInteger is already a vended utility
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $1584d617982d5f8b$export$2e2bcd8739ae039(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $1584d617982d5f8b$var$nbi() {
    return new $1584d617982d5f8b$export$2e2bcd8739ae039(null, null);
}
// Bits per digit
let $1584d617982d5f8b$var$dbits;
// JavaScript engine analysis
const $1584d617982d5f8b$var$canary = 0xdeadbeefcafe;
const $1584d617982d5f8b$var$j_lm = ($1584d617982d5f8b$var$canary & 0xffffff) === 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $1584d617982d5f8b$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        const v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $1584d617982d5f8b$var$am2(i, x, w, j, c, n) {
    const xl = x & 0x7fff;
    const xh = x >> 15;
    while(--n >= 0){
        let l = this[i] & 0x7fff;
        const h = this[i++] >> 15;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $1584d617982d5f8b$var$am3(i, x, w, j, c, n) {
    const xl = x & 0x3fff;
    const xh = x >> 14;
    while(--n >= 0){
        let l = this[i] & 0x3fff;
        const h = this[i++] >> 14;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
const $1584d617982d5f8b$var$inBrowser = typeof navigator !== 'undefined';
if ($1584d617982d5f8b$var$inBrowser && $1584d617982d5f8b$var$j_lm && navigator.appName === 'Microsoft Internet Explorer') {
    $1584d617982d5f8b$export$2e2bcd8739ae039.prototype.am = $1584d617982d5f8b$var$am2;
    $1584d617982d5f8b$var$dbits = 30;
} else if ($1584d617982d5f8b$var$inBrowser && $1584d617982d5f8b$var$j_lm && navigator.appName !== 'Netscape') {
    $1584d617982d5f8b$export$2e2bcd8739ae039.prototype.am = $1584d617982d5f8b$var$am1;
    $1584d617982d5f8b$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $1584d617982d5f8b$export$2e2bcd8739ae039.prototype.am = $1584d617982d5f8b$var$am3;
    $1584d617982d5f8b$var$dbits = 28;
}
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.DB = $1584d617982d5f8b$var$dbits;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.DM = (1 << $1584d617982d5f8b$var$dbits) - 1;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.DV = 1 << $1584d617982d5f8b$var$dbits;
const $1584d617982d5f8b$var$BI_FP = 52;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.FV = Math.pow(2, $1584d617982d5f8b$var$BI_FP);
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.F1 = $1584d617982d5f8b$var$BI_FP - $1584d617982d5f8b$var$dbits;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.F2 = 2 * $1584d617982d5f8b$var$dbits - $1584d617982d5f8b$var$BI_FP;
// Digit conversions
const $1584d617982d5f8b$var$BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
const $1584d617982d5f8b$var$BI_RC = [];
let $1584d617982d5f8b$var$rr, $1584d617982d5f8b$var$vv;
$1584d617982d5f8b$var$rr = '0'.charCodeAt(0);
for($1584d617982d5f8b$var$vv = 0; $1584d617982d5f8b$var$vv <= 9; ++$1584d617982d5f8b$var$vv)$1584d617982d5f8b$var$BI_RC[$1584d617982d5f8b$var$rr++] = $1584d617982d5f8b$var$vv;
$1584d617982d5f8b$var$rr = 'a'.charCodeAt(0);
for($1584d617982d5f8b$var$vv = 10; $1584d617982d5f8b$var$vv < 36; ++$1584d617982d5f8b$var$vv)$1584d617982d5f8b$var$BI_RC[$1584d617982d5f8b$var$rr++] = $1584d617982d5f8b$var$vv;
$1584d617982d5f8b$var$rr = 'A'.charCodeAt(0);
for($1584d617982d5f8b$var$vv = 10; $1584d617982d5f8b$var$vv < 36; ++$1584d617982d5f8b$var$vv)$1584d617982d5f8b$var$BI_RC[$1584d617982d5f8b$var$rr++] = $1584d617982d5f8b$var$vv;
function $1584d617982d5f8b$var$int2char(n) {
    return $1584d617982d5f8b$var$BI_RM.charAt(n);
}
function $1584d617982d5f8b$var$intAt(s, i) {
    const c = $1584d617982d5f8b$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $1584d617982d5f8b$var$bnpCopyTo(r) {
    for(let i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $1584d617982d5f8b$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $1584d617982d5f8b$var$nbv(i) {
    const r = $1584d617982d5f8b$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $1584d617982d5f8b$var$bnpFromString(s, b) {
    let k;
    if (b === 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    this.t = 0;
    this.s = 0;
    let i = s.length;
    let mi = false;
    let sh = 0;
    while(--i >= 0){
        const x = $1584d617982d5f8b$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) === '-') mi = true;
            continue;
        }
        mi = false;
        if (sh === 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $1584d617982d5f8b$export$2e2bcd8739ae039.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $1584d617982d5f8b$var$bnpClamp() {
    const c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $1584d617982d5f8b$var$bnToString(b) {
    if (this.s < 0) return '-' + this.negate().toString(b);
    let k;
    if (b == 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    const km = (1 << k) - 1;
    let d;
    let m = false;
    let r = '';
    let i = this.t;
    let p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $1584d617982d5f8b$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $1584d617982d5f8b$var$int2char(d);
        }
    }
    return m ? r : '0';
}
// (public) -this
function $1584d617982d5f8b$var$bnNegate() {
    const r = $1584d617982d5f8b$var$nbi();
    $1584d617982d5f8b$export$2e2bcd8739ae039.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $1584d617982d5f8b$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $1584d617982d5f8b$var$bnCompareTo(a) {
    let r = this.s - a.s;
    if (r != 0) return r;
    let i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $1584d617982d5f8b$var$nbits(x) {
    let r = 1;
    let t;
    if ((t = x >>> 16) !== 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) !== 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) !== 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) !== 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) !== 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $1584d617982d5f8b$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $1584d617982d5f8b$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $1584d617982d5f8b$var$bnpDLShiftTo(n, r) {
    let i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $1584d617982d5f8b$var$bnpDRShiftTo(n, r) {
    for(let i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $1584d617982d5f8b$var$bnpLShiftTo(n, r) {
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << cbs) - 1;
    const ds = Math.floor(n / this.DB);
    let c = this.s << bs & this.DM;
    let i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $1584d617982d5f8b$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    const ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(let i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $1584d617982d5f8b$var$bnpSubTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $1584d617982d5f8b$var$bnpMultiplyTo(a, r) {
    const x = this.abs();
    const y = a.abs();
    let i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s !== a.s) $1584d617982d5f8b$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $1584d617982d5f8b$var$bnpSquareTo(r) {
    const x = this.abs();
    let i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        const c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $1584d617982d5f8b$var$bnpDivRemTo(m, q, r) {
    const pm = m.abs();
    if (pm.t <= 0) return;
    const pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r === null) r = $1584d617982d5f8b$var$nbi();
    const y = $1584d617982d5f8b$var$nbi();
    const ts = this.s;
    const ms = m.s;
    const nsh = this.DB - $1584d617982d5f8b$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    const ys = y.t;
    const y0 = y[ys - 1];
    if (y0 === 0) return;
    const yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    const d1 = this.FV / yt;
    const d2 = (1 << this.F1) / yt;
    const e = 1 << this.F2;
    let i = r.t;
    let j = i - ys;
    const t = q === null ? $1584d617982d5f8b$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $1584d617982d5f8b$export$2e2bcd8739ae039.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        let qd = r[--i] === y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q !== null) {
        r.drShiftTo(ys, q);
        if (ts !== ms) $1584d617982d5f8b$export$2e2bcd8739ae039.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $1584d617982d5f8b$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (public) this mod a
function $1584d617982d5f8b$var$bnMod(a) {
    const r = $1584d617982d5f8b$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($1584d617982d5f8b$export$2e2bcd8739ae039.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $1584d617982d5f8b$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    const x = this[0];
    if ((x & 1) === 0) return 0;
    let y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $1584d617982d5f8b$var$bnEquals(a) {
    return this.compareTo(a) === 0;
}
// (protected) r = this + a
function $1584d617982d5f8b$var$bnpAddTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $1584d617982d5f8b$var$bnAdd(a) {
    const r = $1584d617982d5f8b$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $1584d617982d5f8b$var$bnSubtract(a) {
    const r = $1584d617982d5f8b$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $1584d617982d5f8b$var$bnMultiply(a) {
    const r = $1584d617982d5f8b$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $1584d617982d5f8b$var$bnDivide(a) {
    const r = $1584d617982d5f8b$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $1584d617982d5f8b$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $1584d617982d5f8b$var$montConvert(x) {
    const r = $1584d617982d5f8b$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($1584d617982d5f8b$export$2e2bcd8739ae039.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $1584d617982d5f8b$var$montRevert(x) {
    const r = $1584d617982d5f8b$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $1584d617982d5f8b$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(let i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        let j = x[i] & 0x7fff;
        const u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $1584d617982d5f8b$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $1584d617982d5f8b$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$1584d617982d5f8b$var$Montgomery.prototype.convert = $1584d617982d5f8b$var$montConvert;
$1584d617982d5f8b$var$Montgomery.prototype.revert = $1584d617982d5f8b$var$montRevert;
$1584d617982d5f8b$var$Montgomery.prototype.reduce = $1584d617982d5f8b$var$montReduce;
$1584d617982d5f8b$var$Montgomery.prototype.mulTo = $1584d617982d5f8b$var$montMulTo;
$1584d617982d5f8b$var$Montgomery.prototype.sqrTo = $1584d617982d5f8b$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $1584d617982d5f8b$var$bnModPow(e, m, callback) {
    let i = e.bitLength();
    let k;
    let r = $1584d617982d5f8b$var$nbv(1);
    const z = new $1584d617982d5f8b$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    const g = [];
    let n = 3;
    const k1 = k - 1;
    const km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        const g2 = $1584d617982d5f8b$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $1584d617982d5f8b$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    let j = e.t - 1;
    let w;
    let is1 = true;
    let r2 = $1584d617982d5f8b$var$nbi();
    let t;
    i = $1584d617982d5f8b$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) === 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) === 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    const result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.copyTo = $1584d617982d5f8b$var$bnpCopyTo;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.fromInt = $1584d617982d5f8b$var$bnpFromInt;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.fromString = $1584d617982d5f8b$var$bnpFromString;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.clamp = $1584d617982d5f8b$var$bnpClamp;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.dlShiftTo = $1584d617982d5f8b$var$bnpDLShiftTo;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.drShiftTo = $1584d617982d5f8b$var$bnpDRShiftTo;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.lShiftTo = $1584d617982d5f8b$var$bnpLShiftTo;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.rShiftTo = $1584d617982d5f8b$var$bnpRShiftTo;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.subTo = $1584d617982d5f8b$var$bnpSubTo;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.multiplyTo = $1584d617982d5f8b$var$bnpMultiplyTo;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.squareTo = $1584d617982d5f8b$var$bnpSquareTo;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.divRemTo = $1584d617982d5f8b$var$bnpDivRemTo;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.invDigit = $1584d617982d5f8b$var$bnpInvDigit;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.addTo = $1584d617982d5f8b$var$bnpAddTo;
// public
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.toString = $1584d617982d5f8b$var$bnToString;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.negate = $1584d617982d5f8b$var$bnNegate;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.abs = $1584d617982d5f8b$var$bnAbs;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.compareTo = $1584d617982d5f8b$var$bnCompareTo;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.bitLength = $1584d617982d5f8b$var$bnBitLength;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.mod = $1584d617982d5f8b$var$bnMod;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.equals = $1584d617982d5f8b$var$bnEquals;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.add = $1584d617982d5f8b$var$bnAdd;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.subtract = $1584d617982d5f8b$var$bnSubtract;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.multiply = $1584d617982d5f8b$var$bnMultiply;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.divide = $1584d617982d5f8b$var$bnDivide;
$1584d617982d5f8b$export$2e2bcd8739ae039.prototype.modPow = $1584d617982d5f8b$var$bnModPow;
// "constants"
$1584d617982d5f8b$export$2e2bcd8739ae039.ZERO = $1584d617982d5f8b$var$nbv(0);
$1584d617982d5f8b$export$2e2bcd8739ae039.ONE = $1584d617982d5f8b$var$nbv(1);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $ea8fc9ae8e78a7bf$export$f7340100dd3acd38 = async ({ a: a, g: g, k: k, x: x, B: B, N: N, U: U })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(x, N, (outerErr, outerResult)=>{
            if (outerErr) {
                reject(outerErr);
                return;
            }
            B.subtract(k.multiply(outerResult)).modPow(a.add(U.multiply(x)), N, (innerErr, innerResult)=>{
                if (innerErr) {
                    reject(innerErr);
                    return;
                }
                resolve(innerResult.mod(N));
            });
        });
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $bf87c628313d34c2$export$baab4dd8c7240846 = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
const $bf87c628313d34c2$export$a0f75f7d2f3bd702 = {};
const $bf87c628313d34c2$export$fcb552daf117d7e3 = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $bf87c628313d34c2$export$a0f75f7d2f3bd702[i] = encodedByte;
    $bf87c628313d34c2$export$fcb552daf117d7e3[encodedByte] = i;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ const $8bafa6bc7cf545f4$export$b772e43c3daf2e7a = (encoded)=>{
    if (encoded.length % 2 !== 0) throw new Error('Hex encoded strings must have an even number length');
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in (0, $bf87c628313d34c2$export$fcb552daf117d7e3)) out[i / 2] = (0, $bf87c628313d34c2$export$fcb552daf117d7e3)[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ const $53dcd5adec6205d5$export$22a20ab34c1d7a2b = (bytes)=>{
    let out = '';
    for(let i = 0; i < bytes.byteLength; i++)out += (0, $bf87c628313d34c2$export$a0f75f7d2f3bd702)[bytes[i]];
    return out;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a `SourceData`
 * @param {SourceData} data Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $729d2058b3ea14d7$export$629ee8d7d3ebacd1 = (data)=>{
    const sha256 = new (0, $bf8fb85b69ce25b0$export$3b58ea8124ac5e28)();
    sha256.update(data);
    const hashedData = sha256.digestSync();
    const hashHexFromUint8 = (0, $53dcd5adec6205d5$export$22a20ab34c1d7a2b)(hashedData);
    return new Array(64 - hashHexFromUint8.length).join('0') + hashHexFromUint8;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a hex string
 * @param {string} hexStr Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $4caca335d8745505$export$8b112e065a8843a = (hexStr)=>(0, $729d2058b3ea14d7$export$629ee8d7d3ebacd1)((0, $8bafa6bc7cf545f4$export$b772e43c3daf2e7a)(hexStr));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ const $df02bdef0f6f06fd$var$HEX_MSB_REGEX = /^[89a-f]/i;
/**
 * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
 *
 * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
 * byte array containing the two's-complement representation of a BigInteger. The array contains
 * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
 *
 * Examples showing how ambiguity is avoided by left padding with:
 * 	"00" (for positive values where the most-significant-bit is set)
 *  "FF" (for negative values where the most-significant-bit is set)
 *
 * padHex(bigInteger.fromInt(-236))  === "FF14"
 * padHex(bigInteger.fromInt(20))    === "14"
 *
 * padHex(bigInteger.fromInt(-200))  === "FF38"
 * padHex(bigInteger.fromInt(56))    === "38"
 *
 * padHex(bigInteger.fromInt(-20))   === "EC"
 * padHex(bigInteger.fromInt(236))   === "00EC"
 *
 * padHex(bigInteger.fromInt(-56))   === "C8"
 * padHex(bigInteger.fromInt(200))   === "00C8"
 *
 * @param {AuthBigInteger} bigInt Number to encode.
 * @returns {String} even-length hex string of the two's complement encoding.
 */ const $df02bdef0f6f06fd$export$35d4ea07514a0402 = (bigInt)=>{
    if (!(bigInt instanceof (0, $1584d617982d5f8b$export$2e2bcd8739ae039))) throw new Error('Not a BigInteger');
    const isNegative = bigInt.compareTo((0, $1584d617982d5f8b$export$2e2bcd8739ae039).ZERO) < 0;
    /* Get a hex string for abs(bigInt) */ let hexStr = bigInt.abs().toString(16);
    /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? `0${hexStr}` : hexStr;
    /* Prepend "00" if the most significant bit is set */ hexStr = $df02bdef0f6f06fd$var$HEX_MSB_REGEX.test(hexStr) ? `00${hexStr}` : hexStr;
    if (isNegative) {
        /* Flip the bits of the representation */ const invertedNibbles = hexStr.split('').map((x)=>{
            const invertedNibble = ~parseInt(x, 16) & 0xf;
            return '0123456789ABCDEF'.charAt(invertedNibble);
        }).join('');
        /* After flipping the bits, add one to get the 2's complement representation */ const flippedBitsBI = new (0, $1584d617982d5f8b$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $1584d617982d5f8b$export$2e2bcd8739ae039).ONE);
        hexStr = flippedBitsBI.toString(16);
        /*
        For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128

        Any sequence of '1' bits on the left can always be substituted with a single '1' bit
        without changing the represented value.

        This only happens in the case when the input is 80...00
        */ if (hexStr.toUpperCase().startsWith('FF8')) hexStr = hexStr.substring(2);
    }
    return hexStr;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $56590fbc441e2690$export$e2f40082638513e7 = ({ A: A, B: B })=>{
    const U = new (0, $1584d617982d5f8b$export$2e2bcd8739ae039)((0, $4caca335d8745505$export$8b112e065a8843a)((0, $df02bdef0f6f06fd$export$35d4ea07514a0402)(A) + (0, $df02bdef0f6f06fd$export$35d4ea07514a0402)(B)), 16);
    if (U.equals((0, $1584d617982d5f8b$export$2e2bcd8739ae039).ZERO)) throw new Error('U cannot be zero.');
    return U;
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Standard HKDF algorithm.
 *
 * @param {Uint8Array} ikm Input key material.
 * @param {Uint8Array} salt Salt value.
 * @param {Uint8Array} info Context and application specific info.
 *
 * @returns {Uint8Array} Strong key material.
 *
 * @internal
 */ const $6388c03f533fb331$export$295a0a5429217d03 = (ikm, salt, info)=>{
    const awsCryptoHash = new (0, $bf8fb85b69ce25b0$export$3b58ea8124ac5e28)(salt);
    awsCryptoHash.update(ikm);
    const resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
    const awsCryptoHashHmac = new (0, $bf8fb85b69ce25b0$export$3b58ea8124ac5e28)(resultFromAWSCryptoPrk);
    awsCryptoHashHmac.update(info);
    const resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
    const hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
    return hashHexFromAWSCrypto.slice(0, 16);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*
 * Cryptographically secure pseudorandom number generator
 * As Math.random() is cryptographically not safe to use
 */ function $92a9c67d3ddcc046$export$d265930babe23ca5() {
    const crypto = (0, $2f3406124c4dec3f$export$e003cc239f955cb6)();
    const randomResult = crypto.getRandomValues(new Uint32Array(1))[0];
    return randomResult;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $723431b4a836e1db$var$hexStringify(wordArray) {
    // Shortcuts
    const { words: words } = wordArray;
    const { sigBytes: sigBytes } = wordArray;
    // Convert
    const hexChars = [];
    for(let i = 0; i < sigBytes; i++){
        const bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join('');
}
class $723431b4a836e1db$export$4cd4919e303276a6 {
    constructor(words, sigBytes){
        this.words = [];
        let Words = words;
        Words = this.words = Words || [];
        if (sigBytes !== undefined) this.sigBytes = sigBytes;
        else this.sigBytes = Words.length * 4;
    }
    random(nBytes) {
        const words = [];
        for(let i = 0; i < nBytes; i += 4)words.push((0, $92a9c67d3ddcc046$export$d265930babe23ca5)());
        return new $723431b4a836e1db$export$4cd4919e303276a6(words, nBytes);
    }
    toString() {
        return $723431b4a836e1db$var$hexStringify(this);
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a Uint8Array with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Uint8Array} fixed-length sequence of random bytes
 */ const $f3c88e6264b55d10$export$763d6fc7c4b5dc52 = (nBytes)=>{
    const str = new (0, $723431b4a836e1db$export$4cd4919e303276a6)().random(nBytes).toString();
    return (0, $8bafa6bc7cf545f4$export$b772e43c3daf2e7a)(str);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Helper function to generate a random string
 * @returns {string} a random value.
 *
 * @internal
 */ const $e09586726d6f6244$export$8c487394e1c35fbe = ()=>(0, $820769526bac512e$export$695b149896bd3e2a).convert((0, $f3c88e6264b55d10$export$763d6fc7c4b5dc52)(40));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @class */ class $37c2c6f8544f6977$export$2e2bcd8739ae039 {
    constructor({ userPoolName: userPoolName, a: a, g: g, A: A, N: N }){
        this.encoder = (0, $0b638bbfb6d0e3bb$export$f5d75491a17f02c);
        this.userPoolName = userPoolName;
        this.a = a;
        this.g = g;
        this.A = A;
        this.N = N;
        this.k = new (0, $1584d617982d5f8b$export$2e2bcd8739ae039)((0, $4caca335d8745505$export$8b112e065a8843a)(`${(0, $df02bdef0f6f06fd$export$35d4ea07514a0402)(N)}${(0, $df02bdef0f6f06fd$export$35d4ea07514a0402)(g)}`), 16);
    }
    /**
     * @returns {string} Generated random value included in password hash.
     */ getRandomPassword() {
        if (!this.randomPassword) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
            name: 'EmptyBigIntegerRandomPassword',
            message: 'random password is empty'
        });
        return this.randomPassword;
    }
    /**
     * @returns {string} Generated random value included in devices hash.
     */ getSaltToHashDevices() {
        if (!this.saltToHashDevices) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
            name: 'EmptyBigIntegersaltToHashDevices',
            message: 'saltToHashDevices is empty'
        });
        return this.saltToHashDevices;
    }
    /**
     * @returns {string} Value used to verify devices.
     */ getVerifierDevices() {
        if (!this.verifierDevices) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
            name: 'EmptyBigIntegerVerifierDevices',
            message: 'verifyDevices is empty'
        });
        return this.verifierDevices;
    }
    /**
     * Generate salts and compute verifier.
     *
     * @param {string} deviceGroupKey Devices to generate verifier for.
     * @param {string} username User to generate verifier for.
     *
     * @returns {Promise<void>}
     */ async generateHashDevice(deviceGroupKey, username) {
        this.randomPassword = (0, $e09586726d6f6244$export$8c487394e1c35fbe)();
        const combinedString = `${deviceGroupKey}${username}:${this.randomPassword}`;
        const hashedString = (0, $729d2058b3ea14d7$export$629ee8d7d3ebacd1)(combinedString);
        const hexRandom = (0, $53dcd5adec6205d5$export$22a20ab34c1d7a2b)((0, $f3c88e6264b55d10$export$763d6fc7c4b5dc52)(16));
        // The random hex will be unambiguously represented as a postive integer
        this.saltToHashDevices = (0, $df02bdef0f6f06fd$export$35d4ea07514a0402)(new (0, $1584d617982d5f8b$export$2e2bcd8739ae039)(hexRandom, 16));
        return new Promise((resolve, reject)=>{
            this.g.modPow(new (0, $1584d617982d5f8b$export$2e2bcd8739ae039)((0, $4caca335d8745505$export$8b112e065a8843a)(this.saltToHashDevices + hashedString), 16), this.N, (err, result)=>{
                if (err) {
                    reject(err);
                    return;
                }
                this.verifierDevices = (0, $df02bdef0f6f06fd$export$35d4ea07514a0402)(result);
                resolve();
            });
        });
    }
    /**
     * Calculates the final HKDF key based on computed S value, computed U value and the key
     *
     * @param {String} username Username.
     * @param {String} password Password.
     * @param {AuthBigInteger} B Server B value.
     * @param {AuthBigInteger} salt Generated salt.
     */ async getPasswordAuthenticationKey({ username: username, password: password, serverBValue: serverBValue, salt: salt }) {
        if (serverBValue.mod(this.N).equals((0, $1584d617982d5f8b$export$2e2bcd8739ae039).ZERO)) throw new Error('B cannot be zero.');
        const U = (0, $56590fbc441e2690$export$e2f40082638513e7)({
            A: this.A,
            B: serverBValue
        });
        const usernamePassword = `${this.userPoolName}${username}:${password}`;
        const usernamePasswordHash = (0, $729d2058b3ea14d7$export$629ee8d7d3ebacd1)(usernamePassword);
        const x = new (0, $1584d617982d5f8b$export$2e2bcd8739ae039)((0, $4caca335d8745505$export$8b112e065a8843a)((0, $df02bdef0f6f06fd$export$35d4ea07514a0402)(salt) + usernamePasswordHash), 16);
        const S = await (0, $ea8fc9ae8e78a7bf$export$f7340100dd3acd38)({
            a: this.a,
            g: this.g,
            k: this.k,
            x: x,
            B: serverBValue,
            N: this.N,
            U: U
        });
        const context = this.encoder.convert('Caldera Derived Key');
        const spacer = this.encoder.convert(String.fromCharCode(1));
        const info = new Uint8Array(context.byteLength + spacer.byteLength);
        info.set(context, 0);
        info.set(spacer, context.byteLength);
        const hkdfKey = (0, $6388c03f533fb331$export$295a0a5429217d03)((0, $8bafa6bc7cf545f4$export$b772e43c3daf2e7a)((0, $df02bdef0f6f06fd$export$35d4ea07514a0402)(S)), (0, $8bafa6bc7cf545f4$export$b772e43c3daf2e7a)((0, $df02bdef0f6f06fd$export$35d4ea07514a0402)(U)), info);
        return hkdfKey;
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $5e2797d72563689f$export$53a55138f9e96c65 = async ({ a: a, g: g, N: N })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(a, N, (err, A)=>{
            if (err) {
                reject(err);
                return;
            }
            if (A.mod(N).equals((0, $1584d617982d5f8b$export$2e2bcd8739ae039).ZERO)) {
                reject(new Error('Illegal parameter. A mod N cannot be 0.'));
                return;
            }
            resolve(A);
        });
    });
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a new {@link AuthenticationHelper} instance with randomly generated BigInteger seed
 *
 * @param userPoolName Cognito user pool name.
 * @returns An {@link AuthenticationHelper} instance.
 *
 * @internal
 */ const $55d20ee460e3d4cf$export$47560e2dc89f678c = async (userPoolName)=>{
    const N = new (0, $1584d617982d5f8b$export$2e2bcd8739ae039)((0, $bf87c628313d34c2$export$baab4dd8c7240846), 16);
    const g = new (0, $1584d617982d5f8b$export$2e2bcd8739ae039)('2', 16);
    const a = $55d20ee460e3d4cf$var$generateRandomBigInteger();
    const A = await (0, $5e2797d72563689f$export$53a55138f9e96c65)({
        a: a,
        g: g,
        N: N
    });
    return new (0, $37c2c6f8544f6977$export$2e2bcd8739ae039)({
        userPoolName: userPoolName,
        a: a,
        g: g,
        A: A,
        N: N
    });
};
/**
 * Generates a random BigInteger.
 *
 * @returns {BigInteger} a random value.
 */ const $55d20ee460e3d4cf$var$generateRandomBigInteger = ()=>{
    // This will be interpreted as a postive 128-bit integer
    const hexRandom = (0, $53dcd5adec6205d5$export$22a20ab34c1d7a2b)((0, $f3c88e6264b55d10$export$763d6fc7c4b5dc52)(128));
    // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
    return new (0, $1584d617982d5f8b$export$2e2bcd8739ae039)(hexRandom, 16);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This function is used to kick off the device management flow.
 *
 * If an error is thrown while generating a hash device or calling the `ConfirmDevice`
 * client, then this API will ignore the error and return undefined. Otherwise the authentication
 * flow will not complete and the user won't be able to be signed in.
 *
 * @returns DeviceMetadata | undefined
 */ async function $e205307ce629ac6f$export$548ed8ad974a8b30({ userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint, newDeviceMetadata: newDeviceMetadata, accessToken: accessToken }) {
    if (!newDeviceMetadata) return undefined;
    const userPoolName = userPoolId.split('_')[1] || '';
    const authenticationHelper = await (0, $55d20ee460e3d4cf$export$47560e2dc89f678c)(userPoolName);
    const deviceKey = newDeviceMetadata?.DeviceKey;
    const deviceGroupKey = newDeviceMetadata?.DeviceGroupKey;
    try {
        await authenticationHelper.generateHashDevice(deviceGroupKey ?? '', deviceKey ?? '');
    } catch (errGenHash) {
        // TODO: log error here
        return undefined;
    }
    const deviceSecretVerifierConfig = {
        Salt: (0, $820769526bac512e$export$695b149896bd3e2a).convert((0, $8bafa6bc7cf545f4$export$b772e43c3daf2e7a)(authenticationHelper.getSaltToHashDevices())),
        PasswordVerifier: (0, $820769526bac512e$export$695b149896bd3e2a).convert((0, $8bafa6bc7cf545f4$export$b772e43c3daf2e7a)(authenticationHelper.getVerifierDevices()))
    };
    const randomPassword = authenticationHelper.getRandomPassword();
    try {
        const confirmDevice = (0, $e7bfbc78b3dd11ef$export$d88a63af6351a7c3)({
            endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        await confirmDevice({
            region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId)
        }, {
            AccessToken: accessToken,
            DeviceName: await (0, $9351d6ed6be2ae5c$export$98f0aedb14d75123)(),
            DeviceKey: newDeviceMetadata?.DeviceKey,
            DeviceSecretVerifierConfig: deviceSecretVerifierConfig
        });
        return {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        };
    } catch (error) {
        // TODO: log error here
        return undefined;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $88e1efa685aced3d$export$77701654924537aa(challengeParameters) {
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const { username: username, signInSession: signInSession, signInDetails: signInDetails, challengeName: challengeName } = (0, $fd57acfd3d6695db$export$390d5da4c63a4a41).getState();
    if (challengeName !== 'WEB_AUTHN' || !username) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: (0, $8d93f22263ae8b19$export$473ab0b56598aacd).SignInException,
        message: 'Unable to proceed due to invalid sign in state.'
    });
    const { CREDENTIAL_REQUEST_OPTIONS: credentialRequestOptions } = challengeParameters;
    (0, $6d90af1ed0fee71a$export$3145abf24cf8a54e)(!!credentialRequestOptions, (0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).InvalidPasskeyAuthenticationOptions);
    const cred = await (0, $fba96e0dec8734ec$export$d7f92bd7f1e366c1)(JSON.parse(credentialRequestOptions));
    const respondToAuthChallenge = (0, $8f35e4984ef6e471$export$11329f5ae466ab5d)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: authConfig.userPoolEndpoint
        })
    });
    const { ChallengeName: nextChallengeName, ChallengeParameters: nextChallengeParameters, AuthenticationResult: authenticationResult, Session: nextSession } = await respondToAuthChallenge({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(authConfig.userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: 'WEB_AUTHN',
        ChallengeResponses: {
            USERNAME: username,
            CREDENTIAL: JSON.stringify(cred)
        },
        ClientId: authConfig.userPoolClientId,
        Session: signInSession
    });
    (0, $fd57acfd3d6695db$export$bae72361b690e075)({
        signInSession: nextSession,
        username: username,
        challengeName: nextChallengeName,
        signInDetails: signInDetails
    });
    if (authenticationResult) {
        await (0, $91b271eeb38cc677$export$729df6fdd19b8b0d)({
            ...authenticationResult,
            username: username,
            NewDeviceMetadata: await (0, $e205307ce629ac6f$export$548ed8ad974a8b30)({
                userPoolId: authConfig.userPoolId,
                userPoolEndpoint: authConfig.userPoolEndpoint,
                newDeviceMetadata: authenticationResult.NewDeviceMetadata,
                accessToken: authenticationResult.AccessToken
            }),
            signInDetails: signInDetails
        });
        (0, $fd57acfd3d6695db$export$390d5da4c63a4a41).dispatch({
            type: 'RESET_STATE'
        });
        await (0, $e29e37b04a825a54$export$4d78d2ee899572ab)();
        return {
            isSignedIn: true,
            nextStep: {
                signInStep: 'DONE'
            }
        };
    }
    if (nextChallengeName === 'WEB_AUTHN') throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: (0, $8d93f22263ae8b19$export$473ab0b56598aacd).SignInException,
        message: 'Sequential WEB_AUTHN challenges returned from underlying service cannot be handled.'
    });
    return {
        challengeName: nextChallengeName,
        challengeParameters: nextChallengeParameters
    };
}



































// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1271d84133389c1c$var$MONTH_NAMES = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
const $1271d84133389c1c$var$WEEK_NAMES = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
const $1271d84133389c1c$export$218a6e05f05aec48 = ()=>{
    const now = new Date();
    const weekDay = $1271d84133389c1c$var$WEEK_NAMES[now.getUTCDay()];
    const month = $1271d84133389c1c$var$MONTH_NAMES[now.getUTCMonth()];
    const day = now.getUTCDate();
    let hours = now.getUTCHours();
    if (hours < 10) hours = `0${hours}`;
    let minutes = now.getUTCMinutes();
    if (minutes < 10) minutes = `0${minutes}`;
    let seconds = now.getUTCSeconds();
    if (seconds < 10) seconds = `0${seconds}`;
    const year = now.getUTCFullYear();
    // ddd MMM D HH:mm:ss UTC YYYY
    const dateNow = `${weekDay} ${month} ${day} ${hours}:${minutes}:${seconds} UTC ${year}`;
    return dateNow;
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7325b637c9f21e0b$export$577b7d8a4f1b23fd = ({ userPoolName: userPoolName, username: username, challengeParameters: challengeParameters, dateNow: dateNow, hkdf: hkdf })=>{
    const bufUPIDaToB = (0, $0b638bbfb6d0e3bb$export$f5d75491a17f02c).convert(userPoolName);
    const bufUNaToB = (0, $0b638bbfb6d0e3bb$export$f5d75491a17f02c).convert(username);
    const bufSBaToB = $7325b637c9f21e0b$var$urlB64ToUint8Array(challengeParameters.SECRET_BLOCK);
    const bufDNaToB = (0, $0b638bbfb6d0e3bb$export$f5d75491a17f02c).convert(dateNow);
    const bufConcat = new Uint8Array(bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength + bufDNaToB.byteLength);
    bufConcat.set(bufUPIDaToB, 0);
    bufConcat.set(bufUNaToB, bufUPIDaToB.byteLength);
    bufConcat.set(bufSBaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength);
    bufConcat.set(bufDNaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength);
    const awsCryptoHash = new (0, $bf8fb85b69ce25b0$export$3b58ea8124ac5e28)(hkdf);
    awsCryptoHash.update(bufConcat);
    const resultFromAWSCrypto = awsCryptoHash.digestSync();
    const signatureString = (0, $820769526bac512e$export$695b149896bd3e2a).convert(resultFromAWSCrypto);
    return signatureString;
};
const $7325b637c9f21e0b$var$urlB64ToUint8Array = (base64String)=>{
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = (0, $05be7a5c43db640d$export$1e303d38dab7b376).convert(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
};






















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $23a20e919e040981$export$18ec6b77c0b7fafe({ username: username, config: config, clientMetadata: clientMetadata, session: session, tokenOrchestrator: tokenOrchestrator }) {
    const { userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint } = config;
    const clientId = config.userPoolClientId;
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $6cdbc20a8ad3ee2e$export$b6f03be79626ab0f)(deviceMetadata);
    const authenticationHelper = await (0, $55d20ee460e3d4cf$export$47560e2dc89f678c)(deviceMetadata.deviceGroupKey);
    const challengeResponses = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        DEVICE_KEY: deviceMetadata.deviceKey
    };
    const jsonReqResponseChallenge = {
        ChallengeName: 'DEVICE_SRP_AUTH',
        ClientId: clientId,
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session
    };
    const respondToAuthChallenge = (0, $8f35e4984ef6e471$export$11329f5ae466ab5d)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { ChallengeParameters: respondedChallengeParameters, Session: Session } = await respondToAuthChallenge({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId)
    }, jsonReqResponseChallenge);
    return $23a20e919e040981$var$handleDevicePasswordVerifier(username, respondedChallengeParameters, clientMetadata, Session, authenticationHelper, config, tokenOrchestrator);
}
async function $23a20e919e040981$var$handleDevicePasswordVerifier(username, challengeParameters, clientMetadata, session, authenticationHelper, { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint }, tokenOrchestrator) {
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $6cdbc20a8ad3ee2e$export$b6f03be79626ab0f)(deviceMetadata);
    const serverBValue = new (0, $1584d617982d5f8b$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $1584d617982d5f8b$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const { deviceKey: deviceKey } = deviceMetadata;
    const { deviceGroupKey: deviceGroupKey } = deviceMetadata;
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: deviceMetadata.deviceKey,
        password: deviceMetadata.randomPassword,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $1271d84133389c1c$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: challengeParameters?.USERNAME ?? username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $7325b637c9f21e0b$export$577b7d8a4f1b23fd)({
            username: deviceKey,
            userPoolName: deviceGroupKey,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        }),
        DEVICE_KEY: deviceKey
    };
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
        ClientId: userPoolClientId,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $8f35e4984ef6e471$export$11329f5ae466ab5d)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId)
    }, jsonReqResponseChallenge);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $50e4977d72f02868$export$7f7b64167822fe34(password, challengeParameters, clientMetadata, session, authenticationHelper, config, tokenOrchestrator) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const userPoolName = userPoolId?.split('_')[1] || '';
    const serverBValue = new (0, $1584d617982d5f8b$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $1584d617982d5f8b$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const username = challengeParameters?.USER_ID_FOR_SRP;
    if (!username) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: 'EmptyUserIdForSRPException',
        message: 'USER_ID_FOR_SRP was not found in challengeParameters'
    });
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: username,
        password: password,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $1271d84133389c1c$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $7325b637c9f21e0b$export$577b7d8a4f1b23fd)({
            username: username,
            userPoolName: userPoolName,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        })
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: 'PASSWORD_VERIFIER',
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $8f35e4984ef6e471$export$11329f5ae466ab5d)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId)
    }, jsonReqResponseChallenge);
    if (response.ChallengeName === 'DEVICE_SRP_AUTH') return (0, $23a20e919e040981$export$18ec6b77c0b7fafe)({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * It will retry the function if the error is a `ResourceNotFoundException` and
 * will clean the device keys stored in the storage mechanism.
 *
 */ async function $da73af6c4a37b7ee$export$30f932fe98713ccc(func, args, username, tokenOrchestrator) {
    try {
        return await func(...args);
    } catch (error) {
        if (error instanceof (0, $6b5d16e8c6288a5f$export$145273558d58e0ac) && error.name === 'ResourceNotFoundException' && error.message.includes('Device does not exist.')) {
            await tokenOrchestrator.clearDeviceMetadata(username);
            return func(...args);
        }
        throw error;
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $dd2813b104f41b95$export$fecfbc200868d412(username) {
    const { dispatch: dispatch } = (0, $fd57acfd3d6695db$export$390d5da4c63a4a41);
    dispatch({
        type: 'SET_USERNAME',
        value: username
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the Password SRP (Secure Remote Password) authentication flow.
 * This function can be used with both USER_SRP_AUTH and USER_AUTH flows.
 *
 * @param {Object} params - The parameters for the Password SRP authentication
 * @param {string} params.username - The username for authentication
 * @param {string} params.password - The user's password
 * @param {ClientMetadata} [params.clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {AuthTokenOrchestrator} params.tokenOrchestrator - Token orchestrator for managing auth tokens
 * @param {AuthFlowType} params.authFlow - The type of authentication flow ('USER_SRP_AUTH' or 'USER_AUTH')
 * @param {AuthFactorType} [params.preferredChallenge] - Optional preferred challenge type when using USER_AUTH flow
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The authentication response
 */ async function $1c0a8a512bbf0c35$export$169bd15774e46c56({ username: username, password: password, clientMetadata: clientMetadata, config: config, tokenOrchestrator: tokenOrchestrator, authFlow: authFlow, preferredChallenge: preferredChallenge }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const userPoolName = userPoolId?.split('_')[1] || '';
    const authenticationHelper = await (0, $55d20ee460e3d4cf$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    if (authFlow === 'USER_AUTH' && preferredChallenge) authParameters.PREFERRED_CHALLENGE = preferredChallenge;
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: authFlow,
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $d16d4d8349af273b$export$91f349d78bea7765)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const resp = await initiateAuth({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const { ChallengeParameters: challengeParameters, Session: session } = resp;
    const activeUsername = challengeParameters?.USERNAME ?? username;
    (0, $dd2813b104f41b95$export$fecfbc200868d412)(activeUsername);
    if (resp.ChallengeName === 'PASSWORD_VERIFIER') return (0, $da73af6c4a37b7ee$export$30f932fe98713ccc)((0, $50e4977d72f02868$export$7f7b64167822fe34), [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
    return resp;
}















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response for authentication.
 * Initiates the selected authentication challenge based on user choice.
 *
 * @param {Object} params - The parameters for handling the selected challenge
 * @param {string} params.username - The username for authentication
 * @param {string} params.session - The current authentication session token
 * @param {string} params.selectedChallenge - The challenge type selected by the user
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {ClientMetadata} [params.clientMetadata] - Optional metadata to be sent with auth requests
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function $00dd4e7743ccc6ec$export$4eb37109154e77c1({ username: username, session: session, selectedChallenge: selectedChallenge, config: config, clientMetadata: clientMetadata }) {
    const respondToAuthChallenge = (0, $8f35e4984ef6e471$export$11329f5ae466ab5d)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: config.userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(config.userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: 'SELECT_CHALLENGE',
        ChallengeResponses: {
            USERNAME: username,
            ANSWER: selectedChallenge
        },
        ClientId: config.userPoolClientId,
        Session: session,
        ClientMetadata: clientMetadata
    });
}

















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response specifically for Password authentication.
 * This function combines the SELECT_CHALLENGE flow with standard password authentication.
 *
 * @param {string} username - The username for authentication
 * @param {string} password - The user's password
 * @param {ClientMetadata} [clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} config - Cognito User Pool configuration
 * @param {string} session - The current authentication session token
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function $d15e8b7453edf9f8$export$cca550d6560f23b8(username, password, clientMetadata, config, session) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const authParameters = {
        ANSWER: 'PASSWORD',
        USERNAME: username,
        PASSWORD: password
    };
    const userContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const respondToAuthChallenge = (0, $8f35e4984ef6e471$export$11329f5ae466ab5d)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: 'SELECT_CHALLENGE',
        ChallengeResponses: authParameters,
        ClientId: userPoolClientId,
        ClientMetadata: clientMetadata,
        Session: session,
        UserContextData: userContextData
    });
    const activeUsername = response.ChallengeParameters?.USERNAME ?? username;
    (0, $dd2813b104f41b95$export$fecfbc200868d412)(activeUsername);
    return response;
}






















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response specifically for Password SRP authentication.
 * This function combines the SELECT_CHALLENGE flow with Password SRP protocol.
 *
 * @param {string} username - The username for authentication
 * @param {string} password - The user's password
 * @param {ClientMetadata} [clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} config - Cognito User Pool configuration
 * @param {string} session - The current authentication session token
 * @param {AuthTokenOrchestrator} tokenOrchestrator - Token orchestrator for managing auth tokens
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function $25cd7f3c190fe693$export$e496ff225fdec499(username, password, clientMetadata, config, session, tokenOrchestrator) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const userPoolName = userPoolId.split('_')[1] || '';
    const authenticationHelper = await (0, $55d20ee460e3d4cf$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        ANSWER: 'PASSWORD_SRP',
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    const userContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const respondToAuthChallenge = (0, $8f35e4984ef6e471$export$11329f5ae466ab5d)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: 'SELECT_CHALLENGE',
        ChallengeResponses: authParameters,
        ClientId: userPoolClientId,
        ClientMetadata: clientMetadata,
        Session: session,
        UserContextData: userContextData
    });
    const activeUsername = response.ChallengeParameters?.USERNAME ?? username;
    (0, $dd2813b104f41b95$export$fecfbc200868d412)(activeUsername);
    if (response.ChallengeName === 'PASSWORD_VERIFIER') return (0, $da73af6c4a37b7ee$export$30f932fe98713ccc)((0, $50e4977d72f02868$export$7f7b64167822fe34), [
        password,
        response.ChallengeParameters,
        clientMetadata,
        response.Session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
    return response;
}












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a34f9704f91c4ae9$var$USER_ATTRIBUTES = 'userAttributes.';
function $a34f9704f91c4ae9$var$isWebAuthnResultAuthSignInOutput(result) {
    return 'isSignedIn' in result && 'nextStep' in result;
}
async function $a34f9704f91c4ae9$export$6fe6331471b54d26({ challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, config: config, tokenOrchestrator: tokenOrchestrator }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const challengeResponses = {
        USERNAME: username,
        ANSWER: challengeResponse
    };
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: 'CUSTOM_CHALLENGE',
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $8f35e4984ef6e471$export$11329f5ae466ab5d)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
    if (response.ChallengeName === 'DEVICE_SRP_AUTH') return (0, $23a20e919e040981$export$18ec6b77c0b7fafe)({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $a34f9704f91c4ae9$export$9b78cd405a35bccd({ challengeResponse: challengeResponse, username: username, clientMetadata: clientMetadata, session: session, deviceName: deviceName, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    if (challengeResponse === 'EMAIL') return {
        ChallengeName: 'MFA_SETUP',
        Session: session,
        ChallengeParameters: {
            MFAS_CAN_SETUP: '["EMAIL_OTP"]'
        },
        $metadata: {}
    };
    if (challengeResponse === 'TOTP') return {
        ChallengeName: 'MFA_SETUP',
        Session: session,
        ChallengeParameters: {
            MFAS_CAN_SETUP: '["SOFTWARE_TOKEN_MFA"]'
        },
        $metadata: {}
    };
    const challengeResponses = {
        USERNAME: username
    };
    const isTOTPCode = /^\d+$/.test(challengeResponse);
    if (isTOTPCode) {
        const verifySoftwareToken = (0, $c0fbf9d4293877db$export$cf5dd9429415aa98)({
            endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        const { Session: Session } = await verifySoftwareToken({
            region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignIn)
        }, {
            UserCode: challengeResponse,
            Session: session,
            FriendlyDeviceName: deviceName
        });
        (0, $fd57acfd3d6695db$export$390d5da4c63a4a41).dispatch({
            type: 'SET_SIGN_IN_SESSION',
            value: Session
        });
        const jsonReq = {
            ChallengeName: 'MFA_SETUP',
            ChallengeResponses: challengeResponses,
            Session: Session,
            ClientMetadata: clientMetadata,
            ClientId: userPoolClientId
        };
        const respondToAuthChallenge = (0, $8f35e4984ef6e471$export$11329f5ae466ab5d)({
            endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        return respondToAuthChallenge({
            region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignIn)
        }, jsonReq);
    }
    const isEmail = challengeResponse.includes('@');
    if (isEmail) {
        challengeResponses.EMAIL = challengeResponse;
        const jsonReq = {
            ChallengeName: 'MFA_SETUP',
            ChallengeResponses: challengeResponses,
            Session: session,
            ClientMetadata: clientMetadata,
            ClientId: userPoolClientId
        };
        const respondToAuthChallenge = (0, $8f35e4984ef6e471$export$11329f5ae466ab5d)({
            endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        return respondToAuthChallenge({
            region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignIn)
        }, jsonReq);
    }
    throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: (0, $8d93f22263ae8b19$export$473ab0b56598aacd).SignInException,
        message: `Cannot proceed with MFA setup using challengeResponse: ${challengeResponse}`,
        recoverySuggestion: 'Try passing "EMAIL", "TOTP", a valid email, or OTP code as the challengeResponse.'
    });
}
async function $a34f9704f91c4ae9$export$f0699fc2b71f49c0({ challengeResponse: challengeResponse, username: username, clientMetadata: clientMetadata, session: session, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(challengeResponse === 'TOTP' || challengeResponse === 'SMS' || challengeResponse === 'EMAIL', (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).IncorrectMFAMethod);
    const challengeResponses = {
        USERNAME: username,
        ANSWER: $a34f9704f91c4ae9$export$7e7902092e38fcff(challengeResponse)
    };
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: 'SELECT_MFA_TYPE',
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $8f35e4984ef6e471$export$11329f5ae466ab5d)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $a34f9704f91c4ae9$export$df3f8a8c68da6a2e({ challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, requiredAttributes: requiredAttributes, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const challengeResponses = {
        ...$a34f9704f91c4ae9$export$c7c9603a6b1fd815(requiredAttributes),
        NEW_PASSWORD: challengeResponse,
        USERNAME: username
    };
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: 'NEW_PASSWORD_REQUIRED',
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $8f35e4984ef6e471$export$11329f5ae466ab5d)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $a34f9704f91c4ae9$export$29fb48d356e16a7(username, password, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint } = config;
    const authParameters = {
        USERNAME: username,
        PASSWORD: password
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: 'USER_PASSWORD_AUTH',
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $d16d4d8349af273b$export$91f349d78bea7765)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? response.ChallengeParameters?.USER_ID_FOR_SRP ?? username;
    (0, $dd2813b104f41b95$export$fecfbc200868d412)(activeUsername);
    if (response.ChallengeName === 'DEVICE_SRP_AUTH') return (0, $23a20e919e040981$export$18ec6b77c0b7fafe)({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $a34f9704f91c4ae9$export$13a3ef5ef8cac338(username, password, clientMetadata, config, tokenOrchestrator) {
    return (0, $1c0a8a512bbf0c35$export$169bd15774e46c56)({
        username: username,
        password: password,
        clientMetadata: clientMetadata,
        config: config,
        tokenOrchestrator: tokenOrchestrator,
        authFlow: 'USER_SRP_AUTH'
    });
}
async function $a34f9704f91c4ae9$export$1a654dcab55e0de5(username, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint } = config;
    const authParameters = {
        USERNAME: username
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: 'CUSTOM_AUTH',
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $d16d4d8349af273b$export$91f349d78bea7765)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? username;
    (0, $dd2813b104f41b95$export$fecfbc200868d412)(activeUsername);
    if (response.ChallengeName === 'DEVICE_SRP_AUTH') return (0, $23a20e919e040981$export$18ec6b77c0b7fafe)({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $a34f9704f91c4ae9$export$9ce9dd351616104c(username, password, clientMetadata, config, tokenOrchestrator) {
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(config);
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const userPoolName = userPoolId?.split('_')[1] || '';
    const authenticationHelper = await (0, $55d20ee460e3d4cf$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        CHALLENGE_NAME: 'SRP_A'
    };
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: 'CUSTOM_AUTH',
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $d16d4d8349af273b$export$91f349d78bea7765)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { ChallengeParameters: challengeParameters, Session: session } = await initiateAuth({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = challengeParameters?.USERNAME ?? username;
    (0, $dd2813b104f41b95$export$fecfbc200868d412)(activeUsername);
    return (0, $da73af6c4a37b7ee$export$30f932fe98713ccc)((0, $50e4977d72f02868$export$7f7b64167822fe34), [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
}
async function $a34f9704f91c4ae9$export$cf152400b58b8e65(params) {
    const { challengeName: challengeName, challengeParameters: challengeParameters, availableChallenges: availableChallenges } = params;
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    switch(challengeName){
        case 'CUSTOM_CHALLENGE':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE',
                    additionalInfo: challengeParameters
                }
            };
        case 'MFA_SETUP':
            {
                const { signInSession: signInSession, username: username } = (0, $fd57acfd3d6695db$export$390d5da4c63a4a41).getState();
                const mfaSetupTypes = $a34f9704f91c4ae9$export$d70c792e078766ea($a34f9704f91c4ae9$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_SETUP)) || [];
                const allowedMfaSetupTypes = $a34f9704f91c4ae9$export$343435e7c7c3ff0f(mfaSetupTypes);
                const isTotpMfaSetupAvailable = allowedMfaSetupTypes.includes('TOTP');
                const isEmailMfaSetupAvailable = allowedMfaSetupTypes.includes('EMAIL');
                if (isTotpMfaSetupAvailable && isEmailMfaSetupAvailable) return {
                    isSignedIn: false,
                    nextStep: {
                        signInStep: 'CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION',
                        allowedMFATypes: allowedMfaSetupTypes
                    }
                };
                if (isEmailMfaSetupAvailable) return {
                    isSignedIn: false,
                    nextStep: {
                        signInStep: 'CONTINUE_SIGN_IN_WITH_EMAIL_SETUP'
                    }
                };
                if (isTotpMfaSetupAvailable) {
                    const associateSoftwareToken = (0, $888d91bf57e232eb$export$6bff32634453de2a)({
                        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
                            endpointOverride: authConfig.userPoolEndpoint
                        })
                    });
                    const { Session: Session, SecretCode: secretCode } = await associateSoftwareToken({
                        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(authConfig.userPoolId)
                    }, {
                        Session: signInSession
                    });
                    (0, $fd57acfd3d6695db$export$390d5da4c63a4a41).dispatch({
                        type: 'SET_SIGN_IN_SESSION',
                        value: Session
                    });
                    return {
                        isSignedIn: false,
                        nextStep: {
                            signInStep: 'CONTINUE_SIGN_IN_WITH_TOTP_SETUP',
                            totpSetupDetails: $a34f9704f91c4ae9$export$b105c3e8e4f5ce91(secretCode, username)
                        }
                    };
                }
                throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
                    name: (0, $8d93f22263ae8b19$export$473ab0b56598aacd).SignInException,
                    message: `Cannot initiate MFA setup from available types: ${mfaSetupTypes}`
                });
            }
        case 'NEW_PASSWORD_REQUIRED':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',
                    missingAttributes: $a34f9704f91c4ae9$export$fbe550151e406473(challengeParameters.requiredAttributes)
                }
            };
        case 'SELECT_MFA_TYPE':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONTINUE_SIGN_IN_WITH_MFA_SELECTION',
                    allowedMFATypes: $a34f9704f91c4ae9$export$d70c792e078766ea($a34f9704f91c4ae9$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_CHOOSE))
                }
            };
        case 'SMS_OTP':
        case 'SMS_MFA':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONFIRM_SIGN_IN_WITH_SMS_CODE',
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case 'SOFTWARE_TOKEN_MFA':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONFIRM_SIGN_IN_WITH_TOTP_CODE'
                }
            };
        case 'EMAIL_OTP':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE',
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case 'WEB_AUTHN':
            {
                const result = await (0, $88e1efa685aced3d$export$77701654924537aa)(challengeParameters);
                if ($a34f9704f91c4ae9$var$isWebAuthnResultAuthSignInOutput(result)) return result;
                return $a34f9704f91c4ae9$export$cf152400b58b8e65(result);
            }
        case 'PASSWORD':
        case 'PASSWORD_SRP':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONFIRM_SIGN_IN_WITH_PASSWORD'
                }
            };
        case 'SELECT_CHALLENGE':
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: 'CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION',
                    availableChallenges: availableChallenges
                }
            };
    }
    // TODO: remove this error message for production apps
    throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: (0, $8d93f22263ae8b19$export$473ab0b56598aacd).SignInException,
        message: 'An error occurred during the sign in process. ' + `${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $a34f9704f91c4ae9$export$b105c3e8e4f5ce91(secretCode, username) {
    return {
        sharedSecret: secretCode,
        getSetupUri: (appName, accountName)=>{
            const totpUri = `otpauth://totp/${appName}:${accountName ?? username}?secret=${secretCode}&issuer=${appName}`;
            return new (0, $e4212cfe0940953e$export$beb82d9d9136c16e)(totpUri);
        }
    };
}
function $a34f9704f91c4ae9$export$cafe99bb44d49edb(errorName) {
    if (errorName === (0, $9dae3ebf1d7aa1cb$export$43ac0110dfdad33b).PasswordResetRequiredException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: 'RESET_PASSWORD'
        }
    };
    else if (errorName === (0, $9dae3ebf1d7aa1cb$export$43ac0110dfdad33b).UserNotConfirmedException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: 'CONFIRM_SIGN_UP'
        }
    };
}
function $a34f9704f91c4ae9$export$fbe550151e406473(attributes) {
    if (!attributes) return [];
    const parsedAttributes = JSON.parse(attributes).map((att)=>att.includes($a34f9704f91c4ae9$var$USER_ATTRIBUTES) ? att.replace($a34f9704f91c4ae9$var$USER_ATTRIBUTES, '') : att);
    return parsedAttributes;
}
function $a34f9704f91c4ae9$export$c7c9603a6b1fd815(attributes) {
    if (!attributes) return {};
    const newAttributes = {};
    Object.entries(attributes).forEach(([key, value])=>{
        if (value) newAttributes[`${$a34f9704f91c4ae9$var$USER_ATTRIBUTES}${key}`] = value;
    });
    return newAttributes;
}
async function $a34f9704f91c4ae9$export$cfd8b50d0f78e4fa(username, challengeName, session, challengeResponse, config, tokenOrchestrator, clientMetadata, options) {
    const userAttributes = options?.userAttributes;
    const deviceName = options?.friendlyDeviceName;
    switch(challengeName){
        case 'WEB_AUTHN':
        case 'SELECT_CHALLENGE':
            if (challengeResponse === 'PASSWORD_SRP' || challengeResponse === 'PASSWORD') return {
                ChallengeName: challengeResponse,
                Session: session,
                $metadata: {}
            };
            return (0, $00dd4e7743ccc6ec$export$4eb37109154e77c1)({
                username: username,
                session: session,
                selectedChallenge: challengeResponse,
                config: config,
                clientMetadata: clientMetadata
            });
        case 'SELECT_MFA_TYPE':
            return $a34f9704f91c4ae9$export$f0699fc2b71f49c0({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case 'MFA_SETUP':
            return $a34f9704f91c4ae9$export$9b78cd405a35bccd({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                deviceName: deviceName,
                config: config
            });
        case 'NEW_PASSWORD_REQUIRED':
            return $a34f9704f91c4ae9$export$df3f8a8c68da6a2e({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                requiredAttributes: userAttributes,
                config: config
            });
        case 'CUSTOM_CHALLENGE':
            return (0, $da73af6c4a37b7ee$export$30f932fe98713ccc)($a34f9704f91c4ae9$export$6fe6331471b54d26, [
                {
                    challengeResponse: challengeResponse,
                    clientMetadata: clientMetadata,
                    session: session,
                    username: username,
                    config: config,
                    tokenOrchestrator: tokenOrchestrator
                }
            ], username, tokenOrchestrator);
        case 'SMS_MFA':
        case 'SOFTWARE_TOKEN_MFA':
        case 'SMS_OTP':
        case 'EMAIL_OTP':
            return $a34f9704f91c4ae9$export$1ec196d12cb921db({
                challengeName: challengeName,
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config,
                tokenOrchestrator: tokenOrchestrator
            });
        case 'PASSWORD':
            return (0, $d15e8b7453edf9f8$export$cca550d6560f23b8)(username, challengeResponse, clientMetadata, config, session);
        case 'PASSWORD_SRP':
            return (0, $25cd7f3c190fe693$export$e496ff225fdec499)(username, challengeResponse, clientMetadata, config, session, tokenOrchestrator);
    }
    // TODO: remove this error message for production apps
    throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: (0, $8d93f22263ae8b19$export$473ab0b56598aacd).SignInException,
        message: `An error occurred during the sign in process.
		${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $a34f9704f91c4ae9$export$7e7902092e38fcff(mfa) {
    let mfaType = 'SMS_MFA';
    if (mfa === 'TOTP') mfaType = 'SOFTWARE_TOKEN_MFA';
    if (mfa === 'EMAIL') mfaType = 'EMAIL_OTP';
    return mfaType;
}
function $a34f9704f91c4ae9$export$6ce04ce89055b1fe(type) {
    if (type === 'SMS_MFA') return 'SMS';
    if (type === 'SOFTWARE_TOKEN_MFA') return 'TOTP';
    if (type === 'EMAIL_OTP') return 'EMAIL';
// TODO: log warning for unknown MFA type
}
function $a34f9704f91c4ae9$export$d70c792e078766ea(types) {
    if (!types) return undefined;
    return types.map($a34f9704f91c4ae9$export$6ce04ce89055b1fe).filter(Boolean);
}
function $a34f9704f91c4ae9$export$4055ded9e78438ba(mfa) {
    if (!mfa) return [];
    return JSON.parse(mfa);
}
function $a34f9704f91c4ae9$export$343435e7c7c3ff0f(availableMfaSetupTypes) {
    return availableMfaSetupTypes.filter((authMfaType)=>authMfaType === 'EMAIL' || authMfaType === 'TOTP');
}
async function $a34f9704f91c4ae9$export$8061cd07f982ef08() {
    let authUser;
    try {
        authUser = await (0, $52783992aa7f744e$export$e5432d4c8eb97ea7)();
    } catch (error) {}
    if (authUser && authUser.userId && authUser.username) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: (0, $6c49017af88bac4c$export$bdd0e7e9babcd5c8),
        message: 'There is already a signed in user.',
        recoverySuggestion: 'Call signOut before calling signIn again.'
    });
}
function $a34f9704f91c4ae9$export$cc3585de146a51be(username) {
    const state = (0, $fd57acfd3d6695db$export$390d5da4c63a4a41).getState();
    return state.username ?? username;
}
async function $a34f9704f91c4ae9$export$1ec196d12cb921db({ challengeName: challengeName, challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, config: config, tokenOrchestrator: tokenOrchestrator }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const challengeResponses = {
        USERNAME: username
    };
    if (challengeName === 'EMAIL_OTP') challengeResponses.EMAIL_OTP_CODE = challengeResponse;
    if (challengeName === 'SMS_MFA') challengeResponses.SMS_MFA_CODE = challengeResponse;
    if (challengeName === 'SMS_OTP') challengeResponses.SMS_OTP_CODE = challengeResponse;
    if (challengeName === 'SOFTWARE_TOKEN_MFA') challengeResponses.SOFTWARE_TOKEN_MFA_CODE = challengeResponse;
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const userContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: challengeName,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: userContextData
    };
    const respondToAuthChallenge = (0, $8f35e4984ef6e471$export$11329f5ae466ab5d)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
    if (response.ChallengeName === 'DEVICE_SRP_AUTH') return (0, $23a20e919e040981$export$18ec6b77c0b7fafe)({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Continues or completes the sign in process when required by the initial call to `signIn`.
 *
 * @param input -  The ConfirmSignInInput object
 * @returns ConfirmSignInOutput
 * @throws  -{@link VerifySoftwareTokenException }:
 * Thrown due to an invalid MFA token.
 * @throws  -{@link RespondToAuthChallengeException }:
 * Thrown due to an invalid auth challenge response.
 * @throws  -{@link AssociateSoftwareTokenException}:
 * Thrown due to a service error during the MFA setup process.
 * @throws  -{@link AuthValidationErrorCode }:
 * Thrown when `challengeResponse` is not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $311c1ce5abcae932$export$a477d84c2f7b792a(input) {
    const { challengeResponse: challengeResponse, options: options } = input;
    const { username: username, challengeName: challengeName, signInSession: signInSession, signInDetails: signInDetails } = (0, $fd57acfd3d6695db$export$390d5da4c63a4a41).getState();
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const clientMetaData = options?.clientMetadata;
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!challengeResponse, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyChallengeResponse);
    if (!username || !challengeName || !signInSession) // TODO: remove this error message for production apps
    throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: (0, $8d93f22263ae8b19$export$473ab0b56598aacd).SignInException,
        message: `
			An error occurred during the sign in process.

			This most likely occurred due to:
			1. signIn was not called before confirmSignIn.
			2. signIn threw an exception.
			3. page was refreshed during the sign in flow and session has expired.
			`,
        recoverySuggestion: "Make sure a successful call to signIn is made before calling confirmSignInand that the session has not expired."
    });
    try {
        const { Session: Session, ChallengeName: handledChallengeName, AuthenticationResult: AuthenticationResult, ChallengeParameters: handledChallengeParameters } = await (0, $a34f9704f91c4ae9$export$cfd8b50d0f78e4fa)(username, challengeName, signInSession, challengeResponse, authConfig, (0, $3c6129946b01fbcd$export$66561e66d62991d0), clientMetaData, options);
        // sets up local state used during the sign-in process
        (0, $fd57acfd3d6695db$export$bae72361b690e075)({
            signInSession: Session,
            username: username,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $91b271eeb38cc677$export$729df6fdd19b8b0d)({
                username: username,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $e205307ce629ac6f$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $fd57acfd3d6695db$export$ddfd5a0262ce9df3)();
            await (0, $e29e37b04a825a54$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: 'DONE'
                }
            };
        }
        return (0, $a34f9704f91c4ae9$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $d7152ac0bbeb6a00$export$5b3890f50cd4853f)(error);
        const result = (0, $a34f9704f91c4ae9$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}





















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $19eab82d2cb12f2c$export$f182f73f82c5c23a = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('ConfirmSignUp'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $23695c9c141a4f1e$var$defaultState() {
    return {
        active: false
    };
}
const $23695c9c141a4f1e$var$autoSignInReducer = (state, action)=>{
    switch(action.type){
        case 'SET_USERNAME':
            return {
                ...state,
                username: action.value
            };
        case 'SET_SESSION':
            return {
                ...state,
                session: action.value
            };
        case 'START':
            return {
                ...state,
                active: true
            };
        case 'RESET':
            return $23695c9c141a4f1e$var$defaultState();
        default:
            return state;
    }
};
const $23695c9c141a4f1e$var$createAutoSignInStore = (reducer)=>{
    let currentState = reducer($23695c9c141a4f1e$var$defaultState(), {
        type: 'RESET'
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const $23695c9c141a4f1e$export$ef87a9980a3566ca = $23695c9c141a4f1e$var$createAutoSignInStore($23695c9c141a4f1e$var$autoSignInReducer);







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3eebb98ac5401111$var$initialAutoSignIn = async ()=>{
    throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: (0, $6c49017af88bac4c$export$fe46a12932d2550a),
        message: 'The autoSignIn flow has not started, or has been cancelled/completed.',
        recoverySuggestion: 'Please try to use the signIn API or log out before starting a new autoSignIn flow.'
    });
};
/**
 * Signs a user in automatically after finishing the sign-up process.
 *
 * This API will automatically sign a user in if the autoSignIn flow has been completed in the following cases:
 * - User confirmed their account with a verification code sent to their phone or email (default option).
 * - User confirmed their account with a verification link sent to their phone or email. In order to
 * enable this option you need to go to the Amazon Cognito [console](https://aws.amazon.com/pm/cognito),
 * look for your userpool, then go to the `Messaging` tab and enable `link` mode inside the `Verification message` option.
 * Finally you need to define the `signUpVerificationMethod` in your `Auth` config.
 *
 * @example
 * ```typescript
 *  Amplify.configure({
 *    Auth: {
 *     Cognito: {
 *    ...cognitoConfig,
 *    signUpVerificationMethod: "link" // the default value is "code"
 *   }
 *	}});
 * ```
 *
 * @throws AutoSignInException - Thrown when the autoSignIn flow has not started, or has been cancelled/completed.
 * @returns The signInOutput.
 *
 * @example
 * ```typescript
 *  // handleSignUp.ts
 * async function handleSignUp(
 *   username:string,
 *   password:string
 * ){
 *   try {
 *     const { nextStep } = await signUp({
 *       username,
 *       password,
 *       options: {
 *         userAttributes:{ email:'email@email.com'},
 *         autoSignIn: true // This enables the auto sign-in flow.
 *       },
 *     });
 *
 *     handleSignUpStep(nextStep);
 *
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // handleConfirmSignUp.ts
 * async function handleConfirmSignUp(username:string, confirmationCode:string) {
 *   try {
 *     const { nextStep } = await confirmSignUp({
 *       username,
 *       confirmationCode,
 *     });
 *
 *     handleSignUpStep(nextStep);
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // signUpUtils.ts
 * async function handleSignUpStep( step: SignUpOutput["nextStep"]) {
 * switch (step.signUpStep) {
 *   case "CONFIRM_SIGN_UP":
 *
 *    // Redirect end-user to confirm-sign up screen.
 *
 *   case "COMPLETE_AUTO_SIGN_IN":
 *	   const codeDeliveryDetails = step.codeDeliveryDetails;
 *     if (codeDeliveryDetails) {
 *      // Redirect user to confirm-sign-up with link screen.
 *     }
 *     const signInOutput = await autoSignIn();
 *   // handle sign-in steps
 * }
 *
 * ```
 */ // TODO(Eslint): can this be refactored not using `let` on exported member?
// eslint-disable-next-line import/no-mutable-exports
let $3eebb98ac5401111$export$c5378dc7d6787fa5 = $3eebb98ac5401111$var$initialAutoSignIn;
/**
 * Sets the context of autoSignIn at run time.
 * @internal
 */ function $3eebb98ac5401111$export$7dcbf67a23c27835(callback) {
    $3eebb98ac5401111$export$c5378dc7d6787fa5 = callback;
}
/**
 * Resets the context
 *
 * @internal
 */ function $3eebb98ac5401111$export$1ffa2742ce5c589b(resetCallback = true) {
    if (resetCallback) $3eebb98ac5401111$export$c5378dc7d6787fa5 = $3eebb98ac5401111$var$initialAutoSignIn;
    (0, $23695c9c141a4f1e$export$ef87a9980a3566ca).dispatch({
        type: 'RESET'
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a new user account.
 *
 * @param input -  The ConfirmSignUpInput object.
 * @returns ConfirmSignUpOutput
 * @throws -{@link ConfirmSignUpException }
 * Thrown due to an invalid confirmation code.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $d48b31097d200b93$export$2ce39ab6662e8c24(input) {
    const { username: username, confirmationCode: confirmationCode, options: options } = input;
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = authConfig;
    const clientMetadata = options?.clientMetadata;
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!username, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername);
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!confirmationCode, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyConfirmSignUpCode);
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const confirmSignUpClient = (0, $19eab82d2cb12f2c$export$f182f73f82c5c23a)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { Session: session } = await confirmSignUpClient({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(authConfig.userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignUp)
    }, {
        Username: username,
        ConfirmationCode: confirmationCode,
        ClientMetadata: clientMetadata,
        ForceAliasCreation: options?.forceAliasCreation,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    return new Promise((resolve, reject)=>{
        try {
            const signUpOut = {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: 'DONE'
                }
            };
            const autoSignInStoreState = (0, $23695c9c141a4f1e$export$ef87a9980a3566ca).getState();
            if (!autoSignInStoreState.active || autoSignInStoreState.username !== username) {
                resolve(signUpOut);
                (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)();
                return;
            }
            (0, $23695c9c141a4f1e$export$ef87a9980a3566ca).dispatch({
                type: 'SET_SESSION',
                value: session
            });
            const stopListener = (0, $7c7b61d0858d9585$export$45dde0743a4c8d6e).listen('auth-internal', ({ payload: payload })=>{
                switch(payload.event){
                    case 'autoSignIn':
                        resolve({
                            isSignUpComplete: true,
                            nextStep: {
                                signUpStep: 'COMPLETE_AUTO_SIGN_IN'
                            }
                        });
                        stopListener();
                }
            });
            (0, $7c7b61d0858d9585$export$45dde0743a4c8d6e).dispatch('auth-internal', {
                event: 'confirmSignUp',
                data: signUpOut
            });
        } catch (error) {
            reject(error);
        }
    });
}





















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ab9c983472b7ec3d$export$cf53d1782ddbc93c = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('ResendConfirmationCode'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resend the confirmation code while signing up
 *
 * @param input -  The ResendSignUpCodeInput object
 * @returns ResendSignUpCodeOutput
 * @throws service: {@link ResendConfirmationException } - Cognito service errors thrown when resending the code.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $03d9406d995f2690$export$b295e842f1d42d13(input) {
    const { username: username } = input;
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!username, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignUpUsername);
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint } = authConfig;
    const clientMetadata = input.options?.clientMetadata;
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const resendConfirmationCode = (0, $ab9c983472b7ec3d$export$cf53d1782ddbc93c)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { CodeDeliveryDetails: CodeDeliveryDetails } = await resendConfirmationCode({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(authConfig.userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ResendSignUpCode)
    }, {
        Username: username,
        ClientMetadata: clientMetadata,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    const { DeliveryMedium: DeliveryMedium, AttributeName: AttributeName, Destination: Destination } = {
        ...CodeDeliveryDetails
    };
    return {
        destination: Destination,
        deliveryMedium: DeliveryMedium,
        attributeName: AttributeName ? AttributeName : undefined
    };
}





















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d8906c7407e96e11$export$f8a72614a2df8d41 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('ForgotPassword'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resets a user's password.
 *
 * @param input -  The ResetPasswordInput object.
 * @returns ResetPasswordOutput
 * @throws -{@link ForgotPasswordException }
 * Thrown due to an invalid confirmation code or password.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty username.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 **/ async function $478d4cfb377600b8$export$dc726c8e334dd814(input) {
    const { username: username } = input;
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!username, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyResetPasswordUsername);
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint } = authConfig;
    const clientMetadata = input.options?.clientMetadata;
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const forgotPassword = (0, $d8906c7407e96e11$export$f8a72614a2df8d41)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const res = await forgotPassword({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ResetPassword)
    }, {
        Username: username,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    });
    const codeDeliveryDetails = res.CodeDeliveryDetails;
    return {
        isPasswordReset: false,
        nextStep: {
            resetPasswordStep: 'CONFIRM_RESET_PASSWORD_WITH_CODE',
            codeDeliveryDetails: {
                deliveryMedium: codeDeliveryDetails?.DeliveryMedium,
                destination: codeDeliveryDetails?.Destination,
                attributeName: codeDeliveryDetails?.AttributeName
            }
        }
    };
}

















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow without password
 *
 * @param input -  The SignInWithCustomAuthInput object
 * @returns AuthSignInResult
 * @throws service: {@link InitiateAuthException } - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws SignInWithCustomAuthOutput - Thrown when the token provider config is invalid.
 */ async function $cb5b40ca391bdd6a$export$7f948971bcf643ff(input) {
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const { username: username, password: password, options: options } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: 'CUSTOM_WITHOUT_SRP'
    };
    const metadata = options?.clientMetadata;
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!username, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!password, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).CustomAuthSignInPassword);
    try {
        const { ChallengeName: retriedChallengeName, ChallengeParameters: retiredChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $da73af6c4a37b7ee$export$30f932fe98713ccc)((0, $a34f9704f91c4ae9$export$1a654dcab55e0de5), [
            username,
            metadata,
            authConfig,
            (0, $3c6129946b01fbcd$export$66561e66d62991d0)
        ], username, (0, $3c6129946b01fbcd$export$66561e66d62991d0));
        const activeUsername = (0, $a34f9704f91c4ae9$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $fd57acfd3d6695db$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retriedChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $91b271eeb38cc677$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $e205307ce629ac6f$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $fd57acfd3d6695db$export$ddfd5a0262ce9df3)();
            await (0, $e29e37b04a825a54$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: 'DONE'
                }
            };
        }
        return (0, $a34f9704f91c4ae9$export$cf152400b58b8e65)({
            challengeName: retriedChallengeName,
            challengeParameters: retiredChallengeParameters
        });
    } catch (error) {
        (0, $fd57acfd3d6695db$export$ddfd5a0262ce9df3)();
        (0, $d7152ac0bbeb6a00$export$5b3890f50cd4853f)(error);
        const result = (0, $a34f9704f91c4ae9$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow with SRP
 *
 * @param input -  The SignInWithCustomSRPAuthInput object
 * @returns SignInWithCustomSRPAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito
 * service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $95e25e4035ba2095$export$2c0317ed1bbb0787(input) {
    const { username: username, password: password, options: options } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: 'CUSTOM_WITH_SRP'
    };
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!username, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!password, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName, ChallengeParameters: handledChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $a34f9704f91c4ae9$export$9ce9dd351616104c)(username, password, metadata, authConfig, (0, $3c6129946b01fbcd$export$66561e66d62991d0));
        const activeUsername = (0, $a34f9704f91c4ae9$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $fd57acfd3d6695db$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $91b271eeb38cc677$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $e205307ce629ac6f$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $fd57acfd3d6695db$export$ddfd5a0262ce9df3)();
            await (0, $e29e37b04a825a54$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: 'DONE'
                }
            };
        }
        return (0, $a34f9704f91c4ae9$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $fd57acfd3d6695db$export$ddfd5a0262ce9df3)();
        (0, $d7152ac0bbeb6a00$export$5b3890f50cd4853f)(error);
        const result = (0, $a34f9704f91c4ae9$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}

















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input - The SignInWithSRPInput object
 * @returns SignInWithSRPOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $eb1e2186f8d8fa6d$export$728178cf826a5ab9(input) {
    const { username: username, password: password } = input;
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: 'USER_SRP_AUTH'
    };
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const clientMetaData = input.options?.clientMetadata;
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!username, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!password, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName, ChallengeParameters: handledChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $a34f9704f91c4ae9$export$13a3ef5ef8cac338)(username, password, clientMetaData, authConfig, (0, $3c6129946b01fbcd$export$66561e66d62991d0));
        const activeUsername = (0, $a34f9704f91c4ae9$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $fd57acfd3d6695db$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $91b271eeb38cc677$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $e205307ce629ac6f$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $fd57acfd3d6695db$export$ddfd5a0262ce9df3)();
            await (0, $e29e37b04a825a54$export$4d78d2ee899572ab)();
            (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: 'DONE'
                }
            };
        }
        return (0, $a34f9704f91c4ae9$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $fd57acfd3d6695db$export$ddfd5a0262ce9df3)();
        (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)();
        (0, $d7152ac0bbeb6a00$export$5b3890f50cd4853f)(error);
        const result = (0, $a34f9704f91c4ae9$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}


















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using USER_PASSWORD_AUTH AuthFlowType
 *
 * @param input - The SignInWithUserPasswordInput object
 * @returns SignInWithUserPasswordOutput
 * @throws service: {@link InitiateAuthException } - Cognito service error thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $393816b6625b1951$export$200af5a623414b2b(input) {
    const { username: username, password: password, options: options } = input;
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: 'USER_PASSWORD_AUTH'
    };
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!username, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!password, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: retiredChallengeName, ChallengeParameters: retriedChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $da73af6c4a37b7ee$export$30f932fe98713ccc)((0, $a34f9704f91c4ae9$export$29fb48d356e16a7), [
            username,
            password,
            metadata,
            authConfig,
            (0, $3c6129946b01fbcd$export$66561e66d62991d0)
        ], username, (0, $3c6129946b01fbcd$export$66561e66d62991d0));
        const activeUsername = (0, $a34f9704f91c4ae9$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $fd57acfd3d6695db$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retiredChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $91b271eeb38cc677$export$729df6fdd19b8b0d)({
                ...AuthenticationResult,
                username: activeUsername,
                NewDeviceMetadata: await (0, $e205307ce629ac6f$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $fd57acfd3d6695db$export$ddfd5a0262ce9df3)();
            await (0, $e29e37b04a825a54$export$4d78d2ee899572ab)();
            (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: 'DONE'
                }
            };
        }
        return (0, $a34f9704f91c4ae9$export$cf152400b58b8e65)({
            challengeName: retiredChallengeName,
            challengeParameters: retriedChallengeParameters
        });
    } catch (error) {
        (0, $fd57acfd3d6695db$export$ddfd5a0262ce9df3)();
        (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)();
        (0, $d7152ac0bbeb6a00$export$5b3890f50cd4853f)(error);
        const result = (0, $a34f9704f91c4ae9$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}

































// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles user authentication flow with configurable challenge preferences.
 * Supports AuthFactorType challenges through the USER_AUTH flow.
 *
 * @param {HandleUserAuthFlowInput} params - Authentication flow parameters
 * @param {string} params.username - The username for authentication
 * @param {Record<string, string>} [params.clientMetadata] - Optional metadata to pass to authentication service
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {AuthTokenOrchestrator} params.tokenOrchestrator - Manages authentication tokens and device tracking
 * @param {AuthFactorType} [params.preferredChallenge] - Optional preferred authentication method
 * @param {string} [params.password] - Required when preferredChallenge is 'PASSWORD' or 'PASSWORD_SRP'
 *
 * @returns {Promise<InitiateAuthCommandOutput>} The authentication response from Cognito
 */ async function $ee04fdefeac2a77c$export$f21455679019a68e({ username: username, clientMetadata: clientMetadata, config: config, tokenOrchestrator: tokenOrchestrator, preferredChallenge: preferredChallenge, password: password, session: session }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const UserContextData = (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const authParameters = {
        USERNAME: username
    };
    if (preferredChallenge) {
        // Validate that the preferred challenge is enabled in the backend config
        // Only validate if passwordless config exists (for backward compatibility)
        if (config.passwordless) {
            const isInvalidChallenge = preferredChallenge === 'EMAIL_OTP' && !config.passwordless.emailOtpEnabled || preferredChallenge === 'SMS_OTP' && !config.passwordless.smsOtpEnabled || preferredChallenge === 'WEB_AUTHN' && !config.passwordless.webAuthn;
            if (isInvalidChallenge) (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(false, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).InvalidPreferredChallenge);
        }
        if (preferredChallenge === 'PASSWORD_SRP') {
            (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!password, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignInPassword);
            return (0, $1c0a8a512bbf0c35$export$169bd15774e46c56)({
                username: username,
                password: password,
                clientMetadata: clientMetadata,
                config: config,
                tokenOrchestrator: tokenOrchestrator,
                authFlow: 'USER_AUTH',
                preferredChallenge: preferredChallenge
            });
        }
        if (preferredChallenge === 'PASSWORD') {
            (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!password, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignInPassword);
            authParameters.PASSWORD = password;
        }
        authParameters.PREFERRED_CHALLENGE = preferredChallenge;
    }
    const jsonReq = {
        AuthFlow: 'USER_AUTH',
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    if (session) jsonReq.Session = session;
    const initiateAuth = (0, $d16d4d8349af273b$export$91f349d78bea7765)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    // Set the active username immediately after successful authentication attempt
    // If a user starts a new sign-in while another sign-in is incomplete,
    // this ensures we're tracking the correct user for subsequent auth challenges.
    (0, $dd2813b104f41b95$export$fecfbc200868d412)(username);
    return response;
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in through a registered email or phone number without a password by by receiving and entering an OTP.
 *
 * @param input - The SignInWithUserAuthInput object
 * @returns SignInWithUserAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password -- needs to change
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $576df20512bdd287$export$fcfa00cf0f5ec937(input) {
    const { username: username, password: password, options: options } = input;
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: 'USER_AUTH'
    };
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const clientMetaData = options?.clientMetadata;
    const preferredChallenge = options?.preferredChallenge ?? authConfig?.passwordless?.preferredChallenge;
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!username, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignInUsername);
    try {
        const handleUserAuthFlowInput = {
            username: username,
            config: authConfig,
            tokenOrchestrator: $3c6129946b01fbcd$export$66561e66d62991d0,
            clientMetadata: clientMetaData,
            preferredChallenge: preferredChallenge,
            password: password
        };
        const autoSignInStoreState = (0, $23695c9c141a4f1e$export$ef87a9980a3566ca).getState();
        if (autoSignInStoreState.active && autoSignInStoreState.username === username) handleUserAuthFlowInput.session = autoSignInStoreState.session;
        const response = await (0, $ee04fdefeac2a77c$export$f21455679019a68e)(handleUserAuthFlowInput);
        const activeUsername = (0, $a34f9704f91c4ae9$export$cc3585de146a51be)(username);
        (0, $fd57acfd3d6695db$export$bae72361b690e075)({
            signInSession: response.Session,
            username: activeUsername,
            challengeName: response.ChallengeName,
            signInDetails: signInDetails
        });
        if (response.AuthenticationResult) {
            await (0, $91b271eeb38cc677$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...response.AuthenticationResult,
                NewDeviceMetadata: await (0, $e205307ce629ac6f$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: response.AuthenticationResult.NewDeviceMetadata,
                    accessToken: response.AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            });
            (0, $fd57acfd3d6695db$export$ddfd5a0262ce9df3)();
            await (0, $e29e37b04a825a54$export$4d78d2ee899572ab)();
            (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: 'DONE'
                }
            };
        }
        return (0, $a34f9704f91c4ae9$export$cf152400b58b8e65)({
            challengeName: response.ChallengeName,
            challengeParameters: response.ChallengeParameters,
            availableChallenges: 'AvailableChallenges' in response ? response.AvailableChallenges : undefined
        });
    } catch (error) {
        (0, $fd57acfd3d6695db$export$ddfd5a0262ce9df3)();
        (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)();
        (0, $d7152ac0bbeb6a00$export$5b3890f50cd4853f)(error);
        const result = (0, $a34f9704f91c4ae9$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input -  The SignInInput object
 * @returns SignInOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException }
 *  - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $7e871d6ead052ab2$export$9670d83f11d4b64a(input) {
    // Here we want to reset the store but not reassign the callback.
    // The callback is reset when the underlying promise resolves or rejects.
    // With the advent of session based sign in, this guarantees that the signIn API initiates a new auth flow,
    // regardless of whether it is called for a user currently engaged in an active auto sign in session.
    (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)(false);
    const authFlowType = input.options?.authFlowType;
    await (0, $a34f9704f91c4ae9$export$8061cd07f982ef08)();
    switch(authFlowType){
        case 'USER_SRP_AUTH':
            return (0, $eb1e2186f8d8fa6d$export$728178cf826a5ab9)(input);
        case 'USER_PASSWORD_AUTH':
            return (0, $393816b6625b1951$export$200af5a623414b2b)(input);
        case 'CUSTOM_WITHOUT_SRP':
            return (0, $cb5b40ca391bdd6a$export$7f948971bcf643ff)(input);
        case 'CUSTOM_WITH_SRP':
            return (0, $95e25e4035ba2095$export$2c0317ed1bbb0787)(input);
        case 'USER_AUTH':
            return (0, $576df20512bdd287$export$fcfa00cf0f5ec937)(input);
        default:
            return (0, $eb1e2186f8d8fa6d$export$728178cf826a5ab9)(input);
    }
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Transforms a user attributes object into an array of AttributeType objects.
 * @param attributes user attributes to be mapped to AttributeType objects.
 * @returns an array of AttributeType objects.
 */ function $074b27d937db39a8$export$720a7caa078a04b0(attributes) {
    return Object.entries(attributes).map(([key, value])=>({
            Name: key,
            Value: value
        }));
}
/**
 * Transforms an array of AttributeType objects into a user attributes object.
 *
 * @param attributes - an array of AttributeType objects.
 * @returns AuthUserAttributes object.
 */ function $074b27d937db39a8$export$1b975641d03f3b17(attributes) {
    const userAttributes = {};
    attributes?.forEach((attribute)=>{
        if (attribute.Name) userAttributes[attribute.Name] = attribute.Value;
    });
    return userAttributes;
}








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $63f1fded447314c7$var$MAX_AUTOSIGNIN_POLLING_MS = 180000;
function $63f1fded447314c7$export$385d6b43f72ecccf(signInInput) {
    const stopHubListener = (0, $7c7b61d0858d9585$export$45dde0743a4c8d6e).listen('auth-internal', async ({ payload: payload })=>{
        switch(payload.event){
            case 'confirmSignUp':
                {
                    const response = payload.data;
                    if (response?.isSignUpComplete) {
                        (0, $7c7b61d0858d9585$export$45dde0743a4c8d6e).dispatch('auth-internal', {
                            event: 'autoSignIn'
                        });
                        (0, $3eebb98ac5401111$export$7dcbf67a23c27835)($63f1fded447314c7$var$autoSignInWithCode(signInInput));
                        stopHubListener();
                    }
                }
        }
    });
    // This will stop the listener if confirmSignUp is not resolved.
    const timeOutId = setTimeout(()=>{
        stopHubListener();
        clearTimeout(timeOutId);
        (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)();
    }, $63f1fded447314c7$var$MAX_AUTOSIGNIN_POLLING_MS);
}
function $63f1fded447314c7$var$debounce(fun, delay) {
    let timer;
    return (args)=>{
        if (!timer) fun(...args);
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = undefined;
        }, delay);
    };
}
function $63f1fded447314c7$var$handleAutoSignInWithLink(signInInput, resolve, reject) {
    const start = Date.now();
    const autoSignInPollingIntervalId = setInterval(async ()=>{
        const elapsedTime = Date.now() - start;
        const maxTime = $63f1fded447314c7$var$MAX_AUTOSIGNIN_POLLING_MS;
        if (elapsedTime > maxTime) {
            clearInterval(autoSignInPollingIntervalId);
            reject(new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
                name: (0, $6c49017af88bac4c$export$fe46a12932d2550a),
                message: 'The account was not confirmed on time.',
                recoverySuggestion: 'Try to verify your account by clicking the link sent your email or phone and then login manually.'
            }));
            (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)();
        } else try {
            const signInOutput = await (0, $7e871d6ead052ab2$export$9670d83f11d4b64a)(signInInput);
            if (signInOutput.nextStep.signInStep !== 'CONFIRM_SIGN_UP') {
                resolve(signInOutput);
                clearInterval(autoSignInPollingIntervalId);
                (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)();
            }
        } catch (error) {
            clearInterval(autoSignInPollingIntervalId);
            reject(error);
            (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)();
        }
    }, 5000);
}
const $63f1fded447314c7$var$debouncedAutoSignInWithLink = $63f1fded447314c7$var$debounce($63f1fded447314c7$var$handleAutoSignInWithLink, 300);
const $63f1fded447314c7$var$debouncedAutoSignWithCodeOrUserConfirmed = $63f1fded447314c7$var$debounce($63f1fded447314c7$var$handleAutoSignInWithCodeOrUserConfirmed, 300);
function $63f1fded447314c7$export$feaed4858b71e8a(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            $63f1fded447314c7$var$debouncedAutoSignInWithLink([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
async function $63f1fded447314c7$var$handleAutoSignInWithCodeOrUserConfirmed(signInInput, resolve, reject) {
    try {
        const output = signInInput?.options?.authFlowType === 'USER_AUTH' ? await (0, $576df20512bdd287$export$fcfa00cf0f5ec937)(signInInput) : await (0, $7e871d6ead052ab2$export$9670d83f11d4b64a)(signInInput);
        resolve(output);
        (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)();
    } catch (error) {
        reject(error);
        (0, $3eebb98ac5401111$export$1ffa2742ce5c589b)();
    }
}
function $63f1fded447314c7$var$autoSignInWithCode(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            $63f1fded447314c7$var$debouncedAutoSignWithCodeOrUserConfirmed([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
const $63f1fded447314c7$export$9ec2c3d010185172 = $63f1fded447314c7$var$autoSignInWithCode;


















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $373ad7b05ee6c010$export$f9d992c2ce90154a = ()=>async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $5267ac398181f2f6$export$be467dfcc0538e25)(response);
            (0, $d7152ac0bbeb6a00$export$5b3890f50cd4853f)(error);
            if (// Missing Password Error
            // 1 validation error detected: Value at 'password'failed to satisfy constraint: Member must not be null
            error.name === (0, $9dae3ebf1d7aa1cb$export$d0816902ed99fce6).InvalidParameterException && /'password'/.test(error.message) && /Member must not be null/.test(error.message)) {
                const name = (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignUpPassword;
                const { message: message, recoverySuggestion: recoverySuggestion } = (0, $8d93f22263ae8b19$export$195137955146d376)[name];
                throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
                    name: name,
                    message: message,
                    recoverySuggestion: recoverySuggestion
                });
            }
            throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        }
        return (0, $5267ac398181f2f6$export$759bcb35b0d1bf81)(response);
    };
const $373ad7b05ee6c010$export$99fa98564ba4db04 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('SignUp'), $373ad7b05ee6c010$export$f9d992c2ce90154a(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Creates a user
 *
 * @param input - The SignUpInput object
 * @returns SignUpOutput
 * @throws service: {@link SignUpException } - Cognito service errors thrown during the sign-up process.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $969bd7469327c15a$export$cf64224bcd829024(input) {
    const { username: username, password: password, options: options } = input;
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signUpVerificationMethod = authConfig?.signUpVerificationMethod ?? 'code';
    const { clientMetadata: clientMetadata, validationData: validationData, autoSignIn: autoSignIn } = input.options ?? {};
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!username, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptySignUpUsername);
    const signInServiceOptions = typeof autoSignIn !== 'boolean' ? autoSignIn : undefined;
    const signInInput = {
        username: username,
        options: signInServiceOptions
    };
    // if the authFlowType is 'CUSTOM_WITHOUT_SRP' then we don't include the password
    if (signInServiceOptions?.authFlowType !== 'CUSTOM_WITHOUT_SRP') signInInput.password = password;
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = authConfig;
    const signUpClient = (0, $373ad7b05ee6c010$export$99fa98564ba4db04)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const signUpClientInput = {
        Username: username,
        Password: undefined,
        UserAttributes: options?.userAttributes && (0, $074b27d937db39a8$export$720a7caa078a04b0)(options?.userAttributes),
        ClientMetadata: clientMetadata,
        ValidationData: validationData && (0, $074b27d937db39a8$export$720a7caa078a04b0)(validationData),
        ClientId: userPoolClientId,
        UserContextData: (0, $69dcd6b2db6e872f$export$b6e6cdd1f90faa62)({
            username: username,
            userPoolId: userPoolId,
            userPoolClientId: userPoolClientId
        })
    };
    if (password) signUpClientInput.Password = password;
    const { UserSub: userId, CodeDeliveryDetails: cdd, UserConfirmed: userConfirmed, Session: session } = await signUpClient({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignUp)
    }, signUpClientInput);
    if (signInServiceOptions || autoSignIn === true) {
        (0, $23695c9c141a4f1e$export$ef87a9980a3566ca).dispatch({
            type: 'START'
        });
        (0, $23695c9c141a4f1e$export$ef87a9980a3566ca).dispatch({
            type: 'SET_USERNAME',
            value: username
        });
        (0, $23695c9c141a4f1e$export$ef87a9980a3566ca).dispatch({
            type: 'SET_SESSION',
            value: session
        });
    }
    const codeDeliveryDetails = {
        destination: cdd?.Destination,
        deliveryMedium: cdd?.DeliveryMedium,
        attributeName: cdd?.AttributeName
    };
    const isSignUpComplete = !!userConfirmed;
    const isAutoSignInStarted = (0, $23695c9c141a4f1e$export$ef87a9980a3566ca).getState().active;
    // Sign Up Complete
    // No Confirm Sign In Step Required
    if (isSignUpComplete) {
        if (isAutoSignInStarted) {
            (0, $3eebb98ac5401111$export$7dcbf67a23c27835)((0, $63f1fded447314c7$export$9ec2c3d010185172)(signInInput));
            return {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: 'COMPLETE_AUTO_SIGN_IN'
                },
                userId: userId
            };
        }
        return {
            isSignUpComplete: true,
            nextStep: {
                signUpStep: 'DONE'
            },
            userId: userId
        };
    }
    // Sign Up Not Complete
    // Confirm Sign Up Step Required
    if (isAutoSignInStarted) {
        // Confirmation Via Link Occurs In Separate Context
        // AutoSignIn Fn Will Initiate Polling Once Executed
        if (signUpVerificationMethod === 'link') {
            (0, $3eebb98ac5401111$export$7dcbf67a23c27835)((0, $63f1fded447314c7$export$feaed4858b71e8a)(signInInput));
            return {
                isSignUpComplete: false,
                nextStep: {
                    signUpStep: 'COMPLETE_AUTO_SIGN_IN',
                    codeDeliveryDetails: codeDeliveryDetails
                },
                userId: userId
            };
        }
        // Confirmation Via Code Occurs In Same Context
        // AutoSignIn Next Step Will Be Returned From Confirm Sign Up
        (0, $63f1fded447314c7$export$385d6b43f72ecccf)(signInInput);
    }
    return {
        isSignUpComplete: false,
        nextStep: {
            signUpStep: 'CONFIRM_SIGN_UP',
            codeDeliveryDetails: codeDeliveryDetails
        },
        userId: userId
    };
}









// Cognito does not allow a password length less then 8 characters
const $74c4c42c59a292e1$var$DEFAULT_COGNITO_PASSWORD_MIN_LENGTH = 8;
const $74c4c42c59a292e1$var$isInvalidUserAtributes = (userAttributes)=>Array.isArray(userAttributes);
const $74c4c42c59a292e1$var$parseUserAttributes = (userAttributes)=>{
    if (!userAttributes) return undefined;
    // `aws-amplify` versions <= 6.0.5 return an array of `userAttributes` rather than an object
    if ($74c4c42c59a292e1$var$isInvalidUserAtributes(userAttributes)) return Object.entries(userAttributes).map(([_, value])=>Object.keys(value)[0]);
    return Object.keys(userAttributes);
};
const $74c4c42c59a292e1$export$7ae2d201ca9520b = {
    async getAmplifyConfig () {
        const result = (0, $c429b4341d882bd4$export$11ac3725994bec7b).getConfig();
        const cliConfig = result.Auth?.Cognito;
        const { loginWith: loginWith, userAttributes: userAttributes } = result.Auth?.Cognito ?? {};
        const parsedLoginMechanisms = loginWith ? Object.entries(loginWith).filter(([key, _value])=>key !== 'oauth').filter(([_key, value])=>!!value).map((keyValueArray)=>{
            return keyValueArray[0] === 'phone' // the key for phone_number is phone in getConfig but everywhere else we treat is as phone_number
             ? 'phone_number' : keyValueArray[0];
        }) : undefined;
        const parsedSignupAttributes = $74c4c42c59a292e1$var$parseUserAttributes(userAttributes);
        const parsedSocialProviders = loginWith?.oauth?.providers ? loginWith.oauth.providers?.map((provider)=>provider.toString().toLowerCase()) : undefined;
        // Detect passwordless capabilities from amplify_outputs.json
        // Support both snake_case (legacy) and camelCase (current) formats
        const passwordlessConfig = result.Auth?.Cognito?.passwordless;
        const passwordlessCapabilities = {
            emailOtpEnabled: passwordlessConfig?.emailOtpEnabled ?? passwordlessConfig?.email_otp_enabled === true,
            smsOtpEnabled: passwordlessConfig?.smsOtpEnabled ?? passwordlessConfig?.sms_otp_enabled === true,
            webAuthnEnabled: !!(passwordlessConfig?.webAuthn ?? passwordlessConfig?.web_authn),
            preferredChallenge: passwordlessConfig?.preferredChallenge ?? passwordlessConfig?.preferred_challenge
        };
        return {
            ...cliConfig,
            loginMechanisms: parsedLoginMechanisms,
            signUpAttributes: parsedSignupAttributes,
            socialProviders: parsedSocialProviders,
            passwordlessCapabilities: passwordlessCapabilities
        };
    },
    getCurrentUser: $52783992aa7f744e$export$e5432d4c8eb97ea7,
    handleSignIn: (0, $7e871d6ead052ab2$export$9670d83f11d4b64a),
    handleSignUp: (0, $969bd7469327c15a$export$cf64224bcd829024),
    handleConfirmSignIn: (0, $311c1ce5abcae932$export$a477d84c2f7b792a),
    handleConfirmSignUp: (0, $d48b31097d200b93$export$2ce39ab6662e8c24),
    handleForgotPasswordSubmit: (0, $beebe0ff828f8cfe$export$890261705c8ce36b),
    handleForgotPassword: (0, $478d4cfb377600b8$export$dc726c8e334dd814),
    handleResendSignUpCode: (0, $03d9406d995f2690$export$b295e842f1d42d13),
    // Validation hooks for overriding
    async validateCustomSignUp (_, __) {},
    async validateFormPassword (formData, touchData, passwordSettings) {
        const { password: password } = formData;
        const { password: touched_password } = touchData;
        /**
         * If the password is not touched,
         * or if the password settings are not set, we don't need to validate it.
         */ if (!touched_password || !passwordSettings) return null;
        const password_complexity = [];
        const policyMinLength = passwordSettings.minLength ?? $74c4c42c59a292e1$var$DEFAULT_COGNITO_PASSWORD_MIN_LENGTH;
        if (password.length < policyMinLength) password_complexity.push(`Password must have at least ${policyMinLength} characters`);
        if (passwordSettings.requireLowercase && !/[a-z]/.test(password)) password_complexity.push('Password must have lower case letters');
        if (passwordSettings.requireUppercase && !/[A-Z]/.test(password)) password_complexity.push('Password must have upper case letters');
        if (passwordSettings.requireNumbers && !/[0-9]/.test(password)) password_complexity.push('Password must have numbers');
        // https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
        if (passwordSettings.requireSpecialCharacters && !(0, $ff807ec90f5c0ad3$export$1ec93875315f071d)(password)) password_complexity.push('Password must have special characters');
        /**
         * Only return an error if there is at least one error.
         */ return password_complexity.length !== 0 ? {
            password: password_complexity
        } : null;
    },
    async validateConfirmPassword (formData, touchData) {
        const { password: password, confirm_password: confirm_password } = formData;
        const { confirm_password: touched_confirm_password, password: touched_password } = touchData;
        if (!password && !confirm_password) // these inputs are clean, don't complain yet
        return null;
        else if ((password || confirm_password) && password !== confirm_password && (touched_confirm_password && touched_password || password?.length >= 6 && confirm_password?.length >= 6)) // Only return an error if both fields have text entered,
        // the passwords do not match, and the fields have been
        // touched or the password and confirm password is longer then or equal to 6.
        return {
            confirm_password: 'Your passwords must match'
        };
    },
    async validatePreferredUsername (_, __) {},
    async validateRequiredFieldsForAuthMethod (formData) {
        const authMethod = formData.__authMethod;
        // If no auth method specified, skip validation (will use default required fields)
        if (!authMethod) return null;
        // Check required fields based on auth method
        if (authMethod === 'EMAIL_OTP' && !formData.email) return {
            email: 'Email is required for Email OTP sign up'
        };
        if (authMethod === 'SMS_OTP' && !formData.phone_number) return {
            phone_number: 'Phone number is required for SMS OTP sign up'
        };
        if (authMethod === 'PASSWORD') {
            const errors = {};
            if (!formData.password) errors.password = 'Password is required';
            if (!formData.confirm_password) errors.confirm_password = 'Confirm Password is required';
            return Object.keys(errors).length > 0 ? errors : null;
        }
        return null;
    }
};


function $385d2ee3594940bd$export$d384478d1c0083d2({ services: services }) {
    return (0, $15bb13904b1fd3cf$export$aaa7fa18f8e9b2e8)({
        id: 'forgotPasswordActor',
        initial: 'init',
        predictableActionArguments: true,
        states: {
            init: {
                always: [
                    {
                        cond: 'shouldResetPassword',
                        target: 'confirmResetPassword'
                    },
                    {
                        cond: 'shouldConfirmResetPassword',
                        target: 'confirmResetPassword'
                    },
                    {
                        target: 'forgotPassword'
                    }
                ]
            },
            forgotPassword: {
                initial: 'edit',
                entry: 'sendUpdate',
                exit: [
                    'clearError',
                    'clearTouched'
                ],
                states: {
                    edit: {
                        entry: 'sendUpdate',
                        on: {
                            SUBMIT: {
                                actions: 'handleSubmit',
                                target: 'submit'
                            },
                            CHANGE: {
                                actions: 'handleInput'
                            },
                            BLUR: {
                                actions: 'handleBlur'
                            }
                        }
                    },
                    submit: {
                        tags: 'pending',
                        entry: [
                            'sendUpdate',
                            'clearError',
                            'setUsernameForgotPassword'
                        ],
                        invoke: {
                            src: 'handleResetPassword',
                            onDone: {
                                actions: [
                                    'setCodeDeliveryDetails',
                                    'setNextResetPasswordStep'
                                ],
                                target: '#forgotPasswordActor.confirmResetPassword'
                            },
                            onError: {
                                actions: 'setRemoteError',
                                target: 'edit'
                            }
                        }
                    }
                }
            },
            confirmResetPassword: {
                type: 'parallel',
                exit: [
                    'clearFormValues',
                    'clearError',
                    'clearTouched'
                ],
                states: {
                    validation: {
                        initial: 'pending',
                        states: {
                            pending: {
                                invoke: {
                                    src: 'validateFields',
                                    onDone: {
                                        target: 'valid',
                                        actions: 'clearValidationError'
                                    },
                                    onError: {
                                        target: 'invalid',
                                        actions: 'setFieldErrors'
                                    }
                                }
                            },
                            valid: {
                                entry: 'sendUpdate'
                            },
                            invalid: {
                                entry: 'sendUpdate'
                            }
                        },
                        on: {
                            CHANGE: {
                                actions: 'handleInput',
                                target: '.pending'
                            },
                            BLUR: {
                                actions: 'handleBlur',
                                target: '.pending'
                            }
                        }
                    },
                    submission: {
                        initial: 'idle',
                        states: {
                            idle: {
                                entry: 'sendUpdate',
                                on: {
                                    SUBMIT: {
                                        actions: 'handleSubmit',
                                        target: 'validate'
                                    },
                                    RESEND: 'resendCode',
                                    CHANGE: {
                                        actions: 'handleInput'
                                    },
                                    BLUR: {
                                        actions: 'handleBlur'
                                    }
                                }
                            },
                            validate: {
                                entry: 'sendUpdate',
                                invoke: {
                                    src: 'validateFields',
                                    onDone: {
                                        target: 'pending',
                                        actions: 'clearValidationError'
                                    },
                                    onError: {
                                        target: 'idle',
                                        actions: 'setFieldErrors'
                                    }
                                }
                            },
                            resendCode: {
                                tags: 'pending',
                                entry: [
                                    'clearError',
                                    'sendUpdate'
                                ],
                                invoke: {
                                    src: 'handleResetPassword',
                                    onDone: {
                                        target: 'idle'
                                    },
                                    onError: {
                                        actions: 'setRemoteError',
                                        target: 'idle'
                                    }
                                }
                            },
                            pending: {
                                tags: 'pending',
                                entry: [
                                    'clearError',
                                    'sendUpdate'
                                ],
                                invoke: {
                                    src: 'handleConfirmResetPassword',
                                    onDone: [
                                        {
                                            cond: 'hasCompletedResetPassword',
                                            actions: 'setNextResetPasswordStep',
                                            target: '#forgotPasswordActor.resolved'
                                        },
                                        {
                                            actions: 'setSignInStep',
                                            target: '#forgotPasswordActor.resolved'
                                        }
                                    ],
                                    onError: {
                                        actions: 'setRemoteError',
                                        target: 'idle'
                                    }
                                }
                            }
                        }
                    }
                }
            },
            resolved: {
                type: 'final',
                data: ({ step: step })=>({
                        step: step
                    })
            }
        }
    }, {
        // sendUpdate is a HOC
        actions: {
            ...(0, $64ef23d998d8f5c7$export$2e2bcd8739ae039),
            sendUpdate: (0, $ce3108fccc482c97$export$7f8b724299523eb6)()
        },
        guards: (0, $c736c047e930e5f4$export$2e2bcd8739ae039),
        services: {
            handleResetPassword ({ username: username }) {
                return services.handleForgotPassword({
                    username: username
                });
            },
            handleConfirmResetPassword ({ formValues: formValues, username: username }) {
                const { confirmation_code: confirmationCode, password: newPassword } = formValues;
                return services.handleForgotPasswordSubmit({
                    confirmationCode: confirmationCode,
                    newPassword: newPassword,
                    username: username
                });
            },
            validateFields (context) {
                return (0, $823a1d9578ae4f09$export$59e2b39f02edfada)(context.formValues, context.touched, context.passwordSettings, [
                    (0, $74c4c42c59a292e1$export$7ae2d201ca9520b).validateFormPassword,
                    (0, $74c4c42c59a292e1$export$7ae2d201ca9520b).validateConfirmPassword
                ]);
            }
        }
    });
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ab5acd7972ff939a$export$39430dfe49142ae = (amplify, options)=>{
    return amplify.Auth.fetchAuthSession(options);
};




















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3a7cd168fab21612$export$9b3b12a535efe659 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('GetUser'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $eaee5c977a111a2b$export$5dc95ecf3f16c6c9 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = authConfig;
    const { tokens: tokens } = await (0, $ab5acd7972ff939a$export$39430dfe49142ae)(amplify, {
        forceRefresh: false
    });
    (0, $6cdbc20a8ad3ee2e$export$77712ea5882cac9f)(tokens);
    const getUser = (0, $3a7cd168fab21612$export$9b3b12a535efe659)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { UserAttributes: UserAttributes } = await getUser({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).FetchUserAttributes)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    return (0, $074b27d937db39a8$export$1b975641d03f3b17)(UserAttributes);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetches the current user attributes while authenticated.
 *
 * @throws - {@link GetUserException} - Cognito service errors thrown when the service is not able to get the user.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $c0cd52bad52ebf63$export$5dc95ecf3f16c6c9 = ()=>{
    return (0, $eaee5c977a111a2b$export$5dc95ecf3f16c6c9)((0, $4e3539eda5094cb7$export$a3858a9a153cffc7));
};






















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2abe92115445a860$export$a79582342a827ee1 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('ListWebAuthnCredentials'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $397df97c4ca51b0c$export$91d5486d023a5f8d(amplify, input) {
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = authConfig;
    const { tokens: tokens } = await amplify.Auth.fetchAuthSession();
    (0, $6cdbc20a8ad3ee2e$export$77712ea5882cac9f)(tokens);
    const listWebAuthnCredentialsResult = (0, $2abe92115445a860$export$a79582342a827ee1)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { Credentials: commandCredentials = [], NextToken: nextToken } = await listWebAuthnCredentialsResult({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ListWebAuthnCredentials)
    }, {
        AccessToken: tokens.accessToken.toString(),
        MaxResults: input?.pageSize,
        NextToken: input?.nextToken
    });
    const credentials = commandCredentials.map((item)=>({
            credentialId: item.CredentialId,
            friendlyCredentialName: item.FriendlyCredentialName,
            relyingPartyId: item.RelyingPartyId,
            authenticatorAttachment: item.AuthenticatorAttachment,
            authenticatorTransports: item.AuthenticatorTransports,
            createdAt: item.CreatedAt ? new Date(item.CreatedAt * 1000) : undefined
        }));
    return {
        credentials: credentials,
        nextToken: nextToken
    };
}











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Lists registered credentials for an authenticated user
 *
 * @param {ListWebAuthnCredentialsInput} input The list input parameters including page size and next token.
 * @returns Promise<ListWebAuthnCredentialsOutput>
 * @throws - {@link AuthError}:
 * - Thrown when user is unauthenticated
 * @throws - {@link ListWebAuthnCredentialsException}
 * - Thrown due to a service error when listing WebAuthn credentials
 */ async function $51abed20915325ca$export$91d5486d023a5f8d(input) {
    return (0, $397df97c4ca51b0c$export$91d5486d023a5f8d)((0, $4e3539eda5094cb7$export$a3858a9a153cffc7), input);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $7b0cee280d6cceb5$export$b855308a44508212(str) {
    return str.split('').map((char)=>char.charCodeAt(0).toString(16).padStart(2, '0')).join('');
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $dcbde1c4a218fd11$export$a7ea17e93539f9a5(hex) {
    const matchArr = hex.match(/.{2}/g) || [];
    return matchArr.map((char)=>String.fromCharCode(parseInt(char, 16))).join('');
}












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: delete this module when the Auth class is removed.
const $0b34846ed6450e0e$var$logger = new (0, $294c375a4ec5088f$export$ba6a9c7ac8291f7f)('AuthError');
class $0b34846ed6450e0e$export$145273558d58e0ac extends Error {
    constructor(type){
        const { message: message, log: log } = $0b34846ed6450e0e$export$d8113b8d790509a4[type];
        super(message);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $0b34846ed6450e0e$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $0b34846ed6450e0e$export$145273558d58e0ac.prototype);
        this.name = 'AuthError';
        this.log = log || message;
        $0b34846ed6450e0e$var$logger.error(this.log);
    }
}
class $0b34846ed6450e0e$export$71192787e041818c extends $0b34846ed6450e0e$export$145273558d58e0ac {
    constructor(type){
        super(type);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $0b34846ed6450e0e$export$71192787e041818c;
        Object.setPrototypeOf(this, $0b34846ed6450e0e$export$71192787e041818c.prototype);
        this.name = 'NoUserPoolError';
    }
}
const $0b34846ed6450e0e$export$d8113b8d790509a4 = {
    oauthSignInError: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).OAUTH_ERROR,
        log: 'Make sure Cognito Hosted UI has been configured correctly'
    },
    noConfig: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).DEFAULT_MSG,
        log: `
            Error: Amplify has not been configured correctly.
            This error is typically caused by one of the following scenarios:

            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point
                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information
            
            2. There might be multiple conflicting versions of amplify packages in your node_modules.
				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)
        `
    },
    missingAuthConfig: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).DEFAULT_MSG,
        log: `
            Error: Amplify has not been configured correctly. 
            The configuration object is missing required auth properties.
            This error is typically caused by one of the following scenarios:

            1. Did you run \`amplify push\` after adding auth via \`amplify add auth\`?
                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information

            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.
        `
    },
    emptyUsername: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).EMPTY_CODE
    },
    signUpError: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).SIGN_UP_ERROR,
        log: 'The first parameter should either be non-null string or object'
    },
    noMFA: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).NO_MFA
    },
    invalidMFA: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).NO_USER_SESSION
    },
    deviceConfig: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).DEVICE_CONFIG
    },
    networkError: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).NETWORK_ERROR
    },
    autoSignInError: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).AUTOSIGNIN_ERROR
    },
    default: {
        message: (0, $8d93f22263ae8b19$export$c3070468b9d65120).DEFAULT_MSG
    }
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $304765191d6a9abf$export$84cc8f04e08ffc24 = (message, recoverySuggestion)=>new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        message: message ?? 'An error has occurred during the oauth process.',
        name: (0, $8d93f22263ae8b19$export$473ab0b56598aacd).OAuthSignInError,
        recoverySuggestion: recoverySuggestion ?? (0, $0b34846ed6450e0e$export$d8113b8d790509a4).oauthSignInError.log
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $496e18d90617bb52$export$edb367c0a140d3db;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
    AuthErrorTypes["OAuthSignInError"] = "oauthSignInError";
})($496e18d90617bb52$export$edb367c0a140d3db || ($496e18d90617bb52$export$edb367c0a140d3db = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $de8b18bf0512bc81$export$8963ba4ccadccff8 = '`signInWithRedirect` has been canceled.';
const $de8b18bf0512bc81$export$72e3479c52537deb = 'An error occurred while validating the state.';
const $de8b18bf0512bc81$export$80dc16ad7fef6c6 = 'Try to initiate an OAuth flow from Amplify';
const $de8b18bf0512bc81$export$6925991e7e736e7 = async (state)=>{
    const savedState = await (0, $8a5433823b726473$export$2ed0ec267eb6cb1c).loadOAuthState();
    // This is because savedState only exists if the flow was initiated by Amplify
    const validatedState = state === savedState ? savedState : undefined;
    if (!validatedState) throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
        name: (0, $496e18d90617bb52$export$edb367c0a140d3db).OAuthSignInError,
        message: state === null ? $de8b18bf0512bc81$export$8963ba4ccadccff8 : $de8b18bf0512bc81$export$72e3479c52537deb,
        recoverySuggestion: state === null ? undefined : $de8b18bf0512bc81$export$80dc16ad7fef6c6
    });
    return validatedState;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $06b365ece4b72d48$export$342f5c7ddb2087ec = async ({ currentUrl: currentUrl, userAgentValue: userAgentValue, clientId: clientId, redirectUri: redirectUri, responseType: responseType, domain: domain, preferPrivateSession: preferPrivateSession })=>{
    const urlParams = new (0, $e4212cfe0940953e$export$beb82d9d9136c16e)(currentUrl);
    const error = urlParams.searchParams.get('error');
    const errorMessage = urlParams.searchParams.get('error_description');
    if (error) throw (0, $304765191d6a9abf$export$84cc8f04e08ffc24)(errorMessage ?? error);
    if (responseType === 'code') return $06b365ece4b72d48$var$handleCodeFlow({
        currentUrl: currentUrl,
        userAgentValue: userAgentValue,
        clientId: clientId,
        redirectUri: redirectUri,
        domain: domain,
        preferPrivateSession: preferPrivateSession
    });
    return $06b365ece4b72d48$var$handleImplicitFlow({
        currentUrl: currentUrl,
        redirectUri: redirectUri,
        preferPrivateSession: preferPrivateSession
    });
};
const $06b365ece4b72d48$var$handleCodeFlow = async ({ currentUrl: currentUrl, userAgentValue: userAgentValue, clientId: clientId, redirectUri: redirectUri, domain: domain, preferPrivateSession: preferPrivateSession })=>{
    /* Convert URL into an object with parameters as keys
{ redirect_uri: 'http://localhost:3000/', response_type: 'code', ...} */ const url = new (0, $e4212cfe0940953e$export$beb82d9d9136c16e)(currentUrl);
    const code = url.searchParams.get('code');
    const state = url.searchParams.get('state');
    // if `code` or `state` is not presented in the redirect url, most likely
    // that the end user cancelled the inflight oauth flow by:
    // 1. clicking the back button of browser
    // 2. closing the provider hosted UI page and coming back to the app
    if (!code || !state) throw (0, $304765191d6a9abf$export$84cc8f04e08ffc24)('User cancelled OAuth flow.');
    // may throw error is being caught in attemptCompleteOAuthFlow.ts
    const validatedState = await (0, $de8b18bf0512bc81$export$6925991e7e736e7)(state);
    const oAuthTokenEndpoint = 'https://' + domain + '/oauth2/token';
    // TODO(v6): check hub events
    // dispatchAuthEvent(
    // 	'codeFlow',
    // 	{},
    // 	`Retrieving tokens from ${oAuthTokenEndpoint}`
    // );
    const codeVerifier = await (0, $8a5433823b726473$export$2ed0ec267eb6cb1c).loadPKCE();
    const oAuthTokenBody = {
        grant_type: 'authorization_code',
        code: code,
        client_id: clientId,
        redirect_uri: redirectUri,
        ...codeVerifier ? {
            code_verifier: codeVerifier
        } : {}
    };
    const body = Object.entries(oAuthTokenBody).map(([k, v])=>`${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
    const { access_token: access_token, refresh_token: refreshToken, id_token: id_token, error: error, error_message: errorMessage, token_type: token_type, expires_in: expires_in } = await (await fetch(oAuthTokenEndpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            [(0, $8e91a29fca34c6c0$export$16032fc466434892)]: userAgentValue
        },
        body: body
    })).json();
    if (error) // error is being caught in attemptCompleteOAuthFlow.ts
    throw (0, $304765191d6a9abf$export$84cc8f04e08ffc24)(errorMessage ?? error);
    const username = (access_token && (0, $5c85900a0ff57646$export$9a62e6c0a30e00bc)(access_token).payload.username) ?? 'username';
    await (0, $91b271eeb38cc677$export$729df6fdd19b8b0d)({
        username: username,
        AccessToken: access_token,
        IdToken: id_token,
        RefreshToken: refreshToken
    });
    return $06b365ece4b72d48$var$completeFlow({
        redirectUri: redirectUri,
        state: validatedState,
        preferPrivateSession: preferPrivateSession
    });
};
const $06b365ece4b72d48$var$handleImplicitFlow = async ({ currentUrl: currentUrl, redirectUri: redirectUri, preferPrivateSession: preferPrivateSession })=>{
    // hash is `null` if `#` doesn't exist on URL
    const url = new (0, $e4212cfe0940953e$export$beb82d9d9136c16e)(currentUrl);
    const { id_token: id_token, access_token: access_token, state: state, token_type: token_type, expires_in: expires_in, error_description: error_description, error: error } = (url.hash ?? '#').substring(1) // Remove # from returned code
    .split('&').map((pairings)=>pairings.split('=')).reduce((accum, [k, v])=>({
            ...accum,
            [k]: v
        }), {
        id_token: undefined,
        access_token: undefined,
        state: undefined,
        token_type: undefined,
        expires_in: undefined,
        error_description: undefined,
        error: undefined
    });
    if (error) throw (0, $304765191d6a9abf$export$84cc8f04e08ffc24)(error_description ?? error);
    if (!access_token) // error is being caught in attemptCompleteOAuthFlow.ts
    throw (0, $304765191d6a9abf$export$84cc8f04e08ffc24)('No access token returned from OAuth flow.');
    const validatedState = await (0, $de8b18bf0512bc81$export$6925991e7e736e7)(state);
    const username = (access_token && (0, $5c85900a0ff57646$export$9a62e6c0a30e00bc)(access_token).payload.username) ?? 'username';
    await (0, $91b271eeb38cc677$export$729df6fdd19b8b0d)({
        username: username,
        AccessToken: access_token,
        IdToken: id_token
    });
    return $06b365ece4b72d48$var$completeFlow({
        redirectUri: redirectUri,
        state: validatedState,
        preferPrivateSession: preferPrivateSession
    });
};
const $06b365ece4b72d48$var$completeFlow = async ({ redirectUri: redirectUri, state: state, preferPrivateSession: preferPrivateSession })=>{
    await (0, $3c6129946b01fbcd$export$66561e66d62991d0).setOAuthMetadata({
        oauthSignIn: true
    });
    await (0, $8a5433823b726473$export$2ed0ec267eb6cb1c).clearOAuthData();
    await (0, $8a5433823b726473$export$2ed0ec267eb6cb1c).storeOAuthSignIn(true, preferPrivateSession);
    // this should be called before any call that involves `fetchAuthSession`
    // e.g. `getCurrentUser()` below, so it allows every inflight async calls to
    //  `fetchAuthSession` can be resolved
    (0, $1b618344cbb99d11$export$bcb0b7a105a5df59)();
    // clear history before sending out final Hub events
    $06b365ece4b72d48$var$clearHistory(redirectUri);
    if ($06b365ece4b72d48$var$isCustomState(state)) (0, $7c7b61d0858d9585$export$8c41bb232f1008b1).dispatch('auth', {
        event: 'customOAuthState',
        data: (0, $dcbde1c4a218fd11$export$a7ea17e93539f9a5)($06b365ece4b72d48$var$getCustomState(state))
    }, 'Auth', (0, $7c7b61d0858d9585$export$aadf71dd9875dd20));
    (0, $7c7b61d0858d9585$export$8c41bb232f1008b1).dispatch('auth', {
        event: 'signInWithRedirect'
    }, 'Auth', (0, $7c7b61d0858d9585$export$aadf71dd9875dd20));
    await (0, $e29e37b04a825a54$export$4d78d2ee899572ab)();
};
const $06b365ece4b72d48$var$isCustomState = (state)=>{
    return /-/.test(state);
};
const $06b365ece4b72d48$var$getCustomState = (state)=>{
    return state.split('-').splice(1).join('-');
};
const $06b365ece4b72d48$var$clearHistory = (redirectUri)=>{
    if (typeof window !== 'undefined' && typeof window.history !== 'undefined') window.history.replaceState(window.history.state, '', redirectUri);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @internal */ function $126e34cf849d74c5$export$93832c3affb240d3(redirects, preferredRedirectUrl) {
    if (preferredRedirectUrl) {
        const redirectUrl = redirects?.find((redirect)=>redirect === preferredRedirectUrl);
        if (!redirectUrl) throw 0, $6c49017af88bac4c$export$41a56a70fc1a4962;
        return redirectUrl;
    } else {
        const redirectUrlFromTheSameOrigin = redirects?.find($126e34cf849d74c5$var$isSameOriginAndPathName) ?? redirects?.find($126e34cf849d74c5$var$isTheSameDomain);
        const redirectUrlFromDifferentOrigin = redirects?.find($126e34cf849d74c5$var$isHttps) ?? redirects?.find($126e34cf849d74c5$var$isHttp);
        if (redirectUrlFromTheSameOrigin) return redirectUrlFromTheSameOrigin;
        else if (redirectUrlFromDifferentOrigin) throw 0, $6c49017af88bac4c$export$c01b4acd6291e035;
        throw 0, $6c49017af88bac4c$export$60b68b138a52e5ae;
    }
}
// origin + pathname => https://example.com/app
const $126e34cf849d74c5$var$isSameOriginAndPathName = (redirect)=>redirect.startsWith(String(window.location.origin + (window.location.pathname || '/')));
// domain => outlook.live.com, github.com
const $126e34cf849d74c5$var$isTheSameDomain = (redirect)=>redirect.includes(String(window.location.hostname));
const $126e34cf849d74c5$var$isHttp = (redirect)=>redirect.startsWith('http://');
const $126e34cf849d74c5$var$isHttps = (redirect)=>redirect.startsWith('https://');






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $32141a0d2b889e1d$export$9adf33f0521751a3 = async (error)=>{
    (0, $1b618344cbb99d11$export$bcb0b7a105a5df59)();
    await (0, $8a5433823b726473$export$2ed0ec267eb6cb1c).clearOAuthInflightData();
    (0, $7c7b61d0858d9585$export$8c41bb232f1008b1).dispatch('auth', {
        event: 'signInWithRedirect_failure',
        data: {
            error: error
        }
    }, 'Auth', (0, $7c7b61d0858d9585$export$aadf71dd9875dd20));
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $b21c03d9a5b1657f$export$602253b28f67ef40 = async (authConfig)=>{
    try {
        (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
        (0, $5c85900a0ff57646$export$c13e6dbaf90a8e5f)(authConfig);
        (0, $8a5433823b726473$export$2ed0ec267eb6cb1c).setAuthConfig(authConfig);
    } catch (_) {
        // no-op
        // This should not happen as Amplify singleton checks the oauth config key
        // unless the oauth config object doesn't contain required properties
        return;
    }
    // No inflight OAuth
    if (!await (0, $8a5433823b726473$export$2ed0ec267eb6cb1c).loadOAuthInFlight()) return;
    try {
        const currentUrl = window.location.href;
        const { loginWith: loginWith, userPoolClientId: userPoolClientId } = authConfig;
        const { domain: domain, redirectSignIn: redirectSignIn, responseType: responseType } = loginWith.oauth;
        const redirectUri = (0, $126e34cf849d74c5$export$93832c3affb240d3)(redirectSignIn);
        await (0, $06b365ece4b72d48$export$342f5c7ddb2087ec)({
            currentUrl: currentUrl,
            clientId: userPoolClientId,
            domain: domain,
            redirectUri: redirectUri,
            responseType: responseType,
            userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignInWithRedirect)
        });
    } catch (err) {
        await (0, $32141a0d2b889e1d$export$9adf33f0521751a3)(err);
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// attach the side effect for handling the completion of an inflight oauth flow
// this side effect works only on Web
(0, $f030787848639548$export$4e09c449d6c407f7)() && (()=>{
    // add the listener to the singleton for triggering
    (0, $4e3539eda5094cb7$export$a3858a9a153cffc7)[0, $34cc7e2a3c52f094$export$35210b3191d26437]((0, $b21c03d9a5b1657f$export$602253b28f67ef40));
})();


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $84ca4bfa2a98e4b3$export$6893de5f4e1216c3 = {
    Google: 'Google',
    Facebook: 'Facebook',
    Amazon: 'LoginWithAmazon',
    Apple: 'SignInWithApple'
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $39a566cced05f3c9$export$a673d54799039714 = async (url)=>{
    if (!window?.location) return;
    // enforce HTTPS
    window.location.href = url.replace('http://', 'https://');
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $b531800ebd2820fd$var$CODE_VERIFIER_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
/**
 *
 * @param length Desired length of the code verifier.
 *
 * **NOTE:** According to the [RFC 7636](https://datatracker.ietf.org/doc/html/rfc7636#section-4.1)
 * A code verifier must be with a length >= 43 and <= 128.
 *
 * @returns An object that contains the generated `codeVerifier` and a method
 * `toCodeChallenge` to generate the code challenge from the `codeVerifier`
 * following the spec of [RFC 7636](https://datatracker.ietf.org/doc/html/rfc7636#section-4.2).
 */ const $b531800ebd2820fd$export$cf1891f923f5943a = (length)=>{
    const randomBytes = new Uint8Array(length);
    (0, $2f3406124c4dec3f$export$e003cc239f955cb6)().getRandomValues(randomBytes);
    let value = '';
    let codeChallenge;
    for (const byte of randomBytes)value += $b531800ebd2820fd$var$CODE_VERIFIER_CHARSET.charAt(byte % $b531800ebd2820fd$var$CODE_VERIFIER_CHARSET.length);
    return {
        value: value,
        method: 'S256',
        toCodeChallenge () {
            if (codeChallenge) return codeChallenge;
            codeChallenge = $b531800ebd2820fd$var$generateCodeChallenge(value);
            return codeChallenge;
        }
    };
};
function $b531800ebd2820fd$var$generateCodeChallenge(codeVerifier) {
    const awsCryptoHash = new (0, $bf8fb85b69ce25b0$export$3b58ea8124ac5e28)();
    awsCryptoHash.update(codeVerifier);
    const codeChallenge = $b531800ebd2820fd$var$removePaddingChar((0, $820769526bac512e$export$695b149896bd3e2a).convert(awsCryptoHash.digestSync(), {
        urlSafe: true
    }));
    return codeChallenge;
}
function $b531800ebd2820fd$var$removePaddingChar(base64Encoded) {
    return base64Encoded.replace(/=/g, '');
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $cf312aba62b88f71$export$9e15fb06e64c4810 = (length)=>{
    const STATE_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const result = [];
    const randomNums = new Uint8Array(length);
    (0, $2f3406124c4dec3f$export$e003cc239f955cb6)().getRandomValues(randomNums);
    for (const num of randomNums)result.push(STATE_CHARSET[num % STATE_CHARSET.length]);
    return result.join('');
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $5461938caea28fed$export$9ccd2716e53a229b = ()=>{
    return (0, $cf312aba62b88f71$export$9e15fb06e64c4810)(32);
};













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $adc2bbfcf5a883d5$export$35c17f3730c1b943 = (store)=>{
    async function handleCancelOAuthFlow(event) {
        const isBfcache = event.persisted;
        if (isBfcache && await store.loadOAuthInFlight()) {
            const error = (0, $304765191d6a9abf$export$84cc8f04e08ffc24)('User cancelled OAuth flow.');
            await (0, $32141a0d2b889e1d$export$9adf33f0521751a3)(error);
        }
        window.removeEventListener('pageshow', handleCancelOAuthFlow);
    }
    window.addEventListener('pageshow', handleCancelOAuthFlow);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs in a user with OAuth. Redirects the application to an Identity Provider.
 *
 * @param input - The SignInWithRedirectInput object, if empty it will redirect to Cognito HostedUI
 *
 * @throws AuthTokenConfigException - Thrown when the user pool config is invalid.
 * @throws OAuthNotConfigureException - Thrown when the oauth config is invalid.
 */ async function $6f84eeb20c8c9468$export$3d0a7d1372e866bb(input) {
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    (0, $5c85900a0ff57646$export$c13e6dbaf90a8e5f)(authConfig);
    (0, $8a5433823b726473$export$2ed0ec267eb6cb1c).setAuthConfig(authConfig);
    if (!input?.options?.prompt) await (0, $a34f9704f91c4ae9$export$8061cd07f982ef08)();
    let provider = 'COGNITO'; // Default
    let idpIdentifier;
    if (typeof input?.provider === 'string') provider = (0, $84ca4bfa2a98e4b3$export$6893de5f4e1216c3)[input.provider];
    else if (input?.provider?.custom) provider = input.provider.custom;
    else if (input?.provider?.idpIdentifier) ({ idpIdentifier: idpIdentifier } = input.provider);
    return $6f84eeb20c8c9468$var$oauthSignIn({
        oauthConfig: authConfig.loginWith.oauth,
        clientId: authConfig.userPoolClientId,
        provider: provider,
        idpIdentifier: idpIdentifier,
        customState: input?.customState,
        preferPrivateSession: input?.options?.preferPrivateSession,
        options: {
            loginHint: input?.options?.loginHint,
            lang: input?.options?.lang,
            nonce: input?.options?.nonce,
            prompt: input?.options?.prompt
        },
        authSessionOpener: input?.options?.authSessionOpener
    });
}
const $6f84eeb20c8c9468$var$oauthSignIn = async ({ oauthConfig: oauthConfig, provider: provider, idpIdentifier: idpIdentifier, clientId: clientId, customState: customState, preferPrivateSession: preferPrivateSession, options: options, authSessionOpener: authSessionOpener })=>{
    const { domain: domain, redirectSignIn: redirectSignIn, responseType: responseType, scopes: scopes } = oauthConfig;
    const { loginHint: loginHint, lang: lang, nonce: nonce, prompt: prompt } = options ?? {};
    const randomState = (0, $5461938caea28fed$export$9ccd2716e53a229b)();
    const openAuthSession$1 = authSessionOpener || (0, $39a566cced05f3c9$export$a673d54799039714);
    /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
    single-encodes/decodes url on first sign in and double-encodes/decodes url
    when user already signed in. Using encodeURIComponent, Base32, Base64 add
    characters % or = which on further encoding becomes unsafe. '=' create issue
    for parsing query params.
    Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ const state = customState ? `${randomState}-${(0, $7b0cee280d6cceb5$export$b855308a44508212)(customState)}` : randomState;
    const { value: value, method: method, toCodeChallenge: toCodeChallenge } = (0, $b531800ebd2820fd$export$cf1891f923f5943a)(128);
    const redirectUri = (0, $126e34cf849d74c5$export$93832c3affb240d3)(oauthConfig.redirectSignIn);
    if ((0, $f030787848639548$export$4e09c449d6c407f7)()) (0, $8a5433823b726473$export$2ed0ec267eb6cb1c).storeOAuthInFlight(true);
    (0, $8a5433823b726473$export$2ed0ec267eb6cb1c).storeOAuthState(state);
    (0, $8a5433823b726473$export$2ed0ec267eb6cb1c).storePKCE(value);
    const params = new URLSearchParams();
    params.append('redirect_uri', redirectUri);
    params.append('response_type', responseType);
    params.append('client_id', clientId);
    // Add either identity_provider or idp_identifier, but not both
    if (idpIdentifier) params.append('idp_identifier', idpIdentifier);
    else params.append('identity_provider', provider);
    params.append('scope', scopes.join(' '));
    loginHint && params.append('login_hint', loginHint);
    lang && params.append('lang', lang);
    nonce && params.append('nonce', nonce);
    prompt && params.append('prompt', prompt.toLowerCase());
    params.append('state', state);
    if (responseType === 'code') {
        params.append('code_challenge', toCodeChallenge());
        params.append('code_challenge_method', method);
    }
    // Using URL object is not supported in React Native as the `search` property is read-only
    // See: https://github.com/facebook/react-native/blob/main/packages/react-native/Libraries/Blob/URL.js
    const oAuthUrl = `https://${domain}/oauth2/authorize?${params.toString()}`;
    // this will only take effect in the following scenarios:
    // 1. the user cancels the OAuth flow on web via back button, and
    // 2. when bfcache is enabled
    (0, $adc2bbfcf5a883d5$export$35c17f3730c1b943)((0, $8a5433823b726473$export$2ed0ec267eb6cb1c));
    // the following is effective only in react-native as openAuthSession resolves only in react-native
    const { type: type, error: error, url: url } = await openAuthSession$1(oAuthUrl, redirectSignIn, preferPrivateSession) ?? {};
    try {
        if (type === 'error') throw (0, $304765191d6a9abf$export$84cc8f04e08ffc24)(String(error));
        if (type === 'canceled') throw (0, $304765191d6a9abf$export$84cc8f04e08ffc24)(String(type));
        if (type === 'success' && url) await (0, $06b365ece4b72d48$export$342f5c7ddb2087ec)({
            currentUrl: url,
            clientId: clientId,
            domain: domain,
            redirectUri: redirectUri,
            responseType: responseType,
            userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignInWithRedirect),
            preferPrivateSession: preferPrivateSession
        });
    } catch (err) {
        await (0, $32141a0d2b889e1d$export$9adf33f0521751a3)(err);
        // rethrow the error so it can be caught by `await signInWithRedirect()` in react-native
        throw err;
    }
};






const $afbcd3ab1cd1e36f$export$e4c83e92363a7a74 = (target)=>({
        entry: [
            'sendUpdate',
            'clearError'
        ],
        invoke: {
            src: 'signInWithRedirect',
            onDone: {
                target: target
            },
            onError: {
                actions: 'setRemoteError',
                target: target
            }
        }
    });
const $afbcd3ab1cd1e36f$export$b6a6630ce2404714 = (signInStep)=>{
    if ([
        'CONTINUE_SIGN_IN_WITH_MFA_SELECTION',
        'CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION'
    ].includes(signInStep)) return 'mfa_type';
    if (signInStep === 'CONTINUE_SIGN_IN_WITH_EMAIL_SETUP') return 'email';
    return 'confirmation_code';
};


const $ee80a0a5495650ae$var$handleSignInResponse = {
    onDone: [
        {
            cond: 'hasCompletedSignIn',
            actions: 'setNextSignInStep',
            target: '#signInActor.fetchUserAttributes'
        },
        {
            cond: 'shouldConfirmSignInWithNewPassword',
            actions: [
                'setMissingAttributes',
                'setNextSignInStep'
            ],
            target: '#signInActor.forceChangePassword'
        },
        {
            cond: 'shouldResetPasswordFromSignIn',
            actions: 'setNextSignInStep',
            target: '#signInActor.resetPassword'
        },
        {
            cond: 'shouldConfirmSignUpFromSignIn',
            actions: 'setNextSignInStep',
            target: '#signInActor.resendSignUpCode'
        },
        {
            actions: [
                'setChallengeName',
                'setMissingAttributes',
                'setNextSignInStep',
                'setTotpSecretCode',
                'setAllowedMfaTypes',
                'setCodeDeliveryDetails'
            ],
            target: '#signInActor.init'
        }
    ],
    onError: {
        actions: 'setRemoteError',
        target: 'edit'
    }
};
const $ee80a0a5495650ae$var$getDefaultConfirmSignInState = (exit)=>({
        initial: 'edit',
        exit: exit,
        states: {
            edit: {
                entry: 'sendUpdate',
                on: {
                    SUBMIT: {
                        actions: 'handleSubmit',
                        target: 'submit'
                    },
                    SIGN_IN: '#signInActor.signIn',
                    CHANGE: {
                        actions: 'handleInput'
                    },
                    RESEND: {
                        target: 'resend'
                    }
                }
            },
            submit: {
                tags: 'pending',
                entry: [
                    'sendUpdate',
                    'clearError'
                ],
                invoke: {
                    src: 'confirmSignIn',
                    ...$ee80a0a5495650ae$var$handleSignInResponse
                }
            },
            resend: {
                tags: 'pending',
                entry: [
                    'sendUpdate',
                    'clearError'
                ],
                invoke: {
                    src: 'resendSignInCode',
                    onDone: {
                        actions: [
                            'setCodeDeliveryDetails',
                            'sendUpdate'
                        ],
                        target: 'edit'
                    },
                    onError: {
                        actions: 'setRemoteError',
                        target: 'edit'
                    }
                }
            }
        }
    });
function $ee80a0a5495650ae$export$f9c30eaa77191700({ services: services }) {
    return (0, $15bb13904b1fd3cf$export$aaa7fa18f8e9b2e8)({
        id: 'signInActor',
        initial: 'init',
        predictableActionArguments: true,
        states: {
            init: {
                always: [
                    {
                        cond: 'shouldConfirmSignIn',
                        target: 'confirmSignIn'
                    },
                    {
                        cond: 'shouldSetupTotp',
                        target: 'setupTotp'
                    },
                    {
                        cond: 'shouldSetupEmail',
                        target: 'setupEmail'
                    },
                    {
                        cond: 'shouldSelectMfaType',
                        target: 'selectMfaType'
                    },
                    {
                        cond: ({ step: step })=>step === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',
                        actions: 'setActorDoneData',
                        target: 'forceChangePassword'
                    },
                    {
                        target: 'signIn'
                    }
                ]
            },
            federatedSignIn: {
                ...(0, $afbcd3ab1cd1e36f$export$e4c83e92363a7a74)('signIn')
            },
            fetchUserAttributes: {
                invoke: {
                    src: 'fetchUserAttributes',
                    onDone: [
                        {
                            cond: 'hasPasskeyRegistrationPrompts',
                            actions: 'setFetchedUserAttributes',
                            target: 'checkPasskeys'
                        },
                        {
                            actions: 'setFetchedUserAttributes',
                            target: 'evaluatePasskeyPrompt'
                        }
                    ],
                    onError: {
                        actions: 'setConfirmAttributeCompleteStep',
                        target: '#signInActor.resolved'
                    }
                }
            },
            checkPasskeys: {
                invoke: {
                    src: async ()=>{
                        try {
                            const result = await (0, $51abed20915325ca$export$91d5486d023a5f8d)();
                            return result.credentials && result.credentials.length > 0;
                        } catch  {
                            return false;
                        }
                    },
                    onDone: {
                        actions: 'setHasExistingPasskeys',
                        target: 'evaluatePasskeyPrompt'
                    },
                    onError: {
                        actions: 'clearHasExistingPasskeys',
                        target: 'evaluatePasskeyPrompt'
                    }
                }
            },
            evaluatePasskeyPrompt: {
                always: [
                    {
                        cond: 'shouldPromptPasskeyRegistration',
                        target: '#signInActor.passkeyPrompt'
                    },
                    {
                        cond: 'shouldVerifyAttribute',
                        actions: [
                            'setShouldVerifyUserAttributeStep',
                            'setUnverifiedUserAttributes'
                        ],
                        target: '#signInActor.resolved'
                    },
                    {
                        actions: 'setConfirmAttributeCompleteStep',
                        target: '#signInActor.resolved'
                    }
                ]
            },
            resendSignUpCode: {
                invoke: {
                    src: 'handleResendSignUpCode',
                    onDone: {
                        actions: 'setCodeDeliveryDetails',
                        target: '#signInActor.resolved'
                    },
                    onError: {
                        actions: 'setRemoteError',
                        target: '#signInActor.signIn'
                    }
                }
            },
            resetPassword: {
                invoke: {
                    src: 'resetPassword',
                    onDone: [
                        {
                            actions: 'setCodeDeliveryDetails',
                            target: '#signInActor.resolved'
                        }
                    ],
                    onError: {
                        actions: [
                            'setRemoteError',
                            'sendUpdate'
                        ]
                    }
                }
            },
            signIn: {
                initial: 'edit',
                exit: 'clearTouched',
                states: {
                    edit: {
                        entry: 'sendUpdate',
                        on: {
                            CHANGE: {
                                actions: 'handleInput'
                            },
                            FEDERATED_SIGN_IN: {
                                target: '#signInActor.federatedSignIn'
                            },
                            SHOW_AUTH_METHODS: {
                                actions: 'setUsernameSignIn',
                                target: 'selectMethod'
                            },
                            SUBMIT: [
                                {
                                    cond: 'shouldSelectAuthMethod',
                                    actions: 'handleSubmit',
                                    target: 'selectMethod'
                                },
                                {
                                    actions: 'handleSubmit',
                                    target: 'submit'
                                }
                            ]
                        }
                    },
                    selectMethod: {
                        entry: [
                            'sendUpdate',
                            'setSelectAuthMethodStep',
                            'setUsernameSignIn'
                        ],
                        on: {
                            SELECT_METHOD: {
                                actions: 'setSelectedAuthMethod',
                                target: 'submit'
                            },
                            SUBMIT: {
                                actions: [
                                    'handleSubmit',
                                    'setSelectedAuthMethodFromForm'
                                ],
                                target: 'submit'
                            },
                            SIGN_IN: {
                                target: 'edit'
                            }
                        }
                    },
                    submit: {
                        tags: 'pending',
                        entry: [
                            'clearError',
                            'sendUpdate',
                            'setUsernameSignIn'
                        ],
                        exit: 'clearFormValues',
                        invoke: {
                            src: 'handleSignIn',
                            onDone: $ee80a0a5495650ae$var$handleSignInResponse.onDone,
                            onError: [
                                {
                                    cond: 'shouldReturnToSelectMethod',
                                    actions: 'setRemoteError',
                                    target: 'selectMethod'
                                },
                                $ee80a0a5495650ae$var$handleSignInResponse.onError
                            ]
                        }
                    }
                }
            },
            confirmSignIn: {
                ...$ee80a0a5495650ae$var$getDefaultConfirmSignInState([
                    'clearChallengeName',
                    'clearFormValues',
                    'clearError',
                    'clearTouched'
                ])
            },
            forceChangePassword: {
                entry: 'sendUpdate',
                type: 'parallel',
                exit: [
                    'clearFormValues',
                    'clearError',
                    'clearTouched'
                ],
                states: {
                    validation: {
                        initial: 'pending',
                        states: {
                            pending: {
                                invoke: {
                                    src: 'validateFields',
                                    onDone: {
                                        target: 'valid',
                                        actions: 'clearValidationError'
                                    },
                                    onError: {
                                        target: 'invalid',
                                        actions: 'setFieldErrors'
                                    }
                                }
                            },
                            valid: {
                                entry: 'sendUpdate'
                            },
                            invalid: {
                                entry: 'sendUpdate'
                            }
                        },
                        on: {
                            SIGN_IN: {
                                actions: 'setSignInStep',
                                target: '#signInActor.resolved'
                            },
                            CHANGE: {
                                actions: 'handleInput',
                                target: '.pending'
                            },
                            BLUR: {
                                actions: 'handleBlur',
                                target: '.pending'
                            }
                        }
                    },
                    submit: {
                        initial: 'edit',
                        entry: 'clearError',
                        states: {
                            edit: {
                                entry: 'sendUpdate',
                                on: {
                                    SUBMIT: {
                                        actions: 'handleSubmit',
                                        target: 'validate'
                                    }
                                }
                            },
                            validate: {
                                entry: 'sendUpdate',
                                invoke: {
                                    src: 'validateFields',
                                    onDone: {
                                        actions: 'clearValidationError',
                                        target: 'pending'
                                    },
                                    onError: {
                                        actions: 'setFieldErrors',
                                        target: 'edit'
                                    }
                                }
                            },
                            pending: {
                                tags: 'pending',
                                entry: [
                                    'sendUpdate',
                                    'clearError'
                                ],
                                invoke: {
                                    src: 'handleForceChangePassword',
                                    ...$ee80a0a5495650ae$var$handleSignInResponse
                                }
                            }
                        }
                    }
                }
            },
            setupTotp: {
                ...$ee80a0a5495650ae$var$getDefaultConfirmSignInState([
                    'clearFormValues',
                    'clearError',
                    'clearTouched'
                ])
            },
            setupEmail: {
                ...$ee80a0a5495650ae$var$getDefaultConfirmSignInState([
                    'clearFormValues',
                    'clearError',
                    'clearTouched'
                ])
            },
            selectMfaType: {
                ...$ee80a0a5495650ae$var$getDefaultConfirmSignInState([
                    'clearFormValues',
                    'clearError',
                    'clearTouched'
                ])
            },
            passkeyPrompt: {
                entry: 'sendUpdate',
                on: {
                    SUBMIT: {
                        actions: 'setConfirmAttributeCompleteStep',
                        target: 'resolved'
                    },
                    SKIP: {
                        actions: 'setConfirmAttributeCompleteStep',
                        target: 'resolved'
                    }
                }
            },
            resolved: {
                type: 'final',
                data: (context)=>({
                        codeDeliveryDetails: context.codeDeliveryDetails,
                        remoteError: context.remoteError,
                        step: context.step,
                        unverifiedUserAttributes: context.unverifiedUserAttributes,
                        username: context.username
                    })
            }
        }
    }, {
        // sendUpdate is a HOC
        actions: {
            ...(0, $64ef23d998d8f5c7$export$2e2bcd8739ae039),
            sendUpdate: (0, $ce3108fccc482c97$export$7f8b724299523eb6)()
        },
        guards: (0, $c736c047e930e5f4$export$2e2bcd8739ae039),
        services: {
            async fetchUserAttributes () {
                return (0, $c0cd52bad52ebf63$export$5dc95ecf3f16c6c9)();
            },
            resetPassword ({ username: username }) {
                return (0, $478d4cfb377600b8$export$dc726c8e334dd814)({
                    username: username
                });
            },
            handleResendSignUpCode ({ username: username }) {
                return services.handleResendSignUpCode({
                    username: username
                });
            },
            resendSignInCode ({ username: username, selectedAuthMethod: selectedAuthMethod, availableAuthMethods: availableAuthMethods, preferredChallenge: preferredChallenge }) {
                // Resend code by calling signIn again with the same parameters
                const method = selectedAuthMethod ?? preferredChallenge ?? availableAuthMethods?.[0] ?? 'PASSWORD';
                return services.handleSignIn({
                    username: username,
                    options: {
                        authFlowType: 'USER_AUTH',
                        preferredChallenge: method
                    }
                });
            },
            handleSignIn ({ formValues: formValues, username: username, selectedAuthMethod: selectedAuthMethod, availableAuthMethods: availableAuthMethods, preferredChallenge: preferredChallenge }) {
                // Determine which method to use
                const method = selectedAuthMethod ?? preferredChallenge ?? availableAuthMethods?.[0] ?? 'PASSWORD';
                if (method === 'PASSWORD') {
                    // Traditional password flow
                    const { password: password } = formValues;
                    return services.handleSignIn({
                        username: username,
                        password: password
                    });
                } else // Passwordless flow using USER_AUTH
                return services.handleSignIn({
                    username: username,
                    options: {
                        authFlowType: 'USER_AUTH',
                        preferredChallenge: method
                    }
                });
            },
            confirmSignIn ({ formValues: formValues, step: step }) {
                const formValuesKey = (0, $afbcd3ab1cd1e36f$export$b6a6630ce2404714)(step);
                const { [formValuesKey]: challengeResponse } = formValues;
                return services.handleConfirmSignIn({
                    challengeResponse: challengeResponse
                });
            },
            async handleForceChangePassword ({ formValues: formValues }) {
                let { password: challengeResponse, phone_number: phone_number, country_code: country_code, confirm_password: // destructure and toss UI confirm_password field
                // to prevent error from sending to confirmSignIn
                confirm_password, username: username, ...userAttributes } = formValues;
                let phoneNumberWithCountryCode;
                if (phone_number) {
                    phoneNumberWithCountryCode = `${country_code}${phone_number}`.replace(/[^A-Z0-9+]/gi, '');
                    userAttributes = {
                        ...userAttributes,
                        phone_number: phoneNumberWithCountryCode
                    };
                }
                const input = {
                    challengeResponse: challengeResponse,
                    options: {
                        userAttributes: userAttributes
                    }
                };
                return (0, $311c1ce5abcae932$export$a477d84c2f7b792a)(input);
            },
            signInWithRedirect (_, { data: data }) {
                return (0, $6f84eeb20c8c9468$export$3d0a7d1372e866bb)(data);
            },
            async validateFields (context) {
                return (0, $823a1d9578ae4f09$export$59e2b39f02edfada)(context.formValues, context.touched, context.passwordSettings, [
                    (0, $74c4c42c59a292e1$export$7ae2d201ca9520b).validateFormPassword,
                    (0, $74c4c42c59a292e1$export$7ae2d201ca9520b).validateConfirmPassword
                ]);
            }
        }
    });
}









const $c8ba0bafe1f65301$var$handleResetPasswordResponse = {
    onDone: [
        {
            actions: 'setCodeDeliveryDetails',
            target: '#signUpActor.resolved'
        }
    ],
    onError: {
        actions: [
            'setRemoteError',
            'sendUpdate'
        ]
    }
};
const $c8ba0bafe1f65301$var$handleAutoSignInResponse = {
    onDone: [
        {
            cond: 'hasCompletedSignIn',
            actions: 'setNextSignInStep',
            target: '#signUpActor.fetchUserAttributes'
        },
        {
            cond: 'shouldConfirmSignInWithNewPassword',
            actions: 'setNextSignInStep',
            target: '#signUpActor.resolved'
        },
        {
            cond: 'shouldResetPasswordFromSignIn',
            actions: 'setNextSignInStep',
            target: '#signUpActor.resetPassword'
        },
        {
            cond: 'shouldConfirmSignUpFromSignIn',
            actions: 'setNextSignInStep',
            target: '#signUpActor.resendSignUpCode'
        },
        {
            actions: [
                'setNextSignInStep',
                'setChallengeName',
                'setMissingAttributes',
                'setTotpSecretCode',
                'setAllowedMfaTypes'
            ],
            target: '#signUpActor.resolved'
        }
    ],
    onError: {
        actions: 'setRemoteError',
        target: '#signUpActor.resolved'
    }
};
function $c8ba0bafe1f65301$export$6cf61434854181b4({ services: services }) {
    return (0, $15bb13904b1fd3cf$export$aaa7fa18f8e9b2e8)({
        id: 'signUpActor',
        initial: 'init',
        predictableActionArguments: true,
        states: {
            init: {
                always: [
                    {
                        cond: 'shouldConfirmSignUp',
                        target: 'confirmSignUp'
                    },
                    {
                        target: 'signUp'
                    }
                ]
            },
            autoSignIn: {
                tags: 'pending',
                invoke: {
                    src: 'autoSignIn',
                    ...$c8ba0bafe1f65301$var$handleAutoSignInResponse
                }
            },
            fetchUserAttributes: {
                invoke: {
                    src: 'fetchUserAttributes',
                    onDone: [
                        {
                            cond: 'hasPasskeyRegistrationPrompts',
                            actions: 'setFetchedUserAttributes',
                            target: 'checkPasskeys'
                        },
                        {
                            actions: 'setFetchedUserAttributes',
                            target: 'evaluatePasskeyPrompt'
                        }
                    ],
                    onError: {
                        actions: 'setConfirmAttributeCompleteStep',
                        target: '#signUpActor.resolved'
                    }
                }
            },
            checkPasskeys: {
                invoke: {
                    src: async ()=>{
                        try {
                            const result = await (0, $51abed20915325ca$export$91d5486d023a5f8d)();
                            return result.credentials && result.credentials.length > 0;
                        } catch  {
                            return false;
                        }
                    },
                    onDone: {
                        actions: 'setHasExistingPasskeys',
                        target: 'evaluatePasskeyPrompt'
                    },
                    onError: {
                        actions: 'clearHasExistingPasskeys',
                        target: 'evaluatePasskeyPrompt'
                    }
                }
            },
            evaluatePasskeyPrompt: {
                always: [
                    {
                        cond: 'shouldPromptPasskeyRegistrationAfterSignup',
                        target: '#signUpActor.passkeyPrompt'
                    },
                    {
                        cond: 'shouldVerifyAttribute',
                        actions: [
                            'setShouldVerifyUserAttributeStep',
                            'setUnverifiedUserAttributes'
                        ],
                        target: '#signUpActor.resolved'
                    },
                    {
                        actions: 'setConfirmAttributeCompleteStep',
                        target: '#signUpActor.resolved'
                    }
                ]
            },
            federatedSignIn: {
                ...(0, $afbcd3ab1cd1e36f$export$e4c83e92363a7a74)('signUp')
            },
            resetPassword: {
                invoke: {
                    src: 'resetPassword',
                    ...$c8ba0bafe1f65301$var$handleResetPasswordResponse
                }
            },
            resendSignUpCode: {
                tags: 'pending',
                entry: 'sendUpdate',
                exit: 'sendUpdate',
                invoke: {
                    src: 'resendSignUpCode',
                    onDone: {
                        actions: [
                            'setCodeDeliveryDetails',
                            'sendUpdate'
                        ],
                        target: '#signUpActor.confirmSignUp'
                    },
                    onError: [
                        {
                            cond: 'isUserAlreadyConfirmed',
                            target: '#signUpActor.resolved'
                        },
                        {
                            actions: [
                                'setRemoteError',
                                'sendUpdate'
                            ],
                            target: '#signUpActor.confirmSignUp'
                        }
                    ]
                }
            },
            signUp: {
                type: 'parallel',
                exit: 'clearTouched',
                on: {
                    FEDERATED_SIGN_IN: {
                        target: 'federatedSignIn'
                    }
                },
                states: {
                    validation: {
                        initial: 'pending',
                        states: {
                            pending: {
                                invoke: {
                                    src: 'validateSignUp',
                                    onDone: {
                                        actions: 'clearValidationError',
                                        target: 'valid'
                                    },
                                    onError: {
                                        actions: 'setFieldErrors',
                                        target: 'invalid'
                                    }
                                }
                            },
                            valid: {
                                entry: 'sendUpdate'
                            },
                            invalid: {
                                entry: 'sendUpdate'
                            }
                        },
                        on: {
                            BLUR: {
                                actions: 'handleBlur',
                                target: '.pending'
                            },
                            CHANGE: {
                                actions: 'handleInput',
                                target: '.pending'
                            }
                        }
                    },
                    submission: {
                        initial: 'idle',
                        states: {
                            idle: {
                                entry: [
                                    'sendUpdate'
                                ],
                                on: {
                                    SUBMIT: {
                                        actions: [
                                            'setSelectedAuthMethodFromForm',
                                            'handleSubmit'
                                        ],
                                        target: 'validate'
                                    }
                                }
                            },
                            validate: {
                                entry: 'sendUpdate',
                                invoke: {
                                    src: 'validateSignUp',
                                    onDone: {
                                        target: 'handleSignUp',
                                        actions: 'clearValidationError'
                                    },
                                    onError: {
                                        actions: 'setFieldErrors',
                                        target: 'idle'
                                    }
                                }
                            },
                            handleSignUp: {
                                tags: 'pending',
                                entry: [
                                    'setUsernameSignUp',
                                    'clearError'
                                ],
                                exit: 'sendUpdate',
                                invoke: {
                                    src: 'handleSignUp',
                                    onDone: [
                                        {
                                            cond: 'hasCompletedSignUp',
                                            actions: 'setNextSignUpStep',
                                            target: '#signUpActor.resolved'
                                        },
                                        {
                                            cond: 'shouldAutoSignIn',
                                            actions: 'setNextSignUpStep',
                                            target: '#signUpActor.autoSignIn'
                                        },
                                        {
                                            actions: [
                                                'setCodeDeliveryDetails',
                                                'setNextSignUpStep'
                                            ],
                                            target: '#signUpActor.init'
                                        }
                                    ],
                                    onError: {
                                        actions: [
                                            'sendUpdate',
                                            'setRemoteError'
                                        ],
                                        target: 'idle'
                                    }
                                }
                            }
                        }
                    }
                }
            },
            confirmSignUp: {
                initial: 'edit',
                entry: 'sendUpdate',
                states: {
                    edit: {
                        on: {
                            SUBMIT: {
                                actions: 'handleSubmit',
                                target: 'submit'
                            },
                            CHANGE: {
                                actions: 'handleInput'
                            },
                            BLUR: {
                                actions: 'handleBlur'
                            },
                            RESEND: '#signUpActor.resendSignUpCode'
                        }
                    },
                    submit: {
                        tags: 'pending',
                        entry: [
                            'clearError',
                            'sendUpdate'
                        ],
                        invoke: {
                            src: 'confirmSignUp',
                            onDone: [
                                {
                                    cond: 'shouldAutoSignIn',
                                    actions: [
                                        'setNextSignUpStep',
                                        'clearFormValues'
                                    ],
                                    target: '#signUpActor.autoSignIn'
                                },
                                {
                                    cond: 'shouldManualSignIn',
                                    actions: [
                                        'clearFormValues',
                                        'setSignInStep'
                                    ],
                                    target: '#signUpActor.resolved'
                                },
                                {
                                    actions: 'setNextSignUpStep',
                                    target: '#signUpActor.init'
                                }
                            ],
                            onError: {
                                actions: [
                                    'setRemoteError',
                                    'sendUpdate'
                                ],
                                target: 'edit'
                            }
                        }
                    }
                }
            },
            passkeyPrompt: {
                entry: 'sendUpdate',
                on: {
                    SKIP: {
                        actions: 'setConfirmAttributeCompleteStep',
                        target: 'resolved'
                    },
                    SUBMIT: {
                        actions: 'setConfirmAttributeCompleteStep',
                        target: 'resolved'
                    }
                }
            },
            resolved: {
                type: 'final',
                data: (context)=>({
                        challengeName: context.challengeName,
                        missingAttributes: context.missingAttributes,
                        remoteError: context.remoteError,
                        step: context.step,
                        totpSecretCode: context.totpSecretCode,
                        username: context.username,
                        unverifiedUserAttributes: context.unverifiedUserAttributes,
                        allowedMfaTypes: context.allowedMfaTypes
                    })
            }
        }
    }, {
        // sendUpdate is a HOC
        actions: {
            ...(0, $64ef23d998d8f5c7$export$2e2bcd8739ae039),
            sendUpdate: (0, $ce3108fccc482c97$export$7f8b724299523eb6)()
        },
        guards: (0, $c736c047e930e5f4$export$2e2bcd8739ae039),
        services: {
            autoSignIn () {
                return (0, $3eebb98ac5401111$export$c5378dc7d6787fa5)();
            },
            async fetchUserAttributes () {
                return (0, $c0cd52bad52ebf63$export$5dc95ecf3f16c6c9)();
            },
            confirmSignUp ({ formValues: formValues, username: username }) {
                const { confirmation_code: confirmationCode } = formValues;
                const input = {
                    username: username,
                    confirmationCode: confirmationCode
                };
                return services.handleConfirmSignUp(input);
            },
            resendSignUpCode ({ username: username }) {
                return services.handleResendSignUpCode({
                    username: username
                });
            },
            signInWithRedirect (_, { data: data }) {
                return (0, $6f84eeb20c8c9468$export$3d0a7d1372e866bb)(data);
            },
            handleSignUp (context) {
                const { formValues: formValues, loginMechanisms: loginMechanisms, username: username, selectedAuthMethod: selectedAuthMethod, preferredChallenge: preferredChallenge } = context;
                const loginMechanism = loginMechanisms[0];
                const authMethod = selectedAuthMethod ?? preferredChallenge;
                const input = (0, $c8aa466d6fbfe6bd$export$6bc605b0b68c7601)(username, formValues, loginMechanism, authMethod);
                return services.handleSignUp(input);
            },
            async validateSignUp (context) {
                // This needs to exist in the machine to reference new `services`
                return (0, $823a1d9578ae4f09$export$59e2b39f02edfada)(context.formValues, context.touched, context.passwordSettings, [
                    // Validation of password
                    services.validateFormPassword,
                    // Validation for default form fields
                    services.validateConfirmPassword,
                    services.validatePreferredUsername,
                    // Validation for required fields based on auth method
                    services.validateRequiredFieldsForAuthMethod,
                    // Validation for any custom Sign Up fields
                    services.validateCustomSignUp
                ]);
            }
        }
    });
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $cdabff1d8417d87c$export$d1b63878dfcc70a6() {
    return (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).Auth.clearCredentials();
}


















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a0085ee76401d60f$export$f8a4fedaab76b065 = async (store)=>{
    await store.clearOAuthData();
    (0, $3c6129946b01fbcd$export$66561e66d62991d0).clearTokens();
    await (0, $cdabff1d8417d87c$export$d1b63878dfcc70a6)();
    (0, $7c7b61d0858d9585$export$8c41bb232f1008b1).dispatch('auth', {
        event: 'signedOut'
    }, 'Auth', (0, $7c7b61d0858d9585$export$aadf71dd9875dd20));
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7a760a1ea8d00bb4$export$a20426d3d43ad21f = async (authConfig, preferPrivateSession = false, redirectUrl)=>{
    (0, $5c85900a0ff57646$export$c13e6dbaf90a8e5f)(authConfig);
    const { loginWith: loginWith, userPoolClientId: userPoolClientId } = authConfig;
    const { domain: domain, redirectSignOut: redirectSignOut } = loginWith.oauth;
    const signoutUri = (0, $126e34cf849d74c5$export$93832c3affb240d3)(redirectSignOut, redirectUrl);
    const oAuthLogoutEndpoint = `https://${domain}/logout?${Object.entries({
        client_id: userPoolClientId,
        logout_uri: encodeURIComponent(signoutUri)
    }).map(([k, v])=>`${k}=${v}`).join('&')}`;
    return (0, $39a566cced05f3c9$export$a673d54799039714)(oAuthLogoutEndpoint);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7dc1b4920d289a93$export$74290142c99a2f64 = async (cognitoConfig, store, tokenOrchestrator, redirectUrl)=>{
    const { isOAuthSignIn: isOAuthSignIn } = await store.loadOAuthSignIn();
    const oauthMetadata = await tokenOrchestrator.getOAuthMetadata();
    // Clear everything before attempting to visted logout endpoint since the current application
    // state could be wiped away on redirect
    await (0, $a0085ee76401d60f$export$f8a4fedaab76b065)(store);
    // The isOAuthSignIn flag is propagated by the oAuthToken store which manages oauth keys in local storage only.
    // These keys are used to determine if a user is in an inflight or signedIn oauth states.
    // However, this behavior represents an issue when 2 apps share the same set of tokens in Cookie storage because the app that didn't
    // start the OAuth will not have access to the oauth keys.
    // A heuristic solution is to add oauth metadata to the tokenOrchestrator which will have access to the underlying
    // storage mechanism that is used by Amplify.
    if (isOAuthSignIn || oauthMetadata?.oauthSignIn) // On web, this will always end up being a void action
    return (0, $7a760a1ea8d00bb4$export$a20426d3d43ad21f)(cognitoConfig, false, redirectUrl);
};

















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4255c97877878057$export$93ed00c43cc3ad50 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('RevokeToken'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0d2102e5c1581e7b$export$9ebd23b04fdf4c3a = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('GlobalSignOut'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0ae677266e10530e$var$logger = new (0, $294c375a4ec5088f$export$ba6a9c7ac8291f7f)('Auth');
/**
 * Signs a user out
 *
 * @param input - The SignOutInput object
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $0ae677266e10530e$export$b0ac3a1c242cb1ea(input) {
    const cognitoConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(cognitoConfig);
    if (input?.global) await $0ae677266e10530e$var$globalSignOut(cognitoConfig);
    else await $0ae677266e10530e$var$clientSignOut(cognitoConfig);
    let hasOAuthConfig;
    try {
        (0, $5c85900a0ff57646$export$c13e6dbaf90a8e5f)(cognitoConfig);
        hasOAuthConfig = true;
    } catch (err) {
        hasOAuthConfig = false;
    }
    if (hasOAuthConfig) {
        const oAuthStore = new (0, $42fbbaa41d94a4ff$export$9b2cef5d94f9b6e8)((0, $48e450c8813210c3$export$586b30dcaeecb901));
        oAuthStore.setAuthConfig(cognitoConfig);
        const { type: type } = await (0, $7dc1b4920d289a93$export$74290142c99a2f64)(cognitoConfig, oAuthStore, (0, $3c6129946b01fbcd$export$66561e66d62991d0), input?.oauth?.redirectUrl) ?? {};
        if (type === 'error') throw new (0, $6b5d16e8c6288a5f$export$145273558d58e0ac)({
            name: (0, $6c49017af88bac4c$export$625255707e22459c),
            message: `An error occurred when attempting to log out from OAuth provider.`
        });
    } else {
        // complete sign out
        (0, $3c6129946b01fbcd$export$66561e66d62991d0).clearTokens();
        await (0, $cdabff1d8417d87c$export$d1b63878dfcc70a6)();
        (0, $7c7b61d0858d9585$export$8c41bb232f1008b1).dispatch('auth', {
            event: 'signedOut'
        }, 'Auth', (0, $7c7b61d0858d9585$export$aadf71dd9875dd20));
    }
}
async function $0ae677266e10530e$var$clientSignOut(cognitoConfig) {
    try {
        const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId, userPoolClientId: userPoolClientId } = cognitoConfig;
        const authTokens = await (0, $3c6129946b01fbcd$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $6cdbc20a8ad3ee2e$export$be38b2d22222d505)(authTokens);
        if ($0ae677266e10530e$var$isSessionRevocable(authTokens.accessToken)) {
            const revokeToken = (0, $4255c97877878057$export$93ed00c43cc3ad50)({
                endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
                    endpointOverride: userPoolEndpoint
                })
            });
            await revokeToken({
                region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
                userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignOut)
            }, {
                ClientId: userPoolClientId,
                Token: authTokens.refreshToken
            });
        }
    } catch (err) {
        // this shouldn't throw
        $0ae677266e10530e$var$logger.debug('Client signOut error caught but will proceed with token removal');
    }
}
async function $0ae677266e10530e$var$globalSignOut(cognitoConfig) {
    try {
        const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = cognitoConfig;
        const authTokens = await (0, $3c6129946b01fbcd$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $6cdbc20a8ad3ee2e$export$77712ea5882cac9f)(authTokens);
        const globalSignOutClient = (0, $0d2102e5c1581e7b$export$9ebd23b04fdf4c3a)({
            endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        await globalSignOutClient({
            region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignOut)
        }, {
            AccessToken: authTokens.accessToken.toString()
        });
    } catch (err) {
        // it should not throw
        $0ae677266e10530e$var$logger.debug('Global signOut error caught but will proceed with token removal');
    }
}
const $0ae677266e10530e$var$isSessionRevocable = (token)=>!!token?.payload?.origin_jti;


const $012745cb209a95b9$export$2f15f45f1f7b7787 = ()=>{
    return (0, $15bb13904b1fd3cf$export$aaa7fa18f8e9b2e8)({
        initial: 'pending',
        id: 'signOutActor',
        predictableActionArguments: true,
        states: {
            pending: {
                tags: 'pending',
                invoke: {
                    src: 'signOut',
                    onDone: 'resolved',
                    onError: 'rejected'
                }
            },
            resolved: {
                type: 'final'
            },
            rejected: {
                type: 'final'
            }
        }
    }, {
        services: {
            signOut: ()=>(0, $0ae677266e10530e$export$b0ac3a1c242cb1ea)()
        }
    });
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetch the auth session including the tokens and credentials if they are available. By default it
 * will automatically refresh expired auth tokens if a valid refresh token is present. You can force a refresh
 * of non-expired tokens with `{ forceRefresh: true }` input.
 *
 * @param options - Options configuring the fetch behavior.
 * @throws {@link AuthError} - Throws error when session information cannot be refreshed.
 * @returns Promise<AuthSession>
 */ const $586898866ba92b93$export$39430dfe49142ae = (options)=>{
    return (0, $ab5acd7972ff939a$export$39430dfe49142ae)((0, $4e3539eda5094cb7$export$a3858a9a153cffc7), options);
};





















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $29a21328585b0348$export$76361ce6f84050b5 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('VerifyUserAttribute'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a user attribute with the confirmation code.
 *
 * @param input -  The ConfirmUserAttributeInput object
 * @throws  -{@link AuthValidationErrorCode } -
 * Thrown when `confirmationCode` is not defined.
 * @throws  -{@link VerifyUserAttributeException } - Thrown due to an invalid confirmation code or attribute.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $3665a199c4afef65$export$db3262544786991c(input) {
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = authConfig;
    const { confirmationCode: confirmationCode, userAttributeKey: userAttributeKey } = input;
    (0, $b8b9ab4ec1557efa$export$45936001d12f9b53)(!!confirmationCode, (0, $a5f802e0bb2944ff$export$12d5c695b2213c4a).EmptyConfirmUserAttributeCode);
    const { tokens: tokens } = await (0, $586898866ba92b93$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $6cdbc20a8ad3ee2e$export$77712ea5882cac9f)(tokens);
    const verifyUserAttribute = (0, $29a21328585b0348$export$76361ce6f84050b5)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    await verifyUserAttribute({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmUserAttribute)
    }, {
        AccessToken: tokens.accessToken.toString(),
        AttributeName: userAttributeKey,
        Code: confirmationCode
    });
}




















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $bf51af06f570682a$export$59ccb8aa6646ad4 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('GetUserAttributeVerificationCode'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resends user's confirmation code when updating attributes while authenticated.
 *
 * @param input - The SendUserAttributeVerificationCodeInput object
 * @returns SendUserAttributeVerificationCodeOutput
 * @throws - {@link GetUserAttributeVerificationException}
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $baccecb40b6c0d83$export$fa66ca482758432e = async (input)=>{
    const { userAttributeKey: userAttributeKey, options: options } = input;
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const clientMetadata = options?.clientMetadata;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = authConfig;
    const { tokens: tokens } = await (0, $586898866ba92b93$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $6cdbc20a8ad3ee2e$export$77712ea5882cac9f)(tokens);
    const getUserAttributeVerificationCode = (0, $bf51af06f570682a$export$59ccb8aa6646ad4)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { CodeDeliveryDetails: CodeDeliveryDetails } = await getUserAttributeVerificationCode({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).SendUserAttributeVerificationCode)
    }, {
        AccessToken: tokens.accessToken.toString(),
        ClientMetadata: clientMetadata,
        AttributeName: userAttributeKey
    });
    const { DeliveryMedium: DeliveryMedium, AttributeName: AttributeName, Destination: Destination } = {
        ...CodeDeliveryDetails
    };
    return {
        destination: Destination,
        deliveryMedium: DeliveryMedium,
        attributeName: AttributeName
    };
};





function $800240bdb8836e80$export$15cd9b2846733edf() {
    return (0, $15bb13904b1fd3cf$export$aaa7fa18f8e9b2e8)({
        id: 'verifyUserAttributesActor',
        initial: 'selectUserAttributes',
        predictableActionArguments: true,
        states: {
            selectUserAttributes: {
                initial: 'edit',
                exit: [
                    'clearError',
                    'clearTouched',
                    'sendUpdate'
                ],
                states: {
                    edit: {
                        entry: 'sendUpdate',
                        on: {
                            SUBMIT: {
                                actions: 'handleSubmit',
                                target: 'submit'
                            },
                            SKIP: {
                                target: '#verifyUserAttributesActor.resolved'
                            },
                            CHANGE: {
                                actions: 'handleInput'
                            }
                        }
                    },
                    submit: {
                        tags: 'pending',
                        entry: [
                            'clearError',
                            'sendUpdate'
                        ],
                        invoke: {
                            src: 'sendUserAttributeVerificationCode',
                            onDone: {
                                actions: [
                                    'setSelectedUserAttribute',
                                    'setCodeDeliveryDetails'
                                ],
                                target: '#verifyUserAttributesActor.confirmVerifyUserAttribute'
                            },
                            onError: {
                                actions: 'setRemoteError',
                                target: 'edit'
                            }
                        }
                    }
                }
            },
            confirmVerifyUserAttribute: {
                initial: 'edit',
                exit: [
                    'clearError',
                    'clearFormValues',
                    'clearTouched'
                ],
                states: {
                    edit: {
                        entry: 'sendUpdate',
                        on: {
                            SUBMIT: {
                                actions: 'handleSubmit',
                                target: 'submit'
                            },
                            SKIP: '#verifyUserAttributesActor.resolved',
                            CHANGE: {
                                actions: 'handleInput'
                            }
                        }
                    },
                    submit: {
                        tags: 'pending',
                        entry: [
                            'clearError',
                            'sendUpdate'
                        ],
                        invoke: {
                            src: 'confirmVerifyUserAttribute',
                            onDone: {
                                actions: [
                                    'setConfirmAttributeCompleteStep',
                                    'clearSelectedUserAttribute'
                                ],
                                target: '#verifyUserAttributesActor.resolved'
                            },
                            onError: {
                                actions: 'setRemoteError',
                                target: 'edit'
                            }
                        }
                    }
                }
            },
            resolved: {
                type: 'final',
                data: ({ step: step })=>({
                        step: step
                    })
            }
        }
    }, {
        // sendUpdate is a HOC
        actions: {
            ...(0, $64ef23d998d8f5c7$export$2e2bcd8739ae039),
            sendUpdate: (0, $ce3108fccc482c97$export$7f8b724299523eb6)()
        },
        services: {
            sendUserAttributeVerificationCode ({ formValues: { unverifiedAttr: unverifiedAttr } }) {
                const input = {
                    userAttributeKey: unverifiedAttr
                };
                return (0, $baccecb40b6c0d83$export$fa66ca482758432e)(input);
            },
            async confirmVerifyUserAttribute ({ formValues: { confirmation_code: confirmationCode }, selectedUserAttribute: selectedUserAttribute }) {
                const input = {
                    confirmationCode: confirmationCode,
                    userAttributeKey: selectedUserAttribute
                };
                return (0, $3665a199c4afef65$export$db3262544786991c)(input);
            },
            async validateFields (context) {
                return (0, $823a1d9578ae4f09$export$59e2b39f02edfada)(context.formValues, context.touched, context.passwordSettings, [
                    (0, $74c4c42c59a292e1$export$7ae2d201ca9520b).validateFormPassword,
                    (0, $74c4c42c59a292e1$export$7ae2d201ca9520b).validateConfirmPassword
                ]);
            }
        }
    });
}




const $41c72a7eca42464e$var$getActorContext = (context, defaultStep)=>{
    const availableAuthMethods = (0, $c8aa466d6fbfe6bd$export$3c35915b968f3769)(context.passwordlessCapabilities, context.config?.passwordless?.hiddenAuthMethods);
    // Determine effective preferred challenge: component prop takes precedence over backend config
    const preferredChallenge = context.config?.passwordless?.preferredAuthMethod ?? context.passwordlessCapabilities?.preferredChallenge;
    return {
        ...context.actorDoneData,
        step: context?.actorDoneData?.step ?? defaultStep,
        // initialize empty objects on actor start
        formValues: {},
        touched: {},
        validationError: {},
        // values included on `context.config` that should be available in actors
        formFields: context.config?.formFields,
        loginMechanisms: context.config?.loginMechanisms,
        passwordSettings: context.config?.passwordSettings,
        signUpAttributes: context.config?.signUpAttributes,
        socialProviders: context.config?.socialProviders,
        availableAuthMethods: availableAuthMethods,
        preferredChallenge: preferredChallenge,
        passwordless: context.config?.passwordless
    };
};
const { choose: $41c72a7eca42464e$var$choose, stop: $41c72a7eca42464e$var$stop } = (0, $673da5a8478f7656$exports);
const $41c72a7eca42464e$var$stopActor = (machineId)=>$41c72a7eca42464e$var$stop(machineId);
// setup step waits for ui to emit INIT action to proceed to configure
const $41c72a7eca42464e$var$LEGACY_WAIT_CONFIG = {
    on: {
        INIT: {
            actions: 'configure',
            target: 'getConfig'
        },
        SIGN_OUT: '#authenticator.signOut'
    }
};
// setup step proceeds directly to configure
const $41c72a7eca42464e$var$NEXT_WAIT_CONFIG = {
    always: {
        actions: 'configure',
        target: 'getConfig'
    }
};
function $41c72a7eca42464e$export$af98f08c6e0e0d4d(options) {
    const { useNextWaitConfig: useNextWaitConfig, ...overrideConfigServices } = options ?? {};
    const initConfig = useNextWaitConfig ? $41c72a7eca42464e$var$NEXT_WAIT_CONFIG : $41c72a7eca42464e$var$LEGACY_WAIT_CONFIG;
    return (0, $15bb13904b1fd3cf$export$aaa7fa18f8e9b2e8)({
        id: 'authenticator',
        initial: 'idle',
        context: {
            user: undefined,
            config: {},
            services: (0, $74c4c42c59a292e1$export$7ae2d201ca9520b),
            actorRef: undefined,
            hasSetup: false
        },
        predictableActionArguments: true,
        states: {
            // See: https://xstate.js.org/docs/guides/communication.html#invoking-promises
            idle: {
                invoke: {
                    src: 'handleGetCurrentUser',
                    onDone: {
                        actions: 'setUser',
                        target: 'setup'
                    },
                    onError: {
                        target: 'setup'
                    }
                }
            },
            setup: {
                initial: 'initConfig',
                states: {
                    initConfig: initConfig,
                    getConfig: {
                        invoke: {
                            src: 'getAmplifyConfig',
                            onDone: [
                                {
                                    actions: [
                                        'applyAmplifyConfig',
                                        'setHasSetup'
                                    ],
                                    cond: 'hasUser',
                                    target: '#authenticator.authenticated'
                                },
                                {
                                    actions: [
                                        'applyAmplifyConfig',
                                        'setHasSetup'
                                    ],
                                    target: 'goToInitialState'
                                }
                            ]
                        }
                    },
                    goToInitialState: {
                        always: [
                            {
                                cond: 'isInitialStateSignUp',
                                target: '#authenticator.signUpActor'
                            },
                            {
                                cond: 'isInitialStateResetPassword',
                                target: '#authenticator.forgotPasswordActor'
                            },
                            {
                                target: '#authenticator.signInActor'
                            }
                        ]
                    }
                }
            },
            getCurrentUser: {
                invoke: {
                    src: 'handleGetCurrentUser',
                    onDone: {
                        actions: 'setUser',
                        target: '#authenticator.authenticated'
                    },
                    onError: {
                        target: '#authenticator.setup'
                    }
                }
            },
            signInActor: {
                initial: 'spawnActor',
                states: {
                    spawnActor: {
                        always: {
                            actions: 'spawnSignInActor',
                            target: 'runActor'
                        }
                    },
                    runActor: {
                        entry: 'clearActorDoneData',
                        exit: $41c72a7eca42464e$var$stopActor('signInActor')
                    }
                },
                on: {
                    FORGOT_PASSWORD: 'forgotPasswordActor',
                    SELECT_METHOD: {
                        actions: 'forwardToActor'
                    },
                    SHOW_AUTH_METHODS: {
                        actions: 'forwardToActor'
                    },
                    SIGN_IN: 'signInActor',
                    SIGN_UP: 'signUpActor',
                    'done.invoke.signInActor': [
                        {
                            cond: 'hasCompletedAttributeConfirmation',
                            target: '#authenticator.getCurrentUser'
                        },
                        {
                            cond: 'isShouldConfirmUserAttributeStep',
                            actions: 'setActorDoneData',
                            target: '#authenticator.verifyUserAttributesActor'
                        },
                        {
                            cond: 'isResetPasswordStep',
                            actions: 'setActorDoneData',
                            target: '#authenticator.forgotPasswordActor'
                        },
                        {
                            cond: 'isConfirmSignUpStep',
                            actions: 'setActorDoneData',
                            target: '#authenticator.signUpActor'
                        }
                    ]
                }
            },
            signUpActor: {
                initial: 'spawnActor',
                states: {
                    spawnActor: {
                        always: {
                            actions: 'spawnSignUpActor',
                            target: 'runActor'
                        }
                    },
                    runActor: {
                        entry: 'clearActorDoneData',
                        exit: $41c72a7eca42464e$var$stopActor('signUpActor')
                    }
                },
                on: {
                    SIGN_IN: 'signInActor',
                    'done.invoke.signUpActor': [
                        {
                            cond: 'hasCompletedAttributeConfirmation',
                            target: '#authenticator.getCurrentUser'
                        },
                        {
                            cond: 'isShouldConfirmUserAttributeStep',
                            actions: 'setActorDoneData',
                            target: '#authenticator.verifyUserAttributesActor'
                        },
                        {
                            cond: 'isConfirmUserAttributeStep',
                            target: '#authenticator.verifyUserAttributesActor'
                        },
                        {
                            actions: 'setActorDoneData',
                            target: '#authenticator.signInActor'
                        }
                    ]
                }
            },
            forgotPasswordActor: {
                initial: 'spawnActor',
                states: {
                    spawnActor: {
                        always: {
                            actions: 'spawnForgotPasswordActor',
                            target: 'runActor'
                        }
                    },
                    runActor: {
                        entry: 'clearActorDoneData',
                        exit: $41c72a7eca42464e$var$stopActor('forgotPasswordActor')
                    }
                },
                on: {
                    SIGN_IN: 'signInActor',
                    'done.invoke.forgotPasswordActor': [
                        {
                            target: '#authenticator.signInActor'
                        }
                    ]
                }
            },
            verifyUserAttributesActor: {
                initial: 'spawnActor',
                states: {
                    spawnActor: {
                        always: {
                            actions: 'spawnVerifyUserAttributesActor',
                            target: 'runActor'
                        }
                    },
                    runActor: {
                        entry: 'clearActorDoneData',
                        exit: $41c72a7eca42464e$var$stopActor('verifyUserAttributesActor')
                    }
                },
                on: {
                    'done.invoke.verifyUserAttributesActor': [
                        {
                            actions: 'setActorDoneData',
                            target: '#authenticator.getCurrentUser'
                        }
                    ]
                }
            },
            authenticated: {
                initial: 'idle',
                states: {
                    idle: {
                        on: {
                            TOKEN_REFRESH: 'refreshUser'
                        }
                    },
                    refreshUser: {
                        invoke: {
                            src: '#authenticator.getCurrentUser',
                            onDone: {
                                actions: 'setUser',
                                target: 'idle'
                            },
                            onError: {
                                target: '#authenticator.signOut'
                            }
                        }
                    }
                },
                on: {
                    SIGN_OUT: 'signOut'
                }
            },
            signOut: {
                initial: 'spawnActor',
                states: {
                    spawnActor: {
                        always: {
                            actions: 'spawnSignOutActor',
                            target: 'runActor'
                        }
                    },
                    runActor: {
                        entry: 'clearActorDoneData',
                        exit: $41c72a7eca42464e$var$stopActor('signOutActor')
                    }
                },
                on: {
                    'done.invoke.signOutActor': {
                        actions: 'clearUser',
                        target: 'setup.getConfig'
                    }
                }
            }
        },
        on: {
            SIGN_IN_WITH_REDIRECT: {
                target: '#authenticator.getCurrentUser'
            },
            CHANGE: {
                actions: 'forwardToActor'
            },
            BLUR: {
                actions: 'forwardToActor'
            },
            SUBMIT: {
                actions: 'forwardToActor'
            },
            FEDERATED_SIGN_IN: {
                actions: 'forwardToActor'
            },
            RESEND: {
                actions: 'forwardToActor'
            },
            SIGN_IN: {
                actions: 'forwardToActor'
            },
            SKIP: {
                actions: 'forwardToActor'
            }
        }
    }, {
        actions: {
            ...(0, $64ef23d998d8f5c7$export$2e2bcd8739ae039),
            forwardToActor: $41c72a7eca42464e$var$choose([
                {
                    cond: 'hasActor',
                    actions: (0, $ce3108fccc482c97$export$eb147b7589db8e8a)(({ actorRef: actorRef })=>actorRef)
                }
            ]),
            setActorDoneData: (0, $ce3108fccc482c97$export$e6e34fd1f2686227)({
                actorDoneData: (_, event)=>({
                        challengeName: event.data.challengeName,
                        codeDeliveryDetails: event.data.codeDeliveryDetails,
                        missingAttributes: event.data.missingAttributes,
                        remoteError: event.data.remoteError,
                        username: event.data.username,
                        step: event.data.step,
                        totpSecretCode: event.data.totpSecretCode,
                        unverifiedUserAttributes: event.data.unverifiedUserAttributes,
                        allowedMfaTypes: event.data.allowedMfaTypes
                    })
            }),
            applyAmplifyConfig: (0, $ce3108fccc482c97$export$e6e34fd1f2686227)({
                passwordlessCapabilities: (_, { data: cliConfig })=>cliConfig.passwordlessCapabilities,
                config (context, { data: cliConfig }) {
                    // Prefer explicitly configured settings over default CLI values\
                    const { loginMechanisms: loginMechanisms = cliConfig.loginMechanisms ?? [], signUpAttributes: signUpAttributes = cliConfig.signUpAttributes ?? [], socialProviders: socialProviders = cliConfig.socialProviders ?? [], initialState: initialState, formFields: _formFields, passwordSettings: passwordSettings = cliConfig.passwordFormat ?? {}, passwordless: passwordless } = context.config;
                    // By default, Cognito assumes `username`, so there isn't a different username attribute like `email`.
                    // We explicitly add it as a login mechanism to be consistent with Admin UI's language.
                    if (loginMechanisms.length === 0) loginMechanisms.push('username');
                    const formFields = $41c72a7eca42464e$var$convertFormFields(_formFields) ?? {};
                    return {
                        formFields: formFields,
                        initialState: initialState,
                        loginMechanisms: loginMechanisms,
                        passwordSettings: passwordSettings,
                        passwordless: passwordless,
                        signUpAttributes: signUpAttributes,
                        socialProviders: socialProviders
                    };
                }
            }),
            spawnSignInActor: (0, $ce3108fccc482c97$export$e6e34fd1f2686227)({
                actorRef: (context, _)=>{
                    const { services: services } = context;
                    const actor = (0, $ee80a0a5495650ae$export$f9c30eaa77191700)({
                        services: services
                    }).withContext($41c72a7eca42464e$var$getActorContext(context, 'SIGN_IN'));
                    return (0, $d85a79a5044f63e6$export$1713f5ac2bf0caf5)(actor, {
                        name: 'signInActor'
                    });
                }
            }),
            spawnSignUpActor: (0, $ce3108fccc482c97$export$e6e34fd1f2686227)({
                actorRef: (context, _)=>{
                    const { services: services } = context;
                    const actor = (0, $c8ba0bafe1f65301$export$6cf61434854181b4)({
                        services: services
                    }).withContext($41c72a7eca42464e$var$getActorContext(context, 'SIGN_UP'));
                    return (0, $d85a79a5044f63e6$export$1713f5ac2bf0caf5)(actor, {
                        name: 'signUpActor'
                    });
                }
            }),
            spawnForgotPasswordActor: (0, $ce3108fccc482c97$export$e6e34fd1f2686227)({
                actorRef: (context, _)=>{
                    const { services: services } = context;
                    const actor = (0, $385d2ee3594940bd$export$d384478d1c0083d2)({
                        services: services
                    }).withContext($41c72a7eca42464e$var$getActorContext(context, 'FORGOT_PASSWORD'));
                    return (0, $d85a79a5044f63e6$export$1713f5ac2bf0caf5)(actor, {
                        name: 'forgotPasswordActor'
                    });
                }
            }),
            spawnVerifyUserAttributesActor: (0, $ce3108fccc482c97$export$e6e34fd1f2686227)({
                actorRef: (context)=>{
                    const actor = (0, $800240bdb8836e80$export$15cd9b2846733edf)().withContext($41c72a7eca42464e$var$getActorContext(context));
                    return (0, $d85a79a5044f63e6$export$1713f5ac2bf0caf5)(actor, {
                        name: 'verifyUserAttributesActor'
                    });
                }
            }),
            spawnSignOutActor: (0, $ce3108fccc482c97$export$e6e34fd1f2686227)({
                actorRef: (context)=>{
                    const actor = (0, $012745cb209a95b9$export$2f15f45f1f7b7787)().withContext({
                        user: context?.user
                    });
                    return (0, $d85a79a5044f63e6$export$1713f5ac2bf0caf5)(actor, {
                        name: 'signOutActor'
                    });
                }
            }),
            configure: (0, $ce3108fccc482c97$export$e6e34fd1f2686227)((_, event)=>{
                const { services: customServices, ...config } = !(0, $fd30e9352c42562e$export$83b788b1a3698c03)(overrideConfigServices) ? overrideConfigServices : event.data ?? {};
                return {
                    services: {
                        ...(0, $74c4c42c59a292e1$export$7ae2d201ca9520b),
                        ...customServices
                    },
                    config: config
                };
            }),
            setHasSetup: (0, $ce3108fccc482c97$export$e6e34fd1f2686227)({
                hasSetup: true
            })
        },
        guards: {
            ...(0, $c736c047e930e5f4$export$2e2bcd8739ae039),
            hasActor: ({ actorRef: actorRef })=>!!actorRef,
            isInitialStateSignUp: ({ config: config })=>config.initialState === 'signUp',
            isInitialStateResetPassword: ({ config: config })=>config.initialState === 'forgotPassword',
            shouldSetup: ({ hasSetup: hasSetup })=>!hasSetup,
            hasUser: ({ user: user })=>{
                return !!user;
            }
        },
        services: {
            getAmplifyConfig: ({ services: services })=>services.getAmplifyConfig(),
            handleGetCurrentUser: ({ services: services })=>services.getCurrentUser()
        }
    });
}
function $41c72a7eca42464e$var$convertFormFields(formFields) {
    if (formFields) Object.keys(formFields).forEach((component)=>{
        Object.keys(formFields[component]).forEach((inputName)=>{
            let ff = formFields[component][inputName];
            ff.required = ff.isRequired;
        });
    });
    return formFields;
}





/**
 * Handles Amplify JS Auth hub events, by forwarding hub events as appropriate
 * xstate events.
 */ const $4c8ca74758712415$export$f726708373635d8a = ({ payload: payload }, service, options)=>{
    const { data: data, event: event } = payload;
    const { send: send } = service;
    const { onSignIn: onSignIn, onSignOut: onSignOut } = options ?? {};
    switch(event){
        case 'signedIn':
            if ((0, $fd30e9352c42562e$export$f6e2535fb5126e54)(onSignIn)) onSignIn(payload);
            break;
        case 'signInWithRedirect':
            send('SIGN_IN_WITH_REDIRECT');
            break;
        case 'signedOut':
            if ((0, $fd30e9352c42562e$export$f6e2535fb5126e54)(onSignOut)) onSignOut();
            send('SIGN_OUT');
            break;
        case 'tokenRefresh_failure':
            if (data?.error?.name === (0, $0f90bdfda3f0916b$export$4e712df6b850c8d0).NetworkError) return;
            send('SIGN_OUT');
            break;
    }
};
/**
 * Listens to external auth Hub events and sends corresponding event to
 * the `service.send` of interest
 *
 * @param service - contains state machine `send` function
 * @param handler - auth event handler
 * @returns function that unsubscribes to the hub evenmt
 */ const $4c8ca74758712415$export$4776c363cae9362c = (service, handler = $4c8ca74758712415$export$f726708373635d8a)=>{
    const eventHandler = (data)=>handler(data, service);
    return (0, $7c7b61d0858d9585$export$8c41bb232f1008b1).listen('auth', eventHandler, 'authenticator-hub-handler');
};



var $6aRB8 = parcelRequire("6aRB8");
/**
 * AuthenticatorContext serves static reference to the auth machine service.
 *
 * https://xstate.js.org/docs/recipes/react.html#context-provider
 */ const $a62a00af9a1a28f6$export$2254a7bd02a5abf7 = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createContext(null);


const $3ac0cda803dc6fc4$var$createHubHandler = (options)=>(data, service)=>{
        (0, $4c8ca74758712415$export$f726708373635d8a)(data, service, options);
    };
function $3ac0cda803dc6fc4$export$2e2bcd8739ae039({ children: children }) {
    // `authStatus` is exposed by `useAuthenticator` but should not be derived directly from the
    // state machine as the machine only updates on `Authenticator` initiated events, which
    // leads to scenarios where the state machine `authStatus` gets "stuck". For exmample,
    // if a user was to sign in using `Auth.signIn` directly rather than using `Authenticator`
    const [authStatus, setAuthStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useState('configuring');
    // only run on first render
    (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useEffect(()=>{
        (0, $52783992aa7f744e$export$e5432d4c8eb97ea7)().then(()=>{
            setAuthStatus('authenticated');
        }).catch(()=>{
            setAuthStatus('unauthenticated');
        });
    }, []);
    /**
     * Based on use cases, developer might already have added another Provider
     * outside Authenticator. In that case, we sync the two providers by just
     * passing the parent value.
     *
     * TODO(BREAKING): enforce only one provider in App tree
     */ const parentProviderVal = (0, $6aRB8.useContext)((0, $a62a00af9a1a28f6$export$2254a7bd02a5abf7));
    const service = (0, $ee9601896ba21c96$export$d9e9b060fbbae528)((0, $41c72a7eca42464e$export$af98f08c6e0e0d4d));
    const value = (0, $6aRB8.useMemo)(()=>parentProviderVal ?? {
            authStatus: authStatus,
            service: service
        }, [
        authStatus,
        parentProviderVal,
        service
    ]);
    const { service: activeService } = value;
    (0, $6aRB8.useEffect)(()=>{
        const onSignIn = ()=>{
            setAuthStatus('authenticated');
        };
        const onSignOut = ()=>{
            setAuthStatus('unauthenticated');
        };
        const unsubscribe = (0, $4c8ca74758712415$export$4776c363cae9362c)(activeService, $3ac0cda803dc6fc4$var$createHubHandler({
            onSignIn: onSignIn,
            onSignOut: onSignOut
        }));
        return unsubscribe;
    }, [
        activeService
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $a62a00af9a1a28f6$export$2254a7bd02a5abf7).Provider, {
        value: value
    }, children);
}


var $6aRB8 = parcelRequire("6aRB8");

var $6aRB8 = parcelRequire("6aRB8");
var $34ababfc3ee2dd23$exports = {};
'use strict';

$34ababfc3ee2dd23$exports = (parcelRequire("kaWlt"));



var $6aRB8 = parcelRequire("6aRB8");




var $133fc242d663e257$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $133fc242d663e257$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $133fc242d663e257$export$b29f828819edca8d(items, predicate) {
    var e_1, _a;
    var _b = $133fc242d663e257$var$__read([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = $133fc242d663e257$var$__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $133fc242d663e257$export$2b6ccfda635c9803(service) {
    return service.status !== 0 ? service.getSnapshot() : service.machine.initialState;
}
// From https://github.com/reduxjs/react-redux/blob/master/src/utils/shallowEqual.ts
function $133fc242d663e257$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $133fc242d663e257$export$d36bdfa510afb180(objA, objB) {
    if ($133fc242d663e257$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$133fc242d663e257$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $133fc242d663e257$export$ab21a1e7bed2882e(actor) {
    return 'state' in actor && 'machine' in actor;
}
function $133fc242d663e257$export$3496c38320247757(service, prevState, nextState) {
    if (service.status === (0, $d85a79a5044f63e6$export$7a567c9c5088a551).NotStarted) return true;
    // Only change the current state if:
    // - the incoming state is the "live" initial state (since it might have new actors)
    // - OR the incoming state actually changed.
    //
    // The "live" initial state will have .changed === undefined.
    var initialStateChanged = nextState.changed === undefined && (Object.keys(nextState.children).length > 0 || typeof prevState.changed === 'boolean');
    return !(nextState.changed || initialStateChanged);
}


function $9f42f787da262388$var$identity(a) {
    return a;
}
function $9f42f787da262388$export$656eb38a7c1ce0b6(actorRef) {
    return 'state' in actorRef;
}
function $9f42f787da262388$var$isDeferredActor(actorRef) {
    return 'deferred' in actorRef;
}
function $9f42f787da262388$var$defaultGetSnapshot(actorRef) {
    return 'getSnapshot' in actorRef ? (0, $133fc242d663e257$export$ab21a1e7bed2882e)(actorRef) ? (0, $133fc242d663e257$export$2b6ccfda635c9803)(actorRef) : actorRef.getSnapshot() : $9f42f787da262388$export$656eb38a7c1ce0b6(actorRef) ? actorRef.state : undefined;
}
function $9f42f787da262388$export$25c4ab29592aabd9(actorRef, getSnapshot) {
    if (getSnapshot === void 0) getSnapshot = $9f42f787da262388$var$defaultGetSnapshot;
    var actorRefRef = (0, $6aRB8.useRef)(actorRef);
    var deferredEventsRef = (0, $6aRB8.useRef)([]);
    var subscribe = (0, $6aRB8.useCallback)(function(handleStoreChange) {
        var unsubscribe = actorRef.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        actorRef
    ]);
    var boundGetSnapshot = (0, $6aRB8.useCallback)(function() {
        return getSnapshot(actorRef);
    }, [
        actorRef,
        getSnapshot
    ]);
    var isEqual = (0, $6aRB8.useCallback)(function(prevState, nextState) {
        if ((0, $133fc242d663e257$export$ab21a1e7bed2882e)(actorRef)) return (0, $133fc242d663e257$export$3496c38320247757)(actorRef, prevState, nextState);
        return prevState === nextState;
    }, [
        actorRef
    ]);
    var storeSnapshot = (0, $34ababfc3ee2dd23$exports.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, $9f42f787da262388$var$identity, isEqual);
    var send = (0, $38bf2de1fea6698f$export$2e2bcd8739ae039)(function() {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var event = args[0];
            var currentActorRef = actorRefRef.current;
            // If the previous actor is a deferred actor,
            // queue the events so that they can be replayed
            // on the non-deferred actor.
            if ($9f42f787da262388$var$isDeferredActor(currentActorRef) && currentActorRef.deferred) deferredEventsRef.current.push(event);
            else currentActorRef.send(event);
        };
    });
    (0, $d1ed4a9ded341161$export$2e2bcd8739ae039)(function() {
        actorRefRef.current = actorRef;
        // Dequeue deferred events from the previous deferred actorRef
        while(deferredEventsRef.current.length > 0){
            var deferredEvent = deferredEventsRef.current.shift();
            actorRef.send(deferredEvent);
        }
    }, [
        actorRef
    ]);
    return [
        storeSnapshot,
        send
    ];
}



var $27e4649a9dcd71fe$var$defaultCompare = function(a, b) {
    return a === b;
};
var $27e4649a9dcd71fe$var$defaultGetSnapshot = function(a, initialStateCacheRef) {
    if ((0, $133fc242d663e257$export$ab21a1e7bed2882e)(a)) {
        // A status of 0 = interpreter not started
        if (a.status === 0 && initialStateCacheRef.current) return initialStateCacheRef.current;
        var snapshot = (0, $133fc242d663e257$export$2b6ccfda635c9803)(a);
        initialStateCacheRef.current = a.status === 0 ? snapshot : null;
        return snapshot;
    }
    return (0, $9f42f787da262388$export$656eb38a7c1ce0b6)(a) ? a.state : undefined;
};
function $27e4649a9dcd71fe$export$2105062e25df4afe(actor, selector, compare, getSnapshot) {
    if (compare === void 0) compare = $27e4649a9dcd71fe$var$defaultCompare;
    var initialStateCacheRef = (0, $6aRB8.useRef)(null);
    var subscribe = (0, $6aRB8.useCallback)(function(handleStoreChange) {
        var unsubscribe = actor.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        actor
    ]);
    var boundGetSnapshot = (0, $6aRB8.useCallback)(function() {
        if (getSnapshot) return getSnapshot(actor);
        return $27e4649a9dcd71fe$var$defaultGetSnapshot(actor, initialStateCacheRef);
    }, [
        actor,
        getSnapshot
    ]);
    var selectedSnapshot = (0, $34ababfc3ee2dd23$exports.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
    return selectedSnapshot;
}


/**
 * This file contains helpers that lets you easily access current actor's state
 * and context.
 */ /**
 * Get the state of current actor. This is useful for checking which screen
 * to render: e.g. `getActorState(state).matches('confirmSignUp.edit').
 */ const $496812a4ac8d01c5$export$99a4282e2c3b772d = (state)=>{
    return state.context.actorRef?.getSnapshot();
};
/**
 * Get the context of current actor. Useful for getting any nested context
 * like remoteError.
 */ const $496812a4ac8d01c5$export$c39505fa2700473f = (state)=>{
    return $496812a4ac8d01c5$export$99a4282e2c3b772d(state)?.context;
};



const $f2ea8eb89d77bec1$export$da6d2f7032b7150b = (state, actorState)=>{
    // 'federatedSignIn' exists as a state on both the 'signInActor' and 'signUpActor',
    // match against the `actorState` initially to determine if the federated sign in flow
    // has begun, then which actor has begun the flow and return the corresponding `route`
    if (actorState?.matches('federatedSignIn')) {
        if (state.matches('signUpActor')) return 'signUp';
        if (state.matches('signInActor')) return 'signIn';
    }
    switch(true){
        case state.matches('idle'):
            return 'idle';
        case state.matches('setup'):
            return 'setup';
        case state.matches('signOut'):
            return 'signOut';
        case state.matches('authenticated'):
            return 'authenticated';
        case actorState?.matches('confirmSignUp'):
        case actorState?.matches('resendSignUpCode'):
            return 'confirmSignUp';
        case actorState?.matches('confirmSignIn'):
            return 'confirmSignIn';
        case actorState?.matches('setupTotp.edit'):
        case actorState?.matches('setupTotp.submit'):
            return 'setupTotp';
        case actorState?.matches('signIn.submit'):
            return actorState?.context.selectedAuthMethod != null ? 'signInSelectAuthFactor' : 'signIn';
        case actorState?.matches('signIn.selectMethod'):
            return 'signInSelectAuthFactor';
        case actorState?.matches('passkeyPrompt'):
            return 'passkeyPrompt';
        case actorState?.matches('signIn'):
            return 'signIn';
        case actorState?.matches('signUp'):
        case actorState?.matches('autoSignIn'):
            return 'signUp';
        case actorState?.matches('forceChangePassword'):
            return 'forceNewPassword';
        case actorState?.matches('forgotPassword'):
            return 'forgotPassword';
        case actorState?.matches('confirmResetPassword'):
            return 'confirmResetPassword';
        case actorState?.matches('selectUserAttributes'):
            return 'verifyUser';
        case actorState?.matches('confirmVerifyUserAttribute'):
            return 'confirmVerifyUser';
        case actorState?.matches('setupEmail'):
            return 'setupEmail';
        case actorState?.matches('selectMfaType'):
            return 'selectMfaType';
        case state.matches('getCurrentUser'):
        case actorState?.matches('fetchUserAttributes'):
            /**
             * This route is needed for autoSignIn to capture both the
             * autoSignIn.pending and the resolved states when the
             * signIn actor is running.
             */ return 'transition';
        default:
            return null;
    }
};


/**
 * This file contains helpers that translates xstate internals to more
 * understandable authenticator contexts. We provide these contexts with
 * `useAuthenticator` hook/composable/service.
 */ /**
 * Creates public facing auth helpers that abstracts out xstate implementation
 * detail. Each framework implementation can export these helpers so that
 * developers can send events without having to learn internals.
 *
 * ```
 * const [state, send] = useActor(...);
 * const { submit } = getSendEventAliases(send);
 * submit({ username, password})
 * ```
 */ const $d37b17a31b839403$export$2def2023b76dbf7d = (send)=>{
    const sendToMachine = (type)=>{
        // TODO If these were created during the creation of the machine & provider,
        // then invalid transitions could be caught via https://xstate.js.org/docs/guides/states.html#state-can-event
        return (data)=>send({
                type: type,
                data: data
            });
    };
    return {
        initializeMachine: sendToMachine('INIT'),
        resendCode: sendToMachine('RESEND'),
        selectAuthMethod: sendToMachine('SELECT_METHOD'),
        signOut: sendToMachine('SIGN_OUT'),
        submitForm: sendToMachine('SUBMIT'),
        toShowAuthMethods: sendToMachine('SHOW_AUTH_METHODS'),
        updateForm: sendToMachine('CHANGE'),
        updateBlur: sendToMachine('BLUR'),
        // Actions that don't immediately invoke a service but instead transition to a screen
        // are prefixed with `to*`
        toFederatedSignIn: sendToMachine('FEDERATED_SIGN_IN'),
        toForgotPassword: sendToMachine('FORGOT_PASSWORD'),
        toSignIn: sendToMachine('SIGN_IN'),
        toSignUp: sendToMachine('SIGN_UP'),
        skipVerification: sendToMachine('SKIP')
    };
};
const $d37b17a31b839403$var$getNextSendEventAliases = (send)=>{
    const { toFederatedSignIn: toFederatedSignIn, submitForm: submitForm, resendCode: resendCode, skipVerification: skipVerification } = $d37b17a31b839403$export$2def2023b76dbf7d(send);
    return {
        handleSubmit: submitForm,
        resendConfirmationCode: resendCode,
        // manual "route" navigation
        setRoute: (route)=>send({
                type: (0, $4417241f2cb511f3$export$7ccc20c5f9bc8a70)[route]
            }),
        skipAttributeVerification: skipVerification,
        toFederatedSignIn: toFederatedSignIn
    };
};
const $d37b17a31b839403$export$e6da373757d26435 = (state)=>{
    const actorContext = (0, $496812a4ac8d01c5$export$c39505fa2700473f)(state) ?? {};
    const { allowedMfaTypes: allowedMfaTypes, availableAuthMethods: availableAuthMethods, challengeName: challengeName, codeDeliveryDetails: codeDeliveryDetails, preferredChallenge: preferredChallenge, remoteError: error, selectedAuthMethod: selectedAuthMethod, validationError: validationErrors, totpSecretCode: totpSecretCode = null, unverifiedUserAttributes: unverifiedUserAttributes, username: username } = actorContext;
    const { socialProviders: socialProviders = [], loginMechanisms: loginMechanisms } = state.context?.config ?? {};
    const loginMechanism = loginMechanisms?.[0];
    // check for user in actorContext prior to state context. actorContext is more "up to date",
    // but is not available on all states
    const user = actorContext?.user ?? state.context?.user;
    const hasValidationErrors = !!(validationErrors && Object.keys(validationErrors).length > 0);
    const actorState = (0, $496812a4ac8d01c5$export$99a4282e2c3b772d)(state);
    const isPending = state.hasTag('pending') || actorState?.hasTag('pending');
    const route = (0, $f2ea8eb89d77bec1$export$da6d2f7032b7150b)(state, actorState);
    // Auth status represents the current state of the auth flow
    // The `configuring` state is used to indicate when the xState machine is loading
    const authStatus = ((route)=>{
        switch(route){
            case 'idle':
            case 'setup':
                return 'configuring';
            case 'authenticated':
                return 'authenticated';
            default:
                return 'unauthenticated';
        }
    })(route);
    const facade = {
        allowedMfaTypes: allowedMfaTypes,
        authStatus: authStatus,
        availableAuthMethods: availableAuthMethods,
        challengeName: challengeName,
        codeDeliveryDetails: codeDeliveryDetails,
        error: error,
        hasValidationErrors: hasValidationErrors,
        isPending: isPending,
        loginMechanism: loginMechanism,
        preferredChallenge: preferredChallenge,
        route: route,
        selectedAuthMethod: selectedAuthMethod,
        socialProviders: socialProviders,
        totpSecretCode: totpSecretCode,
        unverifiedUserAttributes: unverifiedUserAttributes,
        user: user,
        username: username,
        validationErrors: validationErrors
    };
    return facade;
};
const $d37b17a31b839403$export$198a1c4c61f42650 = (state)=>{
    const actorContext = (0, $496812a4ac8d01c5$export$c39505fa2700473f)(state) ?? {};
    const { allowedMfaTypes: allowedMfaTypes, challengeName: challengeName, codeDeliveryDetails: codeDeliveryDetails, remoteError: errorMessage, totpSecretCode: totpSecretCode, unverifiedUserAttributes: unverifiedUserAttributes, username: username } = actorContext;
    const { socialProviders: federatedProviders, loginMechanisms: loginMechanisms } = state.context?.config ?? {};
    const loginMechanism = loginMechanisms?.[0];
    const actorState = (0, $496812a4ac8d01c5$export$99a4282e2c3b772d)(state);
    const isPending = state.hasTag('pending') || actorState?.hasTag('pending');
    // @todo-migration remove this cast for Authenticator.Next
    const route = (0, $f2ea8eb89d77bec1$export$da6d2f7032b7150b)(state, actorState);
    return {
        allowedMfaTypes: allowedMfaTypes,
        challengeName: challengeName,
        codeDeliveryDetails: codeDeliveryDetails,
        errorMessage: errorMessage,
        federatedProviders: federatedProviders,
        isPending: isPending,
        loginMechanism: loginMechanism,
        route: route,
        totpSecretCode: totpSecretCode,
        unverifiedUserAttributes: unverifiedUserAttributes,
        username: username
    };
};
const $d37b17a31b839403$export$5f925d5954b1c10b = ({ send: send, state: state })=>{
    const sendEventAliases = $d37b17a31b839403$export$2def2023b76dbf7d(send);
    const serviceContext = $d37b17a31b839403$export$e6da373757d26435(state);
    return {
        ...sendEventAliases,
        ...serviceContext
    };
};
const $d37b17a31b839403$export$d158c470c375eb4d = ({ send: send, state: state })=>({
        ...$d37b17a31b839403$var$getNextSendEventAliases(send),
        ...$d37b17a31b839403$export$198a1c4c61f42650(state)
    });




const $3153471c054ed57c$export$7e92b2e9f0809b11 = '`useAuthenticator` must be used inside an `Authenticator.Provider`.';




/**
 * ConfirmSignIn
 */ const $120fa0aee8e8ba04$var$getChallengeText = (challengeName)=>{
    switch(challengeName){
        case 'EMAIL_OTP':
            return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CONFIRM_EMAIL);
        case 'SMS_MFA':
            return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CONFIRM_SMS);
        case 'SOFTWARE_TOKEN_MFA':
            return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CONFIRM_TOTP);
        default:
            return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CONFIRM_MFA_DEFAULT);
    }
};
/**
 * ConfirmSignUp
 */ const $120fa0aee8e8ba04$var$getDeliveryMessageText = (codeDeliveryDetails)=>{
    const { DeliveryMedium: DeliveryMedium, Destination: Destination } = codeDeliveryDetails ?? {};
    const isEmailMessage = DeliveryMedium === 'EMAIL';
    const isTextMessage = DeliveryMedium === 'SMS';
    const arrivalMessage = (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CODE_ARRIVAL);
    if (!(isEmailMessage || isTextMessage)) return `${(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CODE_SENT)}. ${arrivalMessage}.`;
    const instructionMessage = isEmailMessage ? (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CODE_EMAILED) : (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CODE_TEXTED);
    return `${instructionMessage} ${Destination}. ${arrivalMessage}.`;
};
const $120fa0aee8e8ba04$var$getDeliveryMethodText = (codeDeliveryDetails)=>{
    const { DeliveryMedium: DeliveryMedium } = codeDeliveryDetails ?? {};
    const isEmailMessage = DeliveryMedium === 'EMAIL';
    const isTextMessage = DeliveryMedium === 'SMS';
    if (!isEmailMessage && isTextMessage) return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).WE_SENT_CODE);
    return isEmailMessage ? (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).WE_EMAILED) : (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).WE_TEXTED);
};
/**
 * FederatedSignIn
 */ const $120fa0aee8e8ba04$var$providerNameMap = {
    amazon: 'Amazon',
    apple: 'Apple',
    facebook: 'Facebook',
    google: 'Google'
};
const $120fa0aee8e8ba04$var$getSignInWithFederationText = (route, provider)=>{
    const isSignIn = route === 'signIn';
    return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)(`Sign ${isSignIn ? 'In' : 'Up'} with ${$120fa0aee8e8ba04$var$providerNameMap[provider]}`);
};
/**
 * SelectMfaType
 */ const $120fa0aee8e8ba04$var$getSelectMfaTypeByChallengeName = (challengeName)=>{
    if (challengeName === 'MFA_SETUP') return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).MFA_SETUP_SELECTION);
    return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).MFA_SELECTION);
};
const $120fa0aee8e8ba04$var$getUsernameLabelByLoginMechanism = (loginMechanism)=>{
    switch(loginMechanism){
        case 'email':
            return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).EMAIL_ADDRESS);
        case 'phone_number':
            return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).PHONE_NUMBER);
        case 'username':
        default:
            return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).USERNAME);
    }
};
const $120fa0aee8e8ba04$var$getMfaTypeLabelByValue = (mfaType)=>{
    switch(mfaType){
        case 'EMAIL':
            return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $a364e3b26e52691b$export$320d289eca4cc695).EMAIL_OTP);
        case 'SMS':
            return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $a364e3b26e52691b$export$320d289eca4cc695).SMS_MFA);
        case 'TOTP':
            return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $a364e3b26e52691b$export$320d289eca4cc695).SOFTWARE_TOKEN_MFA);
        default:
            return (0, $94bd8652748873ad$export$d73ee8ef04f5226a)(mfaType);
    }
};
const $120fa0aee8e8ba04$export$34e9c32aebe14fbb = {
    /** Shared */ getBackToSignInText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).BACK_SIGN_IN),
    getChangePasswordText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CHANGE_PASSWORD),
    getChangingText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CHANGING_PASSWORD),
    getConfirmText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CONFIRM),
    getConfirmingText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CONFIRMING),
    getContinueText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CONTINUE),
    getCopyText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).UPPERCASE_COPY),
    getHidePasswordText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).HIDE_PASSWORD),
    getLoadingText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).LOADING),
    getOrText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).OR),
    getResendCodeText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).RESEND_CODE),
    getSendCodeText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SEND_CODE),
    getSendingText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SENDING),
    getShowPasswordText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SHOW_PASSWORD),
    getSubmitText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SUBMIT),
    getSubmittingText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SUBMITTING),
    /** SignInSignUpTabs */ getSignInTabText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SIGN_IN_TAB),
    getSignUpTabText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CREATE_ACCOUNT),
    /** SignIn */ getForgotPasswordText: (shortVersion)=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)(shortVersion ? (0, $94bd8652748873ad$export$6ba37fd455cdd594).FORGOT_PASSWORD : (0, $94bd8652748873ad$export$6ba37fd455cdd594).FORGOT_YOUR_PASSWORD),
    getSigningInText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SIGNING_IN_BUTTON),
    getSignInText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SIGN_IN_BUTTON),
    /** SignUp */ getCreatingAccountText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CREATING_ACCOUNT),
    getCreateAccountText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CREATE_ACCOUNT),
    getCreateAccountWithEmailText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CREATE_ACCOUNT_WITH_EMAIL_OTP),
    getCreateAccountWithPasswordText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CREATE_ACCOUNT_WITH_PASSWORD),
    getCreateAccountWithSmsText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CREATE_ACCOUNT_WITH_SMS_OTP),
    getDeliveryMessageText: /** ConfirmSignUp */ $120fa0aee8e8ba04$var$getDeliveryMessageText,
    getDeliveryMethodText: $120fa0aee8e8ba04$var$getDeliveryMethodText,
    getChallengeText: /** ConfirmSignIn */ $120fa0aee8e8ba04$var$getChallengeText,
    /** ForgotPassword */ getResetYourPasswordText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).RESET_PASSWORD),
    /** SetupEmail */ getSetupEmailText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SETUP_EMAIL),
    /** SetupTotp */ getSetupTotpText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SETUP_TOTP),
    // TODO: add defaultText for below
    getSetupTotpInstructionsText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)('Copy and paste the secret key below into an authenticator app and then enter the code in the text field below.'),
    // TODO: add defaultText for "COPIED"
    getCopiedText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)('COPIED'),
    getSignInWithFederationText: /** FederatedSignIn */ $120fa0aee8e8ba04$var$getSignInWithFederationText,
    getMfaTypeLabelByValue: /** SelectMfaType */ $120fa0aee8e8ba04$var$getMfaTypeLabelByValue,
    getSelectMfaTypeByChallengeName: $120fa0aee8e8ba04$var$getSelectMfaTypeByChallengeName,
    getSelectMfaTypeText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SELECT_MFA_TYPE),
    /** VerifyUser */ getSkipText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SKIP),
    getVerifyText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).VERIFY),
    getVerifyContactText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).VERIFY_CONTACT),
    getAccountRecoveryInfoText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).VERIFY_HEADING),
    /** Passwordless */ getPasskeyPromptHeadingText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).PASSKEY_PROMPT_HEADING),
    getPasskeyPromptDescriptionText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).PASSKEY_PROMPT_DESCRIPTION),
    getCreatePasskeyText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CREATE_PASSKEY),
    getRegisteringText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).REGISTERING),
    getContinueWithoutPasskeyText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).CONTINUE_WITHOUT_PASSKEY),
    getPasskeyCreatedSuccessText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).PASSKEY_CREATED_SUCCESS),
    getPasskeyRegisteredText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).PASSKEY_REGISTERED),
    getPasskeyRegistrationFailedText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).PASSKEY_REGISTRATION_FAILED),
    getPasskeyLabelText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).PASSKEY_LABEL),
    getExistingPasskeysText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).EXISTING_PASSKEYS),
    getSetupAnotherPasskeyText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SETUP_ANOTHER_PASSKEY),
    getSignInWithPasswordText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SIGN_IN_WITH_PASSWORD),
    getSignInWithEmailText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SIGN_IN_WITH_EMAIL),
    getSignInWithSmsText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SIGN_IN_WITH_SMS),
    getSignInWithPasskeyText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).SIGN_IN_WITH_PASSKEY),
    getOtherSignInOptionsText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).OTHER_SIGN_IN_OPTIONS),
    getEnterUsernameFirstText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)((0, $94bd8652748873ad$export$6ba37fd455cdd594).ENTER_USERNAME_FIRST),
    getUsernameLabelByLoginMechanism: $120fa0aee8e8ba04$var$getUsernameLabelByLoginMechanism,
    /** Validations */ // TODO: add defaultText
    getInvalidEmailText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)('Please enter a valid email'),
    // TODO: add defaultText
    getRequiredFieldText: ()=>(0, $94bd8652748873ad$export$d73ee8ef04f5226a)('This field is required')
}; // using `as const` so that keys are strongly typed


/** Array of auth fields that we supply defaults with */ const $dda55acdf96ceebc$export$43a753047a354e27 = [
    'birthdate',
    'email',
    'family_name',
    'given_name',
    'middle_name',
    'name',
    'nickname',
    'phone_number',
    'preferred_username',
    'profile',
    'website'
];
/** Array of auth fields that we do not supply defaults with */ const $dda55acdf96ceebc$export$a263a0ca54f86170 = [
    'address',
    'gender',
    'locale',
    'picture',
    'updated_at',
    'zoneinfo'
];
/** Array of known login mechanisms */ const $dda55acdf96ceebc$export$c3f13f1789f7946b = [
    'username',
    'email',
    'phone_number'
];
const $dda55acdf96ceebc$export$ee5f111526f572af = [
    ...$dda55acdf96ceebc$export$c3f13f1789f7946b,
    ...$dda55acdf96ceebc$export$43a753047a354e27,
    'confirmation_code',
    'password',
    'confirm_password'
];
const $dda55acdf96ceebc$export$fed672849e2dd0ad = (field)=>{
    return $dda55acdf96ceebc$export$ee5f111526f572af.includes(field);
};








const $8709da976487c46a$export$e29bbbec84471f66 = (event)=>{
    const formData = new FormData(event.target);
    return Object.fromEntries(formData);
};
const $8709da976487c46a$export$b5859dd113079414 = (formOverrides, fieldNames)=>{
    let orderedKeys = [];
    if (formOverrides) orderedKeys = Object.keys(formOverrides).reduce((prev, key)=>{
        // reduce to array that can be sorted
        prev.push([
            key,
            formOverrides[key]?.order
        ]);
        return prev;
    }, []).sort((a, b)=>//sort them based on order
        a[1] - b[1]) // returned just key
    .filter((a)=>a[1] !== undefined).map((a)=>a[0]);
    // remove duplicates
    return Array.from(new Set([
        ...orderedKeys,
        ...fieldNames
    ]));
};
const $8709da976487c46a$export$3237178b1c616b9f = (field)=>{
    return (0, $dda55acdf96ceebc$export$ee5f111526f572af).includes(field);
};
const $8709da976487c46a$var$isArray = (val)=>{
    return Array.isArray(val);
};
const $8709da976487c46a$export$501239432719417d = (errors)=>{
    if (!errors) return null;
    if ($8709da976487c46a$var$isArray(errors)) return errors;
    else return [
        errors
    ];
};



const $02a5556189eebe05$export$65f2c683ca9e9a02 = (state)=>{
    const loginMechanisms = state?.context.config?.loginMechanisms;
    /**
     * @migration this is where we grab only the first index of `aws_cognito_username_attributes`
     */ const [primaryAlias] = loginMechanisms ?? [
        'username'
    ];
    return primaryAlias;
};
/** Applies translations to label and placeholder */ const $02a5556189eebe05$export$850c34c1087496e6 = (formFields)=>{
    const newFormFields = {
        ...formFields
    };
    for (const [name, options] of Object.entries(formFields)){
        const { label: label, placeholder: placeholder } = options;
        newFormFields[name] = {
            ...options,
            label: label ? (0, $94bd8652748873ad$export$d73ee8ef04f5226a)(label) : undefined,
            placeholder: placeholder ? (0, $94bd8652748873ad$export$d73ee8ef04f5226a)(placeholder) : undefined
        };
    }
    return newFormFields;
};
/** Sorts formFields according to their `order`.  */ const $02a5556189eebe05$export$c610ae674f32e5d9 = (formFields)=>{
    return Object.entries(formFields).sort((a, b)=>{
        const orderA = a[1].order || Number.MAX_VALUE;
        const orderB = b[1].order || Number.MAX_VALUE;
        return orderA - orderB;
    }).filter((formFieldEntry)=>formFieldEntry[1] !== undefined);
};


/**
 * This file contains helpers that generate default formFields for each screen
 */ const $9845a58c9c4ddc0b$export$7baaffefa21dec1 = '+1';
/** Helper function that gets the default formField for given field name */ const $9845a58c9c4ddc0b$var$getDefaultFormField = (fieldName)=>{
    let options = (0, $4417241f2cb511f3$export$1222d357a3c2c47f)[fieldName];
    const { type: type } = options;
    if (type === 'tel') options = {
        ...options,
        dialCode: $9845a58c9c4ddc0b$export$7baaffefa21dec1
    };
    return options;
};
// Helper function that returns default form field for configured primary alias
const $9845a58c9c4ddc0b$export$447e18c20e391f9 = (state)=>{
    const primaryAlias = (0, $02a5556189eebe05$export$65f2c683ca9e9a02)(state);
    return {
        ...$9845a58c9c4ddc0b$var$getDefaultFormField(primaryAlias),
        autocomplete: 'username'
    };
};
/** Reusable confirmation code form fields. */ const $9845a58c9c4ddc0b$var$getConfirmationCodeFormFields = (_)=>({
        confirmation_code: {
            ...$9845a58c9c4ddc0b$var$getDefaultFormField('confirmation_code'),
            label: 'Code *',
            placeholder: 'Code'
        }
    });
const $9845a58c9c4ddc0b$var$getSignInFormFields = (state)=>{
    const actorContext = state.context.actorRef?.getSnapshot()?.context;
    const availableAuthMethods = actorContext?.availableAuthMethods;
    const preferredChallenge = actorContext?.preferredChallenge;
    const shouldShowPassword = !availableAuthMethods?.length || availableAuthMethods.length === 1 && availableAuthMethods[0] === 'PASSWORD' || availableAuthMethods.length > 1 && (!preferredChallenge || preferredChallenge === 'PASSWORD');
    const fields = {
        username: {
            ...$9845a58c9c4ddc0b$export$447e18c20e391f9(state)
        }
    };
    if (shouldShowPassword) fields.password = {
        ...$9845a58c9c4ddc0b$var$getDefaultFormField('password'),
        autocomplete: 'current-password'
    };
    return fields;
};
const $9845a58c9c4ddc0b$var$getSignUpFormFields = (state)=>{
    const { loginMechanisms: loginMechanisms, signUpAttributes: signUpAttributes } = state.context.config;
    const primaryAlias = (0, $02a5556189eebe05$export$65f2c683ca9e9a02)(state);
    const actorContext = state.context.actorRef?.getSnapshot()?.context;
    const availableAuthMethods = actorContext?.availableAuthMethods;
    const hasMultipleMethods = availableAuthMethods && availableAuthMethods.length > 1;
    /**
     * @migration signUp Fields created here
     */ const fieldNames = Array.from(new Set([
        ...loginMechanisms,
        'password',
        'confirm_password',
        ...signUpAttributes
    ]));
    const formField = {};
    for (const fieldName of fieldNames)if ((0, $8709da976487c46a$export$3237178b1c616b9f)(fieldName)) {
        const fieldAttrs = fieldName === primaryAlias ? $9845a58c9c4ddc0b$export$447e18c20e391f9(state) : $9845a58c9c4ddc0b$var$getDefaultFormField(fieldName);
        // Make email, phone_number, password, and confirm_password optional when multiple auth methods available
        // Validation will check based on selected method
        const isOptional = hasMultipleMethods && (fieldName === 'email' || fieldName === 'phone_number' || fieldName === 'password' || fieldName === 'confirm_password');
        formField[fieldName] = {
            ...fieldAttrs,
            ...isOptional && {
                isRequired: false
            }
        };
    } else // There's a `custom:*` attribute or one we don't already have an implementation for
    // eslint-disable-next-line no-console
    console.debug(`Authenticator does not have a default implementation for ${fieldName}. Customize SignUp FormFields to add your own.`);
    return formField;
};
const $9845a58c9c4ddc0b$var$getConfirmSignUpFormFields = (_)=>({
        confirmation_code: {
            ...$9845a58c9c4ddc0b$var$getDefaultFormField('confirmation_code'),
            placeholder: 'Enter your code'
        }
    });
const $9845a58c9c4ddc0b$var$getForgotPasswordFormFields = (state)=>{
    const primaryAlias = (0, $02a5556189eebe05$export$65f2c683ca9e9a02)(state);
    const { label: label } = (0, $4417241f2cb511f3$export$1222d357a3c2c47f)[primaryAlias];
    return {
        username: {
            ...$9845a58c9c4ddc0b$export$447e18c20e391f9(state),
            label: `Enter your ${label.toLowerCase()}`,
            placeholder: `Enter your ${label.toLowerCase()}`
        }
    };
};
const $9845a58c9c4ddc0b$var$getConfirmResetPasswordFormFields = (state)=>({
        ...$9845a58c9c4ddc0b$var$getConfirmationCodeFormFields(),
        password: {
            ...$9845a58c9c4ddc0b$var$getDefaultFormField('password'),
            label: 'New Password',
            placeholder: 'New Password'
        },
        confirm_password: {
            ...$9845a58c9c4ddc0b$var$getDefaultFormField('confirm_password'),
            label: 'Confirm Password',
            placeholder: 'Confirm Password'
        }
    });
const $9845a58c9c4ddc0b$var$getForceNewPasswordFormFields = (state)=>{
    const actorState = (0, $496812a4ac8d01c5$export$99a4282e2c3b772d)(state);
    const { missingAttributes: missingAttributes } = actorState.context;
    const fieldNames = Array.from(new Set([
        'password',
        'confirm_password',
        ...missingAttributes ?? []
    ]));
    const formField = {};
    for (const fieldName of fieldNames)if ((0, $8709da976487c46a$export$3237178b1c616b9f)(fieldName)) formField[fieldName] = {
        ...$9845a58c9c4ddc0b$var$getDefaultFormField(fieldName)
    };
    else // There's a `custom:*` attribute or one we don't already have an implementation for
    // eslint-disable-next-line no-console
    console.debug(`Authenticator does not have a default implementation for ${fieldName}. Customize ForceNewPassword FormFields to add your own.`);
    return formField;
};
const $9845a58c9c4ddc0b$var$getSetupEmailFormFields = (_)=>({
        email: $9845a58c9c4ddc0b$var$getDefaultFormField('email')
    });
/** Collect all the defaultFormFields getters */ const $9845a58c9c4ddc0b$export$9bcaa03841470ad7 = {
    signIn: $9845a58c9c4ddc0b$var$getSignInFormFields,
    signUp: $9845a58c9c4ddc0b$var$getSignUpFormFields,
    confirmSignUp: $9845a58c9c4ddc0b$var$getConfirmSignUpFormFields,
    confirmSignIn: $9845a58c9c4ddc0b$var$getConfirmationCodeFormFields,
    forceNewPassword: $9845a58c9c4ddc0b$var$getForceNewPasswordFormFields,
    forgotPassword: $9845a58c9c4ddc0b$var$getForgotPasswordFormFields,
    confirmResetPassword: $9845a58c9c4ddc0b$var$getConfirmResetPasswordFormFields,
    confirmVerifyUser: $9845a58c9c4ddc0b$var$getConfirmationCodeFormFields,
    setupEmail: $9845a58c9c4ddc0b$var$getSetupEmailFormFields,
    setupTotp: $9845a58c9c4ddc0b$var$getConfirmationCodeFormFields
};



// Gets the default formFields for given route
const $61a57bec4d3fa805$export$bafc1c085dad2945 = (route, state)=>{
    const formFieldGetter = (0, $9845a58c9c4ddc0b$export$9bcaa03841470ad7)[route];
    return formFieldGetter(state);
};
// Gets custom formFields, and applies default values
const $61a57bec4d3fa805$export$40c1faef715b9f52 = (route, state)=>{
    const customFormFields = (0, $496812a4ac8d01c5$export$c39505fa2700473f)(state)?.formFields?.[route];
    if (!customFormFields || Object.keys(customFormFields).length === 0) return {};
    return Object.entries(customFormFields).reduce((acc, [fieldName, customOptions])=>{
        if ((route === 'signIn' || route === 'forgotPassword') && fieldName === 'username') {
            // Unlike other screens, `signIn` and `forgotPassword` screens default login
            // alias field names to "username", even if it's a phone number or email.
            // In this case, we get the default formFieldOptions based on loginMechanism.
            const defaultOptions = (0, $9845a58c9c4ddc0b$export$447e18c20e391f9)(state);
            // apply default to fill any gaps that are not present in customOptions
            const mergedOptions = {
                ...defaultOptions,
                ...customOptions
            };
            return {
                ...acc,
                [fieldName]: mergedOptions
            };
        } else if ((0, $dda55acdf96ceebc$export$fed672849e2dd0ad)(fieldName)) {
            // if this field is a known auth attribute that we have defaults for,
            // apply defaults to customOptions.
            const defaultOptions = (0, $4417241f2cb511f3$export$1222d357a3c2c47f)[fieldName];
            const mergedOptions = {
                ...defaultOptions,
                ...customOptions
            };
            return {
                ...acc,
                [fieldName]: mergedOptions
            };
        } else // if this is not a known field, use customOptions as is.
        return {
            ...acc,
            [fieldName]: customOptions
        };
    }, {});
};
const $61a57bec4d3fa805$export$5e097831852eb087 = (route, state)=>{
    const defaultFormFields = $61a57bec4d3fa805$export$bafc1c085dad2945(route, state);
    const customFormFields = $61a57bec4d3fa805$export$40c1faef715b9f52(route, state);
    const formFields = {
        ...defaultFormFields,
        ...customFormFields
    };
    delete formFields['QR'];
    return (0, $02a5556189eebe05$export$850c34c1087496e6)(formFields);
};
const $61a57bec4d3fa805$export$8f6c429ad9970441 = (formFields)=>formFields.map((field)=>{
        const key = field[0];
        // Drop order key to prevent passing to form field UI components
        const values = {
            ...field[1],
            order: undefined
        };
        return [
            key,
            values
        ];
    });
/** Calls `getFormFields` above, then sorts it into an indexed array */ const $61a57bec4d3fa805$export$2fcee3580f06a0ca = (route, state)=>{
    const formFields = $61a57bec4d3fa805$export$5e097831852eb087(route, state);
    return $61a57bec4d3fa805$export$8f6c429ad9970441((0, $02a5556189eebe05$export$c610ae674f32e5d9)(formFields));
};


const $f88d5f8bc1dcac60$export$297d226dd86a0de7 = [
    'confirmResetPassword',
    'confirmSignIn',
    'confirmSignUp',
    'confirmVerifyUser',
    'forceNewPassword',
    'forgotPassword',
    'selectMfaType',
    'setupEmail',
    'setupTotp',
    'signIn',
    'signUp',
    'verifyUser'
];
const $f88d5f8bc1dcac60$export$8ccdb5ff21fda761 = [
    'ConfirmResetPassword',
    'ConfirmSignIn',
    'ConfirmSignUp',
    'ConfirmVerifyUser',
    'ForceNewPassword',
    'ForgotPassword',
    'SelectMfaType',
    'SetupEmail',
    'SetupTotp',
    'SignIn',
    'SignUp',
    'VerifyUser'
];


const $4a60eb838d604cee$export$65443658c81b32cc = (route)=>(0, $f88d5f8bc1dcac60$export$297d226dd86a0de7).some((componentRoute)=>componentRoute === route);
function $4a60eb838d604cee$export$a909c85e22b33d81(defaults, overrides) {
    if (!overrides) return defaults;
    return (0, $f88d5f8bc1dcac60$export$8ccdb5ff21fda761).reduce((components, route)=>{
        const Default = defaults[route];
        const Override = overrides[route];
        if (typeof Override !== 'function') return {
            ...components,
            [route]: Default
        };
        const { Footer: Footer, FormFields: FormFields, Header: Header } = Default;
        // cast to allow assigning of component slots
        const Component = Override;
        Component.Footer = Footer;
        Component.FormFields = FormFields;
        Component.Header = Header;
        return {
            ...components,
            [route]: Component
        };
    }, {});
}


const $5247e94bf2c12dd8$export$6756c954b2014a15 = ()=>false;
/**
 * Does an ordering and shallow comparison of each array value,
 * plus a value equality check for empty objects and arrays.
 */ function $5247e94bf2c12dd8$export$6d39b5fae5236692(currentDeps, nextDeps) {
    if (currentDeps.length !== nextDeps.length) return false;
    return currentDeps.every((currentDep, index)=>{
        const nextDep = nextDeps[index];
        if ((0, $fd30e9352c42562e$export$2c02be4a78959098)(currentDep, nextDep) || (0, $fd30e9352c42562e$export$d6708a3543c32fe4)(currentDep, nextDep)) return true;
        return currentDep === nextDep;
    });
}
const $5247e94bf2c12dd8$export$1f14d6e84ea4650a = (selector)=>(currentFacade, nextFacade)=>{
        const currentSelectorDeps = selector(currentFacade);
        const nextSelectorDeps = selector(nextFacade);
        // Shallow compare the array values
        return $5247e94bf2c12dd8$export$6d39b5fae5236692(currentSelectorDeps, nextSelectorDeps);
    };
const $5247e94bf2c12dd8$export$4680a6e0cbf2b7d7 = (state)=>({
        ...(0, $496812a4ac8d01c5$export$c39505fa2700473f)(state)?.formFields?.setupTotp?.QR
    });
const $5247e94bf2c12dd8$var$flattenFormFields = (fields)=>fields.flatMap(([name, options])=>({
            name: name,
            ...options
        }));
const $5247e94bf2c12dd8$var$convertContactMethodsToFields = (unverifiedUserAttributes = {})=>{
    return unverifiedUserAttributes && Object.entries(unverifiedUserAttributes).map(([name, value])=>{
        const valueIsString = (0, $fd30e9352c42562e$export$844ec244b1367d54)(value);
        if (!valueIsString || !name) return {};
        return {
            name: name,
            label: value,
            type: 'radio',
            value: value
        };
    });
};
const $5247e94bf2c12dd8$var$convertAllowedMfaTypesToFields = (allowedMfaTypes = [])=>{
    return allowedMfaTypes.map((mfaType)=>({
            name: 'mfa_type',
            label: (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb).getMfaTypeLabelByValue(mfaType),
            type: 'radio',
            value: mfaType
        }));
};
/**
 * Retrieves default and custom (RWA only, to be updated) form field values from state machine
 * for subcomponent routes that render fields
 */ const $5247e94bf2c12dd8$export$e72db6842cb587a1 = (route, state)=>{
    if ((0, $4a60eb838d604cee$export$65443658c81b32cc)(route)) {
        if (route === 'verifyUser') return $5247e94bf2c12dd8$var$convertContactMethodsToFields((0, $496812a4ac8d01c5$export$c39505fa2700473f)(state).unverifiedUserAttributes);
        if (route === 'selectMfaType') return $5247e94bf2c12dd8$var$convertAllowedMfaTypesToFields((0, $496812a4ac8d01c5$export$c39505fa2700473f)(state).allowedMfaTypes);
        return $5247e94bf2c12dd8$var$flattenFormFields((0, $61a57bec4d3fa805$export$2fcee3580f06a0ca)(route, state));
    }
    return [];
};


/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/connected-components/authenticator/headless#useauthenticator-hook)
 */ function $eb4806d462018926$export$2e2bcd8739ae039(selector) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useContext((0, $a62a00af9a1a28f6$export$2254a7bd02a5abf7));
    if (!context) throw new Error((0, $3153471c054ed57c$export$7e92b2e9f0809b11));
    const { service: service } = context;
    const { send: send } = service;
    const xstateSelector = (0, $6aRB8.useCallback)((state)=>({
            ...(0, $d37b17a31b839403$export$5f925d5954b1c10b)({
                send: send,
                state: state
            })
        }), [
        send
    ]);
    const comparator = selector ? (0, $5247e94bf2c12dd8$export$1f14d6e84ea4650a)(selector) : (0, $5247e94bf2c12dd8$export$6756c954b2014a15);
    // the purpose of `context.authStatus`is to intentionally override `facade.authStatus`. `facade.authStatus` does
    // not update on external sign in events (for example when a user is not using the `Authenticator`).
    const { authStatus: authStatus } = context;
    const facade = (0, $27e4649a9dcd71fe$export$2105062e25df4afe)(service, xstateSelector, comparator);
    const { route: route, totpSecretCode: totpSecretCode, user: user, ...rest } = facade;
    // do not memoize output. `service.getSnapshot` reference remains stable preventing
    // `fields` from updating with current form state on value changes
    const serviceSnapshot = service.getSnapshot();
    // legacy `QRFields` values only used for SetupTotp page to retrieve issuer information, will be removed in future
    const QRFields = route === 'setupTotp' ? (0, $5247e94bf2c12dd8$export$4680a6e0cbf2b7d7)(serviceSnapshot) : null;
    // legacy `formFields` values required until form state is removed from state machine
    const fields = (0, $5247e94bf2c12dd8$export$e72db6842cb587a1)(route, serviceSnapshot);
    return {
        ...rest,
        authStatus: authStatus,
        route: route,
        totpSecretCode: totpSecretCode,
        user: user,
        fields: /** @deprecated For internal use only */ fields,
        QRFields: QRFields
    };
}


var $6aRB8 = parcelRequire("6aRB8");

// only select `route` from machine context
const $3a1f3adcb2aef67a$export$55f632bbdf6d0e4 = ({ route: route })=>[
        route
    ];
function $3a1f3adcb2aef67a$export$2e2bcd8739ae039(data) {
    const { route: route, initializeMachine: initializeMachine } = (0, $eb4806d462018926$export$2e2bcd8739ae039)($3a1f3adcb2aef67a$export$55f632bbdf6d0e4);
    const hasInitialized = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useEffect(()=>{
        if (!hasInitialized.current && route === 'setup') {
            initializeMachine(data);
            hasInitialized.current = true;
        }
    }, [
        initializeMachine,
        route,
        data
    ]);
}


var $6aRB8 = parcelRequire("6aRB8");


const $7e97cb32125a0933$export$4739d1a1a0c1611d = {
    category: (0, $c2cf6542a631fa20$export$3a8840c5b2ecf003).AI,
    apis: [
        (0, $c2cf6542a631fa20$export$89656a7f296a8665).CreateConversation,
        (0, $c2cf6542a631fa20$export$89656a7f296a8665).DeleteConversation,
        (0, $c2cf6542a631fa20$export$89656a7f296a8665).ListConversations,
        (0, $c2cf6542a631fa20$export$89656a7f296a8665).UpdateConversation,
        (0, $c2cf6542a631fa20$export$89656a7f296a8665).OnMessage,
        (0, $c2cf6542a631fa20$export$89656a7f296a8665).SendMessage,
        (0, $c2cf6542a631fa20$export$89656a7f296a8665).Generation
    ]
};
const $7e97cb32125a0933$export$f0e53cf2fcbe6801 = {
    apis: [
        (0, $c2cf6542a631fa20$export$900b1436d7e65f4).DeleteUser,
        (0, $c2cf6542a631fa20$export$900b1436d7e65f4).UpdatePassword
    ],
    category: (0, $c2cf6542a631fa20$export$3a8840c5b2ecf003).Auth
};
const $7e97cb32125a0933$export$b4592dada0e918ed = {
    apis: [
        (0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignUp,
        (0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignUp,
        (0, $c2cf6542a631fa20$export$900b1436d7e65f4).ResendSignUpCode,
        (0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignIn,
        (0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmSignIn,
        (0, $c2cf6542a631fa20$export$900b1436d7e65f4).FetchUserAttributes,
        (0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignOut,
        (0, $c2cf6542a631fa20$export$900b1436d7e65f4).ResetPassword,
        (0, $c2cf6542a631fa20$export$900b1436d7e65f4).ConfirmResetPassword,
        (0, $c2cf6542a631fa20$export$900b1436d7e65f4).SignInWithRedirect
    ],
    category: (0, $c2cf6542a631fa20$export$3a8840c5b2ecf003).Auth
};
const $7e97cb32125a0933$export$27960736bb3ab48 = {
    apis: [
        (0, $c2cf6542a631fa20$export$d4f3c54b808b00ce).UploadData
    ],
    category: (0, $c2cf6542a631fa20$export$3a8840c5b2ecf003).Storage
};
const $7e97cb32125a0933$export$9350eeaf9304c617 = {
    apis: [
        (0, $c2cf6542a631fa20$export$c01a8c16ffda791e).NotifyMessageInteraction
    ],
    category: (0, $c2cf6542a631fa20$export$3a8840c5b2ecf003).InAppMessaging
};
const $7e97cb32125a0933$export$9ec4d9b90e0651f3 = {
    category: (0, $c2cf6542a631fa20$export$3a8840c5b2ecf003).Geo,
    apis: [
        (0, $c2cf6542a631fa20$export$afafab3eb8fc6fef).SearchByText,
        (0, $c2cf6542a631fa20$export$afafab3eb8fc6fef).SearchForSuggestions,
        (0, $c2cf6542a631fa20$export$afafab3eb8fc6fef).SearchByPlaceId
    ]
};
const $7e97cb32125a0933$export$8b6b593c0f557e5e = {
    category: (0, $c2cf6542a631fa20$export$3a8840c5b2ecf003).Geo,
    apis: []
};
const $7e97cb32125a0933$export$5650166bd1af1e38 = {
    apis: [
        (0, $c2cf6542a631fa20$export$d4f3c54b808b00ce).UploadData
    ],
    category: (0, $c2cf6542a631fa20$export$3a8840c5b2ecf003).Storage
};
const $7e97cb32125a0933$export$b372fc1aad1ed630 = {
    apis: [
        (0, $c2cf6542a631fa20$export$d4f3c54b808b00ce).UploadData,
        (0, $c2cf6542a631fa20$export$d4f3c54b808b00ce).Copy,
        (0, $c2cf6542a631fa20$export$d4f3c54b808b00ce).GetUrl,
        (0, $c2cf6542a631fa20$export$d4f3c54b808b00ce).List,
        (0, $c2cf6542a631fa20$export$d4f3c54b808b00ce).Remove,
        (0, $c2cf6542a631fa20$export$d4f3c54b808b00ce).GetDataAccess,
        (0, $c2cf6542a631fa20$export$d4f3c54b808b00ce).ListCallerAccessGrants
    ],
    category: (0, $c2cf6542a631fa20$export$3a8840c5b2ecf003).Storage
};



/**
 * @example
 * ```ts
 * // set user agent options
 * const clear = setUserAgent(input);
 *
 * // clear user agent options
 * clear();
 * ```
 */ const $06793f2207acf35a$export$57d3cdb500cb5402 = ({ componentName: componentName, packageName: packageName, version: version })=>{
    const packageData = [
        `ui-${packageName}`,
        version
    ];
    switch(componentName){
        case 'AIConversation':
            (0, $241333051c8fcffd$export$20cd2fa9001e90da)({
                ...(0, $7e97cb32125a0933$export$4739d1a1a0c1611d),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case 'Authenticator':
            (0, $241333051c8fcffd$export$20cd2fa9001e90da)({
                ...(0, $7e97cb32125a0933$export$b4592dada0e918ed),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case 'ChangePassword':
        case 'DeleteUser':
            (0, $241333051c8fcffd$export$20cd2fa9001e90da)({
                ...(0, $7e97cb32125a0933$export$f0e53cf2fcbe6801),
                additionalDetails: [
                    [
                        'AccountSettings'
                    ],
                    packageData
                ]
            });
            break;
        case 'FileUploader':
            (0, $241333051c8fcffd$export$20cd2fa9001e90da)({
                ...(0, $7e97cb32125a0933$export$27960736bb3ab48),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case 'InAppMessaging':
            (0, $241333051c8fcffd$export$20cd2fa9001e90da)({
                ...(0, $7e97cb32125a0933$export$9350eeaf9304c617),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case 'LocationSearch':
            (0, $241333051c8fcffd$export$20cd2fa9001e90da)({
                ...(0, $7e97cb32125a0933$export$9ec4d9b90e0651f3),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case 'MapView':
            (0, $241333051c8fcffd$export$20cd2fa9001e90da)({
                ...(0, $7e97cb32125a0933$export$8b6b593c0f557e5e),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case 'StorageManager':
            (0, $241333051c8fcffd$export$20cd2fa9001e90da)({
                ...(0, $7e97cb32125a0933$export$5650166bd1af1e38),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case 'StorageBrowser':
            (0, $241333051c8fcffd$export$20cd2fa9001e90da)({
                ...(0, $7e97cb32125a0933$export$b372fc1aad1ed630),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
    }
    return 0, $fd30e9352c42562e$export$8793edee2d425525;
};


function $ec85c69bee30366d$export$2e2bcd8739ae039({ componentName: componentName, packageName: packageName, version: version }) {
    (0, $6aRB8.useEffect)(()=>{
        const clearUserAgent = (0, $06793f2207acf35a$export$57d3cdb500cb5402)({
            componentName: componentName,
            packageName: packageName,
            version: version
        });
        return clearUserAgent;
    }, [
        componentName,
        packageName,
        version
    ]);
}


const $608fab696bcdaf1b$export$a4ad2735b021c132 = '6.15.4';



var $6aRB8 = parcelRequire("6aRB8");
/**
 * Logs a deprecation warning message.
 *
 * @important Please use the React/React Native specific platform implementations.
 * This version of the hook is a base implementation that the others extend from due
 * to env differences between running in RN or the browser
 */ const $c0fed4ef2dc73ca6$export$2e2bcd8739ae039 = ({ shouldWarn: shouldWarn, message: message })=>{
    $6aRB8.useEffect(()=>{
        if (shouldWarn) // eslint-disable-next-line no-console
        console.warn(message);
    }, [
        shouldWarn,
        message
    ]);
};


/**
 * Logs a deprecation warning `message` to the console.
 */ const $8011ad08ebd75fbc$export$406e4c8585b97b03 = ({ message: message, shouldWarn: _shouldWarn })=>{
    const shouldWarn = _shouldWarn && // show message on builds without Node `process` polyfill
    // or with process.env.NODE_ENV not production
    true;
    (0, $c0fed4ef2dc73ca6$export$2e2bcd8739ae039)({
        message: message,
        shouldWarn: shouldWarn
    });
};



var $6aRB8 = parcelRequire("6aRB8");
const $dd10c02aadfdf910$export$da5ac45a736a5880 = // @ts-ignore
$6aRB8.createContext(null);
const $dd10c02aadfdf910$export$b0e9d19f717d0a5c = ()=>{
    const context = $6aRB8.useContext($dd10c02aadfdf910$export$da5ac45a736a5880);
    if (!context) throw new Error('`useCustomComponents` cannot be used outside of a `CustomComponentsContext.Provider`');
    return context;
};




var $6aRB8 = parcelRequire("6aRB8");


var $6aRB8 = parcelRequire("6aRB8");


var $6aRB8 = parcelRequire("6aRB8");

const $ee1340d798dd5e54$export$ce4ab0c55987d1ff = (...args)=>{
    const classes = [];
    for (const arg of args){
        // skip falsey values
        if (!arg) continue;
        if ((0, $fd30e9352c42562e$export$844ec244b1367d54)(arg)) {
            classes.push(arg);
            continue;
        }
        if (typeof arg === 'number') {
            classes.push(arg.toString());
            continue;
        }
        if (Array.isArray(arg)) {
            classes.push($ee1340d798dd5e54$export$ce4ab0c55987d1ff(...arg));
            continue;
        }
        if ((0, $fd30e9352c42562e$export$a6cdc56e425d0d0a)(arg)) {
            // check if the object has a valid .toString() method
            if (arg.toString !== Object.prototype.toString && arg.toString() !== '[object Object]') {
                classes.push(arg.toString());
                continue;
            }
            for(const key in arg)if ((0, $fd30e9352c42562e$export$a4f4bb6b1453fff5)(arg, key) && arg[key]) classes.push(key);
        }
    }
    return classes.join(' ');
};

const $22bf574a47253734$export$a5e41a4bc3f9b1d6 = {
    Accordion: 'amplify-accordion',
    AccordionItem: 'amplify-accordion__item',
    AccordionItemTrigger: 'amplify-accordion__item__trigger',
    AccordionItemContent: 'amplify-accordion__item__content',
    AccordionItemIcon: 'amplify-accordion__item__icon',
    Alert: 'amplify-alert',
    AlertIcon: 'amplify-alert__icon',
    AlertHeading: 'amplify-alert__heading',
    AlertBody: 'amplify-alert__body',
    AlertDismiss: 'amplify-alert__dismiss',
    Autocomplete: 'amplify-autocomplete',
    AutocompleteMenu: 'amplify-autocomplete__menu',
    AutocompleteMenuEmpty: 'amplify-autocomplete__menu--empty',
    AutocompleteMenuFooter: 'amplify-autocomplete__menu__footer',
    AutocompleteMenuHeader: 'amplify-autocomplete__menu__header',
    AutocompleteMenuLoading: 'amplify-autocomplete__menu--loading',
    AutocompleteMenuOption: 'amplify-autocomplete__menu__option',
    AutocompleteMenuOptions: 'amplify-autocomplete__menu__options',
    Avatar: 'amplify-avatar',
    AvatarIcon: 'amplify-avatar__icon',
    AvatarImage: 'amplify-avatar__image',
    AvatarLoader: 'amplify-avatar__loader',
    AIConversation: 'amplify-ai-conversation',
    AIConversationScrollView: 'amplify-ai-conversation__scrollview',
    AIConversationAttachment: 'amplify-ai-conversation__attachment',
    AIConversationAttachmentList: 'amplify-ai-conversation__attachment__list',
    AIConversationAttachmentImage: 'amplify-ai-conversation__attachment__image',
    AIConversationAttachmentName: 'amplify-ai-conversation__attachment__name',
    AIConversationAttachmentSize: 'amplify-ai-conversation__attachment__size',
    AIConversationAttachmentRemove: 'amplify-ai-conversation__attachment__remove',
    AIConversationForm: 'amplify-ai-conversation__form',
    AIConversationFormAttach: 'amplify-ai-conversation__form__attach',
    AIConversationFormError: 'amplify-ai-conversation__form__error',
    AIConversationFormSend: 'amplify-ai-conversation__form__send',
    AIConversationFormField: 'amplify-ai-conversation__form__field',
    AIConversationFormDropzone: 'amplify-ai-conversation__form__dropzone',
    AIConversationMessage: 'amplify-ai-conversation__message',
    AIConversationMessageAvatar: 'amplify-ai-conversation__message__avatar',
    AIConversationMessageSender: 'amplify-ai-conversation__message__sender',
    AIConversationMessageSenderUsername: 'amplify-ai-conversation__message__sender__username',
    AIConversationMessageSenderTimestamp: 'amplify-ai-conversation__message__sender__timestamp',
    AIConversationMessageBody: 'amplify-ai-conversation__message__body',
    AIConversationMessageContent: 'amplify-ai-conversation__message__content',
    AIConversationMessageActions: 'amplify-ai-conversation__message__actions',
    AIConversationMessageList: 'amplify-ai-conversation__message__list',
    AIConversationPrompt: 'amplify-ai-conversation__prompt',
    Badge: 'amplify-badge',
    Breadcrumbs: 'amplify-breadcrumbs',
    BreadcrumbsList: 'amplify-breadcrumbs__list',
    BreadcrumbsItem: 'amplify-breadcrumbs__item',
    BreadcrumbsSeparator: 'amplify-breadcrumbs__separator',
    BreadcrumbsLink: 'amplify-breadcrumbs__link',
    Button: 'amplify-button',
    ButtonGroup: 'amplify-buttongroup',
    ButtonLoaderWrapper: 'amplify-button__loader-wrapper',
    Card: 'amplify-card',
    Checkbox: 'amplify-checkbox',
    CheckboxButton: 'amplify-checkbox__button',
    CheckboxIcon: 'amplify-checkbox__icon',
    CheckboxInput: 'amplify-checkbox__input',
    CheckboxLabel: 'amplify-checkbox__label',
    CheckboxField: 'amplify-checkboxfield',
    Collection: 'amplify-collection',
    CollectionItems: 'amplify-collection-items',
    CollectionSearch: 'amplify-collection-search',
    CollectionPagination: 'amplify-collection-pagination',
    CountryCodeSelect: 'amplify-countrycodeselect',
    DialCodeSelect: 'amplify-dialcodeselect',
    Divider: 'amplify-divider',
    DividerLabel: 'amplify-divider--label',
    DropZone: 'amplify-dropzone',
    Field: 'amplify-field',
    FieldDescription: 'amplify-field__description',
    FieldErrorMessage: 'amplify-field__error-message',
    FieldGroup: 'amplify-field-group',
    FieldGroupControl: 'amplify-field-group__control',
    FieldGroupOuterEnd: 'amplify-field-group__outer-end',
    FieldGroupOuterStart: 'amplify-field-group__outer-start',
    FieldGroupInnerEnd: 'amplify-field-group__inner-end',
    FieldGroupInnerStart: 'amplify-field-group__inner-start',
    FieldGroupIcon: 'amplify-field-group__icon',
    FieldGroupIconButton: 'amplify-field-group__icon-button',
    FieldGroupHasInnerEnd: 'amplify-field-group--has-inner-end',
    FieldGroupHasInnerStart: 'amplify-field-group--has-inner-start',
    FieldShowPassword: 'amplify-field__show-password',
    FieldGroupFieldWrapper: 'amplify-field-group__field-wrapper',
    Fieldset: 'amplify-fieldset',
    FieldsetLegend: 'amplify-fieldset__legend',
    FileUploader: 'amplify-fileuploader',
    FileUploaderDropZone: 'amplify-fileuploader__dropzone',
    FileUploaderDropZoneIcon: 'amplify-fileuploader__dropzone__icon',
    FileUploaderDropZoneText: 'amplify-fileuploader__dropzone__text',
    FileUploaderFilePicker: 'amplify-fileuploader__file__picker',
    FileUploaderFile: 'amplify-fileuploader__file',
    FileUploaderFileWrapper: 'amplify-fileuploader__file__wrapper',
    FileUploaderFileList: 'amplify-fileuploader__file__list',
    FileUploaderFileName: 'amplify-fileuploader__file__name',
    FileUploaderFileSize: 'amplify-fileuploader__file__size',
    FileUploaderFileInfo: 'amplify-fileuploader__file__info',
    FileUploaderFileImage: 'amplify-fileuploader__file__image',
    FileUploaderFileMain: 'amplify-fileuploader__file__main',
    FileUploaderFileStatus: 'amplify-fileuploader__file__status',
    FileUploaderLoader: 'amplify-fileuploader__loader',
    FileUploaderPreviewer: 'amplify-fileuploader__previewer',
    FileUploaderPreviewerText: 'amplify-fileuploader__previewer__text',
    FileUploaderPreviewerActions: 'amplify-fileuploader__previewer__actions',
    FileUploaderPreviewerFooter: 'amplify-fileuploader__previewer__footer',
    Flex: 'amplify-flex',
    Grid: 'amplify-grid',
    Heading: 'amplify-heading',
    HighlightMatch: 'amplify-highlightmatch',
    HighlightMatchHighlighted: 'amplify-highlightmatch__highlighted',
    Icon: 'amplify-icon',
    Image: 'amplify-image',
    Input: 'amplify-input',
    Label: 'amplify-label',
    Link: 'amplify-link',
    Loader: 'amplify-loader',
    LoaderLabel: 'amplify-loader__label',
    MenuContent: 'amplify-menu__content',
    MenuItem: 'amplify-menu__content__item',
    MenuTrigger: 'amplify-menu__trigger',
    MenuWrapper: 'amplify-menu__wrapper',
    Message: 'amplify-message',
    MessageIcon: 'amplify-message__icon',
    MessageHeading: 'amplify-message__heading',
    MessageBody: 'amplify-message__body',
    MessageContent: 'amplify-message__content',
    MessageDismiss: 'amplify-message__dismiss',
    Pagination: 'amplify-pagination',
    PaginationItem: 'amplify-pagination__item',
    PasswordField: 'amplify-passwordfield',
    PhoneNumberField: 'amplify-phonenumberfield',
    Placeholder: 'amplify-placeholder',
    Radio: 'amplify-radio',
    RadioButton: 'amplify-radio__button',
    RadioInput: 'amplify-radio__input',
    RadioLabel: 'amplify-radio__label',
    RadioGroupField: 'amplify-radiogroupfield',
    RadioGroup: 'amplify-radiogroup',
    Rating: 'amplify-rating',
    RatingItem: 'amplify-rating__item',
    RatingIcon: 'amplify-rating__icon',
    RatingLabel: 'amplify-rating__label',
    ScrollView: 'amplify-scrollview',
    SearchField: 'amplify-searchfield',
    SearchFieldClear: 'amplify-searchfield__clear',
    SearchFieldSearch: 'amplify-searchfield__search',
    Select: 'amplify-select',
    SelectField: 'amplify-selectfield',
    SelectWrapper: 'amplify-select__wrapper',
    SelectIcon: 'amplify-select__icon',
    SliderField: 'amplify-sliderfield',
    SliderFieldGroup: 'amplify-sliderfield__group',
    SliderFieldLabel: 'amplify-sliderfield__label',
    SliderFieldRange: 'amplify-sliderfield__range',
    SliderFieldRoot: 'amplify-sliderfield__root',
    SliderFieldThumb: 'amplify-sliderfield__thumb',
    SliderFieldTrack: 'amplify-sliderfield__track',
    StepperField: 'amplify-stepperfield',
    StepperFieldButtonDecrease: 'amplify-stepperfield__button--decrease',
    StepperFieldButtonIncrease: 'amplify-stepperfield__button--increase',
    StepperFieldInput: 'amplify-stepperfield__input',
    StorageImage: 'amplify-storageimage',
    StorageManager: 'amplify-storagemanager',
    StorageManagerDropZone: 'amplify-storagemanager__dropzone',
    StorageManagerDropZoneIcon: 'amplify-storagemanager__dropzone__icon',
    StorageManagerDropZoneText: 'amplify-storagemanager__dropzone__text',
    StorageManagerFilePicker: 'amplify-storagemanager__file__picker',
    StorageManagerFile: 'amplify-storagemanager__file',
    StorageManagerFileWrapper: 'amplify-storagemanager__file__wrapper',
    StorageManagerFileList: 'amplify-storagemanager__file__list',
    StorageManagerFileName: 'amplify-storagemanager__file__name',
    StorageManagerFileSize: 'amplify-storagemanager__file__size',
    StorageManagerFileInfo: 'amplify-storagemanager__file__info',
    StorageManagerFileImage: 'amplify-storagemanager__file__image',
    StorageManagerFileMain: 'amplify-storagemanager__file__main',
    StorageManagerFileStatus: 'amplify-storagemanager__file__status',
    StorageManagerLoader: 'amplify-storagemanager__loader',
    StorageManagerPreviewer: 'amplify-storagemanager__previewer',
    StorageManagerPreviewerText: 'amplify-storagemanager__previewer__text',
    StorageManagerPreviewerActions: 'amplify-storagemanager__previewer__actions',
    StorageManagerPreviewerFooter: 'amplify-storagemanager__previewer__footer',
    SwitchField: 'amplify-switchfield',
    SwitchLabel: 'amplify-switch__label',
    SwitchThumb: 'amplify-switch__thumb',
    SwitchTrack: 'amplify-switch__track',
    SwitchWrapper: 'amplify-switch__wrapper',
    Table: 'amplify-table',
    TableCaption: 'amplify-table__caption',
    TableBody: 'amplify-table__body',
    TableTd: 'amplify-table__td',
    TableTh: 'amplify-table__th',
    TableFoot: 'amplify-table__foot',
    TableHead: 'amplify-table__head',
    TableRow: 'amplify-table__row',
    Tabs: 'amplify-tabs',
    TabsList: 'amplify-tabs__list',
    TabsItem: 'amplify-tabs__item',
    TabsPanel: 'amplify-tabs__panel',
    Text: 'amplify-text',
    Textarea: 'amplify-textarea',
    TextAreaField: 'amplify-textareafield',
    TextField: 'amplify-textfield',
    ToggleButton: 'amplify-togglebutton',
    ToggleButtonGroup: 'amplify-togglebuttongroup',
    VisuallyHidden: 'amplify-visually-hidden'
};



var $6aRB8 = parcelRequire("6aRB8");
/**
 * Updates the return type for primitives wrapped in `React.forwardRef` to
 * `React.ReactElement`. In React 18 the return type of `React.ExoticComponent`
 * was changed from `React.ReactElement` to `React.ReactNode`, which breaks
 * clients using React 16 and 17.
 *
 * @param primitive UI Primitive to be wrapped with `React.forwardRef`
 * @returns ForwaredRef wrapped UI Primitive
 */ const $268f040634758fba$export$44aa160b17c73194 = (primitive)=>$6aRB8.forwardRef(primitive);



var $6aRB8 = parcelRequire("6aRB8");
const $503b6352ab4ec9e6$export$74e4d3bc6dc1117 = $6aRB8.createContext({
    isFieldsetDisabled: false
});
/**
 * @description Fieldsets in HTML can be disabled, which disables all child
 * fieldsets and input controls. `useFieldset` passes the disabled state down
 * via context.
 */ const $503b6352ab4ec9e6$export$b140571ec72925dd = (fallback)=>{
    const ctx = $6aRB8.useContext($503b6352ab4ec9e6$export$74e4d3bc6dc1117);
    let value = ctx.isFieldsetDisabled;
    // cannot use nullish `??` since isFieldsetDisabled can be `false`
    if (value === undefined || value === false) value = fallback;
    return {
        isFieldsetDisabled: value
    };
};



var $6aRB8 = parcelRequire("6aRB8");


var $6aRB8 = parcelRequire("6aRB8");

var $6aRB8 = parcelRequire("6aRB8");
var $1df74ef3ff6217b2$exports = {};
var $f5c6f51428f65cde$exports = {};
var $68f040e828aef0b5$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $68f040e828aef0b5$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$68f040e828aef0b5$exports = $68f040e828aef0b5$var$arrayReduce;


var $eeebc9031e98b8fe$exports = {};
var $4310088d0b598707$exports = {};
var $0f35899bf1f47ef0$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $0f35899bf1f47ef0$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$0f35899bf1f47ef0$exports = $0f35899bf1f47ef0$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $4310088d0b598707$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $4310088d0b598707$var$deburrLetter = $0f35899bf1f47ef0$exports($4310088d0b598707$var$deburredLetters);
$4310088d0b598707$exports = $4310088d0b598707$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $eeebc9031e98b8fe$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $eeebc9031e98b8fe$var$rsComboMarksRange = '\\u0300-\\u036f', $eeebc9031e98b8fe$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $eeebc9031e98b8fe$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $eeebc9031e98b8fe$var$rsComboRange = $eeebc9031e98b8fe$var$rsComboMarksRange + $eeebc9031e98b8fe$var$reComboHalfMarksRange + $eeebc9031e98b8fe$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $eeebc9031e98b8fe$var$rsCombo = '[' + $eeebc9031e98b8fe$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $eeebc9031e98b8fe$var$reComboMark = RegExp($eeebc9031e98b8fe$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $eeebc9031e98b8fe$var$deburr(string) {
    string = $03a7e8a900f37d77$exports(string);
    return string && string.replace($eeebc9031e98b8fe$var$reLatin, $4310088d0b598707$exports).replace($eeebc9031e98b8fe$var$reComboMark, '');
}
$eeebc9031e98b8fe$exports = $eeebc9031e98b8fe$var$deburr;


var $88827c9ebf369ec2$exports = {};
var $43ec4a95376254d1$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $43ec4a95376254d1$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $43ec4a95376254d1$var$asciiWords(string) {
    return string.match($43ec4a95376254d1$var$reAsciiWord) || [];
}
$43ec4a95376254d1$exports = $43ec4a95376254d1$var$asciiWords;


var $7d510d337b5ce401$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $7d510d337b5ce401$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $7d510d337b5ce401$var$hasUnicodeWord(string) {
    return $7d510d337b5ce401$var$reHasUnicodeWord.test(string);
}
$7d510d337b5ce401$exports = $7d510d337b5ce401$var$hasUnicodeWord;



var $addd46ea40343888$exports = {};
/** Used to compose unicode character classes. */ var $addd46ea40343888$var$rsAstralRange = '\\ud800-\\udfff', $addd46ea40343888$var$rsComboMarksRange = '\\u0300-\\u036f', $addd46ea40343888$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $addd46ea40343888$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $addd46ea40343888$var$rsComboRange = $addd46ea40343888$var$rsComboMarksRange + $addd46ea40343888$var$reComboHalfMarksRange + $addd46ea40343888$var$rsComboSymbolsRange, $addd46ea40343888$var$rsDingbatRange = '\\u2700-\\u27bf', $addd46ea40343888$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $addd46ea40343888$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $addd46ea40343888$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $addd46ea40343888$var$rsPunctuationRange = '\\u2000-\\u206f', $addd46ea40343888$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $addd46ea40343888$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $addd46ea40343888$var$rsVarRange = '\\ufe0e\\ufe0f', $addd46ea40343888$var$rsBreakRange = $addd46ea40343888$var$rsMathOpRange + $addd46ea40343888$var$rsNonCharRange + $addd46ea40343888$var$rsPunctuationRange + $addd46ea40343888$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $addd46ea40343888$var$rsApos = "['\u2019]", $addd46ea40343888$var$rsBreak = '[' + $addd46ea40343888$var$rsBreakRange + ']', $addd46ea40343888$var$rsCombo = '[' + $addd46ea40343888$var$rsComboRange + ']', $addd46ea40343888$var$rsDigits = '\\d+', $addd46ea40343888$var$rsDingbat = '[' + $addd46ea40343888$var$rsDingbatRange + ']', $addd46ea40343888$var$rsLower = '[' + $addd46ea40343888$var$rsLowerRange + ']', $addd46ea40343888$var$rsMisc = '[^' + $addd46ea40343888$var$rsAstralRange + $addd46ea40343888$var$rsBreakRange + $addd46ea40343888$var$rsDigits + $addd46ea40343888$var$rsDingbatRange + $addd46ea40343888$var$rsLowerRange + $addd46ea40343888$var$rsUpperRange + ']', $addd46ea40343888$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $addd46ea40343888$var$rsModifier = '(?:' + $addd46ea40343888$var$rsCombo + '|' + $addd46ea40343888$var$rsFitz + ')', $addd46ea40343888$var$rsNonAstral = '[^' + $addd46ea40343888$var$rsAstralRange + ']', $addd46ea40343888$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $addd46ea40343888$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $addd46ea40343888$var$rsUpper = '[' + $addd46ea40343888$var$rsUpperRange + ']', $addd46ea40343888$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $addd46ea40343888$var$rsMiscLower = '(?:' + $addd46ea40343888$var$rsLower + '|' + $addd46ea40343888$var$rsMisc + ')', $addd46ea40343888$var$rsMiscUpper = '(?:' + $addd46ea40343888$var$rsUpper + '|' + $addd46ea40343888$var$rsMisc + ')', $addd46ea40343888$var$rsOptContrLower = '(?:' + $addd46ea40343888$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $addd46ea40343888$var$rsOptContrUpper = '(?:' + $addd46ea40343888$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $addd46ea40343888$var$reOptMod = $addd46ea40343888$var$rsModifier + '?', $addd46ea40343888$var$rsOptVar = '[' + $addd46ea40343888$var$rsVarRange + ']?', $addd46ea40343888$var$rsOptJoin = '(?:' + $addd46ea40343888$var$rsZWJ + '(?:' + [
    $addd46ea40343888$var$rsNonAstral,
    $addd46ea40343888$var$rsRegional,
    $addd46ea40343888$var$rsSurrPair
].join('|') + ')' + $addd46ea40343888$var$rsOptVar + $addd46ea40343888$var$reOptMod + ')*', $addd46ea40343888$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $addd46ea40343888$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $addd46ea40343888$var$rsSeq = $addd46ea40343888$var$rsOptVar + $addd46ea40343888$var$reOptMod + $addd46ea40343888$var$rsOptJoin, $addd46ea40343888$var$rsEmoji = '(?:' + [
    $addd46ea40343888$var$rsDingbat,
    $addd46ea40343888$var$rsRegional,
    $addd46ea40343888$var$rsSurrPair
].join('|') + ')' + $addd46ea40343888$var$rsSeq;
/** Used to match complex or compound words. */ var $addd46ea40343888$var$reUnicodeWord = RegExp([
    $addd46ea40343888$var$rsUpper + '?' + $addd46ea40343888$var$rsLower + '+' + $addd46ea40343888$var$rsOptContrLower + '(?=' + [
        $addd46ea40343888$var$rsBreak,
        $addd46ea40343888$var$rsUpper,
        '$'
    ].join('|') + ')',
    $addd46ea40343888$var$rsMiscUpper + '+' + $addd46ea40343888$var$rsOptContrUpper + '(?=' + [
        $addd46ea40343888$var$rsBreak,
        $addd46ea40343888$var$rsUpper + $addd46ea40343888$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $addd46ea40343888$var$rsUpper + '?' + $addd46ea40343888$var$rsMiscLower + '+' + $addd46ea40343888$var$rsOptContrLower,
    $addd46ea40343888$var$rsUpper + '+' + $addd46ea40343888$var$rsOptContrUpper,
    $addd46ea40343888$var$rsOrdUpper,
    $addd46ea40343888$var$rsOrdLower,
    $addd46ea40343888$var$rsDigits,
    $addd46ea40343888$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $addd46ea40343888$var$unicodeWords(string) {
    return string.match($addd46ea40343888$var$reUnicodeWord) || [];
}
$addd46ea40343888$exports = $addd46ea40343888$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $88827c9ebf369ec2$var$words(string, pattern, guard) {
    string = $03a7e8a900f37d77$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $7d510d337b5ce401$exports(string) ? $addd46ea40343888$exports(string) : $43ec4a95376254d1$exports(string);
    return string.match(pattern) || [];
}
$88827c9ebf369ec2$exports = $88827c9ebf369ec2$var$words;


/** Used to compose unicode capture groups. */ var $f5c6f51428f65cde$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $f5c6f51428f65cde$var$reApos = RegExp($f5c6f51428f65cde$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $f5c6f51428f65cde$var$createCompounder(callback) {
    return function(string) {
        return $68f040e828aef0b5$exports($88827c9ebf369ec2$exports($eeebc9031e98b8fe$exports(string).replace($f5c6f51428f65cde$var$reApos, '')), callback, '');
    };
}
$f5c6f51428f65cde$exports = $f5c6f51428f65cde$var$createCompounder;


/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $1df74ef3ff6217b2$var$kebabCase = $f5c6f51428f65cde$exports(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
$1df74ef3ff6217b2$exports = $1df74ef3ff6217b2$var$kebabCase;






const $814e47091d38609e$export$8eb3892b442747bd = {
    separator: '.'
};
const $814e47091d38609e$export$c6afb6177f6861ca = /\{([^}]+)\}/g;


/**
 * Checks if the value uses a value reference.
 * @param {string} value
 * @returns {boolean} - True, if the value uses a value reference
 */ function $19e62d0ecad789c8$export$36597e059227d3a8(value) {
    const regex = new RegExp((0, $814e47091d38609e$export$c6afb6177f6861ca));
    if (typeof value === 'string') return regex.test(value);
    if (typeof value === 'object') {
        let hasReference = false;
        // iterate over each property in the object,
        // if any element passes the regex test,
        // the whole thing should be true
        for(const key in value)if ((0, $fd30e9352c42562e$export$a4f4bb6b1453fff5)(value, key)) {
            const element = value[key];
            let reference = $19e62d0ecad789c8$export$36597e059227d3a8(element);
            if (reference) {
                hasReference = true;
                break;
            }
        }
        return hasReference;
    }
    return false;
}
function $19e62d0ecad789c8$export$35b163fd1a69f633(path, obj) {
    let ref = obj;
    if (!Array.isArray(path)) return;
    for(let i = 0; i < path.length; i++)// Check for undefined as 0 is a valid, truthy value
    if (typeof ref[path[i]] !== 'undefined') ref = ref[path[i]];
    else {
        // set the reference as undefined if we don't find anything
        ref = undefined;
        break;
    }
    return ref;
}
/**
 * Returns the path from a path name be splitting the name by a given separator.
 */ function $19e62d0ecad789c8$export$739cfa5695759e2d(pathName) {
    if (typeof pathName !== 'string') throw new Error('Getting path from name failed. Name must be a string');
    return pathName.split((0, $814e47091d38609e$export$8eb3892b442747bd).separator);
}
/**
 * Returns the paths name be joining its parts with a given separator.
 */ function $19e62d0ecad789c8$export$7d9f7e9c1c02b41e(path) {
    if (!path || !(path instanceof Array)) throw new Error('Getting name for path failed. Path must be an array');
    return path.join((0, $814e47091d38609e$export$8eb3892b442747bd).separator);
}


const $619e2162debdd3f4$export$f9ebafeabd662d32 = 'amplify';
/**
 * This will take an object like:
 * {paddingTop:'20px',color:'{colors.font.primary}'}
 * and turn it into a CSS string:
 * `padding-top:20px; color: var(--colors-font-primary);`
 */ function $619e2162debdd3f4$export$51cf6524dc225642(props) {
    return Object.entries(props).map(([key, value])=>{
        const _value = $619e2162debdd3f4$export$daee9cd42beef6d1(value) ? value.toString() : $619e2162debdd3f4$export$55101aa37e5c1f8f({
            value: value
        });
        return `${(0, (/*@__PURE__*/$parcel$interopDefault($1df74ef3ff6217b2$exports)))(key)}:${_value}; `;
    }).join(' ');
}
function $619e2162debdd3f4$export$8658ddf1aae625a3({ path: path = [] }) {
    return `${(0, (/*@__PURE__*/$parcel$interopDefault($1df74ef3ff6217b2$exports)))([
        $619e2162debdd3f4$export$f9ebafeabd662d32,
        ...path
    ].join(' '))}`;
}
// Important: these properties should not be altered in
// order to maintain the expected order of the CSS `box-shadow` property
const $619e2162debdd3f4$var$SHADOW_PROPERTIES = [
    'offsetX',
    'offsetY',
    'blurRadius',
    'spreadRadius',
    'color'
];
/**
 * Will take a design token in a theme and return its value as CSS
 *
 * @param token
 * @returns
 */ function $619e2162debdd3f4$export$55101aa37e5c1f8f(token) {
    const { value: value } = token;
    if ((0, $fd30e9352c42562e$export$844ec244b1367d54)(value)) return $619e2162debdd3f4$export$6d0b22b283c7a62b(value);
    if ($619e2162debdd3f4$export$50306062f6ed54c(value)) return $619e2162debdd3f4$var$SHADOW_PROPERTIES.map((property)=>{
        return $619e2162debdd3f4$export$6d0b22b283c7a62b(// lookup property against `token` first for custom non-nested value, then lookup
        // property against `value` for design token value
        $619e2162debdd3f4$export$50306062f6ed54c(token) ? token[property] : value[property]);
    }).join(' ');
    return value;
}
/**
 * Helper function to test if something is a design token or not.
 * Used in the React component style props.
 *
 * @param value - thing to test if it is a design token or not
 * @returns boolean
 */ function $619e2162debdd3f4$export$daee9cd42beef6d1(value) {
    return (0, $fd30e9352c42562e$export$a6cdc56e425d0d0a)(value) && (0, $fd30e9352c42562e$export$a4f4bb6b1453fff5)(value, 'value');
}
function $619e2162debdd3f4$export$50306062f6ed54c(value) {
    return (0, $fd30e9352c42562e$export$a6cdc56e425d0d0a)(value) && (0, $fd30e9352c42562e$export$a4f4bb6b1453fff5)(value, 'offsetX');
}
/**
 * Function that sees if a string contains a design token reference
 * and if so will turn that into a CSS variable.
 *
 * @param {string} value
 * @returns string
 */ function $619e2162debdd3f4$export$6d0b22b283c7a62b(value) {
    if (!value) return '';
    if ((0, $19e62d0ecad789c8$export$36597e059227d3a8)(value)) {
        const path = value.replace(/\{|\}/g, '').replace('.value', '').split('.');
        return `var(--${$619e2162debdd3f4$export$8658ddf1aae625a3({
            path: path
        })})`;
    }
    return value;
}
/**
 * This will take a design token and add some data to it for it
 * to be used in JS/CSS. It will create its CSS var name and update
 * the value to use a CSS var if it is a reference. It will also
 * add a `.toString()` method to make it easier to use in JS.
 *
 * We should see if there is a way to share this logic with style dictionary...
 */ const $619e2162debdd3f4$export$e65646439c92605c = ({ token: token, path: path })=>{
    const name = `--${$619e2162debdd3f4$export$8658ddf1aae625a3({
        path: path
    })}`;
    const { value: original } = token;
    const value = $619e2162debdd3f4$export$55101aa37e5c1f8f(token);
    return {
        name: name,
        original: original,
        path: path,
        value: value,
        toString: ()=>`var(${name})`
    };
};
/**
 * Recursive function that will walk down the token object
 * and perform the setupToken function on each token.
 * Similar to what Style Dictionary does.
 */ function $619e2162debdd3f4$export$4ae67d38aae8ca2e({ tokens: tokens, path: path = [], setupToken: setupToken }) {
    if ((0, $fd30e9352c42562e$export$a4f4bb6b1453fff5)(tokens, 'value')) return setupToken({
        token: tokens,
        path: path
    });
    const output = {};
    for(const name in tokens)if ((0, $fd30e9352c42562e$export$a4f4bb6b1453fff5)(tokens, name)) {
        const value = tokens[name];
        const nextTokens = (0, $fd30e9352c42562e$export$a6cdc56e425d0d0a)(value) ? value : {
            value: value
        };
        output[name] = $619e2162debdd3f4$export$4ae67d38aae8ca2e({
            tokens: nextTokens,
            path: path.concat(name),
            setupToken: setupToken
        });
    }
    return output;
}
// Internal Style Dictionary methods
// copied from amzn/style-dictionary with the owner's permission
/**
 * Takes an plain javascript object and will make a flat array of all the leaf nodes.
 * A leaf node in this context has a 'value' property. Potentially refactor this to
 * be more generic.
 * @private
 * @param  {Object} properties - The plain object you want flattened into an array.
 * @param  {Array} [to_ret=[]] - Properties array. This function is recursive therefore this is what gets passed along.
 * @return {Array}
 */ function $619e2162debdd3f4$export$5739a35fb355a0f7(properties, to_ret) {
    to_ret = to_ret || [];
    for(var name in properties)if ((0, $fd30e9352c42562e$export$a4f4bb6b1453fff5)(properties, name)) {
        if ((0, $fd30e9352c42562e$export$a6cdc56e425d0d0a)(properties[name]) && 'value' in properties[name]) to_ret.push(properties[name]);
        else if ((0, $fd30e9352c42562e$export$a6cdc56e425d0d0a)(properties[name])) $619e2162debdd3f4$export$5739a35fb355a0f7(properties[name], to_ret);
    }
    return to_ret;
}
/**
 * Performs an deep extend on the objects, from right to left.
 * @private
 * @param {Object[]} objects - An array of JS objects
 * @param {Function} collision - A function to be called when a merge collision happens.
 * @param {string[]} path - (for internal use) An array of strings which is the current path down the object when this is called recursively.
 * @returns {Object}
 */ function $619e2162debdd3f4$export$54e9fb29908872fa(objects, collision, path) {
    if (objects == null) return {};
    var src, copyIsArray, copy, name, options, clone, target = objects[0] || {}, i = 1, length = objects.length;
    path = path || [];
    // Handle case when target is a string or something (possible in deep copy)
    if (typeof target !== 'object') target = {};
    for(; i < length; i++){
        // Only deal with non-null/undefined values
        if ((options = objects[i]) != null) // Extend the base object
        for(name in options){
            if (!(0, $fd30e9352c42562e$export$a4f4bb6b1453fff5)(options, name)) continue;
            if (name === '__proto__') continue;
            src = target[name];
            copy = options[name];
            // Prevent never-ending loop
            if (target === copy) continue;
            // Recurse if we're merging plain objects or arrays
            if (copy && ((0, $fd30e9352c42562e$export$a6cdc56e425d0d0a)(copy) || (copyIsArray = Array.isArray(copy)))) {
                if (copyIsArray) {
                    copyIsArray = false;
                    clone = src && Array.isArray(src) ? src : [];
                } else clone = src && (0, $fd30e9352c42562e$export$a6cdc56e425d0d0a)(src) ? src : {};
                var nextPath = path.slice(0);
                nextPath.push(name);
                // Never move original objects, clone them
                target[name] = $619e2162debdd3f4$export$54e9fb29908872fa([
                    clone,
                    copy
                ], collision, nextPath);
            // Don't bring in undefined values
            } else if (copy !== undefined) {
                if (src != null && typeof collision == 'function') collision({
                    target: target,
                    copy: options,
                    path: path,
                    key: name
                });
                target[name] = copy;
            }
        }
    }
    return target;
}


/**
 * @internal May be removed in a future version
 * Maps from component style props to React `style` props
 * Note: Primarily needed to map from component style props that don't match CSS Properties directly
 * such as wrap => flexWrap and direction => flexDirection
 */ const $4a29dbc0bab4c85a$export$c69338bc7d797351 = {
    alignContent: 'alignContent',
    alignItems: 'alignItems',
    alignSelf: 'alignSelf',
    area: 'gridArea',
    aspectRatio: 'aspectRatio',
    autoColumns: 'gridAutoColumns',
    autoFlow: 'gridAutoFlow',
    autoRows: 'gridAutoRows',
    backgroundColor: 'backgroundColor',
    backgroundImage: 'backgroundImage',
    basis: 'flexBasis',
    border: 'border',
    borderRadius: 'borderRadius',
    borderColor: 'borderColor',
    borderWidth: 'borderWidth',
    borderStyle: 'borderStyle',
    bottom: 'bottom',
    boxShadow: 'boxShadow',
    color: 'color',
    column: 'gridColumn',
    columnEnd: 'gridColumnEnd',
    columnGap: 'columnGap',
    columnSpan: 'gridColumn',
    columnStart: 'gridColumnStart',
    direction: 'flexDirection',
    display: 'display',
    flex: 'flex',
    fontFamily: 'fontFamily',
    fontSize: 'fontSize',
    fontStyle: 'fontStyle',
    fontWeight: 'fontWeight',
    gap: 'gap',
    grow: 'flexGrow',
    height: 'height',
    justifyContent: 'justifyContent',
    left: 'left',
    letterSpacing: 'letterSpacing',
    lineHeight: 'lineHeight',
    margin: 'margin',
    marginBlock: 'marginBlock',
    marginBlockEnd: 'marginBlockEnd',
    marginBlockStart: 'marginBlockStart',
    marginBottom: 'marginBlockEnd',
    marginInline: 'marginInline',
    marginInlineEnd: 'marginInlineEnd',
    marginInlineStart: 'marginInlineStart',
    marginLeft: 'marginInlineStart',
    marginRight: 'marginInlineEnd',
    marginTop: 'marginBlockStart',
    maxHeight: 'maxHeight',
    maxWidth: 'maxWidth',
    minHeight: 'minHeight',
    minWidth: 'minWidth',
    objectFit: 'objectFit',
    objectPosition: 'objectPosition',
    opacity: 'opacity',
    order: 'order',
    overflow: 'overflow',
    padding: 'padding',
    paddingBlock: 'paddingBlock',
    paddingBlockEnd: 'paddingBlockEnd',
    paddingBlockStart: 'paddingBlockStart',
    paddingBottom: 'paddingBlockEnd',
    paddingInline: 'paddingInline',
    paddingInlineEnd: 'paddingInlineEnd',
    paddingInlineStart: 'paddingInlineStart',
    paddingLeft: 'paddingInlineStart',
    paddingRight: 'paddingInlineEnd',
    paddingTop: 'paddingBlockStart',
    position: 'position',
    resize: 'resize',
    right: 'right',
    row: 'gridRow',
    rowEnd: 'gridRowEnd',
    rowGap: 'rowGap',
    rowSpan: 'gridRow',
    rowStart: 'gridRowStart',
    shrink: 'flexShrink',
    templateAreas: 'gridTemplateAreas',
    templateColumns: 'gridTemplateColumns',
    templateRows: 'gridTemplateRows',
    textAlign: 'textAlign',
    textDecoration: 'textDecoration',
    textTransform: 'textTransform',
    top: 'top',
    transform: 'transform',
    transformOrigin: 'transformOrigin',
    width: 'width',
    whiteSpace: 'whiteSpace',
    wrap: 'flexWrap'
};
/**
 * @internal May be removed in a future version
 */ const $4a29dbc0bab4c85a$export$885e0ebc08cdd9a0 = Object.keys($4a29dbc0bab4c85a$export$c69338bc7d797351);


const $6b11bf327c015793$export$6f3cc5789c9e770e = {
    small: {
        value: '1px'
    },
    medium: {
        value: '2px'
    },
    large: {
        value: '3px'
    }
};


const $c25c8e3281149d33$export$8f45430ccf837300 = {
    red: {
        10: {
            value: 'hsl(0, 75%, 95%)'
        },
        20: {
            value: 'hsl(0, 75%, 85%)'
        },
        40: {
            value: 'hsl(0, 75%, 75%)'
        },
        60: {
            value: 'hsl(0, 50%, 50%)'
        },
        80: {
            value: 'hsl(0, 95%, 30%)'
        },
        90: {
            value: 'hsl(0, 100%, 20%)'
        },
        100: {
            value: 'hsl(0, 100%, 15%)'
        }
    },
    orange: {
        10: {
            value: 'hsl(30, 75%, 95%)'
        },
        20: {
            value: 'hsl(30, 75%, 85%)'
        },
        40: {
            value: 'hsl(30, 75%, 75%)'
        },
        60: {
            value: 'hsl(30, 50%, 50%)'
        },
        80: {
            value: 'hsl(30, 95%, 30%)'
        },
        90: {
            value: 'hsl(30, 100%, 20%)'
        },
        100: {
            value: 'hsl(30, 100%, 15%)'
        }
    },
    yellow: {
        10: {
            value: 'hsl(60, 75%, 95%)'
        },
        20: {
            value: 'hsl(60, 75%, 85%)'
        },
        40: {
            value: 'hsl(60, 75%, 75%)'
        },
        60: {
            value: 'hsl(60, 50%, 50%)'
        },
        80: {
            value: 'hsl(60, 95%, 30%)'
        },
        90: {
            value: 'hsl(60, 100%, 20%)'
        },
        100: {
            value: 'hsl(60, 100%, 15%)'
        }
    },
    green: {
        10: {
            value: 'hsl(130, 60%, 95%)'
        },
        20: {
            value: 'hsl(130, 60%, 90%)'
        },
        40: {
            value: 'hsl(130, 44%, 63%)'
        },
        60: {
            value: 'hsl(130, 43%, 46%)'
        },
        80: {
            value: 'hsl(130, 33%, 37%)'
        },
        90: {
            value: 'hsl(130, 27%, 29%)'
        },
        100: {
            value: 'hsl(130, 22%, 23%)'
        }
    },
    teal: {
        10: {
            value: 'hsl(190, 75%, 95%)'
        },
        20: {
            value: 'hsl(190, 75%, 85%)'
        },
        40: {
            value: 'hsl(190, 70%, 70%)'
        },
        60: {
            value: 'hsl(190, 50%, 50%)'
        },
        80: {
            value: 'hsl(190, 95%, 30%)'
        },
        90: {
            value: 'hsl(190, 100%, 20%)'
        },
        100: {
            value: 'hsl(190, 100%, 15%)'
        }
    },
    blue: {
        10: {
            value: 'hsl(220, 95%, 95%)'
        },
        20: {
            value: 'hsl(220, 85%, 85%)'
        },
        40: {
            value: 'hsl(220, 70%, 70%)'
        },
        60: {
            value: 'hsl(220, 50%, 50%)'
        },
        80: {
            value: 'hsl(220, 95%, 30%)'
        },
        90: {
            value: 'hsl(220, 100%, 20%)'
        },
        100: {
            value: 'hsl(220, 100%, 15%)'
        }
    },
    purple: {
        10: {
            value: 'hsl(300, 95%, 95%)'
        },
        20: {
            value: 'hsl(300, 85%, 85%)'
        },
        40: {
            value: 'hsl(300, 70%, 70%)'
        },
        60: {
            value: 'hsl(300, 50%, 50%)'
        },
        80: {
            value: 'hsl(300, 95%, 30%)'
        },
        90: {
            value: 'hsl(300, 100%, 20%)'
        },
        100: {
            value: 'hsl(300, 100%, 15%)'
        }
    },
    pink: {
        10: {
            value: 'hsl(340, 95%, 95%)'
        },
        20: {
            value: 'hsl(340, 90%, 85%)'
        },
        40: {
            value: 'hsl(340, 70%, 70%)'
        },
        60: {
            value: 'hsl(340, 50%, 50%)'
        },
        80: {
            value: 'hsl(340, 95%, 30%)'
        },
        90: {
            value: 'hsl(340, 100%, 20%)'
        },
        100: {
            value: 'hsl(340, 100%, 15%)'
        }
    },
    neutral: {
        10: {
            value: 'hsl(210, 5%, 98%)'
        },
        20: {
            value: 'hsl(210, 5%, 94%)'
        },
        40: {
            value: 'hsl(210, 5%, 87%)'
        },
        60: {
            value: 'hsl(210, 10%, 58%)'
        },
        80: {
            value: 'hsl(210, 10%, 40%)'
        },
        90: {
            value: 'hsl(210, 25%, 25%)'
        },
        100: {
            value: 'hsl(210, 50%, 10%)'
        }
    },
    primary: {
        10: {
            value: '{colors.teal.10.value}'
        },
        20: {
            value: '{colors.teal.20.value}'
        },
        40: {
            value: '{colors.teal.40.value}'
        },
        60: {
            value: '{colors.teal.60.value}'
        },
        80: {
            value: '{colors.teal.80.value}'
        },
        90: {
            value: '{colors.teal.90.value}'
        },
        100: {
            value: '{colors.teal.100.value}'
        }
    },
    secondary: {
        10: {
            value: '{colors.purple.10.value}'
        },
        20: {
            value: '{colors.purple.20.value}'
        },
        40: {
            value: '{colors.purple.40.value}'
        },
        60: {
            value: '{colors.purple.60.value}'
        },
        80: {
            value: '{colors.purple.80.value}'
        },
        90: {
            value: '{colors.purple.90.value}'
        },
        100: {
            value: '{colors.purple.100.value}'
        }
    },
    font: {
        primary: {
            value: '{colors.neutral.100.value}'
        },
        secondary: {
            value: '{colors.neutral.90.value}'
        },
        tertiary: {
            value: '{colors.neutral.80.value}'
        },
        disabled: {
            value: '{colors.neutral.60.value}'
        },
        inverse: {
            value: '{colors.white.value}'
        },
        interactive: {
            value: '{colors.primary.80.value}'
        },
        // Hover and Focus colors are intentionally different colors.
        // This allows users to distinguish between the current keyboard focus
        // and the location of their pointer
        hover: {
            value: '{colors.primary.90.value}'
        },
        // Focus color is set to 100 to ensure enough contrast for accessibility
        focus: {
            value: '{colors.primary.100.value}'
        },
        active: {
            value: '{colors.primary.100.value}'
        },
        info: {
            value: '{colors.blue.90.value}'
        },
        warning: {
            value: '{colors.orange.90.value}'
        },
        error: {
            value: '{colors.red.90.value}'
        },
        success: {
            value: '{colors.green.90.value}'
        }
    },
    background: {
        primary: {
            value: '{colors.white.value}'
        },
        secondary: {
            value: '{colors.neutral.10.value}'
        },
        tertiary: {
            value: '{colors.neutral.20.value}'
        },
        quaternary: {
            value: '{colors.neutral.60.value}'
        },
        disabled: {
            value: '{colors.background.tertiary.value}'
        },
        info: {
            value: '{colors.blue.10.value}'
        },
        warning: {
            value: '{colors.orange.10.value}'
        },
        error: {
            value: '{colors.red.10.value}'
        },
        success: {
            value: '{colors.green.10.value}'
        }
    },
    border: {
        primary: {
            value: '{colors.neutral.60.value}'
        },
        secondary: {
            value: '{colors.neutral.40.value}'
        },
        tertiary: {
            value: '{colors.neutral.20.value}'
        },
        disabled: {
            value: '{colors.border.tertiary.value}'
        },
        pressed: {
            value: '{colors.primary.100.value}'
        },
        // Focus color is set to 100 to ensure enough contrast for accessibility
        focus: {
            value: '{colors.primary.100.value}'
        },
        error: {
            value: '{colors.red.80.value}'
        },
        info: {
            value: '{colors.blue.80.value}'
        },
        success: {
            value: '{colors.green.80.value}'
        },
        warning: {
            value: '{colors.orange.80.value}'
        }
    },
    shadow: {
        primary: {
            value: 'hsla(210, 50%, 10%, 0.25)'
        },
        secondary: {
            value: 'hsla(210, 50%, 10%, 0.15)'
        },
        tertiary: {
            value: 'hsla(210, 50%, 10%, 0.05)'
        }
    },
    overlay: {
        5: {
            value: 'hsla(0, 0%, 0%, 0.05)'
        },
        10: {
            value: 'hsla(0, 0%, 0%, 0.1)'
        },
        20: {
            value: 'hsla(0, 0%, 0%, 0.2)'
        },
        30: {
            value: 'hsla(0, 0%, 0%, 0.3)'
        },
        40: {
            value: 'hsla(0, 0%, 0%, 0.4)'
        },
        50: {
            value: 'hsla(0, 0%, 0%, 0.5)'
        },
        60: {
            value: 'hsla(0, 0%, 0%, 0.6)'
        },
        70: {
            value: 'hsla(0, 0%, 0%, 0.7)'
        },
        80: {
            value: 'hsla(0, 0%, 0%, 0.8)'
        },
        90: {
            value: 'hsla(0, 0%, 0%, 0.9)'
        }
    },
    black: {
        value: 'hsl(0, 0%, 0%)'
    },
    white: {
        value: 'hsl(0, 0%, 100%)'
    },
    transparent: {
        value: 'transparent'
    }
};


const $c0ac9cc352677dda$export$5ea928c9faf85bd3 = {
    // Default styles
    alignItems: {
        value: 'center'
    },
    justifyContent: {
        value: 'space-between'
    },
    color: {
        value: '{colors.font.primary.value}'
    },
    backgroundColor: {
        value: '{colors.background.tertiary.value}'
    },
    paddingBlock: {
        value: '{space.small.value}'
    },
    paddingInline: {
        value: '{space.medium.value}'
    },
    icon: {
        size: {
            value: '{fontSizes.xl.value}'
        }
    },
    heading: {
        fontSize: {
            value: '{fontSizes.medium.value}'
        },
        fontWeight: {
            value: '{fontWeights.bold.value}'
        }
    },
    // Variations
    info: {
        color: {
            value: '{colors.font.info.value}'
        },
        backgroundColor: {
            value: '{colors.background.info.value}'
        }
    },
    error: {
        color: {
            value: '{colors.font.error.value}'
        },
        backgroundColor: {
            value: '{colors.background.error.value}'
        }
    },
    warning: {
        color: {
            value: '{colors.font.warning.value}'
        },
        backgroundColor: {
            value: '{colors.background.warning.value}'
        }
    },
    success: {
        color: {
            value: '{colors.font.success.value}'
        },
        backgroundColor: {
            value: '{colors.background.success.value}'
        }
    }
};


const $51d00ed546b058aa$export$3ddce1834cf07f8a = {
    message: {
        backgroundColor: {
            value: '{colors.background.secondary.value}'
        },
        borderRadius: {
            value: '{radii.large.value}'
        },
        gap: {
            value: '{space.small.value}'
        },
        paddingBlock: {
            value: '{space.small.value}'
        },
        paddingInline: {
            value: '{space.small.value}'
        },
        user: {
            backgroundColor: {
                value: '{colors.background.secondary.value}'
            }
        },
        assistant: {
            backgroundColor: {
                value: '{colors.primary.10.value}'
            }
        },
        sender: {
            gap: {
                value: '{space.small.value}'
            },
            username: {
                color: {
                    value: '{colors.font.primary.value}'
                },
                fontSize: {
                    value: 'inherit'
                },
                fontWeight: {
                    value: '{fontWeights.bold.value}'
                }
            },
            timestamp: {
                color: {
                    value: '{colors.font.tertiary.value}'
                },
                fontSize: {
                    value: 'inherit'
                },
                fontWeight: {
                    value: 'inherit'
                }
            }
        },
        body: {
            gap: {
                value: '{space.xs.value}'
            }
        },
        actions: {
            gap: {
                value: '{space.xs.value}'
            }
        }
    },
    form: {
        gap: {
            value: '{space.small.value}'
        },
        padding: {
            value: '{space.small.value}'
        }
    },
    attachment: {
        borderColor: {
            value: '{colors.border.secondary.value}'
        },
        borderWidth: {
            value: '{borderWidths.small.value}'
        },
        borderRadius: {
            value: '{radii.small.value}'
        },
        fontSize: {
            value: '{fontSizes.small.value}'
        },
        paddingBlock: {
            value: '{space.xxxs.value}'
        },
        paddingInline: {
            value: '{space.xs.value}'
        },
        gap: {
            value: '{space.xs.value}'
        },
        list: {
            padding: {
                value: '{space.xs.value}'
            },
            paddingBlockStart: {
                value: '0'
            },
            gap: {
                value: '{space.xxs.value}'
            }
        },
        name: {
            color: {
                value: '{colors.font.primary.value}'
            },
            fontSize: {
                value: '{fontSizes.small.value}'
            },
            fontWeight: {
                value: '{fontWeights.normal.value}'
            }
        },
        size: {
            color: {
                value: '{colors.font.tertiary.value}'
            },
            fontSize: {
                value: '{fontSizes.small.value}'
            },
            fontWeight: {
                value: '{fontWeights.normal.value}'
            }
        },
        remove: {
            padding: {
                value: '{space.xxs.value}'
            }
        },
        image: {
            width: {
                value: '{fontSizes.medium.value}'
            },
            height: {
                value: '{fontSizes.medium.value}'
            }
        }
    }
};


const $3c8b40f52da830f7$export$485ded5f26ebe08d = {
    menu: {
        width: {
            value: '100%'
        },
        marginBlockStart: {
            value: '{space.xxxs}'
        },
        backgroundColor: {
            value: '{colors.background.primary}'
        },
        borderColor: {
            value: '{colors.border.primary}'
        },
        borderWidth: {
            value: '{borderWidths.small}'
        },
        borderStyle: {
            value: 'solid'
        },
        borderRadius: {
            value: '{radii.small}'
        },
        options: {
            display: {
                value: 'flex'
            },
            flexDirection: {
                value: 'column'
            },
            maxHeight: {
                value: '300px'
            }
        },
        option: {
            backgroundColor: {
                value: '{colors.background.primary}'
            },
            color: {
                value: 'currentcolor'
            },
            cursor: {
                value: 'pointer'
            },
            transitionDuration: {
                value: '{time.short}'
            },
            transitionProperty: {
                value: 'background-color, color'
            },
            transitionTimingFunction: {
                value: 'ease'
            },
            _active: {
                backgroundColor: {
                    value: '{colors.primary.80}'
                },
                color: {
                    value: '{colors.white}'
                }
            }
        },
        _empty: {
            display: {
                value: 'flex'
            }
        },
        _loading: {
            alignItems: {
                value: 'center'
            },
            display: {
                value: 'flex'
            },
            gap: {
                value: '{space.xxxs}'
            }
        },
        spaceShared: {
            paddingBlock: {
                value: '{space.xs}'
            },
            paddingInline: {
                value: '{space.small}'
            }
        }
    }
};


const $438f371b01826385$export$d5cb6eef88ffbde2 = {
    maxWidth: {
        value: '60rem'
    },
    modal: {
        width: {
            value: '{space.relative.full}'
        },
        height: {
            value: '{space.relative.full}'
        },
        backgroundColor: {
            value: '{colors.overlay.50.value}'
        },
        top: {
            value: '{space.zero}'
        },
        left: {
            value: '{space.zero}'
        }
    },
    container: {
        widthMax: {
            value: '30rem'
        }
    },
    router: {
        borderWidth: {
            value: '{borderWidths.small.value}'
        },
        borderStyle: {
            value: 'solid'
        },
        borderColor: {
            value: '{colors.border.primary.value}'
        },
        backgroundColor: {
            value: '{colors.background.primary.value}'
        },
        boxShadow: {
            value: '{shadows.medium.value}'
        }
    },
    footer: {
        paddingBottom: {
            value: '{space.medium.value}'
        }
    },
    form: {
        padding: {
            value: '{space.xl.value}'
        }
    },
    state: {
        inactive: {
            backgroundColor: {
                value: '{colors.background.secondary.value}'
            }
        }
    },
    orContainer: {
        color: {
            value: '{colors.neutral.80.value}'
        },
        orLine: {
            backgroundColor: {
                value: '{colors.background.primary.value}'
            }
        }
    }
};


const $afc6236ef7f85bdc$export$345c5736c8054f22 = {
    // Default styles
    color: {
        value: '{colors.font.tertiary.value}'
    },
    lineHeight: {
        value: 1
    },
    fontWeight: {
        value: '{fontWeights.semibold.value}'
    },
    fontSize: {
        value: '{fontSizes.small.value}'
    },
    textAlign: {
        value: 'center'
    },
    width: {
        value: '{fontSizes.xxl.value}'
    },
    height: {
        value: '{fontSizes.xxl.value}'
    },
    backgroundColor: {
        value: '{colors.background.tertiary}'
    },
    borderRadius: {
        value: '100%'
    },
    borderColor: {
        value: '{colors.border.primary.value}'
    },
    borderWidth: {
        value: '{borderWidths.medium.value}'
    },
    // Color Theme Variations
    info: {
        color: {
            value: '{colors.font.info.value}'
        },
        backgroundColor: {
            value: '{colors.background.info.value}'
        },
        borderColor: {
            value: '{colors.border.info.value}'
        }
    },
    warning: {
        color: {
            value: '{colors.font.warning.value}'
        },
        backgroundColor: {
            value: '{colors.background.warning.value}'
        },
        borderColor: {
            value: '{colors.border.warning.value}'
        }
    },
    success: {
        color: {
            value: '{colors.font.success.value}'
        },
        backgroundColor: {
            value: '{colors.background.success.value}'
        },
        borderColor: {
            value: '{colors.border.success.value}'
        }
    },
    error: {
        color: {
            value: '{colors.font.error.value}'
        },
        backgroundColor: {
            value: '{colors.background.error.value}'
        },
        borderColor: {
            value: '{colors.border.error.value}'
        }
    },
    // Sizes
    small: {
        fontSize: {
            value: '{fontSizes.xs.value}'
        },
        width: {
            value: '{fontSizes.xl.value}'
        },
        height: {
            value: '{fontSizes.xl.value}'
        }
    },
    // medium is the default size
    large: {
        fontSize: {
            value: '{fontSizes.medium.value}'
        },
        width: {
            value: '{fontSizes.xxxl.value}'
        },
        height: {
            value: '{fontSizes.xxxl.value}'
        }
    }
};


const $df5a5743a2d3a417$export$4aebd143f31d0c0d = {
    // Default styles
    color: {
        value: '{colors.font.primary.value}'
    },
    lineHeight: {
        value: 1
    },
    fontWeight: {
        value: '{fontWeights.semibold.value}'
    },
    fontSize: {
        value: '{fontSizes.small.value}'
    },
    textAlign: {
        value: 'center'
    },
    paddingVertical: {
        value: '{space.xs.value}'
    },
    paddingHorizontal: {
        value: '{space.small.value}'
    },
    backgroundColor: {
        value: '{colors.background.tertiary.value}'
    },
    // An arbitrarily large value to ensure that the left and right sides of the badge are perfectly rounded for any size variation
    borderRadius: {
        value: '{radii.xl.value}'
    },
    // Variations
    info: {
        color: {
            value: '{colors.font.info.value}'
        },
        backgroundColor: {
            value: '{colors.background.info.value}'
        }
    },
    warning: {
        color: {
            value: '{colors.font.warning.value}'
        },
        backgroundColor: {
            value: '{colors.background.warning.value}'
        }
    },
    success: {
        color: {
            value: '{colors.font.success.value}'
        },
        backgroundColor: {
            value: '{colors.background.success.value}'
        }
    },
    error: {
        color: {
            value: '{colors.font.error.value}'
        },
        backgroundColor: {
            value: '{colors.background.error.value}'
        }
    },
    // Sizes
    small: {
        fontSize: {
            value: '{fontSizes.xs.value}'
        },
        paddingVertical: {
            value: '{space.xxs.value}'
        },
        paddingHorizontal: {
            value: '{space.xs.value}'
        }
    },
    // medium is the default size
    large: {
        fontSize: {
            value: '{fontSizes.medium.value}'
        },
        paddingVertical: {
            value: '{space.small.value}'
        },
        paddingHorizontal: {
            value: '{space.medium.value}'
        }
    }
};


const $fd3c65b861b23482$export$515d2155aaad79e4 = {
    flexDirection: {
        value: 'row'
    },
    flexWrap: {
        value: 'wrap'
    },
    gap: {
        value: '0'
    },
    color: {
        value: '{colors.font.tertiary}'
    },
    item: {
        flexDirection: {
            value: 'row'
        },
        color: {
            value: 'inherit'
        },
        fontSize: {
            value: 'inherit'
        },
        alignItems: {
            value: 'center'
        },
        lineHeight: {
            value: '1'
        }
    },
    separator: {
        color: {
            value: 'inherit'
        },
        fontSize: {
            value: 'inherit'
        },
        paddingInline: {
            value: '{space.xxs}'
        }
    },
    link: {
        color: {
            value: '{components.link.color}'
        },
        fontSize: {
            value: 'inherit'
        },
        fontWeight: {
            value: 'normal'
        },
        textDecoration: {
            value: 'none'
        },
        paddingInline: {
            value: '{space.xs}'
        },
        paddingBlock: {
            value: '{space.xxs}'
        },
        current: {
            color: {
                value: 'inherit'
            },
            fontSize: {
                value: 'inherit'
            },
            fontWeight: {
                value: 'normal'
            },
            textDecoration: {
                value: 'none'
            }
        }
    }
};


const $66b019780ee7dc1f$export$2ba01fb71ed41cb6 = {
    // shared styles
    fontWeight: {
        value: '{fontWeights.bold.value}'
    },
    transitionDuration: {
        value: '{components.fieldcontrol.transitionDuration.value}'
    },
    fontSize: {
        value: '{components.fieldcontrol.fontSize.value}'
    },
    lineHeight: {
        value: '{components.fieldcontrol.lineHeight.value}'
    },
    paddingBlockStart: {
        value: '{components.fieldcontrol.paddingBlockStart.value}'
    },
    paddingBlockEnd: {
        value: '{components.fieldcontrol.paddingBlockEnd.value}'
    },
    paddingInlineStart: {
        value: '{components.fieldcontrol.paddingInlineStart.value}'
    },
    paddingInlineEnd: {
        value: '{components.fieldcontrol.paddingInlineEnd.value}'
    },
    backgroundColor: {
        value: 'transparent'
    },
    borderColor: {
        value: '{components.fieldcontrol.borderColor.value}'
    },
    borderWidth: {
        value: '{components.fieldcontrol.borderWidth.value}'
    },
    borderStyle: {
        value: '{components.fieldcontrol.borderStyle.value}'
    },
    borderRadius: {
        value: '{components.fieldcontrol.borderRadius.value}'
    },
    color: {
        value: '{colors.font.primary.value}'
    },
    _hover: {
        color: {
            value: '{colors.font.focus.value}'
        },
        backgroundColor: {
            value: '{colors.primary.10.value}'
        },
        borderColor: {
            value: '{colors.primary.60.value}'
        }
    },
    _focus: {
        color: {
            value: '{colors.font.focus.value}'
        },
        backgroundColor: {
            value: '{colors.primary.10.value}'
        },
        borderColor: {
            value: '{colors.border.focus.value}'
        },
        boxShadow: {
            value: '{components.fieldcontrol._focus.boxShadow.value}'
        }
    },
    _active: {
        color: {
            value: '{colors.font.active.value}'
        },
        backgroundColor: {
            value: '{colors.primary.20.value}'
        },
        borderColor: {
            value: '{colors.primary.100.value}'
        }
    },
    _loading: {
        color: {
            value: '{colors.font.disabled.value}'
        },
        backgroundColor: {
            value: 'transparent'
        },
        borderColor: {
            value: '{colors.border.tertiary.value}'
        }
    },
    _disabled: {
        color: {
            value: '{colors.font.disabled.value}'
        },
        backgroundColor: {
            value: 'transparent'
        },
        borderColor: {
            value: '{colors.border.tertiary.value}'
        }
    },
    // variations
    outlined: {
        info: {
            borderColor: {
                value: '{colors.blue.60.value}'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.blue.100}'
            },
            _hover: {
                borderColor: {
                    value: '{colors.blue.60.value}'
                },
                backgroundColor: {
                    value: '{colors.blue.10.value}'
                },
                color: {
                    value: '{colors.blue.100.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: '{colors.blue.100.value}'
                },
                backgroundColor: {
                    value: '{colors.blue.10.value}'
                },
                color: {
                    value: '{colors.blue.100.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol.info._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: '{colors.blue.100.value}'
                },
                backgroundColor: {
                    value: '{colors.blue.20.value}'
                },
                color: {
                    value: '{colors.blue.100.value}'
                }
            }
        },
        warning: {
            borderColor: {
                value: '{colors.orange.60.value}'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.orange.100}'
            },
            _hover: {
                borderColor: {
                    value: '{colors.orange.60.value}'
                },
                backgroundColor: {
                    value: '{colors.orange.10.value}'
                },
                color: {
                    value: '{colors.orange.100.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: '{colors.orange.100.value}'
                },
                backgroundColor: {
                    value: '{colors.orange.10.value}'
                },
                color: {
                    value: '{colors.orange.100.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol.warning._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: '{colors.orange.100.value}'
                },
                backgroundColor: {
                    value: '{colors.orange.20.value}'
                },
                color: {
                    value: '{colors.orange.100.value}'
                }
            }
        },
        success: {
            borderColor: {
                value: '{colors.green.60.value}'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.green.100}'
            },
            _hover: {
                borderColor: {
                    value: '{colors.green.60.value}'
                },
                backgroundColor: {
                    value: '{colors.green.10.value}'
                },
                color: {
                    value: '{colors.green.100.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: '{colors.green.100.value}'
                },
                backgroundColor: {
                    value: '{colors.green.10.value}'
                },
                color: {
                    value: '{colors.green.100.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol.success._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: '{colors.green.100.value}'
                },
                backgroundColor: {
                    value: '{colors.green.20.value}'
                },
                color: {
                    value: '{colors.green.100.value}'
                }
            }
        },
        error: {
            borderColor: {
                value: '{colors.red.80.value}'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.red.100}'
            },
            _hover: {
                borderColor: {
                    value: '{colors.red.80.value}'
                },
                backgroundColor: {
                    value: '{colors.red.10.value}'
                },
                color: {
                    value: '{colors.red.100.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: '{colors.red.100.value}'
                },
                backgroundColor: {
                    value: '{colors.red.10.value}'
                },
                color: {
                    value: '{colors.red.100.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol._error._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: '{colors.red.100.value}'
                },
                backgroundColor: {
                    value: '{colors.red.20.value}'
                },
                color: {
                    value: '{colors.red.100.value}'
                }
            }
        },
        overlay: {
            borderColor: {
                value: '{colors.overlay.60.value}'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.font.primary.value}'
            },
            _hover: {
                borderColor: {
                    value: '{colors.overlay.60.value}'
                },
                backgroundColor: {
                    value: '{colors.overlay.5.value}'
                },
                color: {
                    value: '{colors.neutral.90.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: '{colors.overlay.90.value}'
                },
                backgroundColor: {
                    value: '{colors.overlay.5.value}'
                },
                color: {
                    value: '{colors.neutral.90.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol.overlay._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: '{colors.overlay.90.value}'
                },
                backgroundColor: {
                    value: '{colors.overlay.10.value}'
                },
                color: {
                    value: '{colors.neutral.100.value}'
                }
            }
        }
    },
    primary: {
        borderColor: {
            value: 'transparent'
        },
        borderWidth: {
            value: '{borderWidths.small.value}'
        },
        borderStyle: {
            value: 'solid'
        },
        backgroundColor: {
            value: '{colors.primary.80.value}'
        },
        color: {
            value: '{colors.font.inverse.value}'
        },
        _disabled: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.background.disabled.value}'
            },
            color: {
                value: '{colors.font.disabled.value}'
            }
        },
        _loading: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.background.disabled.value}'
            },
            color: {
                value: '{colors.font.disabled.value}'
            }
        },
        _hover: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.primary.90.value}'
            },
            color: {
                value: '{colors.font.inverse.value}'
            }
        },
        _focus: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.primary.90.value}'
            },
            color: {
                value: '{colors.font.inverse.value}'
            },
            boxShadow: {
                value: '{components.fieldcontrol._focus.boxShadow.value}'
            }
        },
        _active: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.primary.100.value}'
            },
            color: {
                value: '{colors.font.inverse.value}'
            }
        },
        info: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.blue.80}'
            },
            color: {
                value: '{colors.font.inverse.value}'
            },
            _hover: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.blue.90.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.blue.90.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol.info._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.blue.100.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                }
            }
        },
        warning: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.orange.80}'
            },
            color: {
                value: '{colors.font.inverse.value}'
            },
            _hover: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.orange.90.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.orange.90.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol.overlay._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.orange.100.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                }
            }
        },
        error: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.red.80}'
            },
            color: {
                value: '{colors.font.inverse.value}'
            },
            _hover: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.red.90.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.red.90.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol._error._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.red.100.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                }
            }
        },
        success: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.green.80}'
            },
            color: {
                value: '{colors.font.inverse.value}'
            },
            _hover: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.green.90.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.green.90.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol.success._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.green.100.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                }
            }
        },
        overlay: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.overlay.70}'
            },
            color: {
                value: '{colors.font.inverse.value}'
            },
            _hover: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.overlay.90.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.overlay.90.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol.overlay._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.overlay.90.value}'
                },
                color: {
                    value: '{colors.font.inverse.value}'
                }
            }
        }
    },
    menu: {
        borderWidth: {
            value: '{space.zero.value}'
        },
        backgroundColor: {
            value: 'transparent'
        },
        justifyContent: {
            value: 'start'
        },
        // Focus and hover styles are identical for menu variation
        // because for Menu primitive, menu items are forced to be focused even
        // for mouse interactions, making it impossible to distinguish the two interactions
        _hover: {
            color: {
                value: '{colors.font.inverse.value}'
            },
            backgroundColor: {
                value: '{colors.primary.80.value}'
            }
        },
        _focus: {
            color: {
                value: '{colors.font.inverse.value}'
            },
            backgroundColor: {
                value: '{colors.primary.80.value}'
            }
        },
        _active: {
            color: {
                value: '{colors.font.inverse.value}'
            },
            backgroundColor: {
                value: '{colors.primary.90.value}'
            }
        },
        _disabled: {
            color: {
                value: '{colors.font.disabled.value}'
            }
        }
    },
    link: {
        backgroundColor: {
            value: 'transparent'
        },
        borderColor: {
            value: 'transparent'
        },
        borderWidth: {
            value: '{borderWidths.small.value}'
        },
        color: {
            value: '{colors.font.interactive.value}'
        },
        _hover: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.primary.10.value}'
            },
            color: {
                value: '{colors.font.hover.value}'
            }
        },
        _focus: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.primary.10.value}'
            },
            color: {
                value: '{colors.font.focus.value}'
            },
            boxShadow: {
                value: '{components.fieldcontrol._focus.boxShadow.value}'
            }
        },
        _active: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.primary.20.value}'
            },
            color: {
                value: '{colors.font.active.value}'
            }
        },
        _disabled: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.font.disabled.value}'
            }
        },
        _loading: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.font.disabled.value}'
            }
        },
        info: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.blue.100}'
            },
            _hover: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.blue.10.value}'
                },
                color: {
                    value: '{colors.blue.90.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.blue.10.value}'
                },
                color: {
                    value: '{colors.blue.100.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol.info._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.blue.20.value}'
                },
                color: {
                    value: '{colors.blue.100.value}'
                }
            }
        },
        warning: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.orange.100}'
            },
            _hover: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.orange.10.value}'
                },
                color: {
                    value: '{colors.orange.90.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.orange.10.value}'
                },
                color: {
                    value: '{colors.orange.100.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol.warning._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.orange.20.value}'
                },
                color: {
                    value: '{colors.orange.100.value}'
                }
            }
        },
        success: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.green.100}'
            },
            _hover: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.green.10.value}'
                },
                color: {
                    value: '{colors.green.90.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.green.10.value}'
                },
                color: {
                    value: '{colors.green.100.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol.success._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.green.20.value}'
                },
                color: {
                    value: '{colors.green.100.value}'
                }
            }
        },
        error: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.red.100}'
            },
            _hover: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.red.10.value}'
                },
                color: {
                    value: '{colors.red.90.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.red.10.value}'
                },
                color: {
                    value: '{colors.red.100.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol._error._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.red.20.value}'
                },
                color: {
                    value: '{colors.red.100.value}'
                }
            }
        },
        overlay: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.neutral.100}'
            },
            _hover: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.overlay.5.value}'
                },
                color: {
                    value: '{colors.overlay.80.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.overlay.5.value}'
                },
                color: {
                    value: '{colors.overlay.90.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol.overlay._focus.boxShadow.value}'
                }
            },
            _active: {
                borderColor: {
                    value: 'transparent'
                },
                backgroundColor: {
                    value: '{colors.overlay.10.value}'
                },
                color: {
                    value: '{colors.overlay.90.value}'
                }
            }
        }
    },
    warning: {
        backgroundColor: {
            value: 'transparent'
        },
        borderColor: {
            value: '{colors.red.60}'
        },
        borderWidth: {
            value: '{borderWidths.small}'
        },
        color: {
            value: '{colors.red.60}'
        },
        _hover: {
            borderColor: {
                value: '{colors.red.80}'
            },
            backgroundColor: {
                value: '{colors.red.10}'
            },
            color: {
                value: '{colors.font.error}'
            }
        },
        _focus: {
            borderColor: {
                value: '{colors.red.80}'
            },
            backgroundColor: {
                value: '{colors.red.10}'
            },
            color: {
                value: '{colors.red.80}'
            },
            boxShadow: {
                value: '{components.fieldcontrol._error._focus.boxShadow}'
            }
        },
        _active: {
            borderColor: {
                value: '{colors.red.100}'
            },
            backgroundColor: {
                value: '{colors.red.20}'
            },
            color: {
                value: '{colors.red.100}'
            }
        },
        _disabled: {
            borderColor: {
                value: '{colors.border.tertiary}'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.font.disabled}'
            }
        },
        _loading: {
            borderColor: {
                value: '{colors.border.tertiary}'
            },
            backgroundColor: {
                value: 'transparent'
            },
            color: {
                value: '{colors.font.disabled}'
            }
        }
    },
    destructive: {
        borderColor: {
            value: 'transparent'
        },
        borderWidth: {
            value: '{borderWidths.small}'
        },
        borderStyle: {
            value: 'solid'
        },
        backgroundColor: {
            value: '{colors.red.60}'
        },
        color: {
            value: '{colors.font.inverse}'
        },
        _disabled: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.background.disabled}'
            },
            color: {
                value: '{colors.font.disabled}'
            }
        },
        _loading: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.background.disabled}'
            },
            color: {
                value: '{colors.font.disabled}'
            }
        },
        _hover: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.red.80}'
            },
            color: {
                value: '{colors.font.inverse}'
            }
        },
        _focus: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.red.80}'
            },
            color: {
                value: '{colors.font.inverse}'
            },
            boxShadow: {
                value: '{components.fieldcontrol._error._focus.boxShadow}'
            }
        },
        _active: {
            borderColor: {
                value: 'transparent'
            },
            backgroundColor: {
                value: '{colors.red.100}'
            },
            color: {
                value: '{colors.font.inverse}'
            }
        }
    },
    // sizes
    small: {
        fontSize: {
            value: '{components.fieldcontrol.small.fontSize.value}'
        },
        paddingBlockStart: {
            value: '{components.fieldcontrol.small.paddingBlockStart.value}'
        },
        paddingBlockEnd: {
            value: '{components.fieldcontrol.small.paddingBlockEnd.value}'
        },
        paddingInlineStart: {
            value: '{components.fieldcontrol.small.paddingInlineStart.value}'
        },
        paddingInlineEnd: {
            value: '{components.fieldcontrol.small.paddingInlineEnd.value}'
        }
    },
    large: {
        fontSize: {
            value: '{components.fieldcontrol.large.fontSize.value}'
        },
        paddingBlockStart: {
            value: '{components.fieldcontrol.large.paddingBlockStart.value}'
        },
        paddingBlockEnd: {
            value: '{components.fieldcontrol.large.paddingBlockEnd.value}'
        },
        paddingInlineStart: {
            value: '{components.fieldcontrol.large.paddingInlineStart.value}'
        },
        paddingInlineEnd: {
            value: '{components.fieldcontrol.large.paddingInlineEnd.value}'
        }
    },
    loaderWrapper: {
        alignItems: {
            value: 'center'
        },
        gap: {
            value: '{space.xs.value}'
        }
    }
};


const $6a8e0515745d8b5a$export$aa3e815946b80764 = {
    backgroundColor: {
        value: '{colors.background.primary.value}'
    },
    borderRadius: {
        value: '{radii.xs.value}'
    },
    borderWidth: {
        value: '0'
    },
    borderStyle: {
        value: 'solid'
    },
    borderColor: {
        value: 'transparent'
    },
    boxShadow: {
        value: 'none'
    },
    padding: {
        value: '{space.medium.value}'
    },
    outlined: {
        backgroundColor: {
            value: '{components.card.backgroundColor.value}'
        },
        borderRadius: {
            value: '{radii.xs.value}'
        },
        borderWidth: {
            value: '{borderWidths.small.value}'
        },
        borderStyle: {
            value: 'solid'
        },
        borderColor: {
            value: '{colors.border.primary.value}'
        },
        boxShadow: {
            value: '{components.card.boxShadow.value}'
        }
    },
    elevated: {
        backgroundColor: {
            value: '{components.card.backgroundColor.value}'
        },
        borderRadius: {
            value: '{radii.xs.value}'
        },
        borderWidth: {
            value: '0'
        },
        borderStyle: {
            value: 'solid'
        },
        borderColor: {
            value: 'transparent'
        },
        boxShadow: {
            value: '{shadows.medium.value}'
        }
    }
};


const $20c2909ec7439911$export$b07e517d22efa1ca = {
    cursor: {
        value: 'pointer'
    },
    alignItems: {
        value: 'center'
    },
    _disabled: {
        cursor: {
            value: 'not-allowed'
        }
    },
    button: {
        position: {
            value: 'relative'
        },
        alignItems: {
            value: 'center'
        },
        justifyContent: {
            value: 'center'
        },
        color: {
            value: '{colors.font.inverse.value}'
        },
        before: {
            width: {
                value: '100%'
            },
            height: {
                value: '100%'
            },
            borderWidth: {
                value: '{borderWidths.medium.value}'
            },
            borderRadius: {
                value: '20%'
            },
            borderStyle: {
                value: 'solid'
            },
            borderColor: {
                value: '{colors.border.primary.value}'
            }
        },
        _focus: {
            outlineColor: {
                value: '{colors.transparent.value}'
            },
            outlineStyle: {
                value: 'solid'
            },
            outlineWidth: {
                value: '{outlineWidths.medium.value}'
            },
            outlineOffset: {
                value: '{outlineOffsets.medium.value}'
            },
            borderColor: {
                value: '{colors.border.focus.value}'
            },
            boxShadow: {
                value: '{components.fieldcontrol._focus.boxShadow.value}'
            }
        },
        _disabled: {
            borderColor: {
                value: '{colors.border.disabled.value}'
            }
        },
        _error: {
            borderColor: {
                value: '{colors.border.error.value}'
            },
            _focus: {
                borderColor: {
                    value: '{colors.border.error.value}'
                },
                boxShadow: {
                    value: '{components.fieldcontrol._error._focus.boxShadow.value}'
                }
            }
        }
    },
    icon: {
        backgroundColor: {
            value: '{colors.primary.80.value}'
        },
        borderRadius: {
            value: '20%'
        },
        opacity: {
            value: '{opacities.0.value}'
        },
        transform: {
            value: 'scale(0)'
        },
        transitionProperty: {
            value: 'all'
        },
        transitionDuration: {
            value: '{time.short.value}'
        },
        transitionTimingFunction: {
            value: 'ease-in-out'
        },
        _checked: {
            opacity: {
                value: '{opacities.100.value}'
            },
            transform: {
                value: 'scale(1)'
            },
            _disabled: {
                backgroundColor: {
                    value: '{colors.background.disabled.value}'
                }
            }
        },
        _indeterminate: {
            opacity: {
                value: '{opacities.100.value}'
            },
            transform: {
                value: 'scale(1)'
            },
            _disabled: {
                backgroundColor: {
                    value: '{colors.background.disabled.value}'
                }
            }
        }
    },
    label: {
        color: {
            value: '{components.text.color.value}'
        },
        _disabled: {
            color: {
                value: '{colors.font.disabled.value}'
            }
        }
    }
};


const $6b692d1e40924362$export$282c9e915736aefa = {
    alignItems: {
        value: 'flex-start'
    },
    alignContent: {
        value: 'center'
    },
    flexDirection: {
        value: 'column'
    },
    justifyContent: {
        value: 'center'
    }
};


//we are reusing the types from the nested components but new tokens need to be created that reference the previous tokens so that they can inherit the needed values but can be overwritten and only effect the collection component.
//only a subset of the design tokens of the nested components are being exposed, this can be expanded later.
const $1dcc57f0ce1fda0a$export$bf5175b0c24981cd = {
    pagination: {
        current: {
            color: {
                value: '{components.pagination.current.color}'
            },
            backgroundColor: {
                value: '{components.pagination.current.backgroundColor}'
            }
        },
        button: {
            color: {
                value: '{components.pagination.button.color}'
            },
            _hover: {
                backgroundColor: {
                    value: '{components.pagination.button.hover.backgroundColor}'
                },
                color: {
                    value: '{components.pagination.button.hover.color}'
                }
            },
            _disabled: {
                color: {
                    value: '{components.pagination.button.disabled.color}'
                }
            }
        }
    },
    search: {
        input: {
            color: {
                value: '{components.searchfield.color}'
            }
        },
        button: {
            color: {
                value: '{components.searchfield.button.color}'
            },
            _active: {
                backgroundColor: {
                    value: '{components.searchfield.button._active.backgroundColor}'
                },
                borderColor: {
                    value: '{components.searchfield.button._active.borderColor}'
                },
                color: {
                    value: '{components.searchfield.button._active.color}'
                }
            },
            _disabled: {
                backgroundColor: {
                    value: '{components.searchfield.button._disabled.backgroundColor}'
                },
                borderColor: {
                    value: '{components.searchfield.button._disabled.borderColor}'
                },
                color: {
                    value: '{components.searchfield.button._disabled.color}'
                }
            },
            _focus: {
                backgroundColor: {
                    value: '{components.searchfield.button._focus.backgroundColor}'
                },
                borderColor: {
                    value: '{components.searchfield.button._focus.borderColor}'
                },
                color: {
                    value: '{components.searchfield.button._focus.color}'
                }
            },
            _hover: {
                backgroundColor: {
                    value: '{components.searchfield.button._hover.backgroundColor}'
                },
                borderColor: {
                    value: '{components.searchfield.button._hover.borderColor}'
                },
                color: {
                    value: '{components.searchfield.button._hover.color}'
                }
            }
        }
    }
};


const $aac04ffd6917a1d0$export$784d13d8ee351f07 = {
    fontSize: {
        value: '{fontSizes.xs}'
    },
    gap: {
        value: '{space.relative.medium}'
    },
    svg: {
        path: {
            fill: {
                value: '{colors.font.primary}'
            }
        }
    },
    toolTip: {
        bottom: {
            value: '{space.large}'
        },
        color: {
            value: '{colors.teal.100}'
        },
        fontSize: {
            value: '{fontSizes.xxs}'
        }
    }
};


const $72aeb273d00bf6f4$export$5a80fc6ecf647d64 = {
    height: {
        value: '{space.relative.full.value}'
    }
};


const $0c11e10b1af0e361$export$e8c9778bf415dd08 = {
    borderStyle: {
        value: 'solid'
    },
    borderColor: {
        value: '{colors.border.primary.value}'
    },
    borderWidth: {
        value: '{borderWidths.medium.value}'
    },
    label: {
        color: {
            value: '{colors.font.tertiary.value}'
        },
        paddingInline: {
            value: '{space.medium.value}'
        },
        fontSize: {
            value: '{fontSizes.small.value}'
        },
        backgroundColor: {
            value: '{colors.background.primary.value}'
        }
    },
    small: {
        borderWidth: {
            value: '{borderWidths.small.value}'
        }
    },
    large: {
        borderWidth: {
            value: '{borderWidths.large.value}'
        }
    },
    opacity: {
        value: '{opacities.60.value}'
    }
};


const $96d537d0ab554364$export$585d0a7a39ed94ea = {
    backgroundColor: {
        value: '{colors.background.primary}'
    },
    borderRadius: {
        value: '{radii.small}'
    },
    borderColor: {
        value: '{colors.border.primary}'
    },
    borderStyle: {
        value: 'dashed'
    },
    borderWidth: {
        value: '{borderWidths.small}'
    },
    color: {
        value: '{colors.font.primary}'
    },
    gap: {
        value: '{space.small}'
    },
    paddingBlock: {
        value: '{space.xl}'
    },
    paddingInline: {
        value: '{space.large}'
    },
    textAlign: {
        value: 'center'
    },
    _active: {
        backgroundColor: {
            value: '{colors.primary.10}'
        },
        borderRadius: {
            value: '{components.dropzone.borderRadius}'
        },
        borderColor: {
            value: '{colors.border.pressed}'
        },
        borderStyle: {
            value: '{components.dropzone.borderStyle}'
        },
        borderWidth: {
            value: '{components.dropzone.borderWidth}'
        },
        color: {
            value: '{colors.font.primary}'
        }
    },
    _disabled: {
        backgroundColor: {
            value: '{colors.background.disabled}'
        },
        borderRadius: {
            value: '{components.dropzone.borderRadius}'
        },
        borderColor: {
            value: '{colors.border.disabled}'
        },
        borderStyle: {
            value: '{components.dropzone.borderStyle}'
        },
        borderWidth: {
            value: '{components.dropzone.borderWidth}'
        },
        color: {
            value: '{colors.font.disabled}'
        }
    },
    accepted: {
        backgroundColor: {
            value: '{colors.background.success}'
        },
        borderRadius: {
            value: '{components.dropzone.borderRadius}'
        },
        borderColor: {
            value: '{colors.border.success}'
        },
        borderStyle: {
            value: '{components.dropzone.borderStyle}'
        },
        borderWidth: {
            value: '{components.dropzone.borderWidth}'
        },
        color: {
            value: '{colors.font.success}'
        }
    },
    rejected: {
        backgroundColor: {
            value: '{colors.background.error}'
        },
        borderRadius: {
            value: '{components.dropzone.borderRadius}'
        },
        borderColor: {
            value: '{colors.border.pressed}'
        },
        borderStyle: {
            value: '{components.dropzone.borderStyle}'
        },
        borderWidth: {
            value: '{components.dropzone.borderWidth}'
        },
        color: {
            value: '{colors.font.error}'
        }
    }
};


const $427231fe728e403a$export$77f5744dadf9dca6 = {
    backgroundColor: {
        value: '{colors.background.primary.value}'
    },
    item: {
        borderColor: {
            value: '{colors.border.secondary.value}'
        },
        borderWidth: {
            value: '{borderWidths.small.value}'
        },
        borderStyle: {
            value: 'solid'
        },
        borderRadius: {
            value: '{radii.small.value}'
        },
        trigger: {
            alignItems: {
                value: 'center'
            },
            backgroundColor: {
                value: '{colors.background.primary.value}'
            },
            color: {
                value: 'inherit'
            },
            gap: {
                value: '{space.small.value}'
            },
            justifyContent: {
                value: 'space-between'
            },
            paddingBlock: {
                value: '{space.xs.value}'
            },
            paddingInline: {
                value: '{space.small.value}'
            },
            _hover: {
                color: {
                    value: 'inherit'
                },
                backgroundColor: {
                    value: '{colors.overlay.5.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: '{colors.border.focus.value}'
                },
                boxShadow: {
                    value: {
                        offsetX: '0',
                        offsetY: '0',
                        blurRadius: '0',
                        spreadRadius: '2px',
                        color: '{colors.border.focus.value}'
                    }
                }
            }
        },
        content: {
            color: {
                value: 'inherit'
            },
            paddingInline: {
                value: '{space.small.value}'
            },
            paddingBlockEnd: {
                value: '{space.small.value}'
            },
            paddingBlockStart: {
                value: '{space.xxxs.value}'
            }
        },
        icon: {
            color: {
                value: '{colors.font.tertiary.value}'
            },
            transitionDuration: {
                value: '{time.medium.value}'
            },
            transitionTimingFunction: {
                value: 'cubic-bezier(0.87, 0, 0.13, 1)'
            }
        }
    }
};


const $bdfed67225b2b58a$export$e0f35d825088c098 = {
    // default styles
    gap: {
        value: '{space.xs.value}'
    },
    fontSize: {
        value: '{fontSizes.medium.value}'
    },
    flexDirection: {
        value: 'column'
    },
    // Adjust base fontSize and gap for small and large sizes
    small: {
        gap: {
            value: '{space.xxxs.value}'
        },
        fontSize: {
            value: '{fontSizes.small.value}'
        }
    },
    large: {
        gap: {
            value: '{space.small.value}'
        },
        fontSize: {
            value: '{fontSizes.large.value}'
        }
    },
    label: {
        color: {
            value: '{colors.font.secondary.value}'
        }
    }
};


const $6d42bf09234c104b$export$5ba822cdf6eca6d5 = {
    borderStyle: {
        value: 'solid'
    },
    borderColor: {
        value: '{colors.border.primary.value}'
    },
    borderWidth: {
        value: '{borderWidths.small.value}'
    },
    borderRadius: {
        value: '{radii.small.value}'
    },
    color: {
        value: '{colors.font.primary.value}'
    },
    paddingBlockStart: {
        value: '{space.xs.value}'
    },
    paddingBlockEnd: {
        value: '{space.xs.value}'
    },
    paddingInlineStart: {
        value: '{space.medium.value}'
    },
    paddingInlineEnd: {
        value: '{space.medium.value}'
    },
    fontSize: {
        value: '{components.field.fontSize.value}'
    },
    lineHeight: {
        value: '{lineHeights.medium.value}'
    },
    transitionDuration: {
        value: '{time.medium.value}'
    },
    outlineColor: {
        value: '{colors.transparent.value}'
    },
    outlineStyle: {
        value: 'solid'
    },
    outlineWidth: {
        value: '{outlineWidths.medium.value}'
    },
    outlineOffset: {
        value: '{outlineOffsets.medium.value}'
    },
    small: {
        fontSize: {
            value: '{components.field.small.fontSize.value}'
        },
        paddingBlockStart: {
            value: '{space.xxs.value}'
        },
        paddingBlockEnd: {
            value: '{space.xxs.value}'
        },
        paddingInlineStart: {
            value: '{space.small.value}'
        },
        paddingInlineEnd: {
            value: '{space.small.value}'
        }
    },
    large: {
        fontSize: {
            value: '{components.field.large.fontSize.value}'
        },
        paddingBlockStart: {
            value: '{space.xs.value}'
        },
        paddingBlockEnd: {
            value: '{space.xs.value}'
        },
        paddingInlineStart: {
            value: '{space.medium.value}'
        },
        paddingInlineEnd: {
            value: '{space.medium.value}'
        }
    },
    quiet: {
        borderStyle: {
            value: 'none'
        },
        borderInlineStart: {
            value: 'none'
        },
        borderInlineEnd: {
            value: 'none'
        },
        borderBlockStart: {
            value: 'none'
        },
        borderRadius: {
            value: '0'
        },
        _focus: {
            borderBlockEndColor: {
                value: 'transparent'
            },
            boxShadow: {
                value: '{components.fieldcontrol._focus.boxShadow.value}'
            }
        },
        _error: {
            borderBlockEndColor: {
                value: '{colors.border.error.value}'
            },
            _focus: {
                borderBlockEndColor: {
                    value: 'transparent'
                },
                boxShadow: {
                    value: '{components.fieldcontrol._error._focus.boxShadow.value}'
                }
            }
        }
    },
    _focus: {
        // These focus styles have been calibrated to create
        // a highly visible focus indicator per WCAG 2.2 guidlines:
        // See: https://www.w3.org/TR/WCAG22/#focus-appearance
        //
        // Key features:
        // * Focus indicator area is at least the 2 CSS px perimeter around the component.
        // * Contrast between focused and unfocused area of contrast has a ratio of 3:1
        //
        // IMPORTANT: Must recalibrate if `colors.border.focus` are changed
        borderColor: {
            value: '{colors.border.focus.value}'
        },
        boxShadow: {
            value: {
                offsetX: '0px',
                offsetY: '0px',
                blurRadius: '0px',
                spreadRadius: '2px',
                color: '{colors.border.focus.value}'
            }
        }
    },
    _disabled: {
        color: {
            value: '{colors.font.disabled.value}'
        },
        cursor: {
            value: 'not-allowed'
        },
        borderColor: {
            value: '{colors.transparent.value}'
        },
        backgroundColor: {
            value: '{colors.background.disabled.value}'
        }
    },
    _error: {
        borderColor: {
            value: '{colors.border.error.value}'
        },
        color: {
            value: '{colors.font.error.value}'
        },
        _focus: {
            boxShadow: {
                value: {
                    offsetX: '0px',
                    offsetY: '0px',
                    blurRadius: '0px',
                    spreadRadius: '2px',
                    color: '{colors.border.error.value}'
                }
            }
        }
    },
    info: {
        _focus: {
            boxShadow: {
                value: {
                    offsetX: '0px',
                    offsetY: '0px',
                    blurRadius: '0px',
                    spreadRadius: '2px',
                    color: '{colors.blue.100.value}'
                }
            }
        }
    },
    warning: {
        _focus: {
            boxShadow: {
                value: {
                    offsetX: '0px',
                    offsetY: '0px',
                    blurRadius: '0px',
                    spreadRadius: '2px',
                    color: '{colors.orange.100.value}'
                }
            }
        }
    },
    success: {
        _focus: {
            boxShadow: {
                value: {
                    offsetX: '0px',
                    offsetY: '0px',
                    blurRadius: '0px',
                    spreadRadius: '2px',
                    color: '{colors.green.100.value}'
                }
            }
        }
    },
    overlay: {
        _focus: {
            boxShadow: {
                value: {
                    offsetX: '0px',
                    offsetY: '0px',
                    blurRadius: '0px',
                    spreadRadius: '2px',
                    color: '{colors.overlay.90.value}'
                }
            }
        }
    }
};


const $b9828c9079716621$export$886e4abc352a8403 = {
    gap: {
        value: '{space.zero.value}'
    },
    vertical: {
        alignItems: {
            value: 'center'
        }
    },
    outer: {
        alignItems: {
            value: 'center'
        }
    }
};


const $88e1c51dce624a91$export$a38812d1aa1302d9 = {
    backgroundColor: {
        value: 'transparent'
    },
    borderRadius: {
        value: '{radii.xs.value}'
    },
    flexDirection: {
        value: 'column'
    },
    gap: {
        value: '{components.field.gap.value}'
    },
    legend: {
        color: {
            value: '{colors.font.primary.value}'
        },
        fontSize: {
            value: '{components.field.fontSize.value}'
        },
        fontWeight: {
            value: '{fontWeights.bold.value}'
        },
        lineHeight: {
            value: '{lineHeights.medium.value}'
        },
        small: {
            fontSize: '{components.field.small.fontSize.value}'
        },
        large: {
            fontSize: '{components.field.large.fontSize.value}'
        }
    },
    outlined: {
        padding: '{space.medium.value}',
        borderColor: '{colors.neutral.40.value}',
        borderWidth: '{borderWidths.small.value}',
        borderStyle: 'solid',
        small: {
            padding: '{space.small.value}'
        },
        large: {
            padding: '{space.large.value}'
        }
    },
    small: {
        gap: '{components.field.small.gap.value}'
    },
    large: {
        gap: '{components.field.large.gap.value}'
    }
};


const $65a7f31a6e4726b8$export$b29676ca3eb575f7 = {
    error: {
        color: {
            value: '{colors.font.error.value}'
        },
        fontSize: {
            value: '{fontSizes.small.value}'
        }
    },
    description: {
        color: {
            value: '{colors.font.secondary.value}'
        },
        fontStyle: {
            value: 'italic'
        },
        fontSize: {
            value: '{fontSizes.small.value}'
        }
    }
};


const $a48ce20eab28b130$export$ec053a04994851f2 = {
    dropzone: {
        backgroundColor: {
            value: '{colors.background.primary}'
        },
        borderRadius: {
            value: '{radii.small}'
        },
        borderColor: {
            value: '{colors.border.primary}'
        },
        borderStyle: {
            value: 'dashed'
        },
        borderWidth: {
            value: '{borderWidths.small}'
        },
        gap: {
            value: '{space.small}'
        },
        paddingBlock: {
            value: '{space.xl}'
        },
        paddingInline: {
            value: '{space.large}'
        },
        textAlign: {
            value: 'center'
        },
        _active: {
            backgroundColor: {
                value: '{colors.primary.10}'
            },
            borderRadius: {
                value: '{components.fileuploader.dropzone.borderRadius}'
            },
            borderColor: {
                value: '{colors.border.pressed}'
            },
            borderStyle: {
                value: '{components.fileuploader.dropzone.borderStyle}'
            },
            borderWidth: {
                value: '{borderWidths.medium}'
            }
        },
        icon: {
            color: {
                value: '{colors.border.primary}'
            },
            fontSize: {
                value: '{fontSizes.xxl}'
            }
        },
        text: {
            color: {
                value: '{colors.font.tertiary}'
            },
            fontSize: {
                value: '{fontSizes.medium}'
            },
            fontWeight: {
                value: '{fontWeights.bold}'
            }
        }
    },
    file: {
        backgroundColor: {
            value: '{colors.background.primary}'
        },
        borderRadius: {
            value: '{radii.small}'
        },
        borderColor: {
            value: '{colors.border.primary}'
        },
        borderStyle: {
            value: 'solid'
        },
        borderWidth: {
            value: '{borderWidths.small}'
        },
        paddingBlock: {
            value: '{space.xs}'
        },
        paddingInline: {
            value: '{space.small}'
        },
        gap: {
            value: '{space.small}'
        },
        alignItems: {
            value: 'baseline'
        },
        name: {
            fontSize: {
                value: '{fontSizes.medium}'
            },
            fontWeight: {
                value: '{fontWeights.bold}'
            },
            color: {
                value: '{colors.font.primary}'
            }
        },
        size: {
            fontSize: {
                value: '{fontSizes.small}'
            },
            fontWeight: {
                value: '{fontWeights.normal}'
            },
            color: {
                value: '{colors.font.tertiary}'
            }
        },
        image: {
            width: {
                value: '{space.xxl}'
            },
            height: {
                value: '{space.xxl}'
            },
            backgroundColor: {
                value: '{colors.background.secondary}'
            },
            color: {
                value: '{colors.font.tertiary}'
            },
            borderRadius: {
                value: '{radii.small}'
            }
        }
    },
    filelist: {
        flexDirection: {
            value: 'column'
        },
        gap: {
            value: '{space.small}'
        }
    },
    loader: {
        strokeLinecap: {
            value: 'round'
        },
        strokeEmpty: {
            value: '{colors.border.secondary}'
        },
        strokeFilled: {
            value: '{components.loader.strokeFilled}'
        },
        strokeWidth: {
            value: '{borderWidths.large}'
        }
    },
    previewer: {
        backgroundColor: {
            value: '{colors.background.primary}'
        },
        borderColor: {
            value: '{colors.border.primary}'
        },
        borderStyle: {
            value: 'solid'
        },
        borderWidth: {
            value: '{borderWidths.small}'
        },
        borderRadius: {
            value: '{radii.small}'
        },
        paddingBlock: {
            value: '{space.zero}'
        },
        paddingInline: {
            value: '{space.zero}'
        },
        maxHeight: {
            value: '40rem'
        },
        maxWidth: {
            value: 'auto'
        },
        text: {
            fontSize: {
                value: '{fontSizes.medium}'
            },
            fontWeight: {
                value: '{fontWeights.bold}'
            },
            color: {
                value: '{colors.font.primary}'
            }
        },
        body: {
            paddingBlock: {
                value: '{space.medium}'
            },
            paddingInline: {
                value: '{space.medium}'
            },
            gap: {
                value: '{space.small}'
            }
        },
        footer: {
            justifyContent: {
                value: 'flex-end'
            }
        }
    }
};


const $a2029bc61345c439$export$97691fbb80847c19 = {
    gap: {
        value: '{space.medium.value}'
    },
    justifyContent: {
        value: 'normal'
    },
    alignItems: {
        value: 'stretch'
    },
    alignContent: {
        value: 'normal'
    },
    flexWrap: {
        value: 'nowrap'
    }
};


const $e9d8ea8ba90fa0bb$export$46e4a324ac90507f = {
    color: {
        value: '{colors.font.primary.value}'
    },
    lineHeight: {
        value: '{lineHeights.small.value}'
    },
    1: {
        fontSize: {
            value: '{fontSizes.xxxxl.value}'
        },
        fontWeight: {
            value: '{fontWeights.light.value}'
        }
    },
    2: {
        fontSize: {
            value: '{fontSizes.xxxl.value}'
        },
        fontWeight: {
            value: '{fontWeights.normal.value}'
        }
    },
    3: {
        fontSize: {
            value: '{fontSizes.xxl.value}'
        },
        fontWeight: {
            value: '{fontWeights.medium.value}'
        }
    },
    4: {
        fontSize: {
            value: '{fontSizes.xl.value}'
        },
        fontWeight: {
            value: '{fontWeights.semibold.value}'
        }
    },
    5: {
        fontSize: {
            value: '{fontSizes.large.value}'
        },
        fontWeight: {
            value: '{fontWeights.bold.value}'
        }
    },
    6: {
        fontSize: {
            value: '{fontSizes.medium.value}'
        },
        fontWeight: {
            value: '{fontWeights.extrabold.value}'
        }
    }
};


const $a5c639d183e53e8a$export$5340050496cd0f8f = {
    highlighted: {
        fontWeight: {
            value: '{fontWeights.bold}'
        }
    }
};


const $e3400b570fbdc14b$export$1ca1ec8b29a4ce27 = {
    lineHeight: {
        value: 1
    },
    height: {
        value: '1em'
    }
};


const $0d18adb4dc917636$export$b7e3ae3d7c15e42e = {
    color: {
        value: '{components.fieldcontrol.color.value}'
    },
    borderColor: {
        value: '{components.fieldcontrol.borderColor.value}'
    },
    fontSize: {
        value: '{components.fieldcontrol.fontSize.value}'
    },
    _focus: {
        borderColor: {
            value: '{components.fieldcontrol._focus.borderColor.value}'
        }
    }
};


const $2b527447bd116461$export$5c452ff88e35e47d = {
    maxWidth: {
        value: '100%'
    },
    height: {
        value: 'auto'
    },
    objectFit: {
        value: 'initial'
    },
    objectPosition: {
        value: 'initial'
    }
};


const $34537f2210528349$export$be5f4c7eec37e17e = {
    banner: {
        height: {
            value: '150px '
        },
        width: {
            value: '400px '
        }
    },
    button: {
        backgroundColor: {
            value: '#e8e8e8'
        },
        borderRadius: {
            value: '5px'
        },
        color: {
            value: 'black'
        }
    },
    dialog: {
        height: {
            value: '50vh'
        },
        minHeight: {
            value: '400px'
        },
        minWidth: {
            value: '400px'
        },
        width: {
            value: '30vw'
        }
    },
    header: {
        fontSize: {
            value: '{fontSizes.medium.value}'
        },
        fontWeight: {
            value: '{fontWeights.extrabold.value}'
        }
    }
};


const $22d1a63f75fc48d1$export$9c30223ca0a664fb = {
    active: {
        color: {
            value: '{colors.font.active.value}'
        }
    },
    color: {
        value: '{colors.font.interactive.value}'
    },
    focus: {
        color: {
            value: '{colors.font.focus.value}'
        }
    },
    hover: {
        color: {
            value: '{colors.font.hover.value}'
        }
    },
    visited: {
        color: {
            value: '{colors.font.interactive.value}'
        }
    }
};


const $0d80bdbfd6efb689$export$674047c1a0a83243 = {
    cameraModule: {
        backgroundColor: {
            value: '{colors.background.primary.value}'
        }
    }
};


const $15098a209f360e7b$export$f4c5de44377d2946 = {
    width: {
        value: '{fontSizes.medium.value}'
    },
    height: {
        value: '{fontSizes.medium.value}'
    },
    fontSize: {
        value: '{fontSizes.xs.value}'
    },
    strokeEmpty: {
        value: '{colors.neutral.20.value}'
    },
    strokeFilled: {
        value: '{colors.primary.80.value}'
    },
    strokeLinecap: {
        value: 'round'
    },
    animationDuration: {
        value: '1s'
    },
    small: {
        width: {
            value: '{fontSizes.small.value}'
        },
        height: {
            value: '{fontSizes.small.value}'
        },
        fontSize: {
            value: '{fontSizes.xxs.value}'
        }
    },
    large: {
        width: {
            value: '{fontSizes.large.value}'
        },
        height: {
            value: '{fontSizes.large.value}'
        },
        fontSize: {
            value: '{fontSizes.small.value}'
        }
    },
    linear: {
        width: {
            value: '100%'
        },
        minWidth: {
            value: '5rem'
        },
        fontSize: {
            value: '{fontSizes.xxs.value}'
        },
        strokeWidth: {
            value: '{fontSizes.xxs.value}'
        },
        strokeFilled: {
            value: '{colors.primary.80.value}'
        },
        strokeEmpty: {
            value: '{colors.neutral.20.value}'
        },
        strokeLinecap: {
            value: 'round'
        },
        animationDuration: {
            value: '1s'
        },
        small: {
            strokeWidth: {
                value: '{fontSizes.xxxs.value}'
            },
            fontSize: {
                value: '{fontSizes.xxxs.value}'
            }
        },
        large: {
            strokeWidth: {
                value: '{fontSizes.xs.value}'
            },
            fontSize: {
                value: '{fontSizes.xs.value}'
            }
        }
    },
    text: {
        fill: {
            value: '{colors.font.primary.value}'
        }
    }
};


const $dd93d9e57746b85c$export$b1e5508a851be14d = {
    backgroundColor: {
        value: '{colors.background.primary.value}'
    },
    borderRadius: {
        value: '{radii.medium.value}'
    },
    borderWidth: {
        value: '{borderWidths.small.value}'
    },
    borderStyle: {
        value: 'solid'
    },
    borderColor: {
        value: '{colors.border.primary.value}'
    },
    boxShadow: {
        value: '{shadows.large.value}'
    },
    flexDirection: {
        value: 'column'
    },
    gap: {
        value: '{space.zero.value}'
    },
    maxWidth: {
        value: '30rem'
    },
    minWidth: {
        value: '14rem'
    },
    small: {
        width: {
            value: '{fontSizes.medium.value}'
        },
        height: {
            value: '{fontSizes.medium.value}'
        }
    },
    large: {
        width: {
            value: '{fontSizes.xxxl.value}'
        },
        height: {
            value: '{fontSizes.xxxl.value}'
        }
    },
    item: {
        minHeight: {
            value: '2.5rem'
        },
        paddingInlineStart: {
            value: '{space.medium.value}'
        },
        paddingInlineEnd: {
            value: '{space.medium.value}'
        }
    }
};


const $cf4f7ae878809c75$export$a8ecead220dd38a6 = {
    // Default styles
    alignItems: {
        value: 'center'
    },
    backgroundColor: {
        value: '{colors.background.tertiary.value}'
    },
    borderColor: {
        value: 'transparent'
    },
    borderStyle: {
        value: 'solid'
    },
    borderWidth: {
        value: '{borderWidths.small.value}'
    },
    borderRadius: {
        value: '{radii.xs.value}'
    },
    color: {
        value: '{colors.font.primary.value}'
    },
    justifyContent: {
        value: 'flex-start'
    },
    paddingBlock: {
        value: '{space.small.value}'
    },
    paddingInline: {
        value: '{space.medium.value}'
    },
    lineHeight: {
        value: '{lineHeights.small.value}'
    },
    icon: {
        size: {
            value: '{fontSizes.xl.value}'
        }
    },
    heading: {
        fontSize: {
            value: '{fontSizes.medium.value}'
        },
        fontWeight: {
            value: '{fontWeights.bold.value}'
        }
    },
    dismiss: {
        gap: {
            value: '{space.xxs.value}'
        }
    },
    // Variations
    plain: {
        color: {
            value: '{colors.font.primary.value}'
        },
        backgroundColor: {
            value: '{colors.background.primary.value}'
        },
        borderColor: {
            value: 'transparent'
        },
        info: {
            color: {
                value: '{colors.font.info.value}'
            },
            backgroundColor: {
                value: '{colors.background.primary.value}'
            },
            borderColor: {
                value: 'transparent'
            }
        },
        error: {
            color: {
                value: '{colors.font.error.value}'
            },
            backgroundColor: {
                value: '{colors.background.primary.value}'
            },
            borderColor: {
                value: 'transparent'
            }
        },
        success: {
            color: {
                value: '{colors.font.success.value}'
            },
            backgroundColor: {
                value: '{colors.background.primary.value}'
            },
            borderColor: {
                value: 'transparent'
            }
        },
        warning: {
            color: {
                value: '{colors.font.warning.value}'
            },
            backgroundColor: {
                value: '{colors.background.primary.value}'
            },
            borderColor: {
                value: 'transparent'
            }
        }
    },
    outlined: {
        color: {
            value: '{colors.font.primary.value}'
        },
        backgroundColor: {
            value: '{colors.background.primary.value}'
        },
        borderColor: {
            value: '{colors.border.primary.value}'
        },
        info: {
            color: {
                value: '{colors.font.info.value}'
            },
            backgroundColor: {
                value: '{colors.background.primary.value}'
            },
            borderColor: {
                value: '{colors.border.info.value}'
            }
        },
        error: {
            color: {
                value: '{colors.font.error.value}'
            },
            backgroundColor: {
                value: '{colors.background.primary.value}'
            },
            borderColor: {
                value: '{colors.border.error.value}'
            }
        },
        success: {
            color: {
                value: '{colors.font.success.value}'
            },
            backgroundColor: {
                value: '{colors.background.primary.value}'
            },
            borderColor: {
                value: '{colors.border.success.value}'
            }
        },
        warning: {
            color: {
                value: '{colors.font.warning.value}'
            },
            backgroundColor: {
                value: '{colors.background.primary.value}'
            },
            borderColor: {
                value: '{colors.border.warning.value}'
            }
        }
    },
    filled: {
        color: {
            value: '{colors.font.primary.value}'
        },
        backgroundColor: {
            value: '{colors.background.secondary.value}'
        },
        borderColor: {
            value: 'transparent'
        },
        info: {
            color: {
                value: '{colors.font.info.value}'
            },
            backgroundColor: {
                value: '{colors.background.info.value}'
            },
            borderColor: {
                value: 'transparent'
            }
        },
        error: {
            color: {
                value: '{colors.font.error.value}'
            },
            backgroundColor: {
                value: '{colors.background.error.value}'
            },
            borderColor: {
                value: 'transparent'
            }
        },
        success: {
            color: {
                value: '{colors.font.success.value}'
            },
            backgroundColor: {
                value: '{colors.background.success.value}'
            },
            borderColor: {
                value: 'transparent'
            }
        },
        warning: {
            color: {
                value: '{colors.font.warning.value}'
            },
            backgroundColor: {
                value: '{colors.background.warning.value}'
            },
            borderColor: {
                value: 'transparent'
            }
        }
    }
};


const $892ffa998a71b70e$export$22fa394f3ba39578 = {
    current: {
        alignItems: {
            value: 'center'
        },
        justifyContent: {
            value: 'center'
        },
        color: {
            value: '{colors.font.inverse.value}'
        },
        fontSize: {
            value: '{fontSizes.small.value}'
        },
        backgroundColor: {
            value: '{colors.overlay.40.value}'
        }
    },
    button: {
        color: {
            value: '{colors.font.primary.value}'
        },
        paddingInlineStart: {
            value: '{space.xxs.value}'
        },
        paddingInlineEnd: {
            value: '{space.xxs.value}'
        },
        transitionProperty: {
            value: 'background-color'
        },
        transitionDuration: {
            value: '{time.medium.value}'
        },
        hover: {
            backgroundColor: {
                value: '{colors.overlay.10.value}'
            },
            color: {
                value: '{colors.font.primary.value}'
            }
        },
        disabled: {
            color: {
                value: '{colors.font.disabled.value}'
            }
        }
    },
    ellipsis: {
        alignItems: {
            value: 'baseline'
        },
        justifyContent: {
            value: 'center'
        },
        paddingInlineStart: {
            value: '{space.xs.value}'
        },
        paddingInlineEnd: {
            value: '{space.xs.value}'
        }
    },
    itemContainer: {
        marginLeft: {
            value: '{space.xxxs.value}'
        },
        marginRight: {
            value: '{space.xxxs.value}'
        }
    },
    itemShared: {
        height: {
            value: '{fontSizes.xxl.value}'
        },
        minWidth: {
            value: '{fontSizes.xxl.value}'
        },
        borderRadius: {
            value: '{fontSizes.medium.value}'
        }
    }
};


const $1b82d7fa04ad2590$export$75dd6c0d8e7c7e6b = {
    color: {
        value: '{components.fieldcontrol.color.value}'
    },
    button: {
        color: {
            value: '{components.button.color.value}'
        },
        _active: {
            backgroundColor: {
                value: '{components.button._active.backgroundColor.value}'
            },
            borderColor: {
                value: '{components.button._active.borderColor.value}'
            },
            color: {
                value: '{components.button._active.color.value}'
            }
        },
        _disabled: {
            backgroundColor: {
                value: '{components.button._disabled.backgroundColor.value}'
            },
            borderColor: {
                value: '{components.button._disabled.borderColor.value}'
            },
            color: {
                value: '{components.button._disabled.color.value}'
            }
        },
        _error: {
            color: {
                value: '{components.button.outlined.error.color.value}'
            },
            backgroundColor: {
                value: '{components.button.outlined.error.backgroundColor.value}'
            },
            borderColor: {
                value: '{components.button.outlined.error.borderColor.value}'
            },
            _active: {
                borderColor: {
                    value: '{components.button.outlined.error._active.borderColor.value}'
                },
                backgroundColor: {
                    value: '{components.button.outlined.error._active.backgroundColor.value}'
                },
                color: {
                    value: '{components.button.outlined.error._active.color.value}'
                }
            },
            _focus: {
                borderColor: {
                    value: '{components.button.outlined.error._focus.borderColor.value}'
                },
                backgroundColor: {
                    value: '{components.button.outlined.error._focus.backgroundColor.value}'
                },
                color: {
                    value: '{components.button.outlined.error._focus.color.value}'
                },
                boxShadow: {
                    value: '{components.button.outlined.error._focus.boxShadow.value}'
                }
            },
            _hover: {
                borderColor: {
                    value: '{components.button.outlined.error._hover.borderColor.value}'
                },
                backgroundColor: {
                    value: '{components.button.outlined.error._hover.backgroundColor.value}'
                },
                color: {
                    value: '{components.button.outlined.error._hover.color.value}'
                }
            }
        },
        _focus: {
            backgroundColor: {
                value: '{components.button._focus.backgroundColor.value}'
            },
            borderColor: {
                value: '{components.button._focus.borderColor.value}'
            },
            color: {
                value: '{components.button._focus.color.value}'
            }
        },
        _hover: {
            backgroundColor: {
                value: '{components.button._hover.backgroundColor.value}'
            },
            borderColor: {
                value: '{components.button._hover.borderColor.value}'
            },
            color: {
                value: '{components.button._hover.color.value}'
            }
        }
    }
};


const $41ff83f21e1d8c64$export$2b14d7973e978f83 = {
    color: {
        value: '{components.fieldcontrol.color}'
    },
    borderColor: {
        value: '{components.fieldcontrol.borderColor}'
    },
    fontSize: {
        value: '{components.fieldcontrol.fontSize}'
    },
    _focus: {
        borderColor: {
            value: '{components.fieldcontrol._focus.borderColor}'
        }
    }
};


const $b14179f3ea1969b8$export$c7187bbd1a7a9244 = {
    borderRadius: {
        value: '{radii.small.value}'
    },
    transitionDuration: {
        value: '{time.long.value}'
    },
    startColor: {
        value: '{colors.background.secondary.value}'
    },
    endColor: {
        value: '{colors.background.tertiary.value}'
    },
    // sizes
    small: {
        height: {
            value: '{space.small.value}'
        }
    },
    default: {
        height: {
            value: '{space.medium.value}'
        }
    },
    large: {
        height: {
            value: '{space.large.value}'
        }
    }
};


const $531e8898e172310f$export$b56dc0f160585b86 = {
    alignItems: {
        value: 'center'
    },
    justifyContent: {
        value: 'flex-start'
    },
    gap: {
        value: 'inherit'
    },
    _disabled: {
        cursor: {
            value: 'not-allowed'
        }
    },
    button: {
        alignItems: {
            value: 'center'
        },
        justifyContent: {
            value: 'center'
        },
        width: {
            value: '{fontSizes.medium.value}'
        },
        height: {
            value: '{fontSizes.medium.value}'
        },
        boxSizing: {
            value: 'border-box'
        },
        borderWidth: {
            value: '{borderWidths.medium.value}'
        },
        borderStyle: {
            value: 'solid'
        },
        borderRadius: {
            value: '50%'
        },
        borderColor: {
            value: '{colors.border.primary.value}'
        },
        color: {
            value: '{colors.background.primary.value}'
        },
        backgroundColor: {
            value: '{colors.background.primary.value}'
        },
        transitionProperty: {
            value: 'all'
        },
        transitionDuration: {
            value: '{time.medium.value}'
        },
        outlineColor: {
            value: '{colors.transparent.value}'
        },
        outlineStyle: {
            value: 'solid'
        },
        outlineWidth: {
            value: '{outlineWidths.medium.value}'
        },
        outlineOffset: {
            value: '{outlineOffsets.medium.value}'
        },
        // We want the dot inside the border to be a border-width from the border
        padding: {
            value: '{borderWidths.medium.value}'
        },
        small: {
            width: {
                value: '{fontSizes.small.value}'
            },
            height: {
                value: '{fontSizes.small.value}'
            }
        },
        large: {
            width: {
                value: '{fontSizes.large.value}'
            },
            height: {
                value: '{fontSizes.large.value}'
            }
        },
        _checked: {
            color: {
                value: '{colors.primary.80.value}'
            },
            _disabled: {
                color: {
                    value: '{colors.background.disabled.value}'
                }
            }
        },
        _focus: {
            borderColor: {
                value: '{colors.border.focus.value}'
            },
            boxShadow: {
                value: '{components.fieldcontrol._focus.boxShadow.value}'
            }
        },
        _error: {
            borderColor: {
                value: '{colors.border.error.value}'
            },
            _focus: {
                boxShadow: {
                    value: '{components.fieldcontrol._error._focus.boxShadow.value}'
                }
            }
        },
        _disabled: {
            borderColor: {
                value: '{colors.border.disabled.value}'
            },
            backgroundColor: {
                value: '{colors.background.primary.value}'
            }
        }
    },
    label: {
        color: {
            value: '{components.text.color.value}'
        },
        _disabled: {
            color: {
                value: '{colors.font.disabled.value}'
            }
        }
    }
};


const $4d9b9d562ceb9004$export$19d611f01a2bdcee = {
    radio: {
        borderWidth: {
            value: '{components.radio.button.borderWidth}'
        },
        borderColor: {
            value: '{components.radio.button.borderColor}'
        },
        backgroundColor: {
            value: '{components.radio.button.backgroundColor}'
        },
        _checked: {
            color: {
                value: '{components.radio.button._checked.color}'
            }
        },
        label: {
            color: {
                value: '{components.radio.label.color}'
            }
        }
    },
    legend: {
        color: {
            value: '{components.fieldset.legend.color}'
        },
        fontWeight: {
            value: '{fontWeights.normal}'
        }
    }
};


const $7f28d78c2484b8f6$export$8121c87bde23d44 = {
    large: {
        size: {
            value: '{fontSizes.xxxl.value}'
        }
    },
    default: {
        size: {
            value: '{fontSizes.xl.value}'
        }
    },
    small: {
        size: {
            value: '{fontSizes.small.value}'
        }
    },
    filled: {
        color: {
            value: '{colors.secondary.80.value}'
        }
    },
    empty: {
        color: {
            value: '{colors.background.tertiary.value}'
        }
    }
};


const $6630eeee6544784c$export$20f8183d3857720a = {
    color: {
        value: '{components.fieldcontrol.color.value}'
    },
    button: {
        color: {
            value: '{components.button.color.value}'
        },
        backgroundColor: {
            value: '{colors.background.primary.value}'
        },
        _active: {
            backgroundColor: {
                value: '{components.button._active.backgroundColor.value}'
            },
            borderColor: {
                value: '{components.button._active.borderColor.value}'
            },
            color: {
                value: '{components.button._active.color.value}'
            }
        },
        _disabled: {
            backgroundColor: {
                value: '{components.button._disabled.backgroundColor.value}'
            },
            borderColor: {
                value: '{components.button._disabled.borderColor.value}'
            },
            color: {
                value: '{components.button._disabled.color.value}'
            }
        },
        _focus: {
            backgroundColor: {
                value: '{components.button._focus.backgroundColor.value}'
            },
            borderColor: {
                value: '{components.button._focus.borderColor.value}'
            },
            color: {
                value: '{components.button._focus.color.value}'
            }
        },
        _hover: {
            backgroundColor: {
                value: '{components.button._hover.backgroundColor.value}'
            },
            borderColor: {
                value: '{components.button._hover.borderColor.value}'
            },
            color: {
                value: '{components.button._hover.color.value}'
            }
        }
    }
};


const $e28b4a1982990609$export$2e6c959c16ff56b8 = {
    color: {
        value: '{components.fieldcontrol.color}'
    },
    backgroundColor: {
        value: '{colors.background.primary.value}'
    },
    paddingInlineEnd: {
        value: '{space.xxl.value}'
    },
    _disabled: {
        color: {
            value: '{colors.font.disabled.value}'
        },
        backgroundColor: {
            value: '{colors.background.disabled.value}'
        }
    },
    // wrappers
    wrapper: {
        flex: {
            value: '1'
        },
        display: {
            value: 'block'
        },
        position: {
            value: 'relative'
        },
        cursor: {
            value: 'pointer'
        }
    },
    iconWrapper: {
        alignItems: {
            value: 'center'
        },
        position: {
            value: 'absolute'
        },
        top: {
            value: '50%'
        },
        right: {
            value: '{space.medium.value}'
        },
        transform: {
            value: 'translateY(-50%)'
        },
        pointerEvents: {
            value: 'none'
        },
        small: {
            right: {
                value: '{space.xs.value}'
            }
        },
        large: {
            right: {
                value: '{space.medium.value}'
            }
        }
    },
    // It's important to test these option values on Chrome/FireFox/Edge
    // on Windows because they allow styling of the option element.
    // Chrome/Safari/Firefox on Mac uses the system ui.
    option: {
        backgroundColor: {
            value: 'transparent'
        },
        color: {
            value: '{colors.font.primary.value}'
        },
        _disabled: {
            color: {
                value: '{colors.font.disabled.value}'
            },
            backgroundColor: {
                value: 'transparent'
            }
        }
    },
    whiteSpace: {
        value: 'nowrap'
    },
    minWidth: {
        value: '6.5rem'
    },
    small: {
        minWidth: {
            value: '5.5rem'
        },
        paddingInlineEnd: {
            value: '{space.xl.value}'
        }
    },
    large: {
        minWidth: {
            value: '7.5rem'
        },
        paddingInlineEnd: {
            value: '{space.xxl.value}'
        }
    },
    expanded: {
        paddingBlock: {
            value: '{space.xs.value}'
        },
        paddingInline: {
            value: '{space.small.value}'
        },
        option: {
            paddingBlock: {
                value: '{space.xs.value}'
            },
            paddingInline: {
                value: '{space.small.value}'
            }
        }
    }
};


const $e1506e2973669b96$export$43b12a9ec74e5c15 = {
    borderColor: {
        value: '{components.fieldcontrol.borderColor}'
    },
    color: {
        value: '{components.fieldcontrol.color}'
    },
    flexDirection: {
        value: 'column'
    },
    fontSize: {
        value: '{components.fieldcontrol.fontSize}'
    },
    _focus: {
        borderColor: {
            value: '{components.fieldcontrol._focus.borderColor}'
        }
    },
    label: {
        color: {
            value: '{components.field.label.color}'
        }
    }
};


const $60dfadfff6866cc0$export$91a82c92775294e7 = {
    paddingBlock: {
        value: '{space.xs.value}'
    },
    // The track is the thin background of the slider
    track: {
        backgroundColor: {
            value: '{colors.background.quaternary.value}'
        },
        borderRadius: {
            value: '9999px'
        },
        height: {
            value: '0.375rem'
        },
        minWidth: {
            value: '10rem'
        }
    },
    // The range is the filled part of the track
    range: {
        backgroundColor: {
            value: '{colors.primary.80.value}'
        },
        borderRadius: {
            value: '9999px'
        },
        _disabled: {
            backgroundColor: {
                value: '{colors.background.disabled.value}'
            }
        }
    },
    // The thumb is the circle above the track that the user drags
    thumb: {
        width: {
            value: '1.25rem'
        },
        height: {
            value: '1.25rem'
        },
        backgroundColor: {
            value: '{colors.background.primary.value}'
        },
        boxShadow: {
            value: '{shadows.small.value}'
        },
        borderRadius: {
            value: '50%'
        },
        borderWidth: {
            value: '{borderWidths.medium.value}'
        },
        borderColor: {
            value: '{colors.border.primary.value}'
        },
        borderStyle: {
            value: 'solid'
        },
        _disabled: {
            backgroundColor: {
                value: '{colors.background.disabled.value}'
            },
            borderColor: {
                value: 'transparent'
            },
            boxShadow: {
                value: 'none'
            }
        },
        _hover: {
            backgroundColor: {
                value: '{colors.background.primary.value}'
            },
            borderColor: {
                value: '{colors.border.focus.value}'
            }
        },
        _focus: {
            borderColor: {
                value: '{colors.border.focus.value}'
            },
            boxShadow: {
                value: '{components.fieldcontrol._focus.boxShadow.value}'
            }
        }
    },
    small: {
        track: {
            height: {
                value: '0.25rem'
            }
        },
        thumb: {
            width: {
                value: '1rem'
            },
            height: {
                value: '1rem'
            }
        }
    },
    large: {
        track: {
            height: {
                value: '0.625rem'
            }
        },
        thumb: {
            width: {
                value: '1.5rem'
            },
            height: {
                value: '1.5rem'
            }
        }
    }
};


const $9b0ebcc3d366b801$export$2391ed8b13703124 = {
    borderColor: {
        value: '{components.fieldcontrol.borderColor}'
    },
    flexDirection: {
        value: 'column'
    },
    input: {
        color: {
            value: '{components.fieldcontrol.color}'
        },
        fontSize: {
            value: '{components.fieldcontrol.fontSize}'
        },
        textAlign: {
            value: 'center'
        }
    },
    button: {
        color: {
            value: '{components.button.color}'
        },
        backgroundColor: {
            value: '{colors.transparent}'
        },
        _active: {
            color: {
                value: '{components.button._active.color}'
            },
            backgroundColor: {
                value: '{components.button._active.backgroundColor}'
            }
        },
        _focus: {
            color: {
                value: '{components.button._focus.color}'
            },
            backgroundColor: {
                value: '{components.button._focus.backgroundColor}'
            }
        },
        _disabled: {
            color: {
                value: '{components.button._disabled.color}'
            },
            backgroundColor: {
                value: '{components.fieldcontrol._disabled.backgroundColor}'
            }
        },
        _hover: {
            color: {
                value: '{components.button._hover.color}'
            },
            backgroundColor: {
                value: '{components.button._hover.backgroundColor}'
            }
        }
    }
};


const $8b415b23e0fbbcb2$export$38e5783f648ff5e4 = {
    dropzone: {
        backgroundColor: {
            value: '{colors.background.primary}'
        },
        borderRadius: {
            value: '{radii.small}'
        },
        borderColor: {
            value: '{colors.border.primary}'
        },
        borderStyle: {
            value: 'dashed'
        },
        borderWidth: {
            value: '{borderWidths.small}'
        },
        gap: {
            value: '{space.small}'
        },
        paddingBlock: {
            value: '{space.xl}'
        },
        paddingInline: {
            value: '{space.large}'
        },
        textAlign: {
            value: 'center'
        },
        _active: {
            backgroundColor: {
                value: '{colors.primary.10}'
            },
            borderRadius: {
                value: '{components.storagemanager.dropzone.borderRadius}'
            },
            borderColor: {
                value: '{colors.border.pressed}'
            },
            borderStyle: {
                value: '{components.storagemanager.dropzone.borderStyle}'
            },
            borderWidth: {
                value: '{borderWidths.medium}'
            }
        },
        icon: {
            color: {
                value: '{colors.border.primary}'
            },
            fontSize: {
                value: '{fontSizes.xxl}'
            }
        },
        text: {
            color: {
                value: '{colors.font.tertiary}'
            },
            fontSize: {
                value: '{fontSizes.medium}'
            },
            fontWeight: {
                value: '{fontWeights.bold}'
            }
        }
    },
    file: {
        backgroundColor: {
            value: '{colors.background.primary}'
        },
        borderRadius: {
            value: '{radii.small}'
        },
        borderColor: {
            value: '{colors.border.primary}'
        },
        borderStyle: {
            value: 'solid'
        },
        borderWidth: {
            value: '{borderWidths.small}'
        },
        paddingBlock: {
            value: '{space.xs}'
        },
        paddingInline: {
            value: '{space.small}'
        },
        gap: {
            value: '{space.small}'
        },
        alignItems: {
            value: 'baseline'
        },
        name: {
            fontSize: {
                value: '{fontSizes.medium}'
            },
            fontWeight: {
                value: '{fontWeights.bold}'
            },
            color: {
                value: '{colors.font.primary}'
            }
        },
        size: {
            fontSize: {
                value: '{fontSizes.small}'
            },
            fontWeight: {
                value: '{fontWeights.normal}'
            },
            color: {
                value: '{colors.font.tertiary}'
            }
        },
        image: {
            width: {
                value: '{space.xxl}'
            },
            height: {
                value: '{space.xxl}'
            },
            backgroundColor: {
                value: '{colors.background.secondary}'
            },
            color: {
                value: '{colors.font.tertiary}'
            },
            borderRadius: {
                value: '{radii.small}'
            }
        }
    },
    filelist: {
        flexDirection: {
            value: 'column'
        },
        gap: {
            value: '{space.small}'
        }
    },
    loader: {
        strokeLinecap: {
            value: 'round'
        },
        strokeEmpty: {
            value: '{colors.border.secondary}'
        },
        strokeFilled: {
            value: '{components.loader.strokeFilled}'
        },
        strokeWidth: {
            value: '{borderWidths.large}'
        }
    },
    previewer: {
        backgroundColor: {
            value: '{colors.background.primary}'
        },
        borderColor: {
            value: '{colors.border.primary}'
        },
        borderStyle: {
            value: 'solid'
        },
        borderWidth: {
            value: '{borderWidths.small}'
        },
        borderRadius: {
            value: '{radii.small}'
        },
        paddingBlock: {
            value: '{space.zero}'
        },
        paddingInline: {
            value: '{space.zero}'
        },
        maxHeight: {
            value: '40rem'
        },
        maxWidth: {
            value: 'auto'
        },
        text: {
            fontSize: {
                value: '{fontSizes.medium}'
            },
            fontWeight: {
                value: '{fontWeights.bold}'
            },
            color: {
                value: '{colors.font.primary}'
            }
        },
        body: {
            paddingBlock: {
                value: '{space.medium}'
            },
            paddingInline: {
                value: '{space.medium}'
            },
            gap: {
                value: '{space.small}'
            }
        },
        footer: {
            justifyContent: {
                value: 'flex-end'
            }
        }
    }
};


const $1dd1dedf5c01121f$export$3df77196ea7dd221 = {
    // States
    _disabled: {
        opacity: {
            value: '{opacities.60.value}'
        }
    },
    _focused: {
        shadow: {
            value: '{components.fieldcontrol._focus.boxShadow.value}'
        }
    },
    // Sizes
    fontSize: {
        value: '{fontSizes.medium.value}'
    },
    large: {
        fontSize: {
            value: '{fontSizes.large.value}'
        }
    },
    small: {
        fontSize: {
            value: '{fontSizes.small.value}'
        }
    },
    // Child elements
    label: {
        padding: {
            value: '{space.xs.value}'
        }
    },
    thumb: {
        backgroundColor: {
            value: '{colors.background.primary.value}'
        },
        borderColor: {
            value: 'transparent'
        },
        borderWidth: {
            value: '{borderWidths.small.value}'
        },
        borderStyle: {
            value: 'solid'
        },
        borderRadius: {
            value: '{radii.xxxl.value}'
        },
        checked: {
            transform: {
                value: '{transforms.slideX.medium.value}'
            }
        },
        transition: {
            duration: {
                value: '{time.medium.value}'
            }
        },
        width: {
            value: '{space.relative.medium.value}'
        }
    },
    track: {
        backgroundColor: {
            value: '{colors.background.quaternary.value}'
        },
        borderRadius: {
            value: '{radii.xxxl.value}'
        },
        checked: {
            backgroundColor: {
                value: '{colors.primary.80.value}'
            }
        },
        height: {
            value: '{space.relative.medium.value}'
        },
        padding: {
            value: '{outlineWidths.medium.value}'
        },
        transition: {
            duration: {
                value: '{time.short.value}'
            }
        },
        width: {
            value: '{space.relative.xl.value}'
        },
        _error: {
            backgroundColor: {
                value: '{colors.background.error.value}'
            }
        }
    }
};


const $7188dbe0db4bbf86$export$9852986a3ec5f6a0 = {
    /**
     * Default table styles
     */ borderCollapse: {
        value: 'collapse'
    },
    display: {
        value: 'table'
    },
    width: {
        value: '100%'
    },
    /**
     * Default table head styles
     */ head: {
        display: {
            value: 'table-header-group'
        },
        verticalAlign: {
            value: 'middle'
        }
    },
    /**
     * Default table body styles
     */ body: {
        display: {
            value: 'table-row-group'
        },
        verticalAlign: {
            value: 'middle'
        }
    },
    /**
     * Default table foot styles
     */ foot: {
        display: {
            value: 'table-footer-group'
        },
        verticalAlign: {
            value: 'middle'
        }
    },
    /**
     * Default table row styles
     */ row: {
        display: {
            value: 'table-row'
        },
        verticalAlign: {
            value: 'middle'
        },
        hover: {
            backgroundColor: {
                value: '{colors.background.tertiary.value}'
            }
        },
        striped: {
            backgroundColor: {
                value: '{colors.background.secondary.value}'
            }
        }
    },
    /**
     * Default table header cell styles
     */ header: {
        borderColor: {
            value: '{colors.border.tertiary.value}'
        },
        borderStyle: {
            value: 'solid'
        },
        borderWidth: {
            value: '{borderWidths.small.value}'
        },
        color: {
            value: '{colors.font.primary.value}'
        },
        display: {
            value: 'table-cell'
        },
        fontSize: {
            value: '{fontSizes.medium.value}'
        },
        fontWeight: {
            value: '{fontWeights.bold.value}'
        },
        padding: {
            value: '{space.medium.value}'
        },
        verticalAlign: {
            value: 'middle'
        },
        large: {
            fontSize: {
                value: '{fontSizes.large.value}'
            },
            padding: {
                value: '{space.large.value}'
            }
        },
        small: {
            fontSize: {
                value: '{fontSizes.small.value}'
            },
            padding: {
                value: '{space.xs.value}'
            }
        }
    },
    /**
     * Default table data cell styles
     */ data: {
        borderColor: {
            value: '{colors.border.tertiary.value}'
        },
        borderStyle: {
            value: 'solid'
        },
        borderWidth: {
            value: '{borderWidths.small.value}'
        },
        color: {
            value: '{colors.font.primary.value}'
        },
        display: {
            value: 'table-cell'
        },
        fontSize: {
            value: '{fontSizes.medium.value}'
        },
        fontWeight: {
            value: '{fontWeights.normal.value}'
        },
        padding: {
            value: '{space.medium.value}'
        },
        verticalAlign: {
            value: 'middle'
        },
        large: {
            fontSize: {
                value: '{fontSizes.large.value}'
            },
            padding: {
                value: '{space.large.value}'
            }
        },
        small: {
            fontSize: {
                value: '{fontSizes.small.value}'
            },
            padding: {
                value: '{space.xs.value}'
            }
        }
    },
    /**
     * Default table caption styles
     */ caption: {
        captionSide: {
            value: 'bottom'
        },
        color: {
            value: '{colors.font.primary.value}'
        },
        display: {
            value: 'table-caption'
        },
        fontSize: {
            value: '{fontSizes.medium.value}'
        },
        textAlign: {
            value: 'center'
        },
        wordBreak: {
            value: 'break-all'
        },
        large: {
            fontSize: {
                value: '{fontSizes.large.value}'
            }
        },
        small: {
            fontSize: {
                value: '{fontSizes.small.value}'
            }
        }
    }
};


const $3f8502afaddc0480$export$39f5674517ec0000 = {
    backgroundColor: {
        value: 'transparent'
    },
    borderColor: {
        value: '{colors.border.secondary.value}'
    },
    borderStyle: {
        value: 'solid'
    },
    borderWidth: {
        value: '{borderWidths.medium.value}'
    },
    gap: {
        value: '0'
    },
    item: {
        backgroundColor: {
            value: 'transparent'
        },
        borderColor: {
            value: '{colors.border.secondary.value}'
        },
        borderStyle: {
            value: 'solid'
        },
        borderWidth: {
            value: '{borderWidths.medium.value}'
        },
        color: {
            value: '{colors.font.secondary.value}'
        },
        fontSize: {
            value: '{fontSizes.medium.value}'
        },
        fontWeight: {
            value: '{fontWeights.bold.value}'
        },
        paddingVertical: {
            value: '{space.small.value}'
        },
        paddingHorizontal: {
            value: '{space.medium.value}'
        },
        textAlign: {
            value: 'center'
        },
        transitionDuration: {
            value: '{time.medium.value}'
        },
        _hover: {
            backgroundColor: {
                value: 'transparent'
            },
            borderColor: {
                value: '{colors.border.focus.value}'
            },
            boxShadow: {
                value: 'none'
            },
            color: {
                value: '{colors.font.hover.value}'
            }
        },
        _focus: {
            backgroundColor: {
                value: 'transparent'
            },
            borderColor: {
                value: '{colors.border.focus.value}'
            },
            boxShadow: {
                value: {
                    offsetX: '0px',
                    offsetY: '0px',
                    blurRadius: '0px',
                    spreadRadius: '{borderWidths.medium}',
                    color: '{colors.border.focus.value}'
                }
            },
            color: {
                value: '{colors.font.focus.value}'
            }
        },
        _active: {
            backgroundColor: {
                value: 'transparent'
            },
            borderColor: {
                value: '{colors.font.interactive.value}'
            },
            boxShadow: {
                value: 'none'
            },
            color: {
                value: '{colors.font.interactive.value}'
            }
        },
        _disabled: {
            backgroundColor: {
                value: 'transparent'
            },
            borderColor: {
                value: '{colors.border.tertiary.value}'
            },
            boxShadow: {
                value: 'none'
            },
            color: {
                value: '{colors.font.disabled.value}'
            }
        }
    },
    panel: {
        backgroundColor: {
            value: 'transparent'
        },
        paddingInline: {
            value: '0'
        },
        paddingBlock: {
            value: '{space.small.value}'
        }
    }
};


const $a31e0ec4f66926fb$export$6f093cfa640b7166 = {
    // default styles
    color: {
        value: '{colors.font.primary.value}'
    },
    // variations
    primary: {
        color: {
            value: '{colors.font.primary.value}'
        }
    },
    secondary: {
        color: {
            value: '{colors.font.secondary.value}'
        }
    },
    tertiary: {
        color: {
            value: '{colors.font.tertiary.value}'
        }
    },
    error: {
        color: {
            value: '{colors.font.error.value}'
        }
    },
    warning: {
        color: {
            value: '{colors.font.warning.value}'
        }
    },
    success: {
        color: {
            value: '{colors.font.success.value}'
        }
    },
    info: {
        color: {
            value: '{colors.font.info.value}'
        }
    }
};


const $a2e355bc581a07e7$export$a97649e9ae9088d4 = {
    color: {
        value: '{components.fieldcontrol.color.value}'
    },
    borderColor: {
        value: '{components.fieldcontrol.borderColor.value}'
    },
    _focus: {
        borderColor: {
            value: '{components.fieldcontrol._focus.borderColor.value}'
        }
    }
};


const $486740f47cfe06c7$export$a0baff9279ccf6a1 = {
    color: {
        value: '{components.fieldcontrol.color.value}'
    },
    borderColor: {
        value: '{components.fieldcontrol.borderColor.value}'
    },
    fontSize: {
        value: '{components.fieldcontrol.fontSize.value}'
    },
    _focus: {
        borderColor: {
            value: '{components.fieldcontrol._focus.borderColor.value}'
        }
    }
};


const $1c64c70ceea1fe28$export$72f8a860416016a1 = {
    borderColor: {
        value: '{colors.border.primary.value}'
    },
    color: {
        value: '{colors.font.primary.value}'
    },
    _hover: {
        backgroundColor: {
            value: '{colors.overlay.10.value}'
        }
    },
    _focus: {
        borderColor: {
            value: '{colors.border.focus.value}'
        },
        color: {
            value: '{colors.font.primary.value}'
        }
    },
    _active: {
        backgroundColor: {
            value: '{colors.transparent.value}'
        }
    },
    _disabled: {
        backgroundColor: {
            value: '{colors.transparent.value}'
        },
        borderColor: {
            value: '{colors.border.disabled.value}'
        },
        color: {
            value: '{colors.font.disabled.value}'
        }
    },
    _pressed: {
        borderColor: {
            value: '{colors.border.pressed.value}'
        },
        color: {
            value: '{colors.font.primary.value}'
        },
        backgroundColor: {
            value: '{colors.overlay.20.value}'
        },
        _hover: {
            backgroundColor: {
                value: '{colors.overlay.30.value}'
            }
        }
    },
    primary: {
        backgroundColor: {
            value: '{colors.transparent.value}'
        },
        borderWidth: {
            value: '{borderWidths.small.value}'
        },
        _focus: {
            borderColor: {
                value: '{colors.border.focus.value}'
            },
            backgroundColor: {
                value: '{colors.transparent.value}'
            },
            boxShadow: {
                value: '{components.fieldcontrol._focus.boxShadow.value}'
            },
            color: {
                value: '{colors.font.primary.value}'
            }
        },
        _hover: {
            backgroundColor: {
                value: '{colors.overlay.10.value}'
            },
            color: {
                value: '{colors.font.primary.value}'
            }
        },
        _disabled: {
            borderColor: {
                value: '{colors.border.disabled.value}'
            },
            backgroundColor: {
                value: '{colors.background.disabled.value}'
            },
            color: {
                value: '{colors.font.disabled.value}'
            }
        },
        _pressed: {
            backgroundColor: {
                value: '{colors.primary.80.value}'
            },
            borderColor: {
                value: '{colors.primary.80.value}'
            },
            color: {
                value: '{colors.background.primary.value}'
            },
            _focus: {
                backgroundColor: {
                    value: '{colors.border.focus.value}'
                },
                borderColor: {
                    value: '{colors.border.focus.value}'
                },
                color: {
                    value: '{colors.background.primary.value}'
                }
            },
            _hover: {
                borderColor: {
                    value: '{colors.primary.60.value}'
                },
                backgroundColor: {
                    value: '{colors.primary.60.value}'
                },
                boxShadow: {
                    value: '{colors.primary.60.value}'
                },
                color: {
                    value: '{colors.background.primary.value}'
                }
            }
        }
    },
    link: {
        backgroundColor: {
            value: '{colors.transparent.value}'
        },
        color: {
            value: '{colors.overlay.50.value}'
        },
        _hover: {
            backgroundColor: {
                value: '{colors.transparent.value}'
            },
            color: {
                value: '{colors.overlay.50.value}'
            }
        },
        _focus: {
            backgroundColor: {
                value: '{colors.transparent.value}'
            },
            color: {
                value: '{colors.overlay.50.value}'
            }
        },
        _disabled: {
            backgroundColor: {
                value: '{colors.transparent.value}'
            },
            color: {
                value: '{colors.font.disabled.value}'
            }
        },
        _pressed: {
            backgroundColor: {
                value: '{colors.transparent.value}'
            },
            color: {
                value: '{colors.overlay.90.value}'
            },
            _focus: {
                backgroundColor: {
                    value: '{colors.transparent.value}'
                },
                color: {
                    value: '{colors.overlay.90.value}'
                }
            },
            _hover: {
                color: {
                    value: '{colors.overlay.90.value}'
                },
                backgroundColor: {
                    value: '{colors.transparent.value}'
                }
            }
        }
    }
};


const $cee4850caa1c2091$export$8f367359b07a0011 = {
    alignItems: {
        value: 'center'
    },
    alignContent: {
        value: 'center'
    },
    justifyContent: {
        value: 'flex-start'
    }
};


const $49dc30a8be9f55cd$export$9b5ac10f59f76296 = {
    accordion: $427231fe728e403a$export$77f5744dadf9dca6,
    aiConversation: $51d00ed546b058aa$export$3ddce1834cf07f8a,
    alert: $c0ac9cc352677dda$export$5ea928c9faf85bd3,
    authenticator: $438f371b01826385$export$d5cb6eef88ffbde2,
    autocomplete: $3c8b40f52da830f7$export$485ded5f26ebe08d,
    avatar: $afc6236ef7f85bdc$export$345c5736c8054f22,
    badge: $df5a5743a2d3a417$export$4aebd143f31d0c0d,
    breadcrumbs: $fd3c65b861b23482$export$515d2155aaad79e4,
    button: $66b019780ee7dc1f$export$2ba01fb71ed41cb6,
    card: $6a8e0515745d8b5a$export$aa3e815946b80764,
    checkbox: $20c2909ec7439911$export$b07e517d22efa1ca,
    checkboxfield: $6b692d1e40924362$export$282c9e915736aefa,
    collection: $1dcc57f0ce1fda0a$export$bf5175b0c24981cd,
    copy: $aac04ffd6917a1d0$export$784d13d8ee351f07,
    countrycodeselect: (0, $72aeb273d00bf6f4$export$5a80fc6ecf647d64),
    divider: $0c11e10b1af0e361$export$e8c9778bf415dd08,
    dropzone: $96d537d0ab554364$export$585d0a7a39ed94ea,
    field: $bdfed67225b2b58a$export$e0f35d825088c098,
    fieldcontrol: $6d42bf09234c104b$export$5ba822cdf6eca6d5,
    fieldgroup: $b9828c9079716621$export$886e4abc352a8403,
    fieldmessages: $65a7f31a6e4726b8$export$b29676ca3eb575f7,
    fieldset: $88e1c51dce624a91$export$a38812d1aa1302d9,
    fileuploader: $a48ce20eab28b130$export$ec053a04994851f2,
    flex: $a2029bc61345c439$export$97691fbb80847c19,
    heading: $e9d8ea8ba90fa0bb$export$46e4a324ac90507f,
    icon: $e3400b570fbdc14b$export$1ca1ec8b29a4ce27,
    highlightmatch: $a5c639d183e53e8a$export$5340050496cd0f8f,
    image: $2b527447bd116461$export$5c452ff88e35e47d,
    inappmessaging: $34537f2210528349$export$be5f4c7eec37e17e,
    input: $0d18adb4dc917636$export$b7e3ae3d7c15e42e,
    link: $22d1a63f75fc48d1$export$9c30223ca0a664fb,
    liveness: $0d80bdbfd6efb689$export$674047c1a0a83243,
    loader: $15098a209f360e7b$export$f4c5de44377d2946,
    menu: $dd93d9e57746b85c$export$b1e5508a851be14d,
    message: $cf4f7ae878809c75$export$a8ecead220dd38a6,
    pagination: $892ffa998a71b70e$export$22fa394f3ba39578,
    passwordfield: $1b82d7fa04ad2590$export$75dd6c0d8e7c7e6b,
    phonenumberfield: $41ff83f21e1d8c64$export$2b14d7973e978f83,
    placeholder: $b14179f3ea1969b8$export$c7187bbd1a7a9244,
    radio: $531e8898e172310f$export$b56dc0f160585b86,
    radiogroup: $4d9b9d562ceb9004$export$19d611f01a2bdcee,
    rating: $7f28d78c2484b8f6$export$8121c87bde23d44,
    searchfield: $6630eeee6544784c$export$20f8183d3857720a,
    select: $e28b4a1982990609$export$2e6c959c16ff56b8,
    selectfield: $e1506e2973669b96$export$43b12a9ec74e5c15,
    sliderfield: $60dfadfff6866cc0$export$91a82c92775294e7,
    stepperfield: $9b0ebcc3d366b801$export$2391ed8b13703124,
    storagemanager: $8b415b23e0fbbcb2$export$38e5783f648ff5e4,
    switchfield: $1dd1dedf5c01121f$export$3df77196ea7dd221,
    table: $7188dbe0db4bbf86$export$9852986a3ec5f6a0,
    tabs: $3f8502afaddc0480$export$39f5674517ec0000,
    text: $a31e0ec4f66926fb$export$6f093cfa640b7166,
    textareafield: $a2e355bc581a07e7$export$a97649e9ae9088d4,
    textfield: $486740f47cfe06c7$export$a0baff9279ccf6a1,
    togglebutton: $1c64c70ceea1fe28$export$72f8a860416016a1,
    togglebuttongroup: $cee4850caa1c2091$export$8f367359b07a0011
};


// TODO: update the design tokens to use an array
// export interface FontDesignToken {
//   value: Array<string>
// }
const $f424a7c350ac3341$export$f45fbea8fe20ca8a = {
    default: {
        variable: {
            value: `'InterVariable', 'Inter var', 'Inter', -apple-system, BlinkMacSystemFont,
        'Helvetica Neue', 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans',
        sans-serif`
        },
        static: {
            value: `'Inter', -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
        'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', sans-serif`
        }
    }
};


const $155a26307e57980b$export$67baea80019ff381 = {
    xxxs: {
        value: '0.375rem'
    },
    xxs: {
        value: '0.5rem'
    },
    xs: {
        value: '0.75rem'
    },
    small: {
        value: '0.875rem'
    },
    medium: {
        value: '1rem'
    },
    large: {
        value: '1.25rem'
    },
    xl: {
        value: '1.5rem'
    },
    xxl: {
        value: '2rem'
    },
    xxxl: {
        value: '2.5rem'
    },
    xxxxl: {
        value: '3rem'
    }
};


const $1a2ad0f53a7bdafe$export$59230918eb9bd861 = {
    hairline: {
        value: 100
    },
    thin: {
        value: 200
    },
    light: {
        value: 300
    },
    normal: {
        value: 400
    },
    medium: {
        value: 500
    },
    semibold: {
        value: 600
    },
    bold: {
        value: 700
    },
    extrabold: {
        value: 800
    },
    black: {
        value: 900
    }
};


const $71f745bfd346012a$export$e646ed6b629bf51e = {
    small: {
        value: '1.25'
    },
    medium: {
        value: '1.5'
    },
    large: {
        value: '2'
    }
};


const $824dabee99514cdf$export$da6c1b172b339805 = {
    0: {
        value: '0'
    },
    10: {
        value: '0.1'
    },
    20: {
        value: '0.2'
    },
    30: {
        value: '0.3'
    },
    40: {
        value: '0.4'
    },
    50: {
        value: '0.5'
    },
    60: {
        value: '0.6'
    },
    70: {
        value: '0.7'
    },
    80: {
        value: '0.8'
    },
    90: {
        value: '0.9'
    },
    100: {
        value: '1'
    }
};


const $abf4d4b9cc410323$export$ef75ee03a03b44a8 = {
    small: {
        value: '1px'
    },
    medium: {
        value: '2px'
    },
    large: {
        value: '3px'
    }
};


const $7c82f6e828116a38$export$d532f76375153c47 = {
    small: {
        value: '1px'
    },
    medium: {
        value: '2px'
    },
    large: {
        value: '3px'
    }
};


const $d1709aca61784954$export$18f838d5aba6962a = {
    xs: {
        value: '0.125rem'
    },
    small: {
        value: '0.25rem'
    },
    medium: {
        value: '0.5rem'
    },
    large: {
        value: '1rem'
    },
    xl: {
        value: '2rem'
    },
    xxl: {
        value: '4rem'
    },
    xxxl: {
        value: '8rem'
    }
};


const $4623154344a11c2c$export$3eb26d38a832ce9a = {
    small: {
        value: {
            offsetX: '0px',
            offsetY: '2px',
            blurRadius: '4px',
            color: '{colors.shadow.tertiary.value}'
        }
    },
    medium: {
        value: {
            offsetX: '0px',
            offsetY: '2px',
            blurRadius: '6px',
            color: '{colors.shadow.secondary.value}'
        }
    },
    large: {
        value: {
            offsetX: '0px',
            offsetY: '4px',
            blurRadius: '12px',
            color: '{colors.shadow.primary.value}'
        }
    }
};


const $0014cab273e8e86e$export$a941ed4b947d12f8 = {
    zero: {
        value: '0'
    },
    xxxs: {
        value: '0.25rem'
    },
    xxs: {
        value: '0.375rem'
    },
    xs: {
        value: '0.5rem'
    },
    small: {
        value: '0.75rem'
    },
    medium: {
        value: '1rem'
    },
    large: {
        value: '1.5rem'
    },
    xl: {
        value: '2.0rem'
    },
    xxl: {
        value: '3.0rem'
    },
    xxxl: {
        value: '4.5rem'
    },
    relative: {
        //creating a second set of sizes using em which will be sized relative to a parent instead of the root
        xxxs: {
            value: '0.25em'
        },
        xxs: {
            value: '0.375em'
        },
        xs: {
            value: '0.5em'
        },
        small: {
            value: '0.75em'
        },
        medium: {
            value: '1em'
        },
        large: {
            value: '1.5em'
        },
        xl: {
            value: '2.0em'
        },
        xxl: {
            value: '3.0em'
        },
        xxxl: {
            value: '4.5em'
        },
        full: {
            value: '100%'
        }
    }
};


const $3103e64e93edadd7$export$2da9be4cfdb689b1 = {
    short: {
        value: '100ms'
    },
    medium: {
        value: '250ms'
    },
    long: {
        value: '500ms'
    }
};


const $fbdb96f8511512e2$export$63e4f03d302d3e40 = {
    // TODO: make this more generic and cross-platform
    slideX: {
        small: {
            value: 'translateX(0.5em)'
        },
        medium: {
            value: 'translateX(1em)'
        },
        large: {
            value: 'translateX(2em)'
        }
    }
};


const $e415cdca001d2f78$export$6ad93df59e712c43 = {
    components: $49dc30a8be9f55cd$export$9b5ac10f59f76296,
    borderWidths: $6b11bf327c015793$export$6f3cc5789c9e770e,
    colors: $c25c8e3281149d33$export$8f45430ccf837300,
    fonts: $f424a7c350ac3341$export$f45fbea8fe20ca8a,
    fontSizes: $155a26307e57980b$export$67baea80019ff381,
    fontWeights: $1a2ad0f53a7bdafe$export$59230918eb9bd861,
    lineHeights: $71f745bfd346012a$export$e646ed6b629bf51e,
    opacities: $824dabee99514cdf$export$da6c1b172b339805,
    outlineOffsets: $abf4d4b9cc410323$export$ef75ee03a03b44a8,
    outlineWidths: $7c82f6e828116a38$export$d532f76375153c47,
    radii: $d1709aca61784954$export$18f838d5aba6962a,
    shadows: $4623154344a11c2c$export$3eb26d38a832ce9a,
    space: $0014cab273e8e86e$export$a941ed4b947d12f8,
    time: $3103e64e93edadd7$export$2da9be4cfdb689b1,
    transforms: $fbdb96f8511512e2$export$63e4f03d302d3e40
};
const $e415cdca001d2f78$export$166e3af4fe3ca756 = {
    colors: $c25c8e3281149d33$export$8f45430ccf837300,
    borderWidths: $6b11bf327c015793$export$6f3cc5789c9e770e,
    fontSizes: {
        xxs: (0, $155a26307e57980b$export$67baea80019ff381).xxs,
        xs: (0, $155a26307e57980b$export$67baea80019ff381).xs,
        small: (0, $155a26307e57980b$export$67baea80019ff381).small,
        medium: (0, $155a26307e57980b$export$67baea80019ff381).medium,
        large: (0, $155a26307e57980b$export$67baea80019ff381).large,
        xl: (0, $155a26307e57980b$export$67baea80019ff381).xl,
        xxl: (0, $155a26307e57980b$export$67baea80019ff381).xxl,
        xxxl: (0, $155a26307e57980b$export$67baea80019ff381).xxxl
    },
    fontWeights: $1a2ad0f53a7bdafe$export$59230918eb9bd861,
    opacities: $824dabee99514cdf$export$da6c1b172b339805,
    // React Native doesn't need the relative space values
    space: {
        // use `space.xxxs` to output a value of `2` and avoid odd space numbers
        xxs: (0, $0014cab273e8e86e$export$a941ed4b947d12f8).xxxs,
        xs: (0, $0014cab273e8e86e$export$a941ed4b947d12f8).xs,
        small: (0, $0014cab273e8e86e$export$a941ed4b947d12f8).small,
        medium: (0, $0014cab273e8e86e$export$a941ed4b947d12f8).medium,
        large: (0, $0014cab273e8e86e$export$a941ed4b947d12f8).large,
        xl: (0, $0014cab273e8e86e$export$a941ed4b947d12f8).xl,
        xxl: (0, $0014cab273e8e86e$export$a941ed4b947d12f8).xxl,
        xxxl: (0, $0014cab273e8e86e$export$a941ed4b947d12f8).xxxl
    },
    radii: $d1709aca61784954$export$18f838d5aba6962a,
    time: $3103e64e93edadd7$export$2da9be4cfdb689b1
};


// Breakpoint unit is in pixels
const $a9c1fa59e48029c1$export$d07517a676ce386f = {
    values: {
        base: 0,
        small: 480,
        medium: 768,
        large: 992,
        xl: 1280,
        xxl: 1536
    },
    defaultBreakpoint: 'base'
};


const $0d3394ef1fa8ab56$export$164de7ab8df77ef0 = {
    tokens: $e415cdca001d2f78$export$6ad93df59e712c43,
    breakpoints: $a9c1fa59e48029c1$export$d07517a676ce386f,
    name: 'default-theme'
};



// For internal use, no need to export
const $c1b70571c7a5ee38$export$529e7eefcb1e2a4c = {
    Alert: {
        dismissButtonLabel: 'Dismiss alert'
    },
    Autocomplete: {
        emptyText: 'No options found',
        loadingText: 'Loading options...'
    },
    Collection: {
        searchButtonLabel: 'Search',
        searchNoResultsFound: 'No results found'
    },
    Fields: {
        clearButtonLabel: 'Clear input'
    },
    Message: {
        dismissLabel: 'Dismiss message'
    },
    PaginationItem: {
        currentPageLabel: 'Page',
        nextLabel: 'Go to next page',
        pageLabel: 'Go to page',
        previousLabel: 'Go to previous page'
    },
    PhoneNumberField: {
        countryCodeLabel: 'Country code'
    },
    SearchField: {
        searchButtonLabel: 'Search'
    },
    PasswordField: {
        passwordIsHidden: 'Password is hidden',
        passwordIsShown: 'Password is shown',
        showPassword: 'Show password'
    },
    StepperField: {
        increaseButtonLabel: 'Increase to',
        decreaseButtonLabel: 'Decrease to'
    }
};
const $c1b70571c7a5ee38$export$f486c23e21d151b2 = {
    backgroundColor: 'colors',
    borderColor: 'colors',
    borderWidth: 'borderWidths',
    color: 'colors',
    borderRadius: 'radii',
    fontSize: 'fontSizes',
    fontWeight: 'fontWeights',
    fontFamily: 'fonts',
    lineHeight: 'lineHeights',
    opacity: 'opacities',
    boxShadow: 'shadows',
    transform: 'transforms',
    left: 'space',
    right: 'space',
    top: 'space',
    bottom: 'space',
    height: 'space',
    width: 'space',
    letterSpacing: 'space',
    margin: 'space',
    marginBlock: 'space',
    marginBlockEnd: 'space',
    marginBlockStart: 'space',
    marginInline: 'space',
    marginInlineEnd: 'space',
    marginInlineStart: 'space',
    marginLeft: 'space',
    marginRight: 'space',
    marginTop: 'space',
    marginBottom: 'space',
    maxHeight: 'space',
    maxWidth: 'space',
    minHeight: 'space',
    minWidth: 'space',
    padding: 'space',
    paddingBlock: 'space',
    paddingBlockEnd: 'space',
    paddingBlockStart: 'space',
    paddingInline: 'space',
    paddingInlineEnd: 'space',
    paddingInlineStart: 'space',
    paddingLeft: 'space',
    paddingRight: 'space',
    paddingTop: 'space',
    paddingBottom: 'space',
    gap: 'space',
    columnGap: 'space',
    rowGap: 'space'
};
// key name
const $c1b70571c7a5ee38$export$728705b4513abbb5 = 'Escape';
const $c1b70571c7a5ee38$export$4162dbd8c730437 = 'Enter';
const $c1b70571c7a5ee38$export$8188339dbe6c99c4 = 'ArrowUp';
const $c1b70571c7a5ee38$export$59f214baefff6196 = 'ArrowDown';


const $8e7ac2145c765822$export$2e3e72bc642e327 = (key)=>{
    return key in (0, $c1b70571c7a5ee38$export$f486c23e21d151b2);
};



const $607babb376ca0479$export$c6251bf2bc4bb464 = (str)=>typeof str === 'string' && str.length > 0;
const $607babb376ca0479$export$78d1711480f95c3e = (value)=>typeof value === 'string' && value.length === 0;
const $607babb376ca0479$export$68b32c1946a6b59c = (value)=>value == null || $607babb376ca0479$export$78d1711480f95c3e(value);
/**
 * Create a consecutive integer array from start value to end value.
 * @param start start value
 * @param end end value
 * @returns an integer array with elements from start to end consecutively
 */ const $607babb376ca0479$export$12cda49cb4509427 = (start, end)=>{
    const length = end - start + 1;
    return Array.from({
        length: length
    }, (_, idx)=>idx + start);
};
/**
 * TS helper function to make using Object.keys more typesafe
 */ const $607babb376ca0479$export$259b4dd69e654a7a = (obj)=>{
    return Object.keys(obj);
};
const $607babb376ca0479$export$b0c777ec01738e5b = (propKey, value, tokens)=>{
    if (typeof value !== 'string') return value;
    // For shorthand properties like `padding` which can accept 1, 2, 3, or 4 values
    // run this function on each value. This would not work on CSS shorthands that
    // mix types, like border which is a composite of borderWidth, borderStyle, and
    // borderColor.
    if (value.includes(' ')) return value.split(' ').map((val)=>$607babb376ca0479$export$b0c777ec01738e5b(propKey, val, tokens)).join(' ');
    if ((0, $8e7ac2145c765822$export$2e3e72bc642e327)(propKey)) {
        const path = value.split('.');
        const tokenKey = (0, $c1b70571c7a5ee38$export$f486c23e21d151b2)[propKey];
        let tokenProps = tokens[tokenKey];
        for(let i = 0; i < path.length; i++){
            if (tokenProps) {
                // overwrite tokenProps with next nested value of tokenProps
                tokenProps = tokenProps[path[i]];
                continue;
            }
            break;
        }
        return (0, $619e2162debdd3f4$export$daee9cd42beef6d1)(tokenProps) ? `var(--${(0, $619e2162debdd3f4$export$8658ddf1aae625a3)({
            path: [
                (0, $c1b70571c7a5ee38$export$f486c23e21d151b2)[propKey],
                ...path
            ]
        })})` : value;
    }
    return value;
};


const $4b3386e80c2e1cc8$var$getClosestValueByBreakpoint = ({ breakpoint: breakpoint, breakpoints: breakpoints, values: values })=>{
    const value = values[breakpoint];
    // Check if breakpoint exists in values
    if (value !== undefined) return value;
    // Otherwise use a lower breakpoint value
    const breakpointsDesc = (0, $607babb376ca0479$export$259b4dd69e654a7a)(breakpoints).sort((a, b)=>breakpoints[b] - breakpoints[a]);
    const lowerBreakpoints = breakpointsDesc.slice(breakpointsDesc.indexOf(breakpoint));
    for (const breakpoint of lowerBreakpoints){
        // Check if breakpoint exists in values
        const value = values[breakpoint];
        if (value !== undefined) return value;
    }
    return null;
};
/**
 * This takes an object and will return an object that only has the
 * breakpoint keys
 * @param obj
 * @returns
 */ const $4b3386e80c2e1cc8$var$valueObjToBreakpoints = (obj)=>{
    return (0, $607babb376ca0479$export$259b4dd69e654a7a)(obj).reduce((acc, key)=>key in (0, $0d3394ef1fa8ab56$export$164de7ab8df77ef0).breakpoints.values ? {
            ...acc,
            [key]: obj[key]
        } : acc, {});
};
const $4b3386e80c2e1cc8$export$7791b19c8f6fdbca = ({ breakpoint: breakpoint, breakpoints: breakpoints, values: values })=>{
    let breakpointCompatValues = {};
    const breakpointsAscending = (0, $607babb376ca0479$export$259b4dd69e654a7a)(breakpoints).sort((a, b)=>breakpoints[a] - breakpoints[b]);
    if (Array.isArray(values)) values.forEach((value, index)=>{
        breakpointCompatValues[breakpointsAscending[index]] = value;
    });
    else if (typeof values === 'object') breakpointCompatValues = $4b3386e80c2e1cc8$var$valueObjToBreakpoints(values);
    return $4b3386e80c2e1cc8$var$getClosestValueByBreakpoint({
        breakpoint: breakpoint,
        breakpoints: breakpoints,
        values: breakpointCompatValues
    });
};



var $6aRB8 = parcelRequire("6aRB8");

// Inspiration for getMediaQueries and useBreakpoint
// comes from https://github.com/iiroj/use-breakpoint/
const $d6ff3589fa633bc9$export$872f03ff2a363331 = ({ breakpoints: breakpoints })=>{
    const sortedBreakpoints = (0, $607babb376ca0479$export$259b4dd69e654a7a)(breakpoints).sort((a, b)=>breakpoints[b] - breakpoints[a]);
    return sortedBreakpoints.map((breakpoint, index)=>{
        let query = '';
        const minWidth = breakpoints[breakpoint];
        const nextBreakpoint = sortedBreakpoints[index - 1];
        const maxWidth = nextBreakpoint ? breakpoints[nextBreakpoint] - 1 : null;
        if (minWidth >= 0) query = `(min-width: ${minWidth}px)`;
        if (maxWidth !== null) {
            if (query) query += ' and ';
            query += `(max-width: ${maxWidth}px)`;
        }
        return {
            breakpoint: breakpoint,
            query: query,
            maxWidth: maxWidth,
            minWidth: minWidth
        };
    });
};


// Inspiration for getMediaQueries and useBreakpoint
// comes from https://github.com/iiroj/use-breakpoint/
const $1ec8e74f7f873534$var$useIsomorphicEffect = typeof window === 'undefined' ? $6aRB8.useEffect : $6aRB8.useLayoutEffect;
const $1ec8e74f7f873534$export$199d6754bdf4e1e3 = ({ breakpoints: breakpoints, defaultBreakpoint: defaultBreakpoint })=>{
    const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    const matchMedia = supportMatchMedia ? window.matchMedia : null;
    const mediaQueries = $6aRB8.useMemo(()=>(0, $d6ff3589fa633bc9$export$872f03ff2a363331)({
            breakpoints: breakpoints
        }), [
        breakpoints
    ]);
    const [breakpoint, setBreakpoint] = $6aRB8.useState(defaultBreakpoint);
    const updateBreakpoint = $6aRB8.useCallback((matches, breakpoint)=>{
        if (matches) setBreakpoint(breakpoint);
    }, [
        setBreakpoint
    ]);
    $1ec8e74f7f873534$var$useIsomorphicEffect(()=>{
        if (!matchMedia) return;
        const unsubscribeList = mediaQueries.map(({ query: query, breakpoint: breakpoint })=>{
            const queryList = matchMedia(query);
            updateBreakpoint(queryList.matches, breakpoint);
            const handleMediaChange = (event)=>{
                if (event.matches) setBreakpoint(breakpoint);
            };
            queryList.addEventListener('change', handleMediaChange);
            return ()=>queryList.removeEventListener('change', handleMediaChange);
        });
        return ()=>{
            unsubscribeList.forEach((unsubscribe)=>unsubscribe());
        };
    }, [
        breakpoints,
        setBreakpoint,
        matchMedia,
        mediaQueries
    ]);
    /** Print a nice debug value for React Devtools */ $6aRB8.useDebugValue(breakpoint, (breakpoint)=>breakpoint);
    return breakpoint;
};



var $6aRB8 = parcelRequire("6aRB8");






function $0cf30c12ba94a906$var$addVars(selector, vars) {
    if (!vars) return '';
    return `${selector} { ${Object.entries(vars).map(([key, value])=>{
        return `--${key}:${value}; `;
    }).join(' ')}}\n`;
}
function $0cf30c12ba94a906$export$57b5e7281912b1f7(baseSelector, theme) {
    let str = '';
    const { _modifiers: _modifiers = {}, _element: _element = {}, _vars: _vars, ...props } = theme;
    // if there are no props, skip
    if (Object.keys(props).length) {
        // separate psuedo/attribute selectors
        const [selectors, other] = (0, $fd30e9352c42562e$export$d7e675a9b5995fea)(props, (key)=>key.startsWith(':') || key.startsWith('['));
        Object.entries(selectors).forEach(([selector, value])=>{
            // need to remove nested things like vars and elements
            const { _modifiers: _modifiers = {}, _element: _element = {}, _vars: _vars, ...props } = value;
            str += `${baseSelector}${selector} { ${(0, $619e2162debdd3f4$export$51cf6524dc225642)(props)} }\n`;
            str += $0cf30c12ba94a906$var$addVars(`${baseSelector}${selector}`, _vars);
        });
        str += `${baseSelector} { ${(0, $619e2162debdd3f4$export$51cf6524dc225642)(other)} }\n`;
    }
    str += $0cf30c12ba94a906$var$addVars(baseSelector, _vars);
    Object.entries(_modifiers).forEach(([key, value])=>{
        if (value && Object.keys(value).length) str += $0cf30c12ba94a906$export$57b5e7281912b1f7(`${baseSelector}--${key}`, value);
    });
    Object.entries(_element).forEach(([key, value])=>{
        if (value && Object.keys(value).length) str += $0cf30c12ba94a906$export$57b5e7281912b1f7(`${baseSelector}__${key}`, value);
    });
    return str;
}
/**
 * This will take a component theme and create the appropriate CSS for it.
 *
 */ function $0cf30c12ba94a906$export$6e3517fc79b7f892({ theme: theme, components: components }) {
    let cssText = '';
    const { tokens: tokens, name: themeName, breakpoints: breakpoints } = theme;
    components.forEach(({ name: name, theme: theme, overrides: overrides })=>{
        const baseComponentClassName = `amplify-${name}`;
        const componentClassName = `[data-amplify-theme="${themeName}"] .${baseComponentClassName}`;
        // unwrap the component theme
        // if it is a function: call it with the defaultTheme to get a static object
        const componentTheme = (0, $fd30e9352c42562e$export$f6e2535fb5126e54)(theme) ? theme(tokens) : theme;
        cssText += $0cf30c12ba94a906$export$57b5e7281912b1f7(componentClassName, componentTheme);
        // if the component theme has overrides
        // generate the appropriate CSS for each of them
        if (overrides) overrides.forEach((override)=>{
            // unwrap the override component theme just like above
            const componentTheme = (0, $fd30e9352c42562e$export$f6e2535fb5126e54)(override.theme) ? override.theme(tokens) : override.theme;
            if ('mediaQuery' in override) cssText += `@media (${override.mediaQuery}) {\n ${$0cf30c12ba94a906$export$57b5e7281912b1f7(componentClassName, componentTheme)} \n}`;
            if ('breakpoint' in override) {
                const breakpoint = breakpoints.values[override.breakpoint];
                cssText += `\n@media (min-width: ${breakpoint}px) {\n ${$0cf30c12ba94a906$export$57b5e7281912b1f7(componentClassName, componentTheme)} \n}`;
            }
            if ('selector' in override) cssText += $0cf30c12ba94a906$export$57b5e7281912b1f7(`${override.selector} .${baseComponentClassName}`, componentTheme);
            if ('colorMode' in override) {
                cssText += `\n@media (prefers-color-scheme: ${override.colorMode}) {\n${$0cf30c12ba94a906$export$57b5e7281912b1f7(`[data-amplify-theme="${themeName}"][data-amplify-color-mode="system"] .${baseComponentClassName}`, componentTheme)}\n}\n`;
                cssText += $0cf30c12ba94a906$export$57b5e7281912b1f7(`[data-amplify-theme="${themeName}"][data-amplify-color-mode="${override.colorMode}"] .${baseComponentClassName}`, componentTheme);
            }
        });
    });
    return cssText;
}





/**
 * Takes a set of keys and a color name and returns an object of design tokens,
 * used for applying a primary color at the theme level to our tokens.
 *
 * createColorPalette({keys: ['10','20',...], value: 'red'})
 * returns {
 *   10: { value: '{colors.red.10.value}' },
 *   20: { value: '{colors.red.20.value}' },
 *   ...
 * }
 */ function $76c0a0fabfee9cf5$export$e48ea82efb9e52cb({ keys: keys, value: value }) {
    return keys.reduce((acc, key)=>{
        return {
            ...acc,
            [key]: {
                value: `{colors.${value}.${key}.value}`
            }
        };
    }, {});
}






function $37cd3391825a2b10$export$4e9387cc8407d0ac({ animations: animations, tokens: tokens }) {
    let cssText = '';
    Object.entries(animations).forEach(([key, value])=>{
        cssText += `\n  @keyframes ${key} {`;
        Object.entries(value).forEach(([step, properties])=>{
            cssText += `\n    ${step} {\n`;
            const animationProperties = (0, $fd30e9352c42562e$export$f6e2535fb5126e54)(properties) ? properties(tokens) : properties;
            cssText += (0, $619e2162debdd3f4$export$51cf6524dc225642)(animationProperties);
            cssText += `\n    }`;
        });
        cssText += `\n  }`;
    });
    return cssText;
}


/**
 * This will be used like `const myTheme = createTheme({})`
 * `myTheme` can then be passed to a Provider or the generated CSS
 * can be passed to a stylesheet at build-time or run-time.
 * const myTheme = createTheme({})
 * const myOtherTheme = createTheme({}, myTheme);
 */ function $e4b655e84e86f423$export$25d302a5b900a763(theme, DefaultTheme = (0, $0d3394ef1fa8ab56$export$164de7ab8df77ef0)) {
    // merge theme and DefaultTheme to get a complete theme
    // deepExtend is an internal Style Dictionary method
    // that performs a deep merge on n objects. We could change
    // this to another 3p deep merge solution too.
    const mergedTheme = (0, $619e2162debdd3f4$export$54e9fb29908872fa)([
        {},
        DefaultTheme,
        {
            ...theme,
            components: {}
        }
    ]);
    const { primaryColor: primaryColor, secondaryColor: secondaryColor } = mergedTheme;
    // apply primaryColor and secondaryColor if present
    if ((0, $fd30e9352c42562e$export$844ec244b1367d54)(primaryColor)) mergedTheme.tokens.colors.primary = (0, $76c0a0fabfee9cf5$export$e48ea82efb9e52cb)({
        keys: Object.keys(mergedTheme.tokens.colors[primaryColor]),
        value: primaryColor
    });
    if ((0, $fd30e9352c42562e$export$844ec244b1367d54)(secondaryColor)) mergedTheme.tokens.colors.secondary = (0, $76c0a0fabfee9cf5$export$e48ea82efb9e52cb)({
        keys: Object.keys(mergedTheme.tokens.colors[secondaryColor]),
        value: secondaryColor
    });
    // Setting up the tokens. This is similar to what Style Dictionary
    // does. At the end of this, each token should have:
    // - CSS variable name of itself
    // - its value (reference to another CSS variable or raw value)
    const tokens = (0, $619e2162debdd3f4$export$4ae67d38aae8ca2e)({
        tokens: mergedTheme.tokens,
        setupToken: $619e2162debdd3f4$export$e65646439c92605c
    }); // Setting the type here because setupTokens is recursive
    const { breakpoints: breakpoints, name: name } = mergedTheme;
    // flattenProperties is another internal Style Dictionary function
    // that creates an array of all tokens.
    let cssText = `[data-amplify-theme="${name}"] {\n` + (0, $619e2162debdd3f4$export$5739a35fb355a0f7)(tokens).map((token)=>`${token.name}: ${token.value};`).join('\n') + `\n}\n`;
    if (theme?.components) cssText += (0, $0cf30c12ba94a906$export$6e3517fc79b7f892)({
        theme: {
            ...mergedTheme,
            tokens: tokens
        },
        components: theme.components
    });
    let overrides = [];
    if (mergedTheme.animations) cssText += (0, $37cd3391825a2b10$export$4e9387cc8407d0ac)({
        animations: mergedTheme.animations,
        tokens: tokens
    });
    /**
     * For each override, we setup the tokens and then generate the CSS.
     * This allows us to have one single CSS string for all possible overrides
     * and avoid re-renders in React, but also support other frameworks as well.
     */ if (mergedTheme.overrides) overrides = mergedTheme.overrides.map((override)=>{
        const overrideTokens = (0, $619e2162debdd3f4$export$4ae67d38aae8ca2e)({
            tokens: override.tokens,
            setupToken: $619e2162debdd3f4$export$e65646439c92605c
        });
        const customProperties = (0, $619e2162debdd3f4$export$5739a35fb355a0f7)(overrideTokens).map((token)=>`${token.name}: ${token.value};`).join('\n');
        // Overrides can have a selector, media query, breakpoint, or color mode
        // for creating the selector
        if ('selector' in override) cssText += `\n${override.selector} {\n${customProperties}\n}\n`;
        if ('mediaQuery' in override) cssText += `\n@media (${override.mediaQuery}) {
  [data-amplify-theme="${name}"] {
    ${customProperties}
  }
}\n`;
        if ('breakpoint' in override) {
            const breakpoint = mergedTheme.breakpoints.values[override.breakpoint];
            cssText += `\n@media (min-width: ${breakpoint}px) {
  [data-amplify-theme="${name}"] {
    ${customProperties}
  }
}\n`;
        }
        if ('colorMode' in override) {
            cssText += `\n@media (prefers-color-scheme: ${override.colorMode}) {
          [data-amplify-theme="${name}"][data-amplify-color-mode="system"] {
            ${customProperties}
            color-scheme: ${override.colorMode};
          }
        }\n`;
            cssText += `\n[data-amplify-theme="${name}"][data-amplify-color-mode="${override.colorMode}"] {
          ${customProperties}
          color-scheme: ${override.colorMode};
        }\n`;
        }
        return {
            ...override,
            tokens: overrideTokens
        };
    });
    return {
        tokens: tokens,
        breakpoints: breakpoints,
        name: name,
        cssText: cssText,
        containerProps: ({ colorMode: colorMode } = {})=>{
            return {
                'data-amplify-theme': name,
                'data-amplify-color-mode': colorMode
            };
        },
        overrides: // keep overrides separate from base theme
        // this allows web platforms to use plain CSS scoped to a
        // selector and only override the CSS vars needed. This
        // means we could generate CSS at build-time in a postcss
        // plugin, or do it at runtime and inject the CSS into a
        // style tag.
        // This also allows RN to dynamically switch themes in a
        // provider.
        overrides
    };
}



var $6aRB8 = parcelRequire("6aRB8");

const $064779119edb7ede$export$2c657da244d00bd6 = $6aRB8.createContext({
    theme: (0, $e4b655e84e86f423$export$25d302a5b900a763)(),
    colorMode: undefined
});


/**
 * Get current Theme object value from Amplify context.
 * Returns a default theme if context is not available
 */ const $0cdfb44524e2b25f$export$1a3896b0420de28d = (context)=>{
    if (typeof context === 'undefined' || typeof context.theme === 'undefined') return (0, $e4b655e84e86f423$export$25d302a5b900a763)();
    return context.theme;
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/theming)
 */ const $0cdfb44524e2b25f$export$93d4e7f90805808f = ()=>{
    const context = $6aRB8.useContext((0, $064779119edb7ede$export$2c657da244d00bd6));
    return $0cdfb44524e2b25f$export$1a3896b0420de28d(context);
};
/**
 * Internal use only
 */ const $0cdfb44524e2b25f$export$20f3076712c8dfa = ()=>{
    const context = $6aRB8.useContext((0, $064779119edb7ede$export$2c657da244d00bd6));
    return context.colorMode;
};




/**
 * This takes an unknown value, which could be a:
 * - design token: `color={tokens.colors.font.primary}`
 * - string, which could be a:
 *   - theme key: `color='font.primary'`
 *   - plain style: `color='red'`
 * - or a number: `padding={10}`
 * and returns the appropriate and resolved value
 */ const $62277001da0d4c0a$export$741ad47189a64aa0 = ({ value: value, propKey: propKey, tokens: tokens })=>{
    if ((0, $619e2162debdd3f4$export$daee9cd42beef6d1)(value)) return value.toString();
    if ((0, $fd30e9352c42562e$export$844ec244b1367d54)(value)) return (0, $fd30e9352c42562e$export$844ec244b1367d54)(propKey) ? (0, $607babb376ca0479$export$b0c777ec01738e5b)(propKey, value, tokens) : value;
    return null;
};



const $c4c955b401a66b9a$export$63d3b2476bc623b7 = (spanValue)=>{
    return spanValue === 'auto' || typeof spanValue === 'number' && !isNaN(spanValue) || typeof spanValue === 'string' && !isNaN(parseFloat(spanValue));
};
const $c4c955b401a66b9a$export$7a05ae144bf7b4de = (spanValue)=>{
    return spanValue === 'auto' ? 'auto' : `span ${spanValue}`;
};
const $c4c955b401a66b9a$export$2289a9e09445ac09 = (spanValue)=>{
    // PropertyType
    if ($c4c955b401a66b9a$export$63d3b2476bc623b7(spanValue)) return $c4c955b401a66b9a$export$7a05ae144bf7b4de(spanValue);
    // PropertyType[]
    if (Array.isArray(spanValue)) return spanValue.map((value)=>$c4c955b401a66b9a$export$7a05ae144bf7b4de(value));
    // ResponsiveObject<PropertyType>
    if (typeof spanValue === 'object' && spanValue != null) return Object.entries(spanValue).reduce((acc, [key, value])=>({
            ...acc,
            [key]: $c4c955b401a66b9a$export$7a05ae144bf7b4de(value)
        }), {});
    return null;
};
/**
 * Transforms style props to another target prop
 * where the original is a simpler API than the target.
 * This function will remove the original prop and
 * replace target prop values with calculated
 * E.g. rowSpan => row, columnSpan => column
 */ const $c4c955b401a66b9a$export$708ec223603a550 = (props)=>{
    const { rowSpan: rowSpan, columnSpan: columnSpan, row: row, column: column, ...rest } = props;
    const { rowFromSpanValue: rowFromSpanValue, columnFromSpanValue: columnFromSpanValue } = $6aRB8.useMemo(()=>{
        return {
            rowFromSpanValue: $c4c955b401a66b9a$export$2289a9e09445ac09(rowSpan),
            columnFromSpanValue: $c4c955b401a66b9a$export$2289a9e09445ac09(columnSpan)
        };
    }, [
        rowSpan,
        columnSpan
    ]);
    return {
        row: !(0, $607babb376ca0479$export$68b32c1946a6b59c)(row) ? row : rowFromSpanValue,
        column: !(0, $607babb376ca0479$export$68b32c1946a6b59c)(column) ? column : columnFromSpanValue,
        ...rest
    };
};
const $c4c955b401a66b9a$var$isComponentStyleProp = (key)=>{
    return key in (0, $4a29dbc0bab4c85a$export$c69338bc7d797351);
};
/**
 * Convert style props to CSS variables for React style prop
 * Note: Will filter out undefined, null, and empty string prop values
 */ const $c4c955b401a66b9a$export$2184e8c9a9308f34 = ({ props: props = {}, style: style = {}, breakpoint: breakpoint, breakpoints: breakpoints, tokens: tokens })=>{
    const nonStyleProps = {};
    Object.keys(props).filter((propKey)=>props[propKey] !== null).forEach((propKey)=>{
        if ($c4c955b401a66b9a$var$isComponentStyleProp(propKey)) {
            const values = props[propKey];
            if (values === null || values === undefined || (0, $607babb376ca0479$export$78d1711480f95c3e)(values)) return;
            const reactStyleProp = (0, $4a29dbc0bab4c85a$export$c69338bc7d797351)[propKey];
            // short circuit the style prop here if it is a string or design token
            // so we don't have to call getValueAtCurrentBreakpoint every time
            let value = '';
            if ((0, $619e2162debdd3f4$export$daee9cd42beef6d1)(values)) value = values.toString();
            else if (typeof values === 'string') value = (0, $607babb376ca0479$export$b0c777ec01738e5b)(propKey, values, tokens);
            else if (typeof values === 'number') value = values;
            else if (typeof values === 'object') // here values should be a responsive array or object
            value = (0, $62277001da0d4c0a$export$741ad47189a64aa0)({
                propKey: propKey,
                tokens: tokens,
                value: (0, $4b3386e80c2e1cc8$export$7791b19c8f6fdbca)({
                    values: values,
                    breakpoint: breakpoint,
                    breakpoints: breakpoints
                })
            });
            style = {
                ...style,
                [reactStyleProp]: value
            };
        } else if (typeof props[propKey] !== 'undefined') nonStyleProps[propKey] = props[propKey];
    });
    return {
        propStyles: style,
        nonStyleProps: nonStyleProps
    };
};
const $c4c955b401a66b9a$export$28e6b9b82ee883c = (props, style)=>{
    const { breakpoints: { values: breakpoints, defaultBreakpoint: defaultBreakpoint }, tokens: tokens } = (0, $0cdfb44524e2b25f$export$93d4e7f90805808f)();
    const breakpoint = (0, $1ec8e74f7f873534$export$199d6754bdf4e1e3)({
        breakpoints: breakpoints,
        defaultBreakpoint: defaultBreakpoint
    });
    const propStyles = $c4c955b401a66b9a$export$708ec223603a550(props);
    return $6aRB8.useMemo(()=>$c4c955b401a66b9a$export$2184e8c9a9308f34({
            props: propStyles,
            style: style,
            breakpoint: breakpoint,
            breakpoints: breakpoints,
            tokens: tokens
        }), [
        propStyles,
        style,
        breakpoints,
        breakpoint,
        tokens
    ]);
};



const $417f8d85aef5a23a$var$ViewPrimitive = ({ as: as = 'div', children: children, testId: testId, ariaLabel: ariaLabel, isDisabled: isDisabled, style: style, inert: inert, ...rest }, ref)=>{
    const { propStyles: propStyles, nonStyleProps: nonStyleProps } = (0, $c4c955b401a66b9a$export$28e6b9b82ee883c)(rest, style);
    return $6aRB8.createElement(as, {
        'aria-label': ariaLabel,
        'data-testid': testId,
        disabled: isDisabled,
        ref: ref,
        inert: inert ? '' : null,
        style: propStyles,
        ...nonStyleProps
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/view)
 */ const $417f8d85aef5a23a$export$27a5bd065ad55220 = (0, $268f040634758fba$export$44aa160b17c73194)($417f8d85aef5a23a$var$ViewPrimitive);
$417f8d85aef5a23a$export$27a5bd065ad55220.displayName = 'View';



const $c658dcb0f49b8bb3$var$FlexPrimitive = ({ className: className, children: children, ...rest }, ref)=>$6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Flex, className),
        ref: ref,
        ...rest
    }, children);
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/flex)
 */ const $c658dcb0f49b8bb3$export$f51f4c4ede09e011 = (0, $268f040634758fba$export$44aa160b17c73194)($c658dcb0f49b8bb3$var$FlexPrimitive);
$c658dcb0f49b8bb3$export$f51f4c4ede09e011.displayName = 'Flex';



var $6aRB8 = parcelRequire("6aRB8");



const $47642f0614614355$export$c47c5262afb3a760 = 'linear-empty';
const $47642f0614614355$export$84e78a619b590ebb = 'linear-filled';
const $47642f0614614355$export$2dac697651a47d0c = 'circular-empty';
const $47642f0614614355$export$c6c37ac3a7f79d5a = 'circular-filled';
// radius + strokeWidth = 50
const $47642f0614614355$export$a2450a64b7863610 = 8;
const $47642f0614614355$export$2d2c9be8b5b863f = 42;
// circumference = 2 * r * PI  (r = 42)
const $47642f0614614355$export$d13f13f2833cdb46 = 2 * $47642f0614614355$export$2d2c9be8b5b863f * Math.PI;
const $47642f0614614355$var$LoaderPrimitive = ({ className: className, filledColor: filledColor, emptyColor: emptyColor, size: size, variation: variation, isDeterminate: isDeterminate = false, isPercentageTextHidden: isPercentageTextHidden = false, percentage: percentage = 0, ...rest }, ref)=>{
    percentage = Math.min(percentage, 100);
    percentage = Math.max(percentage, 0);
    const percent = `${percentage}%`;
    const componentClasses = (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Loader, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Loader, size), (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Loader, variation), (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Loader, 'determinate', isDeterminate), className);
    const linearLoader = $6aRB8.createElement("g", null, $6aRB8.createElement("line", {
        x1: "0",
        x2: "100%",
        y1: "50%",
        y2: "50%",
        style: {
            stroke: String(emptyColor)
        },
        "data-testid": $47642f0614614355$export$c47c5262afb3a760
    }), $6aRB8.createElement("line", {
        x1: "0",
        x2: isDeterminate ? percent : '100%',
        y1: "50%",
        y2: "50%",
        style: {
            // To get rid of the visible stroke linecap when percentage is 0
            stroke: isDeterminate && percentage === 0 ? 'none' : filledColor ? String(filledColor) : undefined
        },
        "data-testid": $47642f0614614355$export$84e78a619b590ebb
    }), isDeterminate ? $6aRB8.createElement("text", {
        "aria-live": "polite",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).LoaderLabel, isPercentageTextHidden ? (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).VisuallyHidden : null),
        // -1% offset makes the text position look nicest
        x: `${-1 + percentage}%`,
        y: "200%"
    }, percent) : null);
    // r + stroke-width should add up to 50% to avoid overflow
    const circularLoader = $6aRB8.createElement("g", null, $6aRB8.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: `${$47642f0614614355$export$2d2c9be8b5b863f}%`,
        strokeWidth: `${$47642f0614614355$export$a2450a64b7863610}%`,
        style: {
            stroke: String(emptyColor)
        },
        "data-testid": $47642f0614614355$export$2dac697651a47d0c
    }), $6aRB8.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: `${$47642f0614614355$export$2d2c9be8b5b863f}%`,
        strokeWidth: `${$47642f0614614355$export$a2450a64b7863610}%`,
        style: {
            stroke: String(filledColor),
            strokeDasharray: isDeterminate ? `${$47642f0614614355$export$d13f13f2833cdb46}% ${$47642f0614614355$export$d13f13f2833cdb46}%` : undefined,
            strokeDashoffset: isDeterminate ? `${$47642f0614614355$export$d13f13f2833cdb46 - $47642f0614614355$export$d13f13f2833cdb46 * percentage / 100}%` : undefined
        },
        "data-testid": $47642f0614614355$export$c6c37ac3a7f79d5a
    }), isDeterminate ? $6aRB8.createElement("text", {
        "aria-live": "polite",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).LoaderLabel, isPercentageTextHidden ? (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).VisuallyHidden : null),
        // this x and y make text position look nicest
        x: "130%",
        y: "80%"
    }, percent) : null);
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: "svg",
        "aria-valuenow": isDeterminate ? percentage : undefined,
        className: componentClasses,
        ref: ref,
        role: "progressbar",
        ...rest
    }, variation === 'linear' ? linearLoader : circularLoader);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/loader)
 */ const $47642f0614614355$export$3b0d6d7590275603 = (0, $268f040634758fba$export$44aa160b17c73194)($47642f0614614355$var$LoaderPrimitive);
$47642f0614614355$export$3b0d6d7590275603.displayName = 'Loader';



// These variations support colorThemes. 'undefined' accounts for our
// 'default' variation which is not named.
const $5360619bdca83541$var$supportedVariations = [
    'link',
    'primary',
    undefined
];
const $5360619bdca83541$var$ButtonPrimitive = ({ className: className, children: children, colorTheme: colorTheme, isFullWidth: isFullWidth = false, isDisabled: isDisabled, isLoading: isLoading, loadingText: loadingText = '', size: size, type: type = 'button', variation: variation, ...rest }, ref)=>{
    // Creates our colorTheme modifier string based on if the variation
    // supports colorThemes and a colorTheme is used.
    const colorThemeModifier = $5360619bdca83541$var$supportedVariations.includes(variation) && colorTheme ? `${variation ?? 'outlined'}--${colorTheme}` : undefined;
    const { isFieldsetDisabled: shouldBeDisabled } = (0, $503b6352ab4ec9e6$export$b140571ec72925dd)(isDisabled ?? isLoading ?? rest['disabled']);
    const componentClasses = (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Button, (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroupControl, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Button, variation), (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Button, colorThemeModifier), (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Button, size), (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Button, 'disabled', shouldBeDisabled), (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Button, 'loading', isLoading), (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Button, 'fullwidth', isFullWidth), className);
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        ref: ref,
        as: "button",
        className: componentClasses,
        isDisabled: shouldBeDisabled,
        type: type,
        ...rest
    }, isLoading ? $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "span",
        className: (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).ButtonLoaderWrapper
    }, $6aRB8.createElement((0, $47642f0614614355$export$3b0d6d7590275603), {
        size: size
    }), loadingText ? loadingText : null) : children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/button)
 */ const $5360619bdca83541$export$353f5b6fc5456de1 = (0, $268f040634758fba$export$44aa160b17c73194)($5360619bdca83541$var$ButtonPrimitive);
$5360619bdca83541$export$353f5b6fc5456de1.displayName = 'Button';




var $6aRB8 = parcelRequire("6aRB8");



const $9bf13500c30f403f$var$headingLevels = {
    1: 'h1',
    2: 'h2',
    3: 'h3',
    4: 'h4',
    5: 'h5',
    6: 'h6'
};
const $9bf13500c30f403f$var$HeadingPrimitive = ({ className: className, children: children, isTruncated: isTruncated, level: level = 6, ...rest }, ref)=>$6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: $9bf13500c30f403f$var$headingLevels[level],
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Heading, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Heading, level), (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Heading, 'truncated', isTruncated), className),
        ref: ref,
        ...rest
    }, children);
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/heading)
 */ const $9bf13500c30f403f$export$a8a3e93435678ff9 = (0, $268f040634758fba$export$44aa160b17c73194)($9bf13500c30f403f$var$HeadingPrimitive);
$9bf13500c30f403f$export$a8a3e93435678ff9.displayName = 'Heading';



var $6aRB8 = parcelRequire("6aRB8");



const $f5124d0fbf86e15e$var$TextPrimitive = ({ as: as = 'p', className: className, children: children, isTruncated: isTruncated, variation: variation, ...rest }, ref)=>{
    const componentClasses = (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Text, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Text, variation), (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Text, 'truncated', isTruncated), className);
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: as,
        className: componentClasses,
        ref: ref,
        ...rest
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/text)
 */ const $f5124d0fbf86e15e$export$5f1af8db9871e1d6 = (0, $268f040634758fba$export$44aa160b17c73194)($f5124d0fbf86e15e$var$TextPrimitive);
$f5124d0fbf86e15e$export$5f1af8db9871e1d6.displayName = 'Text';





var $6aRB8 = parcelRequire("6aRB8");
const $870204e2b2438016$export$e29bbbec84471f66 = (event)=>{
    const formData = new FormData(event.target);
    return Object.fromEntries(formData);
};



function $81db2db49ed132c1$export$df6a82844cee724c() {
    const { submitForm: submitForm, updateBlur: updateBlur, updateForm: updateForm } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.submitForm,
            context.updateBlur,
            context.updateForm
        ]);
    const handleBlur = (0, $6aRB8.useCallback)(({ target: { name: name } })=>{
        updateBlur({
            name: name
        });
    }, [
        updateBlur
    ]);
    // @TODO: align multiple input type handling with react docs example for 3.0 release
    // example: https://reactjs.org/docs/forms.html#handling-multiple-inputs
    const handleChange = (0, $6aRB8.useCallback)(({ target: { checked: checked, name: name, type: type, value: value } })=>{
        const isUncheckedCheckbox = type === 'checkbox' && !checked;
        updateForm({
            name: name,
            value: isUncheckedCheckbox ? undefined : value
        });
    }, [
        updateForm
    ]);
    const handleSubmit = (0, $6aRB8.useCallback)((event)=>{
        event.preventDefault();
        submitForm((0, $870204e2b2438016$export$e29bbbec84471f66)(event));
    }, [
        submitForm
    ]);
    return {
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleSubmit: handleSubmit
    };
}



var $6aRB8 = parcelRequire("6aRB8");



var $6aRB8 = parcelRequire("6aRB8");







var $6aRB8 = parcelRequire("6aRB8");




var $6aRB8 = parcelRequire("6aRB8");

var $6aRB8 = parcelRequire("6aRB8");
const $dc47945d44f343a3$export$5f8c516af44338bb = $6aRB8.createContext({});


function $6db14e0950ad4d95$export$75b0b37acc90e887(component) {
    const context = $6aRB8.useContext((0, $dc47945d44f343a3$export$5f8c516af44338bb));
    if (component && context) return context[component];
    return undefined;
}




var $6aRB8 = parcelRequire("6aRB8");


/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $81503c8e078b8961$export$8fb9587943155ce3 = (props)=>{
    const { className: className, ...rest } = props;
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $6aRB8.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $6aRB8.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z",
        fill: "currentColor"
    })));
};




var $6aRB8 = parcelRequire("6aRB8");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $9e39c10f6d64d1a1$export$66493327321323ad = (props)=>{
    const { className: className, ...rest } = props;
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $6aRB8.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $6aRB8.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
        fill: "currentColor"
    })));
};




var $6aRB8 = parcelRequire("6aRB8");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $edb29c856c505c99$export$340bfce9b4df026b = (props)=>{
    const { className: className, ...rest } = props;
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $6aRB8.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $6aRB8.createElement("path", {
        d: "M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
        fill: "currentColor"
    })));
};




var $6aRB8 = parcelRequire("6aRB8");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $15771b8281823951$export$5be70e40251e6f9b = (props)=>{
    const { className: className, ...rest } = props;
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $6aRB8.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $6aRB8.createElement("path", {
        d: "M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z",
        fill: "currentColor"
    })));
};


/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $80f4ecaeff7fe3be$export$4a143c8822a09fb4 = ({ variation: variation, ariaHidden: ariaHidden, ariaLabel: ariaLabel, role: role })=>{
    const icons = (0, $6db14e0950ad4d95$export$75b0b37acc90e887)('alert');
    let icon;
    switch(variation){
        case 'info':
            icon = icons?.info ?? $6aRB8.createElement((0, $edb29c856c505c99$export$340bfce9b4df026b), {
                "aria-hidden": ariaHidden,
                "aria-label": ariaLabel,
                role: role
            });
            break;
        case 'error':
            icon = icons?.error ?? $6aRB8.createElement((0, $9e39c10f6d64d1a1$export$66493327321323ad), {
                "aria-hidden": ariaHidden,
                "aria-label": ariaLabel,
                role: role
            });
            break;
        case 'warning':
            icon = icons?.warning ?? $6aRB8.createElement((0, $15771b8281823951$export$5be70e40251e6f9b), {
                "aria-hidden": ariaHidden,
                "aria-label": ariaLabel,
                role: role
            });
            break;
        case 'success':
            icon = icons?.success ?? $6aRB8.createElement((0, $81503c8e078b8961$export$8fb9587943155ce3), {
                "aria-hidden": ariaHidden,
                "aria-label": ariaLabel,
                role: role
            });
            break;
    }
    return icon ? $6aRB8.createElement("span", {
        className: (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).AlertIcon
    }, icon) : null;
};
$80f4ecaeff7fe3be$export$4a143c8822a09fb4.displayName = 'AlertIcon';







var $6aRB8 = parcelRequire("6aRB8");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $7a9a816fddb37adc$export$e04bcc6127e699bf = (props)=>{
    const { className: className, size: size, ...rest } = props;
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: "span",
        width: size ?? '1em',
        height: size ?? '1em',
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $6aRB8.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: size ? {
            width: size,
            height: size
        } : undefined
    }, $6aRB8.createElement("path", {
        d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
        fill: "currentColor"
    })));
};


const $30473de38d0e8b52$var$AlertPrimitive = ({ buttonRef: buttonRef, children: children, className: className, dismissButtonLabel: dismissButtonLabel = (0, $c1b70571c7a5ee38$export$529e7eefcb1e2a4c).Alert.dismissButtonLabel, hasIcon: hasIcon = true, heading: heading, isDismissible: isDismissible = false, onDismiss: onDismiss, variation: variation, ...rest }, ref)=>{
    const [dismissed, setDismissed] = $6aRB8.useState(false);
    const icons = (0, $6db14e0950ad4d95$export$75b0b37acc90e887)('alert');
    const dismissAlert = $6aRB8.useCallback(()=>{
        setDismissed(!dismissed);
        if ((0, $fd30e9352c42562e$export$f6e2535fb5126e54)(onDismiss)) onDismiss();
    }, [
        setDismissed,
        onDismiss,
        dismissed
    ]);
    return !dismissed ? $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Alert, className, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Alert, variation)),
        ref: ref,
        role: "alert",
        ...rest
    }, hasIcon && $6aRB8.createElement((0, $80f4ecaeff7fe3be$export$4a143c8822a09fb4), {
        variation: variation,
        ariaHidden: true
    }), $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        flex: "1"
    }, heading && $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        className: (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).AlertHeading
    }, heading), $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        className: (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).AlertBody
    }, children)), isDismissible && $6aRB8.createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        ariaLabel: dismissButtonLabel,
        variation: "link",
        className: (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).AlertDismiss,
        onClick: dismissAlert,
        ref: buttonRef
    }, icons?.close ?? $6aRB8.createElement((0, $7a9a816fddb37adc$export$e04bcc6127e699bf), {
        "aria-hidden": "true"
    }))) : null;
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/alert)
 */ const $30473de38d0e8b52$export$caec2af78bcc877f = (0, $268f040634758fba$export$44aa160b17c73194)($30473de38d0e8b52$var$AlertPrimitive);
$30473de38d0e8b52$export$caec2af78bcc877f.displayName = 'Alert';


const $1594b49e029449dc$export$3caa4b6a8cb6c61a = ()=>{
    const { error: error } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.error
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, error ? (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $30473de38d0e8b52$export$caec2af78bcc877f), {
        variation: "error",
        isDismissible: true
    }, (0, $94bd8652748873ad$export$d73ee8ef04f5226a)(error)) : null);
};



var $6aRB8 = parcelRequire("6aRB8");

var $6aRB8 = parcelRequire("6aRB8");



var $6aRB8 = parcelRequire("6aRB8");

var $6aRB8 = parcelRequire("6aRB8");



var $6aRB8 = parcelRequire("6aRB8");



const $c954698269074fa8$var$VisuallyHiddenPrimitive = ({ as: as = 'span', children: children, className: className, ...rest }, ref)=>$6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: as,
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).VisuallyHidden, className),
        ref: ref,
        ...rest
    }, children);
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/visuallyhidden)
 */ const $c954698269074fa8$export$439d29a4e110a164 = (0, $268f040634758fba$export$44aa160b17c73194)($c954698269074fa8$var$VisuallyHiddenPrimitive);
$c954698269074fa8$export$439d29a4e110a164.displayName = 'VisuallyHidden';









var $6aRB8 = parcelRequire("6aRB8");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $2ca073cce1e67c08$export$9ef36bcf05bb63d9 = (props)=>{
    const { className: className, ...rest } = props;
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $6aRB8.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $6aRB8.createElement("path", {
        d: "M12 6.0002C15.79 6.0002 19.17 8.1302 20.82 11.5002C20.23 12.7202 19.4 13.7702 18.41 14.6202L19.82 16.0302C21.21 14.8002 22.31 13.2602 23 11.5002C21.27 7.1102 17 4.0002 12 4.0002C10.73 4.0002 9.51 4.2002 8.36 4.5702L10.01 6.2202C10.66 6.0902 11.32 6.0002 12 6.0002ZM10.93 7.14019L13 9.2102C13.57 9.4602 14.03 9.9202 14.28 10.4902L16.35 12.5602C16.43 12.2202 16.49 11.8602 16.49 11.4902C16.5 9.0102 14.48 7.0002 12 7.0002C11.63 7.0002 11.28 7.05019 10.93 7.14019ZM2.01 3.8702L4.69 6.5502C3.06 7.8302 1.77 9.5302 1 11.5002C2.73 15.8902 7 19.0002 12 19.0002C13.52 19.0002 14.98 18.7102 16.32 18.1802L19.74 21.6002L21.15 20.1902L3.42 2.4502L2.01 3.8702ZM9.51 11.3702L12.12 13.9802C12.08 13.9902 12.04 14.0002 12 14.0002C10.62 14.0002 9.5 12.8802 9.5 11.5002C9.5 11.4502 9.51 11.4202 9.51 11.3702V11.3702ZM6.11 7.97019L7.86 9.7202C7.63 10.2702 7.5 10.8702 7.5 11.5002C7.5 13.9802 9.52 16.0002 12 16.0002C12.63 16.0002 13.23 15.8702 13.77 15.6402L14.75 16.6202C13.87 16.8602 12.95 17.0002 12 17.0002C8.21 17.0002 4.83 14.8702 3.18 11.5002C3.88 10.0702 4.9 8.89019 6.11 7.97019Z",
        fill: "currentColor"
    })));
};




var $6aRB8 = parcelRequire("6aRB8");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $450c77fc5220f8df$export$e8b904c5d6d728c0 = (props)=>{
    const { className: className, ...rest } = props;
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $6aRB8.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $6aRB8.createElement("path", {
        d: "M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z",
        fill: "currentColor"
    })));
};



const { passwordIsHidden: $e2d54fea4eb580b8$var$passwordIsHidden, passwordIsShown: $e2d54fea4eb580b8$var$passwordIsShown, showPassword: $e2d54fea4eb580b8$var$showPassword } = (0, $c1b70571c7a5ee38$export$529e7eefcb1e2a4c).PasswordField;
const $e2d54fea4eb580b8$var$ShowPasswordButtonPrimitive = ({ fieldType: fieldType, passwordIsHiddenLabel: passwordIsHiddenLabel = $e2d54fea4eb580b8$var$passwordIsHidden, passwordIsShownLabel: passwordIsShownLabel = $e2d54fea4eb580b8$var$passwordIsShown, showPasswordButtonLabel: showPasswordButtonLabel = $e2d54fea4eb580b8$var$showPassword, size: size, hasError: hasError, ...rest }, ref)=>{
    const icons = (0, $6db14e0950ad4d95$export$75b0b37acc90e887)('passwordField');
    const showPasswordButtonClass = (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldShowPassword, (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldShowPassword, 'error', hasError));
    const icon = fieldType === 'password' ? icons?.visibility ?? $6aRB8.createElement((0, $450c77fc5220f8df$export$e8b904c5d6d728c0), {
        "aria-hidden": "true"
    }) : icons?.visibilityOff ?? $6aRB8.createElement((0, $2ca073cce1e67c08$export$9ef36bcf05bb63d9), {
        "aria-hidden": "true"
    });
    return $6aRB8.createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        "aria-checked": fieldType !== 'password',
        ariaLabel: showPasswordButtonLabel,
        className: showPasswordButtonClass,
        colorTheme: hasError ? 'error' : undefined,
        ref: ref,
        role: "switch",
        size: size,
        ...rest
    }, $6aRB8.createElement((0, $c954698269074fa8$export$439d29a4e110a164), {
        "aria-live": "polite"
    }, fieldType === 'password' ? passwordIsHiddenLabel : passwordIsShownLabel), icon);
};
const $e2d54fea4eb580b8$export$c42f83a0ca8c8188 = (0, $268f040634758fba$export$44aa160b17c73194)($e2d54fea4eb580b8$var$ShowPasswordButtonPrimitive);
$e2d54fea4eb580b8$export$c42f83a0ca8c8188.displayName = 'ShowPasswordButton';



var $6aRB8 = parcelRequire("6aRB8");



var $6aRB8 = parcelRequire("6aRB8");


const $bd2e9207321dbec9$export$806e181b7f4dca8a = 'qa-field-description';
const $bd2e9207321dbec9$export$873ced4623a3149c = ({ descriptiveText: descriptiveText, labelHidden: labelHidden, ...rest })=>descriptiveText ? $6aRB8.createElement((0, $f5124d0fbf86e15e$export$5f1af8db9871e1d6), {
        "data-testid": $bd2e9207321dbec9$export$806e181b7f4dca8a,
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldDescription, {
            [(0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).VisuallyHidden]: labelHidden
        }),
        ...rest
    }, descriptiveText) : null;
$bd2e9207321dbec9$export$873ced4623a3149c.displayName = 'FieldDescription';



var $6aRB8 = parcelRequire("6aRB8");


const $b63758a4e174977f$export$1c081951d49ad6f6 = ({ errorMessage: errorMessage, hasError: hasError, ...rest })=>{
    return hasError && errorMessage ? $6aRB8.createElement((0, $f5124d0fbf86e15e$export$5f1af8db9871e1d6), {
        className: (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldErrorMessage,
        ...rest
    }, errorMessage) : null;
};
$b63758a4e174977f$export$1c081951d49ad6f6.displayName = 'FieldErrorMessage';




var $6aRB8 = parcelRequire("6aRB8");




const $ac83acc3aea65b47$var$FieldGroupPrimitive = ({ children: children, className: className, innerEndComponent: innerEndComponent, innerStartComponent: innerStartComponent, orientation: orientation = 'horizontal', outerEndComponent: outerEndComponent, outerStartComponent: outerStartComponent, variation: variation, ...rest }, ref)=>{
    // Don't apply hasInner classnames unless a component was provided
    const hasInnerStartComponent = innerStartComponent != null;
    const hasInnerEndComponent = innerEndComponent != null;
    const fieldGroupHasInnerStartClassName = hasInnerStartComponent ? (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroupHasInnerStart : null;
    const fieldGroupHasInnerEndClassName = hasInnerEndComponent ? (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroupHasInnerEnd : null;
    const componentClasses = (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroup, fieldGroupHasInnerStartClassName, fieldGroupHasInnerEndClassName, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroup, orientation), className);
    return $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        className: componentClasses,
        ref: ref,
        ...rest
    }, outerStartComponent && $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroupOuterStart, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroupOuterStart, variation))
    }, outerStartComponent), $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroupFieldWrapper, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroupFieldWrapper, orientation))
    }, innerStartComponent && $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        className: (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroupInnerStart
    }, innerStartComponent), children, innerEndComponent && $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        className: (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroupInnerEnd
    }, innerEndComponent)), outerEndComponent && $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroupOuterEnd, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroupOuterEnd, variation))
    }, outerEndComponent));
};
const $ac83acc3aea65b47$export$f0fe469072bc6950 = (0, $268f040634758fba$export$44aa160b17c73194)($ac83acc3aea65b47$var$FieldGroupPrimitive);
$ac83acc3aea65b47$export$f0fe469072bc6950.displayName = 'FieldGroup';




var $6aRB8 = parcelRequire("6aRB8");




const $6c3f8a0f25921fc2$var$InputPrimitive = ({ autoComplete: autoComplete, checked: checked, className: className, defaultChecked: defaultChecked, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, size: size, type: type = 'text', hasError: hasError = false, value: value, variation: variation, ...rest }, ref)=>{
    const componentClasses = (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Input, (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroupControl, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Input, variation), (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Input, 'error', hasError), (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Input, size), className);
    const { isFieldsetDisabled: isFieldsetDisabled } = (0, $503b6352ab4ec9e6$export$b140571ec72925dd)(isDisabled);
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        "aria-invalid": hasError,
        as: "input",
        autoComplete: autoComplete,
        checked: checked,
        className: componentClasses,
        defaultChecked: defaultChecked,
        defaultValue: defaultValue,
        isDisabled: isFieldsetDisabled,
        id: id,
        readOnly: isReadOnly,
        ref: ref,
        required: isRequired,
        type: type,
        value: value,
        ...rest
    });
};
const $6c3f8a0f25921fc2$export$f5b8910cec6cf069 = (0, $268f040634758fba$export$44aa160b17c73194)($6c3f8a0f25921fc2$var$InputPrimitive);
$6c3f8a0f25921fc2$export$f5b8910cec6cf069.displayName = 'Input';



var $6aRB8 = parcelRequire("6aRB8");



const $9fab840be00dfe19$var$LabelPrimitive = ({ children: children, className: className, visuallyHidden: visuallyHidden, ...rest }, ref)=>{
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: "label",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Label, className, {
            [(0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).VisuallyHidden]: visuallyHidden
        }),
        ref: ref,
        ...rest
    }, children);
};
const $9fab840be00dfe19$export$b04be29aa201d4f5 = (0, $268f040634758fba$export$44aa160b17c73194)($9fab840be00dfe19$var$LabelPrimitive);
$9fab840be00dfe19$export$b04be29aa201d4f5.displayName = 'Label';



const $fa266489881990e0$var$isStyleKey = (prop)=>{
    return prop in (0, $4a29dbc0bab4c85a$export$c69338bc7d797351);
};
/**
 * This function splits props into style props and non-style props. This is used
 * on Field primitives so we can apply style props on the wrapper element and
 * the rest on the input.
 * @param props this should be a destructured `rest` from the component's props
 */ const $fa266489881990e0$export$584a75f5facb0a5 = (props)=>{
    const splitProps = {
        styleProps: {},
        rest: {}
    };
    Object.keys(props).forEach((prop)=>{
        if ($fa266489881990e0$var$isStyleKey(prop)) // we know it is a style key
        // so we know we can assign the key in styleProps
        splitProps.styleProps = {
            ...splitProps.styleProps,
            [prop]: props[prop]
        };
        else splitProps.rest = {
            ...splitProps.rest,
            [prop]: props[prop]
        };
    });
    return splitProps;
};



var $6aRB8 = parcelRequire("6aRB8");

var $6aRB8 = parcelRequire("6aRB8");
// Source: https://github.com/radix-ui/primitives/blob/7ae63b6cce6ea53ea5d65b6d411894c004b38f47/packages/react/use-layout-effect/src/useLayoutEffect.tsx
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $914379c8d4538763$export$e5c5a5f917a5871c = globalThis?.document ? $6aRB8.useLayoutEffect : ()=>{};


// Adapted from https://github.com/radix-ui/primitives/blob/main/packages/react/id/src/id.tsx#L8
// Prefixed autogenerated id created by useStableId
const $3e17f7da06cdef50$export$766b2b49c9d08de4 = 'amplify-id';
// Create a local version of React.useId which will reference React.useId for React 18
// and fallback to noop for React 17 and below
// Note: We use `toString()` to prevent bundlers from trying to `import { useId } from 'react';`
// since it doesn't exist in React 17 and below (prevents https://github.com/aws-amplify/amplify-ui/issues/1154)
const $3e17f7da06cdef50$var$useReactId = // disable eslint below to allow usage of casting React to `any`, which ensures that TS
// does not get confused about the existence of `useId` in React 17 and below
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
$6aRB8['useId'.toString()] || (()=>undefined);
let $3e17f7da06cdef50$var$count = 0;
/**
 * Create a uuid to use with amplify fields unless
 * an id is provided
 * @param id user specified id
 * @returns string
 */ const $3e17f7da06cdef50$export$5c0b1cf3fea224ac = (id)=>{
    const [stableId, setStableId] = $6aRB8.useState($3e17f7da06cdef50$var$useReactId());
    // React versions older than 18 will have client-side ids only
    (0, $914379c8d4538763$export$e5c5a5f917a5871c)(()=>{
        if (!id) setStableId((reactId)=>reactId ?? String($3e17f7da06cdef50$var$count++));
    }, [
        id
    ]);
    return id ?? (stableId ? `${$3e17f7da06cdef50$export$766b2b49c9d08de4}-${stableId}` : '');
};



/**
 * Joins an array of strings and undefined values into a single string with spaces as separators.
 * If all elements are undefined, returns undefined.
 *
 * @param {(string | undefined)[]} ids - An array of strings or undefined values.
 * @returns {string | undefined} A single string with space-separated IDs, or undefined if all elements are undefined.
 */ const $51a8d22fceaaa8f7$export$e7d3ee79e84cb57 = (ids)=>{
    const joinedIds = ids.filter((id)=>id !== undefined).join(' ');
    return joinedIds.length > 0 ? joinedIds : undefined;
};



typeof Symbol !== 'undefined' && (0, $fd30e9352c42562e$export$f6e2535fb5126e54)(Symbol.for) && Symbol.for('amplify_default');
const $8dffbf1516571389$export$861adbab90bc3408 = 'error';
const $8dffbf1516571389$export$20840b8285a9a801 = 'description';


const $5db659a628d34970$export$7a33636e1bc2e96d = (id, suffix)=>id && suffix ? `${id}-${suffix}` : undefined;


const $6b33a825af028c52$var$TextFieldPrimitive = (props, ref)=>{
    const { className: className, descriptiveText: descriptiveText, errorMessage: errorMessage, hasError: hasError = false, id: id, innerEndComponent: innerEndComponent, innerStartComponent: innerStartComponent, label: label, labelHidden: labelHidden = false, outerEndComponent: outerEndComponent, outerStartComponent: outerStartComponent, size: size, testId: testId, variation: variation, inputStyles: inputStyles, ..._rest } = props;
    const fieldId = (0, $3e17f7da06cdef50$export$5c0b1cf3fea224ac)(id);
    const stableId = (0, $3e17f7da06cdef50$export$5c0b1cf3fea224ac)();
    const descriptionId = descriptiveText ? (0, $5db659a628d34970$export$7a33636e1bc2e96d)(stableId, (0, $8dffbf1516571389$export$20840b8285a9a801)) : undefined;
    const errorId = hasError ? (0, $5db659a628d34970$export$7a33636e1bc2e96d)(stableId, (0, $8dffbf1516571389$export$861adbab90bc3408)) : undefined;
    const ariaDescribedBy = (0, $51a8d22fceaaa8f7$export$e7d3ee79e84cb57)([
        errorId,
        descriptionId
    ]);
    const { styleProps: styleProps, rest: rest } = (0, $fa266489881990e0$export$584a75f5facb0a5)(_rest);
    return $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Field, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Field, size), (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).TextField, className),
        testId: testId,
        ...styleProps
    }, $6aRB8.createElement((0, $9fab840be00dfe19$export$b04be29aa201d4f5), {
        htmlFor: fieldId,
        visuallyHidden: labelHidden
    }, label), $6aRB8.createElement((0, $bd2e9207321dbec9$export$873ced4623a3149c), {
        id: descriptionId,
        labelHidden: labelHidden,
        descriptiveText: descriptiveText
    }), $6aRB8.createElement((0, $ac83acc3aea65b47$export$f0fe469072bc6950), {
        outerStartComponent: outerStartComponent,
        outerEndComponent: outerEndComponent,
        innerStartComponent: innerStartComponent,
        innerEndComponent: innerEndComponent,
        variation: variation
    }, $6aRB8.createElement((0, $6c3f8a0f25921fc2$export$f5b8910cec6cf069), {
        "aria-describedby": ariaDescribedBy,
        hasError: hasError,
        id: fieldId,
        ref: ref,
        size: size,
        variation: variation,
        ...inputStyles,
        ...rest
    })), $6aRB8.createElement((0, $b63758a4e174977f$export$1c081951d49ad6f6), {
        id: errorId,
        hasError: hasError,
        errorMessage: errorMessage
    }));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/textfield)
 */ const $6b33a825af028c52$export$2c73285ae9390cec = (0, $268f040634758fba$export$44aa160b17c73194)($6b33a825af028c52$var$TextFieldPrimitive);
$6b33a825af028c52$export$2c73285ae9390cec.displayName = 'TextField';



const $7e9c2d18364420fb$var$PasswordFieldPrimitive = ({ autoComplete: autoComplete = 'current-password', label: label, className: className, hideShowPassword: hideShowPassword = false, passwordIsHiddenLabel: passwordIsHiddenLabel, passwordIsShownLabel: passwordIsShownLabel, showPasswordButtonLabel: showPasswordButtonLabel, showPasswordButtonRef: showPasswordButtonRef, size: size, hasError: hasError, ...rest }, ref)=>{
    const [type, setType] = $6aRB8.useState('password');
    const showPasswordOnClick = $6aRB8.useCallback(()=>{
        if (type === 'password') setType('text');
        else setType('password');
    }, [
        setType,
        type
    ]);
    return $6aRB8.createElement((0, $6b33a825af028c52$export$2c73285ae9390cec), {
        autoComplete: autoComplete,
        outerEndComponent: hideShowPassword ? null : $6aRB8.createElement((0, $e2d54fea4eb580b8$export$c42f83a0ca8c8188), {
            fieldType: type,
            onClick: showPasswordOnClick,
            passwordIsHiddenLabel: passwordIsHiddenLabel,
            passwordIsShownLabel: passwordIsShownLabel,
            ref: showPasswordButtonRef,
            size: size,
            showPasswordButtonLabel: showPasswordButtonLabel,
            hasError: hasError
        }),
        size: size,
        type: type,
        label: label,
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).PasswordField, className),
        ref: ref,
        hasError: hasError,
        ...rest
    });
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/passwordfield)
 */ const $7e9c2d18364420fb$export$65ed9482db2257fa = (0, $268f040634758fba$export$44aa160b17c73194)($7e9c2d18364420fb$var$PasswordFieldPrimitive);
$7e9c2d18364420fb$export$65ed9482db2257fa.displayName = 'PasswordField';



var $6aRB8 = parcelRequire("6aRB8");


var $6aRB8 = parcelRequire("6aRB8");


var $6aRB8 = parcelRequire("6aRB8");








var $6aRB8 = parcelRequire("6aRB8");








var $6aRB8 = parcelRequire("6aRB8");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $974671bf46dc81b1$export$e0c00b3c5102a294 = (props)=>{
    const { className: className, ...rest } = props;
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $6aRB8.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $6aRB8.createElement("path", {
        d: "M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z",
        fill: "currentColor"
    })));
};




const $41b0d7fac53271e9$var$SelectPrimitive = ({ autoComplete: autoComplete, className: className, size: size, variation: variation, value: value, defaultValue: defaultValue, hasError: hasError, icon: icon, iconColor: iconColor, children: children, placeholder: placeholder, isDisabled: isDisabled, isRequired: isRequired, isMultiple: isMultiple = false, selectSize: selectSize = 1, ...rest }, ref)=>{
    const DEFAULT_PLACEHOLDER_VALUE = '';
    // value === undefined is to make sure that component is used in uncontrolled way so that setting defaultValue is valid
    const shouldSetDefaultPlaceholderValue = value === undefined && defaultValue === undefined && placeholder;
    const isExpanded = isMultiple || selectSize > 1;
    const componentClasses = (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Select, (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldGroupControl, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Select, size), (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Select, variation), (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Select, 'error', hasError), (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Select, 'expanded', isExpanded), className);
    const icons = (0, $6db14e0950ad4d95$export$75b0b37acc90e887)('select');
    const { isFieldsetDisabled: isFieldsetDisabled } = (0, $503b6352ab4ec9e6$export$b140571ec72925dd)(isDisabled);
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        className: (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).SelectWrapper
    }, $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        "aria-invalid": hasError,
        as: "select",
        autoComplete: autoComplete,
        value: value,
        defaultValue: shouldSetDefaultPlaceholderValue ? DEFAULT_PLACEHOLDER_VALUE : defaultValue,
        isDisabled: isFieldsetDisabled,
        multiple: isMultiple,
        size: selectSize,
        required: isRequired,
        className: componentClasses,
        ref: ref,
        ...rest
    }, placeholder && $6aRB8.createElement("option", {
        value: ""
    }, placeholder), children), isExpanded ? null : $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).SelectIcon, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).SelectIcon, size)),
        color: iconColor,
        "aria-hidden": "true"
    }, icon ?? icons?.expand ?? $6aRB8.createElement((0, $974671bf46dc81b1$export$e0c00b3c5102a294), null)));
};
const $41b0d7fac53271e9$export$ef9b1a59e592288f = (0, $268f040634758fba$export$44aa160b17c73194)($41b0d7fac53271e9$var$SelectPrimitive);
$41b0d7fac53271e9$export$ef9b1a59e592288f.displayName = 'Select';








const $f93ef80a61f6485d$var$selectFieldChildren = ({ children: children, options: options })=>{
    if (children) {
        if (options?.length) // eslint-disable-next-line no-console
        console.warn('Amplify UI: <SelectField> component  defaults to rendering children over `options`. When using the `options` prop, omit children.');
        return children;
    }
    return options?.map((option, index)=>$6aRB8.createElement("option", {
            label: option,
            value: option,
            key: `${option}-${index}`
        }, option));
};
const $f93ef80a61f6485d$var$SelectFieldPrimitive = (props, ref)=>{
    const { children: children, className: className, descriptiveText: descriptiveText, errorMessage: errorMessage, hasError: hasError = false, id: id, label: label, labelHidden: labelHidden = false, options: options, size: size, testId: testId, inputStyles: inputStyles, ..._rest } = props;
    const fieldId = (0, $3e17f7da06cdef50$export$5c0b1cf3fea224ac)(id);
    const stableId = (0, $3e17f7da06cdef50$export$5c0b1cf3fea224ac)();
    const descriptionId = descriptiveText ? (0, $5db659a628d34970$export$7a33636e1bc2e96d)(stableId, (0, $8dffbf1516571389$export$20840b8285a9a801)) : undefined;
    const errorId = hasError ? (0, $5db659a628d34970$export$7a33636e1bc2e96d)(stableId, (0, $8dffbf1516571389$export$861adbab90bc3408)) : undefined;
    const ariaDescribedBy = (0, $51a8d22fceaaa8f7$export$e7d3ee79e84cb57)([
        errorId,
        descriptionId
    ]);
    const { styleProps: styleProps, rest: rest } = (0, $fa266489881990e0$export$584a75f5facb0a5)(_rest);
    return $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Field, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Field, size), (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).SelectField, className),
        testId: testId,
        ...styleProps
    }, $6aRB8.createElement((0, $9fab840be00dfe19$export$b04be29aa201d4f5), {
        htmlFor: fieldId,
        visuallyHidden: labelHidden
    }, label), $6aRB8.createElement((0, $bd2e9207321dbec9$export$873ced4623a3149c), {
        id: descriptionId,
        labelHidden: labelHidden,
        descriptiveText: descriptiveText
    }), $6aRB8.createElement((0, $41b0d7fac53271e9$export$ef9b1a59e592288f), {
        "aria-describedby": ariaDescribedBy,
        hasError: hasError,
        id: fieldId,
        ref: ref,
        size: size,
        ...rest,
        ...inputStyles
    }, $f93ef80a61f6485d$var$selectFieldChildren({
        children: children,
        options: options
    })), $6aRB8.createElement((0, $b63758a4e174977f$export$1c081951d49ad6f6), {
        id: errorId,
        hasError: hasError,
        errorMessage: errorMessage
    }));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/selectfield)
 */ const $f93ef80a61f6485d$export$d55b50a564d0b931 = (0, $268f040634758fba$export$44aa160b17c73194)($f93ef80a61f6485d$var$SelectFieldPrimitive);
$f93ef80a61f6485d$export$d55b50a564d0b931.displayName = 'SelectField';



const $b315a54e6937f4c3$var$DialCodeSelectPrimitive = ({ className: className, dialCodeList: dialCodeList, isReadOnly: isReadOnly, ...props }, ref)=>{
    const dialList = dialCodeList ?? (0, $3f5eb17a62479ee4$export$a51e8cda1526c737);
    const dialCodeOptions = $6aRB8.useMemo(()=>dialList.map((dialCode)=>// Regarding the `disabled` attribute, see comment in SelectField below
            $6aRB8.createElement("option", {
                key: dialCode,
                value: dialCode,
                disabled: isReadOnly
            }, dialCode)), [
        dialList,
        isReadOnly
    ]);
    return $6aRB8.createElement((0, $f93ef80a61f6485d$export$d55b50a564d0b931), {
        "aria-disabled": isReadOnly,
        autoComplete: "tel-country-code",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).CountryCodeSelect, (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).DialCodeSelect, className),
        labelHidden: true,
        ref: ref,
        ...props
    }, dialCodeOptions);
};
const $b315a54e6937f4c3$export$5dbfe48f3829fce4 = (0, $268f040634758fba$export$44aa160b17c73194)($b315a54e6937f4c3$var$DialCodeSelectPrimitive);
$b315a54e6937f4c3$export$5dbfe48f3829fce4.displayName = 'DialCodeSelect';





const $e1c700894044e301$var$PhoneNumberFieldPrimitive = ({ autoComplete: autoComplete = 'tel-national', className: className, defaultDialCode: defaultDialCode, dialCodeLabel: dialCodeLabel = (0, $c1b70571c7a5ee38$export$529e7eefcb1e2a4c).PhoneNumberField.countryCodeLabel, dialCodeList: dialCodeList, dialCodeName: dialCodeName, dialCodeRef: dialCodeRef, hasError: hasError, isDisabled: isDisabled, isReadOnly: isReadOnly, onDialCodeChange: onDialCodeChange, onInput: onInput, size: size, variation: variation, ...rest }, ref)=>{
    return $6aRB8.createElement((0, $6b33a825af028c52$export$2c73285ae9390cec), {
        outerStartComponent: $6aRB8.createElement((0, $b315a54e6937f4c3$export$5dbfe48f3829fce4), {
            defaultValue: defaultDialCode,
            dialCodeList: dialCodeList,
            className: className,
            hasError: hasError,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            label: dialCodeLabel,
            name: dialCodeName,
            onChange: onDialCodeChange,
            ref: dialCodeRef,
            size: size,
            variation: variation
        }),
        autoComplete: autoComplete,
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).PhoneNumberField, className),
        hasError: hasError,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        onInput: onInput,
        ref: ref,
        size: size,
        type: "tel",
        variation: variation,
        ...rest
    });
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/phonenumberfield)
 */ const $e1c700894044e301$export$522a16be7a55e553 = (0, $268f040634758fba$export$44aa160b17c73194)($e1c700894044e301$var$PhoneNumberFieldPrimitive);
$e1c700894044e301$export$522a16be7a55e553.displayName = 'PhoneNumberField';






var $6aRB8 = parcelRequire("6aRB8");



const $c939f3c50b5e8081$export$db10347ccaf03b65 = ({ errors: errors, id: id, dataAttr: dataAttr })=>{
    if (!(errors?.length > 0)) return null;
    const dataAttrProp = dataAttr ? {
        [dataAttr]: true
    } : {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        ...dataAttrProp,
        id: id
    }, errors.map((error)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $f5124d0fbf86e15e$export$5f1af8db9871e1d6), {
            key: error,
            role: "alert",
            variation: "error"
        }, (0, $94bd8652748873ad$export$d73ee8ef04f5226a)(error));
    }));
};


function $04b8f05a65e2f815$export$56e87bf42978147a({ autocomplete: autoComplete, dialCode: dialCode, name: name, type: type, ...props }) {
    const { validationErrors: validationErrors } = (0, $eb4806d462018926$export$2e2bcd8739ae039)(({ validationErrors: validationErrors })=>[
            validationErrors
        ]);
    const errors = $6aRB8.useMemo(()=>(0, $8709da976487c46a$export$501239432719417d)(validationErrors[name]), [
        name,
        validationErrors
    ]);
    const hasError = errors?.length > 0;
    const errorId = (0, $3e17f7da06cdef50$export$5c0b1cf3fea224ac)();
    const ariaDescribedBy = hasError ? errorId : undefined;
    if (type === 'tel') return $6aRB8.createElement($6aRB8.Fragment, null, $6aRB8.createElement((0, $e1c700894044e301$export$522a16be7a55e553), {
        ...props,
        name: name,
        defaultDialCode: dialCode,
        dialCodeName: "country_code",
        autoComplete: autoComplete,
        hasError: hasError,
        "aria-describedby": ariaDescribedBy
    }), $6aRB8.createElement((0, $c939f3c50b5e8081$export$db10347ccaf03b65), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: errors,
        id: errorId
    }));
    else if (type === 'password') return $6aRB8.createElement($6aRB8.Fragment, null, $6aRB8.createElement((0, $7e9c2d18364420fb$export$65ed9482db2257fa), {
        ...props,
        name: name,
        autoCapitalize: "off",
        autoComplete: autoComplete,
        hasError: hasError,
        "aria-describedby": ariaDescribedBy
    }), $6aRB8.createElement((0, $c939f3c50b5e8081$export$db10347ccaf03b65), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: errors,
        id: errorId
    }));
    else return $6aRB8.createElement($6aRB8.Fragment, null, $6aRB8.createElement((0, $6b33a825af028c52$export$2c73285ae9390cec), {
        ...props,
        name: name,
        autoCapitalize: "off",
        autoComplete: autoComplete,
        hasError: hasError,
        type: type,
        "aria-describedby": ariaDescribedBy
    }), $6aRB8.createElement((0, $c939f3c50b5e8081$export$db10347ccaf03b65), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: errors,
        id: errorId
    }));
}



function $08fc83614da0644b$export$125d0b248abd3e88({ includePassword: includePassword } = {}) {
    const { fields: fields } = (0, $eb4806d462018926$export$2e2bcd8739ae039)(({ route: route })=>[
            route
        ]);
    const { selectedAuthMethod: selectedAuthMethod, preferredChallenge: preferredChallenge } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.selectedAuthMethod,
            context.preferredChallenge
        ]);
    // Determine if password should be shown
    const effectiveMethod = selectedAuthMethod ?? preferredChallenge;
    const shouldRequirePassword = includePassword ?? (!effectiveMethod || effectiveMethod === 'PASSWORD');
    const formFields = $6aRB8.useRef(fields.map((field, index)=>{
        // Make password and confirm_password optional for passwordless methods
        if ((field.name === 'password' || field.name === 'confirm_password') && !shouldRequirePassword) return $6aRB8.createElement((0, $04b8f05a65e2f815$export$56e87bf42978147a), {
            key: index,
            ...field,
            isRequired: false
        });
        return $6aRB8.createElement((0, $04b8f05a65e2f815$export$56e87bf42978147a), {
            // use index for key, field order is static
            key: index,
            ...field
        });
    }).filter(Boolean)).current;
    return $6aRB8.createElement($6aRB8.Fragment, null, formFields);
}



var $6aRB8 = parcelRequire("6aRB8");



function $1e2f313ad0cdbcd6$export$253df7dc30f737bc({ children: children, className: className, variation: variation = 'default' }) {
    const { route: route } = (0, $eb4806d462018926$export$2e2bcd8739ae039)(({ route: route })=>[
            route
        ]);
    const { // @ts-ignore
    components: { Header: Header, Footer: Footer } } = (0, $dd10c02aadfdf910$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        className: className,
        "data-amplify-authenticator": "",
        "data-variation": variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        "data-amplify-container": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        "data-amplify-router": "",
        "data-amplify-router-content": undefined
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Footer, null)));
}


const { getDeliveryMessageText: $475df2e5a608f400$var$getDeliveryMessageText, getDeliveryMethodText: $475df2e5a608f400$var$getDeliveryMethodText, getConfirmingText: $475df2e5a608f400$var$getConfirmingText, getConfirmText: $475df2e5a608f400$var$getConfirmText, getResendCodeText: $475df2e5a608f400$var$getResendCodeText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
function $475df2e5a608f400$export$649c708157e61c64({ className: className, variation: variation }) {
    const { isPending: isPending, resendCode: resendCode, codeDeliveryDetails: codeDeliveryDetails } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.resendCode,
            context.codeDeliveryDetails
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $81db2db49ed132c1$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ConfirmSignUp: { Header: Header = $475df2e5a608f400$export$649c708157e61c64.Header, Footer: Footer = $475df2e5a608f400$export$649c708157e61c64.Footer } } } = (0, $dd10c02aadfdf910$export$b0e9d19f717d0a5c)();
    return(// TODO Automatically add these namespaces again from `useAmplify`
    (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmsignup": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $f5124d0fbf86e15e$export$5f1af8db9871e1d6), {
        className: "amplify-authenticator__subtitle"
    }, $475df2e5a608f400$var$getDeliveryMessageText(codeDeliveryDetails)), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $08fc83614da0644b$export$125d0b248abd3e88), null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        variation: "primary",
        isDisabled: isPending,
        type: "submit",
        loadingText: $475df2e5a608f400$var$getConfirmingText(),
        isLoading: isPending
    }, $475df2e5a608f400$var$getConfirmText()), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        onClick: resendCode,
        type: "button"
    }, $475df2e5a608f400$var$getResendCodeText())), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Footer, null)))));
}
const $475df2e5a608f400$var$DefaultHeader = ()=>{
    const { codeDeliveryDetails: codeDeliveryDetails } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.codeDeliveryDetails
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 4
    }, $475df2e5a608f400$var$getDeliveryMethodText(codeDeliveryDetails));
};
$475df2e5a608f400$export$649c708157e61c64.Header = $475df2e5a608f400$var$DefaultHeader;
$475df2e5a608f400$export$649c708157e61c64.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $6aRB8 = parcelRequire("6aRB8");










const { getChangePasswordText: $20fa237c7c67a7b5$var$getChangePasswordText, getChangingText: $20fa237c7c67a7b5$var$getChangingText, getBackToSignInText: $20fa237c7c67a7b5$var$getBackToSignInText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
const $20fa237c7c67a7b5$export$b3aae0a112274a60 = ({ className: className, variation: variation })=>{
    const { isPending: isPending, toSignIn: toSignIn } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.toSignIn
        ]);
    const { handleBlur: handleBlur, handleChange: handleChange, handleSubmit: handleSubmit } = (0, $81db2db49ed132c1$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ForceNewPassword: { FormFields: FormFields = $20fa237c7c67a7b5$export$b3aae0a112274a60.FormFields, Header: Header = $20fa237c7c67a7b5$export$b3aae0a112274a60.Header, Footer: Footer = $20fa237c7c67a7b5$export$b3aae0a112274a60.Footer } } } = (0, $dd10c02aadfdf910$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-forcenewpassword": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit,
        onBlur: handleBlur
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(FormFields, null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        isDisabled: isPending,
        type: "submit",
        variation: "primary",
        isLoading: isPending,
        loadingText: $20fa237c7c67a7b5$var$getChangingText()
    }, $20fa237c7c67a7b5$var$getChangePasswordText()), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        onClick: toSignIn,
        type: "button",
        variation: "link",
        size: "small"
    }, $20fa237c7c67a7b5$var$getBackToSignInText()), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Footer, null))));
};
$20fa237c7c67a7b5$export$b3aae0a112274a60.FormFields = function FormFields$1() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $08fc83614da0644b$export$125d0b248abd3e88), null);
};
$20fa237c7c67a7b5$export$b3aae0a112274a60.Header = function Header() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 4
    }, $20fa237c7c67a7b5$var$getChangePasswordText());
};
$20fa237c7c67a7b5$export$b3aae0a112274a60.Footer = function Footer() {
    return null;
};


var $2846b526ff7f0b00$exports = {};

$parcel$export($2846b526ff7f0b00$exports, "create", function () { return $2846b526ff7f0b00$export$185802fd694ee1f5; }, function (v) { return $2846b526ff7f0b00$export$185802fd694ee1f5 = v; });
$parcel$export($2846b526ff7f0b00$exports, "toCanvas", function () { return $2846b526ff7f0b00$export$f87f6982d1fd4f81; }, function (v) { return $2846b526ff7f0b00$export$f87f6982d1fd4f81 = v; });
$parcel$export($2846b526ff7f0b00$exports, "toDataURL", function () { return $2846b526ff7f0b00$export$723e4939e5a27c8; }, function (v) { return $2846b526ff7f0b00$export$723e4939e5a27c8 = v; });
$parcel$export($2846b526ff7f0b00$exports, "toString", function () { return $2846b526ff7f0b00$export$f84e8e69fd4488a5; }, function (v) { return $2846b526ff7f0b00$export$f84e8e69fd4488a5 = v; });
var $2846b526ff7f0b00$export$185802fd694ee1f5;
var $2846b526ff7f0b00$export$f87f6982d1fd4f81;
var $2846b526ff7f0b00$export$723e4939e5a27c8;
// only svg for now.
var $2846b526ff7f0b00$export$f84e8e69fd4488a5;
var $d5f77c3f2f2a50aa$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$d5f77c3f2f2a50aa$exports = function() {
    return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $94167ac37b7f79b3$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $5b0c59df01b43f2a$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $5b0c59df01b43f2a$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $5b0c59df01b43f2a$export$ed1d66da50968976;
var $5b0c59df01b43f2a$export$6733b14783f975c2;
var $5b0c59df01b43f2a$export$ce5b1274f8597fa0;
var $5b0c59df01b43f2a$export$43dd553ecded716d;
let $5b0c59df01b43f2a$var$toSJISFunction;
const $5b0c59df01b43f2a$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$5b0c59df01b43f2a$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$5b0c59df01b43f2a$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $5b0c59df01b43f2a$var$CODEWORDS_COUNT[version];
};
$5b0c59df01b43f2a$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$5b0c59df01b43f2a$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== 'function') throw new Error('"toSJISFunc" is not a valid function.');
    $5b0c59df01b43f2a$var$toSJISFunction = f;
};
$5b0c59df01b43f2a$export$ce5b1274f8597fa0 = function() {
    return typeof $5b0c59df01b43f2a$var$toSJISFunction !== 'undefined';
};
$5b0c59df01b43f2a$export$43dd553ecded716d = function toSJIS(kanji) {
    return $5b0c59df01b43f2a$var$toSJISFunction(kanji);
};


var $c34382e7df2b82b7$export$61196ced6d74a310;
var $c34382e7df2b82b7$export$3a1a48c8f6ef640e;
var $c34382e7df2b82b7$export$3722cfe417b6ed86;
var $c34382e7df2b82b7$export$7f8ddf7c7c20b3cd;
var $c34382e7df2b82b7$export$1ea939691cdc45b8;
var $c34382e7df2b82b7$export$6788812c4e6611e6;
$c34382e7df2b82b7$export$61196ced6d74a310 = {
    bit: 1
};
$c34382e7df2b82b7$export$3a1a48c8f6ef640e = {
    bit: 0
};
$c34382e7df2b82b7$export$3722cfe417b6ed86 = {
    bit: 3
};
$c34382e7df2b82b7$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $c34382e7df2b82b7$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'l':
        case 'low':
            return $c34382e7df2b82b7$export$61196ced6d74a310;
        case 'm':
        case 'medium':
            return $c34382e7df2b82b7$export$3a1a48c8f6ef640e;
        case 'q':
        case 'quartile':
            return $c34382e7df2b82b7$export$3722cfe417b6ed86;
        case 'h':
        case 'high':
            return $c34382e7df2b82b7$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error('Unknown EC Level: ' + string);
    }
}
$c34382e7df2b82b7$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== 'undefined' && level.bit >= 0 && level.bit < 4;
};
$c34382e7df2b82b7$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($c34382e7df2b82b7$export$1ea939691cdc45b8(value)) return value;
    try {
        return $c34382e7df2b82b7$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $ca7263ebfa1cedab$exports = {};
function $ca7263ebfa1cedab$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$ca7263ebfa1cedab$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$ca7263ebfa1cedab$exports = $ca7263ebfa1cedab$var$BitBuffer;


var $8eaf2105cd306f1b$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $8eaf2105cd306f1b$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error('BitMatrix size must be defined and greater than 0');
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $8eaf2105cd306f1b$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $8eaf2105cd306f1b$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $8eaf2105cd306f1b$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $8eaf2105cd306f1b$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$8eaf2105cd306f1b$exports = $8eaf2105cd306f1b$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $76cfc0b8ef1e9dce$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $76cfc0b8ef1e9dce$export$c39457c570f2b189;

var $76cfc0b8ef1e9dce$require$getSymbolSize = $5b0c59df01b43f2a$export$8d4a06d3facd414b;
$76cfc0b8ef1e9dce$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $76cfc0b8ef1e9dce$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$76cfc0b8ef1e9dce$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $76cfc0b8ef1e9dce$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $0fd8ebc9602ffc6e$export$c39457c570f2b189;

var $0fd8ebc9602ffc6e$require$getSymbolSize = $5b0c59df01b43f2a$export$8d4a06d3facd414b;
const $0fd8ebc9602ffc6e$var$FINDER_PATTERN_SIZE = 7;
$0fd8ebc9602ffc6e$export$c39457c570f2b189 = function getPositions(version) {
    const size = $0fd8ebc9602ffc6e$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $0fd8ebc9602ffc6e$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $0fd8ebc9602ffc6e$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $f92c8a242c5c64e1$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $f92c8a242c5c64e1$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $f92c8a242c5c64e1$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $f92c8a242c5c64e1$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $f92c8a242c5c64e1$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $f92c8a242c5c64e1$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $f92c8a242c5c64e1$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $f92c8a242c5c64e1$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $f92c8a242c5c64e1$export$fe9625aaceb0e563;
$f92c8a242c5c64e1$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $f92c8a242c5c64e1$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$f92c8a242c5c64e1$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$f92c8a242c5c64e1$export$6788812c4e6611e6 = function from(value) {
    return $f92c8a242c5c64e1$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$f92c8a242c5c64e1$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $f92c8a242c5c64e1$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $f92c8a242c5c64e1$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $f92c8a242c5c64e1$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $f92c8a242c5c64e1$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$f92c8a242c5c64e1$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $f92c8a242c5c64e1$var$PenaltyScores.N2;
};
$f92c8a242c5c64e1$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $f92c8a242c5c64e1$var$PenaltyScores.N3;
};
$f92c8a242c5c64e1$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $f92c8a242c5c64e1$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $f92c8a242c5c64e1$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $f92c8a242c5c64e1$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $f92c8a242c5c64e1$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $f92c8a242c5c64e1$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $f92c8a242c5c64e1$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $f92c8a242c5c64e1$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $f92c8a242c5c64e1$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $f92c8a242c5c64e1$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $f92c8a242c5c64e1$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error('bad maskPattern:' + maskPattern);
    }
}
$f92c8a242c5c64e1$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $f92c8a242c5c64e1$var$getMaskAt(pattern, row, col));
    }
};
$f92c8a242c5c64e1$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($f92c8a242c5c64e1$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $f92c8a242c5c64e1$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $f92c8a242c5c64e1$export$a5fd3a02c14d0b3e(data) + $f92c8a242c5c64e1$export$9a9385107a518e46(data) + $f92c8a242c5c64e1$export$ade754353f0dc75e(data) + $f92c8a242c5c64e1$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $f92c8a242c5c64e1$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $bf85a70c3520684b$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $bf85a70c3520684b$export$683d1b3e8a1a8438;

const $bf85a70c3520684b$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $bf85a70c3520684b$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$bf85a70c3520684b$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $c34382e7df2b82b7$export$61196ced6d74a310:
            return $bf85a70c3520684b$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $c34382e7df2b82b7$export$3a1a48c8f6ef640e:
            return $bf85a70c3520684b$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $c34382e7df2b82b7$export$3722cfe417b6ed86:
            return $bf85a70c3520684b$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $c34382e7df2b82b7$export$7f8ddf7c7c20b3cd:
            return $bf85a70c3520684b$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$bf85a70c3520684b$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $c34382e7df2b82b7$export$61196ced6d74a310:
            return $bf85a70c3520684b$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $c34382e7df2b82b7$export$3a1a48c8f6ef640e:
            return $bf85a70c3520684b$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $c34382e7df2b82b7$export$3722cfe417b6ed86:
            return $bf85a70c3520684b$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $c34382e7df2b82b7$export$7f8ddf7c7c20b3cd:
            return $bf85a70c3520684b$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $f10603a5ff8ac6ca$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $47e12706667a827c$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $47e12706667a827c$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $47e12706667a827c$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $31e51c62a9d9921a$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $31e51c62a9d9921a$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $31e51c62a9d9921a$export$6e3a27864ab166fe;
const $31e51c62a9d9921a$var$EXP_TABLE = new Uint8Array(512);
const $31e51c62a9d9921a$var$LOG_TABLE = new Uint8Array(256);
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $31e51c62a9d9921a$var$EXP_TABLE[i] = x;
        $31e51c62a9d9921a$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$31e51c62a9d9921a$var$EXP_TABLE[i] = $31e51c62a9d9921a$var$EXP_TABLE[i - 255];
})();
$31e51c62a9d9921a$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error('log(' + n + ')');
    return $31e51c62a9d9921a$var$LOG_TABLE[n];
};
$31e51c62a9d9921a$export$b310ec824aaee37f = function exp(n) {
    return $31e51c62a9d9921a$var$EXP_TABLE[n];
};
$31e51c62a9d9921a$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $31e51c62a9d9921a$var$EXP_TABLE[$31e51c62a9d9921a$var$LOG_TABLE[x] + $31e51c62a9d9921a$var$LOG_TABLE[y]];
};


$47e12706667a827c$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $31e51c62a9d9921a$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$47e12706667a827c$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $31e51c62a9d9921a$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$47e12706667a827c$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $47e12706667a827c$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $31e51c62a9d9921a$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $f10603a5ff8ac6ca$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $f10603a5ff8ac6ca$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $47e12706667a827c$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $f10603a5ff8ac6ca$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error('Encoder not initialized');
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $47e12706667a827c$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$f10603a5ff8ac6ca$exports = $f10603a5ff8ac6ca$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $61f705a7651e739b$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $61f705a7651e739b$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $61f705a7651e739b$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $61f705a7651e739b$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $0df70ca2f445bcbc$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $0df70ca2f445bcbc$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $0df70ca2f445bcbc$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $0df70ca2f445bcbc$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $0df70ca2f445bcbc$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $0df70ca2f445bcbc$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $0df70ca2f445bcbc$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $0df70ca2f445bcbc$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $0df70ca2f445bcbc$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $0df70ca2f445bcbc$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $198479146e7a84c0$export$1ea939691cdc45b8;
$198479146e7a84c0$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $71803ab3889afd57$export$a4d452c2363c8e12;
var $71803ab3889afd57$export$9df7c29d562bab83;
var $71803ab3889afd57$export$8f4bf8f7eb581284;
var $71803ab3889afd57$export$4d318981b5a83836;
var $71803ab3889afd57$export$376a9ed239d6c1c8;
var $71803ab3889afd57$export$175f16aef75a4569;
var $71803ab3889afd57$export$50b7f9bf92c74274;
var $71803ab3889afd57$export$4ba5f52893b4ac97;
const $71803ab3889afd57$var$numeric = '[0-9]+';
const $71803ab3889afd57$var$alphanumeric = '[A-Z $%*+\\-./:]+';
let $71803ab3889afd57$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$71803ab3889afd57$var$kanji = $71803ab3889afd57$var$kanji.replace(/u/g, '\\u');
const $71803ab3889afd57$var$byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + $71803ab3889afd57$var$kanji + ')(?:.|[\r\n]))+';
$71803ab3889afd57$export$a4d452c2363c8e12 = new RegExp($71803ab3889afd57$var$kanji, 'g');
$71803ab3889afd57$export$9df7c29d562bab83 = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
$71803ab3889afd57$export$8f4bf8f7eb581284 = new RegExp($71803ab3889afd57$var$byte, 'g');
$71803ab3889afd57$export$4d318981b5a83836 = new RegExp($71803ab3889afd57$var$numeric, 'g');
$71803ab3889afd57$export$376a9ed239d6c1c8 = new RegExp($71803ab3889afd57$var$alphanumeric, 'g');
const $71803ab3889afd57$var$TEST_KANJI = new RegExp('^' + $71803ab3889afd57$var$kanji + '$');
const $71803ab3889afd57$var$TEST_NUMERIC = new RegExp('^' + $71803ab3889afd57$var$numeric + '$');
const $71803ab3889afd57$var$TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');
$71803ab3889afd57$export$175f16aef75a4569 = function testKanji(str) {
    return $71803ab3889afd57$var$TEST_KANJI.test(str);
};
$71803ab3889afd57$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $71803ab3889afd57$var$TEST_NUMERIC.test(str);
};
$71803ab3889afd57$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $71803ab3889afd57$var$TEST_ALPHANUMERIC.test(str);
};


$0df70ca2f445bcbc$export$4d318981b5a83836 = {
    id: 'Numeric',
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$0df70ca2f445bcbc$export$376a9ed239d6c1c8 = {
    id: 'Alphanumeric',
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$0df70ca2f445bcbc$export$8f4bf8f7eb581284 = {
    id: 'Byte',
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$0df70ca2f445bcbc$export$a4d452c2363c8e12 = {
    id: 'Kanji',
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$0df70ca2f445bcbc$export$bb410559a65d3418 = {
    bit: -1
};
$0df70ca2f445bcbc$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error('Invalid mode: ' + mode);
    if (!$198479146e7a84c0$export$1ea939691cdc45b8(version)) throw new Error('Invalid version: ' + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$0df70ca2f445bcbc$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($71803ab3889afd57$export$50b7f9bf92c74274(dataStr)) return $0df70ca2f445bcbc$export$4d318981b5a83836;
    else if ($71803ab3889afd57$export$4ba5f52893b4ac97(dataStr)) return $0df70ca2f445bcbc$export$376a9ed239d6c1c8;
    else if ($71803ab3889afd57$export$175f16aef75a4569(dataStr)) return $0df70ca2f445bcbc$export$a4d452c2363c8e12;
    else return $0df70ca2f445bcbc$export$8f4bf8f7eb581284;
};
$0df70ca2f445bcbc$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error('Invalid mode');
};
$0df70ca2f445bcbc$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $0df70ca2f445bcbc$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'numeric':
            return $0df70ca2f445bcbc$export$4d318981b5a83836;
        case 'alphanumeric':
            return $0df70ca2f445bcbc$export$376a9ed239d6c1c8;
        case 'kanji':
            return $0df70ca2f445bcbc$export$a4d452c2363c8e12;
        case 'byte':
            return $0df70ca2f445bcbc$export$8f4bf8f7eb581284;
        default:
            throw new Error('Unknown mode: ' + string);
    }
}
$0df70ca2f445bcbc$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($0df70ca2f445bcbc$export$1ea939691cdc45b8(value)) return value;
    try {
        return $0df70ca2f445bcbc$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $61f705a7651e739b$var$G18 = 7973;
const $61f705a7651e739b$var$G18_BCH = $5b0c59df01b43f2a$export$ed1d66da50968976($61f705a7651e739b$var$G18);
function $61f705a7651e739b$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $61f705a7651e739b$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $61f705a7651e739b$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $0df70ca2f445bcbc$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $61f705a7651e739b$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $61f705a7651e739b$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $61f705a7651e739b$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $61f705a7651e739b$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $61f705a7651e739b$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $0df70ca2f445bcbc$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$61f705a7651e739b$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($198479146e7a84c0$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$61f705a7651e739b$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$198479146e7a84c0$export$1ea939691cdc45b8(version)) throw new Error('Invalid QR Code version');
    // Use Byte mode as default
    if (typeof mode === 'undefined') mode = $0df70ca2f445bcbc$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $5b0c59df01b43f2a$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $bf85a70c3520684b$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $0df70ca2f445bcbc$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $61f705a7651e739b$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $0df70ca2f445bcbc$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $0df70ca2f445bcbc$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $0df70ca2f445bcbc$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $0df70ca2f445bcbc$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$61f705a7651e739b$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $c34382e7df2b82b7$export$6788812c4e6611e6(errorCorrectionLevel, $c34382e7df2b82b7$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $61f705a7651e739b$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $61f705a7651e739b$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$61f705a7651e739b$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$198479146e7a84c0$export$1ea939691cdc45b8(version) || version < 7) throw new Error('Invalid QR Code version');
    let d = version << 12;
    while($5b0c59df01b43f2a$export$ed1d66da50968976(d) - $61f705a7651e739b$var$G18_BCH >= 0)d ^= $61f705a7651e739b$var$G18 << $5b0c59df01b43f2a$export$ed1d66da50968976(d) - $61f705a7651e739b$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $3aec4e4c6688f29d$export$eee5438974ef6f0e;

const $3aec4e4c6688f29d$var$G15 = 1335;
const $3aec4e4c6688f29d$var$G15_MASK = 21522;
const $3aec4e4c6688f29d$var$G15_BCH = $5b0c59df01b43f2a$export$ed1d66da50968976($3aec4e4c6688f29d$var$G15);
$3aec4e4c6688f29d$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($5b0c59df01b43f2a$export$ed1d66da50968976(d) - $3aec4e4c6688f29d$var$G15_BCH >= 0)d ^= $3aec4e4c6688f29d$var$G15 << $5b0c59df01b43f2a$export$ed1d66da50968976(d) - $3aec4e4c6688f29d$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $3aec4e4c6688f29d$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $8642d584779057ca$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $8642d584779057ca$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $8642d584779057ca$export$89ab1afb9839589b;

var $34db7bf4b081c663$exports = {};

function $34db7bf4b081c663$var$NumericData(data) {
    this.mode = $0df70ca2f445bcbc$export$4d318981b5a83836;
    this.data = data.toString();
}
$34db7bf4b081c663$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$34db7bf4b081c663$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$34db7bf4b081c663$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $34db7bf4b081c663$var$NumericData.getBitsLength(this.data.length);
};
$34db7bf4b081c663$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$34db7bf4b081c663$exports = $34db7bf4b081c663$var$NumericData;


var $50a03235b07aeccb$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $50a03235b07aeccb$var$ALPHA_NUM_CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function $50a03235b07aeccb$var$AlphanumericData(data) {
    this.mode = $0df70ca2f445bcbc$export$376a9ed239d6c1c8;
    this.data = data;
}
$50a03235b07aeccb$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$50a03235b07aeccb$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$50a03235b07aeccb$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $50a03235b07aeccb$var$AlphanumericData.getBitsLength(this.data.length);
};
$50a03235b07aeccb$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $50a03235b07aeccb$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $50a03235b07aeccb$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($50a03235b07aeccb$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$50a03235b07aeccb$exports = $50a03235b07aeccb$var$AlphanumericData;


var $85f5a1eb5ef10608$exports = {};
var $b44437278ce25062$exports = {};
'use strict';
$b44437278ce25062$exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};



function $85f5a1eb5ef10608$var$ByteData(data) {
    this.mode = $0df70ca2f445bcbc$export$8f4bf8f7eb581284;
    this.data = new Uint8Array($b44437278ce25062$exports(data));
}
$85f5a1eb5ef10608$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$85f5a1eb5ef10608$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$85f5a1eb5ef10608$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $85f5a1eb5ef10608$var$ByteData.getBitsLength(this.data.length);
};
$85f5a1eb5ef10608$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$85f5a1eb5ef10608$exports = $85f5a1eb5ef10608$var$ByteData;


var $ff516ab954caa421$exports = {};


function $ff516ab954caa421$var$KanjiData(data) {
    this.mode = $0df70ca2f445bcbc$export$a4d452c2363c8e12;
    this.data = data;
}
$ff516ab954caa421$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$ff516ab954caa421$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$ff516ab954caa421$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $ff516ab954caa421$var$KanjiData.getBitsLength(this.data.length);
};
$ff516ab954caa421$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $5b0c59df01b43f2a$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error('Invalid SJIS character: ' + this.data[i] + '\n' + 'Make sure your charset is UTF-8');
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$ff516ab954caa421$exports = $ff516ab954caa421$var$KanjiData;




var $e2dbbd98fa4eb0e6$exports = {};
'use strict';
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $e2dbbd98fa4eb0e6$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $e2dbbd98fa4eb0e6$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === 'undefined';
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
            var msg = [
                'Could not find a path from ',
                s,
                ' to ',
                d,
                '.'
            ].join('');
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $e2dbbd98fa4eb0e6$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $e2dbbd98fa4eb0e6$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $e2dbbd98fa4eb0e6$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$e2dbbd98fa4eb0e6$exports = $e2dbbd98fa4eb0e6$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $8642d584779057ca$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $8642d584779057ca$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $8642d584779057ca$var$getSegmentsFromString(dataStr) {
    const numSegs = $8642d584779057ca$var$getSegments($71803ab3889afd57$export$4d318981b5a83836, $0df70ca2f445bcbc$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $8642d584779057ca$var$getSegments($71803ab3889afd57$export$376a9ed239d6c1c8, $0df70ca2f445bcbc$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($5b0c59df01b43f2a$export$ce5b1274f8597fa0()) {
        byteSegs = $8642d584779057ca$var$getSegments($71803ab3889afd57$export$8f4bf8f7eb581284, $0df70ca2f445bcbc$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $8642d584779057ca$var$getSegments($71803ab3889afd57$export$a4d452c2363c8e12, $0df70ca2f445bcbc$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $8642d584779057ca$var$getSegments($71803ab3889afd57$export$9df7c29d562bab83, $0df70ca2f445bcbc$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $8642d584779057ca$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $0df70ca2f445bcbc$export$4d318981b5a83836:
            return $34db7bf4b081c663$exports.getBitsLength(length);
        case $0df70ca2f445bcbc$export$376a9ed239d6c1c8:
            return $50a03235b07aeccb$exports.getBitsLength(length);
        case $0df70ca2f445bcbc$export$a4d452c2363c8e12:
            return $ff516ab954caa421$exports.getBitsLength(length);
        case $0df70ca2f445bcbc$export$8f4bf8f7eb581284:
            return $85f5a1eb5ef10608$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $8642d584779057ca$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $8642d584779057ca$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $0df70ca2f445bcbc$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $0df70ca2f445bcbc$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $0df70ca2f445bcbc$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $0df70ca2f445bcbc$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $0df70ca2f445bcbc$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $0df70ca2f445bcbc$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $0df70ca2f445bcbc$export$8f4bf8f7eb581284,
                        length: $8642d584779057ca$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $0df70ca2f445bcbc$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $0df70ca2f445bcbc$export$8f4bf8f7eb581284,
                        length: $8642d584779057ca$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $8642d584779057ca$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        'start'
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = '' + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $8642d584779057ca$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $8642d584779057ca$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $8642d584779057ca$var$getSegmentBitsLength(node.length, node.mode) + 4 + $0df70ca2f445bcbc$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $8642d584779057ca$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $0df70ca2f445bcbc$export$1bd4c93ffb42e55e(data);
    mode = $0df70ca2f445bcbc$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $0df70ca2f445bcbc$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + ' cannot be encoded with mode ' + $0df70ca2f445bcbc$export$f84e8e69fd4488a5(mode) + '.\n Suggested mode is: ' + $0df70ca2f445bcbc$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $0df70ca2f445bcbc$export$a4d452c2363c8e12 && !$5b0c59df01b43f2a$export$ce5b1274f8597fa0()) mode = $0df70ca2f445bcbc$export$8f4bf8f7eb581284;
    switch(mode){
        case $0df70ca2f445bcbc$export$4d318981b5a83836:
            return new $34db7bf4b081c663$exports(data);
        case $0df70ca2f445bcbc$export$376a9ed239d6c1c8:
            return new $50a03235b07aeccb$exports(data);
        case $0df70ca2f445bcbc$export$a4d452c2363c8e12:
            return new $ff516ab954caa421$exports(data);
        case $0df70ca2f445bcbc$export$8f4bf8f7eb581284:
            return new $85f5a1eb5ef10608$exports(data);
    }
}
$8642d584779057ca$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === 'string') acc.push($8642d584779057ca$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($8642d584779057ca$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$8642d584779057ca$export$3004f64547af360e = function fromString(data, version) {
    const segs = $8642d584779057ca$var$getSegmentsFromString(data, $5b0c59df01b43f2a$export$ce5b1274f8597fa0());
    const nodes = $8642d584779057ca$var$buildNodes(segs);
    const graph = $8642d584779057ca$var$buildGraph(nodes, version);
    const path = $e2dbbd98fa4eb0e6$exports.find_path(graph.map, 'start', 'end');
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $8642d584779057ca$export$571d59b505e6bb4e($8642d584779057ca$var$mergeSegments(optimizedSegs));
};
$8642d584779057ca$export$89ab1afb9839589b = function rawSplit(data) {
    return $8642d584779057ca$export$571d59b505e6bb4e($8642d584779057ca$var$getSegmentsFromString(data, $5b0c59df01b43f2a$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $94167ac37b7f79b3$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $0fd8ebc9602ffc6e$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $94167ac37b7f79b3$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $94167ac37b7f79b3$var$setupAlignmentPattern(matrix, version) {
    const pos = $76cfc0b8ef1e9dce$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $94167ac37b7f79b3$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $61f705a7651e739b$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $94167ac37b7f79b3$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $3aec4e4c6688f29d$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $94167ac37b7f79b3$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $94167ac37b7f79b3$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $ca7263ebfa1cedab$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $0df70ca2f445bcbc$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $5b0c59df01b43f2a$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $bf85a70c3520684b$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $94167ac37b7f79b3$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $94167ac37b7f79b3$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $5b0c59df01b43f2a$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $bf85a70c3520684b$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $bf85a70c3520684b$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $f10603a5ff8ac6ca$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $94167ac37b7f79b3$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $8642d584779057ca$export$571d59b505e6bb4e(data);
    else if (typeof data === 'string') {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $8642d584779057ca$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $61f705a7651e739b$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $8642d584779057ca$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error('Invalid data');
    // Get the min version that can contain data
    const bestVersion = $61f705a7651e739b$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error('The amount of data is too big to be stored in a QR Code');
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + '.\n');
    const dataBits = $94167ac37b7f79b3$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $5b0c59df01b43f2a$export$8d4a06d3facd414b(version);
    const modules = new $8eaf2105cd306f1b$exports(moduleCount);
    // Add function modules
    $94167ac37b7f79b3$var$setupFinderPattern(modules, version);
    $94167ac37b7f79b3$var$setupTimingPattern(modules);
    $94167ac37b7f79b3$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $94167ac37b7f79b3$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $94167ac37b7f79b3$var$setupVersionInfo(modules, version);
    // Add data codewords
    $94167ac37b7f79b3$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $f92c8a242c5c64e1$export$fe9625aaceb0e563(modules, $94167ac37b7f79b3$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $f92c8a242c5c64e1$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $94167ac37b7f79b3$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$94167ac37b7f79b3$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === 'undefined' || data === '') throw new Error('No input text');
    let errorCorrectionLevel = $c34382e7df2b82b7$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel = $c34382e7df2b82b7$export$6788812c4e6611e6(options.errorCorrectionLevel, $c34382e7df2b82b7$export$3a1a48c8f6ef640e);
        version = $61f705a7651e739b$export$6788812c4e6611e6(options.version);
        mask = $f92c8a242c5c64e1$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $5b0c59df01b43f2a$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $94167ac37b7f79b3$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $c8e4b6ff318e3e20$export$b3890eb0ae9dca99;
var $c8e4b6ff318e3e20$export$c3e5526bbaf70a25;
var $18f1da16f85e30a6$export$d2312e68e1f5ad00;
var $18f1da16f85e30a6$export$5cdac61cf538712e;
var $18f1da16f85e30a6$export$c3a1a1f268a8142b;
var $18f1da16f85e30a6$export$83136f57c739c5f3;
function $18f1da16f85e30a6$var$hex2rgba(hex) {
    if (typeof hex === 'number') hex = hex.toString();
    if (typeof hex !== 'string') throw new Error('Color should be defined as hex string');
    let hexCode = hex.slice().replace('#', '').split('');
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error('Invalid hex color: ' + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push('F', 'F');
    const hexValue = parseInt(hexCode.join(''), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
    };
}
$18f1da16f85e30a6$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === 'undefined' || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $18f1da16f85e30a6$var$hex2rgba(options.color.dark || '#000000ff'),
            light: $18f1da16f85e30a6$var$hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$18f1da16f85e30a6$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$18f1da16f85e30a6$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $18f1da16f85e30a6$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$18f1da16f85e30a6$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $18f1da16f85e30a6$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $c8e4b6ff318e3e20$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + 'px';
    canvas.style.width = size + 'px';
}
function $c8e4b6ff318e3e20$var$getCanvasElement() {
    try {
        return document.createElement('canvas');
    } catch (e) {
        throw new Error('You need to specify a canvas element');
    }
}
$c8e4b6ff318e3e20$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $c8e4b6ff318e3e20$var$getCanvasElement();
    opts = $18f1da16f85e30a6$export$d2312e68e1f5ad00(opts);
    const size = $18f1da16f85e30a6$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext('2d');
    const image = ctx.createImageData(size, size);
    $18f1da16f85e30a6$export$83136f57c739c5f3(image.data, qrData, opts);
    $c8e4b6ff318e3e20$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$c8e4b6ff318e3e20$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $c8e4b6ff318e3e20$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || 'image/png';
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $542c9476da8a3ec4$export$b3890eb0ae9dca99;

function $542c9476da8a3ec4$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $542c9476da8a3ec4$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== 'undefined') str += ' ' + y;
    return str;
}
function $542c9476da8a3ec4$var$qrToPath(data, size, margin) {
    let path = '';
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $542c9476da8a3ec4$var$svgCmd('M', col + margin, 0.5 + row + margin) : $542c9476da8a3ec4$var$svgCmd('m', moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $542c9476da8a3ec4$var$svgCmd('h', lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$542c9476da8a3ec4$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $18f1da16f85e30a6$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? '' : '<path ' + $542c9476da8a3ec4$var$getColorAttrib(opts.color.light, 'fill') + ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';
    const path = '<path ' + $542c9476da8a3ec4$var$getColorAttrib(opts.color.dark, 'stroke') + ' d="' + $542c9476da8a3ec4$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + ' ' + qrcodesize + '"';
    const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';
    if (typeof cb === 'function') cb(null, svgTag);
    return svgTag;
};


function $2846b526ff7f0b00$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === 'function';
    if (!isLastArgCb && !$d5f77c3f2f2a50aa$exports()) throw new Error('Callback required as last argument');
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error('Too few arguments provided');
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === 'undefined') {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error('Too few arguments provided');
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $94167ac37b7f79b3$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $94167ac37b7f79b3$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$2846b526ff7f0b00$export$185802fd694ee1f5 = $94167ac37b7f79b3$export$185802fd694ee1f5;
$2846b526ff7f0b00$export$f87f6982d1fd4f81 = $2846b526ff7f0b00$var$renderCanvas.bind(null, $c8e4b6ff318e3e20$export$b3890eb0ae9dca99);
$2846b526ff7f0b00$export$723e4939e5a27c8 = $2846b526ff7f0b00$var$renderCanvas.bind(null, $c8e4b6ff318e3e20$export$c3e5526bbaf70a25);
$2846b526ff7f0b00$export$f84e8e69fd4488a5 = $2846b526ff7f0b00$var$renderCanvas.bind(null, function(data, _, opts) {
    return $542c9476da8a3ec4$export$b3890eb0ae9dca99(data, opts);
});



var $6aRB8 = parcelRequire("6aRB8");








var $6aRB8 = parcelRequire("6aRB8");




const $336f3e1cc67cb9a3$export$c92b4b399eea902a = (route)=>route === 'signIn' || route === 'signUp';
/**
 * Checks if challenge is OTP
 * @param challengeName - The challenge name (e.g., 'EMAIL_OTP', 'SMS_MFA')
 * @returns true if challenge is OTP
 */ const $336f3e1cc67cb9a3$export$47b54750cef40500 = (challengeName)=>!!challengeName && (challengeName === 'EMAIL_OTP' || challengeName === 'SMS_MFA');


const { getConfirmText: $034adca86c0bc29a$var$getConfirmText, getConfirmingText: $034adca86c0bc29a$var$getConfirmingText, getBackToSignInText: $034adca86c0bc29a$var$getBackToSignInText, getResendCodeText: $034adca86c0bc29a$var$getResendCodeText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
const $034adca86c0bc29a$export$76e9c0cec6811ff4 = ()=>{
    const { isPending: isPending, toSignIn: toSignIn, challengeName: challengeName, resendCode: resendCode, selectedAuthMethod: selectedAuthMethod, availableAuthMethods: availableAuthMethods } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.toSignIn,
            context.challengeName,
            context.resendCode,
            context.selectedAuthMethod,
            context.availableAuthMethods
        ]);
    // Only show "Resend Code" for passwordless (USER_AUTH) flows.
    // Password-based sign-in does not support resending MFA codes.
    const hasPasswordlessMethod = !!selectedAuthMethod && selectedAuthMethod !== 'PASSWORD' || !!availableAuthMethods?.some((m)=>m !== 'PASSWORD');
    const showResendCode = (0, $336f3e1cc67cb9a3$export$47b54750cef40500)(challengeName) && hasPasswordlessMethod && resendCode;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        isDisabled: isPending,
        type: "submit",
        variation: "primary",
        isLoading: isPending,
        loadingText: $034adca86c0bc29a$var$getConfirmingText()
    }, $034adca86c0bc29a$var$getConfirmText()), showResendCode && (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        onClick: resendCode,
        type: "button"
    }, $034adca86c0bc29a$var$getResendCodeText()), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        onClick: toSignIn,
        type: "button",
        variation: "link",
        size: "small"
    }, $034adca86c0bc29a$var$getBackToSignInText()));
};





const $6ed580a08d24e40d$var$logger = new (0, $294c375a4ec5088f$export$ba6a9c7ac8291f7f)('SetupTotp-logger');
const { getSetupTotpText: $6ed580a08d24e40d$var$getSetupTotpText, getCopiedText: $6ed580a08d24e40d$var$getCopiedText, getLoadingText: $6ed580a08d24e40d$var$getLoadingText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
const $6ed580a08d24e40d$export$1f819652bce2948d = ({ className: className, variation: variation })=>{
    const { totpSecretCode: totpSecretCode, isPending: isPending, username: username, QRFields: QRFields } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.totpSecretCode,
            context.username
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $81db2db49ed132c1$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    SetupTotp: { Header: Header = $6ed580a08d24e40d$export$1f819652bce2948d.Header, Footer: Footer = $6ed580a08d24e40d$export$1f819652bce2948d.Footer } } } = (0, $dd10c02aadfdf910$export$b0e9d19f717d0a5c)();
    const [isLoading, setIsLoading] = $6aRB8.useState(true);
    const [qrCode, setQrCode] = $6aRB8.useState();
    const [copyTextLabel, setCopyTextLabel] = $6aRB8.useState('COPY');
    const { totpIssuer: totpIssuer = 'AWSCognito', totpUsername: totpUsername = username } = QRFields ?? {};
    const generateQRCode = $6aRB8.useCallback(async ()=>{
        try {
            const totpCode = (0, $ff807ec90f5c0ad3$export$f1f323074be5cac0)(totpIssuer, totpUsername, totpSecretCode);
            const qrCodeImageSource = await (0, (/*@__PURE__*/$parcel$interopDefault($2846b526ff7f0b00$exports))).toDataURL(totpCode);
            setQrCode(qrCodeImageSource);
        } catch (error) {
            $6ed580a08d24e40d$var$logger.error(error);
        } finally{
            setIsLoading(false);
        }
    }, [
        totpIssuer,
        totpUsername,
        totpSecretCode
    ]);
    $6aRB8.useEffect(()=>{
        if (!qrCode) generateQRCode();
    }, [
        generateQRCode,
        qrCode
    ]);
    const copyText = ()=>{
        navigator.clipboard.writeText(totpSecretCode);
        setCopyTextLabel($6ed580a08d24e40d$var$getCopiedText());
    };
    return $6aRB8.createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, $6aRB8.createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-setup-totp": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, $6aRB8.createElement(Header, null), $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column"
    }, isLoading ? $6aRB8.createElement("p", null, $6ed580a08d24e40d$var$getLoadingText(), "\u2026") : $6aRB8.createElement("img", {
        "data-amplify-qrcode": true,
        src: qrCode,
        alt: "qr code",
        width: "228",
        height: "228"
    }), $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        "data-amplify-copy": true
    }, $6aRB8.createElement("div", null, totpSecretCode), $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        "data-amplify-copy-svg": true,
        onClick: copyText
    }, $6aRB8.createElement("div", {
        "data-amplify-copy-tooltip": true
    }, copyTextLabel), $6aRB8.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, $6aRB8.createElement("path", {
        d: "M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5H8C6.9 5 6.01 5.9 6.01 7L6 21C6 22.1 6.89 23 7.99 23H19C20.1 23 21 22.1 21 21V11L15 5ZM8 21V7H14V12H19V21H8Z"
    })))), $6aRB8.createElement((0, $08fc83614da0644b$export$125d0b248abd3e88), null), $6aRB8.createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null)), $6aRB8.createElement((0, $034adca86c0bc29a$export$76e9c0cec6811ff4), null), $6aRB8.createElement(Footer, null))));
};
$6ed580a08d24e40d$export$1f819652bce2948d.Header = function Header() {
    return $6aRB8.createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 3
    }, $6ed580a08d24e40d$var$getSetupTotpText());
};
$6ed580a08d24e40d$export$1f819652bce2948d.Footer = function Footer() {
    // @ts-ignore
    return null;
};








var $6aRB8 = parcelRequire("6aRB8");



var $6aRB8 = parcelRequire("6aRB8");


var $6aRB8 = parcelRequire("6aRB8");




var $6aRB8 = parcelRequire("6aRB8");
const $c88a7a5dbb2c41de$export$cfa7aa87c26e7d1f = $6aRB8.createContext({
    groupId: '',
    activeTab: '',
    setActiveTab: ()=>{}
});


/* WHITESPACE_VALUE is used to fill whitespace present in user-inputed `value` when creating id for TabsItem and TabsPanel */ const $f05287e7fc887c70$export$51117d20e964020b = '-';


const $4b93fa9ebbbdcedd$var$TabsItemPrimitive = ({ className: className, value: value, children: children, onClick: onClick, as: as = 'button', role: role = 'tab', ...rest }, ref)=>{
    const { activeTab: activeTab, setActiveTab: setActiveTab, groupId: groupId } = $6aRB8.useContext((0, $c88a7a5dbb2c41de$export$cfa7aa87c26e7d1f));
    let idValue = value;
    if (typeof idValue === 'string') idValue = idValue.replace(' ', (0, $f05287e7fc887c70$export$51117d20e964020b));
    const isActive = activeTab === value;
    const handleOnClick = (e)=>{
        if ((0, $fd30e9352c42562e$export$f6e2535fb5126e54)(onClick)) onClick?.(e);
        setActiveTab(value);
    };
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        ...rest,
        role: role,
        as: as,
        id: `${groupId}-tab-${idValue}`,
        "aria-selected": isActive,
        "aria-controls": `${groupId}-panel-${idValue}`,
        tabIndex: !isActive ? -1 : undefined,
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).TabsItem, (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).TabsItem, 'active', activeTab === value), className),
        ref: ref,
        onClick: handleOnClick
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $4b93fa9ebbbdcedd$export$6d702cd3660ac20b = (0, $268f040634758fba$export$44aa160b17c73194)($4b93fa9ebbbdcedd$var$TabsItemPrimitive);
$4b93fa9ebbbdcedd$export$6d702cd3660ac20b.displayName = 'Tabs.Item';



var $6aRB8 = parcelRequire("6aRB8");




const $a12f5e4ed840ea51$var$isValidTab = (child)=>$6aRB8.isValidElement(child);
const $a12f5e4ed840ea51$var$TabListPrimitive = ({ className: className, children: children, indicatorPosition: indicatorPosition, spacing: spacing, role: role = 'tablist', ...rest }, ref)=>{
    const internalRef = $6aRB8.useRef(null);
    const { activeTab: activeTab, setActiveTab: setActiveTab } = $6aRB8.useContext((0, $c88a7a5dbb2c41de$export$cfa7aa87c26e7d1f));
    $6aRB8.useImperativeHandle(ref, ()=>internalRef.current);
    const values = $6aRB8.useMemo(()=>$6aRB8.Children.toArray(children).map((child)=>{
            if (child && $a12f5e4ed840ea51$var$isValidTab(child)) return child.props.value;
        }).filter((child)=>!!child), [
        children
    ]);
    const currentIndex = values.indexOf(activeTab);
    const nextTab = $6aRB8.useCallback(()=>{
        let nextIndex = currentIndex === values.length - 1 ? 0 : currentIndex + 1;
        const elems = internalRef.current?.querySelectorAll('button') ?? [];
        while(elems[nextIndex].disabled)if (nextIndex === values.length - 1) nextIndex = 0;
        else nextIndex++;
        const value = values[nextIndex];
        if (value) {
            setActiveTab(value);
            const elem = elems[nextIndex];
            elem?.focus();
            elem?.click();
        }
    }, [
        currentIndex,
        setActiveTab,
        values
    ]);
    const prevTab = $6aRB8.useCallback(()=>{
        let prevIndex = currentIndex === 0 ? values.length - 1 : currentIndex - 1;
        const elems = internalRef.current?.querySelectorAll('button') ?? [];
        while(elems[prevIndex].disabled)if (prevIndex === 0) prevIndex = values.length - 1;
        else prevIndex--;
        const value = values[prevIndex];
        if (value) {
            setActiveTab(value);
            const elem = elems[prevIndex];
            elem?.focus();
            elem?.click();
        }
    }, [
        currentIndex,
        setActiveTab,
        values
    ]);
    const onKeyDown = $6aRB8.useCallback((event)=>{
        switch(event.key){
            case 'ArrowLeft':
                event.preventDefault();
                event.stopPropagation();
                prevTab();
                break;
            case 'ArrowUp':
            case 'ArrowRight':
                event.preventDefault();
                event.stopPropagation();
                nextTab();
                break;
        }
    }, [
        prevTab,
        nextTab
    ]);
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        ...rest,
        role: role,
        onKeyDown: onKeyDown,
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).TabsList, indicatorPosition ? (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).TabsList, indicatorPosition) : null, spacing ? (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).TabsList, spacing) : null, className),
        ref: internalRef
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $a12f5e4ed840ea51$export$e51a686c67fdaa2d = (0, $268f040634758fba$export$44aa160b17c73194)($a12f5e4ed840ea51$var$TabListPrimitive);
$a12f5e4ed840ea51$export$e51a686c67fdaa2d.displayName = 'Tabs.List';



var $6aRB8 = parcelRequire("6aRB8");





const $6a596fe81a83b6d7$var$TabPanelPrimitive = ({ className: className, value: value, children: children, role: role = 'tabpanel', ...rest }, ref)=>{
    const { activeTab: activeTab, isLazy: isLazy, groupId: groupId } = $6aRB8.useContext((0, $c88a7a5dbb2c41de$export$cfa7aa87c26e7d1f));
    if (isLazy && activeTab !== value) return null;
    let idValue = value;
    if (typeof idValue === 'string') idValue = idValue.replace(' ', (0, $f05287e7fc887c70$export$51117d20e964020b));
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        ...rest,
        role: role,
        id: `${groupId}-panel-${idValue}`,
        "aria-labelledby": `${groupId}-tab-${idValue}`,
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).TabsPanel, (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).TabsPanel, 'active', activeTab === value), className),
        ref: ref
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $6a596fe81a83b6d7$export$3d96ec278d3efce4 = (0, $268f040634758fba$export$44aa160b17c73194)($6a596fe81a83b6d7$var$TabPanelPrimitive);
$6a596fe81a83b6d7$export$3d96ec278d3efce4.displayName = 'Tabs.Panel';



var $6aRB8 = parcelRequire("6aRB8");





const $5d9e35c6a0a61164$var$TabsContainerPrimitive = ({ children: children, defaultValue: defaultValue, className: className, value: controlledValue, onValueChange: onValueChange, isLazy: isLazy, ...rest }, ref)=>{
    const groupId = (0, $3e17f7da06cdef50$export$5c0b1cf3fea224ac)(); // groupId is used to ensure uniqueness between Tab Groups in IDs
    const isControlled = controlledValue !== undefined;
    const [localValue, setLocalValue] = $6aRB8.useState(()=>isControlled ? controlledValue : defaultValue);
    const activeTab = isControlled ? controlledValue : localValue ?? '';
    const setActiveTab = $6aRB8.useCallback((newValue)=>{
        if ((0, $fd30e9352c42562e$export$f6e2535fb5126e54)(onValueChange)) onValueChange(newValue);
        if (!isControlled) setLocalValue(newValue);
    }, [
        onValueChange,
        isControlled
    ]);
    const _value = $6aRB8.useMemo(()=>{
        return {
            activeTab: activeTab,
            isLazy: isLazy,
            setActiveTab: setActiveTab,
            groupId: groupId
        };
    }, [
        activeTab,
        setActiveTab,
        isLazy,
        groupId
    ]);
    return $6aRB8.createElement((0, $c88a7a5dbb2c41de$export$cfa7aa87c26e7d1f).Provider, {
        value: _value
    }, $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        ...rest,
        ref: ref,
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)(className, (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Tabs)
    }, children));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $5d9e35c6a0a61164$export$2206531ad8592d57 = (0, $268f040634758fba$export$44aa160b17c73194)($5d9e35c6a0a61164$var$TabsContainerPrimitive);
$5d9e35c6a0a61164$export$2206531ad8592d57.displayName = 'Tabs.Container';


const $2b38c324a4c98bb9$var$TabsPrimitive = ({ items: items, indicatorPosition: indicatorPosition, justifyContent: justifyContent, spacing: spacing, ...rest }, ref)=>{
    return $6aRB8.createElement((0, $5d9e35c6a0a61164$export$2206531ad8592d57), {
        ...rest,
        ref: ref
    }, $6aRB8.createElement((0, $a12f5e4ed840ea51$export$e51a686c67fdaa2d), {
        indicatorPosition: indicatorPosition,
        justifyContent: justifyContent,
        spacing: spacing
    }, items?.map(({ value: value, label: label, content: content, ...rest })=>$6aRB8.createElement((0, $4b93fa9ebbbdcedd$export$6d702cd3660ac20b), {
            ...rest,
            key: value,
            value: value
        }, label))), items?.map(({ value: value, content: content, isDisabled: isDisabled })=>$6aRB8.createElement((0, $6a596fe81a83b6d7$export$3d96ec278d3efce4), {
            key: value,
            value: value,
            isDisabled: isDisabled
        }, content)));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $2b38c324a4c98bb9$export$b2539bed5023c21c = Object.assign((0, $268f040634758fba$export$44aa160b17c73194)($2b38c324a4c98bb9$var$TabsPrimitive), {
    Item: (0, $4b93fa9ebbbdcedd$export$6d702cd3660ac20b),
    List: (0, $a12f5e4ed840ea51$export$e51a686c67fdaa2d),
    Panel: (0, $6a596fe81a83b6d7$export$3d96ec278d3efce4),
    Container: (0, $5d9e35c6a0a61164$export$2206531ad8592d57)
});
$2b38c324a4c98bb9$export$b2539bed5023c21c.displayName = 'Tabs';




var $6aRB8 = parcelRequire("6aRB8");






var $6aRB8 = parcelRequire("6aRB8");
/** Federated IDPs that Authenticator supports */ var $bae9fb78d8635f5d$export$4d240f091c25e146;
(function(FederatedIdentityProviders) {
    FederatedIdentityProviders["Apple"] = "Apple";
    FederatedIdentityProviders["Amazon"] = "Amazon";
    FederatedIdentityProviders["Facebook"] = "Facebook";
    FederatedIdentityProviders["Google"] = "Google";
})($bae9fb78d8635f5d$export$4d240f091c25e146 || ($bae9fb78d8635f5d$export$4d240f091c25e146 = {}));
/**
 * Cognito user contact method types that have not been verified as valid
 */ var $bae9fb78d8635f5d$export$5733d30e1ebcb3c0;
(function(UnverifiedContactMethodType) {
    UnverifiedContactMethodType["Email"] = "email";
    UnverifiedContactMethodType["PhoneNumber"] = "phone_number";
})($bae9fb78d8635f5d$export$5733d30e1ebcb3c0 || ($bae9fb78d8635f5d$export$5733d30e1ebcb3c0 = {}));




var $6aRB8 = parcelRequire("6aRB8");


const $ba6e89ea5bc83e16$var$DividerPrimitive = ({ className: className, orientation: orientation = 'horizontal', size: size, label: label, ...rest }, ref)=>{
    const componentClasses = (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Divider, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Divider, orientation), (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Divider, size), className);
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        "aria-orientation": orientation,
        as: "hr",
        className: componentClasses,
        "data-label": label,
        ref: ref,
        ...rest
    });
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/divider)
 */ const $ba6e89ea5bc83e16$export$2e0a83ec2e27ecbb = (0, $268f040634758fba$export$44aa160b17c73194)($ba6e89ea5bc83e16$var$DividerPrimitive);
$ba6e89ea5bc83e16$export$2e0a83ec2e27ecbb.displayName = 'Divider';





var $6aRB8 = parcelRequire("6aRB8");



var $6aRB8 = parcelRequire("6aRB8");



const $6d1a9cb013dcdca5$var$defaultViewBox = {
    minX: 0,
    minY: 0,
    width: 24,
    height: 24
};
const $6d1a9cb013dcdca5$var$IconPrimitive = ({ className: className, as: // as can be used to render other icon react components too
as = 'svg', fill: fill = 'currentColor', pathData: pathData, viewBox: viewBox = $6d1a9cb013dcdca5$var$defaultViewBox, children: children, paths: paths, ...rest }, ref)=>{
    const minX = viewBox.minX ?? $6d1a9cb013dcdca5$var$defaultViewBox.minX;
    const minY = viewBox.minY ?? $6d1a9cb013dcdca5$var$defaultViewBox.minY;
    const width = viewBox.width ?? $6d1a9cb013dcdca5$var$defaultViewBox.width;
    const height = viewBox.height ?? $6d1a9cb013dcdca5$var$defaultViewBox.height;
    // An icon can be drawn in 3 ways:
    // 1. Pass it children which should be valid SVG elements
    // 2. Pass an array of path-like objects to `paths` prop
    // 3. Supply `pathData` for a simple icons
    let _children;
    if (children) _children = children;
    if (paths) _children = paths.map((path, index)=>$6aRB8.createElement("path", {
            ...path,
            key: index
        }));
    if (pathData) _children = $6aRB8.createElement("path", {
        d: pathData,
        fill: fill
    });
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: as,
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Icon, className),
        ref: ref,
        viewBox: `${minX} ${minY} ${width} ${height}`,
        ...rest
    }, _children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/icon)
 */ const $6d1a9cb013dcdca5$export$f04a61298a47a40f = (0, $268f040634758fba$export$44aa160b17c73194)($6d1a9cb013dcdca5$var$IconPrimitive);
$6d1a9cb013dcdca5$export$f04a61298a47a40f.displayName = 'Icon';






const $6ea4b16798ee1bab$var$AppleIcon = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("svg", {
        "aria-label": "Apple icon",
        className: "amplify-icon federated-sign-in-icon",
        fill: "#000",
        preserveAspectRatio: "xMidYMid",
        stroke: "#000",
        strokeWidth: "0",
        viewBox: "0 0 1024 1024",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("path", {
        d: "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
    }));
};
const $6ea4b16798ee1bab$var$GoogleIcon = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("svg", {
        "aria-label": "Google icon",
        className: "amplify-icon federated-sign-in-icon",
        viewBox: "0 0 256 262",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("path", {
        d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027",
        fill: "#4285F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("path", {
        d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1",
        fill: "#34A853"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("path", {
        d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782",
        fill: "#FBBC05"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("path", {
        d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251",
        fill: "#EB4335"
    }));
};
const $6ea4b16798ee1bab$var$FacebookIcon = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $6d1a9cb013dcdca5$export$f04a61298a47a40f), {
        className: "federated-sign-in-icon",
        ariaLabel: "Facebook icon",
        viewBox: {
            minX: 0,
            minY: 0,
            width: 279,
            height: 538
        },
        pathData: "M82.3409742,538 L82.3409742,292.936652 L0,292.936652 L0,196.990154 L82.2410458,196.990154 L82.2410458,126.4295 C82.2410458,44.575144 132.205229,0 205.252865,0 C240.227794,0 270.306232,2.59855099 279,3.79788222 L279,89.2502322 L228.536175,89.2502322 C188.964542,89.2502322 181.270057,108.139699 181.270057,135.824262 L181.270057,196.89021 L276.202006,196.89021 L263.810888,292.836708 L181.16913,292.836708 L181.16913,538 L82.3409742,538 Z",
        fill: "#1877F2"
    });
};
const $6ea4b16798ee1bab$var$AmazonIcon = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("svg", {
        "aria-label": "Amazon icon",
        className: "amplify-icon federated-sign-in-icon",
        viewBox: "0 0 243 264",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("path", {
        d: "M230.826 208.039C227.468 203.683 208.551 205.982 200.056 206.998C197.471 207.321 197.076 205.042 199.407 203.405C214.475 192.665 239.201 195.766 242.082 199.364C244.966 202.982 241.337 228.071 227.173 240.049C225.001 241.888 222.93 240.904 223.898 238.468C227.077 230.431 234.205 212.419 230.826 208.039ZM123.769 264C71.0234 264 39.0764 241.955 14.7853 217.542C9.97339 212.706 3.71799 206.296 0.311513 200.691C-1.09773 198.372 2.59096 195.022 5.04421 196.844C35.239 219.268 79.1012 239.538 122.53 239.538C151.82 239.538 188.046 227.47 217.669 214.868C222.147 212.966 222.147 219.18 221.512 221.061C221.183 222.032 206.515 236.221 186.247 247.047C167.304 257.166 143.397 264 123.769 264Z",
        fill: "#F2541B"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M142.943 111.185C142.943 124.756 143.268 136.054 136.406 148.123C130.856 157.913 122.027 163.95 112.222 163.95C98.8288 163.95 90.9806 153.772 90.9806 138.693C90.9806 109.036 117.677 103.647 142.943 103.647V111.185ZM178.166 196.081C175.858 198.15 171.635 198.22 169.914 196.894C157.974 187.684 149.89 173.688 149.89 173.688C130.706 193.156 117.127 199 92.2879 199C62.8772 199 40 180.905 40 144.729C40 116.461 55.3552 97.2408 77.2563 87.823C96.2094 79.5256 122.684 78.0173 142.943 75.7517C142.943 75.7517 144.633 53.933 138.699 45.9806C134.098 39.8163 126.272 36.9329 119.089 36.9329C106.127 36.8829 93.61 43.9051 91.1262 57.4188C90.4136 61.2829 87.5533 64.5261 84.54 64.206L51.0823 60.5922C48.5156 60.2951 45.0381 57.6639 45.8636 53.3081C53.644 12.3684 90.7373 0 123.989 0C140.983 0 163.21 4.51651 176.608 17.3349C193.597 33.1648 191.969 54.2755 191.969 77.2722V131.51C191.969 147.835 198.768 154.987 205.151 163.775C207.376 166.953 207.886 170.714 205.04 173.032C197.902 178.999 178.166 196.081 178.166 196.081Z",
        fill: "#F2541B"
    }));
};
const $6ea4b16798ee1bab$export$66f93ed48923765d = (props)=>{
    const { icon: icon, provider: provider, text: text } = props;
    const { toFederatedSignIn: toFederatedSignIn } = (0, $eb4806d462018926$export$2e2bcd8739ae039)();
    const handleClick = (event)=>{
        event.preventDefault();
        toFederatedSignIn({
            provider: provider
        });
    };
    let iconComponent;
    if (icon === 'facebook') iconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($6ea4b16798ee1bab$var$FacebookIcon, null);
    else if (icon === 'google') iconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($6ea4b16798ee1bab$var$GoogleIcon, null);
    else if (icon === 'amazon') iconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($6ea4b16798ee1bab$var$AmazonIcon, null);
    else if (icon === 'apple') iconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement($6ea4b16798ee1bab$var$AppleIcon, null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        onClick: handleClick,
        className: "federated-sign-in-button",
        gap: "1rem"
    }, iconComponent, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $f5124d0fbf86e15e$export$5f1af8db9871e1d6), {
        as: "span"
    }, text));
};


const { getSignInWithFederationText: $c03815e5c5350a29$var$getSignInWithFederationText, getOrText: $c03815e5c5350a29$var$getOrText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
function $c03815e5c5350a29$export$558443b7244c6aa() {
    const { route: route, socialProviders: socialProviders } = (0, $eb4806d462018926$export$2e2bcd8739ae039)(({ route: route, socialProviders: socialProviders })=>[
            route,
            socialProviders
        ]);
    if (socialProviders.length === 0) // @ts-ignore
    return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column",
        padding: `0 0 1rem 0`,
        className: "federated-sign-in-container"
    }, socialProviders.map((provider)=>{
        switch(provider){
            case 'amazon':
                return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $6ea4b16798ee1bab$export$66f93ed48923765d), {
                    icon: "amazon",
                    key: provider,
                    provider: (0, $bae9fb78d8635f5d$export$4d240f091c25e146).Amazon,
                    text: $c03815e5c5350a29$var$getSignInWithFederationText(route, provider)
                });
            case 'apple':
                return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $6ea4b16798ee1bab$export$66f93ed48923765d), {
                    icon: "apple",
                    key: provider,
                    provider: (0, $bae9fb78d8635f5d$export$4d240f091c25e146).Apple,
                    text: $c03815e5c5350a29$var$getSignInWithFederationText(route, provider)
                });
            case 'facebook':
                return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $6ea4b16798ee1bab$export$66f93ed48923765d), {
                    icon: "facebook",
                    key: provider,
                    provider: (0, $bae9fb78d8635f5d$export$4d240f091c25e146).Facebook,
                    text: $c03815e5c5350a29$var$getSignInWithFederationText(route, provider)
                });
            case 'google':
                return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $6ea4b16798ee1bab$export$66f93ed48923765d), {
                    icon: "google",
                    key: provider,
                    provider: (0, $bae9fb78d8635f5d$export$4d240f091c25e146).Google,
                    text: $c03815e5c5350a29$var$getSignInWithFederationText(route, provider)
                });
            default:
                // eslint-disable-next-line no-console
                console.error(`Authenticator does not support ${provider}. Please open an issue: https://github.com/aws-amplify/amplify-ui/issues/choose`);
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $ba6e89ea5bc83e16$export$2e0a83ec2e27ecbb), {
        size: "small",
        label: $c03815e5c5350a29$var$getOrText()
    }));
}







const { getSignInText: $d2dc871459e13db4$var$getSignInText, getSigningInText: $d2dc871459e13db4$var$getSigningInText, getForgotPasswordText: $d2dc871459e13db4$var$getForgotPasswordText, getSignInWithEmailText: $d2dc871459e13db4$var$getSignInWithEmailText, getSignInWithSmsText: $d2dc871459e13db4$var$getSignInWithSmsText, getSignInWithPasskeyText: $d2dc871459e13db4$var$getSignInWithPasskeyText, getOtherSignInOptionsText: $d2dc871459e13db4$var$getOtherSignInOptionsText, getEnterUsernameFirstText: $d2dc871459e13db4$var$getEnterUsernameFirstText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
function $d2dc871459e13db4$export$b64708c6f1b3ed96() {
    const { isPending: isPending, availableAuthMethods: availableAuthMethods, preferredChallenge: preferredChallenge, toShowAuthMethods: toShowAuthMethods } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.availableAuthMethods,
            context.preferredChallenge,
            context.toShowAuthMethods
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $81db2db49ed132c1$export$df6a82844cee724c)();
    const [usernameValue, setUsernameValue] = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useState('');
    const { components: { // @ts-ignore
    SignIn: { Header: Header = $d2dc871459e13db4$export$b64708c6f1b3ed96.Header, Footer: Footer = $d2dc871459e13db4$export$b64708c6f1b3ed96.Footer } } } = (0, $dd10c02aadfdf910$export$b0e9d19f717d0a5c)();
    const hasMultipleMethods = availableAuthMethods && availableAuthMethods.length > 1;
    const showPreferredButton = hasMultipleMethods && preferredChallenge;
    const hasUsername = usernameValue.trim().length > 0;
    const handleFormChange = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useCallback((e)=>{
        const { name: name, value: value } = e.target;
        // Track username for "Other sign-in options" button validation
        if (name === 'username' && typeof value === 'string') setUsernameValue(value);
        handleChange(e);
    }, [
        handleChange
    ]);
    const getPreferredButtonText = ()=>{
        if (!preferredChallenge) return $d2dc871459e13db4$var$getSignInText();
        switch(preferredChallenge){
            case 'EMAIL_OTP':
                return $d2dc871459e13db4$var$getSignInWithEmailText();
            case 'SMS_OTP':
                return $d2dc871459e13db4$var$getSignInWithSmsText();
            case 'WEB_AUTHN':
                return $d2dc871459e13db4$var$getSignInWithPasskeyText();
            case 'PASSWORD':
            default:
                return $d2dc871459e13db4$var$getSignInText();
        }
    };
    const handlePreferredMethodClick = (e)=>{
        e.preventDefault();
        // For passwordless methods, just submit - the actor already knows the preferredChallenge
        handleSubmit(e);
    };
    const handleOtherOptionsClick = (e)=>{
        e.preventDefault();
        toShowAuthMethods();
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), null, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-signin": "",
        method: "post",
        onSubmit: showPreferredButton ? handlePreferredMethodClick : handleSubmit,
        onChange: handleFormChange
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c03815e5c5350a29$export$558443b7244c6aa), null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c954698269074fa8$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("legend", null, $d2dc871459e13db4$var$getSignInText())), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $08fc83614da0644b$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        isDisabled: isPending,
        type: "submit",
        variation: "primary",
        isLoading: isPending,
        loadingText: $d2dc871459e13db4$var$getSigningInText()
    }, showPreferredButton ? getPreferredButtonText() : $d2dc871459e13db4$var$getSignInText()), showPreferredButton && (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        onClick: handleOtherOptionsClick,
        size: "small",
        variation: "link",
        isDisabled: isPending || !hasUsername,
        title: !hasUsername ? $d2dc871459e13db4$var$getEnterUsernameFirstText() : undefined
    }, $d2dc871459e13db4$var$getOtherSignInOptionsText()), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Footer, null))));
}
const $d2dc871459e13db4$var$DefaultFooter = ()=>{
    const { toForgotPassword: toForgotPassword } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.toForgotPassword
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        "data-amplify-footer": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        onClick: toForgotPassword,
        size: "small",
        variation: "link"
    }, $d2dc871459e13db4$var$getForgotPasswordText()));
};
$d2dc871459e13db4$export$b64708c6f1b3ed96.Footer = $d2dc871459e13db4$var$DefaultFooter;
$d2dc871459e13db4$export$b64708c6f1b3ed96.Header = function Header() {
    // @ts-ignore
    return null;
};



var $6aRB8 = parcelRequire("6aRB8");










const { getCreateAccountText: $814e5e9e481a14d4$var$getCreateAccountText, getCreatingAccountText: $814e5e9e481a14d4$var$getCreatingAccountText, getCreateAccountWithEmailText: $814e5e9e481a14d4$var$getCreateAccountWithEmailText, getCreateAccountWithPasswordText: $814e5e9e481a14d4$var$getCreateAccountWithPasswordText, getCreateAccountWithSmsText: $814e5e9e481a14d4$var$getCreateAccountWithSmsText, getOrText: $814e5e9e481a14d4$var$getOrText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
function $814e5e9e481a14d4$export$4ee457d816cea81a() {
    const { hasValidationErrors: hasValidationErrors, isPending: isPending, availableAuthMethods: availableAuthMethods, preferredChallenge: preferredChallenge, selectedAuthMethod: selectedAuthMethod } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.hasValidationErrors,
            context.isPending,
            context.availableAuthMethods,
            context.preferredChallenge,
            context.selectedAuthMethod
        ]);
    const { handleChange: handleChange, handleBlur: handleBlur, handleSubmit: handleSubmit } = (0, $81db2db49ed132c1$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    SignUp: { Header: Header = $814e5e9e481a14d4$export$4ee457d816cea81a.Header, FormFields: FormFields = $814e5e9e481a14d4$export$4ee457d816cea81a.FormFields, Footer: Footer = $814e5e9e481a14d4$export$4ee457d816cea81a.Footer } } } = (0, $dd10c02aadfdf910$export$b0e9d19f717d0a5c)();
    // Filter out WEB_AUTHN for sign-up (passkeys are sign-in only)
    const signUpMethods = availableAuthMethods?.filter((m)=>m !== 'WEB_AUTHN');
    const hasMultipleMethods = signUpMethods && signUpMethods.length > 1;
    // Determine which method to show first
    const primaryMethod = preferredChallenge && preferredChallenge !== 'WEB_AUTHN' ? preferredChallenge : 'PASSWORD';
    // Other methods (excluding primary)
    const otherMethods = signUpMethods?.filter((m)=>m !== primaryMethod) ?? [];
    // Determine if password should be shown
    const effectiveMethod = selectedAuthMethod ?? primaryMethod;
    const isPasswordless = effectiveMethod !== 'PASSWORD';
    const getButtonText = (method)=>{
        switch(method){
            case 'EMAIL_OTP':
                return $814e5e9e481a14d4$var$getCreateAccountWithEmailText();
            case 'SMS_OTP':
                return $814e5e9e481a14d4$var$getCreateAccountWithSmsText();
            case 'PASSWORD':
                return hasMultipleMethods ? $814e5e9e481a14d4$var$getCreateAccountWithPasswordText() : $814e5e9e481a14d4$var$getCreateAccountText();
            default:
                return $814e5e9e481a14d4$var$getCreateAccountText();
        }
    };
    const handleMethodClick = (method)=>(e)=>{
            e.preventDefault();
            const form = e.target.closest('form');
            if (form) {
                // Get or create the hidden input
                if (!form.__authMethod) {
                    const input = document.createElement('input');
                    input.name = '__authMethod';
                    form.appendChild(input);
                }
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                form.__authMethod.type = 'hidden';
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                form.__authMethod.value = method;
                form.requestSubmit();
            }
        };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), null, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-signup": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit,
        onBlur: handleBlur
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c03815e5c5350a29$export$558443b7244c6aa), null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(FormFields, {
        includePassword: !isPasswordless
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null)), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        isDisabled: (!hasMultipleMethods || otherMethods.length == 0) && hasValidationErrors || isPending,
        isFullWidth: true,
        type: "submit",
        variation: "primary",
        isLoading: isPending,
        loadingText: $814e5e9e481a14d4$var$getCreatingAccountText(),
        onClick: handleMethodClick(primaryMethod)
    }, getButtonText(primaryMethod)), hasMultipleMethods && otherMethods.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        justifyContent: "center",
        padding: "medium 0"
    }, $814e5e9e481a14d4$var$getOrText()), otherMethods.map((method)=>(0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
            key: method,
            isDisabled: isPending,
            isFullWidth: true,
            type: "button",
            variation: "primary",
            onClick: handleMethodClick(method)
        }, getButtonText(method)))), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Footer, null))));
}
$814e5e9e481a14d4$export$4ee457d816cea81a.Header = function Header() {
    // @ts-ignore
    return null;
};
$814e5e9e481a14d4$export$4ee457d816cea81a.FormFields = function FormFields$1() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $08fc83614da0644b$export$125d0b248abd3e88), null);
};
$814e5e9e481a14d4$export$4ee457d816cea81a.Footer = function Footer() {
    // @ts-ignore
    return null;
};



const { getSignInTabText: $de5dcf6e69cfa1ec$var$getSignInTabText, getSignUpTabText: $de5dcf6e69cfa1ec$var$getSignUpTabText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
const $de5dcf6e69cfa1ec$export$6815ad73b98d75ed = ({ className: className, hideSignUp: hideSignUp, variation: variation })=>{
    const { route: route, toSignIn: toSignIn, toSignUp: toSignUp } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.route,
            context.toSignIn,
            context.toSignUp
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, hideSignUp ? (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        "data-amplify-router-content": ""
    }, route === 'signIn' && (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $d2dc871459e13db4$export$b64708c6f1b3ed96), null)) : (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $2b38c324a4c98bb9$export$b2539bed5023c21c).Container, {
        value: route,
        isLazy: true,
        onValueChange: (newRoute)=>{
            if (newRoute !== route) newRoute === 'signIn' ? toSignIn() : toSignUp();
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $2b38c324a4c98bb9$export$b2539bed5023c21c).List, {
        spacing: "equal",
        indicatorPosition: "top"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $2b38c324a4c98bb9$export$b2539bed5023c21c).Item, {
        value: "signIn"
    }, $de5dcf6e69cfa1ec$var$getSignInTabText()), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $2b38c324a4c98bb9$export$b2539bed5023c21c).Item, {
        value: "signUp"
    }, $de5dcf6e69cfa1ec$var$getSignUpTabText())), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $2b38c324a4c98bb9$export$b2539bed5023c21c).Panel, {
        value: "signIn",
        "data-amplify-router-content": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $d2dc871459e13db4$export$b64708c6f1b3ed96), null)), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $2b38c324a4c98bb9$export$b2539bed5023c21c).Panel, {
        value: "signUp",
        "data-amplify-router-content": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $814e5e9e481a14d4$export$4ee457d816cea81a), null))));
};



var $6aRB8 = parcelRequire("6aRB8");








var $6aRB8 = parcelRequire("6aRB8");




const { getSubmitText: $76a26686ee3837d0$var$getSubmitText, getSubmittingText: $76a26686ee3837d0$var$getSubmittingText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
const $76a26686ee3837d0$export$8311b872375357fe = (props)=>{
    const { cancelButtonSendType: cancelButtonSendType, cancelButtonText: cancelButtonText, submitButtonText: submitButtonText } = props;
    const { isPending: isPending, resendCode: resendCode, skipVerification: skipVerification, toSignIn: toSignIn } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const onClick = ()=>{
        switch(cancelButtonSendType){
            case 'SKIP':
                skipVerification();
                break;
            case 'RESEND':
                resendCode();
                break;
            case 'SIGN_IN':
                toSignIn();
                break;
            default:
                return;
        }
    };
    const defaultSubmitText = isPending ? (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, $76a26686ee3837d0$var$getSubmittingText(), "\u2026") : (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, $76a26686ee3837d0$var$getSubmitText());
    const submitText = submitButtonText ?? defaultSubmitText;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        variation: "primary",
        isDisabled: isPending,
        type: "submit"
    }, submitText), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column",
        alignItems: "center"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        onClick: onClick,
        type: "button",
        variation: "link",
        size: "small"
    }, cancelButtonText)));
};




const { getAccountRecoveryInfoText: $3e302eb7702ada73$var$getAccountRecoveryInfoText, getSkipText: $3e302eb7702ada73$var$getSkipText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
const $3e302eb7702ada73$export$79a17bba512ce899 = ({ className: className, variation: variation })=>{
    const { isPending: isPending } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $81db2db49ed132c1$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ConfirmVerifyUser: { Header: Header = $3e302eb7702ada73$export$79a17bba512ce899.Header, Footer: Footer = $3e302eb7702ada73$export$79a17bba512ce899.Footer } } } = (0, $dd10c02aadfdf910$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmverifyuser": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $08fc83614da0644b$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $76a26686ee3837d0$export$8311b872375357fe), {
        cancelButtonText: $3e302eb7702ada73$var$getSkipText(),
        cancelButtonSendType: "SKIP"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Footer, null))));
};
$3e302eb7702ada73$export$79a17bba512ce899.Header = function Header() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 3
    }, $3e302eb7702ada73$var$getAccountRecoveryInfoText());
};
$3e302eb7702ada73$export$79a17bba512ce899.Footer = function Footer() {
    return null;
};



var $6aRB8 = parcelRequire("6aRB8");




var $6aRB8 = parcelRequire("6aRB8");





var $6aRB8 = parcelRequire("6aRB8");
const $0206fe58be051086$var$defaultValue = {
    name: 'default'
};
const $0206fe58be051086$export$a79eda4ff50e30b6 = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createContext($0206fe58be051086$var$defaultValue);
const $0206fe58be051086$export$7bea016dc7ad2ddf = ()=>{
    return (0, $6aRB8.useContext)($0206fe58be051086$export$a79eda4ff50e30b6);
};




const $c27be464c54846df$export$d493a8d66e90d1ca = ({ children: children, className: className, id: id, isDisabled: isDisabled = false, testId: testId, value: value, labelPosition: radioLabelPosition, ...rest }, ref)=>{
    const { currentValue: currentValue, defaultValue: defaultValue, name: name, hasError: hasError, isGroupDisabled: isGroupDisabled = false, isRequired: isRequired, isReadOnly: isReadOnly, onChange: onChange, size: size, labelPosition: groupLabelPosition } = (0, $0206fe58be051086$export$7bea016dc7ad2ddf)();
    const { isFieldsetDisabled: shouldBeDisabled } = (0, $503b6352ab4ec9e6$export$b140571ec72925dd)(isGroupDisabled || isDisabled || isReadOnly && defaultValue !== value);
    // for controlled component
    const checked = currentValue !== undefined ? value === currentValue : undefined;
    // for uncontrolled component
    const defaultChecked = defaultValue !== undefined ? value === defaultValue : undefined;
    const labelPosition = radioLabelPosition ?? groupLabelPosition;
    return $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "label",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Radio, (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Radio, `disabled`, shouldBeDisabled), labelPosition ? `amplify-label-${labelPosition}` : null, className)
    }, children && $6aRB8.createElement((0, $f5124d0fbf86e15e$export$5f1af8db9871e1d6), {
        as: "span",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).RadioLabel, (0, $fd30e9352c42562e$export$3c152e7b97c7496c)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).RadioLabel, `disabled`, shouldBeDisabled))
    }, children), $6aRB8.createElement((0, $6c3f8a0f25921fc2$export$f5b8910cec6cf069), {
        checked: checked,
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).VisuallyHidden, (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).RadioInput),
        defaultChecked: defaultChecked,
        hasError: hasError,
        id: id,
        isDisabled: shouldBeDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        onChange: onChange,
        ref: ref,
        type: "radio",
        name: name,
        value: value,
        ...rest
    }), $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        "aria-hidden": "true",
        as: "span",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).RadioButton, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).RadioButton, size)),
        testId: testId
    }));
};
const $c27be464c54846df$export$d7b12c4107be0d61 = (0, $268f040634758fba$export$44aa160b17c73194)($c27be464c54846df$export$d493a8d66e90d1ca);
$c27be464c54846df$export$d7b12c4107be0d61.displayName = 'Radio';



var $6aRB8 = parcelRequire("6aRB8");






var $6aRB8 = parcelRequire("6aRB8");






const $0b7be19953adb320$var$FieldsetPrimitive = ({ children: children, className: className, isDisabled: isDisabled, legend: legend, legendHidden: legendHidden, size: size, testId: testId, variation: variation = 'plain', ...rest }, ref)=>{
    const { isFieldsetDisabled: shouldBeDisabled } = (0, $503b6352ab4ec9e6$export$b140571ec72925dd)(isDisabled);
    // Fieldsets that are nested within a disabled Fieldset should
    // also be disabled.
    const value = $6aRB8.useMemo(()=>({
            isFieldsetDisabled: shouldBeDisabled
        }), [
        shouldBeDisabled
    ]);
    const fieldsetClasses = (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Fieldset, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Fieldset, variation), (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Fieldset, size), className);
    const legendClasses = (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldsetLegend, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).FieldsetLegend, size), {
        [(0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).VisuallyHidden]: legendHidden
    });
    return $6aRB8.createElement((0, $503b6352ab4ec9e6$export$74e4d3bc6dc1117).Provider, {
        value: value
    }, $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "fieldset",
        className: fieldsetClasses,
        ref: ref,
        disabled: shouldBeDisabled,
        testId: testId,
        ...rest
    }, $6aRB8.createElement((0, $c954698269074fa8$export$439d29a4e110a164), {
        as: "legend"
    }, legend), $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: "div",
        "aria-hidden": "true",
        className: legendClasses
    }, legend), children));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/fieldset)
 */ const $0b7be19953adb320$export$e154be390aa0e14 = (0, $268f040634758fba$export$44aa160b17c73194)($0b7be19953adb320$var$FieldsetPrimitive);
$0b7be19953adb320$export$e154be390aa0e14.displayName = 'Fieldset';










const $f8d0d7fdbda8955f$var$RadioGroupFieldPrimitive = ({ children: children, className: className, defaultValue: defaultValue, descriptiveText: descriptiveText, errorMessage: errorMessage, hasError: hasError = false, id: id, isDisabled: isDisabled, isRequired: isRequired, isReadOnly: isReadOnly, legend: legend, legendHidden: legendHidden = false, labelPosition: labelPosition, onChange: onChange, name: name, size: size, testId: testId, value: value, variation: variation, ...rest }, ref)=>{
    const fieldId = (0, $3e17f7da06cdef50$export$5c0b1cf3fea224ac)(id);
    const stableId = (0, $3e17f7da06cdef50$export$5c0b1cf3fea224ac)();
    const descriptionId = descriptiveText ? (0, $5db659a628d34970$export$7a33636e1bc2e96d)(stableId, (0, $8dffbf1516571389$export$20840b8285a9a801)) : undefined;
    const errorId = hasError ? (0, $5db659a628d34970$export$7a33636e1bc2e96d)(stableId, (0, $8dffbf1516571389$export$861adbab90bc3408)) : undefined;
    const ariaDescribedBy = (0, $51a8d22fceaaa8f7$export$e7d3ee79e84cb57)([
        errorId,
        descriptionId
    ]);
    const radioGroupTestId = (0, $5db659a628d34970$export$7a33636e1bc2e96d)(testId, (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).RadioGroup);
    const radioGroupContextValue = $6aRB8.useMemo(()=>({
            currentValue: value,
            defaultValue: defaultValue,
            hasError: hasError,
            isRequired: isRequired,
            isReadOnly: isReadOnly,
            isGroupDisabled: isDisabled,
            onChange: onChange,
            size: size,
            name: name,
            labelPosition: labelPosition
        }), [
        defaultValue,
        hasError,
        isDisabled,
        isRequired,
        isReadOnly,
        onChange,
        size,
        name,
        value,
        labelPosition
    ]);
    return $6aRB8.createElement((0, $0b7be19953adb320$export$e154be390aa0e14), {
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Field, (0, $fd30e9352c42562e$export$1d6fb99b5e148be8)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Field, size), (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).RadioGroupField, className),
        isDisabled: isDisabled,
        legend: legend,
        legendHidden: legendHidden,
        ref: ref,
        role: "radiogroup",
        size: size,
        testId: testId,
        variation: variation,
        ...rest
    }, $6aRB8.createElement((0, $bd2e9207321dbec9$export$873ced4623a3149c), {
        id: descriptionId,
        labelHidden: legendHidden,
        descriptiveText: descriptiveText
    }), $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        "aria-describedby": ariaDescribedBy,
        className: (0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).RadioGroup,
        id: fieldId,
        testId: radioGroupTestId
    }, $6aRB8.createElement((0, $0206fe58be051086$export$a79eda4ff50e30b6).Provider, {
        value: radioGroupContextValue
    }, children)), $6aRB8.createElement((0, $b63758a4e174977f$export$1c081951d49ad6f6), {
        id: errorId,
        hasError: hasError,
        errorMessage: errorMessage
    }));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/radiogroupfield)
 */ const $f8d0d7fdbda8955f$export$a314277471067e8a = (0, $268f040634758fba$export$44aa160b17c73194)($f8d0d7fdbda8955f$var$RadioGroupFieldPrimitive);
$f8d0d7fdbda8955f$export$a314277471067e8a.displayName = 'RadioGroupField';








const { getSkipText: $972ecbb4fee05e47$var$getSkipText, getVerifyText: $972ecbb4fee05e47$var$getVerifyText, getVerifyContactText: $972ecbb4fee05e47$var$getVerifyContactText, getAccountRecoveryInfoText: $972ecbb4fee05e47$var$getAccountRecoveryInfoText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
const $972ecbb4fee05e47$var$generateRadioGroup = (attributes)=>{
    return Object.entries(attributes).map(([key, value], index)=>{
        const verificationType = (0, $4417241f2cb511f3$export$1222d357a3c2c47f)[key].label;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c27be464c54846df$export$d7b12c4107be0d61), {
            name: "unverifiedAttr",
            value: key,
            key: key,
            defaultChecked: index === 0
        }, (0, $94bd8652748873ad$export$d73ee8ef04f5226a)(verificationType), ":", ' ', (0, $ff807ec90f5c0ad3$export$8d414ac4d74b51)(verificationType, value));
    });
};
const $972ecbb4fee05e47$export$da61eb776d8ee98b = ({ className: className, variation: variation })=>{
    const { components: { // @ts-ignore
    VerifyUser: { Header: Header = $972ecbb4fee05e47$export$da61eb776d8ee98b.Header, Footer: Footer = $972ecbb4fee05e47$export$da61eb776d8ee98b.Footer } } } = (0, $dd10c02aadfdf910$export$b0e9d19f717d0a5c)();
    const { isPending: isPending, unverifiedUserAttributes: unverifiedUserAttributes } = (0, $eb4806d462018926$export$2e2bcd8739ae039)(({ isPending: isPending, unverifiedUserAttributes: unverifiedUserAttributes })=>[
            isPending,
            unverifiedUserAttributes
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $81db2db49ed132c1$export$df6a82844cee724c)();
    const footerSubmitText = isPending ? (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, "Verifying\u2026") : (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, $972ecbb4fee05e47$var$getVerifyText());
    const verificationRadioGroup = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $f8d0d7fdbda8955f$export$a314277471067e8a), {
        legend: $972ecbb4fee05e47$var$getVerifyContactText(),
        name: "verify_context",
        isDisabled: isPending,
        legendHidden: true
    }, $972ecbb4fee05e47$var$generateRadioGroup(unverifiedUserAttributes));
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-verifyuser": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Header, null), verificationRadioGroup, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $76a26686ee3837d0$export$8311b872375357fe), {
        cancelButtonText: $972ecbb4fee05e47$var$getSkipText(),
        cancelButtonSendType: "SKIP",
        submitButtonText: footerSubmitText
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Footer, null))));
};
$972ecbb4fee05e47$export$da61eb776d8ee98b.Header = function Header() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 3
    }, $972ecbb4fee05e47$var$getAccountRecoveryInfoText());
};
$972ecbb4fee05e47$export$da61eb776d8ee98b.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $6aRB8 = parcelRequire("6aRB8");












const { getChallengeText: $843ccf4dbd16f0ec$var$getChallengeText, getDeliveryMessageText: $843ccf4dbd16f0ec$var$getDeliveryMessageText, getDeliveryMethodText: $843ccf4dbd16f0ec$var$getDeliveryMethodText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
const $843ccf4dbd16f0ec$export$b8b09b30a5bdd893 = ({ className: className, variation: variation })=>{
    const { isPending: isPending, challengeName: challengeName, codeDeliveryDetails: codeDeliveryDetails } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.challengeName,
            context.codeDeliveryDetails
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $81db2db49ed132c1$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ConfirmSignIn: { Header: Header = $843ccf4dbd16f0ec$export$b8b09b30a5bdd893.Header, Footer: Footer = $843ccf4dbd16f0ec$export$b8b09b30a5bdd893.Footer } } } = (0, $dd10c02aadfdf910$export$b0e9d19f717d0a5c)();
    const showDeliveryMessage = (0, $336f3e1cc67cb9a3$export$47b54750cef40500)(challengeName) && codeDeliveryDetails;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmsignin": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column"
    }, showDeliveryMessage && (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $f5124d0fbf86e15e$export$5f1af8db9871e1d6), {
        className: "amplify-authenticator__subtitle"
    }, $843ccf4dbd16f0ec$var$getDeliveryMessageText(codeDeliveryDetails)), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $08fc83614da0644b$export$125d0b248abd3e88), null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null)), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $034adca86c0bc29a$export$76e9c0cec6811ff4), null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Footer, null))));
};
function $843ccf4dbd16f0ec$var$Header() {
    const { challengeName: challengeName, codeDeliveryDetails: codeDeliveryDetails } = (0, $eb4806d462018926$export$2e2bcd8739ae039)(({ challengeName: challengeName, codeDeliveryDetails: codeDeliveryDetails })=>[
            challengeName,
            codeDeliveryDetails
        ]);
    const showDeliveryMethod = (0, $336f3e1cc67cb9a3$export$47b54750cef40500)(challengeName) && codeDeliveryDetails;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 3
    }, $843ccf4dbd16f0ec$var$getChallengeText(challengeName)), showDeliveryMethod && (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 5
    }, $843ccf4dbd16f0ec$var$getDeliveryMethodText(codeDeliveryDetails)));
}
$843ccf4dbd16f0ec$export$b8b09b30a5bdd893.Header = $843ccf4dbd16f0ec$var$Header;
$843ccf4dbd16f0ec$export$b8b09b30a5bdd893.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $6aRB8 = parcelRequire("6aRB8");










const { getResendCodeText: $e1ef86b6113859bf$var$getResendCodeText, getResetYourPasswordText: $e1ef86b6113859bf$var$getResetYourPasswordText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
const $e1ef86b6113859bf$export$fb3a0d1a16180c0d = ({ className: className, variation: variation })=>{
    const { isPending: isPending } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleBlur: handleBlur, handleChange: handleChange, handleSubmit: handleSubmit } = (0, $81db2db49ed132c1$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ConfirmResetPassword: { Header: Header = $e1ef86b6113859bf$export$fb3a0d1a16180c0d.Header, Footer: Footer = $e1ef86b6113859bf$export$fb3a0d1a16180c0d.Footer } } } = (0, $dd10c02aadfdf910$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmresetpassword": "",
        method: "post",
        onSubmit: handleSubmit,
        onChange: handleChange,
        onBlur: handleBlur
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $08fc83614da0644b$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $76a26686ee3837d0$export$8311b872375357fe), {
        cancelButtonSendType: "RESEND",
        cancelButtonText: $e1ef86b6113859bf$var$getResendCodeText()
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Footer, null))));
};
$e1ef86b6113859bf$export$fb3a0d1a16180c0d.Header = function Header() {
    const headerText = $e1ef86b6113859bf$var$getResetYourPasswordText();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 3
    }, headerText);
};
$e1ef86b6113859bf$export$fb3a0d1a16180c0d.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $6aRB8 = parcelRequire("6aRB8");










const { getBackToSignInText: $3df26cbf8c86378b$var$getBackToSignInText, getSendingText: $3df26cbf8c86378b$var$getSendingText, getSendCodeText: $3df26cbf8c86378b$var$getSendCodeText, getResetYourPasswordText: $3df26cbf8c86378b$var$getResetYourPasswordText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
const $3df26cbf8c86378b$export$b597ee422a3143dc = ({ className: className, variation: variation })=>{
    const { isPending: isPending } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $81db2db49ed132c1$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ForgotPassword: { Header: Header = $3df26cbf8c86378b$export$b597ee422a3143dc.Header, Footer: Footer = $3df26cbf8c86378b$export$b597ee422a3143dc.Footer } } } = (0, $dd10c02aadfdf910$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-forgotpassword": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $08fc83614da0644b$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $76a26686ee3837d0$export$8311b872375357fe), {
        cancelButtonText: $3df26cbf8c86378b$var$getBackToSignInText(),
        cancelButtonSendType: "SIGN_IN",
        submitButtonText: isPending ? (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, $3df26cbf8c86378b$var$getSendingText(), "\u2026") : (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, $3df26cbf8c86378b$var$getSendCodeText())
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Footer, null))));
};
$3df26cbf8c86378b$export$b597ee422a3143dc.Header = function Header() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 3
    }, $3df26cbf8c86378b$var$getResetYourPasswordText());
};
$3df26cbf8c86378b$export$b597ee422a3143dc.Footer = function Footer() {
    // @ts-ignore
    return null;
};




var $6aRB8 = parcelRequire("6aRB8");











const { getMfaTypeLabelByValue: $66dbeda52148feb1$var$getMfaTypeLabelByValue, getSelectMfaTypeByChallengeName: $66dbeda52148feb1$var$getSelectMfaTypeByChallengeName, getSelectMfaTypeText: $66dbeda52148feb1$var$getSelectMfaTypeText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
const $66dbeda52148feb1$export$486f7e37630ecd7e = ({ className: className, variation: variation })=>{
    const { isPending: isPending, allowedMfaTypes: allowedMfaTypes = [] } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>{
        return [
            context.isPending,
            context.allowedMfaTypes
        ];
    });
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $81db2db49ed132c1$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    SelectMfaType: { Header: Header = $66dbeda52148feb1$export$486f7e37630ecd7e.Header, Footer: Footer = $66dbeda52148feb1$export$486f7e37630ecd7e.Footer } } } = (0, $dd10c02aadfdf910$export$b0e9d19f717d0a5c)();
    return $6aRB8.createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, $6aRB8.createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-select-mfa-type": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, $6aRB8.createElement(Header, null), $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column"
    }, $6aRB8.createElement((0, $f8d0d7fdbda8955f$export$a314277471067e8a), {
        name: "mfa_type",
        legend: $66dbeda52148feb1$var$getSelectMfaTypeText(),
        legendHidden: true,
        isDisabled: isPending,
        isRequired: true
    }, allowedMfaTypes.map((value, index)=>$6aRB8.createElement((0, $c27be464c54846df$export$d7b12c4107be0d61), {
            name: "mfa_type",
            key: value,
            value: value,
            defaultChecked: index === 0
        }, $66dbeda52148feb1$var$getMfaTypeLabelByValue(value)))), $6aRB8.createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null)), $6aRB8.createElement((0, $034adca86c0bc29a$export$76e9c0cec6811ff4), null), $6aRB8.createElement(Footer, null))));
};
$66dbeda52148feb1$export$486f7e37630ecd7e.Header = function Header() {
    const { challengeName: challengeName } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>{
        return [
            context.challengeName
        ];
    });
    return $6aRB8.createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 3
    }, $66dbeda52148feb1$var$getSelectMfaTypeByChallengeName(challengeName));
};
$66dbeda52148feb1$export$486f7e37630ecd7e.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $6aRB8 = parcelRequire("6aRB8");










const { getSetupEmailText: $d9589e3f8c485d49$var$getSetupEmailText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
const $d9589e3f8c485d49$export$eccce35586cc0b80 = ({ className: className, variation: variation })=>{
    const { isPending: isPending } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $81db2db49ed132c1$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    SetupEmail: { Header: Header = $d9589e3f8c485d49$export$eccce35586cc0b80.Header, Footer: Footer = $d9589e3f8c485d49$export$eccce35586cc0b80.Footer } } } = (0, $dd10c02aadfdf910$export$b0e9d19f717d0a5c)();
    return $6aRB8.createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, $6aRB8.createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-setup-email": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, $6aRB8.createElement(Header, null), $6aRB8.createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column"
    }, $6aRB8.createElement((0, $08fc83614da0644b$export$125d0b248abd3e88), null), $6aRB8.createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null)), $6aRB8.createElement((0, $034adca86c0bc29a$export$76e9c0cec6811ff4), null), $6aRB8.createElement(Footer, null))));
};
$d9589e3f8c485d49$export$eccce35586cc0b80.Header = function Header() {
    return $6aRB8.createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 3
    }, $d9589e3f8c485d49$var$getSetupEmailText());
};
$d9589e3f8c485d49$export$eccce35586cc0b80.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $6aRB8 = parcelRequire("6aRB8");




































































const { getSignInWithPasswordText: $8960a92b82883b8c$var$getSignInWithPasswordText, getSignInWithEmailText: $8960a92b82883b8c$var$getSignInWithEmailText, getSignInWithSmsText: $8960a92b82883b8c$var$getSignInWithSmsText, getSignInWithPasskeyText: $8960a92b82883b8c$var$getSignInWithPasskeyText, getSigningInText: $8960a92b82883b8c$var$getSigningInText, getBackToSignInText: $8960a92b82883b8c$var$getBackToSignInText, getOrText: $8960a92b82883b8c$var$getOrText, getUsernameLabelByLoginMechanism: $8960a92b82883b8c$var$getUsernameLabelByLoginMechanism } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
const $8960a92b82883b8c$var$getMethodButtonLabel = (method)=>{
    switch(method){
        case 'EMAIL_OTP':
            return $8960a92b82883b8c$var$getSignInWithEmailText();
        case 'SMS_OTP':
            return $8960a92b82883b8c$var$getSignInWithSmsText();
        case 'WEB_AUTHN':
            return $8960a92b82883b8c$var$getSignInWithPasskeyText();
        case 'PASSWORD':
            return $8960a92b82883b8c$var$getSignInWithPasswordText();
        default:
            return $8960a92b82883b8c$var$getSignInWithPasswordText();
    }
};
const $8960a92b82883b8c$export$73f8c7ce6dfe5a1 = ({ className: className, variation: variation })=>{
    const { isPending: isPending, username: username, availableAuthMethods: availableAuthMethods, toSignIn: toSignIn, selectAuthMethod: selectAuthMethod, loginMechanism: loginMechanism } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.username,
            context.availableAuthMethods,
            context.toSignIn,
            context.selectAuthMethod,
            context.loginMechanism
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $81db2db49ed132c1$export$df6a82844cee724c)();
    const methods = availableAuthMethods ?? [];
    const hasPassword = methods.includes('PASSWORD');
    const passwordlessMethods = methods.filter((m)=>m !== 'PASSWORD');
    const handleMethodSelect = (method)=>{
        selectAuthMethod({
            method: method
        });
    };
    const usernameLabel = $8960a92b82883b8c$var$getUsernameLabelByLoginMechanism(loginMechanism);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("form", {
        "data-amplify-form": true,
        "data-amplify-authenticator-signinselect": true,
        method: "post",
        onSubmit: handleSubmit,
        onChange: handleChange
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $6b33a825af028c52$export$2c73285ae9390cec), {
        label: usernameLabel,
        name: "username",
        value: username,
        isReadOnly: true,
        isDisabled: true
    }), hasPassword && (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $7e9c2d18364420fb$export$65ed9482db2257fa), {
        label: "Password",
        name: "password",
        autoComplete: "current-password",
        isDisabled: isPending
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        isDisabled: isPending,
        type: "submit",
        variation: "primary",
        isFullWidth: true,
        isLoading: isPending,
        loadingText: $8960a92b82883b8c$var$getSigningInText()
    }, $8960a92b82883b8c$var$getSignInWithPasswordText())), hasPassword && passwordlessMethods.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $ba6e89ea5bc83e16$export$2e0a83ec2e27ecbb), {
        label: $8960a92b82883b8c$var$getOrText()
    }), passwordlessMethods.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column",
        gap: "0.5rem"
    }, passwordlessMethods.map((method)=>(0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
            key: method,
            variation: "primary",
            isFullWidth: true,
            isDisabled: isPending,
            onClick: ()=>handleMethodSelect(method)
        }, $8960a92b82883b8c$var$getMethodButtonLabel(method)))), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        onClick: toSignIn,
        size: "small",
        variation: "link",
        isDisabled: isPending
    }, $8960a92b82883b8c$var$getBackToSignInText()))));
};



var $6aRB8 = parcelRequire("6aRB8");












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handle Passkey Registration Errors
 * https://w3c.github.io/webauthn/#sctn-create-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const $abc3a6105181b191$export$7460eb590a766e24 = (err)=>{
    if (err instanceof (0, $6d90af1ed0fee71a$export$bf0fd5fd31fb5a90)) return err;
    if (err instanceof Error) {
        // Duplicate Passkey
        if (err.name === 'InvalidStateError') {
            const { message: message, recoverySuggestion: recoverySuggestion } = (0, $6d90af1ed0fee71a$export$e6bc9bceb73ec912)[(0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).PasskeyAlreadyExists];
            return new (0, $6d90af1ed0fee71a$export$bf0fd5fd31fb5a90)({
                name: (0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).PasskeyAlreadyExists,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
        // User Cancels Ceremony / Generic Catch All
        if (err.name === 'NotAllowedError') {
            const { message: message, recoverySuggestion: recoverySuggestion } = (0, $6d90af1ed0fee71a$export$e6bc9bceb73ec912)[(0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).PasskeyRegistrationCanceled];
            return new (0, $6d90af1ed0fee71a$export$bf0fd5fd31fb5a90)({
                name: (0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).PasskeyRegistrationCanceled,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return (0, $38408e1587f58920$export$4792b205fc9bc457)(err);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Registers a new passkey for user
 * @param input - PasskeyCreateOptionsJson
 * @returns serialized PasskeyCreateResult
 */ const $e11c82f055e5f579$export$f3196ed212209546 = async (input)=>{
    try {
        const isPasskeySupported = (0, $931296c4087014b2$export$3b0e0bb0e9c22c1a)();
        (0, $6d90af1ed0fee71a$export$3145abf24cf8a54e)(isPasskeySupported, (0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).PasskeyNotSupported);
        const passkeyCreationOptions = (0, $53d455558e1abd24$export$a8f43933ee13e976)(input);
        const credential = await navigator.credentials.create({
            publicKey: passkeyCreationOptions
        });
        (0, $409463b9ba1ec40e$export$c7806094d9c936a2)(credential);
        return (0, $53d455558e1abd24$export$f686d838e2fa9da3)(credential);
    } catch (err) {
        throw (0, $abc3a6105181b191$export$7460eb590a766e24)(err);
    }
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $d8e092e31f9f43cc$export$34962d73a9c20c0f(credentialCreationOptions) {
    (0, $6d90af1ed0fee71a$export$3145abf24cf8a54e)([
        !!credentialCreationOptions,
        !!credentialCreationOptions?.challenge,
        !!credentialCreationOptions?.user,
        !!credentialCreationOptions?.rp,
        !!credentialCreationOptions?.pubKeyCredParams
    ].every(Boolean), (0, $6d90af1ed0fee71a$export$8c9a5e3ce7fcf74e).InvalidPasskeyRegistrationOptions);
}
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e8e23cefbe1e1a1f$export$b0508eb84e65d978 = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('StartWebAuthnRegistration'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $cf98af692332db23$export$7843c60f6919628b = (config)=>(0, $d542fb085dbe76dd$export$880429a8ae983d4d)((0, $95cac467723af41c$export$10f11e95d7a96f7b), (0, $6e0e8649366ba8a6$export$1113413e6e842bef)('CompleteWebAuthnRegistration'), (0, $8d8d97398d8cb87c$export$8159795418a3e796)(), {
        ...(0, $ee4971f4008297c5$export$22a3716e7860147a),
        ...config
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Registers a new passkey for an authenticated user
 *
 * @returns Promise<void>
 * @throws - {@link PasskeyError}:
 * - Thrown when intermediate state is invalid
 * @throws - {@link AuthError}:
 * - Thrown when user is unauthenticated
 * @throws - {@link StartWebAuthnRegistrationException}
 * - Thrown due to a service error retrieving WebAuthn registration options
 * @throws - {@link CompleteWebAuthnRegistrationException}
 * - Thrown due to a service error when verifying WebAuthn registration result
 */ async function $e63af43449ad2533$export$43d8cd80709f4234() {
    const authConfig = (0, $4e3539eda5094cb7$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $5c85900a0ff57646$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = authConfig;
    const { tokens: tokens } = await (0, $586898866ba92b93$export$39430dfe49142ae)();
    (0, $6cdbc20a8ad3ee2e$export$77712ea5882cac9f)(tokens);
    const startWebAuthnRegistration = (0, $e8e23cefbe1e1a1f$export$b0508eb84e65d978)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { CredentialCreationOptions: credentialCreationOptions } = await startWebAuthnRegistration({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).StartWebAuthnRegistration)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    (0, $d8e092e31f9f43cc$export$34962d73a9c20c0f)(credentialCreationOptions);
    const cred = await (0, $e11c82f055e5f579$export$f3196ed212209546)(credentialCreationOptions);
    const completeWebAuthnRegistration = (0, $cf98af692332db23$export$7843c60f6919628b)({
        endpointResolver: (0, $7668796e368c8896$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    await completeWebAuthnRegistration({
        region: (0, $26bed30b682a3f10$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $75eb6b3cd47d0a94$export$d6cd780379f37dae)((0, $c2cf6542a631fa20$export$900b1436d7e65f4).CompleteWebAuthnRegistration)
    }, {
        AccessToken: tokens.accessToken.toString(),
        Credential: cred
    });
}












var $6aRB8 = parcelRequire("6aRB8");


/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $25b9ad3298c6e5b5$export$6110139047cb4244 = (props)=>{
    const { className: className, ...rest } = props;
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $6aRB8.createElement("svg", {
        width: "54",
        height: "54",
        viewBox: "0 0 54 54",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $6aRB8.createElement("path", {
        d: "M22.9333 38.9333L41.7333 20.1333L38 16.4L22.9333 31.4667L15.3333 23.8667L11.6 27.6L22.9333 38.9333ZM26.6667 53.3333C22.9778 53.3333 19.5111 52.6333 16.2667 51.2333C13.0222 49.8333 10.2 47.9333 7.8 45.5333C5.4 43.1333 3.5 40.3111 2.1 37.0667C0.7 33.8222 0 30.3556 0 26.6667C0 22.9778 0.7 19.5111 2.1 16.2667C3.5 13.0222 5.4 10.2 7.8 7.8C10.2 5.4 13.0222 3.5 16.2667 2.1C19.5111 0.7 22.9778 0 26.6667 0C30.3556 0 33.8222 0.7 37.0667 2.1C40.3111 3.5 43.1333 5.4 45.5333 7.8C47.9333 10.2 49.8333 13.0222 51.2333 16.2667C52.6333 19.5111 53.3333 22.9778 53.3333 26.6667C53.3333 30.3556 52.6333 33.8222 51.2333 37.0667C49.8333 40.3111 47.9333 43.1333 45.5333 45.5333C43.1333 47.9333 40.3111 49.8333 37.0667 51.2333C33.8222 52.6333 30.3556 53.3333 26.6667 53.3333Z",
        fill: "currentColor"
    })));
};




var $6aRB8 = parcelRequire("6aRB8");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $456301e595ed193a$export$54553b80df2557dd = (props)=>{
    const { className: className, ...rest } = props;
    return $6aRB8.createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $ee1340d798dd5e54$export$ce4ab0c55987d1ff)((0, $22bf574a47253734$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $6aRB8.createElement("svg", {
        width: "195",
        height: "128",
        viewBox: "0 0 195 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $6aRB8.createElement("circle", {
        cx: "60",
        cy: "36",
        r: "31",
        stroke: "#00404D",
        strokeWidth: "2"
    }), $6aRB8.createElement("path", {
        d: "M60 69C84.4313 69 105.396 83.8504 114.357 105.021C116.774 110.729 115.382 116.168 111.798 120.23C108.191 124.319 102.358 127 96 127H24C17.6416 127 11.8094 124.319 8.20215 120.23C4.61836 116.168 3.22626 110.729 5.64258 105.021C14.6036 83.8504 35.5687 69 60 69Z",
        stroke: "#00404D",
        strokeWidth: "2"
    }), $6aRB8.createElement("circle", {
        cx: "122",
        cy: "26",
        r: "25",
        fill: "#E9F9FC",
        stroke: "#00404D",
        strokeWidth: "2"
    }), $6aRB8.createElement("mask", {
        id: "path-4-inside-1_4178_10171",
        fill: "white"
    }, $6aRB8.createElement("path", {
        d: "M121.951 13.927C124.887 13.927 127.658 14.5348 130.262 15.7503C132.866 16.9658 135.04 18.7222 136.786 21.0197C136.98 21.2601 137.042 21.4738 136.973 21.6608C136.903 21.8478 136.786 22.0081 136.619 22.1417C136.453 22.2753 136.259 22.3354 136.038 22.322C135.816 22.3086 135.622 22.1951 135.456 21.9814C133.932 19.8977 131.972 18.3015 129.576 17.1928C127.18 16.0842 124.638 15.5299 121.951 15.5299C119.264 15.5299 116.743 16.0842 114.388 17.1928C112.034 18.3015 110.081 19.8977 108.529 21.9814C108.363 22.2218 108.169 22.3554 107.947 22.3821C107.726 22.4088 107.532 22.3554 107.366 22.2218C107.172 22.0883 107.054 21.9213 107.012 21.7209C106.971 21.5206 107.033 21.3135 107.199 21.0998C108.917 18.8291 111.071 17.066 113.661 15.8104C116.251 14.5548 119.015 13.927 121.951 13.927ZM121.951 17.6937C125.691 17.6937 128.904 18.8959 131.591 21.3002C134.279 23.7045 135.622 26.6831 135.622 30.2361C135.622 31.5719 135.13 32.6872 134.147 33.5821C133.164 34.477 131.965 34.9245 130.553 34.9245C129.14 34.9245 127.928 34.477 126.917 33.5821C125.906 32.6872 125.4 31.5719 125.4 30.2361C125.4 29.3546 125.061 28.6132 124.382 28.0122C123.703 27.4111 122.893 27.1106 121.951 27.1106C121.009 27.1106 120.199 27.4111 119.52 28.0122C118.841 28.6132 118.502 29.3546 118.502 30.2361C118.502 32.8274 119.299 34.9913 120.891 36.7277C122.484 38.4642 124.541 39.6797 127.062 40.3742C127.311 40.4544 127.478 40.588 127.561 40.775C127.644 40.962 127.658 41.1623 127.602 41.376C127.547 41.563 127.436 41.7233 127.27 41.8569C127.104 41.9905 126.896 42.0305 126.647 41.9771C123.766 41.2825 121.411 39.9001 119.582 37.8297C117.754 35.7593 116.84 33.2281 116.84 30.2361C116.84 28.9004 117.339 27.7784 118.336 26.8701C119.333 25.9618 120.538 25.5077 121.951 25.5077C123.364 25.5077 124.569 25.9618 125.566 26.8701C126.563 27.7784 127.062 28.9004 127.062 30.2361C127.062 31.1177 127.408 31.859 128.101 32.4601C128.794 33.0612 129.611 33.3617 130.553 33.3617C131.495 33.3617 132.298 33.0612 132.963 32.4601C133.628 31.859 133.96 31.1177 133.96 30.2361C133.96 27.1373 132.783 24.5326 130.428 22.4222C128.073 20.3117 125.261 19.2565 121.993 19.2565C118.724 19.2565 115.912 20.3117 113.557 22.4222C111.202 24.5326 110.025 27.1239 110.025 30.1961C110.025 30.8372 110.087 31.6386 110.212 32.6004C110.337 33.5621 110.635 34.6841 111.106 35.9664C111.189 36.2068 111.182 36.4205 111.085 36.6075C110.988 36.7945 110.828 36.9281 110.607 37.0082C110.385 37.0884 110.171 37.0817 109.963 36.9882C109.755 36.8947 109.61 36.7411 109.526 36.5274C109.111 35.4855 108.813 34.4503 108.633 33.4218C108.453 32.3933 108.363 31.3314 108.363 30.2361C108.363 26.6831 109.7 23.7045 112.373 21.3002C115.046 18.8959 118.239 17.6937 121.951 17.6937ZM121.951 10C123.724 10 125.455 10.207 127.145 10.6211C128.835 11.0352 130.47 11.6296 132.049 12.4043C132.298 12.5379 132.443 12.6982 132.485 12.8852C132.526 13.0722 132.506 13.2592 132.423 13.4462C132.339 13.6332 132.201 13.7801 132.007 13.8869C131.813 13.9938 131.578 13.9804 131.301 13.8469C129.832 13.1256 128.316 12.5713 126.75 12.1839C125.185 11.7965 123.585 11.6029 121.951 11.6029C120.344 11.6029 118.765 11.7832 117.214 12.1438C115.663 12.5045 114.18 13.0722 112.768 13.8469C112.546 13.9804 112.324 14.0138 112.103 13.947C111.881 13.8803 111.715 13.74 111.604 13.5263C111.493 13.3126 111.466 13.1189 111.521 12.9453C111.576 12.7716 111.715 12.618 111.937 12.4844C113.488 11.683 115.109 11.0686 116.798 10.6411C118.488 10.2137 120.206 10 121.951 10ZM121.951 21.5807C124.527 21.5807 126.744 22.4155 128.6 24.0852C130.456 25.7548 131.384 27.8051 131.384 30.2361C131.384 30.4766 131.308 30.6702 131.155 30.8172C131.003 30.9641 130.802 31.0376 130.553 31.0376C130.331 31.0376 130.137 30.9641 129.971 30.8172C129.805 30.6702 129.722 30.4766 129.722 30.2361C129.722 28.2326 128.953 26.5562 127.415 25.2072C125.878 23.8581 124.056 23.1835 121.951 23.1835C119.846 23.1835 118.038 23.8581 116.528 25.2072C115.018 26.5562 114.264 28.2326 114.264 30.2361C114.264 32.4 114.651 34.2366 115.427 35.746C116.203 37.2553 117.339 38.7714 118.834 40.2941C119.001 40.4544 119.084 40.6414 119.084 40.8551C119.084 41.0688 119.001 41.2558 118.834 41.4161C118.668 41.5764 118.474 41.6565 118.253 41.6565C118.031 41.6565 117.837 41.5764 117.671 41.4161C116.037 39.7598 114.783 38.0701 113.91 36.347C113.038 34.624 112.601 32.587 112.601 30.2361C112.601 27.8051 113.516 25.7548 115.344 24.0852C117.172 22.4155 119.375 21.5807 121.951 21.5807ZM121.909 29.4347C122.159 29.4347 122.36 29.5148 122.512 29.6751C122.664 29.8354 122.741 30.0224 122.741 30.2361C122.741 32.2397 123.488 33.8826 124.984 35.1649C126.48 36.4472 128.226 37.0884 130.22 37.0884C130.386 37.0884 130.622 37.075 130.927 37.0483C131.231 37.0216 131.55 36.9815 131.882 36.9281C132.132 36.8747 132.346 36.9081 132.526 37.0283C132.706 37.1485 132.824 37.3288 132.88 37.5692C132.935 37.7829 132.893 37.9699 132.755 38.1302C132.616 38.2905 132.436 38.3974 132.215 38.4508C131.716 38.5844 131.28 38.6578 130.906 38.6712C130.532 38.6846 130.303 38.6912 130.22 38.6912C127.755 38.6912 125.615 37.8898 123.8 36.2869C121.986 34.6841 121.078 32.6671 121.078 30.2361C121.078 30.0224 121.155 29.8354 121.307 29.6751C121.459 29.5148 121.66 29.4347 121.909 29.4347Z"
    })), $6aRB8.createElement("path", {
        d: "M121.951 13.927C124.887 13.927 127.658 14.5348 130.262 15.7503C132.866 16.9658 135.04 18.7222 136.786 21.0197C136.98 21.2601 137.042 21.4738 136.973 21.6608C136.903 21.8478 136.786 22.0081 136.619 22.1417C136.453 22.2753 136.259 22.3354 136.038 22.322C135.816 22.3086 135.622 22.1951 135.456 21.9814C133.932 19.8977 131.972 18.3015 129.576 17.1928C127.18 16.0842 124.638 15.5299 121.951 15.5299C119.264 15.5299 116.743 16.0842 114.388 17.1928C112.034 18.3015 110.081 19.8977 108.529 21.9814C108.363 22.2218 108.169 22.3554 107.947 22.3821C107.726 22.4088 107.532 22.3554 107.366 22.2218C107.172 22.0883 107.054 21.9213 107.012 21.7209C106.971 21.5206 107.033 21.3135 107.199 21.0998C108.917 18.8291 111.071 17.066 113.661 15.8104C116.251 14.5548 119.015 13.927 121.951 13.927ZM121.951 17.6937C125.691 17.6937 128.904 18.8959 131.591 21.3002C134.279 23.7045 135.622 26.6831 135.622 30.2361C135.622 31.5719 135.13 32.6872 134.147 33.5821C133.164 34.477 131.965 34.9245 130.553 34.9245C129.14 34.9245 127.928 34.477 126.917 33.5821C125.906 32.6872 125.4 31.5719 125.4 30.2361C125.4 29.3546 125.061 28.6132 124.382 28.0122C123.703 27.4111 122.893 27.1106 121.951 27.1106C121.009 27.1106 120.199 27.4111 119.52 28.0122C118.841 28.6132 118.502 29.3546 118.502 30.2361C118.502 32.8274 119.299 34.9913 120.891 36.7277C122.484 38.4642 124.541 39.6797 127.062 40.3742C127.311 40.4544 127.478 40.588 127.561 40.775C127.644 40.962 127.658 41.1623 127.602 41.376C127.547 41.563 127.436 41.7233 127.27 41.8569C127.104 41.9905 126.896 42.0305 126.647 41.9771C123.766 41.2825 121.411 39.9001 119.582 37.8297C117.754 35.7593 116.84 33.2281 116.84 30.2361C116.84 28.9004 117.339 27.7784 118.336 26.8701C119.333 25.9618 120.538 25.5077 121.951 25.5077C123.364 25.5077 124.569 25.9618 125.566 26.8701C126.563 27.7784 127.062 28.9004 127.062 30.2361C127.062 31.1177 127.408 31.859 128.101 32.4601C128.794 33.0612 129.611 33.3617 130.553 33.3617C131.495 33.3617 132.298 33.0612 132.963 32.4601C133.628 31.859 133.96 31.1177 133.96 30.2361C133.96 27.1373 132.783 24.5326 130.428 22.4222C128.073 20.3117 125.261 19.2565 121.993 19.2565C118.724 19.2565 115.912 20.3117 113.557 22.4222C111.202 24.5326 110.025 27.1239 110.025 30.1961C110.025 30.8372 110.087 31.6386 110.212 32.6004C110.337 33.5621 110.635 34.6841 111.106 35.9664C111.189 36.2068 111.182 36.4205 111.085 36.6075C110.988 36.7945 110.828 36.9281 110.607 37.0082C110.385 37.0884 110.171 37.0817 109.963 36.9882C109.755 36.8947 109.61 36.7411 109.526 36.5274C109.111 35.4855 108.813 34.4503 108.633 33.4218C108.453 32.3933 108.363 31.3314 108.363 30.2361C108.363 26.6831 109.7 23.7045 112.373 21.3002C115.046 18.8959 118.239 17.6937 121.951 17.6937ZM121.951 10C123.724 10 125.455 10.207 127.145 10.6211C128.835 11.0352 130.47 11.6296 132.049 12.4043C132.298 12.5379 132.443 12.6982 132.485 12.8852C132.526 13.0722 132.506 13.2592 132.423 13.4462C132.339 13.6332 132.201 13.7801 132.007 13.8869C131.813 13.9938 131.578 13.9804 131.301 13.8469C129.832 13.1256 128.316 12.5713 126.75 12.1839C125.185 11.7965 123.585 11.6029 121.951 11.6029C120.344 11.6029 118.765 11.7832 117.214 12.1438C115.663 12.5045 114.18 13.0722 112.768 13.8469C112.546 13.9804 112.324 14.0138 112.103 13.947C111.881 13.8803 111.715 13.74 111.604 13.5263C111.493 13.3126 111.466 13.1189 111.521 12.9453C111.576 12.7716 111.715 12.618 111.937 12.4844C113.488 11.683 115.109 11.0686 116.798 10.6411C118.488 10.2137 120.206 10 121.951 10ZM121.951 21.5807C124.527 21.5807 126.744 22.4155 128.6 24.0852C130.456 25.7548 131.384 27.8051 131.384 30.2361C131.384 30.4766 131.308 30.6702 131.155 30.8172C131.003 30.9641 130.802 31.0376 130.553 31.0376C130.331 31.0376 130.137 30.9641 129.971 30.8172C129.805 30.6702 129.722 30.4766 129.722 30.2361C129.722 28.2326 128.953 26.5562 127.415 25.2072C125.878 23.8581 124.056 23.1835 121.951 23.1835C119.846 23.1835 118.038 23.8581 116.528 25.2072C115.018 26.5562 114.264 28.2326 114.264 30.2361C114.264 32.4 114.651 34.2366 115.427 35.746C116.203 37.2553 117.339 38.7714 118.834 40.2941C119.001 40.4544 119.084 40.6414 119.084 40.8551C119.084 41.0688 119.001 41.2558 118.834 41.4161C118.668 41.5764 118.474 41.6565 118.253 41.6565C118.031 41.6565 117.837 41.5764 117.671 41.4161C116.037 39.7598 114.783 38.0701 113.91 36.347C113.038 34.624 112.601 32.587 112.601 30.2361C112.601 27.8051 113.516 25.7548 115.344 24.0852C117.172 22.4155 119.375 21.5807 121.951 21.5807ZM121.909 29.4347C122.159 29.4347 122.36 29.5148 122.512 29.6751C122.664 29.8354 122.741 30.0224 122.741 30.2361C122.741 32.2397 123.488 33.8826 124.984 35.1649C126.48 36.4472 128.226 37.0884 130.22 37.0884C130.386 37.0884 130.622 37.075 130.927 37.0483C131.231 37.0216 131.55 36.9815 131.882 36.9281C132.132 36.8747 132.346 36.9081 132.526 37.0283C132.706 37.1485 132.824 37.3288 132.88 37.5692C132.935 37.7829 132.893 37.9699 132.755 38.1302C132.616 38.2905 132.436 38.3974 132.215 38.4508C131.716 38.5844 131.28 38.6578 130.906 38.6712C130.532 38.6846 130.303 38.6912 130.22 38.6912C127.755 38.6912 125.615 37.8898 123.8 36.2869C121.986 34.6841 121.078 32.6671 121.078 30.2361C121.078 30.0224 121.155 29.8354 121.307 29.6751C121.459 29.5148 121.66 29.4347 121.909 29.4347Z",
        fill: "#00404D",
        stroke: "#00404D",
        strokeWidth: "4",
        mask: "url(#path-4-inside-1_4178_10171)"
    }), $6aRB8.createElement("circle", {
        cx: "167.5",
        cy: "49.5",
        r: "19.5",
        fill: "#E9F9FC",
        stroke: "#00404D",
        strokeWidth: "2"
    }), $6aRB8.createElement("path", {
        d: "M167.89 43.65L161.26 54.18H167.89",
        stroke: "#00404D",
        strokeWidth: "2"
    }), $6aRB8.createElement("path", {
        d: "M167.5 60.42C173.316 60.42 178.03 55.7056 178.03 49.89V48.72",
        stroke: "#00404D",
        strokeWidth: "2"
    }), $6aRB8.createElement("circle", {
        cx: "173.74",
        cy: "43.26",
        r: "1",
        fill: "#00404D",
        stroke: "#00404D",
        strokeWidth: "1.12"
    }), $6aRB8.createElement("circle", {
        cx: "160.48",
        cy: "43.26",
        r: "1",
        fill: "#00404D",
        stroke: "#00404D",
        strokeWidth: "1.12"
    }), $6aRB8.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M104 112C116.129 112 126.457 104.288 130.347 93.5H147.5L155.5 101.5L168 89L180.5 101.5L193 89L180.5 76.5H130.984C127.705 64.6779 116.866 56 104 56C88.536 56 76 68.536 76 84C76 99.464 88.536 112 104 112ZM104 98C111.732 98 118 91.732 118 84C118 76.268 111.732 70 104 70C96.268 70 90 76.268 90 84C90 91.732 96.268 98 104 98Z",
        fill: "#BCECF5"
    }), $6aRB8.createElement("path", {
        d: "M130.347 93.5V92.5H129.645L129.407 93.1608L130.347 93.5ZM147.5 93.5L148.207 92.7929L147.914 92.5H147.5V93.5ZM155.5 101.5L154.793 102.207L155.5 102.914L156.207 102.207L155.5 101.5ZM168 89L168.707 88.2929L168 87.5858L167.293 88.2929L168 89ZM180.5 101.5L179.793 102.207L180.5 102.914L181.207 102.207L180.5 101.5ZM193 89L193.707 89.7071L194.414 89L193.707 88.2929L193 89ZM180.5 76.5L181.207 75.7929L180.914 75.5H180.5V76.5ZM130.984 76.5L130.021 76.7673L130.224 77.5H130.984V76.5ZM129.407 93.1608C125.655 103.565 115.694 111 104 111V113C116.564 113 127.259 105.011 131.288 93.8392L129.407 93.1608ZM147.5 92.5H130.347V94.5H147.5V92.5ZM156.207 100.793L148.207 92.7929L146.793 94.2071L154.793 102.207L156.207 100.793ZM167.293 88.2929L154.793 100.793L156.207 102.207L168.707 89.7071L167.293 88.2929ZM181.207 100.793L168.707 88.2929L167.293 89.7071L179.793 102.207L181.207 100.793ZM192.293 88.2929L179.793 100.793L181.207 102.207L193.707 89.7071L192.293 88.2929ZM179.793 77.2071L192.293 89.7071L193.707 88.2929L181.207 75.7929L179.793 77.2071ZM130.984 77.5H180.5V75.5H130.984V77.5ZM104 57C116.405 57 126.859 65.3669 130.021 76.7673L131.948 76.2327C128.552 63.9889 117.327 55 104 55V57ZM77 84C77 69.0883 89.0883 57 104 57V55C87.9837 55 75 67.9837 75 84H77ZM104 111C89.0883 111 77 98.9117 77 84H75C75 100.016 87.9837 113 104 113V111ZM117 84C117 91.1797 111.18 97 104 97V99C112.284 99 119 92.2843 119 84H117ZM104 71C111.18 71 117 76.8203 117 84H119C119 75.7157 112.284 69 104 69V71ZM91 84C91 76.8203 96.8203 71 104 71V69C95.7157 69 89 75.7157 89 84H91ZM104 97C96.8203 97 91 91.1797 91 84H89C89 92.2843 95.7157 99 104 99V97Z",
        fill: "#00404D"
    }), $6aRB8.createElement("path", {
        d: "M138.5 57V66",
        stroke: "#00404D",
        strokeWidth: "2"
    }), $6aRB8.createElement("path", {
        d: "M139 104V124",
        stroke: "#00404D",
        strokeWidth: "2"
    }), $6aRB8.createElement("path", {
        d: "M134 61.5L143 61.5",
        stroke: "#00404D",
        strokeWidth: "2"
    }), $6aRB8.createElement("path", {
        d: "M129 114L149 114",
        stroke: "#00404D",
        strokeWidth: "2"
    })));
};




const { getPasskeyPromptHeadingText: $70d5995815a97460$var$getPasskeyPromptHeadingText, getPasskeyPromptDescriptionText: $70d5995815a97460$var$getPasskeyPromptDescriptionText, getCreatePasskeyText: $70d5995815a97460$var$getCreatePasskeyText, getRegisteringText: $70d5995815a97460$var$getRegisteringText, getContinueWithoutPasskeyText: $70d5995815a97460$var$getContinueWithoutPasskeyText, getPasskeyCreatedSuccessText: $70d5995815a97460$var$getPasskeyCreatedSuccessText, getPasskeyRegisteredText: $70d5995815a97460$var$getPasskeyRegisteredText, getPasskeyRegistrationFailedText: $70d5995815a97460$var$getPasskeyRegistrationFailedText, getPasskeyLabelText: $70d5995815a97460$var$getPasskeyLabelText, getExistingPasskeysText: $70d5995815a97460$var$getExistingPasskeysText, getSetupAnotherPasskeyText: $70d5995815a97460$var$getSetupAnotherPasskeyText, getContinueText: $70d5995815a97460$var$getContinueText } = (0, $120fa0aee8e8ba04$export$34e9c32aebe14fbb);
function $70d5995815a97460$export$9c4e17945f13d789({ className: className, variation: variation }) {
    const [success, setSuccess] = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useState(null);
    const [isRegistering, setIsRegistering] = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useState(false);
    const [credentials, setCredentials] = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useState([]);
    const { submitForm: submitForm, isPending: isPending } = (0, $eb4806d462018926$export$2e2bcd8739ae039)((context)=>[
            context.submitForm,
            context.isPending
        ]);
    const loadCredentials = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useCallback(async ()=>{
        try {
            const result = await (0, $51abed20915325ca$export$91d5486d023a5f8d)();
            setCredentials(result.credentials || []);
        } catch  {
        // Silently fail - credentials list is optional
        }
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useEffect(()=>{
        if (success) loadCredentials();
    }, [
        success,
        loadCredentials
    ]);
    const handleSkip = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useCallback(()=>{
        submitForm({
            type: 'SKIP'
        });
    }, [
        submitForm
    ]);
    const handleContinue = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useCallback(()=>{
        submitForm({
            type: 'SUBMIT'
        });
    }, [
        submitForm
    ]);
    const handleRegister = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useCallback(async ()=>{
        try {
            setError(null);
            setIsRegistering(true);
            await (0, $e63af43449ad2533$export$43d8cd80709f4234)();
            setSuccess(true);
        } catch (err) {
            const error = err;
            const errorName = error.name ?? '';
            const errorMessage = error.message ?? '';
            // If user canceled, skip silently without showing error
            if (errorName === 'PasskeyRegistrationCanceled' || errorName === 'NotAllowedError' || errorMessage.includes('canceled') || errorMessage.includes('cancelled') || errorMessage.includes('ceremony has been canceled') || errorMessage.includes('not allowed')) {
                handleSkip();
                return;
            }
            // Show user-friendly error message
            setError($70d5995815a97460$var$getPasskeyRegistrationFailedText());
        } finally{
            setIsRegistering(false);
        }
    }, [
        handleSkip
    ]);
    if (success) return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column",
        padding: "large",
        "data-amplify-authenticator-passkeyprompt": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column",
        gap: "xs"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $25b9ad3298c6e5b5$export$6110139047cb4244), {
        className: "amplify-authenticator__passkey-success-icon"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 4
    }, $70d5995815a97460$var$getPasskeyCreatedSuccessText()), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $f5124d0fbf86e15e$export$5f1af8db9871e1d6), null, $70d5995815a97460$var$getPasskeyRegisteredText())), credentials.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
        marginTop: "large"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 5
    }, $70d5995815a97460$var$getExistingPasskeysText()), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column",
        gap: "xs",
        marginTop: "xs"
    }, credentials.map((cred, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $417f8d85aef5a23a$export$27a5bd065ad55220), {
            key: cred.credentialId,
            className: "amplify-authenticator__passkey-credential-item"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $f5124d0fbf86e15e$export$5f1af8db9871e1d6), {
            fontSize: "small"
        }, cred.friendlyCredentialName ?? `${$70d5995815a97460$var$getPasskeyLabelText()} ${index + 1}`))))), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column",
        gap: "medium",
        marginTop: "large"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        onClick: ()=>{
            setSuccess(false);
            handleRegister();
        },
        variation: "link"
    }, $70d5995815a97460$var$getSetupAnotherPasskeyText()), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        onClick: ()=>handleContinue(),
        variation: "primary",
        isFullWidth: true
    }, $70d5995815a97460$var$getContinueText()))));
    const isButtonDisabled = isPending || isRegistering;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1e2f313ad0cdbcd6$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-passkeyprompt": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column",
        gap: "medium"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $9bf13500c30f403f$export$a8a3e93435678ff9), {
        level: 4
    }, $70d5995815a97460$var$getPasskeyPromptHeadingText()), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $f5124d0fbf86e15e$export$5f1af8db9871e1d6), null, $70d5995815a97460$var$getPasskeyPromptDescriptionText()), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        justifyContent: "center"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $456301e595ed193a$export$54553b80df2557dd), {
        className: "amplify-authenticator__passkey-icon"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c658dcb0f49b8bb3$export$f51f4c4ede09e011), {
        direction: "column",
        gap: "medium"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        onClick: ()=>void handleRegister(),
        variation: "primary",
        isDisabled: isButtonDisabled,
        isLoading: isRegistering,
        loadingText: $70d5995815a97460$var$getRegisteringText()
    }, $70d5995815a97460$var$getCreatePasskeyText()), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $5360619bdca83541$export$353f5b6fc5456de1), {
        onClick: handleSkip,
        variation: "link",
        isDisabled: isButtonDisabled
    }, $70d5995815a97460$var$getContinueWithoutPasskeyText()), error && (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $f5124d0fbf86e15e$export$5f1af8db9871e1d6), {
        className: "amplify-authenticator__passkey-error"
    }, error), (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $1594b49e029449dc$export$3caa4b6a8cb6c61a), null)))));
}


function $783409d15bebf9fb$var$RenderNothing() {
    // @ts-ignore
    return null;
}
const $783409d15bebf9fb$var$getRouteComponent = (route)=>{
    switch(route){
        case 'authenticated':
        case 'idle':
        case 'setup':
        case 'transition':
            return $783409d15bebf9fb$var$RenderNothing;
        case 'confirmSignUp':
            return 0, $475df2e5a608f400$export$649c708157e61c64;
        case 'confirmSignIn':
            return 0, $843ccf4dbd16f0ec$export$b8b09b30a5bdd893;
        case 'selectMfaType':
            return 0, $66dbeda52148feb1$export$486f7e37630ecd7e;
        case 'setupEmail':
            return 0, $d9589e3f8c485d49$export$eccce35586cc0b80;
        case 'setupTotp':
            return 0, $6ed580a08d24e40d$export$1f819652bce2948d;
        case 'signIn':
        case 'signUp':
            return 0, $de5dcf6e69cfa1ec$export$6815ad73b98d75ed;
        case 'signInSelectAuthFactor':
            return 0, $8960a92b82883b8c$export$73f8c7ce6dfe5a1;
        case 'passkeyPrompt':
            return 0, $70d5995815a97460$export$9c4e17945f13d789;
        case 'forceNewPassword':
            return 0, $20fa237c7c67a7b5$export$b3aae0a112274a60;
        case 'forgotPassword':
            return 0, $3df26cbf8c86378b$export$b597ee422a3143dc;
        case 'confirmResetPassword':
            return 0, $e1ef86b6113859bf$export$fb3a0d1a16180c0d;
        case 'verifyUser':
            return 0, $972ecbb4fee05e47$export$da61eb776d8ee98b;
        case 'confirmVerifyUser':
            return 0, $3e302eb7702ada73$export$79a17bba512ce899;
        default:
            // eslint-disable-next-line no-console
            console.warn(`Unhandled Authenticator route - please open an issue: ${route}`);
            return $783409d15bebf9fb$var$RenderNothing;
    }
};
function $783409d15bebf9fb$export$55185c17a0fcbe46({ className: className, hideSignUp: hideSignUp, variation: variation }) {
    const { route: route } = (0, $eb4806d462018926$export$2e2bcd8739ae039)(({ route: route })=>[
            route
        ]);
    const RouterChildren = (0, $6aRB8.useMemo)(()=>$783409d15bebf9fb$var$getRouteComponent(route), [
        route
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(RouterChildren, {
        className: className,
        // @ts-ignore
        hideSignUp: (0, $336f3e1cc67cb9a3$export$c92b4b399eea902a)(route) ? hideSignUp : undefined,
        variation: variation
    });
}




















const $72a68bc92dbb9d43$export$71abc632aa29e6fe = {
    // @ts-ignore
    Header: ()=>null,
    SignIn: {
        Header: (0, $d2dc871459e13db4$export$b64708c6f1b3ed96).Header,
        Footer: (0, $d2dc871459e13db4$export$b64708c6f1b3ed96).Footer
    },
    SignUp: {
        Header: (0, $814e5e9e481a14d4$export$4ee457d816cea81a).Header,
        FormFields: (0, $814e5e9e481a14d4$export$4ee457d816cea81a).FormFields,
        Footer: (0, $814e5e9e481a14d4$export$4ee457d816cea81a).Footer
    },
    ConfirmSignUp: {
        Header: (0, $475df2e5a608f400$export$649c708157e61c64).Header,
        Footer: (0, $475df2e5a608f400$export$649c708157e61c64).Footer
    },
    SelectMfaType: {
        Header: (0, $66dbeda52148feb1$export$486f7e37630ecd7e).Header,
        Footer: (0, $66dbeda52148feb1$export$486f7e37630ecd7e).Footer
    },
    SetupEmail: {
        Header: (0, $d9589e3f8c485d49$export$eccce35586cc0b80).Header,
        Footer: (0, $d9589e3f8c485d49$export$eccce35586cc0b80).Footer
    },
    SetupTotp: {
        Header: (0, $6ed580a08d24e40d$export$1f819652bce2948d).Header,
        Footer: (0, $6ed580a08d24e40d$export$1f819652bce2948d).Footer
    },
    ConfirmResetPassword: {
        Header: (0, $e1ef86b6113859bf$export$fb3a0d1a16180c0d).Header,
        Footer: (0, $e1ef86b6113859bf$export$fb3a0d1a16180c0d).Footer
    },
    ConfirmSignIn: {
        Header: (0, $843ccf4dbd16f0ec$export$b8b09b30a5bdd893).Header,
        Footer: (0, $843ccf4dbd16f0ec$export$b8b09b30a5bdd893).Footer
    },
    VerifyUser: {
        Header: (0, $972ecbb4fee05e47$export$da61eb776d8ee98b).Header,
        Footer: (0, $972ecbb4fee05e47$export$da61eb776d8ee98b).Footer
    },
    ConfirmVerifyUser: {
        Header: (0, $3e302eb7702ada73$export$79a17bba512ce899).Header,
        // @ts-ignore
        Footer: (0, $3e302eb7702ada73$export$79a17bba512ce899).Footer
    },
    ForceNewPassword: {
        Header: (0, $20fa237c7c67a7b5$export$b3aae0a112274a60).Header,
        Footer: (0, $20fa237c7c67a7b5$export$b3aae0a112274a60).Footer,
        FormFields: (0, $20fa237c7c67a7b5$export$b3aae0a112274a60).FormFields
    },
    ForgotPassword: {
        Header: (0, $3df26cbf8c86378b$export$b597ee422a3143dc).Header,
        Footer: (0, $3df26cbf8c86378b$export$b597ee422a3143dc).Footer
    },
    // @ts-ignore
    Footer: ()=>null
};




// `AuthenticatorInternal` exists to give access to the context returned via `useAuthenticator`,
// which allows the `Authenticator` to just return `children` if a user is authenticated.
// Once the `Provider` is removed from the `Authenticator` component and exported as
// `AuthenticatorProvider`, this component should be renamed to `Authenticator`.
function $abe4b563d6b4dee0$export$213d252991da224({ children: children, className: className, components: customComponents, formFields: formFields, hideSignUp: hideSignUp, initialState: initialState, loginMechanisms: loginMechanisms, passwordSettings: passwordSettings, passwordless: passwordless, signUpAttributes: signUpAttributes, services: services, socialProviders: socialProviders, variation: variation }) {
    (0, $8011ad08ebd75fbc$export$406e4c8585b97b03)({
        message: 'The `passwordSettings` prop has been deprecated and will be removed in a future major version of Amplify UI.',
        // shouldWarn: !!passwordSettings,
        /**
         * @migration turn off until getConfig returns zero config
         */ shouldWarn: false
    });
    const { route: route, signOut: signOut, user: user } = (0, $eb4806d462018926$export$2e2bcd8739ae039)(({ route: route, signOut: signOut, user: user })=>[
            route,
            signOut,
            user
        ]);
    (0, $3a1f3adcb2aef67a$export$2e2bcd8739ae039)({
        initialState: initialState,
        loginMechanisms: loginMechanisms,
        passwordSettings: passwordSettings,
        passwordless: passwordless,
        services: services,
        signUpAttributes: signUpAttributes,
        socialProviders: socialProviders,
        formFields: formFields
    });
    const value = $6aRB8.useMemo(()=>({
            components: {
                ...(0, $72a68bc92dbb9d43$export$71abc632aa29e6fe),
                ...customComponents
            }
        }), [
        customComponents
    ]);
    const isAuthenticatedRoute = route === 'authenticated' || route === 'signOut';
    if (isAuthenticatedRoute) {
        // `Authenticator` might not have user defined `children` for non SPA use cases.
        if (!children) // @ts-ignore
        return null;
        return $6aRB8.createElement($6aRB8.Fragment, null, (0, $fd30e9352c42562e$export$f6e2535fb5126e54)(children) ? children({
            signOut: signOut,
            user: user
        }) // children is a render prop
         : children);
    }
    return $6aRB8.createElement((0, $dd10c02aadfdf910$export$da5ac45a736a5880).Provider, {
        value: value
    }, $6aRB8.createElement((0, $783409d15bebf9fb$export$55185c17a0fcbe46), {
        className: className,
        hideSignUp: hideSignUp,
        variation: variation
    }));
}
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/connected-components/authenticator)
 */ function $abe4b563d6b4dee0$export$3d7a1e8452f884f3(props) {
    (0, $ec85c69bee30366d$export$2e2bcd8739ae039)({
        componentName: 'Authenticator',
        packageName: 'react',
        version: (0, $608fab696bcdaf1b$export$a4ad2735b021c132)
    });
    return $6aRB8.createElement((0, $3ac0cda803dc6fc4$export$2e2bcd8739ae039), null, $6aRB8.createElement($abe4b563d6b4dee0$export$213d252991da224, {
        ...props
    }));
}
$abe4b563d6b4dee0$export$3d7a1e8452f884f3.Provider = (0, $3ac0cda803dc6fc4$export$2e2bcd8739ae039);
$abe4b563d6b4dee0$export$3d7a1e8452f884f3.ForgotPassword = (0, $3df26cbf8c86378b$export$b597ee422a3143dc);
$abe4b563d6b4dee0$export$3d7a1e8452f884f3.SetupTotp = (0, $6ed580a08d24e40d$export$1f819652bce2948d);
$abe4b563d6b4dee0$export$3d7a1e8452f884f3.SignIn = (0, $d2dc871459e13db4$export$b64708c6f1b3ed96);
$abe4b563d6b4dee0$export$3d7a1e8452f884f3.SignUp = (0, $814e5e9e481a14d4$export$4ee457d816cea81a);
$abe4b563d6b4dee0$export$3d7a1e8452f884f3.ForceNewPassword = (0, $20fa237c7c67a7b5$export$b3aae0a112274a60);
$abe4b563d6b4dee0$export$3d7a1e8452f884f3.SelectMfaType = (0, $66dbeda52148feb1$export$486f7e37630ecd7e);
$abe4b563d6b4dee0$export$3d7a1e8452f884f3.SetupEmail = (0, $d9589e3f8c485d49$export$eccce35586cc0b80);


/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/connected-components/authenticator)
 */ function $d02a40f7b0c711be$export$db40a3715ab5b118(Component, options = {}) {
    const { variation: variation = 'modal' } = options;
    return function WrappedWithAuthenticator(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $abe4b563d6b4dee0$export$3d7a1e8452f884f3), {
            variation: variation,
            ...options
        }, (withAuthenticatorProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(Component, {
                ...props,
                ...withAuthenticatorProps
            }));
    };
}





var $6aRB8 = parcelRequire("6aRB8");

const $998b9e4952b694e1$var$AUDIT_APIS_ENDPOINT = "https://73s5496hof.execute-api.us-west-2.amazonaws.com/chad-remote";
async function $998b9e4952b694e1$var$authHeaders() {
    const session = await (0, $586898866ba92b93$export$39430dfe49142ae)();
    return {
        Authorization: session.tokens.idToken.toString()
    };
}
async function $998b9e4952b694e1$var$request(method, path, data) {
    const res = await fetch(`${$998b9e4952b694e1$var$AUDIT_APIS_ENDPOINT}${path}`, {
        method: method,
        headers: {
            "Content-Type": "application/json",
            ...await $998b9e4952b694e1$var$authHeaders()
        },
        body: data != null ? JSON.stringify(data) : undefined
    });
    if (!res.ok) throw new Error(`${method} ${path} failed: ${res.status}`);
    const text = await res.text();
    return text ? JSON.parse(text) : undefined;
}
const $998b9e4952b694e1$export$b216272c8be3751a = (path)=>$998b9e4952b694e1$var$request("GET", path);
const $998b9e4952b694e1$export$bd1dc54ad3b0ef79 = (path, data)=>$998b9e4952b694e1$var$request("POST", path, data);
const $998b9e4952b694e1$export$6dd598fa143977b0 = (path, data)=>$998b9e4952b694e1$var$request("PUT", path, data);
const $998b9e4952b694e1$export$47bb6d36417ecd2e = (path)=>$998b9e4952b694e1$var$request("DELETE", path);



parcelRequire("6aRB8");


var $6aRB8 = parcelRequire("6aRB8");


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $ae95b650a5337ac7$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $ae95b650a5337ac7$export$2e2bcd8739ae039 = $ae95b650a5337ac7$var$apply;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $5ae320c97664ecc7$var$isArray = Array.isArray;
var $5ae320c97664ecc7$export$2e2bcd8739ae039 = $5ae320c97664ecc7$var$isArray;




var $2kosG = parcelRequire("2kosG");
/** Built-in value references. */ var $47aeee022ce46748$var$Symbol = (0, $2kosG.default).Symbol;
var $47aeee022ce46748$export$2e2bcd8739ae039 = $47aeee022ce46748$var$Symbol;



/** Used for built-in method references. */ var $cae3503049cfe734$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cae3503049cfe734$var$hasOwnProperty = $cae3503049cfe734$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cae3503049cfe734$var$nativeObjectToString = $cae3503049cfe734$var$objectProto.toString;
/** Built-in value references. */ var $cae3503049cfe734$var$symToStringTag = (0, $47aeee022ce46748$export$2e2bcd8739ae039) ? (0, $47aeee022ce46748$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $cae3503049cfe734$var$getRawTag(value) {
    var isOwn = $cae3503049cfe734$var$hasOwnProperty.call(value, $cae3503049cfe734$var$symToStringTag), tag = value[$cae3503049cfe734$var$symToStringTag];
    try {
        value[$cae3503049cfe734$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $cae3503049cfe734$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$cae3503049cfe734$var$symToStringTag] = tag;
        else delete value[$cae3503049cfe734$var$symToStringTag];
    }
    return result;
}
var $cae3503049cfe734$export$2e2bcd8739ae039 = $cae3503049cfe734$var$getRawTag;


/** Used for built-in method references. */ var $b7e16ae7dac398f9$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b7e16ae7dac398f9$var$nativeObjectToString = $b7e16ae7dac398f9$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $b7e16ae7dac398f9$var$objectToString(value) {
    return $b7e16ae7dac398f9$var$nativeObjectToString.call(value);
}
var $b7e16ae7dac398f9$export$2e2bcd8739ae039 = $b7e16ae7dac398f9$var$objectToString;


/** `Object#toString` result references. */ var $acaeba78f0dfcb4a$var$nullTag = '[object Null]', $acaeba78f0dfcb4a$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $acaeba78f0dfcb4a$var$symToStringTag = (0, $47aeee022ce46748$export$2e2bcd8739ae039) ? (0, $47aeee022ce46748$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $acaeba78f0dfcb4a$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $acaeba78f0dfcb4a$var$undefinedTag : $acaeba78f0dfcb4a$var$nullTag;
    return $acaeba78f0dfcb4a$var$symToStringTag && $acaeba78f0dfcb4a$var$symToStringTag in Object(value) ? (0, $cae3503049cfe734$export$2e2bcd8739ae039)(value) : (0, $b7e16ae7dac398f9$export$2e2bcd8739ae039)(value);
}
var $acaeba78f0dfcb4a$export$2e2bcd8739ae039 = $acaeba78f0dfcb4a$var$baseGetTag;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ea90ac032deaca1b$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $ea90ac032deaca1b$export$2e2bcd8739ae039 = $ea90ac032deaca1b$var$isObjectLike;


/** `Object#toString` result references. */ var $e38480002ec9114f$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e38480002ec9114f$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $ea90ac032deaca1b$export$2e2bcd8739ae039)(value) && (0, $acaeba78f0dfcb4a$export$2e2bcd8739ae039)(value) == $e38480002ec9114f$var$symbolTag;
}
var $e38480002ec9114f$export$2e2bcd8739ae039 = $e38480002ec9114f$var$isSymbol;


/** Used to match property names within property paths. */ var $fee70519b255a559$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $fee70519b255a559$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $fee70519b255a559$var$isKey(value, object) {
    if ((0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $e38480002ec9114f$export$2e2bcd8739ae039)(value)) return true;
    return $fee70519b255a559$var$reIsPlainProp.test(value) || !$fee70519b255a559$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $fee70519b255a559$export$2e2bcd8739ae039 = $fee70519b255a559$var$isKey;



/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $d9b4f47c9ea17ede$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $d9b4f47c9ea17ede$export$2e2bcd8739ae039 = $d9b4f47c9ea17ede$var$isObject;


/** `Object#toString` result references. */ var $e4f5228c7fe84628$var$asyncTag = '[object AsyncFunction]', $e4f5228c7fe84628$var$funcTag = '[object Function]', $e4f5228c7fe84628$var$genTag = '[object GeneratorFunction]', $e4f5228c7fe84628$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $e4f5228c7fe84628$var$isFunction(value) {
    if (!(0, $d9b4f47c9ea17ede$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $acaeba78f0dfcb4a$export$2e2bcd8739ae039)(value);
    return tag == $e4f5228c7fe84628$var$funcTag || tag == $e4f5228c7fe84628$var$genTag || tag == $e4f5228c7fe84628$var$asyncTag || tag == $e4f5228c7fe84628$var$proxyTag;
}
var $e4f5228c7fe84628$export$2e2bcd8739ae039 = $e4f5228c7fe84628$var$isFunction;



var $2kosG = parcelRequire("2kosG");
/** Used to detect overreaching core-js shims. */ var $b6e2170f617af7de$var$coreJsData = (0, $2kosG.default)['__core-js_shared__'];
var $b6e2170f617af7de$export$2e2bcd8739ae039 = $b6e2170f617af7de$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $10991a1ae46602c0$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $b6e2170f617af7de$export$2e2bcd8739ae039) && (0, $b6e2170f617af7de$export$2e2bcd8739ae039).keys && (0, $b6e2170f617af7de$export$2e2bcd8739ae039).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $10991a1ae46602c0$var$isMasked(func) {
    return !!$10991a1ae46602c0$var$maskSrcKey && $10991a1ae46602c0$var$maskSrcKey in func;
}
var $10991a1ae46602c0$export$2e2bcd8739ae039 = $10991a1ae46602c0$var$isMasked;



/** Used for built-in method references. */ var $14ffe53fa1a07024$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $14ffe53fa1a07024$var$funcToString = $14ffe53fa1a07024$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $14ffe53fa1a07024$var$toSource(func) {
    if (func != null) {
        try {
            return $14ffe53fa1a07024$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $14ffe53fa1a07024$export$2e2bcd8739ae039 = $14ffe53fa1a07024$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $c256b93548e1213e$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $c256b93548e1213e$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $c256b93548e1213e$var$funcProto = Function.prototype, $c256b93548e1213e$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c256b93548e1213e$var$funcToString = $c256b93548e1213e$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c256b93548e1213e$var$hasOwnProperty = $c256b93548e1213e$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $c256b93548e1213e$var$reIsNative = RegExp('^' + $c256b93548e1213e$var$funcToString.call($c256b93548e1213e$var$hasOwnProperty).replace($c256b93548e1213e$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $c256b93548e1213e$var$baseIsNative(value) {
    if (!(0, $d9b4f47c9ea17ede$export$2e2bcd8739ae039)(value) || (0, $10991a1ae46602c0$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $e4f5228c7fe84628$export$2e2bcd8739ae039)(value) ? $c256b93548e1213e$var$reIsNative : $c256b93548e1213e$var$reIsHostCtor;
    return pattern.test((0, $14ffe53fa1a07024$export$2e2bcd8739ae039)(value));
}
var $c256b93548e1213e$export$2e2bcd8739ae039 = $c256b93548e1213e$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $b2c36e7473f815a5$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $b2c36e7473f815a5$export$2e2bcd8739ae039 = $b2c36e7473f815a5$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $52f0708eb8080799$var$getNative(object, key) {
    var value = (0, $b2c36e7473f815a5$export$2e2bcd8739ae039)(object, key);
    return (0, $c256b93548e1213e$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $52f0708eb8080799$export$2e2bcd8739ae039 = $52f0708eb8080799$var$getNative;


/* Built-in method references that are verified to be native. */ var $8d8464a68089520a$var$nativeCreate = (0, $52f0708eb8080799$export$2e2bcd8739ae039)(Object, 'create');
var $8d8464a68089520a$export$2e2bcd8739ae039 = $8d8464a68089520a$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $792efe4e4b04d230$var$hashClear() {
    this.__data__ = (0, $8d8464a68089520a$export$2e2bcd8739ae039) ? (0, $8d8464a68089520a$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $792efe4e4b04d230$export$2e2bcd8739ae039 = $792efe4e4b04d230$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2000463395f529a6$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2000463395f529a6$export$2e2bcd8739ae039 = $2000463395f529a6$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $996597f5ee1d9189$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $996597f5ee1d9189$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $996597f5ee1d9189$var$hasOwnProperty = $996597f5ee1d9189$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $996597f5ee1d9189$var$hashGet(key) {
    var data = this.__data__;
    if (0, $8d8464a68089520a$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $996597f5ee1d9189$var$HASH_UNDEFINED ? undefined : result;
    }
    return $996597f5ee1d9189$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $996597f5ee1d9189$export$2e2bcd8739ae039 = $996597f5ee1d9189$var$hashGet;



/** Used for built-in method references. */ var $d2c6785e0c7bc33d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d2c6785e0c7bc33d$var$hasOwnProperty = $d2c6785e0c7bc33d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d2c6785e0c7bc33d$var$hashHas(key) {
    var data = this.__data__;
    return (0, $8d8464a68089520a$export$2e2bcd8739ae039) ? data[key] !== undefined : $d2c6785e0c7bc33d$var$hasOwnProperty.call(data, key);
}
var $d2c6785e0c7bc33d$export$2e2bcd8739ae039 = $d2c6785e0c7bc33d$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $7e2e2b9034d31ce8$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7e2e2b9034d31ce8$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $8d8464a68089520a$export$2e2bcd8739ae039) && value === undefined ? $7e2e2b9034d31ce8$var$HASH_UNDEFINED : value;
    return this;
}
var $7e2e2b9034d31ce8$export$2e2bcd8739ae039 = $7e2e2b9034d31ce8$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $557a0364372f9806$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$557a0364372f9806$var$Hash.prototype.clear = (0, $792efe4e4b04d230$export$2e2bcd8739ae039);
$557a0364372f9806$var$Hash.prototype['delete'] = (0, $2000463395f529a6$export$2e2bcd8739ae039);
$557a0364372f9806$var$Hash.prototype.get = (0, $996597f5ee1d9189$export$2e2bcd8739ae039);
$557a0364372f9806$var$Hash.prototype.has = (0, $d2c6785e0c7bc33d$export$2e2bcd8739ae039);
$557a0364372f9806$var$Hash.prototype.set = (0, $7e2e2b9034d31ce8$export$2e2bcd8739ae039);
var $557a0364372f9806$export$2e2bcd8739ae039 = $557a0364372f9806$var$Hash;


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $ff59fb5721e5e71c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $ff59fb5721e5e71c$export$2e2bcd8739ae039 = $ff59fb5721e5e71c$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $1ade0d9409bf4c31$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $1ade0d9409bf4c31$export$2e2bcd8739ae039 = $1ade0d9409bf4c31$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6ab284dcd30c85cb$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $1ade0d9409bf4c31$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $6ab284dcd30c85cb$export$2e2bcd8739ae039 = $6ab284dcd30c85cb$var$assocIndexOf;


/** Used for built-in method references. */ var $ebe1b421c9c8d2ff$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ebe1b421c9c8d2ff$var$splice = $ebe1b421c9c8d2ff$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ebe1b421c9c8d2ff$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $6ab284dcd30c85cb$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ebe1b421c9c8d2ff$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $ebe1b421c9c8d2ff$export$2e2bcd8739ae039 = $ebe1b421c9c8d2ff$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $238092727595fdcc$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $6ab284dcd30c85cb$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $238092727595fdcc$export$2e2bcd8739ae039 = $238092727595fdcc$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $296ca56480710109$var$listCacheHas(key) {
    return (0, $6ab284dcd30c85cb$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $296ca56480710109$export$2e2bcd8739ae039 = $296ca56480710109$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $01dad50fa29ef9a6$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $6ab284dcd30c85cb$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $01dad50fa29ef9a6$export$2e2bcd8739ae039 = $01dad50fa29ef9a6$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $24451b9ecdad1cbd$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$24451b9ecdad1cbd$var$ListCache.prototype.clear = (0, $ff59fb5721e5e71c$export$2e2bcd8739ae039);
$24451b9ecdad1cbd$var$ListCache.prototype['delete'] = (0, $ebe1b421c9c8d2ff$export$2e2bcd8739ae039);
$24451b9ecdad1cbd$var$ListCache.prototype.get = (0, $238092727595fdcc$export$2e2bcd8739ae039);
$24451b9ecdad1cbd$var$ListCache.prototype.has = (0, $296ca56480710109$export$2e2bcd8739ae039);
$24451b9ecdad1cbd$var$ListCache.prototype.set = (0, $01dad50fa29ef9a6$export$2e2bcd8739ae039);
var $24451b9ecdad1cbd$export$2e2bcd8739ae039 = $24451b9ecdad1cbd$var$ListCache;




var $2kosG = parcelRequire("2kosG");
/* Built-in method references that are verified to be native. */ var $c0dc7d9e985798af$var$Map = (0, $52f0708eb8080799$export$2e2bcd8739ae039)((0, $2kosG.default), 'Map');
var $c0dc7d9e985798af$export$2e2bcd8739ae039 = $c0dc7d9e985798af$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $a6e4ad0051ee329e$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $557a0364372f9806$export$2e2bcd8739ae039),
        'map': new ((0, $c0dc7d9e985798af$export$2e2bcd8739ae039) || (0, $24451b9ecdad1cbd$export$2e2bcd8739ae039)),
        'string': new (0, $557a0364372f9806$export$2e2bcd8739ae039)
    };
}
var $a6e4ad0051ee329e$export$2e2bcd8739ae039 = $a6e4ad0051ee329e$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $1c419a101ea482d5$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $1c419a101ea482d5$export$2e2bcd8739ae039 = $1c419a101ea482d5$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $20aff72364e81ca5$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $1c419a101ea482d5$export$2e2bcd8739ae039)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $20aff72364e81ca5$export$2e2bcd8739ae039 = $20aff72364e81ca5$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d528eca32704a199$var$mapCacheDelete(key) {
    var result = (0, $20aff72364e81ca5$export$2e2bcd8739ae039)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $d528eca32704a199$export$2e2bcd8739ae039 = $d528eca32704a199$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6b1b40a054dd215b$var$mapCacheGet(key) {
    return (0, $20aff72364e81ca5$export$2e2bcd8739ae039)(this, key).get(key);
}
var $6b1b40a054dd215b$export$2e2bcd8739ae039 = $6b1b40a054dd215b$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3143361ec2b53fad$var$mapCacheHas(key) {
    return (0, $20aff72364e81ca5$export$2e2bcd8739ae039)(this, key).has(key);
}
var $3143361ec2b53fad$export$2e2bcd8739ae039 = $3143361ec2b53fad$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b819f570a25d964b$var$mapCacheSet(key, value) {
    var data = (0, $20aff72364e81ca5$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $b819f570a25d964b$export$2e2bcd8739ae039 = $b819f570a25d964b$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $de77e87a05835c72$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$de77e87a05835c72$var$MapCache.prototype.clear = (0, $a6e4ad0051ee329e$export$2e2bcd8739ae039);
$de77e87a05835c72$var$MapCache.prototype['delete'] = (0, $d528eca32704a199$export$2e2bcd8739ae039);
$de77e87a05835c72$var$MapCache.prototype.get = (0, $6b1b40a054dd215b$export$2e2bcd8739ae039);
$de77e87a05835c72$var$MapCache.prototype.has = (0, $3143361ec2b53fad$export$2e2bcd8739ae039);
$de77e87a05835c72$var$MapCache.prototype.set = (0, $b819f570a25d964b$export$2e2bcd8739ae039);
var $de77e87a05835c72$export$2e2bcd8739ae039 = $de77e87a05835c72$var$MapCache;


/** Error message constants. */ var $a57941e48ba9fa6a$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $a57941e48ba9fa6a$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($a57941e48ba9fa6a$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($a57941e48ba9fa6a$var$memoize.Cache || (0, $de77e87a05835c72$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$a57941e48ba9fa6a$var$memoize.Cache = (0, $de77e87a05835c72$export$2e2bcd8739ae039);
var $a57941e48ba9fa6a$export$2e2bcd8739ae039 = $a57941e48ba9fa6a$var$memoize;


/** Used as the maximum memoize cache size. */ var $aef90a4ba3cf62d5$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $aef90a4ba3cf62d5$var$memoizeCapped(func) {
    var result = (0, $a57941e48ba9fa6a$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $aef90a4ba3cf62d5$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $aef90a4ba3cf62d5$export$2e2bcd8739ae039 = $aef90a4ba3cf62d5$var$memoizeCapped;


/** Used to match property names within property paths. */ var $e0dc47c5de809a27$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $e0dc47c5de809a27$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $e0dc47c5de809a27$var$stringToPath = (0, $aef90a4ba3cf62d5$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($e0dc47c5de809a27$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($e0dc47c5de809a27$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $e0dc47c5de809a27$export$2e2bcd8739ae039 = $e0dc47c5de809a27$var$stringToPath;



/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $736434a056fc3928$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $736434a056fc3928$export$2e2bcd8739ae039 = $736434a056fc3928$var$arrayMap;




/** Used as references for various `Number` constants. */ var $459b0b9dfe351fb3$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $459b0b9dfe351fb3$var$symbolProto = (0, $47aeee022ce46748$export$2e2bcd8739ae039) ? (0, $47aeee022ce46748$export$2e2bcd8739ae039).prototype : undefined, $459b0b9dfe351fb3$var$symbolToString = $459b0b9dfe351fb3$var$symbolProto ? $459b0b9dfe351fb3$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $459b0b9dfe351fb3$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $736434a056fc3928$export$2e2bcd8739ae039)(value, $459b0b9dfe351fb3$var$baseToString) + '';
    if ((0, $e38480002ec9114f$export$2e2bcd8739ae039)(value)) return $459b0b9dfe351fb3$var$symbolToString ? $459b0b9dfe351fb3$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$459b0b9dfe351fb3$var$INFINITY ? '-0' : result;
}
var $459b0b9dfe351fb3$export$2e2bcd8739ae039 = $459b0b9dfe351fb3$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $19ca0d8af35ed84a$var$toString(value) {
    return value == null ? '' : (0, $459b0b9dfe351fb3$export$2e2bcd8739ae039)(value);
}
var $19ca0d8af35ed84a$export$2e2bcd8739ae039 = $19ca0d8af35ed84a$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $9ab94d97aa9e786d$var$castPath(value, object) {
    if ((0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(value)) return value;
    return (0, $fee70519b255a559$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $e0dc47c5de809a27$export$2e2bcd8739ae039)((0, $19ca0d8af35ed84a$export$2e2bcd8739ae039)(value));
}
var $9ab94d97aa9e786d$export$2e2bcd8739ae039 = $9ab94d97aa9e786d$var$castPath;


/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $00f9a68098d6f187$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
var $00f9a68098d6f187$export$2e2bcd8739ae039 = $00f9a68098d6f187$var$last;




/** Used as references for various `Number` constants. */ var $4367555bb6328d41$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4367555bb6328d41$var$toKey(value) {
    if (typeof value == 'string' || (0, $e38480002ec9114f$export$2e2bcd8739ae039)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$4367555bb6328d41$var$INFINITY ? '-0' : result;
}
var $4367555bb6328d41$export$2e2bcd8739ae039 = $4367555bb6328d41$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $446aa16481ec6e14$var$baseGet(object, path) {
    path = (0, $9ab94d97aa9e786d$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $4367555bb6328d41$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $446aa16481ec6e14$export$2e2bcd8739ae039 = $446aa16481ec6e14$var$baseGet;


/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $3b4fde2ed9ed85c6$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
var $3b4fde2ed9ed85c6$export$2e2bcd8739ae039 = $3b4fde2ed9ed85c6$var$baseSlice;


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $32f27927cbc7ad86$var$parent(object, path) {
    return path.length < 2 ? object : (0, $446aa16481ec6e14$export$2e2bcd8739ae039)(object, (0, $3b4fde2ed9ed85c6$export$2e2bcd8739ae039)(path, 0, -1));
}
var $32f27927cbc7ad86$export$2e2bcd8739ae039 = $32f27927cbc7ad86$var$parent;



/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */ function $faa2b0610502f9b6$var$baseInvoke(object, path, args) {
    path = (0, $9ab94d97aa9e786d$export$2e2bcd8739ae039)(path, object);
    object = (0, $32f27927cbc7ad86$export$2e2bcd8739ae039)(object, path);
    var func = object == null ? object : object[(0, $4367555bb6328d41$export$2e2bcd8739ae039)((0, $00f9a68098d6f187$export$2e2bcd8739ae039)(path))];
    return func == null ? undefined : (0, $ae95b650a5337ac7$export$2e2bcd8739ae039)(func, object, args);
}
var $faa2b0610502f9b6$export$2e2bcd8739ae039 = $faa2b0610502f9b6$var$baseInvoke;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $291c4766a973bc5f$var$identity(value) {
    return value;
}
var $291c4766a973bc5f$export$2e2bcd8739ae039 = $291c4766a973bc5f$var$identity;



/* Built-in method references for those with the same name as other `lodash` methods. */ var $5cdbb147ea35e2fb$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $5cdbb147ea35e2fb$var$overRest(func, start, transform) {
    start = $5cdbb147ea35e2fb$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $5cdbb147ea35e2fb$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $ae95b650a5337ac7$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $5cdbb147ea35e2fb$export$2e2bcd8739ae039 = $5cdbb147ea35e2fb$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7243dbe3a09cb93a$var$constant(value) {
    return function() {
        return value;
    };
}
var $7243dbe3a09cb93a$export$2e2bcd8739ae039 = $7243dbe3a09cb93a$var$constant;



var $9c831147253bd1f8$var$defineProperty = function() {
    try {
        var func = (0, $52f0708eb8080799$export$2e2bcd8739ae039)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $9c831147253bd1f8$export$2e2bcd8739ae039 = $9c831147253bd1f8$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $3cb10ee04df8a0eb$var$baseSetToString = !(0, $9c831147253bd1f8$export$2e2bcd8739ae039) ? (0, $291c4766a973bc5f$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $9c831147253bd1f8$export$2e2bcd8739ae039)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $7243dbe3a09cb93a$export$2e2bcd8739ae039)(string),
        'writable': true
    });
};
var $3cb10ee04df8a0eb$export$2e2bcd8739ae039 = $3cb10ee04df8a0eb$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $df9c49eced3eebe9$var$HOT_COUNT = 800, $df9c49eced3eebe9$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $df9c49eced3eebe9$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $df9c49eced3eebe9$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $df9c49eced3eebe9$var$nativeNow(), remaining = $df9c49eced3eebe9$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $df9c49eced3eebe9$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $df9c49eced3eebe9$export$2e2bcd8739ae039 = $df9c49eced3eebe9$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $09f46bb6b2e295e6$var$setToString = (0, $df9c49eced3eebe9$export$2e2bcd8739ae039)((0, $3cb10ee04df8a0eb$export$2e2bcd8739ae039));
var $09f46bb6b2e295e6$export$2e2bcd8739ae039 = $09f46bb6b2e295e6$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $aee0d5bc2e0dbbb6$var$baseRest(func, start) {
    return (0, $09f46bb6b2e295e6$export$2e2bcd8739ae039)((0, $5cdbb147ea35e2fb$export$2e2bcd8739ae039)(func, start, (0, $291c4766a973bc5f$export$2e2bcd8739ae039)), func + '');
}
var $aee0d5bc2e0dbbb6$export$2e2bcd8739ae039 = $aee0d5bc2e0dbbb6$var$baseRest;


/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */ var $a9a92c7799ca2a07$var$invoke = (0, $aee0d5bc2e0dbbb6$export$2e2bcd8739ae039)((0, $faa2b0610502f9b6$export$2e2bcd8739ae039));
var $a9a92c7799ca2a07$export$2e2bcd8739ae039 = $a9a92c7799ca2a07$var$invoke;


/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $9ef17f10bea17fe1$var$isNil(value) {
    return value == null;
}
var $9ef17f10bea17fe1$export$2e2bcd8739ae039 = $9ef17f10bea17fe1$var$isNil;




var $6aRB8 = parcelRequire("6aRB8");



var $6aRB8 = parcelRequire("6aRB8");

/**
 * The function that correctly handles passing refs.
 *
 * @param ref - An ref object or function
 * @param node - A node that should be passed by ref
 */ var $2b42f5a2eeaa6c35$export$5cc535d419e048c1 = function handleRef(ref, node) {
    if (typeof ref === 'function') {
        ref(node);
        return;
    }
    if (ref !== null && typeof ref === 'object') // The `current` property is defined as readonly, however it's a valid way because
    // `ref` is a mutable object
    ref.current = node;
};
var $2b42f5a2eeaa6c35$export$dedd81df7bc1307 = function isRefObject(ref) {
    return ref !== null && typeof ref === 'object' && ref.hasOwnProperty('current');
};


// react/packages/react-reconciler/src/ReactFiber.js
// ========================================================
/**
 * Detects if a passed element is a Fiber object instead of an element. Is needed as `ReactDOM.findDOMNode()` returns
 * a Fiber in `react-test-renderer` that can cause issues with tests. Is used only in non-production env.
 *
 * @see https://github.com/facebook/react/issues/7371#issuecomment-317396864
 * @see https://github.com/Semantic-Org/Semantic-UI-React/issues/4061#issuecomment-694895617
 */ function $67c26abbdc7391e1$var$isFiberRef(node) {
    if (node === null) return false;
    if (node instanceof Element || node instanceof Text) return false;
    return !!(node.type && node.tag);
}
var $67c26abbdc7391e1$export$588cd1fe4610a902 = /*#__PURE__*/ function(_React$Component) {
    (0, $19bf3c71fafed899$export$2e2bcd8739ae039)(RefFindNode, _React$Component);
    function RefFindNode() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.prevNode = void 0;
        return _this;
    }
    var _proto = RefFindNode.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var currentNode = $f0d8bf13803656d4$exports.findDOMNode(this);
        this.prevNode = currentNode;
        (0, $2b42f5a2eeaa6c35$export$5cc535d419e048c1)(this.props.innerRef, currentNode);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var currentNode = $f0d8bf13803656d4$exports.findDOMNode(this);
        if (this.prevNode !== currentNode) {
            this.prevNode = currentNode;
            (0, $2b42f5a2eeaa6c35$export$5cc535d419e048c1)(this.props.innerRef, currentNode);
        }
        if (prevProps.innerRef !== this.props.innerRef) (0, $2b42f5a2eeaa6c35$export$5cc535d419e048c1)(this.props.innerRef, currentNode);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        (0, $2b42f5a2eeaa6c35$export$5cc535d419e048c1)(this.props.innerRef, null);
        delete this.prevNode;
    };
    _proto.render = function render() {
        var children = this.props.children;
        return children;
    };
    return RefFindNode;
}($6aRB8.Component);




var $6aRB8 = parcelRequire("6aRB8");

var $a4b1ee2296bc1ede$export$4b2b2ff7e955d151 = /*#__PURE__*/ function(_React$Component) {
    (0, $19bf3c71fafed899$export$2e2bcd8739ae039)(RefForward, _React$Component);
    function RefForward() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.currentNode = void 0;
        _this.handleRefOverride = function(node) {
            var _this$props = _this.props, children = _this$props.children, innerRef = _this$props.innerRef;
            (0, $2b42f5a2eeaa6c35$export$5cc535d419e048c1)(children.ref, node);
            (0, $2b42f5a2eeaa6c35$export$5cc535d419e048c1)(innerRef, node);
            _this.currentNode = node;
        };
        return _this;
    }
    var _proto = RefForward.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.innerRef !== this.props.innerRef) (0, $2b42f5a2eeaa6c35$export$5cc535d419e048c1)(this.props.innerRef, this.currentNode);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        delete this.currentNode;
    };
    _proto.render = function render() {
        var children = this.props.children;
        return /*#__PURE__*/ $6aRB8.cloneElement(children, {
            ref: this.handleRefOverride
        });
    };
    return RefForward;
}($6aRB8.Component);


var $c3c11b3db64bf060$var$_excluded = [
    "children",
    "innerRef"
];
var $c3c11b3db64bf060$export$9bcc32033bdd12aa = function Ref(props) {
    var children = props.children, innerRef = props.innerRef, rest = (0, $ad714b0cbc0e2484$export$2e2bcd8739ae039)(props, $c3c11b3db64bf060$var$_excluded);
    var child = $6aRB8.Children.only(children);
    var ElementType = $fef01f59125f2c7c$exports.isForwardRef(child) ? (0, $a4b1ee2296bc1ede$export$4b2b2ff7e955d151) : (0, $67c26abbdc7391e1$export$588cd1fe4610a902);
    var childWithProps = child && rest && Object.keys(rest).length > 0 ? /*#__PURE__*/ $6aRB8.cloneElement(child, rest) : child;
    return /*#__PURE__*/ $6aRB8.createElement(ElementType, {
        innerRef: innerRef
    }, childWithProps);
};


function $b589707e9204a564$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $b589707e9204a564$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $b589707e9204a564$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $b589707e9204a564$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $b589707e9204a564$export$2e2bcd8739ae039 = $b589707e9204a564$export$4f5d2d50c9deca37;




var $6aRB8 = parcelRequire("6aRB8");
var $f0526af735e6584e$exports = {};

$parcel$export($f0526af735e6584e$exports, "someByType", function () { return $f0526af735e6584e$export$b86a45f239c36d2a; });
$parcel$export($f0526af735e6584e$exports, "findByType", function () { return $f0526af735e6584e$export$c880cfae7ad226f0; });
$parcel$export($f0526af735e6584e$exports, "isNil", function () { return $f0526af735e6584e$export$984f70f9382f5d27; });


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $cf6a6c83656743a8$var$stackClear() {
    this.__data__ = new (0, $24451b9ecdad1cbd$export$2e2bcd8739ae039);
    this.size = 0;
}
var $cf6a6c83656743a8$export$2e2bcd8739ae039 = $cf6a6c83656743a8$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8e7ef74503cd2d9b$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $8e7ef74503cd2d9b$export$2e2bcd8739ae039 = $8e7ef74503cd2d9b$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c5f55845a7e54f52$var$stackGet(key) {
    return this.__data__.get(key);
}
var $c5f55845a7e54f52$export$2e2bcd8739ae039 = $c5f55845a7e54f52$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $826b06c8f0109d0d$var$stackHas(key) {
    return this.__data__.has(key);
}
var $826b06c8f0109d0d$export$2e2bcd8739ae039 = $826b06c8f0109d0d$var$stackHas;





/** Used as the size to enable large array optimizations. */ var $82bcef34f44d14d3$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $82bcef34f44d14d3$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $24451b9ecdad1cbd$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $c0dc7d9e985798af$export$2e2bcd8739ae039) || pairs.length < $82bcef34f44d14d3$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $de77e87a05835c72$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $82bcef34f44d14d3$export$2e2bcd8739ae039 = $82bcef34f44d14d3$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ff374d423ccd61e7$var$Stack(entries) {
    var data = this.__data__ = new (0, $24451b9ecdad1cbd$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$ff374d423ccd61e7$var$Stack.prototype.clear = (0, $cf6a6c83656743a8$export$2e2bcd8739ae039);
$ff374d423ccd61e7$var$Stack.prototype['delete'] = (0, $8e7ef74503cd2d9b$export$2e2bcd8739ae039);
$ff374d423ccd61e7$var$Stack.prototype.get = (0, $c5f55845a7e54f52$export$2e2bcd8739ae039);
$ff374d423ccd61e7$var$Stack.prototype.has = (0, $826b06c8f0109d0d$export$2e2bcd8739ae039);
$ff374d423ccd61e7$var$Stack.prototype.set = (0, $82bcef34f44d14d3$export$2e2bcd8739ae039);
var $ff374d423ccd61e7$export$2e2bcd8739ae039 = $ff374d423ccd61e7$var$Stack;




/** Used to stand-in for `undefined` hash values. */ var $279a58bafd1d5592$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $279a58bafd1d5592$var$setCacheAdd(value) {
    this.__data__.set(value, $279a58bafd1d5592$var$HASH_UNDEFINED);
    return this;
}
var $279a58bafd1d5592$export$2e2bcd8739ae039 = $279a58bafd1d5592$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $590342f48988a422$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $590342f48988a422$export$2e2bcd8739ae039 = $590342f48988a422$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $c2b64a768f4c9492$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $de77e87a05835c72$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$c2b64a768f4c9492$var$SetCache.prototype.add = $c2b64a768f4c9492$var$SetCache.prototype.push = (0, $279a58bafd1d5592$export$2e2bcd8739ae039);
$c2b64a768f4c9492$var$SetCache.prototype.has = (0, $590342f48988a422$export$2e2bcd8739ae039);
var $c2b64a768f4c9492$export$2e2bcd8739ae039 = $c2b64a768f4c9492$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $9da3b06b1bffe0a3$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $9da3b06b1bffe0a3$export$2e2bcd8739ae039 = $9da3b06b1bffe0a3$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $de3dc5c001dc6fc9$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $de3dc5c001dc6fc9$export$2e2bcd8739ae039 = $de3dc5c001dc6fc9$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $ab0ee094e391bf17$var$COMPARE_PARTIAL_FLAG = 1, $ab0ee094e391bf17$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $ab0ee094e391bf17$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ab0ee094e391bf17$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $ab0ee094e391bf17$var$COMPARE_UNORDERED_FLAG ? new (0, $c2b64a768f4c9492$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $9da3b06b1bffe0a3$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $de3dc5c001dc6fc9$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $ab0ee094e391bf17$export$2e2bcd8739ae039 = $ab0ee094e391bf17$var$equalArrays;




var $2kosG = parcelRequire("2kosG");
/** Built-in value references. */ var $43709c00488c5b2a$var$Uint8Array = (0, $2kosG.default).Uint8Array;
var $43709c00488c5b2a$export$2e2bcd8739ae039 = $43709c00488c5b2a$var$Uint8Array;




/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $a32d0f374f037984$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $a32d0f374f037984$export$2e2bcd8739ae039 = $a32d0f374f037984$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $9455a7f663ccd07f$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $9455a7f663ccd07f$export$2e2bcd8739ae039 = $9455a7f663ccd07f$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $299951dd3f08a835$var$COMPARE_PARTIAL_FLAG = 1, $299951dd3f08a835$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $299951dd3f08a835$var$boolTag = '[object Boolean]', $299951dd3f08a835$var$dateTag = '[object Date]', $299951dd3f08a835$var$errorTag = '[object Error]', $299951dd3f08a835$var$mapTag = '[object Map]', $299951dd3f08a835$var$numberTag = '[object Number]', $299951dd3f08a835$var$regexpTag = '[object RegExp]', $299951dd3f08a835$var$setTag = '[object Set]', $299951dd3f08a835$var$stringTag = '[object String]', $299951dd3f08a835$var$symbolTag = '[object Symbol]';
var $299951dd3f08a835$var$arrayBufferTag = '[object ArrayBuffer]', $299951dd3f08a835$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $299951dd3f08a835$var$symbolProto = (0, $47aeee022ce46748$export$2e2bcd8739ae039) ? (0, $47aeee022ce46748$export$2e2bcd8739ae039).prototype : undefined, $299951dd3f08a835$var$symbolValueOf = $299951dd3f08a835$var$symbolProto ? $299951dd3f08a835$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $299951dd3f08a835$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $299951dd3f08a835$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $299951dd3f08a835$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $43709c00488c5b2a$export$2e2bcd8739ae039)(object), new (0, $43709c00488c5b2a$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $299951dd3f08a835$var$boolTag:
        case $299951dd3f08a835$var$dateTag:
        case $299951dd3f08a835$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $1ade0d9409bf4c31$export$2e2bcd8739ae039)(+object, +other);
        case $299951dd3f08a835$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $299951dd3f08a835$var$regexpTag:
        case $299951dd3f08a835$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $299951dd3f08a835$var$mapTag:
            var convert = (0, $a32d0f374f037984$export$2e2bcd8739ae039);
        case $299951dd3f08a835$var$setTag:
            var isPartial = bitmask & $299951dd3f08a835$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $9455a7f663ccd07f$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $299951dd3f08a835$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $ab0ee094e391bf17$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $299951dd3f08a835$var$symbolTag:
            if ($299951dd3f08a835$var$symbolValueOf) return $299951dd3f08a835$var$symbolValueOf.call(object) == $299951dd3f08a835$var$symbolValueOf.call(other);
    }
    return false;
}
var $299951dd3f08a835$export$2e2bcd8739ae039 = $299951dd3f08a835$var$equalByTag;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $ed5c7987f48dac00$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $ed5c7987f48dac00$export$2e2bcd8739ae039 = $ed5c7987f48dac00$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c2e3c7721d4a68a3$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(object) ? result : (0, $ed5c7987f48dac00$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $c2e3c7721d4a68a3$export$2e2bcd8739ae039 = $c2e3c7721d4a68a3$var$baseGetAllKeys;


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $e8800ecf51c78eaa$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $e8800ecf51c78eaa$export$2e2bcd8739ae039 = $e8800ecf51c78eaa$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $0c6ce6a3801b8af5$var$stubArray() {
    return [];
}
var $0c6ce6a3801b8af5$export$2e2bcd8739ae039 = $0c6ce6a3801b8af5$var$stubArray;


/** Used for built-in method references. */ var $c3a36676a3b9287e$var$objectProto = Object.prototype;
/** Built-in value references. */ var $c3a36676a3b9287e$var$propertyIsEnumerable = $c3a36676a3b9287e$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c3a36676a3b9287e$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $c3a36676a3b9287e$var$getSymbols = !$c3a36676a3b9287e$var$nativeGetSymbols ? (0, $0c6ce6a3801b8af5$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $e8800ecf51c78eaa$export$2e2bcd8739ae039)($c3a36676a3b9287e$var$nativeGetSymbols(object), function(symbol) {
        return $c3a36676a3b9287e$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $c3a36676a3b9287e$export$2e2bcd8739ae039 = $c3a36676a3b9287e$var$getSymbols;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $f13122c75692c029$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $f13122c75692c029$export$2e2bcd8739ae039 = $f13122c75692c029$var$baseTimes;




/** `Object#toString` result references. */ var $4ab65d63b1a71311$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $4ab65d63b1a71311$var$baseIsArguments(value) {
    return (0, $ea90ac032deaca1b$export$2e2bcd8739ae039)(value) && (0, $acaeba78f0dfcb4a$export$2e2bcd8739ae039)(value) == $4ab65d63b1a71311$var$argsTag;
}
var $4ab65d63b1a71311$export$2e2bcd8739ae039 = $4ab65d63b1a71311$var$baseIsArguments;



/** Used for built-in method references. */ var $a53bd3b8e7a3212a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a53bd3b8e7a3212a$var$hasOwnProperty = $a53bd3b8e7a3212a$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $a53bd3b8e7a3212a$var$propertyIsEnumerable = $a53bd3b8e7a3212a$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $a53bd3b8e7a3212a$var$isArguments = (0, $4ab65d63b1a71311$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $4ab65d63b1a71311$export$2e2bcd8739ae039) : function(value) {
    return (0, $ea90ac032deaca1b$export$2e2bcd8739ae039)(value) && $a53bd3b8e7a3212a$var$hasOwnProperty.call(value, 'callee') && !$a53bd3b8e7a3212a$var$propertyIsEnumerable.call(value, 'callee');
};
var $a53bd3b8e7a3212a$export$2e2bcd8739ae039 = $a53bd3b8e7a3212a$var$isArguments;




var $1wW4r = parcelRequire("1wW4r");
/** Used as references for various `Number` constants. */ var $2d3931d505c8ac33$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $2d3931d505c8ac33$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $2d3931d505c8ac33$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $2d3931d505c8ac33$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $2d3931d505c8ac33$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $2d3931d505c8ac33$export$2e2bcd8739ae039 = $2d3931d505c8ac33$var$isIndex;



/** Used as references for various `Number` constants. */ var $0774c15d8318ebf9$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $0774c15d8318ebf9$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $0774c15d8318ebf9$var$MAX_SAFE_INTEGER;
}
var $0774c15d8318ebf9$export$2e2bcd8739ae039 = $0774c15d8318ebf9$var$isLength;



/** `Object#toString` result references. */ var $e7387ab33a8fc1cf$var$argsTag = '[object Arguments]', $e7387ab33a8fc1cf$var$arrayTag = '[object Array]', $e7387ab33a8fc1cf$var$boolTag = '[object Boolean]', $e7387ab33a8fc1cf$var$dateTag = '[object Date]', $e7387ab33a8fc1cf$var$errorTag = '[object Error]', $e7387ab33a8fc1cf$var$funcTag = '[object Function]', $e7387ab33a8fc1cf$var$mapTag = '[object Map]', $e7387ab33a8fc1cf$var$numberTag = '[object Number]', $e7387ab33a8fc1cf$var$objectTag = '[object Object]', $e7387ab33a8fc1cf$var$regexpTag = '[object RegExp]', $e7387ab33a8fc1cf$var$setTag = '[object Set]', $e7387ab33a8fc1cf$var$stringTag = '[object String]', $e7387ab33a8fc1cf$var$weakMapTag = '[object WeakMap]';
var $e7387ab33a8fc1cf$var$arrayBufferTag = '[object ArrayBuffer]', $e7387ab33a8fc1cf$var$dataViewTag = '[object DataView]', $e7387ab33a8fc1cf$var$float32Tag = '[object Float32Array]', $e7387ab33a8fc1cf$var$float64Tag = '[object Float64Array]', $e7387ab33a8fc1cf$var$int8Tag = '[object Int8Array]', $e7387ab33a8fc1cf$var$int16Tag = '[object Int16Array]', $e7387ab33a8fc1cf$var$int32Tag = '[object Int32Array]', $e7387ab33a8fc1cf$var$uint8Tag = '[object Uint8Array]', $e7387ab33a8fc1cf$var$uint8ClampedTag = '[object Uint8ClampedArray]', $e7387ab33a8fc1cf$var$uint16Tag = '[object Uint16Array]', $e7387ab33a8fc1cf$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $e7387ab33a8fc1cf$var$typedArrayTags = {};
$e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$float32Tag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$float64Tag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$int8Tag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$int16Tag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$int32Tag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$uint8Tag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$uint8ClampedTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$uint16Tag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$uint32Tag] = true;
$e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$argsTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$arrayTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$arrayBufferTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$boolTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$dataViewTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$dateTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$errorTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$funcTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$mapTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$numberTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$objectTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$regexpTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$setTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$stringTag] = $e7387ab33a8fc1cf$var$typedArrayTags[$e7387ab33a8fc1cf$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $e7387ab33a8fc1cf$var$baseIsTypedArray(value) {
    return (0, $ea90ac032deaca1b$export$2e2bcd8739ae039)(value) && (0, $0774c15d8318ebf9$export$2e2bcd8739ae039)(value.length) && !!$e7387ab33a8fc1cf$var$typedArrayTags[(0, $acaeba78f0dfcb4a$export$2e2bcd8739ae039)(value)];
}
var $e7387ab33a8fc1cf$export$2e2bcd8739ae039 = $e7387ab33a8fc1cf$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $8ef44e245db4be68$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $8ef44e245db4be68$export$2e2bcd8739ae039 = $8ef44e245db4be68$var$baseUnary;



var $hkpCq = parcelRequire("hkpCq");
/* Node.js helper references. */ var $32c8e7a22690b153$var$nodeIsTypedArray = (0, $hkpCq.default) && (0, $hkpCq.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $32c8e7a22690b153$var$isTypedArray = $32c8e7a22690b153$var$nodeIsTypedArray ? (0, $8ef44e245db4be68$export$2e2bcd8739ae039)($32c8e7a22690b153$var$nodeIsTypedArray) : (0, $e7387ab33a8fc1cf$export$2e2bcd8739ae039);
var $32c8e7a22690b153$export$2e2bcd8739ae039 = $32c8e7a22690b153$var$isTypedArray;


/** Used for built-in method references. */ var $0ed49ec26ada25ff$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ed49ec26ada25ff$var$hasOwnProperty = $0ed49ec26ada25ff$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $0ed49ec26ada25ff$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $a53bd3b8e7a3212a$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $1wW4r.default)(value), isType = !isArr && !isArg && !isBuff && (0, $32c8e7a22690b153$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $f13122c75692c029$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $0ed49ec26ada25ff$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $2d3931d505c8ac33$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $0ed49ec26ada25ff$export$2e2bcd8739ae039 = $0ed49ec26ada25ff$var$arrayLikeKeys;


/** Used for built-in method references. */ var $bf3efd7cde0046a8$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $bf3efd7cde0046a8$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $bf3efd7cde0046a8$var$objectProto;
    return value === proto;
}
var $bf3efd7cde0046a8$export$2e2bcd8739ae039 = $bf3efd7cde0046a8$var$isPrototype;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $1e7ed3532d5dc747$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $1e7ed3532d5dc747$export$2e2bcd8739ae039 = $1e7ed3532d5dc747$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $479a9cff06c58f42$var$nativeKeys = (0, $1e7ed3532d5dc747$export$2e2bcd8739ae039)(Object.keys, Object);
var $479a9cff06c58f42$export$2e2bcd8739ae039 = $479a9cff06c58f42$var$nativeKeys;


/** Used for built-in method references. */ var $4a13fbd915daf9d9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4a13fbd915daf9d9$var$hasOwnProperty = $4a13fbd915daf9d9$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $4a13fbd915daf9d9$var$baseKeys(object) {
    if (!(0, $bf3efd7cde0046a8$export$2e2bcd8739ae039)(object)) return (0, $479a9cff06c58f42$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($4a13fbd915daf9d9$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $4a13fbd915daf9d9$export$2e2bcd8739ae039 = $4a13fbd915daf9d9$var$baseKeys;




/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $a49bb6f04e0bbcec$var$isArrayLike(value) {
    return value != null && (0, $0774c15d8318ebf9$export$2e2bcd8739ae039)(value.length) && !(0, $e4f5228c7fe84628$export$2e2bcd8739ae039)(value);
}
var $a49bb6f04e0bbcec$export$2e2bcd8739ae039 = $a49bb6f04e0bbcec$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $14fb50e4e8ce6222$var$keys(object) {
    return (0, $a49bb6f04e0bbcec$export$2e2bcd8739ae039)(object) ? (0, $0ed49ec26ada25ff$export$2e2bcd8739ae039)(object) : (0, $4a13fbd915daf9d9$export$2e2bcd8739ae039)(object);
}
var $14fb50e4e8ce6222$export$2e2bcd8739ae039 = $14fb50e4e8ce6222$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9882fa5b472632db$var$getAllKeys(object) {
    return (0, $c2e3c7721d4a68a3$export$2e2bcd8739ae039)(object, (0, $14fb50e4e8ce6222$export$2e2bcd8739ae039), (0, $c3a36676a3b9287e$export$2e2bcd8739ae039));
}
var $9882fa5b472632db$export$2e2bcd8739ae039 = $9882fa5b472632db$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $397005f7872dc1d1$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $397005f7872dc1d1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $397005f7872dc1d1$var$hasOwnProperty = $397005f7872dc1d1$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $397005f7872dc1d1$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $397005f7872dc1d1$var$COMPARE_PARTIAL_FLAG, objProps = (0, $9882fa5b472632db$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $9882fa5b472632db$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $397005f7872dc1d1$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $397005f7872dc1d1$export$2e2bcd8739ae039 = $397005f7872dc1d1$var$equalObjects;




var $2kosG = parcelRequire("2kosG");
/* Built-in method references that are verified to be native. */ var $18540162a4d0bb11$var$DataView = (0, $52f0708eb8080799$export$2e2bcd8739ae039)((0, $2kosG.default), 'DataView');
var $18540162a4d0bb11$export$2e2bcd8739ae039 = $18540162a4d0bb11$var$DataView;





var $2kosG = parcelRequire("2kosG");
/* Built-in method references that are verified to be native. */ var $f83d6db734a7e435$var$Promise = (0, $52f0708eb8080799$export$2e2bcd8739ae039)((0, $2kosG.default), 'Promise');
var $f83d6db734a7e435$export$2e2bcd8739ae039 = $f83d6db734a7e435$var$Promise;




var $2kosG = parcelRequire("2kosG");
/* Built-in method references that are verified to be native. */ var $4adb8365aded4bd4$var$Set = (0, $52f0708eb8080799$export$2e2bcd8739ae039)((0, $2kosG.default), 'Set');
var $4adb8365aded4bd4$export$2e2bcd8739ae039 = $4adb8365aded4bd4$var$Set;




var $2kosG = parcelRequire("2kosG");
/* Built-in method references that are verified to be native. */ var $05923e47ab57f57b$var$WeakMap = (0, $52f0708eb8080799$export$2e2bcd8739ae039)((0, $2kosG.default), 'WeakMap');
var $05923e47ab57f57b$export$2e2bcd8739ae039 = $05923e47ab57f57b$var$WeakMap;




/** `Object#toString` result references. */ var $b42d9a808c4fefbd$var$mapTag = '[object Map]', $b42d9a808c4fefbd$var$objectTag = '[object Object]', $b42d9a808c4fefbd$var$promiseTag = '[object Promise]', $b42d9a808c4fefbd$var$setTag = '[object Set]', $b42d9a808c4fefbd$var$weakMapTag = '[object WeakMap]';
var $b42d9a808c4fefbd$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $b42d9a808c4fefbd$var$dataViewCtorString = (0, $14ffe53fa1a07024$export$2e2bcd8739ae039)((0, $18540162a4d0bb11$export$2e2bcd8739ae039)), $b42d9a808c4fefbd$var$mapCtorString = (0, $14ffe53fa1a07024$export$2e2bcd8739ae039)((0, $c0dc7d9e985798af$export$2e2bcd8739ae039)), $b42d9a808c4fefbd$var$promiseCtorString = (0, $14ffe53fa1a07024$export$2e2bcd8739ae039)((0, $f83d6db734a7e435$export$2e2bcd8739ae039)), $b42d9a808c4fefbd$var$setCtorString = (0, $14ffe53fa1a07024$export$2e2bcd8739ae039)((0, $4adb8365aded4bd4$export$2e2bcd8739ae039)), $b42d9a808c4fefbd$var$weakMapCtorString = (0, $14ffe53fa1a07024$export$2e2bcd8739ae039)((0, $05923e47ab57f57b$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $b42d9a808c4fefbd$var$getTag = (0, $acaeba78f0dfcb4a$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $18540162a4d0bb11$export$2e2bcd8739ae039) && $b42d9a808c4fefbd$var$getTag(new (0, $18540162a4d0bb11$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $b42d9a808c4fefbd$var$dataViewTag || (0, $c0dc7d9e985798af$export$2e2bcd8739ae039) && $b42d9a808c4fefbd$var$getTag(new (0, $c0dc7d9e985798af$export$2e2bcd8739ae039)) != $b42d9a808c4fefbd$var$mapTag || (0, $f83d6db734a7e435$export$2e2bcd8739ae039) && $b42d9a808c4fefbd$var$getTag((0, $f83d6db734a7e435$export$2e2bcd8739ae039).resolve()) != $b42d9a808c4fefbd$var$promiseTag || (0, $4adb8365aded4bd4$export$2e2bcd8739ae039) && $b42d9a808c4fefbd$var$getTag(new (0, $4adb8365aded4bd4$export$2e2bcd8739ae039)) != $b42d9a808c4fefbd$var$setTag || (0, $05923e47ab57f57b$export$2e2bcd8739ae039) && $b42d9a808c4fefbd$var$getTag(new (0, $05923e47ab57f57b$export$2e2bcd8739ae039)) != $b42d9a808c4fefbd$var$weakMapTag) $b42d9a808c4fefbd$var$getTag = function(value) {
    var result = (0, $acaeba78f0dfcb4a$export$2e2bcd8739ae039)(value), Ctor = result == $b42d9a808c4fefbd$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $14ffe53fa1a07024$export$2e2bcd8739ae039)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $b42d9a808c4fefbd$var$dataViewCtorString:
            return $b42d9a808c4fefbd$var$dataViewTag;
        case $b42d9a808c4fefbd$var$mapCtorString:
            return $b42d9a808c4fefbd$var$mapTag;
        case $b42d9a808c4fefbd$var$promiseCtorString:
            return $b42d9a808c4fefbd$var$promiseTag;
        case $b42d9a808c4fefbd$var$setCtorString:
            return $b42d9a808c4fefbd$var$setTag;
        case $b42d9a808c4fefbd$var$weakMapCtorString:
            return $b42d9a808c4fefbd$var$weakMapTag;
    }
    return result;
};
var $b42d9a808c4fefbd$export$2e2bcd8739ae039 = $b42d9a808c4fefbd$var$getTag;




var $1wW4r = parcelRequire("1wW4r");

/** Used to compose bitmasks for value comparisons. */ var $68cbf0afd93cd8de$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $68cbf0afd93cd8de$var$argsTag = '[object Arguments]', $68cbf0afd93cd8de$var$arrayTag = '[object Array]', $68cbf0afd93cd8de$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $68cbf0afd93cd8de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $68cbf0afd93cd8de$var$hasOwnProperty = $68cbf0afd93cd8de$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $68cbf0afd93cd8de$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(object), othIsArr = (0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $68cbf0afd93cd8de$var$arrayTag : (0, $b42d9a808c4fefbd$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $68cbf0afd93cd8de$var$arrayTag : (0, $b42d9a808c4fefbd$export$2e2bcd8739ae039)(other);
    objTag = objTag == $68cbf0afd93cd8de$var$argsTag ? $68cbf0afd93cd8de$var$objectTag : objTag;
    othTag = othTag == $68cbf0afd93cd8de$var$argsTag ? $68cbf0afd93cd8de$var$objectTag : othTag;
    var objIsObj = objTag == $68cbf0afd93cd8de$var$objectTag, othIsObj = othTag == $68cbf0afd93cd8de$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $1wW4r.default)(object)) {
        if (!(0, $1wW4r.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $ff374d423ccd61e7$export$2e2bcd8739ae039));
        return objIsArr || (0, $32c8e7a22690b153$export$2e2bcd8739ae039)(object) ? (0, $ab0ee094e391bf17$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $299951dd3f08a835$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $68cbf0afd93cd8de$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $68cbf0afd93cd8de$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $68cbf0afd93cd8de$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $ff374d423ccd61e7$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $ff374d423ccd61e7$export$2e2bcd8739ae039));
    return (0, $397005f7872dc1d1$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $68cbf0afd93cd8de$export$2e2bcd8739ae039 = $68cbf0afd93cd8de$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $6c3e040d1dbd7ea2$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $ea90ac032deaca1b$export$2e2bcd8739ae039)(value) && !(0, $ea90ac032deaca1b$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $68cbf0afd93cd8de$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $6c3e040d1dbd7ea2$var$baseIsEqual, stack);
}
var $6c3e040d1dbd7ea2$export$2e2bcd8739ae039 = $6c3e040d1dbd7ea2$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $eb7df24730a5ec05$var$COMPARE_PARTIAL_FLAG = 1, $eb7df24730a5ec05$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $eb7df24730a5ec05$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $ff374d423ccd61e7$export$2e2bcd8739ae039);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $6c3e040d1dbd7ea2$export$2e2bcd8739ae039)(srcValue, objValue, $eb7df24730a5ec05$var$COMPARE_PARTIAL_FLAG | $eb7df24730a5ec05$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $eb7df24730a5ec05$export$2e2bcd8739ae039 = $eb7df24730a5ec05$var$baseIsMatch;



/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $932b4dab48a80882$var$isStrictComparable(value) {
    return value === value && !(0, $d9b4f47c9ea17ede$export$2e2bcd8739ae039)(value);
}
var $932b4dab48a80882$export$2e2bcd8739ae039 = $932b4dab48a80882$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $73fb34cad1c83c02$var$getMatchData(object) {
    var result = (0, $14fb50e4e8ce6222$export$2e2bcd8739ae039)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $932b4dab48a80882$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $73fb34cad1c83c02$export$2e2bcd8739ae039 = $73fb34cad1c83c02$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $dbb35bf442ba4b1e$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $dbb35bf442ba4b1e$export$2e2bcd8739ae039 = $dbb35bf442ba4b1e$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $864f129bea5289f7$var$baseMatches(source) {
    var matchData = (0, $73fb34cad1c83c02$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $dbb35bf442ba4b1e$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $eb7df24730a5ec05$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $864f129bea5289f7$export$2e2bcd8739ae039 = $864f129bea5289f7$var$baseMatches;




/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $4b263473fff5783f$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $446aa16481ec6e14$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $4b263473fff5783f$export$2e2bcd8739ae039 = $4b263473fff5783f$var$get;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $0744b3756f44cf15$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $0744b3756f44cf15$export$2e2bcd8739ae039 = $0744b3756f44cf15$var$baseHasIn;








/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $2ef0abe1b723d060$var$hasPath(object, path, hasFunc) {
    path = (0, $9ab94d97aa9e786d$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $4367555bb6328d41$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $0774c15d8318ebf9$export$2e2bcd8739ae039)(length) && (0, $2d3931d505c8ac33$export$2e2bcd8739ae039)(key, length) && ((0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(object) || (0, $a53bd3b8e7a3212a$export$2e2bcd8739ae039)(object));
}
var $2ef0abe1b723d060$export$2e2bcd8739ae039 = $2ef0abe1b723d060$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $be6d5fda30899550$var$hasIn(object, path) {
    return object != null && (0, $2ef0abe1b723d060$export$2e2bcd8739ae039)(object, path, (0, $0744b3756f44cf15$export$2e2bcd8739ae039));
}
var $be6d5fda30899550$export$2e2bcd8739ae039 = $be6d5fda30899550$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $5103dc94b2ab7687$var$COMPARE_PARTIAL_FLAG = 1, $5103dc94b2ab7687$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $5103dc94b2ab7687$var$baseMatchesProperty(path, srcValue) {
    if ((0, $fee70519b255a559$export$2e2bcd8739ae039)(path) && (0, $932b4dab48a80882$export$2e2bcd8739ae039)(srcValue)) return (0, $dbb35bf442ba4b1e$export$2e2bcd8739ae039)((0, $4367555bb6328d41$export$2e2bcd8739ae039)(path), srcValue);
    return function(object) {
        var objValue = (0, $4b263473fff5783f$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $be6d5fda30899550$export$2e2bcd8739ae039)(object, path) : (0, $6c3e040d1dbd7ea2$export$2e2bcd8739ae039)(srcValue, objValue, $5103dc94b2ab7687$var$COMPARE_PARTIAL_FLAG | $5103dc94b2ab7687$var$COMPARE_UNORDERED_FLAG);
    };
}
var $5103dc94b2ab7687$export$2e2bcd8739ae039 = $5103dc94b2ab7687$var$baseMatchesProperty;




/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $ce5a4e673c21809d$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $ce5a4e673c21809d$export$2e2bcd8739ae039 = $ce5a4e673c21809d$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4dcb3748f73247cb$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $446aa16481ec6e14$export$2e2bcd8739ae039)(object, path);
    };
}
var $4dcb3748f73247cb$export$2e2bcd8739ae039 = $4dcb3748f73247cb$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $762cd475e5b82e70$var$property(path) {
    return (0, $fee70519b255a559$export$2e2bcd8739ae039)(path) ? (0, $ce5a4e673c21809d$export$2e2bcd8739ae039)((0, $4367555bb6328d41$export$2e2bcd8739ae039)(path)) : (0, $4dcb3748f73247cb$export$2e2bcd8739ae039)(path);
}
var $762cd475e5b82e70$export$2e2bcd8739ae039 = $762cd475e5b82e70$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $3aff02699eb74261$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, $291c4766a973bc5f$export$2e2bcd8739ae039;
    if (typeof value == 'object') return (0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(value) ? (0, $5103dc94b2ab7687$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $864f129bea5289f7$export$2e2bcd8739ae039)(value);
    return (0, $762cd475e5b82e70$export$2e2bcd8739ae039)(value);
}
var $3aff02699eb74261$export$2e2bcd8739ae039 = $3aff02699eb74261$var$baseIteratee;




/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $406c2fea8ea95403$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!(0, $a49bb6f04e0bbcec$export$2e2bcd8739ae039)(collection)) {
            var iteratee = (0, $3aff02699eb74261$export$2e2bcd8739ae039)(predicate, 3);
            collection = (0, $14fb50e4e8ce6222$export$2e2bcd8739ae039)(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
var $406c2fea8ea95403$export$2e2bcd8739ae039 = $406c2fea8ea95403$var$createFind;


/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $409a6a30403d7fff$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
var $409a6a30403d7fff$export$2e2bcd8739ae039 = $409a6a30403d7fff$var$baseFindIndex;



/** Used to match a single whitespace character. */ var $5bde93d05172cf92$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $5bde93d05172cf92$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $5bde93d05172cf92$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $5bde93d05172cf92$export$2e2bcd8739ae039 = $5bde93d05172cf92$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $dc7a0ed3851031a2$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $dc7a0ed3851031a2$var$baseTrim(string) {
    return string ? string.slice(0, (0, $5bde93d05172cf92$export$2e2bcd8739ae039)(string) + 1).replace($dc7a0ed3851031a2$var$reTrimStart, '') : string;
}
var $dc7a0ed3851031a2$export$2e2bcd8739ae039 = $dc7a0ed3851031a2$var$baseTrim;




/** Used as references for various `Number` constants. */ var $294872e6ac32ced0$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $294872e6ac32ced0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $294872e6ac32ced0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $294872e6ac32ced0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $294872e6ac32ced0$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $294872e6ac32ced0$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, $e38480002ec9114f$export$2e2bcd8739ae039)(value)) return $294872e6ac32ced0$var$NAN;
    if ((0, $d9b4f47c9ea17ede$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, $d9b4f47c9ea17ede$export$2e2bcd8739ae039)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, $dc7a0ed3851031a2$export$2e2bcd8739ae039)(value);
    var isBinary = $294872e6ac32ced0$var$reIsBinary.test(value);
    return isBinary || $294872e6ac32ced0$var$reIsOctal.test(value) ? $294872e6ac32ced0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $294872e6ac32ced0$var$reIsBadHex.test(value) ? $294872e6ac32ced0$var$NAN : +value;
}
var $294872e6ac32ced0$export$2e2bcd8739ae039 = $294872e6ac32ced0$var$toNumber;


/** Used as references for various `Number` constants. */ var $d2765d8686dfd75d$var$INFINITY = 1 / 0, $d2765d8686dfd75d$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $d2765d8686dfd75d$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = (0, $294872e6ac32ced0$export$2e2bcd8739ae039)(value);
    if (value === $d2765d8686dfd75d$var$INFINITY || value === -$d2765d8686dfd75d$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $d2765d8686dfd75d$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
var $d2765d8686dfd75d$export$2e2bcd8739ae039 = $d2765d8686dfd75d$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $6e5e9c8d30b196df$var$toInteger(value) {
    var result = (0, $d2765d8686dfd75d$export$2e2bcd8739ae039)(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
var $6e5e9c8d30b196df$export$2e2bcd8739ae039 = $6e5e9c8d30b196df$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $096a5e4acaf669cb$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $096a5e4acaf669cb$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : (0, $6e5e9c8d30b196df$export$2e2bcd8739ae039)(fromIndex);
    if (index < 0) index = $096a5e4acaf669cb$var$nativeMax(length + index, 0);
    return (0, $409a6a30403d7fff$export$2e2bcd8739ae039)(array, (0, $3aff02699eb74261$export$2e2bcd8739ae039)(predicate, 3), index);
}
var $096a5e4acaf669cb$export$2e2bcd8739ae039 = $096a5e4acaf669cb$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $e1d6d905b1dc141e$var$find = (0, $406c2fea8ea95403$export$2e2bcd8739ae039)((0, $096a5e4acaf669cb$export$2e2bcd8739ae039));
var $e1d6d905b1dc141e$export$2e2bcd8739ae039 = $e1d6d905b1dc141e$var$find;




/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $fdb35d7cd2f95b05$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $fdb35d7cd2f95b05$export$2e2bcd8739ae039 = $fdb35d7cd2f95b05$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $fd70632c360bb35d$var$baseFor = (0, $fdb35d7cd2f95b05$export$2e2bcd8739ae039)();
var $fd70632c360bb35d$export$2e2bcd8739ae039 = $fd70632c360bb35d$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $77f13a0df341a55f$var$baseForOwn(object, iteratee) {
    return object && (0, $fd70632c360bb35d$export$2e2bcd8739ae039)(object, iteratee, (0, $14fb50e4e8ce6222$export$2e2bcd8739ae039));
}
var $77f13a0df341a55f$export$2e2bcd8739ae039 = $77f13a0df341a55f$var$baseForOwn;



/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $7129c2d441321280$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $a49bb6f04e0bbcec$export$2e2bcd8739ae039)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $7129c2d441321280$export$2e2bcd8739ae039 = $7129c2d441321280$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $20b772a907d94404$var$baseEach = (0, $7129c2d441321280$export$2e2bcd8739ae039)((0, $77f13a0df341a55f$export$2e2bcd8739ae039));
var $20b772a907d94404$export$2e2bcd8739ae039 = $20b772a907d94404$var$baseEach;


/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $be510fb8051857ed$var$baseSome(collection, predicate) {
    var result;
    (0, $20b772a907d94404$export$2e2bcd8739ae039)(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
var $be510fb8051857ed$export$2e2bcd8739ae039 = $be510fb8051857ed$var$baseSome;







/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $2fa9c3c87095acde$var$isIterateeCall(value, index, object) {
    if (!(0, $d9b4f47c9ea17ede$export$2e2bcd8739ae039)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $a49bb6f04e0bbcec$export$2e2bcd8739ae039)(object) && (0, $2d3931d505c8ac33$export$2e2bcd8739ae039)(index, object.length) : type == 'string' && index in object) return (0, $1ade0d9409bf4c31$export$2e2bcd8739ae039)(object[index], value);
    return false;
}
var $2fa9c3c87095acde$export$2e2bcd8739ae039 = $2fa9c3c87095acde$var$isIterateeCall;


/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $ae0c709b40a9455c$var$some(collection, predicate, guard) {
    var func = (0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(collection) ? (0, $9da3b06b1bffe0a3$export$2e2bcd8739ae039) : (0, $be510fb8051857ed$export$2e2bcd8739ae039);
    if (guard && (0, $2fa9c3c87095acde$export$2e2bcd8739ae039)(collection, predicate, guard)) predicate = undefined;
    return func(collection, (0, $3aff02699eb74261$export$2e2bcd8739ae039)(predicate, 3));
}
var $ae0c709b40a9455c$export$2e2bcd8739ae039 = $ae0c709b40a9455c$var$some;



var $6aRB8 = parcelRequire("6aRB8");
var $f0526af735e6584e$export$b86a45f239c36d2a = function someByType(children, type) {
    return (0, $ae0c709b40a9455c$export$2e2bcd8739ae039)((0, $6aRB8.Children).toArray(children), {
        type: type
    });
};
var $f0526af735e6584e$export$c880cfae7ad226f0 = function findByType(children, type) {
    return (0, $e1d6d905b1dc141e$export$2e2bcd8739ae039)((0, $6aRB8.Children).toArray(children), {
        type: type
    });
};
var $f0526af735e6584e$export$984f70f9382f5d27 = function isNil(children) {
    return children === null || children === undefined || Array.isArray(children) && children.length === 0;
};




/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $aa233bc652e98459$var$baseIsNaN(value) {
    return value !== value;
}
var $aa233bc652e98459$export$2e2bcd8739ae039 = $aa233bc652e98459$var$baseIsNaN;


/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $46ba5d0528d503e4$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
var $46ba5d0528d503e4$export$2e2bcd8739ae039 = $46ba5d0528d503e4$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $acd58e6c3302360d$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? (0, $46ba5d0528d503e4$export$2e2bcd8739ae039)(array, value, fromIndex) : (0, $409a6a30403d7fff$export$2e2bcd8739ae039)(array, (0, $aa233bc652e98459$export$2e2bcd8739ae039), fromIndex);
}
var $acd58e6c3302360d$export$2e2bcd8739ae039 = $acd58e6c3302360d$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $43eb61b138a40b8c$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && (0, $acd58e6c3302360d$export$2e2bcd8739ae039)(array, value, 0) > -1;
}
var $43eb61b138a40b8c$export$2e2bcd8739ae039 = $43eb61b138a40b8c$var$arrayIncludes;


/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $1e7e78f10f7d7907$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
var $1e7e78f10f7d7907$export$2e2bcd8739ae039 = $1e7e78f10f7d7907$var$arrayIncludesWith;




/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $523198dc7af6ada1$var$noop() {
// No operation performed.
}
var $523198dc7af6ada1$export$2e2bcd8739ae039 = $523198dc7af6ada1$var$noop;



/** Used as references for various `Number` constants. */ var $063ca4bc230df0ea$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $063ca4bc230df0ea$var$createSet = !((0, $4adb8365aded4bd4$export$2e2bcd8739ae039) && 1 / (0, $9455a7f663ccd07f$export$2e2bcd8739ae039)(new (0, $4adb8365aded4bd4$export$2e2bcd8739ae039)([
    ,
    -0
]))[1] == $063ca4bc230df0ea$var$INFINITY) ? (0, $523198dc7af6ada1$export$2e2bcd8739ae039) : function(values) {
    return new (0, $4adb8365aded4bd4$export$2e2bcd8739ae039)(values);
};
var $063ca4bc230df0ea$export$2e2bcd8739ae039 = $063ca4bc230df0ea$var$createSet;



/** Used as the size to enable large array optimizations. */ var $0bf5906a7c6b4fc2$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $0bf5906a7c6b4fc2$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = (0, $43eb61b138a40b8c$export$2e2bcd8739ae039), length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = (0, $1e7e78f10f7d7907$export$2e2bcd8739ae039);
    } else if (length >= $0bf5906a7c6b4fc2$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : (0, $063ca4bc230df0ea$export$2e2bcd8739ae039)(array);
        if (set) return (0, $9455a7f663ccd07f$export$2e2bcd8739ae039)(set);
        isCommon = false;
        includes = (0, $de3dc5c001dc6fc9$export$2e2bcd8739ae039);
        seen = new (0, $c2b64a768f4c9492$export$2e2bcd8739ae039);
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
var $0bf5906a7c6b4fc2$export$2e2bcd8739ae039 = $0bf5906a7c6b4fc2$var$baseUniq;


/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $02f053cf5941c13b$var$uniq(array) {
    return array && array.length ? (0, $0bf5906a7c6b4fc2$export$2e2bcd8739ae039)(array) : [];
}
var $02f053cf5941c13b$export$2e2bcd8739ae039 = $02f053cf5941c13b$var$uniq;





/** Built-in value references. */ var $28a87367abcc5578$var$getPrototype = (0, $1e7ed3532d5dc747$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $28a87367abcc5578$export$2e2bcd8739ae039 = $28a87367abcc5578$var$getPrototype;



/** `Object#toString` result references. */ var $88fcb6c8ec5d0788$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $88fcb6c8ec5d0788$var$funcProto = Function.prototype, $88fcb6c8ec5d0788$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $88fcb6c8ec5d0788$var$funcToString = $88fcb6c8ec5d0788$var$funcProto.toString;
/** Used to check objects for own properties. */ var $88fcb6c8ec5d0788$var$hasOwnProperty = $88fcb6c8ec5d0788$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $88fcb6c8ec5d0788$var$objectCtorString = $88fcb6c8ec5d0788$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $88fcb6c8ec5d0788$var$isPlainObject(value) {
    if (!(0, $ea90ac032deaca1b$export$2e2bcd8739ae039)(value) || (0, $acaeba78f0dfcb4a$export$2e2bcd8739ae039)(value) != $88fcb6c8ec5d0788$var$objectTag) return false;
    var proto = (0, $28a87367abcc5578$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $88fcb6c8ec5d0788$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $88fcb6c8ec5d0788$var$funcToString.call(Ctor) == $88fcb6c8ec5d0788$var$objectCtorString;
}
var $88fcb6c8ec5d0788$export$2e2bcd8739ae039 = $88fcb6c8ec5d0788$var$isPlainObject;





/** `Object#toString` result references. */ var $e36d41a37affdc5b$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $e36d41a37affdc5b$var$isNumber(value) {
    return typeof value == 'number' || (0, $ea90ac032deaca1b$export$2e2bcd8739ae039)(value) && (0, $acaeba78f0dfcb4a$export$2e2bcd8739ae039)(value) == $e36d41a37affdc5b$var$numberTag;
}
var $e36d41a37affdc5b$export$2e2bcd8739ae039 = $e36d41a37affdc5b$var$isNumber;





/** `Object#toString` result references. */ var $cbd7d1598fb48d43$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $cbd7d1598fb48d43$var$isString(value) {
    return typeof value == 'string' || !(0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(value) && (0, $ea90ac032deaca1b$export$2e2bcd8739ae039)(value) && (0, $acaeba78f0dfcb4a$export$2e2bcd8739ae039)(value) == $cbd7d1598fb48d43$var$stringTag;
}
var $cbd7d1598fb48d43$export$2e2bcd8739ae039 = $cbd7d1598fb48d43$var$isString;




/** `Object#toString` result references. */ var $7909528216d9a5bc$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $7909528216d9a5bc$var$isBoolean(value) {
    return value === true || value === false || (0, $ea90ac032deaca1b$export$2e2bcd8739ae039)(value) && (0, $acaeba78f0dfcb4a$export$2e2bcd8739ae039)(value) == $7909528216d9a5bc$var$boolTag;
}
var $7909528216d9a5bc$export$2e2bcd8739ae039 = $7909528216d9a5bc$var$isBoolean;





var $6aRB8 = parcelRequire("6aRB8");
var $d590e40415a777e8$var$DEPRECATED_CALLS = {}; // ============================================================
function $d590e40415a777e8$export$e087067e9593d215(Component, mapValueToProps, val, options) {
    if (options === void 0) options = {};
    if (typeof Component !== 'function' && typeof Component !== 'string') throw new Error('createShorthand() Component must be a string or function.');
     // short circuit noop values
    if ((0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(val) || (0, $7909528216d9a5bc$export$2e2bcd8739ae039)(val)) return null;
    var valIsString = (0, $cbd7d1598fb48d43$export$2e2bcd8739ae039)(val);
    var valIsNumber = (0, $e36d41a37affdc5b$export$2e2bcd8739ae039)(val);
    var valIsFunction = (0, $e4f5228c7fe84628$export$2e2bcd8739ae039)(val);
    var valIsReactElement = /*#__PURE__*/ $6aRB8.isValidElement(val);
    var valIsPropsObject = (0, $88fcb6c8ec5d0788$export$2e2bcd8739ae039)(val);
    var valIsPrimitiveValue = valIsString || valIsNumber || (0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(val); // unhandled type return null
    /* eslint-disable no-console */ if (!valIsFunction && !valIsReactElement && !valIsPropsObject && !valIsPrimitiveValue) return null;
    /* eslint-enable no-console */ // ----------------------------------------
    // Build up props
    // ----------------------------------------
    var _options = options, _options$defaultProps = _options.defaultProps, defaultProps = _options$defaultProps === void 0 ? {} : _options$defaultProps; // User's props
    var usersProps = valIsReactElement && val.props || valIsPropsObject && val || valIsPrimitiveValue && mapValueToProps(val); // Override props
    var _options2 = options, _options2$overridePro = _options2.overrideProps, overrideProps = _options2$overridePro === void 0 ? {} : _options2$overridePro;
    overrideProps = (0, $e4f5228c7fe84628$export$2e2bcd8739ae039)(overrideProps) ? overrideProps((0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, defaultProps, usersProps)) : overrideProps; // Merge props
    /* eslint-disable react/prop-types */ var props = (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, defaultProps, usersProps, overrideProps); // Merge className
    if (defaultProps.className || overrideProps.className || usersProps.className) {
        var mergedClassesNames = (0, $b589707e9204a564$export$2e2bcd8739ae039)(defaultProps.className, overrideProps.className, usersProps.className);
        props.className = (0, $02f053cf5941c13b$export$2e2bcd8739ae039)(mergedClassesNames.split(' ')).join(' ');
    } // Merge style
    if (defaultProps.style || overrideProps.style || usersProps.style) props.style = (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, defaultProps.style, usersProps.style, overrideProps.style);
     // ----------------------------------------
    // Get key
    // ----------------------------------------
    // Use key, childKey, or generate key
    if ((0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(props.key)) {
        var childKey = props.childKey;
        var _options3 = options, _options3$autoGenerat = _options3.autoGenerateKey, autoGenerateKey = _options3$autoGenerat === void 0 ? true : _options3$autoGenerat;
        if (!(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(childKey)) {
            // apply and consume the childKey
            props.key = typeof childKey === 'function' ? childKey(props) : childKey;
            delete props.childKey;
        } else if (autoGenerateKey && (valIsString || valIsNumber)) // use string/number shorthand values as the key
        props.key = val;
    } // ----------------------------------------
    // Create Element
    // ----------------------------------------
    // Clone ReactElements
    if (valIsReactElement) return /*#__PURE__*/ $6aRB8.cloneElement(val, props);
    if (typeof props.children === 'function') return props.children(Component, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, props, {
        children: undefined
    }));
     // Create ReactElements from built up props
    if (valIsPrimitiveValue || valIsPropsObject) return /*#__PURE__*/ $6aRB8.createElement(Component, props);
     // Call functions with args similar to createElement()
    // TODO: V3 remove the implementation
    if (valIsFunction) return val(Component, props, props.children);
/* eslint-enable react/prop-types */ } // ============================================================
function $d590e40415a777e8$export$d60247e40ab2d321(Component, mapValueToProps) {
    if (typeof Component !== 'function' && typeof Component !== 'string') throw new Error('createShorthandFactory() Component must be a string or function.');
    return function(val, options) {
        return $d590e40415a777e8$export$e087067e9593d215(Component, mapValueToProps, val, options);
    };
} // ============================================================
var $d590e40415a777e8$export$7e56176d63bd9c59 = /* #__PURE__ */ $d590e40415a777e8$export$d60247e40ab2d321('div', function(val) {
    return {
        children: val
    };
});
var $d590e40415a777e8$export$f3360205e16de29d = /* #__PURE__ */ $d590e40415a777e8$export$d60247e40ab2d321('iframe', function(src) {
    return {
        src: src
    };
});
var $d590e40415a777e8$export$8c003cde5b9e63e0 = /* #__PURE__ */ $d590e40415a777e8$export$d60247e40ab2d321('img', function(val) {
    return {
        src: val
    };
});
var $d590e40415a777e8$export$8f85afee429cd78b = /* #__PURE__ */ $d590e40415a777e8$export$d60247e40ab2d321('input', function(val) {
    return {
        type: val
    };
});
var $d590e40415a777e8$export$6f84ed4ee6b024a3 = /* #__PURE__ */ $d590e40415a777e8$export$d60247e40ab2d321('label', function(val) {
    return {
        children: val
    };
});
var $d590e40415a777e8$export$eb9b746d34c942ce = /* #__PURE__ */ $d590e40415a777e8$export$d60247e40ab2d321('p', function(val) {
    return {
        children: val
    };
});

/**
 * Returns a createElement() type based on the props of the Component.
 * Useful for calculating what type a component should render as.
 *
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @param {function} [getDefault] A function that returns a default element type.
 * @returns {string|function} A ReactElement type
 */ function $444c8af3b9889af9$var$getElementType(Component, props, getDefault) {
    var _Component$defaultPro = Component.defaultProps, defaultProps = _Component$defaultPro === void 0 ? {} : _Component$defaultPro; // ----------------------------------------
    // user defined "as" element type
    if (props.as && props.as !== defaultProps.as) return props.as; // ----------------------------------------
    // computed default element type
    if (getDefault) {
        var computedDefault = getDefault();
        if (computedDefault) return computedDefault;
    } // ----------------------------------------
    // infer anchor links
    if (props.href) return 'a'; // ----------------------------------------
    // use defaultProp or 'div'
    return defaultProps.as || 'div';
}
var $444c8af3b9889af9$export$2e2bcd8739ae039 = $444c8af3b9889af9$var$getElementType;

/**
 * Returns an object consisting of props beyond the scope of the Component.
 * Useful for getting and spreading unknown props from the user.
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @returns {{}} A shallow copy of the prop object
 */ var $55562498df7fa7d0$var$getUnhandledProps = function getUnhandledProps(Component, props) {
    // Note that `handledProps` are generated automatically during build with `babel-plugin-transform-react-handled-props`
    var _Component$handledPro = Component.handledProps, handledProps = _Component$handledPro === void 0 ? [] : _Component$handledPro;
    return Object.keys(props).reduce(function(acc, prop) {
        if (prop === 'childKey') return acc;
        if (handledProps.indexOf(prop) === -1) acc[prop] = props[prop];
        return acc;
    }, {});
};
var $55562498df7fa7d0$export$2e2bcd8739ae039 = $55562498df7fa7d0$var$getUnhandledProps;

var $d6de4e3e8407e580$export$30d133d9cd274bfb = {
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
    5: 'five',
    6: 'six',
    7: 'seven',
    8: 'eight',
    9: 'nine',
    10: 'ten',
    11: 'eleven',
    12: 'twelve',
    13: 'thirteen',
    14: 'fourteen',
    15: 'fifteen',
    16: 'sixteen'
};
function $d6de4e3e8407e580$export$2a5a1b0a8247804e(value) {
    var type = typeof value;
    if (type === 'string' || type === 'number') return $d6de4e3e8407e580$export$30d133d9cd274bfb[value] || value;
    return '';
}


var $87a122667489288b$export$aac7d417530cc39a = function useKeyOnly(val, key) {
    return val && key;
};
var $87a122667489288b$export$fb1b8744f6450628 = function useValueAndKey(val, key) {
    return val && val !== true && val + " " + key;
};
var $87a122667489288b$export$72ebbc0b2506f7f8 = function useKeyOrValueAndKey(val, key) {
    return val && (val === true ? key : val + " " + key);
}; //
var $87a122667489288b$export$d9d5731d8dcdb4fb = function useMultipleProp(val, key) {
    if (!val || val === true) return null;
    return val.replace('large screen', 'large-screen').replace(/ vertically/g, '-vertically').split(' ').map(function(prop) {
        return prop.replace('-', ' ') + " " + key;
    }).join(' ');
};
var $87a122667489288b$export$32c7303ec0b907a1 = function useTextAlignProp(val) {
    return val === 'justified' ? 'justified' : $87a122667489288b$export$fb1b8744f6450628(val, 'aligned');
};
var $87a122667489288b$export$169652642bc5e2a1 = function useVerticalAlignProp(val) {
    return $87a122667489288b$export$fb1b8744f6450628(val, 'aligned');
};
var $87a122667489288b$export$52866a87b538f23c = function useWidthProp(val, widthClass, canEqual) {
    if (widthClass === void 0) widthClass = '';
    if (canEqual === void 0) canEqual = false;
    if (canEqual && val === 'equal') return 'equal width';
    var valType = typeof val;
    if ((valType === 'string' || valType === 'number') && widthClass) return (0, $d6de4e3e8407e580$export$2a5a1b0a8247804e)(val) + " " + widthClass;
    return (0, $d6de4e3e8407e580$export$2a5a1b0a8247804e)(val);
};










var $6aRB8 = parcelRequire("6aRB8");






var $6aRB8 = parcelRequire("6aRB8");

/**
 * Several icons can be used together as a group.
 */ function $b39f98830494cb31$var$IconGroup(props) {
    var children = props.children, className = props.className, content = props.content, size = props.size;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)(size, 'icons', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($b39f98830494cb31$var$IconGroup, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($b39f98830494cb31$var$IconGroup, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$b39f98830494cb31$var$IconGroup.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "size"
];
$b39f98830494cb31$var$IconGroup.propTypes = {};
$b39f98830494cb31$var$IconGroup.defaultProps = {
    as: 'i'
};
var $b39f98830494cb31$export$2e2bcd8739ae039 = $b39f98830494cb31$var$IconGroup;


/**
 * An icon is a glyph used to represent something else.
 * @see Image
 */ var $760d0282e0637aa7$var$Icon = /*#__PURE__*/ function(_PureComponent) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(Icon, _PureComponent);
    function Icon() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _PureComponent.call.apply(_PureComponent, [
            this
        ].concat(args)) || this;
        _this.handleClick = function(e) {
            var disabled = _this.props.disabled;
            if (disabled) {
                e.preventDefault();
                return;
            }
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onClick', e, _this.props);
        };
        return _this;
    }
    var _proto = Icon.prototype;
    _proto.getIconAriaOptions = function getIconAriaOptions() {
        var ariaOptions = {};
        var _this$props = this.props, ariaLabel = _this$props['aria-label'], ariaHidden = _this$props['aria-hidden'];
        if ((0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(ariaLabel)) ariaOptions['aria-hidden'] = 'true';
        else ariaOptions['aria-label'] = ariaLabel;
        if (!(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(ariaHidden)) ariaOptions['aria-hidden'] = ariaHidden;
        return ariaOptions;
    };
    _proto.render = function render() {
        var _this$props2 = this.props, bordered = _this$props2.bordered, circular = _this$props2.circular, className = _this$props2.className, color = _this$props2.color, corner = _this$props2.corner, disabled = _this$props2.disabled, fitted = _this$props2.fitted, flipped = _this$props2.flipped, inverted = _this$props2.inverted, link = _this$props2.link, loading = _this$props2.loading, name = _this$props2.name, rotated = _this$props2.rotated, size = _this$props2.size;
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)(color, name, size, (0, $87a122667489288b$export$aac7d417530cc39a)(bordered, 'bordered'), (0, $87a122667489288b$export$aac7d417530cc39a)(circular, 'circular'), (0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$aac7d417530cc39a)(fitted, 'fitted'), (0, $87a122667489288b$export$aac7d417530cc39a)(inverted, 'inverted'), (0, $87a122667489288b$export$aac7d417530cc39a)(link, 'link'), (0, $87a122667489288b$export$aac7d417530cc39a)(loading, 'loading'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(corner, 'corner'), (0, $87a122667489288b$export$fb1b8744f6450628)(flipped, 'flipped'), (0, $87a122667489288b$export$fb1b8744f6450628)(rotated, 'rotated'), 'icon', className);
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(Icon, this.props);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(Icon, this.props);
        var ariaOptions = this.getIconAriaOptions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, ariaOptions, {
            className: classes,
            onClick: this.handleClick
        }));
    };
    return Icon;
}((0, $6aRB8.PureComponent));
$760d0282e0637aa7$var$Icon.handledProps = [
    "aria-hidden",
    "aria-label",
    "as",
    "bordered",
    "circular",
    "className",
    "color",
    "corner",
    "disabled",
    "fitted",
    "flipped",
    "inverted",
    "link",
    "loading",
    "name",
    "rotated",
    "size"
];
$760d0282e0637aa7$var$Icon.propTypes = {};
$760d0282e0637aa7$var$Icon.defaultProps = {
    as: 'i'
};
$760d0282e0637aa7$var$Icon.Group = (0, $b39f98830494cb31$export$2e2bcd8739ae039);
$760d0282e0637aa7$var$Icon.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($760d0282e0637aa7$var$Icon, function(value) {
    return {
        name: value
    };
});
var $760d0282e0637aa7$export$2e2bcd8739ae039 = $760d0282e0637aa7$var$Icon;




/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $c38f68ed25e223ea$var$isUndefined(value) {
    return value === undefined;
}
var $c38f68ed25e223ea$export$2e2bcd8739ae039 = $c38f68ed25e223ea$var$isUndefined;






var $6aRB8 = parcelRequire("6aRB8");







var $6aRB8 = parcelRequire("6aRB8");





/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $2d927dccf98684c8$var$baseValues(object, props) {
    return (0, $736434a056fc3928$export$2e2bcd8739ae039)(props, function(key) {
        return object[key];
    });
}
var $2d927dccf98684c8$export$2e2bcd8739ae039 = $2d927dccf98684c8$var$baseValues;



/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $86f60cbeb0784f2a$var$values(object) {
    return object == null ? [] : (0, $2d927dccf98684c8$export$2e2bcd8739ae039)(object, (0, $14fb50e4e8ce6222$export$2e2bcd8739ae039)(object));
}
var $86f60cbeb0784f2a$export$2e2bcd8739ae039 = $86f60cbeb0784f2a$var$values;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $9d3d4e08270ebb7e$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $9d3d4e08270ebb7e$var$includes(collection, value, fromIndex, guard) {
    collection = (0, $a49bb6f04e0bbcec$export$2e2bcd8739ae039)(collection) ? collection : (0, $86f60cbeb0784f2a$export$2e2bcd8739ae039)(collection);
    fromIndex = fromIndex && !guard ? (0, $6e5e9c8d30b196df$export$2e2bcd8739ae039)(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $9d3d4e08270ebb7e$var$nativeMax(length + fromIndex, 0);
    return (0, $cbd7d1598fb48d43$export$2e2bcd8739ae039)(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && (0, $acd58e6c3302360d$export$2e2bcd8739ae039)(collection, value, fromIndex) > -1;
}
var $9d3d4e08270ebb7e$export$2e2bcd8739ae039 = $9d3d4e08270ebb7e$var$includes;


/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $5d199a54fac82ada$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $5d199a54fac82ada$export$2e2bcd8739ae039 = $5d199a54fac82ada$var$arrayEach;




/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $00715424e32d3ba0$var$castFunction(value) {
    return typeof value == 'function' ? value : (0, $291c4766a973bc5f$export$2e2bcd8739ae039);
}
var $00715424e32d3ba0$export$2e2bcd8739ae039 = $00715424e32d3ba0$var$castFunction;



/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $5d56675d44092c7d$var$forEach(collection, iteratee) {
    var func = (0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(collection) ? (0, $5d199a54fac82ada$export$2e2bcd8739ae039) : (0, $20b772a907d94404$export$2e2bcd8739ae039);
    return func(collection, (0, $00715424e32d3ba0$export$2e2bcd8739ae039)(iteratee));
}
var $5d56675d44092c7d$export$2e2bcd8739ae039 = $5d56675d44092c7d$var$forEach;


var $506c31eb45df8858$export$e6d74d6a93e99692 = [
    'selected',
    'defaultValue',
    'defaultChecked',
    'accept',
    'autoCapitalize',
    'autoComplete',
    'autoCorrect',
    'autoFocus',
    'checked',
    'disabled',
    'enterKeyHint',
    'form',
    'id',
    'inputMode',
    'lang',
    'list',
    'max',
    'maxLength',
    'min',
    'minLength',
    'multiple',
    'name',
    'pattern',
    'placeholder',
    'readOnly',
    'required',
    'step',
    'title',
    'type',
    'value'
];
var $506c31eb45df8858$export$7d9778f07e2dc93f = [
    // keyboard
    'onKeyDown',
    'onKeyPress',
    'onKeyUp',
    'onFocus',
    'onBlur',
    'onChange',
    'onInput',
    'onClick',
    'onContextMenu',
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onSelect',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart'
];
var $506c31eb45df8858$export$5a260aeba68cfb49 = [].concat($506c31eb45df8858$export$e6d74d6a93e99692, $506c31eb45df8858$export$7d9778f07e2dc93f);
var $506c31eb45df8858$export$d0a09fb9099ece03 = [
    'alt',
    'height',
    'src',
    'srcSet',
    'width',
    'loading'
];
var $506c31eb45df8858$export$a0111cfe23fb429 = function partitionHTMLProps(props, options) {
    if (options === void 0) options = {};
    var _options = options, _options$htmlProps = _options.htmlProps, htmlProps = _options$htmlProps === void 0 ? $506c31eb45df8858$export$5a260aeba68cfb49 : _options$htmlProps, _options$includeAria = _options.includeAria, includeAria = _options$includeAria === void 0 ? true : _options$includeAria;
    var inputProps = {};
    var rest = {};
    (0, $5d56675d44092c7d$export$2e2bcd8739ae039)(props, function(val, prop) {
        var possibleAria = includeAria && (/^aria-.*$/.test(prop) || prop === 'role');
        var target = (0, $9d3d4e08270ebb7e$export$2e2bcd8739ae039)(htmlProps, prop) || possibleAria ? inputProps : rest;
        target[prop] = val;
    });
    return [
        inputProps,
        rest
    ];
};






var $6aRB8 = parcelRequire("6aRB8");

var $227fe03b67c244b4$var$hasDocument = typeof document === 'object' && document !== null;
var $227fe03b67c244b4$var$hasWindow = typeof window === 'object' && window !== null && window.self === window; // eslint-disable-next-line no-confusing-arrow
var $227fe03b67c244b4$var$isBrowser = function isBrowser() {
    return !(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(isBrowser.override) ? isBrowser.override : $227fe03b67c244b4$var$hasDocument && $227fe03b67c244b4$var$hasWindow;
};
var $227fe03b67c244b4$export$2e2bcd8739ae039 = $227fe03b67c244b4$var$isBrowser;





var $d84a0216b5e1bcaf$exports = {};
'use strict';
var $d84a0216b5e1bcaf$var$stack;

$d84a0216b5e1bcaf$var$stack = (parcelRequire("e877a"));
$d84a0216b5e1bcaf$exports = $d84a0216b5e1bcaf$var$stack.default;
$d84a0216b5e1bcaf$exports.instance = $d84a0216b5e1bcaf$var$stack.instance;



var $a6688f2d03345850$exports = {};
'use strict';
var $a6688f2d03345850$var$isObject = function isObject(val) {
    return val !== null && !Array.isArray(val) && typeof val === 'object';
};
var $a6688f2d03345850$var$codes = {
    // ----------------------------------------
    // By Code
    // ----------------------------------------
    3: 'Cancel',
    6: 'Help',
    8: 'Backspace',
    9: 'Tab',
    12: 'Clear',
    13: 'Enter',
    16: 'Shift',
    17: 'Control',
    18: 'Alt',
    19: 'Pause',
    20: 'CapsLock',
    27: 'Escape',
    28: 'Convert',
    29: 'NonConvert',
    30: 'Accept',
    31: 'ModeChange',
    32: ' ',
    33: 'PageUp',
    34: 'PageDown',
    35: 'End',
    36: 'Home',
    37: 'ArrowLeft',
    38: 'ArrowUp',
    39: 'ArrowRight',
    40: 'ArrowDown',
    41: 'Select',
    42: 'Print',
    43: 'Execute',
    44: 'PrintScreen',
    45: 'Insert',
    46: 'Delete',
    48: [
        '0',
        ')'
    ],
    49: [
        '1',
        '!'
    ],
    50: [
        '2',
        '@'
    ],
    51: [
        '3',
        '#'
    ],
    52: [
        '4',
        '$'
    ],
    53: [
        '5',
        '%'
    ],
    54: [
        '6',
        '^'
    ],
    55: [
        '7',
        '&'
    ],
    56: [
        '8',
        '*'
    ],
    57: [
        '9',
        '('
    ],
    91: 'OS',
    93: 'ContextMenu',
    144: 'NumLock',
    145: 'ScrollLock',
    181: 'VolumeMute',
    182: 'VolumeDown',
    183: 'VolumeUp',
    186: [
        ';',
        ':'
    ],
    187: [
        '=',
        '+'
    ],
    188: [
        ',',
        '<'
    ],
    189: [
        '-',
        '_'
    ],
    190: [
        '.',
        '>'
    ],
    191: [
        '/',
        '?'
    ],
    192: [
        '`',
        '~'
    ],
    219: [
        '[',
        '{'
    ],
    220: [
        '\\',
        '|'
    ],
    221: [
        ']',
        '}'
    ],
    222: [
        "'",
        '"'
    ],
    224: 'Meta',
    225: 'AltGraph',
    246: 'Attn',
    247: 'CrSel',
    248: 'ExSel',
    249: 'EraseEof',
    250: 'Play',
    251: 'ZoomOut'
};
// Function Keys (F1-24)
for(var $a6688f2d03345850$var$i = 0; $a6688f2d03345850$var$i < 24; $a6688f2d03345850$var$i += 1)$a6688f2d03345850$var$codes[112 + $a6688f2d03345850$var$i] = 'F' + ($a6688f2d03345850$var$i + 1);
// Alphabet (a-Z)
for(var $a6688f2d03345850$var$j = 0; $a6688f2d03345850$var$j < 26; $a6688f2d03345850$var$j += 1){
    var $a6688f2d03345850$var$n = $a6688f2d03345850$var$j + 65;
    $a6688f2d03345850$var$codes[$a6688f2d03345850$var$n] = [
        String.fromCharCode($a6688f2d03345850$var$n + 32),
        String.fromCharCode($a6688f2d03345850$var$n)
    ];
}
var $a6688f2d03345850$var$keyboardKey = {
    codes: $a6688f2d03345850$var$codes,
    /**
   * Get the `keyCode` or `which` value from a keyboard event or `key` name.
   * @param {string|object} eventOrKey A keyboard event-like object or `key` name.
   * @param {string} [eventOrKey.key] If object, it must have one of these keys.
   * @param {number} [eventOrKey.keyCode] If object, it must have one of these keys.
   * @param {number} [eventOrKey.which] If object, it must have one of these keys.
   * @returns {number|undefined}
   */ getCode: function getCode(eventOrKey) {
        if ($a6688f2d03345850$var$isObject(eventOrKey)) return eventOrKey.keyCode || eventOrKey.which || this[eventOrKey.key];
        return this[eventOrKey];
    },
    /**
   * Get the key name from a keyboard event, `keyCode`, or `which` value.
   * @param {number|object} eventOrCode A keyboard event-like object or key code.
   * @param {string} [eventOrCode.key] If object with a `key` name, it will be returned.
   * @param {number} [eventOrCode.keyCode] If object, it must have one of these keys.
   * @param {number} [eventOrCode.which] If object, it must have one of these keys.
   * @param {boolean} [eventOrCode.shiftKey] If object, it must have one of these keys.
   * @returns {string|undefined}
   */ getKey: function getKey(eventOrCode) {
        var isEvent = $a6688f2d03345850$var$isObject(eventOrCode);
        // handle events with a `key` already defined
        if (isEvent && eventOrCode.key) return eventOrCode.key;
        var name = $a6688f2d03345850$var$codes[isEvent ? eventOrCode.keyCode || eventOrCode.which : eventOrCode];
        if (Array.isArray(name)) {
            if (isEvent) name = name[eventOrCode.shiftKey ? 1 : 0];
            else name = name[0];
        }
        return name;
    },
    // ----------------------------------------
    // By Name
    // ----------------------------------------
    // declare these manually for static analysis
    Cancel: 3,
    Help: 6,
    Backspace: 8,
    Tab: 9,
    Clear: 12,
    Enter: 13,
    Shift: 16,
    Control: 17,
    Alt: 18,
    Pause: 19,
    CapsLock: 20,
    Escape: 27,
    Convert: 28,
    NonConvert: 29,
    Accept: 30,
    ModeChange: 31,
    ' ': 32,
    PageUp: 33,
    PageDown: 34,
    End: 35,
    Home: 36,
    ArrowLeft: 37,
    ArrowUp: 38,
    ArrowRight: 39,
    ArrowDown: 40,
    Select: 41,
    Print: 42,
    Execute: 43,
    PrintScreen: 44,
    Insert: 45,
    Delete: 46,
    0: 48,
    ')': 48,
    1: 49,
    '!': 49,
    2: 50,
    '@': 50,
    3: 51,
    '#': 51,
    4: 52,
    $: 52,
    5: 53,
    '%': 53,
    6: 54,
    '^': 54,
    7: 55,
    '&': 55,
    8: 56,
    '*': 56,
    9: 57,
    '(': 57,
    a: 65,
    A: 65,
    b: 66,
    B: 66,
    c: 67,
    C: 67,
    d: 68,
    D: 68,
    e: 69,
    E: 69,
    f: 70,
    F: 70,
    g: 71,
    G: 71,
    h: 72,
    H: 72,
    i: 73,
    I: 73,
    j: 74,
    J: 74,
    k: 75,
    K: 75,
    l: 76,
    L: 76,
    m: 77,
    M: 77,
    n: 78,
    N: 78,
    o: 79,
    O: 79,
    p: 80,
    P: 80,
    q: 81,
    Q: 81,
    r: 82,
    R: 82,
    s: 83,
    S: 83,
    t: 84,
    T: 84,
    u: 85,
    U: 85,
    v: 86,
    V: 86,
    w: 87,
    W: 87,
    x: 88,
    X: 88,
    y: 89,
    Y: 89,
    z: 90,
    Z: 90,
    OS: 91,
    ContextMenu: 93,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    F13: 124,
    F14: 125,
    F15: 126,
    F16: 127,
    F17: 128,
    F18: 129,
    F19: 130,
    F20: 131,
    F21: 132,
    F22: 133,
    F23: 134,
    F24: 135,
    NumLock: 144,
    ScrollLock: 145,
    VolumeMute: 181,
    VolumeDown: 182,
    VolumeUp: 183,
    ';': 186,
    ':': 186,
    '=': 187,
    '+': 187,
    ',': 188,
    '<': 188,
    '-': 189,
    _: 189,
    '.': 190,
    '>': 190,
    '/': 191,
    '?': 191,
    '`': 192,
    '~': 192,
    '[': 219,
    '{': 219,
    '\\': 220,
    '|': 220,
    ']': 221,
    '}': 221,
    "'": 222,
    '"': 222,
    Meta: 224,
    AltGraph: 225,
    Attn: 246,
    CrSel: 247,
    ExSel: 248,
    EraseEof: 249,
    Play: 250,
    ZoomOut: 251
};
// ----------------------------------------
// By Alias
// ----------------------------------------
// provide dot-notation accessible keys for all key names
$a6688f2d03345850$var$keyboardKey.Spacebar = $a6688f2d03345850$var$keyboardKey[' '];
$a6688f2d03345850$var$keyboardKey.Digit0 = $a6688f2d03345850$var$keyboardKey['0'];
$a6688f2d03345850$var$keyboardKey.Digit1 = $a6688f2d03345850$var$keyboardKey['1'];
$a6688f2d03345850$var$keyboardKey.Digit2 = $a6688f2d03345850$var$keyboardKey['2'];
$a6688f2d03345850$var$keyboardKey.Digit3 = $a6688f2d03345850$var$keyboardKey['3'];
$a6688f2d03345850$var$keyboardKey.Digit4 = $a6688f2d03345850$var$keyboardKey['4'];
$a6688f2d03345850$var$keyboardKey.Digit5 = $a6688f2d03345850$var$keyboardKey['5'];
$a6688f2d03345850$var$keyboardKey.Digit6 = $a6688f2d03345850$var$keyboardKey['6'];
$a6688f2d03345850$var$keyboardKey.Digit7 = $a6688f2d03345850$var$keyboardKey['7'];
$a6688f2d03345850$var$keyboardKey.Digit8 = $a6688f2d03345850$var$keyboardKey['8'];
$a6688f2d03345850$var$keyboardKey.Digit9 = $a6688f2d03345850$var$keyboardKey['9'];
$a6688f2d03345850$var$keyboardKey.Tilde = $a6688f2d03345850$var$keyboardKey['~'];
$a6688f2d03345850$var$keyboardKey.GraveAccent = $a6688f2d03345850$var$keyboardKey['`'];
$a6688f2d03345850$var$keyboardKey.ExclamationPoint = $a6688f2d03345850$var$keyboardKey['!'];
$a6688f2d03345850$var$keyboardKey.AtSign = $a6688f2d03345850$var$keyboardKey['@'];
$a6688f2d03345850$var$keyboardKey.PoundSign = $a6688f2d03345850$var$keyboardKey['#'];
$a6688f2d03345850$var$keyboardKey.PercentSign = $a6688f2d03345850$var$keyboardKey['%'];
$a6688f2d03345850$var$keyboardKey.Caret = $a6688f2d03345850$var$keyboardKey['^'];
$a6688f2d03345850$var$keyboardKey.Ampersand = $a6688f2d03345850$var$keyboardKey['&'];
$a6688f2d03345850$var$keyboardKey.PlusSign = $a6688f2d03345850$var$keyboardKey['+'];
$a6688f2d03345850$var$keyboardKey.MinusSign = $a6688f2d03345850$var$keyboardKey['-'];
$a6688f2d03345850$var$keyboardKey.EqualsSign = $a6688f2d03345850$var$keyboardKey['='];
$a6688f2d03345850$var$keyboardKey.DivisionSign = $a6688f2d03345850$var$keyboardKey['/'];
$a6688f2d03345850$var$keyboardKey.MultiplicationSign = $a6688f2d03345850$var$keyboardKey['*'];
$a6688f2d03345850$var$keyboardKey.Comma = $a6688f2d03345850$var$keyboardKey[','];
$a6688f2d03345850$var$keyboardKey.Decimal = $a6688f2d03345850$var$keyboardKey['.'];
$a6688f2d03345850$var$keyboardKey.Colon = $a6688f2d03345850$var$keyboardKey[':'];
$a6688f2d03345850$var$keyboardKey.Semicolon = $a6688f2d03345850$var$keyboardKey[';'];
$a6688f2d03345850$var$keyboardKey.Pipe = $a6688f2d03345850$var$keyboardKey['|'];
$a6688f2d03345850$var$keyboardKey.BackSlash = $a6688f2d03345850$var$keyboardKey['\\'];
$a6688f2d03345850$var$keyboardKey.QuestionMark = $a6688f2d03345850$var$keyboardKey['?'];
$a6688f2d03345850$var$keyboardKey.SingleQuote = $a6688f2d03345850$var$keyboardKey["'"];
$a6688f2d03345850$var$keyboardKey.DoubleQuote = $a6688f2d03345850$var$keyboardKey['"'];
$a6688f2d03345850$var$keyboardKey.LeftCurlyBrace = $a6688f2d03345850$var$keyboardKey['{'];
$a6688f2d03345850$var$keyboardKey.RightCurlyBrace = $a6688f2d03345850$var$keyboardKey['}'];
$a6688f2d03345850$var$keyboardKey.LeftParenthesis = $a6688f2d03345850$var$keyboardKey['('];
$a6688f2d03345850$var$keyboardKey.RightParenthesis = $a6688f2d03345850$var$keyboardKey[')'];
$a6688f2d03345850$var$keyboardKey.LeftAngleBracket = $a6688f2d03345850$var$keyboardKey['<'];
$a6688f2d03345850$var$keyboardKey.RightAngleBracket = $a6688f2d03345850$var$keyboardKey['>'];
$a6688f2d03345850$var$keyboardKey.LeftSquareBracket = $a6688f2d03345850$var$keyboardKey['['];
$a6688f2d03345850$var$keyboardKey.RightSquareBracket = $a6688f2d03345850$var$keyboardKey[']'];
$a6688f2d03345850$exports = $a6688f2d03345850$var$keyboardKey;




var $6aRB8 = parcelRequire("6aRB8");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $12e6b098cd0820d0$var$nativeMax = Math.max, $12e6b098cd0820d0$var$nativeMin = Math.min;
/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */ function $12e6b098cd0820d0$var$baseInRange(number, start, end) {
    return number >= $12e6b098cd0820d0$var$nativeMin(start, end) && number < $12e6b098cd0820d0$var$nativeMax(start, end);
}
var $12e6b098cd0820d0$export$2e2bcd8739ae039 = $12e6b098cd0820d0$var$baseInRange;




/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */ function $b0ae69ebc65254b7$var$inRange(number, start, end) {
    start = (0, $d2765d8686dfd75d$export$2e2bcd8739ae039)(start);
    if (end === undefined) {
        end = start;
        start = 0;
    } else end = (0, $d2765d8686dfd75d$export$2e2bcd8739ae039)(end);
    number = (0, $294872e6ac32ced0$export$2e2bcd8739ae039)(number);
    return (0, $12e6b098cd0820d0$export$2e2bcd8739ae039)(number, start, end);
}
var $b0ae69ebc65254b7$export$2e2bcd8739ae039 = $b0ae69ebc65254b7$var$inRange;


/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $e674e119863ededc$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
var $e674e119863ededc$export$2e2bcd8739ae039 = $e674e119863ededc$var$head;





/**
 * Determines if a click's coordinates are within the bounds of a node.
 *
 * @see https://github.com/Semantic-Org/Semantic-UI-React/pull/2384
 *
 * @param {object} node - A DOM node.
 * @param {object} e - A SyntheticEvent or DOM Event.
 * @returns {boolean}
 */ var $6e0b9d13855575c4$var$doesNodeContainClick = function doesNodeContainClick(node, e) {
    if ((0, $ae0c709b40a9455c$export$2e2bcd8739ae039)([
        e,
        node
    ], (0, $9ef17f10bea17fe1$export$2e2bcd8739ae039))) return false; // if there is an e.target and it is in the document, use a simple node.contains() check
    if (e.target) {
        (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(e.target, 'setAttribute', 'data-suir-click-target', true);
        if (document.querySelector('[data-suir-click-target=true]')) {
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(e.target, 'removeAttribute', 'data-suir-click-target');
            return node.contains(e.target);
        }
    } // Below logic handles cases where the e.target is no longer in the document.
    // The result of the click likely has removed the e.target node.
    // Instead of node.contains(), we'll identify the click by X/Y position.
    // return early if the event properties aren't available
    // prevent measuring the node and repainting if we don't need to
    var clientX = e.clientX, clientY = e.clientY;
    if ((0, $ae0c709b40a9455c$export$2e2bcd8739ae039)([
        clientX,
        clientY
    ], (0, $9ef17f10bea17fe1$export$2e2bcd8739ae039))) return false; // false if the node is not visible
    var clientRects = node.getClientRects(); // Heads Up!
    // getClientRects returns a DOMRectList, not an array nor a plain object
    // We explicitly avoid _.isEmpty and check .length to cover all possible shapes
    if (!node.offsetWidth || !node.offsetHeight || !clientRects || !clientRects.length) return false; // false if the node doesn't have a valid bounding rect
    var _first2 = (0, $e674e119863ededc$export$2e2bcd8739ae039)(clientRects), top = _first2.top, bottom = _first2.bottom, left = _first2.left, right = _first2.right;
    if ((0, $ae0c709b40a9455c$export$2e2bcd8739ae039)([
        top,
        bottom,
        left,
        right
    ], (0, $9ef17f10bea17fe1$export$2e2bcd8739ae039))) return false; // we add a small decimal to the upper bound just to make it inclusive
    // don't add an whole pixel (1) as the event/node values may be decimal sensitive
    return (0, $b0ae69ebc65254b7$export$2e2bcd8739ae039)(clientY, top, bottom + 0.001) && (0, $b0ae69ebc65254b7$export$2e2bcd8739ae039)(clientX, left, right + 0.001);
};
var $6e0b9d13855575c4$export$2e2bcd8739ae039 = $6e0b9d13855575c4$var$doesNodeContainClick;


function $6b5019111a1a0b91$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}













var $6aRB8 = parcelRequire("6aRB8");
var $14f3bba04a1282e8$var$getDefaultPropName = function getDefaultPropName(prop) {
    return "default" + (prop[0].toUpperCase() + prop.slice(1));
};
/**
 * Return the auto controlled state value for a give prop. The initial value is chosen in this order:
 *  - regular props
 *  - then, default props
 *  - then, initial state
 *  - then, `checked` defaults to false
 *  - then, `value` defaults to '' or [] if props.multiple
 *  - else, undefined
 *
 *  @param {string} propName A prop name
 *  @param {object} [props] A props object
 *  @param {object} [state] A state object
 *  @param {boolean} [includeDefaults=false] Whether or not to heed the default props or initial state
 */ var $14f3bba04a1282e8$var$getAutoControlledStateValue = function getAutoControlledStateValue(propName, props, state, includeDefaults) {
    if (includeDefaults === void 0) includeDefaults = false;
    // regular props
    var propValue = props[propName];
    if (propValue !== undefined) return propValue;
    if (includeDefaults) {
        // defaultProps
        var defaultProp = props[$14f3bba04a1282e8$var$getDefaultPropName(propName)];
        if (defaultProp !== undefined) return defaultProp; // initial state - state may be null or undefined
        if (state) {
            var initialState = state[propName];
            if (initialState !== undefined) return initialState;
        }
    } // React doesn't allow changing from uncontrolled to controlled components,
    // default checked/value if they were not present.
    if (propName === 'checked') return false;
    if (propName === 'value') return props.multiple ? [] : ''; // otherwise, undefined
};
var $14f3bba04a1282e8$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(ModernAutoControlledComponent, _React$Component);
    function ModernAutoControlledComponent() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        var _this$constructor = _this.constructor, autoControlledProps = _this$constructor.autoControlledProps, getAutoControlledStateFromProps = _this$constructor.getAutoControlledStateFromProps;
        var state = (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)((0, $6b5019111a1a0b91$export$2e2bcd8739ae039)(_this), 'getInitialAutoControlledState', _this.props) || {};
        var _this$constructor2, defaultProps, name, propTypes, getDerivedStateFromProps, illegalDefaults, illegalAutoControlled;
        // Set initial state by copying auto controlled props to state.
        // Also look for the default prop for any auto controlled props (foo => defaultFoo)
        // so we can set initial values from defaults.
        var initialAutoControlledState = autoControlledProps.reduce(function(acc, prop) {
            acc[prop] = $14f3bba04a1282e8$var$getAutoControlledStateValue(prop, _this.props, state, true);
            var defaultPropName, _name;
            return acc;
        }, {});
        _this.state = (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, state, initialAutoControlledState, {
            autoControlledProps: autoControlledProps,
            getAutoControlledStateFromProps: getAutoControlledStateFromProps
        });
        return _this;
    }
    ModernAutoControlledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        var autoControlledProps = state.autoControlledProps, getAutoControlledStateFromProps = state.getAutoControlledStateFromProps; // Solve the next state for autoControlledProps
        var newStateFromProps = autoControlledProps.reduce(function(acc, prop) {
            var isNextDefined = !(0, $c38f68ed25e223ea$export$2e2bcd8739ae039)(props[prop]); // if next is defined then use its value
            if (isNextDefined) acc[prop] = props[prop];
            return acc;
        }, {}); // Due to the inheritance of the AutoControlledComponent we should call its
        // getAutoControlledStateFromProps() and merge it with the existing state
        if (getAutoControlledStateFromProps) {
            var computedState = getAutoControlledStateFromProps(props, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, state, newStateFromProps), state); // We should follow the idea of getDerivedStateFromProps() and return only modified state
            return (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, newStateFromProps, computedState);
        }
        return newStateFromProps;
    };
    ModernAutoControlledComponent.getAutoControlledStateFromProps = function getAutoControlledStateFromProps() {
        return null;
    };
    return ModernAutoControlledComponent;
}((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Component);








var $6aRB8 = parcelRequire("6aRB8");


/**
 * An inner component that allows you to render children outside their parent.
 */ var $97e0447f122b581a$var$PortalInner = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(PortalInner, _Component);
    function PortalInner() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.handleRef = function(c) {
            (0, $2b42f5a2eeaa6c35$export$5cc535d419e048c1)(_this.props.innerRef, c);
        };
        return _this;
    }
    var _proto = PortalInner.prototype;
    _proto.componentDidMount = function componentDidMount() {
        (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(this.props, 'onMount', null, this.props);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(this.props, 'onUnmount', null, this.props);
    };
    _proto.render = function render() {
        if (!(0, $227fe03b67c244b4$export$2e2bcd8739ae039)()) return null;
        var _this$props = this.props, children = _this$props.children, _this$props$mountNode = _this$props.mountNode, mountNode = _this$props$mountNode === void 0 ? document.body : _this$props$mountNode;
        return /*#__PURE__*/ (0, $f0d8bf13803656d4$exports.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c3c11b3db64bf060$export$9bcc32033bdd12aa), {
            innerRef: this.handleRef
        }, children), mountNode);
    };
    return PortalInner;
}((0, $6aRB8.Component));
$97e0447f122b581a$var$PortalInner.handledProps = [
    "children",
    "innerRef",
    "mountNode",
    "onMount",
    "onUnmount"
];
$97e0447f122b581a$var$PortalInner.propTypes = {};
var $97e0447f122b581a$export$2e2bcd8739ae039 = $97e0447f122b581a$var$PortalInner;


/**
 * A component that allows you to render children outside their parent.
 * @see Modal
 * @see Popup
 * @see Dimmer
 * @see Confirm
 */ var $bda4cebe3b5b4baa$var$Portal = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(Portal, _Component);
    function Portal() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.contentRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createRef();
        _this.triggerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createRef();
        _this.latestDocumentMouseDownEvent = null;
        _this.handleDocumentMouseDown = function(e) {
            _this.latestDocumentMouseDownEvent = e;
        };
        _this.handleDocumentClick = function(e) {
            var closeOnDocumentClick = _this.props.closeOnDocumentClick;
            var currentMouseDownEvent = _this.latestDocumentMouseDownEvent;
            _this.latestDocumentMouseDownEvent = null;
            if (!_this.contentRef.current || // no portal
            (0, $6e0b9d13855575c4$export$2e2bcd8739ae039)(_this.triggerRef.current, e) || // event happened in trigger (delegate to trigger handlers)
            currentMouseDownEvent && (0, $6e0b9d13855575c4$export$2e2bcd8739ae039)(_this.contentRef.current, currentMouseDownEvent) || // event originated in the portal but was ended outside
            (0, $6e0b9d13855575c4$export$2e2bcd8739ae039)(_this.contentRef.current, e) // event happened in the portal
            ) return;
             // ignore the click
            if (closeOnDocumentClick) _this.close(e);
        };
        _this.handleEscape = function(e) {
            if (!_this.props.closeOnEscape) return;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).getCode(e) !== (0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).Escape) return;
            _this.close(e);
        };
        _this.handlePortalMouseLeave = function(e) {
            var _this$props = _this.props, closeOnPortalMouseLeave = _this$props.closeOnPortalMouseLeave, mouseLeaveDelay = _this$props.mouseLeaveDelay;
            if (!closeOnPortalMouseLeave) return; // Do not close the portal when 'mouseleave' is triggered by children
            if (e.target !== _this.contentRef.current) return;
            _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
        };
        _this.handlePortalMouseEnter = function() {
            // In order to enable mousing from the trigger to the portal, we need to
            // clear the mouseleave timer that was set when leaving the trigger.
            var closeOnPortalMouseLeave = _this.props.closeOnPortalMouseLeave;
            if (!closeOnPortalMouseLeave) return;
            clearTimeout(_this.mouseLeaveTimer);
        };
        _this.handleTriggerBlur = function(e) {
            var _this$props2 = _this.props, trigger = _this$props2.trigger, closeOnTriggerBlur = _this$props2.closeOnTriggerBlur; // Call original event handler
            for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039).apply(void 0, [
                trigger,
                'props.onBlur',
                e
            ].concat(rest)); // IE 11 doesn't work with relatedTarget in blur events
            var target = e.relatedTarget || document.activeElement; // do not close if focus is given to the portal
            var didFocusPortal = (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.contentRef.current, 'contains', target);
            if (!closeOnTriggerBlur || didFocusPortal) return;
            _this.close(e);
        };
        _this.handleTriggerClick = function(e) {
            var _this$props3 = _this.props, trigger = _this$props3.trigger, closeOnTriggerClick = _this$props3.closeOnTriggerClick, openOnTriggerClick = _this$props3.openOnTriggerClick;
            var open = _this.state.open; // Call original event handler
            for(var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)rest[_key3 - 1] = arguments[_key3];
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039).apply(void 0, [
                trigger,
                'props.onClick',
                e
            ].concat(rest));
            if (open && closeOnTriggerClick) _this.close(e);
            else if (!open && openOnTriggerClick) _this.open(e);
        };
        _this.handleTriggerFocus = function(e) {
            var _this$props4 = _this.props, trigger = _this$props4.trigger, openOnTriggerFocus = _this$props4.openOnTriggerFocus; // Call original event handler
            for(var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)rest[_key4 - 1] = arguments[_key4];
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039).apply(void 0, [
                trigger,
                'props.onFocus',
                e
            ].concat(rest));
            if (!openOnTriggerFocus) return;
            _this.open(e);
        };
        _this.handleTriggerMouseLeave = function(e) {
            clearTimeout(_this.mouseEnterTimer);
            var _this$props5 = _this.props, trigger = _this$props5.trigger, closeOnTriggerMouseLeave = _this$props5.closeOnTriggerMouseLeave, mouseLeaveDelay = _this$props5.mouseLeaveDelay; // Call original event handler
            for(var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)rest[_key5 - 1] = arguments[_key5];
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039).apply(void 0, [
                trigger,
                'props.onMouseLeave',
                e
            ].concat(rest));
            if (!closeOnTriggerMouseLeave) return;
            _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
        };
        _this.handleTriggerMouseEnter = function(e) {
            clearTimeout(_this.mouseLeaveTimer);
            var _this$props6 = _this.props, trigger = _this$props6.trigger, mouseEnterDelay = _this$props6.mouseEnterDelay, openOnTriggerMouseEnter = _this$props6.openOnTriggerMouseEnter; // Call original event handler
            for(var _len6 = arguments.length, rest = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)rest[_key6 - 1] = arguments[_key6];
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039).apply(void 0, [
                trigger,
                'props.onMouseEnter',
                e
            ].concat(rest));
            if (!openOnTriggerMouseEnter) return;
            _this.mouseEnterTimer = _this.openWithTimeout(e, mouseEnterDelay);
        };
        _this.open = function(e) {
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onOpen', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                open: true
            }));
            _this.setState({
                open: true
            });
        };
        _this.openWithTimeout = function(e, delay) {
            // React wipes the entire event object and suggests using e.persist() if
            // you need the event for async access. However, even with e.persist
            // certain required props (e.g. currentTarget) are null so we're forced to clone.
            var eventClone = (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, e);
            return setTimeout(function() {
                return _this.open(eventClone);
            }, delay || 0);
        };
        _this.close = function(e) {
            _this.setState({
                open: false
            });
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onClose', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                open: false
            }));
        };
        _this.closeWithTimeout = function(e, delay) {
            // React wipes the entire event object and suggests using e.persist() if
            // you need the event for async access. However, even with e.persist
            // certain required props (e.g. currentTarget) are null so we're forced to clone.
            var eventClone = (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, e);
            return setTimeout(function() {
                return _this.close(eventClone);
            }, delay || 0);
        };
        _this.handleMount = function() {
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onMount', null, _this.props);
        };
        _this.handleUnmount = function() {
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onUnmount', null, _this.props);
        };
        _this.handleTriggerRef = function(c) {
            _this.triggerRef.current = c;
            (0, $2b42f5a2eeaa6c35$export$5cc535d419e048c1)(_this.props.triggerRef, c);
        };
        return _this;
    }
    var _proto = Portal.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        // Clean up timers
        clearTimeout(this.mouseEnterTimer);
        clearTimeout(this.mouseLeaveTimer);
    } // ----------------------------------------
    ;
    _proto.render = function render() {
        var _this$props7 = this.props, children = _this$props7.children, eventPool = _this$props7.eventPool, mountNode = _this$props7.mountNode, trigger = _this$props7.trigger;
        var open = this.state.open;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $97e0447f122b581a$export$2e2bcd8739ae039), {
            innerRef: this.contentRef,
            mountNode: mountNode,
            onMount: this.handleMount,
            onUnmount: this.handleUnmount
        }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d84a0216b5e1bcaf$exports))), {
            name: "mouseleave",
            on: this.handlePortalMouseLeave,
            pool: eventPool,
            target: this.contentRef
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d84a0216b5e1bcaf$exports))), {
            name: "mouseenter",
            on: this.handlePortalMouseEnter,
            pool: eventPool,
            target: this.contentRef
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d84a0216b5e1bcaf$exports))), {
            name: "mousedown",
            on: this.handleDocumentMouseDown,
            pool: eventPool
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d84a0216b5e1bcaf$exports))), {
            name: "click",
            on: this.handleDocumentClick,
            pool: eventPool
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d84a0216b5e1bcaf$exports))), {
            name: "keydown",
            on: this.handleEscape,
            pool: eventPool
        })), trigger && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c3c11b3db64bf060$export$9bcc32033bdd12aa), {
            innerRef: this.handleTriggerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).cloneElement(trigger, {
            onBlur: this.handleTriggerBlur,
            onClick: this.handleTriggerClick,
            onFocus: this.handleTriggerFocus,
            onMouseLeave: this.handleTriggerMouseLeave,
            onMouseEnter: this.handleTriggerMouseEnter
        })));
    };
    return Portal;
}((0, $14f3bba04a1282e8$export$2e2bcd8739ae039));
$bda4cebe3b5b4baa$var$Portal.handledProps = [
    "children",
    "closeOnDocumentClick",
    "closeOnEscape",
    "closeOnPortalMouseLeave",
    "closeOnTriggerBlur",
    "closeOnTriggerClick",
    "closeOnTriggerMouseLeave",
    "defaultOpen",
    "eventPool",
    "mountNode",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "onClose",
    "onMount",
    "onOpen",
    "onUnmount",
    "open",
    "openOnTriggerClick",
    "openOnTriggerFocus",
    "openOnTriggerMouseEnter",
    "trigger",
    "triggerRef"
];
$bda4cebe3b5b4baa$var$Portal.propTypes = {};
$bda4cebe3b5b4baa$var$Portal.defaultProps = {
    closeOnDocumentClick: true,
    closeOnEscape: true,
    eventPool: 'default',
    openOnTriggerClick: true
};
$bda4cebe3b5b4baa$var$Portal.autoControlledProps = [
    'open'
];
$bda4cebe3b5b4baa$var$Portal.Inner = (0, $97e0447f122b581a$export$2e2bcd8739ae039);
var $bda4cebe3b5b4baa$export$2e2bcd8739ae039 = $bda4cebe3b5b4baa$var$Portal;






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A dimmable sub-component for Dimmer.
 */ function $58f70fd95d94a21a$var$DimmerDimmable(props) {
    var blurring = props.blurring, className = props.className, children = props.children, content = props.content, dimmed = props.dimmed;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$aac7d417530cc39a)(blurring, 'blurring'), (0, $87a122667489288b$export$aac7d417530cc39a)(dimmed, 'dimmed'), 'dimmable', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($58f70fd95d94a21a$var$DimmerDimmable, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($58f70fd95d94a21a$var$DimmerDimmable, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$58f70fd95d94a21a$var$DimmerDimmable.handledProps = [
    "as",
    "blurring",
    "children",
    "className",
    "content",
    "dimmed"
];
$58f70fd95d94a21a$var$DimmerDimmable.propTypes = {};
var $58f70fd95d94a21a$export$2e2bcd8739ae039 = $58f70fd95d94a21a$var$DimmerDimmable;









var $6aRB8 = parcelRequire("6aRB8");

/**
 * An inner element for a Dimmer.
 */ var $fff3bfdc45f48e14$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(DimmerInner, _Component);
    function DimmerInner() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.containerRef = /*#__PURE__*/ (0, $6aRB8.createRef)();
        _this.contentRef = /*#__PURE__*/ (0, $6aRB8.createRef)();
        _this.handleClick = function(e) {
            var contentRef = _this.contentRef.current;
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onClick', e, _this.props);
            if (contentRef && contentRef !== e.target && (0, $6e0b9d13855575c4$export$2e2bcd8739ae039)(contentRef, e)) return;
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onClickOutside', e, _this.props);
        };
        return _this;
    }
    var _proto = DimmerInner.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var active = this.props.active;
        this.toggleStyles(active);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var currentActive = this.props.active;
        var prevActive = prevProps.active;
        if (prevActive !== currentActive) this.toggleStyles(currentActive);
    };
    _proto.toggleStyles = function toggleStyles(active) {
        var containerRef = this.containerRef.current;
        if (!containerRef || !containerRef.style) return;
        if (active) containerRef.style.setProperty('display', 'flex', 'important');
        else containerRef.style.removeProperty('display');
    };
    _proto.render = function render() {
        var _this$props = this.props, active = _this$props.active, children = _this$props.children, className = _this$props.className, content = _this$props.content, disabled = _this$props.disabled, inverted = _this$props.inverted, page = _this$props.page, simple = _this$props.simple, verticalAlign = _this$props.verticalAlign;
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', (0, $87a122667489288b$export$aac7d417530cc39a)(active, 'active transition visible'), (0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$aac7d417530cc39a)(inverted, 'inverted'), (0, $87a122667489288b$export$aac7d417530cc39a)(page, 'page'), (0, $87a122667489288b$export$aac7d417530cc39a)(simple, 'simple'), (0, $87a122667489288b$export$169652642bc5e2a1)(verticalAlign), 'dimmer', className);
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(DimmerInner, this.props);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(DimmerInner, this.props);
        var childrenContent = (0, $f0526af735e6584e$exports).isNil(children) ? content : children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c3c11b3db64bf060$export$9bcc32033bdd12aa), {
            innerRef: this.containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            className: classes,
            onClick: this.handleClick
        }), childrenContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("div", {
            className: "content",
            ref: this.contentRef
        }, childrenContent)));
    };
    return DimmerInner;
}((0, $6aRB8.Component));
$fff3bfdc45f48e14$export$2e2bcd8739ae039.handledProps = [
    "active",
    "as",
    "children",
    "className",
    "content",
    "disabled",
    "inverted",
    "onClick",
    "onClickOutside",
    "page",
    "simple",
    "verticalAlign"
];
$fff3bfdc45f48e14$export$2e2bcd8739ae039.propTypes = {};


/**
 * A dimmer hides distractions to focus attention on particular content.
 */ var $ecb3cf85b0a43b04$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(Dimmer, _Component);
    function Dimmer() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.handlePortalMount = function() {
            if (!(0, $227fe03b67c244b4$export$2e2bcd8739ae039)()) return; // Heads up, IE doesn't support second argument in add()
            document.body.classList.add('dimmed');
            document.body.classList.add('dimmable');
        };
        _this.handlePortalUnmount = function() {
            if (!(0, $227fe03b67c244b4$export$2e2bcd8739ae039)()) return; // Heads up, IE doesn't support second argument in add()
            document.body.classList.remove('dimmed');
            document.body.classList.remove('dimmable');
        };
        return _this;
    }
    var _proto = Dimmer.prototype;
    _proto.render = function render() {
        var _this$props = this.props, active = _this$props.active, page = _this$props.page;
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(Dimmer, this.props);
        if (page) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $bda4cebe3b5b4baa$export$2e2bcd8739ae039), {
            closeOnEscape: false,
            closeOnDocumentClick: false,
            onMount: this.handlePortalMount,
            onUnmount: this.handlePortalUnmount,
            open: active,
            openOnTriggerClick: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $fff3bfdc45f48e14$export$2e2bcd8739ae039), (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            active: active,
            page: page
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $fff3bfdc45f48e14$export$2e2bcd8739ae039), (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            active: active,
            page: page
        }));
    };
    return Dimmer;
}((0, $6aRB8.Component));
$ecb3cf85b0a43b04$export$2e2bcd8739ae039.handledProps = [
    "active",
    "page"
];
$ecb3cf85b0a43b04$export$2e2bcd8739ae039.propTypes = {};
$ecb3cf85b0a43b04$export$2e2bcd8739ae039.Dimmable = (0, $58f70fd95d94a21a$export$2e2bcd8739ae039);
$ecb3cf85b0a43b04$export$2e2bcd8739ae039.Inner = (0, $fff3bfdc45f48e14$export$2e2bcd8739ae039);
$ecb3cf85b0a43b04$export$2e2bcd8739ae039.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($ecb3cf85b0a43b04$export$2e2bcd8739ae039, function(value) {
    return {
        content: value
    };
});







var $6aRB8 = parcelRequire("6aRB8");

/**
 * A group of images.
 */ function $77f8727b4cfa5bce$var$ImageGroup(props) {
    var children = props.children, className = props.className, content = props.content, size = props.size;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', size, className, 'images');
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($77f8727b4cfa5bce$var$ImageGroup, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($77f8727b4cfa5bce$var$ImageGroup, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$77f8727b4cfa5bce$var$ImageGroup.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "size"
];
$77f8727b4cfa5bce$var$ImageGroup.propTypes = {};
var $77f8727b4cfa5bce$export$2e2bcd8739ae039 = $77f8727b4cfa5bce$var$ImageGroup;


/**
 * An image is a graphic representation of something.
 * @see Icon
 */ function $32f1a379a68c59a0$var$Image(props) {
    var avatar = props.avatar, bordered = props.bordered, centered = props.centered, children = props.children, circular = props.circular, className = props.className, content = props.content, dimmer = props.dimmer, disabled = props.disabled, floated = props.floated, fluid = props.fluid, hidden = props.hidden, href = props.href, inline = props.inline, label = props.label, rounded = props.rounded, size = props.size, spaced = props.spaced, verticalAlign = props.verticalAlign, wrapped = props.wrapped, ui = props.ui;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$aac7d417530cc39a)(ui, 'ui'), size, (0, $87a122667489288b$export$aac7d417530cc39a)(avatar, 'avatar'), (0, $87a122667489288b$export$aac7d417530cc39a)(bordered, 'bordered'), (0, $87a122667489288b$export$aac7d417530cc39a)(circular, 'circular'), (0, $87a122667489288b$export$aac7d417530cc39a)(centered, 'centered'), (0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$aac7d417530cc39a)(fluid, 'fluid'), (0, $87a122667489288b$export$aac7d417530cc39a)(hidden, 'hidden'), (0, $87a122667489288b$export$aac7d417530cc39a)(inline, 'inline'), (0, $87a122667489288b$export$aac7d417530cc39a)(rounded, 'rounded'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(spaced, 'spaced'), (0, $87a122667489288b$export$fb1b8744f6450628)(floated, 'floated'), (0, $87a122667489288b$export$169652642bc5e2a1)(verticalAlign, 'aligned'), 'image', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($32f1a379a68c59a0$var$Image, props);
    var _partitionHTMLProps = (0, $506c31eb45df8858$export$a0111cfe23fb429)(rest, {
        htmlProps: (0, $506c31eb45df8858$export$d0a09fb9099ece03)
    }), imgTagProps = _partitionHTMLProps[0], rootProps = _partitionHTMLProps[1];
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($32f1a379a68c59a0$var$Image, props, function() {
        if (!(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(dimmer) || !(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(label) || !(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(wrapped) || !(0, $f0526af735e6584e$exports).isNil(children)) return 'div';
    });
    if (!(0, $f0526af735e6584e$exports).isNil(children)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), children);
    if (!(0, $f0526af735e6584e$exports).isNil(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), content);
    if (ElementType === 'img') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rootProps, imgTagProps, {
        className: classes
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rootProps, {
        className: classes,
        href: href
    }), (0, $ecb3cf85b0a43b04$export$2e2bcd8739ae039).create(dimmer, {
        autoGenerateKey: false
    }), (0, $2f87e91a93ad1d2d$export$2e2bcd8739ae039).create(label, {
        autoGenerateKey: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("img", imgTagProps));
}
$32f1a379a68c59a0$var$Image.handledProps = [
    "as",
    "avatar",
    "bordered",
    "centered",
    "children",
    "circular",
    "className",
    "content",
    "dimmer",
    "disabled",
    "floated",
    "fluid",
    "hidden",
    "href",
    "inline",
    "label",
    "rounded",
    "size",
    "spaced",
    "ui",
    "verticalAlign",
    "wrapped"
];
$32f1a379a68c59a0$var$Image.Group = (0, $77f8727b4cfa5bce$export$2e2bcd8739ae039);
$32f1a379a68c59a0$var$Image.propTypes = {};
$32f1a379a68c59a0$var$Image.defaultProps = {
    as: 'img',
    ui: true
};
$32f1a379a68c59a0$var$Image.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($32f1a379a68c59a0$var$Image, function(value) {
    return {
        src: value
    };
});
var $32f1a379a68c59a0$export$2e2bcd8739ae039 = $32f1a379a68c59a0$var$Image;






var $6aRB8 = parcelRequire("6aRB8");

function $5841088248aa95b7$var$LabelDetail(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('detail', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($5841088248aa95b7$var$LabelDetail, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($5841088248aa95b7$var$LabelDetail, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$5841088248aa95b7$var$LabelDetail.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
$5841088248aa95b7$var$LabelDetail.propTypes = {};
$5841088248aa95b7$var$LabelDetail.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($5841088248aa95b7$var$LabelDetail, function(val) {
    return {
        content: val
    };
});
var $5841088248aa95b7$export$2e2bcd8739ae039 = $5841088248aa95b7$var$LabelDetail;






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A label can be grouped.
 */ function $6e0548622221afe0$var$LabelGroup(props) {
    var children = props.children, circular = props.circular, className = props.className, color = props.color, content = props.content, size = props.size, tag = props.tag;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', color, size, (0, $87a122667489288b$export$aac7d417530cc39a)(circular, 'circular'), (0, $87a122667489288b$export$aac7d417530cc39a)(tag, 'tag'), 'labels', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($6e0548622221afe0$var$LabelGroup, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($6e0548622221afe0$var$LabelGroup, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$6e0548622221afe0$var$LabelGroup.handledProps = [
    "as",
    "children",
    "circular",
    "className",
    "color",
    "content",
    "size",
    "tag"
];
$6e0548622221afe0$var$LabelGroup.propTypes = {};
var $6e0548622221afe0$export$2e2bcd8739ae039 = $6e0548622221afe0$var$LabelGroup;


/**
 * A label displays content classification.
 */ var $2f87e91a93ad1d2d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(Label, _Component);
    function Label() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.handleClick = function(e) {
            var onClick = _this.props.onClick;
            if (onClick) onClick(e, _this.props);
        };
        _this.handleIconOverrides = function(predefinedProps) {
            return {
                onClick: function onClick(e) {
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(predefinedProps, 'onClick', e);
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onRemove', e, _this.props);
                }
            };
        };
        return _this;
    }
    var _proto = Label.prototype;
    _proto.render = function render() {
        var _this$props = this.props, active = _this$props.active, attached = _this$props.attached, basic = _this$props.basic, children = _this$props.children, circular = _this$props.circular, className = _this$props.className, color = _this$props.color, content = _this$props.content, corner = _this$props.corner, detail = _this$props.detail, empty = _this$props.empty, floating = _this$props.floating, horizontal = _this$props.horizontal, icon = _this$props.icon, image = _this$props.image, onRemove = _this$props.onRemove, pointing = _this$props.pointing, prompt = _this$props.prompt, removeIcon = _this$props.removeIcon, ribbon = _this$props.ribbon, size = _this$props.size, tag = _this$props.tag;
        var pointingClass = pointing === true && 'pointing' || (pointing === 'left' || pointing === 'right') && pointing + " pointing" || (pointing === 'above' || pointing === 'below') && "pointing " + pointing;
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', color, pointingClass, size, (0, $87a122667489288b$export$aac7d417530cc39a)(active, 'active'), (0, $87a122667489288b$export$aac7d417530cc39a)(basic, 'basic'), (0, $87a122667489288b$export$aac7d417530cc39a)(circular, 'circular'), (0, $87a122667489288b$export$aac7d417530cc39a)(empty, 'empty'), (0, $87a122667489288b$export$aac7d417530cc39a)(floating, 'floating'), (0, $87a122667489288b$export$aac7d417530cc39a)(horizontal, 'horizontal'), (0, $87a122667489288b$export$aac7d417530cc39a)(image === true, 'image'), (0, $87a122667489288b$export$aac7d417530cc39a)(prompt, 'prompt'), (0, $87a122667489288b$export$aac7d417530cc39a)(tag, 'tag'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(corner, 'corner'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(ribbon, 'ribbon'), (0, $87a122667489288b$export$fb1b8744f6450628)(attached, 'attached'), 'label', className);
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(Label, this.props);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(Label, this.props);
        if (!(0, $f0526af735e6584e$exports).isNil(children)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            className: classes,
            onClick: this.handleClick
        }), children);
        var removeIconShorthand = (0, $c38f68ed25e223ea$export$2e2bcd8739ae039)(removeIcon) ? 'delete' : removeIcon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({
            className: classes,
            onClick: this.handleClick
        }, rest), (0, $760d0282e0637aa7$export$2e2bcd8739ae039).create(icon, {
            autoGenerateKey: false
        }), typeof image !== 'boolean' && (0, $32f1a379a68c59a0$export$2e2bcd8739ae039).create(image, {
            autoGenerateKey: false
        }), content, (0, $5841088248aa95b7$export$2e2bcd8739ae039).create(detail, {
            autoGenerateKey: false
        }), onRemove && (0, $760d0282e0637aa7$export$2e2bcd8739ae039).create(removeIconShorthand, {
            autoGenerateKey: false,
            overrideProps: this.handleIconOverrides
        }));
    };
    return Label;
}((0, $6aRB8.Component));
$2f87e91a93ad1d2d$export$2e2bcd8739ae039.handledProps = [
    "active",
    "as",
    "attached",
    "basic",
    "children",
    "circular",
    "className",
    "color",
    "content",
    "corner",
    "detail",
    "empty",
    "floating",
    "horizontal",
    "icon",
    "image",
    "onClick",
    "onRemove",
    "pointing",
    "prompt",
    "removeIcon",
    "ribbon",
    "size",
    "tag"
];
$2f87e91a93ad1d2d$export$2e2bcd8739ae039.propTypes = {};
$2f87e91a93ad1d2d$export$2e2bcd8739ae039.Detail = (0, $5841088248aa95b7$export$2e2bcd8739ae039);
$2f87e91a93ad1d2d$export$2e2bcd8739ae039.Group = (0, $6e0548622221afe0$export$2e2bcd8739ae039);
$2f87e91a93ad1d2d$export$2e2bcd8739ae039.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($2f87e91a93ad1d2d$export$2e2bcd8739ae039, function(value) {
    return {
        content: value
    };
});






var $6aRB8 = parcelRequire("6aRB8");

/**
 * Used in some Button types, such as `animated`.
 */ function $3edf5ecc703487c0$var$ButtonContent(props) {
    var children = props.children, className = props.className, content = props.content, hidden = props.hidden, visible = props.visible;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$aac7d417530cc39a)(visible, 'visible'), (0, $87a122667489288b$export$aac7d417530cc39a)(hidden, 'hidden'), 'content', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($3edf5ecc703487c0$var$ButtonContent, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($3edf5ecc703487c0$var$ButtonContent, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$3edf5ecc703487c0$var$ButtonContent.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "hidden",
    "visible"
];
$3edf5ecc703487c0$var$ButtonContent.propTypes = {};
var $3edf5ecc703487c0$export$2e2bcd8739ae039 = $3edf5ecc703487c0$var$ButtonContent;







/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $900c2b6d1f211769$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $a49bb6f04e0bbcec$export$2e2bcd8739ae039)(collection) ? Array(collection.length) : [];
    (0, $20b772a907d94404$export$2e2bcd8739ae039)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $900c2b6d1f211769$export$2e2bcd8739ae039 = $900c2b6d1f211769$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $2ef0baf102d48982$var$map(collection, iteratee) {
    var func = (0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(collection) ? (0, $736434a056fc3928$export$2e2bcd8739ae039) : (0, $900c2b6d1f211769$export$2e2bcd8739ae039);
    return func(collection, (0, $3aff02699eb74261$export$2e2bcd8739ae039)(iteratee, 3));
}
var $2ef0baf102d48982$export$2e2bcd8739ae039 = $2ef0baf102d48982$var$map;






var $6aRB8 = parcelRequire("6aRB8");


/**
 * Buttons can be grouped.
 */ function $54670c2a9149b939$var$ButtonGroup(props) {
    var attached = props.attached, basic = props.basic, buttons = props.buttons, children = props.children, className = props.className, color = props.color, compact = props.compact, content = props.content, floated = props.floated, fluid = props.fluid, icon = props.icon, inverted = props.inverted, labeled = props.labeled, negative = props.negative, positive = props.positive, primary = props.primary, secondary = props.secondary, size = props.size, toggle = props.toggle, vertical = props.vertical, widths = props.widths;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', color, size, (0, $87a122667489288b$export$aac7d417530cc39a)(basic, 'basic'), (0, $87a122667489288b$export$aac7d417530cc39a)(compact, 'compact'), (0, $87a122667489288b$export$aac7d417530cc39a)(fluid, 'fluid'), (0, $87a122667489288b$export$aac7d417530cc39a)(icon, 'icon'), (0, $87a122667489288b$export$aac7d417530cc39a)(inverted, 'inverted'), (0, $87a122667489288b$export$aac7d417530cc39a)(labeled, 'labeled'), (0, $87a122667489288b$export$aac7d417530cc39a)(negative, 'negative'), (0, $87a122667489288b$export$aac7d417530cc39a)(positive, 'positive'), (0, $87a122667489288b$export$aac7d417530cc39a)(primary, 'primary'), (0, $87a122667489288b$export$aac7d417530cc39a)(secondary, 'secondary'), (0, $87a122667489288b$export$aac7d417530cc39a)(toggle, 'toggle'), (0, $87a122667489288b$export$aac7d417530cc39a)(vertical, 'vertical'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(attached, 'attached'), (0, $87a122667489288b$export$fb1b8744f6450628)(floated, 'floated'), (0, $87a122667489288b$export$52866a87b538f23c)(widths), 'buttons', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($54670c2a9149b939$var$ButtonGroup, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($54670c2a9149b939$var$ButtonGroup, props);
    if ((0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(buttons)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $2ef0baf102d48982$export$2e2bcd8739ae039)(buttons, function(button) {
        return (0, $a7825a90230ff993$export$2e2bcd8739ae039).create(button);
    }));
}
$54670c2a9149b939$var$ButtonGroup.handledProps = [
    "as",
    "attached",
    "basic",
    "buttons",
    "children",
    "className",
    "color",
    "compact",
    "content",
    "floated",
    "fluid",
    "icon",
    "inverted",
    "labeled",
    "negative",
    "positive",
    "primary",
    "secondary",
    "size",
    "toggle",
    "vertical",
    "widths"
];
$54670c2a9149b939$var$ButtonGroup.propTypes = {};
var $54670c2a9149b939$export$2e2bcd8739ae039 = $54670c2a9149b939$var$ButtonGroup;






var $6aRB8 = parcelRequire("6aRB8");

/**
 * Button groups can contain conditionals.
 */ function $21f5ec20fa8bcef4$var$ButtonOr(props) {
    var className = props.className, text = props.text;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('or', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($21f5ec20fa8bcef4$var$ButtonOr, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($21f5ec20fa8bcef4$var$ButtonOr, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes,
        "data-text": text
    }));
}
$21f5ec20fa8bcef4$var$ButtonOr.handledProps = [
    "as",
    "className",
    "text"
];
$21f5ec20fa8bcef4$var$ButtonOr.propTypes = {};
var $21f5ec20fa8bcef4$export$2e2bcd8739ae039 = $21f5ec20fa8bcef4$var$ButtonOr;


/**
 * A Button indicates a possible user action.
 * @see Form
 * @see Icon
 * @see Label
 */ var $a7825a90230ff993$var$Button = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(Button, _Component);
    function Button() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.ref = /*#__PURE__*/ (0, $6aRB8.createRef)();
        _this.computeElementType = function() {
            var _this$props = _this.props, attached = _this$props.attached, label = _this$props.label;
            if (!(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(attached) || !(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(label)) return 'div';
        };
        _this.computeTabIndex = function(ElementType) {
            var _this$props2 = _this.props, disabled = _this$props2.disabled, tabIndex = _this$props2.tabIndex;
            if (!(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(tabIndex)) return tabIndex;
            if (disabled) return -1;
            if (ElementType === 'div') return 0;
        };
        _this.focus = function(options) {
            return (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.ref.current, 'focus', options);
        };
        _this.handleClick = function(e) {
            var disabled = _this.props.disabled;
            if (disabled) {
                e.preventDefault();
                return;
            }
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onClick', e, _this.props);
        };
        _this.hasIconClass = function() {
            var _this$props3 = _this.props, labelPosition = _this$props3.labelPosition, children = _this$props3.children, content = _this$props3.content, icon = _this$props3.icon;
            if (icon === true) return true;
            return icon && (labelPosition || (0, $f0526af735e6584e$exports).isNil(children) && (0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(content));
        };
        return _this;
    }
    var _proto = Button.prototype;
    _proto.computeButtonAriaRole = function computeButtonAriaRole(ElementType) {
        var role = this.props.role;
        if (!(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(role)) return role;
        if (ElementType !== 'button') return 'button';
    };
    _proto.render = function render() {
        var _this$props4 = this.props, active = _this$props4.active, animated = _this$props4.animated, attached = _this$props4.attached, basic = _this$props4.basic, children = _this$props4.children, circular = _this$props4.circular, className = _this$props4.className, color = _this$props4.color, compact = _this$props4.compact, content = _this$props4.content, disabled = _this$props4.disabled, floated = _this$props4.floated, fluid = _this$props4.fluid, icon = _this$props4.icon, inverted = _this$props4.inverted, label = _this$props4.label, labelPosition = _this$props4.labelPosition, loading = _this$props4.loading, negative = _this$props4.negative, positive = _this$props4.positive, primary = _this$props4.primary, secondary = _this$props4.secondary, size = _this$props4.size, toggle = _this$props4.toggle, type = _this$props4.type;
        var baseClasses = (0, $b589707e9204a564$export$2e2bcd8739ae039)(color, size, (0, $87a122667489288b$export$aac7d417530cc39a)(active, 'active'), (0, $87a122667489288b$export$aac7d417530cc39a)(basic, 'basic'), (0, $87a122667489288b$export$aac7d417530cc39a)(circular, 'circular'), (0, $87a122667489288b$export$aac7d417530cc39a)(compact, 'compact'), (0, $87a122667489288b$export$aac7d417530cc39a)(fluid, 'fluid'), (0, $87a122667489288b$export$aac7d417530cc39a)(this.hasIconClass(), 'icon'), (0, $87a122667489288b$export$aac7d417530cc39a)(inverted, 'inverted'), (0, $87a122667489288b$export$aac7d417530cc39a)(loading, 'loading'), (0, $87a122667489288b$export$aac7d417530cc39a)(negative, 'negative'), (0, $87a122667489288b$export$aac7d417530cc39a)(positive, 'positive'), (0, $87a122667489288b$export$aac7d417530cc39a)(primary, 'primary'), (0, $87a122667489288b$export$aac7d417530cc39a)(secondary, 'secondary'), (0, $87a122667489288b$export$aac7d417530cc39a)(toggle, 'toggle'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(animated, 'animated'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(attached, 'attached'));
        var labeledClasses = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$72ebbc0b2506f7f8)(labelPosition || !!label, 'labeled'));
        var wrapperClasses = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$fb1b8744f6450628)(floated, 'floated'));
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(Button, this.props);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(Button, this.props, this.computeElementType);
        var tabIndex = this.computeTabIndex(ElementType);
        if (!(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(label)) {
            var buttonClasses = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', baseClasses, 'button', className);
            var containerClasses = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', labeledClasses, 'button', className, wrapperClasses);
            var labelElement = (0, $2f87e91a93ad1d2d$export$2e2bcd8739ae039).create(label, {
                defaultProps: {
                    basic: true,
                    pointing: labelPosition === 'left' ? 'right' : 'left'
                },
                autoGenerateKey: false
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
                className: containerClasses,
                onClick: this.handleClick
            }), labelPosition === 'left' && labelElement, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c3c11b3db64bf060$export$9bcc32033bdd12aa), {
                innerRef: this.ref
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("button", {
                className: buttonClasses,
                "aria-pressed": toggle ? !!active : undefined,
                disabled: disabled,
                type: type,
                tabIndex: tabIndex
            }, (0, $760d0282e0637aa7$export$2e2bcd8739ae039).create(icon, {
                autoGenerateKey: false
            }), " ", content)), (labelPosition === 'right' || !labelPosition) && labelElement);
        }
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', baseClasses, wrapperClasses, labeledClasses, 'button', className);
        var hasChildren = !(0, $f0526af735e6584e$exports).isNil(children);
        var role = this.computeButtonAriaRole(ElementType);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c3c11b3db64bf060$export$9bcc32033bdd12aa), {
            innerRef: this.ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            className: classes,
            "aria-pressed": toggle ? !!active : undefined,
            disabled: disabled && ElementType === 'button' || undefined,
            onClick: this.handleClick,
            role: role,
            type: type,
            tabIndex: tabIndex
        }), hasChildren && children, !hasChildren && (0, $760d0282e0637aa7$export$2e2bcd8739ae039).create(icon, {
            autoGenerateKey: false
        }), !hasChildren && content));
    };
    return Button;
}((0, $6aRB8.Component));
$a7825a90230ff993$var$Button.handledProps = [
    "active",
    "animated",
    "as",
    "attached",
    "basic",
    "children",
    "circular",
    "className",
    "color",
    "compact",
    "content",
    "disabled",
    "floated",
    "fluid",
    "icon",
    "inverted",
    "label",
    "labelPosition",
    "loading",
    "negative",
    "onClick",
    "positive",
    "primary",
    "role",
    "secondary",
    "size",
    "tabIndex",
    "toggle",
    "type"
];
$a7825a90230ff993$var$Button.propTypes = {};
$a7825a90230ff993$var$Button.defaultProps = {
    as: 'button'
};
$a7825a90230ff993$var$Button.Content = (0, $3edf5ecc703487c0$export$2e2bcd8739ae039);
$a7825a90230ff993$var$Button.Group = (0, $54670c2a9149b939$export$2e2bcd8739ae039);
$a7825a90230ff993$var$Button.Or = (0, $21f5ec20fa8bcef4$export$2e2bcd8739ae039);
$a7825a90230ff993$var$Button.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($a7825a90230ff993$var$Button, function(value) {
    return {
        content: value
    };
});
var $a7825a90230ff993$export$2e2bcd8739ae039 = $a7825a90230ff993$var$Button;





var $6aRB8 = parcelRequire("6aRB8");

/**
 * A divider visually segments content into groups.
 */ function $f11325917db9c363$var$Divider(props) {
    var children = props.children, className = props.className, clearing = props.clearing, content = props.content, fitted = props.fitted, hidden = props.hidden, horizontal = props.horizontal, inverted = props.inverted, section = props.section, vertical = props.vertical;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', (0, $87a122667489288b$export$aac7d417530cc39a)(clearing, 'clearing'), (0, $87a122667489288b$export$aac7d417530cc39a)(fitted, 'fitted'), (0, $87a122667489288b$export$aac7d417530cc39a)(hidden, 'hidden'), (0, $87a122667489288b$export$aac7d417530cc39a)(horizontal, 'horizontal'), (0, $87a122667489288b$export$aac7d417530cc39a)(inverted, 'inverted'), (0, $87a122667489288b$export$aac7d417530cc39a)(section, 'section'), (0, $87a122667489288b$export$aac7d417530cc39a)(vertical, 'vertical'), 'divider', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($f11325917db9c363$var$Divider, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($f11325917db9c363$var$Divider, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$f11325917db9c363$var$Divider.handledProps = [
    "as",
    "children",
    "className",
    "clearing",
    "content",
    "fitted",
    "hidden",
    "horizontal",
    "inverted",
    "section",
    "vertical"
];
$f11325917db9c363$var$Divider.propTypes = {};
var $f11325917db9c363$export$2e2bcd8739ae039 = $f11325917db9c363$var$Divider;








var $6aRB8 = parcelRequire("6aRB8");




var $6aRB8 = parcelRequire("6aRB8");








var $6aRB8 = parcelRequire("6aRB8");





/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $41bb0c5bccfba2d9$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $9c831147253bd1f8$export$2e2bcd8739ae039)) (0, $9c831147253bd1f8$export$2e2bcd8739ae039)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $41bb0c5bccfba2d9$export$2e2bcd8739ae039 = $41bb0c5bccfba2d9$var$baseAssignValue;



/** Used for built-in method references. */ var $70ed42946302dc78$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $70ed42946302dc78$var$hasOwnProperty = $70ed42946302dc78$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $70ed42946302dc78$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($70ed42946302dc78$var$hasOwnProperty.call(object, key) && (0, $1ade0d9409bf4c31$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $41bb0c5bccfba2d9$export$2e2bcd8739ae039)(object, key, value);
}
var $70ed42946302dc78$export$2e2bcd8739ae039 = $70ed42946302dc78$var$assignValue;






/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $b57656294bf78199$var$baseSet(object, path, value, customizer) {
    if (!(0, $d9b4f47c9ea17ede$export$2e2bcd8739ae039)(object)) return object;
    path = (0, $9ab94d97aa9e786d$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = (0, $4367555bb6328d41$export$2e2bcd8739ae039)(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = (0, $d9b4f47c9ea17ede$export$2e2bcd8739ae039)(objValue) ? objValue : (0, $2d3931d505c8ac33$export$2e2bcd8739ae039)(path[index + 1]) ? [] : {};
        }
        (0, $70ed42946302dc78$export$2e2bcd8739ae039)(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
var $b57656294bf78199$export$2e2bcd8739ae039 = $b57656294bf78199$var$baseSet;


/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $2abade96b8d4efaa$var$set(object, path, value) {
    return object == null ? object : (0, $b57656294bf78199$export$2e2bcd8739ae039)(object, path, value);
}
var $2abade96b8d4efaa$export$2e2bcd8739ae039 = $2abade96b8d4efaa$var$set;









var $6aRB8 = parcelRequire("6aRB8");

/**
 * A checkbox allows a user to select a value from a small set of options, often binary.
 * @see Form
 * @see Radio
 */ var $a4dfa44f3ad67085$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(Checkbox, _Component);
    function Checkbox() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.inputRef = /*#__PURE__*/ (0, $6aRB8.createRef)();
        _this.labelRef = /*#__PURE__*/ (0, $6aRB8.createRef)();
        _this.canToggle = function() {
            var _this$props = _this.props, disabled = _this$props.disabled, radio = _this$props.radio, readOnly = _this$props.readOnly;
            var checked = _this.state.checked;
            return !disabled && !readOnly && !(radio && checked);
        };
        _this.computeTabIndex = function() {
            var _this$props2 = _this.props, disabled = _this$props2.disabled, tabIndex = _this$props2.tabIndex;
            if (!(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(tabIndex)) return tabIndex;
            return disabled ? -1 : 0;
        };
        _this.handleClick = function(e) {
            var id = _this.props.id;
            var _this$state = _this.state, checked = _this$state.checked, indeterminate = _this$state.indeterminate;
            var isInputClick = (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.inputRef.current, 'contains', e.target);
            var isLabelClick = (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.labelRef.current, 'contains', e.target);
            var isRootClick = !isLabelClick && !isInputClick;
            var hasId = !(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(id);
            var isLabelClickAndForwardedToInput = isLabelClick && hasId; // https://github.com/Semantic-Org/Semantic-UI-React/pull/3351
            if (!isLabelClickAndForwardedToInput) (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onClick', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                checked: !checked,
                indeterminate: !!indeterminate
            }));
            if (_this.isClickFromMouse) {
                _this.isClickFromMouse = false;
                if (isLabelClick && !hasId) _this.handleChange(e);
                 // Changes should be triggered for the slider variation
                if (isRootClick) _this.handleChange(e);
                if (isLabelClick && hasId) // To prevent two clicks from being fired from the component we have to stop the propagation
                // from the "input" click: https://github.com/Semantic-Org/Semantic-UI-React/issues/3433
                e.stopPropagation();
            }
        };
        _this.handleChange = function(e) {
            var checked = _this.state.checked;
            if (!_this.canToggle()) return;
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onChange', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                checked: !checked,
                indeterminate: false
            }));
            _this.setState({
                checked: !checked,
                indeterminate: false
            });
        };
        _this.handleMouseDown = function(e) {
            var _this$state2 = _this.state, checked = _this$state2.checked, indeterminate = _this$state2.indeterminate;
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onMouseDown', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                checked: !!checked,
                indeterminate: !!indeterminate
            }));
            if (!e.defaultPrevented) (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.inputRef.current, 'focus');
             // Heads up!
            // We need to call "preventDefault" to keep element focused.
            e.preventDefault();
        };
        _this.handleMouseUp = function(e) {
            var _this$state3 = _this.state, checked = _this$state3.checked, indeterminate = _this$state3.indeterminate;
            _this.isClickFromMouse = true;
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onMouseUp', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                checked: !!checked,
                indeterminate: !!indeterminate
            }));
        };
        _this.setIndeterminate = function() {
            var indeterminate = _this.state.indeterminate;
            (0, $2abade96b8d4efaa$export$2e2bcd8739ae039)(_this.inputRef, 'current.indeterminate', !!indeterminate);
        };
        return _this;
    }
    var _proto = Checkbox.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.setIndeterminate();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        this.setIndeterminate();
    };
    _proto.render = function render() {
        var _this$props3 = this.props, className = _this$props3.className, disabled = _this$props3.disabled, label = _this$props3.label, id = _this$props3.id, name = _this$props3.name, radio = _this$props3.radio, readOnly = _this$props3.readOnly, slider = _this$props3.slider, toggle = _this$props3.toggle, type = _this$props3.type, value = _this$props3.value;
        var _this$state4 = this.state, checked = _this$state4.checked, indeterminate = _this$state4.indeterminate;
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', (0, $87a122667489288b$export$aac7d417530cc39a)(checked, 'checked'), (0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$aac7d417530cc39a)(indeterminate, 'indeterminate'), // https://semantic-ui.com/modules/checkbox.html#fitted
        (0, $87a122667489288b$export$aac7d417530cc39a)((0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(label), 'fitted'), (0, $87a122667489288b$export$aac7d417530cc39a)(radio, 'radio'), (0, $87a122667489288b$export$aac7d417530cc39a)(readOnly, 'read-only'), (0, $87a122667489288b$export$aac7d417530cc39a)(slider, 'slider'), (0, $87a122667489288b$export$aac7d417530cc39a)(toggle, 'toggle'), 'checkbox', className);
        var unhandled = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(Checkbox, this.props);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(Checkbox, this.props);
        var _partitionHTMLProps = (0, $506c31eb45df8858$export$a0111cfe23fb429)(unhandled, {
            htmlProps: (0, $506c31eb45df8858$export$e6d74d6a93e99692)
        }), htmlInputProps = _partitionHTMLProps[0], rest = _partitionHTMLProps[1]; // Heads Up!
        // Do not remove empty labels, they are required by SUI CSS
        var labelElement = (0, $d590e40415a777e8$export$6f84ed4ee6b024a3)(label, {
            defaultProps: {
                htmlFor: id
            },
            autoGenerateKey: false
        }) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("label", {
            htmlFor: id
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            className: classes,
            onClick: this.handleClick,
            onChange: this.handleChange,
            onMouseDown: this.handleMouseDown,
            onMouseUp: this.handleMouseUp
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c3c11b3db64bf060$export$9bcc32033bdd12aa), {
            innerRef: this.inputRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("input", (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, htmlInputProps, {
            checked: checked,
            className: "hidden",
            disabled: disabled,
            id: id,
            name: name,
            readOnly: true,
            tabIndex: this.computeTabIndex(),
            type: type,
            value: value
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c3c11b3db64bf060$export$9bcc32033bdd12aa), {
            innerRef: this.labelRef
        }, labelElement));
    };
    return Checkbox;
}((0, $14f3bba04a1282e8$export$2e2bcd8739ae039));
$a4dfa44f3ad67085$export$2e2bcd8739ae039.handledProps = [
    "as",
    "checked",
    "className",
    "defaultChecked",
    "defaultIndeterminate",
    "disabled",
    "fitted",
    "id",
    "indeterminate",
    "label",
    "name",
    "onChange",
    "onClick",
    "onMouseDown",
    "onMouseUp",
    "radio",
    "readOnly",
    "slider",
    "tabIndex",
    "toggle",
    "type",
    "value"
];
$a4dfa44f3ad67085$export$2e2bcd8739ae039.propTypes = {};
$a4dfa44f3ad67085$export$2e2bcd8739ae039.defaultProps = {
    type: 'checkbox'
};
$a4dfa44f3ad67085$export$2e2bcd8739ae039.autoControlledProps = [
    'checked',
    'indeterminate'
];




var $6aRB8 = parcelRequire("6aRB8");


/**
 * A Radio is sugar for <Checkbox radio />.
 * Useful for exclusive groups of sliders or toggles.
 * @see Checkbox
 * @see Form
 */ function $27eaca9c2794488d$var$Radio(props) {
    var slider = props.slider, toggle = props.toggle, type = props.type;
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($27eaca9c2794488d$var$Radio, props); // const ElementType = getElementType(Radio, props)
    // radio, slider, toggle are exclusive
    // use an undefined radio if slider or toggle are present
    var radio = !(slider || toggle) || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $a4dfa44f3ad67085$export$2e2bcd8739ae039), (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        type: type,
        radio: radio,
        slider: slider,
        toggle: toggle
    }));
}
$27eaca9c2794488d$var$Radio.handledProps = [
    "slider",
    "toggle",
    "type"
];
$27eaca9c2794488d$var$Radio.propTypes = {};
$27eaca9c2794488d$var$Radio.defaultProps = {
    type: 'radio'
};
var $27eaca9c2794488d$export$2e2bcd8739ae039 = $27eaca9c2794488d$var$Radio;


/**
 * A field is a form element containing a label and an input.
 * @see Form
 * @see Button
 * @see Checkbox
 * @see Dropdown
 * @see Input
 * @see Radio
 * @see Select
 * @see Visibility
 */ function $19186099d0926d92$var$FormField(props) {
    var children = props.children, className = props.className, content = props.content, control = props.control, disabled = props.disabled, error = props.error, inline = props.inline, label = props.label, required = props.required, type = props.type, width = props.width, id = props.id;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$aac7d417530cc39a)(error, 'error'), (0, $87a122667489288b$export$aac7d417530cc39a)(inline, 'inline'), (0, $87a122667489288b$export$aac7d417530cc39a)(required, 'required'), (0, $87a122667489288b$export$52866a87b538f23c)(width, 'wide'), 'field', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($19186099d0926d92$var$FormField, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($19186099d0926d92$var$FormField, props);
    var errorPointing = (0, $4b263473fff5783f$export$2e2bcd8739ae039)(error, 'pointing', 'above');
    var errorLabel = (0, $2f87e91a93ad1d2d$export$2e2bcd8739ae039).create(error, {
        autoGenerateKey: false,
        defaultProps: {
            prompt: true,
            pointing: errorPointing,
            id: id ? id + "-error-message" : undefined,
            role: 'alert',
            'aria-atomic': true
        }
    });
    var errorLabelBefore = (errorPointing === 'below' || errorPointing === 'right') && errorLabel;
    var errorLabelAfter = (errorPointing === 'above' || errorPointing === 'left') && errorLabel; // ----------------------------------------
    // No Control
    // ----------------------------------------
    if ((0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(control)) {
        if ((0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            className: classes,
            id: id
        }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            className: classes,
            id: id
        }), errorLabelBefore, (0, $d590e40415a777e8$export$6f84ed4ee6b024a3)(label, {
            autoGenerateKey: false
        }), errorLabelAfter);
    } // ----------------------------------------
    // Checkbox/Radio Control
    // ----------------------------------------
    var ariaDescribedBy = id && error ? id + "-error-message" : null;
    var ariaAttrs = {
        'aria-describedby': ariaDescribedBy,
        'aria-invalid': error ? true : undefined
    };
    var controlProps = (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        content: content,
        children: children,
        disabled: disabled,
        required: required,
        type: type,
        id: id
    }); // wrap HTML checkboxes/radios in the label
    if (control === 'input' && (type === 'checkbox' || type === 'radio')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, {
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("label", null, errorLabelBefore, /*#__PURE__*/ (0, $6aRB8.createElement)(control, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, ariaAttrs, controlProps)), " ", label, errorLabelAfter));
     // pass label prop to controls that support it
    if (control === (0, $a4dfa44f3ad67085$export$2e2bcd8739ae039) || control === (0, $27eaca9c2794488d$export$2e2bcd8739ae039)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, {
        className: classes
    }, errorLabelBefore, /*#__PURE__*/ (0, $6aRB8.createElement)(control, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, ariaAttrs, controlProps, {
        label: label
    })), errorLabelAfter);
     // ----------------------------------------
    // Other Control
    // ----------------------------------------
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, {
        className: classes
    }, (0, $d590e40415a777e8$export$6f84ed4ee6b024a3)(label, {
        defaultProps: {
            htmlFor: id
        },
        autoGenerateKey: false
    }), errorLabelBefore, /*#__PURE__*/ (0, $6aRB8.createElement)(control, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, ariaAttrs, controlProps)), errorLabelAfter);
}
$19186099d0926d92$var$FormField.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "control",
    "disabled",
    "error",
    "id",
    "inline",
    "label",
    "required",
    "type",
    "width"
];
$19186099d0926d92$var$FormField.propTypes = {};
var $19186099d0926d92$export$2e2bcd8739ae039 = $19186099d0926d92$var$FormField;


/**
 * Sugar for <Form.Field control={Button} />.
 * @see Button
 * @see Form
 */ function $54ebb874bb85cae3$var$FormButton(props) {
    var control = props.control;
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($54ebb874bb85cae3$var$FormButton, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($54ebb874bb85cae3$var$FormButton, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        control: control
    }));
}
$54ebb874bb85cae3$var$FormButton.handledProps = [
    "as",
    "control"
];
$54ebb874bb85cae3$var$FormButton.propTypes = {};
$54ebb874bb85cae3$var$FormButton.defaultProps = {
    as: (0, $19186099d0926d92$export$2e2bcd8739ae039),
    control: (0, $a7825a90230ff993$export$2e2bcd8739ae039)
};
var $54ebb874bb85cae3$export$2e2bcd8739ae039 = $54ebb874bb85cae3$var$FormButton;





var $6aRB8 = parcelRequire("6aRB8");



/**
 * Sugar for <Form.Field control={Checkbox} />.
 * @see Checkbox
 * @see Form
 */ function $44c86bc4921262be$var$FormCheckbox(props) {
    var control = props.control;
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($44c86bc4921262be$var$FormCheckbox, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($44c86bc4921262be$var$FormCheckbox, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        control: control
    }));
}
$44c86bc4921262be$var$FormCheckbox.handledProps = [
    "as",
    "control"
];
$44c86bc4921262be$var$FormCheckbox.propTypes = {};
$44c86bc4921262be$var$FormCheckbox.defaultProps = {
    as: (0, $19186099d0926d92$export$2e2bcd8739ae039),
    control: (0, $a4dfa44f3ad67085$export$2e2bcd8739ae039)
};
var $44c86bc4921262be$export$2e2bcd8739ae039 = $44c86bc4921262be$var$FormCheckbox;





var $6aRB8 = parcelRequire("6aRB8");




/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function $2b603ea1555cc26f$var$compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
var $2b603ea1555cc26f$export$2e2bcd8739ae039 = $2b603ea1555cc26f$var$compact;



/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $1ebceb6bd2c693bf$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
var $1ebceb6bd2c693bf$export$2e2bcd8739ae039 = $1ebceb6bd2c693bf$var$arrayEvery;



/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $d3de703db46e0846$var$baseEvery(collection, predicate) {
    var result = true;
    (0, $20b772a907d94404$export$2e2bcd8739ae039)(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
var $d3de703db46e0846$export$2e2bcd8739ae039 = $d3de703db46e0846$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $2c6099775fd5a24e$var$every(collection, predicate, guard) {
    var func = (0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(collection) ? (0, $1ebceb6bd2c693bf$export$2e2bcd8739ae039) : (0, $d3de703db46e0846$export$2e2bcd8739ae039);
    if (guard && (0, $2fa9c3c87095acde$export$2e2bcd8739ae039)(collection, predicate, guard)) predicate = undefined;
    return func(collection, (0, $3aff02699eb74261$export$2e2bcd8739ae039)(predicate, 3));
}
var $2c6099775fd5a24e$export$2e2bcd8739ae039 = $2c6099775fd5a24e$var$every;








/** Used as the size to enable large array optimizations. */ var $3b4876adef434db0$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $3b4876adef434db0$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = (0, $43eb61b138a40b8c$export$2e2bcd8739ae039), isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = (0, $736434a056fc3928$export$2e2bcd8739ae039)(values, (0, $8ef44e245db4be68$export$2e2bcd8739ae039)(iteratee));
    if (comparator) {
        includes = (0, $1e7e78f10f7d7907$export$2e2bcd8739ae039);
        isCommon = false;
    } else if (values.length >= $3b4876adef434db0$var$LARGE_ARRAY_SIZE) {
        includes = (0, $de3dc5c001dc6fc9$export$2e2bcd8739ae039);
        isCommon = false;
        values = new (0, $c2b64a768f4c9492$export$2e2bcd8739ae039)(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
var $3b4876adef434db0$export$2e2bcd8739ae039 = $3b4876adef434db0$var$baseDifference;





/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $a13f8818f98848eb$var$isArrayLikeObject(value) {
    return (0, $ea90ac032deaca1b$export$2e2bcd8739ae039)(value) && (0, $a49bb6f04e0bbcec$export$2e2bcd8739ae039)(value);
}
var $a13f8818f98848eb$export$2e2bcd8739ae039 = $a13f8818f98848eb$var$isArrayLikeObject;


/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $f5797dc729670952$var$without = (0, $aee0d5bc2e0dbbb6$export$2e2bcd8739ae039)(function(array, values) {
    return (0, $a13f8818f98848eb$export$2e2bcd8739ae039)(array) ? (0, $3b4876adef434db0$export$2e2bcd8739ae039)(array, values) : [];
});
var $f5797dc729670952$export$2e2bcd8739ae039 = $f5797dc729670952$var$without;





/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */ function $ebd2b0ac32e3e53a$var$dropRight(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) return [];
    n = guard || n === undefined ? 1 : (0, $6e5e9c8d30b196df$export$2e2bcd8739ae039)(n);
    n = length - n;
    return (0, $3b4fde2ed9ed85c6$export$2e2bcd8739ae039)(array, 0, n < 0 ? 0 : n);
}
var $ebd2b0ac32e3e53a$export$2e2bcd8739ae039 = $ebd2b0ac32e3e53a$var$dropRight;








var $1wW4r = parcelRequire("1wW4r");


/** `Object#toString` result references. */ var $ef1dc2bcf455bc8f$var$mapTag = '[object Map]', $ef1dc2bcf455bc8f$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $ef1dc2bcf455bc8f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ef1dc2bcf455bc8f$var$hasOwnProperty = $ef1dc2bcf455bc8f$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $ef1dc2bcf455bc8f$var$isEmpty(value) {
    if (value == null) return true;
    if ((0, $a49bb6f04e0bbcec$export$2e2bcd8739ae039)(value) && ((0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(value) || typeof value == 'string' || typeof value.splice == 'function' || (0, $1wW4r.default)(value) || (0, $32c8e7a22690b153$export$2e2bcd8739ae039)(value) || (0, $a53bd3b8e7a3212a$export$2e2bcd8739ae039)(value))) return !value.length;
    var tag = (0, $b42d9a808c4fefbd$export$2e2bcd8739ae039)(value);
    if (tag == $ef1dc2bcf455bc8f$var$mapTag || tag == $ef1dc2bcf455bc8f$var$setTag) return !value.size;
    if ((0, $bf3efd7cde0046a8$export$2e2bcd8739ae039)(value)) return !(0, $4a13fbd915daf9d9$export$2e2bcd8739ae039)(value).length;
    for(var key in value){
        if ($ef1dc2bcf455bc8f$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
var $ef1dc2bcf455bc8f$export$2e2bcd8739ae039 = $ef1dc2bcf455bc8f$var$isEmpty;







/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $d3dff000715fdbcc$var$asciiSize = (0, $ce5a4e673c21809d$export$2e2bcd8739ae039)('length');
var $d3dff000715fdbcc$export$2e2bcd8739ae039 = $d3dff000715fdbcc$var$asciiSize;


/** Used to compose unicode character classes. */ var $ebb9092dae24ac04$var$rsAstralRange = '\\ud800-\\udfff', $ebb9092dae24ac04$var$rsComboMarksRange = '\\u0300-\\u036f', $ebb9092dae24ac04$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ebb9092dae24ac04$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ebb9092dae24ac04$var$rsComboRange = $ebb9092dae24ac04$var$rsComboMarksRange + $ebb9092dae24ac04$var$reComboHalfMarksRange + $ebb9092dae24ac04$var$rsComboSymbolsRange, $ebb9092dae24ac04$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $ebb9092dae24ac04$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $ebb9092dae24ac04$var$reHasUnicode = RegExp('[' + $ebb9092dae24ac04$var$rsZWJ + $ebb9092dae24ac04$var$rsAstralRange + $ebb9092dae24ac04$var$rsComboRange + $ebb9092dae24ac04$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $ebb9092dae24ac04$var$hasUnicode(string) {
    return $ebb9092dae24ac04$var$reHasUnicode.test(string);
}
var $ebb9092dae24ac04$export$2e2bcd8739ae039 = $ebb9092dae24ac04$var$hasUnicode;


/** Used to compose unicode character classes. */ var $57590e080ab83785$var$rsAstralRange = '\\ud800-\\udfff', $57590e080ab83785$var$rsComboMarksRange = '\\u0300-\\u036f', $57590e080ab83785$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $57590e080ab83785$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $57590e080ab83785$var$rsComboRange = $57590e080ab83785$var$rsComboMarksRange + $57590e080ab83785$var$reComboHalfMarksRange + $57590e080ab83785$var$rsComboSymbolsRange, $57590e080ab83785$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $57590e080ab83785$var$rsAstral = '[' + $57590e080ab83785$var$rsAstralRange + ']', $57590e080ab83785$var$rsCombo = '[' + $57590e080ab83785$var$rsComboRange + ']', $57590e080ab83785$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $57590e080ab83785$var$rsModifier = '(?:' + $57590e080ab83785$var$rsCombo + '|' + $57590e080ab83785$var$rsFitz + ')', $57590e080ab83785$var$rsNonAstral = '[^' + $57590e080ab83785$var$rsAstralRange + ']', $57590e080ab83785$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $57590e080ab83785$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $57590e080ab83785$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $57590e080ab83785$var$reOptMod = $57590e080ab83785$var$rsModifier + '?', $57590e080ab83785$var$rsOptVar = '[' + $57590e080ab83785$var$rsVarRange + ']?', $57590e080ab83785$var$rsOptJoin = '(?:' + $57590e080ab83785$var$rsZWJ + '(?:' + [
    $57590e080ab83785$var$rsNonAstral,
    $57590e080ab83785$var$rsRegional,
    $57590e080ab83785$var$rsSurrPair
].join('|') + ')' + $57590e080ab83785$var$rsOptVar + $57590e080ab83785$var$reOptMod + ')*', $57590e080ab83785$var$rsSeq = $57590e080ab83785$var$rsOptVar + $57590e080ab83785$var$reOptMod + $57590e080ab83785$var$rsOptJoin, $57590e080ab83785$var$rsSymbol = '(?:' + [
    $57590e080ab83785$var$rsNonAstral + $57590e080ab83785$var$rsCombo + '?',
    $57590e080ab83785$var$rsCombo,
    $57590e080ab83785$var$rsRegional,
    $57590e080ab83785$var$rsSurrPair,
    $57590e080ab83785$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $57590e080ab83785$var$reUnicode = RegExp($57590e080ab83785$var$rsFitz + '(?=' + $57590e080ab83785$var$rsFitz + ')|' + $57590e080ab83785$var$rsSymbol + $57590e080ab83785$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $57590e080ab83785$var$unicodeSize(string) {
    var result = $57590e080ab83785$var$reUnicode.lastIndex = 0;
    while($57590e080ab83785$var$reUnicode.test(string))++result;
    return result;
}
var $57590e080ab83785$export$2e2bcd8739ae039 = $57590e080ab83785$var$unicodeSize;


/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $47b546ba24e4cf7d$var$stringSize(string) {
    return (0, $ebb9092dae24ac04$export$2e2bcd8739ae039)(string) ? (0, $57590e080ab83785$export$2e2bcd8739ae039)(string) : (0, $d3dff000715fdbcc$export$2e2bcd8739ae039)(string);
}
var $47b546ba24e4cf7d$export$2e2bcd8739ae039 = $47b546ba24e4cf7d$var$stringSize;


/** `Object#toString` result references. */ var $a1b486df666a0684$var$mapTag = '[object Map]', $a1b486df666a0684$var$setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function $a1b486df666a0684$var$size(collection) {
    if (collection == null) return 0;
    if ((0, $a49bb6f04e0bbcec$export$2e2bcd8739ae039)(collection)) return (0, $cbd7d1598fb48d43$export$2e2bcd8739ae039)(collection) ? (0, $47b546ba24e4cf7d$export$2e2bcd8739ae039)(collection) : collection.length;
    var tag = (0, $b42d9a808c4fefbd$export$2e2bcd8739ae039)(collection);
    if (tag == $a1b486df666a0684$var$mapTag || tag == $a1b486df666a0684$var$setTag) return collection.size;
    return (0, $4a13fbd915daf9d9$export$2e2bcd8739ae039)(collection).length;
}
var $a1b486df666a0684$export$2e2bcd8739ae039 = $a1b486df666a0684$var$size;







/** Built-in value references. */ var $a6d7c6fa04247110$var$spreadableSymbol = (0, $47aeee022ce46748$export$2e2bcd8739ae039) ? (0, $47aeee022ce46748$export$2e2bcd8739ae039).isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $a6d7c6fa04247110$var$isFlattenable(value) {
    return (0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(value) || (0, $a53bd3b8e7a3212a$export$2e2bcd8739ae039)(value) || !!($a6d7c6fa04247110$var$spreadableSymbol && value && value[$a6d7c6fa04247110$var$spreadableSymbol]);
}
var $a6d7c6fa04247110$export$2e2bcd8739ae039 = $a6d7c6fa04247110$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $1a7ebf062dea7256$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = (0, $a6d7c6fa04247110$export$2e2bcd8739ae039));
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $1a7ebf062dea7256$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else (0, $ed5c7987f48dac00$export$2e2bcd8739ae039)(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
var $1a7ebf062dea7256$export$2e2bcd8739ae039 = $1a7ebf062dea7256$var$baseFlatten;




/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $d6966bd170f3aa89$var$difference = (0, $aee0d5bc2e0dbbb6$export$2e2bcd8739ae039)(function(array, values) {
    return (0, $a13f8818f98848eb$export$2e2bcd8739ae039)(array) ? (0, $3b4876adef434db0$export$2e2bcd8739ae039)(array, (0, $1a7ebf062dea7256$export$2e2bcd8739ae039)(values, 1, (0, $a13f8818f98848eb$export$2e2bcd8739ae039), true)) : [];
});
var $d6966bd170f3aa89$export$2e2bcd8739ae039 = $d6966bd170f3aa89$var$difference;






/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $44f86458ac0e5e79$var$union = (0, $aee0d5bc2e0dbbb6$export$2e2bcd8739ae039)(function(arrays) {
    return (0, $0bf5906a7c6b4fc2$export$2e2bcd8739ae039)((0, $1a7ebf062dea7256$export$2e2bcd8739ae039)(arrays, 1, (0, $a13f8818f98848eb$export$2e2bcd8739ae039), true));
});
var $44f86458ac0e5e79$export$2e2bcd8739ae039 = $44f86458ac0e5e79$var$union;








/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $d6a9eb1c5f340c48$var$isEqual(value, other) {
    return (0, $6c3e040d1dbd7ea2$export$2e2bcd8739ae039)(value, other);
}
var $d6a9eb1c5f340c48$export$2e2bcd8739ae039 = $d6a9eb1c5f340c48$var$isEqual;






/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $11aa18236df8a34b$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = (0, $446aa16481ec6e14$export$2e2bcd8739ae039)(object, path);
        if (predicate(value, path)) (0, $b57656294bf78199$export$2e2bcd8739ae039)(result, (0, $9ab94d97aa9e786d$export$2e2bcd8739ae039)(path, object), value);
    }
    return result;
}
var $11aa18236df8a34b$export$2e2bcd8739ae039 = $11aa18236df8a34b$var$basePickBy;



/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $d5e4394e52c31664$var$basePick(object, paths) {
    return (0, $11aa18236df8a34b$export$2e2bcd8739ae039)(object, paths, function(value, path) {
        return (0, $be6d5fda30899550$export$2e2bcd8739ae039)(object, path);
    });
}
var $d5e4394e52c31664$export$2e2bcd8739ae039 = $d5e4394e52c31664$var$basePick;



/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $a14c5e3df20f6db4$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? (0, $1a7ebf062dea7256$export$2e2bcd8739ae039)(array, 1) : [];
}
var $a14c5e3df20f6db4$export$2e2bcd8739ae039 = $a14c5e3df20f6db4$var$flatten;




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $2f30f046959c87f4$var$flatRest(func) {
    return (0, $09f46bb6b2e295e6$export$2e2bcd8739ae039)((0, $5cdbb147ea35e2fb$export$2e2bcd8739ae039)(func, undefined, (0, $a14c5e3df20f6db4$export$2e2bcd8739ae039)), func + '');
}
var $2f30f046959c87f4$export$2e2bcd8739ae039 = $2f30f046959c87f4$var$flatRest;


/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $f7bdf7e80de91b2e$var$pick = (0, $2f30f046959c87f4$export$2e2bcd8739ae039)(function(object, paths) {
    return object == null ? {} : (0, $d5e4394e52c31664$export$2e2bcd8739ae039)(object, paths);
});
var $f7bdf7e80de91b2e$export$2e2bcd8739ae039 = $f7bdf7e80de91b2e$var$pick;









var $6aRB8 = parcelRequire("6aRB8");
var $0080e586c00e3b93$exports = {};
//
$0080e586c00e3b93$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};










var $6aRB8 = parcelRequire("6aRB8");

var $73303d14660f347d$export$e4b2ac9215619f8d = [
    'ad',
    'andorra',
    'ae',
    'united arab emirates',
    'uae',
    'af',
    'afghanistan',
    'ag',
    'antigua',
    'ai',
    'anguilla',
    'al',
    'albania',
    'am',
    'armenia',
    'an',
    'netherlands antilles',
    'ao',
    'angola',
    'ar',
    'argentina',
    'as',
    'american samoa',
    'at',
    'austria',
    'au',
    'australia',
    'aw',
    'aruba',
    'ax',
    'aland islands',
    'az',
    'azerbaijan',
    'ba',
    'bosnia',
    'bb',
    'barbados',
    'bd',
    'bangladesh',
    'be',
    'belgium',
    'bf',
    'burkina faso',
    'bg',
    'bulgaria',
    'bh',
    'bahrain',
    'bi',
    'burundi',
    'bj',
    'benin',
    'bm',
    'bermuda',
    'bn',
    'brunei',
    'bo',
    'bolivia',
    'br',
    'brazil',
    'bs',
    'bahamas',
    'bt',
    'bhutan',
    'bv',
    'bouvet island',
    'bw',
    'botswana',
    'by',
    'belarus',
    'bz',
    'belize',
    'ca',
    'canada',
    'cc',
    'cocos islands',
    'cd',
    'congo',
    'cf',
    'central african republic',
    'cg',
    'congo brazzaville',
    'ch',
    'switzerland',
    'ci',
    'cote divoire',
    'ck',
    'cook islands',
    'cl',
    'chile',
    'cm',
    'cameroon',
    'cn',
    'china',
    'co',
    'colombia',
    'cr',
    'costa rica',
    'cs',
    'cu',
    'cuba',
    'cv',
    'cape verde',
    'cx',
    'christmas island',
    'cy',
    'cyprus',
    'cz',
    'czech republic',
    'de',
    'germany',
    'dj',
    'djibouti',
    'dk',
    'denmark',
    'dm',
    'dominica',
    'do',
    'dominican republic',
    'dz',
    'algeria',
    'ec',
    'ecuador',
    'england',
    'gb eng',
    'ee',
    'estonia',
    'eg',
    'egypt',
    'eh',
    'western sahara',
    'er',
    'eritrea',
    'es',
    'spain',
    'et',
    'ethiopia',
    'eu',
    'european union',
    'fi',
    'finland',
    'fj',
    'fiji',
    'fk',
    'falkland islands',
    'fm',
    'micronesia',
    'fo',
    'faroe islands',
    'fr',
    'france',
    'ga',
    'gabon',
    'gb',
    'uk',
    'united kingdom',
    'gd',
    'grenada',
    'ge',
    'georgia',
    'gf',
    'french guiana',
    'gh',
    'ghana',
    'gi',
    'gibraltar',
    'gl',
    'greenland',
    'gm',
    'gambia',
    'gn',
    'guinea',
    'gp',
    'guadeloupe',
    'gq',
    'equatorial guinea',
    'gr',
    'greece',
    'gs',
    'sandwich islands',
    'gt',
    'guatemala',
    'gu',
    'guam',
    'gw',
    'guinea-bissau',
    'gy',
    'guyana',
    'hk',
    'hong kong',
    'hm',
    'heard island',
    'hn',
    'honduras',
    'hr',
    'croatia',
    'ht',
    'haiti',
    'hu',
    'hungary',
    'id',
    'indonesia',
    'ie',
    'ireland',
    'il',
    'israel',
    'in',
    'india',
    'io',
    'indian ocean territory',
    'iq',
    'iraq',
    'ir',
    'iran',
    'is',
    'iceland',
    'it',
    'italy',
    'jm',
    'jamaica',
    'jo',
    'jordan',
    'jp',
    'japan',
    'ke',
    'kenya',
    'kg',
    'kyrgyzstan',
    'kh',
    'cambodia',
    'ki',
    'kiribati',
    'km',
    'comoros',
    'kn',
    'saint kitts and nevis',
    'kp',
    'north korea',
    'kr',
    'south korea',
    'kw',
    'kuwait',
    'ky',
    'cayman islands',
    'kz',
    'kazakhstan',
    'la',
    'laos',
    'lb',
    'lebanon',
    'lc',
    'saint lucia',
    'li',
    'liechtenstein',
    'lk',
    'sri lanka',
    'lr',
    'liberia',
    'ls',
    'lesotho',
    'lt',
    'lithuania',
    'lu',
    'luxembourg',
    'lv',
    'latvia',
    'ly',
    'libya',
    'ma',
    'morocco',
    'mc',
    'monaco',
    'md',
    'moldova',
    'me',
    'montenegro',
    'mg',
    'madagascar',
    'mh',
    'marshall islands',
    'mk',
    'macedonia',
    'ml',
    'mali',
    'mm',
    'myanmar',
    'burma',
    'mn',
    'mongolia',
    'mo',
    'macau',
    'mp',
    'northern mariana islands',
    'mq',
    'martinique',
    'mr',
    'mauritania',
    'ms',
    'montserrat',
    'mt',
    'malta',
    'mu',
    'mauritius',
    'mv',
    'maldives',
    'mw',
    'malawi',
    'mx',
    'mexico',
    'my',
    'malaysia',
    'mz',
    'mozambique',
    'na',
    'namibia',
    'nc',
    'new caledonia',
    'ne',
    'niger',
    'nf',
    'norfolk island',
    'ng',
    'nigeria',
    'ni',
    'nicaragua',
    'nl',
    'netherlands',
    'no',
    'norway',
    'np',
    'nepal',
    'nr',
    'nauru',
    'nu',
    'niue',
    'nz',
    'new zealand',
    'om',
    'oman',
    'pa',
    'panama',
    'pe',
    'peru',
    'pf',
    'french polynesia',
    'pg',
    'new guinea',
    'ph',
    'philippines',
    'pk',
    'pakistan',
    'pl',
    'poland',
    'pm',
    'saint pierre',
    'pn',
    'pitcairn islands',
    'pr',
    'puerto rico',
    'ps',
    'palestine',
    'pt',
    'portugal',
    'pw',
    'palau',
    'py',
    'paraguay',
    'qa',
    'qatar',
    're',
    'reunion',
    'ro',
    'romania',
    'rs',
    'serbia',
    'ru',
    'russia',
    'rw',
    'rwanda',
    'sa',
    'saudi arabia',
    'sb',
    'solomon islands',
    'sc',
    'seychelles',
    'gb sct',
    'scotland',
    'sd',
    'sudan',
    'se',
    'sweden',
    'sg',
    'singapore',
    'sh',
    'saint helena',
    'si',
    'slovenia',
    'sj',
    'svalbard',
    'jan mayen',
    'sk',
    'slovakia',
    'sl',
    'sierra leone',
    'sm',
    'san marino',
    'sn',
    'senegal',
    'so',
    'somalia',
    'sr',
    'suriname',
    'st',
    'sao tome',
    'sv',
    'el salvador',
    'sy',
    'syria',
    'sz',
    'swaziland',
    'tc',
    'caicos islands',
    'td',
    'chad',
    'tf',
    'french territories',
    'tg',
    'togo',
    'th',
    'thailand',
    'tj',
    'tajikistan',
    'tk',
    'tokelau',
    'tl',
    'timorleste',
    'tm',
    'turkmenistan',
    'tn',
    'tunisia',
    'to',
    'tonga',
    'tr',
    'turkey',
    'tt',
    'trinidad',
    'tv',
    'tuvalu',
    'tw',
    'taiwan',
    'tz',
    'tanzania',
    'ua',
    'ukraine',
    'ug',
    'uganda',
    'um',
    'us minor islands',
    'us',
    'america',
    'united states',
    'uy',
    'uruguay',
    'uz',
    'uzbekistan',
    'va',
    'vatican city',
    'vc',
    'saint vincent',
    've',
    'venezuela',
    'vg',
    'british virgin islands',
    'vi',
    'us virgin islands',
    'vn',
    'vietnam',
    'vu',
    'vanuatu',
    'gb wls',
    'wales',
    'wf',
    'wallis and futuna',
    'ws',
    'samoa',
    'ye',
    'yemen',
    'yt',
    'mayotte',
    'za',
    'south africa',
    'zm',
    'zambia',
    'zw',
    'zimbabwe'
];
/**
 * A flag is is used to represent a political state.
 */ var $73303d14660f347d$var$Flag = /*#__PURE__*/ function(_PureComponent) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(Flag, _PureComponent);
    function Flag() {
        return _PureComponent.apply(this, arguments) || this;
    }
    var _proto = Flag.prototype;
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, name = _this$props.name;
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)(name, 'flag', className);
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(Flag, this.props);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(Flag, this.props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            className: classes
        }));
    };
    return Flag;
}((0, $6aRB8.PureComponent));
$73303d14660f347d$var$Flag.handledProps = [
    "as",
    "className",
    "name"
];
$73303d14660f347d$var$Flag.propTypes = {};
$73303d14660f347d$var$Flag.defaultProps = {
    as: 'i'
};
$73303d14660f347d$var$Flag.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($73303d14660f347d$var$Flag, function(value) {
    return {
        name: value
    };
});
var $73303d14660f347d$export$2e2bcd8739ae039 = $73303d14660f347d$var$Flag;







var $6aRB8 = parcelRequire("6aRB8");

/**
 * A dropdown menu can contain dividers to separate related content.
 */ function $35686c94b8eaa217$var$DropdownDivider(props) {
    var className = props.className;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('divider', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($35686c94b8eaa217$var$DropdownDivider, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($35686c94b8eaa217$var$DropdownDivider, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }));
}
$35686c94b8eaa217$var$DropdownDivider.handledProps = [
    "as",
    "className"
];
$35686c94b8eaa217$var$DropdownDivider.propTypes = {};
var $35686c94b8eaa217$export$2e2bcd8739ae039 = $35686c94b8eaa217$var$DropdownDivider;









var $6aRB8 = parcelRequire("6aRB8");





/**
 * An item sub-component for Dropdown component.
 */ var $d848913c0cf68d0a$var$DropdownItem = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(DropdownItem, _Component);
    function DropdownItem() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.handleClick = function(e) {
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onClick', e, _this.props);
        };
        return _this;
    }
    var _proto = DropdownItem.prototype;
    _proto.render = function render() {
        var _this$props = this.props, active = _this$props.active, children = _this$props.children, className = _this$props.className, content = _this$props.content, disabled = _this$props.disabled, description = _this$props.description, flag = _this$props.flag, icon = _this$props.icon, image = _this$props.image, label = _this$props.label, selected = _this$props.selected, text = _this$props.text;
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$aac7d417530cc39a)(active, 'active'), (0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$aac7d417530cc39a)(selected, 'selected'), 'item', className); // add default dropdown icon if item contains another menu
        var iconName = (0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(icon) ? (0, $f0526af735e6584e$exports).someByType(children, 'DropdownMenu') && 'dropdown' : icon;
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(DropdownItem, this.props);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(DropdownItem, this.props);
        var ariaOptions = {
            role: 'option',
            'aria-disabled': disabled,
            'aria-checked': active,
            'aria-selected': selected
        };
        if (!(0, $f0526af735e6584e$exports).isNil(children)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, ariaOptions, {
            className: classes,
            onClick: this.handleClick
        }), children);
        var flagElement = (0, $73303d14660f347d$export$2e2bcd8739ae039).create(flag, {
            autoGenerateKey: false
        });
        var iconElement = (0, $760d0282e0637aa7$export$2e2bcd8739ae039).create(iconName, {
            autoGenerateKey: false
        });
        var imageElement = (0, $32f1a379a68c59a0$export$2e2bcd8739ae039).create(image, {
            autoGenerateKey: false
        });
        var labelElement = (0, $2f87e91a93ad1d2d$export$2e2bcd8739ae039).create(label, {
            autoGenerateKey: false
        });
        var descriptionElement = (0, $d590e40415a777e8$export$e087067e9593d215)('span', function(val) {
            return {
                children: val
            };
        }, description, {
            defaultProps: {
                className: 'description'
            },
            autoGenerateKey: false
        });
        var textElement = (0, $d590e40415a777e8$export$e087067e9593d215)('span', function(val) {
            return {
                children: val
            };
        }, (0, $f0526af735e6584e$exports).isNil(content) ? text : content, {
            defaultProps: {
                className: 'text'
            },
            autoGenerateKey: false
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, ariaOptions, {
            className: classes,
            onClick: this.handleClick
        }), imageElement, iconElement, flagElement, labelElement, descriptionElement, textElement);
    };
    return DropdownItem;
}((0, $6aRB8.Component));
$d848913c0cf68d0a$var$DropdownItem.handledProps = [
    "active",
    "as",
    "children",
    "className",
    "content",
    "description",
    "disabled",
    "flag",
    "icon",
    "image",
    "label",
    "onClick",
    "selected",
    "text",
    "value"
];
$d848913c0cf68d0a$var$DropdownItem.propTypes = {};
$d848913c0cf68d0a$var$DropdownItem.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($d848913c0cf68d0a$var$DropdownItem, function(opts) {
    return opts;
});
var $d848913c0cf68d0a$export$2e2bcd8739ae039 = $d848913c0cf68d0a$var$DropdownItem;






var $6aRB8 = parcelRequire("6aRB8");


/**
 * A dropdown menu can contain a header.
 */ function $6ce8094570bcf665$var$DropdownHeader(props) {
    var children = props.children, className = props.className, content = props.content, icon = props.icon;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('header', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($6ce8094570bcf665$var$DropdownHeader, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($6ce8094570bcf665$var$DropdownHeader, props);
    if (!(0, $f0526af735e6584e$exports).isNil(children)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $760d0282e0637aa7$export$2e2bcd8739ae039).create(icon, {
        autoGenerateKey: false
    }), content);
}
$6ce8094570bcf665$var$DropdownHeader.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "icon"
];
$6ce8094570bcf665$var$DropdownHeader.propTypes = {};
$6ce8094570bcf665$var$DropdownHeader.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($6ce8094570bcf665$var$DropdownHeader, function(content) {
    return {
        content: content
    };
});
var $6ce8094570bcf665$export$2e2bcd8739ae039 = $6ce8094570bcf665$var$DropdownHeader;






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A dropdown menu can contain a menu.
 */ function $08884420bb5edbf7$var$DropdownMenu(props) {
    var children = props.children, className = props.className, content = props.content, direction = props.direction, open = props.open, scrolling = props.scrolling;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)(direction, (0, $87a122667489288b$export$aac7d417530cc39a)(open, 'visible'), (0, $87a122667489288b$export$aac7d417530cc39a)(scrolling, 'scrolling'), 'menu transition', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($08884420bb5edbf7$var$DropdownMenu, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($08884420bb5edbf7$var$DropdownMenu, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$08884420bb5edbf7$var$DropdownMenu.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "direction",
    "open",
    "scrolling"
];
$08884420bb5edbf7$var$DropdownMenu.propTypes = {};
var $08884420bb5edbf7$export$2e2bcd8739ae039 = $08884420bb5edbf7$var$DropdownMenu;









var $6aRB8 = parcelRequire("6aRB8");

/**
 * A search item sub-component for Dropdown component.
 */ var $5b4aaa243e2b3764$var$DropdownSearchInput = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(DropdownSearchInput, _Component);
    function DropdownSearchInput() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.handleChange = function(e) {
            var value = (0, $4b263473fff5783f$export$2e2bcd8739ae039)(e, 'target.value');
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onChange', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                value: value
            }));
        };
        return _this;
    }
    var _proto = DropdownSearchInput.prototype;
    _proto.render = function render() {
        var _this$props = this.props, autoComplete = _this$props.autoComplete, className = _this$props.className, tabIndex = _this$props.tabIndex, type = _this$props.type, value = _this$props.value;
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('search', className);
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(DropdownSearchInput, this.props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("input", (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            "aria-autocomplete": "list",
            autoComplete: autoComplete,
            className: classes,
            onChange: this.handleChange,
            tabIndex: tabIndex,
            type: type,
            value: value
        }));
    };
    return DropdownSearchInput;
}((0, $6aRB8.Component));
$5b4aaa243e2b3764$var$DropdownSearchInput.handledProps = [
    "as",
    "autoComplete",
    "className",
    "tabIndex",
    "type",
    "value"
];
$5b4aaa243e2b3764$var$DropdownSearchInput.propTypes = {};
$5b4aaa243e2b3764$var$DropdownSearchInput.defaultProps = {
    autoComplete: 'off',
    type: 'text'
};
$5b4aaa243e2b3764$var$DropdownSearchInput.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($5b4aaa243e2b3764$var$DropdownSearchInput, function(type) {
    return {
        type: type
    };
});
var $5b4aaa243e2b3764$export$2e2bcd8739ae039 = $5b4aaa243e2b3764$var$DropdownSearchInput;






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A dropdown contains a selected value.
 */ function $e36564613a7fb3fc$var$DropdownText(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('divider', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($e36564613a7fb3fc$var$DropdownText, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($e36564613a7fb3fc$var$DropdownText, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({
        "aria-atomic": true,
        "aria-live": "polite",
        role: "alert"
    }, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$e36564613a7fb3fc$var$DropdownText.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
$e36564613a7fb3fc$var$DropdownText.propTypes = {};
$e36564613a7fb3fc$var$DropdownText.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($e36564613a7fb3fc$var$DropdownText, function(val) {
    return {
        content: val
    };
});
var $e36564613a7fb3fc$export$2e2bcd8739ae039 = $e36564613a7fb3fc$var$DropdownText;




/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ecefcad13169cfd4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $ecefcad13169cfd4$var$reHasRegExpChar = RegExp($ecefcad13169cfd4$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $ecefcad13169cfd4$var$escapeRegExp(string) {
    string = (0, $19ca0d8af35ed84a$export$2e2bcd8739ae039)(string);
    return string && $ecefcad13169cfd4$var$reHasRegExpChar.test(string) ? string.replace($ecefcad13169cfd4$var$reRegExpChar, '\\$&') : string;
}
var $ecefcad13169cfd4$export$2e2bcd8739ae039 = $ecefcad13169cfd4$var$escapeRegExp;


/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $bde3fc3c135b8b3f$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
var $bde3fc3c135b8b3f$export$2e2bcd8739ae039 = $bde3fc3c135b8b3f$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $36f17ff90f28845d$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $36f17ff90f28845d$var$deburrLetter = (0, $bde3fc3c135b8b3f$export$2e2bcd8739ae039)($36f17ff90f28845d$var$deburredLetters);
var $36f17ff90f28845d$export$2e2bcd8739ae039 = $36f17ff90f28845d$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $4e627eea77f318a5$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $4e627eea77f318a5$var$rsComboMarksRange = '\\u0300-\\u036f', $4e627eea77f318a5$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $4e627eea77f318a5$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $4e627eea77f318a5$var$rsComboRange = $4e627eea77f318a5$var$rsComboMarksRange + $4e627eea77f318a5$var$reComboHalfMarksRange + $4e627eea77f318a5$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $4e627eea77f318a5$var$rsCombo = '[' + $4e627eea77f318a5$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $4e627eea77f318a5$var$reComboMark = RegExp($4e627eea77f318a5$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $4e627eea77f318a5$var$deburr(string) {
    string = (0, $19ca0d8af35ed84a$export$2e2bcd8739ae039)(string);
    return string && string.replace($4e627eea77f318a5$var$reLatin, (0, $36f17ff90f28845d$export$2e2bcd8739ae039)).replace($4e627eea77f318a5$var$reComboMark, '');
}
var $4e627eea77f318a5$export$2e2bcd8739ae039 = $4e627eea77f318a5$var$deburr;






/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $e2eead80d3aab3e1$var$baseFilter(collection, predicate) {
    var result = [];
    (0, $20b772a907d94404$export$2e2bcd8739ae039)(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
var $e2eead80d3aab3e1$export$2e2bcd8739ae039 = $e2eead80d3aab3e1$var$baseFilter;




/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $67d0411f60b64bb6$var$filter(collection, predicate) {
    var func = (0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(collection) ? (0, $e8800ecf51c78eaa$export$2e2bcd8739ae039) : (0, $e2eead80d3aab3e1$export$2e2bcd8739ae039);
    return func(collection, (0, $3aff02699eb74261$export$2e2bcd8739ae039)(predicate, 3));
}
var $67d0411f60b64bb6$export$2e2bcd8739ae039 = $67d0411f60b64bb6$var$filter;



var $6aRB8 = parcelRequire("6aRB8");
function $767c058c18765207$export$2e2bcd8739ae039(config) {
    var additionLabel = config.additionLabel, additionPosition = config.additionPosition, allowAdditions = config.allowAdditions, deburr = config.deburr, multiple = config.multiple, options = config.options, search = config.search, searchQuery = config.searchQuery, value = config.value;
    var filteredOptions = options; // filter out active options
    if (multiple) filteredOptions = (0, $67d0411f60b64bb6$export$2e2bcd8739ae039)(filteredOptions, function(opt) {
        return !(0, $9d3d4e08270ebb7e$export$2e2bcd8739ae039)(value, opt.value);
    });
     // filter by search query
    if (search && searchQuery) {
        if ((0, $e4f5228c7fe84628$export$2e2bcd8739ae039)(search)) filteredOptions = search(filteredOptions, searchQuery);
        else {
            // remove diacritics on search input and options, if deburr prop is set
            var strippedQuery = deburr ? (0, $4e627eea77f318a5$export$2e2bcd8739ae039)(searchQuery) : searchQuery;
            var re = new RegExp((0, $ecefcad13169cfd4$export$2e2bcd8739ae039)(strippedQuery), 'i');
            filteredOptions = (0, $67d0411f60b64bb6$export$2e2bcd8739ae039)(filteredOptions, function(opt) {
                return re.test(deburr ? (0, $4e627eea77f318a5$export$2e2bcd8739ae039)(opt.text) : opt.text);
            });
        }
    } // insert the "add" item
    if (allowAdditions && search && searchQuery && !(0, $ae0c709b40a9455c$export$2e2bcd8739ae039)(filteredOptions, {
        text: searchQuery
    })) {
        var additionLabelElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).isValidElement(additionLabel) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).cloneElement(additionLabel, {
            key: 'addition-label'
        }) : additionLabel || '';
        var addItem = {
            key: 'addition',
            // by using an array, we can pass multiple elements, but when doing so
            // we must specify a `key` for React to know which one is which
            text: [
                additionLabelElement,
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("b", {
                    key: "addition-query"
                }, searchQuery)
            ],
            value: searchQuery,
            className: 'addition',
            'data-additional': true
        };
        if (additionPosition === 'top') filteredOptions.unshift(addItem);
        else filteredOptions.push(addItem);
    }
    return filteredOptions;
}
$767c058c18765207$export$2e2bcd8739ae039.handledProps = [];





/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $8d360eab29e0a1b3$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
var $8d360eab29e0a1b3$export$2e2bcd8739ae039 = $8d360eab29e0a1b3$var$arrayReduce;




/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $71a0884a0e65c4fd$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
var $71a0884a0e65c4fd$export$2e2bcd8739ae039 = $71a0884a0e65c4fd$var$baseReduce;



/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $4e907c799c1a5079$var$reduce(collection, iteratee, accumulator) {
    var func = (0, $5ae320c97664ecc7$export$2e2bcd8739ae039)(collection) ? (0, $8d360eab29e0a1b3$export$2e2bcd8739ae039) : (0, $71a0884a0e65c4fd$export$2e2bcd8739ae039), initAccum = arguments.length < 3;
    return func(collection, (0, $3aff02699eb74261$export$2e2bcd8739ae039)(iteratee, 4), accumulator, initAccum, (0, $20b772a907d94404$export$2e2bcd8739ae039));
}
var $4e907c799c1a5079$export$2e2bcd8739ae039 = $4e907c799c1a5079$var$reduce;



function $fa87ff716389e71e$export$2e2bcd8739ae039(config) {
    var additionLabel = config.additionLabel, additionPosition = config.additionPosition, allowAdditions = config.allowAdditions, deburr = config.deburr, multiple = config.multiple, options = config.options, search = config.search, searchQuery = config.searchQuery, selectedIndex = config.selectedIndex, value = config.value;
    var menuOptions = (0, $767c058c18765207$export$2e2bcd8739ae039)({
        value: value,
        options: options,
        searchQuery: searchQuery,
        additionLabel: additionLabel,
        additionPosition: additionPosition,
        allowAdditions: allowAdditions,
        deburr: deburr,
        multiple: multiple,
        search: search
    });
    var enabledIndexes = (0, $4e907c799c1a5079$export$2e2bcd8739ae039)(menuOptions, function(memo, item, index) {
        if (!item.disabled) memo.push(index);
        return memo;
    }, []);
    var newSelectedIndex; // update the selected index
    if (!selectedIndex || selectedIndex < 0) {
        var firstIndex = enabledIndexes[0]; // Select the currently active item, if none, use the first item.
        // Multiple selects remove active items from the list,
        // their initial selected index should be 0.
        newSelectedIndex = multiple ? firstIndex : (0, $096a5e4acaf669cb$export$2e2bcd8739ae039)(menuOptions, [
            'value',
            value
        ]) || enabledIndexes[0];
    } else if (multiple) {
        newSelectedIndex = (0, $e1d6d905b1dc141e$export$2e2bcd8739ae039)(enabledIndexes, function(index) {
            return index >= selectedIndex;
        }); // multiple selects remove options from the menu as they are made active
        // keep the selected index within range of the remaining items
        if (selectedIndex >= menuOptions.length - 1) newSelectedIndex = enabledIndexes[enabledIndexes.length - 1];
    } else {
        var activeIndex = (0, $096a5e4acaf669cb$export$2e2bcd8739ae039)(menuOptions, [
            'value',
            value
        ]); // regular selects can only have one active item
        // set the selected index to the currently active item
        newSelectedIndex = (0, $9d3d4e08270ebb7e$export$2e2bcd8739ae039)(enabledIndexes, activeIndex) ? activeIndex : undefined;
    }
    if (!newSelectedIndex || newSelectedIndex < 0) newSelectedIndex = enabledIndexes[0];
    return newSelectedIndex;
}


var $6a9eaf6b801099ca$var$getKeyOrValue = function getKeyOrValue(key, value) {
    return (0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(key) ? value : key;
};
var $6a9eaf6b801099ca$var$getKeyAndValues = function getKeyAndValues(options) {
    return options ? options.map(function(option) {
        return (0, $f7bdf7e80de91b2e$export$2e2bcd8739ae039)(option, [
            'key',
            'value'
        ]);
    }) : options;
};
function $6a9eaf6b801099ca$var$renderItemContent(item) {
    var flag = item.flag, image = item.image, text = item.text; // TODO: remove this in v3
    // This maintains compatibility with Shorthand API in v1 as this might be called in "Label.create()"
    if ((0, $e4f5228c7fe84628$export$2e2bcd8739ae039)(text)) return text;
    return {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, (0, $73303d14660f347d$export$2e2bcd8739ae039).create(flag), (0, $32f1a379a68c59a0$export$2e2bcd8739ae039).create(image), text)
    };
}
/**
 * A dropdown allows a user to select a value from a series of options.
 * @see Form
 * @see Select
 * @see Menu
 */ var $6a9eaf6b801099ca$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(Dropdown, _Component);
    function Dropdown() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.searchRef = /*#__PURE__*/ (0, $6aRB8.createRef)();
        _this.sizerRef = /*#__PURE__*/ (0, $6aRB8.createRef)();
        _this.ref = /*#__PURE__*/ (0, $6aRB8.createRef)();
        _this.handleChange = function(e, value) {
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onChange', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                value: value
            }));
        };
        _this.closeOnChange = function(e) {
            var _this$props = _this.props, closeOnChange = _this$props.closeOnChange, multiple = _this$props.multiple;
            var shouldClose = (0, $c38f68ed25e223ea$export$2e2bcd8739ae039)(closeOnChange) ? !multiple : closeOnChange;
            if (shouldClose) _this.close(e, (0, $523198dc7af6ada1$export$2e2bcd8739ae039));
        };
        _this.closeOnEscape = function(e) {
            if (!_this.props.closeOnEscape) return;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).getCode(e) !== (0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).Escape) return;
            e.preventDefault();
            _this.close(e);
        };
        _this.moveSelectionOnKeyDown = function(e) {
            var _moves;
            var _this$props2 = _this.props, multiple = _this$props2.multiple, selectOnNavigation = _this$props2.selectOnNavigation;
            var open = _this.state.open;
            if (!open) return;
            var moves = (_moves = {}, _moves[(0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).ArrowDown] = 1, _moves[(0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).ArrowUp] = -1, _moves);
            var move = moves[(0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).getCode(e)];
            if (move === undefined) return;
            e.preventDefault();
            var nextIndex = _this.getSelectedIndexAfterMove(move);
            if (!multiple && selectOnNavigation) _this.makeSelectedItemActive(e, nextIndex);
            _this.setState({
                selectedIndex: nextIndex
            });
        };
        _this.openOnSpace = function(e) {
            var _e$target, _e$target2, _e$target3;
            var shouldHandleEvent = _this.state.focus && !_this.state.open && (0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).getCode(e) === (0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).Spacebar;
            var shouldPreventDefault = ((_e$target = e.target) == null ? void 0 : _e$target.tagName) !== 'INPUT' && ((_e$target2 = e.target) == null ? void 0 : _e$target2.tagName) !== 'TEXTAREA' && ((_e$target3 = e.target) == null ? void 0 : _e$target3.isContentEditable) !== true;
            if (shouldHandleEvent) {
                if (shouldPreventDefault) e.preventDefault();
                _this.open(e);
            }
        };
        _this.openOnArrow = function(e) {
            var _this$state = _this.state, focus = _this$state.focus, open = _this$state.open;
            if (focus && !open) {
                var code = (0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).getCode(e);
                if (code === (0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).ArrowDown || code === (0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).ArrowUp) {
                    e.preventDefault();
                    _this.open(e);
                }
            }
        };
        _this.makeSelectedItemActive = function(e, selectedIndex) {
            var _this$state2 = _this.state, open = _this$state2.open, value = _this$state2.value;
            var multiple = _this.props.multiple;
            var item = _this.getSelectedItem(selectedIndex);
            var selectedValue = (0, $4b263473fff5783f$export$2e2bcd8739ae039)(item, 'value');
            var disabled = (0, $4b263473fff5783f$export$2e2bcd8739ae039)(item, 'disabled'); // prevent selecting null if there was no selected item value
            // prevent selecting duplicate items when the dropdown is closed
            // prevent selecting disabled items
            if ((0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(selectedValue) || !open || disabled) return value;
             // state value may be undefined
            var newValue = multiple ? (0, $44f86458ac0e5e79$export$2e2bcd8739ae039)(value, [
                selectedValue
            ]) : selectedValue;
            var valueHasChanged = multiple ? !!(0, $d6966bd170f3aa89$export$2e2bcd8739ae039)(newValue, value).length : newValue !== value;
            if (valueHasChanged) {
                // notify the onChange prop that the user is trying to change value
                _this.setState({
                    value: newValue
                });
                _this.handleChange(e, newValue); // Heads up! This event handler should be called after `onChange`
                // Notify the onAddItem prop if this is a new value
                if (item['data-additional']) (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onAddItem', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                    value: selectedValue
                }));
            }
            return value;
        };
        _this.selectItemOnEnter = function(e) {
            var search = _this.props.search;
            var _this$state3 = _this.state, open = _this$state3.open, selectedIndex = _this$state3.selectedIndex;
            if (!open) return;
            var shouldSelect = (0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).getCode(e) === (0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).Enter || // https://github.com/Semantic-Org/Semantic-UI-React/pull/3766
            !search && (0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).getCode(e) === (0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).Spacebar;
            if (!shouldSelect) return;
            e.preventDefault();
            var optionSize = (0, $a1b486df666a0684$export$2e2bcd8739ae039)((0, $767c058c18765207$export$2e2bcd8739ae039)({
                value: _this.state.value,
                options: _this.props.options,
                searchQuery: _this.state.searchQuery,
                additionLabel: _this.props.additionLabel,
                additionPosition: _this.props.additionPosition,
                allowAdditions: _this.props.allowAdditions,
                deburr: _this.props.deburr,
                multiple: _this.props.multiple,
                search: _this.props.search
            }));
            if (search && optionSize === 0) return;
            var nextValue = _this.makeSelectedItemActive(e, selectedIndex); // This is required as selected value may be the same
            _this.setState({
                selectedIndex: (0, $fa87ff716389e71e$export$2e2bcd8739ae039)({
                    additionLabel: _this.props.additionLabel,
                    additionPosition: _this.props.additionPosition,
                    allowAdditions: _this.props.allowAdditions,
                    deburr: _this.props.deburr,
                    multiple: _this.props.multiple,
                    search: _this.props.search,
                    selectedIndex: selectedIndex,
                    value: nextValue,
                    options: _this.props.options,
                    searchQuery: ''
                })
            });
            _this.closeOnChange(e);
            _this.clearSearchQuery();
            if (search) (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.searchRef.current, 'focus');
        };
        _this.removeItemOnBackspace = function(e) {
            var _this$props3 = _this.props, multiple = _this$props3.multiple, search = _this$props3.search;
            var _this$state4 = _this.state, searchQuery = _this$state4.searchQuery, value = _this$state4.value;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).getCode(e) !== (0, (/*@__PURE__*/$parcel$interopDefault($a6688f2d03345850$exports))).Backspace) return;
            if (searchQuery || !search || !multiple || (0, $ef1dc2bcf455bc8f$export$2e2bcd8739ae039)(value)) return;
            e.preventDefault(); // remove most recent value
            var newValue = (0, $ebd2b0ac32e3e53a$export$2e2bcd8739ae039)(value);
            _this.setState({
                value: newValue
            });
            _this.handleChange(e, newValue);
        };
        _this.closeOnDocumentClick = function(e) {
            if (!_this.props.closeOnBlur) return; // If event happened in the dropdown, ignore it
            if (_this.ref.current && (0, $6e0b9d13855575c4$export$2e2bcd8739ae039)(_this.ref.current, e)) return;
            _this.close();
        };
        _this.handleMouseDown = function(e) {
            _this.isMouseDown = true;
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onMouseDown', e, _this.props);
            document.addEventListener('mouseup', _this.handleDocumentMouseUp);
        };
        _this.handleDocumentMouseUp = function() {
            _this.isMouseDown = false;
            document.removeEventListener('mouseup', _this.handleDocumentMouseUp);
        };
        _this.handleClick = function(e) {
            var _this$props4 = _this.props, minCharacters = _this$props4.minCharacters, search = _this$props4.search;
            var _this$state5 = _this.state, open = _this$state5.open, searchQuery = _this$state5.searchQuery;
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onClick', e, _this.props); // prevent closeOnDocumentClick()
            e.stopPropagation();
            if (!search) return _this.toggle(e);
            if (open) {
                (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.searchRef.current, 'focus');
                return;
            }
            if (searchQuery.length >= minCharacters || minCharacters === 1) {
                _this.open(e);
                return;
            }
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.searchRef.current, 'focus');
        };
        _this.handleIconClick = function(e) {
            var clearable = _this.props.clearable;
            var hasValue = _this.hasValue();
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onClick', e, _this.props); // prevent handleClick()
            e.stopPropagation();
            if (clearable && hasValue) _this.clearValue(e);
            else _this.toggle(e);
        };
        _this.handleItemClick = function(e, item) {
            var _this$props5 = _this.props, multiple = _this$props5.multiple, search = _this$props5.search;
            var currentValue = _this.state.value;
            var value = item.value; // prevent toggle() in handleClick()
            e.stopPropagation(); // prevent closeOnDocumentClick() if multiple or item is disabled
            if (multiple || item.disabled) e.nativeEvent.stopImmediatePropagation();
            if (item.disabled) return;
            var isAdditionItem = item['data-additional'];
            var newValue = multiple ? (0, $44f86458ac0e5e79$export$2e2bcd8739ae039)(_this.state.value, [
                value
            ]) : value;
            var valueHasChanged = multiple ? !!(0, $d6966bd170f3aa89$export$2e2bcd8739ae039)(newValue, currentValue).length : newValue !== currentValue; // notify the onChange prop that the user is trying to change value
            if (valueHasChanged) {
                _this.setState({
                    value: newValue
                });
                _this.handleChange(e, newValue);
            }
            _this.clearSearchQuery();
            if (search) (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.searchRef.current, 'focus');
            else (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.ref.current, 'focus');
            _this.closeOnChange(e); // Heads up! This event handler should be called after `onChange`
            // Notify the onAddItem prop if this is a new value
            if (isAdditionItem) (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onAddItem', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                value: value
            }));
        };
        _this.handleFocus = function(e) {
            var focus = _this.state.focus;
            if (focus) return;
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onFocus', e, _this.props);
            _this.setState({
                focus: true
            });
        };
        _this.handleBlur = function(e) {
            // Heads up! Don't remove this.
            // https://github.com/Semantic-Org/Semantic-UI-React/issues/1315
            var currentTarget = (0, $4b263473fff5783f$export$2e2bcd8739ae039)(e, 'currentTarget');
            if (currentTarget && currentTarget.contains(document.activeElement)) return;
            var _this$props6 = _this.props, closeOnBlur = _this$props6.closeOnBlur, multiple = _this$props6.multiple, selectOnBlur = _this$props6.selectOnBlur; // do not "blur" when the mouse is down inside of the Dropdown
            if (_this.isMouseDown) return;
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onBlur', e, _this.props);
            if (selectOnBlur && !multiple) {
                _this.makeSelectedItemActive(e, _this.state.selectedIndex);
                if (closeOnBlur) _this.close();
            }
            _this.setState({
                focus: false
            });
            _this.clearSearchQuery();
        };
        _this.handleSearchChange = function(e, _ref) {
            var value = _ref.value;
            // prevent propagating to this.props.onChange()
            e.stopPropagation();
            var minCharacters = _this.props.minCharacters;
            var open = _this.state.open;
            var newQuery = value;
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onSearchChange', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                searchQuery: newQuery
            }));
            _this.setState({
                searchQuery: newQuery,
                selectedIndex: 0
            }); // open search dropdown on search query
            if (!open && newQuery.length >= minCharacters) {
                _this.open();
                return;
            } // close search dropdown if search query is too small
            if (open && minCharacters !== 1 && newQuery.length < minCharacters) _this.close();
        };
        _this.handleKeyDown = function(e) {
            _this.moveSelectionOnKeyDown(e);
            _this.openOnArrow(e);
            _this.openOnSpace(e);
            _this.selectItemOnEnter(e);
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onKeyDown', e);
        };
        _this.getSelectedItem = function(selectedIndex) {
            var options = (0, $767c058c18765207$export$2e2bcd8739ae039)({
                value: _this.state.value,
                options: _this.props.options,
                searchQuery: _this.state.searchQuery,
                additionLabel: _this.props.additionLabel,
                additionPosition: _this.props.additionPosition,
                allowAdditions: _this.props.allowAdditions,
                deburr: _this.props.deburr,
                multiple: _this.props.multiple,
                search: _this.props.search
            });
            return (0, $4b263473fff5783f$export$2e2bcd8739ae039)(options, "[" + selectedIndex + "]");
        };
        _this.getItemByValue = function(value) {
            var options = _this.props.options;
            return (0, $e1d6d905b1dc141e$export$2e2bcd8739ae039)(options, {
                value: value
            });
        };
        _this.getDropdownAriaOptions = function() {
            var _this$props7 = _this.props, loading = _this$props7.loading, disabled = _this$props7.disabled, search = _this$props7.search, multiple = _this$props7.multiple;
            var open = _this.state.open;
            var ariaOptions = {
                role: search ? 'combobox' : 'listbox',
                'aria-busy': loading,
                'aria-disabled': disabled,
                'aria-expanded': !!open
            };
            if (ariaOptions.role === 'listbox') ariaOptions['aria-multiselectable'] = multiple;
            return ariaOptions;
        };
        _this.clearSearchQuery = function() {
            var searchQuery = _this.state.searchQuery;
            if (searchQuery === undefined || searchQuery === '') return;
            _this.setState({
                searchQuery: ''
            });
        };
        _this.handleLabelClick = function(e, labelProps) {
            // prevent focusing search input on click
            e.stopPropagation();
            _this.setState({
                selectedLabel: labelProps.value
            });
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onLabelClick', e, labelProps);
        };
        _this.handleLabelRemove = function(e, labelProps) {
            // prevent focusing search input on click
            e.stopPropagation();
            var value = _this.state.value;
            var newValue = (0, $f5797dc729670952$export$2e2bcd8739ae039)(value, labelProps.value);
            _this.setState({
                value: newValue
            });
            _this.handleChange(e, newValue);
        };
        _this.getSelectedIndexAfterMove = function(offset, startIndex) {
            if (startIndex === void 0) startIndex = _this.state.selectedIndex;
            var options = (0, $767c058c18765207$export$2e2bcd8739ae039)({
                value: _this.state.value,
                options: _this.props.options,
                searchQuery: _this.state.searchQuery,
                additionLabel: _this.props.additionLabel,
                additionPosition: _this.props.additionPosition,
                allowAdditions: _this.props.allowAdditions,
                deburr: _this.props.deburr,
                multiple: _this.props.multiple,
                search: _this.props.search
            }); // Prevent infinite loop
            // TODO: remove left part of condition after children API will be removed
            if (options === undefined || (0, $2c6099775fd5a24e$export$2e2bcd8739ae039)(options, 'disabled')) return;
            var lastIndex = options.length - 1;
            var wrapSelection = _this.props.wrapSelection; // next is after last, wrap to beginning
            // next is before first, wrap to end
            var nextIndex = startIndex + offset; // if 'wrapSelection' is set to false and selection is after last or before first, it just does not change
            if (!wrapSelection && (nextIndex > lastIndex || nextIndex < 0)) nextIndex = startIndex;
            else if (nextIndex > lastIndex) nextIndex = 0;
            else if (nextIndex < 0) nextIndex = lastIndex;
            if (options[nextIndex].disabled) return _this.getSelectedIndexAfterMove(offset, nextIndex);
            return nextIndex;
        };
        _this.handleIconOverrides = function(predefinedProps) {
            var clearable = _this.props.clearable;
            var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)(clearable && _this.hasValue() && 'clear', predefinedProps.className);
            return {
                className: classes,
                onClick: function onClick(e) {
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(predefinedProps, 'onClick', e, predefinedProps);
                    _this.handleIconClick(e);
                }
            };
        };
        _this.clearValue = function(e) {
            var multiple = _this.props.multiple;
            var newValue = multiple ? [] : '';
            _this.setState({
                value: newValue
            });
            _this.handleChange(e, newValue);
        };
        _this.computeSearchInputTabIndex = function() {
            var _this$props8 = _this.props, disabled = _this$props8.disabled, tabIndex = _this$props8.tabIndex;
            if (!(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(tabIndex)) return tabIndex;
            return disabled ? -1 : 0;
        };
        _this.computeSearchInputWidth = function() {
            var searchQuery = _this.state.searchQuery;
            if (_this.sizerRef.current && searchQuery) {
                // resize the search input, temporarily show the sizer so we can measure it
                _this.sizerRef.current.style.display = 'inline';
                _this.sizerRef.current.textContent = searchQuery;
                var searchWidth = Math.ceil(_this.sizerRef.current.getBoundingClientRect().width);
                _this.sizerRef.current.style.removeProperty('display');
                return searchWidth;
            }
        };
        _this.computeTabIndex = function() {
            var _this$props9 = _this.props, disabled = _this$props9.disabled, search = _this$props9.search, tabIndex = _this$props9.tabIndex; // don't set a root node tabIndex as the search input has its own tabIndex
            if (search) return undefined;
            if (disabled) return -1;
            return (0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(tabIndex) ? 0 : tabIndex;
        };
        _this.handleSearchInputOverrides = function(predefinedProps) {
            return {
                onChange: function onChange(e, inputProps) {
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(predefinedProps, 'onChange', e, inputProps);
                    _this.handleSearchChange(e, inputProps);
                }
            };
        };
        _this.hasValue = function() {
            var multiple = _this.props.multiple;
            var value = _this.state.value;
            return multiple ? !(0, $ef1dc2bcf455bc8f$export$2e2bcd8739ae039)(value) : !(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(value) && value !== '';
        };
        _this.scrollSelectedItemIntoView = function() {
            if (!_this.ref.current) return;
            var menu = _this.ref.current.querySelector('.menu.visible');
            if (!menu) return;
            var item = menu.querySelector('.item.selected');
            if (!item) return;
            var isOutOfUpperView = item.offsetTop < menu.scrollTop;
            var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;
            if (isOutOfUpperView) menu.scrollTop = item.offsetTop;
            else if (isOutOfLowerView) // eslint-disable-next-line no-mixed-operators
            menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
        };
        _this.setOpenDirection = function() {
            if (!_this.ref.current) return;
            var menu = _this.ref.current.querySelector('.menu.visible');
            if (!menu) return;
            var dropdownRect = _this.ref.current.getBoundingClientRect();
            var menuHeight = menu.clientHeight;
            var spaceAtTheBottom = document.documentElement.clientHeight - dropdownRect.top - dropdownRect.height - menuHeight;
            var spaceAtTheTop = dropdownRect.top - menuHeight;
            var upward = spaceAtTheBottom < 0 && spaceAtTheTop > spaceAtTheBottom; // set state only if there's a relevant difference
            if (!upward !== !_this.state.upward) _this.setState({
                upward: upward
            });
        };
        _this.open = function(e, triggerSetState) {
            if (e === void 0) e = null;
            if (triggerSetState === void 0) triggerSetState = true;
            var _this$props10 = _this.props, disabled = _this$props10.disabled, search = _this$props10.search;
            if (disabled) return;
            if (search) (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.searchRef.current, 'focus');
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onOpen', e, _this.props);
            if (triggerSetState) _this.setState({
                open: true
            });
            _this.scrollSelectedItemIntoView();
        };
        _this.close = function(e, callback) {
            if (callback === void 0) callback = _this.handleClose;
            if (_this.state.open) {
                (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onClose', e, _this.props);
                _this.setState({
                    open: false
                }, callback);
            }
        };
        _this.handleClose = function() {
            var hasSearchFocus = document.activeElement === _this.searchRef.current; // https://github.com/Semantic-Org/Semantic-UI-React/issues/627
            // Blur the Dropdown on close so it is blurred after selecting an item.
            // This is to prevent it from re-opening when switching tabs after selecting an item.
            if (!hasSearchFocus && _this.ref.current) _this.ref.current.blur();
            var hasDropdownFocus = document.activeElement === _this.ref.current;
            var hasFocus = hasSearchFocus || hasDropdownFocus; // We need to keep the virtual model in sync with the browser focus change
            // https://github.com/Semantic-Org/Semantic-UI-React/issues/692
            _this.setState({
                focus: hasFocus
            });
        };
        _this.toggle = function(e) {
            return _this.state.open ? _this.close(e) : _this.open(e);
        };
        _this.renderText = function() {
            var _this$props11 = _this.props, multiple = _this$props11.multiple, placeholder = _this$props11.placeholder, search = _this$props11.search, text = _this$props11.text;
            var _this$state6 = _this.state, searchQuery = _this$state6.searchQuery, selectedIndex = _this$state6.selectedIndex, value = _this$state6.value, open = _this$state6.open;
            var hasValue = _this.hasValue();
            var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)(placeholder && !hasValue && 'default', 'text', search && searchQuery && 'filtered');
            var _text = placeholder;
            var selectedItem;
            if (text) _text = text;
            else if (open && !multiple) selectedItem = _this.getSelectedItem(selectedIndex);
            else if (hasValue) selectedItem = _this.getItemByValue(value);
            return (0, $e36564613a7fb3fc$export$2e2bcd8739ae039).create(selectedItem ? $6a9eaf6b801099ca$var$renderItemContent(selectedItem) : _text, {
                defaultProps: {
                    className: classes
                }
            });
        };
        _this.renderSearchInput = function() {
            var _this$props12 = _this.props, search = _this$props12.search, searchInput = _this$props12.searchInput;
            var searchQuery = _this.state.searchQuery;
            return search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c3c11b3db64bf060$export$9bcc32033bdd12aa), {
                innerRef: _this.searchRef
            }, (0, $5b4aaa243e2b3764$export$2e2bcd8739ae039).create(searchInput, {
                defaultProps: {
                    style: {
                        width: _this.computeSearchInputWidth()
                    },
                    tabIndex: _this.computeSearchInputTabIndex(),
                    value: searchQuery
                },
                overrideProps: _this.handleSearchInputOverrides
            }));
        };
        _this.renderSearchSizer = function() {
            var _this$props13 = _this.props, search = _this$props13.search, multiple = _this$props13.multiple;
            return search && multiple && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("span", {
                className: "sizer",
                ref: _this.sizerRef
            });
        };
        _this.renderLabels = function() {
            var _this$props14 = _this.props, multiple = _this$props14.multiple, renderLabel = _this$props14.renderLabel;
            var _this$state7 = _this.state, selectedLabel = _this$state7.selectedLabel, value = _this$state7.value;
            if (!multiple || (0, $ef1dc2bcf455bc8f$export$2e2bcd8739ae039)(value)) return;
            var selectedItems = (0, $2ef0baf102d48982$export$2e2bcd8739ae039)(value, _this.getItemByValue);
            // if no item could be found for a given state value the selected item will be undefined
            // compact the selectedItems so we only have actual objects left
            return (0, $2ef0baf102d48982$export$2e2bcd8739ae039)((0, $2b603ea1555cc26f$export$2e2bcd8739ae039)(selectedItems), function(item, index) {
                var defaultProps = {
                    active: item.value === selectedLabel,
                    as: 'a',
                    key: $6a9eaf6b801099ca$var$getKeyOrValue(item.key, item.value),
                    onClick: _this.handleLabelClick,
                    onRemove: _this.handleLabelRemove,
                    value: item.value
                };
                return (0, $2f87e91a93ad1d2d$export$2e2bcd8739ae039).create(renderLabel(item, index, defaultProps), {
                    defaultProps: defaultProps
                });
            });
        };
        _this.renderOptions = function() {
            var _this$props15 = _this.props, lazyLoad = _this$props15.lazyLoad, multiple = _this$props15.multiple, search = _this$props15.search, noResultsMessage = _this$props15.noResultsMessage;
            var _this$state8 = _this.state, open = _this$state8.open, selectedIndex = _this$state8.selectedIndex, value = _this$state8.value; // lazy load, only render options when open
            if (lazyLoad && !open) return null;
            var options = (0, $767c058c18765207$export$2e2bcd8739ae039)({
                value: _this.state.value,
                options: _this.props.options,
                searchQuery: _this.state.searchQuery,
                additionLabel: _this.props.additionLabel,
                additionPosition: _this.props.additionPosition,
                allowAdditions: _this.props.allowAdditions,
                deburr: _this.props.deburr,
                multiple: _this.props.multiple,
                search: _this.props.search
            });
            if (noResultsMessage !== null && search && (0, $ef1dc2bcf455bc8f$export$2e2bcd8739ae039)(options)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement("div", {
                className: "message"
            }, noResultsMessage);
            var isActive = multiple ? function(optValue) {
                return (0, $9d3d4e08270ebb7e$export$2e2bcd8739ae039)(value, optValue);
            } : function(optValue) {
                return optValue === value;
            };
            return (0, $2ef0baf102d48982$export$2e2bcd8739ae039)(options, function(opt, i) {
                return (0, $d848913c0cf68d0a$export$2e2bcd8739ae039).create((0, $1e0a7747b096edac$export$2e2bcd8739ae039)({
                    active: isActive(opt.value),
                    selected: selectedIndex === i
                }, opt, {
                    key: $6a9eaf6b801099ca$var$getKeyOrValue(opt.key, opt.value),
                    // Needed for handling click events on disabled items
                    style: (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, opt.style, {
                        pointerEvents: 'all'
                    })
                }), {
                    generateKey: false,
                    overrideProps: function overrideProps(predefinedProps) {
                        return {
                            onClick: function onClick(e, item) {
                                predefinedProps.onClick == null || predefinedProps.onClick(e, item);
                                _this.handleItemClick(e, item);
                            }
                        };
                    }
                });
            });
        };
        _this.renderMenu = function() {
            var _this$props16 = _this.props, children = _this$props16.children, direction = _this$props16.direction, header = _this$props16.header;
            var open = _this.state.open;
            var ariaOptions = _this.getDropdownMenuAriaOptions(); // single menu child
            if (!(0, $f0526af735e6584e$exports).isNil(children)) {
                var menuChild = (0, $6aRB8.Children).only(children);
                var className = (0, $b589707e9204a564$export$2e2bcd8739ae039)(direction, (0, $87a122667489288b$export$aac7d417530cc39a)(open, 'visible'), menuChild.props.className);
                return /*#__PURE__*/ (0, $6aRB8.cloneElement)(menuChild, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({
                    className: className
                }, ariaOptions));
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $08884420bb5edbf7$export$2e2bcd8739ae039), (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, ariaOptions, {
                direction: direction,
                open: open
            }), (0, $6ce8094570bcf665$export$2e2bcd8739ae039).create(header, {
                autoGenerateKey: false
            }), _this.renderOptions());
        };
        return _this;
    }
    var _proto = Dropdown.prototype;
    _proto.getInitialAutoControlledState = function getInitialAutoControlledState() {
        return {
            focus: false,
            searchQuery: ''
        };
    };
    Dropdown.getAutoControlledStateFromProps = function getAutoControlledStateFromProps(nextProps, computedState, prevState) {
        // These values are stored only for a comparison on next getAutoControlledStateFromProps()
        var derivedState = {
            __options: nextProps.options,
            __value: computedState.value
        }; // The selected index is only dependent:
        var shouldComputeSelectedIndex = !(0, (/*@__PURE__*/$parcel$interopDefault($0080e586c00e3b93$exports)))(prevState.__value, computedState.value) || // On option keys/values, we only check those properties to avoid recursive performance impacts.
        // https://github.com/Semantic-Org/Semantic-UI-React/issues/3000
        !(0, $d6a9eb1c5f340c48$export$2e2bcd8739ae039)($6a9eaf6b801099ca$var$getKeyAndValues(nextProps.options), $6a9eaf6b801099ca$var$getKeyAndValues(prevState.__options));
        if (shouldComputeSelectedIndex) derivedState.selectedIndex = (0, $fa87ff716389e71e$export$2e2bcd8739ae039)({
            additionLabel: nextProps.additionLabel,
            additionPosition: nextProps.additionPosition,
            allowAdditions: nextProps.allowAdditions,
            deburr: nextProps.deburr,
            multiple: nextProps.multiple,
            search: nextProps.search,
            selectedIndex: computedState.selectedIndex,
            value: computedState.value,
            options: nextProps.options,
            searchQuery: computedState.searchQuery
        });
        return derivedState;
    };
    _proto.componentDidMount = function componentDidMount() {
        var open = this.state.open;
        if (open) this.open(null, false);
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($0080e586c00e3b93$exports)))(nextProps, this.props) || !(0, (/*@__PURE__*/$parcel$interopDefault($0080e586c00e3b93$exports)))(nextState, this.state);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        // eslint-disable-line complexity
        var _this$props17 = this.props, closeOnBlur = _this$props17.closeOnBlur, minCharacters = _this$props17.minCharacters, openOnFocus = _this$props17.openOnFocus, search = _this$props17.search;
        var isNextValueArray, hasValue;
        /* eslint-enable no-console */ // focused / blurred
        if (!prevState.focus && this.state.focus) {
            if (!this.isMouseDown) {
                var openable = !search || search && minCharacters === 1 && !this.state.open;
                if (openOnFocus && openable) this.open();
            }
        } else if (prevState.focus && !this.state.focus) {
            if (!this.isMouseDown && closeOnBlur) this.close();
        } // opened / closed
        if (!prevState.open && this.state.open) {
            this.setOpenDirection();
            this.scrollSelectedItemIntoView();
        } else prevState.open && this.state.open;
        if (prevState.selectedIndex !== this.state.selectedIndex) this.scrollSelectedItemIntoView();
    } // ----------------------------------------
    ;
    _proto.getDropdownMenuAriaOptions = function getDropdownMenuAriaOptions() {
        var _this$props18 = this.props, search = _this$props18.search, multiple = _this$props18.multiple;
        var ariaOptions = {};
        if (search) {
            ariaOptions['aria-multiselectable'] = multiple;
            ariaOptions.role = 'listbox';
        }
        return ariaOptions;
    } // ----------------------------------------
    ;
    _proto.render = function render() {
        var _this$props19 = this.props, basic = _this$props19.basic, button = _this$props19.button, className = _this$props19.className, compact = _this$props19.compact, disabled = _this$props19.disabled, error = _this$props19.error, fluid = _this$props19.fluid, floating = _this$props19.floating, icon = _this$props19.icon, inline = _this$props19.inline, item = _this$props19.item, labeled = _this$props19.labeled, loading = _this$props19.loading, multiple = _this$props19.multiple, pointing = _this$props19.pointing, search = _this$props19.search, selection = _this$props19.selection, scrolling = _this$props19.scrolling, simple = _this$props19.simple, trigger = _this$props19.trigger;
        var _this$state9 = this.state, focus = _this$state9.focus, open = _this$state9.open, upward = _this$state9.upward; // Classes
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', (0, $87a122667489288b$export$aac7d417530cc39a)(open, 'active visible'), (0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$aac7d417530cc39a)(error, 'error'), (0, $87a122667489288b$export$aac7d417530cc39a)(loading, 'loading'), (0, $87a122667489288b$export$aac7d417530cc39a)(basic, 'basic'), (0, $87a122667489288b$export$aac7d417530cc39a)(button, 'button'), (0, $87a122667489288b$export$aac7d417530cc39a)(compact, 'compact'), (0, $87a122667489288b$export$aac7d417530cc39a)(fluid, 'fluid'), (0, $87a122667489288b$export$aac7d417530cc39a)(floating, 'floating'), (0, $87a122667489288b$export$aac7d417530cc39a)(inline, 'inline'), // https://github.com/Semantic-Org/Semantic-UI-React/issues/401#issuecomment-240487229
        // TODO: the icon class is only required when a dropdown is a button
        // useKeyOnly(icon, 'icon'),
        (0, $87a122667489288b$export$aac7d417530cc39a)(labeled, 'labeled'), (0, $87a122667489288b$export$aac7d417530cc39a)(item, 'item'), (0, $87a122667489288b$export$aac7d417530cc39a)(multiple, 'multiple'), (0, $87a122667489288b$export$aac7d417530cc39a)(search, 'search'), (0, $87a122667489288b$export$aac7d417530cc39a)(selection, 'selection'), (0, $87a122667489288b$export$aac7d417530cc39a)(simple, 'simple'), (0, $87a122667489288b$export$aac7d417530cc39a)(scrolling, 'scrolling'), (0, $87a122667489288b$export$aac7d417530cc39a)(upward, 'upward'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(pointing, 'pointing'), 'dropdown', className);
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(Dropdown, this.props);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(Dropdown, this.props);
        var ariaOptions = this.getDropdownAriaOptions(ElementType, this.props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c3c11b3db64bf060$export$9bcc32033bdd12aa), {
            innerRef: this.ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, ariaOptions, {
            className: classes,
            onBlur: this.handleBlur,
            onClick: this.handleClick,
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleMouseDown,
            onFocus: this.handleFocus,
            onChange: this.handleChange,
            tabIndex: this.computeTabIndex()
        }), this.renderLabels(), this.renderSearchInput(), this.renderSearchSizer(), trigger || this.renderText(), (0, $760d0282e0637aa7$export$2e2bcd8739ae039).create(icon, {
            overrideProps: this.handleIconOverrides,
            autoGenerateKey: false
        }), this.renderMenu(), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d84a0216b5e1bcaf$exports))), {
            name: "keydown",
            on: this.closeOnEscape
        }), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d84a0216b5e1bcaf$exports))), {
            name: "click",
            on: this.closeOnDocumentClick
        }), focus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d84a0216b5e1bcaf$exports))), {
            name: "keydown",
            on: this.removeItemOnBackspace
        })));
    };
    return Dropdown;
}((0, $14f3bba04a1282e8$export$2e2bcd8739ae039));
$6a9eaf6b801099ca$export$2e2bcd8739ae039.handledProps = [
    "additionLabel",
    "additionPosition",
    "allowAdditions",
    "as",
    "basic",
    "button",
    "children",
    "className",
    "clearable",
    "closeOnBlur",
    "closeOnChange",
    "closeOnEscape",
    "compact",
    "deburr",
    "defaultOpen",
    "defaultSearchQuery",
    "defaultSelectedLabel",
    "defaultUpward",
    "defaultValue",
    "direction",
    "disabled",
    "error",
    "floating",
    "fluid",
    "header",
    "icon",
    "inline",
    "item",
    "labeled",
    "lazyLoad",
    "loading",
    "minCharacters",
    "multiple",
    "noResultsMessage",
    "onAddItem",
    "onBlur",
    "onChange",
    "onClick",
    "onClose",
    "onFocus",
    "onLabelClick",
    "onMouseDown",
    "onOpen",
    "onSearchChange",
    "open",
    "openOnFocus",
    "options",
    "placeholder",
    "pointing",
    "renderLabel",
    "scrolling",
    "search",
    "searchInput",
    "searchQuery",
    "selectOnBlur",
    "selectOnNavigation",
    "selectedLabel",
    "selection",
    "simple",
    "tabIndex",
    "text",
    "trigger",
    "upward",
    "value",
    "wrapSelection"
];
$6a9eaf6b801099ca$export$2e2bcd8739ae039.propTypes = {};
$6a9eaf6b801099ca$export$2e2bcd8739ae039.defaultProps = {
    additionLabel: 'Add ',
    additionPosition: 'top',
    closeOnBlur: true,
    closeOnEscape: true,
    deburr: false,
    icon: 'dropdown',
    minCharacters: 1,
    noResultsMessage: 'No results found.',
    openOnFocus: true,
    renderLabel: $6a9eaf6b801099ca$var$renderItemContent,
    searchInput: 'text',
    selectOnBlur: true,
    selectOnNavigation: true,
    wrapSelection: true
};
$6a9eaf6b801099ca$export$2e2bcd8739ae039.autoControlledProps = [
    'open',
    'searchQuery',
    'selectedLabel',
    'value',
    'upward'
];
$6a9eaf6b801099ca$export$2e2bcd8739ae039.Divider = (0, $35686c94b8eaa217$export$2e2bcd8739ae039);
$6a9eaf6b801099ca$export$2e2bcd8739ae039.Header = (0, $6ce8094570bcf665$export$2e2bcd8739ae039);
$6a9eaf6b801099ca$export$2e2bcd8739ae039.Item = (0, $d848913c0cf68d0a$export$2e2bcd8739ae039);
$6a9eaf6b801099ca$export$2e2bcd8739ae039.Menu = (0, $08884420bb5edbf7$export$2e2bcd8739ae039);
$6a9eaf6b801099ca$export$2e2bcd8739ae039.SearchInput = (0, $5b4aaa243e2b3764$export$2e2bcd8739ae039);
$6a9eaf6b801099ca$export$2e2bcd8739ae039.Text = (0, $e36564613a7fb3fc$export$2e2bcd8739ae039);



/**
 * Sugar for <Form.Field control={Dropdown} />.
 * @see Dropdown
 * @see Form
 */ function $8bed0ecf6dbfcfb5$var$FormDropdown(props) {
    var control = props.control;
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($8bed0ecf6dbfcfb5$var$FormDropdown, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($8bed0ecf6dbfcfb5$var$FormDropdown, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        control: control
    }));
}
$8bed0ecf6dbfcfb5$var$FormDropdown.handledProps = [
    "as",
    "control"
];
$8bed0ecf6dbfcfb5$var$FormDropdown.propTypes = {};
$8bed0ecf6dbfcfb5$var$FormDropdown.defaultProps = {
    as: (0, $19186099d0926d92$export$2e2bcd8739ae039),
    control: (0, $6a9eaf6b801099ca$export$2e2bcd8739ae039)
};
var $8bed0ecf6dbfcfb5$export$2e2bcd8739ae039 = $8bed0ecf6dbfcfb5$var$FormDropdown;







var $6aRB8 = parcelRequire("6aRB8");

/**
 * A set of fields can appear grouped together.
 * @see Form
 */ function $8b9e9fe3621f374b$var$FormGroup(props) {
    var children = props.children, className = props.className, grouped = props.grouped, inline = props.inline, unstackable = props.unstackable, widths = props.widths;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$aac7d417530cc39a)(grouped, 'grouped'), (0, $87a122667489288b$export$aac7d417530cc39a)(inline, 'inline'), (0, $87a122667489288b$export$aac7d417530cc39a)(unstackable, 'unstackable'), (0, $87a122667489288b$export$52866a87b538f23c)(widths, null, true), 'fields', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($8b9e9fe3621f374b$var$FormGroup, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($8b9e9fe3621f374b$var$FormGroup, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), children);
}
$8b9e9fe3621f374b$var$FormGroup.handledProps = [
    "as",
    "children",
    "className",
    "grouped",
    "inline",
    "unstackable",
    "widths"
];
$8b9e9fe3621f374b$var$FormGroup.propTypes = {};
var $8b9e9fe3621f374b$export$2e2bcd8739ae039 = $8b9e9fe3621f374b$var$FormGroup;





var $6aRB8 = parcelRequire("6aRB8");












var $6aRB8 = parcelRequire("6aRB8");




/**
 * An Input is a field used to elicit a response from a user.
 * @see Button
 * @see Form
 * @see Icon
 * @see Label
 */ var $c3e11b23f4f91050$var$Input = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(Input, _Component);
    function Input() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.inputRef = /*#__PURE__*/ (0, $6aRB8.createRef)();
        _this.computeIcon = function() {
            var _this$props = _this.props, loading = _this$props.loading, icon = _this$props.icon;
            if (!(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(icon)) return icon;
            if (loading) return 'spinner';
        };
        _this.computeTabIndex = function() {
            var _this$props2 = _this.props, disabled = _this$props2.disabled, tabIndex = _this$props2.tabIndex;
            if (!(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(tabIndex)) return tabIndex;
            if (disabled) return -1;
        };
        _this.focus = function(options) {
            return _this.inputRef.current.focus(options);
        };
        _this.select = function() {
            return _this.inputRef.current.select();
        };
        _this.handleChange = function(e) {
            var value = (0, $4b263473fff5783f$export$2e2bcd8739ae039)(e, 'target.value');
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onChange', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                value: value
            }));
        };
        _this.handleChildOverrides = function(child, defaultProps) {
            return (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, defaultProps, child.props, {
                ref: function ref(c) {
                    (0, $2b42f5a2eeaa6c35$export$5cc535d419e048c1)(child.ref, c);
                    _this.inputRef.current = c;
                }
            });
        };
        _this.partitionProps = function() {
            var _this$props3 = _this.props, disabled = _this$props3.disabled, type = _this$props3.type;
            var tabIndex = _this.computeTabIndex();
            var unhandled = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(Input, _this.props);
            var _partitionHTMLProps = (0, $506c31eb45df8858$export$a0111cfe23fb429)(unhandled), htmlInputProps = _partitionHTMLProps[0], rest = _partitionHTMLProps[1];
            return [
                (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, htmlInputProps, {
                    disabled: disabled,
                    type: type,
                    tabIndex: tabIndex,
                    onChange: _this.handleChange,
                    ref: _this.inputRef
                }),
                rest
            ];
        };
        return _this;
    }
    var _proto = Input.prototype;
    _proto.render = function render() {
        var _this2 = this;
        var _this$props4 = this.props, action = _this$props4.action, actionPosition = _this$props4.actionPosition, children = _this$props4.children, className = _this$props4.className, disabled = _this$props4.disabled, error = _this$props4.error, fluid = _this$props4.fluid, focus = _this$props4.focus, icon = _this$props4.icon, iconPosition = _this$props4.iconPosition, input = _this$props4.input, inverted = _this$props4.inverted, label = _this$props4.label, labelPosition = _this$props4.labelPosition, loading = _this$props4.loading, size = _this$props4.size, transparent = _this$props4.transparent, type = _this$props4.type;
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', size, (0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$aac7d417530cc39a)(error, 'error'), (0, $87a122667489288b$export$aac7d417530cc39a)(fluid, 'fluid'), (0, $87a122667489288b$export$aac7d417530cc39a)(focus, 'focus'), (0, $87a122667489288b$export$aac7d417530cc39a)(inverted, 'inverted'), (0, $87a122667489288b$export$aac7d417530cc39a)(loading, 'loading'), (0, $87a122667489288b$export$aac7d417530cc39a)(transparent, 'transparent'), (0, $87a122667489288b$export$fb1b8744f6450628)(actionPosition, 'action') || (0, $87a122667489288b$export$aac7d417530cc39a)(action, 'action'), (0, $87a122667489288b$export$fb1b8744f6450628)(iconPosition, 'icon') || (0, $87a122667489288b$export$aac7d417530cc39a)(icon || loading, 'icon'), (0, $87a122667489288b$export$fb1b8744f6450628)(labelPosition, 'labeled') || (0, $87a122667489288b$export$aac7d417530cc39a)(label, 'labeled'), 'input', className);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(Input, this.props);
        var _this$partitionProps = this.partitionProps(), htmlInputProps = _this$partitionProps[0], rest = _this$partitionProps[1]; // Render with children
        // ----------------------------------------
        if (!(0, $f0526af735e6584e$exports).isNil(children)) {
            // add htmlInputProps to the `<input />` child
            var childElements = (0, $2ef0baf102d48982$export$2e2bcd8739ae039)((0, $6aRB8.Children).toArray(children), function(child) {
                if (child.type !== 'input') return child;
                return /*#__PURE__*/ (0, $6aRB8.cloneElement)(child, _this2.handleChildOverrides(child, htmlInputProps));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
                className: classes
            }), childElements);
        } // Render Shorthand
        // ----------------------------------------
        var actionElement = (0, $a7825a90230ff993$export$2e2bcd8739ae039).create(action, {
            autoGenerateKey: false
        });
        var labelElement = (0, $2f87e91a93ad1d2d$export$2e2bcd8739ae039).create(label, {
            defaultProps: {
                className: (0, $b589707e9204a564$export$2e2bcd8739ae039)('label', (0, $9d3d4e08270ebb7e$export$2e2bcd8739ae039)(labelPosition, 'corner') && labelPosition)
            },
            autoGenerateKey: false
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            className: classes
        }), actionPosition === 'left' && actionElement, labelPosition !== 'right' && labelElement, (0, $d590e40415a777e8$export$8f85afee429cd78b)(input || type, {
            defaultProps: htmlInputProps,
            autoGenerateKey: false
        }), (0, $760d0282e0637aa7$export$2e2bcd8739ae039).create(this.computeIcon(), {
            autoGenerateKey: false
        }), actionPosition !== 'left' && actionElement, labelPosition === 'right' && labelElement);
    };
    return Input;
}((0, $6aRB8.Component));
$c3e11b23f4f91050$var$Input.handledProps = [
    "action",
    "actionPosition",
    "as",
    "children",
    "className",
    "disabled",
    "error",
    "fluid",
    "focus",
    "icon",
    "iconPosition",
    "input",
    "inverted",
    "label",
    "labelPosition",
    "loading",
    "onChange",
    "size",
    "tabIndex",
    "transparent",
    "type"
];
$c3e11b23f4f91050$var$Input.propTypes = {};
$c3e11b23f4f91050$var$Input.defaultProps = {
    type: 'text'
};
$c3e11b23f4f91050$var$Input.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($c3e11b23f4f91050$var$Input, function(type) {
    return {
        type: type
    };
});
var $c3e11b23f4f91050$export$2e2bcd8739ae039 = $c3e11b23f4f91050$var$Input;



/**
 * Sugar for <Form.Field control={Input} />.
 * @see Form
 * @see Input
 */ function $117bc8ff6129c8c2$var$FormInput(props) {
    var control = props.control;
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($117bc8ff6129c8c2$var$FormInput, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($117bc8ff6129c8c2$var$FormInput, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        control: control
    }));
}
$117bc8ff6129c8c2$var$FormInput.handledProps = [
    "as",
    "control"
];
$117bc8ff6129c8c2$var$FormInput.propTypes = {};
$117bc8ff6129c8c2$var$FormInput.defaultProps = {
    as: (0, $19186099d0926d92$export$2e2bcd8739ae039),
    control: (0, $c3e11b23f4f91050$export$2e2bcd8739ae039)
};
var $117bc8ff6129c8c2$export$2e2bcd8739ae039 = $117bc8ff6129c8c2$var$FormInput;





var $6aRB8 = parcelRequire("6aRB8");



/**
 * Sugar for <Form.Field control={Radio} />.
 * @see Form
 * @see Radio
 */ function $7e5e21ba42f1b174$var$FormRadio(props) {
    var control = props.control;
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($7e5e21ba42f1b174$var$FormRadio, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($7e5e21ba42f1b174$var$FormRadio, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        control: control
    }));
}
$7e5e21ba42f1b174$var$FormRadio.handledProps = [
    "as",
    "control"
];
$7e5e21ba42f1b174$var$FormRadio.propTypes = {};
$7e5e21ba42f1b174$var$FormRadio.defaultProps = {
    as: (0, $19186099d0926d92$export$2e2bcd8739ae039),
    control: (0, $27eaca9c2794488d$export$2e2bcd8739ae039)
};
var $7e5e21ba42f1b174$export$2e2bcd8739ae039 = $7e5e21ba42f1b174$var$FormRadio;





var $6aRB8 = parcelRequire("6aRB8");




var $6aRB8 = parcelRequire("6aRB8");

/**
 * A Select is sugar for <Dropdown selection />.
 * @see Dropdown
 * @see Form
 */ function $1899af63a87bc702$var$Select(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $6a9eaf6b801099ca$export$2e2bcd8739ae039), (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, props, {
        selection: true
    }));
}
$1899af63a87bc702$var$Select.handledProps = [
    "options"
];
$1899af63a87bc702$var$Select.propTypes = {};
$1899af63a87bc702$var$Select.Divider = (0, $6a9eaf6b801099ca$export$2e2bcd8739ae039).Divider;
$1899af63a87bc702$var$Select.Header = (0, $6a9eaf6b801099ca$export$2e2bcd8739ae039).Header;
$1899af63a87bc702$var$Select.Item = (0, $6a9eaf6b801099ca$export$2e2bcd8739ae039).Item;
$1899af63a87bc702$var$Select.Menu = (0, $6a9eaf6b801099ca$export$2e2bcd8739ae039).Menu;
var $1899af63a87bc702$export$2e2bcd8739ae039 = $1899af63a87bc702$var$Select;




/**
 * Sugar for <Form.Field control={Select} />.
 * @see Form
 * @see Select
 */ function $5d52ecac9cd25cc8$var$FormSelect(props) {
    var control = props.control, options = props.options;
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($5d52ecac9cd25cc8$var$FormSelect, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($5d52ecac9cd25cc8$var$FormSelect, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        control: control,
        options: options
    }));
}
$5d52ecac9cd25cc8$var$FormSelect.handledProps = [
    "as",
    "control",
    "options"
];
$5d52ecac9cd25cc8$var$FormSelect.propTypes = {};
$5d52ecac9cd25cc8$var$FormSelect.defaultProps = {
    as: (0, $19186099d0926d92$export$2e2bcd8739ae039),
    control: (0, $1899af63a87bc702$export$2e2bcd8739ae039)
};
var $5d52ecac9cd25cc8$export$2e2bcd8739ae039 = $5d52ecac9cd25cc8$var$FormSelect;





var $6aRB8 = parcelRequire("6aRB8");








var $6aRB8 = parcelRequire("6aRB8");

/**
 * A TextArea can be used to allow for extended user input.
 * @see Form
 */ var $9aa330afcf2d2e91$var$TextArea = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(TextArea, _Component);
    function TextArea() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.ref = /*#__PURE__*/ (0, $6aRB8.createRef)();
        _this.focus = function() {
            return _this.ref.current.focus();
        };
        _this.handleChange = function(e) {
            var value = (0, $4b263473fff5783f$export$2e2bcd8739ae039)(e, 'target.value');
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onChange', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                value: value
            }));
        };
        _this.handleInput = function(e) {
            var value = (0, $4b263473fff5783f$export$2e2bcd8739ae039)(e, 'target.value');
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onInput', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                value: value
            }));
        };
        return _this;
    }
    var _proto = TextArea.prototype;
    _proto.render = function render() {
        var _this$props = this.props, rows = _this$props.rows, value = _this$props.value;
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(TextArea, this.props);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(TextArea, this.props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c3c11b3db64bf060$export$9bcc32033bdd12aa), {
            innerRef: this.ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            onChange: this.handleChange,
            onInput: this.handleInput,
            rows: rows,
            value: value
        })));
    };
    return TextArea;
}((0, $6aRB8.Component));
$9aa330afcf2d2e91$var$TextArea.handledProps = [
    "as",
    "onChange",
    "onInput",
    "rows",
    "value"
];
$9aa330afcf2d2e91$var$TextArea.propTypes = {};
$9aa330afcf2d2e91$var$TextArea.defaultProps = {
    as: 'textarea',
    rows: 3
};
var $9aa330afcf2d2e91$export$2e2bcd8739ae039 = $9aa330afcf2d2e91$var$TextArea;



/**
 * Sugar for <Form.Field control={TextArea} />.
 * @see Form
 * @see TextArea
 */ function $1868aa80e47d0b6b$var$FormTextArea(props) {
    var control = props.control;
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($1868aa80e47d0b6b$var$FormTextArea, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($1868aa80e47d0b6b$var$FormTextArea, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        control: control
    }));
}
$1868aa80e47d0b6b$var$FormTextArea.handledProps = [
    "as",
    "control"
];
$1868aa80e47d0b6b$var$FormTextArea.propTypes = {};
$1868aa80e47d0b6b$var$FormTextArea.defaultProps = {
    as: (0, $19186099d0926d92$export$2e2bcd8739ae039),
    control: (0, $9aa330afcf2d2e91$export$2e2bcd8739ae039)
};
var $1868aa80e47d0b6b$export$2e2bcd8739ae039 = $1868aa80e47d0b6b$var$FormTextArea;


/**
 * A Form displays a set of related user input fields in a structured way.
 * @see Button
 * @see Checkbox
 * @see Dropdown
 * @see Input
 * @see Message
 * @see Radio
 * @see Select
 * @see Visibility
 */ var $b1a734f607ca44b0$var$Form = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(Form, _Component);
    function Form() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(_args)) || this;
        _this.handleSubmit = function(e) {
            var action = _this.props.action; // Heads up! Third party libs can pass own data as first argument, we need to check that it has preventDefault()
            // method.
            if (typeof action !== 'string') (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(e, 'preventDefault');
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039).apply(void 0, [
                _this.props,
                'onSubmit',
                e,
                _this.props
            ].concat(args));
        };
        return _this;
    }
    var _proto = Form.prototype;
    _proto.render = function render() {
        var _this$props = this.props, action = _this$props.action, children = _this$props.children, className = _this$props.className, error = _this$props.error, inverted = _this$props.inverted, loading = _this$props.loading, reply = _this$props.reply, size = _this$props.size, success = _this$props.success, unstackable = _this$props.unstackable, warning = _this$props.warning, widths = _this$props.widths;
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', size, (0, $87a122667489288b$export$aac7d417530cc39a)(error, 'error'), (0, $87a122667489288b$export$aac7d417530cc39a)(inverted, 'inverted'), (0, $87a122667489288b$export$aac7d417530cc39a)(loading, 'loading'), (0, $87a122667489288b$export$aac7d417530cc39a)(reply, 'reply'), (0, $87a122667489288b$export$aac7d417530cc39a)(success, 'success'), (0, $87a122667489288b$export$aac7d417530cc39a)(unstackable, 'unstackable'), (0, $87a122667489288b$export$aac7d417530cc39a)(warning, 'warning'), (0, $87a122667489288b$export$52866a87b538f23c)(widths, null, true), 'form', className);
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(Form, this.props);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(Form, this.props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            action: action,
            className: classes,
            onSubmit: this.handleSubmit
        }), children);
    };
    return Form;
}((0, $6aRB8.Component));
$b1a734f607ca44b0$var$Form.handledProps = [
    "action",
    "as",
    "children",
    "className",
    "error",
    "inverted",
    "loading",
    "onSubmit",
    "reply",
    "size",
    "success",
    "unstackable",
    "warning",
    "widths"
];
$b1a734f607ca44b0$var$Form.propTypes = {};
$b1a734f607ca44b0$var$Form.defaultProps = {
    as: 'form'
};
$b1a734f607ca44b0$var$Form.Field = (0, $19186099d0926d92$export$2e2bcd8739ae039);
$b1a734f607ca44b0$var$Form.Button = (0, $54ebb874bb85cae3$export$2e2bcd8739ae039);
$b1a734f607ca44b0$var$Form.Checkbox = (0, $44c86bc4921262be$export$2e2bcd8739ae039);
$b1a734f607ca44b0$var$Form.Dropdown = (0, $8bed0ecf6dbfcfb5$export$2e2bcd8739ae039);
$b1a734f607ca44b0$var$Form.Group = (0, $8b9e9fe3621f374b$export$2e2bcd8739ae039);
$b1a734f607ca44b0$var$Form.Input = (0, $117bc8ff6129c8c2$export$2e2bcd8739ae039);
$b1a734f607ca44b0$var$Form.Radio = (0, $7e5e21ba42f1b174$export$2e2bcd8739ae039);
$b1a734f607ca44b0$var$Form.Select = (0, $5d52ecac9cd25cc8$export$2e2bcd8739ae039);
$b1a734f607ca44b0$var$Form.TextArea = (0, $1868aa80e47d0b6b$export$2e2bcd8739ae039);
var $b1a734f607ca44b0$export$2e2bcd8739ae039 = $b1a734f607ca44b0$var$Form;






var $6aRB8 = parcelRequire("6aRB8");







var $6aRB8 = parcelRequire("6aRB8");

/**
 * Headers may contain subheaders.
 */ function $d7829f61a7c11be1$var$HeaderSubheader(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('sub header', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($d7829f61a7c11be1$var$HeaderSubheader, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($d7829f61a7c11be1$var$HeaderSubheader, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$d7829f61a7c11be1$var$HeaderSubheader.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
$d7829f61a7c11be1$var$HeaderSubheader.propTypes = {};
$d7829f61a7c11be1$var$HeaderSubheader.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($d7829f61a7c11be1$var$HeaderSubheader, function(content) {
    return {
        content: content
    };
});
var $d7829f61a7c11be1$export$2e2bcd8739ae039 = $d7829f61a7c11be1$var$HeaderSubheader;






var $6aRB8 = parcelRequire("6aRB8");

/**
 * Header content wraps the main content when there is an adjacent Icon or Image.
 */ function $49685972f7ef63dc$var$HeaderContent(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('content', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($49685972f7ef63dc$var$HeaderContent, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($49685972f7ef63dc$var$HeaderContent, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$49685972f7ef63dc$var$HeaderContent.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
$49685972f7ef63dc$var$HeaderContent.propTypes = {};
var $49685972f7ef63dc$export$2e2bcd8739ae039 = $49685972f7ef63dc$var$HeaderContent;


/**
 * A header provides a short summary of content
 */ function $562317775b0c6bd4$var$Header(props) {
    var attached = props.attached, block = props.block, children = props.children, className = props.className, color = props.color, content = props.content, disabled = props.disabled, dividing = props.dividing, floated = props.floated, icon = props.icon, image = props.image, inverted = props.inverted, size = props.size, sub = props.sub, subheader = props.subheader, textAlign = props.textAlign;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', color, size, (0, $87a122667489288b$export$aac7d417530cc39a)(block, 'block'), (0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$aac7d417530cc39a)(dividing, 'dividing'), (0, $87a122667489288b$export$fb1b8744f6450628)(floated, 'floated'), (0, $87a122667489288b$export$aac7d417530cc39a)(icon === true, 'icon'), (0, $87a122667489288b$export$aac7d417530cc39a)(image === true, 'image'), (0, $87a122667489288b$export$aac7d417530cc39a)(inverted, 'inverted'), (0, $87a122667489288b$export$aac7d417530cc39a)(sub, 'sub'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(attached, 'attached'), (0, $87a122667489288b$export$32c7303ec0b907a1)(textAlign), 'header', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($562317775b0c6bd4$var$Header, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($562317775b0c6bd4$var$Header, props);
    if (!(0, $f0526af735e6584e$exports).isNil(children)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), children);
    var iconElement = (0, $760d0282e0637aa7$export$2e2bcd8739ae039).create(icon, {
        autoGenerateKey: false
    });
    var imageElement = (0, $32f1a379a68c59a0$export$2e2bcd8739ae039).create(image, {
        autoGenerateKey: false
    });
    var subheaderElement = (0, $d7829f61a7c11be1$export$2e2bcd8739ae039).create(subheader, {
        autoGenerateKey: false
    });
    if (iconElement || imageElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), iconElement || imageElement, (content || subheaderElement) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $49685972f7ef63dc$export$2e2bcd8739ae039), null, content, subheaderElement));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), content, subheaderElement);
}
$562317775b0c6bd4$var$Header.handledProps = [
    "as",
    "attached",
    "block",
    "children",
    "className",
    "color",
    "content",
    "disabled",
    "dividing",
    "floated",
    "icon",
    "image",
    "inverted",
    "size",
    "sub",
    "subheader",
    "textAlign"
];
$562317775b0c6bd4$var$Header.propTypes = {};
$562317775b0c6bd4$var$Header.Content = (0, $49685972f7ef63dc$export$2e2bcd8739ae039);
$562317775b0c6bd4$var$Header.Subheader = (0, $d7829f61a7c11be1$export$2e2bcd8739ae039);
var $562317775b0c6bd4$export$2e2bcd8739ae039 = $562317775b0c6bd4$var$Header;








var $6aRB8 = parcelRequire("6aRB8");






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A message can contain a content.
 */ function $62d84f191a4fbb76$var$MessageContent(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('content', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($62d84f191a4fbb76$var$MessageContent, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($62d84f191a4fbb76$var$MessageContent, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$62d84f191a4fbb76$var$MessageContent.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
$62d84f191a4fbb76$var$MessageContent.propTypes = {};
var $62d84f191a4fbb76$export$2e2bcd8739ae039 = $62d84f191a4fbb76$var$MessageContent;






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A message can contain a header.
 */ function $4890bc763e8a5fcd$var$MessageHeader(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('header', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($4890bc763e8a5fcd$var$MessageHeader, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($4890bc763e8a5fcd$var$MessageHeader, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$4890bc763e8a5fcd$var$MessageHeader.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
$4890bc763e8a5fcd$var$MessageHeader.propTypes = {};
$4890bc763e8a5fcd$var$MessageHeader.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($4890bc763e8a5fcd$var$MessageHeader, function(val) {
    return {
        content: val
    };
});
var $4890bc763e8a5fcd$export$2e2bcd8739ae039 = $4890bc763e8a5fcd$var$MessageHeader;







var $6aRB8 = parcelRequire("6aRB8");





var $6aRB8 = parcelRequire("6aRB8");

/**
 * A message list can contain an item.
 */ function $036b314fbd5f43dd$var$MessageItem(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('content', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($036b314fbd5f43dd$var$MessageItem, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($036b314fbd5f43dd$var$MessageItem, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$036b314fbd5f43dd$var$MessageItem.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
$036b314fbd5f43dd$var$MessageItem.propTypes = {};
$036b314fbd5f43dd$var$MessageItem.defaultProps = {
    as: 'li'
};
$036b314fbd5f43dd$var$MessageItem.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($036b314fbd5f43dd$var$MessageItem, function(content) {
    return {
        content: content
    };
});
var $036b314fbd5f43dd$export$2e2bcd8739ae039 = $036b314fbd5f43dd$var$MessageItem;


/**
 * A message can contain a list of items.
 */ function $d0fd44ef65252804$var$MessageList(props) {
    var children = props.children, className = props.className, items = props.items;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('list', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($d0fd44ef65252804$var$MessageList, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($d0fd44ef65252804$var$MessageList, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? (0, $2ef0baf102d48982$export$2e2bcd8739ae039)(items, (0, $036b314fbd5f43dd$export$2e2bcd8739ae039).create) : children);
}
$d0fd44ef65252804$var$MessageList.handledProps = [
    "as",
    "children",
    "className",
    "items"
];
$d0fd44ef65252804$var$MessageList.propTypes = {};
$d0fd44ef65252804$var$MessageList.defaultProps = {
    as: 'ul'
};
$d0fd44ef65252804$var$MessageList.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($d0fd44ef65252804$var$MessageList, function(val) {
    return {
        items: val
    };
});
var $d0fd44ef65252804$export$2e2bcd8739ae039 = $d0fd44ef65252804$var$MessageList;



/**
 * A message displays information that explains nearby content.
 * @see Form
 */ var $1e5d90c3685c34ec$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(Message, _Component);
    function Message() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.handleDismiss = function(e) {
            var onDismiss = _this.props.onDismiss;
            if (onDismiss) onDismiss(e, _this.props);
        };
        return _this;
    }
    var _proto = Message.prototype;
    _proto.render = function render() {
        var _this$props = this.props, attached = _this$props.attached, children = _this$props.children, className = _this$props.className, color = _this$props.color, compact = _this$props.compact, content = _this$props.content, error = _this$props.error, floating = _this$props.floating, header = _this$props.header, hidden = _this$props.hidden, icon = _this$props.icon, info = _this$props.info, list = _this$props.list, negative = _this$props.negative, onDismiss = _this$props.onDismiss, positive = _this$props.positive, size = _this$props.size, success = _this$props.success, visible = _this$props.visible, warning = _this$props.warning;
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', color, size, (0, $87a122667489288b$export$aac7d417530cc39a)(compact, 'compact'), (0, $87a122667489288b$export$aac7d417530cc39a)(error, 'error'), (0, $87a122667489288b$export$aac7d417530cc39a)(floating, 'floating'), (0, $87a122667489288b$export$aac7d417530cc39a)(hidden, 'hidden'), (0, $87a122667489288b$export$aac7d417530cc39a)(icon, 'icon'), (0, $87a122667489288b$export$aac7d417530cc39a)(info, 'info'), (0, $87a122667489288b$export$aac7d417530cc39a)(negative, 'negative'), (0, $87a122667489288b$export$aac7d417530cc39a)(positive, 'positive'), (0, $87a122667489288b$export$aac7d417530cc39a)(success, 'success'), (0, $87a122667489288b$export$aac7d417530cc39a)(visible, 'visible'), (0, $87a122667489288b$export$aac7d417530cc39a)(warning, 'warning'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(attached, 'attached'), 'message', className);
        var dismissIcon = onDismiss && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $760d0282e0637aa7$export$2e2bcd8739ae039), {
            name: "close",
            onClick: this.handleDismiss
        });
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(Message, this.props);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(Message, this.props);
        if (!(0, $f0526af735e6584e$exports).isNil(children)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            className: classes
        }), dismissIcon, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            className: classes
        }), dismissIcon, (0, $760d0282e0637aa7$export$2e2bcd8739ae039).create(icon, {
            autoGenerateKey: false
        }), (!(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(header) || !(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(content) || !(0, $9ef17f10bea17fe1$export$2e2bcd8739ae039)(list)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $62d84f191a4fbb76$export$2e2bcd8739ae039), null, (0, $4890bc763e8a5fcd$export$2e2bcd8739ae039).create(header, {
            autoGenerateKey: false
        }), (0, $d0fd44ef65252804$export$2e2bcd8739ae039).create(list, {
            autoGenerateKey: false
        }), (0, $d590e40415a777e8$export$eb9b746d34c942ce)(content, {
            autoGenerateKey: false
        })));
    };
    return Message;
}((0, $6aRB8.Component));
$1e5d90c3685c34ec$export$2e2bcd8739ae039.handledProps = [
    "as",
    "attached",
    "children",
    "className",
    "color",
    "compact",
    "content",
    "error",
    "floating",
    "header",
    "hidden",
    "icon",
    "info",
    "list",
    "negative",
    "onDismiss",
    "positive",
    "size",
    "success",
    "visible",
    "warning"
];
$1e5d90c3685c34ec$export$2e2bcd8739ae039.propTypes = {};
$1e5d90c3685c34ec$export$2e2bcd8739ae039.Content = (0, $62d84f191a4fbb76$export$2e2bcd8739ae039);
$1e5d90c3685c34ec$export$2e2bcd8739ae039.Header = (0, $4890bc763e8a5fcd$export$2e2bcd8739ae039);
$1e5d90c3685c34ec$export$2e2bcd8739ae039.List = (0, $d0fd44ef65252804$export$2e2bcd8739ae039);
$1e5d90c3685c34ec$export$2e2bcd8739ae039.Item = (0, $036b314fbd5f43dd$export$2e2bcd8739ae039);













var $6aRB8 = parcelRequire("6aRB8");


var $9e87d49b449c9a2d$export$2e2bcd8739ae039 = (0, $d84a0216b5e1bcaf$exports.instance);











var $6aRB8 = parcelRequire("6aRB8");


/**
 * A modal can contain a row of actions.
 */ var $c94dd7a69748ddc8$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(ModalActions, _Component);
    function ModalActions() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.handleButtonOverrides = function(predefinedProps) {
            return {
                onClick: function onClick(e, buttonProps) {
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(predefinedProps, 'onClick', e, buttonProps);
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onActionClick', e, buttonProps);
                }
            };
        };
        return _this;
    }
    var _proto = ModalActions.prototype;
    _proto.render = function render() {
        var _this2 = this;
        var _this$props = this.props, actions = _this$props.actions, children = _this$props.children, className = _this$props.className, content = _this$props.content;
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('actions', className);
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(ModalActions, this.props);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(ModalActions, this.props);
        if (!(0, $f0526af735e6584e$exports).isNil(children)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            className: classes
        }), children);
        if (!(0, $f0526af735e6584e$exports).isNil(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            className: classes
        }), content);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
            className: classes
        }), (0, $2ef0baf102d48982$export$2e2bcd8739ae039)(actions, function(action) {
            return (0, $a7825a90230ff993$export$2e2bcd8739ae039).create(action, {
                overrideProps: _this2.handleButtonOverrides
            });
        }));
    };
    return ModalActions;
}((0, $6aRB8.Component));
$c94dd7a69748ddc8$export$2e2bcd8739ae039.handledProps = [
    "actions",
    "as",
    "children",
    "className",
    "content",
    "onActionClick"
];
$c94dd7a69748ddc8$export$2e2bcd8739ae039.propTypes = {};
$c94dd7a69748ddc8$export$2e2bcd8739ae039.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($c94dd7a69748ddc8$export$2e2bcd8739ae039, function(actions) {
    return {
        actions: actions
    };
});






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A modal can contain content.
 */ function $333d24f7d8e91cd1$var$ModalContent(props) {
    var children = props.children, className = props.className, content = props.content, image = props.image, scrolling = props.scrolling;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)(className, (0, $87a122667489288b$export$aac7d417530cc39a)(image, 'image'), (0, $87a122667489288b$export$aac7d417530cc39a)(scrolling, 'scrolling'), 'content');
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($333d24f7d8e91cd1$var$ModalContent, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($333d24f7d8e91cd1$var$ModalContent, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$333d24f7d8e91cd1$var$ModalContent.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "image",
    "scrolling"
];
$333d24f7d8e91cd1$var$ModalContent.propTypes = {};
$333d24f7d8e91cd1$var$ModalContent.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($333d24f7d8e91cd1$var$ModalContent, function(content) {
    return {
        content: content
    };
});
var $333d24f7d8e91cd1$export$2e2bcd8739ae039 = $333d24f7d8e91cd1$var$ModalContent;






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A modal can contain a description with one or more paragraphs.
 */ function $c6c36beb231a7b67$var$ModalDescription(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('description', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($c6c36beb231a7b67$var$ModalDescription, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($c6c36beb231a7b67$var$ModalDescription, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$c6c36beb231a7b67$var$ModalDescription.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
$c6c36beb231a7b67$var$ModalDescription.propTypes = {};
var $c6c36beb231a7b67$export$2e2bcd8739ae039 = $c6c36beb231a7b67$var$ModalDescription;







var $6aRB8 = parcelRequire("6aRB8");


var $6aRB8 = parcelRequire("6aRB8");

var $6aRB8 = parcelRequire("6aRB8");

// https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
var $bcebf07881358012$var$useIsomorphicLayoutEffect = (0, $227fe03b67c244b4$export$2e2bcd8739ae039)() && true ? (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useEffect;
var $bcebf07881358012$export$2e2bcd8739ae039 = $bcebf07881358012$var$useIsomorphicLayoutEffect;


var $f39e6f493e508fd9$var$CLASS_NAME_DELITIMITER = /\s+/;
function $f39e6f493e508fd9$export$403c11f880bac268(classNameRefs) {
    var classNames = [];
    if (classNameRefs) {
        classNameRefs.forEach(function(classNameRef) {
            if (typeof classNameRef.current === 'string') {
                var classNamesForRef = classNameRef.current.split($f39e6f493e508fd9$var$CLASS_NAME_DELITIMITER);
                classNamesForRef.forEach(function(className) {
                    classNames.push(className);
                });
            }
        });
        return classNames.filter(function(className, i, array) {
            return className.length > 0 && array.indexOf(className) === i;
        });
    }
    return [];
}
function $f39e6f493e508fd9$export$a904fe2a27e80aff(prevClassNames, currentClassNames) {
    return [
        currentClassNames.filter(function(className) {
            return prevClassNames.indexOf(className) === -1;
        }),
        prevClassNames.filter(function(className) {
            return currentClassNames.indexOf(className) === -1;
        })
    ];
}
var $f39e6f493e508fd9$var$prevClassNames = new Map();
var $f39e6f493e508fd9$export$b59d5baa22a07bdc = function handleClassNamesChange(node, classNameRefs) {
    var currentClassNames = $f39e6f493e508fd9$export$403c11f880bac268(classNameRefs);
    var _computeClassNamesDif = $f39e6f493e508fd9$export$a904fe2a27e80aff($f39e6f493e508fd9$var$prevClassNames.get(node) || [], currentClassNames), forAdd = _computeClassNamesDif[0], forRemoval = _computeClassNamesDif[1];
    if (node) {
        forAdd.forEach(function(className) {
            return node.classList.add(className);
        });
        forRemoval.forEach(function(className) {
            return node.classList.remove(className);
        });
    }
    $f39e6f493e508fd9$var$prevClassNames.set(node, currentClassNames);
};
var $f39e6f493e508fd9$export$461a5cc754605f83 = function NodeRegistry() {
    var _this = this;
    this.add = function(node, classNameRef) {
        if (_this.nodes.has(node)) {
            var _set = _this.nodes.get(node);
            _set.add(classNameRef);
            return;
        } // IE11 does not support constructor params
        var set = new Set();
        set.add(classNameRef);
        _this.nodes.set(node, set);
    };
    this.del = function(node, classNameRef) {
        if (!_this.nodes.has(node)) return;
        var set = _this.nodes.get(node);
        if (set.size === 1) {
            _this.nodes.delete(node);
            return;
        }
        set.delete(classNameRef);
    };
    this.emit = function(node, callback) {
        callback(node, _this.nodes.get(node));
    };
    this.nodes = new Map();
};
var $f39e6f493e508fd9$var$nodeRegistry = new $f39e6f493e508fd9$export$461a5cc754605f83();
function $f39e6f493e508fd9$export$2e2bcd8739ae039(node, className) {
    var classNameRef = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useRef();
    var isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useRef(false);
    (0, $bcebf07881358012$export$2e2bcd8739ae039)(function() {
        classNameRef.current = className;
        if (isMounted.current) {
            var element = (0, $2b42f5a2eeaa6c35$export$dedd81df7bc1307)(node) ? node.current : node;
            $f39e6f493e508fd9$var$nodeRegistry.emit(element, $f39e6f493e508fd9$export$b59d5baa22a07bdc);
        }
        isMounted.current = true;
    }, [
        className
    ]);
    (0, $bcebf07881358012$export$2e2bcd8739ae039)(function() {
        var element = (0, $2b42f5a2eeaa6c35$export$dedd81df7bc1307)(node) ? node.current : node;
        $f39e6f493e508fd9$var$nodeRegistry.add(element, classNameRef);
        $f39e6f493e508fd9$var$nodeRegistry.emit(element, $f39e6f493e508fd9$export$b59d5baa22a07bdc);
        return function() {
            $f39e6f493e508fd9$var$nodeRegistry.del(element, classNameRef);
            $f39e6f493e508fd9$var$nodeRegistry.emit(element, $f39e6f493e508fd9$export$b59d5baa22a07bdc);
        };
    }, [
        node
    ]);
}


/**
 * A modal has a dimmer.
 */ function $f3668c35299018ab$var$ModalDimmer(props) {
    var blurring = props.blurring, children = props.children, className = props.className, centered = props.centered, content = props.content, inverted = props.inverted, mountNode = props.mountNode, scrolling = props.scrolling;
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useRef();
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', (0, $87a122667489288b$export$aac7d417530cc39a)(inverted, 'inverted'), (0, $87a122667489288b$export$aac7d417530cc39a)(!centered, 'top aligned'), 'page modals dimmer transition visible active', className);
    var bodyClasses = (0, $b589707e9204a564$export$2e2bcd8739ae039)('dimmable dimmed', (0, $87a122667489288b$export$aac7d417530cc39a)(blurring, 'blurring'), (0, $87a122667489288b$export$aac7d417530cc39a)(scrolling, 'scrolling'));
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($f3668c35299018ab$var$ModalDimmer, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($f3668c35299018ab$var$ModalDimmer, props);
    (0, $f39e6f493e508fd9$export$2e2bcd8739ae039)(mountNode, bodyClasses);
    (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).useEffect(function() {
        if (ref.current && ref.current.style) ref.current.style.setProperty('display', 'flex', 'important');
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c3c11b3db64bf060$export$9bcc32033bdd12aa), {
        innerRef: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children));
}
$f3668c35299018ab$var$ModalDimmer.handledProps = [
    "as",
    "blurring",
    "centered",
    "children",
    "className",
    "content",
    "inverted",
    "mountNode",
    "scrolling"
];
$f3668c35299018ab$var$ModalDimmer.propTypes = {};
$f3668c35299018ab$var$ModalDimmer.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($f3668c35299018ab$var$ModalDimmer, function(content) {
    return {
        content: content
    };
});
var $f3668c35299018ab$export$2e2bcd8739ae039 = $f3668c35299018ab$var$ModalDimmer;






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A modal can have a header.
 */ function $1196b073e8bca481$var$ModalHeader(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('header', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($1196b073e8bca481$var$ModalHeader, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($1196b073e8bca481$var$ModalHeader, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$1196b073e8bca481$var$ModalHeader.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
$1196b073e8bca481$var$ModalHeader.propTypes = {};
$1196b073e8bca481$var$ModalHeader.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($1196b073e8bca481$var$ModalHeader, function(content) {
    return {
        content: content
    };
});
var $1196b073e8bca481$export$2e2bcd8739ae039 = $1196b073e8bca481$var$ModalHeader;


// https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L956
var $2bfdeb516f3c641b$var$OFFSET = 0; // https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L990
var $2bfdeb516f3c641b$var$PADDING = 50;
var $2bfdeb516f3c641b$export$c67583a46ffa8057 = function canFit(modalRect) {
    // original: scrollHeight = $module.prop('scrollHeight'),
    // is replaced by .height because scrollHeight provides integer which produces glitches
    // https://github.com/Semantic-Org/Semantic-UI-React/issues/2221
    var scrollHeight = modalRect.height + $2bfdeb516f3c641b$var$OFFSET; // $module.outerHeight() + settings.offset
    var height = modalRect.height + $2bfdeb516f3c641b$var$OFFSET; // original: $(window).height()
    var contextHeight = window.innerHeight;
    var verticalCenter = contextHeight / 2;
    var topOffset = -(height / 2); // padding with edge of page
    var paddingHeight = $2bfdeb516f3c641b$var$PADDING;
    var startPosition = verticalCenter + topOffset; // 0
    // original: scrollHeight > height
    //     ? startPosition + scrollHeight + paddingHeight < contextHeight
    //     : height + paddingHeight * 2 < contextHeight
    return startPosition + scrollHeight + paddingHeight < contextHeight;
};
var $2bfdeb516f3c641b$export$b20ed5bbe5ddac26 = function getLegacyStyles(isFitted, centered, modalRect) {
    var marginTop = centered && isFitted ? -(modalRect.height / 2) : 0;
    var marginLeft = -(modalRect.width / 2);
    return {
        marginLeft: marginLeft,
        marginTop: marginTop
    };
}; // https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L631
var $2bfdeb516f3c641b$export$a14116a82adab20d = function isLegacy() {
    return !window.ActiveXObject && 'ActiveXObject' in window;
};


/**
 * A modal displays content that temporarily blocks interactions with the main view of a site.
 * @see Confirm
 * @see Portal
 */ var $00934dd1575f8f3e$var$Modal = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(Modal, _Component);
    function Modal() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.legacy = (0, $227fe03b67c244b4$export$2e2bcd8739ae039)() && (0, $2bfdeb516f3c641b$export$a14116a82adab20d)();
        _this.ref = /*#__PURE__*/ (0, $6aRB8.createRef)();
        _this.dimmerRef = /*#__PURE__*/ (0, $6aRB8.createRef)();
        _this.latestDocumentMouseDownEvent = null;
        _this.getMountNode = function() {
            return (0, $227fe03b67c244b4$export$2e2bcd8739ae039)() ? _this.props.mountNode || document.body : null;
        };
        _this.handleActionsOverrides = function(predefinedProps) {
            return {
                onActionClick: function onActionClick(e, actionProps) {
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(predefinedProps, 'onActionClick', e, actionProps);
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onActionClick', e, _this.props);
                    _this.handleClose(e);
                }
            };
        };
        _this.handleClose = function(e) {
            _this.setState({
                open: false
            });
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onClose', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                open: false
            }));
        };
        _this.handleDocumentMouseDown = function(e) {
            _this.latestDocumentMouseDownEvent = e;
        };
        _this.handleDocumentClick = function(e) {
            var closeOnDimmerClick = _this.props.closeOnDimmerClick;
            var currentDocumentMouseDownEvent = _this.latestDocumentMouseDownEvent;
            _this.latestDocumentMouseDownEvent = null;
            if (!closeOnDimmerClick || (0, $6e0b9d13855575c4$export$2e2bcd8739ae039)(_this.ref.current, currentDocumentMouseDownEvent) || (0, $6e0b9d13855575c4$export$2e2bcd8739ae039)(_this.ref.current, e)) return;
            _this.setState({
                open: false
            });
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onClose', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                open: false
            }));
        };
        _this.handleIconOverrides = function(predefinedProps) {
            return {
                onClick: function onClick(e) {
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(predefinedProps, 'onClick', e);
                    _this.handleClose(e);
                }
            };
        };
        _this.handleOpen = function(e) {
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onOpen', e, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, _this.props, {
                open: true
            }));
            _this.setState({
                open: true
            });
        };
        _this.handlePortalMount = function(e) {
            var eventPool = _this.props.eventPool;
            _this.setState({
                scrolling: false
            });
            _this.setPositionAndClassNames();
            (0, $9e87d49b449c9a2d$export$2e2bcd8739ae039).sub('mousedown', _this.handleDocumentMouseDown, {
                pool: eventPool,
                target: _this.dimmerRef.current
            });
            (0, $9e87d49b449c9a2d$export$2e2bcd8739ae039).sub('click', _this.handleDocumentClick, {
                pool: eventPool,
                target: _this.dimmerRef.current
            });
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onMount', e, _this.props);
        };
        _this.handlePortalUnmount = function(e) {
            var eventPool = _this.props.eventPool;
            cancelAnimationFrame(_this.animationRequestId);
            (0, $9e87d49b449c9a2d$export$2e2bcd8739ae039).unsub('mousedown', _this.handleDocumentMouseDown, {
                pool: eventPool,
                target: _this.dimmerRef.current
            });
            (0, $9e87d49b449c9a2d$export$2e2bcd8739ae039).unsub('click', _this.handleDocumentClick, {
                pool: eventPool,
                target: _this.dimmerRef.current
            });
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onUnmount', e, _this.props);
        };
        _this.setPositionAndClassNames = function() {
            var centered = _this.props.centered;
            var scrolling;
            var newState = {};
            if (_this.ref.current) {
                var rect = _this.ref.current.getBoundingClientRect();
                var isFitted = (0, $2bfdeb516f3c641b$export$c67583a46ffa8057)(rect);
                scrolling = !isFitted; // Styles should be computed for IE11
                var legacyStyles = _this.legacy ? (0, $2bfdeb516f3c641b$export$b20ed5bbe5ddac26)(isFitted, centered, rect) : {};
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($0080e586c00e3b93$exports)))(_this.state.legacyStyles, legacyStyles)) newState.legacyStyles = legacyStyles;
                if (_this.state.scrolling !== scrolling) newState.scrolling = scrolling;
            }
            if (!(0, $ef1dc2bcf455bc8f$export$2e2bcd8739ae039)(newState)) _this.setState(newState);
            _this.animationRequestId = requestAnimationFrame(_this.setPositionAndClassNames);
        };
        _this.renderContent = function(rest) {
            var _this$props = _this.props, actions = _this$props.actions, basic = _this$props.basic, children = _this$props.children, className = _this$props.className, closeIcon = _this$props.closeIcon, content = _this$props.content, header = _this$props.header, size = _this$props.size, style = _this$props.style;
            var _this$state = _this.state, legacyStyles = _this$state.legacyStyles, scrolling = _this$state.scrolling;
            var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', size, (0, $87a122667489288b$export$aac7d417530cc39a)(basic, 'basic'), (0, $87a122667489288b$export$aac7d417530cc39a)(_this.legacy, 'legacy'), (0, $87a122667489288b$export$aac7d417530cc39a)(scrolling, 'scrolling'), 'modal transition visible active', className);
            var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(Modal, _this.props);
            var closeIconName = closeIcon === true ? 'close' : closeIcon;
            var closeIconJSX = (0, $760d0282e0637aa7$export$2e2bcd8739ae039).create(closeIconName, {
                overrideProps: _this.handleIconOverrides
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c3c11b3db64bf060$export$9bcc32033bdd12aa), {
                innerRef: _this.ref
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
                className: classes,
                style: (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, legacyStyles, style)
            }), closeIconJSX, (0, $f0526af735e6584e$exports).isNil(children) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).Fragment, null, (0, $1196b073e8bca481$export$2e2bcd8739ae039).create(header, {
                autoGenerateKey: false
            }), (0, $333d24f7d8e91cd1$export$2e2bcd8739ae039).create(content, {
                autoGenerateKey: false
            }), (0, $c94dd7a69748ddc8$export$2e2bcd8739ae039).create(actions, {
                overrideProps: _this.handleActionsOverrides
            })) : children));
        };
        return _this;
    }
    var _proto = Modal.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.handlePortalUnmount();
    } // Do not access document when server side rendering
    ;
    _proto.render = function render() {
        var _this$props2 = this.props, centered = _this$props2.centered, closeOnDocumentClick = _this$props2.closeOnDocumentClick, dimmer = _this$props2.dimmer, eventPool = _this$props2.eventPool, trigger = _this$props2.trigger;
        var _this$state2 = this.state, open = _this$state2.open, scrolling = _this$state2.scrolling;
        var mountNode = this.getMountNode(); // Short circuit when server side rendering
        if (!(0, $227fe03b67c244b4$export$2e2bcd8739ae039)()) return /*#__PURE__*/ (0, $6aRB8.isValidElement)(trigger) ? trigger : null;
        var unhandled = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(Modal, this.props);
        var portalPropNames = (0, $bda4cebe3b5b4baa$export$2e2bcd8739ae039).handledProps;
        var rest = (0, $4e907c799c1a5079$export$2e2bcd8739ae039)(unhandled, function(acc, val, key) {
            if (!(0, $9d3d4e08270ebb7e$export$2e2bcd8739ae039)(portalPropNames, key)) acc[key] = val;
            return acc;
        }, {});
        var portalProps = (0, $f7bdf7e80de91b2e$export$2e2bcd8739ae039)(unhandled, portalPropNames); // Heads up!
        //
        // The SUI CSS selector to prevent the modal itself from blurring requires an immediate .dimmer child:
        // .blurring.dimmed.dimmable>:not(.dimmer) { ... }
        //
        // The .blurring.dimmed.dimmable is the body, so that all body content inside is blurred.
        // We need the immediate child to be the dimmer to :not() blur the modal itself!
        // Otherwise, the portal div is also blurred, blurring the modal.
        //
        // We cannot them wrap the modalJSX in an actual <Dimmer /> instead, we apply the dimmer classes to the <Portal />.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $bda4cebe3b5b4baa$export$2e2bcd8739ae039), (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({
            closeOnDocumentClick: closeOnDocumentClick
        }, portalProps, {
            trigger: trigger,
            eventPool: eventPool,
            mountNode: mountNode,
            open: open,
            onClose: this.handleClose,
            onMount: this.handlePortalMount,
            onOpen: this.handleOpen,
            onUnmount: this.handlePortalUnmount
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $c3c11b3db64bf060$export$9bcc32033bdd12aa), {
            innerRef: this.dimmerRef
        }, (0, $f3668c35299018ab$export$2e2bcd8739ae039).create((0, $88fcb6c8ec5d0788$export$2e2bcd8739ae039)(dimmer) ? dimmer : {}, {
            autoGenerateKey: false,
            defaultProps: {
                blurring: dimmer === 'blurring',
                inverted: dimmer === 'inverted'
            },
            overrideProps: {
                children: this.renderContent(rest),
                centered: centered,
                mountNode: mountNode,
                scrolling: scrolling
            }
        })));
    };
    return Modal;
}((0, $14f3bba04a1282e8$export$2e2bcd8739ae039));
$00934dd1575f8f3e$var$Modal.handledProps = [
    "actions",
    "as",
    "basic",
    "centered",
    "children",
    "className",
    "closeIcon",
    "closeOnDimmerClick",
    "closeOnDocumentClick",
    "content",
    "defaultOpen",
    "dimmer",
    "eventPool",
    "header",
    "mountNode",
    "onActionClick",
    "onClose",
    "onMount",
    "onOpen",
    "onUnmount",
    "open",
    "size",
    "style",
    "trigger"
];
$00934dd1575f8f3e$var$Modal.propTypes = {};
$00934dd1575f8f3e$var$Modal.defaultProps = {
    centered: true,
    dimmer: true,
    closeOnDimmerClick: true,
    closeOnDocumentClick: false,
    eventPool: 'Modal'
};
$00934dd1575f8f3e$var$Modal.autoControlledProps = [
    'open'
];
$00934dd1575f8f3e$var$Modal.Actions = (0, $c94dd7a69748ddc8$export$2e2bcd8739ae039);
$00934dd1575f8f3e$var$Modal.Content = (0, $333d24f7d8e91cd1$export$2e2bcd8739ae039);
$00934dd1575f8f3e$var$Modal.Description = (0, $c6c36beb231a7b67$export$2e2bcd8739ae039);
$00934dd1575f8f3e$var$Modal.Dimmer = (0, $f3668c35299018ab$export$2e2bcd8739ae039);
$00934dd1575f8f3e$var$Modal.Header = (0, $1196b073e8bca481$export$2e2bcd8739ae039);
var $00934dd1575f8f3e$export$2e2bcd8739ae039 = $00934dd1575f8f3e$var$Modal;


var $83aaeced91761250$export$2e2bcd8739ae039 = ({ createCustomer: createCustomer })=>{
    //ui state
    const [open, setOpen] = (0, $6aRB8.useState)(false);
    const [errors, setErrors] = (0, $6aRB8.useState)([]);
    //form fields
    const [domain, setCustomerId] = (0, $6aRB8.useState)('');
    const [name, setName] = (0, $6aRB8.useState)('');
    const [adminName, setAdminName] = (0, $6aRB8.useState)('Admin');
    const [adminEmail, setAdminEmail] = (0, $6aRB8.useState)('');
    async function createCustomerClose() {
        try {
            await createCustomer({
                domain: domain,
                name: name,
                adminName: adminName,
                adminEmail: adminEmail
            });
            // reset state
            setCustomerId('');
            setName('');
            setAdminName('Admin');
            setAdminEmail('');
            setOpen(false);
        } catch (e) {
            console.log("the error", e.status);
            setErrors(e.response.data.errors);
        }
    }
    const createCustomerButton = /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
        floated: "right",
        icon: true,
        labelPosition: "left",
        primary: true,
        size: "small",
        children: [
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $760d0282e0637aa7$export$2e2bcd8739ae039), {
                name: "user"
            }),
            " Add Customer"
        ]
    });
    return /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039), {
        open: open,
        onOpen: ()=>setOpen(true),
        onClose: ()=>setOpen(false),
        trigger: createCustomerButton,
        children: [
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Header, {
                children: "Create a new customer"
            }),
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Content, {
                children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039), {
                    onSubmit: createCustomerClose,
                    children: [
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $f11325917db9c363$export$2e2bcd8739ae039), {
                            horizontal: true,
                            children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $562317775b0c6bd4$export$2e2bcd8739ae039), {
                                as: "h4",
                                children: [
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $760d0282e0637aa7$export$2e2bcd8739ae039), {
                                        name: "info"
                                    }),
                                    "Customer Details"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                    children: "Customer Name"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                    placeholder: "Customer Name",
                                    onChange: (e)=>setName(e.target.value),
                                    value: name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                    children: "Customer Domain"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                    placeholder: "Domain",
                                    onChange: (e)=>setCustomerId(e.target.value),
                                    value: domain
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $f11325917db9c363$export$2e2bcd8739ae039), {
                            horizontal: true,
                            children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $562317775b0c6bd4$export$2e2bcd8739ae039), {
                                as: "h4",
                                children: [
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $760d0282e0637aa7$export$2e2bcd8739ae039), {
                                        name: "user"
                                    }),
                                    "Admin User"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                    children: "Admin Username"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                    placeholder: "Admin",
                                    onChange: (e)=>setAdminName(e.target.value),
                                    value: adminName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                    children: "Admin Email"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                    placeholder: "email",
                                    onChange: (e)=>setAdminEmail(e.target.value),
                                    value: adminEmail
                                })
                            ]
                        }),
                        errors.map(({ title: title, detail: detail }, i)=>/*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $1e5d90c3685c34ec$export$2e2bcd8739ae039), {
                                negative: true,
                                header: title,
                                content: detail
                            }, i)),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
                            primary: true,
                            type: "submit",
                            children: "Create Customer"
                        })
                    ]
                })
            })
        ]
    });
};




var $6aRB8 = parcelRequire("6aRB8");


var $4bMTH = parcelRequire("4bMTH");


/** Used for built-in method references. */ var $db9f57e75d9681d4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $db9f57e75d9681d4$var$hasOwnProperty = $db9f57e75d9681d4$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $db9f57e75d9681d4$var$baseHas(object, key) {
    return object != null && $db9f57e75d9681d4$var$hasOwnProperty.call(object, key);
}
var $db9f57e75d9681d4$export$2e2bcd8739ae039 = $db9f57e75d9681d4$var$baseHas;



/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $823edead98054fc2$var$has(object, path) {
    return object != null && (0, $2ef0abe1b723d060$export$2e2bcd8739ae039)(object, path, (0, $db9f57e75d9681d4$export$2e2bcd8739ae039));
}
var $823edead98054fc2$export$2e2bcd8739ae039 = $823edead98054fc2$var$has;





var $6aRB8 = parcelRequire("6aRB8");



/**
 * A Confirm modal gives the user a choice to confirm or cancel an action.
 * @see Modal
 */ var $9e710c2e6164cea4$var$Confirm = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(Confirm, _Component);
    function Confirm() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.handleCancel = function(e) {
            (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onCancel', e, _this.props);
        };
        _this.handleCancelOverrides = function(predefinedProps) {
            return {
                onClick: function onClick(e, buttonProps) {
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(predefinedProps, 'onClick', e, buttonProps);
                    _this.handleCancel(e);
                }
            };
        };
        _this.handleConfirmOverrides = function(predefinedProps) {
            return {
                onClick: function onClick(e, buttonProps) {
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(predefinedProps, 'onClick', e, buttonProps);
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onConfirm', e, _this.props);
                }
            };
        };
        return _this;
    }
    var _proto = Confirm.prototype;
    _proto.render = function render() {
        var _this$props = this.props, cancelButton = _this$props.cancelButton, confirmButton = _this$props.confirmButton, content = _this$props.content, header = _this$props.header, open = _this$props.open, size = _this$props.size;
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(Confirm, this.props); // `open` is auto controlled by the Modal
        // It cannot be present (even undefined) with `defaultOpen`
        // only apply it if the user provided an open prop
        var openProp = {};
        if ((0, $823edead98054fc2$export$2e2bcd8739ae039)(this.props, 'open')) openProp.open = open;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $00934dd1575f8f3e$export$2e2bcd8739ae039), (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, openProp, {
            size: size,
            onClose: this.handleCancel
        }), (0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Header.create(header, {
            autoGenerateKey: false
        }), (0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Content.create(content, {
            autoGenerateKey: false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Actions, null, (0, $a7825a90230ff993$export$2e2bcd8739ae039).create(cancelButton, {
            autoGenerateKey: false,
            overrideProps: this.handleCancelOverrides
        }), (0, $a7825a90230ff993$export$2e2bcd8739ae039).create(confirmButton, {
            autoGenerateKey: false,
            defaultProps: {
                primary: true
            },
            overrideProps: this.handleConfirmOverrides
        })));
    };
    return Confirm;
}((0, $6aRB8.Component));
$9e710c2e6164cea4$var$Confirm.handledProps = [
    "cancelButton",
    "confirmButton",
    "content",
    "header",
    "onCancel",
    "onConfirm",
    "open",
    "size"
];
$9e710c2e6164cea4$var$Confirm.propTypes = {};
$9e710c2e6164cea4$var$Confirm.defaultProps = {
    cancelButton: 'Cancel',
    confirmButton: 'OK',
    content: 'Are you sure?',
    size: 'small'
};
var $9e710c2e6164cea4$export$2e2bcd8739ae039 = $9e710c2e6164cea4$var$Confirm;







var $6aRB8 = parcelRequire("6aRB8");





var $6aRB8 = parcelRequire("6aRB8");

function $3b9ab39e575cb214$var$TableBody(props) {
    var children = props.children, className = props.className;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)(className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($3b9ab39e575cb214$var$TableBody, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($3b9ab39e575cb214$var$TableBody, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), children);
}
$3b9ab39e575cb214$var$TableBody.handledProps = [
    "as",
    "children",
    "className"
];
$3b9ab39e575cb214$var$TableBody.defaultProps = {
    as: 'tbody'
};
$3b9ab39e575cb214$var$TableBody.propTypes = {};
var $3b9ab39e575cb214$export$2e2bcd8739ae039 = $3b9ab39e575cb214$var$TableBody;







var $6aRB8 = parcelRequire("6aRB8");


/**
 * A table row can have cells.
 */ function $898755dd1d8ad937$var$TableCell(props) {
    var active = props.active, children = props.children, className = props.className, collapsing = props.collapsing, content = props.content, disabled = props.disabled, error = props.error, icon = props.icon, negative = props.negative, positive = props.positive, selectable = props.selectable, singleLine = props.singleLine, textAlign = props.textAlign, verticalAlign = props.verticalAlign, warning = props.warning, width = props.width;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$aac7d417530cc39a)(active, 'active'), (0, $87a122667489288b$export$aac7d417530cc39a)(collapsing, 'collapsing'), (0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$aac7d417530cc39a)(error, 'error'), (0, $87a122667489288b$export$aac7d417530cc39a)(negative, 'negative'), (0, $87a122667489288b$export$aac7d417530cc39a)(positive, 'positive'), (0, $87a122667489288b$export$aac7d417530cc39a)(selectable, 'selectable'), (0, $87a122667489288b$export$aac7d417530cc39a)(singleLine, 'single line'), (0, $87a122667489288b$export$aac7d417530cc39a)(warning, 'warning'), (0, $87a122667489288b$export$32c7303ec0b907a1)(textAlign), (0, $87a122667489288b$export$169652642bc5e2a1)(verticalAlign), (0, $87a122667489288b$export$52866a87b538f23c)(width, 'wide'), className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($898755dd1d8ad937$var$TableCell, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($898755dd1d8ad937$var$TableCell, props);
    if (!(0, $f0526af735e6584e$exports).isNil(children)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $760d0282e0637aa7$export$2e2bcd8739ae039).create(icon), content);
}
$898755dd1d8ad937$var$TableCell.handledProps = [
    "active",
    "as",
    "children",
    "className",
    "collapsing",
    "content",
    "disabled",
    "error",
    "icon",
    "negative",
    "positive",
    "selectable",
    "singleLine",
    "textAlign",
    "verticalAlign",
    "warning",
    "width"
];
$898755dd1d8ad937$var$TableCell.defaultProps = {
    as: 'td'
};
$898755dd1d8ad937$var$TableCell.propTypes = {};
$898755dd1d8ad937$var$TableCell.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($898755dd1d8ad937$var$TableCell, function(content) {
    return {
        content: content
    };
});
var $898755dd1d8ad937$export$2e2bcd8739ae039 = $898755dd1d8ad937$var$TableCell;





var $6aRB8 = parcelRequire("6aRB8");





var $6aRB8 = parcelRequire("6aRB8");

/**
 * A table can have a header.
 */ function $ef3094b83cd461e0$var$TableHeader(props) {
    var children = props.children, className = props.className, content = props.content, fullWidth = props.fullWidth;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$aac7d417530cc39a)(fullWidth, 'full-width'), className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($ef3094b83cd461e0$var$TableHeader, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($ef3094b83cd461e0$var$TableHeader, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$ef3094b83cd461e0$var$TableHeader.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "fullWidth"
];
$ef3094b83cd461e0$var$TableHeader.defaultProps = {
    as: 'thead'
};
$ef3094b83cd461e0$var$TableHeader.propTypes = {};
var $ef3094b83cd461e0$export$2e2bcd8739ae039 = $ef3094b83cd461e0$var$TableHeader;


/**
 * A table can have a footer.
 */ function $6f7cb05c9848a7b1$var$TableFooter(props) {
    var as = props.as;
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($6f7cb05c9848a7b1$var$TableFooter, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $ef3094b83cd461e0$export$2e2bcd8739ae039), (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        as: as
    }));
}
$6f7cb05c9848a7b1$var$TableFooter.handledProps = [
    "as"
];
$6f7cb05c9848a7b1$var$TableFooter.propTypes = {};
$6f7cb05c9848a7b1$var$TableFooter.defaultProps = {
    as: 'tfoot'
};
var $6f7cb05c9848a7b1$export$2e2bcd8739ae039 = $6f7cb05c9848a7b1$var$TableFooter;







var $6aRB8 = parcelRequire("6aRB8");


/**
 * A table can have a header cell.
 */ function $70b505464867b692$var$TableHeaderCell(props) {
    var as = props.as, className = props.className, sorted = props.sorted;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$fb1b8744f6450628)(sorted, 'sorted'), className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($70b505464867b692$var$TableHeaderCell, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $898755dd1d8ad937$export$2e2bcd8739ae039), (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        as: as,
        className: classes
    }));
}
$70b505464867b692$var$TableHeaderCell.handledProps = [
    "as",
    "className",
    "sorted"
];
$70b505464867b692$var$TableHeaderCell.propTypes = {};
$70b505464867b692$var$TableHeaderCell.defaultProps = {
    as: 'th'
};
var $70b505464867b692$export$2e2bcd8739ae039 = $70b505464867b692$var$TableHeaderCell;








var $6aRB8 = parcelRequire("6aRB8");


/**
 * A table can have rows.
 */ function $8e558ad36d016fdc$var$TableRow(props) {
    var active = props.active, cellAs = props.cellAs, cells = props.cells, children = props.children, className = props.className, disabled = props.disabled, error = props.error, negative = props.negative, positive = props.positive, textAlign = props.textAlign, verticalAlign = props.verticalAlign, warning = props.warning;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$aac7d417530cc39a)(active, 'active'), (0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$aac7d417530cc39a)(error, 'error'), (0, $87a122667489288b$export$aac7d417530cc39a)(negative, 'negative'), (0, $87a122667489288b$export$aac7d417530cc39a)(positive, 'positive'), (0, $87a122667489288b$export$aac7d417530cc39a)(warning, 'warning'), (0, $87a122667489288b$export$32c7303ec0b907a1)(textAlign), (0, $87a122667489288b$export$169652642bc5e2a1)(verticalAlign), className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($8e558ad36d016fdc$var$TableRow, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($8e558ad36d016fdc$var$TableRow, props);
    if (!(0, $f0526af735e6584e$exports).isNil(children)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $2ef0baf102d48982$export$2e2bcd8739ae039)(cells, function(cell) {
        return (0, $898755dd1d8ad937$export$2e2bcd8739ae039).create(cell, {
            defaultProps: {
                as: cellAs
            }
        });
    }));
}
$8e558ad36d016fdc$var$TableRow.handledProps = [
    "active",
    "as",
    "cellAs",
    "cells",
    "children",
    "className",
    "disabled",
    "error",
    "negative",
    "positive",
    "textAlign",
    "verticalAlign",
    "warning"
];
$8e558ad36d016fdc$var$TableRow.defaultProps = {
    as: 'tr',
    cellAs: 'td'
};
$8e558ad36d016fdc$var$TableRow.propTypes = {};
$8e558ad36d016fdc$var$TableRow.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($8e558ad36d016fdc$var$TableRow, function(cells) {
    return {
        cells: cells
    };
});
var $8e558ad36d016fdc$export$2e2bcd8739ae039 = $8e558ad36d016fdc$var$TableRow;


/**
 * A table displays a collections of data grouped into rows.
 */ function $6f17b2bb55436826$var$Table(props) {
    var attached = props.attached, basic = props.basic, celled = props.celled, children = props.children, className = props.className, collapsing = props.collapsing, color = props.color, columns = props.columns, compact = props.compact, definition = props.definition, fixed = props.fixed, footerRow = props.footerRow, headerRow = props.headerRow, headerRows = props.headerRows, inverted = props.inverted, padded = props.padded, renderBodyRow = props.renderBodyRow, selectable = props.selectable, singleLine = props.singleLine, size = props.size, sortable = props.sortable, stackable = props.stackable, striped = props.striped, structured = props.structured, tableData = props.tableData, textAlign = props.textAlign, unstackable = props.unstackable, verticalAlign = props.verticalAlign;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', color, size, (0, $87a122667489288b$export$aac7d417530cc39a)(celled, 'celled'), (0, $87a122667489288b$export$aac7d417530cc39a)(collapsing, 'collapsing'), (0, $87a122667489288b$export$aac7d417530cc39a)(definition, 'definition'), (0, $87a122667489288b$export$aac7d417530cc39a)(fixed, 'fixed'), (0, $87a122667489288b$export$aac7d417530cc39a)(inverted, 'inverted'), (0, $87a122667489288b$export$aac7d417530cc39a)(selectable, 'selectable'), (0, $87a122667489288b$export$aac7d417530cc39a)(singleLine, 'single line'), (0, $87a122667489288b$export$aac7d417530cc39a)(sortable, 'sortable'), (0, $87a122667489288b$export$aac7d417530cc39a)(stackable, 'stackable'), (0, $87a122667489288b$export$aac7d417530cc39a)(striped, 'striped'), (0, $87a122667489288b$export$aac7d417530cc39a)(structured, 'structured'), (0, $87a122667489288b$export$aac7d417530cc39a)(unstackable, 'unstackable'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(attached, 'attached'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(basic, 'basic'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(compact, 'compact'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(padded, 'padded'), (0, $87a122667489288b$export$32c7303ec0b907a1)(textAlign), (0, $87a122667489288b$export$169652642bc5e2a1)(verticalAlign), (0, $87a122667489288b$export$52866a87b538f23c)(columns, 'column'), 'table', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($6f17b2bb55436826$var$Table, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($6f17b2bb55436826$var$Table, props);
    if (!(0, $f0526af735e6584e$exports).isNil(children)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), children);
    var hasHeaderRows = headerRow || headerRows;
    var headerShorthandOptions = {
        defaultProps: {
            cellAs: 'th'
        }
    };
    var headerElement = hasHeaderRows && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $ef3094b83cd461e0$export$2e2bcd8739ae039), null, (0, $8e558ad36d016fdc$export$2e2bcd8739ae039).create(headerRow, headerShorthandOptions), (0, $2ef0baf102d48982$export$2e2bcd8739ae039)(headerRows, function(data) {
        return (0, $8e558ad36d016fdc$export$2e2bcd8739ae039).create(data, headerShorthandOptions);
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), headerElement, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $3b9ab39e575cb214$export$2e2bcd8739ae039), null, renderBodyRow && (0, $2ef0baf102d48982$export$2e2bcd8739ae039)(tableData, function(data, index) {
        return (0, $8e558ad36d016fdc$export$2e2bcd8739ae039).create(renderBodyRow(data, index));
    })), footerRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $6f7cb05c9848a7b1$export$2e2bcd8739ae039), null, (0, $8e558ad36d016fdc$export$2e2bcd8739ae039).create(footerRow)));
}
$6f17b2bb55436826$var$Table.handledProps = [
    "as",
    "attached",
    "basic",
    "celled",
    "children",
    "className",
    "collapsing",
    "color",
    "columns",
    "compact",
    "definition",
    "fixed",
    "footerRow",
    "headerRow",
    "headerRows",
    "inverted",
    "padded",
    "renderBodyRow",
    "selectable",
    "singleLine",
    "size",
    "sortable",
    "stackable",
    "striped",
    "structured",
    "tableData",
    "textAlign",
    "unstackable",
    "verticalAlign"
];
$6f17b2bb55436826$var$Table.defaultProps = {
    as: 'table'
};
$6f17b2bb55436826$var$Table.propTypes = {};
$6f17b2bb55436826$var$Table.Body = (0, $3b9ab39e575cb214$export$2e2bcd8739ae039);
$6f17b2bb55436826$var$Table.Cell = (0, $898755dd1d8ad937$export$2e2bcd8739ae039);
$6f17b2bb55436826$var$Table.Footer = (0, $6f7cb05c9848a7b1$export$2e2bcd8739ae039);
$6f17b2bb55436826$var$Table.Header = (0, $ef3094b83cd461e0$export$2e2bcd8739ae039);
$6f17b2bb55436826$var$Table.HeaderCell = (0, $70b505464867b692$export$2e2bcd8739ae039);
$6f17b2bb55436826$var$Table.Row = (0, $8e558ad36d016fdc$export$2e2bcd8739ae039);
var $6f17b2bb55436826$export$2e2bcd8739ae039 = $6f17b2bb55436826$var$Table;


const $71144acc5ea4c58a$var$CustomerRow = ({ customer: customer, deleteCustomer: deleteCustomer })=>{
    const [confirm, setConfirm] = (0, $6aRB8.useState)(false);
    const { customerId: customerId, name: name, domain: domain, status: status } = customer;
    const confirmDelete = async ()=>{
        await deleteCustomer(customerId);
        setConfirm(false);
    };
    return /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Row, {
        children: [
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $86f9b5396d19fca8$export$a6c7ac8248d6e38a), {
                    to: `/customers/${customerId}`,
                    children: customerId
                })
            }),
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                children: name
            }),
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                children: domain
            }),
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                children: status
            }),
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {}),
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                collapsing: true,
                children: [
                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
                        icon: true,
                        size: "small",
                        color: "red",
                        onClick: ()=>{
                            setConfirm(true);
                        },
                        children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $760d0282e0637aa7$export$2e2bcd8739ae039), {
                            name: "delete"
                        })
                    }),
                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $9e710c2e6164cea4$export$2e2bcd8739ae039), {
                        open: confirm,
                        onConfirm: confirmDelete,
                        onCancel: ()=>setConfirm(false),
                        header: "Delete Customer",
                        content: `Are you sure you want to delete customer '${customerId}'?`
                    })
                ]
            })
        ]
    });
};
$71144acc5ea4c58a$var$CustomerRow.propTypes = {
    customer: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).shape({
        customerId: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).string,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).string,
        domain: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).string,
        status: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).string
    }).isRequired,
    deleteCustomer: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).func.isRequired
};
var $71144acc5ea4c58a$export$2e2bcd8739ae039 = $71144acc5ea4c58a$var$CustomerRow;






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A container limits content to a maximum width.
 */ function $87cfc91b8d4cc84b$var$Container(props) {
    var children = props.children, className = props.className, content = props.content, fluid = props.fluid, text = props.text, textAlign = props.textAlign;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', (0, $87a122667489288b$export$aac7d417530cc39a)(text, 'text'), (0, $87a122667489288b$export$aac7d417530cc39a)(fluid, 'fluid'), (0, $87a122667489288b$export$32c7303ec0b907a1)(textAlign), 'container', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($87cfc91b8d4cc84b$var$Container, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($87cfc91b8d4cc84b$var$Container, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$87cfc91b8d4cc84b$var$Container.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "fluid",
    "text",
    "textAlign"
];
$87cfc91b8d4cc84b$var$Container.propTypes = {};
var $87cfc91b8d4cc84b$export$2e2bcd8739ae039 = $87cfc91b8d4cc84b$var$Container;






var $6aRB8 = parcelRequire("6aRB8");






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A group of segments can be formatted to appear together.
 */ function $ee1eb7572b564ee0$var$SegmentGroup(props) {
    var children = props.children, className = props.className, compact = props.compact, content = props.content, horizontal = props.horizontal, piled = props.piled, raised = props.raised, size = props.size, stacked = props.stacked;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', size, (0, $87a122667489288b$export$aac7d417530cc39a)(compact, 'compact'), (0, $87a122667489288b$export$aac7d417530cc39a)(horizontal, 'horizontal'), (0, $87a122667489288b$export$aac7d417530cc39a)(piled, 'piled'), (0, $87a122667489288b$export$aac7d417530cc39a)(raised, 'raised'), (0, $87a122667489288b$export$aac7d417530cc39a)(stacked, 'stacked'), 'segments', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($ee1eb7572b564ee0$var$SegmentGroup, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($ee1eb7572b564ee0$var$SegmentGroup, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$ee1eb7572b564ee0$var$SegmentGroup.handledProps = [
    "as",
    "children",
    "className",
    "compact",
    "content",
    "horizontal",
    "piled",
    "raised",
    "size",
    "stacked"
];
$ee1eb7572b564ee0$var$SegmentGroup.propTypes = {};
var $ee1eb7572b564ee0$export$2e2bcd8739ae039 = $ee1eb7572b564ee0$var$SegmentGroup;






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A placeholder segment can be inline.
 */ function $dbb7cdc833a2fdf4$var$SegmentInline(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('inline', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($dbb7cdc833a2fdf4$var$SegmentInline, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($dbb7cdc833a2fdf4$var$SegmentInline, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$dbb7cdc833a2fdf4$var$SegmentInline.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
$dbb7cdc833a2fdf4$var$SegmentInline.propTypes = {};
var $dbb7cdc833a2fdf4$export$2e2bcd8739ae039 = $dbb7cdc833a2fdf4$var$SegmentInline;


/**
 * A segment is used to create a grouping of related content.
 */ function $4f8ab05c9302e89f$var$Segment(props) {
    var attached = props.attached, basic = props.basic, children = props.children, circular = props.circular, className = props.className, clearing = props.clearing, color = props.color, compact = props.compact, content = props.content, disabled = props.disabled, floated = props.floated, inverted = props.inverted, loading = props.loading, placeholder = props.placeholder, padded = props.padded, piled = props.piled, raised = props.raised, secondary = props.secondary, size = props.size, stacked = props.stacked, tertiary = props.tertiary, textAlign = props.textAlign, vertical = props.vertical;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', color, size, (0, $87a122667489288b$export$aac7d417530cc39a)(basic, 'basic'), (0, $87a122667489288b$export$aac7d417530cc39a)(circular, 'circular'), (0, $87a122667489288b$export$aac7d417530cc39a)(clearing, 'clearing'), (0, $87a122667489288b$export$aac7d417530cc39a)(compact, 'compact'), (0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$aac7d417530cc39a)(inverted, 'inverted'), (0, $87a122667489288b$export$aac7d417530cc39a)(loading, 'loading'), (0, $87a122667489288b$export$aac7d417530cc39a)(placeholder, 'placeholder'), (0, $87a122667489288b$export$aac7d417530cc39a)(piled, 'piled'), (0, $87a122667489288b$export$aac7d417530cc39a)(raised, 'raised'), (0, $87a122667489288b$export$aac7d417530cc39a)(secondary, 'secondary'), (0, $87a122667489288b$export$aac7d417530cc39a)(stacked, 'stacked'), (0, $87a122667489288b$export$aac7d417530cc39a)(tertiary, 'tertiary'), (0, $87a122667489288b$export$aac7d417530cc39a)(vertical, 'vertical'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(attached, 'attached'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(padded, 'padded'), (0, $87a122667489288b$export$32c7303ec0b907a1)(textAlign), (0, $87a122667489288b$export$fb1b8744f6450628)(floated, 'floated'), 'segment', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($4f8ab05c9302e89f$var$Segment, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($4f8ab05c9302e89f$var$Segment, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$4f8ab05c9302e89f$var$Segment.handledProps = [
    "as",
    "attached",
    "basic",
    "children",
    "circular",
    "className",
    "clearing",
    "color",
    "compact",
    "content",
    "disabled",
    "floated",
    "inverted",
    "loading",
    "padded",
    "piled",
    "placeholder",
    "raised",
    "secondary",
    "size",
    "stacked",
    "tertiary",
    "textAlign",
    "vertical"
];
$4f8ab05c9302e89f$var$Segment.Group = (0, $ee1eb7572b564ee0$export$2e2bcd8739ae039);
$4f8ab05c9302e89f$var$Segment.Inline = (0, $dbb7cdc833a2fdf4$export$2e2bcd8739ae039);
$4f8ab05c9302e89f$var$Segment.propTypes = {};
var $4f8ab05c9302e89f$export$2e2bcd8739ae039 = $4f8ab05c9302e89f$var$Segment;


var $448c76afcb4f3de9$export$2e2bcd8739ae039 = ({ customers: customers = [], creationErrors: creationErrors, getCustomerDetail: getCustomerDetail, createCustomer: createCustomer, deleteCustomer: deleteCustomer })=>{
    const haveCustomers = customers.length > 0;
    return /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $4f8ab05c9302e89f$export$2e2bcd8739ae039), {
        basic: true,
        padded: "very",
        children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $87cfc91b8d4cc84b$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $6f17b2bb55436826$export$2e2bcd8739ae039), {
                celled: true,
                selectable: haveCustomers,
                children: [
                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Header, {
                        children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Row, {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {
                                    children: "CustomerId"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {
                                    children: "Customer Name"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {
                                    children: "Customer Domain"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {
                                    children: "Status"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {
                                    children: "Created"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Body, {
                        children: [
                            customers.map((customer, i)=>/*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $71144acc5ea4c58a$export$2e2bcd8739ae039), {
                                    customer: customer,
                                    deleteCustomer: deleteCustomer,
                                    getCustomerDetail: getCustomerDetail
                                }, i)),
                            !haveCustomers && /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Row, {
                                children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                                    colSpan: 6,
                                    children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $1e5d90c3685c34ec$export$2e2bcd8739ae039), {
                                        info: true,
                                        header: "No customers defined",
                                        content: "Use the 'Add Customer' button to create a new customer"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Footer, {
                        fullWidth: true,
                        children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Row, {
                            children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {
                                colSpan: "6",
                                children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $83aaeced91761250$export$2e2bcd8739ae039), {
                                    createCustomer: createCustomer
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};


class $e88351c3acc3f47c$var$CustomerList extends (0, $6aRB8.Component) {
    state = {
        customers: [],
        customerDetail: null
    };
    constructor(params){
        super(params);
        this.getCustomerDetail = this.getCustomerDetail.bind(this);
        this.createCustomer = this.createCustomer.bind(this);
        this.deleteCustomer = this.deleteCustomer.bind(this);
    }
    componentDidMount() {
        this.getCustomers();
    }
    async getCustomerDetail(customerId) {
        const customerDetail = await (0, $998b9e4952b694e1$export$b216272c8be3751a)(`/customers/${customerId}`);
        this.setState({
            customerDetail: customerDetail.data
        });
    }
    async getCustomers() {
        const customers = await (0, $998b9e4952b694e1$export$b216272c8be3751a)("/customers");
        this.setState({
            customers: customers.data
        });
    }
    async createCustomer(customer) {
        await (0, $998b9e4952b694e1$export$bd1dc54ad3b0ef79)("/customers", customer);
        await this.getCustomers();
    }
    async deleteCustomer(domain) {
        await (0, $998b9e4952b694e1$export$47bb6d36417ecd2e)(`/customers/${domain}`);
        await this.getCustomers();
    }
    render() {
        const { customers: customers } = this.state;
        const { getCustomerDetail: getCustomerDetail, createCustomer: createCustomer, deleteCustomer: deleteCustomer } = this;
        const params = {
            customers: customers,
            getCustomerDetail: getCustomerDetail,
            createCustomer: createCustomer,
            deleteCustomer: deleteCustomer
        };
        return /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $448c76afcb4f3de9$export$2e2bcd8739ae039), {
            ...params
        });
    }
}
var $e88351c3acc3f47c$export$2e2bcd8739ae039 = $e88351c3acc3f47c$var$CustomerList;




var $g7o4x = parcelRequire("g7o4x");

var $6aRB8 = parcelRequire("6aRB8");

var $4bMTH = parcelRequire("4bMTH");








var $6aRB8 = parcelRequire("6aRB8");





var $6aRB8 = parcelRequire("6aRB8");





var $6aRB8 = parcelRequire("6aRB8");

/**
 * A list item can contain a description.
 */ function $77160a82960f24fc$var$ListDescription(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)(className, 'description');
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($77160a82960f24fc$var$ListDescription, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($77160a82960f24fc$var$ListDescription, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$77160a82960f24fc$var$ListDescription.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
$77160a82960f24fc$var$ListDescription.propTypes = {};
$77160a82960f24fc$var$ListDescription.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($77160a82960f24fc$var$ListDescription, function(content) {
    return {
        content: content
    };
});
var $77160a82960f24fc$export$2e2bcd8739ae039 = $77160a82960f24fc$var$ListDescription;






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A list item can contain a header.
 */ function $8c6ea58d9c6e4c08$var$ListHeader(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('header', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($8c6ea58d9c6e4c08$var$ListHeader, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($8c6ea58d9c6e4c08$var$ListHeader, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$8c6ea58d9c6e4c08$var$ListHeader.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
$8c6ea58d9c6e4c08$var$ListHeader.propTypes = {};
$8c6ea58d9c6e4c08$var$ListHeader.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($8c6ea58d9c6e4c08$var$ListHeader, function(content) {
    return {
        content: content
    };
});
var $8c6ea58d9c6e4c08$export$2e2bcd8739ae039 = $8c6ea58d9c6e4c08$var$ListHeader;


/**
 * A list item can contain a content.
 */ function $da7d8194e55a67eb$var$ListContent(props) {
    var children = props.children, className = props.className, content = props.content, description = props.description, floated = props.floated, header = props.header, verticalAlign = props.verticalAlign;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$fb1b8744f6450628)(floated, 'floated'), (0, $87a122667489288b$export$169652642bc5e2a1)(verticalAlign), 'content', className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($da7d8194e55a67eb$var$ListContent, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($da7d8194e55a67eb$var$ListContent, props);
    if (!(0, $f0526af735e6584e$exports).isNil(children)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $8c6ea58d9c6e4c08$export$2e2bcd8739ae039).create(header), (0, $77160a82960f24fc$export$2e2bcd8739ae039).create(description), content);
}
$da7d8194e55a67eb$var$ListContent.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "description",
    "floated",
    "header",
    "verticalAlign"
];
$da7d8194e55a67eb$var$ListContent.propTypes = {};
$da7d8194e55a67eb$var$ListContent.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($da7d8194e55a67eb$var$ListContent, function(content) {
    return {
        content: content
    };
});
var $da7d8194e55a67eb$export$2e2bcd8739ae039 = $da7d8194e55a67eb$var$ListContent;








var $6aRB8 = parcelRequire("6aRB8");


/**
 * A list item can contain an icon.
 */ function $e2088a93d7b17c6c$var$ListIcon(props) {
    var className = props.className, verticalAlign = props.verticalAlign;
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$169652642bc5e2a1)(verticalAlign), className);
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($e2088a93d7b17c6c$var$ListIcon, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $760d0282e0637aa7$export$2e2bcd8739ae039), (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }));
}
$e2088a93d7b17c6c$var$ListIcon.handledProps = [
    "className",
    "verticalAlign"
];
$e2088a93d7b17c6c$var$ListIcon.propTypes = {};
$e2088a93d7b17c6c$var$ListIcon.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($e2088a93d7b17c6c$var$ListIcon, function(name) {
    return {
        name: name
    };
});
var $e2088a93d7b17c6c$export$2e2bcd8739ae039 = $e2088a93d7b17c6c$var$ListIcon;









var $6aRB8 = parcelRequire("6aRB8");






/**
 * A list item can contain a set of items.
 */ var $166f2c0d64afd093$var$ListItem = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(ListItem, _Component);
    function ListItem() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.handleClick = function(e) {
            var disabled = _this.props.disabled;
            if (!disabled) (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onClick', e, _this.props);
        };
        return _this;
    }
    var _proto = ListItem.prototype;
    _proto.render = function render() {
        var _this$props = this.props, active = _this$props.active, children = _this$props.children, className = _this$props.className, content = _this$props.content, description = _this$props.description, disabled = _this$props.disabled, header = _this$props.header, icon = _this$props.icon, image = _this$props.image, value = _this$props.value;
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(ListItem, this.props);
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$aac7d417530cc39a)(active, 'active'), (0, $87a122667489288b$export$aac7d417530cc39a)(disabled, 'disabled'), (0, $87a122667489288b$export$aac7d417530cc39a)(ElementType !== 'li', 'item'), className);
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(ListItem, this.props);
        var valueProp = ElementType === 'li' ? {
            value: value
        } : {
            'data-value': value
        };
        if (!(0, $f0526af735e6584e$exports).isNil(children)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, valueProp, {
            role: "listitem",
            className: classes,
            onClick: this.handleClick
        }, rest), children);
        var iconElement = (0, $e2088a93d7b17c6c$export$2e2bcd8739ae039).create(icon, {
            autoGenerateKey: false
        });
        var imageElement = (0, $32f1a379a68c59a0$export$2e2bcd8739ae039).create(image, {
            autoGenerateKey: false
        }); // See description of `content` prop for explanation about why this is necessary.
        if (!/*#__PURE__*/ (0, $6aRB8.isValidElement)(content) && (0, $88fcb6c8ec5d0788$export$2e2bcd8739ae039)(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, valueProp, {
            role: "listitem",
            className: classes,
            onClick: this.handleClick
        }, rest), iconElement || imageElement, (0, $da7d8194e55a67eb$export$2e2bcd8739ae039).create(content, {
            autoGenerateKey: false,
            defaultProps: {
                header: header,
                description: description
            }
        }));
        var headerElement = (0, $8c6ea58d9c6e4c08$export$2e2bcd8739ae039).create(header, {
            autoGenerateKey: false
        });
        var descriptionElement = (0, $77160a82960f24fc$export$2e2bcd8739ae039).create(description, {
            autoGenerateKey: false
        });
        if (iconElement || imageElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, valueProp, {
            role: "listitem",
            className: classes,
            onClick: this.handleClick
        }, rest), iconElement || imageElement, (content || headerElement || descriptionElement) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement((0, $da7d8194e55a67eb$export$2e2bcd8739ae039), null, headerElement, descriptionElement, content));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, valueProp, {
            role: "listitem",
            className: classes,
            onClick: this.handleClick
        }, rest), headerElement, descriptionElement, content);
    };
    return ListItem;
}((0, $6aRB8.Component));
$166f2c0d64afd093$var$ListItem.handledProps = [
    "active",
    "as",
    "children",
    "className",
    "content",
    "description",
    "disabled",
    "header",
    "icon",
    "image",
    "onClick",
    "value"
];
$166f2c0d64afd093$var$ListItem.propTypes = {};
$166f2c0d64afd093$var$ListItem.create = (0, $d590e40415a777e8$export$d60247e40ab2d321)($166f2c0d64afd093$var$ListItem, function(content) {
    return {
        content: content
    };
});
var $166f2c0d64afd093$export$2e2bcd8739ae039 = $166f2c0d64afd093$var$ListItem;






var $6aRB8 = parcelRequire("6aRB8");

/**
 * A list can contain a sub list.
 */ function $3237a8892612a0c6$var$ListList(props) {
    var children = props.children, className = props.className, content = props.content;
    var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)($3237a8892612a0c6$var$ListList, props);
    var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)($3237a8892612a0c6$var$ListList, props);
    var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)((0, $87a122667489288b$export$aac7d417530cc39a)(ElementType !== 'ul' && ElementType !== 'ol', 'list'), className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({}, rest, {
        className: classes
    }), (0, $f0526af735e6584e$exports).isNil(children) ? content : children);
}
$3237a8892612a0c6$var$ListList.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
$3237a8892612a0c6$var$ListList.propTypes = {};
var $3237a8892612a0c6$export$2e2bcd8739ae039 = $3237a8892612a0c6$var$ListList;


/**
 * A list groups related content.
 */ var $240f803ad1fe928a$var$List = /*#__PURE__*/ function(_Component) {
    (0, $1e69fa31b9c24ab0$export$2e2bcd8739ae039)(List, _Component);
    function List() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        _this.handleItemOverrides = function(predefinedProps) {
            return {
                onClick: function onClick(e, itemProps) {
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(predefinedProps, 'onClick', e, itemProps);
                    (0, $a9a92c7799ca2a07$export$2e2bcd8739ae039)(_this.props, 'onItemClick', e, itemProps);
                }
            };
        };
        return _this;
    }
    var _proto = List.prototype;
    _proto.render = function render() {
        var _this2 = this;
        var _this$props = this.props, animated = _this$props.animated, bulleted = _this$props.bulleted, celled = _this$props.celled, children = _this$props.children, className = _this$props.className, content = _this$props.content, divided = _this$props.divided, floated = _this$props.floated, horizontal = _this$props.horizontal, inverted = _this$props.inverted, items = _this$props.items, link = _this$props.link, ordered = _this$props.ordered, relaxed = _this$props.relaxed, selection = _this$props.selection, size = _this$props.size, verticalAlign = _this$props.verticalAlign;
        var classes = (0, $b589707e9204a564$export$2e2bcd8739ae039)('ui', size, (0, $87a122667489288b$export$aac7d417530cc39a)(animated, 'animated'), (0, $87a122667489288b$export$aac7d417530cc39a)(bulleted, 'bulleted'), (0, $87a122667489288b$export$aac7d417530cc39a)(celled, 'celled'), (0, $87a122667489288b$export$aac7d417530cc39a)(divided, 'divided'), (0, $87a122667489288b$export$aac7d417530cc39a)(horizontal, 'horizontal'), (0, $87a122667489288b$export$aac7d417530cc39a)(inverted, 'inverted'), (0, $87a122667489288b$export$aac7d417530cc39a)(link, 'link'), (0, $87a122667489288b$export$aac7d417530cc39a)(ordered, 'ordered'), (0, $87a122667489288b$export$aac7d417530cc39a)(selection, 'selection'), (0, $87a122667489288b$export$72ebbc0b2506f7f8)(relaxed, 'relaxed'), (0, $87a122667489288b$export$fb1b8744f6450628)(floated, 'floated'), (0, $87a122667489288b$export$169652642bc5e2a1)(verticalAlign), 'list', className);
        var rest = (0, $55562498df7fa7d0$export$2e2bcd8739ae039)(List, this.props);
        var ElementType = (0, $444c8af3b9889af9$export$2e2bcd8739ae039)(List, this.props);
        if (!(0, $f0526af735e6584e$exports).isNil(children)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({
            role: "list",
            className: classes
        }, rest), children);
        if (!(0, $f0526af735e6584e$exports).isNil(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({
            role: "list",
            className: classes
        }, rest), content);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6aRB8))).createElement(ElementType, (0, $1e0a7747b096edac$export$2e2bcd8739ae039)({
            role: "list",
            className: classes
        }, rest), (0, $2ef0baf102d48982$export$2e2bcd8739ae039)(items, function(item) {
            return (0, $166f2c0d64afd093$export$2e2bcd8739ae039).create(item, {
                overrideProps: _this2.handleItemOverrides
            });
        }));
    };
    return List;
}((0, $6aRB8.Component));
$240f803ad1fe928a$var$List.handledProps = [
    "animated",
    "as",
    "bulleted",
    "celled",
    "children",
    "className",
    "content",
    "divided",
    "floated",
    "horizontal",
    "inverted",
    "items",
    "link",
    "onItemClick",
    "ordered",
    "relaxed",
    "selection",
    "size",
    "verticalAlign"
];
$240f803ad1fe928a$var$List.propTypes = {};
$240f803ad1fe928a$var$List.Content = (0, $da7d8194e55a67eb$export$2e2bcd8739ae039);
$240f803ad1fe928a$var$List.Description = (0, $77160a82960f24fc$export$2e2bcd8739ae039);
$240f803ad1fe928a$var$List.Header = (0, $8c6ea58d9c6e4c08$export$2e2bcd8739ae039);
$240f803ad1fe928a$var$List.Icon = (0, $e2088a93d7b17c6c$export$2e2bcd8739ae039);
$240f803ad1fe928a$var$List.Item = (0, $166f2c0d64afd093$export$2e2bcd8739ae039);
$240f803ad1fe928a$var$List.List = (0, $3237a8892612a0c6$export$2e2bcd8739ae039);
var $240f803ad1fe928a$export$2e2bcd8739ae039 = $240f803ad1fe928a$var$List;





var $6aRB8 = parcelRequire("6aRB8");

var $4bMTH = parcelRequire("4bMTH");

const $e02eebbd34b78c4f$var$CreateIdentityProvider = ({ customerId: customerId, createIdentityProvider: createIdentityProvider })=>{
    // ui state
    const [open, setOpen] = (0, $6aRB8.useState)(false);
    const [errors, setErrors] = (0, $6aRB8.useState)([]);
    // form fields
    const [type] = (0, $6aRB8.useState)("OIDC");
    const [name, setName] = (0, $6aRB8.useState)("");
    const [scopes, setScopes] = (0, $6aRB8.useState)("");
    const [clientId, setClientId] = (0, $6aRB8.useState)("");
    const [clientSecret, setClientSecret] = (0, $6aRB8.useState)("");
    const [issuer, setIssuer] = (0, $6aRB8.useState)("");
    async function createIdentityProviderSubmit() {
        try {
            await createIdentityProvider(customerId, {
                name: name,
                type: type,
                clientId: clientId,
                clientSecret: clientSecret,
                scopes: scopes,
                issuer: issuer
            });
            // reset state
            setOpen(false);
        } catch (e) {
            console.error("the error", e.status);
            setErrors(e.response.data.errors);
        }
    }
    const createProviderButton = /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
        floated: "right",
        icon: true,
        labelPosition: "left",
        primary: true,
        size: "small",
        children: [
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $760d0282e0637aa7$export$2e2bcd8739ae039), {
                name: "plus"
            }),
            "Add Identity Provider"
        ]
    });
    return /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039), {
        open: open,
        onOpen: ()=>setOpen(true),
        onClose: ()=>setOpen(false),
        trigger: createProviderButton,
        children: [
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Header, {
                children: "Create a new identity provider"
            }),
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Content, {
                children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039), {
                    onSubmit: createIdentityProviderSubmit,
                    children: [
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $f11325917db9c363$export$2e2bcd8739ae039), {
                            horizontal: true,
                            children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $562317775b0c6bd4$export$2e2bcd8739ae039), {
                                as: "h4",
                                children: [
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $760d0282e0637aa7$export$2e2bcd8739ae039), {
                                        name: "sitemap"
                                    }),
                                    "Identity Provider Details"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                    htmlFor: "name",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                    id: "name",
                                    onChange: (e)=>setName(e.target.value),
                                    value: name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                    htmlFor: "clientId",
                                    children: "Client Id"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                    id: "clientId",
                                    onChange: (e)=>setClientId(e.target.value),
                                    value: clientId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                    htmlFor: "clientSecret",
                                    children: "Client Secret"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                    id: "clientSecret",
                                    onChange: (e)=>setClientSecret(e.target.value),
                                    value: clientSecret
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                    htmlFor: "authoriceScopes",
                                    children: "Authorize Scopes"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                    id: "authoriceScopes",
                                    placeholder: "openid, etc",
                                    onChange: (e)=>setScopes(e.target.value),
                                    value: scopes
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                    htmlFor: "issuer",
                                    children: "Issuer"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                    id: "issuer",
                                    onChange: (e)=>setIssuer(e.target.value),
                                    value: issuer
                                })
                            ]
                        }),
                        errors.map(({ title: title, detail: detail })=>/*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $1e5d90c3685c34ec$export$2e2bcd8739ae039), {
                                negative: true,
                                header: title,
                                content: detail
                            }, title)),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
                            primary: true,
                            type: "submit",
                            children: "Create Identity Provider"
                        })
                    ]
                })
            })
        ]
    });
};
$e02eebbd34b78c4f$var$CreateIdentityProvider.propTypes = {
    customerId: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).string.isRequired,
    createIdentityProvider: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).func.isRequired
};
var $e02eebbd34b78c4f$export$2e2bcd8739ae039 = $e02eebbd34b78c4f$var$CreateIdentityProvider;




var $6aRB8 = parcelRequire("6aRB8");

var $4bMTH = parcelRequire("4bMTH");

const $c4877c469f01034b$var$CreateUserPool = ({ customerId: customerId, createUserPool: createUserPool })=>{
    // ui state
    const [open, setOpen] = (0, $6aRB8.useState)(false);
    const [errors, setErrors] = (0, $6aRB8.useState)([]);
    // form fields
    const [adminName, setAdminName] = (0, $6aRB8.useState)("Admin");
    const [adminEmail, setAdminEmail] = (0, $6aRB8.useState)("");
    async function createUserPoolSubmit(e) {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        try {
            await createUserPool(customerId, {
                adminName: adminName,
                adminEmail: adminEmail
            });
            // reset state
            setOpen(false);
        } catch (err) {
            console.error("the error", err.status);
            setErrors(err.response.data.errors);
        }
    }
    const createUserPoolButton = /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
        floated: "right",
        icon: true,
        labelPosition: "left",
        primary: true,
        size: "small",
        children: [
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $760d0282e0637aa7$export$2e2bcd8739ae039), {
                name: "plus"
            }),
            "Create User Pool"
        ]
    });
    return /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039), {
        open: open,
        onOpen: (e)=>{
            e.preventDefault();
            setOpen(true);
        },
        onClose: ()=>setOpen(false),
        trigger: createUserPoolButton,
        children: [
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Header, {
                children: "Create a new customer"
            }),
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Content, {
                children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039), {
                    onSubmit: createUserPoolSubmit,
                    children: [
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $f11325917db9c363$export$2e2bcd8739ae039), {
                            horizontal: true,
                            children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $562317775b0c6bd4$export$2e2bcd8739ae039), {
                                as: "h4",
                                children: [
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $760d0282e0637aa7$export$2e2bcd8739ae039), {
                                        name: "info"
                                    }),
                                    "User Pool Info"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                    htmlFor: "admin",
                                    children: "Admin Username"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                    id: "admin",
                                    placeholder: "Admin",
                                    onChange: (e)=>setAdminName(e.target.value),
                                    value: adminName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                    htmlFor: "email",
                                    children: "Admin Email"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                    id: "email",
                                    placeholder: "email",
                                    onChange: (e)=>setAdminEmail(e.target.value),
                                    value: adminEmail
                                })
                            ]
                        }),
                        errors.map(({ title: title, detail: detail }, i)=>/*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $1e5d90c3685c34ec$export$2e2bcd8739ae039), {
                                negative: true,
                                header: title,
                                content: detail
                            }, i)),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
                            primary: true,
                            type: "submit",
                            children: "Create User Pool"
                        })
                    ]
                })
            })
        ]
    });
};
$c4877c469f01034b$var$CreateUserPool.propTypes = {
    customerId: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).string.isRequired,
    createUserPool: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).func.isRequired
};
var $c4877c469f01034b$export$2e2bcd8739ae039 = $c4877c469f01034b$var$CreateUserPool;




var $6aRB8 = parcelRequire("6aRB8");

var $4bMTH = parcelRequire("4bMTH");

const $28d2b2ecb48f6577$var$DeleteUserPool = ({ customerId: customerId, userPoolId: userPoolId, deleteUserPool: deleteUserPool })=>{
    // ui state
    const [open, setOpen] = (0, $6aRB8.useState)(false);
    async function deleteUserPoolSubmit() {
        try {
            await deleteUserPool(customerId, userPoolId);
            // reset state
            setOpen(false);
        } catch (e) {
            console.error("the error", e.status);
        }
    }
    const deleteUserPoolButton = /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
        floated: "right",
        negative: true,
        disabled: userPoolId === "default",
        size: "mini",
        children: "Delete"
    });
    return /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039), {
        open: open,
        onOpen: ()=>setOpen(true),
        onClose: ()=>setOpen(false),
        trigger: deleteUserPoolButton,
        children: [
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Header, {
                children: "Are you sure you want to delete this user pool?"
            }),
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Content, {
                children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039), {
                    onSubmit: deleteUserPoolSubmit,
                    children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $a7825a90230ff993$export$2e2bcd8739ae039).Group, {
                        children: [
                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
                                positive: true,
                                type: "submit",
                                children: "Yes"
                            }),
                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a7825a90230ff993$export$2e2bcd8739ae039).Or, {}),
                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    e.nativeEvent.stopImmediatePropagation();
                                    setOpen(false);
                                },
                                children: "Cancel"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
$28d2b2ecb48f6577$var$DeleteUserPool.propTypes = {
    customerId: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).string.isRequired,
    userPoolId: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).string.isRequired,
    deleteUserPool: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).func.isRequired
};
var $28d2b2ecb48f6577$export$2e2bcd8739ae039 = $28d2b2ecb48f6577$var$DeleteUserPool;




var $6aRB8 = parcelRequire("6aRB8");

var $4bMTH = parcelRequire("4bMTH");


const $041734ae61052c71$var$UserBackups = ({ customerId: customerId, poolInfo: poolInfo })=>{
    const { num: num, userPoolId: userPoolId } = poolInfo;
    // ui state
    const [open, setOpen] = (0, $6aRB8.useState)(false);
    const [backups, setBackups] = (0, $6aRB8.useState)([]);
    const [restoreStatus, setRestoreStatus] = (0, $6aRB8.useState)();
    const [backingUp, setBackingUp] = (0, $6aRB8.useState)(false);
    const [restoring, setRestoring] = (0, $6aRB8.useState)(false);
    const refresh = ()=>{
        (0, $998b9e4952b694e1$export$b216272c8be3751a)(`/customers/${customerId}/user-backups`).then((result)=>{
            const sorted = result.data.sort((backup)=>backup.lastModified);
            setBackups(sorted);
        });
    };
    (0, $6aRB8.useEffect)(()=>{
        if (open) refresh();
    }, [
        customerId,
        open
    ]);
    const createUserBackup = (0, $6aRB8.useCallback)(()=>{
        setBackingUp(true);
        (0, $998b9e4952b694e1$export$bd1dc54ad3b0ef79)(`/customers/${customerId}/user-backups/${userPoolId}/backup`, {}).then(()=>{
            setBackingUp(false);
            refresh();
        });
    }, [
        customerId
    ]);
    const restore = (0, $6aRB8.useCallback)((key)=>{
        setRestoring(true);
        (0, $998b9e4952b694e1$export$bd1dc54ad3b0ef79)(`/customers/${customerId}/user-backups/${userPoolId}/restore`, {
            backupKey: key
        }).then((result)=>{
            setRestoreStatus(result);
            setRestoring(false);
        });
    }, [
        customerId
    ]);
    const createUserPoolButton = /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
        floated: "right",
        icon: true,
        labelPosition: "left",
        primary: true,
        size: "small",
        children: [
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $760d0282e0637aa7$export$2e2bcd8739ae039), {
                name: "plus"
            }),
            "Manage Backups"
        ]
    });
    return /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039), {
        open: open,
        onOpen: (e)=>{
            e.preventDefault();
            setOpen(true);
        },
        onClose: ()=>setOpen(false),
        trigger: createUserPoolButton,
        children: [
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Header, {
                children: `Manage User Backups (pool${num})`
            }),
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Content, {
                children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $87cfc91b8d4cc84b$export$2e2bcd8739ae039), {
                    children: [
                        restoreStatus && /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("span", {
                            children: `created: ${restoreStatus.created}, skipped: ${restoreStatus.skipped}, errored: ${restoreStatus.errored}`
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $6f17b2bb55436826$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Header, {
                                    children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Row, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {
                                                children: "Key"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {
                                                children: "Last Modified"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {
                                                children: "Size"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {}),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Body, {
                                    children: backups.map((backup)=>{
                                        return /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Row, {
                                            children: [
                                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                                                    children: backup.key.replace("__mm_backup__/cognito", "")
                                                }),
                                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                                                    children: backup.lastModified
                                                }),
                                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                                                    children: backup.size
                                                }),
                                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                                                    children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
                                                        primary: true,
                                                        size: "mini",
                                                        disabled: restoring,
                                                        onClick: (e)=>{
                                                            e.preventDefault();
                                                            restore(backup.key);
                                                        },
                                                        children: "Restore"
                                                    })
                                                })
                                            ]
                                        }, backup.key);
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $00934dd1575f8f3e$export$2e2bcd8739ae039).Actions, {
                children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
                    disabled: backingUp,
                    onClick: createUserBackup,
                    children: "Create User Backup"
                })
            })
        ]
    });
};
$041734ae61052c71$var$UserBackups.propTypes = {
    customerId: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).string.isRequired,
    poolInfo: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).shape({
        num: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).string,
        userPoolId: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).string
    }).isRequired
};
var $041734ae61052c71$export$2e2bcd8739ae039 = $041734ae61052c71$var$UserBackups;


class $2921762a5da9ac04$var$CustomerDetails extends (0, $6aRB8.Component) {
    constructor(params){
        super(params);
        this.state = {
            modified: false,
            details: {}
        };
        this.getCustomerDetail = this.getCustomerDetail.bind(this);
        this.createIdentityProvider = this.createIdentityProvider.bind(this);
        this.createUserPool = this.createUserPool.bind(this);
        this.deleteUserPool = this.deleteUserPool.bind(this);
        this.updateCustomer = this.updateCustomer.bind(this);
    }
    componentDidMount() {
        const { match: match } = this.props;
        const { customerId: customerId } = match.params;
        this.getCustomerDetail(customerId);
    }
    async getCustomerDetail(customerId) {
        const customerDetail = await (0, $998b9e4952b694e1$export$b216272c8be3751a)(`/customers/${customerId}`);
        this.setState({
            details: customerDetail.data
        });
    }
    async createUserPool(customerId, userPool) {
        await (0, $998b9e4952b694e1$export$bd1dc54ad3b0ef79)(`/customers/${customerId}/user-pools`, userPool);
        await this.getCustomerDetail(customerId);
    }
    async deleteUserPool(customerId, userPoolId) {
        await (0, $998b9e4952b694e1$export$47bb6d36417ecd2e)(`/customers/${customerId}/user-pools/${userPoolId}`);
        await this.getCustomerDetail(customerId);
    }
    async createIdentityProvider(customerId, provider) {
        await (0, $998b9e4952b694e1$export$bd1dc54ad3b0ef79)(`/customers/${customerId}/providers`, provider);
        await this.getCustomerDetail(customerId);
    }
    async updateCustomer() {
        const { details: details } = this.state;
        const { customerId: customerId, storageMethod: storageMethod = "onedrive" } = details;
        const detailsAug = {
            ...details,
            storageMethod: storageMethod
        };
        const cleanDetails = (0, (/*@__PURE__*/$parcel$interopDefault($g7o4x))).pick(detailsAug, [
            "name",
            "domain",
            "storageMethod",
            "emailDomain",
            "pluginRedirect",
            "callbackUrl",
            "siteCollection",
            "identityProviders",
            "sharePointSite",
            "currUserPoolId",
            "azureClientId",
            "azureClientSecret",
            "azureTenantId",
            "azureSSO",
            "allowCognitoLogin"
        ]);
        const customerDetail = await (0, $998b9e4952b694e1$export$6dd598fa143977b0)(`/customers/${customerId}`, cleanDetails);
        this.setState({
            modified: false,
            details: customerDetail.data
        });
    }
    handleChange(name, value) {
        const { details: details } = this.state;
        return this.setState({
            modified: true,
            details: {
                ...details,
                [name]: value
            }
        });
    }
    toggleCognitoSignin() {
        const { details: details } = this.state;
        this.setState({
            modified: true,
            details: {
                ...details,
                allowCognitoLogin: !details.allowCognitoLogin
            }
        });
    }
    toggleAzureSSO() {
        const { details: details } = this.state;
        this.setState({
            modified: true,
            details: {
                ...details,
                azureSSO: !details.azureSSO
            }
        });
    }
    render() {
        const { modified: modified, details: details } = this.state;
        const { customerId: customerId, name: name, domain: domain, emailDomain: emailDomain, userPool: userPool, cognitoDomain: cognitoDomain, identityProviders: identityProviders = [], userPools: userPools, currUserPoolId: currUserPoolId, pluginRedirect: pluginRedirect, storageMethod: storageMethod, siteCollection: siteCollection, sharePointSite: sharePointSite, azureClientId: azureClientId, azureClientSecret: azureClientSecret, azureTenantId: azureTenantId, allowCognitoLogin: allowCognitoLogin, azureSSO: azureSSO } = details || {};
        const { createIdentityProvider: createIdentityProvider, updateCustomer: updateCustomer, createUserPool: createUserPool, deleteUserPool: deleteUserPool } = this;
        const storageOptions = [
            {
                key: "s3",
                value: "s3",
                text: "S3"
            },
            {
                key: "onedrive",
                value: "onedrive",
                text: "OneDrive"
            }
        ];
        return /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $87cfc91b8d4cc84b$export$2e2bcd8739ae039), {
            children: customerId && /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $cd58308bfc2f0eb2$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $f11325917db9c363$export$2e2bcd8739ae039), {
                        horizontal: true,
                        children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $562317775b0c6bd4$export$2e2bcd8739ae039), {
                            color: "blue",
                            as: "h4",
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $760d0282e0637aa7$export$2e2bcd8739ae039), {
                                    name: "info"
                                }),
                                "Customer Details"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $4f8ab05c9302e89f$export$2e2bcd8739ae039), {
                        clearing: true,
                        children: [
                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $86f9b5396d19fca8$export$a6c7ac8248d6e38a), {
                                as: (0, $a7825a90230ff993$export$2e2bcd8739ae039),
                                to: `/customers/${customerId}/users`,
                                children: "Manage Users"
                            }),
                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039), {
                                onSubmit: updateCustomer,
                                children: [
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "customerId",
                                                children: "Customer Id:"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                                id: "customerId",
                                                disabled: true,
                                                readOnly: true,
                                                value: customerId
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "name",
                                                children: "Customer Name:"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                                id: "name",
                                                onChange: (e)=>this.handleChange("name", e.target.value),
                                                value: name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "domain",
                                                children: "Domain:"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                                id: "domain",
                                                onChange: (e)=>this.handleChange("domain", e.target.value),
                                                value: domain
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "userPool",
                                                children: "User Pool:"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                                id: "userPool",
                                                disabled: true,
                                                readOnly: true,
                                                value: userPool
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "cognitoDomain",
                                                children: "Cognito Domain:"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                                id: "cognitoDomain",
                                                disabled: true,
                                                readOnly: true,
                                                value: cognitoDomain
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $240f803ad1fe928a$export$2e2bcd8739ae039), {
                                        children: userPools && userPools.map((p)=>/*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $240f803ad1fe928a$export$2e2bcd8739ae039).Item, {
                                                children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $27eaca9c2794488d$export$2e2bcd8739ae039), {
                                                            label: `(pool${p.num}) ${p.cognitoDomain}`,
                                                            name: "radioGroup",
                                                            value: p.userPoolId,
                                                            checked: currUserPoolId === p.userPoolId,
                                                            onChange: (e, { value: value })=>{
                                                                this.handleChange("currUserPoolId", value);
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $041734ae61052c71$export$2e2bcd8739ae039), {
                                                            customerId: customerId,
                                                            poolInfo: p
                                                        }),
                                                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $28d2b2ecb48f6577$export$2e2bcd8739ae039), {
                                                            customerId: customerId,
                                                            userPoolId: p.userPoolId,
                                                            deleteUserPool: deleteUserPool
                                                        })
                                                    ]
                                                })
                                            }))
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $c4877c469f01034b$export$2e2bcd8739ae039), {
                                        customerId: customerId,
                                        createUserPool: createUserPool
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "emailDomain",
                                                children: "Email Domain:"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                                id: "emailDomain",
                                                onChange: (e)=>this.handleChange("emailDomain", e.target.value),
                                                value: emailDomain
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "pluginRedirect",
                                                children: "Plugin Redirect:"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                                id: "pluginRedirect",
                                                onChange: (e)=>this.handleChange("pluginRedirect", e.target.value),
                                                value: pluginRedirect
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "allowCognitoLogin",
                                                children: "Allow Cognito Login"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a4dfa44f3ad67085$export$2e2bcd8739ae039), {
                                                id: "allowCognitoLogin",
                                                toggle: true,
                                                onChange: ()=>this.toggleCognitoSignin(),
                                                checked: allowCognitoLogin
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "storageMethod",
                                                children: "Storage Method:"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6a9eaf6b801099ca$export$2e2bcd8739ae039), {
                                                id: "storageMethod",
                                                selection: true,
                                                onChange: (e, d)=>this.handleChange("storageMethod", d.value),
                                                options: storageOptions,
                                                value: storageMethod || "onedrive"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $f11325917db9c363$export$2e2bcd8739ae039), {
                                        horizontal: true,
                                        children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $562317775b0c6bd4$export$2e2bcd8739ae039), {
                                            color: "blue",
                                            as: "h4",
                                            children: [
                                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $760d0282e0637aa7$export$2e2bcd8739ae039), {
                                                    name: "microsoft"
                                                }),
                                                "Azure Active Directory"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "clientId",
                                                children: "Client Id"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                                id: "clientId",
                                                onChange: (e)=>this.handleChange("azureClientId", e.target.value),
                                                value: azureClientId
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "tenantId",
                                                children: "Tenant"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                                id: "tenantId",
                                                onChange: (e)=>this.handleChange("azureTenantId", e.target.value),
                                                value: azureTenantId
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "clientSecret",
                                                children: "Client Secret"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                                id: "clientSecret",
                                                onChange: (e)=>this.handleChange("azureClientSecret", e.target.value),
                                                value: azureClientSecret
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "siteCollection",
                                                children: "Site Collection:"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                                id: "siteCollection",
                                                onChange: (e)=>this.handleChange("siteCollection", e.target.value),
                                                value: siteCollection
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "sharePointSite",
                                                children: "SharePoint Site:"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("input", {
                                                id: "sharePointSite",
                                                onChange: (e)=>this.handleChange("sharePointSite", e.target.value),
                                                value: sharePointSite
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("label", {
                                                htmlFor: "enableSSO",
                                                children: "Enable SSO"
                                            }),
                                            /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a4dfa44f3ad67085$export$2e2bcd8739ae039), {
                                                id: "enableSSO",
                                                toggle: true,
                                                onChange: ()=>this.toggleAzureSSO(),
                                                checked: azureSSO
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
                                        floated: "right",
                                        disabled: !modified,
                                        primary: true,
                                        type: "submit",
                                        children: "Update"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $f11325917db9c363$export$2e2bcd8739ae039), {
                        horizontal: true,
                        children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $562317775b0c6bd4$export$2e2bcd8739ae039), {
                            color: "blue",
                            as: "h4",
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $760d0282e0637aa7$export$2e2bcd8739ae039), {
                                    name: "sitemap"
                                }),
                                "Identity Providers"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $4f8ab05c9302e89f$export$2e2bcd8739ae039), {
                        clearing: true,
                        children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $b1a734f607ca44b0$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $240f803ad1fe928a$export$2e2bcd8739ae039), {
                                    divided: true,
                                    relaxed: true,
                                    children: identityProviders && identityProviders.map((p)=>/*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $240f803ad1fe928a$export$2e2bcd8739ae039).Item, {
                                            children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $240f803ad1fe928a$export$2e2bcd8739ae039).Content, {
                                                children: [
                                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $240f803ad1fe928a$export$2e2bcd8739ae039).Header, {
                                                        as: "a",
                                                        children: p.name
                                                    }),
                                                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $240f803ad1fe928a$export$2e2bcd8739ae039).Description, {
                                                        as: "a",
                                                        children: p.type
                                                    })
                                                ]
                                            })
                                        }, p.name))
                                }),
                                identityProviders && identityProviders.length === 0 && /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $1e5d90c3685c34ec$export$2e2bcd8739ae039), {
                                    info: true,
                                    header: "No Third Party Identity Providers Found",
                                    content: "Use the 'Add Provider' button to associate a new Identity Provider with this customer"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $e02eebbd34b78c4f$export$2e2bcd8739ae039), {
                                    customerId: customerId,
                                    createIdentityProvider: createIdentityProvider
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
$2921762a5da9ac04$var$CustomerDetails.propTypes = {
    match: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).shape({
        customerId: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).string,
        params: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).shape({
            customerId: (0, (/*@__PURE__*/$parcel$interopDefault($4bMTH))).string
        })
    }).isRequired
};
var $2921762a5da9ac04$export$2e2bcd8739ae039 = $2921762a5da9ac04$var$CustomerDetails;


/* eslint react/prop-types: 0 */ 

var $g7o4x = parcelRequire("g7o4x");

var $6aRB8 = parcelRequire("6aRB8");


var $b00a07c0f481dacc$export$2e2bcd8739ae039 = (props)=>{
    const { match: match } = props;
    const { customerId: customerId } = match.params;
    const [users, setUsers] = (0, $6aRB8.useState)([]);
    const [departments, setDepartments] = (0, $6aRB8.useState)([]);
    (0, $6aRB8.useEffect)(()=>{
        (0, $998b9e4952b694e1$export$b216272c8be3751a)(`/admin/customers/${customerId}/user-permissions`).then((result)=>{
            setUsers(result.data);
        });
    }, [
        customerId
    ]);
    (0, $6aRB8.useEffect)(()=>{
        (0, $998b9e4952b694e1$export$b216272c8be3751a)(`/admin/customers/${customerId}/settings`).then((result)=>{
            const { data: { departments: departmentSettings = [] } } = result;
            const departmentOptions = departmentSettings.map((dep)=>{
                const { name: name } = dep;
                return {
                    key: name,
                    text: name,
                    value: name
                };
            });
            setDepartments(departmentOptions);
        });
    }, [
        customerId
    ]);
    const saveUser = (0, $6aRB8.useCallback)((changedUser)=>{
        const { principalId: principalId } = changedUser;
        const userPermissions = (0, (/*@__PURE__*/$parcel$interopDefault($g7o4x))).pick(changedUser, [
            "userRoles",
            "userDepartments",
            "enabled"
        ]);
        const allUsers = users.map((user)=>{
            if (user.principalId === principalId) return {
                ...user,
                updated: false,
                loading: true
            };
            return user;
        });
        setUsers(allUsers);
        (0, $998b9e4952b694e1$export$6dd598fa143977b0)(`/admin/customers/${customerId}/user-permissions/${principalId}`, userPermissions).then(()=>{
            setUsers((currUsers)=>{
                const allCurrUsers = currUsers.map((user)=>{
                    if (user.principalId === principalId) return {
                        ...user,
                        loading: false
                    };
                    return user;
                });
                return allCurrUsers;
            });
        });
    }, [
        users
    ]);
    const updateUser = (0, $6aRB8.useCallback)((updatedUser)=>{
        const { principalId: principalId } = updatedUser;
        const allUsers = users.map((user)=>{
            if (user.principalId === principalId) return updatedUser;
            return user;
        });
        setUsers(allUsers);
    }, [
        users
    ]);
    const roles = [
        {
            key: "auditor",
            text: "Auditor",
            value: "auditor"
        },
        {
            key: "addEditAudits",
            text: "Add/Edit Audits",
            value: "addEditAudits"
        },
        {
            key: "publishRecommendations",
            text: "Publish Recommendations",
            value: "publishRecommendations"
        },
        {
            key: "customerSettings",
            text: "Administer Settings",
            value: "customerSettings"
        },
        {
            key: "adminUsers",
            text: "Admin Users",
            value: "adminUsers"
        }
    ];
    const userUI = users.map((user)=>{
        const { principalId: principalId, userFullName: userFullName, userEmail: userEmail, updated: updated, loading: loading, userRoles: userRoles = [], userDepartments: userDepartments = [] } = user;
        return /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Row, {
            children: [
                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                    children: userFullName
                }),
                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                    children: userEmail
                }),
                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                    children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6a9eaf6b801099ca$export$2e2bcd8739ae039), {
                        fluid: true,
                        multiple: true,
                        options: roles,
                        value: userRoles,
                        onChange: (e, v)=>updateUser({
                                ...user,
                                updated: true,
                                userRoles: v.value
                            }),
                        placeholder: "Roles"
                    })
                }),
                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                    children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6a9eaf6b801099ca$export$2e2bcd8739ae039), {
                        fluid: true,
                        multiple: true,
                        options: departments,
                        value: userDepartments,
                        onChange: (e, v)=>updateUser({
                                ...user,
                                updated: true,
                                userDepartments: v.value
                            }),
                        placeholder: "Manged Departments"
                    })
                }),
                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Cell, {
                    collapsing: true,
                    children: [
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $a7825a90230ff993$export$2e2bcd8739ae039), {
                            primary: true,
                            disabled: !updated,
                            loading: loading,
                            icon: true,
                            size: "small",
                            onClick: ()=>saveUser(user),
                            children: "Update"
                        }),
                        /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $9e710c2e6164cea4$export$2e2bcd8739ae039), {
                            header: "Delete Customer",
                            content: "Are you sure you want to delete customer"
                        })
                    ]
                })
            ]
        }, principalId);
    });
    return /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $4f8ab05c9302e89f$export$2e2bcd8739ae039), {
        basic: true,
        padded: "very",
        children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $87cfc91b8d4cc84b$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $6f17b2bb55436826$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Header, {
                        children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Row, {
                            children: [
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {
                                    children: "Roles"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {
                                    children: "Managed Departments"
                                }),
                                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).HeaderCell, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $6f17b2bb55436826$export$2e2bcd8739ae039).Body, {
                        children: userUI
                    })
                ]
            })
        })
    });
};


function $86730823a79145d5$var$Routes() {
    return /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsxs)((0, $853fc940b1a40d2f$export$b5d5cf8927ab7262), {
            children: [
                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $853fc940b1a40d2f$export$2d8d895a0a0f636e), {
                    exact: true,
                    from: "/",
                    to: "/customers"
                }),
                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $853fc940b1a40d2f$export$e7b0ac011bb776c6), {
                    exact: true,
                    path: "/customers",
                    component: (0, $e88351c3acc3f47c$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $853fc940b1a40d2f$export$e7b0ac011bb776c6), {
                    exact: true,
                    path: "/customers/:customerId",
                    component: (0, $2921762a5da9ac04$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $853fc940b1a40d2f$export$e7b0ac011bb776c6), {
                    path: "/customers/:customerId/users",
                    component: (0, $b00a07c0f481dacc$export$2e2bcd8739ae039)
                })
            ]
        })
    });
}
var $86730823a79145d5$export$2e2bcd8739ae039 = (0, $d02a40f7b0c711be$export$db40a3715ab5b118)($86730823a79145d5$var$Routes, {
    hideSignUp: true
});


var $c037deceda53130b$export$2e2bcd8739ae039 = {
    Auth: {
        Cognito: {
            userPoolId: "us-west-2_MvJ60Ghrg",
            userPoolClientId: "490s2c13kbvbnoitjvfgmlc3g5"
        }
    }
};



(0, $c429b4341d882bd4$export$11ac3725994bec7b).configure((0, $c037deceda53130b$export$2e2bcd8739ae039));
const $1d435fac4623d276$var$root = (0, $de5328cf3ad8c318$export$882461b6382ed46c)(document.getElementById("root"));
$1d435fac4623d276$var$root.render(/*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $86f9b5396d19fca8$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $cd58308bfc2f0eb2$exports.jsx)((0, $86730823a79145d5$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=admin-client.b383a6cc.js.map
